var _assertThisInitialized = require("/var/lib/jenkins/workspace/OpsPerfect/node_modules/@babel/runtime/helpers/assertThisInitialized.js").default;
var _possibleConstructorReturn = require("/var/lib/jenkins/workspace/OpsPerfect/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js").default;
var _wrapNativeSuper = require("/var/lib/jenkins/workspace/OpsPerfect/node_modules/@babel/runtime/helpers/wrapNativeSuper.js").default;
var _get = require("/var/lib/jenkins/workspace/OpsPerfect/node_modules/@babel/runtime/helpers/get.js").default;
var _getPrototypeOf = require("/var/lib/jenkins/workspace/OpsPerfect/node_modules/@babel/runtime/helpers/getPrototypeOf.js").default;
var _inherits = require("/var/lib/jenkins/workspace/OpsPerfect/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/var/lib/jenkins/workspace/OpsPerfect/node_modules/@babel/runtime/helpers/createSuper.js").default;
var _classCallCheck = require("/var/lib/jenkins/workspace/OpsPerfect/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/var/lib/jenkins/workspace/OpsPerfect/node_modules/@babel/runtime/helpers/createClass.js").default;
module.exports = function (t) {
  var e = {};
  function i(s) {
    if (e[s]) return e[s].exports;
    var r = e[s] = {
      i: s,
      l: !1,
      exports: {}
    };
    return t[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
  }
  return i.m = t, i.c = e, i.d = function (t, e, s) {
    i.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: s
    });
  }, i.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, i.t = function (t, e) {
    if (1 & e && (t = i(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var s = Object.create(null);
    if (i.r(s), Object.defineProperty(s, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var r in t) i.d(s, r, function (e) {
      return t[e];
    }.bind(null, r));
    return s;
  }, i.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return i.d(e, "a", e), e;
  }, i.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, i.p = "", i(i.s = 1);
}([function (t, e) {
  var i;
  i = function () {
    return this;
  }();
  try {
    i = i || new Function("return this")();
  } catch (t) {
    "object" == typeof window && (i = window);
  }
  t.exports = i;
}, function (t, e, i) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Pivot = void 0;
  var s = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var i = arguments[e];
        for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (t[s] = i[s]);
      }
      return t;
    },
    r = function () {
      function t(t, e) {
        for (var i = 0; i < e.length; i++) {
          var s = e[i];
          s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
        }
      }
      return function (e, i, s) {
        return i && t(e.prototype, i), s && t(e, s), e;
      };
    }(),
    n = h(i(2)),
    a = h(i(3)),
    o = h(i(4));
  function h(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  var l = e.Pivot = function (t) {
    function e(t) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);
      var i = function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));
      return i.DOMNodeRef = a.default.createRef(), i;
    }
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, t), r(e, [{
      key: "componentDidMount",
      value: function value() {
        var t = this.DOMNodeRef.current;
        this.webdatarocks = new o.default(s({}, this.props, {
          container: t
        }));
      }
    }, {
      key: "shouldComponentUpdate",
      value: function value() {
        return !1;
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.webdatarocks.dispose();
      }
    }, {
      key: "render",
      value: function value() {
        return a.default.createElement("div", {
          ref: this.DOMNodeRef
        }, "Pivot");
      }
    }]), e;
  }(a.default.Component);
  l.propTypes = {
    beforetoolbarcreated: n.default.func,
    cellclick: n.default.func,
    celldoubleclick: n.default.func,
    customizeCell: n.default.func,
    datachanged: n.default.func,
    dataerror: n.default.func,
    datafilecancelled: n.default.func,
    dataloaded: n.default.func,
    fieldslistclose: n.default.func,
    fieldslistopen: n.default.func,
    filteropen: n.default.func,
    fullscreen: n.default.func,
    global: n.default.object,
    height: n.default.oneOfType([n.default.string, n.default.number]),
    loadingdata: n.default.func,
    loadinglocalization: n.default.func,
    loadingreportfile: n.default.func,
    localizationerror: n.default.func,
    localizationloaded: n.default.func,
    openingreportfile: n.default.func,
    querycomplete: n.default.func,
    queryerror: n.default.func,
    ready: n.default.func,
    report: n.default.oneOfType([n.default.string, n.default.object]),
    reportchange: n.default.func,
    reportcomplete: n.default.func,
    reportfilecancelled: n.default.func,
    reportfileerror: n.default.func,
    reportfileloaded: n.default.func,
    runningquery: n.default.func,
    toolbar: n.default.bool,
    update: n.default.func,
    width: n.default.oneOfType([n.default.string, n.default.number])
  }, e.default = l;
}, function (t, e) {
  t.exports = require("prop-types");
}, function (t, e) {
  t.exports = require("react");
}, function (t, e, i) {
  (function (t, s, r) {
    var n, a, o, h, l;
    h = window, a = [], void 0 === (o = "function" == typeof (n = l = function l() {
      return function (t) {
        "use strict";

        var e, i, s, r, n, a;
        !function (t) {
          var e = /*#__PURE__*/function () {
            function e(t) {
              var _e2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              _classCallCheck(this, e);
              this.type = t, this.target = _e2, this.data = i;
            }
            _createClass(e, null, [{
              key: "jN",
              value: function jN(t) {
                return -1 < "fullscreenchange mozfullscreenchange webkitfullscreenchange MSFullscreenChange focusin focusout touchstart touchmove touchend touchenter touchleave touchcancel".split(" ").indexOf(t);
              }
            }]);
            return e;
          }();
          e.yg = "event_complete", e.tA = "event_connected", e.vw = "event_progress", e.Vm = "event_select", e.oe = "event_change", e.wb = "event_error", e.OPENED = "event_opened", e.CLOSED = "event_closed", e.rA = "event_cancel", e.OPEN = "event_open", e.vG = "event_close", e.vI = "event_resize", t.ga = e, t.Od = /*#__PURE__*/function () {
            function _class() {
              _classCallCheck(this, _class);
              this.Qx = !1, this.ud = [], this.Fg = [], this.mk = [];
            }
            _createClass(_class, [{
              key: "mr",
              value: function mr(t, e) {
                return t.type == e.type && t.Rg == e.Rg;
              }
            }, {
              key: "TD",
              value: function TD(t, e) {
                if (a.U(this.ud[t])) return !1;
                for (var i = 0; i < this.ud[t].length; i++) if (this.mr(this.ud[t][i], e)) return !0;
                return !1;
              }
            }, {
              key: "addEventListener",
              value: function addEventListener(t, e) {
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                if (e = {
                  type: t,
                  Rg: e,
                  priority: i
                }, !this.TD(t, e)) if (this.Qx) a.U(this.Fg[t]) && (this.Fg[t] = []), this.Fg[t].push(e);else if (a.U(this.ud[t]) && (this.ud[t] = []), 0 == this.ud[t].length) this.ud[t].push(e);else {
                  this.ud[t][this.ud[t].length - 1].priority >= i && this.ud[t].push(e);
                  for (var s = 0; s < this.ud[t].length; s++) if (this.ud[t][s].priority < i) {
                    this.ud[t].splice(s, 0, e);
                    break;
                  }
                }
              }
            }, {
              key: "removeEventListener",
              value: function removeEventListener(t, e) {
                if (!a.U(this.ud[t])) {
                  e = {
                    type: t,
                    Rg: e
                  };
                  for (var i = this.ud[t].slice(0), s = [], r = 0; r < i.length; r++) this.mr(i[r], e) ? this.Qx && (a.U(this.mk[t]) && (this.mk[t] = []), this.mk[t].push(i[r])) : s.push(i[r]);
                  this.ud[t] = s;
                }
              }
            }, {
              key: "Rc",
              value: function Rc(t) {
                void 0 === t ? (this.ud = [], this.Fg = [], this.mk = []) : (a.U(this.ud) || (this.ud[t] = []), a.U(this.Fg) || (this.Fg[t] = []), a.U(this.mk) || (this.mk[t] = []));
              }
            }, {
              key: "na",
              value: function na(t) {
                if (!a.U(this.ud[t.type])) {
                  this.Qx = !0;
                  for (var e = this.ud[t.type].slice(0), i = 0; i < e.length; i++) {
                    if (!a.U(this.mk[t.type])) {
                      var s,
                        n = !1;
                      for (s in this.mk[t.type]) this.mr(e[i], this.mk[t.type][s]) && (n = !0);
                      if (n) continue;
                    }
                    t instanceof r.model.ac ? e[i].Rg.call(this, t.data) : e[i].Rg.call(this, t);
                  }
                  for (var o in delete this.mk[t.type], this.Fg) {
                    if (a.U(this.ud[o])) e = [];else {
                      if (!(this.ud[o] instanceof Array)) continue;
                      e = this.ud[o].slice(0);
                    }
                    if (!a.U(this.Fg[o])) for (i = 0; i < this.Fg[o].length; i++) if (0 == e.length) e.push(this.Fg[o][i]);else for (e[e.length - 1].priority == this.Fg[o][i].priority && e.push(this.Fg[o][i]), t = 0; t < e.length; t++) if (e[t].priority < this.Fg[o][i].priority) {
                      e.splice(t, 0, this.Fg[o][i]);
                      break;
                    }
                    this.ud[o] = e, this.Fg[o] = [];
                  }
                  this.Qx = !1;
                }
              }
            }, {
              key: "Oa",
              value: function Oa(e, i, s) {
                e = new t.ga(e, null == i ? this : i, s), this.na(e);
              }
            }]);
            return _class;
          }();
        }(e || (e = {})), function (t) {
          var e = /*#__PURE__*/function () {
            function e() {
              var _this = this;
              _classCallCheck(this, e);
              this.vL = 5, this.Yo = null, a.lg.addEventListener("mousemove", function (t) {
                return _this.xm(t);
              }), a.lg.addEventListener("touchmove", function (t) {
                return _this.v1(t);
              }, !1), a.lg.addEventListener("mouseup", function (t) {
                return _this.bi(t);
              }), a.lg.addEventListener("touchend", function (t) {
                return _this.yz(t);
              }), a.lg.addEventListener("touchcancel", function (t) {
                return _this.yz(t);
              });
            }
            _createClass(e, [{
              key: "i_",
              value: function i_(t, _e3) {
                var _this2 = this;
                t.Y("wdr-draggable");
                var i = function i(_i2) {
                  _e3.Ny && !_i2.target.matches(_e3.Ny) || _this2.Sb == t || (null != _this2.Sb && _this2.RF(_e3, _i2), _this2.Sb = t, _this2.Ii = _e3, _this2.sP = _this2.RD(_i2), _this2.tP = _this2.Ly(_i2));
                };
                t.addEventListener("mousedown", i), t.addEventListener("touchstart", i);
              }
            }, {
              key: "RD",
              value: function RD(t) {
                return t instanceof MouseEvent ? t.clientX : t.changedTouches[0].clientX;
              }
            }, {
              key: "Ly",
              value: function Ly(t) {
                return t instanceof MouseEvent ? t.clientY : t.changedTouches[0].clientY;
              }
            }, {
              key: "xm",
              value: function xm(t) {
                1 == t.which && this.Sb && (this.wd && this.Sb.Pc("wdr-dragging") ? (this.Zz(t.clientX, t.clientY), this.Ii.NE && this.Ii.NE(this.Sb, t), t.preventDefault()) : a.U(this.Ii.ps) || this.Ii.ps(this.Sb, t) ? (this.wd = this.Ii.Ei(this.Sb), this.wd.ha("opacity", 0), r.G.xb.tb.B.R(this.wd), this.Zz(t.clientX, t.clientY, !0), this.Sb.Y("wdr-dragging")) : (this.Sb = null, this.wd.Wi(!0), this.wd = null));
              }
            }, {
              key: "eN",
              value: function eN(t, _e4) {
                return Math.abs(this.sP - t) > this.vL || Math.abs(this.tP - _e4) > this.vL;
              }
            }, {
              key: "Zz",
              value: function Zz(t, _e5) {
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                if (null != this.wd) {
                  var s = r.G.xb.tb.B.Dj();
                  this.wd.position({
                    top: _e5 - s.top,
                    left: t - s.left
                  }), this.eN(t, _e5) && (this.wd.ha("opacity", 1), this.Sb.Y("wdr-dragging-move")), i && null != this.Sb && (s = this.Sb.Dj(), t = Math.max(0, Math.min(this.Sb.width, this.wd.width, t - s.left)), this.wd.ha("margin-top", -Math.max(0, Math.min(this.Sb.height, _e5 - s.top)) + "px"), this.wd.ha("margin-left", -t + "px"));
                }
              }
            }, {
              key: "v1",
              value: function v1(t) {
                if (this.Sb) {
                  var _e6 = t.touches[0];
                  if (this.wd && this.Sb.Pc("wdr-dragging")) {
                    if (this.Zz(_e6.clientX, _e6.clientY), this.Ii.NE && this.Ii.NE(this.Sb, t), t.preventDefault(), _e6 = t.changedTouches[0], _e6 = s.ia.Ga(document.elementFromPoint(_e6.clientX, _e6.clientY))) {
                      var i = _e6.closest(".wdr-droppable");
                      i && i.hm && i.hm.Oj && (i.hm.Oj(this.Sb, this.wd, i, t), this.Yo = i);
                    }
                    (null == _e6 || null == i) && null != this.Yo && this.Yo.hm && this.Yo.hm.Qf && this.Yo.hm.Qf(this.Sb, this.wd, this.Yo, t);
                  } else a.U(this.Ii.ps) || this.Ii.ps(this.Sb, t) ? (this.wd = this.Ii.Ei(this.Sb), this.wd.ha("opacity", 0), r.G.xb.tb.B.R(this.wd), this.Zz(_e6.clientX, _e6.clientY, !0), this.Sb.Y("wdr-dragging")) : (this.Sb = null, this.wd.Wi(!0), this.wd = null);
                }
              }
            }, {
              key: "bi",
              value: function bi(t) {
                this.RF(this.Ii, t);
              }
            }, {
              key: "yz",
              value: function yz(t) {
                for (var _e7 = t.changedTouches[0], i = _e7 = s.ia.Ga(document.elementFromPoint(_e7.clientX, _e7.clientY)); _e7;) {
                  if (_e7.Pc("wdr-droppable")) {
                    a.Vb(_e7.hm.Tn) || (i = i.closest(_e7.hm.Tn)), _e7.hm.sg(this.Sb, _e7, i, t);
                    break;
                  }
                  _e7 = _e7.parent;
                }
                this.RF(this.Ii, t);
              }
            }, {
              key: "RF",
              value: function RF(t, _e8) {
                null != this.wd && (this.wd.Wi(!0), this.wd = null), null != this.Sb && (this.Sb.qd("wdr-dragging"), this.Sb.qd("wdr-dragging-move"), t.d0 && this.eN(this.RD(_e8), this.Ly(_e8)) && t.d0(this.Sb, _e8), this.Sb = null), this.Yo = null, this.tP = this.sP = NaN;
              }
            }, {
              key: "j_",
              value: function j_(t, _e9, i) {
                var _this3 = this;
                t.Pc("wdr-droppable") || (t.Y("wdr-droppable"), t.addEventListener("mouseenter", function (t) {
                  null != _this3.Sb && 1 == t.which && i.os && i.os(_this3.Sb, _this3.wd, _e9, t);
                }), t.addEventListener("mouseleave", function (t) {
                  null != _this3.Sb && 1 == t.which && i.Qf && i.Qf(_this3.Sb, _this3.wd, _e9, t);
                }), t.addEventListener("mouseover", function (t) {
                  null != _this3.Sb && 1 == t.which && i.Oj && i.Oj(_this3.Sb, _this3.wd, _e9, t);
                }), t.addEventListener("mouseup", function (_e10) {
                  if (null != _this3.Sb && 1 == _e10.which) {
                    var r = s.ia.Ga(_e10.target);
                    a.Vb(i.Tn) || (r = r.closest(i.Tn)), i.sg(_this3.Sb, t, r, _e10);
                  }
                }));
              }
            }], [{
              key: "V",
              value: function V() {
                return e.instance || (e.instance = new e()), e.instance;
              }
            }, {
              key: "la",
              value: function la() {
                e.instance = null;
              }
            }]);
            return e;
          }();
          t.CA = e;
        }((s = i || (i = {})).Rx || (s.Rx = {})), function (t) {
          var i = /*#__PURE__*/function (_e$Od) {
            _inherits(i, _e$Od);
            var _super = _createSuper(i);
            function i() {
              var _this4;
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "div";
              var _i3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              _classCallCheck(this, i);
              _this4 = _super.call(this), _this4.B = new t.ia(e), _this4.B.Y("wdr-ui " + _i3), a.Wc().pg && _this4.B.Y("wdr-ui-mobile"), _this4.validate();
              return _this4;
            }
            _createClass(i, [{
              key: "validate",
              value: function validate() {
                this.dE = {};
              }
            }, {
              key: "df",
              value: function df() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "all";
                this.dE[t] = !0, this.Ha();
              }
            }, {
              key: "ez",
              value: function ez() {
                var t = ["data"];
                if (this.dE.all) return !0;
                for (var e = 0; e < t.length; e++) if (this.dE[t[e]]) return !0;
                return !1;
              }
            }, {
              key: "Ha",
              value: function Ha() {
                this.validate();
              }
            }, {
              key: "so",
              value: function so() {
                this.df();
              }
            }, {
              key: "show",
              value: function show() {
                this.B.show();
              }
            }, {
              key: "Da",
              value: function Da() {
                this.B.Da();
              }
            }, {
              key: "Nu",
              value: function Nu() {
                return this.B.ja("id");
              }
            }, {
              key: "qb",
              value: function qb(t) {
                this.B.ja("id", t);
              }
            }, {
              key: "Q2",
              value: function Q2(t) {
                this.name = t;
              }
            }, {
              key: "Lc",
              value: function Lc(t) {
                return void 0 === t ? this.B.Lc() : (this.B.Lc(t), this);
              }
            }, {
              key: "Xz",
              value: function Xz(t) {
                this.B.Va("wdr-ui-disabled", !t);
              }
            }, {
              key: "xy",
              value: function xy() {
                return !this.B.Pc("wdr-ui-disabled");
              }
            }, {
              key: "Y",
              value: function Y() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                this.B.Y(t);
              }
            }, {
              key: "qd",
              value: function qd(t) {
                this.B.qd(t);
              }
            }, {
              key: "padding",
              get: function get() {
                return this.B.padding;
              },
              set: function set(t) {}
            }, {
              key: "Lf",
              value: function Lf(t) {
                return this.B.Lf(t);
              }
            }, {
              key: "Dm",
              value: function Dm(t) {
                this.Lf() !== t && (this.B.Dm(t), this.df("size"));
              }
            }, {
              key: "Xc",
              value: function Xc() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                return this.B.Xc(t);
              }
            }, {
              key: "Fs",
              value: function Fs(t) {
                this.Xc() !== t && (this.B.Fs(t), this.df("size"));
              }
            }, {
              key: "isVisible",
              value: function isVisible(t) {
                return void 0 !== t && (t ? this.show() : this.Da()), this.B.visible;
              }
            }, {
              key: "position",
              value: function position() {
                return this.B.position();
              }
            }, {
              key: "R",
              value: function R(t) {
                this.B.append(t.B);
              }
            }, {
              key: "Wi",
              value: function Wi() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                t ? this.B.remove() : this.B.detach();
              }
            }, {
              key: "RD",
              value: function RD() {
                return this.B.left;
              }
            }, {
              key: "Ly",
              value: function Ly() {
                return this.B.top;
              }
            }, {
              key: "addEventListener",
              value: function addEventListener(t, e) {
                this.B.addEventListener(t, e);
              }
            }, {
              key: "removeEventListener",
              value: function removeEventListener(t, e) {
                this.B.removeEventListener(t, e);
              }
            }, {
              key: "na",
              value: function na(t) {
                this.B.na(t);
              }
            }, {
              key: "Oa",
              value: function Oa(t, e, _i4) {
                this.B.Oa(t, e, _i4);
              }
            }, {
              key: "cu",
              value: function cu() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                t = t ? this.Lf(!0) : r.G.xb.eA, this.B.Va("wdr-layout-tablet", 768 > t), this.B.Va("wdr-layout-mobile", 580 > t), this.B.Va("wdr-layout-mobile-small", 460 > t);
              }
            }]);
            return i;
          }(e.Od);
          t.ya = i;
        }(i || (i = {})), function (t) {
          var i = /*#__PURE__*/function (_e$Od2) {
            _inherits(i, _e$Od2);
            var _super2 = _createSuper(i);
            function i() {
              var _this5;
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "div";
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              _classCallCheck(this, i);
              _this5 = _super2.call(this), _this5.display = "block", _this5.frames = [], _this5.mj = [], _this5.element = "string" == typeof t ? document.createElement(t) : t, _this5.Y("wdr-ui-element"), _this5.Y(e);
              return _this5;
            }
            _createClass(i, [{
              key: "element",
              get: function get() {
                return this.Kt;
              },
              set: function set(t) {
                (this.Kt = t) && (this.Kt.uielement = this);
              }
            }, {
              key: "id",
              get: function get() {
                return this.element.id;
              },
              set: function set(t) {
                this.element.id = t;
              }
            }, {
              key: "parent",
              get: function get() {
                return i.Ga(this.element.parentElement);
              }
            }, {
              key: "nodeName",
              get: function get() {
                return this.Kt.nodeName.toLowerCase();
              }
            }, {
              key: "R",
              value: function R(t) {
                this.element.appendChild(t.element);
              }
            }, {
              key: "children",
              value: function children() {
                for (var t = this.element.firstElementChild, e = []; t;) e.push(i.Ga(t)), t = t.nextElementSibling;
                return e;
              }
            }, {
              key: "contains",
              value: function contains(t) {
                return this.element.contains(t.element);
              }
            }, {
              key: "append",
              value: function append(t) {
                return t && this.R(t), this;
              }
            }, {
              key: "prepend",
              value: function prepend(t) {
                return this.element.insertBefore(t.element, this.element.firstChild), this;
              }
            }, {
              key: "before",
              value: function before(t) {
                return this.element.parentNode && this.element.parentNode.insertBefore(t.element, this.element), this;
              }
            }, {
              key: "after",
              value: function after(t) {
                return this.element.parentNode && this.element.nextElementSibling ? this.element.parentNode.insertBefore(t.element, this.element.nextElementSibling) : this.append(t), this;
              }
            }, {
              key: "sU",
              value: function sU(t) {
                this.element.appendChild(t.B.element);
              }
            }, {
              key: "Wi",
              value: function Wi() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                t ? this.remove() : this.detach();
              }
            }, {
              key: "remove",
              value: function remove() {
                null != this.element && (this.element.parentNode && this.element.parentNode.removeChild(this.element), this.la());
              }
            }, {
              key: "detach",
              value: function detach() {
                if (null != this.element && this.element.parentNode) {
                  var t = this.element.cloneNode(!0);
                  this.element.parentNode.removeChild(this.element), this.element = t;
                }
              }
            }, {
              key: "fq",
              value: function fq() {
                for (; this.element && this.element.firstChild;) {
                  var t = i.Ga(this.element.firstChild);
                  t && t.dispose && t.la(), this.element.removeChild(this.element.firstChild);
                }
              }
            }, {
              key: "clone",
              value: function clone() {
                return i.Ga(this.element.cloneNode(!0));
              }
            }, {
              key: "get",
              value: function get(t) {
                var e = this.children();
                return 0 < e.length ? e[t] : null;
              }
            }, {
              key: "find",
              value: function find(t, e) {
                if (void 0 === e || 0 == e) return i.Ga(this.element.querySelector(t));
                t = this.element.querySelectorAll(t), e = [];
                for (var s = 0; s < t.length; s++) e.push(i.Ga(t[s]));
                return e;
              }
            }, {
              key: "closest",
              value: function closest(t) {
                if (!this.element) return null;
                for (var e = this.element; null != e;) {
                  if (e.matches) {
                    if (e.matches(t)) return e == this.element ? this : i.Ga(e);
                  } else if (e.msMatchesSelector(t)) return e == this.element ? this : i.Ga(e);
                  e = e.parentElement;
                }
                return null;
              }
            }, {
              key: "Y",
              value: function Y(t) {
                if (!this.element) return this;
                for (var e = (t = t.trim()).split(" "), _i5 = 0; _i5 < e.length; _i5++) 0 < e[_i5].length && (a.Fr().rm ? (t = this.element.getAttribute("class"), a.U(t) ? this.element.setAttribute("class", e[_i5]) : -1 == t.split(" ").indexOf(e[_i5]) && this.element.setAttribute("class", t + " " + e[_i5])) : 0 == this.element.classList.contains(e[_i5]) && this.element.classList.add(e[_i5]));
                return this;
              }
            }, {
              key: "qd",
              value: function qd(t) {
                if (this.element && 0 < (t = t.trim()).length) if (a.Fr().rm) {
                  var e = this.element.getAttribute("class");
                  a.U(e) || -1 < (t = (e = e.split(" ")).indexOf(t)) && (e.splice(t, 1), this.element.setAttribute("class", e.join(" ")));
                } else this.element.classList.contains(t) && this.element.classList.remove(t);
              }
            }, {
              key: "Va",
              value: function Va(t, e) {
                e ? this.Y(t) : this.qd(t);
              }
            }, {
              key: "Pc",
              value: function Pc(t) {
                return this.element.classList.contains(t);
              }
            }, {
              key: "Hi",
              value: function Hi() {
                this.Y("wdr-noselect");
              }
            }, {
              key: "hX",
              value: function hX() {
                this.Y("wdr-selectable");
              }
            }, {
              key: "Lf",
              value: function Lf() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                if (!this.element) return 0;
                var e = window.getComputedStyle(this.element);
                return this.element.clientWidth - (t ? 0 : (parseFloat(e.paddingLeft) || 0) + (parseFloat(e.paddingRight) || 0));
              }
            }, {
              key: "Dm",
              value: function Dm(t) {
                "number" == typeof t ? this.element.style.width = t + "px" : "string" == typeof t && (this.element.style.width = t);
              }
            }, {
              key: "width",
              get: function get() {
                return this.Lf();
              },
              set: function set(t) {
                this.Dm(t);
              }
            }, {
              key: "padding",
              get: function get() {
                var t = window.getComputedStyle(this.element);
                return {
                  left: parseFloat(t.paddingLeft) || 0,
                  right: parseFloat(t.paddingRight) || 0,
                  top: parseFloat(t.paddingTop) || 0,
                  bottom: parseFloat(t.paddingBottom) || 0
                };
              },
              set: function set(t) {}
            }, {
              key: "borderWidth",
              get: function get() {
                var t = window.getComputedStyle(this.element);
                return {
                  left: parseFloat(t.borderLeftWidth || t.borderWidth) || 0,
                  right: parseFloat(t.borderRightWidth || t.borderWidth) || 0,
                  top: parseFloat(t.borderTopWidth || t.borderWidth) || 0,
                  bottom: parseFloat(t.borderBottomWidth || t.borderWidth) || 0
                };
              }
            }, {
              key: "Xc",
              value: function Xc() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var e = window.getComputedStyle(this.element);
                return t = t ? 0 : (parseFloat(e.paddingTop) || 0) + (parseFloat(e.paddingBottom) || 0), 0 > this.element.clientHeight - t ? 0 : this.element.clientHeight - t;
              }
            }, {
              key: "Fs",
              value: function Fs(t) {
                "number" == typeof t ? this.element.style.height = t + "px" : "string" == typeof t && (this.element.style.height = t);
              }
            }, {
              key: "height",
              get: function get() {
                return this.Xc();
              },
              set: function set(t) {
                this.Fs(t);
              }
            }, {
              key: "left",
              get: function get() {
                return this.element.getBoundingClientRect().left;
              },
              set: function set(t) {
                this.element.style.left = t + "px";
              }
            }, {
              key: "top",
              get: function get() {
                return this.element.getBoundingClientRect().top;
              },
              set: function set(t) {
                this.element.style.top = t + "px";
              }
            }, {
              key: "right",
              get: function get() {
                return this.element.getBoundingClientRect().right;
              },
              set: function set(t) {
                this.element.style.right = t + "px";
              }
            }, {
              key: "bottom",
              get: function get() {
                return this.element.getBoundingClientRect().bottom;
              },
              set: function set(t) {
                this.element.style.bottom = t + "px";
              }
            }, {
              key: "Lc",
              value: function Lc(t) {
                return void 0 === t ? this.element.innerHTML : (this.element.innerHTML = t, this);
              }
            }, {
              key: "empty",
              value: function empty() {
                this.Lc("");
              }
            }, {
              key: "clear",
              value: function clear() {
                this.empty();
              }
            }, {
              key: "text",
              value: function text(t) {
                return void 0 === t ? this.element.textContent : ("input" == this.element.tagName.toLowerCase() ? this.element.value = t : this.element.textContent = t, this);
              }
            }, {
              key: "focus",
              value: function focus() {
                return this.element.focus(), this;
              }
            }, {
              key: "blur",
              value: function blur() {
                return this.element.blur(), this;
              }
            }, {
              key: "show",
              value: function show() {
                this.element.style.display = this.display;
              }
            }, {
              key: "Da",
              value: function Da() {
                this.element.style.display = "none";
              }
            }, {
              key: "x",
              get: function get() {
                return this.element.offsetLeft;
              }
            }, {
              key: "y",
              get: function get() {
                return this.element.offsetTop;
              }
            }, {
              key: "offset",
              value: function offset(t) {
                if (void 0 === t) return this.Dj();
                this.ha("left", t.left + "px"), this.ha("top", t.top + "px");
              }
            }, {
              key: "getBoundingClientRect",
              value: function getBoundingClientRect() {
                return this.element.getBoundingClientRect();
              }
            }, {
              key: "position",
              value: function position(t) {
                if (void 0 === t) return {
                  top: this.y,
                  left: this.x
                };
                this.offset(t);
              }
            }, {
              key: "ja",
              value: function ja(t, e) {
                if (void 0 === e) return this.element.getAttribute(t);
                try {
                  this.element.setAttribute(t, e);
                } catch (_i6) {
                  this.element.attributes[t] = e;
                }
                return this;
              }
            }, {
              key: "ha",
              value: function ha(t, e) {
                return void 0 === e ? window.getComputedStyle(this.element)[i.BP(t)] : (this.element.style[i.BP(t)] = e, this);
              }
            }, {
              key: "pq",
              value: function pq() {
                return "input" == this.element.tagName.toLowerCase() || "textarea" == this.element.tagName.toLowerCase() ? this.element.value : this.element.textContent;
              }
            }, {
              key: "requestAnimationFrame",
              value: function requestAnimationFrame(t) {
                var e = 0;
                return window.requestAnimationFrame ? e = window.requestAnimationFrame(t) : window.msRequestAnimationFrame ? e = window.msRequestAnimationFrame(t) : window.mozRequestAnimationFrame ? e = window.mozRequestAnimationFrame(t) : window.webkitRequestAnimationFrame ? e = window.webkitRequestAnimationFrame(t) : t.call(null), this.frames.push(e), e;
              }
            }, {
              key: "cancelAnimationFrame",
              value: function cancelAnimationFrame(t) {
                this.frames.splice(this.frames.indexOf(t), 1), 0 != t && (null != window.cancelAnimationFrame ? window.cancelAnimationFrame(t) : null != window.msCancelRequestAnimationFrame ? window.msCancelRequestAnimationFrame(t) : null != window.mozCancelAnimationFrame ? window.mozCancelAnimationFrame(t) : null != window.webkitCancelAnimationFrame && window.webkitCancelAnimationFrame(t));
              }
            }, {
              key: "visible",
              get: function get() {
                return this.element && "none" != this.ha("display");
              },
              set: function set(t) {
                t ? this.show() : this.Da();
              }
            }, {
              key: "Dj",
              value: function Dj() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                if (null == t) return this.element.getBoundingClientRect();
                for (var e = 0, _i7 = 0, s = this.element; s && s != t && !isNaN(s.offsetLeft) && !isNaN(s.offsetTop);) e += s.offsetLeft - s.scrollLeft, _i7 += s.offsetTop - s.scrollTop, s = s.offsetParent;
                return {
                  top: _i7,
                  left: e
                };
              }
            }, {
              key: "HF",
              value: function HF(t) {
                this.element.scrollTop = t;
              }
            }, {
              key: "addEventListener",
              value: function addEventListener(t, _i8, s) {
                void 0 !== this.element["on" + t] || e.ga.jN(t) ? (a.U(this.mj[t]) && (this.mj[t] = []), this.mj[t][_i8.toString()] = function (t) {
                  _i8(t);
                }, this.element.addEventListener(t, this.mj[t][_i8.toString()], s)) : _get(_getPrototypeOf(i.prototype), "addEventListener", this).call(this, t, _i8, s);
              }
            }, {
              key: "removeEventListener",
              value: function removeEventListener(t, _i9, s) {
                void 0 !== this.element["on" + t] || e.ga.jN(t) ? this.mj[t] && this.element.removeEventListener(t, this.mj[t][_i9.toString()], s) : _get(_getPrototypeOf(i.prototype), "removeEventListener", this).call(this, t, _i9);
              }
            }, {
              key: "na",
              value: function na(t) {
                _get(_getPrototypeOf(i.prototype), "na", this).call(this, t);
              }
            }, {
              key: "Rc",
              value: function Rc(t) {
                for (var e in this.mj) if (void 0 === t || t == e) for (var _i10 in this.mj[e]) try {
                  this.element.removeEventListener(e, this.mj[e][_i10], !0), this.element.removeEventListener(e, this.mj[e][_i10], !1);
                } catch (t) {
                  console.error(t);
                }
                this.mj = [], _get(_getPrototypeOf(i.prototype), "Rc", this).call(this, e);
              }
            }, {
              key: "la",
              value: function la() {
                this.Rc(), this.fq(), this.Kt = this.Kt.uielement = null;
                for (var t = 0; t < this.frames.length; t++) this.cancelAnimationFrame(this.frames[t]);
                this.frames = [], this.PJ && this.PJ.la();
              }
            }, {
              key: "refresh",
              value: function refresh() {
                this.Lc(this.Lc());
              }
            }, {
              key: "draggable",
              value: function draggable(e) {
                t.Rx.CA.V().i_(this, e);
              }
            }, {
              key: "zj",
              value: function zj(e, _i11) {
                this.LT = e, t.Rx.CA.V().j_(this, _i11 || this, e);
              }
            }, {
              key: "hm",
              get: function get() {
                return this.LT;
              }
            }, {
              key: "index",
              value: function index() {
                for (var t = 0, e = this.element; e = e.previousElementSibling;) t++;
                return t;
              }
            }, {
              key: "Nz",
              value: function Nz(e) {
                this.PJ = new t.Nz.xS(this, e);
              }
            }], [{
              key: "Ga",
              value: function Ga(t) {
                return t && t.nodeType == Node.ELEMENT_NODE ? a.U(t.uielement) ? new i(t) : t.uielement : null;
              }
            }, {
              key: "BP",
              value: function BP(t) {
                var e = t.split("-");
                if (1 < e.length) {
                  for (t = 1; t < e.length; t++) e[t] = e[t].charAt(0).toUpperCase() + e[t].substr(1);
                  return e.join("");
                }
                return t;
              }
            }]);
            return i;
          }(e.Od);
          t.ia = i;
        }(i || (i = {})), function (t) {
          var i = /*#__PURE__*/function (_t$ya) {
            _inherits(i, _t$ya);
            var _super3 = _createSuper(i);
            function i() {
              var _this6;
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
              _classCallCheck(this, i);
              _this6 = _super3.call(this, "a", "wdr-ui-btn"), _this6.GE = 0, _this6.d2 = 50, _this6.Y(t), _this6.B.addEventListener("click", function (t) {
                return _this6.wf(t);
              }), _this6.B.addEventListener("mousedown", function () {
                return _this6.wm();
              }), _this6.B.addEventListener("mouseup", function () {
                return _this6.bi();
              }), _this6.B.addEventListener("mouseout", function () {
                return _this6.O0();
              }), _this6.B.display = "inline-block";
              return _this6;
            }
            _createClass(i, [{
              key: "wf",
              value: function wf(t) {
                this.xy() && this.Oa(i.Se, this), t.stopImmediatePropagation();
              }
            }, {
              key: "wm",
              value: function wm() {
                var _this7 = this;
                this.B.Va("wdr-ui-pressed", !0), this.GE = a.YL(function () {
                  return _this7.TW();
                }, this.d2);
              }
            }, {
              key: "TW",
              value: function TW() {
                this.na(new e.ga(i.UR, this));
              }
            }, {
              key: "bi",
              value: function bi() {
                this.B.Va("wdr-ui-pressed", !1), a.Mr(this.GE);
              }
            }, {
              key: "O0",
              value: function O0() {
                this.B.Va("wdr-ui-pressed", !1), a.Mr(this.GE);
              }
            }, {
              key: "I",
              value: function I() {
                return this.label;
              }
            }, {
              key: "wa",
              value: function wa(t) {
                this.label != t && (this.label = t, this.B.text(this.label));
              }
            }]);
            return i;
          }(t.ya);
          i.UR = "buttonmousedown", i.Se = "buttonclick", t.Wb = i;
        }(i || (i = {})), function (t) {
          var e = /*#__PURE__*/function (_t$ya2) {
            _inherits(e, _t$ya2);
            var _super4 = _createSuper(e);
            function e() {
              var _this8;
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
              _classCallCheck(this, e);
              _this8 = _super4.call(this, "span", "wdr-ui wdr-ui-label"), _this8.B.display = "inline-block", _this8.wa(t);
              return _this8;
            }
            _createClass(e, [{
              key: "I",
              value: function I() {
                return this.label;
              }
            }, {
              key: "wa",
              value: function wa(t) {
                var _e11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                this.label != t && (this.label = t, _e11 ? this.B.Lc(this.label) : this.B.text(this.label));
              }
            }, {
              key: "IF",
              value: function IF(t) {
                t ? this.B.hX() : this.B.Hi();
              }
            }]);
            return e;
          }(t.ya);
          t.dc = e;
        }(i || (i = {})), function (t) {
          var i = /*#__PURE__*/function (_t$ya3) {
            _inherits(i, _t$ya3);
            var _super5 = _createSuper(i);
            function i() {
              var _this9;
              _classCallCheck(this, i);
              _this9 = _super5.call(this, "textarea", "wdr-ui-text-area"), _this9.B.addEventListener("keypress", function (t) {
                return _this9.WE(t);
              }), _this9.B.addEventListener("keyup", function () {
                return _this9.XE();
              }), _this9.B.addEventListener("paste", function () {
                return _this9.VE();
              });
              return _this9;
            }
            _createClass(i, [{
              key: "XE",
              value: function XE() {
                this.Gr();
              }
            }, {
              key: "VE",
              value: function VE() {
                this.Gr();
              }
            }, {
              key: "Gr",
              value: function Gr() {
                this.na(new e.ga(t.zl.gi, this));
              }
            }, {
              key: "Gj",
              value: function Gj() {
                return this.B.pq();
              }
            }, {
              key: "bj",
              value: function bj(t) {
                this.Gj() != t && (this.B.element.value = t, this.Gr());
              }
            }, {
              key: "clear",
              value: function clear() {
                this.bj("");
              }
            }, {
              key: "Pn",
              value: function Pn(t) {
                var e = this.B.element.selectionStart,
                  _i12 = this.B.element.selectionEnd,
                  s = this.Gj();
                this.bj(s.substr(0, e) + t + s.substr(e)), this.wc(e + t.length, _i12 + t.length);
              }
            }, {
              key: "wc",
              value: function wc(t) {
                var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
                this.B.element.focus(), this.B.element.setSelectionRange(t, 0 > e ? t : e);
              }
            }, {
              key: "Bm",
              value: function Bm() {
                this.wc(0, this.Gj().length);
              }
            }, {
              key: "WE",
              value: function WE(t) {
                t.ctrlKey ? (this.Oa(i.QQ), t.preventDefault()) : 13 == t.keyCode && (this.Oa(i.DA), t.preventDefault());
              }
            }]);
            return i;
          }(t.ya);
          i.DA = "ntr", i.QQ = "ntl", t.UI = i;
        }(i || (i = {})), function (t) {
          var i = /*#__PURE__*/function (_t$ya4) {
            _inherits(i, _t$ya4);
            var _super6 = _createSuper(i);
            function i() {
              var _this10;
              _classCallCheck(this, i);
              _this10 = _super6.call(this, "input", "wdr-ui-text-input"), _this10.prompt = _this10.text = "", _this10.yC = 0, _this10.zC = !0, _this10.B.display = "inline-block", _this10.B.ja("type", "text"), _this10.B.ja("data-placeholder", ""), _this10.B.addEventListener("focusin", function () {
                return _this10.r0();
              }), _this10.B.addEventListener("focusout", function () {
                return _this10.s0();
              }), _this10.B.addEventListener("keyup", function () {
                return _this10.XE();
              }), _this10.B.addEventListener("keypress", function (t) {
                return _this10.WE(t);
              }), _this10.B.addEventListener("paste", function () {
                return _this10.VE();
              });
              return _this10;
            }
            _createClass(i, [{
              key: "WE",
              value: function WE(t) {
                if (13 == t.keyCode && this.Oa(i.DA), !(a.U(this.vO) || t.ctrlKey || t.altKey || t.metaKey)) {
                  var e = i.gY(t);
                  null != e && !1 === this.vO.test(e) && t.preventDefault();
                }
              }
            }, {
              key: "XE",
              value: function XE() {
                this.B.pq() !== this.text && (this.text = this.B.pq(), this.Gr());
              }
            }, {
              key: "VE",
              value: function VE() {
                this.B.pq() !== this.text && (this.text = this.B.pq(), this.Gr());
              }
            }, {
              key: "Gr",
              value: function Gr() {
                var _this11 = this;
                0 < this.yC ? this.zC && (this.zC = !1, a.xd(function () {
                  return _this11.wB();
                }, this.yC)) : this.wB();
              }
            }, {
              key: "wB",
              value: function wB() {
                this.zC = !0, this.na(new e.ga(i.gi, this, this.text));
              }
            }, {
              key: "r0",
              value: function r0() {
                0 == this.text.length && (this.B.text(""), this.im(!1));
              }
            }, {
              key: "s0",
              value: function s0() {
                this.im(0 == this.text.length);
              }
            }, {
              key: "Gj",
              value: function Gj() {
                return this.text = this.B.pq() == this.prompt ? this.text : this.B.pq();
              }
            }, {
              key: "bj",
              value: function bj(t) {
                this.text != t && (this.text = t, this.B.text(this.text), this.im(0 == this.text.length));
              }
            }, {
              key: "clear",
              value: function clear() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                this.bj(""), t && this.wB();
              }
            }, {
              key: "Hs",
              value: function Hs(t) {
                t != this.prompt && (this.prompt = t, this.B.ja("data-placeholder", this.prompt), this.im(0 == this.text.length));
              }
            }, {
              key: "im",
              value: function im(t) {
                this.B.text(t ? this.prompt : this.text), this.B.Va("wdr-ui-prompt", t);
              }
            }, {
              key: "T2",
              value: function T2() {
                this.vO = /^\d+$/;
              }
            }, {
              key: "MO",
              value: function MO(t) {
                this.yC = t;
              }
            }, {
              key: "Z2",
              value: function Z2() {
                this.B.ja("type", "number");
              }
            }], [{
              key: "gY",
              value: function gY(t) {
                return null == t.which ? 32 > t.keyCode ? null : String.fromCharCode(t.keyCode) : 0 != t.which && 0 != t.charCode ? 32 > t.which ? null : String.fromCharCode(t.which) : null;
              }
            }]);
            return i;
          }(t.ya);
          i.gi = "_", i.DA = "ntr", t.zl = i;
        }(i || (i = {})), function (t) {
          var i = /*#__PURE__*/function (_t$Wb) {
            _inherits(i, _t$Wb);
            var _super7 = _createSuper(i);
            function i() {
              var _this12;
              _classCallCheck(this, i);
              _this12 = _super7.call(this), _this12.B.display = "inline-block", _this12.B.Pc("wdr-ui-btn") && _this12.B.qd("wdr-ui-btn"), _this12.B.Y("wdr-ui-toggle-btn"), _this12.selected = 0, _this12.addEventListener(t.Wb.Se, function () {
                return _this12.wf();
              });
              return _this12;
            }
            _createClass(i, [{
              key: "wf",
              value: function wf() {
                this.xy() && (this.toggle(), this.Oa(e.ga.oe, this));
              }
            }, {
              key: "toggle",
              value: function toggle() {
                this.selected = 1 == this.selected ? 0 : 1, this.B.Va("wdr-selected", 1 == this.selected);
              }
            }, {
              key: "wc",
              value: function wc(t) {
                this.selected == t || 1 < t || -1 > t || (this.selected = t, this.B.Va("wdr-selected", 1 == this.selected));
              }
            }, {
              key: "getSelection",
              value: function getSelection() {
                return this.selected;
              }
            }]);
            return i;
          }(t.Wb);
          t.Xm = i;
        }(i || (i = {})), function (t) {
          var e = /*#__PURE__*/function (_t$Xm) {
            _inherits(e, _t$Xm);
            var _super8 = _createSuper(e);
            function e() {
              var _this13;
              _classCallCheck(this, e);
              _this13 = _super8.call(this), _this13.B.display = "inline-block", _this13.B.Pc("wdr-ui-toggle-btn") && _this13.B.qd("wdr-ui-toggle-btn"), _this13.B.Y("wdr-ui-checkbox"), _this13.dv = new t.dc("Label"), _this13.B.append(_this13.dv.B);
              return _this13;
            }
            _createClass(e, [{
              key: "toggle",
              value: function toggle() {
                _get(_getPrototypeOf(e.prototype), "toggle", this).call(this), this.B.Va("wdr-ui-semi-selected", -1 == this.getSelection());
              }
            }, {
              key: "wa",
              value: function wa(t) {
                var _e12 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                null != this.dv && this.dv.wa(t, _e12);
              }
            }, {
              key: "I",
              value: function I() {
                return null != this.dv ? this.dv.I() : "";
              }
            }, {
              key: "wc",
              value: function wc(t) {
                this.getSelection() == t || 1 < t || -1 > t || (_get(_getPrototypeOf(e.prototype), "wc", this).call(this, t), this.B.Va("wdr-ui-semi-selected", -1 == this.getSelection()));
              }
            }, {
              key: "checked",
              get: function get() {
                return 1 == this.getSelection();
              },
              set: function set(t) {
                this.wc(t ? 1 : 0);
              }
            }]);
            return e;
          }(t.Xm);
          e.BS = 1, e.hT = 0, e.CS = -1, t.No = e;
        }(i || (i = {})), function (t) {
          var e = /*#__PURE__*/function (_t$ya5) {
            _inherits(e, _t$ya5);
            var _super9 = _createSuper(e);
            function e() {
              var _this14;
              _classCallCheck(this, e);
              _this14 = _super9.call(this, "div", "wdr-ui-divider"), _this14.NN = function (t) {
                return _this14.xm(t);
              }, _this14.t_ = function (t) {
                return _this14.wm(t);
              }, _this14.u_ = function (t) {
                return _this14.bi(t);
              }, _this14.direction = e.kw, _this14.addEventListener("mousedown", _this14.t_), a.lg.addEventListener("mouseup", _this14.u_), _this14.B.Hi();
              return _this14;
            }
            _createClass(e, [{
              key: "wm",
              value: function wm(t) {
                this.$q = this.direction == e.kw ? this.Xc() : this.Lf(), this.zt = this.B.parent.Dj(), a.lg.addEventListener("mousemove", this.NN), t.preventDefault(), t.stopImmediatePropagation();
              }
            }, {
              key: "xm",
              value: function xm(t) {
                if (this.direction == e.kw) {
                  var i = t.clientY - this.zt.top;
                  if (this.Ft && (i < this.Ft[1] || i > this.Ft[3])) return;
                  this.B.ha("top", i - this.$q / 2 + "px"), this.Oa(e.UG, this, {
                    top: i
                  });
                }
                this.direction == e.YI && (t = t.clientX - this.zt.left, this.Ft && (t < this.Ft[0] || t > this.Ft[2]) || (this.B.ha("left", t - this.$q / 2 + "px"), this.Oa(e.UG, this, {
                  left: t
                })));
              }
            }, {
              key: "bi",
              value: function bi() {
                a.lg.removeEventListener("mousemove", this.NN);
              }
            }, {
              key: "direction",
              get: function get() {
                return this.vB;
              },
              set: function set(t) {
                this.vB = t, this.B.Va("wdr-ui-horizontal", this.vB == e.kw), this.B.Va("wdr-ui-vertical", this.vB == e.YI), this.B.ha("position", "absolute");
              }
            }]);
            return e;
          }(t.ya);
          e.kw = 0, e.YI = 1, e.UG = "divider_movedEvent_", t.o5 = e;
        }(i || (i = {})), function (t) {
          var e = /*#__PURE__*/function (_t$ya6) {
            _inherits(e, _t$ya6);
            var _super10 = _createSuper(e);
            function e() {
              _classCallCheck(this, e);
              return _super10.call(this, "div", "wdr-ui-modal-overlay");
            }
            _createClass(e, [{
              key: "R2",
              value: function R2(t) {
                this.B.Va("wdr-ui-transparent", !1), this.B.Va("wdr-ui-opaque", t);
              }
            }]);
            return e;
          }(t.ya);
          t.dT = e;
        }(i || (i = {})), function (t) {
          !function (e) {
            var i = /*#__PURE__*/function (_t$ya7) {
              _inherits(i, _t$ya7);
              var _super11 = _createSuper(i);
              function i() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "wdr-ui-container";
                _classCallCheck(this, i);
                return _super11.call(this, "div", t);
              }
              _createClass(i, [{
                key: "removeChild",
                value: function removeChild(t) {
                  this.contains(t) && t.B.detach();
                }
              }, {
                key: "contains",
                value: function contains(t) {
                  return !a.U(t) && this.B.contains(t.B);
                }
              }, {
                key: "Lf",
                value: function Lf() {
                  return this.B.width;
                }
              }, {
                key: "Xc",
                value: function Xc() {
                  return this.B.height;
                }
              }, {
                key: "fq",
                value: function fq() {
                  for (var t = this.B.children(), e = t.length - 1; 0 <= e; e--) t[e].Wi();
                }
              }]);
              return i;
            }(t.ya);
            e.Lh = i;
          }(t.Ac || (t.Ac = {}));
        }(i || (i = {})), function (t) {
          !function (t) {
            var e = /*#__PURE__*/function (_t$Lh) {
              _inherits(e, _t$Lh);
              var _super12 = _createSuper(e);
              function e() {
                _classCallCheck(this, e);
                return _super12.call(this, "wdr-ui-border-container");
              }
              return _createClass(e);
            }(t.Lh);
            t.aT = e;
          }(t.Ac || (t.Ac = {}));
        }(i || (i = {})), function (t) {
          !function (t) {
            var e = /*#__PURE__*/function (_t$Lh2) {
              _inherits(e, _t$Lh2);
              var _super13 = _createSuper(e);
              function e() {
                var _this15;
                _classCallCheck(this, e);
                _this15 = _super13.call(this), _this15.B.Y("wdr-ui-window"), _this15.Da();
                return _this15;
              }
              _createClass(e, [{
                key: "setPosition",
                value: function setPosition(t, _e13) {
                  this.B.offset({
                    left: Math.floor(t),
                    top: Math.floor(_e13)
                  }), this.B.ha("position", "absolute");
                }
              }]);
              return e;
            }(t.Lh);
            t.fT = e;
          }(t.Ac || (t.Ac = {}));
        }(i || (i = {})), function (t) {
          !function (t) {
            var e = /*#__PURE__*/function (_t$Lh3) {
              _inherits(e, _t$Lh3);
              var _super14 = _createSuper(e);
              function e() {
                _classCallCheck(this, e);
                return _super14.call(this, "wdr-ui-hgroup");
              }
              return _createClass(e);
            }(t.Lh);
            t.p5 = e;
          }(t.Ac || (t.Ac = {}));
        }(i || (i = {})), function (t) {
          !function (t) {
            var e = /*#__PURE__*/function (_t$Lh4) {
              _inherits(e, _t$Lh4);
              var _super15 = _createSuper(e);
              function e() {
                _classCallCheck(this, e);
                return _super15.call(this, "wdr-ui-vgroup");
              }
              return _createClass(e);
            }(t.Lh);
            t.t5 = e;
          }(t.Ac || (t.Ac = {}));
        }(i || (i = {})), function (t) {
          !function (t) {
            var e = /*#__PURE__*/function (_t$Lh5) {
              _inherits(e, _t$Lh5);
              var _super16 = _createSuper(e);
              function e() {
                _classCallCheck(this, e);
                return _super16.call(this, "wdr-ui-panel");
              }
              return _createClass(e);
            }(t.Lh);
            t.q5 = e;
          }(t.Ac || (t.Ac = {}));
        }(i || (i = {})), function (t) {
          !function (i) {
            var s = /*#__PURE__*/function (_i$fT) {
              _inherits(s, _i$fT);
              var _super17 = _createSuper(s);
              function s(e) {
                var _this16;
                _classCallCheck(this, s);
                _this16 = _super17.call(this), _this16.IJ = function () {
                  return _this16.aF();
                }, _this16.tO = function (t) {
                  return _this16.jF(t);
                }, _this16.lE = !1, _this16.ap = e, _this16.B.Y("wdr-ui-popup"), _this16.Da(), _this16.cp = new t.dT(), _this16.cp.addEventListener("click", _this16.IJ), _this16.cp.Da(), _this16.ap && _this16.ap.R(_this16.cp.B);
                return _this16;
              }
              _createClass(s, [{
                key: "jF",
                value: function jF(t) {
                  var _this17 = this;
                  t.target === window && (this.B.requestAnimationFrame(function () {
                    return _this17.sr();
                  }), this.cu());
                }
              }, {
                key: "aF",
                value: function aF() {
                  this.close();
                }
              }, {
                key: "open",
                value: function open() {
                  a.qD.addEventListener("resize", this.tO), this.cp.show(), this.cp.B.Va("wdr-ui-opaque", this.lE), this.show(), this.sr(), this.Oa(e.ga.OPENED), this.cu();
                }
              }, {
                key: "close",
                value: function close() {
                  a.qD.removeEventListener("resize", this.tO), this.cp.Da(), this.Da(), this.Oa(e.ga.CLOSED);
                }
              }, {
                key: "sr",
                value: function sr() {
                  var t = this.ap;
                  if (t) {
                    var e = Math.max(0, (t.Lf(!0) - this.B.Lf(!0) - 2) / 2);
                    t = Math.max(0, (t.Xc(!0) - this.B.Xc(!0) - 2) / 2), this.setPosition(e, t);
                  }
                }
              }, {
                key: "ts",
                get: function get() {
                  return this.cp;
                }
              }]);
              return s;
            }(i.fT);
            i.Oo = s;
          }(t.Ac || (t.Ac = {}));
        }(i || (i = {})), function (t) {
          !function (t) {
            var e = /*#__PURE__*/function (_t$Lh6) {
              _inherits(e, _t$Lh6);
              var _super18 = _createSuper(e);
              function e() {
                _classCallCheck(this, e);
                return _super18.call(this, "wdr-ui-toolbar");
              }
              return _createClass(e);
            }(t.Lh);
            t.r5 = e;
          }(t.Ac || (t.Ac = {}));
        }(i || (i = {})), function (t) {
          !function (e) {
            var i = /*#__PURE__*/function (_e$Lh) {
              _inherits(i, _e$Lh);
              var _super19 = _createSuper(i);
              function i() {
                var _this18;
                _classCallCheck(this, i);
                _this18 = _super19.call(this, "wdr-ui-toolbar-mobile"), _this18.VD = new t.dc(), _this18.VD.Y("wdr-ui-header-display"), _this18.R(_this18.VD);
                return _this18;
              }
              _createClass(i, [{
                key: "L2",
                value: function L2(t) {
                  this.Hj != t && (this.Hj = t, this.VD.wa(t));
                }
              }]);
              return i;
            }(e.Lh);
            e.s5 = i;
          }(t.Ac || (t.Ac = {}));
        }(i || (i = {})), function (t) {
          (t.MW || (t.MW = {})).k5 = /*#__PURE__*/function () {
            function _class2() {
              _classCallCheck(this, _class2);
              this.items = [], this.sx = [];
            }
            _createClass(_class2, [{
              key: "aA",
              value: function aA(t) {
                this.sx = t;
              }
            }, {
              key: "LD",
              value: function LD(t, e) {
                if (0 > t || e > this.sx.length + 1) return [];
                for (this.items.length = 0; t < e; t++) this.items.push(this.sx[t]);
                return this.items;
              }
            }, {
              key: "Ou",
              value: function Ou() {
                return this.sx.length;
              }
            }]);
            return _class2;
          }();
        }(i || (i = {})), function (t) {
          !function (i) {
            var s = /*#__PURE__*/function (_t$ya8) {
              _inherits(s, _t$ya8);
              var _super20 = _createSuper(s);
              function s() {
                var _this19;
                _classCallCheck(this, s);
                _this19 = _super20.call(this, "ul", "wdr-ui-list"), _this19.yO = a.Wc().pg ? s.DQ : s.CQ, _this19.EF = [], _this19.tv = [], _this19.Si = !1, _this19.useCache = !0, _this19.Oq = !1, _this19.K = [], _this19.sN = [], _this19.eh = [], _this19.tm = "label", _this19.Sn = _this19.QW, _this19.Zg = null, _this19.selectedIndex = -1, _this19.B.addEventListener("click", function (t) {
                  return _this19.D0(t);
                });
                return _this19;
              }
              _createClass(s, [{
                key: "Zb",
                value: function Zb() {
                  return 0 < this.eh.length ? this.eh[0].Xc() : this.yO;
                }
              }, {
                key: "Gy",
                value: function Gy() {
                  return 0;
                }
              }, {
                key: "Vr",
                value: function Vr() {
                  return this.K.length;
                }
              }, {
                key: "Ha",
                value: function Ha() {
                  this.ez() && this.$W(), this.validate();
                }
              }, {
                key: "$W",
                value: function $W() {
                  var _this20 = this;
                  var t = this.B.element.scrollTop;
                  this.Y1();
                  for (var e, i = this.Qb(), _s = 0; _s < i.length; _s++) e = this.getItem(i[_s], _s), this.Ea(e);
                  this.B.HF(t), this.B.requestAnimationFrame(function () {
                    0 < _this20.eh.length && (_this20.yO = _this20.eh[0].Xc());
                  });
                }
              }, {
                key: "getItem",
                value: function getItem(t, e) {
                  if (this.useCache && 0 < this.sN.length) {
                    var i = this.sN.pop();
                    i.setData(t), i.al(e);
                  } else (i = this.Sn(t, e)).wg(this.tm);
                  return i;
                }
              }, {
                key: "Ea",
                value: function Ea(t) {
                  this.eh.push(t), this.R(t);
                }
              }, {
                key: "Y1",
                value: function Y1() {
                  for (; 0 < this.eh.length;) this.NJ(this.eh.pop());
                }
              }, {
                key: "removeItem",
                value: function removeItem(t) {
                  for (var e = 0; e < this.eh.length; e++) if (this.eh[e] === t) {
                    this.eh.splice(e, 1);
                    break;
                  }
                  this.NJ(t);
                }
              }, {
                key: "NJ",
                value: function NJ(t) {
                  null != this.B.find(t.B.element.nodeName) && t.B.remove();
                }
              }, {
                key: "D0",
                value: function D0(i) {
                  if (null != (i = t.ia.Ga(i.target).closest("li"))) {
                    i = parseInt(i.ja("data-index"));
                    var _s2 = this.Gy() + i,
                      r = this.Zg,
                      n = this.selectedIndex;
                    this.io(i), this.Oa(e.ga.oe, this, {
                      Zg: this.Zg,
                      selectedIndex: this.selectedIndex,
                      L5: _s2,
                      K5: r,
                      J5: n
                    });
                  }
                }
              }, {
                key: "Qb",
                value: function Qb() {
                  return this.K;
                }
              }, {
                key: "vg",
                value: function vg(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                  this.K = t, e && this.df("data");
                }
              }, {
                key: "Ni",
                value: function Ni() {
                  return this.tm;
                }
              }, {
                key: "wg",
                value: function wg(t) {
                  this.tm != t && (this.tm = t, this.df("data"));
                }
              }, {
                key: "$g",
                value: function $g(t) {
                  this.Sn = t, this.df("data");
                }
              }, {
                key: "fl",
                value: function fl(t) {
                  -1 < t && t < this.eh.length && this.eh[t].so();
                }
              }, {
                key: "Zj",
                value: function Zj(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  for (var i, _s3 = 0; _s3 < this.eh.length; _s3++) if (i = this.eh[_s3].getData(), 0 == e.length && i === t || 0 < e.length && i.hasOwnProperty(e) && i[e] == t[e]) {
                    this.eh[_s3].so();
                    break;
                  }
                }
              }, {
                key: "io",
                value: function io(t) {
                  var e = this.Qb();
                  -1 < t && t < e.length ? this.kA(e[t], t) : this.kA(null, -1);
                }
              }, {
                key: "Jn",
                value: function Jn() {
                  return this.Zg;
                }
              }, {
                key: "yv",
                value: function yv(t, e) {
                  var i = this.Qb();
                  if (a.U(t) || a.Vb(e)) -1 < i.indexOf(t) && this.kA(t, i.indexOf(t));else for (var _s4 = 0; _s4 < i.length; _s4++) if (!a.U(i[_s4]) && i[_s4][e] == t[e]) {
                    this.kA(i[_s4], _s4);
                    break;
                  }
                }
              }, {
                key: "kA",
                value: function kA(t, e) {
                  if (this.qj) {
                    var i = -1 < this.tv.indexOf(e);
                    !(i = !i) && 2 > this.tv.length || (i ? (this.tv.push(e), this.EF.push(t)) : (this.tv.splice(this.tv.indexOf(e), 1), this.EF.splice(this.EF.indexOf(t), 1)), this.Si && (t.isSelected = i, this.fl(e)));
                  } else this.Si && null != this.Zg && (this.Zg.isSelected = !1, this.fl(this.selectedIndex)), this.Zg = t, this.selectedIndex = e, this.Si && null != this.Zg && (this.Zg.isSelected = !0, this.fl(this.selectedIndex));
                }
              }, {
                key: "QW",
                value: function QW(e, i) {
                  var _s5 = new t.yf.wt();
                  return _s5.setData(e), _s5.al(i), _s5;
                }
              }, {
                key: "ND",
                value: function ND() {
                  return this.Zb();
                }
              }, {
                key: "Ur",
                value: function Ur() {
                  return this.Zb() * this.Qb().length;
                }
              }, {
                key: "qj",
                get: function get() {
                  return this.Oq;
                },
                set: function set(t) {
                  this.Oq = t;
                }
              }, {
                key: "zj",
                value: function zj(t) {
                  this.B.zj(t, this);
                }
              }]);
              return s;
            }(t.ya);
            s.CQ = 21, s.DQ = 31, i.Mh = s;
          }(t.Zc || (t.Zc = {}));
        }(i || (i = {})), function (t) {
          !function (i) {
            var s = /*#__PURE__*/function (_t$ya9) {
              _inherits(s, _t$ya9);
              var _super21 = _createSuper(s);
              function s() {
                var _this21;
                _classCallCheck(this, s);
                _this21 = _super21.call(this, "div", "wdr-ui-dropdown"), _this21.prompt = "Choose item", _this21.HE = function (t) {
                  return _this21.eZ(t);
                }, _this21.Oq = !1, _this21.B.display = "inline-block", _this21.wp = new i.bT(), _this21.wp.addEventListener(e.ga.oe, function () {
                  return _this21.P_();
                }), _this21.Au = new t.ya("div", "wdr-ui-dropdown-list"), _this21.Au.Da(), _this21.Id = new i.Mh(), _this21.Id.Si = !0, _this21.Id.$g(_this21.Sn), _this21.Id.addEventListener(e.ga.oe, function (t) {
                  return _this21.jv(t);
                }), _this21.Au.R(_this21.Id), _this21.R(_this21.wp), _this21.R(_this21.Au);
                return _this21;
              }
              _createClass(s, [{
                key: "Sn",
                value: function Sn(e, i) {
                  var _s6 = new t.yf.dB();
                  return _s6.setData(e), _s6.al(i), _s6;
                }
              }, {
                key: "jv",
                value: function jv(t) {
                  this.im(null == t.data.Zg), this.Oa(e.ga.oe, this, t.data), this.qj || this.close();
                }
              }, {
                key: "P_",
                value: function P_() {
                  this.wp.getSelection() ? this.open() : this.close();
                }
              }, {
                key: "im",
                value: function im(t) {
                  var e = this.Id.Jn();
                  this.wp.wa(t || this.qj || null == e ? this.prompt : e[this.Ni()]), this.B.Va("wdr-ui-prompt", t);
                }
              }, {
                key: "Hs",
                value: function Hs(t) {
                  this.prompt !== t && (this.prompt = t, this.im(!0));
                }
              }, {
                key: "open",
                value: function open() {
                  this.xy() && (this.Au.show(), this.Id.Dm(this.wp.Lf(!0)), this.wp.wc(1), document.body.addEventListener("mousedown", this.HE));
                }
              }, {
                key: "eZ",
                value: function eZ(e) {
                  null == t.ia.Ga(e.target).closest(".wdr-ui-dropdown") && (document.body.removeEventListener("mousedown", this.HE), this.close());
                }
              }, {
                key: "close",
                value: function close() {
                  this.xy() && (this.Au.Da(), this.wp.wc(0), document.body.removeEventListener("mouseup", this.HE));
                }
              }, {
                key: "Qb",
                value: function Qb() {
                  return this.Id.Qb();
                }
              }, {
                key: "vg",
                value: function vg(t) {
                  this.Id.vg(t);
                }
              }, {
                key: "Ni",
                value: function Ni() {
                  return this.Id.Ni();
                }
              }, {
                key: "wg",
                value: function wg(t) {
                  this.Id.wg(t);
                }
              }, {
                key: "$g",
                value: function $g(t) {
                  this.Id.$g(t);
                }
              }, {
                key: "so",
                value: function so() {
                  this.Id.so();
                }
              }, {
                key: "fl",
                value: function fl(t) {
                  this.Id.fl(t);
                }
              }, {
                key: "io",
                value: function io(t) {
                  this.Id.io(t), this.im(null == this.Id.Jn());
                }
              }, {
                key: "Jn",
                value: function Jn() {
                  return this.Id.Jn();
                }
              }, {
                key: "yv",
                value: function yv(t, e) {
                  this.Id.yv(t, e), this.im(null == this.Id.Jn());
                }
              }, {
                key: "show",
                value: function show() {
                  _get(_getPrototypeOf(s.prototype), "show", this).call(this);
                }
              }, {
                key: "Zb",
                value: function Zb() {
                  return this.Id.Zb();
                }
              }, {
                key: "Vr",
                value: function Vr() {
                  return this.Id.Vr();
                }
              }, {
                key: "Zj",
                value: function Zj() {}
              }, {
                key: "ND",
                value: function ND() {
                  return 0;
                }
              }, {
                key: "Ur",
                value: function Ur() {
                  return 0;
                }
              }, {
                key: "qj",
                get: function get() {
                  return this.Oq;
                },
                set: function set(t) {
                  this.Oq = t, this.Id.qj = t, this.Oq ? this.Id.B.Y("wdr-ui-dropdown-multiple-selection-list") : this.Id.B.qd("wdr-ui-dropdown-multiple-selection-list");
                }
              }, {
                key: "Si",
                set: function set(t) {
                  this.Id.Si = t;
                }
              }]);
              return s;
            }(t.ya);
            i.cT = s;
          }(t.Zc || (t.Zc = {}));
        }(i || (i = {})), function (t) {
          !function (e) {
            var i = /*#__PURE__*/function (_t$ya10) {
              _inherits(i, _t$ya10);
              var _super22 = _createSuper(i);
              function i() {
                var _this22;
                _classCallCheck(this, i);
                _this22 = _super22.call(this), _this22.Y("wdr-ui-vlist"), _this22.Hg = new e.Mh(), _this22.R(_this22.Hg), _this22.rk = new t.ya("div", "wdr-ui-vlist-placeholder"), _this22.R(_this22.rk), _this22.addEventListener("scroll", function () {
                  return _this22.h1();
                });
                return _this22;
              }
              _createClass(i, [{
                key: "h1",
                value: function h1() {
                  this.df("data");
                }
              }, {
                key: "Ha",
                value: function Ha() {
                  if (this.rk.Fs(Math.min(this.Ur(), i.nw)), this.ez()) {
                    this.Hg.vg(this.Qb());
                    var t = this.Gy() * this.Zb() * this.Wr() - this.NM();
                    this.Hg.B.top = Math.min(t, this.rk.Xc() - this.Hg.B.height);
                  }
                  this.validate();
                }
              }, {
                key: "Wr",
                value: function Wr() {
                  return this.Ur() > i.nw ? i.nw / this.Ur() : 1;
                }
              }, {
                key: "Gy",
                value: function Gy() {
                  return 1 != this.Wr() ? Math.floor((this.B.element.scrollTop + this.NM()) / this.Wr() / this.Zb()) : Math.floor(this.B.element.scrollTop / this.Zb());
                }
              }, {
                key: "NM",
                value: function NM() {
                  return 1 != this.Wr() ? (this.Xc() / this.Wr() - this.Xc()) * (this.B.element.scrollTop / i.nw) * this.Wr() : 0;
                }
              }, {
                key: "qj",
                get: function get() {
                  return this.Hg.qj;
                },
                set: function set(t) {
                  this.Hg.qj = t;
                }
              }, {
                key: "Ni",
                value: function Ni() {
                  return this.Hg.Ni();
                }
              }, {
                key: "wg",
                value: function wg(t) {
                  this.Hg.wg(t);
                }
              }, {
                key: "$g",
                value: function $g(t) {
                  this.Hg.$g(t);
                }
              }, {
                key: "fl",
                value: function fl(t) {
                  this.Hg.fl(t);
                }
              }, {
                key: "Zj",
                value: function Zj(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  this.Hg.Zj(t, e);
                }
              }, {
                key: "Zb",
                value: function Zb() {
                  return 37;
                }
              }, {
                key: "Vr",
                value: function Vr() {
                  return 0 < this.Zb() ? Math.ceil(this.Xc() / this.Zb()) + 1 : 0;
                }
              }, {
                key: "io",
                value: function io(t) {
                  this.Hg.io(t);
                }
              }, {
                key: "Jn",
                value: function Jn() {
                  return this.Hg.Jn();
                }
              }, {
                key: "yv",
                value: function yv(t, e) {
                  this.Hg.yv(t, e);
                }
              }, {
                key: "ND",
                value: function ND() {
                  return this.Hg.Zb();
                }
              }, {
                key: "Ur",
                value: function Ur() {
                  return this.Zb() * this.Ud().Ou();
                }
              }, {
                key: "Ud",
                value: function Ud() {
                  return this.k3;
                }
              }, {
                key: "JF",
                value: function JF(t) {
                  this.k3 = t;
                }
              }, {
                key: "W2",
                value: function W2() {
                  this.B.HF(0);
                }
              }, {
                key: "vg",
                value: function vg(t) {
                  this.Ud() && (this.Ud().aA(t), this.W2(), this.df("data"));
                }
              }, {
                key: "Qb",
                value: function Qb() {
                  var t = this.Gy(),
                    e = t + this.Vr();
                  return this.Ud() ? this.Ud().LD(t, e) : [];
                }
              }]);
              return i;
            }(t.ya);
            i.nw = 1e6, e.eT = i;
          }(t.Zc || (t.Zc = {}));
        }(i || (i = {})), function (t) {
          !function (e) {
            var i = /*#__PURE__*/function (_t$Xm2) {
              _inherits(i, _t$Xm2);
              var _super23 = _createSuper(i);
              function i() {
                var _this23;
                _classCallCheck(this, i);
                _this23 = _super23.call(this), _this23.Y("wdr-ui-dropdown-btn"), _this23.uN = new t.dc(), _this23.R(_this23.uN);
                return _this23;
              }
              _createClass(i, [{
                key: "wa",
                value: function wa(t) {
                  this.uN.wa(t);
                }
              }]);
              return i;
            }(t.Xm);
            e.bT = i;
          }(t.Zc || (t.Zc = {}));
        }(i || (i = {})), function (t) {
          !function (e) {
            var i = /*#__PURE__*/function (_t$ya11) {
              _inherits(i, _t$ya11);
              var _super24 = _createSuper(i);
              function i() {
                var _this24;
                _classCallCheck(this, i);
                _this24 = _super24.call(this, "li"), _this24.tm = "label";
                return _this24;
              }
              _createClass(i, [{
                key: "getData",
                value: function getData() {
                  return this.data;
                }
              }, {
                key: "setData",
                value: function setData(t) {
                  null != t && (this.data = t, this.df("data"));
                }
              }, {
                key: "zM",
                value: function zM() {
                  return parseInt(this.B.ja("data-index"));
                }
              }, {
                key: "al",
                value: function al(t) {
                  this.B.ja("data-index", t);
                }
              }, {
                key: "Ni",
                value: function Ni() {
                  return this.tm;
                }
              }, {
                key: "wg",
                value: function wg(t) {
                  this.tm != t && (this.tm = t, this.df("data"));
                }
              }, {
                key: "N2",
                value: function N2(t) {
                  this.uE != t && (this.uE = t, this.df("data"));
                }
              }, {
                key: "Ha",
                value: function Ha() {
                  this.ez() && this.B.text(this.data[this.tm]), this.validate();
                }
              }]);
              return i;
            }(t.ya);
            e.wt = i;
          }(t.yf || (t.yf = {}));
        }(i || (i = {})), function (t) {
          !function (e) {
            var i = /*#__PURE__*/function (_e$wt) {
              _inherits(i, _e$wt);
              var _super25 = _createSuper(i);
              function i() {
                _classCallCheck(this, i);
                return _super25.call(this);
              }
              _createClass(i, [{
                key: "Ha",
                value: function Ha() {
                  var e = this.getData();
                  null == this.label && (this.label = new t.dc(), this.label.qb("#wdr-text-display"), this.B.append(this.label.B)), this.label.wa(e[this.Ni()], !0), this.B.Va("wdr-selected", !0 === e.isSelected), this.B.Va("wdr-not-selected", !0 !== e.isSelected);
                }
              }]);
              return i;
            }(e.wt);
            e.dB = i;
          }(t.yf || (t.yf = {}));
        }(i || (i = {})), function (t) {
          (t.Nz || (t.Nz = {})).xS = /*#__PURE__*/function () {
            function _class3(t, e) {
              var _this25 = this;
              _classCallCheck(this, _class3);
              this.$w = function (t) {
                return _this25.wm(t);
              }, this.dr = function (t) {
                return _this25.bi(t);
              }, this.bp = function (t) {
                return _this25.xm(t);
              }, this.target = t, this.options = e, this.yW();
            }
            _createClass(_class3, [{
              key: "yW",
              value: function yW() {
                for (var t = 0; t < this.options.jP.length; t++) this.Dk(this.options.jP[t]);
              }
            }, {
              key: "Dk",
              value: function Dk(e) {
                var i = new t.ia("div", "wdr-resizable-handle");
                return i.Y("wdr-" + e), i.addEventListener("mousedown", this.$w), this.target.R(i), i;
              }
            }, {
              key: "wm",
              value: function wm(e) {
                (e = t.ia.Ga(e.target)).Pc("wdr-left") ? this.Sw = "left" : e.Pc("wdr-right") && (this.Sw = "right"), this.Ev();
              }
            }, {
              key: "bi",
              value: function bi(t) {
                this.aO(t.clientX), this.Fv();
              }
            }, {
              key: "xm",
              value: function xm(t) {
                this.At && (t.clientX < this.At.left || t.clientX > this.At.right || t.clientY < this.At.top || t.clientY > this.At.bottom) ? this.bi(t) : this.aO(t.clientX);
              }
            }, {
              key: "aO",
              value: function aO(t) {
                var e = {
                    left: this.Vt.left,
                    top: this.Vt.top
                  },
                  i = {
                    width: this.ZB.width,
                    height: this.ZB.height
                  };
                "left" == this.Sw && (e.left = t, i.width += this.Vt.left - e.left), "right" == this.Sw && (i.width = t - this.Vt.left), this.options.resize && this.options.resize({
                  N5: this.Sw,
                  I5: this.Vt,
                  E1: this.ZB,
                  position: e,
                  size: i
                });
              }
            }, {
              key: "Ev",
              value: function Ev() {
                document.addEventListener("mousemove", this.bp), document.addEventListener("mouseup", this.dr), this.ZB = {
                  width: this.target.Lf(!0),
                  height: this.target.Xc(!0)
                }, this.Vt = {
                  left: this.target.Dj().left,
                  top: this.target.Dj().top
                }, this.At = this.options.IC ? this.options.IC.getBoundingClientRect() : null;
              }
            }, {
              key: "Fv",
              value: function Fv() {
                document.removeEventListener("mousemove", this.bp), document.removeEventListener("mouseup", this.dr);
              }
            }, {
              key: "la",
              value: function la() {
                document.removeEventListener("mousemove", this.bp), document.removeEventListener("mouseup", this.dr);
              }
            }]);
            return _class3;
          }();
        }(i || (i = {})), function (t) {
          (t.ZJ || (t.ZJ = {})).zR = /*#__PURE__*/function () {
            function _class4(t) {
              var _this26 = this;
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1e3;
              _classCallCheck(this, _class4);
              this.KP = function (t) {
                return _this26.w1(t);
              }, this.JP = function (t) {
                return _this26.yz(t);
              }, this.target = t, this.delay = e;
            }
            _createClass(_class4, [{
              key: "b_",
              value: function b_(t) {
                this.Rg = t, this.target.addEventListener("touchstart", this.KP), this.target.addEventListener("touchend", this.JP);
              }
            }, {
              key: "stop",
              value: function stop() {
                this.target.removeEventListener("touchstart", this.KP), this.target.removeEventListener("touchend", this.JP);
              }
            }, {
              key: "w1",
              value: function w1(t) {
                var _this27 = this;
                this.me = a.xd(function () {
                  return _this27.yV(t);
                }, this.delay);
              }
            }, {
              key: "yz",
              value: function yz() {
                this.me && a.Pg(this.me);
              }
            }, {
              key: "yV",
              value: function yV(t) {
                this.Rg(t, t && 0 < t.changedTouches.length ? t.changedTouches[0] : null);
              }
            }]);
            return _class4;
          }();
        }(i || (i = {})), function (t) {
          var e = /*#__PURE__*/function () {
            function e(t) {
              var _e14 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              _classCallCheck(this, e);
              this.MT = !0, this.an = 0, this.Vo = _e14, this.buffer = t, this.position = 0;
            }
            _createClass(e, [{
              key: "byteOffset",
              get: function get() {
                return this.Vo;
              },
              set: function set(t) {
                this.Vo = t, this.eJ = new DataView(this.pi, this.Vo), this.an = this.pi.byteLength;
              }
            }, {
              key: "byteLength",
              get: function get() {
                return this.an - this.Vo;
              }
            }, {
              key: "buffer",
              get: function get() {
                return this.kU(), this.pi;
              },
              set: function set(t) {
                this.pi = t, this.eJ = 0 == this.Vo ? new DataView(this.pi) : new DataView(this.pi, this.Vo), this.an = this.pi.byteLength;
              }
            }, {
              key: "seek",
              value: function seek(t) {
                t = Math.max(0, Math.min(this.byteLength, t)), this.position = isNaN(t) || !isFinite(t) ? 0 : t;
              }
            }, {
              key: "h4",
              value: function h4(t) {
                this.j4(i.encode(t));
              }
            }, {
              key: "i4",
              value: function i4(t) {
                this.aC(1), this.eJ.setUint8(this.position, t), this.position += 1;
              }
            }, {
              key: "j4",
              value: function j4(t) {
                if (this.aC(1 * t.length), t instanceof Uint8Array && 0 == this.byteOffset + this.position % t.BYTES_PER_ELEMENT) this.n_(this.pi, this.byteOffset + this.position, t.buffer, t.byteLength), this.EN(t.length);else for (var _e15 = 0; _e15 < t.length; _e15++) this.i4(t[_e15]);
              }
            }, {
              key: "rF",
              value: function rF(t) {
                return s.decode(this.EN(t));
              }
            }, {
              key: "EN",
              value: function EN(t) {
                this.aC(1 * t);
                var _e16 = new Uint8Array(this.pi, this.byteOffset + this.position, t);
                return this.position += 1 * t, _e16;
              }
            }, {
              key: "aC",
              value: function aC(t) {
                if (this.MT) {
                  t = this.Vo + this.position + t;
                  var _e17 = this.pi.byteLength;
                  if (t <= _e17) t > this.an && (this.an = t);else {
                    for (1 > _e17 && (_e17 = 1); t > _e17;) _e17 *= 2;
                    _e17 = new ArrayBuffer(_e17);
                    var i = new Uint8Array(this.pi);
                    new Uint8Array(_e17, 0, i.length).set(i), this.buffer = _e17, this.an = t;
                  }
                }
              }
            }, {
              key: "kU",
              value: function kU() {
                if (this.an != this.pi.byteLength) {
                  var t = new ArrayBuffer(this.an),
                    _e18 = new Uint8Array(t),
                    i = new Uint8Array(this.pi, 0, _e18.length);
                  _e18.set(i), this.buffer = t;
                }
              }
            }, {
              key: "n_",
              value: function n_(t, _e19, i, s) {
                t = new Uint8Array(t, _e19, s), i = new Uint8Array(i, 0, s), t.set(i);
              }
            }]);
            return e;
          }();
          e.nA = !1, t.yq = e;
          var i = /*#__PURE__*/function () {
            function i() {
              _classCallCheck(this, i);
            }
            _createClass(i, null, [{
              key: "encode",
              value: function encode(t) {
                t = t ? String(t) : "";
                var e = [],
                  s = new o(e);
                for (t = new h(t), null == i.fD && (i.fD = new n()); t.get() !== i.Ag;) i.fD.encode(s, t);
                do {
                  var r = i.fD.encode(s, t);
                } while (r !== i.fj);
                return new Uint8Array(e);
              }
            }]);
            return i;
          }();
          i.fj = -1, i.Ag = -1, t.TextEncoder = i;
          var s = /*#__PURE__*/function () {
            function s() {
              _classCallCheck(this, s);
            }
            _createClass(s, null, [{
              key: "decode",
              value: function decode(t) {
                t || (t = new Uint8Array(0)), t = new Uint8Array(t.buffer, t.byteOffset, t.byteLength), t = new a(t);
                var e = new l();
                for (null == s.UC && (s.UC = new r()); t.get() !== s.fj;) {
                  var i = s.UC.decode(t);
                  null !== i && i !== s.Ag && e.Kr(i);
                }
                do {
                  null !== (i = s.UC.decode(t)) && i !== s.Ag && e.Kr(i);
                } while (i !== s.Ag);
                return e.Ml;
              }
            }]);
            return s;
          }();
          s.fj = -1, s.Ag = -1, t.TextDecoder = s;
          var r = /*#__PURE__*/function () {
            function r() {
              _classCallCheck(this, r);
              this.Ag = this.fj = -1, this.Qs = this.Ps = this.Gm = this.el = 0;
            }
            _createClass(r, [{
              key: "decode",
              value: function decode(t) {
                var e = t.get();
                if (e === this.fj) return this.Ag;
                if (t.offset(1), 0 === this.Gm) {
                  if (this.inRange(e, 0, 127)) return e;
                  if (this.inRange(e, 194, 223)) this.Gm = 1, this.Qs = 128, this.el = e - 192;else if (this.inRange(e, 224, 239)) this.Gm = 2, this.Qs = 2048, this.el = e - 224;else {
                    if (!this.inRange(e, 240, 244)) return this.Ag;
                    this.Gm = 3, this.Qs = 65536, this.el = e - 240;
                  }
                  return this.el *= Math.pow(64, this.Gm), null;
                }
                return this.inRange(e, 128, 191) ? (this.Ps += 1, this.el += (e - 128) * Math.pow(64, this.Gm - this.Ps), this.Ps !== this.Gm ? null : (t = this.el, e = this.Qs, this.Qs = this.Ps = this.Gm = this.el = 0, this.inRange(t, e, 1114111) && !this.inRange(t, 55296, 57343) ? t : this.Ag)) : (this.Qs = this.Ps = this.Gm = this.el = 0, t.offset(-1), this.Ag);
              }
            }, {
              key: "inRange",
              value: function inRange(t, e, i) {
                return e <= t && t <= i;
              }
            }]);
            return r;
          }();
          t.w5 = r;
          var n = /*#__PURE__*/function () {
            function n() {
              _classCallCheck(this, n);
              this.Ag = this.fj = -1;
            }
            _createClass(n, [{
              key: "inRange",
              value: function inRange(t, e, i) {
                return e <= t && t <= i;
              }
            }, {
              key: "wL",
              value: function wL(t, e) {
                return Math.floor(t / e);
              }
            }, {
              key: "encode",
              value: function encode(t, e) {
                var i = e.get();
                if (i === this.Ag) return this.fj;
                if (e.offset(1), this.inRange(i, 55296, 57343)) return this.Ag;
                if (this.inRange(i, 0, 127)) return t.Kr(i);
                if (this.inRange(i, 128, 2047)) var s = 1,
                  r = 192;else this.inRange(i, 2048, 65535) ? (s = 2, r = 224) : this.inRange(i, 65536, 1114111) && (s = 3, r = 240);
                for (e = t.Kr(this.wL(i, Math.pow(64, s)) + r); 0 < s;) e = t.Kr(128 + this.wL(i, Math.pow(64, s - 1)) % 64), --s;
                return e;
              }
            }]);
            return n;
          }();
          t.x5 = n;
          var a = /*#__PURE__*/function () {
            function a(t) {
              _classCallCheck(this, a);
              this.fj = -1, this.Rf = 0, this.mp = t;
            }
            _createClass(a, [{
              key: "get",
              value: function get() {
                return this.Rf >= this.mp.length ? this.fj : Number(this.mp[this.Rf]);
              }
            }, {
              key: "offset",
              value: function offset(t) {
                if (this.Rf += t, 0 > this.Rf) throw Error("Seeking past start of the buffer");
                if (this.Rf > this.mp.length) throw Error("Seeking past EOF");
              }
            }, {
              key: "match",
              value: function match(t) {
                if (t.length > this.Rf + this.mp.length) return !1;
                var e;
                for (e = 0; e < t.length; e += 1) if (Number(this.mp[this.Rf + e]) !== t[e]) return !1;
                return !0;
              }
            }]);
            return a;
          }();
          t.r4 = a;
          var o = /*#__PURE__*/function () {
            function o(t) {
              _classCallCheck(this, o);
              this.fj = -1, this.Rf = 0, this.mp = t;
            }
            _createClass(o, [{
              key: "Kr",
              value: function Kr(t) {
                var e,
                  i = this.fj;
                for (e = 0; e < arguments.length; ++e) i = Number(arguments[e]), this.mp[this.Rf++] = i;
                return i;
              }
            }]);
            return o;
          }();
          t.s4 = o;
          var h = /*#__PURE__*/function () {
            function h(t) {
              _classCallCheck(this, h);
              this.Rf = 0, this.Ag = -1, this.Ml = t, this.NC = this.pY(this.Ml);
            }
            _createClass(h, [{
              key: "pY",
              value: function pY(t) {
                for (var e = [], i = 0, s = t.length; i < t.length;) {
                  var r = t.charCodeAt(i);
                  if (this.inRange(r, 55296, 57343)) {
                    if (this.inRange(r, 56320, 57343)) e.push(65533);else if (i === s - 1) e.push(65533);else {
                      var n = t.charCodeAt(i + 1);
                      this.inRange(n, 56320, 57343) ? (r &= 1023, n &= 1023, i += 1, e.push(65536 + (r << 10) + n)) : e.push(65533);
                    }
                  } else e.push(r);
                  i += 1;
                }
                return e;
              }
            }, {
              key: "inRange",
              value: function inRange(t, e, i) {
                return e <= t && t <= i;
              }
            }, {
              key: "offset",
              value: function offset(t) {
                if (this.Rf += t, 0 > this.Rf) throw Error("Seeking past start of the buffer");
                if (this.Rf > this.NC.length) throw Error("Seeking past EOF");
              }
            }, {
              key: "get",
              value: function get() {
                return this.Rf >= this.NC.length ? this.Ag : this.NC[this.Rf];
              }
            }]);
            return h;
          }();
          t.w4 = h;
          var l = /*#__PURE__*/function () {
            function l() {
              _classCallCheck(this, l);
              this.Ml = "";
            }
            _createClass(l, [{
              key: "Kr",
              value: function Kr(t) {
                65535 >= t ? this.Ml += String.fromCharCode(t) : (t -= 65536, this.Ml += String.fromCharCode(55296 + (t >> 10 & 1023)), this.Ml += String.fromCharCode(56320 + (1023 & t)));
              }
            }]);
            return l;
          }();
          t.x4 = l;
        }(r || (r = {})), function (t) {
          var i = /*#__PURE__*/function (_e$Od3) {
            _inherits(i, _e$Od3);
            var _super26 = _createSuper(i);
            function i() {
              var _this28;
              _classCallCheck(this, i);
              _this28 = _super26.call(this), _this28.connected = !1;
              return _this28;
            }
            _createClass(i, [{
              key: "load",
              value: function load(t) {
                var _this29 = this;
                this.url = t, this.connected = !1, this.close(), this.Wa = new XMLHttpRequest(), this.Wa.open("GET", t, !0), this.Wa.responseType = "arraybuffer", this.Wa.onload = function () {
                  return _this29.ms();
                }, this.Wa.onprogress = function (t) {
                  return _this29.Wp(t);
                }, this.Wa.onerror = function (t) {
                  return _this29.Bh(t);
                }, this.Wa.onreadystatechange = function () {
                  return _this29.kv();
                }, this.Wa.send();
              }
            }, {
              key: "ms",
              value: function ms() {
                this.response = this.Wa.response, this.na(new e.ga(e.ga.yg, this));
              }
            }, {
              key: "Wp",
              value: function Wp(t) {
                this.na(t);
              }
            }, {
              key: "Bh",
              value: function Bh(t) {
                this.na(t);
              }
            }, {
              key: "kv",
              value: function kv() {
                null != this.Wa && 4 === this.Wa.readyState && 200 !== this.Wa.status && this.na(new e.ga(e.ga.wb, this, this.Wa.statusText)), null != this.Wa && 3 > this.Wa.readyState && !this.connected && (this.connected = !0, this.na(new e.ga(e.ga.tA)));
              }
            }, {
              key: "close",
              value: function close() {
                null != this.Wa && this.Wa.abort();
              }
            }, {
              key: "la",
              value: function la() {
                this.response = null, null != this.Wa && (this.Wa.onload = null, this.Wa.onprogress = null, this.Wa.onerror = null, this.Wa.onreadystatechange = null), this.Wa = null;
              }
            }]);
            return i;
          }(e.Od);
          t.u5 = i;
        }(n || (n = {})), function (t) {
          var i = /*#__PURE__*/function (_e$Od4) {
            _inherits(i, _e$Od4);
            var _super27 = _createSuper(i);
            function i() {
              var _this30;
              _classCallCheck(this, i);
              _this30 = _super27.call(this), _this30.dataType = s.st, _this30.contentType = r.TS, _this30.xF = n.fR, _this30.withCredentials = _this30.connected = !1, _this30.RB = 0, _this30.Tt = null, _this30.R1 = 0, _this30.zs = [], _this30.data = {}, _this30.Gg = 0;
              return _this30;
            }
            _createClass(i, [{
              key: "load",
              value: function load(t) {
                var _this31 = this;
                var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                for (this.url = t, this.Gg = 0, this.connected = !1, this.P1(e), this.close(), this.Wa = new XMLHttpRequest(), this.Wa.open(this.xF, this.url, !0), this.Wa.onerror = function (t) {
                  return _this31.Bh(t);
                }, this.Wa.onreadystatechange = function () {
                  return _this31.kv();
                }, this.Wa.onprogress = function (t) {
                  return _this31.Wp(t);
                }, this.Wa.setRequestHeader("Content-type", this.contentType), t = 0; t < this.zs.length; t++) this.Wa.setRequestHeader(this.zs[t].Hj, this.zs[t].value);
                this.Wa.send(this.data);
              }
            }, {
              key: "P1",
              value: function P1(t) {
                if (this.zs = [], null != t) for (var e in t) this.zs.push(new o(e, t[e]));
              }
            }, {
              key: "UF",
              value: function UF() {
                this.response = this.Wa.response || this.Wa.responseText, this.Gg = this.Tt ? this.Tt.loaded : this.response.length, this.na(new e.ga(e.ga.yg, this));
              }
            }, {
              key: "kv",
              value: function kv() {
                null != this.Wa && 4 === this.Wa.readyState && (200 === this.Wa.status ? this.UF() : this.na(new e.ga(e.ga.wb, this, this.Wa.statusText))), null != this.Wa && 3 > this.Wa.readyState && !this.connected && (this.connected = !0, this.na(new e.ga(e.ga.tA)));
              }
            }, {
              key: "Wp",
              value: function Wp(t) {
                a.Nk() - this.RB > this.R1 ? (this.response = this.Wa.response || this.Wa.responseText, this.Gg = t.loaded, this.na(t), this.RB = a.Nk(), this.Tt = null) : this.Tt = t;
              }
            }, {
              key: "Bh",
              value: function Bh() {
                this.na(new e.ga(e.ga.wb, this));
              }
            }, {
              key: "close",
              value: function close() {
                null != this.Wa && (this.Wa.onprogress = null, this.Wa.onreadystatechange = null, this.Wa.abort());
              }
            }, {
              key: "la",
              value: function la() {
                this.data = this.response = null, this.zs = [], null != this.Wa && (this.Wa.onprogress = null, this.Wa.onreadystatechange = null), this.RB = this.Tt = this.Wa = null;
              }
            }]);
            return i;
          }(e.Od);
          t.Gw = i;
          var s = /*#__PURE__*/_createClass(function s() {
            _classCallCheck(this, s);
          });
          s.st = "text", s.ZI = "xml", s.Fo = "html", s.JSON = "json", t.QG = s;
          var r = /*#__PURE__*/_createClass(function r() {
            _classCallCheck(this, r);
          });
          r.TS = "text/plain", r.UP = "application/x-www-form-urlencoded", t.zQ = r;
          var n = /*#__PURE__*/_createClass(function n() {
            _classCallCheck(this, n);
          });
          n.lI = "POST", n.fR = "GET", t.WI = n;
          var o = /*#__PURE__*/_createClass(function o(t, e) {
            _classCallCheck(this, o);
            this.Hj = t, this.value = e;
          });
          t.v5 = o, t.jT = /*#__PURE__*/function () {
            function _class5() {
              _classCallCheck(this, _class5);
              this.data = {};
            }
            _createClass(_class5, [{
              key: "toString",
              value: function toString() {
                var t,
                  e = [];
                for (t in this.data) e.push(t + "=" + this.data[t]);
                return e.join("&");
              }
            }]);
            return _class5;
          }();
        }(n || (n = {})), function (t) {
          var i = /*#__PURE__*/function (_e$Od5) {
            _inherits(i, _e$Od5);
            var _super28 = _createSuper(i);
            function i() {
              var _this32;
              _classCallCheck(this, i);
              _this32 = _super28.call(this), _this32.Px = !1, document.body.onfocus = function () {
                return _this32.q0();
              };
              return _this32;
            }
            _createClass(i, [{
              key: "FK",
              value: function FK() {
                var _this33 = this;
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                this.input = document.createElement("input"), this.input.setAttribute("type", "file"), this.input.style.display = "none", document.body.appendChild(this.input), this.input.setAttribute("accept", t.join(",")), this.input.addEventListener("change", function () {
                  return _this33.S_();
                }), this.Px = !0, this.input.click();
              }
            }, {
              key: "S_",
              value: function S_() {
                this.Px = !1, a.U(this.input.files) || a.U(this.input.files[0]) || (this.file = this.input.files[0], this.Oa(e.ga.Vm));
              }
            }, {
              key: "q0",
              value: function q0() {
                var _this34 = this;
                this.Px && a.xd(function () {
                  (a.U(_this34.input.files) || a.U(_this34.input.files[0])) && _this34.Oa(e.ga.rA), _this34.Px = !1;
                }, 500);
              }
            }, {
              key: "load",
              value: function load() {
                var _this35 = this;
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : s.st;
                null != this.file && (this.cq = new FileReader(), this.cq.onload = function () {
                  return _this35.F0();
                }, this.cq.onprogress = function (t) {
                  return _this35.Wp(t);
                }, this.cq.onerror = function (t) {
                  return _this35.Bh(t);
                }, t == s.ARRAY_BUFFER ? this.cq.readAsArrayBuffer(this.file) : this.cq.readAsText(this.file));
              }
            }, {
              key: "F0",
              value: function F0() {
                this.response = this.cq.result, this.na(new e.ga(e.ga.yg, this));
              }
            }, {
              key: "Wp",
              value: function Wp(t) {
                this.na(t);
              }
            }, {
              key: "Bh",
              value: function Bh(t) {
                this.na(t);
              }
            }, {
              key: "la",
              value: function la() {
                this.cq = this.file = this.response = null;
              }
            }]);
            return i;
          }(e.Od);
          t.tH = i;
          var s = /*#__PURE__*/_createClass(function s() {
            _classCallCheck(this, s);
          });
          s.st = "TEXT", s.ARRAY_BUFFER = "ARRAY_BUFFER", t.vS = s;
        }(n || (n = {})), function (t) {
          var e = /*#__PURE__*/function () {
            function e() {
              _classCallCheck(this, e);
            }
            _createClass(e, [{
              key: "item",
              get: function get() {
                return this[0];
              }
            }, {
              key: "find",
              value: function find(t) {
                return void 0 === this.item ? this : this.item.find(t);
              }
            }, {
              key: "text",
              value: function text() {
                return void 0 === this.item ? "" : this.item.text();
              }
            }, {
              key: "ja",
              value: function ja(t, _e20) {
                if (void 0 !== this.item) return _e20 ? this.item.ja(t, _e20) : this.item.ja(t);
              }
            }, {
              key: "children",
              value: function children() {
                for (var t = new e(), s = 0; void 0 !== this[s];) t[s] = i.Ga(this[s]), s++;
                return t;
              }
            }, {
              key: "push",
              value: function push(t) {
                return this[this.length] = t, this;
              }
            }, {
              key: "length",
              get: function get() {
                for (var t = 0; void 0 !== this[t];) t++;
                return t;
              }
            }]);
            return e;
          }();
          t.z5 = e;
          var i = /*#__PURE__*/function (_Element) {
            _inherits(i, _Element);
            var _super29 = _createSuper(i);
            function i() {
              _classCallCheck(this, i);
              return _super29.apply(this, arguments);
            }
            _createClass(i, [{
              key: "text",
              value: function text(t) {
                return t || !1 === t ? (this.textContent = t.toString(), this) : t = a.U(this.textContent) ? "" : this.textContent;
              }
            }, {
              key: "append",
              value: function append(t) {
                return a.U(t) || "string" == typeof t && a.Vb(t) || (t instanceof CDATASection || "" != t.textContent) && this.appendChild(t), this;
              }
            }, {
              key: "Db",
              value: function Db() {
                return "" == this.text();
              }
            }, {
              key: "find",
              value: function find(t) {
                t = this.querySelectorAll(t);
                for (var s = new e(), r = 0; r < t.length; r++) s[r] = i.Ga(t[r]);
                return s;
              }
            }, {
              key: "ja",
              value: function ja(t, e) {
                return e || !1 === e ? (this.setAttribute(t, e), this) : (null == (e = this.getAttribute(t)) && (e = void 0), e);
              }
            }, {
              key: "fM",
              value: function fM() {
                for (var t = new e(), s = this.firstElementChild; s;) s.nodeType === Node.ELEMENT_NODE && t.push(i.Ga(s)), s = s.nextElementSibling;
                return t;
              }
            }, {
              key: "length",
              get: function get() {
                return this.childNodes.length;
              }
            }], [{
              key: "Ga",
              value: function Ga(t) {
                return t.find = i.prototype.find, t.append = i.prototype.append, t.text = i.prototype.text, t.ja = i.prototype.ja, t.Db = i.prototype.Db, t.fM = i.prototype.fM, t;
              }
            }]);
            return i;
          }( /*#__PURE__*/_wrapNativeSuper(Element));
          t.y5 = i;
          var s = /*#__PURE__*/function () {
            function s() {
              _classCallCheck(this, s);
              throw Error("Singleton");
            }
            _createClass(s, null, [{
              key: "create",
              value: function create(t) {
                if (null == t.firstChild) {
                  if (t = new DOMParser().parseFromString(t, "text/xml"), s.QZ(t)) return null;
                  t = t.firstElementChild ? t.firstElementChild : t.firstChild;
                } else t = t.firstChild;
                return i.Ga(t);
              }
            }, {
              key: "QZ",
              value: function QZ(t) {
                return !(!t.getElementsByTagName("parsererror") || !t.getElementsByTagName("parsererror")[0]) && 0 < t.getElementsByTagNameNS(t.getElementsByTagName("parsererror")[0].namespaceURI, "parsererror").length;
              }
            }, {
              key: "ne",
              value: function ne(t) {
                return null == s.KO && (s.KO = new XMLSerializer()), s.KO.serializeToString(t).trim();
              }
            }, {
              key: "format",
              value: function format(t) {
                var e,
                  i = (t = t.replace(/>\s{0,}</g, "><").replace(/</g, "~::~<").replace(/\s*xmlns:/g, "~::~xmlns:").replace(/\s*xmlns=/g, "~::~xmlns=").split("~::~")).length,
                  _s7 = !1,
                  r = 0,
                  n = "",
                  a = ["\n"];
                for (e = 0; 20 > e; e++) a.push(a[e] + "    ");
                for (e = 0; e < i; e++) -1 < t[e].search(/<!/) ? (n += a[r] + t[e], _s7 = !0, (-1 < t[e].search(/--\x3e/) || -1 < t[e].search(/\]>/) || -1 < t[e].search(/!DOCTYPE/)) && (_s7 = !1)) : -1 < t[e].search(/--\x3e/) || -1 < t[e].search(/\]>/) ? (n += t[e], _s7 = !1) : /^<\w/.exec(t[e - 1]) && /^<\/\w/.exec(t[e]) && /^<[\w:\-\.,]+/.exec(t[e - 1])[0] == /^<\/[\w:\-\.,]+/.exec(t[e])[0].replace("/", "") ? (n += t[e], _s7 || r--) : n = -1 < t[e].search(/<\w/) && -1 == t[e].search(/<\//) && -1 == t[e].search(/\/>/) ? n += _s7 ? t[e] : a[r++] + t[e] : -1 < t[e].search(/<\w/) && -1 < t[e].search(/<\//) ? n += _s7 ? t[e] : a[r] + t[e] : -1 < t[e].search(/<\//) ? n += _s7 ? t[e] : a[--r] + t[e] : -1 < t[e].search(/\/>/) ? n += _s7 ? t[e] : a[r] + t[e] : -1 < t[e].search(/<\?/) || -1 < t[e].search(/xmlns:/) || -1 < t[e].search(/xmlns=/) ? n + (a[r] + t[e]) : n + t[e];
                return (t = (t = "\n" == n[0] ? n.slice(1) : n).replace(/[\r\n\s]*<!\[CDATA\[/g, "<![CDATA[")).replace(/]]\x3e\s*/g, "]]>");
              }
            }]);
            return s;
          }();
          new DOMParser().parseFromString("<tmp/>", "text/xml"), t.ZI = s;
        }(n || (n = {})), function (t) {
          t.rS = /*#__PURE__*/function () {
            function _class6() {
              _classCallCheck(this, _class6);
            }
            _createClass(_class6, null, [{
              key: "print",
              value: function print(t) {
                var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
                var r = "printer-" + new Date().getTime(),
                  n = new i.ia("iframe").ja("name", r);
                n.ha("width", "1px").ha("height", "1px").ha("position", "absolute").ha("left", "-9999px"), i.ia.Ga(document.body).append(n);
                var o = (r = window.frames[r]).document;
                o.open(), o.write("<!DOCTYPE html>"), o.write("<html>"), o.write("<head>"), o.write("<title>"), o.write(s), o.write("</title>"), o.write("<style>"), o.write(e + "body{-webkit-print-color-adjust:exact;}"), o.write("</style>"), o.write("</head>"), o.write("<body>"), o.write(t), o.write("</body>"), o.write("</html>"), o.close(), r.focus(), r.print(), a.xd(function () {
                  n.remove();
                }, 2e3);
              }
            }]);
            return _class6;
          }();
        }(n || (n = {})), function (t) {
          var e = /*#__PURE__*/function () {
            function e() {
              _classCallCheck(this, e);
              this.uf = {};
            }
            _createClass(e, [{
              key: "target",
              get: function get() {
                return null;
              }
            }, {
              key: "mr",
              value: function mr(t, _e21) {
                return t.type === _e21.type && t.Rg === _e21.Rg && t.bG === _e21.bG;
              }
            }, {
              key: "TD",
              value: function TD(_e22, i) {
                if (t.U(this.uf[_e22])) return !1;
                for (var s = 0; s < this.uf[_e22].length; s++) if (this.mr(this.uf[_e22][s], i)) return !0;
                return !1;
              }
            }, {
              key: "addEventListener",
              value: function addEventListener(_e23, i, s) {
                var r = {
                  type: _e23,
                  Rg: i,
                  bG: s
                };
                this.TD(_e23, r) || (t.U(this.uf[_e23]) && (this.uf[_e23] = []), this.uf[_e23].push(r), this.target.addEventListener(_e23, i, s));
              }
            }, {
              key: "removeEventListener",
              value: function removeEventListener(t, _e24, i) {
                for (t in _e24 = {
                  type: t,
                  Rg: _e24,
                  bG: i
                }, this.uf) {
                  for (var s = [], r = 0; r < this.uf[t].length; r++) this.mr(this.uf[t][r], _e24) ? "boolean" == typeof i ? this.target.removeEventListener(t, this.uf[t][r].Rg, i) : this.target.removeEventListener(t, this.uf[t][r].Rg) : s.push(this.uf[t][r]);
                  this.uf[t] = s;
                }
              }
            }, {
              key: "la",
              value: function la() {
                for (var t in this.uf) for (var _e25 = 0; _e25 < this.uf[t].length; _e25++) this.target.removeEventListener(t, this.uf[t][_e25].Rg, !0), this.target.removeEventListener(t, this.uf[t][_e25].Rg, !1);
                this.uf = {};
              }
            }]);
            return e;
          }();
          var i = /*#__PURE__*/function (_e26) {
            _inherits(i, _e26);
            var _super30 = _createSuper(i);
            function i() {
              _classCallCheck(this, i);
              return _super30.apply(this, arguments);
            }
            _createClass(i, [{
              key: "target",
              get: function get() {
                return document;
              }
            }], [{
              key: "V",
              value: function V() {
                return null == i.instance && (i.instance = new i()), i.instance;
              }
            }]);
            return i;
          }(e);
          var s = /*#__PURE__*/function (_e27) {
            _inherits(s, _e27);
            var _super31 = _createSuper(s);
            function s() {
              _classCallCheck(this, s);
              return _super31.apply(this, arguments);
            }
            _createClass(s, [{
              key: "target",
              get: function get() {
                return window;
              }
            }], [{
              key: "V",
              value: function V() {
                return null == s.instance && (s.instance = new s()), s.instance;
              }
            }]);
            return s;
          }(e);
          var r = /*#__PURE__*/function () {
            function r() {
              _classCallCheck(this, r);
            }
            _createClass(r, null, [{
              key: "la",
              value: function la() {
                for (; 0 < r.Iv.length;) clearTimeout(r.Iv.pop());
                for (; 0 < r.Xu.length;) clearInterval(r.Xu.pop());
              }
            }]);
            return r;
          }();
          r.Iv = [], r.Xu = [], t.$S = r, t.xd = function (t, e) {
            return t = setTimeout(t, e), r.Iv.push(t), t;
          }, t.Pg = function (t) {
            clearTimeout(t), r.Iv.splice(r.Iv.indexOf(t), 1);
          }, t.YL = function (t, e) {
            return t = setInterval(t, e), r.Xu.push(t), t;
          }, t.Mr = function (t) {
            clearInterval(t), r.Xu.splice(r.Xu.indexOf(t), 1);
          }, t.lg = i.V(), t.qD = s.V();
        }(a || (a = {})), function (t) {
          var i = /*#__PURE__*/function (_e$Od6) {
            _inherits(i, _e$Od6);
            var _super32 = _createSuper(i);
            function i(t) {
              var _this36;
              _classCallCheck(this, i);
              _this36 = _super32.call(this), _this36.dC = function () {
                return _this36.w2();
              }, _this36.Uw = function () {
                return _this36.Uw();
              }, _this36.Nl = t, _this36.y3(_this36.Nl.element);
              return _this36;
            }
            _createClass(i, [{
              key: "sO",
              value: function sO(t) {
                var e = t.__resizeTriggers__;
                t = e.firstElementChild, e = e.lastElementChild;
                var _i13 = t.firstElementChild;
                e.scrollLeft = e.scrollWidth, e.scrollTop = e.scrollHeight, _i13.style.width = t.offsetWidth + 1 + "px", _i13.style.height = t.offsetHeight + 1 + "px", t.scrollLeft = t.scrollWidth, t.scrollTop = t.scrollHeight;
              }
            }, {
              key: "FV",
              value: function FV(t) {
                return t.offsetWidth != t.__resizeLast__.width || t.offsetHeight != t.__resizeLast__.height;
              }
            }, {
              key: "w2",
              value: function w2() {
                var _this37 = this;
                if (null != this.Nl) {
                  var t = this.Nl.element;
                  this.sO(t), t.__resizeRAF__ && this.Nl.cancelAnimationFrame(t.__resizeRAF__), t.__resizeRAF__ = this.Nl.requestAnimationFrame(function () {
                    _this37.FV(t) && (t.__resizeLast__.width = t.offsetWidth, t.__resizeLast__.height = t.offsetHeight, _this37.UW());
                  });
                }
              }
            }, {
              key: "UW",
              value: function UW() {
                this.Oa(e.ga.vI);
              }
            }, {
              key: "y3",
              value: function y3(t) {
                t.attachEvent ? t.attachEvent("onresize", this.Uw) : t.__resizeTriggers__ || ("static" == getComputedStyle(t).position && (t.style.position = "relative"), t.__resizeLast__ = {}, t.__resizeListeners__ = [], t.__resizeTriggers__ = document.createElement("div"), t.__resizeTriggers__.className = "wdr-resize-triggers", t.__resizeTriggers__.innerHTML = '<div class="wdr-expand-trigger"><div></div></div><div class="wdr-contract-trigger"></div>', t.appendChild(t.__resizeTriggers__), this.sO(t), t.addEventListener("scroll", this.dC, !0));
              }
            }, {
              key: "A3",
              value: function A3(t) {
                t.detachEvent ? t.detachEvent("onresize", this.Uw) : (t.removeEventListener("scroll", this.dC), t.__resizeTriggers__ = !t.removeChild(t.__resizeTriggers__));
              }
            }, {
              key: "la",
              value: function la() {
                this.Nl && this.Nl.element && this.A3(this.Nl.element), this.Uw = this.dC = this.Nl = null;
              }
            }]);
            return i;
          }(e.Od);
          t.yS = i;
        }(a || (a = {})), function (t) {
          var e = /*#__PURE__*/function () {
            function e() {
              _classCallCheck(this, e);
            }
            _createClass(e, null, [{
              key: "IZ",
              value: function IZ(t) {
                return null != t && (0 == t.indexOf("http://") || 0 == t.indexOf("https://"));
              }
            }, {
              key: "rZ",
              value: function rZ(t) {
                return null != t && 0 == t.indexOf("blob:http");
              }
            }, {
              key: "PM",
              value: function PM(t) {
                if (!t) return "()";
                if (0 == (t = t.trim()).length) return "()";
                if (e.rZ(t)) return t;
                if (t += (-1 < t.indexOf("?") ? "&" : "?") + Math.round(Date.now() / 3600), e.IZ(t) || 0 == t.indexOf("file") || "/" == t.substr(0, 1)) return t;
                if (-1 != t.indexOf("..")) {
                  for (t = t.split("/"); ".." == t[0];) 0 < t.length && t.shift();
                  "/" == (t = "/" + t.join("/")).substr(0, 1) && (t = t.substring(1));
                }
                return t;
              }
            }, {
              key: "YU",
              value: function YU(t) {
                return t + (-1 < t.indexOf("?") ? "&" : "?") + Math.round(Date.now() / 3600);
              }
            }]);
            return e;
          }();
          t.jB = e;
        }(a || (a = {})), function (t) {
          var e = /*#__PURE__*/function () {
            function e() {
              _classCallCheck(this, e);
            }
            _createClass(e, null, [{
              key: "oN",
              value: function oN(t) {
                return "UTC:" == t.slice(0, 4);
              }
            }, {
              key: "format",
              value: function format(t, i) {
                var s = !1;
                "UTC:" == i.slice(0, 4) && (i = i.slice(4), s = !0);
                var r = s ? "getUTC" : "get",
                  n = t[r + "Date"](),
                  a = t[r + "Day"](),
                  o = t[r + "Month"](),
                  h = t[r + "FullYear"](),
                  l = t[r + "Hours"](),
                  A = t[r + "Minutes"](),
                  c = t[r + "Seconds"]();
                r = t[r + "Milliseconds"]();
                var u = s ? 0 : t.getTimezoneOffset(),
                  d = {
                    d: n,
                    dd: e.Tk(n),
                    ddd: e.On.tu[a],
                    dddd: e.On.tu[a + 7],
                    D: n,
                    DD: e.Tk(n),
                    DDD: e.On.tu[a],
                    DDDD: e.On.tu[a + 7],
                    M: o + 1,
                    MM: e.Tk(o + 1),
                    MMM: e.On.EE[o],
                    MMMM: e.On.EE[o + 12],
                    yy: String(h).slice(2),
                    yyyy: h,
                    YY: String(h).slice(2),
                    YYYY: h,
                    h: l % 12 || 12,
                    hh: e.Tk(l % 12 || 12),
                    H: l,
                    HH: e.Tk(l),
                    m: A,
                    mm: e.Tk(A),
                    s: c,
                    ss: e.Tk(c),
                    l: e.Tk(r, 3),
                    L: e.Tk(99 < r ? Math.round(r / 10) : r),
                    t: 12 > l ? "a" : "p",
                    tt: 12 > l ? "am" : "pm",
                    T: 12 > l ? "A" : "P",
                    TT: 12 > l ? "AM" : "PM",
                    Z: s ? "UTC" : (String(t).match(e.F3) || [""]).pop().replace(e.G3, ""),
                    o: (0 < u ? "-" : "+") + e.Tk(100 * Math.floor(Math.abs(u) / 60) + Math.abs(u) % 60, 4),
                    S: ["th", "st", "nd", "rd"][3 < n % 10 ? 0 : (10 != n % 100 - n % 10 ? 1 : 0) * n % 10]
                  };
                return i.replace(e.O3, function (t) {
                  return t in d ? d[t] : t.slice(1, t.length - 1);
                });
              }
            }, {
              key: "Tk",
              value: function Tk(t, _e28) {
                for (t = "" + t, _e28 = _e28 || 2; t.length < _e28;) t = "0" + t;
                return t;
              }
            }, {
              key: "G2",
              value: function G2(t, i) {
                e.On.tu = i.concat(t);
              }
            }, {
              key: "P2",
              value: function P2(t, i) {
                e.On.EE = i.concat(t);
              }
            }]);
            return e;
          }();
          e.O3 = /d{1,4}|D{1,4}|m{1,4}|M{1,4}|yy(?:yy)?|YY(?:YY)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g, e.F3 = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g, e.G3 = /[^-+\dA-Z]/g, e.On = {
            tu: "Sun Mon Tue Wed Thu Fri Sat Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
            EE: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec January February March April May June July August September October November December".split(" ")
          }, t.bt = e;
        }(a || (a = {})), function (t) {
          function e() {
            for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
              t[_key] = arguments[_key];
            }
            for (var e = 0; e < t.length; e++) if (void 0 === t[e] || null === t[e]) return !0;
            return !1;
          }
          var i = /*#__PURE__*/function () {
            function i() {
              _classCallCheck(this, i);
            }
            _createClass(i, null, [{
              key: "ky",
              value: function ky() {
                var t = new Date().getTime() - new Date(2012, 2, 8).getTime();
                return i.$Z == t ? t.toString(35) + (i.vN++).toString() : (i.$Z = t, i.vN = 0, t.toString(35));
              }
            }, {
              key: "bind",
              value: function bind(e) {
                if (t.U(e)) return e;
                for (var _len2 = arguments.length, _i14 = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                  _i14[_key2 - 1] = arguments[_key2];
                }
                for (var s = 0; s < _i14.length; s++) e = e.replace(new RegExp("\\{" + s + "\\}", "gi"), null == _i14[s] ? "" : _i14[s].toString());
                return e;
              }
            }, {
              key: "concat",
              value: function concat(t, e) {
                if (0 == t.length) return e;
                var _i15 = 0 < t.length ? t.charCodeAt(t.length - 1) : -1,
                  s = 0 < t.length ? t.charCodeAt(t.length - 2) : -1;
                if (-1 != s && 128 < s && 256 > s && !(191 < s && 224 > s)) {
                  var r = e.charCodeAt(0);
                  return _i15 = String.fromCharCode((15 & s) << 12 | (63 & _i15) << 6 | 63 & r), t.substr(0, t.length - 2) + _i15 + e.substr(1);
                }
                if (!(128 > _i15 || 256 < _i15)) {
                  if (191 < _i15 && 224 > _i15) return s = e.charCodeAt(0), _i15 = String.fromCharCode((31 & _i15) << 6 | 63 & s), t.substr(0, t.length - 1) + _i15 + e.substr(1);
                  if (256 > _i15) return s = e.charCodeAt(0), r = e.charCodeAt(1), _i15 = String.fromCharCode((15 & _i15) << 12 | (63 & s) << 6 | 63 & r), t.substr(0, t.length - 1) + _i15 + e.substr(2);
                }
                return t + e;
              }
            }, {
              key: "Kv",
              value: function Kv(t) {
                if (isNaN(t)) return r.model.v.g.sl;
                var e = 0 > t;
                0 > t && (t *= -1);
                var _i16 = (t = Math.round(t)) % 60,
                  s = 10 > _i16 ? "0" + _i16 : _i16.toString();
                return s = (10 > (_i16 = (t = (t - _i16) / 60) % 60) ? "0" + _i16 : _i16.toString()) + ":" + s, s = (10 > (_i16 = (t = (t - _i16) / 60) % 24) ? "0" + _i16 : _i16.toString()) + ":" + s, 0 < (t = (t - _i16) / 24) && (s = t.toString() + "d " + s), e && (s = "-" + s), s;
              }
            }, {
              key: "hA",
              value: function hA(e) {
                var _i17 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "dd/MM/yyyy";
                return isNaN(e) || 0 == e ? r.model.v.g.sl : (e = new Date(e), isNaN(e.getTime()) ? "" : t.bt.format(e, _i17));
              }
            }, {
              key: "Jv",
              value: function Jv(t) {
                var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "dd/MM/yyyy HH:mm:ss";
                return i.hA(t, e);
              }
            }, {
              key: "dN",
              value: function dN(t) {
                return this.l_(t) && !isNaN(Date.parse(t)) && (1 < t.match(/\d+/).length || 1 == t.match(/\d+/).length && new Date(Date.parse(t)).toDateString() != new Date(Date.parse(t.match(/\d+/)[0])).toDateString());
              }
            }, {
              key: "l_",
              value: function l_(e) {
                return !(t.Fr().Yu && !e.match(/^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/i));
              }
            }, {
              key: "Mi",
              value: function Mi(t) {
                if (e(t)) return 0;
                if ("#" === t.substr(0, 1)) return parseInt(t.substr(1), 16);
                "transparent" == t && (t = "rgb(255,255,255)"), t = (t = t.replace(/[^\d,]/g, "")).split(",");
                var _i18 = parseInt(t[0]),
                  s = parseInt(t[1]),
                  r = parseInt(t[2]);
                return 0 === parseInt(t[3]) && (_i18 = s = r = 255), r | s << 8 | _i18 << 16;
              }
            }, {
              key: "C3",
              value: function C3(t) {
                for (var e = new Uint8Array(t.length), _i19 = 0, s = t.length; _i19 < s; ++_i19) e[_i19] = t.charCodeAt(_i19);
                return e;
              }
            }, {
              key: "decode",
              value: function decode(t) {
                for (var e = "", _i20 = 0; _i20 < t.length; _i20++) e += String.fromCharCode(t[_i20]);
                return decodeURIComponent(escape(e));
              }
            }, {
              key: "contains",
              value: function contains(t, e) {
                return -1 < t.toLowerCase().indexOf(e);
              }
            }, {
              key: "K3",
              value: function K3(t) {
                return null == t ? NaN : "number" == typeof t ? t : ("string" != typeof t && (t = t.toString()), "," == r.model.format.Bg.Ne("").Gh && (t = t.replace(/,/gi, "")), t = (t = t.replace(",", ".")).replace(/[^[,|\.|\-|\d|e]]*/gi, ""), parseFloat(t));
              }
            }, {
              key: "trim",
              value: function trim(t) {
                var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                if (null == t) return "";
                for (var s = 0; i.tE(t.charAt(s), e);) ++s;
                for (var r = t.length - 1; i.tE(t.charAt(r), e);) --r;
                return r >= s ? t.slice(s, r + 1) : "";
              }
            }, {
              key: "trimLeft",
              value: function trimLeft(t) {
                var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                if (null == t) return "";
                for (var s = 0; i.tE(t.charAt(s), e);) ++s;
                return (e = t.length - 1) >= s ? t.slice(s, e + 1) : "";
              }
            }, {
              key: "tE",
              value: function tE(t) {
                var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                if (null != e && t == e) return !1;
                switch (t) {
                  case " ":
                  case "\t":
                  case "\r":
                  case "\n":
                  case "\f":
                    return !0;
                }
                return !1;
              }
            }, {
              key: "DZ",
              value: function DZ(t) {
                for (var e in i.Bu) if (i.Bu[e] == t) return !0;
                return !1;
              }
            }, {
              key: "jX",
              value: function jX(t) {
                var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                return e ? t.replace(/[<>"'\/]/g, function (t) {
                  return i.Bu[t];
                }) : t.replace(/[&<>"'\/]/g, function (t) {
                  return i.Bu[t];
                });
              }
            }, {
              key: "kX",
              value: function kX(t) {
                return e(t) ? "" : t.replace(/[&<>"']/g, function (t) {
                  return i.Bu[t];
                });
              }
            }]);
            return i;
          }();
          i.vN = 0, i.Bu = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
            "/": "&#x2F;"
          }, t.$ = i, t.U = e, t.Vb = function (t) {
            return !!e(t) || ("string" != typeof t && (t = "" + t), 0 === t.trim().length);
          }, t.Q5 = function (t) {
            return t.replace(/\|/g, "{%7C}");
          }, t.P5 = function (t) {
            return t.replace(/{%7C}/g, "|");
          };
        }(a || (a = {})), function (t) {
          var e = /*#__PURE__*/function () {
            function e() {
              _classCallCheck(this, e);
            }
            _createClass(e, null, [{
              key: "sort",
              value: function sort(i) {
                var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var r = arguments.length > 2 ? arguments[2] : undefined;
                var n = 1 == s % 2,
                  a = 1 == (s >>= 1) % 2,
                  o = 1 == ((s = s >> 1 >> 1) >> 1) % 2 ? function (_e29, i) {
                    if (void 0 !== r) {
                      if (t.U(i)) return -1;
                      if (t.U(_e29)) return 1;
                      _e29 = r(_e29), i = r(i);
                    }
                    return isNaN(i) || null === i ? -1 : isNaN(_e29) || null === _e29 ? 1 : _e29 - i;
                  } : n ? function (i, s) {
                    if (t.Vb(s)) return -1;
                    if (t.Vb(i)) return 1;
                    if (void 0 !== r) {
                      if (i = r(i), s = r(s), t.Vb(s)) return -1;
                      if (t.Vb(i)) return 1;
                    }
                    return e.localeCompare(i, s);
                  } : function (i, s) {
                    if (t.Vb(s)) return -1;
                    if (t.Vb(i)) return 1;
                    if (void 0 !== r) {
                      if (i = r(i), s = r(s), t.Vb(s)) return -1;
                      if (t.Vb(i)) return 1;
                    }
                    return e.localeCompare(i.toLocaleLowerCase(), s.toLocaleLowerCase());
                  };
                if (1 == s % 2) {
                  for (s = [], n = 0; n < i.length; n++) s[n] = n;
                  return s.sort(function (t, _e30) {
                    return o(i[t], i[_e30]);
                  }), a && s.reverse(), s;
                }
                return i.sort(o), a && i.reverse(), i;
              }
            }, {
              key: "localeCompare",
              value: function localeCompare(t, _e31) {
                return t && t.localeCompare ? t.localeCompare(_e31) : t === _e31 ? 0 : t > _e31 ? 1 : -1;
              }
            }, {
              key: "lo",
              value: function lo(t, i, s, r) {
                var n = 1 == (s >>= 1) % 2,
                  a = 1 == ((s = s >> 1 >> 1) >> 1) % 2;
                return 1 == s % 2 ? (t = e.o3(t, i, r), n && t.reverse(), t) : (a ? e.r3(t, i) : "" == i ? t.sort() : t.sort(function (t, e) {
                  return t[i] == e[i] ? 0 : t[i] > e[i] ? 1 : -1;
                }), n && t.reverse(), t);
              }
            }, {
              key: "oP",
              value: function oP(t) {
                var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var s = arguments.length > 2 ? arguments[2] : undefined;
                return e.lo(t, "", i, s);
              }
            }, {
              key: "r3",
              value: function r3(t, _e32) {
                "" == _e32 ? t.sort(function (t, e) {
                  return isNaN(t) ? 1 : isNaN(e) ? -1 : t - e;
                }) : t.sort(function (t, i) {
                  return isNaN(t[_e32]) ? 1 : isNaN(i[_e32]) ? -1 : t[_e32] - i[_e32];
                });
              }
            }, {
              key: "o3",
              value: function o3(t, _e33, i) {
                var s,
                  r = [];
                for (s in t) r.push([t[s], parseInt(s)]);
                for (var n in "" == _e33 ? i ? r.sort(function (t, e) {
                  return i(t[0], e[0]);
                }) : r.sort(function (t, e) {
                  return t[0] == e[0] ? 0 : t[0] > e[0] ? 1 : -1;
                }) : i ? r.sort(function (t, s) {
                  return i(t[0][_e33], s[0][_e33]);
                }) : r.sort(function (t, i) {
                  return t[0][_e33] == i[0][_e33] ? 0 : t[0][_e33] > i[0][_e33] ? 1 : -1;
                }), t = [], r) t.push(r[n][1]);
                return t;
              }
            }, {
              key: "pm",
              value: function pm(t, _e34, i) {
                for (var s = 0; s < _e34.length; s++) t.splice(i + s, 0, _e34[s]);
              }
            }]);
            return e;
          }();
          e.il = 1, e.ih = 2, e.$f = 8, e.Xe = 16, t.sa = e;
        }(a || (a = {})), function (t) {
          var e = /*#__PURE__*/function () {
            function e() {
              _classCallCheck(this, e);
              this.values = {}, this.keys = [];
            }
            _createClass(e, [{
              key: "Ea",
              value: function Ea(t, _e35) {
                void 0 === this.values[t] && this.keys.push(t), this.values[t] = _e35;
              }
            }, {
              key: "oK",
              value: function oK(t, _e36) {
                this.keys.push(t), this.values[t] = _e36;
              }
            }, {
              key: "unshift",
              value: function unshift(t, _e37) {
                this.keys.unshift(t), this.values[t] = _e37;
              }
            }, {
              key: "ip",
              value: function ip(t, _e38, i) {
                null != this.getItem(t) && this.removeItem(t), this.keys.splice(i, 0, t), this.values[t] = _e38;
              }
            }, {
              key: "removeItem",
              value: function removeItem(t) {
                null != this.getItem(t) && (this.keys.splice(this.indexOf(t), 1), delete this.values[t]);
              }
            }, {
              key: "vF",
              value: function vF() {
                var t = this.yd(0);
                null != t && (this.keys.splice(0, 1), delete this.values[t]);
              }
            }, {
              key: "length",
              get: function get() {
                return this.keys.length;
              },
              set: function set(t) {}
            }, {
              key: "indexOf",
              value: function indexOf(t) {
                return this.keys.indexOf(t);
              }
            }, {
              key: "rc",
              value: function rc(t) {
                return null != this.values[t];
              }
            }, {
              key: "getItem",
              value: function getItem(t) {
                return this.values[t];
              }
            }, {
              key: "F",
              value: function F(t) {
                return this.getItem(this.keys[t]);
              }
            }, {
              key: "yd",
              value: function yd(t) {
                return this.keys[t];
              }
            }, {
              key: "mz",
              value: function mz(t, _e39) {
                this.keys.splice(_e39, 0, this.keys.splice(t, 1)[0]);
              }
            }, {
              key: "slice",
              value: function slice() {
                var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                0 == s && (s = this.length - i);
                for (var r = new e(), n = 0; n < s; n++) this.length > n + i && (t.U(this.F(n + i)) || r.Ea(this.yd(n + i), this.F(n + i)));
                return r;
              }
            }, {
              key: "concat",
              value: function concat(t) {
                var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                if (!i) return this.HT(t), null;
                var s = new e();
                for (i = 0; i < this.length; i++) s.Ea(this.yd(i), this.F(i));
                for (i = 0; i < t.length; i++) s.Ea(t.yd(i), t.F(i));
                return s;
              }
            }, {
              key: "HT",
              value: function HT(t) {
                var _e40,
                  i = t.length;
                for (_e40 = 0; _e40 < i; _e40++) this.Ea(t.yd(_e40), t.F(_e40));
              }
            }, {
              key: "splice",
              value: function splice(t) {
                var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var s = new e();
                t + i > this.length && (i = this.length - t), 1 > i && (i = this.length);
                for (var r = 0; r < this.length; r++) (r < t || r >= t + i) && s.Ea(this.yd(r), this.F(r));
                return s;
              }
            }, {
              key: "reverse",
              value: function reverse() {
                var t,
                  i = new e();
                for (t = this.length - 1; -1 < t; t--) i.Ea(this.yd(t), this.F(t));
                return i;
              }
            }, {
              key: "Tc",
              value: function Tc() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                if (t) return this.keys.slice(0);
                t = [];
                for (var _e41 = 0; _e41 < this.length; _e41++) t.push(this.F(_e41));
                return t;
              }
            }, {
              key: "EP",
              value: function EP() {
                for (var t = [], _e42 = 0; _e42 < this.length; _e42++) t.push(this.yd(_e42));
                return t;
              }
            }, {
              key: "toString",
              value: function toString() {
                var t,
                  _e43 = [];
                for (t in this.keys) {
                  var i = "{" + t + ": " + this.getItem(t) + "}";
                  _e43.push(i);
                }
                return _e43.join(", ");
              }
            }], [{
              key: "Ga",
              value: function Ga(t) {
                for (var i = new e(), s = 0; s < t.length; s++) i.Ea(t[s][void 0], t[s]);
                return i;
              }
            }]);
            return e;
          }();
          t.ma = e;
        }(a || (a = {})), function (t) {
          t.mt = /*#__PURE__*/function () {
            function _class7() {
              _classCallCheck(this, _class7);
              this.quotes = [];
            }
            _createClass(_class7, [{
              key: "parse",
              value: function parse(t) {
                try {
                  this.quotes = [];
                  for (var e = [], i = !1, s = "", r = 0; r < t.length; r++) {
                    var n = t.charAt(r);
                    '"' == n || "'" == n ? (i && (this.quotes.push(s), e.push(n), s = ""), i = !i) : i && (s += n);
                  }
                  for (t = "  " + t, r = 0; r < this.quotes.length; r++) if ("truestyle" != this.quotes[r].toLowerCase()) {
                    var a = e[r] + this.quotes[r] + e[r],
                      o = t.substring(0, t.indexOf(a) + a.length + 2),
                      h = /(\w\w\w\()['|"][^'|^"]*['|"]/i;
                    if (h.test(o)) t = t.replace(a, "@" + r);else {
                      h = /(\W)['|"][^'|^"]*['|"]/i;
                      var l = (-1 != o.indexOf("#value") || -1 != o.indexOf("#updateDifference") || -1 != o.indexOf("#updatePercent")) && -1 != o.indexOf("if(");
                      h.test(o) && !l ? t = t.replace(a, "sum(@" + r + ")") : (h = /(\W)['|"][^'|^"]*['|"]/i, t = t.replace(a, "@" + r));
                    }
                  }
                  h = /#value/g, t = t.replace(h, "value()"), h = /#updateDifference/g, t = t.replace(h, "updateDifference()"), h = /#updatePercent/g, t = (t = t.replace(h, "updatePercent()")).toLocaleLowerCase();
                  var A = this.LJ(t);
                  A = A[1][0];
                } catch (t) {
                  return null;
                }
                return A;
              }
            }, {
              key: "LJ",
              value: function LJ(t) {
                for (var e = [], i = "", s = t.length, r = 0; r < t.length; r++) {
                  var n = t.charAt(r);
                  if ("(" == n) i += "$" + e.length + ";", n = this.LJ(t.slice(r + 1)), e.push(n[1]), r = r + n[0] + 1;else {
                    if (")" == n) {
                      s = r;
                      break;
                    }
                    i += n;
                  }
                }
                for (t = [], i = i.split(","), r = 0; r < i.length; r++) t.push(this.$B(i[r], e));
                return [s, t];
              }
            }, {
              key: "$B",
              value: function $B(t, e) {
                for (var i = [[" or ", " and "], "== != >= <= = > <".split(" "), ["-", "+"], ["/", "*"], ["^"]], s = 0; s < i.length; s++) {
                  var r = Number.MIN_VALUE,
                    n = i[s][0];
                  if (3 == s) {
                    r = t.indexOf(i[s][0]);
                    var a = t.indexOf(i[s][1]);
                    -1 != r && -1 != a ? n = r < a ? i[s][0] : i[s][1] : -1 != r ? n = i[s][0] : -1 != a && (n = i[s][1]);
                  } else for (a = 0; a < i[s].length; a++) {
                    var o = t.indexOf(i[s][a]);
                    -1 != o && o >= r && (r = o + (n = i[s][a]).length);
                  }
                  if (2 < (r = t.split(n)).length && (a = r[r.length - 1], r.pop(), r = [r.join(n), a]), 2 == r.length) return [n.trim(), [this.$B(r[0], e), this.$B(r[1], e)], !0];
                }
                return this.gU(t, e);
              }
            }, {
              key: "gU",
              value: function gU(t, e) {
                if (-1 != (t = t.trim()).indexOf("$")) {
                  var i = t.split("$");
                  if (t = i[0], i = parseInt(i[1]), 0 < t.length) {
                    var s = "string" != typeof e[i][0];
                    return ("min" == t || "max" == t) && 1 < e[i].length && (s = !0, "string" == typeof e[i][0] && (e[i][0] = ["sum", [e[i][0]], !1]), "string" == typeof e[i][1] && (e[i][1] = ["sum", [e[i][1]], !1])), [t, e[i], s];
                  }
                  return e[i][0];
                }
                return -1 != t.indexOf("@") ? (e = parseInt(t.slice(1)), this.quotes[e]) : "truestyle" == t.toLowerCase() || "truestyle" == t.substring(1, t.length - 1).toLowerCase() ? "truestyle" : (e = parseFloat(t), isNaN(e) ? 0 : e);
              }
            }]);
            return _class7;
          }();
        }(a || (a = {})), function (t) {
          t.Dg = /*#__PURE__*/function () {
            function _class8() {
              _classCallCheck(this, _class8);
            }
            _createClass(_class8, null, [{
              key: "qm",
              get: function get() {
                return /Mac/i.test(navigator.platform);
              }
            }, {
              key: "fs",
              get: function get() {
                return /(iPhone|iPod|iPad)/i.test(navigator.platform) || /(iPhone|iPod|iPad)/i.test(navigator.userAgent);
              }
            }]);
            return _class8;
          }();
        }(a || (a = {})), function (t) {
          t.ee = /*#__PURE__*/function () {
            function _class9() {
              _classCallCheck(this, _class9);
            }
            _createClass(_class9, null, [{
              key: "je",
              value: function je(e) {
                for (var i in e) if (!t.U(e[i])) return !1;
                return !0;
              }
            }]);
            return _class9;
          }();
        }(a || (a = {})), function (t) {
          var e = /*#__PURE__*/function () {
            function e() {
              _classCallCheck(this, e);
              throw Error("Singleton");
            }
            _createClass(e, null, [{
              key: "la",
              value: function la() {
                e.us = [], e.instance = null, e.Zi = null;
              }
            }, {
              key: "jp",
              value: function jp(t, i) {
                var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                e.us.push({
                  D3: t,
                  context: i,
                  lV: s,
                  xr: r
                }), null == e.Zi && e.Uf();
              }
            }, {
              key: "Uf",
              value: function Uf() {
                e.Zi = new i(e.us.shift(), function () {
                  return e.o1();
                }), e.Zi.Uf();
              }
            }, {
              key: "pause",
              value: function pause() {
                null != e.Zi && e.Zi.stop();
              }
            }, {
              key: "resume",
              value: function resume() {
                null != e.Zi ? e.Zi.Uf() : 0 < e.us.length && e.Uf();
              }
            }, {
              key: "o1",
              value: function o1() {
                e.Zi = null, 0 < e.us.length && this.Uf();
              }
            }, {
              key: "cancel",
              value: function cancel() {
                null != e.Zi && (e.Zi.stop(), e.Zi = null), e.us = [];
              }
            }, {
              key: "SZ",
              value: function SZ() {
                return null != e.Zi;
              }
            }, {
              key: "qK",
              value: function qK(t, _e44) {
                return 10 < t - 50 ? _e44 = Math.floor(.95 * _e44) : -10 > t - 50 && (_e44 = Math.floor(1.05 * _e44)), Math.max(5, _e44);
              }
            }]);
            return e;
          }();
          e.us = [], t.ni = e;
          var i = /*#__PURE__*/function () {
            function i(t) {
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              _classCallCheck(this, i);
              this.delay = 1, this.Vh = !1, this.Ns = t, this.xr = e;
            }
            _createClass(i, [{
              key: "Uf",
              value: function Uf() {
                var _this38 = this;
                this.hL = t.xd(function () {
                  return _this38.xL();
                }, this.delay);
              }
            }, {
              key: "stop",
              value: function stop() {
                t.Pg(this.hL);
              }
            }, {
              key: "xL",
              value: function xL() {
                var _this39 = this;
                this.Vh = this.Ns.D3.call(this.Ns.context, this.Ns.lV), 1 == this.Vh ? this.ms() : this.hL = t.xd(function () {
                  return _this39.xL();
                }, this.delay);
              }
            }, {
              key: "ms",
              value: function ms() {
                null != this.xr && this.xr(), null != this.Ns.xr && this.Ns.xr();
              }
            }, {
              key: "la",
              value: function la() {
                this.stop(), this.xr = this.Ns = null;
              }
            }]);
            return i;
          }();
        }(a || (a = {})), function (t) {
          function e() {
            var t = navigator.userAgent.toLowerCase(),
              e = {};
            if (e.av = /mozilla/.test(t) && /firefox/.test(t), e.Yu = /webkit/.test(t) && /chrome/.test(t) && !/edge/.test(t), e.fE = /edge/.test(t), e.TZ = /applewebkit/.test(t) && /safari/.test(t) && !/chrome/.test(t), e.NZ = /opera/.test(t), e.rm = /msie/.test(t), e.pg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(t) || /iPad|iPhone|iPod|BlackBerry/i.test(navigator.platform), e.version = NaN, e.rm || e.av || e.Yu || e.TZ || e.NZ || !/trident/.test(t) || (e.rm = !0, e.version = 11), isNaN(e.version)) for (var i = ["chrome", "firefox", "msie", "safari", "opera"], s = 0; s < i.length; s++) try {
              e.version = parseInt(t.match(new RegExp("(" + i[s] + ")( |/)([0-9]+)"))[3]);
              break;
            } catch (t) {}
            return e;
          }
          t.Wc = function () {
            return e();
          }, t.Fr = e, t.cz = function () {
            return null != document.fullscreenElement || null != document.mozFullScreenElement || null != document.webkitFullscreenElement || null != document.msFullscreenElement;
          }, t.HZ = function () {
            try {
              return !(void 0 === ArrayBuffer || void 0 === DataView || void 0 === Uint8Array || window.chrome && navigator.userAgent.match(/chrome.\d*/gi) && !(12 <= parseInt(navigator.userAgent.match(/chrome.\d*/gi)[0].replace(/[^\d]/g, ""))) || window.opera && !(15 <= window.opera.version()) || navigator.userAgent.match("Safari/") && (navigator.userAgent.match("Version/5.") || navigator.userAgent.match("Version/6.0")));
            } catch (t) {
              return !1;
            }
          }, t.E5 = function (t) {
            var e = document.cookie,
              i = e.indexOf(" " + t + "=");
            return -1 == i && (i = e.indexOf(t + "=")), -1 == i ? e = null : (i = e.indexOf("=", i) + 1, -1 == (t = e.indexOf(";", i)) && (t = e.length), e = decodeURI(e.substring(i, t))), e;
          }, t.M5 = function (t, e) {
            var i = new Date();
            i.setDate(i.getDate() + 1825), e = encodeURI(e) + "; expires=" + i.toUTCString(), document.cookie = t + "=" + e;
          }, t.F5 = function () {
            return screen.orientation && -1 < screen.orientation.type.indexOf("landscape");
          }, t.G5 = function () {
            return screen.orientation && -1 < screen.orientation.type.indexOf("portrait");
          }, t.R5 = function () {
            return Math.max(document.documentElement.clientWidth);
          }, t.e4 = function () {
            return Math.max(document.documentElement.clientHeight);
          };
        }(a || (a = {})), function (t) {
          var i = /*#__PURE__*/function (_e$Od7) {
            _inherits(i, _e$Od7);
            var _super33 = _createSuper(i);
            function i(t) {
              var _this40;
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              _classCallCheck(this, i);
              _this40 = _super33.call(this), _this40.Pw = 0, _this40.Zt = !1, _this40.IT = t, _this40.OJ = e;
              return _this40;
            }
            _createClass(i, [{
              key: "r1",
              value: function r1() {
                this.Pw++, this.na(new e.ga(s.Bw)), 0 < this.OJ && this.Pw >= this.OJ && (this.stop(), this.na(new e.ga(s.Cw)));
              }
            }, {
              key: "start",
              value: function start() {
                var _this41 = this;
                this.Zt || (this.wJ = t.YL(function () {
                  return _this41.r1();
                }, this.IT), this.Zt = !0);
              }
            }, {
              key: "stop",
              value: function stop() {
                this.Zt && !t.U(this.wJ) && (t.Mr(this.wJ), this.Zt = !1);
              }
            }, {
              key: "reset",
              value: function reset() {
                this.Pw = 0, this.stop();
              }
            }, {
              key: "SC",
              get: function get() {
                return this.Pw;
              },
              set: function set(t) {}
            }, {
              key: "Rz",
              get: function get() {
                return this.Zt;
              },
              set: function set(t) {}
            }]);
            return i;
          }(e.Od);
          t.hB = i;
          var s = /*#__PURE__*/_createClass(function s() {
            _classCallCheck(this, s);
          });
          s.Bw = "timer", s.Cw = "complete", t.Lq = s, t.Nk = function () {
            return "undefined" != typeof performance && "function" == typeof window.performance.now ? performance.now() : new Date().getTime();
          };
        }(a || (a = {})), function (t) {
          var s = /*#__PURE__*/function (_e$Od8) {
            _inherits(s, _e$Od8);
            var _super34 = _createSuper(s);
            function s(e) {
              var _this42;
              _classCallCheck(this, s);
              if (_this42 = _super34.call(this), _this42.Xo = !1, _this42.bU = function (t) {
                return _this42.hv(t);
              }, _this42.$M = function () {
                return _this42.C0();
              }, null != s.Nc) throw Error("KeyboardListener is singleton");
              t.Wc().pg || (t.lg.addEventListener("keydown", _this42.bU), _this42.br = new i.ia("div"), _this42.br.ha("position", "fixed").ha("left", "0px").ha("top", "0px").ha("opacity", "0").ha("width", "0px").ha("height", "0px"), _this42.br.Da(), _this42.ui = new i.UI(), _this42.ui.B.ha("width", "1px").ha("height", "1px").ha("padding", "0px"), _this42.ui.addEventListener("focusin", function () {
                _this42.Xo = !0;
              }), _this42.ui.addEventListener("focusout", function () {
                _this42.Xo = !1;
              }), _this42.br.append(_this42.ui.B), e.append(_this42.br));
              return _possibleConstructorReturn(_this42);
            }
            _createClass(s, [{
              key: "bz",
              get: function get() {
                return this.Xo;
              }
            }, {
              key: "hv",
              value: function hv(t) {
                var e = new n(n.RA);
                e.keyCode = t.keyCode, e.altKey = t.altKey, e.ctrlKey = t.ctrlKey, e.metaKey = t.metaKey, e.shiftKey = t.shiftKey, e.D1 = t, this.na(e);
              }
            }, {
              key: "C0",
              value: function C0() {
                this.br.Da(), this.ui.bj(""), this.ui.B.blur(), this.ui.removeEventListener("keyup", this.$M);
              }
            }, {
              key: "MC",
              value: function MC(t) {
                this.br.show(), this.ui.bj(t), this.ui.B.focus(), this.ui.Bm(), this.ui.B.focus(), this.ui.addEventListener("keyup", this.$M);
              }
            }], [{
              key: "V",
              value: function V() {
                return null == s.Nc && (s.Nc = new s(r.G.xb.tb.B)), s.Nc;
              }
            }]);
            return s;
          }(e.Od);
          t.uR = s;
          var n = /*#__PURE__*/function (_e$ga) {
            _inherits(n, _e$ga);
            var _super35 = _createSuper(n);
            function n(t) {
              _classCallCheck(this, n);
              return _super35.call(this, t);
            }
            return _createClass(n);
          }(e.ga);
          n.RA = "event_keydown", t.KeyboardEvent = n;
        }(a || (a = {})), function (t) {
          t.debug = function () {
            if (null != console && null != console.log) for (var e = a.Wc().av && a.Wc().pg ? 0 : 1; e < arguments.length; e++);
          }, t.O5 = function () {
            var t = Error();
            return t && t.stack ? t.stack.substr(77) : "";
          };
        }(r || (r = {})), function (t) {
          t.yc = function (i) {
            var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.to;
            var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
            t.G.hG.V().ym(i, s, r, n, a, !1);
          };
          var e = /*#__PURE__*/_createClass(function e() {
            _classCallCheck(this, e);
          });
          e.to = "alert", e.wq = "confirmation", e.wb = "error", e.FH = "info", t.ld = e;
        }(r || (r = {})), function (t) {
          t.Ta = function () {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            var i = arguments.length > 1 ? arguments[1] : undefined;
            var s = arguments.length > 2 ? arguments[2] : undefined;
            var r = arguments.length > 3 ? arguments[3] : undefined;
            var n = arguments.length > 4 ? arguments[4] : undefined;
            t.G.qS.V().show(e, i, s, r, n);
          };
        }(r || (r = {})), function (t) {
          !function (i) {
            var s = /*#__PURE__*/function (_e$Od9) {
              _inherits(s, _e$Od9);
              var _super36 = _createSuper(s);
              function s() {
                var _this43;
                _classCallCheck(this, s);
                if (_this43 = _super36.call(this), null != s.instance) throw Error("Singleton");
                _this43.O = t.u.Ja.V(), _this43.Pa = new i.sb.RS();
                return _possibleConstructorReturn(_this43);
              }
              _createClass(s, [{
                key: "$D",
                value: function $D(e) {
                  s.id = e.id ? e.id : "", i.xa.K2(e), i.v.Ho.V().reset(), t.G.N.C.ad.tp = e.customizeCell, this.Pa.$D(e);
                }
              }, {
                key: "open",
                value: function open() {
                  this.Pa.open();
                }
              }, {
                key: "load",
                value: function load(t) {
                  this.Pa.load(t);
                }
              }, {
                key: "save",
                value: function save(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var i = arguments.length > 2 ? arguments[2] : undefined;
                  var _s8 = arguments.length > 3 ? arguments[3] : undefined;
                  var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
                  return this.Pa.save(t, e, i, _s8, r);
                }
              }, {
                key: "xv",
                value: function xv(t) {
                  this.Pa.xv(t);
                }
              }, {
                key: "Dp",
                value: function Dp() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  return this.Pa.Dp(t);
                }
              }, {
                key: "clear",
                value: function clear() {
                  this.Pa.clear();
                }
              }, {
                key: "IK",
                value: function IK(t) {
                  var e = {};
                  return a.U(t.dataSourceType) || (e.dataSourceType = t.dataSourceType), a.U(t.filename) || (e.filename = t.filename), a.U(t.requestHeader) || (e.requestHeader = t.requestHeader), a.U(t.fieldSeparator) || (e.fieldSeparator = t.fieldSeparator), a.U(t.recordsetDelimiter) || (e.recordsetDelimiter = t.recordsetDelimiter), a.U(t.browseForFile) || (e.browseForFile = t.browseForFile), a.U(t.data) || (e.data = t.data), a.U(t.ignoreQuotedLineBreaks) || (e.ignoreQuotedLineBreaks = t.ignoreQuotedLineBreaks), a.U(t.hash) || (e.hash = t.hash), a.U(t.username) || (e.username = t.username), a.U(t.password) || (e.password = t.password), e;
                }
              }, {
                key: "zr",
                value: function zr(t) {
                  this.Pa.zr(this.IK(t));
                }
              }, {
                key: "dl",
                value: function dl(t, e) {
                  e.partial ? this.Pa.V3(t.data, e) : this.Pa.dl(this.IK(t), e);
                }
              }, {
                key: "getData",
                value: function getData(e, _s9, r) {
                  if (null != r && t.Um.instance.TN("update", function () {
                    t.Um.instance.getData(e, r);
                  }), null != e && null != e.slice) {
                    var n = e.slice instanceof t.u.oa.lh ? e.slice : t.u.oa.lh.Za(i.kb.Kh.Za(e.slice), this.O.ea);
                    i.cs.QA.V().z2(n, _s9);
                  } else _s9((n = i.cs.QA.V().getData()).Sa());
                }
              }, {
                key: "yD",
                value: function yD() {
                  return i.pf.hi.MY();
                }
              }, {
                key: "ED",
                value: function ED(t) {
                  return (t = i.pf.hi.get(t)) ? t.Sa() : null;
                }
              }, {
                key: "ox",
                value: function ox(t) {
                  i.pf.hi.add(i.pf.C.wA.Za(t));
                }
              }, {
                key: "Kz",
                value: function Kz(t) {
                  i.pf.hi.remove(t);
                }
              }, {
                key: "Jz",
                value: function Jz() {
                  i.pf.hi.sF();
                }
              }, {
                key: "vk",
                value: function vk(t) {
                  this.O.vk(t);
                }
              }, {
                key: "fo",
                value: function fo(t) {
                  this.O.fo(t);
                }
              }, {
                key: "eq",
                value: function eq() {
                  this.O.eq();
                }
              }, {
                key: "Ux",
                value: function Ux() {
                  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                  this.O.fa.oc = !0, this.O.fa.gd = e, this.O.fa.MV(), this.O.fa.LV(), t.u.qf.bk.la(), this.refresh();
                }
              }, {
                key: "xp",
                value: function xp(t) {
                  this.Ng.xp(t);
                }
              }, {
                key: "Dx",
                value: function Dx() {
                  this.O.fa.oc = !1, this.O.fa.gd = !1, this.O.fa.nb.jd = [], this.O.fa.nb.hd = [], this.O.fa.zb.jd = [], this.O.fa.zb.hd = [], t.u.qf.bk.la(), this.refresh();
                }
              }, {
                key: "rp",
                value: function rp(t) {
                  this.Ng.rp(t);
                }
              }, {
                key: "Uj",
                value: function Uj(t) {
                  null != t.localSettingsUrl && delete t.localSettingsUrl, null != t.zoom && delete t.zoom, i.A.P.Uj(i.A.C.ij.Za(t), !1);
                }
              }, {
                key: "print",
                value: function print(t) {
                  i.ao.XA.V().print(t);
                }
              }, {
                key: "Aj",
                value: function Aj(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var _s10 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  i.Pd.cw.Aj(t, e, _s10);
                }
              }, {
                key: "ID",
                value: function ID(t) {
                  if (null == this.O || null == this.O.ea) return [];
                  var e = [];
                  if ((t = this.O.ea.bb(!1).getItem(t)) && t.Sg()) for (var i = t.filter, _s11 = 0; _s11 < i.length; _s11++) {
                    var r = i.F(_s11);
                    e.push({
                      caption: r.caption,
                      uniqueName: r.j,
                      hierarchyName: t.j,
                      parentMember: r.parent.j
                    });
                  }
                  return e;
                }
              }, {
                key: "JD",
                value: function JD(e) {
                  if (null == this.O || null == this.O.ea) return [];
                  var i = {};
                  if (i.type = t.u.i.Dd.NONE, i.members = [], (e = this.O.ea.bb(!1).getItem(e)) && e.Sg()) {
                    if (e.Wu()) {
                      i.type = "members";
                      for (var _s12 = e.Me, r = 0; r < _s12.length; r++) {
                        var n = _s12.F(r);
                        i.members.push({
                          caption: n.caption,
                          uniqueName: n.j,
                          hierarchyName: e.j,
                          parentMember: n.parent.j
                        });
                      }
                    }
                    e.$r() && (i.type = e.Jd, i.quantity = e.bf, i.measure = e.pd, i.measureName = e.pd);
                  }
                  return i;
                }
              }, {
                key: "wv",
                value: function wv(e, _s13) {
                  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  if (e = this.O.ea.bb(!1).getItem(e)) {
                    var n = {};
                    n.members = _s13, n.negation = r, t.u.oa.de.VL(n, e), i.xa.V().na(new i.ac(i.xa.Gq)), this.O.filter();
                  }
                }
              }, {
                key: "vn",
                value: function vn(t) {
                  (t = this.O.ea.bb(!1).getItem(t)) && (t.vn(), this.O.select());
                }
              }, {
                key: "Ru",
                value: function Ru() {
                  if (null == this.O || null == this.O.fa) return [];
                  for (var t = this.O.fa.rows, e = [], i = 0; i < t.length; i++) {
                    var _s14 = t.F(i);
                    e.push({
                      caption: _s14.caption,
                      uniqueName: _s14.j,
                      sort: _s14.Gc,
                      folder: _s14.folder
                    });
                  }
                  return e;
                }
              }, {
                key: "Ku",
                value: function Ku() {
                  if (null == this.O || null == this.O.fa) return [];
                  for (var t = this.O.fa.za, e = [], i = 0; i < t.length; i++) {
                    var _s15 = t.F(i);
                    e.push({
                      caption: _s15.caption,
                      uniqueName: _s15.j,
                      sort: _s15.Gc,
                      folder: _s15.folder
                    });
                  }
                  return e;
                }
              }, {
                key: "Qu",
                value: function Qu() {
                  if (null == this.O || null == this.O.fa) return [];
                  for (var t = this.O.fa.eb, e = [], i = 0; i < t.length; i++) {
                    var _s16 = t.F(i);
                    e.push({
                      caption: _s16.caption,
                      uniqueName: _s16.j,
                      sort: _s16.Gc,
                      folder: _s16.folder
                    });
                  }
                  return e;
                }
              }, {
                key: "Pu",
                value: function Pu() {
                  if (null == this.O || null == this.O.fa) return [];
                  var t,
                    e = [];
                  if (i.A.P.Dc) {
                    var _s17 = this.O.fa.flatten();
                    for (t = 0; t < _s17.length; t++) {
                      var r = _s17.F(t);
                      (r = this.O.ea.og(r.j)) && e.push(r.VF());
                    }
                  } else for (_s17 = this.O.fa.pa, t = 0; t < _s17.length; t++) r = _s17.F(t), e.push(r.VF());
                  return e;
                }
              }, {
                key: "Gn",
                value: function Gn() {
                  if (null == this.O || null == this.O.ea) return [];
                  for (var e = this.O.ea.pa, _s18 = [], r = 0; r < e.length; r++) {
                    var n = e.F(r),
                      a = n.VF();
                    if (i.A.P.Dc) a.availableAggregations = [], a.availableAggregationsCaptions = [], a.caption = a.grandTotalCaption = n.$n;else {
                      var o = n.te;
                      n.te && 0 == n.te.length && !n.La && (o = t.u.i.ca.sq), a.availableAggregations = o, a.availableAggregationsCaptions = t.u.i.ca.tK(o);
                    }
                    _s18.push(a);
                  }
                  return _s18;
                }
              }, {
                key: "Lz",
                value: function Lz(t) {
                  this.O.ea.bb(!1).getItem(t.name).label = t.caption;
                }
              }, {
                key: "Gu",
                value: function Gu() {
                  if (null == this.O || null == this.O.ea) return [];
                  for (var t = this.O.ea.bb(!1), e = [], i = 0; i < t.length; i++) {
                    var _s19 = t.F(i);
                    e.push({
                      caption: _s19.caption,
                      uniqueName: _s19.j,
                      folder: _s19.folder
                    });
                  }
                  return e;
                }
              }, {
                key: "dA",
                value: function dA(t, e, i, _s20) {
                  null != (t = this.O.fa.axes.getItem(t)) && ((_s20 = this.O.ea.pa.getItem(_s20)) && (t.Nb = e, t.ah = i, t.xg = _s20), this.O.sort());
                }
              }, {
                key: "jo",
                value: function jo(e, _s21) {
                  if (e = this.O.ea.bb(!1).getItem(e)) {
                    var r = this.O.fa.axes.getItem(t.u.i.da.rb),
                      n = this.O.fa.axes.getItem(t.u.i.da.Ka);
                    -1 != r.va.indexOf(e.j) ? this.O.yx(n) : -1 != n.va.indexOf(e.j) && this.O.yx(r), e.Gc = _s21, i.A.P.Dc && (this.Ng.Gf = _s21, this.Ng.af = this.Ng.lM(e.j), this.Ng.tj = this.O.ea.og(e.j));
                  }
                  this.O.select();
                }
              }, {
                key: "PD",
                value: function PD(t) {
                  return null == this.O || null == this.O.ea ? "" : null != (t = this.O.ea.bb(!1).getItem(t)) ? t.Gc : "";
                }
              }, {
                key: "zv",
                value: function zv(e, _s22, r) {
                  e = this.O.ea.bb(!1).getItem(e);
                  var n = i.A.P.Dc ? this.O.ea.pa.getItem(r) : this.O.fa.pa.getItem(r);
                  e && n && !e.tf && (e.Jd = t.u.i.Dd.ut, e.bf = _s22, e.pd = r, e.Gc = t.u.i.ba.mb, _s22 = this.O.fa.ve(t.u.i.da.Ka), r = this.O.fa.ve(t.u.i.da.rb), -1 != _s22.va.indexOf(e.j) && (r.ah = [], r.Nb = t.u.i.ba.vb, r.xg = this.O.fa.pa.getItem(e.pd)), -1 != r.va.indexOf(e.j) && (_s22.ah = [], _s22.Nb = t.u.i.ba.vb, _s22.xg = this.O.fa.pa.getItem(e.pd))), this.O.filter();
                }
              }, {
                key: "uv",
                value: function uv(e, _s23, r) {
                  e = this.O.ea.bb(!1).getItem(e);
                  var n = i.A.P.Dc ? this.O.ea.pa.getItem(r) : this.O.fa.pa.getItem(r);
                  e && n && !e.tf && (e.Jd = t.u.i.Dd.tq, e.bf = _s23, e.pd = r, e.Gc = t.u.i.ba.mb, _s23 = this.O.fa.ve(t.u.i.da.Ka), r = this.O.fa.ve(t.u.i.da.rb), -1 != _s23.va.indexOf(e.j) && (r.ah = [], r.Nb = t.u.i.ba.ub, r.xg = this.O.fa.pa.getItem(e.pd)), -1 != r.va.indexOf(e.j) && (_s23.ah = [], _s23.Nb = t.u.i.ba.ub, _s23.xg = this.O.fa.pa.getItem(e.pd))), this.O.filter();
                }
              }, {
                key: "Ay",
                value: function Ay(t, e, i) {
                  return null == this.O || null == this.O.ea ? [] : (e = [], (t = this.O.ea.bb(!1).getItem(t)) && (e = this.dM(t.Qd), null != i && i(e)), e);
                }
              }, {
                key: "dM",
                value: function dM(t) {
                  t = t.Kc.Cf(t, !1);
                  for (var e = [], _s24 = 0; _s24 < t.length; _s24++) {
                    var r = t.F(_s24),
                      n = r.level.Md == r.Kc.Fb.length - 1,
                      a = [];
                    1 == r.children.length && r.children.F(0).caption == i.v.g.Cg || (a = this.dM(r)), e.push({
                      caption: r.caption,
                      uniqueName: r.j,
                      hierarchyName: r.Kc.j,
                      children: a,
                      parentMember: r.parent.Qc ? "(All)" : r.parent.j,
                      isLeaf: n
                    });
                  }
                  return e;
                }
              }, {
                key: "Qz",
                value: function Qz(e) {
                  this.Pa.xk(t.u.oa.lh.Za(e, t.u.Ja.V().ea));
                }
              }, {
                key: "xk",
                value: function xk(t) {
                  this.Pa.xk(t);
                }
              }, {
                key: "Cp",
                value: function Cp() {
                  return i.A.P.Cp(!0, !0).Sa();
                }
              }, {
                key: "Ne",
                value: function Ne(t) {
                  return ((t = this.O && this.O.ea ? this.O.ea.we(t) : null) ? t.Ne() : i.format.Bg.Ne("")).Sa(!0);
                }
              }, {
                key: "jq",
                value: function jq(e, _s25) {
                  e.hasOwnProperty("name") || (e.name = a.$.ky());
                  try {
                    i.format.Bg.jq(e);
                  } catch (e) {
                    return void t.yc("Can't add format. Component's configuration requires more parameters.");
                  }
                  try {
                    var r = this.O.ea.we(_s25);
                    if (r && (r.format = e.name), "" != e.name && ("" == _s25 || null == _s25)) for (_s25 = 0; _s25 < this.O.ea.pa.length; _s25++) (r = this.O.ea.pa.F(_s25)).format = e.name;
                  } catch (e) {
                    t.yc("List of measures is empty. There is nothing to format.");
                  }
                }
              }, {
                key: "refresh",
                value: function refresh() {
                  this.O.filter();
                }
              }, {
                key: "la",
                value: function la() {
                  t.u.qf.bk.la(), this.O && this.O.la(), this.Pa && this.Pa.la(), this.Ng = this.Pa = this.O = null, s.instance = null;
                }
              }], [{
                key: "V",
                value: function V() {
                  return null == this.instance && (this.instance = new s()), this.instance;
                }
              }]);
              return s;
            }(e.Od);
            s.id = "WebDataRocks", i.yb = s;
          }(t.model || (t.model = {}));
        }(r || (r = {})), function (t) {
          !function (t) {
            t.ac = /*#__PURE__*/function () {
              function _class10(t) {
                var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                _classCallCheck(this, _class10);
                this.type = t, this.data = e;
              }
              return _createClass(_class10);
            }();
            var i = /*#__PURE__*/function (_e$Od10) {
              _inherits(i, _e$Od10);
              var _super37 = _createSuper(i);
              function i() {
                var _this44;
                _classCallCheck(this, i);
                if (_this44 = _super37.call(this), null != i.instance) throw Error("Singleton");
                return _possibleConstructorReturn(_this44);
              }
              _createClass(i, [{
                key: "addEventListener",
                value: function addEventListener(t, e) {
                  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                  t = i.HP(t), i.rE(t) && _get(_getPrototypeOf(i.prototype), "addEventListener", this).call(this, t, e, s);
                }
              }, {
                key: "removeEventListener",
                value: function removeEventListener(t, e) {
                  t = i.HP(t), i.rE(t) && _get(_getPrototypeOf(i.prototype), "removeEventListener", this).call(this, t, e);
                }
              }], [{
                key: "V",
                value: function V() {
                  return null == i.instance && (i.instance = new i()), i.instance;
                }
              }, {
                key: "la",
                value: function la() {
                  i.instance = null;
                }
              }, {
                key: "HP",
                value: function HP(t) {
                  return i.rE(t) ? t : "";
                }
              }, {
                key: "rE",
                value: function rE(t) {
                  return -1 < i.types.indexOf(t);
                }
              }, {
                key: "K2",
                value: function K2(t) {
                  i.vc(i.ww, t[i.ww]), i.vc(i.Rm, t[i.Rm]), i.vc(i.tl, t[i.tl]), i.vc(i.Zf, t[i.Zf]), i.vc(i.Jo, t[i.Jo]), i.vc(i.li, t[i.li]), i.vc(i.Gq, t[i.Gq]), i.vc(i.Lm, t[i.Lm]), i.vc(i.Ao, t[i.Ao]), i.vc(i.yo, t[i.yo]), i.vc(i.zo, t[i.zo]), i.vc(i.xA, t[i.xA]), i.vc(i.xl, t[i.xl]), i.vc(i.Ye, t[i.Ye]), i.vc(i.gk, t[i.gk]), i.vc(i.Mm, t[i.Mm]), i.vc(i.Nm, t[i.Nm]), i.vc(i.Go, t[i.Go]), i.vc(i.He, t[i.He]), i.vc(i.uw, t[i.uw]), i.vc(i.vl, t[i.vl]), i.vc(i.bw, t[i.bw]), i.vc(i.jh, t[i.jh]), i.vc(i.Dw, t[i.Dw]), i.vc(i.gl, t[i.gl]), i.vc(i.ak, t[i.ak]), i.vc(i.Tv, t[i.Tv]), i.vc(i.Uv, t[i.Uv]), i.vc(i.Do, t[i.Do]), i.vc(i.fw, t[i.fw]), i.vc(i.ew, t[i.ew]), i.vc(i.Vs, t[i.Vs]);
                }
              }, {
                key: "vc",
                value: function vc(t, e) {
                  if (e) {
                    "string" == typeof e && (e = i.Rr(e));
                    var s = e;
                    t != i.Vs && t != i.gl && t != i.ak && (s = function s() {
                      for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                        t[_key3] = arguments[_key3];
                      }
                      a.xd(function () {
                        e.apply(null, t);
                      }, 1);
                    }), i.V().addEventListener(t, s);
                  }
                }
              }, {
                key: "Rr",
                value: function Rr(t) {
                  for (var e = window, _i21 = (t = t.split(".")).pop(), s = 0; s < t.length; s++) {
                    if (null == e) return null;
                    e = e[t[s]];
                  }
                  return e[_i21];
                }
              }]);
              return i;
            }(e.Od);
            i.Rm = "openingreportfile", i.tl = "loadingreportfile", i.Zf = "reportfileloaded", i.Jo = "reportfileerror", i.li = "reportfilecancelled", i.Lm = "loadingdata", i.Ao = "dataloaded", i.yo = "dataerror", i.zo = "datafilecancelled", i.xA = "datachanged", i.xl = "runningquery", i.Ye = "querycomplete", i.gk = "queryerror", i.Mm = "loadinglocalization", i.Nm = "localizationloaded", i.Go = "localizationerror", i.He = "reportcomplete", i.Gq = "reportchange", i.bw = "exportstart", i.jh = "exportcomplete", i.uw = "printstart", i.vl = "printcomplete", i.ww = "ready", i.Dw = "update", i.gl = "beforegriddraw", i.ak = "aftergriddraw", i.Tv = "cellclick", i.Uv = "celldoubleclick", i.Do = "filteropen", i.fw = "fieldslistopen", i.ew = "fieldslistclose", i.Vs = "beforetoolbarcreated", i.types = [i.ww, i.Rm, i.tl, i.Zf, i.Jo, i.li, i.Lm, i.Ao, i.yo, i.zo, i.xA, i.xl, i.Ye, i.gk, i.Mm, i.Nm, i.Go, i.He, i.Gq, i.uw, i.vl, i.bw, i.jh, i.Dw, i.gl, i.ak, i.Tv, i.Uv, i.Do, i.fw, i.ew, i.Vs], t.xa = i;
          }(t.model || (t.model = {}));
        }(r || (r = {})), function (t) {
          (t.model || (t.model = {})).zc = /*#__PURE__*/function () {
            function _class11() {
              _classCallCheck(this, _class11);
            }
            _createClass(_class11, null, [{
              key: "valid",
              value: function valid(t) {
                return null == t || -1 == (t = t.toLowerCase()).indexOf("<script") && -1 == t.indexOf("javascript:") && -1 == t.indexOf("<iframe") && -1 == t.indexOf("<object") && -1 == t.indexOf("expression(") && -1 == t.indexOf("onmouseover") && -1 == t.indexOf("onerror");
              }
            }, {
              key: "validate",
              value: function validate(t) {
                var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                return a.$.jX(t, e);
              }
            }]);
            return _class11;
          }();
        }(r || (r = {})), function (t) {
          var e;
          !function (i) {
            var s = /*#__PURE__*/function () {
              function s() {
                _classCallCheck(this, s);
              }
              _createClass(s, [{
                key: "getData",
                value: function getData() {
                  var e = t.u.qf.bk.Qb();
                  return this.Gx(e);
                }
              }, {
                key: "z2",
                value: function z2(e, i) {
                  var _s26 = t.u.Ja.V(),
                    r = t.u.KH.clone(_s26.Ua);
                  r.fa = e, r.filter(), r.select(), (_s26 = new t.u.qf.vQ()).reset(), _s26.ta = r, _s26.slice = e, _s26.load(), i((e = this.Gx(_s26)).Sa()), _s26.reset();
                }
              }, {
                key: "Gx",
                value: function Gx(t) {
                  var _s27 = new i.cS();
                  if (null == t.slice) return _s27;
                  _s27.slice = t.slice.Sa(), _s27.Xn = {
                    vAmount: t.slice.pa.length,
                    formats: []
                  };
                  var r = 0,
                    n = 0;
                  if (t.Th && !t.Db) {
                    var a = "on" == e.A.P.xc || "rows" == e.A.P.xc ? t.Hd - 1 : t.Hd,
                      o = "on" == e.A.P.xc || "columns" == e.A.P.xc ? t.vd - 1 : t.vd;
                    _s27.data = [];
                    for (var h = [], l = [], A = {}, c = 0; c < t.Ia.length; c++) {
                      var u = t.Ia.F(c);
                      _s27.Xn["v" + c + "Name"] = u.caption;
                      var d = e.yb.V().Ne(u.j);
                      _s27.Xn.formats.push(d), u = t.Mb(h, l, u), A["v" + c] = u;
                    }
                    for (_s27.data.push(A), d = 0; d < o; d++) {
                      for (A = {}, h = t.Ep(d), r = Math.max(r, h.length), l = [], c = t.hc, u = 0; u < h.length; u++) {
                        var f = u,
                          p = c.F(f),
                          g = h[u];
                        g = p.ua.F(g), _s27.Xn["r" + f + "Name"] = p.caption, p = this.uy(g), A["r" + f] = p;
                      }
                      for (c = 0; c < t.Ia.length; c++) u = t.Ia.F(c), u = t.Mb(h, l, u), A["v" + c] = u;
                      _s27.data.push(A);
                    }
                    for (var w = 0; w < a; w++) {
                      for (A = {}, h = [], l = t.Kk(w), n = Math.max(n, l.length), c = t.ed, u = 0; u < l.length; u++) f = u, p = c.F(f), g = l[u], g = p.ua.F(g), _s27.Xn["c" + f + "Name"] = p.caption, p = this.uy(g), A["c" + f] = p;
                      for (c = 0; c < t.Ia.length; c++) u = t.Ia.F(c), u = t.Mb(h, l, u), A["v" + c] = u;
                      _s27.data.push(A);
                    }
                    for (d = 0; d < o; d++) for (h = t.Ep(d), r = Math.max(r, h.length), w = 0; w < a; w++) {
                      for (l = t.Kk(w), n = Math.max(n, l.length), A = {}, c = t.hc, u = 0; u < h.length; u++) f = u, p = c.F(f), g = h[u], g = p.ua.F(g), p = this.uy(g), A["r" + f] = p;
                      for (c = t.ed, u = 0; u < l.length; u++) f = u, p = c.F(f), g = l[u], g = p.ua.F(g), p = this.uy(g), A["c" + f] = p;
                      for (c = 0; c < t.Ia.length; c++) u = t.Ia.F(c), u = t.Mb(h, l, u), A["v" + c] = u;
                      _s27.data.push(A);
                    }
                  }
                  return _s27.Xn.rAmount = r, _s27.Xn.cAmount = n, _s27;
                }
              }, {
                key: "uy",
                value: function uy(e) {
                  return e.level.type == t.u.types.Ab.Rb || e.level.type == t.u.types.Ab.td ? e.qg : e.level.type == t.u.types.Ab.NI ? Date.parse(e.caption) : e.level.type == t.u.types.Ab.ii ? isNaN(parseFloat(e.caption)) ? e.caption : parseFloat(e.caption) : e.caption;
                }
              }], [{
                key: "V",
                value: function V() {
                  return null == s.instance && (s.instance = new s()), s.instance;
                }
              }, {
                key: "la",
                value: function la() {
                  s.instance = null;
                }
              }]);
              return s;
            }();
            i.QA = s;
          }((e = t.model || (t.model = {})).cs || (e.cs = {}));
        }(r || (r = {})), function (t) {
          var e;
          ((e = t.model || (t.model = {})).cs || (e.cs = {})).cS = /*#__PURE__*/function () {
            function _class12() {
              _classCallCheck(this, _class12);
              this.slice = {}, this.Xn = {}, this.data = [];
            }
            _createClass(_class12, [{
              key: "Sa",
              value: function Sa() {
                var t = {};
                return t.meta = this.Xn, t.data = this.data, t;
              }
            }]);
            return _class12;
          }();
        }(r || (r = {}));
        var o = r || (r = {}),
          h = o.model || (o.model = {}),
          l = h.v || (h.v = {});
        var c = /*#__PURE__*/_createClass(function c() {
          _classCallCheck(this, c);
        });
        c.JG = "WebDataRocks Reporting Tool", l.g = c, function (t) {
          var e, i;
          e = t.model || (t.model = {}), (i = e.v || (e.v = {})).xR = /*#__PURE__*/function () {
            function _class13() {
              _classCallCheck(this, _class13);
            }
            _createClass(_class13, [{
              key: "load",
              value: function load(t, e, i) {
                var _this45 = this;
                this.Xj = e, this.Bc = i, this.Wa = new XMLHttpRequest(), this.Wa.open("GET", t, !0), this.Wa.onerror = function (t) {
                  return _this45.Bh(t);
                }, this.Wa.onreadystatechange = function () {
                  return _this45.kv();
                }, this.Wa.send();
              }
            }, {
              key: "kv",
              value: function kv() {
                null != this.Wa && 4 === this.Wa.readyState && (200 === this.Wa.status ? this.UF() : this.Bc());
              }
            }, {
              key: "UF",
              value: function UF() {
                this.Wa.response && null == this.Wa.response.error ? null != this.Xj && this.qs(this.Wa.response) : this.Bc && this.Bc();
              }
            }, {
              key: "Bh",
              value: function Bh() {
                null != this.Bc && this.Bc();
              }
            }, {
              key: "qs",
              value: function qs(t) {
                try {
                  var e = JSON.parse(t);
                  this.Xj(i.mw.Za(e));
                } catch (t) {
                  console.error(t), this.Bc();
                }
              }
            }]);
            return _class13;
          }();
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function () {
              function e() {
                _classCallCheck(this, e);
                if (null != e.instance) throw Error("Singleton");
                this.defaults = new t.mw(), this.defaults.iq();
              }
              _createClass(e, [{
                key: "updateLabels",
                value: function updateLabels() {
                  t.g.gH = this.I("fieldsList/flatHierarchyBox"), t.g.D4 = this.I("fieldsList/hierarchyBox"), t.g.C4 = this.I("fieldsList/filterBox"), t.g.F4 = this.I("fieldsList/rowBox"), t.g.B4 = this.I("fieldsList/columnBox"), t.g.E4 = this.I("fieldsList/measureBox"), t.g.IA = this.I("fieldsList/values"), t.g.bH = this.I("fieldsList/addCalculatedMeasure"), t.g.RQ = this.I("fieldsList/expandAll"), t.g.dH = this.I("fieldsList/collapseAll"), t.g.hH = this.I("fieldsList/formulasGroupName"), t.g.cH = this.I("fieldsList/allFields"), t.g.iH = this.I("fieldsList/rows"), t.g.eH = this.I("fieldsList/columns"), t.g.fH = this.I("fieldsList/filters"), t.g.Jm = this.I("fieldsList/dropField"), t.g.dw = this.I("fieldsList/title"), t.g.jH = this.I("fieldsList/subtitle"), t.g.SQ = this.I("filter/all"), t.g.VQ = this.I("filter/multipleItems"), t.g.jt = this.I("filter/selectAll"), t.g.WQ = this.I("filter/selectAllResults"), t.g.pH = this.I("filter/top"), t.g.lH = this.I("filter/bottom"), t.g.kH = this.I("filter/ascSort"), t.g.mH = this.I("filter/descSort"), t.g.qH = this.I("filter/topX"), t.g.rH = this.I("filter/clearTopX"), t.g.nH = this.I("filter/search"), t.g.UQ = this.I("filter/amountSelected"), t.g.TQ = this.I("filter/amountFound"), t.g.oH = this.I("filter/sort"), t.g.MQ = this.I("drillThrough/title"), t.g.LQ = this.I("drillThrough/row"), t.g.KQ = this.I("drillThrough/column"), t.g.NQ = this.I("drillThrough/value"), t.g.tG = this.I("calculatedView/title"), t.g.qG = this.I("calculatedView/measureBox"), t.g.rG = this.I("calculatedView/measureName"), t.g.qA = this.I("calculatedView/formula"), t.g.pG = this.I("calculatedView/formulaPrompt"), t.g.oG = this.I("calculatedView/calculateIndividualValues"), t.g.sG = this.I("calculatedView/removeValue"), t.g.cQ = this.I("calculatedView/removeValueTitle"), t.g.bQ = this.I("calculatedView/removeValueMessage"), t.g.u4 = this.I("calculatedView/header"), t.g.t4 = this.I("calculatedView/allValues"), t.g.zH = this.I("grid/total"), t.g.hR = this.I("grid/totals"), t.g.jw = this.I("grid/grandTotal"), t.g.Cg = this.I("grid/blankMember"), t.g.sl = this.I("grid/dateInvalidCaption"), t.g.n5 = this.I("tooltips/row"), t.g.m5 = this.I("tooltips/column"), t.g.ZS = this.I("tooltips/headerResize"), t.g.OI = this.I("tooltips/headerFit"), t.g.gB = this.I("tooltips/filterIcon"), t.g.fB = this.I("tooltips/filtered"), t.g.YS = this.I("tooltips/expandIcon"), t.g.VS = this.I("tooltips/collapseIcon"), t.g.WS = this.I("tooltips/drillDown"), t.g.XS = this.I("tooltips/drillUp"), t.g.SI = this.I("tooltips/sortIcon"), t.g.RI = this.I("tooltips/sortedDescIcon"), t.g.QI = this.I("tooltips/sortedAscIcon"), t.g.l5 = this.I("tooltips/close"), t.g.II = this.I("aggregations/sum/caption"), t.g.JI = this.I("aggregations/sum/totalCaption"), t.g.LS = this.I("aggregations/sum/grandTotalCaption"), t.g.CG = this.I("aggregations/count/caption"), t.g.DG = this.I("aggregations/count/totalCaption"), t.g.qQ = this.I("aggregations/count/grandTotalCaption"), t.g.GQ = this.I("aggregations/distinctCount/caption"), t.g.NG = this.I("aggregations/distinctCount/totalCaption"), t.g.HQ = this.I("aggregations/distinctCount/grandTotalCaption"), t.g.EQ = this.I("aggregations/difference/caption"), t.g.MG = this.I("aggregations/difference/totalCaption"), t.g.FQ = this.I("aggregations/difference/grandTotalCaption"), t.g.gS = this.I("aggregations/percentDifference/caption"), t.g.hI = this.I("aggregations/percentDifference/totalCaption"), t.g.hS = this.I("aggregations/percentDifference/grandTotalCaption"), t.g.eG = this.I("aggregations/average/caption"), t.g.fG = this.I("aggregations/average/totalCaption"), t.g.WP = this.I("aggregations/average/grandTotalCaption"), t.g.mS = this.I("aggregations/product/caption"), t.g.nI = this.I("aggregations/product/totalCaption"), t.g.nS = this.I("aggregations/product/grandTotalCaption"), t.g.QR = this.I("aggregations/min/caption"), t.g.$H = this.I("aggregations/min/totalCaption"), t.g.RR = this.I("aggregations/min/grandTotalCaption"), t.g.AR = this.I("aggregations/max/caption"), t.g.NH = this.I("aggregations/max/totalCaption"), t.g.BR = this.I("aggregations/max/grandTotalCaption"), t.g.dS = this.I("aggregations/percent/caption"), t.g.jI = this.I("aggregations/percent/totalCaption"), t.g.iS = this.I("aggregations/percent/grandTotalCaption"), t.g.eS = this.I("aggregations/percentOfColumn/caption"), t.g.gI = this.I("aggregations/percentOfColumn/totalCaption"), t.g.fS = this.I("aggregations/percentOfColumn/grandTotalCaption"), t.g.jS = this.I("aggregations/percentOfRow/caption"), t.g.iI = this.I("aggregations/percentOfRow/totalCaption"), t.g.kS = this.I("aggregations/percentOfRow/grandTotalCaption"), t.g.rR = this.I("aggregations/index/caption"), t.g.EH = this.I("aggregations/index/totalCaption"), t.g.sR = this.I("aggregations/index/grandTotalCaption"), t.g.ZR = this.I("aggregations/none/caption"), t.g.ER = this.I("aggregations/median/caption"), t.g.OH = this.I("aggregations/median/totalCaption"), t.g.FR = this.I("aggregations/median/grandTotalCaption"), t.g.GS = this.I("aggregations/stdevp/caption"), t.g.FI = this.I("aggregations/stdevp/totalCaption"), t.g.HS = this.I("aggregations/stdevp/grandTotalCaption"), t.g.IS = this.I("aggregations/stdevs/caption"), t.g.GI = this.I("aggregations/stdevs/totalCaption"), t.g.JS = this.I("aggregations/stdevs/grandTotalCaption"), t.g.sS = this.I("aggregations/runningTotals/caption"), t.g.xI = this.I("aggregations/runningTotals/totalCaption"), t.g.tS = this.I("aggregations/runningTotals/grandTotalCaption"), t.g.wb = this.I("messages/error"), t.g.pT = this.I("messages/warning"), t.g.K4 = this.I("messages/limitation"), t.g.m4 = this.I("messages/browse"), t.g.wq = this.I("messages/confirmation"), t.g.j5 = this.I("messages/reportFileType"), t.g.RH = this.I("messages/loading"), t.g.X4 = this.I("messages/loadingConfiguration"), t.g.Pm = this.I("messages/loadingData"), t.g.TH = this.I("messages/waiting"), t.g.SH = this.I("messages/progress"), t.g.d5 = this.I("messages/progressUnknown"), t.g.ow = this.I("messages/analyzing"), t.g.GR = this.I("messages/analyzingProgress"), t.g.ot = this.I("messages/analyzingRecords"), t.g.WH = this.I("messages/saving"), t.g.Y4 = this.I("messages/loadingDimensions"), t.g.Z4 = this.I("messages/loadingHierarchies"), t.g.b5 = this.I("messages/loadingMeasures"), t.g.c5 = this.I("messages/loadingMembers"), t.g.a5 = this.I("messages/loadingLevels"), t.g.S4 = this.I("messages/fullscreen"), t.g.Q4 = this.I("messages/exportComplete"), t.g.pw = this.I("messages/exportProgress"), t.g.UA = this.I("messages/exportError"), t.g.T4 = this.I("messages/generatingPDF"), t.g.qw = this.I("messages/pleaseWait"), t.g.VH = this.I("messages/pagesWereGenerated"), t.g.XH = this.I("messages/uploading"), t.g.Eq = this.I("messages/cantSaveFile"), t.g.L4 = this.I("messages/cantSaveToClipboard"), t.g.NR = this.I("messages/saveReportToFile"), t.g.e5 = this.I("messages/loadReportFromFile"), t.g.U4 = this.I("messages/inputNewName"), t.g.V4 = this.I("messages/inputReportName"), t.g.W4 = this.I("messages/invalidDataSource"), t.g.M4 = this.I("messages/dataStreamError"), t.g.rw = this.I("messages/unableToOpenFile"), t.g.O4 = this.I("messages/unableTwoFileBrowsingSessions"), t.g.KR = this.I("messages/inappropriateFileFormat"), t.g.LR = this.I("messages/invalidJSONdata"), t.g.PR = this.I("messages/wrongFormulaFormat"), t.g.P4 = this.I("messages/excelPdfExportLimitation"), t.g.R4 = this.I("messages/excelExportLimitation"), t.g.UH = this.I("messages/noDataAvailable"), t.g.g5 = this.I("messages/saveDataToFile"), t.g.N4 = this.I("messages/dataWasUpdated"), t.g.f5 = this.I("messages/ocsvIncompatible"), t.g.h5 = this.I("messages/unknownError"), t.g.QH = this.I("messages/invalidReportFormat"), t.g.JR = this.I("messages/csvHeaderParsingError"), t.g.OR = this.I("messages/tooManyColumnsInClassicMode"), t.g.HR = this.I("messages/cantExpand"), t.g.IR = this.I("messages/cantExpandTitle"), t.g.MR = this.I("messages/noGoogleClientKey"), t.g.lG = this.I("buttons/ok"), t.g.Im = this.I("buttons/apply"), t.g.hl = this.I("buttons/cancel"), t.g.mG = this.I("buttons/save"), t.g.n4 = this.I("buttons/clear"), t.g.o4 = this.I("buttons/select"), t.g.pA = this.I("buttons/yes"), t.g.kG = this.I("buttons/no"), t.g.AG = this.I("contextMenu/clearSorting"), t.g.hQ = this.I("contextMenu/collapse"), t.g.iQ = this.I("contextMenu/drillThrough"), t.g.jQ = this.I("contextMenu/expand"), t.g.kQ = this.I("contextMenu/openFilter"), t.g.lQ = this.I("contextMenu/sortColumnAsc"), t.g.mQ = this.I("contextMenu/sortColumnDesc"), t.g.nQ = this.I("contextMenu/sortRowAsc"), t.g.oQ = this.I("contextMenu/sortRowDesc"), t.g.$m = this.I("date/year"), t.g.pt = this.I("date/quarter"), t.g.Ef = this.I("date/month"), t.g.ii = this.I("date/day"), t.g.rI = [this.I("quarters/q1"), this.I("quarters/q2"), this.I("quarters/q3"), this.I("quarters/q4")], t.g.fk = [this.I("months/january"), this.I("months/february"), this.I("months/march"), this.I("months/april"), this.I("months/may"), this.I("months/june"), this.I("months/july"), this.I("months/august"), this.I("months/september"), this.I("months/october"), this.I("months/november"), this.I("months/december")], t.g.Qm = [this.I("monthsShort/january"), this.I("monthsShort/february"), this.I("monthsShort/march"), this.I("monthsShort/april"), this.I("monthsShort/may"), this.I("monthsShort/june"), this.I("monthsShort/july"), this.I("monthsShort/august"), this.I("monthsShort/september"), this.I("monthsShort/october"), this.I("monthsShort/november"), this.I("monthsShort/december")], t.g.Qo = [this.I("weekdays/first"), this.I("weekdays/second"), this.I("weekdays/third"), this.I("weekdays/fourth"), this.I("weekdays/fifth"), this.I("weekdays/sixth"), this.I("weekdays/seventh")], t.g.Ro = [this.I("weekdaysShort/first"), this.I("weekdaysShort/second"), this.I("weekdaysShort/third"), this.I("weekdaysShort/fourth"), this.I("weekdaysShort/fifth"), this.I("weekdaysShort/sixth"), this.I("weekdaysShort/seventh")], a.bt.G2(t.g.Qo, t.g.Ro), a.bt.P2(t.g.fk, t.g.Qm);
                }
              }, {
                key: "I",
                value: function I(t) {
                  if (0 == a.U(this.ys)) {
                    var _e45 = this.ys.I(t);
                    if (0 == a.U(_e45)) return _e45;
                  }
                  return 0 == a.U(this.My) && (_e45 = this.My.I(t), 0 == a.U(_e45)) ? _e45 : this.defaults.I(t);
                }
              }, {
                key: "reset",
                value: function reset() {
                  this.ys = null, this.updateLabels();
                }
              }, {
                key: "load",
                value: function load(_e46, i) {
                  var _this46 = this;
                  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  try {
                    "string" == typeof _e46 && 0 == a.Vb(_e46) ? new t.xR().load(a.jB.PM(_e46), function (t) {
                      _this46.ZN(t, s), null != i && i(!0);
                    }, function () {
                      null != i && i(!1);
                    }) : (_e46 instanceof Object ? this.ZN(t.mw.Za(_e46), s) : this.reset(), null != i && i(!0));
                  } catch (t) {
                    console.error(t), null != i && i(!1);
                  }
                }
              }, {
                key: "ZN",
                value: function ZN(t) {
                  var _e47 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  _e47 ? this.My = t : this.ys = t, this.updateLabels();
                }
              }, {
                key: "mM",
                value: function mM() {
                  var _e48 = new t.mw();
                  return _e48.iq(), _e48.ks(this.My), this.ys && _e48.ks(this.ys), _e48.Sa().toolbar;
                }
              }], [{
                key: "V",
                value: function V() {
                  return null == e.instance && (e.instance = new e()), e.instance;
                }
              }, {
                key: "la",
                value: function la() {
                  t.g.fk = null, t.g.Qm = null, t.g.Qo = null, t.g.Ro = null, t.g.rI = null, e.instance.defaults = null, e.instance.My = null, e.instance.ys = null, e.instance = null;
                }
              }]);
              return e;
            }();
            t.Ho = e;
          }((e = t.model || (t.model = {})).v || (e.v = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function () {
              function e() {
                _classCallCheck(this, e);
                this.labels = {};
              }
              _createClass(e, [{
                key: "I",
                value: function I(t) {
                  var _e49 = this.labels;
                  t = t.split("/");
                  for (var i = 0; i < t.length; i++) {
                    if (void 0 === _e49[t[i]]) return;
                    _e49 = _e49[t[i]];
                  }
                  return _e49;
                }
              }, {
                key: "wa",
                value: function wa(t, _e50) {
                  var i = this.labels;
                  t = t.split("/");
                  for (var s = 0; s < t.length - 1; s++) i = i[t[s]];
                  i[t[t.length - 1]] = _e50;
                }
              }, {
                key: "iq",
                value: function iq() {
                  this.labels.fieldsList = {}, this.labels.fieldsList.flatHierarchyBox = "Select and arrange columns", this.labels.fieldsList.hierarchyBox = "Drag Dimensions", this.labels.fieldsList.filterBox = "Drop & Arrange Report Filter", this.labels.fieldsList.rowBox = "Drop & Arrange Rows", this.labels.fieldsList.columnBox = "Drop & Arrange Columns", this.labels.fieldsList.measureBox = "Drop & Arrange Values", this.labels.fieldsList.values = "Values", this.labels.fieldsList.allFields = "All Fields", this.labels.fieldsList.rows = "Rows", this.labels.fieldsList.columns = "Columns", this.labels.fieldsList.filters = "Report Filters", this.labels.fieldsList.dropField = "Drop field here", this.labels.fieldsList.addCalculatedMeasure = "Add calculated value", this.labels.fieldsList.expandAll = "Expand All", this.labels.fieldsList.collapseAll = "Collapse All", this.labels.fieldsList.formulasGroupName = "Calculated Values", this.labels.fieldsList.title = "Fields", this.labels.fieldsList.subtitle = "Drag and drop fields to arrange", this.labels.filter = {}, this.labels.filter.ascSort = "Az", this.labels.filter.descSort = "zA", this.labels.filter.topX = "Top 10", this.labels.filter.clearTopX = "Clear", this.labels.filter.top = "Top", this.labels.filter.bottom = "Bottom", this.labels.filter.measuresPrompt = "Choose value", this.labels.filter.search = "Search", this.labels.filter.selectAll = "Select All", this.labels.filter.selectAllResults = "Select All Results", this.labels.filter.amountSelected = "{0} of {1} selected", this.labels.filter.amountFound = "{0} of {1} found are selected", this.labels.filter.multipleItems = "Multiple Items", this.labels.filter.all = "All", this.labels.filter.sort = "Sort:", this.labels.drillThrough = {}, this.labels.drillThrough.title = "Details", this.labels.drillThrough.row = "Row: <b>{0}</b>", this.labels.drillThrough.column = "Column: <b>{0}</b>", this.labels.drillThrough.value = "{0}: <b>{1}</b>", this.labels.calculatedView = {}, this.labels.calculatedView.title = "Calculated Value", this.labels.calculatedView.measureBox = "Drag values to formula", this.labels.calculatedView.measureName = "Value name", this.labels.calculatedView.formula = "Formula", this.labels.calculatedView.formulaPrompt = "Drop values and edit formula here", this.labels.calculatedView.calculateIndividualValues = "Calculate individual values", this.labels.calculatedView.removeValue = "Remove", this.labels.calculatedView.removeValueTitle = "Remove {0}?", this.labels.calculatedView.removeValueMessage = "Are you sure you want to remove this.labels calculated value?", this.labels.calculatedView.header = "Add calculated value", this.labels.calculatedView.allValues = "All values", this.labels.grid = {}, this.labels.grid.total = "Total", this.labels.grid.totals = "Totals", this.labels.grid.grandTotal = "Grand Total", this.labels.grid.blankMember = "(blank)", this.labels.grid.dateInvalidCaption = "Invalid date", this.labels.tooltips = {}, this.labels.tooltips.row = "Row:", this.labels.tooltips.column = "Column:", this.labels.tooltips.headerResize = "Drag to resize", this.labels.tooltips.headerFit = "Double click to fit", this.labels.tooltips.filterIcon = "Click to filter", this.labels.tooltips.filtered = "Filtered", this.labels.tooltips.expandIcon = "Click to expand", this.labels.tooltips.collapseIcon = "Click to collapse", this.labels.tooltips.drillDown = "Click to drill down", this.labels.tooltips.drillUp = "Click to drill up", this.labels.tooltips.sortIcon = "Click to sort Desc", this.labels.tooltips.sortedDescIcon = "Click to sort Asc", this.labels.tooltips.sortedAscIcon = "Click to sort Desc", this.labels.tooltips.close = "Click to close", this.labels.aggregations = {}, this.labels.aggregations.sum = {}, this.labels.aggregations.sum.caption = "Sum", this.labels.aggregations.sum.totalCaption = "Sum of {0}", this.labels.aggregations.sum.grandTotalCaption = "Total Sum of {0}", this.labels.aggregations.count = {}, this.labels.aggregations.count.caption = "Count", this.labels.aggregations.count.totalCaption = "Count of {0}", this.labels.aggregations.count.grandTotalCaption = "Total Count of {0}", this.labels.aggregations.distinctCount = {}, this.labels.aggregations.distinctCount.caption = "Distinct Count", this.labels.aggregations.distinctCount.totalCaption = "Distinct Count of {0}", this.labels.aggregations.distinctCount.grandTotalCaption = "Total Distinct Count of {0}", this.labels.aggregations.average = {}, this.labels.aggregations.average.caption = "Average", this.labels.aggregations.average.totalCaption = "Average of {0}", this.labels.aggregations.average.grandTotalCaption = "Total Average of {0}", this.labels.aggregations.product = {}, this.labels.aggregations.product.caption = "Product", this.labels.aggregations.product.totalCaption = "Product of {0}", this.labels.aggregations.product.grandTotalCaption = "Total Product of {0}", this.labels.aggregations.min = {}, this.labels.aggregations.min.caption = "Min", this.labels.aggregations.min.totalCaption = "Min of {0}", this.labels.aggregations.min.grandTotalCaption = "Total Min of {0}", this.labels.aggregations.max = {}, this.labels.aggregations.max.caption = "Max", this.labels.aggregations.max.totalCaption = "Max of {0}", this.labels.aggregations.max.grandTotalCaption = "Total Max of {0}", this.labels.aggregations.percent = {}, this.labels.aggregations.percent.caption = "% of Grand Total", this.labels.aggregations.percent.totalCaption = "% of Grand Total of {0}", this.labels.aggregations.percent.grandTotalCaption = "Total % of Grand Total of {0}", this.labels.aggregations.percentOfColumn = {}, this.labels.aggregations.percentOfColumn.caption = "% of Column", this.labels.aggregations.percentOfColumn.totalCaption = "% of Column of {0}", this.labels.aggregations.percentOfColumn.grandTotalCaption = "Total % of Column of {0}", this.labels.aggregations.percentOfRow = {}, this.labels.aggregations.percentOfRow.caption = "% of Row", this.labels.aggregations.percentOfRow.totalCaption = "% of Row of {0}", this.labels.aggregations.percentOfRow.grandTotalCaption = "Total % of Row of {0}", this.labels.aggregations.index = {}, this.labels.aggregations.index.caption = "Index", this.labels.aggregations.index.totalCaption = "Index of {0}", this.labels.aggregations.index.grandTotalCaption = "Index of {0}", this.labels.aggregations.difference = {}, this.labels.aggregations.difference.caption = "Difference", this.labels.aggregations.difference.totalCaption = "Difference of {0}", this.labels.aggregations.difference.grandTotalCaption = "Difference of {0}", this.labels.aggregations.percentDifference = {}, this.labels.aggregations.percentDifference.caption = "% Difference", this.labels.aggregations.percentDifference.totalCaption = "% Difference of {0}", this.labels.aggregations.percentDifference.grandTotalCaption = "% Difference of {0}", this.labels.aggregations.none = {}, this.labels.aggregations.none.caption = "No Calculation", this.labels.aggregations.median = {}, this.labels.aggregations.median.caption = "Median", this.labels.aggregations.median.totalCaption = "Median of {0}", this.labels.aggregations.median.grandTotalCaption = "Total Median of {0}", this.labels.aggregations.stdevp = {}, this.labels.aggregations.stdevp.caption = "Population StDev", this.labels.aggregations.stdevp.totalCaption = "Population StDev of {0}", this.labels.aggregations.stdevp.grandTotalCaption = "Total Population StDev of {0}", this.labels.aggregations.stdevs = {}, this.labels.aggregations.stdevs.caption = "Sample StDev", this.labels.aggregations.stdevs.totalCaption = "Sample StDev of {0}", this.labels.aggregations.stdevs.grandTotalCaption = "Total Sample StDev of {0}", this.labels.aggregations.runningTotals = {}, this.labels.aggregations.runningTotals.caption = "Running Totals", this.labels.aggregations.runningTotals.totalCaption = "Running Totals of {0}", this.labels.aggregations.runningTotals.grandTotalCaption = "Running Totals of {0}", this.labels.messages = {}, this.labels.messages.error = "Error!", this.labels.messages.warning = "Warning!", this.labels.messages.limitation = "Limitation!", this.labels.messages.browse = "Browse", this.labels.messages.confirmation = "Confirmation", this.labels.messages.reportFileType = "WebDataRocks report file", this.labels.messages.loading = "Loading...", this.labels.messages.loadingConfiguration = "", this.labels.messages.loadingData = "Loading data...", this.labels.messages.uploading = "Uploading...", this.labels.messages.waiting = "Waiting for the response {0} sec.", this.labels.messages.progress = "{0}K", this.labels.messages.progressUnknown = "loaded {0}K", this.labels.messages.analyzing = "Analyzing data...", this.labels.messages.analyzingProgress = "{0} records of {1} ({2}%)", this.labels.messages.analyzingRecords = "{0} records", this.labels.messages.saving = "Saving...", this.labels.messages.loadingDimensions = "Loading dimensions...", this.labels.messages.loadingHierarchies = "Loading hierarchies...", this.labels.messages.loadingMeasures = "Loading measures...", this.labels.messages.loadingMembers = "Loading members...", this.labels.messages.loadingLevels = "Loading levels...", this.labels.messages.fullscreen = "Open report in full screen?", this.labels.messages.exportComplete = 'Export data is created, please click "Save" button to save the _data.', this.labels.messages.generatingPDF = "Generating PDF", this.labels.messages.pleaseWait = "Please wait.", this.labels.messages.pagesWereGenerated = "pages were generated.", this.labels.messages.exportProgress = "Export in progress...", this.labels.messages.exportError = "Failed to export. An unexpected error occurred.", this.labels.messages.cantSaveFile = "Cannot save file.", this.labels.messages.cantSaveToClipboard = "Error: Cannot write to the clipboard.", this.labels.messages.saveReportToFile = 'Report is ready to be saved to file, please click "Save" button to save the report.', this.labels.messages.saveDataToFile = 'Data is ready to be saved to file, please click "Save" button to save the file.', this.labels.messages.loadReportFromFile = "Select report file to be loaded.", this.labels.messages.inputNewName = "Input new name", this.labels.messages.inputReportName = "Please input report name", this.labels.messages.dataStreamError = "Stream error occurred while loading '{0}'", this.labels.messages.unableToOpenFile = "Unable to open file {0}.<br/><br/>It seems that this.labels file doesn't exist or 'Access-Control-Allow-Origin' header is absent in the resource requested.", this.labels.messages.unableTwoFileBrowsingSessions = "Browse file dialog is already opened.", this.labels.messages.noGoogleClientKey = "Please enter Google Client Key in index.html file.", this.labels.messages.wrongFormulaFormat = "Wrong formula format. Please check.", this.labels.messages.inappropriateFileFormat = "The data file is of inappropriate format.", this.labels.messages.invalidJSONdata = "JSON data is invalid.", this.labels.messages.excelPdfExportLimitation = "Export to Microsoft Excel or PDF is not available in the current edition.", this.labels.messages.excelExportLimitation = "Export is not available in the current edition.", this.labels.messages.noDataAvailable = "Data source is empty. Please check the CSV file.", this.labels.messages.csvHeaderParsingError = "CSV header parsing error.", this.labels.messages.dataWasUpdated = "Data source has been updated on the server. Refresh the report?", this.labels.messages.ocsvIncompatible = "Unable to read data source. It seems that OCSV file was compressed with a newer version. Please update the component to version {0} or newer.", this.labels.messages.unknownError = "Unknown error occurred.", this.labels.messages.invalidReportFormat = "Invalid report format or access to file is denied.", this.labels.messages.tooManyColumnsInClassicMode = "Too many columns for classic form. Switched layout to compact form.", this.labels.messages.cantExpand = "Some fields cannot be expanded. Please narrow down the data set.", this.labels.messages.cantExpandTitle = "Data set is too large", this.labels.buttons = {}, this.labels.buttons.ok = "OK", this.labels.buttons.apply = "Apply", this.labels.buttons.cancel = "Cancel", this.labels.buttons.save = "Save", this.labels.buttons.clear = "Clear", this.labels.buttons.select = "Select", this.labels.buttons.yes = "Yes", this.labels.buttons.no = "No", this.labels.contextMenu = {}, this.labels.contextMenu.drillThrough = "Drill through", this.labels.contextMenu.openFilter = "Open filter", this.labels.contextMenu.collapse = "Collapse", this.labels.contextMenu.expand = "Expand", this.labels.contextMenu.sortRowDesc = "Sort row desc", this.labels.contextMenu.sortRowAsc = "Sort row asc", this.labels.contextMenu.clearSorting = "Clear sorting", this.labels.contextMenu.sortColumnDesc = "Sort column desc", this.labels.contextMenu.sortColumnAsc = "Sort column asc", this.labels.date = {}, this.labels.date.year = "Year", this.labels.date.quarter = "Quarter", this.labels.date.month = "Month", this.labels.date.day = "Day", this.labels.quarters = {}, this.labels.quarters.q1 = "Quarter 1", this.labels.quarters.q2 = "Quarter 2", this.labels.quarters.q3 = "Quarter 3", this.labels.quarters.q4 = "Quarter 4", this.labels.months = {}, this.labels.months.january = "January", this.labels.months.february = "February", this.labels.months.march = "March", this.labels.months.april = "April", this.labels.months.may = "May", this.labels.months.june = "June", this.labels.months.july = "July", this.labels.months.august = "August", this.labels.months.september = "September", this.labels.months.october = "October", this.labels.months.november = "November", this.labels.months.december = "December", this.labels.monthsShort = {}, this.labels.monthsShort.january = "Jan", this.labels.monthsShort.february = "Feb", this.labels.monthsShort.march = "Mar", this.labels.monthsShort.april = "Apr", this.labels.monthsShort.may = "May", this.labels.monthsShort.june = "Jun", this.labels.monthsShort.july = "Jul", this.labels.monthsShort.august = "Aug", this.labels.monthsShort.september = "Sep", this.labels.monthsShort.october = "Oct", this.labels.monthsShort.november = "Nov", this.labels.monthsShort.december = "Dec", this.labels.weekdays = {}, this.labels.weekdays.first = "Sunday", this.labels.weekdays.second = "Monday", this.labels.weekdays.third = "Tuesday", this.labels.weekdays.fourth = "Wednesday", this.labels.weekdays.fifth = "Thursday", this.labels.weekdays.sixth = "Friday", this.labels.weekdays.seventh = "Saturday", this.labels.weekdaysShort = {}, this.labels.weekdaysShort.first = "Sun", this.labels.weekdaysShort.second = "Mon", this.labels.weekdaysShort.third = "Tue", this.labels.weekdaysShort.fourth = "Wed", this.labels.weekdaysShort.fifth = "Thu", this.labels.weekdaysShort.sixth = "Fri", this.labels.weekdaysShort.seventh = "Sat", this.labels.toolbar = {}, this.labels.toolbar.connect = "Connect", this.labels.toolbar.connect_local_csv = "To local CSV", this.labels.toolbar.connect_local_json = "To local JSON", this.labels.toolbar.connect_google_drive = "To Google Drive", this.labels.toolbar.connect_remote_csv = "To remote CSV", this.labels.toolbar.connect_remote_csv_mobile = "CSV", this.labels.toolbar.connect_remote_json = "To remote JSON", this.labels.toolbar.connect_remote_json_mobile = "JSON", this.labels.toolbar.open = "Open", this.labels.toolbar.local_report = "Local report", this.labels.toolbar.remote_report = "Remote report", this.labels.toolbar.remote_report_mobile = "Report", this.labels.toolbar.save = "Save", this.labels.toolbar.load_json = "JSON report", this.labels.toolbar.grid = "Grid", this.labels.toolbar.grid_flat = "Flat", this.labels.toolbar.grid_classic = "Classic", this.labels.toolbar.grid_compact = "Compact", this.labels.toolbar.format = "Format", this.labels.toolbar.format_cells = "Format cells", this.labels.toolbar.format_cells_mobile = "Format", this.labels.toolbar.conditional_formatting = "Conditional formatting", this.labels.toolbar.conditional_formatting_mobile = "Conditional", this.labels.toolbar.options = "Options", this.labels.toolbar.fullscreen = "Fullscreen", this.labels.toolbar.minimize = "Minimize", this.labels.toolbar.export = "Export", this.labels.toolbar.export_print = "Print", this.labels.toolbar.export_html = "To HTML", this.labels.toolbar.export_csv = "To CSV", this.labels.toolbar.export_excel = "To Excel", this.labels.toolbar.export_image = "To Image", this.labels.toolbar.export_pdf = "To PDF", this.labels.toolbar.fields = "Fields", this.labels.toolbar.ok = "OK", this.labels.toolbar.apply = "Apply", this.labels.toolbar.done = "Done", this.labels.toolbar.cancel = "Cancel", this.labels.toolbar.value = "Value", this.labels.toolbar.delete = "Delete", this.labels.toolbar.if = "If", this.labels.toolbar.then = "Then", this.labels.toolbar.open_remote_csv = "Open remote CSV", this.labels.toolbar.open_remote_json = "Open remote JSON", this.labels.toolbar.csv = "CSV", this.labels.toolbar.credentials = "credentials", this.labels.toolbar.username = "Username", this.labels.toolbar.password = "Password", this.labels.toolbar.open_remote_report = "Open remote report", this.labels.toolbar.choose_value = "Choose value", this.labels.toolbar.text_align = "Text align", this.labels.toolbar.align_left = "left", this.labels.toolbar.align_right = "right", this.labels.toolbar.none = "None", this.labels.toolbar.space = "(Space)", this.labels.toolbar.thousand_separator = "Thousand separator", this.labels.toolbar.decimal_separator = "Decimal separator", this.labels.toolbar.decimal_places = "Decimal places", this.labels.toolbar.currency_symbol = "Currency symbol", this.labels.toolbar.currency_align = "Currency align", this.labels.toolbar.null_value = "Null value", this.labels.toolbar.is_percent = "Format as percent", this.labels.toolbar.true_value = "true", this.labels.toolbar.false_value = "false", this.labels.toolbar.conditional = "Conditional", this.labels.toolbar.add_condition = "Add condition", this.labels.toolbar.less_than = "Less than", this.labels.toolbar.less_than_or_equal = "Less than or equal to", this.labels.toolbar.greater_than = "Greater than", this.labels.toolbar.greater_than_or_equal = "Greater than or equal to", this.labels.toolbar.equal_to = "Equal to", this.labels.toolbar.not_equal_to = "Not equal to", this.labels.toolbar.between = "Between", this.labels.toolbar.is_empty = "Empty", this.labels.toolbar.all_values = "All values", this.labels.toolbar.and = "and", this.labels.toolbar.and_symbole = "&", this.labels.toolbar.cp_text = "Text", this.labels.toolbar.cp_highlight = "Highlight", this.labels.toolbar.layout_options = "Layout options", this.labels.toolbar.layout = "Layout", this.labels.toolbar.compact_view = "Compact form", this.labels.toolbar.classic_view = "Classic form", this.labels.toolbar.flat_view = "Flat form", this.labels.toolbar.grand_totals = "Grand totals", this.labels.toolbar.grand_totals_off = "Do not show grand totals", this.labels.toolbar.grand_totals_on = "Show grand totals", this.labels.toolbar.grand_totals_on_rows = "Show for rows only", this.labels.toolbar.grand_totals_on_columns = "Show for columns only", this.labels.toolbar.subtotals = "Subtotals", this.labels.toolbar.subtotals_off = "Do not show subtotals", this.labels.toolbar.subtotals_on = "Show subtotals", this.labels.toolbar.subtotals_on_rows = "Show subtotal rows only", this.labels.toolbar.subtotals_on_columns = "Show subtotal columns only", this.labels.toolbar.choose_page_orientation = "Choose page orientation", this.labels.toolbar.landscape = "Landscape", this.labels.toolbar.portrait = "Portrait", this.labels.toolbar.message_error = this.labels.messages.error, this.labels.toolbar.message_no_google_client_id = this.labels.messages.H5;
                }
              }, {
                key: "ks",
                value: function ks(t) {
                  a.U(t) || this.RN(t.labels, this.labels);
                }
              }, {
                key: "Sa",
                value: function Sa() {
                  return this.labels;
                }
              }, {
                key: "RN",
                value: function RN(t, _e51) {
                  if (!a.U(t) && !a.U(_e51) && t instanceof Object) for (var i in t) {
                    var s = t[i];
                    a.U(s) || "function" != typeof s && ("string" == typeof s ? _e51[i] = s : s instanceof Object && this.RN(s, _e51[i]));
                  }
                }
              }], [{
                key: "Za",
                value: function Za(t) {
                  var i = new e();
                  return i.labels = t, i;
                }
              }]);
              return e;
            }();
            t.mw = e;
          }((e = t.model || (t.model = {})).v || (e.v = {}));
        }(r || (r = {})), function (t) {
          var i;
          !function (t) {
            var i = /*#__PURE__*/_createClass(function i() {
              _classCallCheck(this, i);
            });
            i.Zf = "load", i.wl = "fail", i.li = "cancel", t.$e = i;
            var s = /*#__PURE__*/function (_e$ga2) {
              _inherits(s, _e$ga2);
              var _super38 = _createSuper(s);
              function s(t) {
                var _this47;
                _classCallCheck(this, s);
                _this47 = _super38.call(this, i.Zf), _this47.kb = t;
                return _this47;
              }
              return _createClass(s);
            }(e.ga);
            t.yI = s;
            var r = /*#__PURE__*/function (_e$ga3) {
              _inherits(r, _e$ga3);
              var _super39 = _createSuper(r);
              function r(t) {
                var _this48;
                _classCallCheck(this, r);
                _this48 = _super39.call(this, i.wl), _this48.message = t;
                return _this48;
              }
              return _createClass(r);
            }(e.ga);
            t.ZA = r;
          }((i = t.model || (t.model = {})).kb || (i.kb = {}));
        }(r || (r = {})), function (t) {
          var i;
          !function (s) {
            var r = /*#__PURE__*/function (_e$Od11) {
              _inherits(r, _e$Od11);
              var _super40 = _createSuper(r);
              function r() {
                var _this49;
                _classCallCheck(this, r);
                _this49 = _super40.call(this), _this49.PW = "report.json";
                return _this49;
              }
              _createClass(r, [{
                key: "open",
                value: function open() {
                  var _this50 = this;
                  this.Vn = new s.yR(), this.Vn.addEventListener(s.$e.Zf, function (t) {
                    return _this50.Yp(t);
                  }), this.Vn.addEventListener(s.$e.wl, function (t) {
                    return _this50.mv(t);
                  }), this.Vn.addEventListener(s.$e.li, function () {
                    return _this50.lv();
                  }), this.Vn.load();
                }
              }, {
                key: "load",
                value: function load(e) {
                  var _this51 = this;
                  t.Ta(!0, i.v.g.RH), this.oq = new s.kT(), this.oq.addEventListener(s.$e.Zf, function (t) {
                    return _this51.Yp(t);
                  }), this.oq.addEventListener(s.$e.wl, function (t) {
                    return _this51.mv(t);
                  }), this.oq.load(a.jB.YU(e));
                }
              }, {
                key: "cancel",
                value: function cancel() {
                  this.Vn && (this.Vn.Rc(s.$e.Zf), this.Vn.Rc(s.$e.wl), this.Vn = null), this.oq && (this.oq.Rc(s.$e.Zf), this.oq.Rc(s.$e.wl), this.oq = null), this.Rc(s.$e.Zf), this.Rc(s.$e.wl);
                }
              }, {
                key: "Yp",
                value: function Yp(t) {
                  this.na(new s.yI(t.kb));
                }
              }, {
                key: "mv",
                value: function mv(e) {
                  t.yc(e.message, i.v.g.wb, t.ld.wb), this.Oa(s.$e.wl);
                }
              }, {
                key: "lv",
                value: function lv() {
                  this.Oa(s.$e.li);
                }
              }, {
                key: "save",
                value: function save(e) {
                  var _this52 = this;
                  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var _r = arguments.length > 2 ? arguments[2] : undefined;
                  var n = arguments.length > 3 ? arguments[3] : undefined;
                  var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
                  var o = arguments.length > 5 ? arguments[5] : undefined;
                  this.CF = _r, _r = !1;
                  var h = "string" == typeof e ? e : null,
                    l = n;
                  switch (n = a, e instanceof Object && (e.hasOwnProperty("filename") && (h = e.filename), e.hasOwnProperty("destination") && (i = e.destination), e.hasOwnProperty("url") && (l = e.url), e.hasOwnProperty("embedData") && (n = e.embedData)), null != h && "" != h || (h = this.PW), o.Td.gg == t.u.i.Te.jl && o.options.qa("gridType") != t.G.N.Ue.Ih && (o.Td instanceof t.u.C.KA && o.Td.eg || o.Td.hg || n) && ((e = new t.u.C.$s()).hg = !0, o.Td = e, _r = !0), i = null == i ? s.ml.gt : i.toLowerCase()) {
                    case s.ml.$A:
                      _r ? new t.u.vj.vA().getData(function (t) {
                        return _this52.Sz(l, h, o, t);
                      }) : this.Sz(l, h, o);
                      break;
                    case s.ml.gt:
                      _r ? new t.u.vj.vA().getData(function (t) {
                        return _this52.gq(h, o, t);
                      }) : this.gq(h, o);
                      break;
                    default:
                      _r ? new t.u.vj.vA().getData(function (t) {
                        return _this52.gq(h, o, t);
                      }) : this.gq(h, o);
                  }
                  return null;
                }
              }, {
                key: "xu",
                value: function xu(t) {
                  if (null != this.CF) try {
                    this.CF(t);
                  } catch (t) {
                    this.CF("Error! " + t);
                  }
                }
              }, {
                key: "VC",
                value: function VC(t) {
                  return JSON.stringify(t.Sa(), null, 4);
                }
              }, {
                key: "gq",
                value: function gq(e, s) {
                  var _r2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  var n = [this.VC(s)];
                  null != _r2 && (n.push("\n"), n.push(_r2));
                  try {
                    var a = this;
                    t.yc(i.v.g.NR, i.v.g.wq, t.ld.wq, [i.v.g.mG, i.v.g.hl], [function () {
                      u(new Blob(n, {
                        type: "text/js;charset=utf-8"
                      }), e), a.xu(!0);
                    }, function () {
                      a.xu(!1);
                    }]);
                  } catch (e) {
                    t.yc(i.v.g.Eq, i.v.g.wb, t.ld.wb), this.xu(!1);
                  }
                }
              }, {
                key: "Sz",
                value: function Sz(s, _r3, o) {
                  var _this53 = this;
                  var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                  a.Vb(s) && t.yc("Report cannot be saved. Save report url is empty.", i.v.g.pT, t.ld.wb);
                  var l = new n.jT();
                  l.data.name = _r3, l.data.report = null == h ? this.VC(o) : this.VC(o) + "\n" + h, l.data.type = "json";
                  var A = new n.Gw();
                  return A.data = l.toString(), A.contentType = n.zQ.UP, A.xF = n.WI.lI, A.addEventListener(e.ga.yg, function () {
                    return _this53.g1(A);
                  }), A.addEventListener(e.ga.wb, function () {
                    return _this53.Bh(A);
                  }), A.load(s), t.Ta(!0, i.v.g.XH), null;
                }
              }, {
                key: "g1",
                value: function g1(e) {
                  t.Ta(!1), this.xu(e.response);
                }
              }, {
                key: "Bh",
                value: function Bh(e) {
                  t.Ta(!1), this.xu(!1), e = i.zc.valid(e.url) ? e.url : i.zc.validate(e.url), t.yc(i.v.g.Eq + a.$.bind(' (<a href="{0}">{0}</a>)', e), i.v.g.wb, t.ld.wb);
                }
              }]);
              return r;
            }(e.Od);
            s.wS = r;
          }((i = t.model || (t.model = {})).kb || (i.kb = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (i) {
            var s = /*#__PURE__*/function () {
              function s() {
                _classCallCheck(this, s);
                this.Ss = !1, this.Td = new t.u.C.xq(), this.slice = new i.Kh(), this.options = new e.A.C.ij(), this.Ec = [], this.uc = [], this.Sd = {}, this.$d = {}, this.Rd = [], this.Zd = [], this.le = [], this.Wl = {}, this.Am = {}, this.Mg = [], this.labels = {}, this.Pf = null;
              }
              _createClass(s, [{
                key: "Sa",
                value: function Sa() {
                  var t = {},
                    e = this.Td.Sa(this.Ss);
                  if (a.ee.je(e) || (t.dataSource = e), e = this.slice.Sa(this.Ss), a.ee.je(e) || (t.slice = e), e = this.options.Sa(), a.ee.je(e) || (t.options = e), 0 < (e = this.aW()).length && (t.conditions = e), null != this.Ec && 0 != this.Ec.length) {
                    e = [];
                    for (var i = !this.options.qa("saveAllFormats") && 5 < this.Ec.length, _s28 = 0; _s28 < this.Ec.length; _s28++) {
                      var r = this.Ec[_s28];
                      "" != r.name && (null == this.slice.sD[r.name] || i && !this.slice.sD[r.name]) || e.push(r);
                    }
                    t.formats = e;
                  }
                  return e = this.iW(), a.ee.je(e) || (t.tableSizes = e), null != this.Mg && 0 != this.Mg.length && (t.customFields = this.Mg), null != this.Pf && "" != this.Pf && (t.localization = this.Pf), t;
                }
              }, {
                key: "aW",
                value: function aW() {
                  for (var t = [], e = 0; e < this.uc.length; e++) {
                    var i = this.uc[e],
                      _s29 = {};
                    _s29.formula = i.formula, -1 < i.row && (_s29.row = i.row), -1 < i.column && (_s29.column = i.column), -1 < i.isTotal && (_s29.isTotal = 1 == i.isTotal), i.measure && 0 < i.measure.length && (_s29.measure = i.measure), i.hierarchy && 0 < i.hierarchy.length && (_s29.hierarchy = i.hierarchy), i.member && 0 < i.member.length && (_s29.member = i.member), i.format && !a.ee.je(i.format) && (_s29.format = i.format), t.push(_s29);
                  }
                  return t;
                }
              }, {
                key: "iW",
                value: function iW() {
                  var t,
                    e,
                    _s30 = {};
                  if (null != this.Rd && !a.ee.je(this.Rd) || null != this.Sd && !a.ee.je(this.Sd)) {
                    if (_s30.columns = [], null != this.Rd && !a.ee.je(this.Rd)) for (e = 0; e < this.Rd.length; e++) null != this.Rd[e] && _s30.columns.push({
                      idx: e,
                      width: this.Rd[e]
                    });
                    if (e = i.Kh.we(this.slice.za), null != this.Sd && !a.ee.je(this.Sd)) for (t in this.Sd) {
                      var r = t.split(",");
                      if (0 <= e) {
                        var n = r.pop();
                        _s30.columns.push({
                          tuple: r,
                          measure: n,
                          width: this.Sd[t]
                        });
                      } else _s30.columns.push({
                        tuple: r,
                        width: this.Sd[t]
                      });
                    }
                  }
                  if (null != this.le && !a.ee.je(this.le) || null != this.Zd && !a.ee.je(this.Zd) || null != this.$d && !a.ee.je(this.$d)) {
                    if (_s30.rows = [], null != this.le && !a.ee.je(this.le)) for (e = 0; e < this.le.length; e++) null != this.le[e] && _s30.rows.push({
                      idx: e,
                      height: this.le[e]
                    });
                    if (null != this.Zd && !a.ee.je(this.Zd)) for (e = 0; e < this.Zd.length; e++) null != this.Zd[e] && _s30.rows.push({
                      idx: e,
                      height: this.Zd[e]
                    });
                    if (e = i.Kh.we(this.slice.rows), null != this.$d && !a.ee.je(this.$d)) for (t in this.$d) r = t.split(","), 0 <= e ? (n = r.pop(), _s30.rows.push({
                      tuple: r,
                      measure: n,
                      height: this.$d[t]
                    })) : _s30.rows.push({
                      tuple: r,
                      height: this.$d[t]
                    });
                  }
                  return _s30;
                }
              }, {
                key: "ks",
                value: function ks(i) {
                  if (!a.U(i)) {
                    i = s.Hh(i);
                    var r,
                      n = s.Hh(this);
                    for (r in i) i.hasOwnProperty(r) && ("connectionInfo" == r ? t.u.C.xq.Za(i.connectionInfo).Db || (n[r] = i[r]) : "options" == r ? (this.options.gv(i[r]), n[r] = e.A.C.ij.Hh(this.options)) : n[r] = i[r]);
                    s.Za(n);
                  }
                }
              }], [{
                key: "Za",
                value: function Za(r) {
                  if (null == r) return null;
                  r = s.Hh(r);
                  var n = new s();
                  return n.Td = t.u.C.xq.Za(r.connectionInfo ? r.connectionInfo : r), n.options = e.A.C.ij.Za(r.options ? r.options : r), n.slice = i.Kh.Za(r.slice ? r.slice : r, n.Td, n.options.qa("gridType") == t.G.N.Ue.Ih), null != r.formats && r.formats.length && (n.Ec = r.formats), null != r.conditions && r.conditions.length && (n.uc = r.conditions), null != r.columnSizes && "string" != typeof r.columnSizes && (n.Sd = r.columnSizes), null != r.rowSizes && "string" != typeof r.rowSizes && (n.$d = r.rowSizes), null != r.columnHeaderSizes && "string" != typeof r.columnHeaderSizes && (n.Rd = r.columnHeaderSizes), null != r.rowHeaderSizes && "string" != typeof r.rowHeaderSizes && (n.Zd = r.rowHeaderSizes), null != r.rowFilterSizes && "string" != typeof r.rowFilterSizes && (n.le = r.rowFilterSizes), null != r.columnSizesByIdx && (n.Wl = r.columnSizesByIdx), null != r.rowSizesByIdx && (n.Am = r.rowSizesByIdx), null != r.customFields && (n.Mg = r.customFields), null != r.localization && (n.Pf = r.localization), n;
                }
              }, {
                key: "Hh",
                value: function Hh(_s31) {
                  var r = {};
                  if (null == _s31) return r;
                  if (null != _s31.columnSizes && (r.columnSizes = _s31.columnSizes), null != _s31.rowSizes && (r.rowSizes = _s31.rowSizes), null != _s31.columnHeaderSizes && (r.columnHeaderSizes = _s31.columnHeaderSizes), null != _s31.rowHeaderSizes && (r.rowHeaderSizes = _s31.rowHeaderSizes), null != _s31.rowFilterSizes && (r.rowFilterSizes = _s31.rowFilterSizes), null != _s31.rowSizesByIdx && (r.rowSizesByIdx = _s31.rowSizesByIdx), null != _s31.columnSizesByIdx && (r.columnSizesByIdx = _s31.columnSizesByIdx), null != _s31.customFields && (r.customFields = _s31.customFields), null != _s31.labels && (r.labels = _s31.labels), r.connectionInfo = t.u.C.xq.Hh(_s31.connectionInfo ? _s31.connectionInfo : _s31), r.slice = i.Kh.Hh(_s31.slice ? _s31.slice : _s31), r.options = e.A.C.ij.Hh(_s31.options ? _s31.options : _s31), null != _s31.formats && 0 < _s31.formats.length && (r.formats = _s31.formats), null != _s31.conditions && 0 < _s31.conditions.length && (r.conditions = _s31.conditions), null != _s31.tableSizes) {
                    var n;
                    if (null != _s31.tableSizes.columns) {
                      var a = _s31.tableSizes.columns;
                      for (n = 0; n < a.length; n++) if (null != a[n].idx && (null == r.columnSizesByIdx && (r.columnSizesByIdx = {}), r.columnSizesByIdx[parseInt(a[n].idx)] = parseInt(a[n].width)), null != a[n].tuple || null != a[n].measure) {
                        null == r.columnSizes && (r.columnSizes = {});
                        var o = null == a[n].tuple ? [] : a[n].tuple.slice();
                        null != a[n].measure && o.push(a[n].measure), r.columnSizes[o.join(",")] = parseInt(a[n].width);
                      }
                    }
                    if (null != _s31.tableSizes.rows) for (a = _s31.tableSizes.rows, n = 0; n < a.length; n++) null != a[n].idx && (null == r.rowSizesByIdx && (r.rowSizesByIdx = {}), r.rowSizesByIdx[parseInt(a[n].idx)] = parseInt(a[n].height)), (null != a[n].tuple || null != a[n].measure) && (null == r.rowSizes && (r.rowSizes = {}), o = null == a[n].tuple ? [] : a[n].tuple.slice(), null != a[n].measure && o.push(a[n].measure), r.rowSizes[o.join(",")] = parseInt(a[n].height));
                  }
                  return null != _s31.localization && (r.localization = _s31.localization), r;
                }
              }]);
              return s;
            }();
            i.Jq = s;
          }((e = t.model || (t.model = {})).kb || (e.kb = {}));
        }(r || (r = {})), function (t) {
          var i;
          !function (s) {
            var r = /*#__PURE__*/function (_e$Od12) {
              _inherits(r, _e$Od12);
              var _super41 = _createSuper(r);
              function r() {
                _classCallCheck(this, r);
                return _super41.apply(this, arguments);
              }
              _createClass(r, [{
                key: "uL",
                value: function uL(t) {
                  t ? this.na(new s.yI(t)) : this.na(new s.ZA(i.v.g.QH));
                }
              }, {
                key: "fO",
                value: function fO(t) {
                  try {
                    var e;
                    return e = t.indexOf("/**----**"), JSON.parse(-1 < e ? t.substring(0, e) : t);
                  } catch (t) {
                    return console.error(t), null;
                  }
                }
              }, {
                key: "Hy",
                value: function Hy(e) {
                  var i = new t.yq(new ArrayBuffer(0), 0, t.yq.nA);
                  return i.h4(e), i.byteLength;
                }
              }]);
              return r;
            }(e.Od);
            s.zI = r;
          }((i = t.model || (t.model = {})).kb || (i.kb = {}));
        }(r || (r = {})), function (t) {
          var i;
          !function (s) {
            var r = /*#__PURE__*/function (_s$zI) {
              _inherits(r, _s$zI);
              var _super42 = _createSuper(r);
              function r() {
                var _this54;
                _classCallCheck(this, r);
                _this54 = _super42.call(this), _this54.counter = 0, _this54.GL = "/**----**";
                return _this54;
              }
              _createClass(r, [{
                key: "load",
                value: function load(t) {
                  var _this55 = this;
                  this.url = t, this.np = 0, this.Ub = new n.Gw(), this.Ub.dataType = n.QG.st, this.Ub.addEventListener(e.ga.vw, function (t) {
                    return _this55.Wp(t);
                  }), this.Ub.addEventListener(e.ga.yg, function () {
                    return _this55.qs();
                  }), this.Ub.addEventListener(e.ga.wb, function () {
                    return _this55.Bh();
                  }), this.Ub.load(t);
                }
              }, {
                key: "Wp",
                value: function Wp() {
                  var t = 0;
                  null != this.Ub && -1 < (t = this.Ub.response.indexOf("</config>")) && t + this.GL.length + 1 < this.Ub.response.length && this.qs();
                }
              }, {
                key: "qs",
                value: function qs() {
                  if (null != this.Ub) {
                    this.Ub.Rc(e.ga.yg);
                    var i = this.fO(this.Ub.response);
                    if (i instanceof s.Jq) {
                      if (i.Td instanceof t.u.C.$s && 1 == i.Td.hg) {
                        var _r4 = i.Td;
                        _r4.filename = this.Ub.url, _r4.Tx = this.Hy(this.Ub.response.substring(0, this.Ub.response.indexOf("</config>") + 9) + "\n"), i.Td = _r4;
                      }
                    } else a.U(i) || a.U(i.dataSource) || 1 != i.dataSource.hg || (i.dataSource.filename = this.Ub.url, i.dataSource.embeddedDataOffset = this.Hy(this.Ub.response.substring(0, this.Ub.response.indexOf(this.GL))));
                    this.uL(i), this.la();
                  }
                }
              }, {
                key: "Bh",
                value: function Bh() {
                  this.Ub.Rc(e.ga.vw), this.Ub.Rc(e.ga.yg), this.Ub.Rc(e.ga.wb);
                  var t = i.zc.valid(this.url) ? this.url : i.zc.validate(this.url);
                  t = a.$.bind(i.v.g.rw, t), this.na(new s.ZA(t)), this.la();
                }
              }, {
                key: "la",
                value: function la() {
                  null != this.Ub && (this.Ub.Rc(), this.Ub.la(), this.Ub = null);
                }
              }]);
              return r;
            }(s.zI);
            s.kT = r;
          }((i = t.model || (t.model = {})).kb || (i.kb = {}));
        }(r || (r = {})), function (t) {
          var i;
          !function (s) {
            var r = /*#__PURE__*/function (_s$zI2) {
              _inherits(r, _s$zI2);
              var _super43 = _createSuper(r);
              function r() {
                _classCallCheck(this, r);
                return _super43.call(this);
              }
              _createClass(r, [{
                key: "load",
                value: function load() {
                  var _this56 = this;
                  this.file = new n.tH(), this.file.addEventListener(e.ga.Vm, function () {
                    return _this56.l1();
                  }), this.file.addEventListener(e.ga.yg, function () {
                    return _this56.qs();
                  }), this.file.addEventListener(e.ga.rA, function () {
                    return _this56.R_();
                  }), this.file.addEventListener(e.ga.wb, function () {
                    return _this56.Bh();
                  }), this.file.FK([".json", ".js"]);
                }
              }, {
                key: "l1",
                value: function l1() {
                  null != this.file && this.file.load(n.vS.ARRAY_BUFFER);
                }
              }, {
                key: "qs",
                value: function qs() {
                  try {
                    var e = new t.yq(this.file.response, 0, t.yq.nA),
                      i = e.rF(e.byteLength),
                      _r5 = this.fO(i);
                    if (_r5 instanceof s.Jq) {
                      if (_r5.Td instanceof t.u.C.$s && 1 == _r5.Td.hg) {
                        var n = _r5.Td;
                        n.HL = this.file.response, n.Tx = this.Hy(i.substring(0, i.indexOf("</config>") + 9) + "\n"), _r5.Td = n;
                      }
                    } else a.U(_r5) || a.U(_r5.dataSource) || 1 != _r5.dataSource.hg || (_r5.dataSource.embeddedDataToLoad = this.file.response, _r5.dataSource.embeddedDataOffset = this.Hy(i.substring(0, i.indexOf("/**----**"))));
                    this.uL(_r5), this.la();
                  } catch (t) {
                    console.error(t), this.Bh();
                  }
                }
              }, {
                key: "Bh",
                value: function Bh() {
                  var t = a.$.bind(i.v.g.rw, "");
                  this.na(new s.ZA(t)), this.la();
                }
              }, {
                key: "R_",
                value: function R_() {
                  this.Oa(s.$e.li), this.la();
                }
              }, {
                key: "la",
                value: function la() {
                  null != this.file && (this.file.Rc(), this.file.la(), this.file = null);
                }
              }]);
              return r;
            }(s.zI);
            s.yR = r;
          }((i = t.model || (t.model = {})).kb || (i.kb = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function () {
              function e() {
                _classCallCheck(this, e);
              }
              _createClass(e, null, [{
                key: "Rs",
                value: function Rs(t) {
                  return t == e.gt || t == e.$A || t == e.jG || t == e.kI;
                }
              }]);
              return e;
            }();
            e.gt = "file", e.$A = "server", e.jG = "binary", e.kI = "plain", t.ml = e;
          }((e = t.model || (t.model = {})).kb || (e.kb = {}));
        }(r || (r = {}));
        var d = r || (r = {}),
          f = d.model || (d.model = {}),
          p = f.kb || (f.kb = {});
        var w = /*#__PURE__*/_createClass(function w() {
          _classCallCheck(this, w);
        });
        w.Mg = [], p.at = w, function (t) {
          var e;
          !function (i) {
            var s = /*#__PURE__*/function () {
              function s() {
                _classCallCheck(this, s);
                this.rows = [], this.za = [], this.eb = [], this.Ia = [], this.Xi = {}, this.Ci = {}, this.Dn = [], this.Bn = [], this.An = [], this.yn = [], this.gd = this.oc = !1, this.ze = [], this.sD = {};
              }
              _createClass(s, [{
                key: "A_",
                value: function A_(t) {
                  if (0 <= s.we(t.rows)) {
                    var e = s.we(t.za);
                    0 <= e && (t.za[e] = t.za[0], t.za.shift());
                  }
                }
              }, {
                key: "Sa",
                value: function Sa() {
                  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  var i,
                    _s36 = {},
                    r = [];
                  for (i = 0; i < this.eb.length; i++) r.push(this.YD(this.eb[i], e));
                  for (0 < r.length && (_s36.reportFilters = r), r = [], i = 0; i < this.rows.length; i++) r.push(this.YD(this.rows[i], e));
                  for (0 < r.length && (_s36.rows = r), r = [], i = 0; i < this.za.length; i++) r.push(this.YD(this.za[i], e));
                  for (0 < r.length && (_s36.columns = r), r = [], i = 0; i < this.Ia.length; i++) r.push(this.m_(this.Ia[i], e));
                  return 0 < r.length && (_s36.measures = r), (null != this.Xi && null != this.Xi.type && this.Xi.type != t.u.i.ba.mb || null != this.Ci && this.Ci.type && this.Ci.type != t.u.i.ba.mb) && (_s36.sorting = {}, null != this.Xi && null != this.Xi.type && this.Xi.type != t.u.i.ba.mb && (_s36.sorting.row = this.Xi), null != this.Ci && this.Ci.type && this.Ci.type != t.u.i.ba.mb && (_s36.sorting.column = this.Ci)), i = {}, (e || this.oc) && (i.expandAll = this.oc), 0 < this.Dn.length && (i.rows = this.KL(this.Dn)), 0 < this.Bn.length && (i.columns = this.KL(this.Bn)), a.ee.je(i) || (_s36.expands = i), i = {}, (e || this.gd) && (i.drillAll = this.gd), 0 < this.An.length && (i.rows = this.DL(this.An)), 0 < this.yn.length && (i.columns = this.DL(this.yn)), a.ee.je(i) || (_s36.drills = i), 0 < this.ze.length && (_s36.flatOrder = this.ze), _s36;
                }
              }, {
                key: "KL",
                value: function KL(t) {
                  for (var e, i, _s37, r = [], n = 0; n < t.length; n++) e = {}, _s37 = (i = t[n].slice(0)).shift(), 0 != i.length && (e.tuple = i, "" != _s37 && (e.measure = _s37), r.push(e));
                  return r;
                }
              }, {
                key: "DL",
                value: function DL(t) {
                  for (var e, i, _s38, r, n = [], a = 0; a < t.length; a++) e = {}, i = (r = t[a].slice(0)).shift(), _s38 = r.shift(), r.shift(), 0 != r.length && (e.tuple = r, "" != _s38 && (e.measure = _s38), "" != i && (e.level = i), n.push(e));
                  return n;
                }
              }, {
                key: "m_",
                value: function m_(e, i) {
                  var _s39 = {};
                  return _s39.uniqueName = e.uniqueName, null != e.formula && "" != e.formula ? (_s39.formula = e.formula, e.individual && (_s39.individual = !0), _s39.caption = e.caption) : (i || e.aggregation != t.u.i.ca.NONE) && (_s39.aggregation = e.aggregation), (i || 0 == e.active) && (_s39.active = e.active), null != e.format && "" != e.format && (_s39.format = e.format, this.sD[e.format] = e.active), null != e.availableAggregations && 0 < e.availableAggregations.length && (_s39.availableAggregations = e.availableAggregations), _s39;
                }
              }, {
                key: "YD",
                value: function YD(e, i) {
                  var _s40 = {};
                  if (_s40.uniqueName = e.uniqueName, null != e.activeLevelName && (_s40.levelName = e.activeLevelName), null != e.filter && (_s40.filter = {}, null != e.filter.type && e.filter.type != t.u.i.Dd.NONE && (_s40.filter = {
                    type: e.filter.type,
                    quantity: e.filter.quantity,
                    measure: e.filter.measure
                  }), null != e.filter.members)) {
                    var r = "string" == typeof e.filter.members ? e.filter.members.split(",") : e.filter.members;
                    0 < r.length && (_s40.filter.members = r, !0 === e.filter.negation && (_s40.filter.negation = e.filter.negation));
                  }
                  return e.filterEnabled || (_s40.filterEnabled = !0), e.uniqueName != t.u.Ja.re && e.sortName && (i || e.sortName != t.u.oa.de.Yv) && (_s40.sort = e.sortName), e.uniqueName != t.u.Ja.re && e.sortAs && (_s40.sortAs = e.sortAs), _s40;
                }
              }], [{
                key: "we",
                value: function we(e) {
                  for (var i = t.u.Ja.re, _s32 = 0; _s32 < e.length; _s32++) if (e[_s32].uniqueName == i) return _s32;
                  return -1;
                }
              }, {
                key: "Iz",
                value: function Iz(t) {
                  for (var e, i = [], _s33 = 0; _s33 < t.length; _s33++) {
                    if ((e = []).push(null != t[_s33].measure ? t[_s33].measure : ""), null != t[_s33].tuple) for (var r = 0; r < t[_s33].tuple.length; r++) e.push(t[_s33].tuple[r]);
                    i.push(e);
                  }
                  return i;
                }
              }, {
                key: "Hz",
                value: function Hz(t) {
                  for (var e, i = [], _s34 = 0; _s34 < t.length; _s34++) {
                    if ((e = []).push(null != t[_s34].level ? t[_s34].level : ""), e.push(null != t[_s34].measure ? t[_s34].measure : -1), null != t[_s34].tuple) {
                      e.push(t[_s34].tuple[t[_s34].tuple.length - 1]);
                      for (var r = 0; r < t[_s34].tuple.length; r++) e.push(t[_s34].tuple[r]);
                    }
                    i.push(e);
                  }
                  return i;
                }
              }, {
                key: "Za",
                value: function Za(t) {
                  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  if (null == t) return null;
                  t instanceof s || (t = s.Hh(t));
                  var n = new s();
                  return null != t.measures && t.measures.length && (n.Ia = t.measures), null == i && e.yb.V(), null != t.pages && t.pages.length && (n.eb = s.WD(t.pages)), null != t.columns && t.columns.length && (n.za = s.WD(t.columns, r)), null != t.rows && t.rows.length && (n.rows = s.WD(t.rows, r)), null != t.flatOrder && t.flatOrder.length && (n.ze = t.flatOrder), n.A_(n), null != t.rowSorting && (n.Xi = t.rowSorting), null != t.columnSorting && (n.Ci = t.columnSorting), null != t.expandAll && (n.oc = t.expandAll), null != t.expandedRows && t.expandedRows.length && (n.Dn = t.expandedRows), null != t.expandedColumns && t.expandedColumns.length && (n.Bn = t.expandedColumns), null != t.drillAll && (n.gd = t.drillAll), null != t.drilledRows && t.drilledRows.length && (n.An = t.drilledRows), null != t.drilledColumns && t.drilledColumns.length && (n.yn = t.drilledColumns), n;
                }
              }, {
                key: "WD",
                value: function WD(e) {
                  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  for (var _s35 = [], r = 0; r < e.length; r++) for (var n in _s35[r] = {}, i && !e[r].sort && (e[r].sort = t.u.i.ba.mb), e[r]) "sort" == n ? _s35[r].sortName = e[r].sort : _s35[r][n] = e[r][n];
                  return _s35;
                }
              }, {
                key: "Hh",
                value: function Hh(t) {
                  var e = {};
                  return null == t || (null != t.pages && (e.pages = t.pages), null != t.reportFilters && (e.pages = t.reportFilters), null != t.rows && (e.rows = t.rows), null != t.columns && (e.columns = t.columns), null != t.measures && (e.measures = t.measures), null != t.rowSorting && (e.rowSorting = t.rowSorting, null != e.rowSorting.tuple && "string" == typeof e.rowSorting.tuple && (e.rowSorting.tuple = e.rowSorting.tuple.split(","))), null != t.sorting && null != t.sorting.row && (e.rowSorting = t.sorting.row), null != t.columnSorting && (e.columnSorting = t.columnSorting, null != e.columnSorting.tuple && "string" == typeof e.columnSorting.tuple && (e.columnSorting.tuple = e.columnSorting.tuple.split(","))), null != t.sorting && null != t.sorting.column && (e.columnSorting = t.sorting.column), null != t.expandAll && (e.expandAll = t.expandAll), null != t.expandedRows && (e.expandedRows = t.expandedRows), null != t.expandedColumns && (e.expandedColumns = t.expandedColumns), null != t.expands && (null != t.expands.expandAll && (e.expandAll = t.expands.expandAll), null != t.expands.rows && (e.expandedRows = s.Iz(t.expands.rows)), null != t.expands.columns && (e.expandedColumns = s.Iz(t.expands.columns))), null != t.drillAll && (e.drillAll = t.drillAll), null != t.drilledRows && (e.drilledRows = t.drilledRows), null != t.drilledColumns && (e.drilledColumns = t.drilledColumns), null != t.drills && (null != t.drills.drillAll && (e.drillAll = t.drills.drillAll), null != t.drills.rows && (e.drilledRows = s.Hz(t.drills.rows)), null != t.drills.columns && (e.drilledColumns = s.Hz(t.drills.columns))), null != t.flatOrder && (e.flatOrder = t.flatOrder), null != t.slice && (null != (t = t.slice).pages && t.pages.length && (e.pages = t.pages), null != t.reportFilters && t.reportFilters.length && (e.pages = t.reportFilters), null != t.rows && t.rows.length && (e.rows = t.rows), null != t.columns && t.columns.length && (e.columns = t.columns), null != t.measures && t.measures.length && (e.measures = t.measures), null != t.sorting && null != t.sorting.row && (e.rowSorting = t.sorting.row), null != t.sorting && null != t.sorting.column && (e.columnSorting = t.sorting.column), null != t.expands && (null != t.expands.expandAll && (e.expandAll = t.expands.expandAll), null != t.expands.rows && (e.expandedRows = s.Iz(t.expands.rows)), null != t.expands.columns && (e.expandedColumns = s.Iz(t.expands.columns))), null != t.drills && (null != t.drills.drillAll && (e.drillAll = t.drills.drillAll), null != t.drills.rows && (e.drilledRows = s.Hz(t.drills.rows)), null != t.drills.columns && (e.drilledColumns = s.Hz(t.drills.columns))), null != t.flatOrder && t.flatOrder.length && (e.flatOrder = t.flatOrder))), e;
                }
              }]);
              return s;
            }();
            i.Kh = s;
          }((e = t.model || (t.model = {})).kb || (e.kb = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.model || (t.model = {}), ((i = e.sb || (e.sb = {})).C || (i.C = {})).MI = /*#__PURE__*/function () {
            function _class14() {
              _classCallCheck(this, _class14);
              this.Ec = new a.ma(), this.uc = new a.ma(), this.Mg = [], this.$d = {}, this.Sd = {}, this.nq = 0, this.Zd = {}, this.Rd = {}, this.le = {}, this.Dn = [], this.Bn = [], this.An = [], this.yn = [], this.Pf = null, this.labels = {}, this.g4 = this.Ss = !1;
            }
            _createClass(_class14, null, [{
              key: "L3",
              value: function L3(i) {
                var s,
                  r = new e.kb.Jq();
                if (r.Ss = i.Ss, r.Td = i.ag, i.ab) {
                  var n = i.ab.ve(t.u.i.da.Ka).Sa(),
                    a = i.ab.ve(t.u.i.da.rb).Sa(),
                    o = i.ab.ve(t.u.i.da.Sm).Sa();
                  for (r.slice = new e.kb.Kh(), r.slice.rows = n.hierarchies, r.slice.za = a.hierarchies, r.slice.eb = o.hierarchies, r.slice.Ia = [], o = 0; o < i.ab.pa.length; o++) {
                    var h = i.ab.pa.F(o);
                    (h = t.u.oa.ol.Sa(h)).active = !0, r.slice.Ia.push(h);
                  }
                  for (o = 0; o < i.oa.pa.length; o++) h = i.oa.pa.F(o), i.ab.pa.rc(h.j) || h.gZ() || ((h = t.u.oa.ol.Sa(h)).active = !1, r.slice.Ia.push(h));
                  r.slice.Xi = n.sort, r.slice.Ci = a.sort, r.slice.oc = i.ab.oc, r.slice.Dn = i.Dn, r.slice.Bn = i.Bn, r.slice.gd = i.ab.gd, r.slice.An = i.An, r.slice.yn = i.yn, r.slice.ze = i.ab.ze;
                }
                for (r.options = i.A, n = [], o = 0; o < i.Ec.length; o++) n[o] = i.Ec.F(o).Sa();
                for (r.Ec = n, n = [], o = 0; o < i.uc.length; o++) n[o] = e.pf.C.wA.Sa(i.uc.F(o));
                for (s in r.uc = n, r.Mg = i.Mg, r.labels = i.labels, o = {}, i.Sd) o[s] = i.Sd[s];
                for (s in r.Sd = o, n = [], i.Rd) n[o = parseInt(s)] = i.Rd[s];
                for (s in r.Rd = n, o = {}, i.$d) o[s] = i.$d[s];
                for (s in r.$d = o, n = [], i.Zd) n[(o = parseInt(s)) + i.nq] = i.Zd[s];
                if (r.Zd = n, n = [], 0 != i.nq) for (s in i.le) n[o = parseInt(s)] = i.le[s];
                return r.le = n, r.Pf = i.Pf, r;
              }
            }]);
            return _class14;
          }();
        }(r || (r = {})), function (t) {
          var e;
          !function (s) {
            var r = /*#__PURE__*/function () {
              function r() {
                var _this57 = this;
                _classCallCheck(this, r);
                this.LH = 25, this.dx = !1, this.kO = function () {
                  return _this57.X0();
                }, this.Cj = this.Pi = 0;
              }
              _createClass(r, [{
                key: "print",
                value: function print() {
                  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                  this.dx || (this.dx = !0, this.A = i || new e.ao.qI(), e.yb.V().addEventListener(t.Eg.vl, this.kO), e.yb.V().Oa(t.Eg.VA));
                }
              }, {
                key: "X0",
                value: function X0() {
                  e.yb.V().removeEventListener(t.Eg.vl, this.kO), this.dx = !1;
                }
              }, {
                key: "Uf",
                value: function Uf(t, e) {
                  this.N = t, this.K = e, this.X = null != t ? t.X : null, this.start();
                }
              }, {
                key: "start",
                value: function start() {
                  var _this58 = this;
                  this.Ch = 0, this.KJ = 576 - 2 * this.LH, this.JJ = 756 - 2 * this.LH, this.eb = new i.ia("div"), this.Wj = [], this.As = this.sh = 0, a.ni.jp(this.cY, this, null, function () {
                    return _this58.finish();
                  });
                }
              }, {
                key: "clear",
                value: function clear() {
                  this.dx = !1, this.sh = this.Ch = this.As = 0, this.eb = this.Vi = null, this.Cj = this.Pi = 0;
                }
              }, {
                key: "cY",
                value: function cY() {
                  return this.rU();
                }
              }, {
                key: "rU",
                value: function rU() {
                  if (null == this.Vi) this.Vi = this.dL(), this.Ez = this.Vi.find("table");else if (!(this.Vi.Lf(!0) <= this.KJ && 0 != this.sh) && (this.Vi.Lf(!0) > this.KJ && (this.sh--, this.Vi.find("td:last-child").remove()), this.lK(), this.Vi = this.dL(), this.Ez = this.Vi.find("table"), 0 == this.N.ef)) {
                    var t = this.sh;
                    0 != this.sh && (this.sh = 0, this.aK(), this.sh = t, this.sh + 1 <= this.K.ig - (this.N.ef ? 1 : 0) && (this.sh += 1));
                  }
                  return this.aK(), 1 == this.shift() && (this.lK(), !0);
                }
              }, {
                key: "dL",
                value: function dL() {
                  var t = new i.ia("div").Y("page");
                  if (t.ha("position", "absolute").ha("left", "-9999px"), null != this.A.Hj) {
                    var s = this.bL(this.A.Hj);
                    t.append(s);
                  }
                  var _r6 = new i.ia("table");
                  if (0 == this.Ch && 0 < e.A.P.ng.length && _r6.append(new i.ia("caption").text(e.A.P.ng)), t.append(_r6), null != this.A.yp) {
                    var n = this.bL(this.A.yp);
                    t.append(n);
                  }
                  return this.N.B.append(t), this.Pi = null != s ? s.Xc() : 0, this.Cj = null != n ? n.Xc() : 0, t;
                }
              }, {
                key: "bL",
                value: function bL(t) {
                  var e = new i.ia("div");
                  return t = (t = t.replace(/##PAGE-NUMBER##/gi, (this.Ch + 1).toString())).replace(/##CURRENT-DATE##/gi, new Date().toLocaleString()), e.Lc(t), e;
                }
              }, {
                key: "lK",
                value: function lK() {
                  this.Ch++, t.Ta(!0, e.v.g.qw, this.Ch + " " + e.v.g.VH, !0), this.sv > this.JJ && (this.Ic--, this.Vi.find("tr:last-child").remove()), this.Vi.detach(), this.Vi.ha("position", "").ha("left", ""), this.eb.append(this.Vi);
                }
              }, {
                key: "shift",
                value: function shift() {
                  return ++this.sh, this.sh > this.K.ig - (this.N.ef ? 1 : 0) && (this.sh = 0, this.As += this.Ic - this.N.md), 1e3 <= this.Ch || this.As >= this.K.Jf;
                }
              }, {
                key: "aK",
                value: function aK() {
                  this.sv = 0;
                  var t = this.N.mi + this.sh,
                    e = this.JJ - this.Pi - this.Cj;
                  for (this.Ic = this.N.jf; this.sv <= e && this.Ic < this.K.Jf + this.N.md - this.As; this.Ic++) {
                    this.rowIndex = this.Ic < this.N.md ? this.Ic : this.Ic + this.As;
                    var i = this.X.Ld(this.rowIndex, t, !0);
                    if (this.sv += this.qU(this.Ic, i), this.sv >= e) break;
                  }
                }
              }, {
                key: "qU",
                value: function qU(t, e) {
                  var s = this.Ez.find("tr", !0);
                  for (s = 0 < s.length ? s[t] : null; null == s;) this.Ez.append(new i.ia("tr")), s = this.Ez.find("tr", !0)[t];
                  if (t = "<td {0}>" + (e ? e.I() : "") + "</td>", null == e) t = a.$.bind(t, "class='cell'");else {
                    var _r7 = "",
                      n = "";
                    e.ds && (n = e.style.Iy(), _r7 = e.style.ty(), this.sC(e.style.sp)), "" != (_r7 = e.Be ? _r7 + " rowHeaderCell level" + e.level : e.Ae ? _r7 + " columnHeaderCell" : e.xh ? _r7 + " filterHeaderCell" : e.Ri && "" != e.I() ? _r7 + " totalCell" : _r7 + " cell").trim() && (_r7 = "class='" + _r7.trim() + "'"), "" != n.trim() && (n = "style='" + n.trim() + "maxWidth:400px'"), t = a.$.bind(t, _r7 + " " + n);
                  }
                  return s.element.innerHTML += t, s.Xc(!0) + 4;
                }
              }, {
                key: "sC",
                value: function sC(t) {
                  for (var e = 0; e < t.length; e++) 0 > this.Wj.indexOf(t[e]) && this.Wj.push(t[e]);
                }
              }, {
                key: "finish",
                value: function finish() {
                  t.Ta(!0, e.v.g.qw, "Sending pages to printer...", !1, !0), n.rS.print(this.eb.Lc(), this.xD(), e.A.P.ng), t.Ta(!1), e.yb.V().Oa(t.Eg.vl), this.clear();
                }
              }, {
                key: "xD",
                value: function xD() {
                  var e = "",
                    s = i.ia.Ga(this.X.element),
                    _r8 = s.find("#wdr-data-sheet");
                  for (e += a.$.bind("table{width:100%;border-collapse:collapse;{0}}\n", t.G.N.C.Eb.gy(s, ["font-family", "font-size"])), e += a.$.bind("caption{{0}}\n", t.G.N.C.Eb.mg(t.G.N.C.aa.eB, s)), e += a.$.bind("td{white-space:nowrap;{0}}\n", a.Wc().Yu ? "" : "border: 1px solid #eee;"), e += a.$.bind(".cell{{0}}\n", t.G.N.C.Eb.mg(t.G.N.C.aa.Hc, _r8)), e += a.$.bind(".totalCell{{0}}\n", t.G.N.C.Eb.mg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.vt, _r8)), e += a.$.bind(".rowHeaderCell{{0}}\n", t.G.N.C.Eb.mg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.Ve + " " + t.G.N.C.aa.ql, s)), e += a.$.bind(".columnHeaderCell{{0}}\n", t.G.N.C.Eb.mg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.Ve + " " + t.G.N.C.aa.Cq, s)), e += a.$.bind(".filterHeaderCell{{0}}\n", t.G.N.C.Eb.mg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.Ve + " " + t.G.N.C.aa.gj, s)), _r8 = 1; 20 >= _r8; _r8++) e += a.$.bind(".level{0}{{1}}\n", _r8, t.G.N.C.Eb.mg(t.G.N.C.aa.ql + " " + t.G.N.C.aa.We + _r8, s, ["padding-left"]));
                  for (_r8 = 0; _r8 < this.Wj.length; _r8++) e += a.$.bind(".{0}{{1}}\n", this.Wj[_r8], t.G.N.C.Eb.mg(this.Wj[_r8], s));
                  return (e = (e + ".page:not(:last-child), svg { page-break-after: always; }").replace(/background-color:rgb\(33, 33, 33\)/g, "background-color:rgb(255, 255, 255)")).replace(/background-color:rgb\(66, 66, 66\)/g, "background-color:rgb(247, 247, 247)");
                }
              }], [{
                key: "V",
                value: function V() {
                  return null == r.Nc && (r.Nc = new r()), r.Nc;
                }
              }, {
                key: "la",
                value: function la() {
                  r.Nc = null;
                }
              }]);
              return r;
            }();
            s.XA = r;
          }((e = t.model || (t.model = {})).ao || (e.ao = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function () {
              function e() {
                _classCallCheck(this, e);
              }
              _createClass(e, null, [{
                key: "Za",
                value: function Za(t) {
                  var i = new e();
                  return null != t && (null != t.header && (i.Hj = t.header), null != t.footer && (i.yp = t.footer)), i;
                }
              }]);
              return e;
            }();
            t.qI = e;
          }((e = t.model || (t.model = {})).ao || (e.ao = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.model || (t.model = {}), function (e) {
            var i = /*#__PURE__*/function () {
              function i() {
                _classCallCheck(this, i);
                this.tc = {
                  configuratorActive: !1,
                  configuratorOpened: !1,
                  configuratorButton: !0,
                  gridType: t.G.N.Ue.xo,
                  gridTitle: "",
                  showFilter: !0,
                  showDefaultSlice: !0,
                  showEmptyData: !0,
                  showAggregations: !0,
                  showHierarchyCaptions: !0,
                  drillthroughMaxRows: 1e3,
                  showHeaders: !0,
                  showReportFiltersArea: !0,
                  showExtraTotalLabels: !1,
                  drillThrough: !0,
                  showDrillThroughConfigurator: !0,
                  sorting: "on",
                  showHierarchies: !0,
                  saveAllFormats: !1,
                  showTotals: "on",
                  showGrandTotals: "on",
                  showAutoCalculationBar: !0,
                  datePattern: "dd/MM/yyyy",
                  dateTimePattern: "dd/MM/yyyy HH:mm:ss",
                  showCalculatedValuesButton: !0,
                  selectEmptyCells: !0,
                  defaultHierarchySortName: t.u.i.ba.ub,
                  showAggregationLabels: !0,
                  grandTotalsPosition: "top"
                };
              }
              _createClass(i, [{
                key: "Ra",
                value: function Ra(t, e) {
                  this[t] = e;
                }
              }, {
                key: "qa",
                value: function qa(t) {
                  return this[t];
                }
              }, {
                key: "iq",
                value: function iq() {
                  for (var t in this.tc) this[t] = this.tc[t];
                }
              }, {
                key: "JV",
                value: function JV() {
                  if (a.U(void 0)) for (e in this.tc) (this[e] == this.tc[e] || "object" == typeof this[e] && a.ee.je(this[e]) && a.ee.je(this.tc[e])) && (this[e] = void 0);else for (var t = 0; t < (void 0).length; t++) {
                    var e = (void 0)[t];
                    null != this[e] && (this[e] == this.tc[e] || "object" == typeof this[e] && a.ee.je(this[e]) && a.ee.je(this.tc[e])) && (this[e] = void 0);
                  }
                }
              }, {
                key: "Sa",
                value: function Sa() {
                  var e = {},
                    _i22 = {};
                  return this.gridType === t.G.N.Ue.xo ? _i22.type = t.G.N.Ue.xo : this.gridType === t.G.N.Ue.vq ? _i22.type = t.G.N.Ue.vq : this.gridType === t.G.N.Ue.Ih && (_i22.type = t.G.N.Ue.Ih), null != this.gridTitle && (_i22.title = this.gridTitle), null != this.showFilter && (_i22.showFilter = this.showFilter), null != this.showHeaders && (_i22.showHeaders = this.showHeaders), null != this.showTotals && (_i22.showTotals = this.showTotals), null != this.showGrandTotals && (_i22.showGrandTotals = this.showGrandTotals), null != this.grandTotalsPosition && (_i22.grandTotalsPosition = this.grandTotalsPosition), null != this.showExtraTotalLabels && (_i22.showExtraTotalLabels = this.showExtraTotalLabels), null != this.showHierarchies && (_i22.showHierarchies = this.showHierarchies), null != this.showHierarchyCaptions && (_i22.showHierarchyCaptions = this.showHierarchyCaptions), null != this.drillthroughMaxRows && (_i22.drillthroughMaxRows = this.drillthroughMaxRows), null != this.showReportFiltersArea && (_i22.showReportFiltersArea = this.showReportFiltersArea), null != this.showAutoCalculationBar && (_i22.showAutoCalculationBar = this.showAutoCalculationBar), a.ee.je(_i22) || (e.grid = _i22), null != this.configuratorActive && (e.configuratorActive = this.configuratorActive), null != this.configuratorButton && (e.configuratorButton = this.configuratorButton), null != this.showAggregations && (e.showAggregations = this.showAggregations), null != this.showCalculatedValuesButton && (e.showCalculatedValuesButton = this.showCalculatedValuesButton), null != this.drillThrough && (e.drillThrough = this.drillThrough), null != this.showDrillThroughConfigurator && (e.showDrillThroughConfigurator = this.showDrillThroughConfigurator), null != this.sorting && (e.sorting = this.sorting), null != this.datePattern && (e.datePattern = this.datePattern), null != this.dateTimePattern && (e.dateTimePattern = this.dateTimePattern), null != this.saveAllFormats && (e.saveAllFormats = this.saveAllFormats), null != this.showDefaultSlice && (e.showDefaultSlice = this.showDefaultSlice), null != this.showEmptyData && (e.showEmptyData = this.showEmptyData), null != this.defaultHierarchySortName && (e.defaultHierarchySortName = this.defaultHierarchySortName), null != this.selectEmptyCells && (e.selectEmptyCells = this.selectEmptyCells), null != this.showAggregationLabels && (e.showAggregationLabels = this.showAggregationLabels), e;
                }
              }, {
                key: "gv",
                value: function gv(t) {
                  for (var e in t) this.tc.hasOwnProperty(e) && null != t[e] && (this[e] = t[e]);
                }
              }], [{
                key: "Za",
                value: function Za(t) {
                  var e = new i();
                  return null == t || (null != t.options && (t = t.options), t instanceof i || (t = i.Hh(t)), null != t.configuratorActive && e.Ra("configuratorActive", t.configuratorActive), null != t.configuratorButton && e.Ra("configuratorButton", t.configuratorButton), null != t.gridTitle && e.Ra("gridTitle", t.gridTitle), null != t.gridType && e.Ra("gridType", t.gridType), null != t.showFilter && e.Ra("showFilter", t.showFilter), null != t.showDefaultSlice && e.Ra("showDefaultSlice", t.showDefaultSlice), null != t.showEmptyData && e.Ra("showEmptyData", t.showEmptyData), null != t.showAggregations && e.Ra("showAggregations", t.showAggregations), null != t.showHierarchyCaptions && e.Ra("showHierarchyCaptions", t.showHierarchyCaptions), null != t.showHeaders && e.Ra("showHeaders", t.showHeaders), null != t.showReportFiltersArea && e.Ra("showReportFiltersArea", t.showReportFiltersArea), null != t.showExtraTotalLabels && e.Ra("showExtraTotalLabels", t.showExtraTotalLabels), null != t.drillThrough && e.Ra("drillThrough", t.drillThrough), null != t.showDrillThroughConfigurator && e.Ra("showDrillThroughConfigurator", t.showDrillThroughConfigurator), null != t.sorting && (e.Ra("sorting", t.sorting), "true" == e.qa("sorting").toString().toLowerCase() && e.Ra("sorting", "on"), "false" == e.qa("sorting").toString().toLowerCase() && e.Ra("sorting", "off")), null != t.showHierarchies && e.Ra("showHierarchies", t.showHierarchies), null != t.saveAllFormats && e.Ra("saveAllFormats", t.saveAllFormats), null != t.showTotals && (e.Ra("showTotals", t.showTotals), "true" == e.qa("showTotals").toString().toLowerCase() && e.Ra("showTotals", "on"), "false" == e.qa("showTotals").toString().toLowerCase() && e.Ra("showTotals", "off")), null != t.showGrandTotals && (e.Ra("showGrandTotals", t.showGrandTotals), "true" == e.qa("showGrandTotals").toString().toLowerCase() && e.Ra("showGrandTotals", "on"), "false" == e.qa("showGrandTotals").toString().toLowerCase() && e.Ra("showGrandTotals", "off")), null != t.showAutoCalculationBar && e.Ra("showAutoCalculationBar", t.showAutoCalculationBar), null != t.datePattern && e.Ra("datePattern", t.datePattern), null != t.dateTimePattern && e.Ra("dateTimePattern", t.dateTimePattern), null != t.showCalculatedValuesButton && e.Ra("showCalculatedValuesButton", t.showCalculatedValuesButton), null != t.selectEmptyCells && e.Ra("selectEmptyCells", t.selectEmptyCells), null != t.defaultHierarchySortName && e.Ra("defaultHierarchySortName", t.defaultHierarchySortName), null != t.showAggregationLabels && e.Ra("showAggregationLabels", t.showAggregationLabels), null != t.grandTotalsPosition && e.Ra("grandTotalsPosition", t.grandTotalsPosition)), e;
                }
              }, {
                key: "Hh",
                value: function Hh(t) {
                  var e = {};
                  return null == t || (null != t.configuratorActive && (e.configuratorActive = t.configuratorActive), null != t.configuratorButton && (e.configuratorButton = t.configuratorButton), null != t.showAggregations && (e.showAggregations = t.showAggregations), null != t.showCalculatedValuesButton && (e.showCalculatedValuesButton = t.showCalculatedValuesButton), null != t.drillThrough && (e.drillThrough = t.drillThrough), null != t.showDrillThroughConfigurator && (e.showDrillThroughConfigurator = t.showDrillThroughConfigurator), null != t.sorting && (e.sorting = t.sorting), null != t.datePattern && (e.datePattern = t.datePattern), null != t.dateTimePattern && (e.dateTimePattern = t.dateTimePattern), null != t.saveAllFormats && (e.saveAllFormats = t.saveAllFormats), null != t.showDefaultSlice && (e.showDefaultSlice = t.showDefaultSlice), null != t.showEmptyData && (e.showEmptyData = t.showEmptyData), null != t.defaultHierarchySortName && (e.defaultHierarchySortName = t.defaultHierarchySortName), null != t.selectEmptyCells && (e.selectEmptyCells = t.selectEmptyCells), null != t.showAggregationLabels && (e.showAggregationLabels = t.showAggregationLabels), null != t.classicView && (e.classicView = t.classicView), null != t.flatView && (e.flatView = t.flatView), null != t.gridType && (e.gridType = t.gridType), null != t.gridTitle && (e.gridTitle = t.gridTitle), null != t.showFilter && (e.showFilter = t.showFilter), null != t.showHeaders && (e.showHeaders = t.showHeaders), null != t.showTotals && (e.showTotals = t.showTotals), null != t.showGrandTotals && (e.showGrandTotals = t.showGrandTotals), null != t.showAutoCalculationBar && (e.showAutoCalculationBar = t.showAutoCalculationBar), null != t.grandTotalsPosition && (e.grandTotalsPosition = t.grandTotalsPosition), null != t.showExtraTotalLabels && (e.showExtraTotalLabels = t.showExtraTotalLabels), null != t.showHierarchies && (e.showHierarchies = t.showHierarchies), null != t.showHierarchyCaptions && (e.showHierarchyCaptions = t.showHierarchyCaptions), null != t.drillthroughMaxRows && (e.drillthroughMaxRows = t.drillthroughMaxRows), null != t.showReportFiltersArea && (e.showReportFiltersArea = t.showReportFiltersArea), null != t.grid && (null != (t = t.grid).type && (e.gridType = t.type), null != t.title && (e.gridTitle = t.title), null != t.showFilter && (e.showFilter = t.showFilter), null != t.showHeaders && (e.showHeaders = t.showHeaders), null != t.showAutoCalculationBar && (e.showAutoCalculationBar = t.showAutoCalculationBar), null != t.showTotals && (e.showTotals = t.showTotals, "true" == e.showTotals.toString().toLowerCase() && (e.showTotals = "on"), "false" == e.showTotals.toString().toLowerCase() && (e.showTotals = "off")), null != t.showGrandTotals && (e.showGrandTotals = t.showGrandTotals, "true" == e.showGrandTotals.toString().toLowerCase() && (e.showGrandTotals = "on"), "false" == e.showGrandTotals.toString().toLowerCase() && (e.showGrandTotals = "off")), null != t.grandTotalsPosition && (e.grandTotalsPosition = t.grandTotalsPosition), null != t.showExtraTotalLabels && (e.showExtraTotalLabels = t.showExtraTotalLabels), null != t.showHierarchies && (e.showHierarchies = t.showHierarchies), null != t.showHierarchyCaptions && (e.showHierarchyCaptions = t.showHierarchyCaptions), null != t.drillthroughMaxRows && (e.drillthroughMaxRows = t.drillthroughMaxRows), null != t.showReportFiltersArea && (e.showReportFiltersArea = t.showReportFiltersArea))), e;
                }
              }]);
              return i;
            }();
            e.ij = i;
          }((i = e.A || (e.A = {})).C || (i.C = {}));
        }(r || (r = {})), function (t) {
          var i;
          !function (s) {
            var r = /*#__PURE__*/function (_e$Od13) {
              _inherits(r, _e$Od13);
              var _super44 = _createSuper(r);
              function r() {
                var _this59;
                _classCallCheck(this, r);
                if (_this59 = _super44.call(this), r.tc = new s.C.ij(), r.tc.iq(), r.A = new s.C.ij(), r.instance) throw Error("Singleton");
                return _possibleConstructorReturn(_this59);
              }
              _createClass(r, null, [{
                key: "V",
                value: function V() {
                  return a.U(r.instance) && (r.instance = new r()), r.instance;
                }
              }, {
                key: "la",
                value: function la() {
                  r.Yq.tc = null, r.Yq = null, r.A = null, r.tc = null, r.instance = null;
                }
              }, {
                key: "J2",
                value: function J2(t) {
                  r.Yq = t;
                }
              }, {
                key: "Cp",
                value: function Cp() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  var i = new s.C.ij();
                  return t && i.gv(r.tc), e && i.gv(r.Yq), i.gv(r.A), t || i.JV(), i;
                }
              }, {
                key: "clear",
                value: function clear() {
                  this.A = new s.C.ij();
                }
              }, {
                key: "Uj",
                value: function Uj(e) {
                  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                  (a.U(r.A) || i) && (i = r.Xl, r.A = new s.C.ij(), r.A.Ra("configuratorOpened", i)), e = s.C.ij.Hh(e), i = !1, r.aD = !0;
                  var n,
                    o = r.Cp(!0, !0);
                  for (n in e) if (null != o[n] && e[n] != o[n] && (i = !0, r.Zp(n))) {
                    r.zm = !0;
                    break;
                  }
                  r.A.gv(e), t.u.oa.de.Yv = r.oL, r.aD = !1, i && r.Pb();
                }
              }, {
                key: "Zp",
                value: function Zp(t) {
                  return -1 < r.dU.indexOf(t);
                }
              }, {
                key: "qa",
                value: function qa(t) {
                  return null != r.A[t] ? r.A[t] : r.Yq && null != r.Yq[t] ? r.Yq[t] : r.tc[t];
                }
              }, {
                key: "Xl",
                get: function get() {
                  return r.A.qa("configuratorOpened");
                },
                set: function set(t) {
                  r.A.Ra("configuratorOpened", t);
                }
              }, {
                key: "GC",
                get: function get() {
                  return r.qa("configuratorActive");
                },
                set: function set(t) {
                  if (r.A.qa("configuratorActive") !== t) {
                    var _e52 = !a.U(r.A.qa("configuratorActive"));
                    r.A.Ra("configuratorActive", t), _e52 && r.Pb();
                  }
                }
              }, {
                key: "HC",
                get: function get() {
                  return r.qa("configuratorButton");
                },
                set: function set(t) {
                  if (r.A.qa("configuratorButton") !== t) {
                    var _e53 = !a.U(r.A.qa("configuratorButton"));
                    r.A.Ra("configuratorButton", t), _e53 && r.Pb();
                  }
                }
              }, {
                key: "ph",
                get: function get() {
                  return r.qa("gridType") == t.G.N.Ue.vq;
                },
                set: function set(e) {
                  r.A.qa("gridType") != t.G.N.Ue.vq && (e = !a.U(r.A.qa("gridType")), r.A.Ra("gridType", t.G.N.Ue.vq), r.zm = r.Zp("gridType"), e && r.Pb());
                }
              }, {
                key: "Dc",
                get: function get() {
                  return r.qa("gridType") == t.G.N.Ue.Ih;
                },
                set: function set(e) {
                  if (1 == e && r.A.qa("gridType") != t.G.N.Ue.Ih) {
                    var _e54 = !a.U(r.A.qa("gridType"));
                    r.A.Ra("gridType", t.G.N.Ue.Ih), r.zm = r.Zp("gridType"), _e54 && r.Pb();
                  }
                  0 == e && r.A.qa("gridType") == t.G.N.Ue.Ih && (r.A.Ra("gridType", t.G.N.Ue.xo), r.zm = r.Zp("gridType"), r.Pb());
                }
              }, {
                key: "TM",
                get: function get() {
                  return r.qa("gridType");
                },
                set: function set(t) {
                  if (r.A.qa("gridType") !== t) {
                    var _e55 = !a.U(r.A.qa("gridType"));
                    r.A.Ra("gridType", t), _e55 && r.Pb();
                  }
                }
              }, {
                key: "ng",
                get: function get() {
                  return r.qa("gridTitle");
                },
                set: function set(t) {
                  if (r.A.qa("gridTitle") !== t) {
                    var _e56 = !a.U(r.A.qa("gridTitle"));
                    r.A.Ra("gridTitle", t), _e56 && r.Pb();
                  }
                }
              }, {
                key: "Ks",
                get: function get() {
                  return r.qa("showFilter");
                },
                set: function set(t) {
                  if (r.A.qa("showFilter") !== t) {
                    var _e57 = !a.U(r.A.qa("showFilter"));
                    r.A.Ra("showFilter", t), _e57 && r.Pb();
                  }
                }
              }, {
                key: "dP",
                get: function get() {
                  return r.qa("showDefaultSlice");
                },
                set: function set(t) {
                  if (r.A.qa("showDefaultSlice") !== t) {
                    var _e58 = !a.U(r.A.qa("showDefaultSlice"));
                    r.A.Ra("showDefaultSlice", t), _e58 && r.Pb();
                  }
                }
              }, {
                key: "gP",
                get: function get() {
                  return r.qa("showEmptyData");
                },
                set: function set(t) {
                  if (r.A.qa("showEmptyData") !== t) {
                    var _e59 = !a.U(r.A.qa("showEmptyData"));
                    r.A.Ra("showEmptyData", t), _e59 && r.Pb();
                  }
                }
              }, {
                key: "Wf",
                get: function get() {
                  return r.qa("showAggregations");
                },
                set: function set(t) {
                  if (r.A.qa("showAggregations") !== t) {
                    var _e60 = !a.U(r.A.qa("showAggregations"));
                    r.A.Ra("showAggregations", t), _e60 && r.Pb();
                  }
                }
              }, {
                key: "Vj",
                get: function get() {
                  return r.qa("showHierarchyCaptions");
                },
                set: function set(t) {
                  if (r.A.qa("showHierarchyCaptions") !== t) {
                    var _e61 = !a.U(r.A.qa("showHierarchyCaptions"));
                    r.A.Ra("showHierarchyCaptions", t), _e61 && r.Pb();
                  }
                }
              }, {
                key: "Js",
                get: function get() {
                  return r.qa("showExtraTotalLabels");
                },
                set: function set(t) {
                  if (r.A.qa("showExtraTotalLabels") !== t) {
                    var _e62 = !a.U(r.A.qa("showExtraTotalLabels"));
                    r.A.Ra("showExtraTotalLabels", t), _e62 && r.Pb();
                  }
                }
              }, {
                key: "Re",
                get: function get() {
                  return r.qa("showHeaders");
                },
                set: function set(t) {
                  if (r.A.qa("showHeaders") !== t) {
                    var _e63 = !a.U(r.A.qa("showHeaders"));
                    r.A.Ra("showHeaders", t), _e63 && r.Pb();
                  }
                }
              }, {
                key: "Fe",
                get: function get() {
                  return r.qa("sorting");
                },
                set: function set(t) {
                  if (r.A.qa("sorting") !== t) {
                    var _e64 = !a.U(r.A.qa("sorting"));
                    r.A.Ra("sorting", t), _e64 && r.Pb();
                  }
                }
              }, {
                key: "yj",
                get: function get() {
                  return r.qa("drillThrough");
                },
                set: function set(t) {
                  if (r.A.qa("drillThrough") !== t) {
                    var _e65 = !a.U(r.A.qa("drillThrough"));
                    r.A.Ra("drillThrough", t), _e65 && r.Pb();
                  }
                }
              }, {
                key: "fP",
                get: function get() {
                  return r.qa("showDrillThroughConfigurator");
                },
                set: function set(t) {
                  if (r.A.qa("showDrillThroughConfigurator") !== t) {
                    var _e66 = !a.U(r.A.qa("showDrillThroughConfigurator"));
                    r.A.Ra("showDrillThroughConfigurator", t), _e66 && r.Pb();
                  }
                }
              }, {
                key: "Av",
                get: function get() {
                  return r.qa("showHierarchies");
                },
                set: function set(t) {
                  if (r.A.qa("showHierarchies") !== t) {
                    var _e67 = !a.U(r.A.qa("showHierarchies"));
                    r.A.Ra("showHierarchies", t), _e67 && r.Pb();
                  }
                }
              }, {
                key: "r2",
                get: function get() {
                  return r.qa("saveAllFormats");
                },
                set: function set(t) {
                  if (r.A.qa("saveAllFormats") !== t) {
                    var _e68 = !a.U(r.A.qa("saveAllFormats"));
                    r.A.Ra("saveAllFormats", t), _e68 && r.Pb();
                  }
                }
              }, {
                key: "cj",
                get: function get() {
                  return r.qa("showTotals");
                },
                set: function set(t) {
                  if (r.A.qa("showTotals") !== t) {
                    var _e69 = !a.U(r.A.qa("showTotals"));
                    r.A.Ra("showTotals", t), r.zm = r.Zp("showTotals"), _e69 && r.Pb();
                  }
                }
              }, {
                key: "aP",
                get: function get() {
                  return r.qa("showAutoCalculationBar");
                },
                set: function set(t) {
                  if (r.A.qa("showAutoCalculationBar") !== t) {
                    var _e70 = !a.U(r.A.qa("showAutoCalculationBar"));
                    r.A.Ra("showAutoCalculationBar", t), _e70 && r.Pb();
                  }
                }
              }, {
                key: "xc",
                get: function get() {
                  return r.qa("showGrandTotals");
                },
                set: function set(t) {
                  if (r.A.qa("showGrandTotals") !== t) {
                    var _e71 = !a.U(r.A.qa("showGrandTotals"));
                    r.A.Ra("showGrandTotals", t), r.zm = r.Zp("showGrandTotals"), _e71 && r.Pb();
                  }
                }
              }, {
                key: "Gk",
                get: function get() {
                  return r.qa("datePattern");
                },
                set: function set(t) {
                  if (r.A.qa("datePattern") !== t) {
                    var _e72 = !a.U(r.A.qa("datePattern"));
                    r.A.Ra("datePattern", t), _e72 && r.Pb();
                  }
                }
              }, {
                key: "cm",
                get: function get() {
                  return r.qa("dateTimePattern");
                },
                set: function set(t) {
                  if (r.A.qa("dateTimePattern") !== t) {
                    var _e73 = !a.U(r.A.qa("dateTimePattern"));
                    r.A.Ra("dateTimePattern", t), _e73 && r.Pb();
                  }
                }
              }, {
                key: "bP",
                get: function get() {
                  return r.qa("showCalculatedValuesButton");
                },
                set: function set(t) {
                  if (r.A.qa("showCalculatedValuesButton") !== t) {
                    var _e74 = !a.U(r.A.qa("showCalculatedValuesButton"));
                    r.A.Ra("showCalculatedValuesButton", t), _e74 && r.Pb();
                  }
                }
              }, {
                key: "oL",
                get: function get() {
                  return r.qa("defaultHierarchySortName");
                },
                set: function set(t) {
                  if (r.A.qa("defaultHierarchySortName") !== t) {
                    var _e75 = !a.U(r.A.qa("defaultHierarchySortName"));
                    r.A.Ra("defaultHierarchySortName", t), _e75 && r.Pb();
                  }
                }
              }, {
                key: "bA",
                get: function get() {
                  return r.qa("showAggregationLabels");
                },
                set: function set(t) {
                  if (r.A.qa("showAggregationLabels") !== t) {
                    var _e76 = !a.U(r.A.qa("showAggregationLabels"));
                    r.A.Ra("showAggregationLabels", t), _e76 && r.Pb();
                  }
                }
              }, {
                key: "Yr",
                get: function get() {
                  return r.qa("grandTotalsPosition");
                },
                set: function set(t) {
                  if (r.A.qa("grandTotalsPosition") !== t) {
                    var _e77 = !a.U(r.A.qa("grandTotalsPosition"));
                    r.A.Ra("grandTotalsPosition", t), r.zm = r.Zp("grandTotalsPosition"), _e77 && r.Pb();
                  }
                }
              }, {
                key: "iP",
                get: function get() {
                  return r.qa("showReportFiltersArea");
                },
                set: function set(t) {
                  if (r.A.qa("showReportFiltersArea") !== t) {
                    var _e78 = !a.U(r.A.qa("showReportFiltersArea"));
                    r.A.Ra("showReportFiltersArea", t), _e78 && r.Pb();
                  }
                }
              }, {
                key: "Pb",
                value: function Pb() {
                  r.aD || r.V().na(new e.ga(i.sb.kc.lj));
                }
              }]);
              return r;
            }(e.Od);
            r.zm = !1, r.aD = !1, r.dU = ["gridType", "showTotals", "showGrandTotals", "grandTotalsPosition"], r.mL = "dd/MM/yyyy", s.P = r;
          }((i = t.model || (t.model = {})).A || (i.A = {}));
        }(r || (r = {})), function (t) {
          var i;
          !function (t) {
            var s = /*#__PURE__*/function (_e$Od14) {
              _inherits(s, _e$Od14);
              var _super45 = _createSuper(s);
              function s() {
                var _this60;
                _classCallCheck(this, s);
                if (_this60 = _super45.call(this), null != s.instance) throw Error("Singleton");
                return _possibleConstructorReturn(_this60);
              }
              _createClass(s, null, [{
                key: "V",
                value: function V() {
                  return null == s.instance && (s.instance = new s()), s.instance;
                }
              }, {
                key: "la",
                value: function la() {
                  s.uc = null, s.instance = null;
                }
              }, {
                key: "add",
                value: function add(t) {
                  null != t && (s.uc.Ea(t.id, t), this.Pb());
                }
              }, {
                key: "get",
                value: function get(t) {
                  return s.uc.getItem(t);
                }
              }, {
                key: "remove",
                value: function remove(t) {
                  s.uc.removeItem(t), this.Pb();
                }
              }, {
                key: "sF",
                value: function sF() {
                  s.uc = new a.ma(), this.Pb();
                }
              }, {
                key: "MY",
                value: function MY() {
                  for (var t = [], e = 0; e < s.uc.length; e++) {
                    var i = s.uc.F(e);
                    i.pE || t.push(i.Sa());
                  }
                  return t;
                }
              }, {
                key: "Pb",
                value: function Pb() {
                  s.V().Oa(i.sb.kc.lj);
                }
              }]);
              return s;
            }(e.Od);
            s.uc = new a.ma(), t.hi = s;
          }((i = t.model || (t.model = {})).pf || (i.pf = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.model || (t.model = {}), function (e) {
            var i = /*#__PURE__*/function () {
              function i() {
                _classCallCheck(this, i);
                this.id = "", this.zk = this.Xk = -1, this.Jc = this.lb = this.ke = this.measure = "", this.Pe = [];
              }
              _createClass(i, [{
                key: "pE",
                get: function get() {
                  return -1 < this.Jc.toLowerCase().indexOf(t.u.i.$a.Ew) || -1 < this.Jc.toLowerCase().indexOf(t.u.i.$a.Fw);
                }
              }, {
                key: "Sa",
                value: function Sa() {
                  var t = {};
                  return t.id = this.id, t.row = this.Xk, t.column = this.zk, void 0 !== this.Ri && (t.isTotal = this.Ri), t.measure = this.measure, t.member = this.ke, t.hierarchy = this.lb, t.formula = this.Jc, null != this.format && (t.format = this.format.Sa(), t.formatCSS = this.format.toString()), t;
                }
              }], [{
                key: "Sa",
                value: function Sa(t) {
                  return t.Sa();
                }
              }, {
                key: "Za",
                value: function Za(t) {
                  var e = new i();
                  return e.id = null != t.id ? t.id : a.$.ky(), null != t.row && (e.Xk = t.row), null != t.column && (e.zk = t.column), null != t.isTotal && (1 != t.isTotal && 1 != t.isTotal || (e.Ri = !0), 0 != t.isTotal && 0 != t.isTotal || (e.Ri = !1)), null != t.measure && (e.measure = t.measure), e.Jc = t.formula, null != t.trueStyle && null == t.format && (t.format = t.trueStyle), null != t.format && (e.format = "string" == typeof t.format ? s.hy(t.format) : s.Za(t.format)), t = new a.mt(), e.Pe = t.parse(e.Jc), null == e.Pe ? null : e;
                }
              }]);
              return i;
            }();
            e.wA = i;
            var s = /*#__PURE__*/function () {
              function s() {
                _classCallCheck(this, s);
              }
              _createClass(s, [{
                key: "Sa",
                value: function Sa() {
                  var t = {};
                  return null != this.backgroundColor && (t.backgroundColor = this.backgroundColor), null != this.color && (t.color = this.color), null != this.fontFamily && (t.fontFamily = this.fontFamily), null != this.fontSize && (t.fontSize = this.fontSize), null != this.fontStyle && (t.fontStyle = this.fontStyle), null != this.fontWeight && (t.fontWeight = this.fontWeight), null != this.padding && (t.padding = this.padding), null != this.textAlign && (t.textAlign = this.textAlign), null != this.textIndent && (t.textIndent = this.textIndent), t;
                }
              }, {
                key: "AP",
                value: function AP() {
                  var t = {};
                  return null != this.backgroundColor && (t["background-color"] = this.backgroundColor), null != this.color && (t.color = this.color), null != this.fontFamily && (t["font-family"] = this.fontFamily), null != this.fontSize && (t["font-size"] = this.fontSize), null != this.fontStyle && (t["font-style"] = this.fontStyle), null != this.fontWeight && (t["font-weight"] = this.fontWeight), null != this.padding && (t.padding = this.padding), null != this.textAlign && (t["text-align"] = this.textAlign), null != this.textIndent && (t["text-indent"] = this.textIndent), t;
                }
              }, {
                key: "toString",
                value: function toString() {
                  var t,
                    e = "",
                    i = this.AP();
                  for (t in i) e += t + ":" + i[t] + ";";
                  return e;
                }
              }], [{
                key: "Za",
                value: function Za(t) {
                  var e = new s();
                  return null == t || (null != t.backgroundColor && (e.backgroundColor = s.color(t.backgroundColor)), null != t.color && (e.color = s.color(t.color)), null != t.fontFamily && (e.fontFamily = t.fontFamily), null != t.fontSize && (e.fontSize = s.size(t.fontSize)), null != t.italic && t.italic && (e.fontStyle = "italic"), null != t.fontStyle && (e.fontStyle = t.fontStyle), null != t.bold && t.bold && (e.fontWeight = "bold"), null != t.fontWeight && (e.fontWeight = t.fontWeight), null != t.padding && (e.padding = s.size(Math.round(1.5 * t.padding))), null != t.textAlign && (e.textAlign = t.textAlign), null != t.textIndent && (e.textIndent = s.size(t.textIndent))), e;
                }
              }, {
                key: "hy",
                value: function hy(t) {
                  var e = {};
                  if (null != (t = t.split(";"))) for (var i = 0; i < t.length; i++) {
                    var r = t[i].split(":")[0];
                    "" != r && (e[r] = t[i].split(":")[1]);
                  }
                  return s.Za(e);
                }
              }, {
                key: "color",
                value: function color(t) {
                  return t.replace("0x", "#");
                }
              }, {
                key: "size",
                value: function size(t) {
                  return "number" == typeof t ? t + "px" : "string" == typeof t && 0 > t.indexOf("px") ? t.trim() + "px" : t;
                }
              }]);
              return s;
            }();
            e.v4 = s;
          }((i = e.pf || (e.pf = {})).C || (i.C = {}));
        }(r || (r = {})), function (t) {
          var i;
          !function (s) {
            var r = /*#__PURE__*/function (_e$Od15) {
              _inherits(r, _e$Od15);
              var _super46 = _createSuper(r);
              function r() {
                var _this61;
                _classCallCheck(this, r);
                if (_this61 = _super46.call(this), null != r.instance) throw Error("Singleton");
                return _possibleConstructorReturn(_this61);
              }
              _createClass(r, null, [{
                key: "V",
                value: function V() {
                  return null == r.instance && (r.instance = new r()), r.instance;
                }
              }, {
                key: "la",
                value: function la() {
                  r.le = null, r.Zd = null, r.$d = null, r.Am = null, r.gx = null, r.gr = null, r.Rd = null, r.Sd = null, r.Wl = null, r.Nw = null, r.Rq = null, r.instance = null;
                }
              }, {
                key: "zO",
                get: function get() {
                  return this.gx = r.FP(t.u.i.da.Ka);
                }
              }, {
                key: "QK",
                get: function get() {
                  return this.Nw = r.FP(t.u.i.da.rb);
                }
              }, {
                key: "clear",
                value: function clear() {
                  r.$d = {}, r.Sd = {}, r.gr = {}, r.gx = {}, r.Rq = {}, r.Nw = {}, r.Am = {}, r.Wl = {}, r.Zd = {}, r.Rd = {}, r.le = {};
                }
              }, {
                key: "xK",
                value: function xK(t, e, i, s, n, a, o) {
                  r.DK(t) || r.DK(e) ? (r.gr = r.UK(t), r.Rq = r.UK(e), r.lO()) : (r.EK(t) || r.EK(e)) && (r.gr = t, r.Rq = e, r.lO()), r.Am = i, r.Wl = s, r.Zd = n, r.Rd = a, r.le = o;
                }
              }, {
                key: "lO",
                value: function lO() {
                  i.yb.V().Pa.xs == i.sb.kc.He ? this.ns() : t.u.Ja.V().addEventListener(t.u.Uc.Ye, r.ns, 1);
                }
              }, {
                key: "DK",
                value: function DK(t) {
                  var e,
                    i = /[A-Za-z]+/;
                  for (e in t) if (-1 < t[e].toString().search(i)) return !0;
                  return !1;
                }
              }, {
                key: "EK",
                value: function EK(t) {
                  var e,
                    i = /[A-Za-z]+/;
                  for (e in t) if (-1 < e.toString().search(i)) return !0;
                  return !1;
                }
              }, {
                key: "UK",
                value: function UK(t) {
                  var e = {};
                  if (null != t) for (var i in t) {
                    var s = t[i];
                    if (s instanceof Array && 0 < s.length) {
                      var _r9 = parseInt(s.pop());
                      e[s.toString()] = _r9;
                    }
                  }
                  return e;
                }
              }, {
                key: "ns",
                value: function ns() {
                  t.u.Ja.V().removeEventListener(t.u.Uc.Ye, r.ns), r.$d = r.cM(t.u.i.da.Ka), r.gr = {}, r.Sd = r.cM(t.u.i.da.rb), r.Rq = {};
                }
              }, {
                key: "cM",
                value: function cM(e) {
                  var s,
                    n = {},
                    a = e == t.u.i.da.Ka ? r.gr : r.Rq;
                  for (s in a) {
                    var o = s.split(","),
                      h = a[s],
                      l = t.u.Ja.V().fa.axes.getItem(e).Ba;
                    if (l && !i.A.P.Dc) {
                      var A = o[o.length - 1];
                      o.splice(o.length - 1, 1);
                    }
                    for (var c = !1, u = [], d = 0; d < o.length; d++) if (i.A.P.Dc) {
                      if (e == t.u.i.da.Ka) u.push(o[d]);else {
                        var f = o[d];
                        if (-1 == (f = t.u.Ja.V().Ua.keys.indexOf(f))) {
                          c = !0;
                          break;
                        }
                        u.push(f);
                      }
                    } else {
                      if (f = o[d], null == (f = (e == t.u.i.da.Ka ? t.u.Ja.V().fa.hc.F(d) : t.u.Ja.V().fa.ed.F(d)).ua.getItem(f))) {
                        c = !0;
                        break;
                      }
                      f.Qc ? u.push("") : u.push(f.ra.toString());
                    }
                    if (!c) {
                      if (l && !i.A.P.Dc) {
                        if (o = t.u.Ja.V().fa.pa.indexOf(A), "" != A && -1 == o) continue;
                        u.push(o);
                      }
                      n[u.toString()] = h;
                    }
                  }
                  return n;
                }
              }, {
                key: "FP",
                value: function FP(e) {
                  var s,
                    n = {},
                    a = e == t.u.i.da.Ka ? r.$d : r.Sd;
                  for (s in a) {
                    var o = s.split(","),
                      h = a[s],
                      l = t.u.Ja.V().fa.axes.getItem(e).Ba;
                    if (l && !i.A.P.Dc) {
                      var A = parseInt(o[o.length - 1]);
                      o.splice(o.length - 1, 1);
                    }
                    for (var c = !1, u = [], d = 0; d < o.length; d++) if (i.A.P.Dc) {
                      if (e == t.u.i.da.Ka) u.push(o[d]);else {
                        var f = "" === o[d] ? 0 : parseInt(o[d]);
                        if (null == (f = t.u.Ja.V().Ua.keys[f])) {
                          c = !0;
                          break;
                        }
                        u.push(f);
                      }
                    } else {
                      f = "" === o[d] ? 0 : parseInt(o[d]);
                      var p = e == t.u.i.da.Ka ? t.u.Ja.V().fa.hc.F(d) : t.u.Ja.V().fa.ed.F(d);
                      if (null == p) {
                        c = !0;
                        break;
                      }
                      if (null == (f = p.ua.F(f))) {
                        c = !0;
                        break;
                      }
                      u.push(f.j);
                    }
                    if (!c) {
                      if (l && !i.A.P.Dc) {
                        if (A >= t.u.Ja.V().fa.pa.length) continue;
                        -1 == A && 1 == t.u.Ja.V().fa.pa.length && (A = 0), u.push(t.u.Ja.V().fa.pa.yd(A));
                      }
                      n[u.toString()] = h;
                    }
                  }
                  return n;
                }
              }]);
              return r;
            }(e.Od);
            r.$d = {}, r.Sd = {}, r.gr = {}, r.gx = {}, r.Rq = {}, r.Nw = {}, r.nq = 0, r.Am = {}, r.Wl = {}, r.Zd = {}, r.Rd = {}, r.le = {}, s.Ib = r;
          }((i = t.model || (t.model = {})).sizes || (i.sizes = {}));
        }(r || (r = {})), function (t) {
          var s;
          !function (r) {
            var n = /*#__PURE__*/function () {
              function n() {
                _classCallCheck(this, n);
              }
              _createClass(n, null, [{
                key: "Uf",
                value: function Uf(i, r, o, h) {
                  var _this62 = this;
                  t.Ta(!0, s.v.g.qw, "...", !0, !0), n.clear(), n.N = i, n.vd = h, n.Hd = o, n.coords = i.X.coords, n.Cc = r, n.Qe = new jsPDF(r.Az, "mm", "a4", !a.Wc().rm), n.Qj = n.tD - 2 * n.ul, n.$p = n.uD - 2 * n.ul, n.XF = n.N.pe + o, n.YF = n.N.md + h, n.rq = {}, n.$l = n.ul;
                  try {
                    n.HK(), n.QD(), n.$K(n.Cc.Hj, n.Cc.yp, function () {
                      return _this62.y0();
                    });
                  } catch (i) {
                    console.error("Export PDF error:", i), t.yc(s.v.g.UA, s.v.g.wb, t.ld.wb), t.Ta(!1), s.yb.V().na(new e.ga(t.Eg.jh)), n.clear();
                  }
                }
              }, {
                key: "$K",
                value: function $K(e, s, r) {
                  try {
                    n.Pi = 0, n.Cj = 0;
                    var a = null == e,
                      o = null == s;
                    if (a && o) r();else {
                      if (!a) {
                        e = (e = e.replace(/##PAGE-NUMBER##/gi, (n.Ch + 1).toString())).replace(/##CURRENT-DATE##/gi, new Date().toLocaleString());
                        var h = new i.ia("div");
                        h.ha("position", "absolute"), h.ha("background", "white"), h.Dm(n.DE(n.uD - 2 * n.pl)), h.Lc(e), t.G.xb.tb.B.prepend(h), html2canvas(h.element).then(function (t) {
                          h.remove(), n.Sy = t, n.Pi = n.bq(t.height), a = !0, o && r();
                        });
                      }
                      if (!o) {
                        s = (s = s.replace(/##PAGE-NUMBER##/gi, (n.Ch + 1).toString())).replace(/##CURRENT-DATE##/gi, new Date().toLocaleString());
                        var l = new i.ia("div");
                        l.ha("position", "absolute"), l.ha("background", "white"), l.Dm(n.DE(n.uD - 2 * n.pl)), l.Lc(s), t.G.xb.tb.B.prepend(l), html2canvas(l.element).then(function (t) {
                          l.remove(), n.dy = t, n.Cj = n.bq(t.height), o = !0, a && r();
                        });
                      }
                    }
                  } catch (t) {
                    n.Sy = null, n.Pi = 0, n.dy = null, n.Cj = 0, r();
                  }
                }
              }, {
                key: "IU",
                value: function IU(t, e) {
                  t.addImage(e, "JPEG", n.pl, n.pl);
                }
              }, {
                key: "GU",
                value: function GU(t, e) {
                  t.addImage(e, "JPEG", n.pl, n.tD - n.Cj - n.pl);
                }
              }, {
                key: "hK",
                value: function hK() {
                  null != n.Sy && n.IU(n.Qe, n.Sy), null != n.dy && n.GU(n.Qe, n.dy), n.Qj = n.tD, n.Qj -= 0 == n.Pi ? n.ul : n.Pi + 2 * n.pl, n.Qj -= 0 == n.Cj ? n.ul : n.Cj + 2 * n.pl, n.$l = 0 == n.Pi ? n.ul : n.Pi + 2 * n.pl;
                }
              }, {
                key: "tD",
                get: function get() {
                  return "portrait" === n.Cc.Az ? 297 : 210;
                }
              }, {
                key: "uD",
                get: function get() {
                  return "portrait" === n.Cc.Az ? 210 : 297;
                }
              }, {
                key: "y0",
                value: function y0() {
                  n.hK(), n.oC(s.A.P.ng, n.Qe), a.Vb(s.A.P.ng) || 0 != n.Ch || (n.$l += 5), n.J1(), a.ni.jp(n.wD, null, null, function () {
                    return n.U0();
                  });
                }
              }, {
                key: "oC",
                value: function oC(t, e) {
                  if (!a.Vb(t)) {
                    e.setTextColor(0, 0, 0), e.setFontStyle("bold"), e.setFontSize(12);
                    var i = 12 * e.getStringUnitWidth(t) / e.internal.scaleFactor;
                    e.text(t, (e.internal.pageSize.width - i) / 2, n.$l);
                  }
                }
              }, {
                key: "QD",
                value: function QD() {
                  var e = n.N.X,
                    s = e.find("#wdr-data-sheet");
                  n.vx = t.G.N.C.Eb.Qg(t.G.N.C.aa.Hc, s), n.WF = t.G.N.C.Eb.Qg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.vt, s), n.AF = t.G.N.C.Eb.Qg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.Ve + " " + t.G.N.C.aa.ql, i.ia.Ga(e.element)), n.EC = t.G.N.C.Eb.Qg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.Ve + " " + t.G.N.C.aa.Cq, i.ia.Ga(e.element)), n.nD = t.G.N.C.Eb.Qg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.Ve + " " + t.G.N.C.aa.gj, i.ia.Ga(e.element));
                }
              }, {
                key: "Or",
                value: function Or(t) {
                  return .9 * (t = (t = n.gO(n.N.X.coords.sf(t))) < n.$p ? t : n.$p - 1);
                }
              }, {
                key: "Es",
                value: function Es(e, i) {
                  return null != e && e.ds && ((e = 0 < e.style.sp.length ? t.G.N.C.Eb.Qg(e.style.ty()) : t.G.N.C.Eb.hy(e.style.Iy())).ks(i), i = e), i.color = i.color || "rgb(0,0,0)", "rgb(33, 33, 33)" == i.backgroundColor && (i.color = "rgb(242, 242, 242)"), i.backgroundColor = i.backgroundColor || "rgb(0,0,0,0)", i.borderColor = i.borderColor || "rgb(222,222,222)", i.fontSize = i.fontSize || 11, i;
                }
              }, {
                key: "By",
                value: function By(e) {
                  return {
                    fontSize: .85 * e.fontSize,
                    fontName: null == e.fontFamily ? n.XQ : e.fontFamily,
                    fontStyle: t.G.N.C.eR.BY(parseFloat(e.fontWeight))
                  };
                }
              }, {
                key: "J1",
                value: function J1() {
                  n.YM = Array(n.YF);
                  for (var e, i, s, r = 0; r < n.YF;) {
                    i = e = 0;
                    for (var a = .8 * Math.max(n.bq(n.coords.Zb(r)), 6); e < n.XF;) {
                      s = n.N.X.Ld(r, e, !0), new t.G.N.C.Eb();
                      var o = n.vx.clone();
                      if (o = n.Es(s, o), null != s) {
                        var h = s.I();
                        "number" == typeof h && (s.value = h, h += "", s.numeric = !0), h = h.replace(/<(?:.|\n)*?>/gi, ""), i = (s = (s = 1 > (s = (1 < (s = n.Qe.splitTextToSize(h, null != n.rq && null != n.rq[e] ? n.rq[e] : n.Or(e), n.By(o))).length ? n.bq(s.length * (11 + 2 * n.Yf) - 2 * n.Yf) : n.bq(11 * s.length - n.Yf)) / a) ? a : (s + 1) * a) > n.Qj / 2 ? (n.Qj - 1) / 2 : s) > i ? s : i;
                      }
                      e++;
                    }
                    n.YM[r] = i, r++;
                  }
                }
              }, {
                key: "wD",
                value: function wD() {
                  if (n.Kw) return !1;
                  for (var e = a.Nk(), i = 0; i < n.gh; i++) {
                    if (n.ov && (n.QU(), n.Kw)) return !1;
                    var r,
                      o = n.ul,
                      h = n.Ek - n.Lx < n.N.md && n.Ek > n.N.mi ? n.Ek - n.Lx : n.Ek,
                      l = n.YM[h];
                    for (n.Zl = n.wj; n.Zl < n.wn + n.wj;) {
                      var A = (r = !s.A.P.Dc && n.Zl == n.wj && n.Zl > n.N.mi) ? n.N.mi : n.Zl;
                      if (n.gu() || !(n.Oz + l <= n.Qj)) {
                        n.ov = !0;
                        break;
                      }
                      if (.9 * (o + (r = null != n.rq && null != n.rq[A] ? n.rq[A] : n.Or(A))) > n.$p) break;
                      A = n.N.X.Ld(h, A, !0);
                      var c = a.U(A) ? "" : A.I();
                      "number" == typeof c && (A.value = c, c += "", A.numeric = !0);
                      var u = (c = c.replace(/<(?:.|\n)*?>/gi, "")).match(/&#(\d{3,4});/gi);
                      if (u) for (var d, f = 0; f < u.length; f++) d = parseInt(u[f].substring(2, u[f].length - 1)), c = c.replace(u[f], String.fromCharCode(d));
                      u = [c], new t.G.N.C.Eb(), null != A && A.Be ? (f = n.AF.clone(), f = n.Es(A, f), u = n.Qe.splitTextToSize(c, r, n.By(f))) : null != A && A.Ae ? (f = n.EC.clone(), f = n.Es(A, f), u = n.Qe.splitTextToSize(c, r, n.By(f))) : null != A && A.xh ? (f = n.nD.clone(), f = n.Es(A, f)) : null != A && A.Ri && "" != A.I() ? (f = n.WF.clone(), f = n.Es(A, f)) : (f = n.vx.clone(), f = n.Es(A, f), u = n.Qe.splitTextToSize(c, r, n.By(f)));
                      var p = 1 < (d = u.length) ? n.bq(u.length * (f.fontSize + 2 * n.Yf) - 2 * n.Yf) : n.bq(u.length * f.fontSize - n.Yf);
                      p > n.Qj / 2 && (p = (n.Qj - 20) / 2, d = Math.floor(n.DE(p) / (f.fontSize + 2 * n.Yf))), f.fontSize *= .7;
                      var g = t.G.N.C.Eb.lF(f.backgroundColor);
                      if (n.Qe.setFillColor(g[0], g[1], g[2], 0 != g[3] ? void 0 : 0), g = t.G.N.C.Eb.lF(f.borderColor), n.Qe.setDrawColor(g[0], g[1], g[2], 0 != g[3] ? void 0 : 0), g = t.G.N.C.Eb.lF(f.color), n.Qe.setTextColor(g[0], g[1], g[2]), n.Qe.setFontStyle("bold" == f.fontWeight ? "bold" : "normal"), n.Qe.setFontSize(f.fontSize), n.Qe.rect(o, n.$l, r, l, "FD"), p = n.$l + (l - p) / 2 + n.Yf, "right" == f.textAlign) {
                        if (1 < u.length) for (i = 0; i < d; i++) n.Qe.text(u[i], o + r - n.Yf, p, null, null, "right"), p += 2 * n.Yf;else n.Qe.text(c, o + r - n.Yf, p, null, null, "right");
                      } else if (1 < u.length) for (i = 0; i < d; i++) f = !s.A.P.ph && null != A && 0 < A.level ? (A.level + 1) * n.Yf : n.Yf, n.Qe.text(u[i], o + f, p), p += 2 * n.Yf;else f = !s.A.P.ph && null != A && 0 < A.level ? (A.level + 1) * n.Yf : n.Yf, n.Qe.text(c, o + f, p);
                      n.Zl++, o += r;
                    }
                    if (n.ov || (n.$l += l, n.Oz += l, n.Ek++), n.rx() && n.gu()) break;
                  }
                  return n.gh = a.ni.qK(a.Nk() - e, n.gh), n.rx() && n.gu();
                }
              }, {
                key: "rx",
                value: function rx() {
                  return n.wj + n.wn >= n.Hd + n.N.pe;
                }
              }, {
                key: "gu",
                value: function gu() {
                  return n.Ek >= n.vd + n.N.md;
                }
              }, {
                key: "QU",
                value: function QU() {
                  n.Qe.addPage(), n.Ch++, n.ov = !1, n.Kw = !0, n.$K(n.Cc.Hj, n.Cc.yp, function () {
                    n.Kw = !1, n.hK();
                  }), n.Oz = 0, 1 < n.Ch && (n.c3(), n.b3()), t.Ta(!0, s.v.g.qw, n.Ch + 1 + " " + s.v.g.VH, !0);
                }
              }, {
                key: "c3",
                value: function c3() {
                  n.rx() && !n.gu() ? (n.Ek -= n.N.md, n.Lx = n.Ek) : n.Ek = n.Lx;
                }
              }, {
                key: "b3",
                value: function b3() {
                  n.rx() ? n.gu() || (n.wj = 0, n.Zl = 0) : (n.wj += n.wn, n.Zl = n.wj), n.HK();
                }
              }, {
                key: "HK",
                value: function HK() {
                  n.wn = 0;
                  var t = n.wj,
                    e = 0;
                  if (!s.A.P.Dc && n.wj >= n.N.pe) {
                    var i = n.Or(n.N.mi);
                    e += i, n.wn++, n.wj--, n.Zl--;
                  }
                  for (; t < n.XF;) {
                    if ((i = n.Or(t)) > n.$p / 2 - n.ul && (i = (n.$p + n.ul) / 2, n.rq[t] = i), !((e += i) <= n.$p)) {
                      0 == n.wn && (n.wn = 1);
                      break;
                    }
                    n.wn++, t++;
                  }
                }
              }, {
                key: "U0",
                value: function U0() {
                  0 == n.Cc.filename.length && (n.Cc.filename = "pivot.pdf");
                  var i = n.Qe.output();
                  i = a.$.C3(i), r.cw.save(i, n.Cc), n.clear(), s.yb.V().na(new e.ga(t.Eg.jh));
                }
              }, {
                key: "clear",
                value: function clear() {
                  n.N = null, n.Cc = null, n.Qe = null, n.Hd = 0, n.vd = 0, n.XF = 0, n.YF = 0, n.wn = 0, n.Zl = 0, n.wj = 0, n.Ek = 0, n.Lx = 0, n.Oz = 0, n.$l = 0, n.ov = !1, n.Ch = 0, n.Qj = 0, n.$p = 0, n.Pi = 0, n.Sy = null, n.Cj = 0, n.dy = null;
                }
              }, {
                key: "gO",
                value: function gO(t) {
                  return .264 * t;
                }
              }, {
                key: "DE",
                value: function DE(t) {
                  return 3.779 * t;
                }
              }, {
                key: "bq",
                value: function bq(t) {
                  return t / 3.779;
                }
              }]);
              return n;
            }();
            n.XQ = "Helvetica", n.ul = 15, n.ov = !1, n.Ch = 0, n.pl = 5, n.Pi = 0, n.Cj = 0, n.Kw = !1, n.gh = 20, n.Yf = n.gO(8), r.$G = n;
          }((s = t.model || (t.model = {})).Pd || (s.Pd = {}));
        }(r || (r = {})), function (t) {
          var s;
          !function (r) {
            var n = /*#__PURE__*/function () {
              function n() {
                _classCallCheck(this, n);
                throw Error("Singleton");
              }
              _createClass(n, null, [{
                key: "Uf",
                value: function Uf(i, r, a, o) {
                  n.N = i, n.Hd = a, n.vd = o, n.Cc = r;
                  try {
                    n.oX();
                  } catch (i) {
                    console.error("Export HTML error:", i), t.yc(s.v.g.UA, s.v.g.wb, t.ld.wb), t.Ta(!1), s.yb.V().na(new e.ga(t.Eg.jh)), n.clear();
                  }
                }
              }, {
                key: "oX",
                value: function oX() {
                  t.Ta(!0, s.v.g.pw), n.Ok = "", n.fb = n.N.jf, n.Wj = [], a.ni.jp(n.wD, null, null, n.x0);
                }
              }, {
                key: "xD",
                value: function xD() {
                  var e = "",
                    s = n.N.X,
                    r = s.find("#wdr-data-sheet");
                  for (e += a.$.bind("body{{0}}\n", t.G.N.C.Eb.gy(i.ia.Ga(s.element), ["font-family"])), e += a.$.bind(".grid{border-collapse:collapse;{0}border-top:1px solid #e9e9e9;border-left:1px solid #e9e9e9;}\n", t.G.N.C.Eb.gy(i.ia.Ga(s.element), ["font-family", "font-size", "color"])), e += a.$.bind(".title{{0}}\n", t.G.N.C.Eb.mg(t.G.N.C.aa.eB, i.ia.Ga(s.element))), e += a.$.bind(".cell{{0}}\n", t.G.N.C.Eb.mg(t.G.N.C.aa.Hc, r)), e += a.$.bind(".totalCell{{0}}\n", t.G.N.C.Eb.mg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.vt, r)), e += a.$.bind(".rowHeaderCell{{0}}\n", t.G.N.C.Eb.mg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.Ve + " " + t.G.N.C.aa.ql, i.ia.Ga(s.element))), e += a.$.bind(".columnHeaderCell{{0}}\n", t.G.N.C.Eb.mg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.Ve + " " + t.G.N.C.aa.Cq, i.ia.Ga(s.element))), e += a.$.bind(".filterHeaderCell{{0}}\n", t.G.N.C.Eb.mg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.Ve + " " + t.G.N.C.aa.gj, i.ia.Ga(s.element))), r = 1; 20 >= r; r++) e += a.$.bind(".level{0}{{1}}\n", r, t.G.N.C.Eb.mg(t.G.N.C.aa.ql + " " + t.G.N.C.aa.We + r, i.ia.Ga(s.element), ["padding-left"]));
                  for (r = 0; r < n.Wj.length; r++) e += a.$.bind(".{0}{{1}}\n", n.Wj[r], t.G.N.C.Eb.mg(n.Wj[r], i.ia.Ga(s.element)));
                  return e;
                }
              }, {
                key: "sC",
                value: function sC(t) {
                  for (var e = 0; e < t.length; e++) 0 > n.Wj.indexOf(t[e]) && n.Wj.push(t[e]);
                }
              }, {
                key: "wD",
                value: function wD() {
                  for (var t, e, i = a.Nk(), s = Math.min(n.fb + n.gh, n.vd + n.N.md); n.fb < s; n.fb++) {
                    e = "";
                    for (var r = n.N.mi; r < n.Hd + n.N.pe; r++) if (e += "<td {0}>" + ((t = n.N.X.Ld(n.fb, r, !0)) ? t.I() : "") + "</td>", null == t) e = a.$.bind(e, "class='cell'");else {
                      var o = "",
                        h = "";
                      t.ds && (h = t.style.Iy(), o = t.style.ty(), n.sC(t.style.sp)), o = t.Be ? o + " rowHeaderCell level" + t.level : t.Ae ? o + " columnHeaderCell" : t.xh ? o + " filterHeaderCell" : t.Ri && "" != t.I() ? o + " totalCell" : o + " cell", null != t && t.xh && (o += " level" + t.level), "" != o.trim() && (o = "class='" + o.trim() + "'"), "" != (h += "width:" + n.N.X.coords.sf(r) + "px;").trim() && (h = "style='" + h.trim() + "'"), e = a.$.bind(e, o + " " + h);
                    }
                    n.Pz += "<tr>" + e + "</tr>";
                  }
                  return n.gh = a.ni.qK(a.Nk() - i, n.gh), n.f3(n.fb), n.fb >= n.vd + n.N.md;
                }
              }, {
                key: "f3",
                value: function f3(e) {
                  t.Ta(!0, s.v.g.pw, a.$.bind("{0}%", (e / (n.vd + n.N.md) * 100).toFixed(0)));
                }
              }, {
                key: "x0",
                value: function x0() {
                  t.Ta(!1), n.t2(), n.clear();
                }
              }, {
                key: "t2",
                value: function t2() {
                  0 == n.Cc.filename.length && (n.Cc.filename = "pivotgrid.html");
                  var i = "";
                  if (!a.Vb(n.Cc.Hj)) {
                    var o = n.Cc.Hj;
                    i += o = (o = o.replace(/##PAGE-NUMBER##/gi, "")).replace(/##CURRENT-DATE##/gi, new Date().toLocaleString());
                  }
                  i += "<div class='title'>" + s.A.P.ng + "</div>", i += "<table class='grid'>" + n.Pz + "</table>", a.Vb(n.Cc.yp) || (i += o = (o = (o = n.Cc.yp).replace(/##PAGE-NUMBER##/gi, "")).replace(/##CURRENT-DATE##/gi, new Date().toLocaleString())), n.Ok = "<!DOCTYPE html><html><head><meta charset='UTF-8'/>", n.Ok += "<title>" + (a.Vb(s.A.P.ng) ? s.v.g.JG : s.A.P.ng) + "</title>", n.Ok += "<style>" + n.xD() + "</style></head>", n.Ok += "<body>" + i + "</body></html>", r.cw.save(n.Ok, n.Cc), s.yb.V().na(new e.ga(t.Eg.jh));
                }
              }, {
                key: "clear",
                value: function clear() {
                  n.fb = 0, n.Ok = "", n.Pz = "", n.Hd = 0, n.vd = 0, n.N = null, n.Cc = null;
                }
              }]);
              return n;
            }();
            n.fb = 0, n.Ok = "", n.Pz = "", n.gh = 20, r.YG = n;
          }((s = t.model || (t.model = {})).Pd || (s.Pd = {}));
        }(r || (r = {})), function (t) {
          var s;
          !function (r) {
            var n = /*#__PURE__*/function () {
              function n() {
                _classCallCheck(this, n);
                throw Error("Singleton");
              }
              _createClass(n, null, [{
                key: "Uf",
                value: function Uf(i, r, a, o) {
                  n.N = i, n.Hd = a, n.vd = o, n.Cc = r;
                  try {
                    n.pX();
                  } catch (i) {
                    console.error("Export XLS error:", i), t.yc(s.v.g.UA, s.v.g.wb, t.ld.wb), t.Ta(!1), s.yb.V().na(new e.ga(t.Eg.jh));
                  }
                }
              }, {
                key: "pX",
                value: function pX() {
                  t.Ta(!0, s.v.g.pw), n.fb = n.N.jf, n.Nd = 0, n.sd = new rt.uT();
                  var e = a.Vb(s.A.P.ng) ? s.v.g.JG : s.A.P.ng.replace(/[^a-zA-Z\d\s\-|+@#$^&()_,.!]/g, "");
                  30 < (e = 0 < n.Cc.hD.length ? n.Cc.hD : e).length && (e = e.substr(0, 27) + "..."), e = new rt.vT(e), n.sd.be.push(e), n.QD(), n.oC(), n.$U(), n.EU(), a.ni.jp(n.eY, null, null, function () {
                    return n.z1();
                  });
                }
              }, {
                key: "QD",
                value: function QD() {
                  var e = n.N.X.element;
                  n.vx = t.G.N.C.Eb.Qg(t.G.N.C.aa.Hc, i.ia.Ga(e)), n.WF = t.G.N.C.Eb.Qg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.vt, i.ia.Ga(e)), n.AF = t.G.N.C.Eb.Qg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.Ve + " " + t.G.N.C.aa.ql, i.ia.Ga(e)), n.EC = t.G.N.C.Eb.Qg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.Ve + " " + t.G.N.C.aa.Cq, i.ia.Ga(e)), n.nD = t.G.N.C.Eb.Qg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.Ve + " " + t.G.N.C.aa.gj, i.ia.Ga(e));
                  for (var s = 1; 20 >= s; s++) n.BF[s] = t.G.N.C.Eb.Qg(t.G.N.C.aa.Hc + " " + t.G.N.C.aa.Ve + " " + t.G.N.C.aa.ql + " " + t.G.N.C.aa.We + s, i.ia.Ga(e));
                }
              }, {
                key: "z1",
                value: function z1() {
                  n.q_(), t.Ta(!1), n.v2();
                }
              }, {
                key: "v2",
                value: function v2() {
                  n.fb = n.N.jf, 0 == n.Cc.filename.length && (n.Cc.filename = "pivot.xlsx"), r.cw.save(n.sd.N3(), n.Cc), n.sd = null, n.Cc = null, s.yb.V().na(new e.ga(t.Eg.jh));
                }
              }, {
                key: "eY",
                value: function eY() {
                  for (var e = a.Nk(), i = n.vd + n.N.md; n.fb < i; n.fb++) {
                    if (100 < a.Nk() - e) {
                      if (100 < (e = n.fb / i * 100)) return !1;
                      t.Ta(!0, s.v.g.pw, a.$.bind("{0}% ({1} rows)", e.toFixed(0), n.fb.toString()));
                      break;
                    }
                    for (var r = n.N.mi; r < n.Hd + n.N.pe; r++) {
                      var o,
                        h = n.N.X.Ld(n.fb, r, !0),
                        l = a.U(h) ? "" : h.I();
                      a.U(h) || null != h.measure && (h.measure.type == t.u.types.Ca.jc ? isNaN(h.value) || (o = n.nW(h.value)) : h.measure.type == t.u.types.Ca.ce && (isNaN(h.value) || (o = n.oW(h.value)))), "number" == typeof l && (h.value = l, l += "", h.numeric = !0);
                      var A = null != h && (h.Be || h.Ae);
                      if (n.Cc.IL && "" == l && null != h && null != h.ke && (l = h.ke.caption), "" != l.trim() || A) {
                        if (new t.G.N.C.Eb(), A = null != h && h.Be ? 0 < h.level && n.BF[h.level] ? n.BF[h.level].clone() : n.AF.clone() : null != h && h.Ae ? n.EC.clone() : null != h && h.xh ? n.nD.clone() : null != h && h.Ri && "" != h.I() ? n.WF.clone() : n.vx.clone(), null != h && h.ds) {
                          var c = 0 < h.style.sp.length ? t.G.N.C.Eb.Qg(h.style.ty()) : t.G.N.C.Eb.hy(h.style.Iy());
                          c.ks(A), A = c;
                        }
                        A.color = A.color || "rgb(0,0,0)", "rgb(33, 33, 33)" == A.backgroundColor && (A.color = "rgb(242, 242, 242)"), A.backgroundColor = A.backgroundColor || "rgb(255,255,255)", A.fontSize = A.fontSize ? n.S1(A.fontSize) : 8;
                        var u = new rt.Gb.fonts.Ym("Tahoma", A.fontSize, a.$.Mi(A.color));
                        u.bold = "bold" == A.fontWeight, u.hs = !1;
                        var d = null,
                          f = c = !1;
                        if (h.numeric) {
                          if (null != h.measure) {
                            f = "" != (d = h.measure.Ne()).Qp || f, c = h.measure.Fa == t.u.i.ca.jj || h.measure.Fa == t.u.i.ca.Jh || h.measure.Fa == t.u.i.ca.ki || h.measure.Fa == t.u.i.ca.ji || h.measure.La && -1 < h.measure.Jc.indexOf("percent");
                            var p = d.IP();
                            (c || d.Wh) && ((d = d.clone()).fd = "" == d.fd ? "%" : d.fd, p = d.IP()), d = new rt.Gb.format.So("" == p ? 0 : -1, p);
                          }
                        } else null == h.measure || h.measure.type != t.u.types.Ca.jc && h.measure.type != t.u.types.Ca.ce || (d = new rt.Gb.format.So(14, ""));
                        d && n.sd.styleSheet.HU(d), u = new rt.Gb.Mq(u, a.$.Mi(A.backgroundColor), d, A.textAlign), !s.A.P.ph && h && h.Be && 0 < h.level && (u.textIndent = h.level), n.sd.styleSheet.pn(u), d = null != h.measure ? h.measure.Ne() : null, h.numeric ? null == d || h.label != d.Fp && h.label != d.vp ? (o = null == d || !c && "%" != d.fd ? h.value : h.value / 100, n.sd.be[0].Bf(n.fb - n.N.jf + n.Nd, r, isNaN(h.value) && f ? h.I() : o, u)) : n.sd.be[0].Bf(n.fb - n.N.jf + n.Nd, r, h.I(), u) : !h.yh || null == h.measure || h.measure.type != t.u.types.Ca.jc && h.measure.type != t.u.types.Ca.ce ? h.yh && null != h.measure && h.measure.Fa == t.u.i.ca.NONE ? n.sd.be[0].Bf(n.fb - n.N.jf + n.Nd, r, h.value, u) : n.sd.be[0].Bf(n.fb - n.N.jf + n.Nd, r, l, u) : n.sd.be[0].Bf(n.fb - n.N.jf + n.Nd, r, o, u), null != h && (0 == n.sd.be[0].Or(r) && n.sd.be[0].PO(r, n.mW(n.N.X.coords.sf(r))), r != n.N.mi || n.N.X.coords.RZ(n.fb) || (h = n.qu(n.N.X.coords.Zb(n.fb)), n.sd.be[0].kq(n.fb + n.Nd, h)), l.length > A.width && n.sd.be[0].PO(r, n.qu(l.length + n.cellPadding) > n.qu(n.IG) ? n.qu(n.IG) : n.qu(l.length + n.cellPadding)));
                      }
                    }
                  }
                  return n.fb >= i;
                }
              }, {
                key: "nW",
                value: function nW(t) {
                  return a.bt.oN(s.A.P.Gk) || (t -= 6e4 * new Date(t).getTimezoneOffset()), t = -Date.parse("1899-12-30") + t, Math.floor(t / 864e5);
                }
              }, {
                key: "oW",
                value: function oW(t) {
                  return a.bt.oN(s.A.P.cm) || (t -= 6e4 * new Date(t).getTimezoneOffset()), (-Date.parse("1899-12-30") + t) / 864e5;
                }
              }, {
                key: "S1",
                value: function S1(t) {
                  return .75 * t;
                }
              }, {
                key: "qu",
                value: function qu(e) {
                  return 0 >= e ? 0 : n.OW / n.nL * e * (n.nL / t.G.N.sheet.dk.vo);
                }
              }, {
                key: "mW",
                value: function mW(t) {
                  return 0 >= t ? 0 : ((t - 5) / 7 * 100 + .5) / 100;
                }
              }, {
                key: "$U",
                value: function $U() {
                  var e = s.kb.at.Mg;
                  if (0 < e.length) {
                    var i = getComputedStyle(t.G.xb.tb.B.find("." + t.G.N.C.aa.Cq).element),
                      r = new rt.Gb.fonts.Ym(i.fontFamily, parseInt(i.fontSize) - 2, a.$.Mi(i.color));
                    r.bold = "bold" === i.fontWeight, r.hs = "italic" === i.fontStyle, (r = new rt.Gb.Mq(r, a.$.Mi(i.backgroundColor))).textAlign = i.textAlign, n.sd.styleSheet.pn(r), n.sd.be[0].Bf(n.Nd, 0, "Report Information", r), n.sd.be[0].Bf(n.Nd, 1, "", r), i = getComputedStyle(t.G.xb.tb.B.find("." + t.G.N.C.aa.Hc).element);
                    var o = new rt.Gb.fonts.Ym(i.fontFamily, parseInt(i.fontSize) - 2, a.$.Mi(i.color));
                    for (o.bold = "bold" === i.fontWeight, o.hs = "italic" === i.fontStyle, (o = new rt.Gb.Mq(o, a.$.Mi(i.backgroundColor))).textAlign = i.textAlign, n.sd.styleSheet.pn(o), i = 0; i < e.length; i++) n.sd.be[0].Bf(i + 1 + n.Nd, 0, String(e[i].name), r), n.sd.be[0].Bf(i + 1 + n.Nd, 1, String(e[i].value), r);
                  }
                  n.Nd += 0 == e.length ? 0 : e.length + 2;
                }
              }, {
                key: "oC",
                value: function oC() {
                  var e = s.A.P.ng;
                  if (0 != e.length) {
                    var i = getComputedStyle(t.G.xb.tb.B.find("." + t.G.N.C.aa.eB).element),
                      r = new rt.Gb.fonts.Ym(i.fontFamily, parseInt(i.fontSize) - 2, a.$.Mi(i.color));
                    r.bold = "bold" === i.fontWeight, r.hs = "italic" === i.fontStyle, (i = new rt.Gb.Mq(r, a.$.Mi(i.backgroundColor))).textAlign = "center", n.sd.styleSheet.pn(i), n.sd.be[0].Bf(0, 0, e, i), n.Nd = 1;
                  }
                }
              }, {
                key: "q_",
                value: function q_() {
                  if (0 < s.A.P.ng.length) {
                    var t = n.sd.be[0];
                    t.KN(0, 0, Math.min(t.YV, 10));
                  }
                }
              }, {
                key: "EU",
                value: function EU() {
                  if (n.Cc.hP) {
                    var e = s.yb.V().O.fa.bb(),
                      i = [],
                      r = !0,
                      o = getComputedStyle(t.G.xb.tb.B.find("." + t.G.N.C.aa.Ve).element),
                      h = new rt.Gb.fonts.Ym(o.fontFamily, parseInt(o.fontSize) - 2, a.$.Mi(o.color));
                    h.bold = "bold" === o.fontWeight, h.hs = "italic" === o.fontStyle, (h = new rt.Gb.Mq(h, a.$.Mi(o.backgroundColor))).textAlign = o.textAlign, n.sd.styleSheet.pn(h);
                    var l = getComputedStyle(t.G.xb.tb.B.find("." + t.G.N.C.aa.Hc).element);
                    (o = new rt.Gb.fonts.Ym(l.fontFamily, parseInt(l.fontSize) - 2, a.$.Mi(l.color))).bold = "bold" === l.fontWeight, o.hs = "italic" === l.fontStyle, (o = new rt.Gb.Mq(o, a.$.Mi(l.backgroundColor))).textAlign = l.textAlign, n.sd.styleSheet.pn(o), l = n.sd.be[0];
                    for (var A = 0, c = 0; c < e.length; c++) {
                      var u = e.F(c),
                        d = u.xj.type == t.u.types.zq.TA;
                      if (u.Sg()) {
                        if (i.length = 0, d) d = n.cW(u);else {
                          for (var f = 0; f < u.Me.length; f++) d = u.Me.F(f), i.push(d.caption);
                          d = i.join(", ");
                        }
                        r && (l.Bf(A + n.Nd, 0, "", h), l.Bf(A + n.Nd, 1, "Filters", h), A++), l.Bf(A + n.Nd, 0, u.caption, h), l.Bf(A + n.Nd, 1, d, o), A++, r = !1;
                      }
                    }
                    if (s.A.P.TM == t.G.N.Ue.Ih) for (e = s.yb.V().O.fa.CE, c = 0; c < e.length; c++) if ((u = s.yb.V().O.fa.Zh(e.F(c))).Sg()) {
                      for (f = i.length = 0; f < u.Me.length; f++) d = u.Me.F(f), i.push(d.caption);
                      d = i.join(", "), r && (l.Bf(A + n.Nd, 0, "", h), l.Bf(A + n.Nd, 1, "Filters", h), A++), l.Bf(A + n.Nd, 0, u.caption, h), l.Bf(A + n.Nd, 1, d, o), A++, r = !1;
                    }
                    n.Nd += r ? 0 : A + 1;
                  }
                }
              }, {
                key: "cW",
                value: function cW(t) {
                  var e,
                    i = [];
                  null != n.oo && (n.oo.length = 0), n.mP(t.Qd);
                  for (var s = n.dW(t), r = !1, a = 0; a < n.oo.length; a++) {
                    var o = n.oo[a],
                      h = a == n.oo.length - 1;
                    if (!r && t.Me.rc(o.j)) {
                      r = !0;
                      var l = o;
                    }
                    r && (t.Me.rc(o.j) && (e = o), -1 < s.indexOf(o) && !h || (e = null != e ? e : l, o = n.SK(l), h = e.j != l.j ? ":" + n.SK(e, !0) : "", e = l = null, r = !1, i.push(o + h)));
                  }
                  return i.join(", ");
                }
              }, {
                key: "mP",
                value: function mP(e) {
                  null == n.oo && (n.oo = []), e.Qc || n.oo.push(e);
                  for (var i, s = (e = e.Kc.Cf(e, !1, t.u.i.ba.ub)).length, r = 0; r < s; r++) 0 < (i = e.F(r)).children.length ? n.mP(i) : n.oo.push(i);
                }
              }, {
                key: "SK",
                value: function SK(e) {
                  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  var s = e,
                    r = [];
                  for (r.push(e.caption); s && s.j != e.j && !s.level.jE && 0 < s.children.length;) r.push(s.caption), s = (s = s.Kc.Cf(s, !1, t.u.i.ba.ub)).F(i ? s.length - 1 : 0);
                  for (s = e.parent; s && !s.Qc;) r.unshift(s.caption), s = s.parent;
                  return r.join("-");
                }
              }, {
                key: "dW",
                value: function dW(t) {
                  var e = [];
                  t = t.Me;
                  for (var i, s, r = 0; r < t.length; r++) {
                    i = t.F(r), e.push(i), s = i.up;
                    for (var _n = 0; _n < s.length; _n++) e.push(s.F(_n));
                    if (!(i.parent && !i.parent.Qc && -1 < e.indexOf(i.parent))) for (; i.parent && !i.parent.Qc;) i = i.parent, e.push(i);
                  }
                  return e;
                }
              }]);
              return n;
            }();
            n.fb = 0, n.Nd = 0, n.cellPadding = 3, n.IG = 100, n.BF = [], n.OW = 14.3, n.nL = 38, r.aH = n;
          }((s = t.model || (t.model = {})).Pd || (s.Pd = {}));
        }(r || (r = {})), function (t) {
          var i;
          !function (s) {
            var r = /*#__PURE__*/function () {
              function r() {
                _classCallCheck(this, r);
              }
              _createClass(r, null, [{
                key: "Aj",
                value: function Aj(e) {
                  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var l = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  r.DB ? this.YC.push({
                    type: e,
                    options: n,
                    zV: l
                  }) : (e = e.toLowerCase(), e = h.Rs(e) ? e : h.Fq, i.yb.V().addEventListener(t.Eg.jh, r.NL), r.DB = !0, r.ou = l, a.U(n) && (n = new s.ZG()), n.type = e, e = new o(e, n, l), i.yb.V().na(e));
                }
              }, {
                key: "z3",
                value: function z3() {
                  t.Ta(!1), i.yb.V().removeEventListener(t.Eg.jh, r.NL), r.DB = !1;
                }
              }, {
                key: "j0",
                value: function j0() {
                  if (r.z3(), 0 < r.YC.length) {
                    var t = r.YC.shift();
                    this.Aj(t.type, t.options, t.zV);
                  }
                }
              }, {
                key: "save",
                value: function save(t, e) {
                  switch (e.ZC.toLowerCase()) {
                    case i.kb.ml.gt:
                      r.gq(t, e);
                      break;
                    case i.kb.ml.$A:
                      r.Sz(t, e);
                      break;
                    case i.kb.ml.jG:
                    case i.kb.ml.kI:
                      break;
                    default:
                      r.gq(t, e);
                  }
                }
              }, {
                key: "Sz",
                value: function Sz(e, s) {
                  switch (s.type) {
                    case h.Fo:
                    case h.dt:
                    case h.Fq:
                      r.u2(e, s);
                      break;
                    default:
                      e = i.zc.validate(s.type), t.yc("Unknown type of export: '" + e + "'", i.v.g.wb);
                  }
                }
              }, {
                key: "gq",
                value: function gq(e, s) {
                  switch (s.type) {
                    case h.Fo:
                      var n = "text/html;charset=utf-8";
                      s.filename = r.rC(s.filename, ".html");
                      break;
                    case h.dt:
                      n = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", s.filename = r.rC(s.filename, ".xlsx");
                      break;
                    case h.Fq:
                      n = "application/pdf", s.filename = r.rC(s.filename, ".pdf");
                      break;
                    default:
                      n = "text/plain;charset=utf-8";
                  }
                  var a = [e];
                  try {
                    u(new Blob(a, {
                      type: n
                    }), s.filename), r.iA({
                      data: e,
                      rX: s.filename,
                      type: s.type
                    });
                  } catch (e) {
                    t.yc(i.v.g.Eq, i.v.g.wb, t.ld.wb), r.iA(null, {
                      message: i.v.g.Eq
                    });
                  }
                }
              }, {
                key: "rC",
                value: function rC(t, e) {
                  return t.indexOf(e) != t.length - e.length && (t += e), t;
                }
              }, {
                key: "u2",
                value: function u2(s, o) {
                  var h = new a.hB(500);
                  h.addEventListener(a.Lq.Bw, function () {
                    t.Ta(!0, i.v.g.XH, (h.SC / 10).toString() + " sec");
                  });
                  var l = new n.Gw();
                  l.addEventListener(e.ga.wb, function () {
                    t.yc(i.v.g.Eq, i.v.g.wb), h.stop(), t.Ta(!1), r.iA(null, {
                      message: i.v.g.Eq
                    });
                  }), l.addEventListener(e.ga.yg, function () {
                    h.stop(), t.Ta(!1), r.iA({
                      data: s,
                      rX: o.filename,
                      type: o.type,
                      response: l.response
                    });
                  });
                  var A = new Blob([s], {
                      type: "application/octet-binary"
                    }),
                    c = new FormData();
                  for (var u in c.append("filedata", A, o.filename), o.kD) c.append(u, o.kD[u]);
                  l.xF = n.WI.lI, l.data = c, l.contentType = !1, l.load(o.url), h.start();
                }
              }, {
                key: "iA",
                value: function iA() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  null != r.ou && r.ou.call(null, t, e);
                }
              }]);
              return r;
            }();
            r.DB = !1, r.YC = [], r.NL = function () {
              return r.j0();
            }, s.cw = r;
            var o = /*#__PURE__*/function (_e$ga4) {
              _inherits(o, _e$ga4);
              var _super47 = _createSuper(o);
              function o(e, i, s) {
                var _this63;
                _classCallCheck(this, o);
                _this63 = _super47.call(this, t.Eg.HA), _this63.OL = e, _this63.Cc = i, _this63.ou = s;
                return _this63;
              }
              return _createClass(o);
            }(e.ga);
            s.A4 = o;
            var h = /*#__PURE__*/function () {
              function h() {
                _classCallCheck(this, h);
              }
              _createClass(h, null, [{
                key: "Rs",
                value: function Rs(t) {
                  return t === h.dt || t === h.Fo || t === h.Fq;
                }
              }]);
              return h;
            }();
            h.dt = "excel", h.Fo = "html", h.Fq = "pdf", s.Co = h;
          }((i = t.model || (t.model = {})).Pd || (i.Pd = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (e) {
            var i = /*#__PURE__*/function () {
              function i() {
                var _i23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "file";
                _classCallCheck(this, i);
                this.Re = !0, this.ZC = t.model.kb.ml.gt, this.filename = "", this.url = "()", this.type = e.Co.Fo, this.Az = "portrait", this.hD = "", this.hP = this.IL = !1, this.kD = {}, this.ZC = _i23;
              }
              _createClass(i, null, [{
                key: "Za",
                value: function Za(e) {
                  var s = new i();
                  return a.U(e) || (e.hasOwnProperty("showHeaders") && (s.Re = "true" === e.showHeaders || !0 === e.showHeaders), e.hasOwnProperty("filename") && (s.filename = e.filename), e.hasOwnProperty("url") && (s.url = e.url), e.hasOwnProperty("excelSheetName") && (s.hD = e.excelSheetName), e.hasOwnProperty("excelExportAll") && (s.IL = e.excelExportAll), !e.hasOwnProperty("pageOrientation") || "portrait" !== e.pageOrientation && "landscape" !== e.pageOrientation || (s.Az = e.pageOrientation.toLowerCase()), e.hasOwnProperty("destinationType") && t.model.kb.ml.Rs(e.destinationType.toString().toLowerCase()) && (s.ZC = e.destinationType.toString().toLowerCase()), null != e.showFilters && (s.hP = e.showFilters), null != e.extendedParameters && (s.kD = e.extendedParameters), null != e.header && (s.Hj = e.header), null != e.footer && (s.yp = e.footer)), s;
                }
              }]);
              return i;
            }();
            e.ZG = i;
          }((e = t.model || (t.model = {})).Pd || (e.Pd = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function () {
              function e() {
                _classCallCheck(this, e);
              }
              _createClass(e, null, [{
                key: "Ne",
                value: function Ne(t) {
                  return e.Ec.rc(t) ? e.Ec.getItem(t) : "" != t && e.Ec.rc("") ? e.Ec.getItem("") : e.FD();
                }
              }, {
                key: "jq",
                value: function jq(i) {
                  var s = t.C.Eo.Za(i);
                  if (e.wx.Ea(s.name, s), null != e.Dr) s.LN(e.Dr);else if ("" == s.name) for (e.Dr = i, i = 0; i < e.Ec.length; i++) e.Ec.F(i).LN(e.Dr);
                  e.Ec.Ea(s.name, s);
                }
              }, {
                key: "fY",
                value: function fY() {
                  return e.wx.slice();
                }
              }, {
                key: "clear",
                value: function clear() {
                  e.Ec = new a.ma(), e.wx = new a.ma(), e.Dr = null;
                }
              }, {
                key: "FD",
                value: function FD() {
                  return new t.C.Eo();
                }
              }, {
                key: "$L",
                value: function $L(t) {
                  return e.Ec.rc(t);
                }
              }, {
                key: "la",
                value: function la() {
                  e.Ec = null, e.wx = null, e.Dr = null;
                }
              }]);
              return e;
            }();
            e.Ec = new a.ma(), e.wx = new a.ma(), e.Dr = null, t.Bg = e;
          }((e = t.model || (t.model = {})).format || (e.format = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.model || (t.model = {}), function (t) {
            var i = /*#__PURE__*/function () {
              function i() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                _classCallCheck(this, i);
                this.name = "", this.Ya = {}, this.tc = {
                  thousandsSeparator: " ",
                  decimalSeparator: ".",
                  decimalPlaces: -1,
                  maxDecimalPlaces: -1,
                  maxSymbols: 20,
                  currencySymbol: "",
                  currencySymbolAlign: "left",
                  nullValue: "",
                  infinityValue: "Infinity",
                  divideByZeroValue: "Infinity",
                  textAlign: "",
                  isPercent: !1,
                  isCount: !1
                }, this.name = t;
              }
              _createClass(i, [{
                key: "Pe",
                get: function get() {
                  return this.Ya;
                }
              }, {
                key: "Gh",
                get: function get() {
                  return null != this.Ya.thousandsSeparator ? this.Ya.thousandsSeparator : this.tc.thousandsSeparator;
                },
                set: function set(t) {
                  this.Ya.thousandsSeparator = t;
                }
              }, {
                key: "Br",
                get: function get() {
                  return null != this.Ya.decimalSeparator ? this.Ya.decimalSeparator : this.tc.decimalSeparator;
                },
                set: function set(t) {
                  this.Ya.decimalSeparator = t;
                }
              }, {
                key: "Og",
                get: function get() {
                  return null != this.Ya.decimalPlaces ? this.Ya.decimalPlaces : this.tc.decimalPlaces;
                },
                set: function set(t) {
                  this.Ya.decimalPlaces = t;
                }
              }, {
                key: "um",
                get: function get() {
                  return null != this.Ya.maxDecimalPlaces ? this.Ya.maxDecimalPlaces : this.tc.maxDecimalPlaces;
                },
                set: function set(t) {
                  this.Ya.maxDecimalPlaces = t;
                }
              }, {
                key: "vm",
                get: function get() {
                  return null != this.Ya.maxSymbols ? this.Ya.maxSymbols : this.tc.maxSymbols;
                },
                set: function set(t) {
                  this.Ya.maxSymbols = t;
                }
              }, {
                key: "fd",
                get: function get() {
                  return null != this.Ya.currencySymbol ? this.Ya.currencySymbol : this.tc.currencySymbol;
                },
                set: function set(t) {
                  this.Ya.currencySymbol = t;
                }
              }, {
                key: "Fi",
                get: function get() {
                  return null != this.Ya.currencySymbolAlign ? this.Ya.currencySymbolAlign : this.tc.currencySymbolAlign;
                },
                set: function set(t) {
                  this.Ya.currencySymbolAlign = t;
                }
              }, {
                key: "Qp",
                get: function get() {
                  return null != this.Ya.nullValue ? this.Ya.nullValue : this.tc.nullValue;
                },
                set: function set(t) {
                  this.Ya.nullValue = t;
                }
              }, {
                key: "Fp",
                get: function get() {
                  return null != this.Ya.infinityValue ? this.Ya.infinityValue : this.tc.infinityValue;
                },
                set: function set(t) {
                  this.Ya.infinityValue = t;
                }
              }, {
                key: "vp",
                get: function get() {
                  return null != this.Ya.divideByZeroValue ? this.Ya.divideByZeroValue : this.tc.divideByZeroValue;
                },
                set: function set(t) {
                  this.Ya.divideByZeroValue = t;
                }
              }, {
                key: "textAlign",
                get: function get() {
                  return null != this.Ya.textAlign ? this.Ya.textAlign : this.tc.textAlign;
                },
                set: function set(t) {
                  this.Ya.textAlign = t;
                }
              }, {
                key: "Wh",
                get: function get() {
                  return null != this.Ya.isPercent ? this.Ya.isPercent : this.tc.isPercent;
                },
                set: function set(t) {
                  this.Ya.isPercent = t;
                }
              }, {
                key: "Qn",
                get: function get() {
                  return null != this.Ya.isCount ? this.Ya.isCount : this.tc.isCount;
                },
                set: function set(t) {
                  this.Ya.isCount = t;
                }
              }, {
                key: "RC",
                get: function get() {
                  return 1 < this.fd.length && "&" == this.fd.charAt(0) && ";" == this.fd.charAt(this.fd.length - 1) ? 1 : this.fd.length;
                },
                set: function set(t) {}
              }, {
                key: "IP",
                value: function IP() {
                  var t;
                  if (-1 == this.Og && "" == this.fd) return "";
                  if ("%" == this.fd) {
                    var e = -1 == this.Og ? 0 : this.Og,
                      _i24 = 0 < e ? "0." : "0";
                    for (t = 0; t < e; t++) _i24 += "0";
                    return _i24 + this.fd;
                  }
                  if (_i24 = "" != this.Gh ? "#,##0" : "###0", 0 < this.Og) for (_i24 += ".", t = 0; t < this.Og; t++) _i24 += "0";
                  return "" != this.fd && (_i24 = "left" == this.Fi ? "\\" + this.fd + _i24 : _i24 + "\\" + this.fd), _i24;
                }
              }, {
                key: "Sa",
                value: function Sa() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  var e = {};
                  if (e.name = this.name, t) e.thousandsSeparator = this.Gh, e.decimalSeparator = this.Br, e.decimalPlaces = this.Og, e.maxDecimalPlaces = this.um, e.maxSymbols = this.vm, e.currencySymbol = this.fd, e.currencySymbolAlign = this.Fi, e.nullValue = this.Qp, e.infinityValue = this.Fp, e.divideByZeroValue = this.vp, e.textAlign = "" != this.textAlign ? this.textAlign : "right", e.isPercent = this.Wh, e.isCount = this.Qn;else for (var _i25 in this.Ya) e[_i25] = "textAlign" == _i25 ? "" == this.textAlign ? "right" : this.textAlign : this.Ya[_i25];
                  return e;
                }
              }, {
                key: "clone",
                value: function clone() {
                  var t = new i();
                  t.name = this.name, this.Ya.hasOwnProperty("thousandsSeparator") && (t.Gh = this.Gh), this.Ya.hasOwnProperty("decimalSeparator") && (t.Br = this.Br), this.Ya.hasOwnProperty("decimalPlaces") && (t.Og = this.Og), this.Ya.hasOwnProperty("maxDecimalPlaces") && (t.um = this.um), this.Ya.hasOwnProperty("maxSymbols") && (t.vm = this.vm), this.Ya.hasOwnProperty("currencySymbol") && (t.fd = this.fd), this.Ya.hasOwnProperty("currencySymbolAlign") && (t.Fi = this.Fi), this.Ya.hasOwnProperty("nullValue") && (t.Qp = this.Qp), this.Ya.hasOwnProperty("infinityValue") && (t.Fp = this.Fp), this.Ya.hasOwnProperty("divideByZeroValue") && (t.vp = this.vp), this.Ya.hasOwnProperty("textAlign") && (t.textAlign = this.textAlign), this.Ya.hasOwnProperty("isPercent") && (t.Wh = this.Wh), this.Ya.hasOwnProperty("isPercent") && (t.Qn = this.Qn);
                  var e,
                    s = {};
                  for (e in this.tc) s[e] = this.tc[e];
                  return t.tc = s, t;
                }
              }, {
                key: "LN",
                value: function LN(t) {
                  for (var e in t) this.tc[e] = t[e];
                }
              }], [{
                key: "Za",
                value: function Za(t) {
                  var s = new i();
                  return null != t.name && (s.name = t.name), null != t.thousandsSeparator && e.zc.valid(t.thousandsSeparator) && (s.Gh = e.zc.validate(t.thousandsSeparator, !0)), null != t.decimalSeparator && e.zc.valid(t.decimalSeparator) && (s.Br = e.zc.validate(t.decimalSeparator)), null != t.decimalPlaces && -1 < parseInt(t.decimalPlaces) && (s.Og = isNaN(parseInt(t.decimalPlaces)) ? -1 : parseInt(t.decimalPlaces)), null != t.maxDecimalPlaces && -1 < parseInt(t.maxDecimalPlaces) && (s.um = t.maxDecimalPlaces), null != t.maxSymbols && 1 < parseInt(t.maxSymbols) && (s.vm = t.maxSymbols), null != t.currencySymbol && e.zc.valid(t.currencySymbol) && (s.fd = e.zc.validate(t.currencySymbol, !0)), null != t.currencySymbolAlign && e.zc.valid(t.currencySymbolAlign) && (s.Fi = e.zc.validate(t.currencySymbolAlign)), null != t.nullValue && e.zc.valid(t.nullValue) && (s.Qp = e.zc.validate(t.nullValue)), null != t.infinityValue && e.zc.valid(t.infinityValue) && (s.Fp = e.zc.validate(t.infinityValue)), null != t.divideByZeroValue && e.zc.valid(t.divideByZeroValue) && (s.vp = e.zc.validate(t.divideByZeroValue)), null != t.textAlign && e.zc.valid(t.textAlign) && (s.textAlign = e.zc.validate(t.textAlign)), null != t.isPercent && (s.Wh = 1 == t.isPercent), null != t.isCount && (s.Qn = 1 == t.isCount), s;
                }
              }]);
              return i;
            }();
            t.Eo = i;
          }((i = e.format || (e.format = {})).C || (i.C = {}));
        }(r || (r = {})), function (t) {
          var e = /*#__PURE__*/function () {
            function e() {
              _classCallCheck(this, e);
            }
            _createClass(e, null, [{
              key: "format",
              value: function format(i) {
                var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
                if (null == s && (s = e.Ox), isNaN(i) || t.U(i)) return s.Qp;
                if (1 / 0 == i) return s.Fp;
                if (i == r.u.i.aw.$v) return s.vp;
                n || (n = s.Qn), i = s.Wh && "%" != s.fd ? 100 * i : i;
                var h = a ? "%" : s.fd;
                h = !a && s.Wh && "%" != s.fd ? "%" : h, s.Fi = s.Wh ? "right" : s.Fi;
                var l = n ? 0 : s.Og;
                if (0 == i && 0 > l) {
                  var A = "0";
                  return !n && 0 < h.length && (A = e.ZL(A, h, s.Fi, a)), A;
                }
                A = 0 > i ? s.vm - 1 : s.vm, 1 < s.Gh.length && !t.$.DZ(s.Gh) && (A -= Math.floor(A / 3) * s.Gh.length), !n && 0 < s.RC && (A -= s.RC), s.Gh = "&#39;" == s.Gh ? "'" : s.Gh;
                var c = i.toString().split(".");
                if (1 < c.length && 10 <= c[1].length) {
                  for (var u = 0, d = 0, f = (c = c[1]).length - 2; 0 <= f; f--) if ("9" != c.charAt(f) && "0" != c.charAt(f) || c.charAt(f) != c.charAt(f + 1)) {
                    if (!(4 > u)) {
                      d = f + 1;
                      break;
                    }
                    u = 0;
                  } else u++;
                  4 <= u && (c = Math.pow(10, d), i = Math.round(i * c) / c);
                }
                return c = 4 < l ? Math.pow(10, A - l - 1) : Math.pow(10, A - 4), u = Math.pow(10, -(A - 4)), -1 < o && (l = o), Math.abs(i) > c ? (o = Math.round(Math.log(i) / Math.LN10), o = Math.round(Math.log(o) / Math.LN10 + 1), 20 < (A = 0 > i ? s.vm - o - 5 : s.vm - o - 4) && (A = 20), 1 > A && (A = 1), A = i.toExponential(A)) : Math.abs(i) < u && 0 > l ? (o = Math.round(Math.log(i) / Math.LN10), 20 < (A = A - 4 - (o = Math.round(Math.log(-o) / Math.LN10 + 1))) && (A = 20), 1 > A && (A = 1), A = i.toExponential(A)) : 0 > l ? (1 < Math.abs(i) ? (o = Math.round(Math.log(Math.abs(i)) / Math.LN10), A = Math.pow(10, A - o - 2)) : A = Math.pow(10, A - 2), A = (Math.round(Math.abs(i) * A) / A).toString(), 0 > i && (A = "-" + A)) : A = 0 == l ? Math.round(i).toString() : i.toFixed(l), -1 == A.indexOf("e") && (A = A.split("."), o = e.Jk(A[0], s), c = 1 < A.length ? A[1] : "", (1 < A.length || 0 < l) && 0 != s.um ? (-1 < s.um && c.length > s.um && (c = c.substr(0, s.um)), A = o + s.Br + c) : A = o), !n && 0 < h.length && (A = e.ZL(A, h, s.Fi, a)), e.EV(A, i);
              }
            }, {
              key: "Jk",
              value: function Jk(t) {
                var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                var s = 0 > parseFloat(t);
                s && (t = t.substr(1));
                var n = t;
                if (3 < t.length) {
                  null == i && (null == e.Ox && (e.Ox = new r.model.format.C.Eo("")), i = e.Ox), n = Math.floor(t.length / 3);
                  var a = [],
                    o = t.length % 3;
                  0 < o && a.push(t.substr(0, o));
                  for (var h = 0; h < n; h++) a.push(t.substr(o + 3 * h, 3));
                  n = a.join(i.Gh);
                }
                return s && (n = "-" + n), n;
              }
            }, {
              key: "ZL",
              value: function ZL(t, _e79, i, s) {
                return "left" != i || s ? t + _e79 : 0 == t.indexOf("-") ? "-" + _e79 + t.substr(1) : _e79 + t;
              }
            }, {
              key: "EV",
              value: function EV(t, _e80) {
                return 0 <= _e80 || -1 == t.indexOf("-") || -1 < t.search("[1-9]+") ? t : t.replace("-", "");
              }
            }]);
            return e;
          }();
          e.Ox = new r.model.format.C.Eo(), t.Fd = e;
        }(a || (a = {})), function (t) {
          var e;
          (e = t.u || (t.u = {})).SS = /*#__PURE__*/function () {
            function _class15() {
              _classCallCheck(this, _class15);
            }
            _createClass(_class15, null, [{
              key: "aZ",
              value: function aZ(t) {
                var i = null;
                switch (t.gg) {
                  case e.i.Te.jl:
                    i = 1 == t.hg ? new e.vj.rQ() : new e.vj.uA();
                    break;
                  case e.i.Te.JSON:
                    i = new e.json.tR();
                }
                return i;
              }
            }]);
            return _class15;
          }();
        }(r || (r = {})), function (t) {
          (t.u || (t.u = {})).sI = /*#__PURE__*/function () {
            function _class16() {
              _classCallCheck(this, _class16);
              this.type = "", this.fi = [];
            }
            return _createClass(_class16);
          }();
        }(r || (r = {}));
        var m = r || (r = {}),
          v = m.u || (m.u = {});
        v.i5 = /*#__PURE__*/function () {
          function _class17() {
            _classCallCheck(this, _class17);
          }
          return _createClass(_class17);
        }(), function (t) {
          !function (t) {
            var i = /*#__PURE__*/_createClass(function i() {
              _classCallCheck(this, i);
            });
            i.bB = "STRUCTURE_CONNECTED", i.rt = "STRUCTURE_LOADED", i.aB = "STRUCTURE_CANCELLED", i.cB = "STRUCTURE_LOADING_FAILED", i.Us = "BEFORE_QUERY", i.Ye = "QUERY_COMPLETE", i.gk = "QUERY_ERROR", t.Uc = i;
            var s = /*#__PURE__*/function (_e$ga5) {
              _inherits(s, _e$ga5);
              var _super48 = _createSuper(s);
              function s(t) {
                var _this64;
                _classCallCheck(this, s);
                _this64 = _super48.call(this, i.Us), _this64.xf = t;
                return _this64;
              }
              return _createClass(s);
            }(e.ga);
            t.Sv = s;
            var r = /*#__PURE__*/function (_e$ga6) {
              _inherits(r, _e$ga6);
              var _super49 = _createSuper(r);
              function r(t) {
                var _this65;
                _classCallCheck(this, r);
                _this65 = _super49.call(this, i.Ye), _this65.xf = t;
                return _this65;
              }
              return _createClass(r);
            }(e.ga);
            t.YA = r;
          }(t.u || (t.u = {}));
        }(r || (r = {})), function (t) {
          var i;
          !function (s) {
            var r = /*#__PURE__*/function (_e$Od16) {
              _inherits(r, _e$Od16);
              var _super50 = _createSuper(r);
              function r() {
                var _this66;
                _classCallCheck(this, r);
                _this66 = _super50.call(this), _this66.ae = [], _this66.mf = [], _this66.Bk = [], _this66.lf = [], _this66.Yd = [], _this66.Zk = [], _this66.fg = [], _this66.er = "", _this66.co = function () {
                  return _this66.Xp();
                }, _this66.hu = function (t) {
                  return _this66.KE(t);
                }, _this66.Hv = function () {
                  return _this66.iF();
                }, _this66.Ph = new a.ma(), _this66.fx = [], _this66.sB = [], _this66.Nh = new a.ma(), _this66.bx = new a.ma(), _this66.Xa = new a.ma(), _this66.Ie = 0, _this66.Tq = !1, _this66.$o = _this66.bn = _this66.Xt = 0, _this66.xf = i.i.Ze.Vm, _this66.fC = !1, _this66.EB = 0, r.counter++, _this66.O = i.Ja.V();
                return _this66;
              }
              _createClass(r, [{
                key: "dK",
                value: function dK() {
                  this.O.addEventListener(i.Uc.Ye, this.co, 1), this.O.addEventListener(i.Uc.Us, this.hu), this.O.addEventListener(i.Uc.rt, this.Hv, 1);
                }
              }, {
                key: "qv",
                value: function qv() {
                  this.O.removeEventListener(i.Uc.Ye, this.co), this.O.removeEventListener(i.Uc.Us, this.hu), this.O.removeEventListener(i.Uc.rt, this.Hv);
                }
              }, {
                key: "ta",
                get: function get() {
                  return null != this.Gt ? this.Gt : this.O.Ua;
                },
                set: function set(t) {
                  this.Gt = t;
                }
              }, {
                key: "slice",
                get: function get() {
                  return null != this.ab ? this.ab : this.O.fa;
                },
                set: function set(t) {
                  this.ab = t;
                }
              }, {
                key: "Tg",
                get: function get() {
                  return t.model.A.P.ph;
                },
                set: function set(t) {}
              }, {
                key: "rows",
                get: function get() {
                  return this.Ph;
                },
                set: function set(t) {}
              }, {
                key: "hc",
                get: function get() {
                  return this.slice.hc;
                },
                set: function set(t) {}
              }, {
                key: "Sj",
                get: function get() {
                  return this.fx;
                },
                set: function set(t) {}
              }, {
                key: "za",
                get: function get() {
                  return this.Nh;
                },
                set: function set(t) {}
              }, {
                key: "ed",
                get: function get() {
                  return this.slice.ed;
                },
                set: function set(t) {}
              }, {
                key: "eb",
                get: function get() {
                  return this.bx;
                },
                set: function set(t) {}
              }, {
                key: "Ia",
                get: function get() {
                  return this.Xa;
                },
                set: function set(t) {}
              }, {
                key: "Ee",
                get: function get() {
                  return this.Ie;
                },
                set: function set(t) {}
              }, {
                key: "Th",
                get: function get() {
                  return this.slice && this.Tq;
                },
                set: function set(t) {
                  this.Tq = t;
                }
              }, {
                key: "Bi",
                get: function get() {
                  return this.bn;
                },
                set: function set(t) {}
              }, {
                key: "fv",
                get: function get() {
                  return this.$o;
                },
                set: function set(t) {}
              }, {
                key: "zb",
                get: function get() {
                  return this.Na;
                },
                set: function set(t) {}
              }, {
                key: "nb",
                get: function get() {
                  return this.Qa;
                },
                set: function set(t) {}
              }, {
                key: "Rj",
                get: function get() {
                  return this.Na ? this.Na.Ba ? this.Na.va.length - 1 : this.Na.va.length : 0;
                },
                set: function set(t) {}
              }, {
                key: "Ai",
                get: function get() {
                  return this.Qa ? this.Qa.Ba ? this.Qa.va.length - 1 : this.Qa.va.length : 0;
                },
                set: function set(t) {}
              }, {
                key: "Yg",
                get: function get() {
                  return 1 < this.Xa.length || this.Qa.Ba && t.model.A.P.Js;
                },
                set: function set(t) {}
              }, {
                key: "HD",
                value: function HD() {
                  return this.Na && !this.slice.oc ? this.Na.jd : [];
                }
              }, {
                key: "VO",
                value: function VO(t) {
                  this.Na && !this.slice.oc && (this.Na.jd = t);
                }
              }, {
                key: "GD",
                value: function GD() {
                  return this.Qa && !this.slice.oc ? this.Qa.jd : [];
                }
              }, {
                key: "UO",
                value: function UO(t) {
                  this.Qa && !this.slice.oc && (this.Qa.jd = t);
                }
              }, {
                key: "BD",
                value: function BD() {
                  return this.Na && this.slice.oc ? this.Na.jd : [];
                }
              }, {
                key: "OO",
                value: function OO(t) {
                  this.Na && this.slice.oc && (this.Na.jd = t);
                }
              }, {
                key: "Ju",
                value: function Ju() {
                  return this.Qa && this.slice.oc ? this.Qa.jd : [];
                }
              }, {
                key: "NO",
                value: function NO(t) {
                  this.Qa && this.slice.oc && (this.Qa.jd = t);
                }
              }, {
                key: "Qr",
                value: function Qr() {
                  return this.Na && !this.slice.gd ? this.Na.hd : [];
                }
              }, {
                key: "GF",
                value: function GF(t) {
                  this.Na && !this.slice.gd && (this.Na.hd = t);
                }
              }, {
                key: "Pr",
                value: function Pr() {
                  return this.Qa && !this.slice.gd ? this.Qa.hd : [];
                }
              }, {
                key: "FF",
                value: function FF(t) {
                  this.Qa && !this.slice.gd && (this.Qa.hd = t);
                }
              }, {
                key: "Mu",
                value: function Mu() {
                  return this.Na && this.slice.gd ? this.Na.hd : [];
                }
              }, {
                key: "TO",
                value: function TO(t) {
                  this.Na && this.slice.gd && (this.Na.hd = t);
                }
              }, {
                key: "Lu",
                value: function Lu() {
                  return this.Qa && this.slice.gd ? this.Qa.hd : [];
                }
              }, {
                key: "SO",
                value: function SO(t) {
                  this.Qa && this.slice.gd && (this.Qa.hd = t);
                }
              }, {
                key: "Tf",
                get: function get() {
                  var t = i.i.ba.mb;
                  return this.Na && (t = this.Na.Nb) == i.i.ba.mb && this.Na.Fm && this.Na.cl != i.i.ba.mb && (t = this.Na.cl), t;
                },
                set: function set(t) {
                  this.Na && (this.Na.Nb = t);
                }
              }, {
                key: "Af",
                get: function get() {
                  if (this.Na) {
                    var t = this.Na.ah;
                    this.Na.Nb == i.i.ba.mb && this.Na.Fm && this.Na.cl != i.i.ba.mb && (t = []);
                  }
                  return t;
                },
                set: function set(t) {
                  this.Na && (this.Na.ah = t);
                }
              }, {
                key: "Yk",
                get: function get() {
                  if (this.Na) {
                    var t = this.Na.xg;
                    this.Na.Nb == i.i.ba.mb && this.Na.Fm && this.Na.cl != i.i.ba.mb && (t = this.Na.Fm);
                  }
                  return t;
                },
                set: function set(t) {
                  this.Na && (this.Na.xg = t);
                }
              }, {
                key: "Qy",
                get: function get() {
                  if (this.Tf == i.i.ba.mb || null == this.Af) return !1;
                  if (1 > this.Af.length) return !0;
                  var t = !1;
                  try {
                    t = this.Vg(this.Af.slice(0, this.Af.length - 1));
                  } catch (t) {}
                  return t;
                },
                set: function set(t) {}
              }, {
                key: "Gf",
                get: function get() {
                  var t = i.i.ba.mb;
                  return this.Qa && (t = this.Qa.Nb) == i.i.ba.mb && this.Qa.Fm && this.Qa.cl != i.i.ba.mb && (t = this.Qa.cl), t;
                },
                set: function set(t) {
                  this.Qa && (this.Qa.Nb = t);
                }
              }, {
                key: "af",
                get: function get() {
                  if (this.Qa) {
                    var t = this.Qa.ah;
                    this.Qa.Nb == i.i.ba.mb && this.Qa.Fm && this.Qa.cl != i.i.ba.mb && (t = []);
                  }
                  return t;
                },
                set: function set(t) {
                  this.Qa && (this.Qa.ah = t);
                }
              }, {
                key: "tj",
                get: function get() {
                  if (this.Qa) {
                    var t = this.Qa.xg;
                    this.Qa.Nb == i.i.ba.mb && this.Qa.Fm && this.Qa.cl != i.i.ba.mb && (t = this.Qa.Fm);
                  }
                  return t;
                },
                set: function set(t) {
                  this.Qa && (this.Qa.xg = t);
                }
              }, {
                key: "Zr",
                get: function get() {
                  if (this.Gf == i.i.ba.mb || null == this.af) return !1;
                  if (1 > this.af.length) return !0;
                  var t = !1;
                  try {
                    t = this.Lj(this.af.slice(0, this.af.length - 1));
                  } catch (t) {}
                  return t;
                },
                set: function set(t) {}
              }, {
                key: "reset",
                value: function reset() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                  this.Th = !1, this.Xa = new a.ma(), this.Ph = new a.ma(), this.Nh = new a.ma(), this.bx = new a.ma(), this.fx = [], this.sB = [], this.mf = [], this.lf = [], this.ae = [], this.Bk = [], this.Yd = [], this.fg = [], this.bn = this.Xt = 0, this.Zk = [], t && (this.Qa && (this.Qa.jd = []), this.Na && (this.Na.jd = []), this.Qa && (this.Qa.hd = []), this.Na && (this.Na.hd = []));
                }
              }, {
                key: "KE",
                value: function KE(t) {
                  this.xf = t.xf, this.Th = !1, t.xf == i.i.Ze.Vm && this.reset(), t.xf != i.i.Ze.BA && t.xf != i.i.Ze.AA || this.reset(!1);
                }
              }, {
                key: "Xp",
                value: function Xp() {
                  this.load();
                }
              }, {
                key: "iF",
                value: function iF() {
                  this.Th = !1, this.reset();
                }
              }, {
                key: "load",
                value: function load() {
                  if (null != this.ta || (this.ta = this.O.Ua, null != this.ta)) if (this.slice) {
                    if (this.Qa = this.slice.ve(i.i.da.rb), this.Na = this.slice.ve(i.i.da.Ka), 0 == this.Bk.length && 0 == this.ae.length || this.xf == i.i.Ze.gw) {
                      var t;
                      if (this.slice.oc ? this.ta.oc(this.slice.gd) : (this.ta.expand([], i.i.da.Ka, null), this.ta.expand([], i.i.da.rb, null)), (0 < this.Qr().length || 0 < this.Mu().length) && this.iJ(), (0 < this.Pr().length || 0 < this.Lu().length) && this.gJ(), this.xf == i.i.Ze.gw) if (this.slice.oc) {
                        var e = this.BD();
                        if (0 < e.length) for (t = 0; t < e.length; t++) try {
                          var s = this.slice.pa.F(e[t][0]),
                            _r10 = e[t].slice(1);
                          this.ta.collapse(_r10, i.i.da.Ka, s);
                        } catch (t) {}
                        if (e = this.Ju(), 0 < this.Ju().length) for (t = 0; t < this.Ju().length; t++) try {
                          s = this.slice.pa.F(e[t][0]), _r10 = e[t].slice(1), this.ta.collapse(_r10, i.i.da.rb, s);
                        } catch (t) {}
                      } else {
                        if (0 < (e = this.HD()).length) for (t = 0; t < e.length; t++) try {
                          s = this.slice.pa.F(e[t][0]), _r10 = e[t].slice(1), this.ta.expand(_r10, i.i.da.Ka, s);
                        } catch (t) {}
                        if (0 < (e = this.GD()).length) for (t = 0; t < e.length; t++) try {
                          s = this.slice.pa.F(e[t][0]), _r10 = e[t].slice(1), this.ta.expand(_r10, i.i.da.rb, s);
                        } catch (t) {}
                      }
                      (0 < this.Qr().length || 0 < this.Mu().length) && this.iJ(), (0 < this.Pr().length || 0 < this.Lu().length) && this.gJ();
                    }
                    this.Dz(), this.Th = !0;
                  } else this.Na = this.Qa = null;
                }
              }, {
                key: "iJ",
                value: function iJ() {
                  var t = this.zb.va.slice();
                  if (t.removeItem(i.Ja.re), this.slice.gd) for (var e = this.Mu(), s = 0; s < e.length; s++) try {
                    var _r11 = this.slice.pa.F(e[s][0]),
                      n = e[s].slice(2),
                      a = t.F(n.length - 1),
                      o = a.ua.getItem(e[s][1]);
                    this.ta.Xh(n, o, _r11) && this.ta.fm(n, o, i.i.da.Ka, _r11);
                  } catch (t) {} else for (e = this.Qr(), s = 0; s < e.length; s++) try {
                    if ("string" == typeof e[s][0]) {
                      var h = e[s][0];
                      _r11 = this.slice.pa.F(e[s][1]), n = e[s].slice(3), o = (a = t.F(n.length - 1)).ua.getItem(e[s][2]);
                    } else _r11 = this.slice.pa.F(e[s][0]), n = e[s].slice(2), o = (a = t.F(n.length - 1)).ua.getItem(e[s][1]);
                    if (void 0 !== h) {
                      if (a.by(h).Md < o.level.Md) {
                        var l = this.nV(o, h);
                        n[n.length - 1] = l.ra, a.eD(l), this.ta.fm(n, l, i.i.da.Ka, _r11);
                      } else this.ta.dD(n, o, i.i.da.Ka, h);
                    } else this.ta.Xh(n, o, _r11) || (this.ta.Vy(n, o, i.i.da.Ka), this.ta.Hk(n, o, i.i.da.Ka, _r11));
                  } catch (t) {}
                }
              }, {
                key: "gJ",
                value: function gJ() {
                  var t = this.nb.va.slice();
                  if (t.removeItem(i.Ja.re), this.slice.gd) for (var e = this.Lu(), s = 0; s < e.length; s++) try {
                    var _r12 = this.slice.pa.F(e[s][0]),
                      n = e[s].slice(2),
                      a = t.F(n.length - 1),
                      o = a.ua.getItem(e[s][1]);
                    this.ta.Kj(n, o, _r12) && this.ta.fm(n, o, i.i.da.rb, _r12);
                  } catch (t) {} else for (e = this.Pr(), s = 0; s < e.length; s++) try {
                    _r12 = this.slice.pa.F(e[s][0]), n = e[s].slice(2), o = (a = t.F(n.length - 1)).ua.getItem(e[s][1]), this.ta.Kj(n, o, _r12) || (this.ta.Vy(n, o, i.i.da.rb), this.ta.Hk(n, o, i.i.da.rb, _r12));
                  } catch (t) {}
                }
              }, {
                key: "Dz",
                value: function Dz() {
                  this.fC = !1, this.slice ? (this.Xa = this.slice.pa, this.Ie = this.Na.Ba ? this.Na.Ee : this.Qa.Ee, this.Ph = this.slice.rows, this.Nh = this.slice.za, this.bx = this.slice.eb) : (this.Xa = new a.ma(), this.Ie = 0, this.Ph = new a.ma(), this.Nh = new a.ma(), this.bx = new a.ma()), this.fx = [], this.sB = [], this.mf = [], this.lf = [], this.ae = [], this.Bk = [], this.Yd = [], this.fg = [], this.Zk = [], this.bn = this.Xt = 0;
                  var e,
                    i = this.ta.result[0],
                    s = this.ta.result[1];
                  if (!a.U(this.slice) && !this.slice.Db) {
                    if ((!this.Na.Ba || 1 < this.Ph.length || this.Tg) && this.mD(i, [], 0), ("on" == t.model.A.P.xc || "columns" == t.model.A.P.xc || this.Na.Ba && 1 == this.Ph.length) && (this.ae.push([]), this.Yd.push(0)), !this.Tg) if (this.Na.Ba && this.Yg) {
                      if (this.Yd = [], this.Zk = [], 1 < this.Ph.length) for (0 != this.Ee && this.Eu(i, [], -1, 0), e = 0; e < this.Xa.length; e++) "on" == t.model.A.P.xc || "columns" == t.model.A.P.xc ? (this.mf.push([[], e]), this.Yd.push(0)) : 0 != this.Ie || "off" != t.model.A.P.xc && "rows" != t.model.A.P.xc || (this.mf.push([[], e]), this.Yd.push(0)), 0 == this.Ee && this.Eu(i, [], e, 1);
                      if (0 == this.Ee && ("on" == t.model.A.P.xc || "columns" == t.model.A.P.xc || this.Na.Ba && 1 == this.Ph.length)) for (e = 0; e < this.Xa.length; e++) this.mf.push([[], e]), this.Yd.push(0);
                    } else this.mf = this.ae;
                    if ((!this.Qa.Ba || 1 < this.Nh.length) && this.QL(s, [], 0), this.$o = -1, ("on" == t.model.A.P.xc || "rows" == t.model.A.P.xc || this.Qa.Ba && 1 == this.Nh.length) && (this.Bk.push([]), this.fg.push(0)), this.Qa.Ba && this.Yg) {
                      if (this.fg = [], 1 < this.Nh.length) for (0 != this.Ie && this.Cu(s, [], -1, 0), e = 0; e < this.Xa.length; e++) "on" == t.model.A.P.xc || "rows" == t.model.A.P.xc ? (this.lf.push([[], e]), this.fg.push(0)) : 0 != this.Ie || "off" != t.model.A.P.xc && "columns" != t.model.A.P.xc || (this.lf.push([[], e]), this.fg.push(0)), 0 == this.Ie && this.Cu(s, [], e, 0);
                      if (0 == this.Ie && ("on" == t.model.A.P.xc || "rows" == t.model.A.P.xc || this.Qa.Ba && 1 == this.Nh.length)) for (e = 0; e < this.Xa.length; e++) this.lf.push([[], e]), this.fg.push(0);
                    } else this.lf = this.Bk;
                    for (i = 0; i < this.Yd.length; i++) this.Yd[i] > this.Xt && (this.Xt = this.Yd[i]);
                    for (this.Xt++, i = 0; i < this.fg.length; i++) this.fg[i] > this.bn && (this.bn = this.fg[i]);
                    this.bn++, 0 < this.slice.ed.length && this.Qa.Ba && this.Yg && this.bn++, -1 == this.$o ? this.$o = 0 == this.Ee ? 0 : this.bn : this.$o++, this.fC && t.yc(t.model.v.g.HR, t.model.v.g.IR, t.ld.to);
                  }
                }
              }, {
                key: "mD",
                value: function mD(t, e, i) {
                  var s = e.length;
                  (s = this.Na.Ba && e.length >= this.Ie ? this.Ph.F(s + 1) : this.Ph.F(s)) && (0 == i && (this.EB = Date.now()), this.Tg ? this.mJ(s.Qd, t, e, i) : this.SL(s.Qd, t, e, i));
                }
              }, {
                key: "gE",
                value: function gE(t) {
                  for (var e = 0; e < this.Ia.length; e++) if (!isNaN(this.Mb(t, [], this.Ia.F(e)))) return !1;
                  return !0;
                }
              }, {
                key: "gN",
                value: function gN(t) {
                  for (var e = 0; e < this.Ia.length; e++) if (!isNaN(this.Mb([], t, this.Ia.F(e)))) return !1;
                  return !0;
                }
              }, {
                key: "SL",
                value: function SL(t, e, i, s) {
                  if (null != t) {
                    var n = t.Kc.Cf(t, !1, "");
                    n = this.Dv(n, e, i), t = this.hc.indexOf(t.Kc.j) < this.hc.length - 1;
                    for (var a = 0; a < n.length; a++) {
                      var o = n.F(a);
                      if (0 == a && this.TL(o), null != e[o.ra] && !o.Qc) {
                        var h = i.slice(0);
                        if (h.push(o.ra), !this.gE(h)) {
                          var l = !o.Mj && this.ta.Xh(h, o),
                            A = t && this.ta.Vg(h);
                          this.ae.push(h), this.Yd.push(s), Date.now() - this.EB < r.CI && (l ? this.SL(o, e, i, s + 1) : A && this.mD(e[o.ra], h, s + 1));
                        }
                      }
                    }
                  }
                }
              }, {
                key: "Eu",
                value: function Eu(t, e, i, s) {
                  if (!this.Tg) {
                    var _r13 = e.length;
                    (_r13 = this.Na.Ba && e.length >= this.Ie ? this.Ph.F(_r13 + 1) : this.Ph.F(_r13)) && this.Yx(_r13.Qd, t, e, i, s);
                  }
                }
              }, {
                key: "Yx",
                value: function Yx(t, e, i, s, _r14) {
                  if (null != t) {
                    var n = i.length;
                    t = t.Kc.Cf(t, !1, ""), t = this.Dv(t, e, i);
                    for (var a, o = 0; o < t.length; o++) {
                      var h = t.F(o);
                      if (null != e[h.ra] && !h.Qc) {
                        var l = i.slice(0);
                        if (l.push(h.ra), !this.gE(l)) if (n < this.Ie) {
                          if (this.mf.push([l, -1]), this.Yd.push(_r14), n == this.Ie - 1 && this.ta.Vg(l, s)) for (a = 0; a < this.Xa.length; a++) this.ta.Xh(l, h, a) ? this.Yx(h, e, i, a, _r14 + 2) : (this.mf.push([l, a]), this.Yd.push(_r14 + 1), this.ta.Vg(l) && this.Eu(e[h.ra], l, a, _r14 + 2));else {
                            for (a = 0; a < this.Xa.length; a++) this.mf.push([l, a]), this.Yd.push(_r14 + 1);
                            this.ta.Xh(l, h, s) ? this.Yx(h, e, i, s, _r14 + 2) : this.ta.Vg(l, s) && this.Eu(e[h.ra], l, s, _r14 + 2);
                          }
                        } else this.mf.push([l, s]), this.Yd.push(_r14), this.ta.Xh(l, h, s) ? this.Yx(h, e, i, s, _r14 + 1) : this.ta.Vg(l, s) && this.Eu(e[h.ra], l, s, _r14 + 1);
                      }
                    }
                  }
                }
              }, {
                key: "mJ",
                value: function mJ(e, i, s, n) {
                  if (null != e) {
                    e = e.Kc.Cf(e, !1, ""), e = this.Dv(e, i, s);
                    for (var a = 0; a < e.length; a++) {
                      var o = e.F(a);
                      if (0 == a && this.TL(o), null != i[o.ra] && !o.Qc) {
                        var h = s.slice(0);
                        if (h.push(o.ra), !this.gE(h)) {
                          var l = this.ta.Xh(h, o),
                            A = this.ta.Vg(h),
                            c = this.ae.length;
                          this.Rj > h.length && (this.Zk[c] = 1, null == this.Yd[c] && (this.Yd[c] = n)), Date.now() - this.EB < r.CI ? l ? this.mJ(o, i, s, n + 1) : A && this.mD(i[o.ra], h, n + 1) : (l || A) && (this.fC = !0), l || A ? ("on" != t.model.A.P.cj && "rows" != t.model.A.P.cj || (this.ae.push(h), this.Zk[this.ae.length - 1] = 2, this.Yd[this.ae.length - 1] = n), l && this.Yd[c] > n && (this.Yd[c] = n, this.Zk[c] = 0)) : (this.ae.push(h), null == this.Zk[this.ae.length - 1] && (this.Zk[this.ae.length - 1] = 0, this.Yd[this.ae.length - 1] = n));
                        }
                      }
                    }
                  }
                }
              }, {
                key: "TL",
                value: function TL(t) {
                  this.RL(this.fx, t);
                }
              }, {
                key: "sX",
                value: function sX(t) {
                  this.RL(this.sB, t);
                }
              }, {
                key: "RL",
                value: function RL(t, e) {
                  -1 == t.indexOf(e.level.j) && (1 >= e.level.Md ? t.push(e.level.j) : t.splice(t.indexOf(e.parent.level.j) + 1, 0, e.level.j));
                }
              }, {
                key: "qN",
                value: function qN(t, e) {
                  for (var i = 0; i < t.length; i++) {
                    var s = e.F(i);
                    if (s.Sg()) {
                      var _r15 = s.ua.F(t[i]);
                      if (!s.filter.rc(_r15.j)) return !1;
                    }
                  }
                  return !0;
                }
              }, {
                key: "Dv",
                value: function Dv(t, e, s) {
                  if (!this.Zr) return t;
                  var _r16 = this.af;
                  if (!this.qN(_r16, this.ed)) return t;
                  for (var n, o = [], h = [], l = [], A = new a.ma(), c = 0; c < t.length; c++) if (null != e[(n = t.F(c)).ra] && !n.Qc) {
                    var u = s.slice(0);
                    u.push(n.ra), u = this.Mb(u, _r16, this.tj), isNaN(u) ? l.push(n) : (o.push(u), h.push(n));
                  }
                  for (t = this.Gf != i.i.ba.vb ? a.sa.sort(o, a.sa.Xe | a.sa.$f) : a.sa.sort(o, a.sa.Xe | a.sa.ih | a.sa.$f), c = 0; c < t.length; c++) null != (n = h[t[c]]) && A.Ea(n.j, n);
                  for (c = 0; c < l.length; c++) n = l[c], this.Gf == i.i.ba.vb ? A.Ea(n.j, n) : A.ip(n.j, n, c);
                  return A;
                }
              }, {
                key: "lP",
                value: function lP(t, e, s) {
                  if (!this.Qy) return t;
                  var _r17 = this.Af;
                  if (!this.qN(_r17, this.hc)) return t;
                  for (var n, o = [], h = [], l = [], A = new a.ma(), c = 0; c < t.length; c++) if (null != e[(n = t.F(c)).ra] && !n.Qc) {
                    var u = s.slice(0);
                    u.push(n.ra), u = this.Mb(_r17, u, this.Yk), isNaN(u) ? l.push(n) : (o.push(u), h.push(n));
                  }
                  for (t = this.Tf != i.i.ba.vb ? a.sa.sort(o, a.sa.Xe | a.sa.$f) : a.sa.sort(o, a.sa.Xe | a.sa.ih | a.sa.$f), c = 0; c < t.length; c++) null != (n = h[t[c]]) && A.Ea(n.j, n);
                  for (c = 0; c < l.length; c++) n = l[c], this.Tf == i.i.ba.vb ? A.Ea(n.j, n) : A.ip(n.j, n, c);
                  return A;
                }
              }, {
                key: "QL",
                value: function QL(t, e, i) {
                  var s = e.length;
                  (s = this.Qa.Ba && e.length >= this.Ie ? this.Nh.F(s + 1) : this.Nh.F(s)) && this.PL(s.Qd, t, e, i);
                }
              }, {
                key: "PL",
                value: function PL(t, e, i, s) {
                  t = t.Kc.Cf(t, !1, ""), t = this.lP(t, e, i);
                  for (var _r18 = 0; _r18 < t.length; _r18++) {
                    var n = t.F(_r18);
                    if (0 == _r18 && this.sX(n), null != e[n.ra] && !n.Qc) {
                      var a = i.slice(0);
                      if (a.push(n.ra), !this.gN(a)) {
                        var o = this.ta.Lj(a);
                        this.Bk.push(a), this.fg.push(s), this.ta.Kj(a, n) ? this.PL(n, e, i, s + 1) : o && this.QL(e[n.ra], a, s + 1);
                      }
                    }
                  }
                }
              }, {
                key: "Cu",
                value: function Cu(t, e, i, s) {
                  var _r19 = e.length;
                  (_r19 = this.Qa.Ba && e.length >= this.Ie ? this.Nh.F(_r19 + 1) : this.Nh.F(_r19)) && this.Xx(_r19.Qd, t, e, i, s);
                }
              }, {
                key: "Xx",
                value: function Xx(t, e, i, s, _r20) {
                  var n = i.length;
                  t = t.Kc.Cf(t, !1, ""), t = this.lP(t, e, i);
                  for (var a, o = 0; o < t.length; o++) {
                    var h = t.F(o);
                    if (null != e[h.ra] && !h.Qc) {
                      var l = i.slice(0);
                      if (l.push(h.ra), !this.gN(l)) {
                        var A = this.ta.Lj(l, s);
                        if (n < this.Ie) {
                          if (this.Qa.Ba && this.$o < _r20 + 1 && (this.$o = _r20 + 1), n == this.Ie - 1 && A) {
                            if (this.ta.Kj(l, h)) {
                              for (a = 0; a < this.Xa.length; a++) this.lf.push([l, a]), this.fg.push(_r20);
                              this.Xx(h, e, i, s, _r20 + 1);
                            } else for (a = 0; a < this.Xa.length; a++) this.lf.push([l, a]), this.fg.push(_r20), this.ta.Lj(l, a) && this.Cu(e[h.ra], l, a, _r20 + 1);
                          } else {
                            for (a = 0; a < this.Xa.length; a++) this.lf.push([l, a]), this.fg.push(_r20);
                            this.ta.Kj(l, h, s) ? this.Xx(h, e, i, s, _r20 + 1) : A && this.Cu(e[h.ra], l, s, _r20 + 1);
                          }
                        } else this.lf.push([l, s]), this.fg.push(_r20), this.ta.Kj(l, h, s) ? this.Xx(h, e, i, s, _r20 + 1) : A && this.Cu(e[h.ra], l, s, _r20 + 1);
                      }
                    }
                  }
                }
              }, {
                key: "Db",
                get: function get() {
                  return 0 == this.Bk.length && 0 == this.ae.length;
                },
                set: function set(t) {}
              }, {
                key: "DM",
                value: function DM(t) {
                  return this.Tg ? this.Yd[this.Na.Ba ? Math.floor(t / this.Xa.length) : t] : this.Yd[t];
                }
              }, {
                key: "KM",
                value: function KM(t) {
                  return this.Tg ? this.Zk[this.Na.Ba ? Math.floor(t / this.Xa.length) : t] : this.Zk[t];
                }
              }, {
                key: "CD",
                value: function CD() {
                  return 1;
                }
              }, {
                key: "iM",
                value: function iM(t) {
                  return this.fg[t];
                }
              }, {
                key: "HM",
                value: function HM(t) {
                  return this.Na.Ba && (t.length > this.Ie || 0 == this.Ie) ? t.length : t.length - 1;
                }
              }, {
                key: "GM",
                value: function GM(t) {
                  return this.Ph.F(this.HM(t));
                }
              }, {
                key: "jM",
                value: function jM(t) {
                  return this.Qa.Ba && (t.length > this.Ie || 0 == this.Ie) ? t.length : t.length - 1;
                }
              }, {
                key: "Nr",
                value: function Nr(t) {
                  return this.Nh.F(this.jM(t));
                }
              }, {
                key: "Hd",
                get: function get() {
                  return this.Bk.length;
                },
                set: function set(t) {}
              }, {
                key: "vd",
                get: function get() {
                  return this.ae.length;
                },
                set: function set(t) {}
              }, {
                key: "ig",
                get: function get() {
                  return this.lf.length;
                },
                set: function set(t) {}
              }, {
                key: "Jf",
                get: function get() {
                  return this.Tg ? (this.zb && this.zb.Ba ? this.Xa.length : 1) * this.ae.length : this.mf.length;
                },
                set: function set(t) {}
              }, {
                key: "Vg",
                value: function Vg(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  return this.ta.Vg(t, e);
                }
              }, {
                key: "Lj",
                value: function Lj(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  return this.ta.Lj(t, e);
                }
              }, {
                key: "Xh",
                value: function Xh(t, e) {
                  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  return this.ta.Xh(t, e, i);
                }
              }, {
                key: "Kj",
                value: function Kj(t, e) {
                  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  return this.ta.Kj(t, e, i);
                }
              }, {
                key: "ry",
                value: function ry(t) {
                  t = t.slice(0);
                  for (var e = this.Qa.Ba, i = e ? t.pop() : -1, s = this.lf, _r21 = 0; _r21 < s.length; _r21++) {
                    var n = !0;
                    if (e && this.Yg) {
                      if (i != s[_r21][1]) continue;
                      var a = s[_r21][0];
                    } else a = s[_r21];
                    if (a.length == t.length) {
                      for (var o = 0; o < a.length; o++) if (a[o] != t[o]) {
                        n = !1;
                        break;
                      }
                      if (n) return _r21;
                    }
                  }
                  return -1;
                }
              }, {
                key: "Fy",
                value: function Fy(t) {
                  t = t.slice(0);
                  for (var e = this.Na.Ba, i = e ? t.pop() : -1, s = this.Tg ? this.ae : this.mf, _r22 = 0; _r22 < s.length; _r22++) {
                    var n = !0;
                    if (e && this.Yg) {
                      if (i != s[_r22][1]) continue;
                      var a = s[_r22][0];
                    } else a = s[_r22];
                    if (a.length == t.length) {
                      for (var o = 0; o < a.length; o++) if (a[o] != t[o]) {
                        n = !1;
                        break;
                      }
                      if (n) return _r22;
                    }
                  }
                  return -1;
                }
              }, {
                key: "Ep",
                value: function Ep(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  return 0 > t || null == this.Na || null == this.Xa ? null : e && this.Na.Ba && this.Yg ? this.Tg ? (t = Math.floor(t / this.Xa.length), null == this.ae[t] ? null : this.ae[t].slice(0)) : null == this.mf[t] ? null : this.mf[t][0].slice(0) : null == this.ae[t] ? null : this.ae[t].slice(0);
                }
              }, {
                key: "Kk",
                value: function Kk(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  return 0 > t || null == this.Qa || null == this.Xa ? null : e && this.Qa.Ba && this.Yg ? null == this.lf[t] ? null : this.lf[t][0].slice() : null == this.Bk[t] ? null : this.Bk[t].slice();
                }
              }, {
                key: "lM",
                value: function lM() {
                  return null;
                }
              }, {
                key: "JM",
                value: function JM(t) {
                  return null == this.mf[t] ? -1 : this.Na.Ba && this.Yg ? this.mf[t][1] : -1;
                }
              }, {
                key: "kM",
                value: function kM(t) {
                  return null == this.lf[t] ? -1 : this.Qa.Ba && this.Yg ? this.lf[t][1] : -1;
                }
              }, {
                key: "AM",
                value: function AM(t, e) {
                  return null == this.Xa || null == this.Na || null == this.Qa ? null : this.Yg ? this.Na.Ba ? this.Tg ? (e = t % this.Xa.length, null == this.ae[Math.floor(t / this.Ia.length)] ? this.Xa.F(0) : this.Xa.F(e)) : null == this.mf[t] ? this.Xa.F(0) : this.Xa.F(this.mf[t][1]) : null == this.lf[e] ? this.Xa.F(0) : this.Xa.F(this.lf[e][1]) : this.Xa.F(0);
                }
              }, {
                key: "yj",
                value: function yj(t, e, i) {
                  return this.ta.yj(t, e, i);
                }
              }, {
                key: "save",
                value: function save(t, e, i, s, _r23) {
                  this.ta.save(t, e, i, s, _r23);
                }
              }, {
                key: "Uu",
                value: function Uu(t, e, i) {
                  return this.ta.Uu(t, e, i);
                }
              }, {
                key: "Cy",
                value: function Cy() {
                  return null;
                }
              }, {
                key: "Mb",
                value: function Mb(t, e, s) {
                  if (s.Fa == i.i.ca.jj) {
                    var _r24 = this.ta.Mb([], [], s);
                    return t = this.ta.Mb(t, e, s), Math.abs(100 * t / _r24);
                  }
                  if (s.Fa == i.i.ca.Jh) return _r24 = this.ta.Mb([], e, s), 100 * (t = this.ta.Mb(t, e, s)) / _r24;
                  if (s.Fa == i.i.ca.ki) return _r24 = this.ta.Mb(t, [], s), 100 * (t = this.ta.Mb(t, e, s)) / _r24;
                  if (s.Fa == i.i.ca.rl) {
                    _r24 = this.ta.Mb([], [], s);
                    var n = this.ta.Mb(t, [], s),
                      a = this.ta.Mb([], e, s);
                    return t = this.ta.Mb(t, e, s), Math.abs(_r24 * t / (a * n));
                  }
                  return s.Fa == i.i.ca.ll ? this.vy(t, e, s, !1) : s.Fa == i.i.ca.ji ? this.vy(t, e, s, !0) : s.Fa == i.i.ca.hk ? this.ta.LM(t, e, s, this.zb.Ba ? i.i.da.Ka : i.i.da.rb) : this.ta.Mb(t, e, s);
                }
              }, {
                key: "vy",
                value: function vy(t, e, i, s) {
                  return this.zb.Ba ? this.uY(t, e, i, s) : this.vY(t, e, i, s);
                }
              }, {
                key: "uY",
                value: function uY(t, e, i, s) {
                  if (0 < this.za.length) {
                    var _r25 = this.ry(e);
                    if (0 > _r25) return 0;
                    if (0 == _r25 || 0 == e.length) return NaN;
                    if (_r25 = this.Kk(_r25 - 1), e.length != _r25.length) return NaN;
                    _r25 = this.ta.Mb(t, _r25, i);
                  } else {
                    if (t.slice(0), t.push(-1), _r25 = this.Fy(t), t.pop(), 0 == _r25 || 0 == t.length) return NaN;
                    if (0 > _r25) return 0;
                    if (_r25 = this.Ep(_r25 - 1, !0), t.length != _r25.length) return NaN;
                    _r25 = this.ta.Mb(_r25, e, i);
                  }
                  return t = this.ta.Mb(t, e, i), s ? (t - _r25) / _r25 * 100 : t - _r25;
                }
              }, {
                key: "vY",
                value: function vY(t, e, i, s) {
                  if (0 < this.rows.length) {
                    var _r26 = this.Fy(t);
                    if (0 == _r26 || 0 == t.length) return NaN;
                    if (0 > _r26) return 0;
                    if (_r26 = this.Ep(_r26 - 1), t.length != _r26.length) return NaN;
                    _r26 = this.ta.Mb(_r26, e, i);
                  } else {
                    if ((e = e.slice(0)).push(0), _r26 = this.ry(e), e.pop(), 0 == _r26 || 0 == e.length) return NaN;
                    if (0 > _r26) return 0;
                    if (_r26 = this.Kk(_r26 - 1, !0), e.length != _r26.length) return NaN;
                    _r26 = this.ta.Mb(t, _r26, i);
                  }
                  return t = this.ta.Mb(t, e, i), s ? (t - _r26) / _r26 * 100 : t - _r26;
                }
              }, {
                key: "nr",
                value: function nr(t, e, i, s) {
                  return this.ta.nr(t, e, i, s);
                }
              }, {
                key: "xp",
                value: function xp(t) {
                  this.Th && null != (t = this.slice.bb().getItem(t)) && this.mX(t);
                }
              }, {
                key: "mX",
                value: function mX(t) {
                  var e = this.slice.rows.rc(t.j) ? i.i.da.Ka : i.i.da.rb;
                  if ((t = e == i.i.da.Ka ? this.slice.hc.indexOf(t.j) : this.slice.ed.indexOf(t.j)) + 1 != (e == i.i.da.Ka ? this.slice.hc.length : this.slice.ed.length)) {
                    var s = [],
                      _r27 = (e == i.i.da.Ka ? this.slice.hc : this.slice.ed).slice(0, t + 1);
                    this.Tu([], _r27, s), _r27 = e == this.slice.Rh.j ? this.slice.Rh.Ee : -1;
                    for (var n = 0; n < s.length; n++) if (0 <= _r27 && _r27 <= t && 1 < this.slice.pa.length) for (var a = 0; a < this.slice.pa.length; a++) {
                      var o = this.slice.pa.F(a);
                      s[n].length > _r27 ? this.expand(s[n], e, o, !1) : this.expand(s[n], e, null, !1);
                    } else this.expand(s[n], e, null, !1);
                    this.O.na(new i.YA(i.i.Ze.GA));
                  }
                }
              }, {
                key: "Tu",
                value: function Tu(t, e, i) {
                  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
                  if (0 != e.length) {
                    var _r28 = e.F(0);
                    _r28 = _r28.Sg() ? _r28.filter : _r28.ua;
                    for (var n = 0; n < _r28.length; n++) {
                      var a = _r28.F(n);
                      if (!a.Qc) {
                        var o = t.slice(0);
                        o.push(a.ra), (s || !s && 1 == e.length) && i.push(o.slice(0)), this.Tu(o.slice(0), e.slice(1), i, s);
                      }
                    }
                  }
                }
              }, {
                key: "rp",
                value: function rp(t) {
                  this.Th && null != (t = this.slice.bb().getItem(t)) && this.VV(t);
                }
              }, {
                key: "VV",
                value: function VV(t) {
                  var e = this.slice.rows.rc(t.j) ? i.i.da.Ka : i.i.da.rb;
                  if ((t = e == i.i.da.Ka ? this.slice.hc.indexOf(t.j) : this.slice.ed.indexOf(t.j)) + 1 != (e == i.i.da.Ka ? this.slice.hc.length : this.slice.ed.length)) {
                    var s = [],
                      _r29 = (e == i.i.da.Ka ? this.slice.hc : this.slice.ed).slice(0, t + 1);
                    this.Tu([], _r29, s, !1), _r29 = e == this.slice.Rh.j ? this.slice.Rh.Ee : -1;
                    for (var n = 0; n < s.length; n++) if (0 <= _r29 && _r29 <= t && 1 < this.slice.pa.length) for (var a = 0; a < this.slice.pa.length; a++) {
                      var o = this.slice.pa.F(a);
                      s[n].length > _r29 ? this.collapse(s[n], e, o, !1) : this.collapse(s[n], e, null, !1);
                    } else this.collapse(s[n], e, null, !1);
                    this.O.na(new i.YA(i.i.Ze.wG));
                  }
                }
              }, {
                key: "oc",
                value: function oc() {
                  this.Th && (this.reset(), this.slice.oc ? this.ta.oc(this.slice.gd) : this.O.select());
                }
              }, {
                key: "sort",
                value: function sort() {
                  this.Dz(), this.O.Oa(t.model.sb.kc.lj);
                }
              }, {
                key: "expand",
                value: function expand(e, s) {
                  var _r30 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
                  var a = this.slice.ve(s),
                    o = e.slice(0);
                  if (o.unshift(_r30 && a.Ba ? this.Xa.indexOf(_r30.j) : -1), this.slice.oc) {
                    if (s == i.i.da.Ka) {
                      var h = [],
                        l = this.BD();
                      for (a = 0; a < l.length; a++) o.toString() != l[a].toString() && h.push(l[a]);
                      this.OO(h);
                    } else {
                      for (h = [], l = this.Ju(), a = 0; a < l.length; a++) o.toString() != l[a].toString() && h.push(l[a]);
                      this.NO(h);
                    }
                  } else s == i.i.da.Ka ? ((h = this.HD().slice(0)).push(o), this.VO(h)) : ((h = this.GD().slice(0)).push(o), this.UO(h));
                  this.O.expand(e, s, _r30, n), this.O.Oa(t.model.sb.kc.lj);
                }
              }, {
                key: "collapse",
                value: function collapse(e, s) {
                  var _r31 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
                  s == i.i.da.Ka && e.slice(0, e.length - 1), s == i.i.da.rb && e.slice(0, e.length - 1);
                  var a = this.slice.ve(s),
                    o = e.slice(0);
                  if (o.unshift(_r31 && a.Ba ? this.Xa.indexOf(_r31.j) : -1), this.slice.oc) {
                    if (s == i.i.da.Ka) {
                      var h = this.BD().slice(0);
                      h.push(o), this.OO(h);
                    } else (h = this.Ju().slice(0)).push(o), this.NO(h);
                  } else if (s == i.i.da.Ka) {
                    h = [];
                    var l = this.HD();
                    for (a = 0; a < l.length; a++) o.toString() != l[a].toString() && h.push(l[a]);
                    this.VO(h);
                  } else {
                    for (h = [], l = this.GD(), a = 0; a < l.length; a++) o.toString() != l[a].toString() && h.push(l[a]);
                    this.UO(h);
                  }
                  this.O.collapse(e, s, _r31, n), this.O.Oa(t.model.sb.kc.lj);
                }
              }, {
                key: "fm",
                value: function fm(e, s, _r32) {
                  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                  var a = this.slice.ve(_r32),
                    o = [],
                    h = e.slice(0);
                  if (h.unshift(s.j), h.unshift(n && a.Ba ? this.Xa.indexOf(n.j) : -1), this.slice.gd) _r32 == i.i.da.Ka ? ((o = this.Mu().slice(0)).push(h), this.TO(o)) : ((o = this.Lu().slice(0)).push(h), this.SO(o));else if (_r32 == i.i.da.Ka) {
                    var l,
                      A = this.Qr();
                    for (l in A) "string" == typeof (a = A[l])[0] && (a = a.slice(1)), a.toString() != h.toString() && o.push(a);
                    this.GF(o);
                  } else {
                    for (l in A = this.Pr()) "string" == typeof (a = A[l])[0] && (a = a.slice(1)), a.toString() != h.toString() && o.push(a);
                    this.FF(o);
                  }
                  this.O.fm(e, s, _r32, n), this.O.Oa(t.model.sb.kc.lj);
                }
              }, {
                key: "nV",
                value: function nV(t, e) {
                  for (; void 0 !== t && t.level.j != e;) t = t.parent;
                  return t;
                }
              }, {
                key: "Hk",
                value: function Hk(e, s, _r33) {
                  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                  var a = this.slice.ve(_r33),
                    o = [],
                    h = e.slice(0);
                  if (h.unshift(s.j), h.unshift(n && a.Ba ? this.Xa.indexOf(n.j) : -1), this.slice.gd) {
                    if (_r33 == i.i.da.Ka) {
                      var l,
                        A = this.Mu();
                      for (l in A) (a = A[l]).toString() != h.toString() && o.push(a);
                      this.TO(o);
                    } else {
                      for (l in A = this.Lu()) (a = A[l]).toString() != h.toString() && o.push(a);
                      this.SO(o);
                    }
                  } else _r33 == i.i.da.Ka ? ((o = this.Qr().slice(0)).push(h), this.GF(o)) : ((o = this.Pr().slice(0)).push(h), this.FF(o));
                  this.O.Hk(e, s, _r33, n), this.O.Oa(t.model.sb.kc.lj);
                }
              }, {
                key: "dD",
                value: function dD(t, e, s, _r34) {
                  var n = this.slice.ve(s);
                  (t = t.slice(0)).unshift(e.j), t.unshift(_r34 && n.Ba ? this.Xa.indexOf(_r34.j) : -1), t.unshift(void 0), s == i.i.da.Ka ? ((e = this.Qr().slice(0)).push(t), this.GF(e)) : ((e = this.Pr().slice(0)).push(t), this.FF(e));
                }
              }], [{
                key: "V",
                value: function V() {
                  return null == r.instance && (r.instance = new r(), r.instance.er = "grid" + r.counter), r.instance;
                }
              }, {
                key: "la",
                value: function la() {
                  r.instance && (r.instance.qv(), r.instance.Rc()), r.instance = null;
                }
              }]);
              return r;
            }(e.Od);
            r.counter = 0, r.CI = 9e3, s.Hw = r;
          }((i = t.u || (t.u = {})).qf || (i.qf = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (e) {
            var i = /*#__PURE__*/function () {
              function i() {
                _classCallCheck(this, i);
              }
              _createClass(i, null, [{
                key: "Qb",
                value: function Qb() {
                  var r = "";
                  return "" == r && (r = t.model.A.P.Dc ? s.Ih : s.lS), (r = r == s.Ih ? e.xH.V() : e.Hw.V()).dK(), i.Ng != r ? (i.Ng && i.Ng.qv(), r.load()) : t.model.A.P.zm && (r.load(), t.model.A.P.zm = !1), i.Ng = r, i.Ng;
                }
              }, {
                key: "la",
                value: function la() {
                  e.xH.la(), e.Hw.la(), i.Ng = null;
                }
              }]);
              return i;
            }();
            i.Ng = null, e.bk = i;
            var s = /*#__PURE__*/_createClass(function s() {
              _classCallCheck(this, s);
            });
            s.lS = "pivot", s.Ih = "flat", e.z4 = s;
          }((e = t.u || (t.u = {})).qf || (e.qf = {}));
        }(r || (r = {})), function (t) {
          var i;
          !function (t) {
            var s = /*#__PURE__*/function (_e$Od17) {
              _inherits(s, _e$Od17);
              var _super51 = _createSuper(s);
              function s() {
                var _this67;
                _classCallCheck(this, s);
                _this67 = _super51.call(this), _this67.Xa = new a.ma(), _this67.Tq = !1, _this67.co = function () {
                  return _this67.Xp();
                }, _this67.El = i.i.ba.mb, _this67.Dl = null, _this67.Ij = [], _this67.zi = [], _this67.O = i.Ja.V();
                return _this67;
              }
              _createClass(s, [{
                key: "ta",
                get: function get() {
                  return null != this.Gt ? this.Gt : this.O.Ua;
                },
                set: function set(t) {
                  this.Gt = t;
                }
              }, {
                key: "slice",
                get: function get() {
                  return null != this.ab ? this.ab : this.O.fa;
                },
                set: function set(t) {
                  this.ab = t;
                }
              }, {
                key: "Ia",
                get: function get() {
                  return this.Xa;
                },
                set: function set(t) {}
              }, {
                key: "Yg",
                get: function get() {
                  return 1 < this.Xa.length;
                },
                set: function set(t) {}
              }, {
                key: "Th",
                get: function get() {
                  return this.slice && this.Tq;
                },
                set: function set(t) {}
              }, {
                key: "dK",
                value: function dK() {
                  this.O.addEventListener(i.Uc.Ye, this.co, 1);
                }
              }, {
                key: "qv",
                value: function qv() {
                  this.O.removeEventListener(i.Uc.Ye, this.co);
                }
              }, {
                key: "load",
                value: function load() {
                  null == this.ta && (this.ta = this.O.Ua, null == this.ta) || this.slice && (this.ta.expand([], i.i.da.Ka, null), this.ta.expand([], i.i.da.rb, null), this.Dz(), this.Tq = !0);
                }
              }, {
                key: "Xp",
                value: function Xp() {
                  this.load();
                }
              }, {
                key: "Dz",
                value: function Dz() {
                  var t,
                    e = this.slice ? this.slice.flatten(!0) : new a.ma();
                  for (this.zi.length = 0, this.DC = new a.ma(), this.Xa = new a.ma(), t = 0; t < e.length; t++) {
                    var _s41 = e.F(t),
                      r = this.O.ea.og(_s41.j);
                    null == r && (r = this.O.ea.yk.getItem(_s41.j)), r && this.Xa.Ea(r.j, r), this.zi.push(this.ta.cb.indexOf(_s41.j)), this.DC.Ea(_s41.j, this.zi.length - 1);
                  }
                  if (this.Zr) this.RJ();else for (t = 0; t < e.length; t++) if ((_s41 = e.F(t)).Gc != i.i.ba.mb) {
                    this.El = _s41.Gc, this.Dl = this.Kk(t), this.cn = this.O.ea.og(_s41.j), null == this.cn && (this.cn = this.O.ea.yk.getItem(_s41.j)), this.sort();
                    break;
                  }
                }
              }, {
                key: "Ee",
                get: function get() {
                  return 0;
                },
                set: function set(t) {}
              }, {
                key: "Bi",
                get: function get() {
                  return 0;
                },
                set: function set(t) {}
              }, {
                key: "fv",
                get: function get() {
                  return 0;
                },
                set: function set(t) {}
              }, {
                key: "rows",
                get: function get() {
                  return new a.ma();
                },
                set: function set(t) {}
              }, {
                key: "hc",
                get: function get() {
                  return new a.ma();
                },
                set: function set(t) {}
              }, {
                key: "Sj",
                get: function get() {
                  return [];
                },
                set: function set(t) {}
              }, {
                key: "za",
                get: function get() {
                  return new a.ma();
                },
                set: function set(t) {}
              }, {
                key: "ed",
                get: function get() {
                  return new a.ma();
                },
                set: function set(t) {}
              }, {
                key: "eb",
                get: function get() {
                  return new a.ma();
                },
                set: function set(t) {}
              }, {
                key: "zb",
                get: function get() {
                  return new i.oa.ej(i.i.da.Ka);
                },
                set: function set(t) {}
              }, {
                key: "nb",
                get: function get() {
                  return new i.oa.ej(i.i.da.rb);
                },
                set: function set(t) {}
              }, {
                key: "Rj",
                get: function get() {
                  return 1;
                },
                set: function set(t) {}
              }, {
                key: "Ai",
                get: function get() {
                  return 0;
                },
                set: function set(t) {}
              }, {
                key: "Tf",
                get: function get() {
                  return null;
                },
                set: function set(t) {}
              }, {
                key: "Af",
                get: function get() {
                  return null;
                },
                set: function set(t) {}
              }, {
                key: "Yk",
                get: function get() {
                  return null;
                },
                set: function set(t) {}
              }, {
                key: "Qy",
                get: function get() {
                  return !1;
                },
                set: function set(t) {}
              }, {
                key: "Gf",
                get: function get() {
                  return this.El;
                },
                set: function set(t) {
                  t = t.toLowerCase(), this.El = t == i.i.ba.ub || t == i.i.ba.vb ? t : i.i.ba.mb;
                }
              }, {
                key: "af",
                get: function get() {
                  return this.Dl;
                },
                set: function set(t) {
                  this.Dl = t;
                }
              }, {
                key: "tj",
                get: function get() {
                  return this.cn;
                },
                set: function set(t) {
                  this.cn = t;
                }
              }, {
                key: "Zr",
                get: function get() {
                  return this.El != i.i.ba.mb && null != this.Dl;
                },
                set: function set(t) {}
              }, {
                key: "reset",
                value: function reset() {
                  this.Tq = !1, this.hC = null, this.Xa = new a.ma(), this.Ij.length = 0, this.zi.length = 0, this.DC = new a.ma(), this.Dl = this.cn = null, this.El = i.i.ba.mb;
                }
              }, {
                key: "Db",
                get: function get() {
                  return 0 == this.zi.length;
                },
                set: function set(t) {}
              }, {
                key: "DM",
                value: function DM() {
                  return 0;
                }
              }, {
                key: "KM",
                value: function KM() {
                  return 0;
                }
              }, {
                key: "CD",
                value: function CD() {
                  return 0;
                }
              }, {
                key: "iM",
                value: function iM() {
                  return 1;
                }
              }, {
                key: "HM",
                value: function HM() {
                  return 0;
                }
              }, {
                key: "GM",
                value: function GM(t) {
                  return this.Nr(t);
                }
              }, {
                key: "jM",
                value: function jM() {
                  return 0;
                }
              }, {
                key: "Nr",
                value: function Nr(t) {
                  return this.O.ea.bb().getItem(this.ta.keys[t[0]]);
                }
              }, {
                key: "Hd",
                get: function get() {
                  return this.zi.length;
                },
                set: function set(t) {}
              }, {
                key: "vd",
                get: function get() {
                  return this.ta ? this.ta.result[0] : 0;
                },
                set: function set(t) {}
              }, {
                key: "ig",
                get: function get() {
                  return this.zi.length;
                },
                set: function set(t) {}
              }, {
                key: "Jf",
                get: function get() {
                  return this.ta.Vr();
                },
                set: function set(t) {}
              }, {
                key: "Vg",
                value: function Vg() {
                  return !1;
                }
              }, {
                key: "Lj",
                value: function Lj() {
                  return !1;
                }
              }, {
                key: "Xh",
                value: function Xh() {
                  return !1;
                }
              }, {
                key: "Kj",
                value: function Kj() {
                  return !1;
                }
              }, {
                key: "ry",
                value: function ry(t) {
                  for (var e = 0; e < this.zi.length; e++) if (this.zi[e].toString() == t.toString()) return e;
                  return -1;
                }
              }, {
                key: "Fy",
                value: function Fy(t) {
                  if (!(0 < this.Ij.length && t[0] < this.Ij.length)) return t[0];
                  for (var e = 0; e < this.Ij.length; e++) if (this.Ij[e].toString() == t.toString()) return e;
                  return -1;
                }
              }, {
                key: "Ep",
                value: function Ep(t) {
                  return 0 > t ? null : 0 < this.Ij.length && t < this.Ij.length ? [this.Ij[t]] : [t];
                }
              }, {
                key: "Kk",
                value: function Kk(t) {
                  return 0 > t ? null : 0 < this.zi.length && t < this.zi.length ? [this.zi[t]] : [t];
                }
              }, {
                key: "lM",
                value: function lM(t) {
                  return t = this.DC.getItem(t), this.Kk(t, !1);
                }
              }, {
                key: "JM",
                value: function JM() {
                  return 0;
                }
              }, {
                key: "kM",
                value: function kM() {
                  return 0;
                }
              }, {
                key: "AM",
                value: function AM(t, e) {
                  return t = this.Kk(e), this.Xa.getItem(this.ta.cb[t[0]]);
                }
              }, {
                key: "Uu",
                value: function Uu(t, e, i) {
                  return null == t ? this.ta.yM(null, i) : this.ta.yM(t[0], i);
                }
              }, {
                key: "Mb",
                value: function Mb(t, e, _s42) {
                  return null == e && null == t ? this.ta.Mb([], [], _s42) : this.ta.KD(t[0], e[0], _s42, _s42.type != i.types.Ca.Hb);
                }
              }, {
                key: "Cy",
                value: function Cy(t, e, i) {
                  return null == e && null == t ? null : this.ta.Cy(t[0], e[0], i);
                }
              }, {
                key: "sort",
                value: function sort() {
                  this.RJ();
                }
              }, {
                key: "RJ",
                value: function RJ() {
                  if (this.Zr) {
                    this.cn.type != i.types.Ca.Hb ? this.Dv() : this.t3(), this.hC && (this.hC.Gc = i.i.ba.mb);
                    var t = this.Nr(this.Dl);
                    t && (t.Gc = this.El, this.hC = t);
                  }
                }
              }, {
                key: "Dv",
                value: function Dv() {
                  var t,
                    e = [];
                  for (t = 0; t < this.Jf; t++) {
                    var _s43 = this.Mb([t], this.Dl, this.cn);
                    e[t] = isNaN(_s43) ? Number.NEGATIVE_INFINITY : _s43;
                  }
                  this.Ij = this.El != i.i.ba.vb ? a.sa.sort(e, a.sa.Xe | a.sa.$f) : a.sa.sort(e, a.sa.Xe | a.sa.ih | a.sa.$f);
                }
              }, {
                key: "t3",
                value: function t3() {
                  var _this68 = this;
                  var t = this.Nr(this.Dl);
                  if (null != t) {
                    var e = [],
                      _s44 = t.Fb.F(1).type,
                      r = _s44 == i.types.Ab.$m || _s44 == i.types.Ab.Ef || _s44 == i.types.Ab.ii;
                    for (_s44 = 0; _s44 < this.Jf; _s44++) {
                      var n = this.Mb([_s44], this.Dl, this.cn);
                      n = t.ua.F(n), e.push(r ? n.j : n.caption);
                    }
                    if (r) {
                      for (this.QF = {}, r = t.Cf(t.Qd, !1, this.El), _s44 = 0; _s44 < t.ua.length; _s44++) n = t.ua.F(_s44), this.QF[n.j] = r.indexOf(n.j);
                      this.Ij = a.sa.oP(e, a.sa.$f, function (t, e) {
                        return _this68.n3(t, e);
                      });
                    } else this.Ij = this.El != i.i.ba.vb ? a.sa.sort(e, a.sa.$f) : a.sa.sort(e, a.sa.ih | a.sa.$f);
                  }
                }
              }, {
                key: "n3",
                value: function n3(t, e) {
                  return (t = this.QF[t]) > (e = this.QF[e]) ? 1 : t < e ? -1 : 0;
                }
              }, {
                key: "nr",
                value: function nr(t, e, i, _s45) {
                  return this.ta.tV(i, _s45);
                }
              }, {
                key: "xp",
                value: function xp() {}
              }, {
                key: "rp",
                value: function rp() {}
              }, {
                key: "oc",
                value: function oc() {}
              }, {
                key: "expand",
                value: function expand() {}
              }, {
                key: "collapse",
                value: function collapse() {}
              }, {
                key: "fm",
                value: function fm() {}
              }, {
                key: "Hk",
                value: function Hk() {}
              }, {
                key: "yj",
                value: function yj() {
                  return [];
                }
              }, {
                key: "save",
                value: function save(t, e, i, _s46) {
                  this.ta.s2(t, e, i, _s46);
                }
              }, {
                key: "Tg",
                get: function get() {
                  return !1;
                },
                set: function set(t) {}
              }], [{
                key: "V",
                value: function V() {
                  return null == s.instance && (s.instance = new s()), s.instance;
                }
              }, {
                key: "la",
                value: function la() {
                  s.instance && (s.instance.Rc(), s.instance.qv()), s.instance = null;
                }
              }]);
              return s;
            }(e.Od);
            t.xH = s;
          }((i = t.u || (t.u = {})).qf || (i.qf = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function (_t$Hw) {
              _inherits(e, _t$Hw);
              var _super52 = _createSuper(e);
              function e() {
                _classCallCheck(this, e);
                return _super52.call(this);
              }
              _createClass(e, [{
                key: "Tg",
                get: function get() {
                  return !1;
                },
                set: function set(t) {}
              }], [{
                key: "V",
                value: function V() {
                  return null == e.Nc && (e.Nc = new e(), e.Nc.er = "chart" + t.Hw.counter), e.Nc;
                }
              }, {
                key: "la",
                value: function la() {
                  e.Nc && (e.Nc.qv(), e.Nc.Rc()), e.Nc = null;
                }
              }]);
              return e;
            }(t.Hw);
            t.vQ = e;
          }((e = t.u || (t.u = {})).qf || (e.qf = {}));
        }(r || (r = {})), function (t) {
          var e;
          ((e = t.u || (t.u = {})).oa || (e.oa = {})).lt = /*#__PURE__*/function () {
            function _class18(t) {
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              _classCallCheck(this, _class18);
              this.data = {}, this.j = t, this.caption = e;
            }
            _createClass(_class18, [{
              key: "caption",
              get: function get() {
                return this.ib;
              },
              set: function set(e) {
                null == e && (e = ""), "number" == typeof (e = e.toString()) ? this.ib = "" + e : "" == e.trim() ? this.ib = t.model.v.g.Cg : this.ib = e;
              }
            }, {
              key: "j",
              get: function get() {
                return this.jC;
              },
              set: function set(t) {
                this.jC = t;
              }
            }, {
              key: "Ww",
              value: function Ww(t) {
                if (this.gn(t)) return this.data[t];
              }
            }, {
              key: "hx",
              value: function hx(t, e) {
                this.data[t] = e;
              }
            }, {
              key: "gn",
              value: function gn(t) {
                return this.data.hasOwnProperty(t);
              }
            }, {
              key: "toString",
              value: function toString() {
                return this.j;
              }
            }, {
              key: "Sa",
              value: function Sa() {
                var t = {};
                return t.caption = this.caption, t.uniqueName = this.j, t;
              }
            }, {
              key: "Za",
              value: function Za(t) {
                for (var e in t) null != this[e] && (this[e] = t[e]);
              }
            }]);
            return _class18;
          }();
        }(r || (r = {})), function (t) {
          var e;
          !function (i) {
            var s = /*#__PURE__*/function (_i$lt) {
              _inherits(s, _i$lt);
              var _super53 = _createSuper(s);
              function s(t) {
                var _this69;
                var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                _classCallCheck(this, s);
                _this69 = _super53.call(this, t, r), _this69.Vc = 1, _this69.HJ = 0, _this69.oB = _this69.Wq = "", _this69.bg = s.Yv, _this69.SJ = null, _this69.nk = new a.ma(), _this69.pk = new a.ma(), _this69.lB = !1, _this69.Il = new a.ma(), _this69.mB = !1, _this69.cr = new a.ma(), _this69.Vw = new a.ma(), _this69.UB = new a.ma(), _this69.nJ = !0, _this69.MJ = [], _this69.cache = [], _this69.Lg = [], _this69.Ot = e.i.Dd.NONE, _this69.Nt = -1, _this69.FB = "", r = t + ".(All)";
                var n = new i.Xf(r, "All", 0);
                _this69.dg(n), t += ".(All Member)", n = new i.qe(t, "All"), _this69.Oc(n, r), _this69.pC = t;
                return _this69;
              }
              _createClass(s, [{
                key: "xj",
                get: function get() {
                  return this.JT;
                },
                set: function set(t) {
                  this.JT = t;
                }
              }, {
                key: "type",
                get: function get() {
                  return this.Vc;
                },
                set: function set(t) {
                  this.Vc = t;
                }
              }, {
                key: "origin",
                get: function get() {
                  return this.HJ;
                },
                set: function set(t) {
                  this.HJ = t;
                }
              }, {
                key: "qF",
                get: function get() {
                  return this.ua.length;
                },
                set: function set(t) {}
              }, {
                key: "folder",
                get: function get() {
                  return this.Wq;
                },
                set: function set(t) {
                  this.Wq = "undefined" == t ? "" : t;
                }
              }, {
                key: "Fb",
                get: function get() {
                  return this.UB;
                },
                set: function set(t) {}
              }, {
                key: "dg",
                value: function dg(t) {
                  t.lb = this, this.UB.Ea(t.j, t), this.Vw.ip(t.j, new a.ma(), t.Md);
                }
              }, {
                key: "by",
                value: function by(t) {
                  return this.UB.getItem(t);
                }
              }, {
                key: "Rk",
                get: function get() {
                  return 2 < this.Fb.length;
                },
                set: function set(t) {}
              }, {
                key: "tf",
                get: function get() {
                  return this.j == e.Ja.re;
                },
                set: function set(t) {}
              }, {
                key: "Zx",
                get: function get() {
                  return this.nJ;
                },
                set: function set(t) {
                  this.nJ = t;
                }
              }, {
                key: "ua",
                get: function get() {
                  return this.cr;
                },
                set: function set(t) {}
              }, {
                key: "clear",
                value: function clear() {
                  this.cr = new a.ma();
                }
              }, {
                key: "Oc",
                value: function Oc(e) {
                  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  var _s47 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
                  "" == i && (i = this.Fb && 1 < this.Fb.length ? this.Fb.F(1).j : this.j + "." + this.caption, this.caption == t.model.v.g.Cg && (i = this.j + ".[]")), null == this.xe(e.j) && (e.Kc = this, e.parent = this.xe(_s47) || this.Qd, e.level = this.by(i), null != e.parent && e.parent.R(e), e.ra = this.cr.length, this.cr.Ea(e.j, e), this.cache = [], this.Lg = []);
                }
              }, {
                key: "CL",
                value: function CL(t) {
                  null != t && (t.Zu = !0, this.Vw.getItem(t.level.j).Ea(t.j, t));
                }
              }, {
                key: "eD",
                value: function eD(t) {
                  t.Zu = !1, this.Vw.getItem(t.level.j).removeItem(t.j), t = t.up;
                  for (var e = 0; e < t.length; e++) {
                    var i = t.F(e);
                    i.Zu && this.eD(i);
                  }
                }
              }, {
                key: "gX",
                value: function gX(t) {
                  return this.Vw.getItem(t.j);
                }
              }, {
                key: "BL",
                get: function get() {
                  for (var t = 1; t < this.Fb.length; t++) {
                    var e = this.Fb.F(t);
                    if (0 == this.gX(e).length) return t;
                  }
                  return 1;
                },
                set: function set(t) {}
              }, {
                key: "XL",
                value: function XL(t) {
                  for (var e = 0; e < this.ua.length; e++) if (this.ua.F(e).caption == t) return this.ua.F(e);
                  return null;
                }
              }, {
                key: "xe",
                value: function xe(t) {
                  return this.ua.getItem(t);
                }
              }, {
                key: "QV",
                value: function QV() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  this.Gc = t ? e.i.ba.mb : s.Yv;
                }
              }, {
                key: "Gc",
                get: function get() {
                  return this.bg;
                },
                set: function set(t) {
                  this.bg = t;
                }
              }, {
                key: "cA",
                get: function get() {
                  return this.SJ;
                },
                set: function set(t) {
                  this.SJ = t;
                }
              }, {
                key: "sort",
                value: function sort() {
                  return this.Cf(this.Qd);
                }
              }, {
                key: "Cf",
                value: function Cf(t) {
                  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                  var _s48 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
                  if (null == t) return new a.ma();
                  if (e.i.ba.XZ(_s48) || (_s48 = this.bg), i) {
                    if (null != this.Lg[t.ra]) {
                      if (null != this.Lg[t.ra][_s48]) return this.Lg[t.ra][_s48];
                      if (!this.Rk) {
                        if (_s48 == e.i.ba.vb && null != this.Lg[t.ra][e.i.ba.ub]) return this.Lg[t.ra][e.i.ba.vb] = this.Lg[t.ra][e.i.ba.ub].reverse(), this.Lg[t.ra][e.i.ba.vb];
                        if (_s48 == e.i.ba.ub && null != this.Lg[t.ra][e.i.ba.vb]) return this.Lg[t.ra][e.i.ba.ub] = this.Lg[t.ra][e.i.ba.vb].reverse(), this.Lg[t.ra][e.i.ba.ub];
                      }
                    }
                  } else if (null != this.cache[t.ra]) {
                    if (null != this.cache[t.ra][_s48]) return this.cache[t.ra][_s48];
                    if (!this.Rk) {
                      if (_s48 == e.i.ba.vb && null != this.cache[t.ra][e.i.ba.ub]) return this.cache[t.ra][e.i.ba.vb] = this.cache[t.ra][e.i.ba.ub].reverse(), this.cache[t.ra][e.i.ba.vb];
                      if (_s48 == e.i.ba.ub && null != this.cache[t.ra][e.i.ba.vb]) return this.cache[t.ra][e.i.ba.ub] = this.cache[t.ra][e.i.ba.vb].reverse(), this.cache[t.ra][e.i.ba.ub];
                    }
                  }
                  var r = this.bg;
                  this.bg = _s48;
                  var n = i ? t.up : t.children;
                  return 1e6 < n.length ? n = i ? t.up : t.children : this.bg == e.i.ba.mb ? 0 < (n = i ? t.up : t.children).length && n.F(0).Qc && n.vF() : n = this.l3(t, i), i ? (null == this.Lg[t.ra] && (this.Lg[t.ra] = []), this.Lg[t.ra][_s48] = n) : (null == this.cache[t.ra] && (this.cache[t.ra] = []), this.cache[t.ra][_s48] = n), this.bg = r, n;
                }
              }, {
                key: "jU",
                value: function jU(t, i) {
                  var _s49 = t.hY();
                  t = _s49.sj, _s49 = _s49.ua, this.bg == e.i.ba.vb && (t = t.reverse(), _s49 = _s49.reverse());
                  for (var r = new a.ma(), n = 0; n < t.length; n++) if (null != t[n]) {
                    var o;
                    this.bg === e.i.ba.ub && (o = a.sa.sort(t[n], a.sa.il | a.sa.$f)), this.bg === e.i.ba.vb && (o = a.sa.sort(t[n], a.sa.ih | a.sa.il | a.sa.$f));
                    for (var h = 0; h < o.length; h++) {
                      var l = _s49[n][o[h]];
                      r.oK(l.j, l), i && 0 < (l = this.Cf(l)).length && r.concat(l, !1);
                    }
                  }
                  return r;
                }
              }, {
                key: "DV",
                value: function DV(i) {
                  try {
                    if ("month" == i.level.caption.toLowerCase()) return !0;
                    if (12 < i.children.length) return !1;
                    for (var _s50 = 0; _s50 < i.children.length; _s50++) {
                      var r = i.children.F(_s50).caption.split(" ")[0];
                      if (-1 == t.model.v.g.fk.indexOf(r) && -1 == t.model.v.g.Qm.indexOf(r)) return !1;
                    }
                    var n = i.Kc.Fb.indexOf(i.level.j);
                    return !(i.Kc.Fb.length < n + 2 || (i.Kc.Fb.F(n + 1).type = e.types.Ab.Ef, i.Kc.Fb.F(n + 2).type = e.types.Ab.ii, 0));
                  } catch (t) {}
                  return !1;
                }
              }, {
                key: "l3",
                value: function l3(t, i) {
                  var _s51 = this.Fb.F(t.level.Md + 1),
                    r = _s51 && _s51.type == e.types.Ab.$m,
                    n = _s51 && _s51.type == e.types.Ab.BH,
                    o = _s51 && _s51.type == e.types.Ab.pt,
                    h = _s51 && _s51.type == e.types.Ab.Ef,
                    l = _s51 && _s51.type == e.types.Ab.qT,
                    A = _s51 && _s51.type == e.types.Ab.ii,
                    c = _s51 && _s51.type == e.types.Ab.DH,
                    u = _s51 && _s51.type == e.types.Ab.YH,
                    d = _s51 && _s51.type == e.types.Ab.Rb,
                    f = _s51 && _s51.type == e.types.Ab.td || _s51 && _s51.type == e.types.Ab.jc,
                    p = _s51 && _s51.type == e.types.Ab.NI,
                    g = this.cA == e.i.ba.bS;
                  if (!(o || h || l || f || A || c || u || d || p)) {
                    if (1e3 < t.children.length) return this.jU(t, i);
                    this.DV(t) && (h = !0);
                  }
                  var w = t.children.Tc();
                  for (o || h || l || A || c || u || p || n || r ? w = this.s3(w, _s51 ? _s51.type : -1) : f ? w = this.m3(w) : d ? (this.bg === e.i.ba.ub && a.sa.sort(w, a.sa.Xe, function (t) {
                    return t.qg;
                  }), this.bg === e.i.ba.vb && a.sa.sort(w, a.sa.ih | a.sa.Xe, function (t) {
                    return t.qg;
                  })) : g ? w.sort(this.D_) : (this.bg === e.i.ba.ub && a.sa.sort(w, a.sa.il, function (t) {
                    return t.caption;
                  }), this.bg === e.i.ba.vb && a.sa.sort(w, a.sa.ih | a.sa.il, function (t) {
                    return t.caption;
                  })), _s51 = new a.ma(), r = 0; r < w.length; r++) n = w[r], _s51.oK(n.j, n), i && !t.Mj && 0 < (n = this.Cf(n, i)).length && _s51.concat(n, !1);
                  return _s51;
                }
              }, {
                key: "s3",
                value: function s3(t, i) {
                  return i == e.types.Ab.Ef ? t = this.p3(t) : i == e.types.Ab.ii ? t = this.u3(t) : i == e.types.Ab.pt || i == e.types.Ab.BH || i == e.types.Ab.$m ? t = a.sa.lo(t, "caption", a.sa.il | (this.Gc == e.i.ba.vb ? a.sa.ih : 0)) : (this.Gc == e.i.ba.ub && a.sa.lo(t, "levelOrdinal", a.sa.Xe), this.Gc == e.i.ba.vb && a.sa.lo(t, "levelOrdinal", a.sa.ih | a.sa.Xe)), t;
                }
              }, {
                key: "p3",
                value: function p3(t) {
                  var _this70 = this;
                  for (var i = [], _s52 = [], r = 0; r < t.length; ++r) {
                    var n = t[r];
                    this.FT(n.caption) ? _s52.push(n) : i.push(n);
                  }
                  return this.Gc == e.i.ba.ub && a.sa.lo(i, "caption", a.sa.il), this.Gc == e.i.ba.vb && a.sa.lo(i, "caption", a.sa.ih | a.sa.il), _s52.sort(function (t, e) {
                    return _this70.NW(t, e);
                  }), _s52.concat(i);
                }
              }, {
                key: "u3",
                value: function u3(t) {
                  var _this71 = this;
                  for (var i = [], _s53 = [], r = 0; r < t.length; ++r) {
                    var n = t[r];
                    this.GT(n.caption) ? _s53.push(n) : i.push(n);
                  }
                  return this.Gc == e.i.ba.ub && a.sa.lo(i, "caption", a.sa.il | a.sa.Xe), this.Gc == e.i.ba.vb && a.sa.lo(i, "caption", a.sa.ih | a.sa.il | a.sa.Xe), _s53.sort(function (t, e) {
                    return _this71.f4(t, e);
                  }), _s53.concat(i);
                }
              }, {
                key: "FT",
                value: function FT(e) {
                  return -1 != t.model.v.g.fk.indexOf(e) || -1 != t.model.v.g.Qm.indexOf(e);
                }
              }, {
                key: "GT",
                value: function GT(e) {
                  return -1 != t.model.v.g.Qo.indexOf(e) || -1 != t.model.v.g.Ro.indexOf(e);
                }
              }, {
                key: "NW",
                value: function NW(i, _s54) {
                  var r = this.Gc == e.i.ba.ub ? t.model.v.g.fk.indexOf(i.caption) : t.model.v.g.fk.indexOf(_s54.caption);
                  -1 == r && (r = this.Gc == e.i.ba.ub ? t.model.v.g.Qm.indexOf(i.caption) : t.model.v.g.Qm.indexOf(_s54.caption));
                  var n = this.Gc == e.i.ba.ub ? t.model.v.g.fk.indexOf(_s54.caption) : t.model.v.g.fk.indexOf(i.caption);
                  return -1 == n && (n = this.Gc == e.i.ba.ub ? t.model.v.g.Qm.indexOf(_s54.caption) : t.model.v.g.Qm.indexOf(i.caption)), r > n ? 1 : r < n ? -1 : 0;
                }
              }, {
                key: "f4",
                value: function f4(i, _s55) {
                  var r = this.Gc == e.i.ba.ub ? t.model.v.g.Qo.indexOf(i.caption) : t.model.v.g.Qo.indexOf(_s55.caption);
                  -1 == r && (r = this.Gc == e.i.ba.ub ? t.model.v.g.Ro.indexOf(i.caption) : t.model.v.g.Ro.indexOf(_s55.caption));
                  var n = this.Gc == e.i.ba.ub ? t.model.v.g.Qo.indexOf(_s55.caption) : t.model.v.g.Qo.indexOf(i.caption);
                  return -1 == n && (n = this.Gc == e.i.ba.ub ? t.model.v.g.Ro.indexOf(_s55.caption) : t.model.v.g.Ro.indexOf(i.caption)), r > n ? 1 : r < n ? -1 : 0;
                }
              }, {
                key: "m3",
                value: function m3(t) {
                  return this.bg == e.i.ba.ub && a.sa.sort(t, a.sa.Xe, function (t) {
                    return t.qg;
                  }), this.bg == e.i.ba.vb && a.sa.sort(t, a.sa.ih | a.sa.Xe, function (t) {
                    return t.qg;
                  }), t;
                }
              }, {
                key: "D_",
                value: function D_(t, e) {
                  return t = t.caption.match(/(?:\d*\.)?\d+/), e = e.caption.match(/(?:\d*\.)?\d+/), (t = t && 0 < t.length ? parseFloat(t[0]) : Number.POSITIVE_INFINITY) > (e = e && 0 < e.length ? parseFloat(e[0]) : Number.POSITIVE_INFINITY) ? 1 : t < e ? -1 : 0;
                }
              }, {
                key: "filter",
                get: function get() {
                  return 0 < this.nk.length ? this.nk : this.Me;
                },
                set: function set(t) {
                  this.nk = t;
                }
              }, {
                key: "Me",
                get: function get() {
                  return this.mB && (this.pk = new a.ma(), 0 < this.Il.length && (this.pk = this.cL(this.Il)), this.mB = !1), this.pk;
                },
                set: function set(t) {
                  t.length + 1 == this.ua.length && (t = new a.ma()), this.lB = !0, this.pk = t, this.Il = new a.ma();
                }
              }, {
                key: "oD",
                get: function get() {
                  return this.lB && (this.Il = new a.ma(), 0 < this.pk.length && (this.Il = this.cL(this.pk)), this.lB = !1), this.Il;
                },
                set: function set(t) {
                  t.length + 1 == this.ua.length && (t = new a.ma()), this.mB = !0, this.Il = t, this.pk = new a.ma();
                }
              }, {
                key: "cL",
                value: function cL(t) {
                  for (var e = this.ua.slice(1), i = 0; i < t.length; i++) {
                    var _s56 = t.F(i);
                    e.removeItem(_s56.j), this.wF(e, _s56), _s56.parent && this.qO(e, _s56.parent);
                  }
                  return this.JK(e, this.Qd), e;
                }
              }, {
                key: "JK",
                value: function JK(t, e) {
                  for (var i = 0; i < e.children.length; i++) {
                    var _s57 = e.children.F(i);
                    0 < _s57.children.length && (t.getItem(_s57.j) ? t.getItem(_s57.children.F(0).j) && this.wF(t, _s57) : this.JK(t, _s57));
                  }
                }
              }, {
                key: "wF",
                value: function wF(t, e) {
                  if (e) {
                    e = e.children;
                    for (var i = 0; i < e.length; i++) t.removeItem(e.F(i).j), this.wF(t, e.F(i));
                  }
                }
              }, {
                key: "qO",
                value: function qO(t, e) {
                  e && (t.removeItem(e.j), e.parent && this.qO(t, e.parent));
                }
              }, {
                key: "Jd",
                get: function get() {
                  return -1 == this.Nt ? e.i.Dd.NONE : this.Ot;
                },
                set: function set(t) {
                  t = t.toLowerCase(), this.Ot = t == e.i.Dd.ut || t == e.i.Dd.tq ? t : e.i.Dd.NONE;
                }
              }, {
                key: "bf",
                get: function get() {
                  return this.Nt;
                },
                set: function set(t) {
                  isNaN(t) || 1 > t ? (this.Nt = -1, this.Ot = e.i.Dd.NONE) : this.Nt = t;
                }
              }, {
                key: "pd",
                get: function get() {
                  return this.FB;
                },
                set: function set(t) {
                  this.FB = t;
                }
              }, {
                key: "vn",
                value: function vn() {
                  this.NV(), this.zx();
                }
              }, {
                key: "NV",
                value: function NV() {
                  this.nk = new a.ma(), this.pk = new a.ma(), this.Il = new a.ma();
                }
              }, {
                key: "zx",
                value: function zx() {
                  this.nk = new a.ma(), this.Nt = -1, this.Ot = e.i.Dd.NONE, this.FB = "";
                }
              }, {
                key: "Sg",
                value: function Sg() {
                  return this.Wu() || this.$r();
                }
              }, {
                key: "Wu",
                value: function Wu() {
                  return 0 < this.pk.length || 0 < this.Il.length;
                }
              }, {
                key: "$r",
                value: function $r() {
                  return this.Ot && this.Jd != e.i.Dd.NONE;
                }
              }, {
                key: "tX",
                value: function tX() {
                  for (var t = new a.ma(), e = 0 < this.nk.length ? this.nk : this.pk, i = 0; i < e.length; i++) {
                    var _s58 = e.F(i);
                    1 == _s58.level.Md && t.Ea(_s58.j, _s58);
                  }
                  return t;
                }
              }, {
                key: "pC",
                get: function get() {
                  return this.oB;
                },
                set: function set(t) {
                  this.oB = t;
                }
              }, {
                key: "Qd",
                get: function get() {
                  return this.nB || (this.nB = this.xe(this.oB), this.CL(this.nB)), this.nB;
                },
                set: function set(t) {}
              }, {
                key: "pF",
                get: function get() {
                  return this.MJ;
                },
                set: function set(t) {
                  this.MJ = t;
                }
              }], [{
                key: "Sa",
                value: function Sa(t) {
                  var e = {};
                  return e.uniqueName = t.j, e.caption = t.caption, e.filterEnabled = t.Zx, e.sortName = t.Gc, e.sortAs = t.cA, e.type = t.type, e.filter = s.vX(t), e;
                }
              }, {
                key: "vX",
                value: function vX(t) {
                  if (0 == t.Sg()) return null;
                  var e = {};
                  return t.$r() && (e = {
                    type: t.Jd,
                    quantity: t.bf,
                    measure: t.pd,
                    measureName: t.pd
                  }), t.Wu() && (t.Me.length < t.ua.length / 2 ? e.members = t.Me.Tc(!0) : (e.negation = !0, e.members = t.oD.Tc(!0))), e;
                }
              }, {
                key: "Za",
                value: function Za(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var i = t.uniqueName;
                  return null == e && (e = new s(i)), t.hasOwnProperty("caption") && (e.caption = t.caption), t.hasOwnProperty("sortName") && (e.Gc = t.sortName), t.hasOwnProperty("sortAs") && (e.cA = t.sortAs), t.hasOwnProperty("filterEnabled") && (e.Zx = t.filterEnabled), t.hasOwnProperty("type") && (e.type = t.type), t.hasOwnProperty("origin") && (e.origin = t.origin), t.hasOwnProperty("folder") && (e.folder = t.folder), t.hasOwnProperty("filter") && s.VL(t.filter, e), t.hasOwnProperty("allMemberName") && (e.pC = t.allMemberName), e;
                }
              }, {
                key: "VL",
                value: function VL(t, i) {
                  if (null != t) {
                    if (t.hasOwnProperty("members")) {
                      for (var _s59, r, n = new a.ma(), o = 0; o < t.members.length; o++) _s59 = "string" == typeof t.members[o] ? t.members[o] : t.members[o].j, null != (r = i.xe(_s59)) && n.Ea(_s59, r);
                      t.negation ? i.oD = n : i.Me = n;
                    }
                    _s59 = t.hasOwnProperty("type") ? t.type : e.i.Dd.NONE, r = t.hasOwnProperty("quantity") ? Number(t.quantity) : -1, n = "", t.hasOwnProperty("measureName") && (n = t.measureName), t.hasOwnProperty("measure") && (n = t.measure), _s59 != e.i.Dd.NONE && (i.Jd = _s59, i.bf = r, i.pd = n);
                  }
                }
              }]);
              return s;
            }(i.lt);
            s.Yv = "asc", i.de = s;
          }((e = t.u || (t.u = {})).oa || (e.oa = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function (_t$lt) {
              _inherits(e, _t$lt);
              var _super54 = _createSuper(e);
              function e(t) {
                var _this72;
                var _e81 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                _classCallCheck(this, e);
                _this72 = _super54.call(this, t, _e81), _this72.Vc = 1, new a.ma(), _this72.XB = i;
                return _this72;
              }
              _createClass(e, [{
                key: "Md",
                get: function get() {
                  return this.XB;
                },
                set: function set(t) {
                  this.XB = t;
                }
              }, {
                key: "type",
                get: function get() {
                  return this.Vc;
                },
                set: function set(t) {
                  this.Vc = t;
                }
              }, {
                key: "jE",
                get: function get() {
                  return this.hn.Fb.length - 1 == this.XB;
                },
                set: function set(t) {}
              }, {
                key: "lb",
                get: function get() {
                  return this.hn;
                },
                set: function set(t) {
                  this.hn = t;
                }
              }]);
              return e;
            }(t.lt);
            t.Xf = e;
          }((e = t.u || (t.u = {})).oa || (e.oa = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var i = /*#__PURE__*/function (_t$lt2) {
              _inherits(i, _t$lt2);
              var _super55 = _createSuper(i);
              function i(t, e) {
                var _this73;
                _classCallCheck(this, i);
                _this73 = _super55.call(this, t, e), _this73.YB = 1, _this73.DJ = 0, _this73.zJ = !1, _this73.Rt = _this73.ax = -1;
                return _this73;
              }
              _createClass(i, [{
                key: "ra",
                get: function get() {
                  return this.YB;
                },
                set: function set(t) {
                  this.YB = t;
                }
              }, {
                key: "qg",
                get: function get() {
                  return this.DJ;
                },
                set: function set(t) {
                  this.DJ = t;
                }
              }, {
                key: "Kc",
                get: function get() {
                  return this.hn;
                },
                set: function set(t) {
                  this.hn = t;
                }
              }, {
                key: "parent",
                get: function get() {
                  return this.eU;
                },
                set: function set(t) {
                  this.eU = t;
                }
              }, {
                key: "root",
                get: function get() {
                  if (2 > this.CJ.Md) return this;
                  var t = this;
                  do {
                    t = t.parent;
                  } while (1 < t.level.Md);
                  return t;
                },
                set: function set(t) {}
              }, {
                key: "level",
                get: function get() {
                  return this.CJ;
                },
                set: function set(t) {
                  this.CJ = t;
                }
              }, {
                key: "Qc",
                get: function get() {
                  return null != this.Kc.Qd && this.Kc.Qd.j == this.j;
                },
                set: function set(t) {}
              }, {
                key: "Zu",
                get: function get() {
                  return this.zJ;
                },
                set: function set(t) {
                  this.zJ = t;
                }
              }, {
                key: "children",
                get: function get() {
                  return this.gn("_children_") ? this.Ww("_children_") : new a.ma();
                },
                set: function set(t) {}
              }, {
                key: "up",
                get: function get() {
                  if (this.gn("_descendants_")) return this.Ww("_descendants_");
                  var t = new a.ma();
                  if (t.Ea(this.j, this), 0 == this.nz) return t;
                  for (var e = this.children.length, _i26 = 0; _i26 < e; _i26++) {
                    var s = this.children.F(_i26);
                    s.Mj ? t.Ea(s.j, s) : 0 < s.nz ? t.concat(s.up, !1) : t.Ea(s.j, s);
                  }
                  return 0 < t.length && this.hx("descendants", t), t;
                },
                set: function set(t) {}
              }, {
                key: "nz",
                get: function get() {
                  if (-1 < this.ax) return this.ax;
                  if (!this.gn("_children_")) return this.ax = 0;
                  for (var t = this.children.length, e = t, _i27 = 0; _i27 < t; _i27++) e += this.children.F(_i27).nz;
                  return e;
                },
                set: function set(t) {}
              }, {
                key: "hY",
                value: function hY() {
                  return {
                    sj: this.sj,
                    ua: this.op
                  };
                }
              }, {
                key: "BC",
                value: function BC() {
                  this.gn("_descendants_") && delete this._descendants_, this.parent && this.parent.BC();
                }
              }, {
                key: "sj",
                get: function get() {
                  return this.gn("_captions_") || (this.sj = []), this.Ww("_captions_");
                },
                set: function set(t) {
                  this.hx("_captions_", t);
                }
              }, {
                key: "op",
                get: function get() {
                  return this.gn("_captionMembers_") || (this.op = []), this.Ww("_captionMembers_");
                },
                set: function set(t) {
                  this.hx("_captionMembers_", t);
                }
              }, {
                key: "R",
                value: function R(t) {
                  var e = this.children;
                  e.Ea(t.j, t), this.hx("_children_", e), t.parent = this, this.ax = -1, this.BC(), 1 == this.VM(t) && (e = t.caption.charAt(0).toLowerCase().charCodeAt(0), null == this.sj[e] && (this.sj[e] = [], this.op[e] = []), this.sj[e].push(t.caption), this.op[e].push(t)), 1e6 < this.children.length && (this.Rt = 0, this.sj = [], this.op = []);
                }
              }, {
                key: "removeChild",
                value: function removeChild(t) {
                  if (this.children.removeItem(t.j), this.BC(), 1 == this.VM(t)) {
                    var e = t.caption.charAt(0).toLowerCase().charCodeAt(0);
                    t = this.sj[e].indexOf(t.caption), this.sj[e].splice(t, 1), this.op[e].splice(t, 1);
                  }
                }
              }, {
                key: "VM",
                value: function VM(t) {
                  return -1 != this.Rt ? this.Rt : this.Rt = t.level.type == e.types.Ab.DH || t.level.type == e.types.Ab.YH || t.level.type == e.types.Ab.ii || t.level.type == e.types.Ab.Rb ? 0 : 1;
                }
              }, {
                key: "toString",
                value: function toString() {
                  return this.j + " : " + this.YB;
                }
              }, {
                key: "Mj",
                get: function get() {
                  return !this.gn("_children_") || 0 == this.children.length;
                },
                set: function set(t) {}
              }], [{
                key: "Sa",
                value: function Sa(t) {
                  var e = {};
                  return e.uniqueName = t.j, e.caption = t.caption, e.hierarchyName = t.Kc.j, e;
                }
              }]);
              return i;
            }(t.lt);
            t.qe = i;
          }((e = t.u || (t.u = {})).oa || (e.oa = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (i) {
            var s = /*#__PURE__*/function (_i$lt2) {
              _inherits(s, _i$lt2);
              var _super56 = _createSuper(s);
              function s(t) {
                var _this74;
                var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                _classCallCheck(this, s);
                _this74 = _super56.call(this, t, i), _this74.qJ = _this74.Wq = "", _this74.Vc = e.types.Ca.Rb, _this74.Nq = _this74.Qt = "", _this74.Bl = [], _this74.Ya = [], _this74.rJ = "", _this74.tJ = _this74.vJ = !1, _this74.Tw = e.i.ca.ik;
                return _this74;
              }
              _createClass(s, [{
                key: "caption",
                get: function get() {
                  if (this.tB) return this.tB;
                  if (0 == t.model.A.P.bA) return this.ib;
                  switch (this.Fa) {
                    case e.i.ca.Hb:
                      return a.$.bind(t.model.v.g.DG, this.ib);
                    case e.i.ca.Tm:
                      return a.$.bind(t.model.v.g.nI, this.ib);
                    case e.i.ca.zg:
                      return a.$.bind(t.model.v.g.NG, this.ib);
                    case e.i.ca.Hm:
                      return a.$.bind(t.model.v.g.fG, this.ib);
                    case e.i.ca.MAX:
                      return a.$.bind(t.model.v.g.NH, this.ib);
                    case e.i.ca.MIN:
                      return a.$.bind(t.model.v.g.$H, this.ib);
                    case e.i.ca.jj:
                      return a.$.bind(t.model.v.g.jI, this.ib);
                    case e.i.ca.Jh:
                      return a.$.bind(t.model.v.g.gI, this.ib);
                    case e.i.ca.ki:
                      return a.$.bind(t.model.v.g.iI, this.ib);
                    case e.i.ca.rl:
                      return a.$.bind(t.model.v.g.EH, this.ib);
                    case e.i.ca.ll:
                      return a.$.bind(t.model.v.g.MG, this.ib);
                    case e.i.ca.ji:
                      return a.$.bind(t.model.v.g.hI, this.ib);
                    case e.i.ca.Om:
                      return a.$.bind(t.model.v.g.OH, this.ib);
                    case e.i.ca.Lo:
                      return a.$.bind(t.model.v.g.FI, this.ib);
                    case e.i.ca.Mo:
                      return a.$.bind(t.model.v.g.GI, this.ib);
                    case e.i.ca.hk:
                      return a.$.bind(t.model.v.g.xI, this.ib);
                    case e.i.ca.NONE:
                      return this.ib;
                  }
                  return a.$.bind(t.model.v.g.JI, this.ib);
                },
                set: function set(e) {
                  "" == e.trim() ? this.ib = t.model.v.g.Cg : this.ib = e;
                }
              }, {
                key: "$n",
                get: function get() {
                  return this.ib;
                },
                set: function set(t) {}
              }, {
                key: "folder",
                get: function get() {
                  return this.Wq;
                },
                set: function set(t) {
                  this.Wq = t;
                }
              }, {
                key: "format",
                get: function get() {
                  return this.qJ;
                },
                set: function set(t) {
                  this.qJ = t;
                }
              }, {
                key: "Mf",
                get: function get() {
                  return this.vJ;
                },
                set: function set(t) {
                  this.vJ = t;
                }
              }, {
                key: "hidden",
                get: function get() {
                  return this.tJ;
                },
                set: function set(t) {
                  this.tJ = t;
                }
              }, {
                key: "type",
                get: function get() {
                  return this.Vc;
                },
                set: function set(t) {
                  this.Vc = t, this.Vc != e.types.Ca.Rb && this.Vc != e.types.Ca.td && (this.Vc == e.types.Ca.jc || this.Vc == e.types.Ca.ce ? (this.te = [e.i.ca.Hb, e.i.ca.zg, e.i.ca.MAX, e.i.ca.MIN], this.Tw = e.i.ca.MAX) : (this.te = [e.i.ca.Hb, e.i.ca.zg], this.Tw = e.i.ca.Hb));
                }
              }, {
                key: "Xr",
                get: function get() {
                  if (this.La) return this.ib;
                  if (this.Qt) return this.Qt;
                  if (0 == t.model.A.P.bA) return this.ib;
                  switch (this.Fa) {
                    case e.i.ca.ik:
                      return a.$.bind(t.model.v.g.LS, this.ib);
                    case e.i.ca.Hb:
                      return a.$.bind(t.model.v.g.qQ, this.ib);
                    case e.i.ca.Tm:
                      return a.$.bind(t.model.v.g.nS, this.ib);
                    case e.i.ca.zg:
                      return a.$.bind(t.model.v.g.HQ, this.ib);
                    case e.i.ca.Hm:
                      return a.$.bind(t.model.v.g.WP, this.ib);
                    case e.i.ca.MAX:
                      return a.$.bind(t.model.v.g.BR, this.ib);
                    case e.i.ca.MIN:
                      return a.$.bind(t.model.v.g.RR, this.ib);
                    case e.i.ca.jj:
                      return a.$.bind(t.model.v.g.iS, this.ib);
                    case e.i.ca.Jh:
                      return a.$.bind(t.model.v.g.fS, this.ib);
                    case e.i.ca.ki:
                      return a.$.bind(t.model.v.g.kS, this.ib);
                    case e.i.ca.rl:
                      return a.$.bind(t.model.v.g.sR, this.ib);
                    case e.i.ca.ll:
                      return a.$.bind(t.model.v.g.FQ, this.ib);
                    case e.i.ca.ji:
                      return a.$.bind(t.model.v.g.hS, this.ib);
                    case e.i.ca.Om:
                      return a.$.bind(t.model.v.g.FR, this.ib);
                    case e.i.ca.Lo:
                      return a.$.bind(t.model.v.g.HS, this.ib);
                    case e.i.ca.Mo:
                      return a.$.bind(t.model.v.g.JS, this.ib);
                    case e.i.ca.hk:
                      return a.$.bind(t.model.v.g.tS, this.ib);
                  }
                  return this.ib;
                },
                set: function set(t) {
                  this.Qt = t;
                }
              }, {
                key: "Fa",
                get: function get() {
                  return "" == this.Nq ? this.Tw : this.Nq;
                },
                set: function set(t) {
                  t && t.toLowerCase() != this.Nq ? (t = t.toLowerCase(), e.i.ca.rL(t) && (t = e.i.ca.bM(t)), e.i.ca.Rs(t) || this.La && t == e.i.ca.NONE ? (this.Qt = this.tB = void 0, this.Nq = t, !this.La && 0 < this.te.length && -1 == this.te.indexOf(t) && (this.Nq = this.Bl[0])) : this.uO()) : "" == t && this.uO();
                }
              }, {
                key: "uO",
                value: function uO() {
                  this.Qt = this.tB = void 0, this.Nq = 0 < this.Bl.length ? this.Bl[0] : this.Tw;
                }
              }, {
                key: "te",
                get: function get() {
                  return this.Bl;
                },
                set: function set(t) {
                  if (this.Bl = [], null == t) this.Bl = [];else if (this.type != e.types.Ca.Rb && this.Vc != e.types.Ca.td && 0 == this.Bl.length) this.Bl = this.Vc == e.types.Ca.jc || this.Vc == e.types.Ca.ce ? [e.i.ca.Hb, e.i.ca.zg, e.i.ca.MAX, e.i.ca.MIN] : [e.i.ca.Hb, e.i.ca.zg];else for (var i = 0; i < t.length; i++) {
                    var _s60 = t[i].trim().toLowerCase();
                    e.i.ca.rL(_s60) && (_s60 = e.i.ca.bM(_s60)), (this.type == e.types.Ca.Rb || this.Vc == e.types.Ca.td || _s60 == e.i.ca.Hb || _s60 == e.i.ca.zg) && e.i.ca.Rs(_s60) && this.Bl.push(_s60);
                  }
                }
              }, {
                key: "Pe",
                get: function get() {
                  return this.Ya;
                },
                set: function set(t) {
                  this.Ya = t;
                }
              }, {
                key: "La",
                get: function get() {
                  return null != this.Jc && "" != this.Jc;
                },
                set: function set(t) {}
              }, {
                key: "Jc",
                get: function get() {
                  return this.rJ;
                },
                set: function set(t) {
                  this.rJ = t;
                }
              }, {
                key: "nE",
                value: function nE() {
                  return 0 === this.te.length || this.La;
                }
              }, {
                key: "VF",
                value: function VF() {
                  var t = {};
                  return t.aggregation = this.Fa, t.availableAggregations = this.te, this.La || a.U(this.te) || 0 != this.te.length || (t.availableAggregations = e.i.ca.sq), t.caption = this.caption, (t.calculated = this.La) && (t.formula = this.Jc.trim(), t.individual = this.Mf), t.folder = this.folder, t.format = this.format, t.grandTotalCaption = this.Xr, t.originalCaption = this.$n, t.name = this.$n, t.uniqueName = this.j, t.type = this.type, t;
                }
              }, {
                key: "gZ",
                value: function gZ() {
                  var t = new s("", "");
                  return !(this.Mf != t.Mf || this.Jc != t.Jc || this.format != t.format || this.type == e.types.Ca.Hb && this.Fa != e.i.ca.Hb && this.Fa != e.i.ca.NONE || this.type == e.types.Ca.Rb && this.Fa != e.i.ca.ik && this.Fa != e.i.ca.NONE);
                }
              }, {
                key: "Ne",
                value: function Ne() {
                  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  var _s61 = t.model.format.Bg.$L(this.format) ? t.model.format.Bg.Ne(this.format) : "" != this.format && t.model.format.Bg.$L("") ? t.model.format.Bg.Ne("") : t.model.format.Bg.FD();
                  return i && a.U(_s61.Pe.textAlign) && this.type != e.types.Ca.Rb && this.type != e.types.Ca.td && this.type != e.types.Ca.ce && ((_s61 = _s61.clone()).textAlign = "left"), _s61;
                }
              }], [{
                key: "Sa",
                value: function Sa(t) {
                  var e = {};
                  return e.uniqueName = t.j, e.name = t.$n, t.La && (e.formula = t.Jc), e.format = t.format, e.individual = t.Mf, e.availableAggregations = t.te, e.aggregation = t.Fa, e.caption = t.caption, e.originalCaption = t.$n, e.grandTotalCaption = t.Xr, e.folder = t.folder, e.type = t.type, e.calculated = t.La, e;
                }
              }]);
              return s;
            }(i.lt);
            i.ol = s;
          }((e = t.u || (t.u = {})).oa || (e.oa = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function (_t$lt3) {
              _inherits(e, _t$lt3);
              var _super57 = _createSuper(e);
              function e(t) {
                var _this75;
                var _e82 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                _classCallCheck(this, e);
                _this75 = _super57.call(this, t, _e82), _this75.va = new a.ma();
                return _this75;
              }
              _createClass(e, [{
                key: "va",
                get: function get() {
                  return this.Aa;
                },
                set: function set(t) {
                  this.Aa = t;
                }
              }, {
                key: "type",
                get: function get() {
                  return this.Vc;
                },
                set: function set(t) {
                  this.Vc = t;
                }
              }, {
                key: "Ge",
                get: function get() {
                  return this.oa;
                },
                set: function set(t) {
                  this.oa = t;
                }
              }, {
                key: "nh",
                value: function nh(t) {
                  t.xj = this, this.Aa.Ea(t.j, t);
                }
              }, {
                key: "Fn",
                value: function Fn(t) {
                  return this.Aa.getItem(t);
                }
              }], [{
                key: "Za",
                value: function Za(t) {
                  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var s = t.uniqueName;
                  return null == i && (i = new e(s)), void 0 !== t.caption && (i.caption = t.caption), void 0 !== t.type && (i.type = t.type), i;
                }
              }]);
              return e;
            }(t.lt);
            t.LA = e;
          }((e = t.u || (t.u = {})).oa || (e.oa = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.u || (t.u = {}), (i = e.oa || (e.oa = {})).iR = /*#__PURE__*/function () {
            function _class19() {
              _classCallCheck(this, _class19);
              this.xJ = !1, this.id = this.uu = "", this.Ce = [], this.fJ = new a.ma(), this.Xa = new a.ma(), this.WB = {}, this.KB = {};
              var t = new i.de(e.Ja.re, e.Ja.re),
                s = new i.LA(e.Ja.re, e.Ja.re);
              s.type = e.types.zq.SA, s.nh(t), this.nC(s), this.vh = new a.ma(), this.types = {}, this.id = this.uu = "";
            }
            _createClass(_class19, [{
              key: "Vh",
              get: function get() {
                return this.xJ;
              },
              set: function set(t) {
                this.xJ = t;
              }
            }, {
              key: "wu",
              get: function get() {
                return this.fJ;
              },
              set: function set(t) {}
            }, {
              key: "pa",
              get: function get() {
                return this.Xa;
              },
              set: function set(t) {}
            }, {
              key: "yk",
              get: function get() {
                for (var t = new a.ma(), e = 0; e < this.Xa.length; e++) {
                  var i = this.Xa.F(e);
                  i.La && t.Ea(i.j, i);
                }
                return t;
              },
              set: function set(t) {}
            }, {
              key: "Pp",
              get: function get() {
                var t = this.ay(e.Ja.re);
                if (null == t) {
                  var s = new i.de(e.Ja.re, e.Ja.re);
                  (t = new i.LA(e.Ja.re, e.Ja.re)).type = e.types.zq.SA, t.nh(s), this.nC(t);
                }
                return t.Fn(e.Ja.re);
              },
              set: function set(t) {}
            }, {
              key: "HN",
              value: function HN(t, s) {
                var r = t.uniqueName;
                return null == s && (s = new i.ol(r)), t.hasOwnProperty("type") && (s.type = "string" == typeof t.type ? e.types.Ca.DX(parseInt(t.type)) : t.type), t.hasOwnProperty("individual") && (s.Mf = t.individual), t.hasOwnProperty("formula") && (s.Jc = t.formula), t.hasOwnProperty("format") && (s.format = t.format), t.hasOwnProperty("availableAggregations") && (s.te = t.availableAggregations), s.Fa = t.hasOwnProperty("aggregation") ? t.aggregation : s.La ? e.i.ca.NONE : "", t.hasOwnProperty("caption") && (s.caption = t.caption), t.hasOwnProperty("name") && (s.caption = t.name), t.hasOwnProperty("grandTotalCaption") && (s.Xr = t.grandTotalCaption), t.hasOwnProperty("folder") && (s.folder = t.folder), s.La && (t = new a.mt(), s.Pe = t.parse(s.Jc)), s;
              }
            }, {
              key: "nC",
              value: function nC(t) {
                null == this.ay(t.j) && (t.Ge = this, this.wu.Ea(t.j, t));
              }
            }, {
              key: "ay",
              value: function ay(t) {
                return this.wu.getItem(t);
              }
            }, {
              key: "bb",
              value: function bb() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                for (var i = new a.ma(), s = 0; s < this.wu.length; s++) {
                  var r = this.wu.F(s);
                  (t || r.type != e.types.zq.SA) && (i = i.concat(r.va));
                }
                return i;
              }
            }, {
              key: "Fn",
              value: function Fn(t) {
                return this.bb(!0).getItem(t);
              }
            }, {
              key: "du",
              value: function du(t) {
                this.pa.Ea(t.j, t);
              }
            }, {
              key: "we",
              value: function we(t) {
                return this.pa.getItem(t);
              }
            }, {
              key: "rv",
              value: function rv(t) {
                this.pa.removeItem(t);
              }
            }, {
              key: "clear",
              value: function clear() {
                this.WB = {}, this.KB = {}, this.vh = new a.ma(), this.types = {}, this.id = this.uu = "", this.fJ = new a.ma(), this.Xa = new a.ma(), this.Vh = !1;
              }
            }, {
              key: "Zh",
              value: function Zh(t) {
                return this.WB[t];
              }
            }, {
              key: "og",
              value: function og(t) {
                return this.KB[t];
              }
            }, {
              key: "pM",
              value: function pM(t) {
                return this.types[t];
              }
            }, {
              key: "Uh",
              value: function Uh(t) {
                return this.vh.getItem(t);
              }
            }, {
              key: "oM",
              value: function oM() {
                return this.vh.Tc(!0);
              }
            }, {
              key: "LU",
              value: function LU(t, e) {
                this.WB[t] = this.Fn(e), this.KB[e] = this.we(t);
              }
            }, {
              key: "oi",
              value: function oi(t, e) {
                var s = new i.ol(t.j, t.caption);
                s.type = e, this.du(s), this.LU(s.j, t.j), this.Ua.px(s.j);
              }
            }, {
              key: "mK",
              value: function mK(s, r, n) {
                var a = r.uniqueName;
                r = new i.de(a, r.caption), s.nh(r), this.Ua.cg(a), s = new i.Xf(r.caption == t.model.v.g.Cg ? a + ".[]" : a, r.caption, 1), r.dg(s), this.oi(r, e.types.Ca.Hb), this.vh.Ea(n, r);
              }
            }, {
              key: "JU",
              value: function JU(s, r, n) {
                var a = r.uniqueName,
                  o = r.caption;
                s.type = e.types.zq.TA, o = new i.de(a, o), s.nh(o), (s = new i.Xf(a + ".Year", t.model.v.g.$m, o.Fb.length)).type = e.types.Ab.$m, o.dg(s), this.Ua.cg(o.j), r.type == e.types.ka.ek && (r = a + ".Quarter", (s = new i.Xf(r, t.model.v.g.pt, o.Fb.length)).type = e.types.Ab.pt, o.dg(s), this.Ua.cg(r, o.j)), r = a + ".Month", (s = new i.Xf(r, t.model.v.g.Ef, o.Fb.length)).type = e.types.Ab.Ef, o.dg(s), this.Ua.cg(r, o.j), a += ".Day", (s = new i.Xf(a, t.model.v.g.ii, o.Fb.length)).type = e.types.Ab.ii, o.dg(s), this.Ua.cg(a, o.j), this.oi(o, e.types.Ca.Hb), this.vh.Ea(n, o);
              }
            }, {
              key: "jK",
              value: function jK(t, s, r) {
                var n = s.hasOwnProperty("hierarchy") ? s.hierarchy : s.uniqueName,
                  a = s.hasOwnProperty("hierarchy") ? s.hierarchy : s.caption,
                  o = t.Fn(n);
                if (null == o && (o = new i.de(n, a), t.nh(o)), a = 0, s.hasOwnProperty("parent")) {
                  if (null == (n = o.by(s.parent))) return null == this.Ce[o.j] && (this.Ce[o.j] = []), void (this.Ce[o.j][s.parent] = [s, r]);
                  a = o.Fb.indexOf(n.j);
                }
                n = s.hasOwnProperty("level") ? s.level : r, s = s.hasOwnProperty("level") ? s.level : r, s = new i.Xf(n, s, a + 1), o.dg(s), 1 == s.Md ? this.Ua.cg(o.j) : this.Ua.cg(n, o.j), this.oi(o, e.types.Ca.Hb), this.vh.Ea(r, s), this.Ce[o.j] && this.Ce[o.j][n] && this.jK(t, this.Ce[o.j][n][0], this.Ce[o.j][n][1]);
              }
            }, {
              key: "wU",
              value: function wU(s, r, n) {
                var a = r.uniqueName,
                  o = r.caption;
                s.type = e.types.zq.TA;
                var h = a + ".Year",
                  l = o + "." + t.model.v.g.$m;
                (r = new i.de(h, l)).type = e.types.ka.T3(e.types.ka.jc), s.nh(r), (l = new i.Xf(h + "." + l, l, 1)).type = e.types.Ab.$m, r.dg(l), this.Ua.cg(h), this.oi(r, e.types.Ca.Hb), h = a + ".Month", l = o + "." + t.model.v.g.Ef, r = new i.de(h, l), s.nh(r), (l = new i.Xf(h + "." + l, l, 1)).type = e.types.Ab.Ef, r.dg(l), this.Ua.cg(h), this.oi(r, e.types.Ca.Hb), a += ".Day", o = o + "." + t.model.v.g.ii, r = new i.de(a, o), s.nh(r), (o = new i.Xf(a + "." + o, o, 1)).type = e.types.Ab.ii, r.dg(o), this.Ua.cg(a), this.oi(r, e.types.Ca.Hb), this.vh.Ea(n, s);
              }
            }, {
              key: "RU",
              value: function RU(t, s, r) {
                var n = s.uniqueName,
                  a = s.caption;
                s = new i.de(n, a), t.nh(s), this.Ua.cg(n), (t = new i.Xf(n + "." + a, a, 1)).type = e.types.Ab.Rb, s.dg(t), this.oi(s, e.types.Ca.Rb), this.vh.Ea(r, s);
              }
            }, {
              key: "PU",
              value: function PU(t, s, r) {
                var n = s.uniqueName,
                  a = s.caption;
                s = new i.de(n, a), t.nh(s), this.Ua.cg(n), (t = new i.Xf(n + "." + a, a, 1)).type = e.types.Ab.Ef, s.dg(t), this.oi(s, e.types.Ca.Hb), this.vh.Ea(r, s);
              }
            }, {
              key: "ZU",
              value: function ZU(t, s, r) {
                var n = s.uniqueName,
                  a = s.caption;
                s = new i.de(n, a), t.nh(s), this.Ua.cg(n), (t = new i.Xf(n + "." + a, a, 1)).type = e.types.Ab.ii, s.dg(t), this.oi(s, e.types.Ca.Hb), this.vh.Ea(r, s);
              }
            }, {
              key: "yU",
              value: function yU(t, s, r) {
                var n = s.uniqueName,
                  a = s.caption;
                s = new i.de(n, a), t.nh(s), this.Ua.cg(n), (t = new i.Xf(n + "." + a, a, 1)).type = e.types.Ab.td, s.dg(t), this.oi(s, e.types.Ca.jc), this.vh.Ea(r, s);
              }
            }, {
              key: "WU",
              value: function WU(t, s, r) {
                var n = s.uniqueName,
                  a = s.caption;
                s = new i.de(n, a), t.nh(s), this.Ua.cg(n), (t = new i.Xf(n + "." + a, a, 1)).type = e.types.Ab.Rb, s.dg(t), this.oi(s, e.types.Ca.td), this.vh.Ea(r, s);
              }
            }, {
              key: "AU",
              value: function AU(t, s, r) {
                var n = s.uniqueName,
                  a = s.caption;
                s = new i.de(n, a), t.nh(s), this.Ua.cg(n), (t = new i.Xf(n + "." + a, a, 1)).type = e.types.Ab.Rb, s.dg(t), this.oi(s, e.types.Ca.ce), this.vh.Ea(r, s);
              }
            }, {
              key: "LZ",
              value: function LZ(t) {
                return t.hasOwnProperty("type") || t.hasOwnProperty("caption") || t.hasOwnProperty("hierarchy") || t.hasOwnProperty("level") || t.hasOwnProperty("parent") || t.hasOwnProperty("dimensionCaption");
              }
            }, {
              key: "vU",
              value: function vU(t) {
                var i,
                  s = !1;
                for (i in t) null == t[i] && (t[i] = ""), "string" == typeof t[i] || "number" == typeof t[i] ? this.cK(i, e.types.ka.R3(t[i])) : t[i] instanceof Date ? this.cK(i, e.types.ka.jc) : t[i] instanceof Array || (this.LZ(t[i]) && (s = !0), t[i].hasOwnProperty("formula") ? 0 == a.Vb(t[i].formula) && this.vk(t[i], i) : this.bu(t[i], i));
                return this.Vh = !0, s;
              }
            }, {
              key: "vk",
              value: function vk(i, s) {
                (s = new e.oa.ol(s, null == i.caption ? s : i.caption)).Jc = i.formula, s.Xr = null == i.grandTotalCaption ? t.model.v.g.jw : i.grandTotalCaption, t.model.yb.V().vk(s);
              }
            }, {
              key: "cK",
              value: function cK(t, e) {
                this.bu({
                  j: t,
                  caption: t,
                  type: e
                }, t);
              }
            }, {
              key: "bu",
              value: function bu(t) {
                var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s,
                  r,
                  n = {};
                for (s in t) n[s] = t[s];
                switch (n.hasOwnProperty("uniqueName") || (n.uniqueName = i), n.hasOwnProperty("caption") && "" != n.caption || (n.caption = i), "" == i && (i = n.uniqueName), t = e.types.ka.nd, n.hasOwnProperty("type") && (t = String(n.type).trim().toLowerCase()), n.type = t, (n.hasOwnProperty("hierarchy") || t == e.types.ka.We && n.hasOwnProperty("hierarchy")) && (r = this.ay(n.hierarchy)), null == r && (r = e.oa.LA.Za(n), n.hasOwnProperty("hierarchy") && (r.j = n.hierarchy), r.caption = n.hasOwnProperty("caption") ? n.caption : n.hasOwnProperty("hierarchy") ? n.hierarchy : r.caption, t == e.types.ka.We && n.hasOwnProperty("hierarchy") && (r.j = n.hierarchy), this.nC(r)), this.types[i] = t, t) {
                  case e.types.ka.nd:
                    this.mK(r, n, i);
                    break;
                  case e.types.ka.Rb:
                    this.RU(r, n, i);
                    break;
                  case e.types.ka.Ef:
                    this.PU(r, n, i);
                    break;
                  case e.types.ka.Po:
                    this.ZU(r, n, i);
                    break;
                  case e.types.ka.jc:
                    this.wU(r, n, i);
                    break;
                  case e.types.ka.ce:
                    this.AU(r, n, i);
                    break;
                  case e.types.ka.td:
                    this.WU(r, n, i);
                    break;
                  case e.types.ka.We:
                    this.jK(r, n, i);
                    break;
                  case e.types.ka.Km:
                  case e.types.ka.ek:
                    this.JU(r, n, i);
                    break;
                  case e.types.ka.kl:
                    this.yU(r, n, i);
                    break;
                  case e.types.ka.Dq:
                    this.id = i, this.vh.Ea(i, null);
                    break;
                  case e.types.ka.LG:
                    this.uu = i;
                    break;
                  case e.types.ka.NA:
                    break;
                  default:
                    this.mK(r, n, i);
                }
              }
            }]);
            return _class19;
          }();
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var i = /*#__PURE__*/function () {
              function i(t) {
                _classCallCheck(this, i);
                this.Aa = new a.ma(), this.cl = e.i.ba.mb, this.uk = this.Jw = null, this.Mt = [], this.Jt = [], this.gC = e.i.ba.mb, this.er = t;
              }
              _createClass(i, [{
                key: "ah",
                get: function get() {
                  if (null != this.Jw) return this.Jw;
                  var t = null;
                  if (null != this.uk) {
                    var e = 0;
                    t = [];
                    for (var _i28 = 0; _i28 < this.Aa.length; _i28++) {
                      var s = this.va.F(_i28);
                      if (!s.tf) {
                        if (!this.uk[e]) break;
                        if ("number" == typeof this.uk[e]) {
                          t = this.uk;
                          break;
                        }
                        var r = this.uk[e].toString().trim();
                        if (!/\D/.test(r)) {
                          t = this.uk;
                          break;
                        }
                        if (null != (s = s.xe(this.uk[e].toString().trim()))) t.push(s.ra);else if (this.uk[e]) {
                          t = null;
                          break;
                        }
                      }
                      e++;
                    }
                  }
                  return this.Jw = t;
                },
                set: function set(t) {
                  this.uk = t, this.Jw = null;
                }
              }, {
                key: "nP",
                get: function get() {
                  var t = null,
                    e = this.ah;
                  if (null != e) {
                    var _i29 = 0;
                    t = [];
                    for (var s = 0; s < this.Aa.length; s++) {
                      var r = this.va.F(s);
                      if (!r.tf) {
                        if (!e[_i29]) break;
                        if (null != (r = r.ua.F("" === e[s] ? 0 : parseInt(e[s])))) t.push(r.j);else if (e[_i29]) {
                          t = null;
                          break;
                        }
                      }
                      _i29++;
                    }
                  }
                  return t;
                },
                set: function set(t) {
                  this.ah = t;
                }
              }, {
                key: "jd",
                get: function get() {
                  return this.Mt;
                },
                set: function set(t) {
                  if (null == t) this.Mt = [];else if (this.Ba) this.Mt = t;else {
                    this.Mt = [];
                    for (var e = 0; e < t.length; e++) {
                      var _i30 = t[e];
                      _i30[0] = -1, this.Mt.push(_i30);
                    }
                  }
                }
              }, {
                key: "LL",
                get: function get() {
                  for (var t, e, _i31, s, r, n, a = [], o = 0; o < this.jd.length; o++) {
                    e = [], _i31 = (t = this.jd[o].slice(0)).shift(), s = "";
                    for (var h = r = 0; h < t.length; h++) (n = this.va.F(r)).tf && (-1 < _i31 && (s = n.ua.F(_i31).j), r++, n = this.va.F(r)), null != n.ua.F(t[h]) && e.push(n.ua.F(t[h]).j), r++;
                    e.unshift(s), a.push(e);
                  }
                  return a;
                }
              }, {
                key: "H1",
                value: function H1(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  for (var _i32, s, r, n, o, h, l = [], A = 0; A < t.length; A++) {
                    if (_i32 = t[A].slice(0), isNaN(parseInt(_i32[0]))) {
                      if (s = [], n = -1, r = _i32.shift(), o = 0, 0 < this.va.length) for (var c = 0; c < _i32.length; c++) {
                        if (h = this.va.F(o), a.U(h)) return [];
                        h.tf && ("" != r && (n = e ? e.indexOf(r) : h.ua.indexOf(r)), o++, h = this.va.F(o)), s.push(h.ua.indexOf(_i32[c])), o++;
                      }
                      s.unshift(n);
                    } else s = _i32;
                    l.push(s);
                  }
                  return l;
                }
              }, {
                key: "hd",
                get: function get() {
                  return this.Jt;
                },
                set: function set(t) {
                  if (a.U(t)) this.Jt = [];else {
                    if (this.Ba) this.Jt = t;else {
                      this.Jt = [];
                      for (var e = 0; e < t.length; e++) {
                        var _i33 = t[e];
                        "string" == typeof _i33[0] ? _i33[1] = -1 : _i33[0] = -1, this.Jt.push(_i33);
                      }
                    }
                    this.S2(t);
                  }
                }
              }, {
                key: "S2",
                value: function S2(t) {
                  var _i34 = this.Aa.slice();
                  _i34.removeItem(e.Ja.re);
                  for (var s, r = 0; r < t.length; r++) {
                    var n = t[r].slice(0);
                    "string" == typeof n[0] && (s = n.shift());
                    var a = _i34.F(n.length - 3);
                    if (null == a) break;
                    var o = n[1];
                    isNaN(parseFloat(n[1])) || null != (n = a.ua.F(n[1])) && (o = n.j), -1 == a.pF.indexOf(o) && a.pF.push([s, o]);
                  }
                }
              }, {
                key: "EL",
                get: function get() {
                  for (var t, e, _i35, s, r, n, a, o, h = [], l = 0; l < this.hd.length; l++) {
                    e = [], r = _i35 = "", "string" == typeof (t = this.hd[l].slice(0))[0] && (_i35 = t.shift()), s = t.shift(), n = t.shift();
                    for (var A = a = 0; A < t.length; A++) (o = this.va.F(a)).tf && (-1 < s && (r = o.ua.F(s).j), a++, o = this.va.F(a)), null != o.ua.F(t[A]) && e.push(o.ua.F(t[A]).j), a++;
                    e.unshift(n), e.unshift(r), e.unshift(_i35), h.push(e);
                  }
                  return h;
                }
              }, {
                key: "G1",
                value: function G1(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  for (var _i36, s, r, n, o, h, l, A, c = [], u = 0; u < t.length; u++) {
                    if (_i36 = t[u].slice(0), isNaN(parseInt(_i36[_i36.length - 1]))) {
                      if (s = [], n = -1, r = _i36.shift(), o = _i36.shift(), h = _i36.shift(), l = 0, 0 < this.va.length) for (var d = 0; d < _i36.length; d++) {
                        if (A = this.va.F(l), a.U(A)) return [];
                        A.tf && ("" != o && (n = e ? e.indexOf(o) : A.ua.indexOf(o)), l++, A = this.va.F(l)), s.push(A.ua.indexOf(_i36[d])), l++;
                      }
                      s.unshift(h), s.unshift(n), "" != r && s.unshift(r);
                    } else s = _i36;
                    c.push(s);
                  }
                  return c;
                }
              }, {
                key: "Nb",
                get: function get() {
                  return this.gC;
                },
                set: function set(t) {
                  t = t.toLowerCase(), this.gC = t == e.i.ba.ub || t == e.i.ba.vb ? t : e.i.ba.mb;
                }
              }, {
                key: "j",
                get: function get() {
                  return this.er;
                },
                set: function set(t) {
                  this.er = t;
                }
              }, {
                key: "caption",
                get: function get() {
                  return this.ib;
                },
                set: function set(t) {
                  this.ib = t;
                }
              }, {
                key: "va",
                get: function get() {
                  return this.Aa;
                },
                set: function set(t) {
                  this.jd = [], this.hd = [], this.uk = null, this.gC = e.i.ba.mb, this.xg = null, this.Aa = t;
                }
              }, {
                key: "size",
                get: function get() {
                  for (var t = 1, e = 0; e < this.Aa.length; e++) t *= this.Aa.F(e).size;
                  return t;
                },
                set: function set(t) {}
              }, {
                key: "Ee",
                get: function get() {
                  return this.Aa.indexOf(e.Ja.re);
                },
                set: function set(t) {}
              }, {
                key: "Pp",
                get: function get() {
                  return this.Aa.getItem(e.Ja.re);
                },
                set: function set(t) {}
              }, {
                key: "Ba",
                get: function get() {
                  return -1 < this.Ee;
                },
                set: function set(t) {}
              }, {
                key: "depth",
                get: function get() {
                  for (var t = 0, e = 0; e < this.Aa.length; e++) t += this.Aa.F(e).BL;
                  return t;
                },
                set: function set(t) {}
              }, {
                key: "toString",
                value: function toString() {
                  return "[Axis:" + this.er + " ]";
                }
              }, {
                key: "Sa",
                value: function Sa() {
                  var _i37 = {},
                    s = [];
                  for (var _e83 = 0; _e83 < this.va.length; _e83++) {
                    var _i38 = t.de.Sa(this.va.F(_e83));
                    s.push(_i38);
                  }
                  return _i37.hierarchies = s, this.Nb == e.i.ba.mb || a.U(this.ah) || a.U(this.xg) || (_i37.sort = {
                    type: this.Nb,
                    tuple: this.nP,
                    measure: this.xg.j
                  }), _i37;
                }
              }, {
                key: "jo",
                value: function jo(t, e, _i39) {
                  this.xg = t, this.ah = e, this.Nb = _i39, 0 == e.length && (this.cl = this.Nb, this.Fm = this.xg);
                }
              }], [{
                key: "Za",
                value: function Za(t, s, r, n, o, h) {
                  var l = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
                  var A;
                  if ((t = new i(t)).va = new a.ma(), s) for (A = 0; A < s.length; A++) if (null != s[A].uniqueName) {
                    var c = h.Fn(s[A].uniqueName);
                    null != c && (e.oa.de.Za(s[A], c), c.tf && t.j == e.i.da.Sm || t.va.Ea(c.j, c));
                  }
                  if (r && (null != (A = h.we(r.measure ? r.measure : "")) && null != r.tuple ? t.jo(A, r.tuple, r.type) : t.pP = r), n && 0 < n.length) {
                    for (c = [], A = 0; A < n.length; A++) {
                      for (h = [], 0 < (s = n[A]).length && h.push(s[0]), r = 1; r < s.length; r++) h.push(s[r]);
                      c.push(h);
                    }
                    n = c;
                  }
                  if (t.jd = n ? t.H1(n, l) : [], o && 0 < o.length) {
                    for (n = [], A = 0; A < o.length; A++) {
                      for (h = [], 0 < (s = o[A]).length && h.push(s[0]), r = 1; r < s.length; r++) h.push(s[r]);
                      n.push(h);
                    }
                    o = n;
                  }
                  return t.hd = o ? t.G1(o, l) : [], t;
                }
              }]);
              return i;
            }();
            t.ej = i;
          }((e = t.u || (t.u = {})).oa || (e.oa = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.u || (t.u = {}), function (s) {
            var r = /*#__PURE__*/function () {
              function r(t) {
                _classCallCheck(this, r);
                this.Cl = new a.ma(), this.Xa = new a.ma(), this.Vq = this.kJ = !1, this.Pt = [], this.Ge = t, this.nn(new e.oa.ej(e.i.da.Ka)), this.nn(new e.oa.ej(e.i.da.rb)), this.nn(new e.oa.ej(e.i.da.Sm));
              }
              _createClass(r, [{
                key: "axes",
                get: function get() {
                  return this.Cl;
                },
                set: function set(t) {}
              }, {
                key: "nn",
                value: function nn(t) {
                  this.Cl.Ea(t.j, t), t.Ba && (this.Uo = t);
                }
              }, {
                key: "ve",
                value: function ve(t) {
                  return this.Cl.getItem(t);
                }
              }, {
                key: "Rh",
                get: function get() {
                  if (null == this.Uo) {
                    for (var t = 0; t < this.Cl.length; t++) {
                      var i = this.Cl.F(t);
                      if (i.Ba) {
                        this.Uo = i;
                        break;
                      }
                    }
                    null == this.Uo && (this.Uo = this.ve(e.i.da.rb));
                  }
                  return this.Uo.Ba || (t = this.Ge.Pp) && this.Uo.va.Ea(t.j, t), this.Uo;
                },
                set: function set(t) {}
              }, {
                key: "yk",
                get: function get() {
                  for (var t = new a.ma(), e = 0; e < this.Xa.length; e++) {
                    var i = this.Xa.F(e);
                    i.La && t.Ea(i.j, i);
                  }
                  return t;
                },
                set: function set(t) {}
              }, {
                key: "CE",
                get: function get() {
                  return this.Xa;
                },
                set: function set(t) {
                  this.pa = t;
                }
              }, {
                key: "pa",
                get: function get() {
                  for (var t = new a.ma(), e = 0; e < this.Xa.length; e++) {
                    var i = this.Xa.F(e);
                    i.hidden || t.Ea(i.j, i);
                  }
                  return t;
                },
                set: function set(t) {
                  if (this.Xa = t, null != (t = this.Rh.Pp) && (t.clear(), null != this.Xa)) for (var e = 0; e < this.Xa.length; e++) {
                    var s = this.Xa.F(e);
                    s = new i.qe(s.j, s.caption), t.Oc(s, "", "", !1);
                  }
                }
              }, {
                key: "bb",
                value: function bb() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  for (var s = new a.ma(), _r35 = 0; _r35 < this.Cl.length; _r35++) {
                    var n = this.Cl.F(_r35);
                    s = s.concat(n.va);
                  }
                  if (t || s.removeItem(this.Ge.Pp.j), !e) for (t = 0; t < this.eb.length; t++) s.removeItem(this.eb.yd(_r35));
                  if (i) for (_r35 = 0; _r35 < this.pa.length; _r35++) (i = this.pa.F(_r35)).La || (i = this.Ge.Zh(i.j), s.Ea(i.j, i));
                  return s;
                }
              }, {
                key: "clear",
                value: function clear() {
                  for (var t = 0; t < this.Cl.length; t++) this.Cl.F(t).va = new a.ma();
                  this.Xa = new a.ma();
                }
              }, {
                key: "rows",
                get: function get() {
                  return this.ve(e.i.da.Ka).va;
                },
                set: function set(t) {
                  var i = this.ve(e.i.da.Ka);
                  null == i && (i = new s.ej(e.i.da.Ka)), i.va = t, null == t && (i.va = new a.ma()), this.nn(i);
                }
              }, {
                key: "za",
                get: function get() {
                  return this.ve(e.i.da.rb).va;
                },
                set: function set(t) {
                  var i = this.ve(e.i.da.rb);
                  null == i && (i = new s.ej(e.i.da.rb)), i.va = t, null == t && (i.va = new a.ma()), this.nn(i);
                }
              }, {
                key: "eb",
                get: function get() {
                  return this.ve(e.i.da.Sm).va;
                },
                set: function set(t) {
                  var i = this.ve(e.i.da.Sm);
                  null == i && (i = new s.ej(e.i.da.Sm)), i.va = t, null == t && (i.va = new a.ma()), this.nn(i);
                }
              }, {
                key: "hc",
                get: function get() {
                  return this.Rh.j == e.i.da.Ka ? this.rows.splice(this.Rh.Ee, 1) : this.rows;
                },
                set: function set(t) {}
              }, {
                key: "ed",
                get: function get() {
                  return this.Rh.j == e.i.da.rb ? this.za.splice(this.Rh.Ee, 1) : this.za;
                },
                set: function set(t) {}
              }, {
                key: "clone",
                value: function clone() {
                  var t = new r(this.Ge);
                  return t.rows = this.rows.slice(), t.za = this.za.slice(), t.eb = this.eb.slice(), t.pa = this.pa.slice(), t.ze = this.ze.slice(0), t;
                }
              }, {
                key: "Sa",
                value: function Sa() {
                  for (var t = {
                      rows: []
                    }, e = 0; e < this.rows.length; e++) {
                    var i = this.rows.F(e).Sa();
                    t.rows[e] = i;
                  }
                  for (t.columns = [], e = 0; e < this.za.length; e++) i = this.za.F(e).Sa(), t.columns[e] = i;
                  for (t.pages = [], e = 0; e < this.eb.length; e++) i = this.eb.F(e).Sa(), t.pages[e] = i;
                  for (t.measures = [], e = 0; e < this.pa.length; e++) i = this.pa.F(e).Sa(), t.measures[e] = i;
                  return t;
                }
              }, {
                key: "flatten",
                value: function flatten() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  for (var e = this.bb(!1), i = 0; i < this.pa.length; i++) {
                    var _r36 = this.pa.F(i),
                      n = this.Zh(_r36.j);
                    null != n && e.Ea(n.j, n), _r36.La && t && (n = new s.de(_r36.j, _r36.caption), e.Ea(_r36.j, n));
                  }
                  for (t = new a.ma(), i = 0; i < this.ze.length; i++) _r36 = this.ze[i], e.rc(_r36) && (t.Ea(_r36, e.getItem(_r36)), e.removeItem(_r36));
                  for (i = 0; i < e.length; i++) t.Ea(e.yd(i), e.F(i));
                  return t;
                }
              }, {
                key: "isEqual",
                value: function isEqual(t) {
                  if (null == t || this.eb.length != t.eb.length || this.rows.length != t.rows.length || this.za.length != t.za.length || this.pa.length != t.pa.length) return !1;
                  for (var e = 0; e < this.eb.length; e++) if (this.eb.yd(e) != t.eb.yd(e)) return !1;
                  for (e = 0; e < this.rows.length; e++) if (this.rows.yd(e) != t.rows.yd(e)) return !1;
                  for (e = 0; e < this.za.length; e++) if (this.za.yd(e) != t.za.yd(e)) return !1;
                  for (e = 0; e < this.pa.length; e++) if (this.pa.yd(e) != t.pa.yd(e) || this.pa.F(e).Fa != t.pa.F(e).Fa) return !1;
                  return !0;
                }
              }, {
                key: "Zh",
                value: function Zh(t) {
                  return this.Ge.Zh(t);
                }
              }, {
                key: "og",
                value: function og(t) {
                  return this.Ge.og(t);
                }
              }, {
                key: "Db",
                get: function get() {
                  return 0 == this.bb(!1).length && 0 == this.pa.length;
                },
                set: function set(t) {}
              }, {
                key: "h_",
                value: function h_() {
                  if (t.model.A.P.Dc) {
                    this.rows = new a.ma(), this.za = new a.ma(), this.eb = new a.ma();
                    for (var i = new a.ma(), s = [], _r37 = 0; _r37 < this.Ge.pa.length; _r37++) {
                      var n = this.Ge.pa.F(_r37);
                      s.push(n.j), n.type == e.types.Ca.Hb ? (n = this.Ge.Zh(n.j)) && this.rows.Ea(n.j, n) : i.Ea(n.j, n);
                    }
                    this.Pt = s, this.pa = i;
                  } else {
                    for (_r37 = 0; _r37 < this.Ge.pa.length && ((n = this.Ge.pa.F(_r37)).type != e.types.Ca.Rb ? null == i && (i = this.Ge.Zh(n.j)) : null == s && (s = n), null == i || null == s); _r37++);
                    null == s ? s = this.Ge.pa.F(0) : null == i ? (n = this.Ge.pa.F(0), i = this.Ge.Zh(n.j)) : null == i && null == s && 0 < this.Ge.pa.length && (s = this.Ge.pa.F(0), i = this.Ge.Zh(s.j)), null != i && null != s && (this.eb = new a.ma(), this.rows = new a.ma(), this.za = new a.ma(), this.rows.Ea(i.j, i), (i = new a.ma()).Ea(s.j, s), this.pa = i);
                  }
                }
              }, {
                key: "oc",
                get: function get() {
                  return this.kJ;
                },
                set: function set(t) {
                  this.kJ = t;
                }
              }, {
                key: "gd",
                get: function get() {
                  return this.Vq;
                },
                set: function set(t) {
                  this.Vq = t;
                }
              }, {
                key: "MV",
                value: function MV() {
                  this.zb.jd = [], this.nb.jd = [];
                }
              }, {
                key: "LV",
                value: function LV() {
                  this.zb.hd = [], this.nb.hd = [];
                }
              }, {
                key: "ze",
                get: function get() {
                  return null == this.Pt && (this.Pt = []), this.Pt;
                },
                set: function set(t) {
                  this.Pt = t;
                }
              }, {
                key: "zb",
                get: function get() {
                  return this.axes.getItem(e.i.da.Ka);
                }
              }, {
                key: "nb",
                get: function get() {
                  return this.axes.getItem(e.i.da.rb);
                }
              }, {
                key: "p_",
                value: function p_(t) {
                  a.U(t) || (this.oc = t.oc, this.gd = t.gd, r.zK(this, t) ? (this.zb.jd = this.Nx(t.zb.jd, this.sy(this.zb.va, t.zb.va)), this.zb.hd = this.Nx(t.zb.hd, this.sy(this.zb.va, t.zb.va) + 2)) : (this.zb.jd = this.Bx(t.zb.jd), this.zb.hd = this.Bx(t.zb.hd)), r.yK(this, t) ? (this.nb.jd = this.Nx(t.nb.jd, this.sy(this.nb.va, t.nb.va)), this.nb.hd = this.Nx(t.nb.hd, this.sy(this.nb.va, t.nb.va) + 2)) : (this.nb.jd = this.Bx(t.nb.jd), this.nb.hd = this.Bx(t.nb.hd)));
                }
              }, {
                key: "rv",
                value: function rv(t) {
                  this.Xa.removeItem(t);
                }
              }, {
                key: "sy",
                value: function sy(t, e) {
                  for (var i = 0, s = Math.min(t.length, e.length), _r38 = 0; _r38 < s; _r38++) {
                    var n = t.F(_r38),
                      a = e.F(_r38);
                    if (n.j != a.j) break;
                    n.tf || i++;
                  }
                  return i;
                }
              }, {
                key: "Nx",
                value: function Nx(t, e) {
                  var i = [];
                  if (1 < e) for (var s = 0; s < t.length; s++) {
                    var _r39 = t[s];
                    _r39.length <= e && i.push(_r39.slice());
                  }
                  return i;
                }
              }, {
                key: "Bx",
                value: function Bx(t) {
                  for (var e = [], i = 0; i < t.length; i++) e.push(t[i].slice());
                  return e;
                }
              }], [{
                key: "zK",
                value: function zK(t, e) {
                  if (null == e) return !0;
                  var i = t.rows.length != e.rows.length;
                  if (!i) for (var s = 0; s < t.rows.length; s++) if (t.rows.F(s).j != e.rows.F(s).j) {
                    i = !0;
                    break;
                  }
                  return i;
                }
              }, {
                key: "yK",
                value: function yK(t, e) {
                  if (null == e) return !0;
                  var i = t.za.length != e.za.length;
                  if (!i) for (var s = 0; s < t.za.length; s++) if (t.za.F(s).j != e.za.F(s).j) {
                    i = !0;
                    break;
                  }
                  return i;
                }
              }, {
                key: "jV",
                value: function jV(t, e) {
                  if (null == e) return !0;
                  var i = t.pa.length != e.pa.length;
                  if (!i) for (var s = 0; s < t.pa.length; s++) if (t.pa.F(s).j != e.pa.F(s).j) {
                    i = !0;
                    break;
                  }
                  return i;
                }
              }, {
                key: "dV",
                value: function dV(t, e) {
                  void 0 !== e.caption && null != t && (t.caption = e.caption);
                }
              }, {
                key: "Za",
                value: function Za(t, i) {
                  var s = new r(i),
                    n = new a.ma();
                  for (var o = i.bb(), h = 0; h < t.Ia.length; h++) if (t.Ia[h].hasOwnProperty("uniqueName")) {
                    var l = i.pa.getItem(t.Ia[h].uniqueName);
                    null == l && a.Vb(t.Ia[h].formula) || (this.dV(o.getItem(t.Ia[h].uniqueName), t.Ia[h]), (l = i.HN(t.Ia[h], l)).La && !i.pa.rc(l.j) && i.du(l), (a.U(t.Ia[h].active) || t.Ia[h].active) && n.Ea(l.j, l));
                  }
                  return o = e.oa.ej.Za(e.i.da.Ka, t.rows, t.Xi, t.Dn, t.An, i, n.Tc(!0)), h = e.oa.ej.Za(e.i.da.rb, t.za, t.Ci, t.Bn, t.yn, i, n.Tc(!0)), s.rows = o.va, s.za = h.va, s.eb = e.oa.ej.Za(e.i.da.Sm, t.eb, null, [], [], i).va, s.pa = n, s.oc = t.oc, s.gd = t.gd, s.ze = t.ze, s.nn(o), s.nn(h), s;
                }
              }]);
              return r;
            }();
            s.lh = r;
          }(i = e.oa || (e.oa = {}));
        }(r || (r = {})), function (t) {
          var i;
          !function (s) {
            var r = /*#__PURE__*/function () {
              function r() {
                var _this76 = this;
                _classCallCheck(this, r);
                this.lD = [".csv"], this.L_ = function () {
                  return _this76.K_();
                }, this.B1 = function (t) {
                  return _this76.dZ(t);
                }, this.wP = function () {
                  return _this76.bO();
                }, this.xP = function () {
                  return _this76.s1();
                }, this.zh = 0, this.mN = !1, this.O = i.Ja.V(), this.lD = [".csv"];
              }
              _createClass(r, [{
                key: "clear",
                value: function clear() {
                  this.data = [], this.jL = this.np = 0, this.connected = !1, this.IV = this.zh = 0, this.eo = "\n", this.Wx = '"', this.Fx = [], this.UD = this.hE = this.$u = this.iE = !1, this.ev = "", this.fb = 0, this.gh = 100, null != this.Ub && (this.Ub.Rc(), this.Ub.la(), this.Ub = null), this.Ls();
                }
              }, {
                key: "load",
                value: function load(e, i, s, _r40, n) {
                  try {
                    this.clear(), this.filename = e.filename, this.Xj = i, this.Bc = s, this.Ck = _r40, this.pu = n, this.jg = e.jg, this.bs = e.bs, e.BZ ? this.generate() : (void 0 !== this.filename && "" != this.filename && "()" != this.filename.substr(-2) || !1 !== e.eg ? this.filename = a.jB.PM(this.filename) : this.ai(), !0 === e.eg ? this.GK() : this.GZ(e.filename) && a.U(e.Mz) ? this.oV() : (t.Ta(!0, t.model.v.g.Pm), this.DN(this.filename, e.Mz)));
                  } catch (t) {
                    console.error(t.stack), this.ai();
                  }
                }
              }, {
                key: "generate",
                value: function generate() {}
              }, {
                key: "oV",
                value: function oV() {
                  window.gapi && window.gapi.load("auth", {
                    callback: this.L_
                  });
                }
              }, {
                key: "K_",
                value: function K_() {
                  "" == t.G.xb.tb.toolbar.googleClientId || null == t.G.xb.tb.toolbar.googleClientId ? this.w0() : window.gapi.B5.C5({
                    client_id: t.G.xb.tb.toolbar.googleClientId,
                    scope: t.G.xb.tb.toolbar.googleScope,
                    immediate: !1
                  }, this.B1);
                }
              }, {
                key: "dZ",
                value: function dZ(e) {
                  var i = {};
                  e && !e.error ? (i.Authorization = "Bearer " + e.A5, t.Ta(!0, t.model.v.g.Pm), this.DN(this.filename, i)) : (t.Ta(!1), this.ai());
                }
              }, {
                key: "GZ",
                value: function GZ(t) {
                  return -1 < t.indexOf("www.googleapis.com/drive");
                }
              }, {
                key: "w0",
                value: function w0() {
                  t.yc(t.model.v.g.MR, t.model.v.g.wb, t.ld.wb);
                }
              }, {
                key: "GK",
                value: function GK() {
                  var _this77 = this;
                  this.lm = new n.tH(), this.lm.addEventListener(e.ga.Vm, function () {
                    return _this77.n0();
                  }), this.lm.addEventListener(e.ga.yg, function () {
                    return _this77.QE();
                  }), this.lm.addEventListener(e.ga.vw, function (t) {
                    return _this77.RE(t);
                  }), this.lm.addEventListener(e.ga.rA, function () {
                    return _this77.l0();
                  }), this.lm.addEventListener(e.ga.wb, function () {
                    return _this77.ai();
                  }), this.lm.FK(this.lD);
                }
              }, {
                key: "n0",
                value: function n0() {
                  t.Ta(!0, t.model.v.g.Pm, "", !0, !0), this.Ub = this.lm, this.lm.load(), this.lm = null;
                }
              }, {
                key: "DN",
                value: function DN(t) {
                  var _this78 = this;
                  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var s = new n.Gw();
                  s.dataType = n.QG.st, s.addEventListener(e.ga.yg, function () {
                    return _this78.QE();
                  }), s.addEventListener(e.ga.tA, function () {
                    return _this78.m0();
                  }), s.addEventListener(e.ga.vw, function (t) {
                    return _this78.RE(t);
                  }), s.addEventListener(e.ga.wb, function () {
                    return _this78.ai();
                  }), s.load(t, i), this.Ub = s, this.me = new a.hB(100, 1e3), this.me.addEventListener(a.Lq.Bw, this.wP), this.me.addEventListener(a.Lq.Cw, this.xP), this.me.start();
                }
              }, {
                key: "bO",
                value: function bO() {
                  0 < this.np || this.$u || this.hE ? this.Ls() : null != this.me && t.Ta(!0, t.model.v.g.Pm, a.$.bind(t.model.v.g.TH, a.Fd.format(this.me.SC / 10, new t.model.format.C.Eo(), !1, !1, 1)));
                }
              }, {
                key: "s1",
                value: function s1() {
                  this.me.Rz && this.Ls();
                }
              }, {
                key: "Ls",
                value: function Ls() {
                  this.me && this.me.Rz && (this.me.stop(), this.me.removeEventListener(a.Lq.Bw, this.wP), this.me.removeEventListener(a.Lq.Cw, this.xP));
                }
              }, {
                key: "l0",
                value: function l0() {
                  null != this.pu && (this.pu(), this.pu = null), this.clear();
                }
              }, {
                key: "ai",
                value: function ai() {
                  if (t.Ta(!1), 0 == this.hE) {
                    this.hE = !0;
                    var e = t.model.zc.valid(this.filename) ? this.filename : t.model.zc.validate(this.filename);
                    t.yc(a.$.bind(t.model.v.g.rw, e), t.model.v.g.wb, t.ld.wb);
                  }
                  null != this.Bc && (this.Bc(), this.Bc = null), this.Ls();
                }
              }, {
                key: "z0",
                value: function z0() {
                  t.Ta(!1), t.yc(a.$.bind(t.model.v.g.JR), t.model.v.g.wb, t.ld.wb);
                }
              }, {
                key: "RE",
                value: function RE(e) {
                  if (404 == e.target.status) this.ai();else if (!a.U(this.Ub)) try {
                    var i = this.Ub.response;
                    if (null != i && 0 != i.length && (this.np != e.loaded || this.jL != i.length) && (this.UD = 0 < e.total && e.lengthComputable, this.jL = i.length, this.np = e.loaded, 1e4 < i.length - this.zh || e.loaded == e.total)) if (this.np > t.model.fc.Io.MH) t.yc(t.model.fc.Ed.I(t.model.fc.Ed.iu), t.model.fc.Ed.I(t.model.fc.Ed.Lv)), t.Ta(!1), null != this.Bc && (this.Bc(), this.Bc = null), this.Ls();else {
                      this.$u = e.loaded == e.total, void 0 !== i && this.aq(i.substring(this.zh, i.length)), this.zh = i.length;
                      var s = a.$.bind(t.model.v.g.SH, a.Fd.Jk(e.loaded.toFixed(0)), a.Fd.Jk(e.total.toFixed(0)));
                      t.Ta(!0, t.model.v.g.Pm, s);
                    }
                  } catch (t) {
                    console.error(t.stack), this.ai();
                  }
                }
              }, {
                key: "m0",
                value: function m0() {
                  this.connected = !0, t.Ta(!0, t.model.v.g.Pm, "");
                }
              }, {
                key: "Uz",
                value: function Uz() {
                  null != this.Ck && (this.Ck(), this.Ck = null);
                }
              }, {
                key: "QE",
                value: function QE() {
                  if (!a.U(this.Ub)) try {
                    if (0 == this.zh || !this.UD) {
                      var e = this.Ub.response;
                      this.connected = !0, e.length > t.model.fc.Io.MH ? (t.yc(t.model.fc.Ed.I(t.model.fc.Ed.iu), t.model.fc.Ed.I(t.model.fc.Ed.Lv)), t.Ta(!1), null != this.Bc && (this.Bc(), this.Bc = null), this.clear()) : (this.$u = !0, this.mN ? this.UD || (this.zh < e.length ? (this.aq(e.substring(this.zh, e.length)), this.zh = e.length) : this.data.push(this.ev)) : this.aq(e), this.pv(), this.ME());
                    }
                  } catch (t) {
                    console.error(t.stack), this.ai();
                  }
                }
              }, {
                key: "aq",
                value: function aq(e) {
                  this.mN = !0, this.Uz(), 0 == this.IV && -1 == e.indexOf("\n") && -1 != e.indexOf("\r") && (this.eo = "\r"), void 0 === this.jg && (this.jg = this.HV(-1 == e.indexOf("\n") && -1 == e.indexOf("\r") ? e : e.substring(0, e.indexOf(this.eo)))), this.appendData(e), 0 == this.iE && (1 < this.data.length || t.model.A.P.gP) && (this.Cz(this.data.shift(), this.data[0]), this.iE = !0);
                }
              }, {
                key: "ME",
                value: function ME() {
                  t.Ta(!1), this.iE ? null != this.Xj && this.Xj() : (t.yc(t.model.v.g.UH, t.model.v.g.wb, t.ld.to), null != this.Bc && (this.Bc(), this.Bc = null)), this.clear();
                }
              }, {
                key: "Cz",
                value: function Cz(e, s) {
                  if (r.sZ(e)) try {
                    a.U(this.jg) && (this.jg = ",");
                    var n = r.qP(e, this.jg),
                      o = r.qP(s, this.jg);
                    for (this.Ak = [], e = 0; e < n.length; e++) {
                      var h = this.mY(o[e]),
                        l = n[e];
                      if (s = null, 0 < n[e].length && -1 < n[e].indexOf("{")) {
                        var A = n[e].substr(n[e].indexOf(":") + 1, n[e].length);
                        if (0 < A.length) {
                          l = n[e].substring(0, n[e].indexOf(":"));
                          try {
                            s = JSON.parse(A);
                          } catch (t) {
                            console.error("The following JSON meta object for the field '" + n[e].substring(0, n[e].indexOf(":")) + "' in CSV is invalid: " + A), console.error(t.stack), n[e] = l;
                          }
                        }
                      }
                      if (a.U(s)) {
                        var c = this.CD(n[e], h, 0 == o.length),
                          u = this.qy(n[e]),
                          d = this.py(u),
                          f = this.jY(n[e]) || d;
                        if (this.Fx[e] = c, this.Ak.push(u), s = {
                          type: c,
                          caption: f,
                          j: u
                        }, c == i.types.ka.We) {
                          var p = u.split(":");
                          if (s.hierarchy = p[0], s.level = p.pop(), 0 < p.length) {
                            var g = p.pop();
                            s.parent = g;
                          }
                        }
                        this.O.ea.bu(s, u);
                      } else !a.U(s.type) && i.types.ka.valid(s.type) || ("" == h || void 0 === h ? s.type = i.types.ka.nd : isNaN(Number(h)) ? isNaN(Number(h)) && (s.type = a.$.dN(h) && t.model.A.P.Gk == t.model.A.P.mL ? i.types.ka.jc : i.types.ka.nd) : s.type = i.types.ka.Rb), u = this.qy(l), (a.U(s.caption) || "" == s.caption.length) && (s.caption = this.py(u)), this.Fx[e] = s.type, this.Ak.push(u), this.O.ea.bu(s, u);
                    }
                  } catch (t) {
                    console.error(t.stack), this.z0();
                  } else this.ai();
                }
              }, {
                key: "mY",
                value: function mY(t) {
                  return null != t && (t = t.replace(",", ".")), t;
                }
              }, {
                key: "py",
                value: function py(t) {
                  var e = t.split(o.Ts);
                  return 1 < e.length ? e[1] : (this.Py(t) && (e = t.split(":")), e[e.length - 1]);
                }
              }, {
                key: "qy",
                value: function qy(t) {
                  if (t = t.trim().split(o.Ts)[0], t = this.tF(t), -1 < this.Ak.indexOf(t)) {
                    for (var e = 1, i = t; -1 < this.Ak.indexOf(i);) i = t + e, e++;
                    t = i;
                  }
                  return t;
                }
              }, {
                key: "jY",
                value: function jY(t) {
                  return 1 < (t = t.split(o.Ts)).length ? t[1] : null;
                }
              }, {
                key: "tF",
                value: function tF(t) {
                  return t.replace(/^(\+|dt\+|t\+|n\+|-|ds\+|d\+|m\+|w\+|D\+|D4\+|url\+|img\+|id\+)/, "");
                }
              }, {
                key: "CD",
                value: function CD(e, s, _r41) {
                  var n = i.types.ka.Rb;
                  return e = e.trim(), a.U(s) && !_r41 ? i.types.ka.nd : ("+" == e.charAt(0) ? n = i.types.ka.nd : "t+" == e.substr(0, 2) ? n = i.types.ka.td : "dt+" == e.substr(0, 3) ? n = i.types.ka.ce : "n+" == e.substr(0, 2) || "-" == e.charAt(0) ? n = i.types.ka.Rb : "ds+" == e.substr(0, 3) ? n = i.types.ka.kl : "d+" == e.substr(0, 2) ? n = i.types.ka.jc : "m+" == e.substr(0, 2) ? n = i.types.ka.Ef : "w+" == e.substr(0, 2) ? n = i.types.ka.Po : "D+" == e.substr(0, 2) ? n = i.types.ka.Km : "D4+" == e.substr(0, 3) ? n = i.types.ka.ek : "id+" == e.substr(0, 3) ? n = i.types.ka.Dq : "" == s || void 0 === s ? n = i.types.ka.nd : isNaN(Number(s)) && (n = a.$.dN(s) && t.model.A.P.Gk == t.model.A.P.mL ? i.types.ka.jc : i.types.ka.nd), n == i.types.ka.nd && this.Py(e) && (n = i.types.ka.We), n);
                }
              }, {
                key: "Py",
                value: function Py(t) {
                  return "+" == t.charAt(0) && (t = t.substr(1)), 1 < t.split(":").length && -1 < this.Ak.indexOf(t.split(":")[0].trim());
                }
              }, {
                key: "pv",
                value: function pv() {
                  for (t.Ta(!0, t.model.v.g.ow, a.$.bind(t.model.v.g.ot, a.Fd.Jk(this.data.length.toFixed(0)))); this.fb < this.data.length; this.fb++) this.Bz(this.data[this.fb]);
                }
              }, {
                key: "Bz",
                value: function Bz(e) {
                  if (!a.Vb(e) && void 0 !== this.Ak) {
                    if ((e = a.$.trim(e, this.jg)).split(this.jg).length < this.Ak.length) for (var s = e.split(this.jg).length; s < this.Ak.length; s++) e = e.concat(this.jg);
                    e += " ";
                    var _r42 = !1,
                      n = !1,
                      o = "",
                      h = 0,
                      l = [],
                      A = [],
                      c = "";
                    for (s = 0; s < e.length; s++) {
                      var u = e.charAt(s);
                      s == e.length - 1 || u == this.jg && !_r42 ? (s == e.length - 1 && (o += u), (o = (o = o.trim()).replace("\r", "")).charAt(0) == this.Wx && o.charAt(o.length - 1) == this.Wx && (o = o.slice(1, o.length - 1)), this.Fx[h] == i.types.ka.Dq && (c = o), t.model.zc.valid(o) || (o = t.model.zc.validate(o)), null != this.Ak[h] && this.O.Ua.Oc(this.Ak[h], o, this.Fx[h], l, A), _r42 = n = !1, o = "", h++) : u == this.Wx ? (n || (o += u), _r42 = !_r42, n = !0) : (o += u, n = !1);
                    }
                    this.O.Ua.pm(l, A, c);
                  }
                }
              }, {
                key: "appendData",
                value: function appendData(t) {
                  void 0 !== this.ev && 0 < this.ev.length && (t = a.$.concat(this.ev, t)), t = this.v3(t);
                  for (var e = 0; e < t.length; e++) this.data.push(t[e]);
                  1 != this.$u && (this.ev = this.data.pop());
                }
              }, {
                key: "v3",
                value: function v3(t) {
                  var e = !1;
                  if (t = t.split(this.eo), 0 == this.bs) for (var i = 0; i < t.length; i++) e ? (this.lN(t[i]) && (e = !1), t[i - 1] += "<br/>" + t[i], t.splice(i, 1), i--) : this.lN(t[i]) && (e = !0);
                  return t;
                }
              }, {
                key: "lN",
                value: function lN(t) {
                  return 1 == this.qW(t, this.Wx) % 2;
                }
              }, {
                key: "qW",
                value: function qW(t, e) {
                  var i = 0;
                  if (t) for (var s = 0; s < t.length; s++) t.charAt(s) == e && i++;
                  return i;
                }
              }, {
                key: "HV",
                value: function HV(t) {
                  if (null == this.jg) return t.split(",").length > t.split(";").length ? "," : ";";
                }
              }, {
                key: "cancel",
                value: function cancel() {
                  this.clear(), this.Ck = this.Bc = this.Xj = null;
                }
              }], [{
                key: "sZ",
                value: function sZ(e) {
                  return -1 == (e = e.toLowerCase()).indexOf("<html>") && -1 == e.indexOf("<config>") && 0 != e.trim().length && -1 == e.indexOf("<!doctype") || (t.yc(t.model.v.g.KR, t.model.v.g.wb, t.ld.wb), !1);
                }
              }, {
                key: "qP",
                value: function qP(t, e) {
                  if (null == t) return [];
                  for (var i = "", s = !1, _r43 = !1, n = [], a = 0; a < t.length; a++) {
                    var o = t.charAt(a);
                    a == t.length - 1 || o == e && !s ? (a == t.length - 1 && o == e ? (n.push(i), i = "") : a == t.length - 1 && (i += o), '"' == (i = i.trim()).charAt(0) && '"' == i.charAt(i.length - 1) && (i = i.slice(1, i.length - 1)), s = _r43 = !1, n.push(i), i = "") : '"' == o ? (_r43 || (i += o), s = !s, _r43 = !0) : (i += o, _r43 = !1);
                  }
                  return n;
                }
              }, {
                key: "w3",
                value: function w3(t, e) {
                  if (null == t) return [];
                  for (var i = "", s = !1, _r44 = !1, n = !1, a = [], o = 0; o < t.length; o++) {
                    var h = t.charAt(o);
                    o == t.length - 1 || h == e && !s && !n ? (o == t.length - 1 && h == e ? (a.push(i), i = "") : o == t.length - 1 && (i += h), '"' == (i = i.trim()).charAt(0) && '"' == i.charAt(i.length - 1) && (i = i.slice(1, i.length - 1)), n = s = _r44 = !1, a.push(i), i = "") : '"' == h ? (_r44 || (i += h), s = !s, _r44 = !0) : (_r44 = !1, "{" == h ? n = !0 : "}" == h && (n = !1), i += h);
                  }
                  return a;
                }
              }, {
                key: "qo",
                value: function qo(e) {
                  return e && 0 < e.length ? e : t.model.v.g.sl;
                }
              }]);
              return r;
            }();
            s.uA = r;
            var o = /*#__PURE__*/_createClass(function o() {
              _classCallCheck(this, o);
            });
            o.FLOAT = "F", o.Ts = "+T+", s.HG = o;
          }((i = t.u || (t.u = {})).vj || (i.vj = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.u || (t.u = {}), (i = e.vj || (e.vj = {})).rQ = /*#__PURE__*/function () {
            function _class20() {
              _classCallCheck(this, _class20);
              this.jJ = !1, this.cJ = 0, this.ft = ",", this.tI = "\n", this.Sq = e.Ja.V(), this.OT = "\x3c!--", this.PT = "--\x3e", this.AB = "/**----**", this.NT = "**--!--**/", this.Rw = this.Qw = "", this.V1 = RegExp("%d%", "g"), this.X1 = RegExp("%q%", "g"), this.W1 = RegExp("%n%", "g");
            }
            _createClass(_class20, [{
              key: "load",
              value: function load(t, e, i, s, r) {
                try {
                  this.clear(), this.ag = t, this.WJ = e, this.Ck = s, this.pu = r, this.BB = i, this.jJ = this.ag.hg, this.cJ = this.ag.Tx, this.dJ = this.ag.HL, this.jJ && null != this.dJ && this.d_(this.dJ);
                } catch (t) {
                  console.error(t.stack), this.ai();
                }
              }
            }, {
              key: "RW",
              value: function RW(t) {
                this.Qw = -1 < t.indexOf(this.AB) ? this.AB : this.OT, this.Rw = this.Qw == this.AB ? this.NT : this.PT;
              }
            }, {
              key: "d_",
              value: function d_(e) {
                var _this79 = this;
                this.gh = 2e3, this.Gg = 0;
                try {
                  var i = new t.yq(e, this.cJ, t.yq.nA),
                    s = i.byteLength > this.gh ? this.gh : i.byteLength,
                    r = i.rF(s);
                  this.RW(r), this.Ht = "", this.Ht += r.substring(this.Qw.length), this.Gg += s, this.Ct = i.byteLength, this.Gg < this.Ct ? a.ni.jp(this.c_, this, i, function () {
                    return _this79.ms();
                  }) : this.ms();
                } catch (t) {
                  console.error(t.stack), this.ai();
                }
              }
            }, {
              key: "c_",
              value: function c_(t) {
                var e = this.Ct - this.Gg > this.gh ? this.gh : this.Ct - this.Gg;
                return t = t.rF(e), this.Gg += e, this.Ht += t, this.e3(this.Gg, this.Ct), this.Gg >= this.Ct;
              }
            }, {
              key: "e3",
              value: function e3(e, i) {
                e = a.$.bind(t.model.v.g.ot, (e / i * 100).toFixed(0) + "%"), t.Ta(!0, t.model.v.g.RH, e);
              }
            }, {
              key: "ms",
              value: function ms() {
                t.Ta(!1), this.NB = !0, this.Q1(this.Ht);
              }
            }, {
              key: "Uz",
              value: function Uz() {
                null != this.Ck && (this.Ck(), this.Ck = null);
              }
            }, {
              key: "Q1",
              value: function Q1(t) {
                t = a.$.trimLeft(t), this.aq(t);
              }
            }, {
              key: "bO",
              value: function bO() {
                if (this.YJ++, 0 < this.Gg || this.NB || this.MB) a.Mr(this.mn), this.YJ = 0;else {
                  var e = this.YJ / 10;
                  this.ZT ? (196 < e && (e = 196), e = a.Fd.format(e / 2, new t.model.format.C.Eo(), !1, !1, 1) + "%") : e = a.$.bind(t.model.v.g.TH, a.Fd.format(e, new t.model.format.C.Eo(), !1, !1, 1)), t.Ta(!0, t.model.v.g.Pm, e);
                }
              }
            }, {
              key: "ai",
              value: function ai() {
                a.Mr(this.mn), t.Ta(!1), 0 == this.MB && (this.MB = !0, t.yc(a.$.bind(t.model.v.g.rw, ""), t.model.v.g.wb, t.ld.wb)), null != this.Bc && (this.Bc(), this.Bc = null), this.clear();
              }
            }, {
              key: "aq",
              value: function aq(t) {
                this.Uz(), this.appendData(t), 0 == this.PB && 1 < this.Ff.length && (this.Ff.shift(), this.Cz(this.Ff.shift()), this.PB = !0, this.pv(), this.ME());
              }
            }, {
              key: "appendData",
              value: function appendData(t) {
                void 0 !== this.Zo && 0 < this.Zo.length && (t = a.$.concat(this.Zo, t)), t = 0 <= t.indexOf(this.tI) ? t.split(this.tI) : [];
                for (var e = 0; e < t.length; e++) this.Ff.push(t[e]);
                1 != this.NB && (this.Zo = this.Ff.pop(), this.Zo = this.Zo == this.Rw ? this.Ff.pop() : this.Zo);
              }
            }, {
              key: "Cz",
              value: function Cz(t) {
                t = i.uA.w3(t, this.ft), this.ti = [];
                for (var e = 0; e < t.length; e++) {
                  var s = t[e],
                    r = {};
                  if (0 < t[e].length && -1 < t[e].indexOf("{")) {
                    var n = t[e].substr(t[e].indexOf(":") + 1, t[e].length);
                    if (0 < n.length) {
                      s = t[e].substring(0, t[e].indexOf(":"));
                      try {
                        r = JSON.parse(n);
                      } catch (i) {
                        console.error("The following JSON meta object for the field '" + t[e].substring(0, t[e].indexOf(":")) + "' in CSV is invalid: " + n), console.error(i.stack);
                      }
                    }
                  }
                  s = this.qy(s), (a.U(r.caption) || "" == r.caption.length) && (r.caption = this.py(s)), this.lk[e] = r.type, this.ti.push(s), this.Sq.ea.bu(r, s);
                }
              }
            }, {
              key: "py",
              value: function py(t) {
                var e = t.split(i.HG.Ts);
                return 1 < e.length ? e[1] : (this.Py(t) && (e = t.split(":")), e[e.length - 1]);
              }
            }, {
              key: "Py",
              value: function Py(t) {
                return "+" == t.charAt(0) && (t = t.substr(1)), 1 < t.split(":").length && -1 < this.ti.indexOf(t.split(":")[0].trim());
              }
            }, {
              key: "qy",
              value: function qy(t) {
                if (t = t.trim().split(i.HG.Ts)[0], t = this.tF(t), t = this.lL(t), -1 < this.ti.indexOf(t)) {
                  for (var e = 1, s = t; -1 < this.ti.indexOf(s);) s = t + e, e++;
                  t = s;
                }
                return t;
              }
            }, {
              key: "tF",
              value: function tF(t) {
                return t.replace(/^(\+|dt\+|t\+|n\+|-|ds\+|d\+|m\+|w\+|D\+|D4\+|url\+|img\+|id\+)/, "");
              }
            }, {
              key: "pv",
              value: function pv() {
                for (t.Ta(!0, t.model.v.g.ow, a.$.bind(t.model.v.g.ot, a.Fd.Jk(this.Ff.length.toFixed(0)))); this.Ic < this.Ff.length; this.Ic++) this.Bz(this.Ff[this.Ic]);
              }
            }, {
              key: "Bz",
              value: function Bz(t) {
                if (!a.Vb(t) && void 0 !== this.ti && t != this.Rw) {
                  if (t.split(this.ft).length < this.ti.length) for (var e = t.split(this.ft).length; e < this.ti.length; e++) t = t.concat(this.ft);
                  var i = [],
                    s = [];
                  for (t = t.split(this.ft), e = 0; e < t.length; e++) this.F1(t[e], e, i, s);
                  this.Sq.Ua.pm(i, s);
                }
              }
            }, {
              key: "F1",
              value: function F1(i, s, r, n) {
                var a = !0;
                if (null != this.ti[s]) {
                  if (this.lk[s] == e.types.ka.nd || this.lk[s] == e.types.ka.Po || this.lk[s] == e.types.ka.Ef) {
                    if ("^" == i.charAt(0)) {
                      var o = parseInt(i.substring(1));
                      if (0 == isNaN(o)) {
                        var h = this.Sq.ea.Uh(this.ti[s]);
                        null != (o = h.ua.F(o + 1)) && (i = o.caption == t.model.v.g.Cg ? "" : o.caption, a = !1);
                      }
                    }
                  } else this.lk[s] == e.types.ka.We ? "^" == i.charAt(0) && (o = parseInt(i.substring(1)), 0 == isNaN(o) && (null == (h = this.Sq.ea.Uh(this.ti[s])).ua && (h = this.Sq.ea.Uh(this.ti[s]).lb), null != (o = h.ua.F(o + 1)) && (i = o.caption == t.model.v.g.Cg ? "" : o.caption, a = !1))) : this.lk[s] != e.types.ka.jc && this.lk[s] != e.types.ka.kl && this.lk[s] != e.types.ka.Km && this.lk[s] != e.types.ka.ek || (i = 1e3 * parseInt(i), a = !1);
                  1 == a && (i = this.lL(i)), this.Sq.Ua.Oc(this.ti[s], i, this.lk[s], r, n);
                }
              }
            }, {
              key: "lL",
              value: function lL(t) {
                return t.replace(this.V1, ",").replace(this.X1, '"').replace(this.W1, "\n");
              }
            }, {
              key: "ME",
              value: function ME() {
                t.Ta(!1), this.PB ? this.Xj() : (t.yc(t.model.v.g.UH, t.model.v.g.wb, t.ld.to), this.Bc(), this.BB = null), this.clear();
              }
            }, {
              key: "clear",
              value: function clear() {
                this.Ff = [], this.Rw = this.Qw = "", this.Gg = 0, this.ZT = !1, this.lk = [], this.MB = this.NB = this.PB = !1, this.Zo = "", this.Ic = 0, this.gh = 100, a.Mr(this.mn);
              }
            }, {
              key: "Xj",
              value: function Xj() {
                null != this.WJ && this.WJ();
              }
            }, {
              key: "Bc",
              value: function Bc() {
                null != this.BB && this.BB();
              }
            }, {
              key: "cancel",
              value: function cancel() {
                this.Ck = this.Bc = this.Xj = null;
              }
            }]);
            return _class20;
          }();
        }(r || (r = {})), function (t) {
          var e;
          !function (i) {
            i.vA = /*#__PURE__*/function () {
              function _class21() {
                _classCallCheck(this, _class21);
                this.NaN = "NaN", this.RT = "/**----**", this.QT = "**--!--**/";
              }
              _createClass(_class21, [{
                key: "getData",
                value: function getData(e) {
                  this.$I = e, t.Ta(!0, t.model.v.g.WH), this.K1(), this.Gx();
                }
              }, {
                key: "K1",
                value: function K1() {
                  for (this.Al = e.Ja.V().ea.bb(), this.bd = [], this.sc = 0; this.sc < this.Al.length;) {
                    var t = this.Al.F(this.sc),
                      i = e.Ja.V().ea.og(t.j).type;
                    i != e.types.Ca.Hb && i != e.types.Ca.jc ? this.O1(e.Ja.V().ea.og(t.j)) : this.M1(t), this.sc++;
                  }
                }
              }, {
                key: "Gx",
                value: function Gx() {
                  var _this80 = this;
                  this.Ic = 0, this.Ff = "", this.UT = e.Ja.V().Ua.pc, this.Jg = e.Ja.V().Ua.Tu(), a.ni.jp(this.fW, this, null, function () {
                    return _this80.$_();
                  });
                }
              }, {
                key: "fW",
                value: function fW() {
                  var t = a.Nk();
                  for (this.se = this.sc = 0; this.Ic < this.Jg.length;) {
                    for (; this.sc + this.se < this.Jg[this.Ic].length;) this.Oc(this.gW()), this.sc++;
                    if (this.Ic++, this.Ff += "\n", this.se = this.sc = 0, 100 < a.Nk() - t) break;
                  }
                  return this.h3(this.Ic, this.Jg.length), this.Ic >= this.Jg.length;
                }
              }, {
                key: "gW",
                value: function gW() {
                  var t = this.bd[this.sc].type;
                  if (t != e.types.ka.jc && t != e.types.ka.kl && t != e.types.ka.We && t != e.types.ka.Km && t != e.types.ka.ek && t != e.types.ka.td && t != e.types.ka.ce) var i = this.Al.getItem(this.bd[this.sc].j).ua.F(this.Jg[this.Ic][this.sc + this.se]).caption;
                  if (t == e.types.ka.Rb) return null != i ? i.toString() : "";
                  if (t != e.types.ka.nd && t != e.types.ka.Po && t != e.types.ka.Ef) {
                    if (t == e.types.ka.We) {
                      i = (t = this.Al.getItem(this.bd[this.sc].lb)).ua.F(this.Jg[this.Ic][this.sc + this.se]).caption;
                      for (var s = this.sc, r = 0; r < t.Fb.length - 2; r++) this.Oc(this.FC(i, s)), this.sc++, i = null == this.Jg[this.Ic][this.sc + this.se] || "" == this.Jg[this.Ic][this.sc + this.se] + "" ? "" : t.ua.F(this.Jg[this.Ic][this.sc + this.se]).caption;
                      return this.FC(i, s);
                    }
                    if (t == e.types.ka.kl) return this.Al.getItem(this.bd[this.sc].j).ua.F(this.Jg[this.Ic][this.sc + this.se]).qg / 1e3 + "";
                    if (t == e.types.ka.jc) return i = "", i += (t = this.Al.getItem(this.bd[this.sc].j + ".Year").ua.F(this.Jg[this.Ic][this.sc + this.se])).caption + "-", this.se++, i += (t = this.Al.getItem(this.bd[this.sc].j + ".Month").ua.F(this.Jg[this.Ic][this.sc + this.se])).caption + "-", this.se++, i += (t = this.Al.getItem(this.bd[this.sc].j + ".Day").ua.F(this.Jg[this.Ic][this.sc + this.se])).caption, new Date(i).getTime() / 1e3 + Math.abs(60 * new Date().getTimezoneOffset()) + "";
                    if (t == e.types.ka.Km || t == e.types.ka.ek) return this.eW(t);
                    if (t == e.types.ka.td || t == e.types.ka.ce) return this.UT[this.Ic][this.sc + this.se] + "";
                  }
                  return this.FC(i);
                }
              }, {
                key: "Oc",
                value: function Oc(e) {
                  this.Ff += e == this.NaN || e == t.model.v.g.Cg ? "" : e, this.Ff += this.sc + this.se < this.Jg[this.Ic].length - 1 ? "," : "";
                }
              }, {
                key: "FC",
                value: function FC(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.sc;
                  return "" == t ? t : (this.bd[e].ua.rc(t) || this.bd[e].ua.Ea(t, this.bd[e].ua.length), this.iX(t));
                }
              }, {
                key: "iX",
                value: function iX(t) {
                  return t.replace(/,/g, "%d%").replace(/"/g, "%q%").replace(/\n/g, "%n%");
                }
              }, {
                key: "eW",
                value: function eW(t) {
                  return this.se += 2, this.se = t == e.types.ka.ek ? this.se + 1 : this.se, this.Al.getItem(this.bd[this.sc].j).ua.F(this.Jg[this.Ic][this.sc + this.se]).qg / 1e3 + "";
                }
              }, {
                key: "$_",
                value: function $_() {
                  t.Ta(!1), null != this.$I && this.$I(this.SY());
                }
              }, {
                key: "M1",
                value: function M1(t) {
                  var i = this.DY(t);
                  i == e.types.ka.We ? this.N1(t) : i == e.types.ka.jc ? (this.bd.push(this.Ix(i, t.xj.j, t.xj.caption)), this.sc += 2) : this.bd.push(this.Ix(i, t.j, t.caption));
                }
              }, {
                key: "SY",
                value: function SY() {
                  for (var e = this.RT + "\n___csv___WDR___" + t.Um.oA + "\n", i = 0; i < this.bd.length; i++) e += this.bd[i].j, e += ":{", e += '"type": "' + this.bd[i].type + '"', this.bd[i].Of ? (e += ', "hierarchy": "' + this.bd[i].lb + '"', e += ', "level": "' + this.bd[i].j + '"', a.U(this.bd[i].parent) || (e += ', "parent": "' + this.bd[i].parent + '"')) : this.bd[i].j != this.bd[i].caption && (e += ', "caption": "' + this.bd[i].caption + '"'), e += "}", e += i < this.bd.length - 1 ? "," : "";
                  return e + "\n" + this.Ff + this.QT;
                }
              }, {
                key: "O1",
                value: function O1(t) {
                  this.bd.push(this.Ix(e.types.Ca.CP(t.type), t.j, t.$n, !0));
                }
              }, {
                key: "N1",
                value: function N1(t) {
                  var i = t.j;
                  t = t.Fb;
                  for (var s, r, n = 1; n < t.length; n++) {
                    if (r = n, s = t.getItem(t.yd(n)), 1 < r) var o = t.getItem(t.yd(r - 1)).j;
                    (s = this.Ix(e.types.ka.We, s.j, s.caption)).Of = !0, s.lb = i, a.U(o) || (s.parent = o), this.bd.push(s);
                  }
                }
              }, {
                key: "DY",
                value: function DY(t) {
                  if (t.xj.type.toString() == e.types.ka.kl) return e.types.ka.kl;
                  var i = e.types.ka.S3(t.type);
                  return 2 < t.Fb.length && (i = 4 == t.Fb.length && t.Fb.F(1).j == t.j + ".Year" ? e.types.ka.Km : 5 == t.Fb.length && t.Fb.F(1).j == t.j + ".Year" ? e.types.ka.ek : e.types.ka.We), i;
                }
              }, {
                key: "h3",
                value: function h3(e, i) {
                  e = a.$.bind(t.model.v.g.ot, (e / i * 100).toFixed(0) + "%"), t.Ta(!0, t.model.v.g.WH, e);
                }
              }, {
                key: "Ix",
                value: function Ix(t, e, i) {
                  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                  var n = new s();
                  return n.type = t, n.j = e, n.caption = i, n.Wd = r, n;
                }
              }]);
              return _class21;
            }();
            var s = /*#__PURE__*/function () {
              function s() {
                _classCallCheck(this, s);
                this.BJ = !1, this.cr = new a.ma();
              }
              _createClass(s, [{
                key: "ua",
                get: function get() {
                  return this.cr;
                }
              }, {
                key: "type",
                get: function get() {
                  return this.Vc;
                },
                set: function set(t) {
                  this.Vc = t;
                }
              }, {
                key: "j",
                get: function get() {
                  return this.jC;
                },
                set: function set(t) {
                  this.jC = t;
                }
              }, {
                key: "caption",
                get: function get() {
                  return this.ib;
                },
                set: function set(t) {
                  this.ib = t;
                }
              }, {
                key: "Wd",
                get: function get() {
                  return this.$T;
                },
                set: function set(t) {
                  this.$T = t;
                }
              }, {
                key: "Of",
                get: function get() {
                  return this.BJ;
                },
                set: function set(t) {
                  this.BJ = t;
                }
              }, {
                key: "lb",
                get: function get() {
                  return this.YT;
                },
                set: function set(t) {
                  this.YT = t;
                }
              }, {
                key: "parent",
                get: function get() {
                  return this.fU;
                },
                set: function set(t) {
                  this.fU = t;
                }
              }]);
              return s;
            }();
            i.y4 = s;
          }((e = t.u || (t.u = {})).vj || (e.vj = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (i) {
            var s = /*#__PURE__*/function (_e$vj$uA) {
              _inherits(s, _e$vj$uA);
              var _super58 = _createSuper(s);
              function s() {
                var _this81;
                _classCallCheck(this, s);
                _this81 = _super58.call(this), _this81.dQ = 1e4, _this81.km = 0, _this81.lD = [".js", ".json"];
                return _this81;
              }
              _createClass(s, [{
                key: "load",
                value: function load(t, e, i, _s62, r) {
                  this.clear(), this.Xj = e, this.Bc = i, this.Ck = _s62, this.pu = r, !0 === t.eg ? this.GK() : void 0 !== t.filename && "" != t.filename && "()" != t.filename.substr(-2) ? _get(_getPrototypeOf(s.prototype), "load", this).call(this, t, e, i, _s62, r) : this.bK(t.data);
                }
              }, {
                key: "RE",
                value: function RE(e) {
                  if (!a.U(this.Ub)) try {
                    if (1e4 < e.loaded - this.np) {
                      var i = a.$.bind(t.model.v.g.SH, a.Fd.Jk((e.loaded / 1e3).toFixed(0)), a.Fd.Jk((e.total / 1e3).toFixed(0)));
                      t.Ta(!0, t.model.v.g.Pm, i);
                    }
                    this.np = e.loaded;
                  } catch (t) {
                    console.error(t.stack), this.ai();
                  }
                }
              }, {
                key: "QE",
                value: function QE() {
                  if (!a.U(this.Ub)) {
                    var e = this.Ub.response;
                    this.connected = !0, e.length > t.model.fc.Io.nt ? (t.yc(t.model.fc.Ed.I(t.model.fc.Ed.iu), t.model.fc.Ed.I(t.model.fc.Ed.Lv)), t.Ta(!1), null != this.Bc && (this.Bc(), this.Bc = null), this.clear()) : (this.$u = !0, this.aq(e));
                  }
                }
              }, {
                key: "aq",
                value: function aq(e) {
                  try {
                    var i = JSON.parse(e);
                    if (a.U(i.items) || (i = i.items), a.U(i.length)) return void this.bN();
                  } catch (t) {
                    return void this.bN();
                  }
                  t.Ta(!1), this.bK(i);
                }
              }, {
                key: "bK",
                value: function bK(e) {
                  if (a.U(e.items) || (e = e.items), !(a.U(e) || 1 > e.length)) if (JSON.stringify(e).length > t.model.fc.Io.nt && 15649632e5 < Date.now() || e.toString().length > t.model.fc.Io.nt) t.yc(t.model.fc.Ed.I(t.model.fc.Ed.iu), t.model.fc.Ed.I(t.model.fc.Ed.Lv));else {
                    this.Uz();
                    var i = !1,
                      _s63 = e[0] && e[0] instanceof Array;
                    _s63 ? this.Cz(e[0].toString(), e[1].toString()) : i = this.O.ea.vU(e[0]), this.data = e.slice(), this.km = 0, (i || _s63) && this.data.shift(), this.pv(), this.T0();
                  }
                }
              }, {
                key: "dl",
                value: function dl(e) {
                  if (!(a.U(e) || 1 > e.length)) if (JSON.stringify(e).length > t.model.fc.Io.nt && 15649632e5 < Date.now() || e.toString().length > t.model.fc.Io.nt) t.yc(t.model.fc.Ed.I(t.model.fc.Ed.iu), t.model.fc.Ed.I(t.model.fc.Ed.Lv));else {
                    this.O.Ua.RV();
                    for (var i = e[1] && e[1] instanceof Array, _s64 = 0; _s64 < e.length; _s64++) i ? this.O.Ua.aE(e[_s64], !0) : this.O.Ua.cE(e[_s64], !0);
                  }
                }
              }, {
                key: "T0",
                value: function T0() {
                  t.Ta(!1), this.Xj();
                }
              }, {
                key: "Bz",
                value: function Bz() {
                  for (var e = this.km, i = e + this.dQ, _s65 = this.data[1] && this.data[1] instanceof Array; e < i; e++) {
                    if (e == this.data.length) return;
                    _s65 ? this.O.Ua.aE(this.data[e]) : this.O.Ua.cE(this.data[e]), this.km++;
                  }
                  100 < (i = Math.round(this.km / this.data.length * 100)) && (i = 100), t.Ta(!0, t.model.v.g.ow, a.$.bind(t.model.v.g.GR, a.Fd.Jk(this.km.toString()), a.Fd.Jk(this.data.length.toString()), i.toString()));
                }
              }, {
                key: "pv",
                value: function pv() {
                  t.Ta(!0, t.model.v.g.ow, a.$.bind(t.model.v.g.ot, a.Fd.Jk(this.data.length.toFixed(0))));
                  for (var e = this.data[1] && this.data[1] instanceof Array; this.km < this.data.length; this.km++) e ? this.O.Ua.aE(this.data[this.km]) : this.O.Ua.cE(this.data[this.km]);
                }
              }, {
                key: "bN",
                value: function bN() {
                  t.Ta(!1), t.yc(t.model.v.g.LR, t.model.v.g.wb), this.Bc(), this.Ls();
                }
              }]);
              return s;
            }(e.vj.uA);
            i.tR = s;
          }((e = t.u || (t.u = {})).json || (e.json = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function () {
              function e() {
                _classCallCheck(this, e);
              }
              _createClass(e, null, [{
                key: "valid",
                value: function valid(t) {
                  return t == e.JSON || t == e.jl || t == e.EMPTY;
                }
              }]);
              return e;
            }();
            e.jl = "csv", e.JSON = "json", e.EMPTY = "", t.Te = e;
          }((e = t.u || (t.u = {})).i || (e.i = {}));
        }(r || (r = {}));
        var b = r || (r = {}),
          B = b.u || (b.u = {}),
          y = B.i || (B.i = {});
        var C = /*#__PURE__*/_createClass(function C() {
          _classCallCheck(this, C);
        });
        C.ut = "top", C.tq = "bottom", C.NONE = "none", y.Dd = C, function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function () {
              function e() {
                _classCallCheck(this, e);
              }
              _createClass(e, null, [{
                key: "XZ",
                value: function XZ(t) {
                  return t == e.mb || t == e.ub || t == e.vb;
                }
              }]);
              return e;
            }();
            e.mb = "unsorted", e.ub = "asc", e.vb = "desc", e.bS = "numericRange", t.ba = e;
          }((e = t.u || (t.u = {})).i || (e.i = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/_createClass(function e() {
              _classCallCheck(this, e);
            });
            e.Ka = "rows", e.rb = "columns", e.Sm = "pages", t.da = e;
          }((e = t.u || (t.u = {})).i || (e.i = {}));
        }(r || (r = {}));
        var F = r || (r = {}),
          x = F.u || (F.u = {}),
          N = x.types || (x.types = {});
        var E = /*#__PURE__*/_createClass(function E() {
          _classCallCheck(this, E);
        });
        E.TA = 1, E.SA = 2, N.zq = E, function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function () {
              function e() {
                _classCallCheck(this, e);
              }
              _createClass(e, null, [{
                key: "CP",
                value: function CP(i) {
                  var s = t.ka.nd;
                  switch (i) {
                    case e.CR:
                      s = t.ka.Rb;
                      break;
                    case e.jc:
                      s = t.ka.jc;
                  }
                  return s;
                }
              }]);
              return e;
            }();
            e.jc = 1, e.CR = 2, t.J4 = e;
          }((e = t.u || (t.u = {})).types || (e.types = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function () {
              function e() {
                _classCallCheck(this, e);
              }
              _createClass(e, null, [{
                key: "DX",
                value: function DX(t) {
                  switch (t) {
                    case 13:
                      return e.td;
                    case 15:
                      return e.ce;
                    case 3:
                      return e.uo;
                    case 12:
                      return e.Rb;
                  }
                  return e.Hb;
                }
              }, {
                key: "EX",
                value: function EX(t) {
                  var i = e.Hb;
                  switch (t) {
                    case "number":
                      i = e.Rb;
                      break;
                    case "string":
                      i = e.nd;
                      break;
                    case "boolean":
                      i = e.uo;
                      break;
                    case "date":
                      i = e.jc;
                      break;
                    case "timestamp":
                      i = e.td;
                      break;
                    case "count":
                      i = e.Hb;
                  }
                  return i;
                }
              }, {
                key: "CP",
                value: function CP(i) {
                  switch (i) {
                    case e.nd:
                      return t.ka.nd;
                    case e.uo:
                      return t.ka.uo;
                    case e.jc:
                      return t.ka.jc;
                    case e.ce:
                      return t.ka.ce;
                    case e.td:
                      return t.ka.td;
                  }
                  return t.ka.Rb;
                }
              }]);
              return e;
            }();
            e.Rb = 1, e.nd = 2, e.uo = 3, e.jc = 4, e.td = 5, e.ce = 6, e.Hb = 7, t.Ca = e;
          }((e = t.u || (t.u = {})).types || (e.types = {}));
        }(r || (r = {}));
        var U = r || (r = {}),
          Q = U.u || (U.u = {}),
          L = Q.types || (Q.types = {});
        var S = /*#__PURE__*/_createClass(function S() {
          _classCallCheck(this, S);
        });
        S.nd = 1, S.Rb = 2, S.uo = 3, S.jc = 4, S.td = 5, S.$m = 6, S.BH = 7, S.pt = 8, S.Ef = 9, S.qT = 10, S.Po = 11, S.ii = 12, S.DH = 13, S.YH = 14, S.NI = 17, L.Ab = S, function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function () {
              function e() {
                _classCallCheck(this, e);
              }
              _createClass(e, null, [{
                key: "S3",
                value: function S3(t) {
                  return e.qC[t];
                }
              }, {
                key: "T3",
                value: function T3(t) {
                  return e.qC.indexOf(t);
                }
              }, {
                key: "valid",
                value: function valid(t) {
                  return -1 < e.qC.indexOf(t);
                }
              }, {
                key: "R3",
                value: function R3(t) {
                  return "" === t ? e.nd : "number" != typeof t && isNaN(Number(t)) ? 0 < Date.parse(t) ? a.Fr().Yu && !t.match(/^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/i) ? e.nd : e.jc : e.nd : e.Rb;
                }
              }]);
              return e;
            }();
            e.nd = "string", e.Rb = "number", e.uo = "boolean", e.We = "level", e.Ef = "month", e.Po = "weekday", e.jc = "date", e.kl = "date string", e.Km = "year/month/day", e.ek = "year/quarter/month/day", e.td = "time", e.ce = "datetime", e.Dq = "id", e.LG = "delete", e.NA = "hidden", e.qC = [e.Rb, e.nd, e.uo, e.We, e.Ef, e.Po, e.jc, e.kl, e.Km, e.ek, e.td, e.ce, e.Dq, e.LG, e.NA], t.ka = e;
          }((e = t.u || (t.u = {})).types || (e.types = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (e) {
            var i = /*#__PURE__*/function () {
              function i() {
                _classCallCheck(this, i);
              }
              _createClass(i, null, [{
                key: "sK",
                value: function sK(e) {
                  return e == i.ik ? t.model.v.g.II : e == i.Hb ? t.model.v.g.CG : e == i.zg || e == i.Zv ? t.model.v.g.GQ : e == i.Hm ? t.model.v.g.eG : e == i.Tm ? t.model.v.g.mS : e == i.MIN ? t.model.v.g.QR : e == i.MAX ? t.model.v.g.AR : e == i.jj ? t.model.v.g.dS : e == i.Jh || e == i.tw ? t.model.v.g.eS : e == i.ki ? t.model.v.g.jS : e == i.rl ? t.model.v.g.rR : e == i.ll ? t.model.v.g.EQ : e == i.ji ? t.model.v.g.gS : e == i.NONE ? t.model.v.g.ZR : e == i.Om ? t.model.v.g.ER : e == i.Lo ? t.model.v.g.GS : e == i.Mo ? t.model.v.g.IS : e == i.hk ? t.model.v.g.sS : e;
                }
              }, {
                key: "tK",
                value: function tK() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                  var e = [];
                  t = t || i.sq;
                  for (var s = 0; s < t.length; s++) e.push(i.sK(t[s]));
                  return e;
                }
              }, {
                key: "aV",
                value: function aV() {
                  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                  var s = [];
                  e = e || i.sq;
                  for (var r = 0; r < e.length; r++) e[r] == i.ik && s.push(t.model.v.g.JI), e[r] == i.Hb && s.push(t.model.v.g.DG), e[r] != i.zg && e[r] != i.Zv || s.push(t.model.v.g.NG), e[r] == i.Hm && s.push(t.model.v.g.fG), e[r] == i.Tm && s.push(t.model.v.g.nI), e[r] == i.MIN && s.push(t.model.v.g.$H), e[r] == i.MAX && s.push(t.model.v.g.NH), e[r] == i.jj && s.push(t.model.v.g.jI), e[r] != i.Jh && e[r] != i.tw || s.push(t.model.v.g.gI), e[r] == i.ki && s.push(t.model.v.g.iI), e[r] == i.rl && s.push(t.model.v.g.EH), e[r] == i.ll && s.push(t.model.v.g.MG), e[r] == i.ji && s.push(t.model.v.g.hI), e[r] == i.NONE && s.push("{0}"), e[r] == i.Om && s.push(t.model.v.g.OH), e[r] == i.Lo && s.push(t.model.v.g.FI), e[r] == i.Mo && s.push(t.model.v.g.GI), e[r] == i.hk && s.push(t.model.v.g.xI);
                  return s;
                }
              }, {
                key: "Rs",
                value: function Rs(t) {
                  return -1 != i.sq.indexOf(t) || t == i.NONE;
                }
              }, {
                key: "Ov",
                value: function Ov(t) {
                  return -1 != i.QP.indexOf(t) || t == i.NONE;
                }
              }, {
                key: "c4",
                value: function c4(t) {
                  return -1 != i.RP.indexOf(t) || t == i.NONE;
                }
              }, {
                key: "Qn",
                value: function Qn(t) {
                  return -1 != i.SP.indexOf(t);
                }
              }, {
                key: "Wh",
                value: function Wh(t) {
                  return -1 != i.TP.indexOf(t);
                }
              }, {
                key: "rL",
                value: function rL(t) {
                  return t == i.Zv || t == i.tw;
                }
              }, {
                key: "bM",
                value: function bM(t) {
                  switch (t) {
                    case i.Zv:
                      return i.zg;
                    case i.tw:
                      return i.Jh;
                    default:
                      return "";
                  }
                }
              }]);
              return i;
            }();
            i.ik = "sum", i.Hb = "count", i.zg = "distinctcount", i.Zv = "distinct count", i.Hm = "average", i.jj = "percent", i.Jh = "percentofcolumn", i.ki = "percentofrow", i.tw = "percent of column", i.Tm = "product", i.rl = "index", i.MIN = "min", i.MAX = "max", i.NONE = "none", i.ll = "difference", i.ji = "%difference", i.Om = "median", i.Lo = "stdevp", i.Mo = "stdevs", i.hk = "runningtotals", i.sq = [i.ik, i.Hb, i.zg, i.Hm, i.Om, i.Tm, i.MIN, i.MAX, i.jj, i.Jh, i.ki, i.rl, i.ll, i.ji, i.Lo, i.Mo, i.hk], i.QP = [i.ik, i.Hm, i.Om, i.Tm, i.MIN, i.MAX], i.RP = [i.ik, i.Hm, i.Om, i.Tm, i.MIN, i.MAX, i.ll, i.Lo, i.Mo, i.hk], i.SP = [i.Hb, i.zg], i.TP = [i.jj, i.Jh, i.ki, i.ji], e.ca = i;
          }((e = t.u || (t.u = {})).i || (e.i = {}));
        }(r || (r = {}));
        var k = r || (r = {}),
          H = k.u || (k.u = {}),
          I = H.i || (H.i = {});
        var O = /*#__PURE__*/_createClass(function O() {
          _classCallCheck(this, O);
        });
        O.cG = "+", O.HI = "-", O.aI = "*", O.yA = "/", O.mI = "^", O.LESS = "<", O.GREATER = ">", O.EQUAL = "=", O.TG = "==", O.cI = "!=", O.IH = "<=", O.yH = ">=", O.fI = "or", O.dG = "and", O.PA = "if", O.mA = "abs", O.MIN = "min", O.MAX = "max", O.ZP = "isnan", O.aS = "!isnan", O.XI = "value", O.Ew = "updatedifference", O.Fw = "updatepercent", I.$a = O;
        var T = r || (r = {}),
          P = T.u || (T.u = {}),
          j = P.i || (P.i = {});
        var M = /*#__PURE__*/_createClass(function M() {
          _classCallCheck(this, M);
        });
        M.Vm = "select", M.GA = "expand", M.wG = "collapse", M.BA = "drillUp", M.AA = "drillDown", M.gw = "filter", j.Ze = M;
        var D = r || (r = {}),
          R = D.u || (D.u = {}),
          _ = R.i || (R.i = {});
        var z = /*#__PURE__*/_createClass(function z() {
          _classCallCheck(this, z);
        });
        z.$v = .001122334400556678, _.aw = z, function (t) {
          var e;
          !function (t) {
            var i = /*#__PURE__*/function () {
              function i() {
                _classCallCheck(this, i);
                this.Uq = e.i.Te.EMPTY, this.pN = !1;
              }
              _createClass(i, [{
                key: "gg",
                get: function get() {
                  return this.Uq;
                },
                set: function set(t) {
                  this.Uq = t.toLowerCase();
                }
              }, {
                key: "isEqual",
                value: function isEqual(t) {
                  return t && this.gg == t.gg;
                }
              }, {
                key: "Db",
                get: function get() {
                  return this.Uq == e.i.Te.EMPTY;
                },
                set: function set(t) {}
              }, {
                key: "BZ",
                get: function get() {
                  return this.Uq == e.i.Te.jl && "this" == this.filename;
                }
              }, {
                key: "gs",
                get: function get() {
                  return !1;
                },
                set: function set(t) {}
              }, {
                key: "Sa",
                value: function Sa() {
                  var t = {};
                  return this.gg != e.i.Te.EMPTY && (t.dataSourceType = this.gg), t;
                }
              }], [{
                key: "Za",
                value: function Za(s) {
                  if (null == s) return new i();
                  if (a.U(s.connectionInfo) || (s = s.connectionInfo), s instanceof i || s instanceof t.$s || s instanceof t.GH || (s = i.Hh(s)), a.U(s.dataSourceType) || (s.dataSourceType = s.dataSourceType.toLowerCase()), !a.U(s.filename) && a.U(s.dataSourceType)) {
                    var r = s.filename.split("?")[0].toLowerCase();
                    s.dataSourceType = ".csv" == r.substr(-4) ? e.i.Te.jl : ".json" == r.substr(-5) || ".js" == r.substr(-3) ? e.i.Te.JSON : e.i.Te.jl;
                  }
                  switch (!a.U(s.data) && s.data instanceof Array && (s.dataSourceType = e.i.Te.JSON, s.data = s.data.slice()), s.dataSourceType) {
                    case e.i.Te.jl:
                      return t.$s.Za(s);
                    case e.i.Te.JSON:
                      return t.GH.Za(s);
                    default:
                      return new i();
                  }
                }
              }, {
                key: "Hh",
                value: function Hh(t) {
                  var e = {};
                  return null != t.dataSourceType && (e.dataSourceType = t.dataSourceType), null != t.filename && (e.filename = t.filename), null != t.requestHeader && (e.requestHeader = t.requestHeader), null != t.browseForFile && (e.browseForFile = t.browseForFile), null != t.fieldSeparator && (e.fieldSeparator = t.fieldSeparator), null != t.recordsetDelimiter && (e.recordsetDelimiter = t.recordsetDelimiter), null != t.ignoreQuotedLineBreaks && (e.ignoreQuotedLineBreaks = t.ignoreQuotedLineBreaks), null != t.embedded && (e.embedded = t.embedded), null != t.embeddedDataOffset && (e.embeddedDataOffset = t.embeddedDataOffset), null != t.embeddedDataToLoad && (e.embeddedDataToLoad = t.embeddedDataToLoad), null != t.data && (e.data = t.data), null != t.checkUpdates && (e.checkUpdates = t.checkUpdates), null != t.url && (e.url = t.url), null != t.hash && (e.hash = t.hash), null != t.username && (e.username = t.username), null != t.password && (e.password = t.password), null != t.dataSource && (null != (t = t.dataSource).dataSourceType && (e.dataSourceType = t.dataSourceType), null != t.filename && (e.filename = t.filename), null != t.browseForFile && (e.browseForFile = t.browseForFile), null != t.fieldSeparator && (e.fieldSeparator = t.fieldSeparator), null != t.recordsetDelimiter && (e.recordsetDelimiter = t.recordsetDelimiter), null != t.ignoreQuotedLineBreaks && (e.ignoreQuotedLineBreaks = t.ignoreQuotedLineBreaks), null != t.embedded && (e.embedded = t.embedded), null != t.embeddedDataOffset && (e.embeddedDataOffset = t.embeddedDataOffset), null != t.embeddedDataToLoad && (e.embeddedDataToLoad = t.embeddedDataToLoad), null != t.isOCSV2Data && (e.isOCSV2Data = t.isOCSV2Data), null != t.data && (e.data = t.data), null != t.url && (e.url = t.url), null != (t = t.credentials) && (null != t.hash && (e.hash = t.hash), null != t.username && (e.username = t.username), null != t.password && (e.password = t.password))), e;
                }
              }]);
              return i;
            }();
            t.xq = i;
          }((e = t.u || (t.u = {})).C || (e.C = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function (_t$xq) {
              _inherits(e, _t$xq);
              var _super59 = _createSuper(e);
              function e() {
                var _this82;
                _classCallCheck(this, e);
                _this82 = _super59.apply(this, arguments), _this82.eg = !1, _this82.Mz = null;
                return _this82;
              }
              _createClass(e, [{
                key: "isEqual",
                value: function isEqual(t) {
                  return _get(_getPrototypeOf(e.prototype), "isEqual", this).call(this, t) && this.filename == t.filename && 0 == this.eg && 0 == t.eg;
                }
              }]);
              return e;
            }(t.xq);
            t.KA = e;
          }((e = t.u || (t.u = {})).C || (e.C = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var i = /*#__PURE__*/function (_t$KA) {
              _inherits(i, _t$KA);
              var _super60 = _createSuper(i);
              function i() {
                var _this83;
                _classCallCheck(this, i);
                _this83 = _super60.call(this), _this83.GV = !1, _this83.gg = e.i.Te.JSON;
                return _this83;
              }
              _createClass(i, [{
                key: "Db",
                get: function get() {
                  return a.Vb(this.filename) && (null == this.eg || 0 == this.eg) && a.U(this.data);
                },
                set: function set(t) {}
              }, {
                key: "gs",
                get: function get() {
                  return !a.U(this.data);
                },
                set: function set(t) {}
              }, {
                key: "isEqual",
                value: function isEqual(t) {
                  return t == this || _get(_getPrototypeOf(i.prototype), "isEqual", this).call(this, t) && a.U(t.data);
                }
              }, {
                key: "Sa",
                value: function Sa() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  var e = {};
                  return e.dataSourceType = this.gg, (t || this.eg) && (e.browseForFile = this.eg), this.filename && (e.filename = this.filename), a.U(this.data) || (e.data = this.data), e;
                }
              }], [{
                key: "Za",
                value: function Za(t) {
                  var e = new i();
                  return void 0 !== t.browseForFile && (e.eg = t.browseForFile), void 0 !== t.filename && "" != t.filename && (e.filename = t.filename), void 0 !== t.data && (e.data = t.data), void 0 !== t.checkUpdates && (e.GV = t.checkUpdates), void 0 !== t.requestHeader && (e.Mz = t.requestHeader), e;
                }
              }]);
              return i;
            }(t.KA);
            t.GH = i;
          }((e = t.u || (t.u = {})).C || (e.C = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var i = /*#__PURE__*/function (_t$KA2) {
              _inherits(i, _t$KA2);
              var _super61 = _createSuper(i);
              function i() {
                var _this84;
                _classCallCheck(this, i);
                _this84 = _super61.call(this), _this84.eo = "\n", _this84.bs = !0, _this84.hg = !1, _this84.Tx = 0, _this84.gg = e.i.Te.jl;
                return _this84;
              }
              _createClass(i, [{
                key: "Db",
                get: function get() {
                  return a.Vb(this.filename) && (null == this.eg || 0 == this.eg) && (null == this.hg || 0 == this.hg);
                },
                set: function set(t) {}
              }, {
                key: "gs",
                get: function get() {
                  return !a.U(this.data);
                },
                set: function set(t) {}
              }, {
                key: "isEqual",
                value: function isEqual(t) {
                  return _get(_getPrototypeOf(i.prototype), "isEqual", this).call(this, t) && 0 == this.hg && 0 == t.hg;
                }
              }, {
                key: "Sa",
                value: function Sa() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  var e = {};
                  return e.dataSourceType = this.gg, (t || this.eg && !this.hg) && (e.browseForFile = this.eg), this.filename && (e.filename = this.filename), this.jg && (e.fieldSeparator = this.jg), this.eo && "\n" != this.eo && (e.recordsetDelimiter = this.eo), (t || 0 == this.bs) && (e.ignoreQuotedLineBreaks = this.bs), this.hg && (e.embedded = this.hg), e;
                }
              }], [{
                key: "Za",
                value: function Za(t) {
                  var e = new i();
                  return void 0 !== t.browseForFile && (e.eg = t.browseForFile), void 0 !== t.filename && "" != t.filename && (e.filename = t.filename), void 0 !== t.fieldSeparator && (e.jg = t.fieldSeparator), void 0 !== t.recordsetDelimiter && (e.eo = t.recordsetDelimiter), void 0 !== t.ignoreQuotedLineBreaks && (e.bs = t.ignoreQuotedLineBreaks), void 0 !== t.embedded && (e.hg = t.embedded), void 0 !== t.embeddedDataOffset && (e.Tx = t.embeddedDataOffset), void 0 !== t.embeddedDataToLoad && (e.HL = t.embeddedDataToLoad), void 0 !== t.requestHeader && (e.Mz = t.requestHeader), e;
                }
              }]);
              return i;
            }(t.KA);
            t.$s = i;
          }((e = t.u || (t.u = {})).C || (e.C = {}));
        }(r || (r = {})), function (t) {
          !function (s) {
            var r = /*#__PURE__*/function (_i$Ac$Lh) {
              _inherits(r, _i$Ac$Lh);
              var _super62 = _createSuper(r);
              function r(e, i) {
                var _this85;
                _classCallCheck(this, r);
                _this85 = _super62.call(this), _this85.nN = !1, _this85.W = t.model.yb.V(), _this85.vE = _this85.wE = _this85.height = _this85.width = 0, _this85.Er = [], _this85.B_ = 0, _this85.zL = !1, _this85.FL = function () {
                  return _this85.e0();
                }, _this85.bz = !0, _this85.qb("wdr-pivot-view"), null != _this85.ff && _this85.ff.la(), e.empty(), _this85.ff = e, r.tb = _assertThisInitialized(_this85);
                var n = i.width ? "number" == typeof i.width ? i.width + "px" : -1 < i.width.indexOf("px") || i.width.indexOf("%") == i.width.length - 1 ? i.width : i.width + "px" : "100%";
                e = i.height ? "number" == typeof i.height ? i.height + "px" : -1 < i.height.indexOf("px") || i.height.indexOf("%") == i.height.length - 1 ? i.height : i.height + "px" : "500px";
                var o = /\d+(?=px|%)/;
                n = n.match(o) ? n : "100%", e = e.match(o) ? e : "500px", _this85.ff.ha("width", n), _this85.ff.ha("height", e), _this85.B.ha("width", n), _this85.B.ha("height", e), _this85.ff.append(_this85.B), _this85.B.requestAnimationFrame(function () {
                  _this85.toolbar = i.toolbar ? new A(_this85.ff.element, t.Um.instance.wK, "html5", n, t.model.v.Ho.V().mM()) : null, t.model.xa.V().na(new t.model.ac(t.model.xa.Vs, _this85.toolbar)), _this85.toolbar && null != _this85.toolbar.create && _this85.toolbar.create(), _this85.Bd(), _this85.Ha();
                }), _this85.W.Pa.addEventListener(t.model.sb.kc.tl, function () {
                  return _this85.ZE();
                }), _this85.W.Pa.addEventListener(t.model.sb.kc.SG, function () {
                  return _this85.OE();
                }), _this85.W.Pa.addEventListener(t.model.sb.kc.Lm, function () {
                  return _this85.YE();
                }), _this85.W.Pa.addEventListener(t.model.sb.kc.xl, function () {}), _this85.W.Pa.addEventListener(t.model.sb.kc.Ye, function () {
                  return _this85.b0();
                }), _this85.W.Pa.addEventListener(t.model.sb.kc.He, function () {
                  return _this85.vz();
                }), _this85.W.Pa.addEventListener(t.model.sb.kc.Nm, function () {
                  return _this85.rs();
                }), _this85.W.addEventListener(t.Eg.HA, function (t) {
                  return _this85.h0(t);
                }), _this85.W.addEventListener(t.Eg.VA, function () {
                  return _this85.V0();
                }), _this85.W.addEventListener(s.kf.Xs, function (t) {
                  return _this85.P0(t);
                }), _this85.W.addEventListener(s.kf.BG, function (t) {
                  return _this85.R0(t);
                }), _this85.addEventListener(s.kf.ak, function () {
                  return _this85.F_();
                }), a.lg.addEventListener("fullscreenchange", function () {
                  return _this85.pz();
                }, !1), a.lg.addEventListener("mozfullscreenchange", function () {
                  return _this85.pz();
                }, !1), a.lg.addEventListener("webkitfullscreenchange", function () {
                  return _this85.pz();
                }, !1), a.lg.addEventListener("MSFullscreenChange", function () {
                  return _this85.pz();
                }, !1), _this85.ff.addEventListener("fullscreenchange", function (t) {
                  return _this85.sz(t);
                }, !1), _this85.ff.addEventListener("mozfullscreenchange", function (t) {
                  return _this85.sz(t);
                }, !1), _this85.ff.addEventListener("webkitfullscreenchange", function (t) {
                  return _this85.sz(t);
                }, !1), _this85.ff.addEventListener("MSFullscreenChange", function (t) {
                  return _this85.sz(t);
                }, !1);
                return _this85;
              }
              _createClass(r, [{
                key: "Mv",
                get: function get() {
                  if (this.toolbar) {
                    var t = i.ia.Ga(document.getElementById("wdr-toolbar-wrapper"));
                    return null == t ? 0 : t.height;
                  }
                  return 0;
                }
              }, {
                key: "I1",
                value: function I1() {
                  return r.rP - r.tb.Mv;
                }
              }, {
                key: "Ha",
                value: function Ha() {
                  var _this86 = this;
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  if (this.LK(), this.zL || this.nN) {
                    var e = this.B.requestAnimationFrame(function () {
                      _this86.LK(), _this86.xB(t);
                    });
                    this.Er.push(e);
                  } else 1e3 > this.B_++ ? this.C_ = a.xd(function () {
                    _this86.Ha(t);
                  }, 10) : this.ff.visible && (console.error("WebDataRocks:\nPivot cannot be drawn."), console.error("document.visibilityState:", document.visibilityState), "hidden" != document.visibilityState && alert("WebDataRocks:\nPivot cannot be drawn."));
                }
              }, {
                key: "LK",
                value: function LK() {
                  for (; 0 < this.Er.length;) this.B.cancelAnimationFrame(this.Er.pop());
                  this.Er = [], a.Pg(this.C_), a.Pg(this.c2);
                }
              }, {
                key: "MP",
                value: function MP() {
                  if (!this.ff) return !1;
                  var t = a.cz(),
                    e = this.ff.Lf();
                  t && (e = window.screen.width);
                  var i = this.ff.Xc();
                  return t && (i = window.screen.height), i -= this.Mv, this.wE === e && this.vE === i || (this.B.ha("width", e + "px"), this.B.ha("height", i + "px")), this.wE !== e || this.vE !== i;
                }
              }, {
                key: "jF",
                value: function jF() {
                  this.toolbar && null != this.toolbar.applyToolbarLayoutClasses && this.toolbar.applyToolbarLayoutClasses(), this.Ha(!0);
                }
              }, {
                key: "ZE",
                value: function ZE() {
                  this.W.Pa.Ad == t.model.sb.yl.INIT && this.cD();
                }
              }, {
                key: "OE",
                value: function OE() {
                  this.Ha();
                }
              }, {
                key: "YE",
                value: function YE() {
                  this.W.Pa.Ad != t.model.sb.yl.VI && this.W.Pa.Ad != t.model.sb.yl.Vv && this.cD();
                }
              }, {
                key: "b0",
                value: function b0() {
                  this.W.Pa.Ad != t.model.sb.yl.INIT && this.W.Pa.Ad != t.model.sb.yl.JH && this.Ha();
                }
              }, {
                key: "rs",
                value: function rs() {
                  null != this.toolbar && this.toolbar.updateLabels(t.model.v.Ho.V().mM());
                }
              }, {
                key: "vz",
                value: function vz() {
                  this.W.Pa.Ad == t.model.sb.yl.uG ? this.cD() : this.ff && this.Ha();
                }
              }, {
                key: "pz",
                value: function pz() {
                  this.UM();
                }
              }, {
                key: "sz",
                value: function sz(t) {
                  t.stopPropagation(), this.UM();
                }
              }, {
                key: "UM",
                value: function UM() {
                  var _this87 = this;
                  var e = a.cz();
                  null != t.model.xa.jsFullScreenHandler && t.model.xa.jsFullScreenHandler.call(null, e), e = this.B.requestAnimationFrame(function () {
                    _this87.MP() && _this87.Ha(!0);
                  }), this.Er.push(e);
                }
              }, {
                key: "Bd",
                value: function Bd() {
                  var _this88 = this;
                  this.toolbar && (this.B.height -= this.Mv), this.cf = new s.N.mR(), this.cf.addEventListener(s.kf.Do, function (t) {
                    return _this88.p0(t);
                  }), this.cf.addEventListener(s.kf.PG, function (t) {
                    return _this88.f0(t);
                  }), this.R(this.cf), this.kg = new s.bc.ck(), this.kg.addEventListener(e.ga.OPENED, function () {}), this.kg.addEventListener(e.ga.CLOSED, function () {}), this.kg.addEventListener(s.bc.ck.EA, function () {
                    return _this88.PE();
                  }), this.kg.addEventListener(s.bc.ck.Bo, function (t) {
                    return _this88.rz(t);
                  }), this.R(this.kg);
                  var t = new i.dc();
                  t.Lc('<a href="https://webdatarocks.com/?r=wdr" target="_blank">\n                <span class="wdr-created">Created using</span>\n                <svg height="14" viewBox="0 0 272 44" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path d="M84.0225 14.1016L82.2646 14.3213L77.9434 32.8516H73.9736L70.0625 18.7744H69.9746L66.0635 32.8516H62.0938L57.7432 14.3213L56 14.1016V11.5234H63.8516V14.1016L61.9033 14.4385L64.3496 26.1279L64.4375 26.1426L68.4365 11.5234H71.5859L75.6143 26.1426L75.7021 26.1279L78.1338 14.4385L76.1855 14.1016V11.5234H84.0225V14.1016Z" fill="#303030"/>\n                <path d="M92.9039 33.1592C90.6188 33.1592 88.7926 32.4268 87.4254 30.9619C86.0582 29.4971 85.3746 27.6367 85.3746 25.3809V24.7949C85.3746 22.4414 86.0191 20.5029 87.3082 18.9795C88.607 17.4561 90.3453 16.6992 92.523 16.709C94.6617 16.709 96.3219 17.3535 97.5035 18.6426C98.6852 19.9316 99.276 21.6748 99.276 23.8721V26.2012H89.8131L89.7838 26.2891C89.8619 27.334 90.2086 28.1934 90.8238 28.8672C91.4488 29.541 92.2936 29.8779 93.358 29.8779C94.3053 29.8779 95.0914 29.7852 95.7164 29.5996C96.3414 29.4043 97.025 29.1016 97.7672 28.6914L98.9244 31.3281C98.2701 31.8457 97.4205 32.2803 96.3756 32.6318C95.3404 32.9834 94.1832 33.1592 92.9039 33.1592ZM92.523 20.0049C91.732 20.0049 91.107 20.3076 90.648 20.9131C90.1891 21.5186 89.9059 22.3145 89.7984 23.3008L89.8424 23.374H95.0865V22.9932C95.0865 22.085 94.8717 21.3623 94.442 20.8252C94.0221 20.2783 93.3824 20.0049 92.523 20.0049Z" fill="#303030"/>\n                <path d="M117.034 25.3662C117.034 27.7295 116.507 29.6191 115.452 31.0352C114.398 32.4512 112.874 33.1592 110.882 33.1592C109.954 33.1592 109.149 32.9688 108.465 32.5879C107.781 32.1973 107.205 31.6357 106.737 30.9033L106.429 32.8516H102.737V13.0176L100.467 12.5781V10H107V18.6865C107.459 18.0518 108.006 17.5635 108.641 17.2217C109.285 16.8799 110.023 16.709 110.853 16.709C112.864 16.709 114.398 17.4707 115.452 18.9941C116.507 20.5078 117.034 22.5293 117.034 25.0586V25.3662ZM112.772 25.0586C112.772 23.5156 112.542 22.2949 112.083 21.3965C111.634 20.4883 110.862 20.0342 109.769 20.0342C109.105 20.0342 108.543 20.1758 108.084 20.459C107.625 20.7324 107.264 21.1279 107 21.6455V28.3398C107.264 28.8281 107.625 29.1992 108.084 29.4531C108.553 29.707 109.124 29.834 109.798 29.834C110.902 29.834 111.673 29.4482 112.112 28.6768C112.552 27.8955 112.772 26.792 112.772 25.3662V25.0586Z" fill="#303030"/>\n                <path d="M128.919 11.5234C131.526 11.5234 133.675 12.3584 135.364 14.0283C137.054 15.6885 137.898 17.8223 137.898 20.4297V23.96C137.898 26.5771 137.054 28.7158 135.364 30.376C133.675 32.0264 131.526 32.8516 128.919 32.8516H119.324V30.2881L121.595 29.8486V14.541L119.324 14.1016V11.5234H121.595H128.919ZM125.872 14.8193V29.5703H128.699C130.232 29.5703 131.433 29.0527 132.303 28.0176C133.172 26.9824 133.606 25.6299 133.606 23.96V20.4004C133.606 18.75 133.172 17.4072 132.303 16.3721C131.433 15.3369 130.232 14.8193 128.699 14.8193H125.872Z" fill="#303030"/>\n                <path d="M150.603 32.8516C150.486 32.5879 150.383 32.3193 150.295 32.0459C150.207 31.7627 150.139 31.4795 150.09 31.1963C149.582 31.7822 148.962 32.2559 148.23 32.6172C147.507 32.9785 146.677 33.1592 145.74 33.1592C144.187 33.1592 142.952 32.7393 142.034 31.8994C141.125 31.0498 140.671 29.8975 140.671 28.4424C140.671 26.958 141.267 25.8105 142.458 25C143.65 24.1895 145.398 23.7842 147.703 23.7842H149.885V22.2314C149.885 21.4697 149.665 20.8789 149.226 20.459C148.787 20.0391 148.137 19.8291 147.278 19.8291C146.789 19.8291 146.355 19.8877 145.974 20.0049C145.593 20.1123 145.286 20.2441 145.051 20.4004L144.773 22.0996H141.55L141.565 18.584C142.346 18.0566 143.24 17.6123 144.246 17.251C145.261 16.8896 146.365 16.709 147.556 16.709C149.519 16.709 151.111 17.1924 152.331 18.1592C153.562 19.1162 154.177 20.4834 154.177 22.2607V28.8086C154.177 29.0527 154.177 29.2822 154.177 29.4971C154.187 29.7119 154.206 29.917 154.236 30.1123L155.539 30.2881V32.8516H150.603ZM146.897 29.9951C147.541 29.9951 148.127 29.8584 148.655 29.585C149.182 29.3018 149.592 28.9502 149.885 28.5303V26.1133H147.703C146.794 26.1133 146.106 26.3281 145.637 26.7578C145.168 27.1777 144.934 27.6855 144.934 28.2812C144.934 28.8184 145.105 29.2383 145.447 29.541C145.798 29.8438 146.282 29.9951 146.897 29.9951Z" fill="#303030"/>\n                <path d="M162.546 13.1201V17.002H165.329V20.0049H162.546V28.0762C162.546 28.6914 162.673 29.1309 162.927 29.3945C163.181 29.6582 163.522 29.79 163.952 29.79C164.245 29.79 164.499 29.7803 164.714 29.7607C164.938 29.7314 165.188 29.6875 165.461 29.6289L165.827 32.7197C165.349 32.8662 164.875 32.9736 164.406 33.042C163.938 33.1201 163.43 33.1592 162.883 33.1592C161.408 33.1592 160.271 32.7539 159.47 31.9434C158.679 31.1328 158.283 29.8486 158.283 28.0908V20.0049H155.954V17.002H158.283V13.1201H162.546Z" fill="#303030"/>\n                <path d="M177.917 32.8516C177.799 32.5879 177.697 32.3193 177.609 32.0459C177.521 31.7627 177.453 31.4795 177.404 31.1963C176.896 31.7822 176.276 32.2559 175.544 32.6172C174.821 32.9785 173.991 33.1592 173.053 33.1592C171.501 33.1592 170.265 32.7393 169.347 31.8994C168.439 31.0498 167.985 29.8975 167.985 28.4424C167.985 26.958 168.581 25.8105 169.772 25C170.963 24.1895 172.712 23.7842 175.016 23.7842H177.199V22.2314C177.199 21.4697 176.979 20.8789 176.54 20.459C176.1 20.0391 175.451 19.8291 174.591 19.8291C174.103 19.8291 173.669 19.8877 173.288 20.0049C172.907 20.1123 172.599 20.2441 172.365 20.4004L172.087 22.0996H168.864L168.879 18.584C169.66 18.0566 170.553 17.6123 171.559 17.251C172.575 16.8896 173.678 16.709 174.87 16.709C176.833 16.709 178.424 17.1924 179.645 18.1592C180.876 19.1162 181.491 20.4834 181.491 22.2607V28.8086C181.491 29.0527 181.491 29.2822 181.491 29.4971C181.501 29.7119 181.52 29.917 181.549 30.1123L182.853 30.2881V32.8516H177.917ZM174.211 29.9951C174.855 29.9951 175.441 29.8584 175.968 29.585C176.496 29.3018 176.906 28.9502 177.199 28.5303V26.1133H175.016C174.108 26.1133 173.42 26.3281 172.951 26.7578C172.482 27.1777 172.248 27.6855 172.248 28.2812C172.248 28.8184 172.419 29.2383 172.76 29.541C173.112 29.8438 173.595 29.9951 174.211 29.9951Z" fill="#303030"/>\n                <path d="M194.196 11.5234C196.617 11.5234 198.517 12.0801 199.894 13.1934C201.271 14.2969 201.959 15.8252 201.959 17.7783C201.959 18.8525 201.671 19.7852 201.095 20.5762C200.519 21.3672 199.674 22.0068 198.561 22.4951C199.821 22.8662 200.724 23.4863 201.271 24.3555C201.827 25.2148 202.106 26.2842 202.106 27.5635V28.6475C202.106 29.1162 202.198 29.4824 202.384 29.7461C202.57 30 202.877 30.1514 203.307 30.2002L203.834 30.2734V32.8516H201.622C200.226 32.8516 199.244 32.4756 198.678 31.7236C198.112 30.9717 197.828 30 197.828 28.8086V27.5928C197.828 26.5576 197.55 25.7471 196.993 25.1611C196.446 24.5654 195.67 24.2529 194.664 24.2236H191.163V29.8486L193.448 30.2881V32.8516H184.615V30.2881L186.886 29.8486V14.541L184.615 14.1016V11.5234H186.886H194.196ZM191.163 20.9277H194.122C195.314 20.9277 196.207 20.6738 196.803 20.166C197.399 19.6582 197.696 18.9258 197.696 17.9688C197.696 17.0117 197.399 16.25 196.803 15.6836C196.217 15.1074 195.348 14.8193 194.196 14.8193H191.163V20.9277Z" fill="#303030"/>\n                <path d="M205.743 24.7803C205.743 22.417 206.402 20.4834 207.721 18.9795C209.049 17.4658 210.88 16.709 213.214 16.709C215.557 16.709 217.388 17.4609 218.707 18.9648C220.035 20.4688 220.699 22.4072 220.699 24.7803V25.0879C220.699 27.4707 220.035 29.4141 218.707 30.918C217.388 32.4121 215.567 33.1592 213.243 33.1592C210.889 33.1592 209.049 32.4121 207.721 30.918C206.402 29.4141 205.743 27.4707 205.743 25.0879V24.7803ZM210.02 25.0879C210.02 26.5332 210.274 27.6953 210.782 28.5742C211.29 29.4434 212.11 29.8779 213.243 29.8779C214.346 29.8779 215.152 29.4385 215.66 28.5596C216.178 27.6807 216.436 26.5234 216.436 25.0879V24.7803C216.436 23.374 216.178 22.2266 215.66 21.3379C215.142 20.4492 214.327 20.0049 213.214 20.0049C212.1 20.0049 211.29 20.4492 210.782 21.3379C210.274 22.2266 210.02 23.374 210.02 24.7803V25.0879Z" fill="#303030"/>\n                <path d="M230.401 29.8779C231.163 29.8779 231.773 29.6582 232.232 29.2188C232.691 28.7695 232.92 28.1738 232.92 27.4316H236.788L236.831 27.5195C236.871 29.1211 236.27 30.4639 235.03 31.5479C233.789 32.6221 232.246 33.1592 230.401 33.1592C228.038 33.1592 226.216 32.4121 224.937 30.918C223.658 29.4238 223.018 27.5049 223.018 25.1611V24.7217C223.018 22.3877 223.672 20.4688 224.981 18.9648C226.299 17.4609 228.174 16.709 230.606 16.709C231.885 16.709 233.033 16.8994 234.048 17.2803C235.064 17.6611 235.909 18.1982 236.582 18.8916L236.641 23.125H233.169L232.466 20.6494C232.251 20.4639 231.988 20.3125 231.675 20.1953C231.363 20.0684 231.006 20.0049 230.606 20.0049C229.395 20.0049 228.54 20.4443 228.042 21.3232C227.544 22.2021 227.295 23.335 227.295 24.7217V25.1611C227.295 26.5771 227.525 27.7197 227.984 28.5889C228.443 29.4482 229.248 29.8779 230.401 29.8779Z" fill="#303030"/>\n                <path d="M238.726 12.5781V10H245.273V23.2422H246.226L248.687 19.7705L247.295 19.5801V17.002H255.088V19.5801L253.213 20.0049L250.356 23.9307L254.355 29.9512L255.981 30.2881V32.8516H248.657V30.2881L249.536 30.1416L247.104 26.2158H245.273V29.8486L247.119 30.2881V32.8516H238.945V30.2881L241.011 29.8486V13.0176L238.726 12.5781Z" fill="#303030"/>\n                <path d="M270.825 22.4512H267.954L267.5 20.4736C267.207 20.2393 266.836 20.0439 266.386 19.8877C265.947 19.7314 265.459 19.6533 264.921 19.6533C264.17 19.6533 263.574 19.8242 263.134 20.166C262.695 20.498 262.475 20.918 262.475 21.4258C262.475 21.9043 262.685 22.3047 263.105 22.627C263.525 22.9395 264.365 23.2178 265.625 23.4619C267.587 23.8525 269.043 24.4287 269.99 25.1904C270.937 25.9424 271.411 26.9824 271.411 28.3105C271.411 29.7363 270.796 30.9033 269.565 31.8115C268.344 32.71 266.733 33.1592 264.731 33.1592C263.51 33.1592 262.387 32.9834 261.362 32.6318C260.346 32.2705 259.443 31.7578 258.652 31.0938L258.608 27.5342H261.596L262.182 29.5996C262.436 29.8145 262.783 29.9756 263.222 30.083C263.662 30.1807 264.121 30.2295 264.599 30.2295C265.468 30.2295 266.128 30.0732 266.577 29.7607C267.036 29.4482 267.265 29.0234 267.265 28.4863C267.265 28.0176 267.036 27.6123 266.577 27.2705C266.118 26.9287 265.273 26.626 264.043 26.3623C262.177 25.9814 260.766 25.4199 259.809 24.6777C258.862 23.9258 258.388 22.9053 258.388 21.6162C258.388 20.2881 258.935 19.1455 260.029 18.1885C261.123 17.2217 262.68 16.7383 264.702 16.7383C265.932 16.7383 267.094 16.9043 268.188 17.2363C269.292 17.5684 270.156 17.9932 270.781 18.5107L270.825 22.4512Z" fill="#303030"/>\n                <g clip-path="url(#clip0)">\n                <path fill-rule="evenodd" clip-rule="evenodd" d="M22.4 44H22C19.2 44 16.3 43.5 13.7 42.4C11.2 41.4 8.8 39.8 6.6 37.7C4.6 35.7 3 33.3 1.8 30.6C0.6 27.8 0 24.9 0 22C0.1 16 2.4 10.4 6.6 6.3C10.7 2.2 16.3 -0.0999995 22 4.87547e-07H42.6C42.8 4.87547e-07 43.2 4.7707e-07 43.6 0.4L43.9 0.7V0.9C44 1 44 1.2 44 1.4V22C43.9 28 41.6 33.6 37.4 37.7C33.4 41.7 27.9 44 22.4 44ZM21.7 2C16.6 2 11.6 4.1 8 7.7C4.2 11.5 2.1 16.6 2 22C2 24.6 2.6 27.3 3.6 29.8C4.7 32.2 6.2 34.5 8 36.3C10 38.2 12.2 39.7 14.5 40.6C16.8 41.5 19.4 42 22 42C27.2 42.1 32.3 40 36 36.3C39.8 32.5 41.9 27.4 42 22V2H22H21.7ZM22 26.5C19.5 26.5 17.5 24.5 17.5 22C17.5 19.5 19.5 17.5 22 17.5C24.5 17.5 26.5 19.5 26.5 22C26.5 24.5 24.5 26.5 22 26.5ZM22 19.5C20.6 19.5 19.5 20.6 19.5 22C19.5 23.4 20.6 24.5 22 24.5C23.4 24.5 24.5 23.4 24.5 22C24.5 20.6 23.4 19.5 22 19.5ZM27.6 15.5V10.3V8.00001H29.9H35.1V10.3H31.4C34.8 13.1 37 17.3 37 22C37 30.3 30.3 37 22 37C13.7 37 7 30.3 7 22C7 17.7 8.8 13.8 11.7 11.1L13.1 12.5C10.6 14.8 9 18.2 9 22C9 29.2 14.8 35 22 35C29.2 35 35 29.2 35 22C35 17.8 33 14.1 29.9 11.7V15.5H27.6Z" fill="url(#paint0_linear)"/>\n                </g>\n                <defs>\n                <linearGradient id="paint0_linear" x1="22" y1="1.33773e-05" x2="22" y2="44" gradientUnits="userSpaceOnUse">\n                <stop offset="0.0187499" stop-color="#06B6E1"/>\n                <stop offset="1" stop-color="#057FDD"/>\n                </linearGradient>\n                <clipPath id="clip0">\n                <rect width="44" height="44" fill="white"/>\n                </clipPath>\n                </defs>\n                </svg>            \n                </a>'), t.Y("wdr-credits"), this.R(t), a.lg.addEventListener("keydown", function (t) {
                    return _this88.hv(t);
                  }), this.B.ja("tabindex", 0), this.B.addEventListener("focusin", function () {
                    _this88.bz = !0;
                  }), this.B.addEventListener("focusout", function () {
                    _this88.bz = !1;
                  }), this.ex = new a.yS(this.ff.parent), this.ex.addEventListener(e.ga.vI, function (t) {
                    return _this88.jF(t);
                  }), this.nN = !0;
                }
              }, {
                key: "xB",
                value: function xB() {
                  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  null != this.W && (this.zL = !0, this.MP(), null != this.Li && this.Li.Ha(), a.U(this.W.Pa.he) || this.W.Pa.he.Db || !t.model.A.P.HC ? this.kg.Da() : this.kg.show(), e || t.model.A.P.GC || s.La.Df.eu || (t.model.A.P.Xl = !1), null != this.W.O.fa && this.W.O.fa.Db && (t.model.A.P.Xl = !0), t.model.A.P.Xl && null != this.W.Pa.he && !this.W.Pa.he.Db ? this.kg.open(this.W.O.ea, this.W.O.fa, this.W.Pa.he.gg) : this.kg.close(), this.yL(e), null != this.uh && this.uh.isVisible() && (t.model.A.P.Dc ? this.uh.close() : this.uh.vs()), this.wE = this.Lf(), this.vE = this.Xc());
                }
              }, {
                key: "cD",
                value: function cD() {
                  this.yL(!1, !0), a.U(this.kg) || this.kg.close();
                }
              }, {
                key: "yL",
                value: function yL() {
                  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  null != this.cf && (e || null == this.Li || this.Li.close(), this.cf.K = i ? null : this.W.Ng = t.u.qf.bk.Qb(), this.cf.B.ha("top", "").ha("left", "").ha("right", "").ha("bottom", ""), this.cf.B.ha("position", "absolute"), this.cf.show(), this.cf.B.ha("height", r.SM + "px"), this.cf.B.ha("width", r.eA + "px"), e || this.W.O.he && this.W.O.he.pN || this.cf.PV(), this.cf.Ha(), t.model.A.P.Dc && this.kg.MZ && this.kg.open(this.W.O.ea, this.W.O.fa, this.W.Pa.he.gg));
                }
              }, {
                key: "f0",
                value: function f0(t) {
                  null == this.uh && this.CU(), this.uh.addEventListener(s.N.Ob.zA, this.FL);
                  var e = this.W.O.ea.we(t.data.measure);
                  this.uh.ym(this.W.Ng, this.W.O.fa, t.data.Di, t.data.Yi, e);
                }
              }, {
                key: "e0",
                value: function e0() {
                  this.uh.removeEventListener(s.N.Ob.zA, this.FL), this.W.O.refresh();
                }
              }, {
                key: "nv",
                value: function nv() {
                  null != this.W.Pa.he && this.kg.open(this.W.O.ea, this.W.O.fa, this.W.Pa.he.gg);
                }
              }, {
                key: "rz",
                value: function rz(t) {
                  this.W.xk(t.data);
                }
              }, {
                key: "p0",
                value: function p0(t) {
                  null == this.Li && this.gK(), this.o0(t);
                }
              }, {
                key: "o0",
                value: function o0(e) {
                  var i = {
                    lb: t.u.oa.de.Sa(e.lb)
                  };
                  t.model.xa.V().na(new t.model.ac(t.model.xa.Do, i)), this.C1(e.lb);
                }
              }, {
                key: "C1",
                value: function C1(t) {
                  null == this.Li && this.gK(), this.Li.ym(t);
                }
              }, {
                key: "Cx",
                value: function Cx() {
                  this.kg.close();
                }
              }, {
                key: "PE",
                value: function PE() {
                  this.nv();
                }
              }, {
                key: "hv",
                value: function hv(t) {
                  this.bz && (73 === t.keyCode && t.ctrlKey && t.altKey && this.d3(), 27 === t.keyCode && (null != this.Li && this.Li.close(), null != this.uh && this.uh.close(), null != this.qr && this.qr.isVisible() ? this.qr.close() : this.kg.close()));
                }
              }, {
                key: "h0",
                value: function h0(t) {
                  this.uh && this.uh.isVisible() ? this.uh.Aj(t.OL, t.Cc, t.ou) : this.cf.Aj(t.OL, t.Cc, t.ou);
                }
              }, {
                key: "V0",
                value: function V0() {
                  this.cf.print();
                }
              }, {
                key: "d3",
                value: function d3() {
                  var e = t.Um.oA + " (build " + a.$.Jv(new Date(parseFloat(t.Um.aQ) / 61).getTime()) + ") <br/><br/>";
                  e += t.model.fc.Ed.I(t.model.fc.Ed.info), t.yc(e, t.model.fc.Ed.I(t.model.fc.Ed.$V), t.ld.FH);
                }
              }, {
                key: "Ld",
                value: function Ld(t, e) {
                  return this.cf.Ld(t, e);
                }
              }, {
                key: "Su",
                value: function Su() {
                  return this.cf.Su();
                }
              }, {
                key: "Is",
                value: function Is(t, e) {
                  this.cf.Is(t, e);
                }
              }, {
                key: "ws",
                value: function ws() {
                  this.cf.ws();
                }
              }, {
                key: "P0",
                value: function P0(t) {
                  null == this.qr && this.pU(), this.qr.ym(t.data ? t.data.IN : "");
                }
              }, {
                key: "R0",
                value: function R0(t) {
                  null == this.contextMenu && this.tU(), this.contextMenu.Bv(this.B, t.data.o_, t.data.coords);
                }
              }, {
                key: "F_",
                value: function F_() {
                  var _this89 = this;
                  0 == this.Er.length && (this.c2 = a.xd(function () {
                    _this89.Oa(s.kf.uI);
                  }, 1));
                }
              }, {
                key: "pU",
                value: function pU() {
                  this.qr = new s.La.Df(), this.R(this.qr);
                }
              }, {
                key: "CU",
                value: function CU() {
                  this.uh = new s.N.PQ(), this.R(this.uh);
                }
              }, {
                key: "gK",
                value: function gK() {
                  this.Li = new s.filter.$Q(), this.Li.addEventListener(e.ga.OPENED, function () {}), this.Li.addEventListener(e.ga.CLOSED, function () {}), this.R(this.Li);
                }
              }, {
                key: "tU",
                value: function tU() {
                  this.contextMenu = new s.AQ(), this.contextMenu.Da(), this.R(this.contextMenu);
                }
              }, {
                key: "la",
                value: function la() {
                  this.W = null, this.cf.la(), this.B.la(), this.ff.la(), s.hG.la(), s.filter.uH.la(), s.WA.la(), i.Rx.CA.la(), r.tb = null, this.ex && (this.ex.la(), this.ex = null);
                }
              }], [{
                key: "eA",
                get: function get() {
                  var t = r.tb.B.borderWidth;
                  return r.tb.ff.Lf(a.cz()) - t.left - t.right;
                }
              }, {
                key: "rP",
                get: function get() {
                  var t = r.tb.B.borderWidth;
                  return r.tb.ff.Xc(a.cz()) - t.top - t.bottom;
                }
              }, {
                key: "cZ",
                get: function get() {
                  return r.eA;
                }
              }, {
                key: "SM",
                get: function get() {
                  return r.tb.I1();
                }
              }]);
              return r;
            }(i.Ac.Lh);
            s.xb = r;
          }(t.G || (t.G = {}));
        }(r || (r = {})), function (t) {
          !function (t) {
            var e = /*#__PURE__*/function () {
              function e() {
                _classCallCheck(this, e);
                this.mn = 0, this.ir = !1, this.It = this.Ut = "", this.au = !1;
              }
              _createClass(e, [{
                key: "show",
                value: function show(t, i, s) {
                  var _this90 = this;
                  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
                  var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
                  t ? (n && this.LF(t, i, s, r), 0 == this.ir ? (this.ir = t, this.Ut = i, this.It = s, this.au = r, this.mn = a.xd(function () {
                    return _this90.yP();
                  }, e.KG)) : 0 == this.mn ? this.LF(t, i, s, r) : (this.ir = t, this.Ut = i, this.It = s, this.au = r)) : (n && this.LF(t, i, s, r), 1 == this.ir && (this.ir = t, this.mn = a.xd(function () {
                    return _this90.yP();
                  }, e.KG)));
                }
              }, {
                key: "LF",
                value: function LF(t, _e84, i, s) {
                  this.rO(), this.jO(t, _e84, i, s);
                }
              }, {
                key: "yP",
                value: function yP() {
                  this.rO(), this.jO(this.ir, this.Ut, this.It, this.au);
                }
              }, {
                key: "rO",
                value: function rO() {
                  a.Pg(this.mn), this.mn = 0;
                }
              }, {
                key: "jO",
                value: function jO(_e85, i, s, r) {
                  t.WA.V() && t.WA.V().ym(_e85, i, s, r);
                }
              }], [{
                key: "V",
                value: function V() {
                  return null == e.Nc && (e.Nc = new e()), e.Nc;
                }
              }, {
                key: "la",
                value: function la() {
                  e.Nc = null;
                }
              }]);
              return e;
            }();
            e.KG = 250, t.qS = e;
          }(t.G || (t.G = {}));
        }(r || (r = {})), function (t) {
          !function (t) {
            var e = /*#__PURE__*/function (_i$Ac$Oo) {
              _inherits(e, _i$Ac$Oo);
              var _super63 = _createSuper(e);
              function e() {
                var _this91;
                _classCallCheck(this, e);
                if (null != e.Nc) throw Error("Singleton");
                _this91 = _super63.call(this, t.xb.tb.B), _this91.qb("wdr-preloader-view"), _this91.Bd();
                return _this91;
              }
              _createClass(e, [{
                key: "ym",
                value: function ym() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                  var _e86 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
                  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
                  this.Ut = _e86, this.It = i, this.au = s, t ? this.open() : this.close();
                }
              }, {
                key: "open",
                value: function open() {
                  _get(_getPrototypeOf(e.prototype), "open", this).call(this), this.Ha();
                }
              }, {
                key: "Bd",
                value: function Bd() {
                  this.ts.Y("wdr-overlay-preloader"), this.ts.removeEventListener("click", this.IJ), this.uJ = new i.ya("div"), this.uJ.qb("wdr-spinner"), this.R(this.uJ), this.kr = new i.dc(), this.kr.qb("wdr-message-label"), this.R(this.kr), this.iC = new i.dc(), this.iC.qb("wdr-details-label"), this.R(this.iC), this.Da(), t.xb.tb.R(this);
                }
              }, {
                key: "Ha",
                value: function Ha() {
                  this.ts.R2(!this.au), this.Gs(this.Ut), this.H2(this.It), this.validate();
                }
              }, {
                key: "Gs",
                value: function Gs(t) {
                  this.kr.wa(t);
                }
              }, {
                key: "H2",
                value: function H2(t) {
                  this.iC.wa(t);
                }
              }, {
                key: "close",
                value: function close() {
                  _get(_getPrototypeOf(e.prototype), "close", this).call(this), this.clear();
                }
              }, {
                key: "clear",
                value: function clear() {
                  this.Gs(""), this.Gs("");
                }
              }], [{
                key: "V",
                value: function V() {
                  return null == t.xb.tb ? null : (null == e.Nc && (e.Nc = new e()), e.Nc);
                }
              }, {
                key: "la",
                value: function la() {
                  e.Nc = null;
                }
              }]);
              return e;
            }(i.Ac.Oo);
            t.WA = e;
          }(t.G || (t.G = {}));
        }(r || (r = {})), function (t) {
          !function (t) {
            var s = /*#__PURE__*/function (_i$Ac$aT) {
              _inherits(s, _i$Ac$aT);
              var _super64 = _createSuper(s);
              function s() {
                var _this92;
                _classCallCheck(this, s);
                _this92 = _super64.call(this), _this92.qb("wdr-context-menu"), _this92.list = new i.Zc.Mh(), _this92.list.$g(_this92.Sn), _this92.list.wg("caption"), _this92.list.addEventListener(e.ga.oe, function (t) {
                  return _this92.jv(t);
                }), _this92.R(_this92.list), _this92.B.Hi();
                return _this92;
              }
              _createClass(s, [{
                key: "Bv",
                value: function Bv(e, i, _s66) {
                  var _this93 = this;
                  0 != i.length && (this.setData(i), this.show(), e = e.Dj(), _s66.top -= e.top + 5, _s66.left -= e.left + 5, this.B.offset(_s66), this.B.addEventListener("mouseleave", function () {
                    return _this93.Da();
                  }), a.Wc().pg ? t.xb.tb.B.addEventListener("touchstart", function (t) {
                    return _this93.hF(t);
                  }) : t.xb.tb.B.addEventListener("mousedown", function (t) {
                    return _this93.hF(t);
                  }));
                }
              }, {
                key: "hF",
                value: function hF(t) {
                  null == i.ia.Ga(t.target).closest("#wdr-context-menu") && this.Da();
                }
              }, {
                key: "setData",
                value: function setData(t) {
                  for (var e = [], i = 0; i < t.length; i++) e.push(t[i]);
                  this.list.vg(e);
                }
              }, {
                key: "jv",
                value: function jv(t) {
                  null != t.data.Zg.handler && t.data.Zg.handler(t.data.Zg.data), this.Da();
                }
              }, {
                key: "Sn",
                value: function Sn(t, e) {
                  var _s67 = new i.yf.dB();
                  return _s67.setData(t), _s67.al(e), _s67;
                }
              }]);
              return s;
            }(i.Ac.aT);
            t.AQ = s;
          }(t.G || (t.G = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (s) {
            var r = /*#__PURE__*/function (_i$Ac$Lh2) {
              _inherits(r, _i$Ac$Lh2);
              var _super65 = _createSuper(r);
              function r() {
                var _this94;
                _classCallCheck(this, r);
                _this94 = _super65.call(this), _this94.pe = _this94.md = _this94.mi = _this94.Wm = _this94.jf = 0, _this94.Kl = t.model.yb.V(), _this94.uc = [], _this94.qb("wdr-grid-view"), a.Wc().pg ? new i.ZJ.zR(_this94.B).b_(function (t, e) {
                  return _this94.I0(t, e);
                }) : a.lg.addEventListener("contextmenu", function (t) {
                  return _this94.Z_(t);
                });
                return _this94;
              }
              _createClass(r, [{
                key: "la",
                value: function la() {
                  this.Kl = this.K = null, this.X && this.X.la(), this.Wo = null;
                }
              }, {
                key: "vW",
                value: function vW() {
                  var _this95 = this;
                  var t = new s.sheet.Xv();
                  return t.id = "wdr-grid-layout", t.Ap = function (t, e) {
                    return _this95.getData(t, e);
                  }, t.addEventListener(s.Ob.kh, function (t) {
                    return _this95.SE(t);
                  }), t.addEventListener(s.Ob.sw, function (t) {
                    return _this95.TE(t);
                  }), t.addEventListener(s.Ob.nl, function (t) {
                    return _this95.Pj(t);
                  }), t.addEventListener(s.Ob.Hq, function (t) {
                    return _this95.dF(t);
                  }), t.addEventListener(s.Ob.Iq, function (t) {
                    return _this95.eF(t);
                  }), this.B.append(t), t;
                }
              }, {
                key: "tW",
                value: function tW() {
                  var _this96 = this;
                  var t = new s.sheet.pp.Wv();
                  return t.id = "wdr-grid-layout", t.Ap = function (t, e) {
                    return _this96.getData(t, e);
                  }, t.addEventListener(s.Ob.kh, function (t) {
                    return _this96.SE(t);
                  }), t.addEventListener(s.Ob.sw, function (t) {
                    return _this96.TE(t);
                  }), t.addEventListener(s.Ob.nl, function (t) {
                    return _this96.Pj(t);
                  }), t.addEventListener(s.Ob.Hq, function (t) {
                    return _this96.dF(t);
                  }), t.addEventListener(s.Ob.Iq, function (t) {
                    return _this96.eF(t);
                  }), this.B.append(t), t;
                }
              }, {
                key: "xW",
                value: function xW() {
                  var _this97 = this;
                  var t = new s.sheet.flat.iw();
                  return t.id = "wdr-grid-layout", t.Ap = function (t, e) {
                    return _this97.getData(t, e);
                  }, t.addEventListener(s.Ob.kh, function (t) {
                    return _this97.SE(t);
                  }), t.addEventListener(s.Ob.sw, function (t) {
                    return _this97.TE(t);
                  }), t.addEventListener(s.Ob.nl, function (t) {
                    return _this97.Pj(t);
                  }), t.addEventListener(s.Ob.Hq, function (t) {
                    return _this97.dF(t);
                  }), t.addEventListener(s.Ob.Iq, function (t) {
                    return _this97.eF(t);
                  }), this.B.append(t), t;
                }
              }, {
                key: "qY",
                value: function qY() {
                  return t.model.A.P.ph ? this.X && this.X.type == s.sheet.pp.Wv.TYPE ? this.X : (null != this.X && this.X.Wi(!0), this.tW()) : t.model.A.P.Dc ? this.X && this.X.type == s.sheet.flat.iw.TYPE ? this.X : (null != this.X && this.X.Wi(!0), this.xW()) : this.X && this.X.type == s.sheet.Xv.TYPE ? this.X : (null != this.X && this.X.Wi(!0), this.vW());
                }
              }, {
                key: "Ha",
                value: function Ha() {
                  if (this.Wo = this.qY(), null != this.X) {
                    if (this.X.kP = this.Kl.Pa.Os ? 100 : 1e3, this.K && this.K.Th && !this.K.Db) {
                      this.X.clearData(), this.Wm = this.mi = this.jf = 0;
                      var i = this.K.Bi,
                        _r45 = t.model.A.P.ph ? 0 < this.K.hc.length ? 1 : 0 : this.K.Rj;
                      if (_r45 >= i + 1) var n = 0,
                        a = n + _r45,
                        o = n + (_r45 - i) - 1;else o = 0, n = 0 < this.K.Ai ? o + (i - _r45) + 1 : o, 0 == this.K.ed.length && 0 == this.K.hc.length && (n += 1), a = n + _r45;
                      var h = o;
                      this.jf = Math.min(n, h), this.Wm = h, this.mi = 0, this.md = a, this.pe = this.ef ? 0 : t.model.A.P.ph ? this.K.zb.Ba && this.K.Yg ? this.K.Sj.length + 1 : this.K.Sj.length : 0 == this.K.rows.length ? 0 : 1, t.model.A.P.Vj || (this.Wm = 1 == _r45 && 0 == this.K.Ai ? 0 : -1, this.md = i), a = 1 + this.K.za.length, this.K.nb.Ba && a--, this.ef && "on" == t.model.A.P.xc && "top" == t.model.A.P.Yr && this.md++, this.X.RO(this.K.Jf + (this.ef && "on" == t.model.A.P.xc && "bottom" == t.model.A.P.Yr ? 1 : 0), this.K.ig), this.X.BX(this.pe), this.X.aM(this.md), this.X instanceof s.sheet.Xv && (this.X.Ex.rowIndex = this.md - this.K.Bi - 1, this.X.Ex.$k(this.K.ed), this.X.AO.$k(this.K.hc), this.X.eO.$k(this.K.eb)), this.X instanceof s.sheet.pp.Wv && (this.X.Ex.rowIndex = this.md - this.K.Bi - 1, this.X.Ex.$k(this.K.ed), this.X.AO.$k(this.K.hc), this.X.eO.$k(this.K.eb)), (1 < this.K.za.length || !this.K.nb.Ba) && t.model.A.P.Vj && this.fK(o, this.pe, t.u.i.da.rb), (1 < this.K.rows.length || !this.K.zb.Ba) && t.model.A.P.Vj && (t.model.A.P.ph ? this.CT(n) : this.fK(n, 0, t.u.i.da.Ka)), this.i2(), this.j2(), this.h2(), this.m2(), this.k2(), this.l2();
                    } else this.X.qp();
                    this.uc = t.model.pf.hi.uc.Tc(), this.X.resize(e.xb.cZ, e.xb.SM), this.X.Ha();
                  }
                }
              }, {
                key: "PV",
                value: function PV() {
                  null != this.X && (this.X.ur(0), this.X.vr(0));
                }
              }, {
                key: "getData",
                value: function getData(e, i) {
                  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  if (null == this.K || !this.K.Th || e < this.Wm || i < this.mi) return null;
                  var _r46 = e - this.md,
                    n = i - this.pe;
                  if ((_r46 > this.K.Jf - 1 || n > this.K.ig - 1) && !(this.ef && "on" == t.model.A.P.xc && "bottom" == t.model.A.P.Yr && _r46 == this.K.Jf && n <= this.K.ig - 1)) return null;
                  var a = this.K.Ep(_r46, !0),
                    o = this.K.Kk(n, !0);
                  if (null == a && null == o) return null;
                  var h = this.K.AM(_r46, n);
                  return this.ef && "on" == t.model.A.P.xc && "top" == t.model.A.P.Yr && (t.model.A.P.Vj && 1 == e || !t.model.A.P.Vj && 0 == e) || this.ef && "on" == t.model.A.P.xc && "bottom" == t.model.A.P.Yr && (t.model.A.P.Vj && e == this.K.Jf + 1 || !t.model.A.P.Vj && e == this.K.Jf) ? this.AY(a, o, h) : null == a ? (s = 1 == (t.model.A.P.ph ? 1 : this.K.hc.length) && 0 == this.K.Ai ? e - this.Wm : e - this.Wm - 1, 0 == this.K.hc.length && 0 == this.K.ed.length && (s = e - this.Wm), this.kY(o, h, this.K.iM(n), s, i)) : (n = this.K.DM(_r46), _r46 = this.K.KM(_r46), null == o ? t.model.A.P.ph ? this.XT(a, h, n, i, _r46) : this.TY(a, h, n) : this.sY(a, o, h, e, i, s, n, _r46));
                }
              }, {
                key: "sY",
                value: function sY(e, i, _r47, n, o) {
                  var h = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
                  var l = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : NaN;
                  var A = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : -1;
                  if (null == _r47) return null;
                  var c = _r47.Ne().clone();
                  _r47.Fa != t.u.i.ca.jj && _r47.Fa != t.u.i.ca.Jh && _r47.Fa != t.u.i.ca.ki && _r47.Fa != t.u.i.ca.ji || (c.fd = "%", c.Fi = "right");
                  var u = new s.C.ad();
                  if (u.yh = !0, u.Di = i, u.measure = _r47, u.lb = this.Kl.O.ea.Zh(_r47.j), u.Yi = e, t.model.A.P.ph ? 0 == e.length ? u.level = 0 : -1 < (l = this.MD(e)) && (u.level = l) : t.model.A.P.Dc || (u.level = l), l = this.K.Mb(e, i, _r47), u.value = l, this.ef) {
                    if (c = _r47.Ne(!0).clone(), _r47.type == t.u.types.Ca.Hb) {
                      var d = this.K.Nr(i).ua.F(l);
                      null != d && (u.ke = d, u.label = d.caption);
                    } else _r47.type == t.u.types.Ca.Rb ? "string" == typeof l ? u.label = l : (u.label = a.Fd.format(l, c), u.numeric = !0) : _r47.type == t.u.types.Ca.jc ? u.label = a.$.hA(l, t.model.A.P.Gk) : _r47.type == t.u.types.Ca.td ? isNaN(l) || (u.label = a.$.Kv(l)) : _r47.type != t.u.types.Ca.ce || isNaN(l) || (u.label = a.$.Jv(l, t.model.A.P.cm));
                    u.nO = this.K.Cy(e, i, _r47);
                  } else _r47.type == t.u.types.Ca.Rb || _r47.type == t.u.types.Ca.Hb ? "string" == typeof l ? u.label = l : (u.label = a.Fd.format(l, c), u.numeric = !0) : _r47.type == t.u.types.Ca.jc ? u.label = t.u.i.ca.Ov(_r47.Fa) ? a.$.hA(u.value, t.model.A.P.Gk) : a.Fd.format(l, c) : _r47.type == t.u.types.Ca.td ? isNaN(l) || (u.label = t.u.i.ca.Ov(_r47.Fa) ? a.$.Kv(l) : a.Fd.format(l, c)) : _r47.type == t.u.types.Ca.ce ? isNaN(u.value) || (u.label = t.u.i.ca.Ov(_r47.Fa) ? a.$.Jv(l, t.model.A.P.cm) : a.Fd.format(l, c)) : u.label = l;
                  if (h) return u;
                  if (h = !1, this.K.Rj > e.length || this.K.Ai > i.length) {
                    if (h = !0, u.sm = this.K.Rj > e.length, u.bv = this.K.Ai > i.length, "on" != t.model.A.P.cj) {
                      if (0 != e.length && (this.K.Vg(e) || this.K.Vg(e, _r47)) && ("off" == t.model.A.P.cj || "columns" == t.model.A.P.cj) || 0 != i.length && (this.K.Lj(i) || this.K.Lj(i, _r47)) && ("off" == t.model.A.P.cj || "rows" == t.model.A.P.cj)) return null;
                      if (0 == this.K.fv && 1 < this.K.Ia.length) if (!this.K.zb.Ba || "off" != t.model.A.P.cj && "columns" != t.model.A.P.cj) {
                        if (this.K.nb.Ba && ("off" == t.model.A.P.cj || "rows" == t.model.A.P.cj) && o < ("on" == t.model.A.P.xc || "rows" == t.model.A.P.xc ? this.pe + this.K.ig - this.K.Ia.length : this.pe + this.K.ig) && this.K.Lj(i, _r47)) return null;
                      } else if (n < ("on" == t.model.A.P.xc || "columns" == t.model.A.P.xc ? this.md + this.K.Jf - this.K.Ia.length : this.md + this.K.Jf) && this.K.Vg(e, _r47)) return null;
                    }
                    u.Hp = 0 == e.length, u.dz = 0 == i.length, u.eE = u.sm && 2 == A && !u.Hp;
                  }
                  if ("" != c.textAlign && u.Mx({
                    "text-align": c.textAlign
                  }), 0 < this.uc.length && u.measure) for (A = 0; A < this.uc.length; A++) if (!((c = this.uc[A]).Xk != n && -1 != c.Xk || c.zk != o && -1 != c.zk || c.measure != _r47.j && "" != c.measure && c.measure != _r47.j || c.Ri !== h && void 0 !== c.Ri || "" != c.lb && !this.CV(e, i, c.lb, c.ke))) if (d = c.Pe.slice(0), c.pE) {
                    if (this.Kl.Pa.Os) {
                      var f = this.K.Uu(e, i, _r47);
                      f && (-1 < c.Jc.toLowerCase().indexOf(t.u.i.$a.Ew) ? l = f.Gi : -1 < c.Jc.toLowerCase().indexOf(t.u.i.$a.Fw) && (l = 100 * f.Uk), null != (d = this.K.nr(e, i, d, l)) && u.TC(d));
                    }
                  } else 1 != (d = this.K.nr(e, i, d, l)) && "truestyle" != d || null == c.format ? null != d && 0 != d && u.TC(d) : (u.Mx(c.format.AP()), u.uc.push(c.id)), u.i3 = !0;
                  return u;
                }
              }, {
                key: "AY",
                value: function AY(e, i, _r48) {
                  if (null == _r48) return null;
                  var n = new s.C.ad();
                  if (n.yh = !0, n.Di = i, n.measure = _r48, n.lb = this.Kl.O.ea.Zh(_r48.j), n.Yi = e, _r48.type == t.u.types.Ca.Rb || _r48.type == t.u.types.Ca.td || _r48.type == t.u.types.Ca.ce) {
                    var o = _r48.Ne().clone();
                    if ((_r48.Fa == t.u.i.ca.jj || _r48.Fa == t.u.i.ca.Jh || _r48.Fa == t.u.i.ca.ki || _r48.Fa == t.u.i.ca.ji || _r48.La && -1 < _r48.Jc.indexOf("percent")) && (o.fd = "%", o.Fi = "right"), n.value = this.K.Mb(null, null, _r48), _r48.type == t.u.types.Ca.Rb ? (n.label = a.Fd.format(n.value, o), n.numeric = !0) : _r48.type == t.u.types.Ca.td ? isNaN(n.value) || (n.label = t.u.i.ca.Ov(_r48.Fa) ? a.$.Kv(n.value) : a.Fd.format(n.value, o)) : _r48.type != t.u.types.Ca.ce || isNaN(n.value) || (n.label = t.u.i.ca.Ov(_r48.Fa) ? a.$.Jv(n.value, t.model.A.P.cm) : a.Fd.format(n.value, o)), n.Hp = !0, "" != o.textAlign && n.Mx({
                      "text-align": o.textAlign
                    }), 0 < this.uc.length) for (o = 0; o < this.uc.length; o++) {
                      var h = this.uc[o],
                        l = h.Pe.slice(0);
                      if (h.measure == _r48.j && h.pE && this.Kl.Pa.Os) {
                        var A,
                          c = this.K.Uu(e, i, _r48);
                        c && (-1 < h.Jc.toLowerCase().indexOf(t.u.i.$a.Ew) ? A = c.Gi : -1 < h.Jc.toLowerCase().indexOf(t.u.i.$a.Fw) && (A = 100 * c.Uk), null != (h = this.K.nr(e, i, l, A)) && n.TC(h));
                      }
                    }
                  }
                  return n;
                }
              }, {
                key: "CV",
                value: function CV(t, e, i, s) {
                  var _r49 = this.K.za.indexOf(i);
                  if (-1 < _r49) {
                    if (_r49 < e.length) return t = this.K.za.getItem(i), e[_r49] && t.ua.F(e[_r49]).j == s;
                  } else if (-1 < (e = this.K.rows.indexOf(i)) && e < t.length) return i = this.K.rows.getItem(i), t[e] && i.ua.F(t[e]).j == s;
                  return !1;
                }
              }, {
                key: "kY",
                value: function kY(t, e, i, s, _r50) {
                  return this.ef ? this.WT(t, e) : this.VT(t, e, i, s, _r50);
                }
              }, {
                key: "VT",
                value: function VT(e, i, _r51, n, a) {
                  if (0 == e.length) return this.K.zb.Ba && n == this.K.Bi - 1 ? this.Sr(i, t.u.i.da.rb) : (e = this.K.ig - this.K.Ia.length + 1, this.K.nb.Ba && n == this.K.Bi - 1 && a >= e && 1 == this.K.Ia.length ? this.Sr(i, t.u.i.da.rb) : (e = "on" == t.model.A.P.xc || "rows" == t.model.A.P.xc ? this.pe + this.K.ig - this.K.Ia.length : this.pe + this.K.ig, this.K.nb.Ba && 0 == n && a >= e && 1 < this.K.Bi ? a == e ? ((a = this.Tr()).label = t.model.v.g.hR, a) : this.wy() : this.K.nb.Ba && 0 == n && 1 < this.K.Bi ? this.Sr(i, t.u.i.da.rb) : this.K.nb.Ba && n == this.K.Bi - 1 ? a >= e || 1 == this.K.nb.va.length ? this.Sr(i, t.u.i.da.rb) : this.Tr() : this.K.nb.Ba && 0 < n && a <= e ? this.Tr() : 0 <= n ? this.wy() : null));
                  var o = this.K.nb.Ba && (e.length > this.K.Ee || 0 == this.K.Ee) ? e.length : e.length - 1,
                    h = this.K.za.F(o);
                  if (this.K.nb.Ba && o > this.K.Ee && (1 == this.K.Ia.length ? o-- : _r51++), _r51 > n) return 0 <= n ? this.wy() : null;
                  (a = new s.C.ad()).Ae = !0, a.measure = this.K.nb.Ba && (1 < this.K.Ia.length || t.model.A.P.Js) ? i : null;
                  var l = !1,
                    A = h.ua.F(e[e.length - 1]),
                    c = this.K.fv;
                  if (this.K.nb.Ba && 1 < this.K.Ia.length && n == c - 1 || this.K.nb.Ba && t.model.A.P.Js && n == c - 1 && 1 != c || this.K.nb.Ba && t.model.A.P.Js && n == c && 1 == c && 2 > this.K.Ia.length) a.label = i.caption, a.kE = !0, A = null;else {
                    if (this.K.nb.Ba && 0 < this.K.Ia.indexOf(i.j) && n < c) return this.wy();
                    _r51 < n ? o == n ? (l = e.length - 1 != this.K.Ai - 1 && !A.Qc, a.label = A.caption) : (a.label = this.K.Bi - 1 == n && t.model.A.P.Js ? null != i ? i.caption : t.model.v.g.zH : "", A = null) : (l = e.length - 1 != this.K.Ai - 1 && !A.Qc, a.label = A.caption, this.K.nb.Ba && n < c && (a.measure = i = null));
                  }
                  return n = null != A && this.K.Kj(e, A, i), A && (1 != A.children.length || A.children.F(0).caption != t.model.v.g.Cg && A.children.F(0).caption != t.model.v.g.sl) && !A.Qc && A.Kc.Rk && !A.level.jE && (l || t.model.A.P.Av ? n ? a.zn = !0 : a.gm = !0 : n ? a.Ki = !0 : a.collapsed = !0), l && !n && (this.K.Lj(e, i) ? a.Ki = !0 : a.collapsed = !0), "on" != t.model.A.P.Fe && "columns" != t.model.A.P.Fe || "" == a.label || (a.mo = !0, !this.K.af || this.K.af.toString() != e.toString() || null != i && this.K.tj.j != i.j || (this.K.Gf == t.u.i.ba.vb ? a.ei = !0 : this.K.Gf == t.u.i.ba.ub && (a.di = !0))), a.bv = this.K.Ai > e.length, a.fi = e, a.url = void 0, a.lb = h, a.ke = A, a;
                }
              }, {
                key: "WT",
                value: function WT(e, i) {
                  var _r52 = this.K.Nr(e);
                  if (null == _r52) {
                    if (null == i) return null;
                    var n = new s.C.ad();
                    return n.Ae = !0, n.label = i.caption, n;
                  }
                  return (n = new s.C.ad()).Ae = !0, n.xh = !0, n.Oy = _r52.Zx, n.ec = _r52.Sg(), n.label = _r52.caption, n.fi = e, n.lb = _r52, n.ke = null, n.measure = i, n.draggable = !0, "on" != t.model.A.P.Fe && "columns" != t.model.A.P.Fe || (n.mo = !0, !this.K.af || this.K.af.toString() != e.toString() || this.K.tj != i && null != i || ((e = this.K.Gf) == t.u.i.ba.vb ? n.ei = !0 : e == t.u.i.ba.ub && (n.di = !0))), n;
                }
              }, {
                key: "Tr",
                value: function Tr() {
                  var t = new s.C.ad();
                  return t.Ae = !0, t;
                }
              }, {
                key: "wy",
                value: function wy() {
                  var t = this.Tr();
                  return t.Db = !0, t;
                }
              }, {
                key: "Sr",
                value: function Sr(e, i) {
                  var _r53 = new s.C.ad();
                  return _r53.label = null == e ? t.model.v.g.jw : e.Xr, _r53.kE = null != e, i == t.u.i.da.rb ? (_r53.Ae = !0, _r53.bv = _r53.dz = !0, "on" != t.model.A.P.Fe && "columns" != t.model.A.P.Fe || (_r53.mo = !0, !this.K.af || "" != this.K.af.toString() || this.K.tj != e && null != e || (this.K.Gf == t.u.i.ba.vb ? _r53.ei = !0 : this.K.Gf == t.u.i.ba.ub && (_r53.di = !0))), this.K.nb.Ba ? _r53.measure = e : _r53.label = t.model.v.g.jw) : (_r53.Be = !0, _r53.sm = _r53.Hp = !0, "on" != t.model.A.P.Fe && "rows" != t.model.A.P.Fe || (_r53.mo = !0, !this.K.Af || "" != this.K.Af.toString() || this.K.Yk != e && null != e || (this.K.Tf == t.u.i.ba.vb ? _r53.ei = !0 : this.K.Tf == t.u.i.ba.ub && (_r53.di = !0))), this.K.zb.Ba ? _r53.measure = e : _r53.label = t.model.v.g.jw, _r53.level = 0), _r53.fi = [], _r53;
                }
              }, {
                key: "TY",
                value: function TY(e, i, _r54) {
                  if (0 == e.length) return this.Sr(i, t.u.i.da.Ka);
                  var n = this.K.zb.Ba && e.length > this.K.Ee ? e.length : e.length - 1,
                    a = e[e.length - 1],
                    o = this.K.rows.F(n),
                    h = new s.C.ad();
                  h.Be = !0;
                  var l = !1;
                  return a = o.ua.F(a), h.level = _r54, null != i && this.K.zb.Ba && this.K.Yg && n <= this.K.Ee ? (h.label = i.caption, a = null) : a && (h.label = a.caption, l = e.length != this.K.Rj && !a.Qc), _r54 = null != a && this.K.Xh(e, a, i), a && !a.Qc && a.Kc.Rk && !a.Mj && (1 != a.children.length || a.children.F(0).caption != t.model.v.g.Cg && a.children.F(0).caption != t.model.v.g.sl) && (t.model.A.P.Av ? _r54 ? h.zn = !0 : h.gm = !0 : _r54 ? h.Ki = !0 : h.collapsed = !0), l && !_r54 && (this.K.Vg(e, i) ? h.Ki = !0 : h.collapsed = !0), "on" != t.model.A.P.Fe && "rows" != t.model.A.P.Fe || (h.mo = !0, this.K.Af && this.K.Af.toString() == e.toString() && this.K.Yk == i && (this.K.Tf == t.u.i.ba.vb ? h.ei = !0 : this.K.Tf == t.u.i.ba.ub && (h.di = !0))), h.sm = this.K.Rj > e.length, h.fi = e, h.url = void 0, h.lb = o, h.ke = a, h.measure = this.K.zb.Ba && 1 < this.K.Ia.length ? i : null, h;
                }
              }, {
                key: "XT",
                value: function XT(e, i, _r55, n, o) {
                  if (0 == e.length) {
                    if (0 == n) return this.Sr(i, t.u.i.da.Ka);
                    var h = new s.C.ad();
                    return h.Be = !0, h.sm = h.Hp = !0, h.Db = !0, h.level = _r55, h;
                  }
                  var l = n;
                  h = this.K.Sj[n];
                  for (var A, c, u = 0; u < this.K.hc.length; u++) {
                    var d = this.K.hc.F(u);
                    if (null != (A = d.by(h))) {
                      var f = d;
                      l = u;
                      break;
                    }
                  }
                  u = null == e[l] ? 0 : e[l], (h = new s.C.ad()).Be = !0, h.sm = this.K.Rj > e.length, h.eE = h.sm && 2 == o, A = !1, _r55 > n && (A = !0), _r55 > n && 2 == o && (A = !0), _r55 + 1 < n && 2 == o && (A = !0), h.level = Math.min(e.length - 1, n);
                  var p = e.slice(0);
                  if (d = !1, n == this.K.Sj.length) h.label = i.caption, d = !0;else {
                    var g = !1;
                    p = null == i ? 0 : this.K.Ia.indexOf(i.j);
                    var w = f.ua.F(u),
                      m = null != w && 2 != o;
                    if (0 > (c = this.K.Sj.indexOf(w.level.j) - n)) {
                      if (!w.Qc) return h;
                      d = !0;
                    } else if (0 < c) for (u = 0; u < c; u++) w = w.parent;
                    if (w && -1 < (u = this.K.Sj.indexOf(w.level.j)) && (h.level = u), h.ke = w, 2 == o) w && _r55 == n && (h.label = this.K.zb.Ba && 1 < this.K.Ia.length ? w.caption + " " + i.caption : w.caption + " " + t.model.v.g.zH, d = !0);else {
                      if (0 > c) return a.Vb(h.label) && (h.Db = !0), -1 < (u = this.MD(e)) && (h.level = u), h;
                      0 < p && (w = null), w && 0 != w.ra && (h.label = w.caption), g = 1 == o && l < this.K.hc.length - 1 && 0 == p;
                    }
                    if (p = e.slice(0, l + 1), m && w) {
                      p[l] = w.ra;
                      var v = this.K.Xh(p, w, i);
                      w.Qc || !w.Kc.Rk || w.Mj || 2 == o || 1 == w.children.length && (w.children.F(0).caption == t.model.v.g.Cg || w.children.F(0).caption == t.model.v.g.sl) || (t.model.A.P.Av ? v ? h.zn = !0 : h.gm = !0 : v ? h.Ki = !0 : h.collapsed = !0);
                    }
                    g && !v && (this.K.Vg(p, i) ? h.Ki = !0 : h.collapsed = !0);
                  }
                  return A ? (h.label = "", h.di = h.ei = h.collapsed = h.Ki = h.zn = h.gm = !1) : (h.fi = p, h.url = void 0, h.lb = f, h.measure = i, ("on" == t.model.A.P.Fe || "rows" == t.model.A.P.Fe) && (h.mo = !0, this.K.Af && this.K.Af.toString() == p.toString() && this.K.Yk == i && (this.K.Tf == t.u.i.ba.vb ? h.ei = !0 : this.K.Tf == t.u.i.ba.ub && (h.di = !0)))), d && -1 < (u = this.MD(e)) && (h.level = u), a.Vb(h.label) && (h.Db = !0, h.EZ = !(2 == o && w && n - 1 > _r55)), h;
                }
              }, {
                key: "MD",
                value: function MD(t) {
                  return (t = this.K.GM(t).ua.F(t[t.length - 1])) ? this.K.Sj.indexOf(t.level.j) : -1;
                }
              }, {
                key: "SE",
                value: function SE(e) {
                  a.U(e.cell) || !e.cell.Ae && !e.cell.Be || (e.cell.lr == s.C.hj.OG ? this.AL(e.cell) : e.cell.lr == s.C.hj.lw && e.cell.JZ || (a.U(e.cell.ke) || e.cell.lr == s.C.hj.xw ? e.cell.lr == s.C.hj.xw && (e.cell.Ae && this.MF(e.cell), e.cell.Be && this.OF(e.cell)) : t.model.A.P.Av || e.cell.ke.Mj ? this.iD(e.cell) : this.AL(e.cell)));
                }
              }, {
                key: "Pj",
                value: function Pj(i) {
                  t.model.A.P.Ks && this.na(new e.vH(i.lb));
                }
              }, {
                key: "AL",
                value: function AL(e) {
                  if (e.gm || e.zn || e.Ki || e.collapsed) {
                    var i = e.fi,
                      s = t.model.A.P.ph ? null : e.measure,
                      _r56 = e.ke;
                    if (null != _r56 && !_r56.Qc && !_r56.Mj) {
                      if (e.Be) {
                        e = t.u.i.da.Ka;
                        var n = this.K.Xh(i, _r56, s);
                      } else e = t.u.i.da.rb, n = this.K.Kj(i, _r56, s);
                      n ? this.K.fm(i, _r56, e, s) : this.K.Hk(i, _r56, e, s);
                    }
                  }
                }
              }, {
                key: "iD",
                value: function iD(e) {
                  if (e.Ki || e.collapsed) {
                    var i = e.fi,
                      s = e.Ae ? t.u.i.da.rb : t.u.i.da.Ka,
                      _r57 = t.model.A.P.ph && s == t.u.i.da.Ka ? null : e.measure;
                    e.Ki ? (this.X.clearData(), this.K.collapse(i, s, _r57)) : e.collapsed && (this.X.clearData(), this.K.expand(i, s, _r57)), e.Ae ? this.X.ur(e.ue + 1) : this.X.vr(e.fb + 1);
                  }
                }
              }, {
                key: "TE",
                value: function TE(e) {
                  e.VZ ? this.j3(e.cell) : (this.CZ && t.model.A.P.yj && !this.ef && this.yj(e.cell), this.VW(e.cell));
                }
              }, {
                key: "yj",
                value: function yj(t) {
                  t.yh && !t.measure.La && this.Oa(e.kf.PG, this, {
                    measure: t.measure.j,
                    Di: t.Di,
                    Yi: t.Yi
                  });
                }
              }, {
                key: "j3",
                value: function j3(e) {
                  var i = e.Sa();
                  this.Vz(i, e.ue, e.fb), t.model.xa.V().na(new t.model.ac(t.model.xa.Tv, i));
                }
              }, {
                key: "VW",
                value: function VW(e) {
                  var i = e.Sa();
                  this.Vz(i, e.ue, e.fb), t.model.xa.V().na(new t.model.ac(t.model.xa.Uv, i));
                }
              }, {
                key: "Vz",
                value: function Vz(t, e, i) {
                  t.x = this.X.coords.Oi(e, this.X.jb), t.y = this.X.coords.Lk(i, this.X.jb), t.width = this.X.coords.sf(e), t.height = this.X.coords.Zb(i);
                }
              }, {
                key: "OF",
                value: function OF(e) {
                  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  var s = e.fi;
                  null == (e = e.measure) && (e = this.K.Ia.F(0)), this.K.Af && this.K.Af.toString() == s.toString() && this.K.Yk == e ? this.K.Tf = this.K.Tf == t.u.i.ba.vb ? t.u.i.ba.ub : t.u.i.ba.vb : (this.K.Tf = t.u.i.ba.vb, this.K.Af = s, this.K.Yk = e), "" != i && (this.K.Tf = i), this.K.sort(), this.X.ur(0), this.Ha();
                }
              }, {
                key: "MF",
                value: function MF(e) {
                  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  var s = e.fi;
                  null == (e = e.measure) && (e = this.K.Ia.F(0)), s && this.K.af && this.K.af.toString() == s.toString() && this.K.tj == e ? this.K.Gf = this.K.Gf == t.u.i.ba.vb ? t.u.i.ba.ub : t.u.i.ba.vb : (this.K.Gf = e.type == t.u.types.Ca.Hb ? t.u.i.ba.ub : t.u.i.ba.vb, this.K.af = s, this.K.tj = e), "" != i && (this.K.Gf = i), this.K.sort(), this.X.vr(0), this.Ha();
                }
              }, {
                key: "KV",
                value: function KV() {
                  this.K.Gf = t.u.i.ba.mb, this.K.af = null, this.K.tj = null, this.Kl.O.yx(this.K.zb), this.K.sort(), this.X.vr(0), this.Ha();
                }
              }, {
                key: "OV",
                value: function OV() {
                  this.K.Tf = t.u.i.ba.mb, this.K.Af = null, this.K.Yk = null, this.Kl.O.yx(this.K.nb), this.K.sort(), this.X.ur(0), this.Ha();
                }
              }, {
                key: "I0",
                value: function I0(t, e) {
                  null == (t = this.X.Hu(t.target)) || a.Vb(t.label) && isNaN(t.value) || (this.cP(t, {
                    left: e.clientX,
                    top: e.clientY
                  }), this.X.dm());
                }
              }, {
                key: "Z_",
                value: function Z_(t) {
                  var e = this.X.aj[0] || this.X.Hu(t.target);
                  null == e || a.Vb(e.label) && isNaN(e.value) || (t.preventDefault(), this.cP(e, {
                    left: t.clientX,
                    top: t.clientY
                  }), this.X.dm());
                }
              }, {
                key: "cP",
                value: function cP(i, s) {
                  var _this98 = this;
                  if (null != i) {
                    var _r58 = [];
                    !i.yh || isNaN(i.value) || this.ef || i.measure.La || !t.model.A.P.yj || _r58.push({
                      caption: t.model.v.g.iQ,
                      handler: function handler() {
                        _this98.yj(i);
                      }
                    }), i.xh && t.model.A.P.Ks && _r58.push({
                      caption: t.model.v.g.kQ,
                      handler: function handler() {
                        _this98.na(new e.vH(i.lb));
                      }
                    }), (i.Be || i.Ae) && (i.Ki && _r58.push({
                      caption: t.model.v.g.hQ,
                      handler: function handler() {
                        _this98.iD(i);
                      }
                    }), i.collapsed && _r58.push({
                      caption: t.model.v.g.jQ,
                      handler: function handler() {
                        _this98.iD(i);
                      }
                    })), i.Be && !i.xh && (i.ei || _r58.push({
                      caption: t.model.v.g.oQ,
                      handler: function handler() {
                        _this98.OF(i, t.u.i.ba.vb);
                      }
                    }), i.di || _r58.push({
                      caption: t.model.v.g.nQ,
                      handler: function handler() {
                        _this98.OF(i, t.u.i.ba.ub);
                      }
                    }), (i.di || i.ei) && _r58.push({
                      caption: t.model.v.g.AG,
                      handler: function handler() {
                        _this98.OV();
                      }
                    })), i.Ae && !i.xh && (i.ei || _r58.push({
                      caption: t.model.v.g.mQ,
                      handler: function handler() {
                        _this98.MF(i, t.u.i.ba.vb);
                      }
                    }), i.di || _r58.push({
                      caption: t.model.v.g.lQ,
                      handler: function handler() {
                        _this98.MF(i, t.u.i.ba.ub);
                      }
                    }), (i.di || i.ei) && _r58.push({
                      caption: t.model.v.g.AG,
                      handler: function handler() {
                        _this98.KV();
                      }
                    })), 0 < _r58.length && this.Kl.Oa(e.kf.BG, this, {
                      o_: _r58,
                      coords: s
                    });
                  }
                }
              }, {
                key: "fK",
                value: function fK(e, i, _r59) {
                  for (var n, a = _r59 == t.u.i.da.rb ? this.K.ed : this.K.hc, o = 0, h = 0; h < a.length; h++) {
                    var l = a.F(h);
                    l.tf || ((n = new s.C.ad()).label = l.caption, n.xh = !0, n.draggable = !0, n.Oy = !0, n.ec = l.Sg(), n.level = o, n.lb = l, _r59 == t.u.i.da.rb ? (n.isFrozen = !this.ef, this.X.K.Wz(e, i + h, n)) : (n.Be = !0, this.X.K.Wz(e + o, i, n), o++));
                  }
                }
              }, {
                key: "CT",
                value: function CT(t) {
                  for (var e, i = this.K.hc, _r60 = 0, n = this.K.zb.Ba && 1 < this.K.Ia.length ? this.pe - 1 : this.pe, a = 0; a < i.length; a++) {
                    var o = i.F(a);
                    if ((e = new s.C.ad()).label = o.caption, e.xh = !0, e.draggable = !0, e.Oy = !0, e.ec = o.Sg(), e.lb = o, this.X.K.Wz(t, 0 + _r60, e), _r60++, 2 < o.Fb.length) for (var h = 2; h < o.Fb.length; h++) {
                      var l = o.Fb.F(h);
                      if (-1 != this.K.Sj.indexOf(l.j) && ((e = new s.C.ad()).label = l.caption, e.Be = !0, e.Oy = !0, this.X.K.Wz(t, 0 + _r60, e), _r60++), _r60 >= n) break;
                    }
                    if (_r60 >= n) break;
                  }
                }
              }, {
                key: "ef",
                get: function get() {
                  return t.model.A.P.Dc;
                }
              }, {
                key: "CZ",
                get: function get() {
                  return !t.model.A.P.Dc;
                }
              }, {
                key: "X",
                get: function get() {
                  return this.Wo;
                }
              }, {
                key: "Aj",
                value: function Aj(e, i) {
                  e == t.model.Pd.Co.Fo && t.model.Pd.YG.Uf(this, i, this.K.ig, this.K.Jf), e == t.model.Pd.Co.Fq && t.model.Pd.$G.Uf(this, i, this.K.ig, this.K.Jf), e == t.model.Pd.Co.dt && t.model.Pd.aH.Uf(this, i, this.K.ig, this.K.Jf);
                }
              }, {
                key: "print",
                value: function print() {
                  t.model.ao.XA.V().Uf(this, this.K);
                }
              }, {
                key: "Ld",
                value: function Ld(t, e) {
                  var i = this.X.Ld(t, e, !0);
                  if (null == i) {
                    (i = new s.C.ad()).fb = t, i.ue = e;
                    var _r61 = this.getData(t, e, !0);
                    i.value = _r61 ? _r61.value : NaN, isNaN(i.value) || (i.label = a.Fd.format(i.value));
                  }
                  return -1 == i.fb && (i.fb = t), -1 == i.ue && (i.ue = e), t = i.Sa(), this.Vz(t, i.ue, i.fb), t;
                }
              }, {
                key: "Su",
                value: function Su() {
                  if (a.U(this.X)) return null;
                  var t = this.X.aj.map(function (t) {
                    return t.Sa();
                  });
                  return 0 == t.length ? null : (1 < t.length || (t = t[0], this.Vz(t, t.columnIndex, t.rowIndex)), t);
                }
              }, {
                key: "Is",
                value: function Is(t, e) {
                  this.X.select(t, e, t, e);
                }
              }, {
                key: "ws",
                value: function ws() {
                  this.X.dm();
                }
              }, {
                key: "dF",
                value: function dF(t) {
                  this.FJ(t.data.ue, t.data.width);
                }
              }, {
                key: "eF",
                value: function eF(t) {
                  this.GJ(t.data.fb, t.data.height);
                }
              }, {
                key: "FJ",
                value: function FJ(e, i) {
                  if (e < this.pe) 0 < i ? t.model.sizes.Ib.Rd[e] = i : delete t.model.sizes.Ib.Rd[e];else {
                    var s = this.K.Kk(e - this.pe, !0);
                    null != s && (e = this.K.kM(e - this.pe), this.K.nb.Ba && s.push(e), 0 < i ? t.model.sizes.Ib.Sd[s.join(",")] = i : delete t.model.sizes.Ib.Sd[s.join(",")]);
                  }
                }
              }, {
                key: "i2",
                value: function i2() {
                  var e = t.model.sizes.Ib.Wl;
                  t.model.sizes.Ib.Wl = {};
                  var i,
                    s = [];
                  for (i in e) e[i] && (s[parseInt(i)] = e[i]);
                  for (var _r62 in s) this.X.yF(parseInt(_r62), s[_r62]), this.FJ(parseInt(_r62), s[_r62]);
                }
              }, {
                key: "j2",
                value: function j2() {
                  var e,
                    i = t.model.sizes.Ib.Rd,
                    s = [];
                  for (e in i) i[e] && (s[e] = i[e]);
                  for (var _r63 in s) (i = parseInt(_r63)) < this.pe && this.X.yF(i, s[i]);
                }
              }, {
                key: "h2",
                value: function h2() {
                  var e,
                    i = t.model.sizes.Ib.Sd,
                    s = [];
                  for (e in i) if (i[e]) {
                    var _r64 = this.K.ry("" == e ? [] : e.split(","));
                    -1 != _r64 && (s[_r64 += this.pe] = i[e]);
                  }
                  for (var n in s) this.X.yF(parseInt(n), s[n]);
                }
              }, {
                key: "m2",
                value: function m2() {
                  var e = t.model.sizes.Ib.Am;
                  t.model.sizes.Ib.Am = {};
                  var i,
                    s = [];
                  for (i in e) e[i] && (s[parseInt(i)] = e[i]);
                  for (var _r65 in s) this.X.zF(parseInt(_r65), s[_r65]), this.GJ(parseInt(_r65), s[_r65]);
                }
              }, {
                key: "k2",
                value: function k2() {
                  t.model.sizes.Ib.nq = this.jf;
                  var e,
                    i = t.model.sizes.Ib.Zd,
                    s = [];
                  for (e in i) i[e] && (s[parseInt(e) + this.jf] = i[e]);
                  for (var _r66 in s) parseInt(_r66) < this.md && this.X.zF(parseInt(_r66), s[_r66]);
                }
              }, {
                key: "l2",
                value: function l2() {
                  var e,
                    i = t.model.sizes.Ib.$d,
                    s = [];
                  for (e in i) if (i[e]) {
                    var _r67 = this.K.Fy("" == e ? [] : e.split(","));
                    -1 != _r67 && (s[_r67 += this.md] = i[e]);
                  }
                  for (var n in s) this.X.zF(parseInt(n), s[n]);
                }
              }, {
                key: "GJ",
                value: function GJ(e, i) {
                  if (t.model.sizes.Ib.nq = this.jf, e < this.jf) 0 < i ? t.model.sizes.Ib.le[e] = i : delete t.model.sizes.Ib.le[e];else if (e < this.md) 0 < i ? t.model.sizes.Ib.Zd[e - this.jf] = i : delete t.model.sizes.Ib.Zd[e - this.jf];else {
                    var s = this.K.Ep(e - this.md, !0);
                    null != s && (e = this.K.JM(e - this.md), this.K.zb.Ba && s.push(e), 0 < i ? t.model.sizes.Ib.$d[s.join(",")] = i : delete t.model.sizes.Ib.$d[s.join(",")]);
                  }
                }
              }]);
              return r;
            }(i.Ac.Lh);
            s.mR = r;
          }((e = t.G || (t.G = {})).N || (e.N = {}));
        }(r || (r = {})), function (t) {
          var i;
          !function (t) {
            var i = /*#__PURE__*/_createClass(function i() {
              _classCallCheck(this, i);
            });
            i.kh = "mclick", i.SR = "dblclick", i.sw = "singledoubleclick", i.WR = "mup", i.TR = "mdown", i.VR = "mmove", i.zA = "dthclosed", i.wR = "long", i.nl = "filter_click", i.Hq = "resize_c", i.Iq = "resize_r", t.Ob = i;
            var s = /*#__PURE__*/function (_e$ga7) {
              _inherits(s, _e$ga7);
              var _super66 = _createSuper(s);
              function s(t) {
                var _this99;
                var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                _classCallCheck(this, s);
                _this99 = _super66.call(this, i.kh), _this99.cell = t, _this99.element = e;
                return _this99;
              }
              return _createClass(s);
            }(e.ga);
            t.MA = s;
            var r = /*#__PURE__*/function (_e$ga8) {
              _inherits(r, _e$ga8);
              var _super67 = _createSuper(r);
              function r(t) {
                var _this100;
                _classCallCheck(this, r);
                _this100 = _super67.call(this, i.SR), _this100.cell = t;
                return _this100;
              }
              return _createClass(r);
            }(e.ga);
            t.H4 = r;
            var n = /*#__PURE__*/function (_e$ga9) {
              _inherits(n, _e$ga9);
              var _super68 = _createSuper(n);
              function n(t, e) {
                var _this101;
                var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                _classCallCheck(this, n);
                _this101 = _super68.call(this, i.sw), _this101.cell = t, _this101.VZ = e, _this101.element = s;
                return _this101;
              }
              return _createClass(n);
            }(e.ga);
            t.AH = n;
            var a = /*#__PURE__*/function (_e$ga10) {
              _inherits(a, _e$ga10);
              var _super69 = _createSuper(a);
              function a(t) {
                var _this102;
                _classCallCheck(this, a);
                _this102 = _super69.call(this, i.TR), _this102.cell = t;
                return _this102;
              }
              return _createClass(a);
            }(e.ga);
            t.jR = a;
            var o = /*#__PURE__*/function (_e$ga11) {
              _inherits(o, _e$ga11);
              var _super70 = _createSuper(o);
              function o(t) {
                var _this103;
                _classCallCheck(this, o);
                _this103 = _super70.call(this, i.VR), _this103.cell = t;
                return _this103;
              }
              return _createClass(o);
            }(e.ga);
            t.kR = o;
            var h = /*#__PURE__*/function (_e$ga12) {
              _inherits(h, _e$ga12);
              var _super71 = _createSuper(h);
              function h(t) {
                var _this104;
                _classCallCheck(this, h);
                _this104 = _super71.call(this, i.WR), _this104.cell = t;
                return _this104;
              }
              return _createClass(h);
            }(e.ga);
            t.lR = h;
            var l = /*#__PURE__*/function (_e$ga13) {
              _inherits(l, _e$ga13);
              var _super72 = _createSuper(l);
              function l(t, e) {
                var _this105;
                _classCallCheck(this, l);
                _this105 = _super72.call(this, i.wR), _this105.cell = t, _this105.coords = e;
                return _this105;
              }
              return _createClass(l);
            }(e.ga);
            t.I4 = l;
            var A = /*#__PURE__*/function (_e$ga14) {
              _inherits(A, _e$ga14);
              var _super73 = _createSuper(A);
              function A(t, e) {
                var _this106;
                var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                _classCallCheck(this, A);
                _this106 = _super73.call(this, i.nl), _this106.lb = t, _this106.cell = e, _this106.element = s;
                return _this106;
              }
              return _createClass(A);
            }(e.ga);
            t.hw = A;
          }((i = t.G || (t.G = {})).N || (i.N = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function () {
              function e() {
                _classCallCheck(this, e);
              }
              _createClass(e, null, [{
                key: "validate",
                value: function validate(t) {
                  return t == e.xo || t == e.vq || t == e.Ih ? t : e.xo;
                }
              }]);
              return e;
            }();
            e.xo = "compact", e.vq = "classic", e.Ih = "flat", t.Ue = e;
          }((e = t.G || (t.G = {})).N || (e.N = {}));
        }(r || (r = {})), function (t) {
          !function (e) {
            var s = /*#__PURE__*/function (_i$Ac$Oo2) {
              _inherits(s, _i$Ac$Oo2);
              var _super74 = _createSuper(s);
              function s() {
                var _this107;
                _classCallCheck(this, s);
                if (null != s.Nc) throw Error("Singleton");
                _this107 = _super74.call(this, e.xb.tb.B), _this107.qb("wdr-alert-view"), _this107.Bd();
                return _this107;
              }
              _createClass(s, [{
                key: "Bd",
                value: function Bd() {
                  this.ts.Y("wdr-overlay-alert"), this.Bt = [];
                  var t = new i.ya("div", "wdr-content");
                  this.R(t), this.Ol = new i.dc(), this.Ol.Y("wdr-popup-title"), t.R(this.Ol), this.kr = new i.dc(), t.R(this.kr), this.jx = new i.ya("div", "wdr-ui-btns-row"), t.R(this.jx), this.ar = new i.ya("div", "wdr-alert-icon"), this.R(this.ar);
                }
              }, {
                key: "ym",
                value: function ym() {
                  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                  var _s68 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t.ld.to;
                  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                  var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
                  var o = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
                  this.clear(), this.ZO(_s68), this.Gs(i), this.M2(r), this.F2(n, a), e.xb.tb.R(this), this.lE = o, this.open(), this.sr();
                }
              }, {
                key: "clear",
                value: function clear() {
                  for (this.ZO(""), this.Gs(""); 0 < this.Bt.length;) this.Bt.pop().Wi();
                  this.B.Va("wdr-alert", !1), this.B.Va("wdr-confirmation", !1), this.B.Va("wdr-error", !1), this.B.Va("wdr-info", !1), this.B.Va("wdr-question", !1);
                }
              }, {
                key: "ZO",
                value: function ZO(t) {
                  this.Ol.IF(!1), this.Ol.wa(t);
                }
              }, {
                key: "Gs",
                value: function Gs(t) {
                  this.kr.wa(t, !0);
                }
              }, {
                key: "F2",
                value: function F2(e, _s69) {
                  var _this108 = this;
                  null == e && (e = [t.model.v.g.lG]), e.reverse(), null != _s69 && _s69.reverse(), this.IB = _s69;
                  for (var r = 0; r < e.length; r++) (_s69 = new i.Wb()).wa(e[r]), _s69.addEventListener(i.Wb.Se, function (t) {
                    return _this108.sV(t);
                  }), this.Bt.push(_s69), this.isPrimary(e[r]) && _s69.Y("wdr-ui-btn-dark"), this.isPrimary(e[r]) && (a.Dg.qm || a.Dg.fs) ? this.jx.R(_s69) : this.isPrimary(e[r]) ? this.jx.B.prepend(_s69.B) : this.jx.R(_s69);
                }
              }, {
                key: "isPrimary",
                value: function isPrimary(e) {
                  switch (e) {
                    case t.model.v.g.lG:
                    case t.model.v.g.mG:
                    case t.model.v.g.pA:
                      return !0;
                  }
                  return !1;
                }
              }, {
                key: "sV",
                value: function sV(t) {
                  t = t.target;
                  for (var e = -1, i = 0; i < this.Bt.length; i++) if (this.Bt[i] == t) {
                    e = i;
                    break;
                  }
                  0 > e || (this.close(), null == this.IB || null == this.IB[e]) || this.IB[e]();
                }
              }, {
                key: "M2",
                value: function M2(e) {
                  this.ar.B.fq(), e == t.ld.to ? this.ar.B.R(this.zW()) : e == t.ld.wq ? this.ar.B.R(this.AW()) : e == t.ld.wb ? this.ar.B.R(this.DW()) : e == t.ld.FH && this.ar.B.R(this.EW());
                }
              }, {
                key: "AW",
                value: function AW() {
                  var t = new i.ia("span", "wdr-circle");
                  return t.R(new i.ia("span", "wdr-ui-icon wdr-icon-notif_confirm")), t;
                }
              }, {
                key: "EW",
                value: function EW() {
                  var t = new i.ia("span", "wdr-circle");
                  return t.R(new i.ia("span", "wdr-ui-icon wdr-icon-notif_info")), t;
                }
              }, {
                key: "zW",
                value: function zW() {
                  var t = new i.ia("span", "wdr-triangle-wrap");
                  return t.R(new i.ia("span", "wdr-triangle")), t.R(new i.ia("span", "wdr-ui-icon wdr-icon-notif_warning")), t;
                }
              }, {
                key: "DW",
                value: function DW() {
                  var t = new i.ia("span", "wdr-hexagon");
                  return t.R(new i.ia("span", "wdr-ui-icon wdr-icon-notif_arrow")), t;
                }
              }, {
                key: "close",
                value: function close() {
                  _get(_getPrototypeOf(s.prototype), "close", this).call(this), this.clear();
                }
              }, {
                key: "aF",
                value: function aF() {
                  this.lE || _get(_getPrototypeOf(s.prototype), "aF", this).call(this);
                }
              }], [{
                key: "V",
                value: function V() {
                  return null == s.Nc && (s.Nc = new s()), s.Nc;
                }
              }, {
                key: "la",
                value: function la() {
                  s.Nc = null;
                }
              }]);
              return s;
            }(i.Ac.Oo);
            e.hG = s;
          }(t.G || (t.G = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (s) {
            var r = /*#__PURE__*/function (_i$Ac$Oo3) {
              _inherits(r, _i$Ac$Oo3);
              var _super75 = _createSuper(r);
              function r() {
                var _this109;
                _classCallCheck(this, r);
                _this109 = _super75.call(this, e.xb.tb.B), _this109.measure = _this109.Yi = _this109.Di = _this109.zz = _this109.slice = null, _this109.pe = _this109.md = _this109.mi = _this109.Wm = _this109.jf = 0, _this109.qb("wdr-drillthrough-view"), _this109.Bd();
                return _this109;
              }
              _createClass(r, [{
                key: "Bd",
                value: function Bd() {
                  var _this110 = this;
                  this.Ry = new i.Ac.Lh("wdr-header-container"), this.R(this.Ry), this.Ol = new i.dc(), this.Ol.Y("wdr-popup-title"), this.Ol.IF(!1), this.Ry.R(this.Ol), this.pB = new i.Wb(), this.pB.Y("wdr-ui-btn-close"), this.pB.addEventListener(i.Wb.Se, function () {
                    return _this110.close();
                  }), this.Ry.R(this.pB), this.vu = new i.Ac.Lh("wdr-details-container"), this.R(this.vu), this.mx = new i.dc(), this.mx.Y("wdr-ui-label-light"), this.vu.R(this.mx), this.kx = new i.dc(), this.kx.Y("wdr-ui-label-light"), this.vu.R(this.kx), this.lx = new i.dc(), this.lx.Y("wdr-ui-label-light"), this.vu.R(this.lx), this.KF = new i.Ac.Lh("wdr-grid-container"), this.R(this.KF), this.X = new s.sheet.flat.iw(), this.X.Qk = !0, this.X.Ap = function (t, e) {
                    return _this110.getData(t, e);
                  }, this.KF.B.R(this.X);
                }
              }, {
                key: "ym",
                value: function ym() {
                  var _this111 = this;
                  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                  var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var _r68 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                  var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
                  this.K = i, this.Cm(s.clone()), this.zz = s, this.Yi = n, this.Di = _r68, this.measure = a, this.zP = t.model.A.P.Re, t.model.A.P.Re = !0, this.data = this.K.yj(this.Yi, this.Di, this.measure), this.keys = this.data.shift(), t.model.A.P.fP && null == this.Hl && (this.Hl = new e.bc.ck(), this.Hl.s_ = e.xb.tb.B, this.Hl.es = !0, this.Hl.IC = this.X.element, this.Hl.addEventListener(e.bc.ck.EA, function () {
                    return _this111.PE();
                  }), this.Hl.addEventListener(e.bc.ck.Bo, function (t) {
                    return _this111.rz(t);
                  }), this.KF.R(this.Hl)), this.X.addEventListener(e.bc.ck.Bo, function (t) {
                    return _this111.rz(t);
                  }), this.open(), this.vs();
                }
              }, {
                key: "ns",
                value: function ns(e) {
                  this.data = e, t.Ta(!1), null != this.data && (this.open(), this.vs());
                }
              }, {
                key: "Cm",
                value: function Cm(t) {
                  this.slice = t;
                }
              }, {
                key: "vs",
                value: function vs() {
                  this.Ol.wa(t.model.v.g.MQ), this.mx.wa(this.EM(), !0), this.kx.wa(this.gM(), !0), this.lx.wa(this.BM(), !0), this.Dm(e.xb.eA - 80);
                  var i = e.xb.tb.B.Xc(!0) - this.vu.B.Xc(!0) - this.Ry.B.Xc(!0) - 30 - this.B.padding.top - this.B.padding.bottom - 40,
                    s = this.Lf() - 2;
                  this.X.qp(), this.X.resize(s, i), this.X.width = s, this.X.height = i, this.X.aM(1), this.X.RO(this.data.length, this.slice.flatten().length), this.X.Ha(), this.sr();
                }
              }, {
                key: "close",
                value: function close() {
                  _get(_getPrototypeOf(r.prototype), "close", this).call(this), 0 == a.U(this.zP) && (t.model.A.P.Re = this.zP), this.Oa(s.Ob.zA);
                }
              }, {
                key: "getData",
                value: function getData(e, i) {
                  if (0 == e) return this.Tr(i);
                  var _r69 = new s.C.ad();
                  if (_r69.Qk = !0, _r69.yh = !0, null == this.data || null == this.data[e - 1]) return null;
                  var n = this.slice.flatten();
                  if (!(i < this.data[e - 1].length)) return null;
                  if (null == (i = n.F(i))) return null;
                  n = this.keys.indexOf(i.j), 2 < i.Fb.length && (n = this.keys.indexOf(i.Fb.yd(i.Fb.length - 1)));
                  var o = this.LY(e, n);
                  return _r69.lb = i, _r69.label = this.IY(i.ua.F(o)), null == (n = this.slice.og(i.j)) ? null : (e = n.Ne(!0).clone(), this.zz.pa.rc(n.j) && null != (i = i.ua.F(o)) && (_r69.value = i.qg, _r69.label = n.type == t.u.types.Ca.Rb ? a.Fd.format(_r69.value, e) : i.caption), "" != e.textAlign && _r69.Mx({
                    "text-align": e.textAlign
                  }), _r69.measure = n, _r69);
                }
              }, {
                key: "LY",
                value: function LY(t, e) {
                  for (; null == this.data[t - 1][e];) e--;
                  return this.data[t - 1][e];
                }
              }, {
                key: "IY",
                value: function IY(t) {
                  for (var e = []; t && t.parent;) e.unshift(t.caption), t = t.parent;
                  return e.join(" / ");
                }
              }, {
                key: "Tr",
                value: function Tr(t) {
                  var e = new s.C.ad();
                  return e.Qk = !0, e.Ae = !0, null == (t = this.slice.flatten().F(t)) ? null : (e.label = t.caption, e);
                }
              }, {
                key: "EM",
                value: function EM() {
                  for (var e, i = [], s = 0; s < this.Yi.length; s++) {
                    if (null == (e = this.zz.hc.F(s))) return null;
                    e = e.ua.F(this.Yi[s]), i.push(e.caption);
                  }
                  return (i = 0 < i.length ? a.$.bind(t.model.v.g.LQ, i.join(" - ")) : "").replace(/<br\s*[\/]?>/gi, " ");
                }
              }, {
                key: "gM",
                value: function gM() {
                  for (var e, i = [], s = 0; s < this.Di.length; s++) {
                    if (null == (e = this.zz.ed.F(s))) return null;
                    e = e.ua.F(this.Di[s]), i.push(e.caption);
                  }
                  return (i = 0 < i.length ? a.$.bind(t.model.v.g.KQ, i.join(" - ")) : "").replace(/<br\s*[\/]?>/gi, " ");
                }
              }, {
                key: "BM",
                value: function BM() {
                  var e = this.measure.Ne().clone(),
                    i = this.K.Mb(this.Yi, this.Di, this.measure);
                  return e = a.Fd.format(i, e), e = (e = a.$.bind(t.model.v.g.NQ, this.measure.caption, e)).replace(/<br\s*[\/]?>/gi, " "), this.value = i, e;
                }
              }, {
                key: "PE",
                value: function PE() {
                  this.Hl && this.Hl.open(t.u.Ja.V().ea, this.slice);
                }
              }, {
                key: "rz",
                value: function rz(e) {
                  e = e.data instanceof t.u.oa.lh ? e.data : t.u.oa.lh.Za(t.model.kb.Kh.Za(e.data), t.u.Ja.V().ea), this.Cm(e), this.vs();
                }
              }, {
                key: "Aj",
                value: function Aj(e, i) {
                  var s = this.slice ? this.slice.flatten().length : this.data[0] ? this.data[0].length : 0,
                    _r70 = this.data ? this.data.length + 1 : 0;
                  e == t.model.Pd.Co.Fo && t.model.Pd.YG.Uf(this, i, s, _r70), e == t.model.Pd.Co.Fq && t.model.Pd.$G.Uf(this, i, s, _r70), e == t.model.Pd.Co.dt && t.model.Pd.aH.Uf(this, i, s, _r70);
                }
              }, {
                key: "saveData",
                value: function saveData(t, e, i) {
                  var _this112 = this;
                  this.me && this.me.Rz && this.me.stop(), null == this.me && (this.me = new a.hB(1e3, 1)), this.me.addEventListener(a.Lq.Cw, function () {
                    return _this112.p1();
                  }), this.me.start(), (e = this.getData(t, e)) && e.label != i && e.value != i && this.K.save(this.Yi, this.Di, e.lb, i, t - 1), this.Ha();
                }
              }, {
                key: "p1",
                value: function p1() {
                  this.mx.wa(this.EM(), !0), this.kx.wa(this.gM(), !0), this.lx.wa(this.BM(), !0), this.me.stop();
                }
              }]);
              return r;
            }(i.Ac.Oo);
            s.PQ = r;
          }((e = t.G || (t.G = {})).N || (e.N = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.G || (t.G = {}), function (e) {
            var i = /*#__PURE__*/function () {
              function i() {
                _classCallCheck(this, i);
                this.value = NaN, this.label = "", this.level = NaN, this.ei = this.di = this.mo = this.zn = this.gm = this.draggable = this.collapsed = this.Ki = this.ec = this.Oy = this.i3 = this.JZ = this.yh = this.eE = this.dz = this.Hp = this.bv = this.sm = this.kE = this.Ae = this.Be = this.isFrozen = this.xh = this.ds = this.numeric = !1, this.ue = this.fb = -1, this.nO = null, this.Qk = this.EZ = this.Db = !1, this.uc = [], this.url = "", this.lr = e.hj.iG;
              }
              _createClass(i, [{
                key: "Ri",
                get: function get() {
                  return this.sm || this.bv;
                }
              }, {
                key: "iN",
                get: function get() {
                  return this.Hp || this.dz;
                }
              }, {
                key: "wY",
                value: function wY() {
                  return this.zn || this.gm ? this.lb.Fb.F(this.ke.level.Md + 1).caption : "";
                }
              }, {
                key: "I",
                value: function I() {
                  if (null != i.tp) {
                    var e = new st();
                    e.clear(), e.tag = "div", e.text += this.label, i.tp(e.node, this.Sa());
                    var s = e.text;
                    return s = t.model.zc.valid(s) ? s : t.model.zc.validate(s), e.clear(), (e = document.createElement("div")).innerHTML = s, e.textContent ? e.textContent.trim() : s;
                  }
                  return this.label;
                }
              }, {
                key: "Mx",
                value: function Mx(t) {
                  this.ds = !0, null == this.style && (this.style = new e.EG()), this.style.nU(t);
                }
              }, {
                key: "TC",
                value: function TC(t) {
                  this.ds = !0, null == this.style && (this.style = new e.EG()), this.style.pn(t), this.style.uU(t);
                }
              }, {
                key: "Sa",
                value: function Sa() {
                  if (this.SN) return this.SN;
                  var e,
                    _i40 = t.model.yb.V(),
                    s = [];
                  if (!t.model.A.P.Dc && (e = this.Ae && this.fi ? this.fi : this.Di)) for (var r = _i40.O.fa ? _i40.O.fa.ed : new a.ma(), n = 0; n < e.length; n++) {
                    var o = r.F(n);
                    o = o.ua.F(e[n]), s.push({
                      caption: o.caption,
                      uniqueName: o.j,
                      hierarchyCaption: o.Kc.caption,
                      hierarchyUniqueName: o.Kc.j
                    });
                  }
                  if (r = [], !t.model.A.P.Dc && (e = this.Be && this.fi ? this.fi : this.Yi)) for (_i40 = _i40.O.fa ? _i40.O.fa.hc : new a.ma(), n = 0; n < e.length; n++) o = (o = _i40.F(n)).ua.F(e[n]), r.push({
                    caption: o.caption,
                    uniqueName: o.j,
                    hierarchyCaption: o.Kc.caption,
                    hierarchyUniqueName: o.Kc.j
                  });
                  return e = {
                    columnIndex: this.ue,
                    columns: s,
                    label: this.label,
                    measure: this.measure ? t.u.oa.ol.Sa(this.measure) : null,
                    hierarchy: this.lb ? t.u.oa.de.Sa(this.lb) : null,
                    member: this.ke ? t.u.oa.qe.Sa(this.ke) : null,
                    rowIndex: this.fb,
                    rows: r,
                    type: this.Ae || this.Be || this.xh ? "header" : "value",
                    value: this.value,
                    recordId: this.nO,
                    isTotal: this.Ri,
                    isTotalRow: this.sm,
                    isTotalColumn: this.bv,
                    isClassicTotalRow: this.eE,
                    isGrandTotal: this.iN,
                    isGrandTotalRow: this.Hp,
                    isGrandTotalColumn: this.dz,
                    isDrillThrough: this.Qk
                  }, isNaN(this.level) || (e.level = this.level), 0 < this.uc.length && (e.conditions = this.uc), this.SN = e;
                }
              }]);
              return i;
            }();
            i.tp = null, e.ad = i;
          }((i = e.N || (e.N = {})).C || (i.C = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.G || (t.G = {}), ((i = e.N || (e.N = {})).C || (i.C = {})).EG = /*#__PURE__*/function () {
            function _class22() {
              _classCallCheck(this, _class22);
              this.fA = [], this.sp = [], this.ha = {};
            }
            _createClass(_class22, [{
              key: "pn",
              value: function pn(t) {
                -1 == this.fA.indexOf(t) && this.fA.push(t);
              }
            }, {
              key: "uU",
              value: function uU(t) {
                -1 == this.sp.indexOf(t) && this.sp.push(t);
              }
            }, {
              key: "nU",
              value: function nU(t) {
                for (var e in t) this.ha[e] = t[e];
              }
            }, {
              key: "ty",
              value: function ty() {
                return this.sp.join(" ");
              }
            }, {
              key: "Iy",
              value: function Iy() {
                var t,
                  e = "";
                for (t in this.ha) e += t + ":" + this.ha[t] + ";";
                return e;
              }
            }]);
            return _class22;
          }();
        }(r || (r = {})), function (t) {
          var e, s;
          e = t.G || (t.G = {}), function (t) {
            var s = /*#__PURE__*/function () {
              function s() {
                _classCallCheck(this, s);
              }
              _createClass(s, null, [{
                key: "BY",
                value: function BY(t) {
                  return 500 < t ? s.$P : s.$R;
                }
              }]);
              return s;
            }();
            s.$R = "", s.$P = "Bold", t.eR = s;
            var r = /*#__PURE__*/function () {
              function r() {
                _classCallCheck(this, r);
              }
              _createClass(r, [{
                key: "ks",
                value: function ks(t) {
                  this.color = this.color || t.color, this.backgroundColor = this.backgroundColor || t.backgroundColor, this.backgroundImage = this.backgroundImage || t.backgroundImage, this.borderColor = this.borderColor || t.borderColor, this.fontSize = this.fontSize || t.fontSize, this.fontWeight = this.fontWeight || t.fontWeight, this.textAlign = this.textAlign || t.textAlign, this.fontFamily = this.fontFamily || t.fontFamily, this.width = this.width || t.width, this.maxWidth = this.maxWidth || t.maxWidth, this.height = this.height || t.height, this.maxHeight = this.maxHeight || t.maxHeight;
                }
              }, {
                key: "clone",
                value: function clone() {
                  var t = new r();
                  return t.color = this.color, t.backgroundColor = this.backgroundColor, t.backgroundImage = this.backgroundImage, t.borderColor = this.borderColor, t.fontSize = this.fontSize, t.fontWeight = this.fontWeight, t.textAlign = this.textAlign, t.fontFamily = this.fontFamily, t.width = this.width, t.maxWidth = this.maxWidth, t.height = this.height, t.maxHeight = this.maxHeight, t;
                }
              }], [{
                key: "FX",
                value: function FX(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var i = new r();
                  return (null == e || null != e && e.ha("color") != t.ha("color")) && (i.color = t.ha("color")), (null == e || null != e && e.ha("background-color") != t.ha("background-color")) && (i.backgroundColor = t.ha("background-color")), (null == e || null != e && e.ha("background-image") != t.ha("background-image")) && (i.backgroundImage = t.ha("background-image")), (null == e || null != e && e.ha("border-color") != t.ha("border-color")) && (i.borderColor = t.ha("border-color")), (null == e || null != e && e.ha("font-size") != t.ha("font-size")) && (i.fontSize = parseInt(t.ha("font-size"))), (null == e || null != e && e.ha("font-weight") != t.ha("font-weight")) && (i.fontWeight = t.ha("font-weight")), (null == e || null != e && e.ha("fill") != t.ha("fill")) && (i.fill = t.ha("fill")), (null == e || null != e && e.ha("text-align") != t.ha("text-align")) && (i.textAlign = t.ha("text-align")), (null == e || null != e && e.ha("font-family") != t.ha("font-family")) && (i.fontFamily = t.ha("font-family")), (null == e || null != e && e.ha("width") != t.ha("width")) && (i.width = parseInt(t.ha("width"))), (null == e || null != e && e.ha("max-width") != t.ha("max-width")) && (i.maxWidth = parseInt(t.ha("max-width"))), (null == e || null != e && e.ha("height") != t.ha("height")) && (i.height = parseInt(t.ha("height"))), (null == e || null != e && e.ha("max-height") != t.ha("max-height")) && (i.maxHeight = parseInt(t.ha("max-height"))), i;
                }
              }, {
                key: "Qg",
                value: function Qg(t) {
                  var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var n = new i.ia("div");
                  return n.Y(t).Da(), t = new i.ia("div"), null == s ? e.xb.tb.B.append(n).append(t) : s.append(n).append(t), s = r.FX(n, t), n.remove(), t.remove(), s;
                }
              }, {
                key: "hy",
                value: function hy(t) {
                  var e,
                    i = new r();
                  for (t = t.replace(/ /g, ";"); -1 < (e = t.indexOf(";"));) this.SW(t.substring(0, e), i), t = t.substring(e + 1);
                  return i;
                }
              }, {
                key: "Uy",
                value: function Uy(t) {
                  return t = t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (t, e, i, s) {
                    return e + e + i + i + s + s;
                  }), null == (t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t)) ? "" : "rgb(" + parseInt(t[1], 16) + "," + parseInt(t[2], 16) + "," + parseInt(t[3], 16) + ")";
                }
              }, {
                key: "SW",
                value: function SW(t, e) {
                  -1 < t.indexOf("background-color") ? e.backgroundColor = this.Uy(t.substring(17, t.length)) : -1 < t.indexOf("background-image") ? e.backgroundImage = t.substring(17, t.length) : -1 < t.indexOf("border-color") ? e.borderColor = this.Uy(t.substring(13, t.length)) : -1 < t.indexOf("color") ? e.color = this.Uy(t.substring(6, t.length)) : -1 < t.indexOf("font-size") ? e.fontSize = parseInt(t.substring(10, t.length)) : -1 < t.indexOf("fill") ? e.fill = this.Uy(t.substring(5, t.length)) : -1 < t.indexOf("text-align") ? e.textAlign = t.substring(11, t.length) : -1 < t.indexOf("max-width") ? e.maxWidth = parseInt(t.substring(10, t.length)) : -1 < t.indexOf("max-height") ? e.maxHeight = parseInt(t.substring(11, t.length)) : -1 < t.indexOf("width") && (e.width = parseInt(t.substring(6, t.length)));
                }
              }, {
                key: "gy",
                value: function gy(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  var s = "";
                  null == e && (e = r.BQ);
                  for (var n = 0; n < e.length; n++) (null == i || null != i && t.ha(e[n]) != i.ha(e[n])) && (s += e[n] + ":" + t.ha(e[n]) + ";");
                  return s;
                }
              }, {
                key: "mg",
                value: function mg(t) {
                  var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  var a = new i.ia("div");
                  if (a.Y(t).Da(), void 0 === o) {
                    var o = new i.ia("div");
                    o.Da();
                  }
                  return null == s ? e.xb.tb.B.append(a).append(o) : s.append(a).append(o), t = r.gy(a, n, o), a.remove(), null != o && o.remove(), t;
                }
              }, {
                key: "lF",
                value: function lF(t) {
                  var e = [],
                    i = t.split("rgb");
                  for (2 < i.length && (t = i[2]), t = (t = t.replace(/[^\d,]/g, "")).split(","), i = 0; i < t.length; i++) e[i] = parseInt(t[i]);
                  return null == e[3] && (e[3] = 1), e;
                }
              }]);
              return r;
            }();
            r.BQ = "background-color background-image color font-family font-size font-weight text-align padding-top padding-left padding-right padding-bottom border border-top-width border-top-color border-top-style border-bottom-width border-bottom-color border-bottom-style border-left-width border-left-color border-left-style border-right-width border-right-color border-right-style".split(" "), t.Eb = r;
          }((s = e.N || (e.N = {})).C || (s.C = {}));
        }(r || (r = {}));
        var K = r || (r = {}),
          q = K.G || (K.G = {}),
          V = q.N || (q.N = {}),
          J = V.C || (V.C = {});
        var G = /*#__PURE__*/_createClass(function G() {
          _classCallCheck(this, G);
        });
        G.eB = "wdr-pivot-title", G.Hc = "wdr-cell", G.sA = "wdr-empty", G.zw = "wdr-sheet-header", G.Ve = "wdr-header", G.Cq = "wdr-header-c", G.ql = "wdr-header-r", G.DR = "wdr-measure-header", G.gj = "wdr-filter-header", G.it = "wdr-filter-icon", G.JA = "wdr-filtered", G.ht = "wdr-filtered-icon", G.vt = "wdr-total", G.gR = "wdr-grand-total", G.CH = "wdr-hierarchy-link", G.lw = "wdr-link", G.lT = "wdr-v-sort", G.oT = "wdr-v-sort-icon", G.mT = "wdr-v-sort-asc", G.nT = "wdr-v-sort-desc", G.nR = "wdr-h-sort", G.qR = "wdr-h-sort-icon", G.oR = "wdr-h-sort-asc", G.pR = "wdr-h-sort-desc", G.Ko = "wdr-sort-icon", G.WG = "wdr-expanded", G.XG = "wdr-expanded-icon", G.xG = "wdr-collapsed", G.yG = "wdr-collapsed-icon", G.We = "wdr-level-", G.JQ = "wdr-drilled-up", G.IQ = "wdr-drilled-down", G.OA = "wdr-icon", J.aa = G;
        var X = r || (r = {}),
          W = X.G || (X.G = {}),
          Y = W.N || (W.N = {}),
          Z = Y.C || (Y.C = {});
        var $ = /*#__PURE__*/_createClass(function $() {
          _classCallCheck(this, $);
        });
        $.vR = "left icon", $.xw = "right icon", $.OG = "drill", $.lw = "link", $.iG = "backgroud", Z.hj = $, function (t) {
          var e, i;
          e = t.G || (t.G = {}), function (i) {
            var s = /*#__PURE__*/function () {
              function s() {
                _classCallCheck(this, s);
                this.qB = this.rB = this.Fl = this.Gl = -1, this.pD = this.gA = this.scrollLeft = this.scrollTop = this.Kd = this.ye = this.Yb = this.Kb = this.Ar = this.Fk = this.eC = this.ix = 0, this.ep = 15e5, this.gp = this.fp = 1, this.kk = [], this.sk = [], this.nj = [], this.tk = [], this.Qq = [], this.hr = [], this.cC = s.VY(), this.ep = s.UY(), this.ix = s.EI, this.eC = s.DI, this.iq();
              }
              _createClass(s, [{
                key: "$b",
                get: function get() {
                  return this.gA + this.pD;
                }
              }, {
                key: "ur",
                value: function ur(t) {
                  this.kk.length > t && (this.kk.length = t), this.nj.length > t && (this.nj.length = t), this.Qq.length > t && (this.Qq.length = t), this.Gl = -1;
                }
              }, {
                key: "vr",
                value: function vr(t) {
                  this.sk.length > t && (this.sk.length = t), this.tk.length > t && (this.tk.length = t), this.hr.length > t && (this.hr.length = t), this.Fl = -1;
                }
              }, {
                key: "reset",
                value: function reset() {
                  this.kk.length = 0, this.sk.length = 0, this.nj.length = 0, this.tk.length = 0, this.Qq.length = 0, this.hr.length = 0, this.Fl = this.Gl = -1, this.pD = this.gA = this.scrollLeft = this.scrollTop = this.Kd = this.ye = this.Yb = this.Kb = this.Ar = this.Fk = 0, this.ix = s.EI, this.eC = s.DI, this.gp = this.fp = 1, this.qB = this.rB = -1, this.iq();
                }
              }, {
                key: "iq",
                value: function iq() {
                  var t = e.N.C.Eb.Qg(a.Wc().pg ? "wdr-grid-column-mobile" : "wdr-grid-column");
                  s.wo = isNaN(t.width) ? 100 : Math.max(s.Zs, t.width), isNaN(t.maxWidth) || (this.rB = Math.max(s.Zs, t.maxWidth)), t = e.N.C.Eb.Qg(a.Wc().pg ? "wdr-grid-row-mobile" : "wdr-grid-row"), s.vo = isNaN(t.height) ? 30 : Math.max(s.Ys, t.height), isNaN(t.maxHeight) || (this.qB = Math.max(s.Ys, t.maxHeight));
                }
              }, {
                key: "un",
                get: function get() {
                  return this.rB;
                }
              }, {
                key: "tn",
                get: function get() {
                  return this.qB;
                }
              }, {
                key: "U2",
                value: function U2() {
                  var t = this.ju(this.Yb, this.Yb + this.Ar);
                  this.gp = t > this.ep ? this.ep / t : 1, t = this.ku(this.Kb, this.Kb + this.Fk), this.fp = t > this.ep ? this.ep / t : 1;
                }
              }, {
                key: "resize",
                value: function resize(t, e) {
                  this.TB = t, this.SB = e;
                }
              }, {
                key: "Cs",
                get: function get() {
                  return this.Nn ? this.cC : 0;
                }
              }, {
                key: "Bs",
                get: function get() {
                  return this.Mn ? this.cC : 0;
                }
              }, {
                key: "EO",
                get: function get() {
                  return this.cC;
                }
              }, {
                key: "Yh",
                get: function get() {
                  return this.TB;
                }
              }, {
                key: "Nj",
                get: function get() {
                  return this.SB;
                }
              }, {
                key: "lp",
                get: function get() {
                  return this.SB - this.Bs - this.$b;
                }
              }, {
                key: "rn",
                get: function get() {
                  return this.TB - this.Cs;
                }
              }, {
                key: "Hd",
                get: function get() {
                  return this.TB - this.ci;
                }
              }, {
                key: "vd",
                get: function get() {
                  return this.SB - this.yi - this.$b;
                }
              }, {
                key: "Oe",
                get: function get() {
                  return this.Kb + this.Fk;
                }
              }, {
                key: "Xg",
                get: function get() {
                  return this.Yb + this.Ar;
                }
              }, {
                key: "Zb",
                value: function Zb(t) {
                  var e = isNaN(this.sk[t]) ? s.vo : this.sk[t];
                  return 0 < this.tn && !this.Lp(t) ? Math.min(this.tn, e) : e;
                }
              }, {
                key: "kq",
                value: function kq(t, e) {
                  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                  e = Math.max(e, s.Ys), i ? (isNaN(this.tk[t]) || e > this.tk[t]) && (this.tk[t] = e) : (this.sk[t] = e, this.Fl = -1), r && (this.hr[t] = !0);
                }
              }, {
                key: "g2",
                value: function g2(t) {
                  this.Lp(t) && (delete this.sk[t], delete this.tk[t], delete this.hr[t], this.Fl = -1);
                }
              }, {
                key: "sf",
                value: function sf(t) {
                  if (-1 == t) return this.Ej();
                  if (t >= this.Oe) return Math.max(100, s.wo);
                  var e = isNaN(this.kk[t]) ? s.wo : this.kk[t];
                  return 0 < this.un && !this.Gp(t) ? Math.min(this.un, e) : e;
                }
              }, {
                key: "vv",
                value: function vv(t, e) {
                  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                  e = Math.max(e, s.Zs), i ? (isNaN(this.nj[t]) || e > this.nj[t]) && (this.nj[t] = e) : (-1 == t ? this.ix = e : this.kk[t] = e, this.Gl = -1), r && (this.Qq[t] = !0);
                }
              }, {
                key: "e2",
                value: function e2(t) {
                  this.Gp(t) && (delete this.kk[t], delete this.nj[t], delete this.Qq[t], this.Gl = -1);
                }
              }, {
                key: "Gp",
                value: function Gp(t) {
                  return !0 === this.Qq[t];
                }
              }, {
                key: "Lp",
                value: function Lp(t) {
                  return !0 === this.hr[t];
                }
              }, {
                key: "ux",
                value: function ux() {
                  for (var t = 0; t < this.tk.length; t++) if (!this.Lp(t)) {
                    var e = this.tk[t];
                    !isNaN(e) && e > this.Zb(t) && this.kq(t, e);
                  }
                  for (this.tk.length = 0, t = -1; t < this.nj.length; t++) this.Gp(t) || (e = this.nj[t], !isNaN(e) && e > this.sf(t) && this.vv(t, e));
                  this.nj.length = 0;
                }
              }, {
                key: "Ey",
                value: function Ey(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  var i = t / this.am * (this.Nj / this.gp - this.Nj) * this.gp;
                  if (1 != this.gp && t + i >= this.am - this.Nj) {
                    for (e = this.Xg, i = this.am; i > t;) i -= this.Zb(e), e--;
                    return e + 1;
                  }
                  e = e ? 0 : this.Yb;
                  for (var _s70 = 0; _s70 < t + i;) _s70 += this.Zb(e) * this.gp, e++;
                  return e;
                }
              }, {
                key: "oy",
                value: function oy(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  var i = t / this.bm * (this.Yh / this.fp - this.Yh) * this.fp;
                  if (1 != this.fp && t + i >= this.bm - this.Yh) {
                    for (e = this.Oe, i = this.bm; i > t;) i -= this.sf(e), e--;
                    return e + 1;
                  }
                  e = e ? 0 : this.Kb;
                  for (var _s71 = 0; _s71 < t + i;) _s71 += this.sf(e) * this.fp, e++;
                  return e;
                }
              }, {
                key: "RM",
                value: function RM(t) {
                  for (var e = 0, i = 0, _s72 = this.vd; i < _s72;) i += this.Zb(t + e), e++;
                  return e;
                }
              }, {
                key: "QM",
                value: function QM(t) {
                  for (var e = 0, i = 0, _s73 = this.Hd; i < _s73;) i += this.sf(t + e), e++;
                  return e;
                }
              }, {
                key: "bm",
                get: function get() {
                  return 0 <= this.Gl ? this.Gl : this.Gl = 1 > this.fp ? this.ep : this.ku(this.Kb, this.Kb + this.Fk);
                }
              }, {
                key: "ku",
                value: function ku(t, e) {
                  if (t >= e) return 0;
                  var i,
                    r = 0,
                    n = 0;
                  for (i in this.kk) {
                    var a = parseInt(i);
                    !isNaN(a) && !isNaN(this.kk[a]) && a >= t && a < e && (n++, r += this.sf(a));
                  }
                  return r += (Math.min(e, this.Oe) - t - n) * (0 < this.un ? Math.min(this.un, s.wo) : s.wo), e >= this.Oe && (r += (e - this.Oe) * this.sf(e)), r;
                }
              }, {
                key: "am",
                get: function get() {
                  return 0 <= this.Fl ? this.Fl : this.Fl = 1 > this.gp ? this.ep : this.ju(this.Yb, this.Yb + this.Ar);
                }
              }, {
                key: "ju",
                value: function ju(t, e) {
                  if (t >= e) return 0;
                  var i,
                    r = 0,
                    n = 0;
                  for (i in this.sk) {
                    var a = parseInt(i);
                    !isNaN(a) && !isNaN(this.sk[a]) && a >= t && a < e && (n++, r += this.Zb(a));
                  }
                  return r + (e - t - n) * (0 < this.tn ? Math.min(this.tn, s.vo) : s.vo);
                }
              }, {
                key: "KK",
                value: function KK() {
                  this.Gl = this.Fl = -1;
                }
              }, {
                key: "r_",
                get: function get() {
                  for (var t = 0, e = this.Kb + this.Fk, i = this.Kb; i < e; i++) if ((t += this.sf(i)) > s.ZH) return s.ZH;
                  return t;
                }
              }, {
                key: "ci",
                get: function get() {
                  for (var t = this.Ej(), e = 0; e < this.Kb; e++) t += this.sf(e);
                  return t;
                }
              }, {
                key: "yi",
                get: function get() {
                  for (var t = this.Mk(), e = 0; e < this.Yb; e++) t += this.Zb(e);
                  return t;
                }
              }, {
                key: "Ej",
                value: function Ej() {
                  return t.model.A.P.Re ? this.ix : 0;
                }
              }, {
                key: "Mk",
                value: function Mk() {
                  return t.model.A.P.Re ? this.eC : 0;
                }
              }, {
                key: "iY",
                value: function iY() {
                  for (var t = [], e = this.Kb; e < this.Fk && (this.yZ(e) || (t.push(e), !(50 <= t.length))); e++);
                  return t;
                }
              }, {
                key: "yZ",
                value: function yZ(t) {
                  return !isNaN(this.kk[t]) || !isNaN(this.nj[t]);
                }
              }, {
                key: "Mn",
                get: function get() {
                  return this.bm + (this.am > this.vd ? this.EO : 0) > this.Hd;
                }
              }, {
                key: "Nn",
                get: function get() {
                  return this.am + (this.bm > this.Hd ? this.EO : 0) > this.vd;
                }
              }, {
                key: "om",
                value: function om(e) {
                  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  return (t.model.A.P.Re && i ? this.Mk() : 0) + this.ju(i ? 0 : this.Yb, e);
                }
              }, {
                key: "In",
                value: function In(e) {
                  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  return (t.model.A.P.Re && i ? this.Ej() : 0) + this.ku(i ? 0 : this.Kb, e);
                }
              }, {
                key: "Sl",
                get: function get() {
                  return !a.Wc().fE && !a.Wc().rm && 500 > this.Oe * this.Xg;
                }
              }, {
                key: "AV",
                get: function get() {
                  return !a.Wc().fE && !a.Wc().rm && (this.Nn || this.Mn) && 1e5 > this.Oe * this.Xg;
                }
              }, {
                key: "AD",
                value: function AD() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  return this.Sl ? this.Yb : t ? Math.max(this.Yb, this.ye - s.wI) : Math.max(this.Yb, this.ye);
                }
              }, {
                key: "zD",
                value: function zD() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  return this.Sl ? this.Kb : t ? Math.max(this.Kb, this.Kd - s.zG) : Math.max(this.Kb, this.Kd);
                }
              }, {
                key: "ly",
                value: function ly() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  var e = this.RM(this.ye);
                  return this.Sl ? this.Nn ? this.Xg : this.ye + e : t ? Math.min(this.ye + e + (this.Nn ? s.wI : 0), this.Nn ? this.Xg : Number.MAX_VALUE) : this.ye + e;
                }
              }, {
                key: "my",
                value: function my() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  var e = this.QM(this.Kd);
                  return this.Sl ? this.Mn ? this.Oe : this.Kd + e : t ? Math.min(this.Kd + e + (this.Mn ? s.zG : 0), this.Mn ? this.Oe : Number.MAX_VALUE) : this.Kd + e;
                }
              }, {
                key: "Jp",
                value: function Jp() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NaN;
                  return isNaN(t) && (t = this.my()), 0 < this.scrollLeft && t >= this.Oe;
                }
              }, {
                key: "Kp",
                value: function Kp() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NaN;
                  return isNaN(t) && (t = this.ly()), 0 < this.scrollTop && t >= this.Xg;
                }
              }, {
                key: "ny",
                value: function ny() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NaN;
                  return isNaN(t) && (t = this.Kd), this.Jp() ? this.bm - this.scrollLeft - this.ku(t, this.Oe) : 0;
                }
              }, {
                key: "Dy",
                value: function Dy() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NaN;
                  return isNaN(t) && (t = this.ye), this.Kp() ? this.am - this.scrollTop - this.ju(t, this.Xg) : 0;
                }
              }, {
                key: "IM",
                value: function IM(e, i) {
                  if (e < this.$b) return NaN;
                  if (t.model.A.P.Re && e < this.$b + this.Mk()) return -1;
                  var _s74 = 0,
                    r = this.$b + this.Mk();
                  for (e > this.yi && (_s74 = this.ye, r = this.$b + this.yi, i && _s74 > this.Yb ? 0 < (i = this.scrollTop - this.om(_s74 - 1)) && (r -= i, _s74--) : i || (e -= this.Dy())); r < e;) r += this.Zb(_s74), _s74++;
                  return _s74 - 1;
                }
              }, {
                key: "hM",
                value: function hM(e, i) {
                  if (t.model.A.P.Re && e < this.Ej()) return -1;
                  var _s75 = 0,
                    r = this.Ej();
                  for (e > this.ci && (_s75 = this.Kd, r = this.ci, i && _s75 > this.Kb ? 0 < (i = this.scrollLeft - this.In(_s75 - 1)) && (r -= i, _s75--) : i || (e -= this.ny())); r < e;) r += this.sf(_s75), _s75++;
                  return _s75 - 1;
                }
              }, {
                key: "Lk",
                value: function Lk(t, e) {
                  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
                  var _s76 = 0,
                    r = (i ? this.$b : 0) + this.Mk();
                  return t > this.Yb && (_s76 = this.ye, r = (i ? this.$b : 0) + this.yi, _s76 <= t && (r += e ? this.om(this.ye) - this.scrollTop : this.Dy())), r + this.ju(_s76, t);
                }
              }, {
                key: "Oi",
                value: function Oi(t, e) {
                  var i = 0,
                    _s77 = this.Ej();
                  return t > this.Kb && (i = this.Kd, _s77 = this.ci, i <= t && (_s77 += e ? this.In(this.Kd) - this.scrollLeft : this.ny())), _s77 + this.ku(i, t);
                }
              }, {
                key: "RZ",
                value: function RZ(t) {
                  return isNaN(this.sk[t]);
                }
              }, {
                key: "zX",
                get: function get() {
                  return this.scrollLeft + this.Hd - this.bm - this.Cs;
                }
              }, {
                key: "AX",
                get: function get() {
                  return this.scrollTop + this.vd - this.am - this.Bs;
                }
              }], [{
                key: "VY",
                value: function VY() {
                  return a.Wc().pg || a.Dg.qm ? 0 : a.Wc().fE ? 12 : 17;
                }
              }, {
                key: "UY",
                value: function UY() {
                  return a.Fr().Yu || a.Fr().av ? 1e7 : 15e5;
                }
              }]);
              return s;
            }();
            s.wI = 5, s.zG = 5, s.wo = 100, s.vo = 30, s.Zs = 50, s.Ys = 30, s.DI = 25, s.EI = 25, s.ZH = 200, i.dk = s;
          }((i = e.N || (e.N = {})).sheet || (i.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, s;
          e = t.G || (t.G = {}), function (e) {
            var r = /*#__PURE__*/function (_i$ia) {
              _inherits(r, _i$ia);
              var _super76 = _createSuper(r);
              function r(t, e) {
                var _this113;
                _classCallCheck(this, r);
                _this113 = _super76.call(this, "div"), _this113.Xw = !1, _this113.cell = new st(), _this113.J = t, _this113.Oh = e, _this113.element.addEventListener("click", function (t) {
                  return _this113.uz(t);
                });
                return _this113;
              }
              _createClass(r, [{
                key: "Rl",
                value: function Rl() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  for (var e = !1, i = this.element.children, s = 0; s < i.length; s++) {
                    var _r71 = i.item(s);
                    e = this.$F(_r71, !0) || e, _r71 = _r71.children;
                    for (var n = 0; n < _r71.length; n++) e = this.jA(_r71.item(n), t) || e;
                  }
                  this.Xw = e;
                }
              }, {
                key: "Pk",
                get: function get() {
                  return this.Xw;
                }
              }, {
                key: "$F",
                value: function $F(t) {
                  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  if (null != this.J) {
                    var s = !1,
                      _r72 = parseInt(t.getAttribute("data-r"));
                    return !isNaN(_r72) && !this.J.Lp(_r72) && (t = t.clientHeight, this.J.Zb(_r72) < t ? (this.J.kq(_r72, Math.round(t + 1), i), s = !0) : t <= e.dk.vo && this.J.kq(_r72, e.dk.vo, i), s);
                  }
                }
              }, {
                key: "jA",
                value: function jA(t) {
                  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  if (null != this.J) {
                    var _r73 = !1,
                      n = parseInt(t.getAttribute("data-c"));
                    return !(isNaN(n) || t.classList.contains(s.C.aa.zw) && 0 <= n || this.J.Gp(n)) && (t = t.clientWidth, this.J.sf(n) < t ? (this.J.vv(n, Math.round(t + 2), i), _r73 = !0) : -1 != n && t <= e.dk.wo && this.J.vv(n, e.dk.wo, i), _r73);
                  }
                }
              }, {
                key: "uj",
                value: function uj(e, i) {
                  var _r74 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  var n = this.Oh ? this.Oh(e, i) : null;
                  this.cell.clear(), this.cell.tag = "div", this.cell.Y(s.C.aa.Hc);
                  var a = e >= this.J.Xg || i >= this.J.Oe;
                  if (!n && a && this.cell.Y(s.C.aa.sA), n && n.Be && (this.cell.Y(s.C.aa.Ve), this.cell.Y(s.C.aa.ql), this.cell.Y(s.C.aa.We + n.level)), n && n.Ae && (this.cell.Y(s.C.aa.Ve), this.cell.Y(s.C.aa.Cq)), n && n.kE && this.cell.Y(s.C.aa.DR), n && n.Ri && this.cell.Y(s.C.aa.vt), n && n.iN && this.cell.Y(s.C.aa.gR), n && n.Ki && (this.cell.Y(s.C.aa.WG), this.cell.text += this.th(s.C.aa.XG, t.model.v.g.VS)), n && n.collapsed && (this.cell.Y(s.C.aa.xG), this.cell.text += this.th(s.C.aa.yG, t.model.v.g.YS)), this.cell.text += n ? n.label : "", n && (n.gm || n.zn) && (this.cell.text += '<span class="' + s.C.aa.CH + '" title="' + (n.gm ? t.model.v.g.WS : t.model.v.g.XS) + '">' + n.wY() + "</span>", n.gm && this.cell.Y(s.C.aa.JQ), n.zn && this.cell.Y(s.C.aa.IQ)), n && n.Ae && (n.mo && !n.Db && (this.cell.text = n.di ? this.cell.text + this.th([s.C.aa.Ko, s.C.aa.mT], t.model.v.g.QI) : n.ei ? this.cell.text + this.th([s.C.aa.Ko, s.C.aa.nT], t.model.v.g.RI) : this.cell.text + this.th([s.C.aa.Ko, s.C.aa.oT], t.model.v.g.SI)), n.Db && this.cell.Y(s.C.aa.sA), n.Db || this.cell.Y(s.C.aa.lT)), n && n.Be && (n.mo && !n.Db && (this.cell.text = n.di ? this.cell.text + this.th([s.C.aa.Ko, s.C.aa.oR], t.model.v.g.QI) : n.ei ? this.cell.text + this.th([s.C.aa.Ko, s.C.aa.pR], t.model.v.g.RI) : this.cell.text + this.th([s.C.aa.Ko, s.C.aa.qR], t.model.v.g.SI)), this.cell.Y(s.C.aa.nR)), this.cell.ja["data-c"] = i, this.cell.ja["data-r"] = e, this.cell.ja["data-n"] = 0 == e % 2 ? "even" : "odd", 0 != i || t.model.A.P.Re || (this.cell.style.height = this.J.Zb(e) + "px"), n && n.style) {
                    for (var o = 0; o < n.style.fA.length; o++) this.cell.Y(n.style.fA[o]);
                    for (var h in o = n.style.ha) this.cell.style[h] = o[h];
                  }
                  return this.LO(this.cell, e, i, n && n.yh), _r74 && (this.cell.style.top = this.J.om(e, e < this.J.Yb) + "px", this.cell.style.left = this.J.In(i, i < this.J.Kb) + "px"), null == s.C.ad.tp || a || (null == n && ((n = new s.C.ad()).fb = e, n.ue = i), s.C.ad.tp(this.cell.node, n.Sa())), this.cell;
                }
              }, {
                key: "vZ",
                value: function vZ(t, e) {
                  return !this.Oh || (t = this.Oh(t, e), a.U(t) || a.Vb(t.label));
                }
              }, {
                key: "LO",
                value: function LO(t, e, i) {
                  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                  this.J.Gp(i) || this.J.Lp(e) ? (t.style.width = this.J.sf(i) + "px", t.style.height = this.J.Zb(e) + "px") : (t.style["min-width"] = this.J.sf(i) + "px", t.style[s ? "height" : "min-height"] = this.J.Zb(e) + "px"), !this.J.Gp(i) && 0 < this.J.un && (t.style["max-width"] = this.J.un + "px"), !this.J.Lp(e) && 0 < this.J.tn && (t.style["max-height"] = this.J.tn + "px");
                }
              }, {
                key: "th",
                value: function th(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  return Array.isArray(t) && (t = t.join(" ")), t = '<i class="' + s.C.aa.OA + " " + t + '"', e && (t += 'title="' + e + '"'), t + "></i>";
                }
              }, {
                key: "JW",
                value: function JW() {
                  return this.cell.clear(), this.cell.tag = "div", this.cell.Y(s.C.aa.Hc), this.cell.Y(s.C.aa.zw), this.cell.style.width = this.J.Ej() + "px", this.cell.style.height = this.J.Mk() + "px", this.cell;
                }
              }, {
                key: "ZK",
                value: function ZK(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  return this.cell.clear(), this.cell.tag = "div", this.cell.Y(s.C.aa.Hc), this.cell.Y(s.C.aa.zw), this.cell.text += t + 1, this.cell.style.width = this.J.sf(t) + "px", 0 < this.J.un && !this.J.Gp(t) && (this.cell.style["max-width"] = this.J.un + "px"), this.cell.style.height = this.J.Mk() + "px", this.cell.ja["data-r"] = -1, this.cell.ja["data-c"] = t, e && (this.cell.style.left = this.J.In(t, !1) + "px"), this.cell;
                }
              }, {
                key: "ru",
                value: function ru(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  return this.cell.clear(), this.cell.tag = "div", this.cell.Y(s.C.aa.Hc), this.cell.Y(s.C.aa.zw), this.cell.text += t + 1, this.cell.style["min-width"] = this.J.Ej() + "px", this.cell.style.height = this.J.Zb(t) + "px", this.cell.style["line-height"] = this.J.Zb(t) - 2 + "px", 0 < this.J.tn && !this.J.Lp(t) && (this.cell.style["max-height"] = this.J.tn + "px"), this.cell.ja["data-r"] = t, this.cell.ja["data-c"] = -1, e && (this.cell.style.top = this.J.om(t, !1) + "px"), this.cell;
                }
              }, {
                key: "Iu",
                value: function Iu(t, e) {
                  t = this.J.oy(t) - 1, e = this.J.Ey(e) - 1;
                  var i = null;
                  return null != this.Oh && (i = this.Oh(e, t)), null == i && ((i = new s.C.ad()).fb = e, i.ue = t), i;
                }
              }, {
                key: "Hu",
                value: function Hu(t) {
                  for (; !t.Pc(s.C.aa.Hc);) if (null == (t = t.parent)) return null;
                  var e = parseInt(t.ja("data-c"));
                  t = parseInt(t.ja("data-r"));
                  var i = null;
                  return null != this.Oh && (i = this.Oh(t, e)), null == i && ((i = new s.C.ad()).fb = t, i.ue = e), i;
                }
              }, {
                key: "uz",
                value: function uz(t) {
                  var e = i.ia.Ga(t.target),
                    _r75 = this.Hu(e) || this.Iu(t.offsetX, t.offsetY);
                  switch (t.type) {
                    case "click":
                      var n = new s.MA(_r75, e);
                  }
                  n && this.na(n);
                }
              }, {
                key: "la",
                value: function la() {
                  _get(_getPrototypeOf(r.prototype), "la", this).call(this), this.J = this.Oh = null;
                }
              }]);
              return r;
            }(i.ia);
            e.Rv = r;
          }((s = e.N || (e.N = {})).sheet || (s.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, s;
          e = t.G || (t.G = {}), function (t) {
            var e = /*#__PURE__*/function (_t$Rv) {
              _inherits(e, _t$Rv);
              var _super77 = _createSuper(e);
              function e(_e87, i) {
                var _this114;
                _classCallCheck(this, e);
                _this114 = _super77.call(this, _e87, i), _this114.Zw = !1, _this114.Y("wdr-sheet-canvas"), _this114.Ll = new tt(), _this114.R(_this114.Ll), _this114.mh = new t.Ws(), _this114.od = new t.Ws();
                return _this114;
              }
              _createClass(e, [{
                key: "Ha",
                value: function Ha() {}
              }, {
                key: "xn",
                value: function xn() {}
              }, {
                key: "jb",
                get: function get() {
                  return this.Zw;
                },
                set: function set(t) {
                  this.Zw != t && (this.Zw = t, this.Oa(this.jb ? e.VG : e.FA));
                }
              }, {
                key: "vP",
                value: function vP() {
                  0 != this.jb && (this.mh.reset(), this.od.reset(), this.Ha());
                }
              }, {
                key: "tr",
                value: function tr() {
                  this.mh.reset();
                }
              }, {
                key: "xx",
                value: function xx() {
                  this.od.reset();
                }
              }, {
                key: "Ul",
                value: function Ul() {
                  this.tr(), this.xx();
                }
              }, {
                key: "Rl",
                value: function Rl() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  for (var _e88 = !1, i = this.Ll.content.element.children, s = 0; s < i.length; s++) {
                    var r = i.item(s);
                    _e88 = this.$F(r, t) || _e88, r = r.children;
                    for (var n = 0; n < r.length; n++) {
                      var a = r.item(n);
                      _e88 = this.jA(a, t) || _e88;
                    }
                  }
                  this.Xw = _e88;
                }
              }, {
                key: "xC",
                value: function xC() {
                  for (var t = !1, _e89 = this.Ma.placeholder.element.children, i = 0; i < _e89.length; i++) {
                    var s = _e89.item(i);
                    t = this.jA(s, !0) || t, t = this.$F(s, !0) || t;
                  }
                  this.Xw = t;
                }
              }, {
                key: "Ds",
                value: function Ds() {
                  this.Ll.content.width = this.lC - this.J.Cs, this.Ll.content.height = this.$q - this.J.Bs;
                }
              }, {
                key: "Ma",
                get: function get() {
                  return this.Ll;
                }
              }, {
                key: "width",
                get: function get() {
                  return this.lC;
                },
                set: function set(t) {
                  this.lC != t && (this.element.style.minWidth = t + "px", this.lC = t, this.Ll.width = t);
                }
              }, {
                key: "height",
                get: function get() {
                  return this.$q;
                },
                set: function set(t) {
                  this.$q != t && (this.element.style.height = t + "px", this.$q = t, this.Ll.height = t);
                }
              }, {
                key: "uz",
                value: function uz(t) {
                  var _e90 = null;
                  if (t.target == this.Ma.placeholder.element) var r = this.Iu(t.offsetX, t.offsetY);else _e90 = i.ia.Ga(t.target), r = this.Hu(_e90) || this.Iu(t.offsetX, t.offsetY);
                  if (null != r && null != _e90) {
                    var n = s.C.hj.iG;
                    _e90.Pc(s.C.aa.CH) ? n = s.C.hj.OG : _e90.Pc(s.C.aa.XG) || _e90.Pc(s.C.aa.yG) ? n = s.C.hj.vR : _e90.Pc(s.C.aa.Ko) ? n = s.C.hj.xw : _e90.Pc(s.C.aa.lw) && (n = s.C.hj.lw), r.lr = n;
                  }
                  switch (t.type) {
                    case "click":
                      var a = new s.MA(r, _e90);
                      break;
                    case "mousedown":
                      a = new s.jR(r);
                      break;
                    case "mouseup":
                      a = new s.lR(r);
                      break;
                    case "mousemove":
                      a = new s.kR(r);
                  }
                  a && this.na(a);
                }
              }]);
              return e;
            }(t.Rv);
            e.VG = "switched_to_smooth", e.FA = "switched_to_simple", t.uq = e;
          }((s = e.N || (e.N = {})).sheet || (s.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.G || (t.G = {}), function (t) {
            var e = /*#__PURE__*/function () {
              function e() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var _e91 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                _classCallCheck(this, e);
                this.left = t, this.top = _e91, this.right = i, this.bottom = s;
              }
              _createClass(e, [{
                key: "set",
                value: function set(t) {
                  this.left = t.left, this.top = t.top, this.right = t.right, this.bottom = t.bottom;
                }
              }, {
                key: "reset",
                value: function reset() {
                  this.bottom = this.right = this.top = this.left = 0;
                }
              }, {
                key: "contains",
                value: function contains(t) {
                  return this.left <= t.left && this.top <= t.top && this.right >= t.right && this.bottom >= t.bottom;
                }
              }, {
                key: "clone",
                value: function clone() {
                  return new e(this.left, this.top, this.right, this.bottom);
                }
              }]);
              return e;
            }();
            t.Ws = e;
          }((i = e.N || (e.N = {})).sheet || (i.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, s;
          e = t.G || (t.G = {}), function (e) {
            var s = /*#__PURE__*/function (_i$ia2) {
              _inherits(s, _i$ia2);
              var _super78 = _createSuper(s);
              function s() {
                var _this115;
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                _classCallCheck(this, s);
                _this115 = _super78.call(this, "div", "wdr-auto-calculation-bar"), _this115.VB = ["average", "count", "sum"], _this115.qx = {}, _this115.Ow = {
                  right: -1e3,
                  bottom: 1e3
                }, _this115.DT = new a.ma(), _this115.VB = null == t ? _this115.VB : t, _this115.nZ(), _this115.Bd();
                return _this115;
              }
              _createClass(s, [{
                key: "nZ",
                value: function nZ() {
                  this.qx.average = t.model.v.g.eG, this.qx.sum = t.model.v.g.II, this.qx.count = t.model.v.g.CG;
                }
              }, {
                key: "Qh",
                get: function get() {
                  return this.DT;
                }
              }, {
                key: "Bd",
                value: function Bd() {
                  this.bC = new i.ia("div"), this.bC.ha("position", "relative"), this.R(this.oO), this.BT = new i.ia("div", "wdr-auto-calculation-bar-conainer"), this.Pl.ha("position", "absolute"), this.bC.R(this.Pl);
                  for (var t, e = 0; e < this.Un.length; e++) (t = new r()).D2(this.qx[this.Un[e]]), this.Pl.R(t), this.Qh.Ea(this.Un[e], t);
                }
              }, {
                key: "zZ",
                value: function zZ() {
                  return -1e3 != this.Ow.right && 1e3 != this.Ow.bottom;
                }
              }, {
                key: "a3",
                value: function a3(t, e) {
                  this.Qh.getItem(t).E2(e);
                }
              }, {
                key: "iZ",
                value: function iZ(t) {
                  this.Qh.getItem(t).Da();
                }
              }, {
                key: "Pl",
                get: function get() {
                  return this.BT;
                }
              }, {
                key: "oO",
                get: function get() {
                  return this.bC;
                }
              }, {
                key: "g_",
                value: function g_() {
                  for (var t, e = 0; e < this.Qh.length; e++) (t = this.Qh.F(e)).visible || t.show();
                }
              }, {
                key: "pZ",
                value: function pZ() {
                  for (var t = 0; t < this.Qh.length; t++) if (this.Qh.F(t).visible) return !1;
                  return !0;
                }
              }, {
                key: "Hf",
                get: function get() {
                  return this.Ow;
                }
              }, {
                key: "Un",
                get: function get() {
                  return this.VB;
                }
              }, {
                key: "f2",
                value: function f2() {
                  this.Ow = {
                    right: -1e3,
                    bottom: 1e3
                  };
                }
              }, {
                key: "clear",
                value: function clear() {
                  for (; 0 < this.Qh.length;) this.Qh.F(0).la(), this.Qh.vF();
                  this.la();
                }
              }]);
              return s;
            }(i.ia);
            e.XP = s;
            var r = /*#__PURE__*/function (_i$ia3) {
              _inherits(r, _i$ia3);
              var _super79 = _createSuper(r);
              function r() {
                var _this116;
                _classCallCheck(this, r);
                _this116 = _super79.call(this, "div", "wdr-auto-calculation-bar-content"), _this116.display = "inline-block", _this116.Bd();
                return _this116;
              }
              _createClass(r, [{
                key: "Bd",
                value: function Bd() {
                  this.uK = new i.ia("div", "wdr-auto-calculation-bar-content-text"), this.R(this.uK), this.vK = new i.ia("div", "wdr-auto-calculation-bar-content-results"), this.R(this.vK);
                }
              }, {
                key: "show",
                value: function show() {
                  this.element.style.display = this.display;
                }
              }, {
                key: "D2",
                value: function D2(t) {
                  this.uK.text(t + ":");
                }
              }, {
                key: "E2",
                value: function E2(t) {
                  this.vK.text(t);
                }
              }]);
              return r;
            }(i.ia);
            e.l4 = r;
          }((s = e.N || (e.N = {})).sheet || (s.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.G || (t.G = {}), ((i = e.N || (e.N = {})).sheet || (i.sheet = {})).YP = /*#__PURE__*/function () {
            function _class23() {
              _classCallCheck(this, _class23);
              this.sJ = null;
            }
            _createClass(_class23, [{
              key: "U1",
              value: function U1(e, i) {
                this.wh = this.wX(i);
                var s = null == this.wh ? t.model.format.Bg.Ne("").clone() : this.wh.Ne().clone();
                s.Og = s.Og == t.model.format.Bg.FD().Og ? 2 : s.Og;
                for (var r = 0; r < e.Un.length; r++) {
                  var n = this.uV(e.Un[r], i);
                  0 != n ? e.a3(e.Un[r], this.CY(n, e.Un[r], s.clone())) : e.iZ(e.Un[r]);
                }
                this.wh = null;
              }
            }, {
              key: "CY",
              value: function CY(e, i, s) {
                var r = "count" == i || null != this.wh && t.u.i.ca.Qn(this.wh.Fa),
                  n = "count" != i && null != this.wh && t.u.i.ca.Wh(this.wh.Fa),
                  o = null != this.wh && this.wh.type == t.u.types.Ca.td && t.u.i.ca.c4(this.wh.Fa);
                return s.Wh = "count" != i && s.Wh, s.fd = null != this.wh && this.wh.Fa == t.u.i.ca.rl ? "" : s.fd, o && !isNaN(e) && "count" != i ? a.$.Kv(e) : a.Fd.format(e, s, r, n);
              }
            }, {
              key: "uV",
              value: function uV(t, e) {
                switch (t) {
                  case "sum":
                    return this.xV(e);
                  case "average":
                    return this.vV(e);
                  case "count":
                    return this.wV(e);
                }
                return 0;
              }
            }, {
              key: "xV",
              value: function xV(t) {
                for (var e = 0, i = 0; i < t.length; i++) e += t[i].yh && !isNaN(t[i].value) && this.fz(t[i]) ? t[i].value : 0;
                return e;
              }
            }, {
              key: "vV",
              value: function vV(t) {
                for (var e = 0, i = 0, s = 0; s < t.length; s++) t[s].yh && !isNaN(t[s].value) && this.fz(t[s]) && (e += t[s].value, i++);
                return 0 == i ? 0 : e / i;
              }
            }, {
              key: "wV",
              value: function wV(t) {
                for (var e = 0, i = 0; i < t.length; i++) (t[i].yh && !isNaN(t[i].value) || t[i].Qk && "" != t[i].label) && e++;
                return e;
              }
            }, {
              key: "wX",
              value: function wX(t) {
                for (var e = null, i = 0; i < t.length; i++) if (this.fz(t[i]) && null == e && !a.U(t[i].measure)) e = t[i].measure;else if (this.fz(t[i]) && null != e && e.j != t[i].measure.j) {
                  e = null;
                  break;
                }
                return e;
              }
            }, {
              key: "fz",
              value: function fz(e) {
                return e.yh && null != e.measure && (null == e.ke || t.u.types.Ca.Hb != e.measure.type) && t.u.types.Ca.jc != e.measure.type && t.u.types.Ca.ce != e.measure.type || !isNaN(e.value);
              }
            }, {
              key: "wh",
              get: function get() {
                return this.sJ;
              },
              set: function set(t) {
                this.sJ = t;
              }
            }]);
            return _class23;
          }();
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.G || (t.G = {}), ((i = e.N || (e.N = {})).sheet || (i.sheet = {})).OS = /*#__PURE__*/function () {
            function _class24(t) {
              _classCallCheck(this, _class24);
              this.zp = [], this.data = [], this.coords = t;
            }
            _createClass(_class24, [{
              key: "reset",
              value: function reset() {
                this.data = [], this.zp = [];
              }
            }, {
              key: "setData",
              value: function setData(t, e, i) {
                var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                i.fb = t, i.ue = e, (e < this.coords.Kb || s) && (null == this.data[t] && (this.data[t] = []), this.data[t][e] = i);
              }
            }, {
              key: "Wz",
              value: function Wz(t, e, i) {
                null == this.zp[t] && (this.zp[t] = []), this.zp[t][e] = i;
              }
            }, {
              key: "BV",
              value: function BV(t, e) {
                return void 0 === this.data[t] && (this.data[t] = []), void 0 !== this.data[t][e];
              }
            }, {
              key: "getData",
              value: function getData(t, e) {
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
                if (0 == this.BV(t, e)) {
                  var s = this.Ap(t, e);
                  if (null != s && (s.fb = t, s.ue = e), !i) return s;
                  this.data[t][e] = s;
                }
                if (null !== this.data[t][e]) return this.data[t][e];
              }
            }, {
              key: "tY",
              value: function tY(t, e) {
                return this.zp[t] && this.zp[t][e] ? this.zp[t][e] : null;
              }
            }, {
              key: "la",
              value: function la() {
                this.reset(), this.Ap = null;
              }
            }]);
            return _class24;
          }();
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.G || (t.G = {}), function (e) {
            e.NS = /*#__PURE__*/function () {
              function _class25(t) {
                var _this117 = this;
                _classCallCheck(this, _class25);
                this.jr = this.fn = null, this.De = new a.ma(), this.Xo = !1, this.Yt = {}, this.Et = {}, this.rD = function () {
                  _this117.Xo = !0;
                }, this.tC = function () {
                  _this117.Xo = !1;
                }, this.tN = function (t) {
                  return _this117.hv(t);
                }, this.X = t, this.X.element.setAttribute("tabindex", "0"), this.X.element.addEventListener("focus", this.rD), this.X.element.addEventListener("focusin", this.rD), this.X.element.addEventListener("blur", this.tC), this.X.element.addEventListener("focusout", this.tC), this.coords = this.X.coords, this.ug = new e.MS(this, this.X), this.B2 = new e.YP(), this.cv = a.uR.V(), this.cv.addEventListener(a.KeyboardEvent.RA, this.tN);
              }
              _createClass(_class25, [{
                key: "la",
                value: function la() {
                  this.X.element && this.X.element.removeEventListener("focus", this.rD), this.X.element && this.X.element.removeEventListener("blur", this.tC), null != this.De && 0 < this.De.length && this.CC(), this.cv.removeEventListener(a.KeyboardEvent.RA, this.tN), this.cv = this.X = null, this.ug.la();
                }
              }, {
                key: "Ha",
                value: function Ha() {
                  this.ug.vs();
                }
              }, {
                key: "hO",
                value: function hO(t, e) {
                  this.ug.hz ? this.p2(t, e) : this.DO(t, e), this.Ha();
                }
              }, {
                key: "iO",
                value: function iO(t, i) {
                  this.ug.Zy || (null == this.ug.Fh && (this.ug.Fh = new e.LI(this.X)), this.ug.Fh.Tl = t.toString() + "|" + i.toString(), this.Ha());
                }
              }, {
                key: "select",
                value: function select(t, e) {
                  this.dm(), this.fn = t, this.jr = e, this.hO(t, e);
                }
              }, {
                key: "p2",
                value: function p2(t, e) {
                  this.cN(t, e) && !this.De.rc(this.yr(t, e)) && (this.CC(), this.DO(t, e));
                }
              }, {
                key: "DO",
                value: function DO(t, i) {
                  if (null != this.ug.Fh && (this.ug.Fh.remove(), this.ug.Fh = null), !this.ug.Zy || this.cN(t, i)) if (this.De.rc(this.yr(t, i))) null != (s = this.De.getItem(this.yr(t, i))).Eh && delete this.Yt[t.y.toString()], null != s.qh && delete this.Et[t.x.toString()], s.remove(), this.De.removeItem(this.yr(t, i));else if (null != t && null != i) {
                    var s = new e.LI(this.X);
                    s.Tl = this.yr(t, i), this.De.Ea(s.Tl, s);
                  }
                }
              }, {
                key: "CC",
                value: function CC() {
                  for (; 0 < this.De.length;) this.De.F(0).remove(), this.De.vF();
                  this.Yt = {}, this.Et = {};
                }
              }, {
                key: "yr",
                value: function yr(t, e) {
                  return t.x.toString() + "|" + t.y.toString() + "|" + e.x.toString() + "|" + e.y.toString();
                }
              }, {
                key: "Cr",
                value: function Cr(e) {
                  var i = {};
                  return 4 == (e = e.split("|")).length ? (i.from = new t.G.N.sheet.kj(parseInt(e[0]), parseInt(e[1])), i.bl = new t.G.N.sheet.kj(parseInt(e[2]), parseInt(e[3]))) : 2 == e.length && (i.Xk = parseInt(e[0]), i.zk = parseInt(e[1])), i;
                }
              }, {
                key: "kN",
                value: function kN(t) {
                  return this.Yt.hasOwnProperty(t.y.toString()) && this.Et.hasOwnProperty(t.x.toString()) && this.Yt[t.y.toString()] == e.FG.Qv && this.Et[t.x.toString()] == e.FG.Qv;
                }
              }, {
                key: "cN",
                value: function cN(t, e) {
                  return !(null == t || null == e || !t.gD(e) || this.kN(t) || this.kN(e) || 0 > t.x * t.y || 0 > e.x * e.y);
                }
              }, {
                key: "Bm",
                value: function Bm() {
                  this.select(new i(0, 0), new i(this.coords.Fk + this.coords.Kb - 1, this.coords.Ar + this.coords.Yb - 1));
                }
              }, {
                key: "JO",
                value: function JO(t) {
                  if (!(null == this.fn || this.fn.gD(t) && this.De.rc(this.yr(this.fn, t)))) {
                    var e = this.fn;
                    this.dm(), this.fn = e, this.jr = t, this.hO(e, t);
                  }
                }
              }, {
                key: "A2",
                value: function A2(t) {
                  this.dm(), this.iO(t, -1);
                }
              }, {
                key: "y2",
                value: function y2(t) {
                  this.dm(), this.iO(-1, t);
                }
              }, {
                key: "dm",
                value: function dm() {
                  !this.ug.Zy && 0 < this.De.length && !this.ug.hz && this.CC(), null != this.ug.Fh && (this.ug.Fh.remove(), this.ug.Fh = null), this.jr = this.fn = null;
                }
              }, {
                key: "clear",
                value: function clear() {
                  this.dm(), this.Ha();
                }
              }, {
                key: "wZ",
                value: function wZ(t) {
                  return t.yh && !isNaN(t.value) || t.Qk && t.yh && "" != t.label;
                }
              }, {
                key: "kV",
                value: function kV(t) {
                  if (null == t) return !1;
                  var e = 0;
                  for (var _i41 = 0; _i41 < t.length; _i41++) if (this.wZ(t[_i41]) && e++, 2 <= e) return !0;
                  return !1;
                }
              }, {
                key: "aj",
                get: function get() {
                  return this.De;
                }
              }, {
                key: "bl",
                get: function get() {
                  return this.jr;
                },
                set: function set(t) {
                  this.jr = t;
                }
              }, {
                key: "from",
                get: function get() {
                  return this.jr;
                },
                set: function set(t) {
                  this.fn = t;
                }
              }, {
                key: "CX",
                value: function CX(t, e) {
                  return t && e ? Math.min(t.x, e.x) : -1;
                }
              }, {
                key: "I3",
                value: function I3(t, e) {
                  return t && e ? Math.max(t.x, e.x) : -1;
                }
              }, {
                key: "GX",
                value: function GX(t, e) {
                  return t && e ? Math.min(t.y, e.y) : -1;
                }
              }, {
                key: "M3",
                value: function M3(t, e) {
                  return t && e ? Math.max(t.y, e.y) : -1;
                }
              }, {
                key: "move",
                value: function move(t, e) {
                  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  switch (t) {
                    case 37:
                      this.x_(i);
                      break;
                    case 38:
                      this.z_(i);
                      break;
                    case 39:
                      this.y_(i);
                      break;
                    case 40:
                      this.v_(i);
                  }
                }
              }, {
                key: "CO",
                get: function get() {
                  return this.Yt;
                }
              }, {
                key: "RK",
                get: function get() {
                  return this.Et;
                }
              }, {
                key: "x_",
                value: function x_() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  this.ON(-1, t);
                }
              }, {
                key: "y_",
                value: function y_() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  this.ON(1, t);
                }
              }, {
                key: "z_",
                value: function z_() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  this.PN(-1, t);
                }
              }, {
                key: "v_",
                value: function v_() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  this.PN(1, t);
                }
              }, {
                key: "ON",
                value: function ON(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  if (1 == this.De.length) {
                    var s = this.Cr(this.De.F(0).Tl),
                      r = s.from,
                      n = s.bl;
                    s = e ? n.x : r.x;
                    var a = e ? n.x : r.x;
                    (s = this.xX(s + t, e ? n.y : r.y)) < this.coords.Kd ? (t = Math.max(s, this.coords.Kb), this.X.FO(t)) : s >= this.coords.QM(this.coords.Kd) + this.coords.Kd - 1 && (t = this.coords.Kd + (s - a), this.X.FO(t + 1)), t = e ? n.y : r.y, n = s, this.select(new i(e ? r.x : s, r.y), new i(n, t));
                  }
                }
              }, {
                key: "PN",
                value: function PN(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  if (1 == this.De.length) {
                    var s = this.Cr(this.De.F(0).Tl),
                      r = s.from,
                      n = s.bl;
                    s = e ? n.y : r.y;
                    var a = e ? n.y : r.y;
                    (s = this.yX(s + t, e ? n.x : r.x)) < this.coords.ye ? (t = Math.max(s, this.coords.Yb), this.X.GO(t)) : s >= this.coords.RM(this.coords.ye) + this.coords.ye - 1 && (t = this.coords.ye + (s - a), this.X.GO(t + 1)), t = s, n = e ? n.x : r.x, this.select(new i(r.x, e ? r.y : s), new i(n, t));
                  }
                }
              }, {
                key: "yX",
                value: function yX(t, e) {
                  return Math.max(e < this.coords.Kb ? this.coords.Yb : this.coords.Yb + 1, Math.min(t, this.coords.Xg - 1));
                }
              }, {
                key: "xX",
                value: function xX(t, e) {
                  return Math.max(e < this.coords.Yb ? this.coords.Kb : this.coords.Kb - 1, Math.min(t, this.coords.Oe - 1));
                }
              }, {
                key: "qV",
                get: function get() {
                  return this.B2;
                }
              }, {
                key: "hv",
                value: function hv(t) {
                  if (null != this.cv && this.Xo) {
                    var e = t.ctrlKey || t.metaKey;
                    switch (t.keyCode) {
                      case 32:
                        e || this.X.Q3(this.X.aj[0]);
                        break;
                      case 65:
                        e && this.Bm();
                        break;
                      case 37:
                      case 38:
                      case 39:
                      case 40:
                        this.move(t.keyCode, t.ctrlKey, t.shiftKey), t.D1.preventDefault();
                    }
                    !e || t.altKey || t.shiftKey || 67 !== t.keyCode || this.MC();
                  }
                }
              }, {
                key: "MC",
                value: function MC() {
                  var t = "";
                  if (0 < this.De.length) for (var e, i = 0; i < this.De.length; i++) null != (e = this.De.F(i)).Le && (e = this.Cr(e.Tl), t += this.pW(e.from, e.bl), i < this.De.length - 1 && (t += "\n"));
                  0 < t.length && this.cv.MC(t);
                }
              }, {
                key: "pW",
                value: function pW(t, e) {
                  var i = "";
                  if (null == t || null == e) return i;
                  var s = Math.min(t.x, e.x),
                    r = Math.max(t.x, e.x),
                    n = Math.max(t.y, e.y);
                  for (e = Math.min(t.y, e.y); e <= n; e++) {
                    for (var a = s; a <= r; a++) a > s && (i += "\t"), null == (t = this.X.Ld(e, a, !0)) && null == (t = e < this.coords.ye && a >= this.coords.Kd ? this.X.Ld(e, a - this.coords.Kd + this.coords.Kb, !0) : null) || (i += null == t ? "" : t.I());
                    e < n && (i += "\n");
                  }
                  return i;
                }
              }]);
              return _class25;
            }();
            var i = /*#__PURE__*/function () {
              function i() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                _classCallCheck(this, i);
                this.x = t, this.y = e;
              }
              _createClass(i, [{
                key: "gD",
                value: function gD(t) {
                  return t.x == this.x && t.y == this.y;
                }
              }]);
              return i;
            }();
            e.kj = i;
          }((i = e.N || (e.N = {})).sheet || (i.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, s;
          e = t.G || (t.G = {}), function (e) {
            e.MS = /*#__PURE__*/function () {
              function _class26(t, i) {
                var _this118 = this;
                _classCallCheck(this, _class26);
                this.VJ = this.Zy = !1, this.ri = this.QJ = null, this.AK = 5, this.x2 = 17, this.hz = !1, this.ls = function (t) {
                  return _this118.uz(t);
                }, this.MN = function (t) {
                  return _this118.$E(t);
                }, this.Xd = t, this.X = i, this.coords = this.X.coords, this.ri = new e.XP(), this.ri.Da(), this.X.R(this.ri), this.X.element.addEventListener("mousedown", this.ls), this.X.element.addEventListener("mouseup", this.ls);
              }
              _createClass(_class26, [{
                key: "po",
                get: function get() {
                  return this.VJ;
                },
                set: function set(t) {
                  this.VJ = t, this.po || (this.X.element.removeEventListener("mousemove", this.ls), document.removeEventListener("mousemove", this.MN));
                }
              }, {
                key: "Fh",
                get: function get() {
                  return this.QJ;
                },
                set: function set(t) {
                  this.QJ = t;
                }
              }, {
                key: "uz",
                value: function uz(t) {
                  if (1 == t.which || 3 == t.which) {
                    var e = i.ia.Ga(t.target);
                    if ("mousedown" != t.type || !(e.Pc(s.C.aa.gj) || e.Pc(s.C.aa.it) || e.Pc(s.C.aa.ht) || null != e.closest(".wdr-filters"))) {
                      var r = this.X.Dj();
                      if (e = t.clientX - r.left, r = t.clientY - r.top, !(e > this.coords.rn || r > this.coords.$b + this.coords.lp || (r = this.coords.IM(r, this.X.jb), e = this.coords.hM(e, this.X.jb), isNaN(r) || isNaN(e)))) switch (this.Zy = !a.Dg.qm && t.ctrlKey || a.Dg.qm && t.metaKey, this.hz = 3 == t.which, t.type) {
                        case "mousedown":
                          this.wm(r, e);
                          break;
                        case "mousemove":
                          this.xm(r, e);
                          break;
                        case "mouseup":
                          this.bi(r, e);
                      }
                    }
                  }
                }
              }, {
                key: "$E",
                value: function $E(t) {
                  var e = i.ia.Ga(this.X.element),
                    s = t.clientX;
                  t = t.clientY, (s < e.left || t < e.top || s > e.left + this.X.width || t > e.top + this.X.height) && this.B3();
                }
              }, {
                key: "select",
                value: function select(t, i, s, r) {
                  this.po = !1, this.Xd.select(new e.kj(i, t), new e.kj(r, s));
                }
              }, {
                key: "B3",
                value: function B3() {
                  this.po = !1;
                }
              }, {
                key: "wm",
                value: function wm(t, i) {
                  this.po = !0, this.Xd.select(new e.kj(i, t), new e.kj(i, t)), this.X.element.addEventListener("mousemove", this.ls), document.addEventListener("mousemove", this.MN);
                }
              }, {
                key: "bi",
                value: function bi(t, i) {
                  this.po && (this.po = !1, this.hz || (-1 == t ? this.Xd.y2(i) : -1 == i ? this.Xd.A2(t) : this.Xd.from && !this.Xd.from.gD(new e.kj(i, t)) && this.Xd.JO(new e.kj(i, t))));
                }
              }, {
                key: "xm",
                value: function xm(t, i) {
                  this.po && (!this.Xd.bl || this.Xd.bl.x == i && this.Xd.bl.y == t || this.Xd.JO(new e.kj(i, t)));
                }
              }, {
                key: "la",
                value: function la() {
                  this.X.element && this.X.element.removeEventListener("mousedown", this.ls), this.X.element && this.X.element.removeEventListener("mouseup", this.ls), this.ri.la(), this.coords = this.X = this.Xd = null, null != this.Fh && (this.Fh.remove(), this.Fh = null);
                }
              }, {
                key: "vs",
                value: function vs() {
                  this.ri.f2();
                  for (var t = 0; t < this.Xd.aj.length; t++) {
                    var e = this.Xd.aj.F(t),
                      i = this.Xd.Cr(this.Xd.aj.yd(t));
                    this.hU(e, i.from, i.bl);
                  }
                  this.iU(this.ri), this.WW(this.Fh);
                }
              }, {
                key: "WW",
                value: function WW(t) {
                  if (null != t) {
                    t.Da();
                    var e = this.Xd.Cr(t.Tl);
                    -1 != e.Xk && this.bX(e.Xk, t), -1 != e.zk && this.aX(e.zk, t);
                  }
                }
              }, {
                key: "iU",
                value: function iU(e) {
                  if (e.Da(), t.model.A.P.aP && e.zZ() && null != t.u.Ja.V() && null != t.u.Ja.V().ea) {
                    var i = this.X.aj;
                    if (this.Xd.kV(i) && (e.g_(), this.U3(e, i), !e.pZ())) {
                      e.show(), e.Pl.Dm("auto"), e.top = e.Hf.bottom, i = this.coords.Oi(this.coords.Kb, this.X.jb);
                      for (var s = 0, r = 0; r < e.Qh.length; r++) s += e.Qh.F(r).width;
                      s = s + 2 * this.AK + 2 * (e.Qh.length - 1) * this.AK, e.Pl.width = s, i - e.Hf.right + s > this.coords.scrollLeft ? e.Hf.right = e.Hf.left + s : i > e.Hf.right - s ? (e.Pl.ha("left", "auto"), e.Pl.right = 0, s = e.Hf.right - i) : e.Hf.xO >= this.coords.rn && (e.Pl.ha("left", "right"), e.Pl.left = 0, s = 0 > (s = s - (e.Hf.xO - this.coords.rn) - 1) ? 0 : s), this.coords.$b + this.coords.lp <= e.Hf.bottom + e.height && (e.top = e.Hf.bottom - this.x2), e.left = e.Hf.right - s, e.oO.width = s, e.width = s;
                    }
                  }
                }
              }, {
                key: "U3",
                value: function U3(t, e) {
                  this.Xd.qV.U1(t, e);
                }
              }, {
                key: "hU",
                value: function hU(e, i, s) {
                  e.Da();
                  var r = Math.min(i.x, s.x),
                    n = Math.min(i.y, s.y),
                    a = Math.max(i.x, s.x);
                  i = Math.max(i.y, s.y), this.L1(r, a, n, i, e), t.model.A.P.Re && this.ZW(r, a, n, i, e), s = this.coords.rn;
                  var o = this.coords.$b + this.coords.lp,
                    h = Math.max(this.coords.$b, this.coords.Lk(n, this.X.jb) - 1),
                    l = this.coords.Lk(i + 1, this.X.jb),
                    A = Math.min(o, l),
                    c = Math.max(0, this.coords.Oi(r, this.X.jb) - 1),
                    u = this.coords.Oi(a + 1, this.X.jb),
                    d = Math.min(s, u),
                    f = A - h,
                    p = d - c;
                  2 >= p || 2 >= f ? null != e.Le && e.Le.Da() : c < s && h < o ? (null != e.Le && (e.Le.show(), e.Le.top = h, e.Le.left = c, e.Le.width = p, e.Le.height = f, this.ri.Hf.bottom * this.ri.Hf.right <= d * A && (this.ri.Hf.left = c, this.ri.Hf.right = d, this.ri.Hf.bottom = A, this.ri.Hf.xO = u)), n < this.coords.Yb && u > d && (e.WK(), e.nf.top = h, e.nf.left = d, e.nf.width = Math.min(u, this.coords.Yh) - d, e.nf.height = Math.min(A, this.coords.$b + this.coords.yi) - h, e.nf.Va("wdr-clear-border-bottom", i > this.coords.Yb), e.nf.Va("wdr-clear-border-right", u > this.coords.Yh), e.nf.qd("wdr-clear-border"), e.nf.show()), r < this.coords.Kb && l > A && (e.eL(), e.zf.top = A, e.zf.left = c, e.zf.width = Math.min(d, this.coords.ci) - c, e.zf.height = Math.min(l, this.coords.Nj) - A, e.zf.Va("wdr-clear-border-bottom", l > this.coords.Nj), e.zf.Va("wdr-clear-border-right", a > this.coords.Kb), e.zf.qd("wdr-clear-border"), e.zf.show()), null != e.Le && (e.Le.Va("wdr-clear-border-right", u > d), e.Le.Va("wdr-clear-border-bottom", l > A))) : null != e.Le && e.Le.Da();
                }
              }, {
                key: "bX",
                value: function bX(t, e) {
                  if (!isNaN(t)) {
                    null == e.Eh && e.fL();
                    var i = this.coords.Lk(t, this.X.jb);
                    t = this.coords.Lk(t + 1, this.X.jb);
                    var s = Math.min(this.coords.$b + this.coords.lp, t);
                    i < this.coords.$b + this.coords.lp ? (e.Eh.left = 0, e.Eh.top = i, e.Eh.width = this.coords.rn, e.Eh.height = s - i, e.Eh.show(), t > s && (e.eL(), e.zf.top = s, e.zf.left = 0, e.zf.width = this.coords.ci, e.zf.height = Math.min(t, this.coords.Nj) - s, e.zf.Y("wdr-clear-border"), e.zf.show())) : e.Eh.Da();
                  }
                }
              }, {
                key: "aX",
                value: function aX(t, e) {
                  if (!isNaN(t)) {
                    null == e.qh && e.XK();
                    var i = this.coords.Oi(t, this.X.jb);
                    t = this.coords.Oi(t + 1, this.X.jb);
                    var s = Math.min(this.coords.rn, t);
                    i < this.coords.rn ? (e.qh.left = i, e.qh.top = this.coords.$b, e.qh.width = s - i, e.qh.height = this.coords.lp, e.qh.show(), t > s && (e.WK(), e.nf.top = this.coords.$b, e.nf.left = s, e.nf.width = Math.min(t, this.coords.Yh) - s, e.nf.height = this.coords.yi, e.nf.Y("wdr-clear-border"), e.nf.show())) : e.qh.Da();
                  }
                }
              }, {
                key: "ZW",
                value: function ZW(t, e, i, s, r) {
                  this.XW(r.qh, t, e), this.YW(r.Eh, i, s);
                }
              }, {
                key: "L1",
                value: function L1(t, e, i, s, n) {
                  if (!this.Xd.CO.hasOwnProperty(i.toString())) {
                    n.fL();
                    for (var a = i; a <= s; a++) this.Xd.CO[a.toString()] = i == s && t == e ? r.eI : r.Qv;
                  }
                  if (!this.Xd.RK.hasOwnProperty(t.toString())) for (n.XK(), a = t; a <= e; a++) this.Xd.RK[a.toString()] = i == s && t == e ? r.eI : r.Qv;
                }
              }, {
                key: "XW",
                value: function XW(t, e, i) {
                  null != t && (e = this.coords.Oi(e, this.X.jb), i = Math.min(this.coords.Yh, this.coords.Oi(i + 1, this.X.jb)), e < this.coords.Yh ? (t.left = e, t.top = this.coords.$b, t.width = i - e, t.height = this.coords.Mk(), t.show()) : t.Da());
                }
              }, {
                key: "YW",
                value: function YW(t, e, i) {
                  null != t && (e = this.coords.Lk(e, this.X.jb), i = Math.min(this.coords.Nj, this.coords.Lk(i + 1, this.X.jb)), t.left = 0, t.top = e, t.width = this.coords.Ej(), t.height = i - e, t.show());
                }
              }]);
              return _class26;
            }();
            var r = /*#__PURE__*/_createClass(function r() {
              _classCallCheck(this, r);
            });
            r.eI = 1, r.Qv = 2, e.FG = r, e.LI = /*#__PURE__*/function () {
              function _class27(t) {
                _classCallCheck(this, _class27);
                this.X = this.Wt = this.Dt = this.fr = this.Pq = this.Mw = null, this.X = t, this.Mw = this.su();
              }
              _createClass(_class27, [{
                key: "su",
                value: function su() {
                  var t = new i.ia("div", "wdr-sheet-selection-canvas");
                  return t.Da(), this.X.R(t), t;
                }
              }, {
                key: "XK",
                value: function XK() {
                  null == this.Pq && (this.Pq = this.su(), this.Pq.Y("wdr-sheet-selection-header"));
                }
              }, {
                key: "fL",
                value: function fL() {
                  null == this.fr && (this.fr = this.su(), this.fr.Y("wdr-sheet-selection-header"));
                }
              }, {
                key: "eL",
                value: function eL() {
                  null == this.Wt && (this.Wt = this.su(), this.Wt.Y("wdr-clear-border-top"));
                }
              }, {
                key: "WK",
                value: function WK() {
                  null == this.Dt && (this.Dt = this.su(), this.Dt.Y("wdr-clear-border-left"));
                }
              }, {
                key: "Tl",
                get: function get() {
                  return this.ET;
                },
                set: function set(t) {
                  this.ET = t;
                }
              }, {
                key: "zf",
                get: function get() {
                  return this.Wt;
                }
              }, {
                key: "nf",
                get: function get() {
                  return this.Dt;
                }
              }, {
                key: "Eh",
                get: function get() {
                  return this.fr;
                },
                set: function set(t) {
                  this.fr = t;
                }
              }, {
                key: "qh",
                get: function get() {
                  return this.Pq;
                },
                set: function set(t) {
                  this.Pq = t;
                }
              }, {
                key: "Le",
                get: function get() {
                  return this.Mw;
                },
                set: function set(t) {
                  this.Mw = t;
                }
              }, {
                key: "Da",
                value: function Da() {
                  this.qh && this.qh.Da(), this.Eh && this.Eh.Da(), this.nf && this.nf.Da(), this.zf && this.zf.Da(), this.Le && this.Le.Da();
                }
              }, {
                key: "remove",
                value: function remove() {
                  null != this.Le && (this.Le.remove(), this.Mw = null), null != this.qh && (this.qh.remove(), this.Pq = null), null != this.Eh && (this.Eh.remove(), this.fr = null), null != this.nf && (this.nf.remove(), this.Dt = null), null != this.zf && (this.zf.remove(), this.Wt = null), this.X = null;
                }
              }]);
              return _class27;
            }();
          }((s = e.N || (e.N = {})).sheet || (s.sheet = {}));
        }(r || (r = {}));
        var tt = /*#__PURE__*/function (_i$ia4) {
          _inherits(tt, _i$ia4);
          var _super80 = _createSuper(tt);
          function tt() {
            var _this119;
            _classCallCheck(this, tt);
            _this119 = _super80.call(this, "div", "wdr-scroll-pane"), _this119.rk = new i.ia("div", "wdr-scroll-placeholder"), _this119.bJ = new i.ia("div", "wdr-scroll-content"), _this119.R(_this119.bJ), _this119.R(_this119.rk);
            return _this119;
          }
          _createClass(tt, [{
            key: "KC",
            get: function get() {
              return this.rk.width;
            },
            set: function set(t) {
              this.rk.width = t;
            }
          }, {
            key: "JC",
            get: function get() {
              return this.rk.height;
            },
            set: function set(t) {
              this.rk.height = t;
            }
          }, {
            key: "scrollLeft",
            get: function get() {
              return this.element.scrollLeft;
            },
            set: function set(t) {
              this.element.scrollLeft = t;
            }
          }, {
            key: "scrollTop",
            get: function get() {
              return this.element.scrollTop;
            },
            set: function set(t) {
              this.element.scrollTop = t;
            }
          }, {
            key: "content",
            get: function get() {
              return this.bJ;
            }
          }, {
            key: "placeholder",
            get: function get() {
              return this.rk;
            }
          }, {
            key: "lZ",
            set: function set(t) {
              this.element.style.overflowX = t ? "scroll" : "hidden";
            }
          }, {
            key: "d4",
            set: function set(t) {
              this.element.style.overflowY = t ? "scroll" : "hidden";
            }
          }]);
          return tt;
        }(i.ia);
        !function (t) {
          var e, i;
          e = t.G || (t.G = {}), function (e) {
            var i = /*#__PURE__*/function (_e$Rv) {
              _inherits(i, _e$Rv);
              var _super81 = _createSuper(i);
              function i(t) {
                var _this120;
                _classCallCheck(this, i);
                _this120 = _super81.call(this, t, null), _this120.J = t;
                return _this120;
              }
              _createClass(i, [{
                key: "Ha",
                value: function Ha() {
                  var e = [],
                    _i42 = new st();
                  if (t.model.A.P.Re) {
                    _i42.tag = "div", _i42.Y("wdr-row"), _i42.text += it(this.JW());
                    for (var s = 0; s < this.J.Kb; s++) _i42.text += it(this.ZK(s));
                    for (e.push(it(_i42)), s = 0; s < this.J.Yb; s++) _i42.text = it(this.ru(s)), e.push(it(_i42));
                  }
                  e = e.join(""), this.element.innerHTML != e && this.Lc(e);
                }
              }, {
                key: "clear",
                value: function clear() {}
              }]);
              return i;
            }(e.Rv);
            e.PS = i;
          }((i = e.N || (e.N = {})).sheet || (i.sheet = {}));
        }(r || (r = {}));
        var et = /*#__PURE__*/function () {
          function et() {
            _classCallCheck(this, et);
            this.text = this.tag = "", this.style = {}, this.tag = "div", this.attr = {}, this.classes = [], this.addClass = this.$J;
          }
          _createClass(et, [{
            key: "$J",
            value: function $J(t) {
              0 > this.classes.indexOf(t) && this.classes.push(t);
            }
          }]);
          return et;
        }();
        function it(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          var i,
            s = t.node,
            n = "<" + s.tag,
            a = [];
          for (i in s.style) a.push(i + ":" + s.style[i]);
          for (var o in 0 < a.length && (n += ' style="' + a.join(";") + ';"'), 0 < s.classes.length && (n += ' class="' + s.classes.join(" ") + '"'), s.attr) n += " " + o + '="' + s.attr[o] + '"';
          return s = n += ">" + (s.text || "") + "</" + s.tag + ">", e && t.clear(), null != r.G.N.C.ad.tp && (s = r.model.zc.valid(s) ? s : r.model.zc.validate(s)), s;
        }
        var st = /*#__PURE__*/function () {
          function st() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "div";
            _classCallCheck(this, st);
            this.cU = new et(), this.clear(), this.tag = t;
          }
          _createClass(st, [{
            key: "node",
            get: function get() {
              return this.cU;
            }
          }, {
            key: "tag",
            get: function get() {
              return this.node.tag;
            },
            set: function set(t) {
              this.node.tag = t;
            }
          }, {
            key: "text",
            get: function get() {
              return this.node.text;
            },
            set: function set(t) {
              this.node.text = t;
            }
          }, {
            key: "style",
            get: function get() {
              return this.node.style;
            },
            set: function set(t) {
              this.node.style = t;
            }
          }, {
            key: "ja",
            get: function get() {
              return this.node.attr;
            },
            set: function set(t) {
              this.node.attr = t;
            }
          }, {
            key: "Y",
            value: function Y(t) {
              this.node.$J(t);
            }
          }, {
            key: "clear",
            value: function clear() {
              this.tag = "div", this.text = "", this.style = {}, this.ja = {}, this.node.classes = [];
            }
          }]);
          return st;
        }();
        !function (t) {
          var e, i;
          e = t.G || (t.G = {}), function (t) {
            var e = /*#__PURE__*/function (_t$uq) {
              _inherits(e, _t$uq);
              var _super82 = _createSuper(e);
              function e() {
                _classCallCheck(this, e);
                return _super82.apply(this, arguments);
              }
              _createClass(e, [{
                key: "Ha",
                value: function Ha() {
                  this.Ds();
                  var t = this.nm();
                  if (this.jb || this.J.Kp(t.bottom) || this.J.Jp(t.right) || !this.mh.contains(t)) {
                    var _e92 = t.clone();
                    if (0 != this.J.Oe && (_e92.right = Math.min(_e92.right, this.J.Oe)), 0 != this.J.Xg && (_e92.bottom = Math.min(_e92.bottom, this.J.Xg)), !this.jb || !this.od.contains(_e92) || !this.J.Sl && (t.left > this.J.Kb && t.left <= this.od.left || t.top > this.J.Yb && t.top <= this.od.top)) {
                      this.J.Jp(t.right) && (t.left = Math.max(t.left - 1, this.J.Kb)), this.J.Kp(t.bottom) && (t.top = Math.max(t.top - 1, this.J.Yb)), _e92 = [];
                      for (var i = new st(), s = t.top; s < t.bottom; s++) {
                        i.tag = "div", i.Y("wdr-row"), i.ja["data-r"] = s;
                        for (var r = t.left; r < t.right; ++r) i.text += it(this.uj(s, r));
                        _e92.push(it(i));
                      }
                      this.Ma.placeholder.Lc(""), this.Ma.placeholder.visible = this.J.Mn || this.J.Nn, this.Ma.content.Lc(_e92.join("")), this.Ma.content.show(), _e92.length = 0, this.jb = !1, this.mh.set(t);
                    }
                  }
                }
              }, {
                key: "fu",
                value: function fu() {
                  this.Ma.content.left = this.J.ny(this.mh.left), this.Ma.content.top = this.J.Dy(this.mh.top);
                }
              }, {
                key: "xn",
                value: function xn() {
                  var t = this.nm(!0);
                  if (!(this.jb && this.J.Sl && this.od.contains(t))) {
                    this.od = t, t = [];
                    for (var _e93 = this.od.top; _e93 < this.od.bottom; _e93++) {
                      this.J.Zb(_e93);
                      for (var i = this.od.left; i < this.od.right; ++i) t.push(it(this.uj(_e93, i, !0)));
                    }
                    this.Ma.placeholder.Lc(t.join("")), this.Ma.placeholder.show(), this.Ma.content.Da(), this.Ma.content.Lc(""), t = this.nm(), this.jb || this.J.Kp(t.bottom) || (this.Ma.scrollTop = this.J.om(this.J.ye, !1)), this.jb || this.J.Jp(t.right) || (this.Ma.scrollLeft = this.J.In(this.J.Kd, !1)), this.jb = !0;
                  }
                }
              }, {
                key: "nm",
                value: function nm() {
                  var _e94 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  var i = new t.Ws();
                  return i.top = this.J.AD(_e94), i.left = this.J.zD(_e94), i.bottom = this.J.ly(_e94), i.right = this.J.my(_e94), i;
                }
              }, {
                key: "Ds",
                value: function Ds() {
                  this.Ma.KC = Math.max(this.J.bm, this.J.Hd - this.J.Cs), this.Ma.JC = Math.max(this.J.am, this.J.vd - this.J.Bs), this.Ma.content.right = this.J.Cs, this.Ma.content.bottom = this.J.Bs, this.Ma.lZ = this.J.Mn, this.Ma.d4 = this.J.Nn;
                }
              }]);
              return e;
            }(t.uq);
            t.OQ = e;
          }((i = e.N || (e.N = {})).sheet || (i.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.G || (t.G = {}), function (e) {
            var s = /*#__PURE__*/function (_e$uq) {
              _inherits(s, _e$uq);
              var _super83 = _createSuper(s);
              function s() {
                _classCallCheck(this, s);
                return _super83.apply(this, arguments);
              }
              _createClass(s, [{
                key: "Ha",
                value: function Ha() {
                  this.Ds();
                  var e = this.nm();
                  if (this.jb || this.J.Kp(e.bottom) || !this.mh.contains(e)) {
                    var i = e.clone();
                    if (0 != this.J.Xg && (i.bottom = Math.min(i.bottom, this.J.Xg)), !this.jb || !this.od.contains(i)) {
                      this.J.Kp(e.bottom) && (e.top = Math.max(e.top - 1, this.J.Yb)), i = [];
                      for (var _s78 = new st(), r = e.top; r < e.bottom; r++) {
                        _s78.tag = "div", _s78.Y("wdr-row"), _s78.ja["data-r"] = r, t.model.A.P.Re && (_s78.text += it(this.ru(r)));
                        for (var n = e.left; n < e.right; ++n) _s78.text += it(this.uj(r, n));
                        i.push(it(_s78));
                      }
                      this.Ma.placeholder.Lc(""), this.Ma.placeholder.Da(), this.Ma.content.Lc(i.join("")), this.Ma.content.show(), i.length = 0, this.Zw = !1, this.mh.set(e);
                    }
                  }
                }
              }, {
                key: "ru",
                value: function ru(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  return this.cell = _get(_getPrototypeOf(s.prototype), "ru", this).call(this, t, e), e || (this.cell.style["min-height"] = this.cell.style.height, delete this.cell.style.height, delete this.cell.style["line-height"]), this.cell;
                }
              }, {
                key: "fu",
                value: function fu() {
                  this.Ma.content.top = this.J.Dy(this.mh.top);
                }
              }, {
                key: "nm",
                value: function nm() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  var i = new e.Ws();
                  return i.top = this.J.AD(t), i.left = 0, i.bottom = this.J.ly(t), i.right = this.J.Kb, t && i.bottom == this.J.Xg && i.bottom++, i;
                }
              }, {
                key: "xn",
                value: function xn() {
                  var e = this.nm(!0);
                  if (!(this.jb && this.J.Sl && this.od.contains(e))) {
                    this.od = e, e = [];
                    for (var i = this.od.top; i < this.od.bottom; i++) {
                      t.model.A.P.Re && e.push(it(this.ru(i, !0)));
                      for (var _s79 = this.od.left; _s79 < this.od.right; ++_s79) e.push(it(this.uj(i, _s79, !0)));
                    }
                    this.Ma.placeholder.Lc(e.join("")), this.Ma.content.Da(), this.Ma.content.Lc(""), this.Ma.placeholder.show(), this.jb || this.J.Kp(this.mh.bottom) ? this.Ll.scrollTop = this.J.scrollTop : this.Ma.scrollTop = this.J.om(this.J.ye, !1), this.jb = !0;
                  }
                }
              }, {
                key: "Ds",
                value: function Ds() {
                  this.Ma.JC = this.J.am + this.J.Bs, this.Ma.content.bottom = 0, this.Ma.scrollTop = this.J.scrollTop;
                }
              }, {
                key: "Iu",
                value: function Iu(t, e) {
                  t = this.J.oy(t, !0) - 1, e = this.J.Ey(e) - 1;
                  var _s80 = this.Oh(e, t);
                  return null == _s80 && ((_s80 = new i.C.ad()).fb = e, _s80.ue = t), _s80;
                }
              }]);
              return s;
            }(e.uq);
            e.zS = s;
          }((i = e.N || (e.N = {})).sheet || (i.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.G || (t.G = {}), function (e) {
            var s = /*#__PURE__*/function (_e$uq2) {
              _inherits(s, _e$uq2);
              var _super84 = _createSuper(s);
              function s() {
                _classCallCheck(this, s);
                return _super84.apply(this, arguments);
              }
              _createClass(s, [{
                key: "Ha",
                value: function Ha() {
                  a.Pg(this.Lw), this.Ds();
                  var e = this.nm();
                  if (this.jb || this.J.Jp(e.right) || !this.mh.contains(e)) {
                    var i = e.clone();
                    if (0 != this.J.Oe && (i.right = Math.min(i.right, this.J.Oe)), !this.jb || !this.od.contains(i)) {
                      this.J.Jp(e.right) && (e.left = Math.max(e.left - 1, this.J.Kb)), i = [], t.model.A.P.Re && i.push(this.Kx(e));
                      for (var _s81 = new st(), r = e.top; r < e.bottom; r++) {
                        _s81.tag = "div", _s81.Y("wdr-row"), _s81.ja["data-r"] = r;
                        for (var n = e.left; n < e.right; ++n) _s81.text += it(this.uj(r, n));
                        i.push(it(_s81));
                      }
                      this.Ma.placeholder.Lc(""), this.Ma.placeholder.Da(), this.Ma.content.Lc(i.join("")), this.Ma.content.show(), i.length = 0, this.jb = !1, this.mh.set(e);
                    }
                  }
                }
              }, {
                key: "fu",
                value: function fu() {
                  this.Ma.content.left = this.J.ny(this.mh.left);
                }
              }, {
                key: "nm",
                value: function nm() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                  var i = new e.Ws();
                  return i.top = 0, i.left = this.J.zD(t), i.bottom = this.J.Yb, i.right = this.J.my(t), t && i.right == this.J.Oe && i.right++, i;
                }
              }, {
                key: "xn",
                value: function xn() {
                  var e = this.nm(!0);
                  if (!(this.jb && this.J.Sl && this.od.contains(e))) {
                    this.od = e, a.Pg(this.Lw), e = [];
                    for (var i = this.od.top; i < this.od.bottom; i++) for (var _s82 = this.od.left; _s82 < this.od.right; ++_s82) e.push(it(this.uj(i, _s82, !0)));
                    i = "", t.model.A.P.Re && (i += this.Kx(this.od, !0)), i += e.join(""), this.Ma.placeholder.Lc(i), this.Ma.content.Da(), this.Ma.content.Lc(""), this.Ma.placeholder.show(), this.Ma.scrollLeft = this.jb || this.J.Jp(this.mh.right) ? this.J.scrollLeft : this.J.In(this.J.Kd, !1), this.jb = !0;
                  }
                }
              }, {
                key: "Ds",
                value: function Ds() {
                  this.Ma.KC = this.J.bm + this.J.Cs, this.Ma.content.right = 0;
                }
              }, {
                key: "CK",
                value: function CK() {
                  var _this121 = this;
                  a.Pg(this.Lw);
                  for (var t = [], e = this.J.iY(), i = 0; i < this.J.Yb; i++) for (var _s83 = 0; _s83 < e.length; _s83++) {
                    var r = e[_s83];
                    this.vZ(i, r) || t.push(it(this.uj(i, r, !0)));
                  }
                  if (0 < t.length) {
                    var n = this.Ll.placeholder.element,
                      o = n.children.length,
                      h = n.innerHTML;
                    n.innerHTML = h + t.join(), this.requestAnimationFrame(function () {
                      for (; o < n.children.length; o++) _this121.jA(n.children.item(o));
                      n.innerHTML = h, _this121.Lw = a.xd(function () {
                        return _this121.CK();
                      }, 500);
                    });
                  }
                }
              }, {
                key: "Kx",
                value: function Kx(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  for (var i = "", _s84 = t.left; _s84 < t.right; ++_s84) i += it(this.ZK(_s84, e));
                  return e || ((t = new st()).tag = "div", t.Y("wdr-row"), t.text = i, i = it(t)), i;
                }
              }, {
                key: "Iu",
                value: function Iu(t, e) {
                  t = this.J.oy(t) - 1, e = this.J.Ey(e, !0) - 1;
                  var _s85 = this.Oh(e, t);
                  return null == _s85 && ((_s85 = new i.C.ad()).fb = e, _s85.ue = t), _s85;
                }
              }, {
                key: "Vl",
                value: function Vl() {
                  a.Pg(this.Lw);
                }
              }, {
                key: "la",
                value: function la() {
                  this.Vl(), _get(_getPrototypeOf(s.prototype), "la", this).call(this);
                }
              }]);
              return s;
            }(e.uq);
            e.GG = s;
          }((i = e.N || (e.N = {})).sheet || (i.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, s;
          e = t.G || (t.G = {}), function (r) {
            var n = /*#__PURE__*/function (_i$ia5) {
              _inherits(n, _i$ia5);
              var _super85 = _createSuper(n);
              function n() {
                var _this122;
                _classCallCheck(this, n);
                _this122 = _super85.call(this, "div", "wdr-grid-layout"), _this122.kP = 1e3, _this122.wk = [], _this122.St = !1, _this122.PK = function (t) {
                  return _this122.VN(t);
                }, _this122.BO = function (t) {
                  return _this122.e1(t);
                }, _this122.kL = function () {
                  return _this122.c0();
                }, _this122.$O = function (t) {
                  return _this122.m1(t);
                }, _this122.Ax = 0, _this122.Hi(), _this122.J = new r.dk(), _this122.en = new r.OS(_this122.J), _this122.Ig = new r.NS(_assertThisInitialized(_this122)), _this122.Bd();
                return _this122;
              }
              _createClass(n, [{
                key: "Bd",
                value: function Bd() {
                  this.KW(), this.Kx(), this.YK(), this.IW(), this.wW(), this.HW();
                }
              }, {
                key: "KW",
                value: function KW() {
                  this.pj = new i.dc(), this.pj.B.display = "block", this.pj.qb("wdr-grid-title"), this.pj.Y("wdr-pivot-title"), this.pj.IF(!0), this.pj.B.ha("position", "relative"), this.pj.Da(), this.sU(this.pj);
                }
              }, {
                key: "Kx",
                value: function Kx() {
                  this.oj = new r.PS(this.J), this.oj.id = "wdr-sheet-headers", this.R(this.oj);
                }
              }, {
                key: "YK",
                value: function YK() {
                  var _this123 = this;
                  this.Bb = new r.GG(this.J, function (t, e) {
                    return _this123.Ld(t, e);
                  }), this.Bb.id = "wdr-cols-sheet", this.Bb.Ma.element.addEventListener("wheel", this.PK), this.Bb.addEventListener(s.Ob.kh, function (t) {
                    return _this123.wf(t);
                  }), this.R(this.Bb);
                }
              }, {
                key: "IW",
                value: function IW() {
                  var _this124 = this;
                  this.mc = new r.zS(this.J, function (t, e) {
                    return _this124.Ld(t, e);
                  }), this.mc.id = "wdr-rows-sheet", this.mc.Ma.element.addEventListener("wheel", this.BO), this.mc.addEventListener(s.Ob.kh, function (t) {
                    return _this124.wf(t);
                  }), this.R(this.mc);
                }
              }, {
                key: "wW",
                value: function wW() {
                  var _this125 = this;
                  this.Cb = new r.OQ(this.J, function (t, e) {
                    return _this125.Ld(t, e);
                  }), this.Cb.id = "wdr-data-sheet", this.Cb.Ma.element.addEventListener("scroll", this.kL, !0), this.Cb.addEventListener(r.uq.FA, function (t) {
                    return _this125.$N(t);
                  }), this.Cb.addEventListener(r.uq.VG, function (t) {
                    return _this125.$N(t);
                  }), this.Cb.addEventListener(s.Ob.kh, function (t) {
                    return _this125.wf(t);
                  }), this.R(this.Cb);
                }
              }, {
                key: "HW",
                value: function HW() {
                  var _this126 = this;
                  this.si = new r.xQ(this), this.si.id = "wdr-cols-resize", this.si.addEventListener(s.Ob.Hq, function (t) {
                    return _this126.V_(t);
                  }), this.R(this.si), this.vi = new r.AS(this), this.vi.id = "wdr-rows-resize", this.vi.addEventListener(s.Ob.Iq, function (t) {
                    return _this126.d1(t);
                  }), this.R(this.vi), this.element.addEventListener("dblclick", this.$O);
                }
              }, {
                key: "Ha",
                value: function Ha() {
                  var _this127 = this;
                  this.J.KK(), this.Cb.width && this.Cb.height || this.Jr(), this.J.U2(), this.pK() || (a.Pg(this.yB), this.bD(), this.wk.push(this.requestAnimationFrame(function () {
                    return _this127.xB();
                  })));
                }
              }, {
                key: "bD",
                value: function bD() {
                  for (; 0 < this.wk.length;) this.cancelAnimationFrame(this.wk.pop());
                }
              }, {
                key: "xB",
                value: function xB() {
                  var _this128 = this;
                  e.xb.tb.Oa(e.kf.gl, this, {
                    smooth: !1
                  }), this.J.ux(), this.Ir(), this.St && (this.wC() && (this.J.ux(), this.Bb.tr(), this.mc.tr(), this.Ir()), this.St = !1), this.zu(), t.model.xa.V().na(new t.model.ac(t.model.xa.ak, {
                    smooth: !1
                  })), this.wk.push(this.requestAnimationFrame(function () {
                    _this128.Jr(), _this128.Ig.Ha();
                  })), this.wk.push(this.requestAnimationFrame(function () {
                    var t = _this128.vC();
                    t ? (_this128.Bb.tr(), _this128.mc.tr(), _this128.Cb.tr(), _this128.Ha()) : _this128.J.AV && (a.Pg(_this128.yB), _this128.yB = a.xd(function () {
                      return _this128.xn();
                    }, _this128.kP)), t || _this128.js();
                  })), this.wk.push(this.requestAnimationFrame(function () {
                    e.xb.tb.Oa(e.kf.ak, _this128, {
                      smooth: !1
                    });
                  }));
                }
              }, {
                key: "Ir",
                value: function Ir() {
                  this.J.gA = a.Vb(t.model.A.P.ng) ? 0 : this.pj.Xc(!0), this.Bb.Ha(), this.Bb.fu(), this.mc.Ha(), this.mc.fu();
                }
              }, {
                key: "zu",
                value: function zu() {
                  this.oj.Ha(), this.Ig.Ha(), this.si.Ha(), this.vi.Ha(), this.Cb.Ha(), this.Cb.fu();
                }
              }, {
                key: "wC",
                value: function wC() {
                  return this.Bb.Rl(!0), this.mc.Rl(!0), this.Bb.Pk || this.mc.Pk;
                }
              }, {
                key: "vC",
                value: function vC() {
                  return this.Cb.Rl(!0), this.Bb.Rl(!0), this.mc.Rl(!0), this.Cb.Pk || this.Bb.Pk || this.mc.Pk;
                }
              }, {
                key: "xn",
                value: function xn() {
                  var _this129 = this;
                  this.bD(), this.wk.push(this.requestAnimationFrame(function () {
                    return _this129.KT();
                  }));
                }
              }, {
                key: "KT",
                value: function KT() {
                  var _this130 = this;
                  e.xb.tb.Oa(e.kf.gl, this, {
                    smooth: !0
                  }), this.Bb.xn(), this.mc.xn(), this.Cb.xn(), t.model.xa.V().na(new t.model.ac(t.model.xa.ak, {
                    smooth: !0
                  })), this.type == r.flat.iw.TYPE && this.js(), this.wk.push(this.requestAnimationFrame(function () {
                    _this130.Bb.xC(), _this130.mc.xC(), _this130.Cb.xC(), (_this130.Bb.Pk || _this130.mc.Pk || _this130.Cb.Pk) && (_this130.Bb.xx(), _this130.mc.xx(), _this130.Cb.xx()), _this130.J.Sl || _this130.Bb.CK();
                  })), this.wk.push(this.requestAnimationFrame(function () {
                    e.xb.tb.Oa(e.kf.ak, _this130, {
                      smooth: !0
                    });
                  }));
                }
              }, {
                key: "$N",
                value: function $N(t) {
                  var _this131 = this;
                  t.type == r.uq.FA && this.wk.push(this.requestAnimationFrame(function () {
                    _this131.Bb.vP(), _this131.mc.vP();
                  }));
                }
              }, {
                key: "c0",
                value: function c0() {
                  this.V2(this.Cb.Ma.scrollTop, this.Cb.Ma.scrollLeft);
                }
              }, {
                key: "e1",
                value: function e1(t) {
                  this.coords.Nn && (t = t.wheelDeltaY || t.deltaY || t.wheelDelta || 0, a.Wc().av && (t *= -40), a.Wc().rm && (t *= -1), isNaN(t) || 0 == t || (this.Cb.Ma.scrollTop = this.J.scrollTop - t));
                }
              }, {
                key: "VN",
                value: function VN(t) {
                  this.coords.Mn && (t = t.wheelDeltaX || t.deltaX || 0, a.Wc().av && (t *= -40), a.Wc().rm && (t *= -1), 0 != t && (this.Cb.Ma.scrollLeft = this.J.scrollLeft - t));
                }
              }, {
                key: "type",
                get: function get() {
                  return this.Vc;
                }
              }, {
                key: "coords",
                get: function get() {
                  return this.J;
                }
              }, {
                key: "Jr",
                value: function Jr() {
                  this.width = this.coords.Yh, this.height = this.coords.Nj, a.Vb(t.model.A.P.ng) ? this.pj.Da() : (this.pj.wa(t.model.A.P.ng), this.pj.show()), this.si.left = 0, this.si.top = this.coords.$b, this.si.right = 0, this.si.height = this.coords.Mk(), this.vi.left = 0, this.vi.top = this.coords.$b, this.vi.bottom = 0, this.vi.width = this.coords.Ej();
                }
              }, {
                key: "Q3",
                value: function Q3(t) {
                  null != t && this.na(new s.MA(t));
                }
              }, {
                key: "aj",
                get: function get() {
                  var t = [];
                  if (0 < this.C2.aj.length) for (var e, i = 0; i < this.Ig.aj.length; i++) null != this.Ig.aj.F(i).Le && (e = this.Ig.Cr(this.Ig.aj.F(i).Tl), this.WY(t, e.from, e.bl));
                  return t;
                }
              }, {
                key: "WY",
                value: function WY(t, e, i) {
                  if (e && i) for (var r = this.Ig.GX(e, i); r <= this.Ig.M3(e, i); r++) for (var _n2 = this.Ig.CX(e, i); _n2 <= this.Ig.I3(e, i); _n2++) {
                    var a = this.Ld(r, _n2, !0);
                    null == a && ((a = new s.C.ad()).fb = r, a.ue = _n2), t.push(a);
                  }
                }
              }, {
                key: "Ld",
                value: function Ld(t, e) {
                  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  var s = this.en.getData(t, e, !i);
                  return i && null == s ? this.en.tY(t, e) : s;
                }
              }, {
                key: "insertCell",
                value: function insertCell(t, e, i) {
                  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                  this.en.setData(t, e, i, s);
                }
              }, {
                key: "resize",
                value: function resize(t, e) {
                  this.J.resize(t, e, !0);
                }
              }, {
                key: "Ap",
                set: function set(t) {
                  this.en.Ap = t;
                }
              }, {
                key: "RO",
                value: function RO(t, e) {
                  this.J.Ar = t, this.J.Fk = e;
                }
              }, {
                key: "aM",
                value: function aM(t) {
                  t != this.J.Yb && (this.J.ye = t + (this.J.ye - this.J.Yb)), this.J.Yb = t;
                }
              }, {
                key: "BX",
                value: function BX(t) {
                  t != this.J.Kb && (this.J.Kd = t + (this.J.Kd - this.J.Kb)), this.J.Kd < t && (this.J.Kd = t), this.J.Kb = t;
                }
              }, {
                key: "qp",
                value: function qp() {
                  this.St = !0, this.en.reset(), this.J.reset(), this.Bb.Ul(), this.mc.Ul(), this.Cb.Ul(), this.Ig.clear(), this.Cb.Ma.scrollTop = 0, this.Cb.Ma.scrollLeft = 0, this.Vl();
                }
              }, {
                key: "clearData",
                value: function clearData() {
                  this.en.reset(), this.Bb.Ul(), this.mc.Ul(), this.Cb.Ul(), this.J.KK();
                }
              }, {
                key: "ur",
                value: function ur(t) {
                  this.St = !0, this.J.ur(t);
                }
              }, {
                key: "vr",
                value: function vr(t) {
                  this.St = !0, this.J.vr(t);
                }
              }, {
                key: "select",
                value: function select(t, e, i, s) {
                  this.Ig.select(new r.kj(e, t), new r.kj(s, i));
                }
              }, {
                key: "dm",
                value: function dm() {
                  this.Ig.clear();
                }
              }, {
                key: "Vl",
                value: function Vl() {
                  this.bD(), a.Pg(this.yB), a.Pg(this.TV), this.Bb.Vl();
                }
              }, {
                key: "la",
                value: function la() {
                  this.en.la(), this.Ig.la(), this.Vl(), this.Bb.Rc(), this.Bb.Ma.element && this.Bb.Ma.element.removeEventListener("wheel", this.PK), this.Bb.la(), this.mc.Rc(), this.mc.Ma.element && this.mc.Ma.element.removeEventListener("wheel", this.BO), this.mc.la(), this.Cb.Rc(), this.Cb.Ma.element && this.Cb.Ma.element.removeEventListener("scroll", this.kL), this.Cb.la(), this.si.Rc(), this.si.la(), this.vi.Rc(), this.vi.la(), this.element && this.element.removeEventListener("dbclick", this.$O), _get(_getPrototypeOf(n.prototype), "la", this).call(this);
                }
              }, {
                key: "wf",
                value: function wf(t) {
                  null != t.cell && this.na(t), this.UN(t);
                }
              }, {
                key: "Pj",
                value: function Pj(t) {
                  this.na(t);
                }
              }, {
                key: "UN",
                value: function UN(t) {
                  var _this132 = this;
                  this.Ax++, 1 == this.Ax && (this.TV = a.xd(function () {
                    if (1 == _this132.Ax) {
                      if (t.cell) {
                        var e = new s.AH(t.cell, !0, t.element);
                        _this132.na(e);
                      }
                    } else t.cell && (e = new s.AH(t.cell, !1, t.element), _this132.na(e));
                    _this132.Ax = 0;
                  }, 300));
                }
              }, {
                key: "V2",
                value: function V2() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NaN;
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NaN;
                  var i = !1;
                  isNaN(t) || t == this.coords.scrollTop || (this.coords.scrollTop = t, this.coords.ye = this.coords.Ey(t), this.mc.Ma.scrollTop = t, i = !0), isNaN(e) || e == this.coords.scrollLeft || (this.coords.scrollLeft = e, this.coords.Kd = this.coords.oy(e), this.Bb.Ma.scrollLeft = e, i = !0), i && this.Ha();
                }
              }, {
                key: "V_",
                value: function V_(t) {
                  this.na(t), this.J.ux(), 0 < t.data.width ? this.J.vv(t.data.ue, t.data.width, !1, !0) : this.J.e2(t.data.ue), this.Sx();
                }
              }, {
                key: "d1",
                value: function d1(t) {
                  this.na(t), this.J.ux(), 0 < t.data.height ? this.J.kq(t.data.fb, t.data.height, !1, !0) : this.J.g2(t.data.fb), this.Sx();
                }
              }, {
                key: "m1",
                value: function m1(e) {
                  if (0 != t.model.A.P.Re) {
                    var i = this.Dj(),
                      r = e.clientX - i.left;
                    e = e.clientY - i.top, r > this.coords.Ej() && e > this.coords.$b + this.coords.Mk() || (e = this.coords.IM(e, this.jb), r = this.coords.hM(r, this.jb), -1 != e || isNaN(r) || this.si.Oa(s.Ob.Hq, this, {
                      width: -1,
                      ue: r
                    }), -1 != r || isNaN(e) || this.vi.Oa(s.Ob.Iq, this, {
                      height: -1,
                      fb: e
                    }));
                  }
                }
              }, {
                key: "Sx",
                value: function Sx() {
                  this.Bb.Ul(), this.mc.Ul(), this.Cb.Ul(), this.pK() || this.Ha();
                }
              }, {
                key: "pK",
                value: function pK() {
                  var t = !1;
                  return 0 < this.J.scrollLeft && this.J.zX > this.J.scrollLeft && (this.Cb.Ma.scrollLeft = 0, t = !0), 0 < this.J.scrollTop && this.J.AX > this.J.scrollTop && (this.Cb.Ma.scrollTop = 0, t = !0), t;
                }
              }, {
                key: "Hu",
                value: function Hu(t) {
                  var e = i.ia.Ga(t).closest(".wdr-cell");
                  return null != e ? (t = parseInt(e.ja("data-r")), e = parseInt(e.ja("data-c")), this.Ld(t, e, !0)) : null;
                }
              }, {
                key: "jb",
                get: function get() {
                  return this.Cb.jb;
                }
              }, {
                key: "GO",
                value: function GO(t) {
                  this.Cb.Ma.scrollTop = this.coords.om(t);
                }
              }, {
                key: "FO",
                value: function FO(t) {
                  this.Cb.Ma.scrollLeft = this.coords.In(t);
                }
              }, {
                key: "K",
                get: function get() {
                  return this.en;
                }
              }, {
                key: "C2",
                get: function get() {
                  return this.Ig;
                }
              }, {
                key: "yF",
                value: function yF(t, e) {
                  this.coords.vv(t, e, !1, !0);
                }
              }, {
                key: "zF",
                value: function zF(t, e) {
                  this.coords.kq(t, e, !1, !0);
                }
              }, {
                key: "js",
                value: function js() {
                  var _this133 = this;
                  this.zj({
                    sg: function sg(t, e, i, s) {
                      return _this133.sg(t, e, i, s);
                    },
                    Oj: function Oj(t, e, i, s) {
                      return _this133.Oj(t, e, i, s);
                    },
                    Qf: function Qf(t, e, i, s) {
                      return _this133.Qf(t, e, i, s);
                    }
                  });
                }
              }, {
                key: "aL",
                value: function aL(t) {
                  var e = new i.ia("span");
                  return e.Y("wdr-helper"), e.Y("wdr-draggable"), e.Y("wdr-header-helper"), e.ha("position", "absolute"), e.ha("z-index", 100), e.text(t.element.firstChild.textContent), e;
                }
              }, {
                key: "Oj",
                value: function Oj(t, e, s, r) {
                  (t = i.ia.Ga(r.target)).Pc("wdr-header-drop-indicator") || this.ko(t, t);
                }
              }, {
                key: "Qf",
                value: function Qf() {
                  this.Dh();
                }
              }, {
                key: "sg",
                value: function sg() {}
              }, {
                key: "ko",
                value: function ko() {}
              }, {
                key: "Yl",
                value: function Yl() {
                  return this.Xb ? this.Xb : new i.ia("div", "wdr-header-drop-indicator");
                }
              }, {
                key: "Dh",
                value: function Dh() {
                  this.Xb && (this.Xb.Wi(!0), this.Xb = null);
                }
              }]);
              return n;
            }(i.ia);
            r.nG = n;
          }((s = e.N || (e.N = {})).sheet || (s.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.G || (t.G = {}), function (e) {
            var s = /*#__PURE__*/function (_e$Rv2) {
              _inherits(s, _e$Rv2);
              var _super86 = _createSuper(s);
              function s(t) {
                var _this134;
                _classCallCheck(this, s);
                _this134 = _super86.call(this, t, null), _this134.J = t, _this134.Aa = [], _this134.Y("wdr-filters"), _this134.addEventListener(i.Ob.kh, function (t) {
                  return _this134.wf(t);
                });
                return _this134;
              }
              _createClass(s, [{
                key: "Ha",
                value: function Ha() {
                  for (var e = [], i = new st(), _s86 = 0; _s86 < this.J.Yb; _s86++) {
                    i.tag = "div", i.Y("wdr-row");
                    for (var r = 0; r < this.J.Kb; r++) if (t.model.A.P.Vj) {
                      var n = _s86 - this.J.Yb + this.Aa.length;
                      i.text += it(this.Jx(_s86, r, 0 <= n ? this.Aa[n] : null));
                    } else i.text += it(this.uj(_s86, r));
                    e.push(it(i));
                  }
                  e = e.join(""), this.element.innerHTML != e && this.Lc(e);
                }
              }, {
                key: "Jx",
                value: function Jx(e, _s87, r) {
                  var n = this.Aa.indexOf(r);
                  return this.cell.clear(), this.cell.tag = "div", this.cell.Y(i.C.aa.Hc), this.cell.Y(i.C.aa.Ve), this.cell.Y(i.C.aa.ql), r ? (this.cell.Y(i.C.aa.We + n), this.cell.text = r.caption, t.model.A.P.Ks && (this.cell.Y(i.C.aa.gj), r.Sg() && (this.cell.Y(i.C.aa.JA), this.cell.text += this.th(i.C.aa.ht, t.model.v.g.fB)), this.cell.ja.title = t.model.v.g.gB, this.cell.text += this.th(i.C.aa.it))) : this.cell.Y(i.C.aa.sA), this.LO(this.cell, e, _s87), this.cell.ja["data-c"] = _s87, this.cell.ja["data-r"] = e, 0 <= n && (this.cell.ja["data-h"] = n), this.cell;
                }
              }, {
                key: "$k",
                value: function $k(t) {
                  for (var e = this.Aa.length = 0; e < t.length; e++) {
                    var i = t.F(e);
                    0 == i.tf && this.Aa.push(i);
                  }
                }
              }, {
                key: "wf",
                value: function wf(t) {
                  var e = t.element;
                  e.Pc(i.C.aa.gj) && (e = parseInt(e.ja("data-h")), isNaN(e) || this.na(new i.hw(this.Aa[e], t.cell)));
                }
              }, {
                key: "clear",
                value: function clear() {
                  this.Aa.length = 0, this.Ha();
                }
              }]);
              return s;
            }(e.Rv);
            e.BI = s;
          }((i = e.N || (e.N = {})).sheet || (i.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.G || (t.G = {}), function (e) {
            var s = /*#__PURE__*/function (_e$Rv3) {
              _inherits(s, _e$Rv3);
              var _super87 = _createSuper(s);
              function s(t) {
                var _this135;
                _classCallCheck(this, s);
                _this135 = _super87.call(this, t, null), _this135.rowIndex = 0, _this135.J = t, _this135.Aa = [], _this135.Y("wdr-filters"), _this135.Da(), _this135.addEventListener(i.Ob.kh, function (t) {
                  return _this135.wf(t);
                });
                return _this135;
              }
              _createClass(s, [{
                key: "Ha",
                value: function Ha() {
                  if (this.fq(), t.model.A.P.Vj) {
                    var e = new st("div");
                    e.Y("wdr-row"), e.style.height = this.J.Zb(this.rowIndex) + "px";
                    for (var i = 0; i < this.Aa.length; i++) e.text += it(this.Jx(this.rowIndex, i, this.Aa[i]));
                    this.Lc(it(e)), 0 == this.Aa.length ? this.Da() : this.show();
                  } else this.Da();
                }
              }, {
                key: "Jx",
                value: function Jx(e, _s88, r) {
                  return this.cell.clear(), this.cell.tag = "div", this.cell.Y(i.C.aa.Hc), this.cell.Y(i.C.aa.Ve), r && (this.cell.text = r.caption, t.model.A.P.Ks && (this.cell.Y(i.C.aa.gj), this.cell.ja.title = t.model.v.g.gB, r.Sg() && (this.cell.Y(i.C.aa.JA), this.cell.text += this.th(i.C.aa.ht, t.model.v.g.fB)), this.cell.text += this.th(i.C.aa.it))), this.cell.style["min-height"] = this.J.Zb(e) + "px", this.cell.ja["data-r"] = e, this.cell.ja["data-h"] = _s88, this.cell;
                }
              }, {
                key: "$k",
                value: function $k(t) {
                  for (var e = this.Aa.length = 0; e < t.length; e++) {
                    var i = t.F(e);
                    0 == i.tf && this.Aa.push(i);
                  }
                  0 == this.Aa.length ? this.Da() : this.show();
                }
              }, {
                key: "wf",
                value: function wf(t) {
                  if ((t = t.element).Pc(i.C.aa.gj)) {
                    var e = parseInt(t.ja("data-h"));
                    isNaN(e) || this.na(new i.hw(this.Aa[e], null, t));
                  }
                }
              }, {
                key: "clear",
                value: function clear() {
                  this.Aa.length = 0, this.Ha();
                }
              }]);
              return s;
            }(e.Rv);
            e.yQ = s;
          }((i = e.N || (e.N = {})).sheet || (i.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, s;
          e = t.G || (t.G = {}), function (e) {
            var r = /*#__PURE__*/function (_i$ia6) {
              _inherits(r, _i$ia6);
              var _super88 = _createSuper(r);
              function r() {
                var _this136;
                _classCallCheck(this, r);
                _this136 = _super88.call(this), _this136.Aa = [], _this136.Y("wdr-ui-hgroup"), _this136.Y("wdr-filters"), _this136.Da();
                return _this136;
              }
              _createClass(r, [{
                key: "Ha",
                value: function Ha() {
                  var _this137 = this;
                  if (this.fq(), t.model.A.P.Ks && t.model.A.P.iP) {
                    for (var e = 0; e < this.Aa.length; e++) {
                      var s = new n(this.Aa[e], !0);
                      s.B.ja("data-h", e), s.addEventListener(i.Wb.Se, function (t) {
                        return _this137.wf(t);
                      }), this.R(s.B);
                    }
                    0 == this.Aa.length ? this.Da() : this.show();
                  } else this.Da();
                }
              }, {
                key: "$k",
                value: function $k(t) {
                  for (var e = this.Aa.length = 0; e < t.length; e++) {
                    var i = t.F(e);
                    0 == i.tf && this.Aa.push(i);
                  }
                  this.Ha();
                }
              }, {
                key: "wf",
                value: function wf(t) {
                  t = t.target, this.na(new s.hw(t.lb, null, t.B));
                }
              }, {
                key: "clear",
                value: function clear() {
                  this.Aa.length = 0, this.Ha();
                }
              }, {
                key: "Db",
                get: function get() {
                  return 0 == this.Aa.length;
                }
              }]);
              return r;
            }(i.ia);
            e.oS = r;
            var n = /*#__PURE__*/function (_i$Wb) {
              _inherits(n, _i$Wb);
              var _super89 = _createSuper(n);
              function n(t) {
                var _this138;
                var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                _classCallCheck(this, n);
                _this138 = _super89.call(this), _this138.hn = t, _this138.aU = e, _this138.wa(_this138.hn.caption), _this138.qd("wdr-ui-btn"), _this138.Y(s.C.aa.gj), _this138.Y(s.C.aa.Ve), _this138.oJ = new i.ia("i", s.C.aa.OA), _this138.oJ.Y(s.C.aa.it), _this138.B.append(_this138.oJ), _this138.pJ = new i.ia("i", s.C.aa.OA), _this138.pJ.Y(s.C.aa.ht), _this138.B.append(_this138.pJ), _this138.hN = _this138.hn.Sg(), _this138.aU && (_this138.uB = new i.dc(), _this138.uB.wa(_this138.yY()), _this138.uB.Y("wdr-filter-desc"), _this138.R(_this138.uB));
                return _this138;
              }
              _createClass(n, [{
                key: "lb",
                get: function get() {
                  return this.hn;
                }
              }, {
                key: "hN",
                get: function get() {
                  return this.B.Pc("wdr-filtered");
                },
                set: function set(t) {
                  this.B.Va("wdr-filtered", t);
                }
              }, {
                key: "yY",
                value: function yY() {
                  var e = t.model.v.g.SQ;
                  return this.lb.Sg() && (e = 1 == this.lb.filter.length ? this.lb.filter.F(0).caption : t.model.v.g.VQ), e;
                }
              }]);
              return n;
            }(i.Wb);
            e.G4 = n;
          }((s = e.N || (e.N = {})).sheet || (s.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.G || (t.G = {}), function (e) {
            var s = /*#__PURE__*/function (_e$nG) {
              _inherits(s, _e$nG);
              var _super90 = _createSuper(s);
              function s() {
                var _this139;
                _classCallCheck(this, s);
                _this139 = _super90.call(this), _this139.Vc = s.TYPE, _this139.Y("wdr-compact-view");
                return _this139;
              }
              _createClass(s, [{
                key: "Bd",
                value: function Bd() {
                  _get(_getPrototypeOf(s.prototype), "Bd", this).call(this), this.uW(), this.gL(), this.GW();
                }
              }, {
                key: "uW",
                value: function uW() {
                  var _this140 = this;
                  this.ge = new e.yQ(this.J), this.ge.id = "wdr-cols-filter", this.ge.addEventListener(i.Ob.nl, function (t) {
                    return _this140.Pj(t);
                  }), this.R(this.ge);
                }
              }, {
                key: "gL",
                value: function gL() {
                  var _this141 = this;
                  this.lc = new e.BI(this.J), this.lc.id = "wdr-rows-filter", this.lc.addEventListener(i.Ob.nl, function (t) {
                    return _this141.Pj(t);
                  }), this.lc.addEventListener(i.Ob.kh, function (t) {
                    return _this141.wf(t);
                  }), this.R(this.lc);
                }
              }, {
                key: "GW",
                value: function GW() {
                  var _this142 = this;
                  this.Je = new e.oS(), this.Je.id = "wdr-page-filter", this.Je.addEventListener(i.Ob.nl, function (t) {
                    return _this142.Pj(t);
                  }), this.R(this.Je);
                }
              }, {
                key: "Ir",
                value: function Ir() {
                  this.J.pD = this.Je.Db ? 0 : this.Je.element.offsetHeight, _get(_getPrototypeOf(s.prototype), "Ir", this).call(this), this.lc.Ha();
                }
              }, {
                key: "zu",
                value: function zu() {
                  _get(_getPrototypeOf(s.prototype), "zu", this).call(this), this.ge.Ha();
                }
              }, {
                key: "wC",
                value: function wC() {
                  return this.lc.Rl(!0), _get(_getPrototypeOf(s.prototype), "wC", this).call(this) || this.lc.Pk;
                }
              }, {
                key: "vC",
                value: function vC() {
                  return this.lc.Rl(!0), _get(_getPrototypeOf(s.prototype), "vC", this).call(this) || this.lc.Pk;
                }
              }, {
                key: "Jr",
                value: function Jr() {
                  _get(_getPrototypeOf(s.prototype), "Jr", this).call(this), this.Je.Db || (this.Je.top = this.J.gA, this.Je.left = 0, this.Je.right = 0), this.si.top = this.J.$b, this.vi.top = this.J.$b, this.oj.top = this.J.$b, this.oj.left = 0, this.oj.width = this.J.ci, this.oj.height = this.J.yi, this.lc.left = this.J.In(0, !0), this.lc.top = this.J.$b + this.J.om(0, !0), this.ge.top = this.J.$b + this.J.om(this.ge.rowIndex, !0), this.ge.left = this.J.ci, this.ge.right = Math.max(0, this.J.Yh - this.J.Oi(this.J.Oe, this.jb)), this.Bb.left = this.J.ci, this.Bb.top = this.J.$b, this.Bb.width = this.J.Hd, this.Bb.height = this.J.Nj - this.J.$b, this.mc.left = 0, this.mc.top = this.J.yi + this.J.$b, this.mc.width = this.J.Yh, this.mc.height = this.J.vd, this.Cb.left = this.J.ci - 1, this.Cb.top = this.J.yi + this.J.$b - 1, this.Cb.width = this.J.Hd, this.Cb.height = this.J.vd + 1;
                }
              }, {
                key: "Sx",
                value: function Sx() {
                  _get(_getPrototypeOf(s.prototype), "Sx", this).call(this), this.lc.Ha(), this.ge.Ha();
                }
              }, {
                key: "js",
                value: function js() {
                  var _this143 = this;
                  _get(_getPrototypeOf(s.prototype), "js", this).call(this);
                  for (var t = {
                      Ei: function Ei(t) {
                        return _this143.aL(t);
                      }
                    }, e = this.ge.find(".wdr-header:not(.wdr-empty)", !0), i = 0; i < e.length; i++) e[i].draggable(t);
                  for (e = this.lc.find(".wdr-header:not(.wdr-empty)", !0), i = 0; i < e.length; i++) e[i].draggable(t);
                  for (e = this.Je.find(".wdr-header:not(.wdr-empty)", !0), i = 0; i < e.length; i++) e[i].draggable(t);
                }
              }, {
                key: "sg",
                value: function sg(e, i, _s89) {
                  if (null == (_s89 = this.vM(_s89))) this.Dh();else {
                    var r = this.xY(_s89, this.Xb);
                    if (this.Dh(), !isNaN(r)) {
                      var n = parseInt(e.ja("data-h")),
                        a = e.closest(".wdr-filters");
                      if (i = t.u.Ja.V().fa.clone(), a == this.ge) {
                        var o = i.ed.F(n);
                        n = i.za.indexOf(o.j);
                      } else a == this.lc ? (o = i.hc.F(n), n = i.rows.indexOf(o.j)) : a == this.Je && (o = i.eb.F(n), n = i.eb.indexOf(o.j));
                      null == o || _s89 == a && n == r || (e.Da(), _s89 == a ? _s89 == this.ge ? i.za.mz(n, r) : _s89 == this.lc ? i.rows.mz(n, r) : _s89 == this.Je && i.eb.mz(n, r) : (i.za.removeItem(o.j), i.rows.removeItem(o.j), i.eb.removeItem(o.j), _s89 == this.ge ? i.za.ip(o.j, o, r) : _s89 == this.lc ? i.rows.ip(o.j, o, r) : _s89 == this.Je && i.eb.ip(o.j, o, r)), 1 < i.za.length && i.za.F(0).tf && (e = i.za.F(0), i.za.splice(0, 1), i.za.ip(e.j, e, i.za.length)), t.model.yb.V().xk(i));
                    }
                  }
                }
              }, {
                key: "xY",
                value: function xY(t, e) {
                  return t == this.ge ? this.lY(e) : t == this.lc ? this.FM(e) : t == this.Je ? this.NY(e) : NaN;
                }
              }, {
                key: "lY",
                value: function lY(e) {
                  var i = t.u.Ja.V().fa;
                  return null != e ? (e = e.index()) > i.za.length ? i.za.length : (0 <= (i = i.za.indexOf("[Measures]")) && i <= e && 0 != e && e++, e) : NaN;
                }
              }, {
                key: "FM",
                value: function FM(e) {
                  var i = t.u.Ja.V().fa;
                  return null != e ? (e = e.parent.Pc("wdr-filters") ? i.rows.length : (e = e.parent.find(".wdr-header")) ? parseInt(e.ja("data-h")) : 0) > i.rows.length ? i.rows.length : (0 <= (i = i.rows.indexOf("[Measures]")) && i <= e && 0 != e && e++, e) : NaN;
                }
              }, {
                key: "NY",
                value: function NY(e) {
                  var i = t.u.Ja.V().fa;
                  return null != e ? (e = e.index()) > i.za.length ? i.za.length : e : NaN;
                }
              }, {
                key: "vM",
                value: function vM(t) {
                  var e = t.closest(".wdr-filters");
                  if (null == e) {
                    var i = t.closest(".wdr-cell");
                    null != i ? (i.ja("data-r"), t = parseInt(i.ja("data-c")), this.OZ(t) ? e = this.ge : this.PZ(t) && (e = this.lc)) : null != (t = t.closest(".wdr-resize-handles")) && ("wdr-cols-resize" == t.id ? e = this.ge : "wdr-rows-resize" == t.id && (e = this.lc));
                  }
                  return e;
                }
              }, {
                key: "OZ",
                value: function OZ(t) {
                  return t >= this.coords.Kb;
                }
              }, {
                key: "PZ",
                value: function PZ(t) {
                  return t <= this.coords.Kb;
                }
              }, {
                key: "ko",
                value: function ko(t, i) {
                  if (null == (t = this.vM(t))) this.Dh();else {
                    var _s90 = i.closest(".wdr-header:not(.wdr-empty)");
                    null != i.closest(".wdr-filters") && null != _s90 ? (this.Xb = this.Yl(), t == this.Je ? _s90.before(this.Xb) : i.before(this.Xb)) : (this.Xb = this.Yl(), t == this.ge ? this.ge.find(".wdr-row").append(this.Xb) : t == this.lc ? null != i.closest(".wdr-filters") ? this.lc.find(".wdr-header").before(this.Xb) : this.Vc == e.pp.Wv.TYPE ? this.lc.find(".wdr-header").parent.append(this.Xb) : this.lc.append(this.Xb) : t == this.Je && this.Je.append(this.Xb));
                  }
                }
              }, {
                key: "qp",
                value: function qp() {
                  _get(_getPrototypeOf(s.prototype), "qp", this).call(this), this.ge.clear(), this.Je.clear(), this.lc.clear();
                }
              }, {
                key: "Ex",
                get: function get() {
                  return this.ge;
                }
              }, {
                key: "AO",
                get: function get() {
                  return this.lc;
                }
              }, {
                key: "eO",
                get: function get() {
                  return this.Je;
                }
              }, {
                key: "la",
                value: function la() {
                  this.ge.Rc(), this.ge.la(), this.lc.Rc(), this.lc.la(), this.Je.Rc(), _get(_getPrototypeOf(s.prototype), "la", this).call(this);
                }
              }]);
              return s;
            }(e.nG);
            s.TYPE = "compact", e.Xv = s;
          }((i = e.N || (e.N = {})).sheet || (i.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, s;
          e = t.G || (t.G = {}), function (e) {
            var s = /*#__PURE__*/function (_i$ia7) {
              _inherits(s, _i$ia7);
              var _super91 = _createSuper(s);
              function s(e) {
                var _this144;
                _classCallCheck(this, s);
                _this144 = _super91.call(this, "div", "wdr-resize-handles"), _this144.$w = function (t) {
                  return _this144.wm(t);
                }, _this144.dr = function (t) {
                  return _this144.bi(t);
                }, _this144.bp = function (t) {
                  return _this144.xm(t);
                }, _this144.Jl = new st(), _this144.Wo = e, _this144.J = e.coords, _this144.element.addEventListener("mousedown", _this144.$w), document.body.addEventListener("mouseup", _this144.dr), _this144.jn = new i.ia("div", "wdr-indicator"), _this144.jn.Da(), _this144.R(_this144.jn), _this144.hp = new i.ia("div", "wdr-wrapper"), _this144.hp.ja("title", t.model.v.g.OI), _this144.R(_this144.hp);
                return _this144;
              }
              _createClass(s, [{
                key: "Ha",
                value: function Ha() {
                  this.hp.ja("title", t.model.v.g.OI);
                }
              }, {
                key: "Dk",
                value: function Dk(e) {
                  return this.Jl.tag = "div", this.Jl.Y("wdr-handle"), this.Jl.ja["data-idx"] = e, this.Jl.ja.title = t.model.v.g.ZS, this.Jl;
                }
              }, {
                key: "wm",
                value: function wm(t) {
                  if (t.target.classList.contains("wdr-handle")) {
                    this.dn = t.target, this.dn.classList.add("wdr-active"), this.zt = this.Dj(), document.body.addEventListener("mousemove", this.bp), t.stopImmediatePropagation();
                    var e = parseInt(this.dn.getAttribute("data-idx"));
                    this.Ev(e), t.preventDefault(), t.stopImmediatePropagation();
                  }
                }
              }, {
                key: "Ev",
                value: function Ev() {}
              }, {
                key: "bi",
                value: function bi() {
                  if (document.body.removeEventListener("mousemove", this.bp), this.dn) {
                    this.dn.classList.remove("wdr-active");
                    var t = parseInt(this.dn.getAttribute("data-idx"));
                    this.Fv(this.dn, t), this.dn = null, this.jn.Da();
                  }
                }
              }, {
                key: "Fv",
                value: function Fv() {}
              }, {
                key: "xm",
                value: function xm(t) {
                  var e = t.clientX - this.zt.left,
                    i = t.clientY - this.zt.top;
                  0 > e || 0 > i || e > this.J.Yh || i > this.J.Nj ? this.bi(t) : (this.oF(this.dn, e, i), this.jn.show());
                }
              }, {
                key: "oF",
                value: function oF() {}
              }, {
                key: "la",
                value: function la() {
                  this.element && this.element.removeEventListener("mousedown", this.$w), document.body.removeEventListener("mousemove", this.bp), document.body.removeEventListener("mouseup", this.dr), _get(_getPrototypeOf(s.prototype), "la", this).call(this);
                }
              }]);
              return s;
            }(i.ia);
            e.AI = s;
          }((s = e.N || (e.N = {})).sheet || (s.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.G || (t.G = {}), function (t) {
            var e = /*#__PURE__*/function (_t$AI) {
              _inherits(e, _t$AI);
              var _super92 = _createSuper(e);
              function e() {
                _classCallCheck(this, e);
                return _super92.apply(this, arguments);
              }
              _createClass(e, [{
                key: "Ha",
                value: function Ha() {
                  _get(_getPrototypeOf(e.prototype), "Ha", this).call(this), this.hp.fq();
                  for (var t = "", _e95 = 0; _e95 < this.J.Yb; _e95++) t += it(this.Dk(_e95), !0);
                  _e95 = this.J.AD();
                  for (var i = Math.min(this.J.Xg, this.J.ly()); _e95 < i; _e95++) t += it(this.Dk(_e95), !0);
                  this.hp.Lc(t);
                }
              }, {
                key: "Dk",
                value: function Dk(t) {
                  return _get(_getPrototypeOf(e.prototype), "Dk", this).call(this, t), this.Jl.style.top = this.J.Lk(t, this.Wo.jb, !1) + this.J.Zb(t) + "px", this.Jl;
                }
              }, {
                key: "Ev",
                value: function Ev(t) {
                  this.UJ = this.J.Lk(t, this.Wo.jb, !1);
                }
              }, {
                key: "Fv",
                value: function Fv(_e96, s) {
                  _e96 = Math.round(_e96.offsetTop + _e96.clientHeight / 2 - this.UJ), _e96 = Math.max(t.dk.Ys, _e96), this.Oa(i.Ob.Iq, this, {
                    height: _e96,
                    fb: s
                  });
                }
              }, {
                key: "oF",
                value: function oF(_e97, i, s) {
                  s = Math.max(this.UJ + t.dk.Ys, s), _e97.style.top = s + "px", this.jn.top = s, this.jn.width = this.J.rn;
                }
              }]);
              return e;
            }(t.AI);
            t.AS = e;
          }((i = e.N || (e.N = {})).sheet || (i.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.G || (t.G = {}), function (t) {
            var e = /*#__PURE__*/function (_t$AI2) {
              _inherits(e, _t$AI2);
              var _super93 = _createSuper(e);
              function e() {
                _classCallCheck(this, e);
                return _super93.apply(this, arguments);
              }
              _createClass(e, [{
                key: "Ha",
                value: function Ha() {
                  _get(_getPrototypeOf(e.prototype), "Ha", this).call(this), this.hp.fq();
                  for (var t = "", _e98 = 0; _e98 < this.J.Kb; _e98++) t += it(this.Dk(_e98), !0);
                  var i = Math.min(this.J.Oe, this.J.my());
                  for (_e98 = this.J.zD(); _e98 < i; _e98++) t += it(this.Dk(_e98), !0);
                  this.hp.Lc(t);
                }
              }, {
                key: "Dk",
                value: function Dk(t) {
                  return _get(_getPrototypeOf(e.prototype), "Dk", this).call(this, t), this.Jl.style.left = this.J.Oi(t, this.Wo.jb) + this.J.sf(t) + "px", this.Jl;
                }
              }, {
                key: "Ev",
                value: function Ev(t) {
                  this.TJ = this.J.Oi(t, this.Wo.jb);
                }
              }, {
                key: "Fv",
                value: function Fv(_e99, s) {
                  _e99 = Math.round(_e99.offsetLeft + _e99.clientWidth / 2 - this.TJ), _e99 = Math.max(t.dk.Zs, _e99), this.Oa(i.Ob.Hq, this, {
                    width: _e99,
                    ue: s
                  });
                }
              }, {
                key: "oF",
                value: function oF(_e100, i) {
                  i = Math.max(this.TJ + t.dk.Zs, i), _e100.style.left = i + "px", this.jn.left = i, this.jn.height = this.J.lp;
                }
              }]);
              return e;
            }(t.AI);
            t.xQ = e;
          }((i = e.N || (e.N = {})).sheet || (i.sheet = {}));
        }(r || (r = {})), function (t) {
          var e, i, s;
          e = t.G || (t.G = {}), i = e.N || (e.N = {}), function (e) {
            var r = /*#__PURE__*/function (_s$Xv) {
              _inherits(r, _s$Xv);
              var _super94 = _createSuper(r);
              function r() {
                var _this145;
                _classCallCheck(this, r);
                _this145 = _super94.call(this), _this145.Vc = r.TYPE, _this145.qd("wdr-compact-view"), _this145.Y("wdr-classic-view");
                return _this145;
              }
              _createClass(r, [{
                key: "gL",
                value: function gL() {
                  var _this146 = this;
                  this.lc = new e.wQ(this.J), this.lc.id = "wdr-rows-filter", this.lc.addEventListener(i.Ob.nl, function (t) {
                    return _this146.Pj(t);
                  }), this.lc.addEventListener(i.Ob.kh, function (t) {
                    return _this146.wf(t);
                  }), this.R(this.lc);
                }
              }, {
                key: "Ir",
                value: function Ir() {
                  this.xZ ? _get(_getPrototypeOf(r.prototype), "Ir", this).call(this) : (t.yc(t.model.v.g.OR, t.model.v.g.wq, t.ld.wq), t.model.yb.V().Uj({
                    gridType: i.Ue.xo
                  }), t.model.yb.V().refresh());
                }
              }, {
                key: "xZ",
                get: function get() {
                  return this.J.Hd > this.J.r_;
                }
              }, {
                key: "Vl",
                value: function Vl() {
                  _get(_getPrototypeOf(r.prototype), "Vl", this).call(this), this.lc.Vl();
                }
              }, {
                key: "FM",
                value: function FM(e) {
                  var i = t.u.Ja.V().fa;
                  return null != e ? (e = e.index()) > i.rows.length ? i.rows.length : (0 <= (i = i.rows.indexOf("[Measures]")) && i <= e && 0 != e && e++, e) : NaN;
                }
              }]);
              return r;
            }(s.Xv);
            r.TYPE = "classic", e.Wv = r;
          }((s = i.sheet || (i.sheet = {})).pp || (s.pp = {}));
        }(r || (r = {})), function (t) {
          var e, i, s;
          e = t.G || (t.G = {}), i = e.N || (e.N = {}), function (e) {
            var i = /*#__PURE__*/function (_s$BI) {
              _inherits(i, _s$BI);
              var _super95 = _createSuper(i);
              function i(t) {
                _classCallCheck(this, i);
                return _super95.call(this, t);
              }
              _createClass(i, [{
                key: "la",
                value: function la() {
                  a.Pg(this.XJ), _get(_getPrototypeOf(i.prototype), "la", this).call(this);
                }
              }, {
                key: "Ha",
                value: function Ha() {
                  var _this147 = this;
                  for (var e = [], _i43 = new st(), s = 0; s < this.J.Yb; s++) {
                    _i43.tag = "div", _i43.Y("wdr-row");
                    for (var r = 0; r < this.J.Kb; r++) _i43.text = t.model.A.P.Vj ? _i43.text + it(this.Jx(s, r, s == this.J.Yb - 1 ? this.Aa[r] : null)) : _i43.text + it(this.uj(s, r));
                    e.push(it(_i43));
                  }
                  this.Lc(e.join("")), this.XJ = a.xd(function () {
                    return _this147.Rl(!0);
                  }, 0);
                }
              }, {
                key: "Vl",
                value: function Vl() {
                  a.Pg(this.XJ);
                }
              }]);
              return i;
            }(s.BI);
            e.wQ = i;
          }((s = i.sheet || (i.sheet = {})).pp || (s.pp = {}));
        }(r || (r = {})), function (t) {
          var e, i, s;
          e = t.G || (t.G = {}), i = e.N || (e.N = {}), function (r) {
            var n = /*#__PURE__*/function (_s$nG) {
              _inherits(n, _s$nG);
              var _super96 = _createSuper(n);
              function n() {
                var _this148;
                _classCallCheck(this, n);
                _this148 = _super96.call(this), _this148.yJ = !1, _this148.JB = null, _this148.XV = function (t) {
                  return _this148.VN(t);
                }, _this148.Vc = n.TYPE, _this148.Y("wdr-flat-view");
                return _this148;
              }
              _createClass(n, [{
                key: "YK",
                value: function YK() {
                  var _this149 = this;
                  this.Bb = new r.bR(this.J, function (t, e) {
                    return _this149.Ld(t, e);
                  }), this.Bb.id = "wdr-cols-sheet", this.Bb.Ma.element.addEventListener("wheel", this.XV), this.Bb.addEventListener(i.Ob.kh, function (t) {
                    return _this149.wf(t);
                  }), this.Bb.addEventListener(i.Ob.kh, function (t) {
                    return _this149.UN(t);
                  }), this.Bb.addEventListener(i.Ob.nl, function (t) {
                    return _this149.Pj(t);
                  }), this.R(this.Bb);
                }
              }, {
                key: "Jr",
                value: function Jr() {
                  _get(_getPrototypeOf(n.prototype), "Jr", this).call(this), this.oj.top = this.J.$b, this.oj.left = 0, this.oj.width = this.J.ci, this.oj.height = this.J.yi, this.Bb.left = this.J.ci, this.Bb.top = this.J.$b, this.Bb.width = this.J.Hd, this.Bb.height = this.J.Nj - this.J.$b, this.mc.left = 0, this.mc.top = this.J.yi + this.J.$b, this.mc.width = this.J.Yh, this.mc.height = this.J.vd, this.Cb.left = this.J.ci - 1, this.Cb.top = this.J.yi + this.J.$b - 1, this.Cb.width = this.J.Hd, this.Cb.height = this.J.vd + 1;
                }
              }, {
                key: "zu",
                value: function zu() {
                  _get(_getPrototypeOf(n.prototype), "zu", this).call(this);
                }
              }, {
                key: "Qk",
                get: function get() {
                  return this.yJ;
                },
                set: function set(t) {
                  this.yJ = t;
                }
              }, {
                key: "js",
                value: function js() {
                  var _this150 = this;
                  _get(_getPrototypeOf(n.prototype), "js", this).call(this);
                  for (var t = {
                      Ei: function Ei(t) {
                        return _this150.aL(t);
                      }
                    }, e = this.Bb.find(".wdr-header", !0), i = 0; i < e.length; i++) e[i].draggable(t);
                }
              }, {
                key: "ko",
                value: function ko(t, e) {
                  null != (t = e.closest(".wdr-cell")) ? (t = parseInt(t.ja("data-c")), t = Math.min(t, this.coords.Fk), this.Xb = this.Yl(), this.Xb.left = this.coords.Oi(t, this.jb) - (t == this.coords.Fk ? 0 : this.Xb.width), this.Xb.top = this.J.$b + this.coords.Lk(0, this.jb) - 1, this.Xb.height = this.coords.Zb(0) + 1, this.append(this.Xb)) : this.Dh();
                }
              }, {
                key: "sg",
                value: function sg(i, s, r) {
                  this.Dh();
                  var _n3 = r.closest(".wdr-cell");
                  null != _n3 && (s = t.u.Ja.V().fa.clone(), r = this.Qk && null != this.JB ? this.JB : s.flatten(), _n3 = parseInt(_n3.ja("data-c")), (i = parseInt(i.ja("data-c"))) != (_n3 = Math.max(0, Math.min(_n3, r.length - 1))) && (r.mz(i, _n3), 0 < s.ze.length && (s.ze = r.EP()), this.Qk ? (this.JB = r, s.ze = r.EP(), this.Oa(e.bc.ck.Bo, this, s)) : (s.rows = r, t.model.yb.V().xk(s))));
                }
              }]);
              return n;
            }(s.nG);
            n.TYPE = "flat", r.iw = n;
          }((s = i.sheet || (i.sheet = {})).flat || (s.flat = {}));
        }(r || (r = {})), function (t) {
          var e, i, s;
          e = t.G || (t.G = {}), i = e.N || (e.N = {}), function (e) {
            var r = /*#__PURE__*/function (_s$GG) {
              _inherits(r, _s$GG);
              var _super97 = _createSuper(r);
              function r(t, e) {
                var _this151;
                _classCallCheck(this, r);
                _this151 = _super97.call(this, t, e), _this151.addEventListener(i.Ob.kh, function (t) {
                  return _this151.Pj(t);
                });
                return _this151;
              }
              _createClass(r, [{
                key: "Pj",
                value: function Pj(t) {
                  null != t.cell && t.cell.xh && null != t.cell.lb && t.cell.lr != i.C.hj.xw && this.na(new i.hw(t.cell.lb, t.cell));
                }
              }, {
                key: "uj",
                value: function uj(e, s) {
                  var _r76 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  return this.cell = _get(_getPrototypeOf(r.prototype), "uj", this).call(this, e, s, _r76), (e = this.Oh ? this.Oh(e, s) : null) && e.xh && (this.cell.Y(i.C.aa.gj), e.ec && (this.cell.Y(i.C.aa.JA), this.cell.text += this.th(i.C.aa.ht, t.model.v.g.fB)), this.cell.ja.title = t.model.v.g.gB, this.cell.text += this.th(i.C.aa.it)), this.cell;
                }
              }]);
              return r;
            }(s.GG);
            e.bR = r;
          }((s = i.sheet || (i.sheet = {})).flat || (s.flat = {}));
        }(r || (r = {}));
        var rt,
          nt = r || (r = {}),
          at = nt.G || (nt.G = {}),
          ot = at.bc || (at.bc = {}),
          ht = ot.C || (ot.C = {});
        ht.k4 = /*#__PURE__*/function () {
          function _class28() {
            _classCallCheck(this, _class28);
          }
          return _createClass(_class28);
        }(), function (t) {
          var e, i;
          e = t.G || (t.G = {}), function (e) {
            e.QS = /*#__PURE__*/function () {
              function _class29() {
                _classCallCheck(this, _class29);
              }
              _createClass(_class29, [{
                key: "Sa",
                value: function Sa() {
                  var t = {};
                  return a.U(this.eb) || (t.pages = this.eb.map(function (t) {
                    return t.Sa();
                  })), a.U(this.rows) || (t.rows = this.rows.map(function (t) {
                    return t.Sa();
                  })), a.U(this.za) || (t.columns = this.za.map(function (t) {
                    return t.Sa();
                  })), a.U(this.Ia) || (t.measures = this.Ia.map(function (t) {
                    return t.Sa();
                  })), a.U(this.ze) || (t.flatOrder = this.ze.slice()), a.U(this.Fe) || (t.sorting = this.Fe), t;
                }
              }]);
              return _class29;
            }();
            var i = /*#__PURE__*/function () {
              function i() {
                _classCallCheck(this, i);
              }
              _createClass(i, [{
                key: "Sa",
                value: function Sa() {
                  var t = {};
                  return a.U(this.j) || (t.uniqueName = this.j), a.U(this.Fa) || (t.aggregation = this.Fa), a.U(this.nx) || (t.activeLevelName = this.nx), t;
                }
              }], [{
                key: "fy",
                value: function fy(t) {
                  var e = new i();
                  return e.j = t.j, t.Wd && (e.Fa = t.Fa, e.Xy = t.Xy), t.Of && (e.nx = t.j, e.j = t.XD), e;
                }
              }]);
              return i;
            }();
            e.Aw = i;
            var s = /*#__PURE__*/function () {
              function s() {
                _classCallCheck(this, s);
              }
              _createClass(s, null, [{
                key: "LC",
                value: function LC(t) {
                  var e = [];
                  for (var _i44 = 0; _i44 < t.length; _i44++) e.push(s.lW(t[_i44]));
                  return e;
                }
              }, {
                key: "lW",
                value: function lW(i) {
                  var _s91 = new e.Bq();
                  var r = i.te;
                  return 0 != i.te.length || i.La || (r = t.u.i.ca.sq), _s91.j = i.j, _s91.caption = i.caption, _s91.name = i.$n, _s91.type = i.type, _s91.Fa = i.Fa, _s91.La = i.La, _s91.folder = i.folder, _s91.te = r, _s91.rV = t.u.i.ca.tK(r), _s91.BK = t.u.i.ca.aV(r), _s91;
                }
              }]);
              return s;
            }();
            e.Bq = s;
          }((i = e.bc || (e.bc = {})).C || (i.C = {}));
        }(r || (r = {})), function (t) {
          var s;
          !function (t) {
            var s = /*#__PURE__*/function (_i$ya) {
              _inherits(s, _i$ya);
              var _super98 = _createSuper(s);
              function s() {
                var _this152;
                _classCallCheck(this, s);
                _this152 = _super98.call(this, "div"), _this152.jz = function (t) {
                  return _this152.$E(t);
                }, _this152.list = new i.Zc.Mh(), _this152.list.Si = !0, _this152.list.$g(_this152.Sn), _this152.list.wg("caption"), _this152.list.addEventListener(e.ga.oe, function (t) {
                  return _this152.jv(t);
                }), _this152.R(_this152.list), _this152.B.Hi();
                var t = new i.ia("div", "wdr-arrow");
                _this152.B.R(t);
                return _this152;
              }
              _createClass(s, [{
                key: "Bv",
                value: function Bv(t, e) {
                  this.origin = e, this.Vx = t, this.setData(t), this.show(), this.B.addEventListener("mouseleave", this.jz), document.body.addEventListener("mousedown", this.jz), t = e.Dj(this.B.element.offsetParent), this.B.ha("right", this.B.element.offsetParent.clientWidth - t.left + "px"), this.B.ha("top", t.top - this.Xc() / 2 + e.Xc() / 2 + "px");
                }
              }, {
                key: "$E",
                value: function $E(t) {
                  "mousedown" == t.type && null != i.ia.Ga(t.target).closest("#wdr-aggregations-view") || (this.B.removeEventListener("mouseleave", this.jz), document.body.removeEventListener("mousedown", this.jz), this.Da());
                }
              }, {
                key: "hF",
                value: function hF(t) {
                  null == i.ia.Ga(t.target).closest("#wdr-aggregations-view") && this.Da();
                }
              }, {
                key: "setData",
                value: function setData(t) {
                  for (var e, i = 0, _s92 = [], r = 0; r < t.te.length; r++) e = {
                    caption: t.rV[r],
                    Fa: t.te[r]
                  }, null != t.BK && (e.P3 = t.BK[r]), _s92.push(e), t.te[r] == t.Fa && (i = r);
                  this.list.vg(_s92), this.list.io(i), this.list.B.HF(0);
                }
              }, {
                key: "jv",
                value: function jv(t) {
                  this.Oa(e.ga.oe, this, {
                    Vx: this.Vx,
                    rK: t.data.Zg,
                    origin: this.origin
                  }), this.Da();
                }
              }, {
                key: "Sn",
                value: function Sn(t, e) {
                  var _s93 = new i.yf.dB();
                  return _s93.setData(t), _s93.al(e), _s93;
                }
              }]);
              return s;
            }(i.ya);
            t.gG = s;
          }((s = t.G || (t.G = {})).bc || (s.bc = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.G || (t.G = {}), function (e) {
            var s = /*#__PURE__*/function () {
              function s() {
                _classCallCheck(this, s);
              }
              _createClass(s, [{
                key: "update",
                value: function update(t, e, i) {
                  this.oa = t, this.ab = e, this.Uq = i, this.MK(), this.NP(), this.aG();
                }
              }, {
                key: "NP",
                value: function NP() {
                  this.eb = this.Qu(), this.rows = this.Ru(), this.FN(this.rows), this.za = this.Ku(), this.FN(this.za), this.Ia = this.Pu(), this.k_(this.Ia);
                }
              }, {
                key: "aG",
                value: function aG() {
                  if (this.Aa = [], this.bb = [], this.KU(this.Aa, this.Gu()), this.b2(this.Aa), this.OU(this.Aa, this.Gn()), this.NF(this.Aa), s.jD) {
                    s.jD = !1;
                    var e = this.Aa.find(function (e) {
                      return e.j === "/" + t.model.v.g.hH;
                    });
                    null != e && this.JL(e);
                  }
                  this.Si(this.eb), this.Si(this.za), this.Si(this.rows), this.Si(this.Ia);
                }
              }, {
                key: "Rp",
                value: function Rp(t) {
                  if (null != this.oa) {
                    var e = this.Gn().find(function (e) {
                      return e.j === t;
                    });
                    if (null != e) {
                      e.Wd = !0, e.Wf = this.Ip;
                      var _i45 = this.Ia.findIndex(function (e) {
                        return e.j === t;
                      });
                      0 <= _i45 ? (e.Xy = !0, this.Ia[_i45] = e) : this.Ia.push(e);
                    }
                    this.aG();
                  }
                }
              }, {
                key: "Sp",
                value: function Sp() {
                  null != this.ab && null != this.oa && (this.NP(), this.aG());
                }
              }, {
                key: "FN",
                value: function FN(e) {
                  null != (e = e.find(function (e) {
                    return e.j === t.u.Ja.re;
                  })) && (e.caption = t.model.v.g.IA, e.sE = !0);
                }
              }, {
                key: "k_",
                value: function k_(e) {
                  for (var i = 0; i < e.length; i++) e[i].Wd = !0, e[i].Wf = t.model.A.P.Wf;
                }
              }, {
                key: "Si",
                value: function Si(t) {
                  for (var e, i = 0; i < t.length; i++) t[i].qc = !0, e = this.WL(t[i].j, t[i].Wd), this.ab.bb().getItem(t[i].j), null != e && this.Vf(e, !0);
                }
              }, {
                key: "Vf",
                value: function Vf(t, e) {
                  if (t.qc = e, null != t.parent && t.parent.qc != e && (1 == e || 0 == this.hZ(t.parent.children)) && this.Vf(t.parent, e), t.isLevelFolder && 0 == e) for (var i = 0; i < t.children.length; i++) this.Vf(t.children[i], e);
                }
              }, {
                key: "hZ",
                value: function hZ(t) {
                  for (var e = 0; e < t.length; e++) if (!0 === t[e].qc) return !0;
                  return !1;
                }
              }, {
                key: "KU",
                value: function KU(e, i) {
                  for (var _s94, r, n, a = 0; a < i.length; a++) null != (n = this.oa.og(i[a].j)) && n.type != t.u.types.Ca.Hb && "" != i[a].folder ? (null == (r = this.bb.find(function (t) {
                    return t.j === "[Folder]." + i[a].folder;
                  })) && ((r = {
                    Vd: !0
                  }).j = "Folder." + i[a].folder, r.caption = i[a].folder, r.children = [], e.push(r), this.bb.push(r)), i[a].level = 1, i[a].parent = r, r.children.push(i[a])) : (null == (_s94 = e.find(function (t) {
                    return t.j === i[a].$C;
                  })) && ((_s94 = {
                    Vd: !0
                  }).j = i[a].$C, _s94.caption = i[a].tL, _s94.children = [], _s94.level = 0, e.push(_s94), this.bb.push(_s94)), i[a].Of ? (n = (n = "" == i[a].folder ? _s94 : r).children.find(function (t) {
                    return t.j === i[a].XD;
                  }), i[a].level = n.level + 1, i[a].parent = n, null == n.children && (n.children = []), n.children.push(i[a]), n.Ug = !0) : "" != i[a].folder ? (null == (r = _s94.children.find(function (t) {
                    return t.j === _s94.j + i[a].folder;
                  })) && ((r = {
                    Vd: !0
                  }).j = _s94.j + i[a].folder, r.caption = i[a].folder, r.children = [], r.level = 1, r.parent = _s94, _s94.children.push(r), this.bb.push(r)), i[a].level = 2, i[a].parent = r, r.children.push(i[a])) : (i[a].level = 1, i[a].parent = _s94, _s94.children.push(i[a]))), this.bb.push(i[a]);
                }
              }, {
                key: "OU",
                value: function OU(e, i) {
                  for (var _s95, r = {}, n = 0; n < i.length; n++) {
                    if (i[n].Wd = !0, i[n].Wf = t.model.A.P.Wf, i[n].La && (i[n].SD = t.model.v.g.hH), this.Ip) {
                      var o = this.DP(i[n].j);
                      _s95 = this.bb.find(function (t) {
                        return t.j === o && !t.Vd;
                      });
                    }
                    if (this.Ip && null != _s95) _s95.vf = i[n], _s95.vf.ZM = _s95, i[n].parent = _s95.parent;else if (a.U(i[n].SD) || "" === i[n].SD) i[n].level = 0, e.push(i[n]);else {
                      var h = this.NU(r, i[n].SD, i[n].folder.split("\\"), i[n].La),
                        l = h.folder;
                      null != l && 0 > l.children.indexOf(i[n]) && l.children.push(i[n]), null != h.root && 0 > e.indexOf(h.root) && e.push(h.root), i[n].level = h.folder.level + 1, i[n].parent = l;
                    }
                    this.bb.push(i[n]);
                  }
                }
              }, {
                key: "NU",
                value: function NU(t, e, i) {
                  var _s96 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                  i.unshift(e), e = "";
                  for (var r, n, o, h = 0, l = 0; l < i.length; l++) {
                    var A = e + "/" + i[l];
                    a.Vb(i[l]) || (null == (n = t[A]) && ((n = {}).caption = i[l], n.j = A, n.folder = e, n.children = [], n.level = h, n.Vd = !0, n.Rn = !0, n.uZ = _s96, this.bb.push(n), t[n.j] = n), (n.parent = r) && r.children && 0 > r.children.indexOf(n) && r.children.push(n), null == o && (o = n), t = t[e += "/" + i[l]], r = n, h++);
                  }
                  return {
                    folder: n,
                    root: o
                  };
                }
              }, {
                key: "b2",
                value: function b2(t) {
                  for (var e, i = 0; i < t.length; i++) if (!0 === t[i].Vd && 1 == t[i].children.length && !0 !== t[i].children[0].Vd && !t[i].children[0].La && ((e = t[i].children[0]).level = 0, e.parent = null, t.splice(i, 1, e), e.children)) for (var _s97 = 0; _s97 < e.children.length; _s97++) --e.children[_s97].level;
                }
              }, {
                key: "NF",
                value: function NF(t) {
                  var _this153 = this;
                  t.sort(function (t, e) {
                    var i = _this153.wM(t),
                      _s98 = _this153.wM(e);
                    return i == _s98 ? t.caption.localeCompare(e.caption) : _s98 - i;
                  });
                }
              }, {
                key: "wM",
                value: function wM(t) {
                  return !0 === t.isLevel ? 0 : !0 === t.Vd && !0 !== t.Rn ? 3 : !0 !== t.Vd && !0 !== t.Wd ? 2 : !0 === t.Vd && !0 === t.Rn ? 1 : 0;
                }
              }, {
                key: "OK",
                value: function OK(t) {
                  if (!this.Mp) {
                    for (var e = this.Aa.indexOf(t) + 1, i = 0; i < t.children.length; i++) !0 === t.children[i].Nf && this.OK(t.children[i]);
                    this.Aa.splice(e, t.children.length), t.Nf = !1;
                  }
                }
              }, {
                key: "JL",
                value: function JL(t) {
                  if (!this.Mp) {
                    var e = this.Aa.indexOf(t) + 1;
                    t.Ug || this.NF(t.children), a.sa.pm(this.Aa, t.children, e), t.Nf = !0;
                  }
                }
              }, {
                key: "DP",
                value: function DP(t) {
                  return null != (t = this.oa.Zh(t)) ? t.j : "";
                }
              }, {
                key: "J3",
                value: function J3(t) {
                  return null != (t = this.oa.og(t)) ? t.j : "";
                }
              }, {
                key: "Fn",
                value: function Fn(t) {
                  for (var e = 0; e < this.bb.length; e++) if (!this.bb[e].Wd && !this.bb[e].Vd && this.bb[e].j == t) return this.bb[e];
                }
              }, {
                key: "we",
                value: function we(t) {
                  for (var e = 0; e < this.bb.length; e++) if (this.bb[e].Wd && !this.bb[e].Vd && this.bb[e].j == t) return this.bb[e];
                }
              }, {
                key: "WL",
                value: function WL(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  return e ? this.we(t) : this.Fn(t);
                }
              }, {
                key: "qE",
                value: function qE() {
                  return 0 < this.Ia.length;
                }
              }, {
                key: "OD",
                value: function OD() {
                  var t = new i.C.QS();
                  if (t.eb = this.eb.map(function (t) {
                    return i.C.Aw.fy(t);
                  }), t.rows = this.rows.map(function (t) {
                    return i.C.Aw.fy(t);
                  }), t.za = this.za.map(function (t) {
                    return i.C.Aw.fy(t);
                  }), t.Ia = this.Ia.map(function (t) {
                    return i.C.Aw.fy(t);
                  }), t.ze = this.ab ? this.ab.ze : [], this.ab) {
                    if (this.ab.zb.xg) {
                      var e = this.ab.zb.Sa();
                      void 0 === t.Fe && (t.Fe = {}), t.Fe.row = e.sort;
                    }
                    this.ab.nb.xg && (e = this.ab.nb.Sa(), void 0 === t.Fe && (t.Fe = {}), t.Fe.column = e.sort);
                  }
                  return t;
                }
              }, {
                key: "oE",
                value: function oE(t) {
                  return null == this.ab || this.$y(t.eb, this.ab.eb.Tc()) || this.$y(t.rows, this.ab.rows.Tc()) || this.$y(t.za, this.ab.za.Tc()) || this.$y(t.Ia, this.ab.pa.Tc());
                }
              }, {
                key: "GP",
                value: function GP(t) {
                  for (var e, i = [], _s99 = 0; _s99 < t.length; _s99++) e = {
                    uniqueName: t[_s99].j
                  }, t[_s99].Wd && (e.aggregation = t[_s99].Fa, e.isChanged = t[_s99].Xy), t[_s99].isLevel && (e.activeLevelName = t[_s99].uniqueName, e.uniqueName = t[_s99].hierarchyName), i.push(e);
                  return i;
                }
              }, {
                key: "$y",
                value: function $y(t, e) {
                  if (t.length != e.length) return !0;
                  for (var i = 0; i < e.length; i++) if (t[i].j != e[i].j || t[i].Fa != e[i].Fa || t[i].nx != e[i].nx || t[i].Xy) return !0;
                  return !1;
                }
              }, {
                key: "Ip",
                get: function get() {
                  var e = this.Uq;
                  return e == t.u.i.Te.jl || e == t.u.i.Te.JSON;
                }
              }, {
                key: "az",
                get: function get() {
                  for (var t = 0; t < this.Aa.length; t++) if ((this.Aa[t].Vd || this.Aa[t].Rn || this.Aa[t].Ug) && !this.Aa[t].Nf) return !0;
                  return !1;
                }
              }, {
                key: "WM",
                get: function get() {
                  for (var t = 0; t < this.Aa.length; t++) if (this.Aa[t].Vd || this.Aa[t].Rn || this.Aa[t].Ug) return !0;
                  return !1;
                }
              }, {
                key: "NK",
                value: function NK() {
                  if (!this.Mp) {
                    for (var t = 0; t < this.Aa.length; t++) (this.Aa[t].Vd || this.Aa[t].Rn || this.Aa[t].Ug) && (this.Aa[t].Nf = !1);
                    var e = [];
                    for (t = 0; t < this.Aa.length; t++) 0 == this.Aa[t].level && e.push(this.Aa[t]);
                    this.Aa.splice(0, this.Aa.length), a.sa.pm(this.Aa, e, 0);
                  }
                }
              }, {
                key: "oc",
                value: function oc() {
                  if (!this.Mp) {
                    this.NK();
                    for (var t = 0; t < this.Aa.length; t++) (this.Aa[t].Vd || this.Aa[t].Ug) && this.ST(this.Aa[t], t + 1);
                  }
                }
              }, {
                key: "ST",
                value: function ST(t, e) {
                  t.Nf = !0, null != t.children && 0 < t.children.length && (this.NF(t.children), a.sa.pm(this.Aa, t.children, e));
                }
              }, {
                key: "Qu",
                value: function Qu() {
                  return null != this.ab ? this.Hx(this.ab.eb) : [];
                }
              }, {
                key: "Ru",
                value: function Ru() {
                  return null != this.ab ? this.Hx(this.ab.rows) : [];
                }
              }, {
                key: "Ku",
                value: function Ku() {
                  return null != this.ab ? this.Hx(this.ab.za) : [];
                }
              }, {
                key: "Pu",
                value: function Pu() {
                  return null != this.ab ? i.C.Bq.LC(this.ab.pa.Tc()) : [];
                }
              }, {
                key: "Gu",
                value: function Gu() {
                  return null != this.oa ? this.Hx(this.oa.bb(!1), !0) : [];
                }
              }, {
                key: "Gn",
                value: function Gn() {
                  return null != this.oa ? i.C.Bq.LC(this.oa.pa.Tc()) : [];
                }
              }, {
                key: "Hx",
                value: function Hx(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  var _s100 = [];
                  for (var r = 0; r < t.length; r++) {
                    var _o = t.F(r);
                    var n = new i.C.Bq(),
                      a = this.oa.og(_o.j);
                    if (n.caption = _o.caption, n.j = _o.j, n.$C = _o.xj.j, n.tL = _o.xj.caption, n.folder = _o.folder, n.Of = !1, n.Ug = _o.Rk && e, n.nE = !!a && a.nE(), _s100.push(n), _o.Rk && e) for (n = 0; n < _o.Fb.length; n++) {
                      if (0 == n) continue;
                      a = _o.Fb.F(n);
                      var _t2 = new i.C.Bq();
                      _t2.j = a.j, _t2.caption = a.caption, _t2.$C = _o.xj.j, _t2.tL = _o.xj.caption, _t2.folder = _o.folder, _t2.XD = _o.j, _t2.kZ = _o.caption, _t2.Of = !0, _t2.Ug = !1, _s100.push(_t2);
                    }
                  }
                  return _s100;
                }
              }, {
                key: "search",
                value: function search(t) {
                  if (t = t.toLowerCase(), this.hf != t) {
                    this.hf = t, this.Tz = [];
                    for (var e = this.bb.length, i = 0; i < e; i++) {
                      var _s101 = this.bb[i];
                      _s101.Vd || _s101.Wd && this.Ip || !a.$.contains(_s101.caption, t) || (this.UU(_s101, this.Tz), this.Tz.push(_s101));
                    }
                  }
                }
              }, {
                key: "UU",
                value: function UU(t, e) {
                  if (t.parent && 0 > e.indexOf(t.parent)) {
                    for (var i = []; null != t.parent;) i.push(t.parent), t = t.parent;
                    for (i = i.reverse(), t = 0; t < i.length; t++) 0 > e.indexOf(i[t]) && e.push(i[t]);
                  }
                }
              }, {
                key: "MK",
                value: function MK() {
                  this.hf = "", this.Tz = null;
                }
              }, {
                key: "Mp",
                get: function get() {
                  return !a.Vb(this.hf);
                }
              }, {
                key: "UZ",
                get: function get() {
                  return this.bb && 50 < this.bb.length;
                }
              }, {
                key: "tZ",
                get: function get() {
                  return t.model.A.P.bP;
                }
              }, {
                key: "va",
                get: function get() {
                  return this.Mp ? this.Tz : this.Aa;
                }
              }]);
              return s;
            }();
            s.jD = !1, e.pI = s;
          }((i = e.bc || (e.bc = {})).ln || (i.ln = {}));
        }(r || (r = {})), function (t) {
          var s, r;
          s = t.G || (t.G = {}), function (n) {
            var o = /*#__PURE__*/function (_e$Od18) {
              _inherits(o, _e$Od18);
              var _super99 = _createSuper(o);
              function o(t) {
                var _this154;
                _classCallCheck(this, o);
                _this154 = _super99.call(this), _this154.type = "pivot", _this154.pr = function (t) {
                  return _this154.Rp(t);
                }, _this154.nu = function (t) {
                  return _this154.Sp(t);
                }, _this154.model = new n.pI(), _this154.view = new n.pS(_assertThisInitialized(_this154), t), _this154.view.addEventListener(e.ga.CLOSED, function (t) {
                  return _this154.na(t);
                }), _this154.Zc = [_this154.view.Ah, _this154.view.rg, _this154.view.Wg, _this154.view.zd], _this154.view.Gd && _this154.view.Gd.addEventListener(i.Wb.Se, function () {
                  return _this154.Vp();
                }), _this154.view.Ke && _this154.view.Ke.addEventListener(i.Wb.Se, function () {
                  return _this154.Tp();
                }), null != _this154.view.oh && _this154.view.oh.addEventListener(e.ga.oe, function (t) {
                  return _this154.I_(t);
                }), _this154.view.gb && (_this154.view.gb.B.addEventListener("click", function (t) {
                  return _this154.UE(t);
                }), _this154.view.gb.zj({
                  sg: function sg(t) {
                    return _this154.A0(t);
                  },
                  os: function os(t, e) {
                    return _this154.YN(t, e);
                  },
                  Oj: function Oj(t, e) {
                    return _this154.YN(t, e);
                  },
                  Qf: function Qf(t, e, i, s) {
                    return _this154.Qf(t, e, i, s);
                  },
                  Tn: "li"
                }), _this154.view.gb.B.Hi()), t = {
                  sg: function sg(t, e, i, s) {
                    return _this154.sg(t, e, i, s);
                  },
                  os: function os(t, e, i, s) {
                    return _this154.Up(t, e, i, s);
                  },
                  Oj: function Oj(t, e, i, s) {
                    return _this154.Up(t, e, i, s);
                  },
                  Qf: function Qf(t, e, i, s) {
                    return _this154.Qf(t, e, i, s);
                  },
                  Tn: "li"
                }, _this154.view.Ah && (_this154.view.Ah.zj(t), _this154.view.Ah.B.addEventListener("dblclick", function (t) {
                  return _this154.qz(t);
                }), _this154.view.Ah.B.Hi()), _this154.view.rg && (_this154.view.rg.zj(t), _this154.view.rg.B.addEventListener("dblclick", function (t) {
                  return _this154.qz(t);
                }), _this154.view.rg.B.Hi()), _this154.view.Wg && (_this154.view.Wg.zj(t), _this154.view.Wg.B.addEventListener("dblclick", function (t) {
                  return _this154.qz(t);
                }), _this154.view.Wg.B.Hi()), _this154.view.zd && (_this154.view.zd.B.addEventListener("click", function (t) {
                  return _this154.K0(t);
                }), _this154.view.zd.B.addEventListener("dblclick", function (t) {
                  return _this154.qz(t);
                }), _this154.view.zd.zj(t), _this154.view.zd.B.Hi()), _this154.view.Sh && _this154.view.Sh.addEventListener(i.Wb.Se, function () {
                  return _this154.JE();
                }), _this154.view.rj && _this154.view.rj.addEventListener(i.Wb.Se, function () {
                  return _this154.X_();
                }), _this154.view.Jj && (_this154.view.Jj.MO(500), _this154.view.Jj.addEventListener(i.zl.gi, function () {
                  return _this154.i1();
                }));
                return _this154;
              }
              _createClass(o, [{
                key: "Tp",
                value: function Tp() {
                  this.view.close();
                }
              }, {
                key: "Vp",
                value: function Vp() {
                  this.xk(), this.view.close();
                }
              }, {
                key: "i1",
                value: function i1() {
                  this.model.search(this.view.Jj.Gj()), this.view.gb.B.Va("wdr-searched", this.model.Mp), this.view.gb.vg(this.model.va), this.dh(this.view.gb), this.view.rj && this.view.rj.isVisible(this.model.WM && !this.model.Mp);
                }
              }, {
                key: "xk",
                value: function xk() {
                  var e = this.model.OD();
                  this.model.oE(e) && (e = t.u.oa.lh.Za(t.model.kb.Kh.Za(e.Sa()), this.model.oa), this.Oa(r.ck.Bo, this, e));
                }
              }, {
                key: "Rp",
                value: function Rp(e) {
                  t.model.yb.V().removeEventListener(s.La.Df.Aq, this.pr), this.model.Rp(e.data.JN), this.dj();
                }
              }, {
                key: "Sp",
                value: function Sp(e) {
                  t.model.yb.V().removeEventListener(s.La.Df.ct, this.nu), this.model.Sp(e.data), this.dj();
                }
              }, {
                key: "JE",
                value: function JE() {
                  t.model.yb.V().Oa(s.kf.Xs), t.model.yb.V().addEventListener(s.La.Df.Aq, this.pr);
                }
              }, {
                key: "X_",
                value: function X_() {
                  this.model.az ? this.model.oc() : this.model.NK(), this.dh(this.view.gb), this.view.Tj();
                }
              }, {
                key: "qz",
                value: function qz(t) {
                  var e = i.ia.Ga(t.target).closest("ul");
                  null != e && (e = this.Bp(e.ja("id")), null != (t = i.ia.Ga(t.target).closest("li")) && (t = parseInt(t.ja("data-index")), this.pO(e, t)));
                }
              }, {
                key: "K0",
                value: function K0(t) {
                  var e = i.ia.Ga(t.target).closest("li");
                  null != e && (e = parseInt(e.ja("data-index")), e = this.model.Ia[e], "wdr-aggr-display" == i.ia.Ga(t.target).ja("id") && this.view.oh.Bv(e, i.ia.Ga(t.target)));
                }
              }, {
                key: "I_",
                value: function I_(e) {
                  var s = e.data.Vx,
                    r = e.data.rK;
                  i.ia.Ga(e.data.origin), s.Fa = r.Fa, s.caption = t.model.A.P.bA ? a.$.bind(r.P3, s.name) : s.name, this.view.zd.Zj(s), null != (e = this.model.va.find(function (t) {
                    return t.j === s.j;
                  })) && (this.model.Ip && null != e.vf && (e = e.vf), e.Fa = s.Fa, e.caption = s.caption, this.view.gb.Zj(e));
                }
              }, {
                key: "UE",
                value: function UE(e) {
                  var r = i.ia.Ga(e.target).closest("li");
                  if (null != r) {
                    r = parseInt(r.ja("data-index"));
                    var n = this.model.va[r];
                    if ("wdr-aggr-display" == i.ia.Ga(e.target).ja("id")) this.view.oh.Bv(n, i.ia.Ga(e.target));else if ("wdr-calc-display" == i.ia.Ga(e.target).ja("id")) t.model.yb.V().Oa(s.kf.Xs, null, {
                      IN: n.j
                    }), t.model.yb.V().addEventListener(s.La.Df.Aq, this.pr), t.model.yb.V().addEventListener(s.La.Df.ct, this.nu);else if (n.Vd || n.Ug && "wdr-moreicon-display" != i.ia.Ga(e.target).ja("id")) !0 === n.Nf ? this.model.OK(n) : this.model.JL(n), this.dh(this.view.gb), this.view.Tj();else {
                      if (1 == n.qc || null != n.vf && 1 == n.vf.qc) 1 == n.qc && (this.model.Vf(n, !1), this.En(n)), null != n.vf && 1 == n.vf.qc && (this.model.Vf(n.vf, !1), this.En(n.vf));else if (n.Wd) this.model.Vf(n, !0), this.model.Ia.push(n), this.dh(this.view.zd);else if (n.vf && n.vf.type != t.u.types.Ca.Hb && n.vf.type != t.u.types.Ca.jc) this.model.Vf(n.vf, !0), this.model.Ia.push(n.vf), this.dh(this.view.zd);else {
                        if (n.Of) for (n.parent.qc && this.En(n.parent), e = 0; e < n.parent.children.length; e++) {
                          var a = n.parent.children[e];
                          a.j != n.j && (a.qc && this.En(a), a.qc = !1);
                        }
                        this.model.Vf(n, !0), this.model.rows.push(n), this.dh(this.view.rg);
                      }
                      this.OP(this.view.gb, r), this.qq();
                    }
                  }
                }
              }, {
                key: "OP",
                value: function OP(t, e) {
                  if (t.fl(e), null != (e = t.Qb()[e]).parent && this.Pv(t, e.parent), e.Ug) for (var i = 0; i < e.children.length; i++) t.Zj(e.children[i]);
                  if (e.Of) for (i = 0; i < e.parent.children.length; i++) t.Zj(e.parent.children[i]);
                }
              }, {
                key: "Pv",
                value: function Pv(t, e) {
                  if (t.Zj(e), e.parent && this.Pv(t, e.parent), e.Ug) for (var i = 0; i < e.children.length; i++) t.Zj(e.children[i]);
                  if (e.Of) for (i = 0; i < e.parent.children.length; i++) t.Zj(e.parent.children[i]);
                }
              }, {
                key: "ps",
                value: function ps() {
                  return !0;
                }
              }, {
                key: "A0",
                value: function A0(t) {
                  if (t && t.closest("ul")) {
                    var e = parseInt(t.ja("data-index"));
                    (t = this.Bp(t.closest("ul").ja("id"))) != this.view.gb && this.pO(t, e);
                  }
                }
              }, {
                key: "YN",
                value: function YN(t, e) {
                  t && t.closest("ul") && (t = this.Bp(t.closest("ul").ja("id"))) != this.view.gb && (t.B.Pc("wdr-droppable") ? e && e.Y("wdr-droppable-valid") : e && e.Y("wdr-droppable-invalid"));
                }
              }, {
                key: "Up",
                value: function Up(t, e, s, r) {
                  this.Dh(), t && t.closest("ul") && (s instanceof i.Zc.Mh || (s = this.Bp(s.ja("id"))), (e = this.Bp(t.closest("ul").ja("id"))).B.Pc("wdr-droppable") && this.fN(this.nM(t, e), e, s) && (r instanceof MouseEvent ? this.ko(i.ia.Ga(r.target)) : (t = r.changedTouches[0], this.ko(i.ia.Ga(document.elementFromPoint(t.clientX, t.clientY))))));
                }
              }, {
                key: "fN",
                value: function fN(t, e, i) {
                  return !(t.sE && i != this.view.Wg && i != this.view.rg || 0 == this.model.Ip && (i != this.view.zd && t.Wd || i == this.view.zd && !t.Wd) || t.La && i != this.view.zd) && (i = i.Qb().find(function (e) {
                    return e.j === t.j;
                  }), e != this.view.gb || null == i);
                }
              }, {
                key: "nM",
                value: function nM(t, e) {
                  return t = parseInt(t.ja("data-index")), e.Qb()[t];
                }
              }, {
                key: "Qf",
                value: function Qf(t, e) {
                  this.Dh(), t && t.closest("ul") && e && (e.qd("wdr-droppable-valid"), e.qd("wdr-droppable-invalid"));
                }
              }, {
                key: "sg",
                value: function sg(t, e, s) {
                  if (this.Dh(), t && t.closest("ul")) {
                    e instanceof i.Zc.Mh || (e = this.Bp(e.ja("id")));
                    var r = this.Bp(t.closest("ul").ja("id"));
                    0 != this.fN(this.nM(t, r), r, e) && (s = s ? parseFloat(s.ja("data-index")) : e.Qb().length, t = parseInt(t.ja("data-index")), r != e || t != s) && (r == this.view.gb && e != this.view.gb ? this.DU(r, e, t, s) : this.w_(r, e, t, s), this.PP());
                  }
                }
              }, {
                key: "ko",
                value: function ko(t) {
                  var e = t.closest("li");
                  null != e ? (this.Xb = this.Yl(), e.before(this.Xb)) : null != (t = t.closest("ul")) && (this.Xb = this.Yl(), 0 < t.element.children.length ? t.append(this.Xb) : t.prepend(this.Xb));
                }
              }, {
                key: "Yl",
                value: function Yl() {
                  return new i.ia("div", "wdr-drop-indicator");
                }
              }, {
                key: "Dh",
                value: function Dh() {
                  this.Xb && (this.Xb.Wi(!0), this.Xb = null);
                }
              }, {
                key: "w_",
                value: function w_(t, e, i, s) {
                  if (t.Qb(), t == e) i < s && --s, (t = e.Qb()).splice(s, 0, t.splice(i, 1)[0]);else {
                    var r = t.Qb()[i];
                    t.Qb().splice(i, 1), t.so(), e == this.view.zd && (this.model.Vf(r, !1), r = this.model.we(this.model.J3(r.j))), t == this.view.zd && (this.model.Vf(r, !1), r = this.model.Fn(this.model.DP(r.j))), null != r && (this.model.Vf(r, !0), this.En(r), e.Qb().splice(s, 0, r));
                  }
                  this.dh(e), this.qq();
                }
              }, {
                key: "DU",
                value: function DU(t, e, i, s) {
                  var r = t.Qb()[i];
                  if (r.Of) {
                    for (r.parent.qc && this.En(r.parent), i = 0; i < r.parent.children.length; i++) {
                      var n = r.parent.children[i];
                      n.j != r.j && (n.qc && this.En(n), n.qc = !1);
                    }
                    this.Pv(this.view.gb, r);
                  }
                  this.model.Ip && e == this.view.zd && null != r.vf && (r = r.vf), r.qc ? (this.model.Vf(r, !1), this.En(r, t, !0), this.model.Vf(r, !0)) : (this.model.Vf(r, !0), t = this.view.gb.Qb().findIndex(function (t) {
                    return t.j === r.j;
                  }), this.OP(this.view.gb, t), this.view.gb.fl(t)), e.Qb().splice(s, 0, r), this.dh(e), this.qq();
                }
              }, {
                key: "pO",
                value: function pO(t, e) {
                  if (!(t.Qb().length <= e)) {
                    var i = t.Qb()[e];
                    i.sE || (t.Qb().splice(e, 1), this.dh(t), null != (t = this.model.WL(i.j, i.Wd)) && (this.model.Vf(t, !1), this.Pv(this.view.gb, null != t.ZM ? t.ZM : t), t.Of && (this.model.Vf(t.parent, !1), this.Pv(this.view.gb, t.parent))), this.qq());
                  }
                }
              }, {
                key: "En",
                value: function En(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  for (var s = -1, r = 0; r < this.Zc.length; r++) this.Zc[r] == e || this.Zc[r] == this.view.zd && i || (-1 == (s = this.Zc[r].Qb().findIndex(function (e) {
                    return e.j === t.j;
                  })) && (s = this.Zc[r].Qb().findIndex(function (e) {
                    return e.XD === t.j;
                  })), -1 < s && (this.Zc[r].Qb().splice(s, 1), this.dh(this.Zc[r])));
                }
              }, {
                key: "Bp",
                value: function Bp(t) {
                  switch (t) {
                    case this.view.gb.Nu():
                      return this.view.gb;
                    case this.view.Ah.Nu():
                      return this.view.Ah;
                    case this.view.rg.Nu():
                      return this.view.rg;
                    case this.view.Wg.Nu():
                      return this.view.Wg;
                    case this.view.zd.Nu():
                      return this.view.zd;
                  }
                  return null;
                }
              }, {
                key: "update",
                value: function update(t, e) {
                  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
                  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
                  s && this.model.update(t, e, i), this.dj();
                }
              }, {
                key: "qq",
                value: function qq() {
                  this.view.Gd && this.view.Gd.Xz(this.model.qE());
                }
              }, {
                key: "az",
                get: function get() {
                  return this.model.az;
                }
              }, {
                key: "dj",
                value: function dj() {
                  var _this155 = this;
                  this.view.reset && this.view.reset(), this.view.Sh && this.view.Sh.isVisible(this.model.tZ), this.view.gb && this.view.gb.vg(this.model.va, !1), this.view.Ah && this.view.Ah.vg(this.model.eb, !1), this.view.rg && this.view.rg.vg(this.model.rows, !1), this.view.Wg && this.view.Wg.vg(this.model.za, !1), this.view.zd && this.view.zd.vg(this.model.Ia, !1), this.view.rj && this.view.rj.isVisible(this.model.WM), this.view.tg && this.view.tg.isVisible(this.model.UZ), this.view.Jj && (this.view.Jj.clear(!1), this.model.MK()), this.view.Tj(), this.view.B.requestAnimationFrame(function () {
                    _this155.PP();
                  });
                }
              }, {
                key: "dh",
                value: function dh(t) {
                  var _this156 = this;
                  t.so();
                  var e = {
                    ps: function ps(t) {
                      return _this156.ps(t);
                    },
                    Ei: function Ei(t) {
                      return _this156.view.Ei(t);
                    }
                  };
                  a.Wc().pg && (e.Ny = "#wdr-drag-handle");
                  var i = t.B.find("li", !0);
                  if (t == this.view.gb) for (t = 0; t < i.length; t++) i[t].Pc("wdr-folder") && !i[t].Pc("wdr-level-folder") || i[t].draggable(e);else for (t.zj({
                    sg: function sg(t, e, i, s) {
                      return _this156.sg(t, e, i, s);
                    },
                    os: function os(t, e, i, s) {
                      return _this156.Up(t, e, i, s);
                    },
                    Oj: function Oj(t, e, i, s) {
                      return _this156.Up(t, e, i, s);
                    },
                    Qf: function Qf(t, e, i, s) {
                      return _this156.Qf(t, e, i, s);
                    },
                    Tn: "li"
                  }), t = 0; t < i.length; t++) i[t].draggable(e);
                }
              }, {
                key: "PP",
                value: function PP() {
                  try {
                    this.qq(), this.dh(this.view.gb), this.dh(this.view.Ah), this.dh(this.view.rg), this.dh(this.view.Wg), this.dh(this.view.zd);
                  } catch (t) {}
                }
              }]);
              return o;
            }(e.Od);
            n.oI = o;
          }((r = s.bc || (s.bc = {})).ln || (r.ln = {}));
        }(r || (r = {})), function (t) {
          var e, s;
          e = t.G || (t.G = {}), function (e) {
            var r = /*#__PURE__*/function (_i$Ac$Oo4) {
              _inherits(r, _i$Ac$Oo4);
              var _super100 = _createSuper(r);
              function r(t, e) {
                var _this157;
                _classCallCheck(this, r);
                _this157 = _super100.call(this, e), _this157.Mv = 0, _this157.controller = t, _this157.Y("wdr-pivot-fields"), _this157.Bd(), _this157.B.Hi(), _this157.B.Nz({
                  jP: ["left", "right"],
                  resize: function resize(t) {
                    return _this157.y1(t);
                  }
                });
                return _this157;
              }
              _createClass(r, [{
                key: "y1",
                value: function y1(t) {
                  this.Dm(t.size.width + (t.size.width - t.E1.width)), this.cu(), this.sr();
                }
              }, {
                key: "Bd",
                value: function Bd() {
                  var _this158 = this;
                  var e = new i.ya("div", "wdr-popup-header wdr-ui-row");
                  this.R(e);
                  var _r77 = new i.ya("div", "wdr-ui-col wdr-vam");
                  e.R(_r77), this.Op = new i.dc(t.model.v.g.dw), this.Op.Y("wdr-popup-title"), _r77.R(this.Op), this.Np = new i.dc(t.model.v.g.jH), this.Np.Y("wdr-popup-subtitle"), _r77.R(this.Np), _r77 = new i.ya("div", "wdr-ui-col wdr-vam wdr-tar wdr-ui-btns-row"), e.R(_r77), this.Sh = new i.Wb("wdr-ui-btn-light wdr-icon-act_calc"), this.Sh.qb("wdr-btn-add-measure"), this.Sh.wa(t.model.v.g.bH), _r77.R(this.Sh), this.Ke = new i.Wb(), this.Ke.wa(t.model.v.g.hl), this.Gd = new i.Wb("wdr-ui-btn-dark"), this.Gd.wa(t.model.v.g.Im), a.Dg.fs || a.Dg.qm ? (_r77.R(this.Ke), _r77.R(this.Gd)) : (_r77.R(this.Gd), _r77.R(this.Ke)), e = new i.ya("div", "wdr-popup-content"), this.R(e);
                  var n = new i.ya("div", "wdr-ui-row");
                  e.R(n), _r77 = new i.ya("div", "wdr-ui-col-3"), n.R(_r77);
                  var o = new i.ya("div", "wdr-list-wrap wdr-list-wrap-all");
                  _r77.R(o);
                  var h = new i.ya("div", "wdr-list-header wdr-list-header-wide");
                  o.R(h), _r77 = new i.ya("div", "wdr-list-header-label-wrap"), h.R(_r77), this.yN = new i.dc(t.model.v.g.cH), _r77.R(this.yN), this.rj = new i.Wb("wdr-ui-link-btn"), this.rj.qd("wdr-ui-btn"), this.rj.qb("wdr-btn-collapse-expand-all"), this.rj.wa(t.model.v.g.dH), _r77.R(this.rj), this.tg = new i.ya("div", "wdr-search-wrap"), h.R(this.tg), (_r77 = new i.ya("button", "wdr-search-btn")).addEventListener("click", function () {
                    return _this158.fF();
                  }), this.tg.R(_r77), h = new i.ya("span", "wdr-ui-icon wdr-icon-act_search"), _r77.R(h), this.Jj = new i.zl(), this.Jj.Y("wdr-search-inp"), this.tg.R(this.Jj), (_r77 = new i.ya("span", "wdr-close-search wdr-ui-icon wdr-icon-act_close")).addEventListener("click", function () {
                    return _this158.wz();
                  }), this.tg.R(_r77), h = new i.ya("div", "wdr-list-content"), o.R(h), this.gb = new i.Zc.Mh(), this.gb.qb("wdr-lst-hierarchies"), this.gb.$g(function (t, e) {
                    return _this158.DF(t, e);
                  }), this.gb.wg("caption"), h.R(this.gb), _r77 = new i.ya("div", "wdr-ui-col-3"), n.R(_r77), (o = new i.ya("div", "wdr-list-wrap wdr-list-wrap-pages")).qb("wdr-wrap-pages"), _r77.R(o), h = new i.ya("div", "wdr-list-header"), o.R(h), this.AN = new i.dc(t.model.v.g.fH), h.R(this.AN), h = new i.ya("div", "wdr-list-content"), o.R(h), this.Ah = new i.Zc.Mh(), this.Ah.qb("wdr-lst-pages"), this.Ah.$g(function (t, e) {
                    return _this158.Lr(t, e);
                  }), this.Ah.wg("caption"), h.R(this.Ah), this.zE = new i.dc(t.model.v.g.Jm), this.zE.Y("wdr-prompt"), o.R(this.zE), (o = new i.ya("div", "wdr-list-wrap wdr-list-wrap-rows")).qb("wdr-wrap-rows"), _r77.R(o), h = new i.ya("div", "wdr-list-header"), o.R(h), this.BN = new i.dc(t.model.v.g.iH), h.R(this.BN), h = new i.ya("div", "wdr-list-content"), o.R(h), this.rg = new i.Zc.Mh(), this.rg.qb("wdr-lst-rows"), this.rg.$g(function (t, e) {
                    return _this158.Lr(t, e);
                  }), this.rg.wg("caption"), h.R(this.rg), this.AE = new i.dc(t.model.v.g.Jm), this.AE.Y("wdr-prompt"), o.R(this.AE), _r77 = new i.ya("div", "wdr-ui-col-3"), n.R(_r77), (o = new i.ya("div", "wdr-list-wrap wdr-list-wrap-cols")).qb("wdr-wrap-columns"), _r77.R(o), h = new i.ya("div", "wdr-list-header"), o.R(h), this.xN = new i.dc(t.model.v.g.eH), h.R(this.xN), h = new i.ya("div", "wdr-list-content"), o.R(h), this.Wg = new i.Zc.Mh(), this.Wg.qb("wdr-lst-columns"), this.Wg.$g(function (t, e) {
                    return _this158.Lr(t, e);
                  }), this.Wg.wg("caption"), h.R(this.Wg), this.xE = new i.dc(t.model.v.g.Jm), this.xE.Y("wdr-prompt"), o.R(this.xE), (o = new i.ya("div", "wdr-list-wrap wdr-list-wrap-measures")).qb("wdr-wrap-measures"), _r77.R(o), h = new i.ya("div", "wdr-list-header"), o.R(h), this.zN = new i.dc(t.model.v.g.IA), h.R(this.zN), h = new i.ya("div", "wdr-list-content"), o.R(h), this.zd = new i.Zc.Mh(), this.zd.qb("wdr-lst-measures"), this.zd.$g(function (t, e) {
                    return _this158.Lr(t, e);
                  }), this.zd.wg("caption"), h.R(this.zd), this.yE = new i.dc(t.model.v.g.Jm), this.yE.Y("wdr-prompt"), o.R(this.yE), this.oh = new s.gG(), this.oh.qb("wdr-aggregations-view"), this.oh.Da(), e.R(this.oh);
                }
              }, {
                key: "Tj",
                value: function Tj() {
                  this.Op.wa(t.model.v.g.dw), this.Np.wa(t.model.v.g.jH), this.Ke.wa(t.model.v.g.hl), this.Gd.wa(t.model.v.g.Im), this.yN.wa(t.model.v.g.cH), this.AN.wa(t.model.v.g.fH), this.BN.wa(t.model.v.g.iH), this.xN.wa(t.model.v.g.eH), this.zN.wa(t.model.v.g.IA), this.Sh.wa(t.model.v.g.bH), this.zE.wa(t.model.v.g.Jm), this.AE.wa(t.model.v.g.Jm), this.xE.wa(t.model.v.g.Jm), this.yE.wa(t.model.v.g.Jm), this.rj.wa(this.controller.az ? t.model.v.g.RQ : t.model.v.g.dH);
                }
              }, {
                key: "Lr",
                value: function Lr(t, e) {
                  var i = new s.yf.sH();
                  return i.setData(t), i.al(e), i;
                }
              }, {
                key: "DF",
                value: function DF(t, e) {
                  return (t = new s.yf.KI(t, e)).al(e), t;
                }
              }, {
                key: "fF",
                value: function fF() {
                  this.tg.Y("wdr-search-opened"), this.Jj.B.focus();
                }
              }, {
                key: "wz",
                value: function wz() {
                  this.tg.qd("wdr-search-opened"), this.Jj.clear();
                }
              }, {
                key: "reset",
                value: function reset() {
                  this.tg.qd("wdr-search-opened"), this.Jj.clear(!1);
                }
              }, {
                key: "Ei",
                value: function Ei(t) {
                  var e = new i.ia("span");
                  return e.ja("id", "wdr-drag-handle"), e.Y("wdr-helper"), e.Y("wdr-draggable"), e.Va("wdr-values", t.Pc("wdr-values")), e.ha("width", t.ha("width")), e.ha("position", "absolute"), e.ha("z-index", 100), e.ja("data-index", t.ja("data-index")), e.text(t.text()), e;
                }
              }, {
                key: "cu",
                value: function cu() {
                  _get(_getPrototypeOf(r.prototype), "cu", this).call(this, !0);
                }
              }]);
              return r;
            }(i.Ac.Oo);
            e.pS = r;
          }((s = e.bc || (e.bc = {})).ln || (s.ln = {}));
        }(r || (r = {})), function (t) {
          var s;
          !function (r) {
            var n = /*#__PURE__*/function (_i$ya2) {
              _inherits(n, _i$ya2);
              var _super101 = _createSuper(n);
              function n() {
                var _this159;
                _classCallCheck(this, n);
                _this159 = _super101.call(this), _this159.Y("wdr-fields-view-wrap"), _this159.Bd();
                return _this159;
              }
              _createClass(n, [{
                key: "Bd",
                value: function Bd() {
                  var _this160 = this;
                  this.kF = new i.Wb(), this.kF.qb("wdr-btn-open-fields"), this.kF.addEventListener(i.Wb.Se, function () {
                    return _this160.Q0();
                  }), this.R(this.kF);
                }
              }, {
                key: "open",
                value: function open(e, i) {
                  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
                  this.B.Va("wdr-fields-opened", !0), this.es || (t.model.xa.V().na(new t.model.ac(t.model.xa.fw)), t.model.A.P.Xl = !0), this.OB = t.model.A.P.Dc, this.controller = this.nY(), this.controller.update(e, i, s, this.fZ), this.controller.view.qb("wdr-fields-view"), this.controller.view.B.Va("wdr-dt-fields", this.es), this.controller.view.ts.B.Va("wdr-dt-fields-overlay", this.es), this.ap ? this.ap.R(this.controller.view.B) : this.R(this.controller.view), this.isVisible() || this.show(), this.controller.view.open(), this.LB = !0, this.cx = t.u.Ja.V().fa ? t.u.Ja.V().fa.clone() : null, this.ag = t.u.Ja.V().he;
                }
              }, {
                key: "FZ",
                get: function get() {
                  return this.OB != t.model.A.P.Dc;
                }
              }, {
                key: "oZ",
                get: function get() {
                  return this.LB != t.model.A.P.Xl;
                }
              }, {
                key: "AZ",
                get: function get() {
                  return null == this.ag || null == t.u.Ja.V().ea || !this.ag.isEqual(t.u.Ja.V().he);
                }
              }, {
                key: "WZ",
                get: function get() {
                  return null == t.u.Ja.V().fa && null != this.cx || null != t.u.Ja.V().fa && null == this.cx || t.u.Ja.V().fa && this.cx && !t.u.Ja.V().fa.isEqual(this.cx);
                }
              }, {
                key: "fZ",
                get: function get() {
                  return this.oZ || this.AZ || this.WZ || this.FZ;
                }
              }, {
                key: "nY",
                value: function nY() {
                  var _this161 = this;
                  var t = null,
                    i = this.OB || this.AJ,
                    a = this.ap || s.xb.tb.B;
                  return null == this.controller ? t = i ? new r.flat.wH(a) : new r.ln.oI(a) : i && "flat" != this.controller.type ? t = new r.flat.wH(a) : i || "pivot" == this.controller.type || (t = new r.ln.oI(a)), null == t ? this.controller : (this.controller && this.controller.Rc(), t.addEventListener(e.ga.CLOSED, function () {
                    return _this161.x1();
                  }), t.addEventListener(n.Bo, function (t) {
                    return _this161.J_(t);
                  }), t);
                }
              }, {
                key: "J_",
                value: function J_(t) {
                  this.na(t);
                }
              }, {
                key: "x1",
                value: function x1() {
                  this.LB = void 0, this.ag = null, this.OB = void 0, this.es || (t.model.xa.V().na(new t.model.ac(t.model.xa.ew)), t.model.A.P.V(), t.model.A.P.HC ? this.show() : this.Da(), t.model.A.P.Xl = !1, this.Oa(e.ga.CLOSED)), this.B.Va("wdr-fields-opened", !1);
                }
              }, {
                key: "close",
                value: function close() {
                  this.controller && this.controller.view.close();
                }
              }, {
                key: "Q0",
                value: function Q0() {
                  this.Oa(n.EA);
                }
              }, {
                key: "es",
                get: function get() {
                  return this.AJ;
                },
                set: function set(t) {
                  this.AJ = t;
                }
              }, {
                key: "s_",
                set: function set(t) {
                  this.ap = t;
                }
              }, {
                key: "IC",
                set: function set(t) {}
              }, {
                key: "MZ",
                get: function get() {
                  return this.LB;
                }
              }]);
              return n;
            }(i.ya);
            n.Bo = "EVENT_APPLY_SLICE", n.EA = "EVENT_OPEN", r.ck = n;
          }((s = t.G || (t.G = {})).bc || (s.bc = {}));
        }(r || (r = {})), function (t) {
          var e, s;
          e = t.G || (t.G = {}), function (e) {
            var s = /*#__PURE__*/function (_i$yf$wt) {
              _inherits(s, _i$yf$wt);
              var _super102 = _createSuper(s);
              function s() {
                var _this162;
                _classCallCheck(this, s);
                _this162 = _super102.call(this), _this162.QC();
                return _this162;
              }
              _createClass(s, [{
                key: "QC",
                value: function QC() {
                  null == this.Yj && (this.Yj = new i.ia("span"), this.Yj.ja("id", "wdr-text-display"));
                }
              }, {
                key: "OC",
                value: function OC() {
                  null == this.kp && (this.kp = new i.ia("span"), this.kp.ja("id", "wdr-aggr-display"));
                }
              }, {
                key: "PC",
                value: function PC() {
                  null == this.em && (this.em = new i.ia("span"), this.em.ja("id", "wdr-drag-handle"));
                }
              }, {
                key: "Ha",
                value: function Ha() {
                  var e = this.getData();
                  this.B.empty();
                  var i = null != this.uE ? (0, this.uE)(e) : e.Of ? e.kZ + " / " + e[this.Ni()] : e[this.Ni()];
                  this.Yj.text(i), this.Yj.ja("title", i), this.B.append(this.Yj), 1 == e.Wd && 1 == e.Wf && 1 < e.te.length && t.model.A.P.Wf && (this.OC(), this.B.append(this.kp)), this.PC(), this.B.append(this.em), this.B.Va("wdr-measure", !0 === e.Wd), this.B.Va("wdr-values", !0 === e.sE), this.B.Va("wdr-selected", !0 === e.qc), this.B.Va("wdr-level", !0 === e.Of);
                }
              }]);
              return s;
            }(i.yf.wt);
            e.sH = s;
          }((s = e.bc || (e.bc = {})).yf || (s.yf = {}));
        }(r || (r = {})), function (t) {
          var e, s;
          e = t.G || (t.G = {}), function (s) {
            var r = /*#__PURE__*/function (_i$yf$wt2) {
              _inherits(r, _i$yf$wt2);
              var _super103 = _createSuper(r);
              function r() {
                var _this163;
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                _classCallCheck(this, r);
                _this163 = _super103.call(this), _this163.data = t, _this163.BW(), _this163.QC();
                return _this163;
              }
              _createClass(r, [{
                key: "BW",
                value: function BW() {
                  null == this.ZD && (this.ZD = new i.ia("span"), this.ZD.ja("id", "wdr-icon-display"));
                }
              }, {
                key: "FW",
                value: function FW() {
                  null == this.FE && (this.FE = new i.ia("span"), this.FE.ja("id", "wdr-moreicon-display"));
                }
              }, {
                key: "QC",
                value: function QC() {
                  null == this.Yj && (this.Yj = new i.ia("span"), this.Yj.ja("id", "wdr-text-display"));
                }
              }, {
                key: "OC",
                value: function OC() {
                  null == this.kp && (this.kp = new i.ia("span"), this.kp.ja("id", "wdr-aggr-display"));
                }
              }, {
                key: "sW",
                value: function sW() {
                  null == this.uC && (this.uC = new i.ia("span"), this.uC.ja("id", "wdr-calc-display"));
                }
              }, {
                key: "PC",
                value: function PC() {
                  null == this.em && (this.em = new i.ia("span"), this.em.ja("id", "wdr-drag-handle"));
                }
              }, {
                key: "Ha",
                value: function Ha() {
                  var i = this.getData();
                  this.B.empty(), this.B.append(this.ZD), i.Ug && (this.FW(), this.B.append(this.FE)), this.Yj.text(i[this.Ni()]), this.Yj.ja("title", i[this.Ni()]), this.B.append(this.Yj), !0 === i.Wd && !0 !== i.La && t.model.A.P.Wf && (this.OC(), this.B.append(this.kp)), !0 === i.Wd && !0 === i.La && !0 === i.Wf && (this.sW(), this.B.append(this.uC)), i.Vd || i.Rn ? null != this.em && this.em.remove() : (this.PC(), this.B.append(this.em));
                  for (var s = !0 === i.qc || null != i.vf && !0 === i.vf.qc, _r78 = 1; 10 > _r78; _r78++) this.B.Va("wdr-level-" + _r78, i.level === _r78);
                  this.B.Va("wdr-selected", !0 === s), this.B.Va("wdr-checked", !0 !== i.Vd && !0 !== i.Of && !0 === s), this.B.Va("wdr-unchecked", !0 !== i.Vd && !0 !== i.Of && !0 !== s), this.B.Va("wdr-measure", !0 === i.nE), this.B.Va("wdr-folder", !0 === i.Vd || !0 === i.Ug), this.B.Va("wdr-level-folder", !0 === i.Ug), this.B.Va("wdr-level", !0 === i.Of), this.B.Va("wdr-measures-folder", !0 === i.Rn), this.B.Va("wdr-measures-calculated-folder", !0 === i.Rn && !0 === i.uZ), this.B.Va("wdr-calculated", !0 === i.La), this.B.Va(e.N.C.aa.xG, (!0 === i.Vd || !0 === i.Ug) && !0 !== i.Nf), this.B.Va(e.N.C.aa.WG, (!0 === i.Vd || !0 === i.Ug) && !0 === i.Nf);
                }
              }]);
              return r;
            }(i.yf.wt);
            s.KI = r;
          }((s = e.bc || (e.bc = {})).yf || (s.yf = {}));
        }(r || (r = {})), function (t) {
          var e, s;
          e = t.G || (t.G = {}), ((s = e.bc || (e.bc = {})).flat || (s.flat = {})).cR = /*#__PURE__*/function () {
            function _class30() {
              _classCallCheck(this, _class30);
              this.IE = [];
            }
            _createClass(_class30, [{
              key: "update",
              value: function update(e, i) {
                this.oa = e, this.ab = i, this.va = [];
                var s = null,
                  r = this.oa.yk;
                if (null != this.ab) {
                  s = this.ab.flatten(!0);
                  for (var n = 0; n < s.length; n++) e = s.F(n), r.rc(e.j) && ((e = r.getItem(e.j)).Wf = t.model.A.P.Wf, e.Wd = !0), e.qc = !0, this.va.push(e);
                }
                var a = [],
                  o = this.oa.bb(!1);
                for (n = 0; n < o.length; n++) e = o.F(n), null == s || s.rc(e.j) || (e.qc = !1, a.push(e));
                for (n = 0; n < r.length; n++) e = r.F(n), null == s || s.rc(e.j) || (e.qc = i.pa.rc(e.j) || -1 < this.IE.indexOf(e.j), e.Wf = t.model.A.P.Wf, e.Wd = !0, a.push(e));
                for (a.sort(function (t, e) {
                  return t.caption < e.caption ? -1 : t.caption > e.caption ? 1 : 0;
                }), n = 0; n < a.length; n++) e = a[n], this.va.push(e);
              }
            }, {
              key: "qE",
              value: function qE() {
                return !0;
              }
            }, {
              key: "GP",
              value: function GP(t, e) {
                for (var i = [], s = 0; s < e.length; s++) {
                  var r = t[e[s]];
                  r.qc && i.push(r.j);
                }
                return i;
              }
            }, {
              key: "OD",
              value: function OD(t) {
                var e = this.ab.clone();
                t = this.GP(this.va, t), e.ze = t;
                for (var i, s = e.flatten(!0), r = e.pa, n = 0; n < t.length; n++) {
                  var a = t[n];
                  s.rc(a) || ((i = this.oa.bb().getItem(a)) ? e.rows.Ea(a, i) : this.oa.yk.rc(a) && (r.Ea(a, this.oa.yk.getItem(a)), e.pa = r));
                }
                for (n = 0; n < s.length; n++) i = s.F(n), -1 == t.indexOf(i.j) && (e.za.rc(i.j) && e.za.removeItem(i.j), e.rows.rc(i.j) && e.rows.removeItem(i.j), null == (a = this.oa.og(i.j)) && (a = this.oa.yk.getItem(i.j)), r.rc(a.j) && r.removeItem(a.j));
                return e.pa = r, this.IE = [], e;
              }
            }, {
              key: "Rp",
              value: function Rp(t) {
                if (null != this.ab && null != this.oa) {
                  this.update(this.oa, this.ab);
                  var _e101 = this.va.find(function (e) {
                    return e.j === t;
                  });
                  null != _e101 && (_e101.qc = !0), this.IE.push(t);
                }
              }
            }, {
              key: "Sp",
              value: function Sp() {
                null != this.ab && null != this.oa && this.update(this.oa, this.ab);
              }
            }, {
              key: "oE",
              value: function oE(t) {
                t = t.flatten(!0);
                var e = this.ab.flatten(!0);
                if (t.length != e.length) return !0;
                for (var i = 0; i < t.length; i++) if (t.yd(i) != e.yd(i)) return !0;
                return !1;
              }
            }, {
              key: "OM",
              value: function OM() {
                for (var t = 0, e = 0; e < this.va.length; e++) this.va[e].qc && t++;
                return 0 == t ? i.No.hT : t == this.va.length ? i.No.BS : i.No.CS;
              }
            }]);
            return _class30;
          }();
        }(r || (r = {})), function (t) {
          var s, r;
          s = t.G || (t.G = {}), function (n) {
            var o = /*#__PURE__*/function (_e$Od19) {
              _inherits(o, _e$Od19);
              var _super104 = _createSuper(o);
              function o(t) {
                var _this164;
                _classCallCheck(this, o);
                _this164 = _super104.call(this), _this164.type = "flat", _this164.pr = function (t) {
                  return _this164.Rp(t);
                }, _this164.nu = function (t) {
                  return _this164.Sp(t);
                }, _this164.W = new n.cR(), _this164.view = new n.dR(_assertThisInitialized(_this164), t), _this164.view.addEventListener(e.ga.CLOSED, function (t) {
                  return _this164.na(t);
                }), _this164.view.Gd && _this164.view.Gd.addEventListener(i.Wb.Se, function () {
                  return _this164.Vp();
                }), _this164.view.Ke && _this164.view.Ke.addEventListener(i.Wb.Se, function () {
                  return _this164.Tp();
                }), _this164.view.gb && (_this164.view.gb.B.addEventListener("click", function (t) {
                  return _this164.UE(t);
                }), _this164.view.gb.B.zj({
                  sg: function sg(t, e, i, s) {
                    return _this164.sg(t, e, i, s);
                  },
                  os: function os(t, e, i, s) {
                    return _this164.Up(t, e, i, s);
                  },
                  Oj: function Oj(t, e, i, s) {
                    return _this164.Up(t, e, i, s);
                  },
                  Qf: function Qf(t, e, i, s) {
                    return _this164.Qf(t, e, i, s);
                  },
                  Tn: "li"
                })), _this164.view.Fc && _this164.view.Fc.addEventListener(e.ga.oe, function () {
                  return _this164.gF();
                }), _this164.view.Sh && _this164.view.Sh.addEventListener(i.Wb.Se, function () {
                  return _this164.JE();
                });
                return _this164;
              }
              _createClass(o, [{
                key: "Up",
                value: function Up(t, e, s, r) {
                  this.Dh(), t && t.closest("ul") && (e && e.Y("wdr-droppable-valid"), t.Y("wdr-drag-over"), this.ko(i.ia.Ga(r.target)));
                }
              }, {
                key: "Qf",
                value: function Qf(t, e) {
                  this.Dh(), t && t.closest("ul") && (e && e.qd("wdr-droppable-valid"), e && e.qd("wdr-droppable-invalid"), t.qd("wdr-drag-over"));
                }
              }, {
                key: "sg",
                value: function sg(t, e, i) {
                  this.Dh(), t && t.closest("ul") && (t = parseInt(t.ja("data-index"))) != (i = i ? parseFloat(i.ja("data-index")) : this.view.gb.Qb().length) && (t < i && --i, (e = this.view.gb.Qb()).splice(i, 0, e.splice(t, 1)[0]), this.dj());
                }
              }, {
                key: "Tp",
                value: function Tp() {
                  this.view.close();
                }
              }, {
                key: "Vp",
                value: function Vp() {
                  this.xk(), this.view.close();
                }
              }, {
                key: "gF",
                value: function gF() {
                  for (var t = this.view.Fc.checked, e = this.W.va, i = 0; i < e.length; i++) e[i].qc = t;
                  this.view.gb.so();
                }
              }, {
                key: "UE",
                value: function UE(e) {
                  var r = i.ia.Ga(e.target).closest("li");
                  if (null != r) {
                    r = parseInt(r.ja("data-index"));
                    var n = this.W.va[r];
                    "wdr-calc-display" == i.ia.Ga(e.target).ja("id") ? t.model.yb.V().Oa(s.kf.Xs, null, {
                      IN: n.j
                    }) : (n.qc = !n.qc, this.view.gb && this.view.gb.fl(r), this.view.Fc && this.view.Fc.wc(this.W.OM()));
                  }
                }
              }, {
                key: "JE",
                value: function JE() {
                  t.model.yb.V().Oa(s.kf.Xs), t.model.yb.V().addEventListener(s.La.Df.Aq, this.pr), t.model.yb.V().addEventListener(s.La.Df.ct, this.nu);
                }
              }, {
                key: "Rp",
                value: function Rp(e) {
                  t.model.yb.V().removeEventListener(s.La.Df.Aq, this.pr), this.W.Rp(e.data.JN), this.dj();
                }
              }, {
                key: "Sp",
                value: function Sp(e) {
                  t.model.yb.V().removeEventListener(s.La.Df.ct, this.nu), this.W.Sp(e.data), this.dj();
                }
              }, {
                key: "dj",
                value: function dj() {
                  var _this165 = this;
                  if (this.view.gb) {
                    this.view.gb.vg(this.W.va), this.qq(), this.view.gb.so();
                    var t = {
                      Ei: function Ei(t) {
                        return _this165.view.Ei(t);
                      }
                    };
                    a.Wc().pg && (t.Ny = "#wdr-drag-handle");
                    for (var e = this.view.gb.B.find("li", !0), i = 0; i < e.length; i++) e[i].draggable(t);
                  }
                }
              }, {
                key: "update",
                value: function update(t, e) {
                  this.W.update(t, e), this.dj(), this.view.Fc && this.view.Fc.wc(this.W.OM()), this.view.Tj();
                }
              }, {
                key: "qq",
                value: function qq() {
                  this.view.Gd && this.view.Gd.Xz(this.W.qE());
                }
              }, {
                key: "xk",
                value: function xk() {
                  for (var t = [], e = this.view.gb.B.find("li", !0), i = 0; i < e.length; i++) {
                    var s = parseInt(e[i].ja("data-index"));
                    t.push(s);
                  }
                  t = this.W.OD(t), this.W.oE(t) && this.Oa(r.ck.Bo, this, t);
                }
              }, {
                key: "ko",
                value: function ko(t) {
                  var e = t.closest("li");
                  null != e ? (this.Xb = this.Yl(), e.before(this.Xb)) : null != (t = t.closest("ul")) && (this.Xb = this.Yl(), 0 < t.element.children.length ? t.append(this.Xb) : t.prepend(this.Xb));
                }
              }, {
                key: "Yl",
                value: function Yl() {
                  return new i.ia("div", "wdr-drop-indicator");
                }
              }, {
                key: "Dh",
                value: function Dh() {
                  this.Xb && (this.Xb.Wi(!0), this.Xb = null);
                }
              }]);
              return o;
            }(e.Od);
            n.wH = o;
          }((r = s.bc || (s.bc = {})).flat || (r.flat = {}));
        }(r || (r = {})), function (t) {
          var e, s;
          e = t.G || (t.G = {}), function (e) {
            var r = /*#__PURE__*/function (_i$Ac$Oo5) {
              _inherits(r, _i$Ac$Oo5);
              var _super105 = _createSuper(r);
              function r(t, e) {
                var _this166;
                _classCallCheck(this, r);
                _this166 = _super105.call(this, e), _this166.Y("wdr-flat-fields"), _this166.controller = t, _this166.Bd();
                return _this166;
              }
              _createClass(r, [{
                key: "Bd",
                value: function Bd() {
                  var e = new i.ya("div", "wdr-popup-header wdr-ui-row");
                  this.R(e);
                  var s = new i.ya("div", "wdr-ui-col wdr-vam");
                  e.R(s), this.Op = new i.dc(t.model.v.g.dw), this.Op.Y("wdr-popup-title"), s.R(this.Op), this.Np = new i.dc(t.model.v.g.gH), this.Np.Y("wdr-popup-subtitle"), s.R(this.Np), s = new i.ya("div", "wdr-ui-col wdr-vam wdr-tar wdr-ui-btns-row"), e.R(s), this.Sh = new i.Wb("wdr-ui-btn-light wdr-icon-act_calc"), this.Sh.qb("wdr-btn-add-measure"), s.R(this.Sh), this.Ke = new i.Wb(), this.Ke.wa(t.model.v.g.hl), this.Gd = new i.Wb("wdr-ui-btn-dark"), this.Gd.wa(t.model.v.g.Im), a.Dg.fs || a.Dg.qm ? (s.R(this.Ke), s.R(this.Gd)) : (s.R(this.Gd), s.R(this.Ke)), s = new i.ya("div", "wdr-popup-content"), this.R(s), e = new i.ya("div", "wdr-list-wrap"), s.R(e), s = new i.ya("div", "wdr-list-header"), e.R(s), this.Fc = new i.No(), this.Fc.qb("wdr-select-all-cbx"), this.Fc.wa(t.model.v.g.jt), s.R(this.Fc), s = new i.ya("div", "wdr-list-content"), e.R(s), this.gb = new i.Zc.Mh(), this.gb.qb("wdr-lst-hierarchies"), this.gb.$g(this.DF), this.gb.wg("caption"), s.R(this.gb);
                }
              }, {
                key: "DF",
                value: function DF(t, e) {
                  var i = new s.yf.KI(t, e);
                  return i.setData(t), i.al(e), i;
                }
              }, {
                key: "Tj",
                value: function Tj() {
                  this.Op.wa(t.model.v.g.dw), this.Np.wa(t.model.v.g.gH), this.Ke.wa(t.model.v.g.hl), this.Gd.wa(t.model.v.g.Im), this.Fc.wa(t.model.v.g.jt);
                }
              }, {
                key: "Ei",
                value: function Ei(t) {
                  var e = new i.ia("span");
                  return e.ja("id", "wdr-drag-handle"), e.Y("wdr-helper"), e.Y("wdr-draggable"), e.Va("wdr-values", t.Pc("wdr-values")), e.ha("width", t.ha("width")), e.ha("position", "absolute"), e.ha("z-index", 100), e.ja("data-index", t.ja("data-index")), e.text(t.text()), e;
                }
              }]);
              return r;
            }(i.Ac.Oo);
            e.dR = r;
          }((s = e.bc || (e.bc = {})).flat || (s.flat = {}));
        }(r || (r = {})), function (t) {
          var s;
          !function (t) {
            var r = /*#__PURE__*/function (_i$Ac$Oo6) {
              _inherits(r, _i$Ac$Oo6);
              var _super106 = _createSuper(r);
              function r() {
                var _this167;
                _classCallCheck(this, r);
                _this167 = _super106.call(this, s.xb.tb.B), _this167.qb("wdr-calculated-view"), _this167.B.Hi(), _this167.ts.Y("wdr-calculated-view-overlay"), _this167.controller = new t.sQ(), _this167.controller.addEventListener(e.ga.vG, function () {
                  return _this167.close();
                }), _this167.R(_this167.controller.view);
                return _this167;
              }
              _createClass(r, [{
                key: "ym",
                value: function ym(t) {
                  this.controller.update(t), this.open();
                }
              }, {
                key: "close",
                value: function close() {
                  _get(_getPrototypeOf(r.prototype), "close", this).call(this), this.controller.clear();
                }
              }]);
              return r;
            }(i.Ac.Oo);
            r.Aq = "EVENT_CALCULATED_VALUE_ADDED", r.ct = "EVENT_CALCULATED_VALUE_REMOVED", r.eu = !1, t.Df = r;
          }((s = t.G || (t.G = {})).La || (s.La = {}));
        }(r || (r = {})), function (t) {
          var e, i;
          e = t.G || (t.G = {}), (i = e.La || (e.La = {})).tQ = /*#__PURE__*/function () {
            function _class31() {
              _classCallCheck(this, _class31);
              this.W = t.model.yb.V(), this.jy = [{
                name: "_addBtn",
                label: "+",
                rf: t.u.i.$a.cG
              }, {
                name: "_subtractBtn",
                label: "-",
                rf: t.u.i.$a.HI
              }, {
                name: "_multiplyBtn",
                label: "×",
                rf: t.u.i.$a.aI
              }, {
                name: "_divideBtn",
                label: "÷",
                rf: t.u.i.$a.yA
              }, {
                name: "_powerBtn",
                label: "^",
                rf: t.u.i.$a.mI
              }, {
                name: "_equalBtn",
                label: "=",
                rf: t.u.i.$a.EQUAL
              }, {
                name: "_lessBtn",
                label: "<",
                rf: t.u.i.$a.LESS
              }, {
                name: "_greaterBtn",
                label: ">",
                rf: t.u.i.$a.GREATER
              }, {
                name: "_lessOrEqualBtn",
                label: "≤",
                rf: t.u.i.$a.IH
              }, {
                name: "_greaterOrEqualBtn",
                label: "≥",
                rf: t.u.i.$a.yH
              }, {
                name: "_equalBtn2",
                label: "==",
                rf: t.u.i.$a.TG
              }, {
                name: "_notEqualBtn",
                label: "!=",
                rf: t.u.i.$a.cI
              }, {
                name: "_orBtn",
                label: "OR",
                rf: t.u.i.$a.fI
              }, {
                name: "_andBtn",
                label: "AND",
                rf: t.u.i.$a.dG
              }, {
                name: "_ifBtn",
                label: "IF",
                rf: t.u.i.$a.PA
              }, {
                name: "_absBtn",
                label: "ABS",
                rf: t.u.i.$a.mA
              }, {
                name: "_minBtn",
                label: "MIN",
                rf: t.u.i.$a.MIN
              }, {
                name: "_maxBtn",
                label: "MAX",
                rf: t.u.i.$a.MAX
              }];
            }
            _createClass(_class31, [{
              key: "update",
              value: function update(t) {
                a.Vb(t) || (this.If = this.W.O.ea.we(t));
              }
            }, {
              key: "Wf",
              get: function get() {
                return !0;
              }
            }, {
              key: "Gn",
              value: function Gn() {
                return e.bc.C.Bq.LC(this.W.O.ea.pa.Tc());
              }
            }, {
              key: "rv",
              value: function rv(t) {
                i.Df.eu = !0, this.W.fo(t.j), this.W.Oa(i.Df.ct, null, t.j), a.xd(function () {
                  i.Df.eu = !1;
                }, 1e3);
              }
            }, {
              key: "du",
              value: function du(s) {
                var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                if (r = 0 < r.length ? r : this.bY(), null != this.If) {
                  if (this.If.caption != r || this.If.Jc != s || this.If.Mf != n) {
                    var o = new t.u.oa.ol(this.If.j, r);
                    o.Jc = s, o.Mf = n;
                  }
                } else (o = new t.u.oa.ol(r, r)).Jc = s, o.Mf = n;
                null != o && (i.Df.eu = !0, e.bc.ln.pI.jD = !0, this.W.vk(o), this.W.Oa(i.Df.Aq, null, {
                  JN: o.j
                }), a.xd(function () {
                  i.Df.eu = !1;
                }, 1e3));
              }
            }, {
              key: "YZ",
              value: function YZ(t) {
                return null != (t = new a.mt().parse(t)) && null != t.length;
              }
            }, {
              key: "bY",
              value: function bY() {
                for (var e = t.model.v.g.qA + " #", i = 0, s = this.W.O.ea.yk, r = new RegExp(t.model.v.g.qA + " #"), n = 0; n < s.length; n++) {
                  var a = s.F(n).caption;
                  r.test(a) && (i = Math.max(i, parseInt(a.substr(t.model.v.g.qA.length + 2))));
                }
                return e + (i + 1);
              }
            }]);
            return _class31;
          }();
        }(r || (r = {})), function (t) {
          var s;
          !function (r) {
            var n = /*#__PURE__*/function (_e$Od20) {
              _inherits(n, _e$Od20);
              var _super107 = _createSuper(n);
              function n() {
                var _this168;
                _classCallCheck(this, n);
                if (_this168 = _super107.call(this), _this168.W = new r.tQ(), _this168.view = new r.uQ(_assertThisInitialized(_this168)), _this168.view.Vk && _this168.view.Vk.addEventListener(i.Wb.Se, function () {
                  return _this168.$0();
                }), _this168.view.$h && _this168.view.$h.$g(function (t, e) {
                  return _this168.Lr(t, e);
                }), _this168.view.ie && _this168.view.ie.B.zj({
                  sg: function sg(t) {
                    return _this168.J0(t);
                  },
                  os: function os() {
                    return _this168.WN();
                  },
                  Oj: function Oj() {
                    return _this168.WN();
                  },
                  Qf: function Qf() {
                    return _this168.u0();
                  },
                  Tn: "li"
                }), _this168.view.Gd && _this168.view.Gd.addEventListener(i.Wb.Se, function () {
                  return _this168.Vp();
                }), _this168.view.Ke && _this168.view.Ke.addEventListener(i.Wb.Se, function () {
                  return _this168.Tp();
                }), _this168.view.oh && _this168.view.oh.addEventListener(e.ga.oe, function (t) {
                  return _this168.G_(t);
                }), _this168.view.iy) for (var t = 0; t < _this168.view.iy.length; t++) _this168.view.iy[t].addEventListener(i.Wb.Se, function (t) {
                  return _this168.v0(t);
                });
                return _possibleConstructorReturn(_this168);
              }
              _createClass(n, [{
                key: "WN",
                value: function WN() {
                  this.view.ie.Y("wdr-droppable-over");
                }
              }, {
                key: "u0",
                value: function u0() {
                  this.view.ie.qd("wdr-droppable-over");
                }
              }, {
                key: "J0",
                value: function J0(t) {
                  this.view.ie.qd("wdr-droppable-over"), t = parseInt(t.ja("data-index")), t = this.view.$h.Qb()[t], this.kK(t);
                }
              }, {
                key: "Lr",
                value: function Lr(e, i) {
                  var _this169 = this;
                  var r = new s.bc.yf.sH();
                  return r.setData(e), r.al(i), r.N2(function (e) {
                    return e.name + " (" + t.u.i.ca.sK(e.Fa) + ")";
                  }), r.addEventListener("click", function (t) {
                    return _this169.H_(t);
                  }), r.addEventListener("dblclick", function (t) {
                    return _this169.E0(t);
                  }), r;
                }
              }, {
                key: "jy",
                get: function get() {
                  return this.W.jy;
                }
              }, {
                key: "update",
                value: function update(t) {
                  this.W.update(t), null != this.W.If ? (this.view.Ui && (this.view.Ui.bj(this.W.If.caption), this.view.Ui.B.Va("wdr-compact", !0)), this.view.ie && this.view.ie.bj(this.W.If.Jc), this.view.Vk && this.view.Vk.isVisible(!0)) : (this.view.Ui && this.view.Ui.B.Va("wdr-compact", !1), this.view.sn && (this.view.sn.checked = !1), this.view.Vk && this.view.Vk.isVisible(!1)), this.view.sn && (this.view.sn.checked = !!this.W.If && this.W.If.Mf), this.view.Tj(), this.Y3();
                }
              }, {
                key: "Y3",
                value: function Y3() {
                  var _this170 = this;
                  for (var e = this.W.Gn(), i = [], s = 0; s < e.length; s++) null != this.W.If && this.W.If.j == e[s].j || (e[s].Wd = !0, e[s].Wf = this.W.Wf && !e[s].La && e[s].type != t.u.types.Ca.Hb, i.push(e[s]));
                  if (i.sort(this.ZV), this.view.$h) for (this.view.$h.vg(i), e = {
                    Ei: function Ei(t) {
                      return _this170.view.Ei(t);
                    }
                  }, a.Wc().pg && (e.Ny = "#wdr-drag-handle"), i = this.view.$h.B.find("li", !0), s = 0; s < i.length; s++) i[s].draggable(e);
                }
              }, {
                key: "clear",
                value: function clear() {
                  this.view.Ui && this.view.Ui.bj(""), this.view.ie && this.view.ie.bj(""), this.W.If = null;
                }
              }, {
                key: "ZV",
                value: function ZV(t, e) {
                  return t.name > e.name ? 1 : -1;
                }
              }, {
                key: "$0",
                value: function $0() {
                  a.Wc().pg ? this.cF() : this.g3();
                }
              }, {
                key: "g3",
                value: function g3() {
                  var _this171 = this;
                  if (a.Dg.fs || a.Dg.qm) var e = [t.model.v.g.kG, t.model.v.g.pA],
                    i = [null, function () {
                      return _this171.cF();
                    }];else e = [t.model.v.g.pA, t.model.v.g.kG], i = [function () {
                    return _this171.cF();
                  }, null];
                  var s = t.model.zc.valid(this.W.If.caption) ? this.W.If.caption : t.model.zc.validate(this.W.If.caption);
                  t.yc(t.model.v.g.bQ, a.$.bind(t.model.v.g.cQ, s), t.ld.to, e, i);
                }
              }, {
                key: "cF",
                value: function cF() {
                  this.W.rv(this.W.If), this.close();
                }
              }, {
                key: "H_",
                value: function H_(t) {
                  if ("wdr-aggr-display" == t.target.id) {
                    var e = parseInt(i.ia.Ga(t.target).closest("li").ja("data-index"));
                    e = this.view.$h.Qb()[e], this.view.oh.Bv(e, i.ia.Ga(t.target));
                  }
                }
              }, {
                key: "E0",
                value: function E0(t) {
                  t = parseInt(i.ia.Ga(t.target).closest("li").ja("data-index")), t = this.view.$h.Qb()[t], this.kK(t);
                }
              }, {
                key: "kK",
                value: function kK(e) {
                  null != e && (e.Fa == t.u.i.ca.NONE ? this.Pn(a.$.bind('"{0}"', e.j)) : this.Pn(a.$.bind('{0}("{1}")', e.Fa, e.j)));
                }
              }, {
                key: "G_",
                value: function G_(t) {
                  var e = t.data.Vx;
                  t = t.data.rK, e.Fa = t.Fa, e.caption = t.caption + " of " + e.name, this.view.$h.Zj(e);
                }
              }, {
                key: "v0",
                value: function v0(e) {
                  e = parseInt(e.target.B.ja("data-index")), (e = this.jy[e].rf) == t.u.i.$a.PA || e == t.u.i.$a.mA || e == t.u.i.$a.MIN || e == t.u.i.$a.MAX || e == t.u.i.$a.XI ? this.VU(e) : this.TU(e);
                }
              }, {
                key: "Tp",
                value: function Tp() {
                  this.close();
                }
              }, {
                key: "Vp",
                value: function Vp() {
                  var e = this.view.ie.Gj();
                  0 == e.length ? this.close() : 0 == this.W.YZ(e) ? t.yc(t.model.v.g.PR) : (this.W.du(e, this.view.Ui.Gj(), this.view.sn.checked), this.close());
                }
              }, {
                key: "close",
                value: function close() {
                  this.Oa(e.ga.vG);
                }
              }, {
                key: "Pn",
                value: function Pn(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                  var i = this.view.ie.B.element.selectionStart,
                    s = this.view.ie.Gj();
                  -1 == i && (i = this.zh), 0 == i || " " == s.charAt(i - 1) ? (this.view.ie.Pn(t + " "), this.zh = i + t.length + 1) : (this.view.ie.Pn(" " + t + " "), this.zh = i + t.length + 2), this.zh -= e, this.view.ie.wc(this.zh);
                }
              }, {
                key: "TU",
                value: function TU(t) {
                  this.Pn(t);
                }
              }, {
                key: "VU",
                value: function VU(t) {
                  var e = this.view.ie.B.element.selectionStart,
                    i = this.view.ie.B.element.selectionEnd,
                    s = this.view.ie.Gj();
                  "if" == t ? this.Pn(t + "(" + s.slice(e, i) + ", , )", 6) : this.Pn(t + "(" + s.slice(e, i) + ")", 2);
                }
              }]);
              return n;
            }(e.Od);
            r.sQ = n;
          }((s = t.G || (t.G = {})).La || (s.La = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (s) {
            var r = /*#__PURE__*/function (_i$ya3) {
              _inherits(r, _i$ya3);
              var _super108 = _createSuper(r);
              function r(t) {
                var _this172;
                _classCallCheck(this, r);
                _this172 = _super108.call(this), _this172.controller = t, _this172.Bd();
                return _this172;
              }
              _createClass(r, [{
                key: "Bd",
                value: function Bd() {
                  var _this173 = this;
                  var s = new i.ya("div", "wdr-popup-header wdr-ui-row");
                  this.R(s);
                  var _r79 = new i.ya("div", "wdr-ui-col wdr-vam");
                  s.R(_r79), this.ro = new i.dc(t.model.v.g.tG), this.ro.Y("wdr-popup-title"), _r79.R(this.ro), this.TF = new i.dc(t.model.v.g.qG), this.TF.Y("wdr-popup-subtitle"), _r79.R(this.TF), _r79 = new i.ya("div", "wdr-ui-col wdr-vam wdr-tar wdr-ui-btns-row"), s.R(_r79), this.Vk = new i.Wb("wdr-ui-btn-light wdr-icon-act_trash"), this.Vk.qb("wdr-remove-btn"), this.Vk.B.ja("title", t.model.v.g.sG), _r79.R(this.Vk), this.Ke = new i.Wb("wdr-ui-btn"), this.Ke.wa(t.model.v.g.hl), this.Gd = new i.Wb("wdr-ui-btn-dark"), this.Gd.wa(t.model.v.g.Im), a.Dg.fs || a.Dg.qm ? (_r79.R(this.Ke), _r79.R(this.Gd)) : (_r79.R(this.Gd), _r79.R(this.Ke)), s = new i.ya("div", "wdr-popup-content"), this.R(s), this.Ui = new i.zl(), this.Ui.qb("wdr-name-input"), this.Ui.Hs(t.model.v.g.rG), s.R(this.Ui), this.$h = new i.Zc.Mh(), this.$h.qb("wdr-lst-measures"), this.$h.useCache = !1, this.$h.wg("caption"), s.R(this.$h), this.sn = new i.No(), this.sn.wa(t.model.v.g.oG), s.R(this.sn), this.vD = new i.ya("div", "wdr-ui-row"), this.vD.qb("wdr-func-btn-group"), s.R(this.vD), this.iy = [], _r79 = this.controller.jy;
                  for (var n = 0; n < _r79.length; n++) {
                    var o = new i.Wb("wdr-ui-col-9 wdr-calc-action");
                    o.qd("wdr-ui-btn"), o.Q2(_r79[n].name), o.wa(_r79[n].label), o.B.ja("data-index", n), this.vD.R(o), this.iy.push(o);
                  }
                  _r79 = new i.ya("div", "wdr-formula-wrap"), s.R(_r79), this.ie = new i.UI(), this.ie.qb("wdr-formula-input"), this.ie.addEventListener(i.zl.gi, function () {
                    return _this173.t0();
                  }), _r79.R(this.ie), this.iz = new i.dc(t.model.v.g.pG), this.iz.Y("wdr-prompt"), _r79.R(this.iz), this.oh = new e.bc.gG(), this.oh.qb("wdr-aggregations-view"), this.oh.Da(), s.R(this.oh);
                }
              }, {
                key: "Tj",
                value: function Tj() {
                  this.ro.wa(t.model.v.g.tG), this.TF.wa(t.model.v.g.qG), this.Gd.wa(t.model.v.g.Im), this.Ke.wa(t.model.v.g.hl), this.Ui.Hs(t.model.v.g.rG), this.sn.wa(t.model.v.g.oG), this.iz.wa(t.model.v.g.pG), this.Vk.B.ja("title", t.model.v.g.sG);
                }
              }, {
                key: "Ei",
                value: function Ei(t) {
                  var e = new i.ia("span");
                  return e.ja("id", "wdr-drag-handle"), e.Y("wdr-helper"), e.Y("wdr-draggable"), e.ha("width", t.ha("width")), e.ha("position", "absolute"), e.ha("z-index", 100), e.ja("data-index", t.ja("data-index")), e.text(t.text()), e;
                }
              }, {
                key: "t0",
                value: function t0() {
                  this.iz.isVisible(0 == this.ie.Gj().length);
                }
              }]);
              return r;
            }(i.ya);
            s.uQ = r;
          }((e = t.G || (t.G = {})).La || (e.La = {}));
        }(r || (r = {})), function (t) {
          !function (t) {
            var i = /*#__PURE__*/_createClass(function i() {
              _classCallCheck(this, i);
            });
            i.Do = "FILTER_OPEN", i.Xs = "CALCULATED_VIEW_OPEN", i.PG = "DRILL_THROUGH_OPEN", i.BG = "CONTEXT_MENU_OPEN", i.uI = "RENDER_COMPLETE", i.gl = "beforegriddraw", i.ak = "aftergriddraw", t.kf = i;
            var s = /*#__PURE__*/function (_e$ga15) {
              _inherits(s, _e$ga15);
              var _super109 = _createSuper(s);
              function s(t) {
                var _this174;
                _classCallCheck(this, s);
                _this174 = _super109.call(this, i.Do), _this174.lb = t;
                return _this174;
              }
              return _createClass(s);
            }(e.ga);
            t.vH = s;
          }(t.G || (t.G = {}));
        }(r || (r = {})), function (t) {
          var e;
          ((e = t.G || (t.G = {})).filter || (e.filter = {})).bI = /*#__PURE__*/function () {
            function _class32() {
              _classCallCheck(this, _class32);
              this.Ql = [], this.pb = [], this.Lb = [], this.hf = "", this.cc = !0;
            }
            _createClass(_class32, [{
              key: "$z",
              value: function $z(t) {
                this.Jb = t;
              }
            }, {
              key: "lq",
              value: function lq(t) {
                this.Nb = t, this.Ql = this.Jb.Cf(this.Jb.Qd, !1, this.Nb).Tc();
              }
            }, {
              key: "select",
              value: function select(t, e) {
                this.cc != e ? this.pb.push(t) : -1 < (t = this.pb.indexOf(t)) && this.pb.splice(t, 1), this.pb.length == this.Ql.length && this.Bm(!this.cc);
              }
            }, {
              key: "search",
              value: function search(t, e) {
                if (t = t.toLowerCase(), this.hf === t) e();else if (this.hf = t, 0 == this.hf.length) e();else {
                  this.Lb.length = 0;
                  var i,
                    s = this.Ql.length;
                  for (i = 0; i < s; i++) a.$.contains(this.Ql[i].caption, t) && this.Lb.push(this.Ql[i]);
                  e(this.Lb);
                }
              }
            }, {
              key: "YO",
              value: function YO(t) {
                null != t ? this.Lb = t : this.Lb.length = 0;
              }
            }, {
              key: "Bm",
              value: function Bm(t) {
                if (this.Yc()) for (var e = this.Lb.length, i = 0; i < e; i++) a.$.contains(this.Lb[i].caption, this.hf) && this.select(this.Lb[i], t);else this.cc = t, this.pb.length = 0;
              }
            }, {
              key: "HO",
              value: function HO() {}
            }, {
              key: "Ln",
              value: function Ln() {
                var t = this.cc || this.Yc() ? this.cc && this.Yc() ? this.Lb.length + this.rW() - this.pb.length : this.cc || 0 != this.pb.length ? this.Ql.length - this.pb.length : this.pb.length : this.pb.length;
                return 0 < t ? t : 0;
              }
            }, {
              key: "rW",
              value: function rW() {
                for (var t = 0, e = 0, i = 0; e < this.pb.length;) {
                  for (; i < this.Lb.length && this.Lb[i].j != this.pb[e].j;) i++;
                  this.Lb.length == i && t++, i = 0, e++;
                }
                return t;
              }
            }, {
              key: "Kn",
              value: function Kn() {
                var _this175 = this;
                if (this.Yc()) {
                  for (var t = 0, e = 0; e < this.Lb.length; e++) 0 > this.pb.findIndex(function (t) {
                    return t.j === _this175.Lb[e].j;
                  }) == this.cc && t++;
                  return t;
                }
                return this.Ln();
              }
            }, {
              key: "Yz",
              value: function Yz(t) {
                this.pb.length = 0;
                var e = t.length;
                if (this.cc = 0 == e, !this.cc) for (var i = 0; i < e; i++) this.pb.push(t[i]);
              }
            }, {
              key: "zy",
              value: function zy() {
                var t = 0,
                  e = [],
                  i = this.Yc() && this.cc ? this.Lb : this.pb,
                  s = i.length;
                if (this.Yc() && this.cc) for (i = t = 0; t < this.Lb.length;) {
                  for (; i < this.pb.length && this.Lb[t].j != this.pb[i].j;) i++;
                  i == this.pb.length && e.push(this.Lb[t]), i = 0, t++;
                } else for (; t < s; t++) e[t] = i[t];
                return {
                  items: e,
                  QN: t = (!this.Yc() || !this.cc) && 0 != e.length && this.cc
                };
              }
            }, {
              key: "aA",
              value: function aA(t) {
                this.Ql = t, this.hf = "", this.Lb.length = 0;
              }
            }, {
              key: "LD",
              value: function LD(t, e) {
                for (var i, s = [], r = t, n = new RegExp("(" + this.hf + ")", "i"), a = this.Yc() ? this.Lb : this.Ql; r < e && !(r > a.length - 1); r++) i = {
                  ke: i = a[r],
                  label: this.Yc() ? i.caption.replace(n, "<b>$1</b>") : i.caption,
                  qc: (-1 == this.pb.indexOf(i) ? this.cc : !this.cc) ? 1 : 0,
                  CN: 0,
                  n2: e - t < a.length - 1 ? 15 : 0
                }, s.push(i);
                return s;
              }
            }, {
              key: "Ou",
              value: function Ou() {
                return this.Yc() ? this.Lb.length : this.Ql.length;
              }
            }, {
              key: "Ky",
              value: function Ky() {
                return this.Ou();
              }
            }, {
              key: "Yc",
              value: function Yc() {
                return 0 < this.hf.length;
              }
            }, {
              key: "expand",
              value: function expand() {}
            }, {
              key: "collapse",
              value: function collapse() {}
            }]);
            return _class32;
          }();
        }(r || (r = {})), function (t) {
          var e;
          ((e = t.G || (t.G = {})).filter || (e.filter = {})).XR = /*#__PURE__*/function () {
            function _class33() {
              _classCallCheck(this, _class33);
              this.oz = 0, this.ua = [], this.pb = [], this.Lb = [], this.gf = [], this.Cn = [], this.hf = "", this.cc = !0, this.Nb = t.u.i.ba.mb;
            }
            _createClass(_class33, [{
              key: "$z",
              value: function $z(t) {
                this.Jb = t, this.ua.length = 0;
              }
            }, {
              key: "lq",
              value: function lq(t) {
                this.Nb = t, this.ua.length = 0, this.bE(this.Jb.Qd, -1);
              }
            }, {
              key: "aA",
              value: function aA(e) {
                for (var i, s = 0, r = e.length; s < r; s++) (i = e[s]).Qc || (this.ua.push(i), i.Zu && i.children && 0 < i.children.length && (this.Cn.push(i), this.aA(this.Nb === t.u.i.ba.mb ? i.children.Tc() : this.Jb.Cf(i, !1, this.Nb).Tc())));
              }
            }, {
              key: "LD",
              value: function LD(t, e) {
                for (var i, s = t, r = [], n = new RegExp("(" + this.hf + ")", "i"), a = this.Yc() ? this.Lb : this.ua; s < e && !(s > a.length - 1); s++) i = {
                  ke: i = a[s],
                  CN: i.level.Md,
                  label: this.Yc() ? i.caption.replace(n, "<b>$1</b>") : i.caption,
                  qc: this.qc(i),
                  Yc: this.Yc(),
                  Nf: this.Nf(i),
                  n2: e - t < a.length - 1 ? 17 : 0
                }, r.push(i);
                return r;
              }
            }, {
              key: "qc",
              value: function qc(t) {
                var e = (-1 == this.pb.indexOf(t) ? this.cc : !this.cc) ? 1 : 0;
                return 0 < this.pb.length && -1 != this.gf.indexOf(t) && (e = -1), e;
              }
            }, {
              key: "Nf",
              value: function Nf(t) {
                return this.Yc() || t.Mj ? -1 : -1 != this.Cn.indexOf(t) ? 1 : 0;
              }
            }, {
              key: "Ou",
              value: function Ou() {
                return this.Yc() ? this.Lb.length : this.ua.length;
              }
            }, {
              key: "Ky",
              value: function Ky() {
                return this.Yc() ? this.Lb.length - this.oz : this.Jb ? this.Jb.ua.length - 1 : 0;
              }
            }, {
              key: "select",
              value: function select(t, e) {
                var i = -1;
                i = this.pb.indexOf(t), this.cc !== e ? (-1 == i && this.pb.push(t), 0 < t.children.length && this.Gz(t)) : (-1 != i && this.pb.splice(i, 1), 0 < t.children.length && this.uF(t)), -1 != (i = this.gf.findIndex(function (e) {
                  return e.j === t.j;
                })) && this.gf.splice(i, 1), this.IO(t), this.pb.length === this.Jb.ua.length - 1 && (this.pb.length = 0, this.gf.length = 0, this.cc = !this.cc);
              }
            }, {
              key: "HO",
              value: function HO(t) {
                -1 == this.gf.indexOf(t) && (-1 == this.pb.indexOf(t) ? this.uF(t) : this.Gz(t));
              }
            }, {
              key: "IO",
              value: function IO(t) {
                var e = t.parent;
                if (e && !e.Qc) {
                  t = this.pb.findIndex(function (t) {
                    return t.j === e.j;
                  });
                  var i = this.gf.findIndex(function (t) {
                      return t.j === e.j;
                    }),
                    s = -1 != t;
                  this.XM(e, !1) ? (this.XM(e) ? (-1 == i && this.gf.push(e), this.cc && s && this.pb.splice(t, 1)) : (-1 != i && this.gf.splice(i, 1), this.cc && !s && this.pb.push(e)), !this.cc && s && this.pb.splice(t, 1)) : (-1 != i && this.gf.splice(i, 1), this.cc && s ? this.pb.splice(t, 1) : this.cc || s || this.pb.push(e)), this.IO(e);
                }
              }
            }, {
              key: "XM",
              value: function XM(t) {
                var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                for (var i, s = 0, r = (t = t.children.Tc()).length; s < r; s++) if (i = t[s], -1 == this.pb.findIndex(function (t) {
                  return t.j === i.j;
                }) == this.cc == e || -1 != this.gf.findIndex(function (t) {
                  return t.j === i.j;
                })) return !0;
                return !1;
              }
            }, {
              key: "Gz",
              value: function Gz(t) {
                for (var e, i, s = 0, r = t.children.Tc(), n = r.length; s < n; s++) i = r[s], t = this.pb.findIndex(function (t) {
                  return t.j === i.j;
                }), e = this.gf.findIndex(function (t) {
                  return t.j === i.j;
                }), -1 == t && this.pb.push(i), -1 != e && this.gf.splice(e, 1), 0 < i.children.length && this.Gz(i);
              }
            }, {
              key: "uF",
              value: function uF(t) {
                for (var e, i, s = 0, r = t.children.Tc(), n = r.length; s < n; s++) i = r[s], t = this.pb.findIndex(function (t) {
                  return t.j === i.j;
                }), e = this.gf.findIndex(function (t) {
                  return t.j === i.j;
                }), -1 != t && this.pb.splice(t, 1), -1 != e && this.gf.splice(e, 1), 0 < i.children.length && this.uF(i);
              }
            }, {
              key: "Bm",
              value: function Bm(t) {
                if (this.Yc()) for (var e = this.Lb.length, i = 0; i < e; i++) a.$.contains(this.Lb[i].caption, this.hf) && this.select(this.Lb[i], t);else this.cc = t, this.pb.length = 0, this.gf.length = 0;
              }
            }, {
              key: "Kn",
              value: function Kn() {
                var _this176 = this;
                if (this.Yc()) {
                  for (var t = 0, e = this.Lb.length, i = 0; i < e; i++) a.$.contains(this.Lb[i].caption, this.hf) && 0 > this.pb.findIndex(function (t) {
                    return t.j === _this176.Lb[i].j;
                  }) == this.cc && t++;
                  return t;
                }
                return this.Ln();
              }
            }, {
              key: "Ln",
              value: function Ln() {
                var t = this.cc ? this.Jb.ua.length - this.pb.length - this.gf.length - 1 : this.pb.length;
                return 0 > t ? 0 : t;
              }
            }, {
              key: "Yz",
              value: function Yz(t) {
                var e = t.length;
                if (this.pb.length = 0, this.gf.length = 0, 0 == e) this.cc = !0;else {
                  this.cc = !1;
                  for (var i, s, r, n = 0; n < e; n++) for (s = (s = (i = t[n]).children.Tc()).length, this.pb.push(i), 0 < s && this.Gz(i); i.parent && !i.parent.Qc;) r = i.parent, -1 == this.gf.findIndex(function (t) {
                    return t.j === r.j;
                  }) && this.gf.push(r), i = r;
                }
              }
            }, {
              key: "zy",
              value: function zy() {
                for (var t = 0, e = [], i = [], s = (i = this.Yc() && this.cc ? this.Lb : this.pb).length; t < s; t++) {
                  var r = i[t],
                    n = r.parent,
                    o = -1;
                  a.U(n) || (o = i.findIndex(function (t) {
                    return t.j === n.j;
                  })), -1 === o && e.push(r);
                }
                return {
                  items: e,
                  QN: t = (!this.Yc() || !this.cc) && 0 != e.length && this.cc
                };
              }
            }, {
              key: "search",
              value: function search(t, e) {
                if (t = t.toLowerCase(), this.hf === t) e();else if (this.hf = t, 0 == this.hf.length) e();else {
                  var i;
                  for (this.oz = this.Lb.length = 0, this.UL(this.Jb.Qd, t), i = 0; i < this.Lb.length; i++) t = this.aN(this.Lb[i], i), this.oz += t, i += t;
                  e(this.Lb);
                }
              }
            }, {
              key: "YO",
              value: function YO(t) {
                null != t ? this.Lb = t : this.Lb.length = 0;
              }
            }, {
              key: "aN",
              value: function aN(t, e) {
                var i = t.parent;
                return t = 0, a.U(i) || i.Qc || (-1 == this.Lb.findIndex(function (t) {
                  return t.j === i.j;
                }) && (t++, this.Lb.splice(e, 0, i)), t += this.aN(i, e)), t;
              }
            }, {
              key: "UL",
              value: function UL(t, e) {
                for (var i, s = (t = t.children).length, r = 0; r < s; r++) i = t.F(r), a.$.contains(i.caption, e) && this.Lb.push(i), this.UL(i, e);
              }
            }, {
              key: "Yc",
              value: function Yc() {
                return 0 < this.hf.length;
              }
            }, {
              key: "expand",
              value: function expand(t) {
                -1 == this.Cn.indexOf(t) && this.Cn.push(t), this.eP(t, !0);
              }
            }, {
              key: "collapse",
              value: function collapse(t) {
                var e = this.Cn.indexOf(t);
                -1 != e && this.Cn.splice(e, 1), this.eP(t, !1);
              }
            }, {
              key: "eP",
              value: function eP(t, e) {
                var i = this.ua.findIndex(function (e) {
                  return e.j === t.j;
                });
                e ? this.bE(t, i) : this.ua.splice(i + 1, this.CM(t));
              }
            }, {
              key: "bE",
              value: function bE(e, i) {
                for (var s = (e = this.Nb === t.u.i.ba.mb ? e.children.Tc() : this.Jb.Cf(e, !1, this.Nb).Tc()).length - 1, r = i + 1; -1 < s; s--) i = e[s], this.ua.splice(r, 0, i), -1 < this.Cn.indexOf(i) && this.bE(i, r);
              }
            }, {
              key: "CM",
              value: function CM(t) {
                for (var e, i = (t = t.children.Tc()).length, s = i, r = 0; r < i; r++) e = t[r], -1 < this.Cn.indexOf(e) && (s += this.CM(e));
                return s;
              }
            }]);
            return _class33;
          }();
        }(r || (r = {})), function (t) {
          var e;
          !function (e) {
            var s = /*#__PURE__*/function (_i$Ac$Lh3) {
              _inherits(s, _i$Ac$Lh3);
              var _super110 = _createSuper(s);
              function s(t) {
                var _this177;
                _classCallCheck(this, s);
                _this177 = _super110.call(this), _this177.controller = t, _this177.Bd();
                return _this177;
              }
              _createClass(s, [{
                key: "Bd",
                value: function Bd() {
                  var _s102 = new i.ya("div", "wdr-popup-header wdr-ui-row");
                  this.R(_s102);
                  var r = new i.ya("div", "wdr-ui-col-2 wdr-vam");
                  _s102.R(r), this.ro = new i.dc(), this.ro.Y("wdr-popup-title"), r.R(this.ro), r = new i.ya("div", "wdr-ui-col wdr-vam wdr-ui-btns-row"), _s102.R(r), this.rr = new i.Wb("wdr-ui-btn"), this.rr.wa(t.model.v.g.hl), this.Zn = new i.Wb("wdr-ui-btn-dark"), this.Zn.wa(t.model.v.g.Im), a.Dg.fs || a.Dg.qm ? (r.R(this.rr), r.R(this.Zn)) : (r.R(this.Zn), r.R(this.rr)), _s102 = new i.ya("div", "wdr-ui-row"), this.R(_s102), this.mq = new i.ya("div", "wdr-ui-col-2"), this.mq.B.display = "inline-block", _s102.R(this.mq), this.Cv = new i.dc(), this.Cv.qb("wdr-sort-label"), this.Cv.Y("wdr-ui-label-light"), this.Cv.wa(t.model.v.g.oH), this.mq.R(this.Cv), r = new i.ya("div", "wdr-sort-btns"), this.mq.R(r), this.Kg = new i.Xm(), this.Kg.B.Y("wdr-sort-btn"), this.Kg.wa(t.model.v.g.kH), r.R(this.Kg), this.fh = new i.Xm(), this.fh.B.Y("wdr-sort-btn"), this.fh.wa(t.model.v.g.mH), r.R(this.fh), (r = new i.ya("div", "wdr-ui-col-2 wdr-tar wdr-topx-col")).B.display = "inline-block", _s102.R(r), this.rd = new i.Xm(), this.rd.qb("wdr-top10-btn"), this.rd.Y("wdr-ui-toggle-btn-dark"), this.rd.wa(t.model.v.g.qH), r.R(this.rd), this.wr = new i.ya("span", "wdr-btn-canceltopx"), this.wr.qb("wdr-clear-top-btn"), this.wr.B.ja("title", t.model.v.g.rH), this.rd.R(this.wr), this.kd = new e.TI(), this.kd.qb("wdr-filters-topx-view"), this.kd.Da(), this.R(this.kd), this.Wn = new e.YR(), this.Wn.Y("wdr-ft-contentheight-220"), this.R(this.Wn);
                }
              }, {
                key: "Fc",
                get: function get() {
                  return this.Wn.Fc;
                }
              }, {
                key: "hb",
                get: function get() {
                  return this.Wn.hb;
                }
              }, {
                key: "ho",
                get: function get() {
                  return this.Wn.ho;
                }
              }, {
                key: "$i",
                get: function get() {
                  return this.Wn.$i;
                }
              }, {
                key: "Tj",
                value: function Tj() {
                  this.rd.wa(t.model.v.g.qH), this.wr.B.ja("title", t.model.v.g.rH), this.Kg.wa(t.model.v.g.kH), this.fh.wa(t.model.v.g.mH), this.$i.Hs(t.model.v.g.nH), this.Fc.wa(t.model.v.g.jt), this.Zn.wa(t.model.v.g.Im), this.rr.wa(t.model.v.g.hl), this.Cv.wa(t.model.v.g.oH), this.kd.Tj();
                }
              }]);
              return s;
            }(i.Ac.Lh);
            e.aR = s;
          }((e = t.G || (t.G = {})).filter || (e.filter = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (e) {
            var s = /*#__PURE__*/function (_i$ya4) {
              _inherits(s, _i$ya4);
              var _super111 = _createSuper(s);
              function s() {
                var _this178;
                _classCallCheck(this, s);
                _this178 = _super111.call(this, "div", "wdr-filters-table");
                var _s103 = new i.ya("div", "wdr-filters-table-header wdr-fth-withsearch");
                _this178.R(_s103), _this178.Fc = new i.No(), _this178.Fc.wa(t.model.v.g.jt), _s103.R(_this178.Fc), _this178.ho = new i.dc(), _this178.ho.qb("wdr-select-counter"), _s103.R(_this178.ho), _this178.tg = new i.ya("div", "wdr-search-wrap"), _s103.R(_this178.tg), (_s103 = new i.ya("a", "wdr-search-btn")).B.text(t.model.v.g.nH), _s103.addEventListener("click", function () {
                  return _this178.fF();
                }), _this178.tg.R(_s103);
                var r = new i.ya("span", "wdr-ui-icon wdr-icon-act_search");
                _s103.R(r), _this178.$i = new i.zl(), _this178.$i.Y("wdr-search-inp"), _this178.tg.R(_this178.$i), (_s103 = new i.ya("span", "wdr-close-search wdr-ui-icon wdr-icon-act_close")).addEventListener("click", function () {
                  return _this178.wz();
                }), _this178.tg.R(_s103), _s103 = new i.ya("div", "wdr-filters-table-content"), _this178.R(_s103), _this178.hb = new e.kt(), _this178.hb.JF(new e.bI()), _this178.hb.qb("wdr-members-filter-list"), _s103.R(_this178.hb);
                return _this178;
              }
              _createClass(s, [{
                key: "fF",
                value: function fF() {
                  this.tg.Y("wdr-search-opened"), this.$i.B.focus(), this.ho.Da();
                }
              }, {
                key: "wz",
                value: function wz() {
                  this.tg.qd("wdr-search-opened"), this.$i.clear(), this.ho.show();
                }
              }, {
                key: "reset",
                value: function reset() {
                  this.wz();
                }
              }]);
              return s;
            }(i.ya);
            e.YR = s;
          }((e = t.G || (t.G = {})).filter || (e.filter = {}));
        }(r || (r = {})), function (t) {
          var s;
          !function (t) {
            var s = /*#__PURE__*/function (_i$yf$wt3) {
              _inherits(s, _i$yf$wt3);
              var _super112 = _createSuper(s);
              function s() {
                var _this179;
                _classCallCheck(this, s);
                _this179 = _super112.call(this), _this179.a_ = 20, _this179.jm = new i.Xm(), _this179.jm.qd("wdr-ui-toggle-btn"), _this179.jm.Y("wdr-expand-toggle-btn"), _this179.jm.addEventListener(e.ga.oe, function () {
                  return _this179.W_();
                }), _this179.B.append(_this179.jm.B), _this179.hq = new i.No(), _this179.hq.addEventListener(e.ga.oe, function () {
                  return _this179.xz();
                }), _this179.B.append(_this179.hq.B), _this179.B.addEventListener("click", function (t) {
                  return _this179.wf(t);
                }), _this179.df("all");
                return _this179;
              }
              _createClass(s, [{
                key: "W_",
                value: function W_() {
                  var e = this.getData();
                  e.Nf = this.jm.getSelection(), this.B.Oa(t.kt.et, this, e);
                }
              }, {
                key: "wf",
                value: function wf(t) {
                  t.target == this.B.element && (this.hq.toggle(), this.xz());
                }
              }, {
                key: "xz",
                value: function xz() {
                  var e = this.getData();
                  e.qc = this.hq.getSelection(), this.B.Oa(t.kt.yw, this, e);
                }
              }, {
                key: "Ha",
                value: function Ha() {
                  if (this.ez()) {
                    var t = this.getData();
                    if (this.jm && this.hq && t) {
                      this.B.ha("padding-left", "");
                      var e = this.a_ * (t.CN - 1);
                      t.Yc || -1 !== t.Nf || (e += 30), 0 < e && this.B.ha("padding-left", e + "px"), isNaN(t.Nf) || -1 === t.Nf || t.Yc ? this.jm.Da() : (this.jm.show(), this.jm.wc(t.Nf)), e = (e = t[this.Ni()]).replace(/<(?:.|\n)*?>/gi, ""), this.hq.wa(e, !0), this.hq.wc(t.qc);
                    }
                  }
                }
              }]);
              return s;
            }(i.yf.wt);
            t.ZQ = s;
          }((s = t.G || (t.G = {})).filter || (s.filter = {}));
        }(r || (r = {})), function (t) {
          var s;
          !function (s) {
            var r = /*#__PURE__*/function (_i$Zc$eT) {
              _inherits(r, _i$Zc$eT);
              var _super113 = _createSuper(r);
              function r() {
                var _this180;
                _classCallCheck(this, r);
                _this180 = _super113.call(this), _this180.$g(function (t, e) {
                  return _this180.FY(t, e);
                });
                return _this180;
              }
              _createClass(r, [{
                key: "FY",
                value: function FY(t, e) {
                  var _this181 = this;
                  var i = new s.ZQ();
                  return i.setData(t), i.al(e), i.addEventListener(r.yw, function (t) {
                    return _this181.xz(t);
                  }), i.addEventListener(r.et, function (t) {
                    return _this181.g0(t);
                  }), i;
                }
              }, {
                key: "xz",
                value: function xz(t) {
                  t = t.data, this.X2(t, 1 === t.qc), this.na(new e.ga(r.yw, this));
                }
              }, {
                key: "g0",
                value: function g0(i) {
                  1 === (i = i.data).Nf ? 0 === i.ke.children.length ? t.model.yb.V() : this.T_(i.ke) : (this.Ud().collapse(i.ke), this.df("data"), this.na(new e.ga(r.et, this)));
                }
              }, {
                key: "T_",
                value: function T_(i) {
                  t.Ta(!1), this.Ud().HO(i), this.Ud().expand(i), this.df("data"), this.na(new e.ga(r.et, this));
                }
              }, {
                key: "Ud",
                value: function Ud() {
                  return this.uX;
                }
              }, {
                key: "JF",
                value: function JF(t) {
                  this.uX = t;
                }
              }, {
                key: "zy",
                value: function zy() {
                  return this.Ud().zy();
                }
              }, {
                key: "Yz",
                value: function Yz(t) {
                  this.Ud().Yz(t), this.df("data");
                }
              }, {
                key: "Kn",
                value: function Kn() {
                  return this.Ud().Kn();
                }
              }, {
                key: "Ln",
                value: function Ln() {
                  return this.Ud().Ln();
                }
              }, {
                key: "Ky",
                value: function Ky() {
                  return this.Ud().Ou();
                }
              }, {
                key: "Jy",
                value: function Jy() {
                  return this.Ud().Ky();
                }
              }, {
                key: "X2",
                value: function X2(t, e) {
                  this.Ud().select(t.ke, e), this.df("data");
                }
              }, {
                key: "Bm",
                value: function Bm(t) {
                  this.Ud().Bm(t), this.df("data");
                }
              }, {
                key: "search",
                value: function search(t, e) {
                  var _this182 = this;
                  this.Ud().search(t, function (t) {
                    _this182.Ud().YO(t), _this182.df("data"), e();
                  });
                }
              }, {
                key: "Yc",
                value: function Yc() {
                  return this.Ud().Yc();
                }
              }, {
                key: "$z",
                value: function $z(t) {
                  this.Ud().$z(t);
                }
              }, {
                key: "sort",
                value: function sort(t) {
                  t !== this.Ud().Nb && (this.Ud().lq(t), this.df("data"));
                }
              }]);
              return r;
            }(i.Zc.eT);
            r.yw = "_", r.et = "__", s.kt = r;
          }((s = t.G || (t.G = {})).filter || (s.filter = {}));
        }(r || (r = {})), function (t) {
          var s;
          !function (s) {
            var r = /*#__PURE__*/function (_i$ya5) {
              _inherits(r, _i$ya5);
              var _super114 = _createSuper(r);
              function r() {
                var _this183;
                _classCallCheck(this, r);
                _this183 = _super114.call(this, "div"), _this183.qk = !0, _this183.Y("wdr-filters-subview"), _this183.bo = new i.zl(), _this183.bo.qb("wdr-top-amount-input"), _this183.bo.T2(), _this183.bo.Z2(), _this183.bo.addEventListener(i.zl.gi, function () {
                  return _this183.Z0();
                }), _this183.R(_this183.bo);
                var s = new i.ya("div");
                s.qb("wdr-topx-btns"), _this183.R(s), _this183.xi = new i.Xm(), _this183.xi.qb("wdr-btn-top"), _this183.xi.Y("wdr-topx-btn"), _this183.xi.wa(t.model.v.g.pH), _this183.xi.addEventListener(e.ga.oe, function () {
                  return _this183.Q_();
                }), s.R(_this183.xi), _this183.wi = new i.Xm(), _this183.wi.qb("wdr-btn-bottom"), _this183.wi.Y("wdr-topx-btn"), _this183.wi.wa(t.model.v.g.lH), _this183.wi.addEventListener(e.ga.oe, function () {
                  return _this183.O_();
                }), s.R(_this183.wi), _this183.Ti = new i.Zc.cT(), _this183.Ti.qb("wdr-top-measures-dropdown"), _this183.Ti.wg("caption"), _this183.Ti.Hs(""), _this183.Ti.addEventListener(e.ga.oe, function () {
                  return _this183.L0();
                }), _this183.R(_this183.Ti);
                return _this183;
              }
              _createClass(r, [{
                key: "Q_",
                value: function Q_() {
                  this.qk = !1, this.wi.wc(1 - this.xi.getSelection()), this.na(new e.ga(r.gi, this));
                }
              }, {
                key: "O_",
                value: function O_() {
                  this.qk = !1, this.xi.wc(1 - this.wi.getSelection()), this.na(new e.ga(r.gi, this));
                }
              }, {
                key: "L0",
                value: function L0() {
                  this.qk = !1, this.na(new e.ga(r.gi, this));
                }
              }, {
                key: "Z0",
                value: function Z0() {
                  this.qk = !1, "" == this.xM() && this.WO(t.u.i.Dd.ut), this.na(new e.ga(r.gi, this));
                }
              }, {
                key: "O2",
                value: function O2(t) {
                  this.Ti.vg(t), this.Ti.io(0);
                }
              }, {
                key: "XY",
                value: function XY() {
                  return this.Ti.Jn();
                }
              }, {
                key: "Y2",
                value: function Y2(t) {
                  this.qk = !1, this.Ti.yv(t, "uniqueName");
                }
              }, {
                key: "reset",
                value: function reset() {
                  this.qk = !0;
                  var e = t.model.A.P.Dc;
                  this.xi.wc(e ? 0 : 1), this.wi.wc(0), this.Ti.io(0), this.Ti.isVisible(!e), this.bo.bj("10");
                }
              }, {
                key: "Tj",
                value: function Tj() {
                  this.xi.wa(t.model.v.g.pH), this.wi.wa(t.model.v.g.lH), this.Ti.Hs("");
                }
              }, {
                key: "xM",
                value: function xM() {
                  return 1 === this.xi.getSelection() ? t.u.i.Dd.ut : 1 === this.wi.getSelection() ? t.u.i.Dd.tq : "";
                }
              }, {
                key: "WO",
                value: function WO(e) {
                  e == t.u.i.Dd.ut ? (this.qk = !1, this.xi.wc(1), this.wi.wc(0)) : e == t.u.i.Dd.tq && (this.qk = !1, this.xi.wc(0), this.wi.wc(1));
                }
              }, {
                key: "zY",
                value: function zY() {
                  return parseInt(this.bo.Gj());
                }
              }, {
                key: "I2",
                value: function I2(t) {
                  this.qk = !1, this.bo.bj(t.toString());
                }
              }, {
                key: "Db",
                get: function get() {
                  return this.qk;
                }
              }]);
              return r;
            }(i.ya);
            r.gi = "_", s.TI = r;
          }((s = t.G || (t.G = {})).filter || (s.filter = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (i) {
            var s = /*#__PURE__*/function () {
              function s() {
                _classCallCheck(this, s);
                if (this.PF = !1, null != s.instance) throw "FilterModel is singleton!";
                this.Sk = t.model.yb.V(), e.xb.tb.position();
              }
              _createClass(s, [{
                key: "$k",
                value: function $k(t) {
                  this.va = t;
                }
              }, {
                key: "update",
                value: function update(t) {
                  var e = this.Sk.O.fa.bb(!1, !0, this.ef).Tc();
                  this.$k(e), this.QO(t), this.Ia = this.Sk.O.fa.pa.Tc();
                }
              }, {
                key: "zx",
                value: function zx() {
                  this.Jd = t.u.i.Dd.NONE, this.bf = -1, this.pd = "";
                }
              }, {
                key: "QO",
                value: function QO(e) {
                  (this.Jb = e) && (this.Nb = this.Jb.Gc, this.PF = !1, this.pd = this.Jb.pd, this.bf = this.Jb.bf, this.Jd = this.Jb.Jd, this.ua = this.Nb !== t.u.i.ba.mb ? this.Jb.Cf(this.Jb.Qd, !1, this.Nb).Tc() : this.Jb.Qd.children.Tc());
                }
              }, {
                key: "bZ",
                value: function bZ() {
                  return this.ef ? [this.Sk.O.ea.og(this.Jb.j)] : this.Ia;
                }
              }, {
                key: "lq",
                value: function lq(t) {
                  this.Nb = t, this.PF = !0;
                }
              }, {
                key: "bV",
                value: function bV() {
                  this.Jb.$r() && this.rN && this.Sk.vn(this.Jb.j), this.eV(), this.iV(), this.gV();
                }
              }, {
                key: "rN",
                get: function get() {
                  return !this.pd || 0 === this.pd.length || isNaN(this.bf) || 1 > this.bf || !this.Jd || 0 === this.Jd.length || this.Jd === t.u.i.Dd.NONE;
                }
              }, {
                key: "ZZ",
                get: function get() {
                  return this.Jb.pd !== this.pd || this.Jb.bf !== this.bf || this.Jb.Jd !== this.Jd;
                }
              }, {
                key: "iV",
                value: function iV() {
                  !this.rN && this.ZZ && ("top" === this.Jd ? this.Sk.zv(this.Jb.j, this.bf, this.pd) : "bottom" === this.Jd && this.Sk.uv(this.Jb.j, this.bf, this.pd));
                }
              }, {
                key: "KZ",
                value: function KZ() {
                  if (this.Fu.length !== this.Jb.Me.length && !this.$x) return !0;
                  for (var t = 0, e = this.Fu.length; t < e; t++) if (this.$x === this.Jb.Me.rc(this.Fu[t].j)) return !0;
                  return !(!this.$x || !this.Jb || this.Jb.Me.length + this.Fu.length === this.Jb.ua.length - 1);
                }
              }, {
                key: "eV",
                value: function eV() {
                  this.KZ() && this.Sk.wv(this.Jb.j, this.Fu, this.$x);
                }
              }, {
                key: "gV",
                value: function gV() {
                  this.PF && this.Sk.jo(this.Jb.j, this.Nb);
                }
              }, {
                key: "mE",
                get: function get() {
                  return !this.ef && this.Sk.O.fa.eb.rc(this.Jb.j);
                }
              }, {
                key: "ef",
                get: function get() {
                  return t.model.A.P.Dc;
                }
              }], [{
                key: "V",
                value: function V() {
                  return null == s.instance && (s.instance = new s()), s.instance;
                }
              }, {
                key: "la",
                value: function la() {
                  s.instance = null;
                }
              }]);
              return s;
            }();
            i.uH = s;
          }((e = t.G || (t.G = {})).filter || (e.filter = {}));
        }(r || (r = {})), function (t) {
          var s;
          !function (r) {
            var n = /*#__PURE__*/function (_e$Od21) {
              _inherits(n, _e$Od21);
              var _super115 = _createSuper(n);
              function n() {
                var _this184;
                _classCallCheck(this, n);
                _this184 = _super115.call(this), _this184.model = r.uH.V(), _this184.view = new r.aR(_assertThisInitialized(_this184)), null != _this184.view.jZ && _this184.view.jZ.addEventListener(e.ga.oe, function (t) {
                  return _this184.B0(t);
                }), null != _this184.view.$i && _this184.view.$i.addEventListener(i.zl.gi, function (t) {
                  return _this184.k1(t.data);
                }), null != _this184.view.hb && (_this184.view.hb.addEventListener(r.kt.yw, function () {
                  return _this184.N0();
                }), _this184.view.hb.addEventListener(r.kt.et, function () {
                  return _this184.M0();
                })), null != _this184.view.Fc && _this184.view.Fc.addEventListener(e.ga.oe, function () {
                  return _this184.gF();
                }), null != _this184.view.Kg && _this184.view.Kg.addEventListener(e.ga.oe, function () {
                  return _this184.M_();
                }), null != _this184.view.fh && _this184.view.fh.addEventListener(e.ga.oe, function () {
                  return _this184.A1();
                }), null != _this184.view.rd && _this184.view.rd.addEventListener(e.ga.oe, function () {
                  return _this184.t1();
                }), null != _this184.view.wr && _this184.view.wr.B.addEventListener("click", function (t) {
                  return _this184.U_(t);
                }), null != _this184.view.kd && _this184.view.kd.addEventListener(r.TI.gi, function () {
                  return _this184.u1();
                }), null != _this184.view.Zn && _this184.view.Zn.addEventListener(i.Wb.Se, function () {
                  return _this184.Vp();
                }), null != _this184.view.rr && _this184.view.rr.addEventListener(i.Wb.Se, function () {
                  return _this184.Tp();
                });
                return _this184;
              }
              _createClass(n, [{
                key: "U_",
                value: function U_(t) {
                  t.stopImmediatePropagation(), this.model.zx(), this.view.kd && (this.view.kd.reset(), this.view.kd.Da()), this.view.rd && (this.view.rd.B.qd("wdr-not-empty"), this.view.rd.wc(0));
                }
              }, {
                key: "u1",
                value: function u1() {
                  if (this.view.kd) {
                    this.model.Jd = this.view.kd.xM(), this.model.bf = this.view.kd.zY();
                    var t = this.view.kd.XY();
                    this.model.pd = t ? t.j : "";
                  }
                  this.view.rd && this.view.rd.B.Y("wdr-not-empty");
                }
              }, {
                key: "t1",
                value: function t1() {
                  this.view.kd && this.view.kd.isVisible(1 === this.view.rd.getSelection());
                }
              }, {
                key: "Vp",
                value: function Vp() {
                  this.Oa("close");
                  var t = this.view.hb.zy();
                  this.model.Fu = t.items, this.model.$x = t.QN, this.model.bV();
                }
              }, {
                key: "Tp",
                value: function Tp() {
                  this.Oa("close");
                }
              }, {
                key: "M_",
                value: function M_() {
                  1 === this.view.Kg.getSelection() && (this.view.fh.wc(0), this.model.lq(t.u.i.ba.ub), this.view.hb && this.view.hb.sort(this.model.Nb)), 0 === this.view.Kg.getSelection() && 0 === this.view.fh.getSelection() && (this.model.lq(t.u.i.ba.mb), this.view.hb && this.view.hb.sort(this.model.Nb));
                }
              }, {
                key: "A1",
                value: function A1() {
                  1 === this.view.fh.getSelection() && (this.view.Kg.wc(0), this.model.lq(t.u.i.ba.vb), this.view.hb && this.view.hb.sort(this.model.Nb)), 0 === this.view.Kg.getSelection() && 0 === this.view.fh.getSelection() && (this.model.lq(t.u.i.ba.mb), this.view.hb && this.view.hb.sort(this.model.Nb));
                }
              }, {
                key: "gF",
                value: function gF() {
                  this.view.hb && (this.view.hb.Bm(1 == this.view.Fc.getSelection()), this.view.hb.Ln(), this.view.Zn.Xz(0 < this.view.hb.Ln())), this.Nv();
                }
              }, {
                key: "N0",
                value: function N0() {
                  this.view.Zn.Xz(0 < this.view.hb.Ln()), this.LP(), this.Nv();
                }
              }, {
                key: "M0",
                value: function M0() {
                  this.ZF(), this.Nv();
                }
              }, {
                key: "LP",
                value: function LP() {
                  0 == this.view.hb.Kn() ? this.view.Fc.wc(0) : this.view.hb.Jy() > this.view.hb.Kn() ? this.view.Fc.wc(-1) : this.view.hb.Jy() == this.view.hb.Kn() && this.view.Fc.wc(1);
                }
              }, {
                key: "update",
                value: function update(e) {
                  var _this185 = this;
                  0 != this.view.isVisible() && (1e4 < e.ua.length ? (t.Ta(!0, "Please, wait", "Sorting members...", !0, !0), setTimeout(function () {
                    _this185.model.update(e), _this185.dj(), t.Ta(!1);
                  }, 50)) : (this.model.update(e), this.dj()));
                }
              }, {
                key: "k1",
                value: function k1(t) {
                  var _this186 = this;
                  t.trim() == t && this.view.hb && this.view.hb.search(t, function () {
                    return _this186.j1();
                  });
                }
              }, {
                key: "j1",
                value: function j1() {
                  this.ZF(), this.Nv(), this.LP();
                }
              }, {
                key: "dj",
                value: function dj() {
                  this.view.Tj(), this.view.B.Va("wdr-filter-pages-layout", this.model.mE), this.view.Wn && this.view.Wn.reset(), this.view.$i && (this.view.$i.clear(), this.view.$i.MO(0)), this.view.rd && (t.u.types.Ca.nd == t.u.types.Ca.EX(this.model.Jb.xj.type + "") && t.model.A.P.Dc ? this.view.rd.Da() : this.view.rd.show()), this.a4(), this.X3(), this.Z3(), this.b4(), this.ZF(), this.Nv();
                  var e = !this.model.mE;
                  this.view.Kg && (e ? this.view.Kg.show() : this.view.Kg.Da()), this.view.fh && (e ? this.view.fh.show() : this.view.fh.Da()), this.view.rd && (this.qZ ? this.view.rd.show() : this.view.rd.Da()), this.view.mq && (e ? this.view.mq.show() : this.view.mq.Da());
                }
              }, {
                key: "qZ",
                get: function get() {
                  if (this.model.ef) {
                    var e = this.model.Sk.O.ea.og(this.model.Jb.j);
                    return e && e.type == t.u.types.Ca.Rb;
                  }
                  return !this.model.mE;
                }
              }, {
                key: "Z3",
                value: function Z3() {
                  var t = this.model.Jb;
                  this.view.Fc && this.view.Fc.wc(0 < t.Me.length ? -1 : 1);
                  var e = 2 < t.Fb.length ? new r.XR() : new r.bI();
                  this.view.hb && (this.view.hb.JF(e), this.view.hb.$z(t), this.view.hb.vg(this.model.ua), this.view.hb.Yz(t.Me.Tc()), this.view.hb.sort(this.model.Nb));
                }
              }, {
                key: "X3",
                value: function X3() {
                  this.view.ro && this.view.ro.wa(this.model.Jb.caption), this.view.toolbar && this.view.toolbar.L2(this.model.Jb.caption);
                }
              }, {
                key: "ZF",
                value: function ZF() {
                  if (this.view.hb && 0 < this.view.hb.Ky()) {
                    if (this.view.Fc && this.view.Fc.show(), 0 == this.view.ML || isNaN(this.view.ML)) {
                      var t = a.Wc().pg ? a.e4() - 50 : s.xb.tb.Ly() + s.xb.rP - window.document.documentElement.scrollTop;
                      t = Math.min(t, parseFloat(window.document.documentElement.style.height)) - this.view.hb.B.offset().top + window.document.documentElement.scrollTop - s.xb.tb.Mv, t = Math.max(t, 84), this.XO(t, !0);
                    } else this.XO(this.view.ML, !1);
                  } else this.view.Fc && this.view.Fc.Da();
                }
              }, {
                key: "a4",
                value: function a4() {
                  this.view.Kg && this.view.Kg.wc("asc" === this.model.Nb ? 1 : 0), this.view.fh && this.view.fh.wc("desc" === this.model.Nb ? 1 : 0);
                }
              }, {
                key: "b4",
                value: function b4() {
                  var _this187 = this;
                  this.view.kd && (this.view.kd.reset(), this.view.kd.O2(this.model.bZ())), "top" === this.model.Jd || "bottom" === this.model.Jd ? (this.view.kd && (this.view.kd.WO(this.model.Jd), this.view.kd.I2(this.model.bf), this.view.kd.Y2(this.model.Ia.find(function (t) {
                    return t.j === _this187.model.pd;
                  })), this.view.kd.show()), this.view.rd && this.view.rd.wc(1)) : (this.view.kd && this.view.kd.Da(), this.view.rd && this.view.rd.wc(0));
                  var t = !this.view.kd || this.view.kd.Db;
                  this.view.rd && this.view.rd.B.Va("wdr-not-empty", !t);
                }
              }, {
                key: "XO",
                value: function XO(t, e) {
                  t = Math.max(Math.min(t, this.view.hb.Ur()), this.view.hb.ND()), e && (t -= e = t % this.view.hb.Zb()), this.view.hb.Fs(t), this.view.table && this.view.D5.Fs(this.view.table.Xc());
                }
              }, {
                key: "Nv",
                value: function Nv() {
                  var e = "";
                  this.view.hb && (e = this.view.hb.Yc() ? a.$.bind(t.model.v.g.TQ, this.view.hb.Kn(), this.view.hb.Jy()) : a.$.bind(t.model.v.g.UQ, this.view.hb.Kn(), this.view.hb.Jy())), this.view.ho && this.view.ho.wa(e), this.view.Fc && this.view.Fc.wa(this.view.hb && this.view.hb.Yc() ? t.model.v.g.WQ : t.model.v.g.jt);
                }
              }, {
                key: "B0",
                value: function B0(t) {
                  var e = t.data.Zg;
                  -1 < t.data.selectedIndex && (this.model.QO(e), this.dj());
                }
              }]);
              return n;
            }(e.Od);
            r.YQ = n;
          }((s = t.G || (t.G = {})).filter || (s.filter = {}));
        }(r || (r = {})), function (t) {
          var s;
          !function (t) {
            var r = /*#__PURE__*/function (_i$Ac$Oo7) {
              _inherits(r, _i$Ac$Oo7);
              var _super116 = _createSuper(r);
              function r() {
                var _this188;
                _classCallCheck(this, r);
                _this188 = _super116.call(this, s.xb.tb.B), _this188.qb("wdr-filter-view"), _this188.Y("wdr-noselect"), _this188.controller = new t.YQ(), _this188.controller.addEventListener("close", function () {
                  return _this188.close();
                }), _this188.R(_this188.controller.view), _this188.controller.view.show();
                return _this188;
              }
              _createClass(r, [{
                key: "ym",
                value: function ym(t) {
                  this.open(), this.controller.update(t), this.sr(), this.Oa(e.ga.OPENED);
                }
              }, {
                key: "close",
                value: function close() {
                  _get(_getPrototypeOf(r.prototype), "close", this).call(this), this.Oa(e.ga.CLOSED);
                }
              }]);
              return r;
            }(i.Ac.Oo);
            t.$Q = r;
          }((s = t.G || (t.G = {})).filter || (s.filter = {}));
        }(r || (r = {})), function (t) {
          t.uT = /*#__PURE__*/function () {
            function _class34() {
              _classCallCheck(this, _class34);
              this.styleSheet = new t.Gb.zT(), this.be = [], t.Gb.format.So.wN = t.Gb.format.So.pL;
            }
            _createClass(_class34, [{
              key: "N3",
              value: function N3() {
                var e = new g();
                e.file("[Content_Types].xml", t.fe.jk + this.bW()), e.file("_rels/.rels", t.fe.jk + t.fe.AT), e.file("xl/_rels/workbook.xml.rels", t.fe.jk + this.jW()), e.file("xl/workbook.xml", t.fe.jk + this.kW()), e.file("xl/theme/theme1.xml", t.fe.jk + t.fe.US);
                for (var i = 0; i < this.be.length; i++) {
                  var s = this.be[i].ne();
                  e.file("xl/worksheets/sheet" + (i + 1) + ".xml", t.fe.jk + s);
                }
                return e.file("xl/sharedStrings.xml", t.fe.jk + this.hW()), e.file("xl/styles.xml", t.fe.jk + this.styleSheet.ne()), e.file("docProps/app.xml", t.fe.jk + t.fe.VP), e.file("docProps/core.xml", t.fe.jk + t.fe.pQ), e.generate({
                  compression: "STORE",
                  type: "uint8array"
                });
              }
            }, {
              key: "hW",
              value: function hW() {
                var e = "";
                n.ZI.create("<axis/>").ja("name", "rows");
                for (var i = 0; i < t.xt.Gv.length; i++) e += "<si><t>" + a.$.kX(t.xt.Gv[i]) + "</t></si>";
                return a.$.bind(t.fe.ES, e);
              }
            }, {
              key: "kW",
              value: function kW() {
                for (var e = "", i = 0; i < this.be.length; i++) e += a.$.bind('<sheet name="{0}" sheetId="{1}" r:id="{2}"/>', this.be[i].name, i + 1, "rId" + (i + 4));
                return a.$.bind(t.fe.rT, e);
              }
            }, {
              key: "jW",
              value: function jW() {
                for (var e = "", i = 0; i < this.be.length; i++) e += a.$.bind(t.fe.tT, "rId" + (i + 4), "worksheets/sheet" + (i + 1) + ".xml");
                return a.$.bind(t.fe.sT, e);
              }
            }, {
              key: "bW",
              value: function bW() {
                for (var e = "", i = 0; i < this.be.length; i++) e += a.$.bind(t.fe.gQ, "/xl/worksheets/sheet" + (i + 1) + ".xml");
                return a.$.bind(t.fe.fQ, e);
              }
            }]);
            return _class34;
          }();
        }(rt || (rt = {})), function (t) {
          t.Iw = /*#__PURE__*/function () {
            function _class35() {
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
              var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
              _classCallCheck(this, _class35);
              this.Xk = t, this.zk = e, this.value = i, this.SF = s;
            }
            _createClass(_class35, [{
              key: "type",
              get: function get() {
                return this.Vc;
              }
            }, {
              key: "value",
              get: function get() {
                return this.kC;
              },
              set: function set(e) {
                if ("number" == typeof e && isNaN(e) && (e = ""), "string" == typeof e) {
                  e = (e = (e = e.replace(RegExp("<br/?>", "gmi"), "\n")).replace("/&/gmi", "")).replace(RegExp("<[^<]+?>", "gmi"), "");
                  var i = t.xt.Gv.indexOf(e);
                  -1 == i ? (this.kC = t.xt.Gv.length, t.xt.Gv.push(e)) : this.kC = i, this.Vc = t.Zm.nd;
                } else this.kC = e, this.Vc = "number" == typeof e ? t.Zm.Rb : null === e ? t.Zm.dI : !1 === e ? t.Zm.PH : t.Zm.gT;
              }
            }, {
              key: "id",
              get: function get() {
                for (var t = "", e = this.zk + 1, i = 0; 26 < e;) {
                  var s = 0 < e % 26 ? e % 26 : 26;
                  if (e /= 26, 26 == s && e--, t = String.fromCharCode(s + 64) + t, 3 == i++) break;
                }
                return (t = String.fromCharCode(e + 64) + t) + (this.Xk + 1);
              },
              set: function set(t) {}
            }, {
              key: "toString",
              value: function toString() {
                return "XLSCell {row: " + this.Xk + ", column: " + this.zk + ", type: " + this.type + ", id: " + this.id + ", value: " + this.value + "}";
              }
            }]);
            return _class35;
          }();
        }(rt || (rt = {}));
        var lt = rt || (rt = {});
        var At = /*#__PURE__*/_createClass(function At() {
          _classCallCheck(this, At);
        });
        At.Gv = [], lt.xt = At, function (t) {
          t.vT = /*#__PURE__*/function () {
            function _class36(t) {
              _classCallCheck(this, _class36);
              this.cells = [], this.kz = this.BE = 0, this.za = [], this.rows = [], this.lz = [], this.name = t;
            }
            _createClass(_class36, [{
              key: "GN",
              get: function get() {
                return this.Ld(this.BE, this.kz);
              },
              set: function set(t) {}
            }, {
              key: "YV",
              get: function get() {
                return this.kz + 1;
              }
            }, {
              key: "PO",
              value: function PO(t, e) {
                this.za[t] = e;
              }
            }, {
              key: "Or",
              value: function Or(t) {
                return this.za[t] ? this.za[t] : 0;
              }
            }, {
              key: "kq",
              value: function kq(t, e) {
                this.rows[t] = e;
              }
            }, {
              key: "Zb",
              value: function Zb(t) {
                return this.rows[t] ? this.rows[t] : 0;
              }
            }, {
              key: "Bf",
              value: function Bf(e, i, s) {
                var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                null == this.cells[e] && (this.cells[e] = []), this.cells[e][i] = s instanceof t.Iw ? s : new t.Iw(e, i, s, null == r ? 0 : r.index), this.BE < e && (this.BE = e), this.kz < i && (this.kz = i);
              }
            }, {
              key: "Ld",
              value: function Ld(e, i) {
                var s;
                return null != this.cells[e] && (s = this.cells[e][i]), null == s && (s = new t.Iw(e, i, null)), s;
              }
            }, {
              key: "KN",
              value: function KN(e, i, s) {
                var r = this.Ld(e, i);
                if (null != r) {
                  for (var n, a = r.id, o = i + 1; o < i + s; o++) n = new t.Iw(e, o, !1, r.SF), this.cells[e][o] = n;
                  a += ":" + (n ? n.id : r.id), this.lz.push(a);
                }
              }
            }, {
              key: "ne",
              value: function ne() {
                for (var e = "", i = 0; i < this.cells.length; i++) {
                  var s = this.cells[i];
                  if (null != s && 0 != s.length) {
                    for (var r = "", n = 0; n < s.length; n++) {
                      var o = s[n];
                      null != o && o.type != t.Zm.dI && (r = o.type == t.Zm.PH ? r + '<c r="' + o.id + '" s="' + o.SF.toString() + '" />' : r + '<c r="' + o.id + '" s="' + o.SF.toString() + '"' + (o.type == t.Zm.nd ? ' t="s"' : "") + "><v>" + o.value + "</v></c>");
                    }
                    e = isNaN(this.rows[i]) ? e + a.$.bind('<row spans="1:3" r="{0}"  >{1}</row>', i + 1, r) : e + a.$.bind('<row spans="1:3" r="{0}" x14ac:dyDescent="0.25" ht="{1}" customHeight="1">{2}</row>', i + 1, this.rows[i], r);
                  }
                }
                for (i = "", s = 0; s < this.za.length; s++) isNaN(this.za[s]) || (i += a.$.bind('<col min="{0}" max="{1}" width="{2}" customWidth="1" />', s + 1, s + 1, this.za[s]));
                for (r = "", s = 0; s < this.lz.length; s++) r += a.$.bind('<mergeCell ref="{0}"/>', this.lz[s]);
                return s = 0 < this.lz.length ? a.$.bind('<mergeCells count="{0}">{1}</mergeCells>', this.KN.length, r) : "", a.$.bind(t.fe.FS, this.Ld(0, 0).id + ":" + this.GN.id, i, e, s);
              }
            }]);
            return _class36;
          }();
        }(rt || (rt = {}));
        var ct = rt || (rt = {});
        var ut = /*#__PURE__*/_createClass(function ut() {
          _classCallCheck(this, ut);
        });
        ut.dI = 0, ut.Rb = 1, ut.nd = 2, ut.PH = 98, ut.gT = 99, ct.Zm = ut, function (t) {
          var e;
          (e = t.Gb || (t.Gb = {})).Mq = /*#__PURE__*/function () {
            function _class37(t, i) {
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              _classCallCheck(this, _class37);
              this.index = 0, this.fill = i instanceof e.Kf.yt ? i : !isNaN(i) && -1 < i ? new e.Kf.yt(i) : new e.Kf.yt(), this.font = t instanceof e.fonts.Ym ? t : new e.fonts.Ym(t), this.format = s && s instanceof e.format.So ? s : new e.format.So(0, ""), null != r && (this.textAlign = r);
            }
            _createClass(_class37, [{
              key: "id",
              get: function get() {
                return this.fill.id + ":" + this.font.id + ":" + this.textIndent + ":" + this.textAlign + ":" + this.format.id;
              },
              set: function set(t) {}
            }, {
              key: "ne",
              value: function ne() {
                var t = this.textIndent || this.textAlign ? a.$.bind('<alignment vertical="center" horizontal="{0}" wrapText="1"{1}/>', a.U(this.textAlign) ? "left" : this.textAlign, a.U(this.textIndent) ? "" : ' indent="' + this.textIndent + '"') : '<alignment vertical="center" wrapText="1"/>';
                return a.$.bind('<xf numFmtId="{0}"{1} fontId="{2}" fillId="{3}" borderId="1" xfId="0" applyFont="1" applyFill="1"{4}>{5}</xf>', this.format.Yn, 0 < this.format.Yn ? ' applyNumberFormat = "1"' : "", this.font.cy, this.fill.Du, 0 < t.length ? ' applyAlignment="1"' : "", t);
              }
            }]);
            return _class37;
          }();
        }(rt || (rt = {})), function (t) {
          var e;
          (e = t.Gb || (t.Gb = {})).zT = /*#__PURE__*/function () {
            function _class38() {
              _classCallCheck(this, _class38);
              this.Gb = new a.ma(), this.Kf = new a.ma(), this.fonts = new a.ma(), this.Ec = new a.ma(), this.eK(new e.Kf.yt());
              var t = new e.Kf.yt();
              t.mF.nF = "solid", t.Du = 1, this.Kf.Ea("solid", t);
            }
            _createClass(_class38, [{
              key: "pn",
              value: function pn(t) {
                this.Gb.rc(t.id) ? t.index = this.Gb.getItem(t.id).index : (this.eK(t.fill), this.FU(t.font), this.Gb.Ea(t.id, t), t.index = this.Gb.length);
              }
            }, {
              key: "eK",
              value: function eK(t) {
                this.Kf.rc(t.id) ? t.Du = this.Kf.getItem(t.id).Du : (t.Du = this.Kf.length, this.Kf.Ea(t.id, t));
              }
            }, {
              key: "FU",
              value: function FU(t) {
                this.fonts.rc(t.id) ? t.cy = this.fonts.getItem(t.id).cy : (this.fonts.Ea(t.id, t), t.cy = this.fonts.length);
              }
            }, {
              key: "HU",
              value: function HU(t) {
                this.Ec.rc(t.id) ? t.Yn = this.Ec.getItem(t.id).Yn : (-1 == t.Yn && (t.Yn = e.format.So.KY()), this.Ec.Ea(t.id, t));
              }
            }, {
              key: "ne",
              value: function ne() {
                var e,
                  i = "",
                  s = "",
                  r = "",
                  n = "";
                if (0 < this.Ec.length) {
                  var o = 0,
                    h = "";
                  for (e = 0; e < this.Ec.length; e++) {
                    var l = this.Ec.F(e);
                    "" != l.ey && (h += l = l.ne(), o++);
                  }
                  0 < o && (i = '<numFmts count="' + o + '">' + h + "</numFmts>");
                }
                for (e = 0; e < this.Kf.length; e++) s += (o = this.Kf.F(e)).ne();
                for (e = 0; e < this.fonts.length; e++) r += (o = this.fonts.F(e)).ne();
                for (e = 0; e < this.Gb.length; e++) n += (o = this.Gb.F(e)).ne();
                return a.$.bind(t.fe.KS, i, this.fonts.length + 1, r, this.Kf.length, s, this.Gb.length + 1, n);
              }
            }]);
            return _class38;
          }();
        }(rt || (rt = {})), function (t) {
          var e;
          ((e = t.Gb || (t.Gb = {})).color || (e.color = {})).kB = /*#__PURE__*/function () {
            function _class39(t) {
              _classCallCheck(this, _class39);
              this.wO = t;
            }
            _createClass(_class39, [{
              key: "id",
              get: function get() {
                return this.wO.toString(16);
              },
              set: function set(t) {}
            }, {
              key: "ne",
              value: function ne() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                0 == t.length && (t = "color"), t = "<" + t, this.pV && (t += ' auto="' + this.pV + '"'), this.E3 && (t += ' theme="' + this.E3 + '"'), this.H3 && (t += ' tint="' + this.H3 + '"'), this.mZ && (t += ' indexed="' + this.mZ + '"');
                for (var e = this.wO.toString(16).toUpperCase(); 6 > e.length;) e = "0" + e;
                return t + ' rgb="FF' + e + '"/>';
              }
            }]);
            return _class39;
          }();
        }(rt || (rt = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function (_t$kB) {
              _inherits(e, _t$kB);
              var _super117 = _createSuper(e);
              function e(t) {
                _classCallCheck(this, e);
                return _super117.call(this, t);
              }
              _createClass(e, [{
                key: "ne",
                value: function ne() {
                  return _get(_getPrototypeOf(e.prototype), "ne", this).call(this, "bgColor");
                }
              }]);
              return e;
            }(t.kB);
            t.wT = e;
          }((e = t.Gb || (t.Gb = {})).color || (e.color = {}));
        }(rt || (rt = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function (_t$kB2) {
              _inherits(e, _t$kB2);
              var _super118 = _createSuper(e);
              function e(t) {
                _classCallCheck(this, e);
                return _super118.call(this, t);
              }
              _createClass(e, [{
                key: "ne",
                value: function ne() {
                  return _get(_getPrototypeOf(e.prototype), "ne", this).call(this, "fgColor");
                }
              }]);
              return e;
            }(t.kB);
            t.xT = e;
          }((e = t.Gb || (t.Gb = {})).color || (e.color = {}));
        }(rt || (rt = {})), function (t) {
          var e, i;
          e = t.Gb || (t.Gb = {}), (i = e.Kf || (e.Kf = {})).yt = /*#__PURE__*/function () {
            function _class40() {
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
              _classCallCheck(this, _class40);
              this.Du = 0, this.mF = new i.yT(t);
            }
            _createClass(_class40, [{
              key: "ne",
              value: function ne() {
                return "<fill>" + this.mF.ne() + "</fill>";
              }
            }, {
              key: "id",
              get: function get() {
                return this.mF.id;
              },
              set: function set(t) {}
            }]);
            return _class40;
          }();
        }(rt || (rt = {})), function (t) {
          var e;
          ((e = t.Gb || (t.Gb = {})).Kf || (e.Kf = {})).yT = /*#__PURE__*/function () {
            function _class41() {
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
              _classCallCheck(this, _class41);
              this.nF = "solid", -1 < t ? (this.fgColor = new e.color.xT(t), this.bgColor = new e.color.wT(t)) : this.nF = "none";
            }
            _createClass(_class41, [{
              key: "id",
              get: function get() {
                return a.U(this.fgColor) ? "none" : this.fgColor.id;
              }
            }, {
              key: "ne",
              value: function ne() {
                return a.$.bind('<patternFill patternType="{0}">{1}{2}</patternFill>', this.nF, a.U(this.fgColor) ? "" : this.fgColor.ne(), a.U(this.bgColor) ? "" : this.bgColor.ne());
              }
            }]);
            return _class41;
          }();
        }(rt || (rt = {})), function (t) {
          var e;
          ((e = t.Gb || (t.Gb = {})).fonts || (e.fonts = {})).Ym = /*#__PURE__*/function () {
            function _class42(t, i, s) {
              _classCallCheck(this, _class42);
              this.cy = 0, a.U(t) || (this.name = t), a.U(i) || (this.size = i), a.U(s) || (this.Ty = new e.color.kB(s));
            }
            _createClass(_class42, [{
              key: "id",
              get: function get() {
                return this.name + "," + this.size + "," + (a.U(this.Ty) ? "" : this.Ty.id) + "," + this.bold + "," + this.hs;
              },
              set: function set(t) {}
            }, {
              key: "ne",
              value: function ne() {
                var t = "<font>";
                if (this.bold && (t += "<b/>"), this.size && (t += '<sz val="' + this.size + '"/>'), this.Ty && (t += this.Ty.ne()), this.name) {
                  var e = this.name;
                  this.name.indexOf(",") && (e = this.name.split(",")[0].trim()), t += '<name val="' + e + '"/>';
                }
                return t + "</font>";
              }
            }]);
            return _class42;
          }();
        }(rt || (rt = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function () {
              function e(t, _e102) {
                _classCallCheck(this, e);
                this.Yn = t, this.ey = _e102;
              }
              _createClass(e, [{
                key: "ne",
                value: function ne() {
                  return '<numFmt numFmtId="' + this.Yn + '" formatCode="' + this.ey + '"/>';
                }
              }, {
                key: "id",
                get: function get() {
                  return "" != this.ey ? this.ey : this.Yn.toString();
                },
                set: function set(t) {}
              }], [{
                key: "KY",
                value: function KY() {
                  return e.wN++;
                }
              }]);
              return e;
            }();
            e.pL = 1, e.wN = e.pL, t.So = e;
          }((e = t.Gb || (t.Gb = {})).format || (e.format = {}));
        }(rt || (rt = {})), function (t) {
          !function (e) {
            var i = /*#__PURE__*/function () {
              function i(t) {
                _classCallCheck(this, i);
                this.Mc = [], this.pc = [], this.qn = [], this.ec = [], this.$c = [], this.cd = [], this.keys = [], this.Ce = [], this.Ji = [], this.cb = [], this.mu = [], this.Wy = [], this.Qi = [], this.dO = [], this.rh = [], this.Sf = [], this.sizes = [], this.filters = [], this.Em = [], this.Ik = [], this.values = [], this.Cd = [], this.bh = [], this.Gk = "dd/MM/yyyy", this.cm = "dd/MM/yyyy HH:mm:ss", this.Zq = [], this.Fz = 0, this.O = t;
              }
              _createClass(i, [{
                key: "clearData",
                value: function clearData() {
                  this.SV(), this.$c = [], this.cd = [], this.bb = null;
                }
              }, {
                key: "SV",
                value: function SV() {
                  this.Qi = [], this.Mc = [], this.pc = [], this.Ji = [], this.Ce = [], this.values = [], this.Cd = [], this.bh = [], this.qn = [], this.ec = [], this.filters = [];
                }
              }, {
                key: "qp",
                value: function qp() {
                  this.clearData(), this.sizes = [], this.keys = [], this.cb = [], this.qn = [];
                }
              }, {
                key: "RV",
                value: function RV() {
                  this.Cd = [], this.bh = [], this.values = [];
                }
              }, {
                key: "fa",
                get: function get() {
                  return null != this.ab ? this.ab : this.O.fa;
                },
                set: function set(t) {
                  this.ab = t;
                }
              }, {
                key: "cg",
                value: function cg(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  -1 == this.keys.indexOf(t) && ("" == e ? this.Ce[this.keys.length] = [-1, this.keys.length] : (e = this.keys.indexOf(e), this.Ce[e] && this.Ce[e].push(this.keys.length)), this.keys.push(t));
                }
              }, {
                key: "px",
                value: function px(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var _i46 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  this.mu[this.cb.length] = e, this.Wy[this.cb.length] = _i46, this.cb.push(t);
                }
              }, {
                key: "W3",
                value: function W3(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var _i47 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  0 <= (t = this.cb.indexOf(t)) && (this.mu[t] = e, this.Wy[t] = _i47);
                }
              }, {
                key: "a2",
                value: function a2(t) {
                  this.cb.splice(this.cb.indexOf(t), 1);
                }
              }, {
                key: "qL",
                value: function qL(t) {
                  var e = this.Qi.indexOf(t);
                  if (!a.U(t) && -1 < e) for (t = 0; t < this.cb.length; t++) this.pc[e][t] = NaN, null == this.Cd[t] && (this.Cd[t] = []), this.Cd[t][e] = {
                    Gi: -this.pc[e][t],
                    Uk: -1
                  };
                }
              }, {
                key: "update",
                value: function update(t, e, _i48) {
                  var s = this.Qi.indexOf(_i48);
                  if (!a.U(_i48) && -1 < s) {
                    for (_i48 = 0; _i48 < this.cb.length; _i48++) if (this.pc[s][_i48] != e[_i48]) {
                      var r = e[_i48] - this.pc[s][_i48];
                      isNaN(r) || (null == this.Cd[_i48] && (this.Cd[_i48] = []), this.Cd[_i48][s] = {
                        Gi: r,
                        Uk: r / this.pc[s][_i48]
                      });
                    }
                    this.pc[s] = e, this.Mc[s] = t;
                  } else {
                    for (s = this.Mc.length, a.U(_i48) || (this.Qi[s] = _i48), _i48 = 0; _i48 < this.cb.length; _i48++) r = e[_i48], isNaN(r) || (null == this.Cd[_i48] && (this.Cd[_i48] = []), this.Cd[_i48][s] = {
                      Gi: r,
                      Uk: 1
                    });
                    this.qn.push(s), this.Mc.push(t), this.pc.push(e);
                  }
                }
              }, {
                key: "pm",
                value: function pm(t, e, _i49) {
                  -1 < t.indexOf(0) || (this.qn.push(this.Mc.length), a.U(_i49) || (this.Qi[this.Mc.length] = _i49), this.Mc.push(t), this.pc.push(e));
                }
              }, {
                key: "qo",
                value: function qo(e) {
                  return e && 0 < e.length && "NaN" != e ? e : t.model.v.g.sl;
                }
              }, {
                key: "nK",
                value: function nK(t, _i50, s, r) {
                  var n = (t = this.O.ea.Uh(t)).j + "." + _i50,
                    a = t.xe(n);
                  null == a && (a = new e.oa.qe(n, _i50), t.Oc(a)), s.push(a.ra), null == _i50 || "" == _i50 ? r.push(NaN) : r.push(1);
                }
              }, {
                key: "SU",
                value: function SU(t, _i51, s, r) {
                  var n = (t = this.O.ea.Uh(t)).j + "." + _i51,
                    o = t.xe(n),
                    h = a.$.K3(_i51);
                  null == o && (o = new e.oa.qe(n, _i51), t.Oc(o)), o.qg = h, s.push(o.ra), r.push(h);
                }
              }, {
                key: "lA",
                value: function lA(t) {
                  return null == t || "string" != typeof t ? "" : t = t.trim();
                }
              }, {
                key: "BU",
                value: function BU(t, _i52, s, r) {
                  if (t = this.O.ea.Uh(t), _i52 instanceof Date) var n = _i52.getTime();else "number" == typeof _i52 ? n = _i52 : (n = Date.parse(this.lA(_i52)), isNaN(n) && (n = parseInt(_i52)));
                  _i52 = a.$.Jv(n, this.cm);
                  var o = t.j + "." + _i52,
                    h = t.xe(o);
                  null == h && ((h = new e.oa.qe(o, _i52)).qg = n, t.Oc(h)), s.push(h.ra), r.push(n);
                }
              }, {
                key: "XU",
                value: function XU(t, _i53, s, r) {
                  t = this.O.ea.Uh(t);
                  var n = parseFloat(_i53),
                    o = isNaN(_i53) || "" == _i53 ? "" : a.$.Kv(n),
                    h = t.j + "." + o,
                    l = t.xe(h);
                  null == l && ((l = new e.oa.qe(h, o)).qg = _i53, t.Oc(l)), s.push(l.ra), r.push(n);
                }
              }, {
                key: "zU",
                value: function zU(t, _i54, s, r) {
                  t = this.O.ea.Uh(t), _i54 = _i54 instanceof Date ? _i54.getTime() : "number" == typeof _i54 ? _i54 : Date.parse(this.lA(_i54));
                  var n = a.$.hA(_i54, this.Gk),
                    o = t.j + "." + n,
                    h = t.xe(o);
                  null == h && ((h = new e.oa.qe(o, n)).qg = _i54, t.Oc(h)), s.push(h.ra), r.push(_i54);
                }
              }, {
                key: "iK",
                value: function iK(_i55, s, r, n, a) {
                  _i55 = this.O.ea.Uh(_i55);
                  var o = s instanceof Date ? s : "number" == typeof s ? new Date(s) : new Date(this.lA(s)),
                    h = "",
                    l = "",
                    A = "",
                    c = "";
                  s = "";
                  var u = 0,
                    d = 1;
                  null != o && (l = t.model.v.g.rI[Math.floor(o.getUTCMonth() / 3)], c = t.model.v.g.fk[o.getUTCMonth()], s = o.getUTCDate().toString(), h = o.getUTCFullYear().toString(), u = o.getTime()), o = _i55.Fb.F(d++);
                  var f = (_i55 = o.lb).j + "." + h,
                    p = _i55.xe(f);
                  if (null == p && (p = new e.oa.qe(f, this.qo(h)), _i55.Oc(p, o.j)), r.push(p.ra), a) {
                    var g = (o = _i55.Fb.F(d++)).j + "." + h + "/" + l;
                    null == (p = _i55.xe(g)) && (p = new e.oa.qe(g, this.qo(l)), _i55.Oc(p, o.j, f)), r.push(p.ra), A = "/" + l;
                  }
                  l = (o = _i55.Fb.F(d++)).j + "." + h + A + "/" + c, null == (p = _i55.xe(l)) && (p = new e.oa.qe(l, this.qo(c)), _i55.Oc(p, o.j, a ? g : f)), r.push(p.ra), a = (o = _i55.Fb.F(d++)).j + "." + h + A + "/" + c + "/" + s, null == (p = _i55.xe(a)) && ((p = new e.oa.qe(a, this.qo(s))).qg = u, _i55.Oc(p, o.j, l)), r.push(p.ra), n.push(1);
                }
              }, {
                key: "xU",
                value: function xU(_i56, s, r, n) {
                  var a = this.O.ea.Uh(_i56),
                    o = "",
                    h = "";
                  _i56 = "";
                  var l = 0;
                  try {
                    var A = s instanceof Date ? s : "number" == typeof s ? new Date(s) : new Date(this.lA(s));
                  } catch (t) {
                    A = null;
                  }
                  null != A && (h = t.model.v.g.fk[A.getUTCMonth()], _i56 = A.getUTCDate().toString(), o = A.getUTCFullYear().toString(), l = A.getUTCDate());
                  var c = (s = a.va.F(0)).j + "." + o;
                  null == (A = s.xe(c)) && (A = new e.oa.qe(c, this.qo(o)), s.Oc(A)), r.push(A.ra), n.push(1), o = (s = a.va.F(1)).j + "." + h, null == (A = s.xe(o)) && (A = new e.oa.qe(o, this.qo(h)), s.Oc(A)), r.push(A.ra), n.push(1), s = a.va.F(2), a = s.j + "." + _i56, null == (A = s.xe(a)) && ((A = new e.oa.qe(a, this.qo(_i56))).qg = l, s.Oc(A)), r.push(A.ra), n.push(1);
                }
              }, {
                key: "MU",
                value: function MU(_i57, s, r, n) {
                  if ("" == s) r.push(null), n.push(null);else {
                    var a = (_i57 = this.O.ea.Uh(_i57)).j + "." + s;
                    if (1 < _i57.Md) {
                      var o = 1 == (a = _i57.lb.Fb.F(_i57.Md - 1)).Md ? this.keys.indexOf(_i57.lb.j) : this.keys.indexOf(a.j),
                        h = _i57.lb.ua.F(r[o]);
                      if (null == h) {
                        var l = a.j + "." + t.model.v.g.Cg;
                        null == (h = _i57.lb.xe(l)) && (h = new e.oa.qe(l, t.model.v.g.Cg), a.lb.Oc(h, a.j)), r[o] = h.ra;
                      }
                      a = h.j + "." + s;
                    }
                    null == (o = _i57.lb.xe(a)) && (o = new e.oa.qe(a, s), 1 == _i57.Md ? _i57.lb.Oc(o, _i57.j) : _i57.lb.Oc(o, _i57.j, h.j)), r.push(o.ra), n.push(1);
                  }
                }
              }, {
                key: "Oc",
                value: function Oc(t, _i58, s, r, n) {
                  switch (s) {
                    case e.types.ka.nd:
                    case e.types.ka.Po:
                    case e.types.ka.Ef:
                      this.nK(t, _i58, r, n);
                      break;
                    case e.types.ka.Rb:
                      this.SU(t, _i58, r, n);
                      break;
                    case e.types.ka.jc:
                      this.xU(t, _i58, r, n);
                      break;
                    case e.types.ka.We:
                      this.MU(t, _i58, r, n);
                      break;
                    case e.types.ka.Km:
                      this.iK(t, _i58, r, n, !1);
                      break;
                    case e.types.ka.ek:
                      this.iK(t, _i58, r, n, !0);
                      break;
                    case e.types.ka.kl:
                      this.zU(t, _i58, r, n);
                      break;
                    case e.types.ka.ce:
                      this.BU(t, _i58, r, n);
                      break;
                    case e.types.ka.td:
                      this.XU(t, _i58, r, n);
                      break;
                    case e.types.ka.NA:
                      break;
                    default:
                      this.nK(t, _i58, r, n);
                  }
                }
              }, {
                key: "cE",
                value: function cE(t) {
                  var _i59 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  var s = [],
                    r = [],
                    n = "",
                    a = this.O.ea.oM(),
                    o = !1;
                  if (_i59) {
                    var h = this.O.ea.uu;
                    o = "" != h && t.hasOwnProperty(h);
                  }
                  for (var l = 0; l < a.length; l++) {
                    h = a[l];
                    var A = this.O.ea.pM(h);
                    A == e.types.ka.Dq ? n = t[h] : t[h] instanceof Array || o || this.Oc(h, t[h], A, s, r);
                  }
                  _i59 ? o ? this.qL(n) : this.update(s, r, n) : this.pm(s, r, n);
                }
              }, {
                key: "aE",
                value: function aE(t) {
                  var _i60 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  var s = this.O.ea.oM(),
                    r = [],
                    n = [],
                    o = "",
                    h = !1;
                  if (_i60) {
                    var l = this.O.ea.uu;
                    "" != l && (h = s.indexOf(l), h = !a.U(t[h]));
                  }
                  for (var A = 0; A < s.length; A++) {
                    l = s[A];
                    var c = this.O.ea.pM(l);
                    c == e.types.ka.Dq ? o = t[A] : h || this.Oc(l, t[A], c, r, n);
                  }
                  _i60 ? h ? this.qL(o) : this.update(r, n, o) : this.pm(r, n, o);
                }
              }, {
                key: "Bj",
                value: function Bj(t, e, _i61) {
                  for (var s = 0; s < e.length; s++) {
                    var r = e[s],
                      n = _i61[s];
                    n = a.U(this.Ji[n]) || a.U(this.Ji[n][r]) ? n : this.Ji[n][r];
                    for (var o = [], h = 0; h < t.length; h++) this.Mc[t[h]][n] == r && o.push(t[h]);
                    t = o;
                  }
                  return t;
                }
              }, {
                key: "Vy",
                value: function Vy(t, _i62, s) {
                  var r = this.keys.indexOf(_i62.Kc.j),
                    n = s == e.i.da.Ka ? this.Tb(t, this.$c) : this.Tb(t, this.cd);
                  for (1 < t.length ? (t = t.slice(0, -1), s = (s == e.i.da.Ka ? this.Tb(t, this.$c) : this.Tb(t, this.cd))[0][0]) : s = this.ec, r = this.Ce[r][_i62.level.Md + 1], t = 0; t < _i62.children.length; t++) {
                    var a = _i62.children.F(t);
                    a = this.Bj(s, [a.ra], [r]);
                    for (var o = 0; o < a.length; o++) -1 == n[0][0].indexOf(a[o]) && n[0][0].push(a[o]);
                  }
                }
              }, {
                key: "sM",
                value: function sM(t, e, _i63, s, r) {
                  if (0 != t.length) {
                    var n;
                    for (n = 0; n < t.length; n++) {
                      var a = this.pc[t[n]][_i63];
                      isNaN(a) || r[a] || (s.push(a), r[a] = !0);
                    }
                    if (this.rh.length != e.length) for (n = 0; n < s.length; n++) {
                      (a = e.slice(0)).push(s[n]);
                      var o = this.Bj(t, a, this.rh);
                      this.sM(o, a, _i63, s, r);
                    }
                  }
                }
              }, {
                key: "tM",
                value: function tM(t, e, _i64, s, r, n) {
                  if (0 != t.length) if (this.Sf.length == e.length) this.sM(t, _i64, s, r, n);else {
                    for (var a = [], o = [], h = this.Sf[e.length], l = 0; l < t.length; l++) {
                      var A = this.Mc[t[l]][h];
                      o[A] || 0 == A || (a.push(A), o[A] = !0);
                    }
                    for (l = 0; l < a.length; l++) (o = e.slice(0)).push(a[l]), h = this.Bj(t, o, this.Sf), this.tM(h, o, _i64, s, r, n);
                  }
                }
              }, {
                key: "rM",
                value: function rM(t, e, _i65, s) {
                  var r = [];
                  return this.tM(t, e, _i65, s, r, []), r.length;
                }
              }, {
                key: "uM",
                value: function uM(t, e) {
                  if (0 == t.length) return 0;
                  e = this.keys.indexOf(this.O.ea.Zh(e.j).j);
                  for (var _i66, s = [], r = [], n = 0; n < t.length; n++) r[_i66 = this.Mc[t[n]][e]] || (r[_i66] = !0, isNaN(this.pc[t[n]][e]) || s.push(_i66));
                  return s.length;
                }
              }, {
                key: "tV",
                value: function tV(t, e) {
                  return this.Hn([], t, !1, e);
                }
              }, {
                key: "nr",
                value: function nr(t, e, _i67, s) {
                  var r = this.Tb(t, this.$c),
                    n = this.Tb(e, this.cd);
                  return t = t.length * n[0][0].length < e.length * r[0][0].length ? this.Bj(n[0][0], t, this.Sf) : this.Bj(r[0][0], e, this.rh), this.Hn(t, _i67, !1, s);
                }
              }, {
                key: "s2",
                value: function s2(t, _i68, s, r) {
                  if (t = this.ec[t[0]], _i68 = _i68[0], this.Cd = [], this.Cd[t] = [], this.values = [], this.bh = [], null != s) {
                    var n = s.XL(r);
                    null == n && (1 == this.VK(_i68, this.Mc[t][_i68]) ? (n = s.ua.F(this.Mc[t][_i68])).caption = r : (n = s.j + "." + r, null != s.xe(n) && (n = s.j + "." + a.$.ky()), n = new e.oa.qe(n, r), s.Oc(n))), this.Mc[t][_i68] = n.ra, n = null != this.Qi[t] ? this.Qi[t] : t, [].push({
                      id: n,
                      qX: s.j,
                      value: r
                    }), s = parseFloat(r) - this.pc[t][_i68], this.Cd[t][_i68] = {
                      Gi: s,
                      Uk: s / this.pc[t][_i68]
                    }, this.pc[t][_i68] = parseFloat(r);
                  }
                }
              }, {
                key: "save",
                value: function save(t, _i69, s, r, n) {
                  var o = this.Tb(t, this.$c),
                    h = this.Tb(_i69, this.cd);
                  n = (t.length * h[0][0].length < _i69.length * o[0][0].length ? this.Bj(h[0][0], t, this.Sf) : this.Bj(o[0][0], _i69, this.rh))[n], t = [], _i69 = this.cb.indexOf(this.O.ea.og(s.j).j), this.Cd = [], this.Cd[_i69] = [], o = parseFloat(r) - this.pc[n][_i69], this.Cd[_i69][n] = {
                    Gi: o,
                    Uk: o / this.pc[n][_i69]
                  }, this.pc[n][_i69] = parseFloat(r), this.values = [], this.bh = [], null != s && (_i69 = this.keys.indexOf(s.j), o = this.VK(_i69, this.Mc[n][_i69]), null == (h = s.XL(r)) && (1 == o ? (h = s.ua.F(this.Mc[n][_i69])).caption = r : (o = s.j + "." + r, null != s.xe(o) && (o = s.j + "." + a.$.ky()), h = new e.oa.qe(o, "" + r), s.Oc(h))), h.qg = r, this.Mc[n][_i69] = h.ra, n = null != this.Qi[n] ? this.Qi[n] : n, t.push({
                    id: n,
                    qX: s.j,
                    value: r
                  }));
                }
              }, {
                key: "VK",
                value: function VK(t, e) {
                  for (var _i70 = 0, s = 0; s < this.Mc.length; s++) this.Mc[s][t] == e && _i70++;
                  return _i70;
                }
              }, {
                key: "yj",
                value: function yj(t, e) {
                  var _i71 = this.Tb(t, this.$c),
                    s = this.Tb(e, this.cd);
                  for (t = t.length * s[0][0].length < e.length * _i71[0][0].length ? this.Bj(s[0][0], t, this.Sf) : this.Bj(_i71[0][0], e, this.rh), (e = []).push(this.keys), _i71 = 0; _i71 < t.length; _i71++) e.push(this.Mc[t[_i71]]);
                  return e;
                }
              }, {
                key: "Uu",
                value: function Uu(t, e, _i72) {
                  return t = this.lu(t, e), null == this.bh[t] ? null : this.bh[t][_i72.La ? this.fa.pa.indexOf(_i72.j) + this.cb.length : this.cb.indexOf(_i72.j)];
                }
              }, {
                key: "yM",
                value: function yM(t, e) {
                  return e.La ? null : (e = this.cb.indexOf(e.j), null == t ? this.AC(this.ec, e) : null == this.bh[t] ? null : this.bh[t][e]);
                }
              }, {
                key: "Cy",
                value: function Cy(t) {
                  return null == this.ec[t] || null == this.Mc[this.ec[t]] || "" == this.O.ea.id ? null : this.Qi[this.ec[t]];
                }
              }, {
                key: "KD",
                value: function KD(t, e, _i73, s) {
                  return null == this.ec[t] || null == this.Mc[this.ec[t]] ? NaN : s ? (_i73.La || (s = this.cb.indexOf(_i73.j), this.Cd.length && (null == this.bh[t] && (this.bh[t] = []), this.bh[t][s] = this.AC([this.ec[t]], s))), _i73.La ? this.Hn([this.ec[t]], _i73.Pe, _i73.Mf) : this.pc[this.ec[t]][e]) : this.Mc[this.ec[t]][e];
                }
              }, {
                key: "Mb",
                value: function Mb(t, _i74, s) {
                  var r = this.lu(t, _i74),
                    n = s.La ? this.fa.pa.indexOf(s.j) + this.cb.length : this.cb.indexOf(s.j);
                  if (null == this.values[r] && (this.values[r] = []), null == this.values[r][n]) {
                    var a = this.Tb(t, this.$c),
                      o = this.Tb(_i74, this.cd),
                      h = [];
                    if (null == a || null == a[0] || null == o || null == o[0]) return NaN;
                    0 < o.length && 0 < a.length && t.length * o[0][0].length < _i74.length * a[0][0].length ? h = this.Bj(o[0][0], t, this.Sf) : 0 < a.length && (h = this.Bj(a[0][0], _i74, this.rh)), this.values[r][n] = s.La ? this.Hn(h, s.Pe, s.Mf, 0, t, _i74) : s.Fa == e.i.ca.zg ? s.type == e.types.Ca.Hb ? this.uM(h, s) : this.rM(h, t, _i74, n) : this.GB(h, n, s.Fa), 0 < this.Cd.length && (null == this.bh[r] && (this.bh[r] = []), this.bh[r][n] = this.AC(h, n));
                  }
                  return this.values[r][n];
                }
              }, {
                key: "AC",
                value: function AC(t, e) {
                  if (null == this.Cd[e]) return null;
                  for (var _i75 = !1, s = {
                      Gi: 0,
                      Uk: 0
                    }, r = 0; r < t.length; r++) this.Cd[e][t[r]] && 0 != this.Cd[e][t[r]].Gi && !isNaN(this.Cd[e][t[r]].Gi) && (s.Gi += this.Cd[e][t[r]].Gi, s.Uk += this.Cd[e][t[r]].Uk, _i75 = !0);
                  return _i75 ? s : null;
                }
              }, {
                key: "filter",
                value: function filter() {
                  this.cd = [], this.$c = [], this.values = [], this.Ji = [], this.bh = [];
                  var _i76,
                    s,
                    r = t.model.A.P.Dc,
                    n = this.fa.bb(!1, !0, r),
                    o = new a.ma(),
                    h = new a.ma();
                  for (_i76 = 0; _i76 < n.length; _i76++) (s = n.F(_i76)) && (s.Jd == e.i.Dd.NONE ? o.Ea(s.j, s) : this.fa.pa.rc(s.pd) && h.Ea(s.j, s));
                  for (this.nk(o, this.qn), _i76 = 0; _i76 < h.length; _i76++) s = h.F(_i76), r ? this.cV(s) : this.hV(s);
                  this.nk(h, this.ec);
                }
              }, {
                key: "nk",
                value: function nk(t, e) {
                  for (var _i77 = [], s = [], r = 0; r < t.length; r++) {
                    var n = t.F(r),
                      o = this.keys.indexOf(n.j);
                    if (n.Sg()) {
                      _i77.push(o), s.push(n.tX().length / n.Qd.children.length), this.filters[o] = [], this.Em[o] = [];
                      for (var h = 0; h < n.filter.length; h++) {
                        var l = n.filter.F(h);
                        1 == l.level.Md ? this.filters[o][l.ra] = !0 : (null == this.Em[o][l.root.ra] && (this.Em[o][l.root.ra] = []), null == this.Em[o][l.root.ra][l.level.Md] && (this.Em[o][l.root.ra][l.level.Md] = []), this.Em[o][l.root.ra][l.level.Md][l.ra] = !0);
                      }
                    }
                  }
                  if (s = a.sa.oP(s, a.sa.$f), 0 < _i77.length) for (r = 0; r < _i77.length; r++) {
                    for (t = _i77[s[r]], n = [], o = 0; o < e.length; o++) if (h = this.Mc[e[o]][this.Ce[t][1]], null != this.filters[t][h]) n.push(e[o]);else if (null != this.Em[t][h]) for (l = 2; l < this.Ce[t].length; l++) if (null != this.Em[t][h][l] && null != this.Em[t][h][l][this.Mc[e[o]][this.Ce[t][l]]]) {
                      n.push(e[o]);
                      break;
                    }
                    e = n;
                  }
                  this.ec = e;
                }
              }, {
                key: "select",
                value: function select() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                  var _i78;
                  for (this.dO = [], this.Sf = [], this.rh = [], this.sizes = [], this.Ji = [], this.Ik = [], this.cO = this.fa.axes.getItem(e.i.da.Sm), this.zb = this.fa.axes.getItem(e.i.da.Ka), this.nb = this.fa.axes.getItem(e.i.da.rb), _i78 = 0; _i78 < this.zb.va.length; _i78++) {
                    var s = this.zb.va.F(_i78);
                    if (!s.tf) {
                      var r = this.keys.indexOf(s.j);
                      this.Sf.push(r), this.sizes.push(s.qF), this.Ji[r] = [];
                    }
                  }
                  for (this.Rj = this.Sf.length, _i78 = 0; _i78 < this.nb.va.length; _i78++) (s = this.nb.va.F(_i78)).tf || (r = this.keys.indexOf(s.j), this.rh.push(r), this.sizes.push(s.qF), this.Ji[r] = []);
                  if (this.Ai = this.rh.length, t) for (_i78 = 0; _i78 < this.cO.va.length; _i78++) s = this.cO.va.F(_i78), r = this.keys.indexOf(s.j), this.dO.push(r);else this.ec = this.qn;
                  for (_i78 = 0; _i78 < this.fa.pa.length; _i78++) t = this.fa.pa.F(_i78), r = this.cb.indexOf(t.j), this.Ik.push(r);
                }
              }, {
                key: "cV",
                value: function cV(t) {
                  if (t.$r()) {
                    var _i79 = this.O.ea.pa.getItem(t.pd);
                    if (null != _i79) {
                      for (var s = [], r = [], n = this.cb.indexOf(_i79.j), o = 0; o < this.ec.length; o++) s.push(this.KD(o, n, _i79, !0)), r.push(this.KD(o, n, _i79, !1));
                      for ((_i79 = t.Jd == e.i.Dd.tq ? a.sa.sort(s, a.sa.Xe | a.sa.$f) : a.sa.sort(s, a.sa.Xe | a.sa.ih | a.sa.$f)).length = Math.min(t.bf, _i79.length), s = t.Wu() ? t.Me : t.ua, n = new a.ma(), o = 0; o < _i79.length; o++) {
                        var h = s.F(r[_i79[o]]);
                        null != h && 0 == n.rc(h.j) && n.Ea(h.j, h);
                      }
                      t.filter = n;
                    }
                  }
                }
              }, {
                key: "hV",
                value: function hV(t) {
                  if (t.$r()) {
                    var _i80 = this.fa.pa.getItem(t.pd);
                    if (null != _i80) {
                      var s = [],
                        r = [],
                        n = [],
                        o = this.keys.indexOf(t.j);
                      if (this.Ji[o]) for (var h in this.Ji[o]) n.push(this.Ji[o][h]);else n = [o];
                      for (h = [], o = 0; o < n.length; o++) for (var l = 0; l < this.ec.length; l++) {
                        var A = this.Mc[this.ec[l]][n[o]];
                        null == h[A] && (h[A] = []), h[A].push(this.ec[l]);
                      }
                      l = this.cb.indexOf(_i80.j), A = t.Wu() ? t.Me : t.ua;
                      var c = _i80.La;
                      for (o = 0; o < A.length; o++) if (!(n = A.F(o)).Qc) {
                        var u = c ? this.Hn(h[n.ra], this.mu[l], this.Wy[l]) : this.GB(h[n.ra], l, _i80.Fa);
                        isNaN(u) && (u = Number.MIN_VALUE), s.push(u), r.push(n);
                      }
                      for (_i80 = t.Jd == e.i.Dd.tq ? a.sa.sort(s, a.sa.Xe | a.sa.$f) : a.sa.sort(s, a.sa.Xe | a.sa.ih | a.sa.$f), s = new a.ma(), h = Math.min(t.bf, r.length), o = 0; o < h; o++) n = r[_i80[o]], s.Ea(n.j, n);
                      t.filter = s;
                    }
                  }
                }
              }, {
                key: "Vq",
                value: function Vq(e, _i81, s, r) {
                  try {
                    if (0 == _i81.children.length || 1 == _i81.children.length && (_i81.children.F(0).caption == t.model.v.g.Cg || _i81.children.F(0).caption == t.model.v.g.sl)) return;
                    this.Vy(e, _i81, r), this.Hk(e, _i81, r, null);
                  } catch (t) {}
                  for (var n = this.Tb(e, this.$c), a = 0; a < _i81.children.length; a++) {
                    var o = _i81.children.F(a);
                    try {
                      if (o.Mj) {
                        this.Lt(n, this.Sf[s], null);
                        var h = e.slice(0);
                        h[h.length - 1] = o.ra, this.CB(h, s + 1, !0);
                      } else {
                        var l = e.slice(0, -1);
                        l.push(o.ra), this.Vq(l, o, s, r);
                      }
                    } catch (t) {}
                  }
                }
              }, {
                key: "oc",
                value: function oc(t) {
                  0 == this.$c.length && (this.$c = [[this.ec, [], [], null, null]]), 0 == this.cd.length && (this.cd = [[this.ec, [], [], null, null]]), this.lJ([], 0, t), this.CB([], 0, t);
                }
              }, {
                key: "CB",
                value: function CB(t, _i82, s) {
                  if (null != this.Sf[_i82]) {
                    var r,
                      n = this.Sf[_i82],
                      a = this.Tb(t, this.$c);
                    if (this.Lt(a, n, null), s && (r = this.zb.va.getItem(this.keys[n])), s && r.Rk) for (r = r.Qd.children, a = 0; a < r.length; a++) s = r.F(a), (n = t.slice(0)).push(s.ra), this.Vq(n, s, _i82, e.i.da.Ka);else for (r = a[0][1], a = 0; a < r.length; a++) (n = t.slice(0)).push(r[a]), this.CB(n, _i82 + 1, s);
                  }
                }
              }, {
                key: "lJ",
                value: function lJ(t, _i83, s) {
                  if (null != this.rh[_i83]) {
                    var r,
                      n = this.rh[_i83],
                      a = this.Tb(t, this.cd);
                    if (this.Lt(a, n, null), s && (r = this.nb.va.getItem(this.keys[n])), s && r.Rk) for (n = 0; n < r.Qd.children.length; n++) s = r.Qd.children.F(n), (a = t.slice(0)).push(s.ra), this.Vq(a, s, _i83, e.i.da.rb);else for (r = a[0][1], n = 0; n < r.length; n++) (a = t.slice(0)).push(r[n]), this.lJ(a, _i83 + 1, s);
                  }
                }
              }, {
                key: "dD",
                value: function dD(e, _i84, s, r) {
                  try {
                    if (0 != _i84.children.length && (1 != _i84.children.length || _i84.children.F(0).caption != t.model.v.g.Cg && _i84.children.F(0).caption != t.model.v.g.sl)) {
                      this.Vy(e, _i84, s), this.Hk(e, _i84, s, null);
                      for (var n = 0; n < _i84.children.length; n++) {
                        var a = _i84.children.F(n);
                        if (!a.Mj && a.level.j != r) {
                          var o = e.slice(0, -1);
                          o.push(a.ra), this.dD(o, a, s, r);
                        }
                      }
                    }
                  } catch (t) {}
                }
              }, {
                key: "expand",
                value: function expand(t, _i85, s) {
                  0 == this.$c.length && (this.$c = [[this.ec, [], [], null, null]]), 0 == this.cd.length && (this.cd = [[this.ec, [], [], null, null]]), 1 == this.Ik.length && (s = null), _i85 == e.i.da.Ka && this.nX(t, s), _i85 == e.i.da.rb && this.lX(t, s);
                }
              }, {
                key: "nX",
                value: function nX(t, e) {
                  var _i86 = this.Tb(t, this.$c);
                  null != _i86 && this.Lt(_i86, this.Sf[t.length], e);
                }
              }, {
                key: "lX",
                value: function lX(t, e) {
                  var _i87 = this.Tb(t, this.cd);
                  null != _i87 && this.Lt(_i87, this.rh[t.length], e);
                }
              }, {
                key: "Lt",
                value: function Lt(t, e, _i88) {
                  if (null != t) {
                    var s = t[0][0];
                    if (0 < s.length && !isNaN(e)) for (var r = 0; r < s.length; r++) {
                      var n = this.Mc[s[r]][this.Ce[e][1]];
                      0 != n && null != n && (null == t[n] ? (t[n] = [[[s[r]], [], [], null, null, !1]], t[0][1].push(n)) : t[0][5] || t[n][0][0].push(s[r]));
                    }
                    null == t[0][3] && (t[0][3] = []), null == _i88 ? t[0][3][this.cb.length] = !0 : t[0][3][this.cb.indexOf(_i88.j)] = !0, t[0][5] = !0;
                  }
                }
              }, {
                key: "collapse",
                value: function collapse(t, _i89, s) {
                  0 == this.$c.length && (this.$c = [[this.ec, [], [], null, null]]), 0 == this.cd.length && (this.cd = [[this.ec, [], [], null, null]]), 1 == this.Ik.length && (s = null), _i89 == e.i.da.Ka && this.WV(t, s), _i89 == e.i.da.rb && this.UV(t, s);
                }
              }, {
                key: "WV",
                value: function WV(t, e) {
                  this.aJ(this.Tb(t, this.$c), e);
                }
              }, {
                key: "UV",
                value: function UV(t, e) {
                  this.aJ(this.Tb(t, this.cd), e);
                }
              }, {
                key: "aJ",
                value: function aJ(t, e) {
                  null != t && (null == t[0][3] && (t[0][3] = []), null != e ? t[0][3][this.cb.indexOf(e.j)] = !1 : t[0][3][this.cb.length] = !1);
                }
              }, {
                key: "Hk",
                value: function Hk(t, _i90, s, r) {
                  0 != _i90.children.length && (1 == this.Ik.length && (r = null), s == e.i.da.Ka && this.dX(t, _i90, r), s == e.i.da.rb && this.cX(t, _i90, r));
                }
              }, {
                key: "dX",
                value: function dX(t, e, _i91) {
                  var s = this.Tb(t, this.$c);
                  t = t.slice(0, -1);
                  var r = this.Sf[t.length];
                  this.hJ(this.Tb(t, this.$c), s, r, this.Ce[r][e.level.Md + 1], _i91);
                }
              }, {
                key: "cX",
                value: function cX(t, e, _i92) {
                  var s = this.Tb(t, this.cd);
                  t = t.slice(0, -1);
                  var r = this.rh[t.length];
                  this.hJ(this.Tb(t, this.cd), s, r, this.Ce[r][e.level.Md + 1], _i92);
                }
              }, {
                key: "hJ",
                value: function hJ(t, e, _i93, s, r) {
                  var n = e[0][0];
                  if (0 < n.length && !isNaN(s)) for (var a = 0; a < n.length; a++) {
                    var o = this.Mc[n[a]][s];
                    0 != o && null != o && (null == t[o] ? (t[o] = [[[n[a]], [], [], null, null]], e[0][2].push(o), this.Ji[_i93][o] = s) : -1 == t[o][0][0].indexOf(n[a]) && t[o][0][0].push(n[a]));
                  }
                  null == e[0][4] && (e[0][4] = []), null == r ? e[0][4][this.cb.length] = !0 : e[0][4][this.cb.indexOf(r.j)] = !0;
                }
              }, {
                key: "Xh",
                value: function Xh(t, e) {
                  var _i94 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  return e = this.cb.length, null != _i94 && (e = "number" == typeof _i94 ? -1 == _i94 ? -1 : this.Ik[_i94] : this.cb.indexOf(_i94.j)), -1 == e && (e = this.cb.length), null != (t = this.Tb(t, this.$c)) && null != t[0][4] && (t[0][4][e] || t[0][4][this.cb.length]);
                }
              }, {
                key: "Kj",
                value: function Kj(t, e) {
                  var _i95 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  return e = this.cb.length, null != _i95 && (e = "number" == typeof _i95 ? -1 == _i95 ? -1 : this.Ik[_i95] : this.cb.indexOf(_i95.j)), -1 == e && (e = this.cb.length), null != (t = this.Tb(t, this.cd)) && null != t[0][4] && (t[0][4][e] || t[0][4][this.cb.length]);
                }
              }, {
                key: "fm",
                value: function fm(t, _i96, s, r) {
                  1 == this.Ik.length && (r = null), s == e.i.da.Ka && this.fX(t, r), s == e.i.da.rb && this.eX(t, r);
                }
              }, {
                key: "fX",
                value: function fX(t, e) {
                  var _i97 = this.Tb(t, this.$c);
                  t = t.slice(0, -1), this.zB(this.Tb(t, this.$c), _i97, e);
                }
              }, {
                key: "eX",
                value: function eX(t, e) {
                  var _i98 = this.Tb(t, this.cd);
                  t = t.slice(0, -1), this.zB(this.Tb(t, this.cd), _i98, e);
                }
              }, {
                key: "zB",
                value: function zB(t, e, _i99) {
                  var s = e[0][2];
                  if (0 < s.length) for (var r = 0; r < s.length; r++) {
                    var n = s[r];
                    null != t[n][0][4] && this.zB(t, t[n], _i99), t[n] = null;
                  }
                  e[0][2] = [], e[0][4][this.cb.length] = !1, null != _i99 && (e[0][4][this.cb.indexOf(_i99.j)] = !1);
                }
              }, {
                key: "Tb",
                value: function Tb(t, e) {
                  for (var _i100 = 0; _i100 < t.length; _i100++) {
                    if (null == e) return null;
                    e = e[t[_i100]];
                  }
                  return e;
                }
              }, {
                key: "result",
                get: function get() {
                  return [this.$c, this.cd];
                },
                set: function set(t) {}
              }, {
                key: "Vg",
                value: function Vg(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  if (0 == t.length) return !0;
                  var _i101 = -1;
                  return null != e && (_i101 = "number" == typeof e ? -1 == e ? -1 : this.Ik[e] : this.cb.indexOf(e.j)), null != (t = this.Tb(t, this.$c)) && null != t[0][3] && (-1 == _i101 || null == t[0][3][_i101] ? t[0][3][this.cb.length] : t[0][3][_i101]);
                }
              }, {
                key: "Lj",
                value: function Lj(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  if (0 == t.length) return !0;
                  var _i102 = -1;
                  return null != e && (_i102 = "number" == typeof e ? this.Ik[e] : this.cb.indexOf(e.j)), null != (t = this.Tb(t, this.cd)) && null != t[0][3] && (-1 == _i102 || null == t[0][3][_i102] ? t[0][3][this.cb.length] : t[0][3][_i102]);
                }
              }, {
                key: "Fj",
                value: function Fj(t, e) {
                  for (var _i103 = 0, s = !0, r = 0; r < t.length; r++) {
                    var n = this.pc[t[r]][e];
                    isNaN(n) || (_i103 += n, s = !1);
                  }
                  return s ? NaN : _i103;
                }
              }, {
                key: "oY",
                value: function oY(t, e) {
                  for (var _i104 = 0, s = 0; s < t.length; s++) isNaN(this.pc[t[s]][e]) || _i104++;
                  return _i104;
                }
              }, {
                key: "JY",
                value: function JY(t, e) {
                  for (var _i105 = Number.MAX_VALUE, s = !0, r = 0; r < t.length; r++) {
                    var n = this.pc[t[r]][e];
                    isNaN(n) || (n < _i105 && (_i105 = n), s = !1);
                  }
                  return s ? NaN : _i105;
                }
              }, {
                key: "GY",
                value: function GY(t, e) {
                  for (var _i106 = Number.MIN_VALUE, s = !0, r = 0; r < t.length; r++) {
                    var n = this.pc[t[r]][e];
                    isNaN(n) || (n > _i106 && (_i106 = n), s = !1);
                  }
                  return s ? NaN : _i106;
                }
              }, {
                key: "RY",
                value: function RY(t, e) {
                  for (var _i107 = 1, s = !0, r = 0; r < t.length; r++) {
                    var n = this.pc[t[r]][e];
                    isNaN(n) || (_i107 *= n, s = !1);
                  }
                  return s ? NaN : _i107;
                }
              }, {
                key: "eM",
                value: function eM(t, e) {
                  for (var _i108 = 0, s = 0, r = 0; r < t.length; r++) {
                    var n = this.pc[t[r]][e];
                    isNaN(n) || (_i108 += n, s++);
                  }
                  return 0 == s ? 0 : _i108 / s;
                }
              }, {
                key: "HY",
                value: function HY(t, e) {
                  for (var _i109 = [], s = 0; s < t.length; s++) {
                    var r = this.pc[t[s]][e];
                    isNaN(r) || _i109.push(r);
                  }
                  return 0 === _i109.length ? NaN : (a.sa.sort(_i109, a.sa.Xe), 1 == _i109.length % 2 ? _i109[Math.floor(_i109.length / 2)] : (_i109[t = _i109.length / 2] + _i109[t - 1]) / 2);
                }
              }, {
                key: "qM",
                value: function qM(t, e) {
                  for (var _i110 = this.eM(t, e), s = 0, r = 0, n = 0; n < t.length; n++) {
                    var a = this.pc[t[n]][e];
                    isNaN(a) || (s += Math.pow(a - _i110, 2), r++);
                  }
                  return {
                    sL: s,
                    count: r
                  };
                }
              }, {
                key: "ZY",
                value: function ZY(t, e) {
                  return 0 == (t = this.qM(t, e)).count ? 0 : Math.sqrt(t.sL / t.count);
                }
              }, {
                key: "$Y",
                value: function $Y(t, e) {
                  return 1 >= (t = this.qM(t, e)).count ? 0 : Math.sqrt(t.sL / (t.count - 1));
                }
              }, {
                key: "OY",
                value: function OY(t, e) {
                  return null == this.Zq[e] && (this.Zq[e] = this.Fj(this.ec, e)), Math.abs(100 * this.Fj(t, e) / this.Zq[e]);
                }
              }, {
                key: "PY",
                value: function PY(t, e, _i111) {
                  return 100 * this.Fj(t, e) / this.Fj(this.Tb(_i111, this.cd)[0][0], e);
                }
              }, {
                key: "QY",
                value: function QY(t, e, _i112) {
                  return 100 * this.Fj(t, e) / this.Fj(this.Tb(_i112, this.$c)[0][0], e);
                }
              }, {
                key: "zM",
                value: function zM(t, e, _i113, s) {
                  return null == this.Zq[e] && (this.Zq[e] = this.Fj(this.ec, e)), Math.abs(this.Zq[e] * this.Fj(t, e) / (this.Fj(this.Tb(_i113, this.$c)[0][0], e) * this.Fj(this.Tb(s, this.cd)[0][0], e)));
                }
              }, {
                key: "vy",
                value: function vy(t, _i114, s) {
                  return e.qf.bk.Qb().Mb(t, _i114, s);
                }
              }, {
                key: "LM",
                value: function LM(t, _i115, s, r) {
                  var n = s.La ? this.ab.CE.indexOf(s.j) + this.cb.length : this.cb.indexOf(s.j);
                  null == this.values[n] && (this.values[n] = []);
                  var a = this.lu(t, _i115);
                  if (null == this.values[n][a]) {
                    if (s.Fa = e.i.ca.ik, r == e.i.da.Ka) {
                      if (0 == _i115.length) this.values[n][a] = this.Mb(t, _i115, s);else {
                        var o = (r = this.fa.ed.F(_i115.length - 1)).ua.F(_i115[_i115.length - 1]);
                        if (null == o || null == o.parent) return null;
                        r = r.Cf(o.parent, !0), o = _i115.slice(0, -1);
                        var h = this.Tb(o, this.cd);
                        if (h[0] && h[0][1]) for (var l = 0, A = 0; A < r.length; A++) {
                          var c = r.F(A).ra;
                          if (null != h[c]) {
                            if (o.push(c), c = this.lu(t, o), null == this.values[n][c]) {
                              var u = this.Mb(t, o, s);
                              isNaN(u) ? this.values[n][c] = NaN : (l += this.Mb(t, o, s), this.values[n][c] = l);
                            } else l = this.values[n][c];
                            o.pop();
                          }
                        }
                      }
                    } else if (0 == t.length) this.values[n][a] = this.Mb(t, _i115, s);else {
                      if (null == (o = (r = this.fa.hc.F(t.length - 1)).ua.F(t[t.length - 1])) || null == o.parent) return null;
                      if (r = r.Cf(o.parent, !0), o = t.slice(0, -1), (h = this.Tb(o, this.$c))[0] && h[0][1]) for (A = l = 0; A < r.length; A++) null != h[c = r.F(A).ra] && (o.push(c), c = this.lu(o, _i115), null == this.values[n][c] ? (u = this.Mb(o, _i115, s), isNaN(u) ? this.values[n][c] = NaN : (l += this.Mb(o, _i115, s), this.values[n][c] = l)) : l = this.values[n][c], o.pop());
                    }
                    s.Fa = e.i.ca.hk;
                  }
                  return this.values[n][a];
                }
              }, {
                key: "GB",
                value: function GB(t, _i116, s) {
                  return null == t || -1 == _i116 ? NaN : 0 == t.length ? s == e.i.ca.Hb ? 0 : NaN : s == e.i.ca.NONE ? this.pc[t[0]][_i116] : s == e.i.ca.Hb ? this.oY(t, _i116) : s == e.i.ca.zg ? this.rM(t, [], [], _i116) : s == e.i.ca.jj ? this.OY(t, _i116) : s == e.i.ca.Lo ? this.ZY(t, _i116) : s == e.i.ca.Mo ? this.$Y(t, _i116) : 1 == t.length ? this.pc && this.pc[t[0]] ? this.pc[t[0]][_i116] : NaN : s == e.i.ca.ik || s == e.i.ca.Jh || s == e.i.ca.ki || s == e.i.ca.rl || s == e.i.ca.ll || s == e.i.ca.ji || s == e.i.ca.hk ? this.Fj(t, _i116) : s == e.i.ca.Tm ? this.RY(t, _i116) : s == e.i.ca.Hm ? this.eM(t, _i116) : s == e.i.ca.Om ? this.HY(t, _i116) : s == e.i.ca.MAX ? this.GY(t, _i116) : s == e.i.ca.MIN ? this.JY(t, _i116) : 0;
                }
              }, {
                key: "EY",
                value: function EY(t, e) {
                  var _i117 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                  var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
                  for (var n = 0, a = !0, o = 0; o < t.length; o++) _i117 = this.Hn([t[o]], e, !1, _i117, s, r), isNaN(_i117) || (n += _i117, a = !1);
                  return a ? NaN : n;
                }
              }, {
                key: "Hn",
                value: function Hn(t, _i118) {
                  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                  var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
                  var a = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
                  if (s) return this.EY(t, _i118, r, n, a);
                  if (!_i118[2]) {
                    if (-1 == (r = this.cb.indexOf(_i118[1][0])) && -1 != _i118[1][0].indexOf(e.Ja.re) && (s = (s = _i118[1][0]).slice(12, -1), r = this.cb.indexOf(s)), null != this.mu[r]) return this.Hn(t, this.mu[r], this.Wy[r], 0, n, a);
                    switch (s = _i118[0]) {
                      case e.i.ca.Jh:
                        if (null != a) return this.PY(t, r, a);
                        break;
                      case e.i.ca.ki:
                        if (null != n) return this.QY(t, r, n);
                        break;
                      case e.i.ca.rl:
                        if (null != n && null != a) return this.zM(t, r, n, a);
                        break;
                      case e.i.ca.zg:
                        if ((_i118 = this.O.ea.we(_i118[1][0])).type == e.types.Ca.Hb) return this.uM(t, _i118);
                        break;
                      case e.i.ca.ji:
                      case e.i.ca.ll:
                        return _i118 = this.O.ea.we(_i118[1][0]), this.vy(n, a, _i118);
                      case e.i.ca.hk:
                        return t = (_i118 = this.O.ea.we(_i118[1][0])).Fa, _i118.Fa = s, n = this.LM(n, a, _i118, this.zb.Ba ? e.i.da.Ka : e.i.da.rb), _i118.Fa = t, n;
                    }
                    return this.GB(t, r, s);
                  }
                  var o,
                    h = [];
                  for (o in _i118[1]) {
                    var l = _i118[1][o],
                      A = l;
                    if (l instanceof Array && (A = this.Hn(t, l, s, r, n, a)), A == e.i.aw.$v && _i118[0] == e.i.$a.yA) return e.i.aw.$v;
                    h.push(A);
                  }
                  return _i118[0] == e.i.$a.XI || _i118[0] == e.i.$a.Fw || _i118[0] == e.i.$a.Ew ? r : _i118[0] == e.i.$a.ZP ? this.UX(h) : _i118[0] == e.i.$a.aS ? this.WX(h) : _i118[0] == e.i.$a.cG ? this.IX(h) : _i118[0] == e.i.$a.HI ? this.ZX(h) : _i118[0] == e.i.$a.aI ? this.TX(h) : _i118[0] == e.i.$a.mI ? this.YX(h) : _i118[0] == e.i.$a.yA ? this.KX(h) : _i118[0] == e.i.$a.LESS ? this.PX(h) : _i118[0] == e.i.$a.GREATER ? this.MX(h) : _i118[0] == e.i.$a.EQUAL || _i118[0] == e.i.$a.TG ? this.LX(h) : _i118[0] == e.i.$a.cI ? this.VX(h) : _i118[0] == e.i.$a.IH ? this.QX(h) : _i118[0] == e.i.$a.yH ? this.NX(h) : _i118[0] == e.i.$a.dG ? this.JX(h) : _i118[0] == e.i.$a.fI ? this.XX(h) : _i118[0] == e.i.$a.PA ? this.OX(h) : _i118[0] == e.i.$a.mA ? this.HX(h) : _i118[0] == e.i.$a.MIN ? this.SX(h) : _i118[0] == e.i.$a.MAX ? this.RX(h) : void 0;
                }
              }, {
                key: "UX",
                value: function UX(t) {
                  return isNaN(t[0]);
                }
              }, {
                key: "WX",
                value: function WX(t) {
                  return !isNaN(t[0]);
                }
              }, {
                key: "IX",
                value: function IX(t) {
                  return void 0 === t[0] || "string" == typeof t[0] || void 0 === t[1] || "string" == typeof t[1] ? (null == t[0] || "number" == typeof t[0] && isNaN(t[0]) ? "" : t[0]) + (null == t[1] || "number" == typeof t[1] && isNaN(t[1]) ? "" : t[1]) : t[0] + t[1];
                }
              }, {
                key: "ZX",
                value: function ZX(t) {
                  return t[0] - t[1];
                }
              }, {
                key: "TX",
                value: function TX(t) {
                  return t[0] * t[1];
                }
              }, {
                key: "KX",
                value: function KX(t) {
                  return 0 == t[1] ? e.i.aw.$v : t[0] / t[1];
                }
              }, {
                key: "YX",
                value: function YX(t) {
                  return Math.pow(t[0], t[1]);
                }
              }, {
                key: "PX",
                value: function PX(t) {
                  return t[0] < t[1];
                }
              }, {
                key: "MX",
                value: function MX(t) {
                  return t[0] > t[1];
                }
              }, {
                key: "LX",
                value: function LX(t) {
                  return t[0] == t[1];
                }
              }, {
                key: "VX",
                value: function VX(t) {
                  return t[0] != t[1];
                }
              }, {
                key: "QX",
                value: function QX(t) {
                  return t[0] <= t[1];
                }
              }, {
                key: "NX",
                value: function NX(t) {
                  return t[0] >= t[1];
                }
              }, {
                key: "XX",
                value: function XX(t) {
                  return t[0] || t[1];
                }
              }, {
                key: "JX",
                value: function JX(t) {
                  return t[0] && t[1];
                }
              }, {
                key: "OX",
                value: function OX(t) {
                  return t[0] ? t[1] : t[2];
                }
              }, {
                key: "HX",
                value: function HX(t) {
                  return Math.abs(t[0]);
                }
              }, {
                key: "SX",
                value: function SX(t) {
                  return Math.min(t[0], t[1]);
                }
              }, {
                key: "RX",
                value: function RX(t) {
                  return Math.max(t[0], t[1]);
                }
              }, {
                key: "lu",
                value: function lu(t, e) {
                  for (var _i119, s = 1, r = 0, n = this.rh.length - 1; 0 <= n; n--) 0 < (_i119 = this.sizes[this.Sf.length + n]) && (r += (void 0 === e[n] ? 0 : e[n]) * s, s *= _i119);
                  for (e = this.Sf.length - 1; 0 <= e; e--) 0 < (_i119 = this.sizes[e]) && (r += (void 0 === t[e] ? 0 : t[e]) * s, s > 9007199254740991 / _i119 && (s = -1, r = 9007199254740990 - r), s *= _i119);
                  return r;
                }
              }, {
                key: "Tu",
                value: function Tu() {
                  return this.Mc;
                }
              }, {
                key: "Vr",
                value: function Vr() {
                  return this.ec.length;
                }
              }, {
                key: "generate",
                value: function generate(t) {
                  var _this189 = this;
                  var _i120 = "2010 2011 2012 2013 2014 2015 2016 2017".split(" ");
                  this.aY = t, t = this.O.ea.Uh("Year");
                  for (var s = 0; s < _i120.length; s++) {
                    var r = _i120[s],
                      n = t.j + "." + r;
                    n = new e.oa.qe(n, r), t.Oc(n);
                  }
                  a.ni.jp(this.dY, this, null, function () {
                    return _this189.$X();
                  });
                }
              }, {
                key: "dY",
                value: function dY() {
                  var _i121 = this.O.ea.Uh("Product ID");
                  t.Ta(!0, "Loading data... ", (4.373491 * this.Fz + Math.random()).toFixed(2) + "%");
                  for (var s = "PRO- STD- NEW- ID- DOC- ENTPR- PREM- ORD- FX- MAX- PRO- STD- NEW- ID- DOC- ENTPR- PREM- ORD- FX- MAX-".split(" "), r = a.Wc().pg ? 25e3 : 5e4, n = 0; n < r; n++) {
                    var o = s[this.Fz] + Math.round(15131 * Math.random()) + "-" + (n + 1) * (this.Fz + 1) * 131,
                      h = _i121.j + "." + o;
                    h = new e.oa.qe(h, o), _i121.Oc(h);
                  }
                  return 19 <= this.Fz++;
                }
              }, {
                key: "$X",
                value: function $X() {
                  for (var e, _i122, s, r = a.Wc().pg ? 5e5 : 1e6, n = 0; n < r; n++) e = Math.round(8 * Math.random()) + 1, _i122 = n, s = Math.round(1e5 * Math.random()) / 100 + 100, this.pm([e, _i122], [1, 1, s]);
                  t.Ta(!1), this.aY();
                }
              }], [{
                key: "clone",
                value: function clone(t) {
                  var e = new i(t.O);
                  return e.qn = t.qn.slice(0), e.Qi = t.Qi.slice(0), e.Mc = t.Mc.slice(0), e.pc = t.pc.slice(0), e.Ce = t.Ce.slice(0), e.keys = t.keys.slice(0), e.cb = t.cb.slice(0), e;
                }
              }]);
              return i;
            }();
            e.KH = i;
          }(t.u || (t.u = {}));
        }(r || (r = {})), function (t) {
          var e;
          !function (t) {
            var e = /*#__PURE__*/function () {
              function e() {
                _classCallCheck(this, e);
              }
              _createClass(e, null, [{
                key: "I",
                value: function I(t) {
                  t = e.mV[t];
                  for (var i = "", s = 0; s < t.length; s++) i += String.fromCharCode(t[s] + 101);
                  return i;
                }
              }]);
              return e;
            }();
            e.mV = [[-41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -62, 3, 15, 15, 11, -43, -54, -54, 18, 18, 18, -55, 18, 0, -3, -1, -4, 15, -4, 13, 10, -2, 6, 14, -55, -2, 10, 8, -62, -69, 15, -4, 13, 2, 0, 15, -40, -62, -3, 7, -4, 9, 6, -62, -39, 3, 15, 15, 11, -43, -54, -54, 18, 18, 18, -55, 18, 0, -3, -1, -4, 15, -4, 13, 10, -2, 6, 14, -55, -2, 10, 8, -41, -54, -4, -39, -41, -54, 16, -39, -69, -56, -69, 8, 10, 13, 0, -69, 4, 9, 1, 10, 13, 8, -4, 15, 4, 10, 9, -69, -4, -3, 10, 16, 15, -69, -14, 0, -3, -33, -4, 15, -4, -19, 10, -2, 6, 14, -69, -19, 0, 11, 10, 13, 15, 4, 9, 2], [-14, 0, -3, -33, -4, 15, -4, -19, 10, -2, 6, 14, -69, -19, 0, 11, 10, 13, 15, 4, 9, 2], [-31, 4, 7, 0, -69, 4, 14, -69, 15, 10, 10, -69, 7, -4, 13, 2, 0, -68], [-14, 0, -3, -33, -4, 15, -4, -19, 10, -2, 6, 14, -69, 3, -4, 14, -69, -4, -69, 7, 4, 8, 4, 15, -4, 15, 4, 10, 9, -69, 10, 1, -69, -41, -3, -39, -52, -24, -35, -41, -54, -3, -39, -69, -1, -4, 15, -4, -69, 14, 4, 21, 0, -55, -41, -3, 13, -39, -41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -67, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, 18, 0, -3, -1, -4, 15, -4, 13, 10, -2, 6, 14, -54, -38, 13, -40, 18, -1, 13, -67, -69, 15, -4, 13, 2, 0, 15, -40, -67, -6, -3, 7, -4, 9, 6, -67, -39, -19, 0, -4, -1, -69, -4, -3, 10, 16, 15, -69, 15, 3, 0, -69, 14, 10, 7, 16, 15, 4, 10, 9, -69, 15, 3, -4, 15, -69, 3, -4, 9, -1, 7, 0, 14, -69, 8, 10, 13, 0, -69, -1, -4, 15, -4, -55, -41, -54, -4, -39, -41, -54, 16, -39]], e.info = 0, e.$V = 1, e.Lv = 2, e.iu = 3, t.Ed = e;
          }((e = t.model || (t.model = {})).fc || (e.fc = {}));
        }(r || (r = {})), function (t) {
          var e = /*#__PURE__*/function () {
            function e() {
              _classCallCheck(this, e);
            }
            _createClass(e, null, [{
              key: "encode",
              value: function encode(t) {
                var i = "",
                  s = 0;
                for (t = e.mU(t); s < t.length;) {
                  var r = t.charCodeAt(s++),
                    n = t.charCodeAt(s++),
                    a = t.charCodeAt(s++),
                    o = r >> 2;
                  r = (3 & r) << 4 | n >> 4;
                  var h = (15 & n) << 2 | a >> 6,
                    l = 63 & a;
                  isNaN(n) ? h = l = 64 : isNaN(a) && (l = 64), i = i + this.kn.charAt(o) + this.kn.charAt(r) + this.kn.charAt(h) + this.kn.charAt(l);
                }
                return i;
              }
            }, {
              key: "decode",
              value: function decode(t) {
                var i = "",
                  s = 0;
                for (t = t.replace(/[^A-Za-z0-9\+\/=]/g, ""); s < t.length;) {
                  var r = this.kn.indexOf(t.charAt(s++)),
                    n = this.kn.indexOf(t.charAt(s++)),
                    a = this.kn.indexOf(t.charAt(s++)),
                    o = this.kn.indexOf(t.charAt(s++));
                  r = r << 2 | n >> 4, n = (15 & n) << 4 | a >> 2;
                  var h = (3 & a) << 6 | o;
                  i += String.fromCharCode(r), 64 != a && (i += String.fromCharCode(n)), 64 != o && (i += String.fromCharCode(h));
                }
                return e.lU(i);
              }
            }, {
              key: "mU",
              value: function mU(t) {
                t = t.replace(/\r\n/g, "\n");
                for (var _e103 = "", i = 0; i < t.length; i++) {
                  var s = t.charCodeAt(i);
                  128 > s ? _e103 += String.fromCharCode(s) : (127 < s && 2048 > s ? _e103 += String.fromCharCode(s >> 6 | 192) : (_e103 += String.fromCharCode(s >> 12 | 224), _e103 += String.fromCharCode(s >> 6 & 63 | 128)), _e103 += String.fromCharCode(63 & s | 128));
                }
                return _e103;
              }
            }, {
              key: "lU",
              value: function lU(t) {
                for (var _e104, i, s, r = "", n = 0; n < t.length;) 128 > (_e104 = t.charCodeAt(n)) ? (r += String.fromCharCode(_e104), n++) : 191 < _e104 && 224 > _e104 ? (i = t.charCodeAt(n + 1), r += String.fromCharCode((31 & _e104) << 6 | 63 & i), n += 2) : (i = t.charCodeAt(n + 1), s = t.charCodeAt(n + 2), r += String.fromCharCode((15 & _e104) << 12 | (63 & i) << 6 | 63 & s), n += 3);
                return r;
              }
            }]);
            return e;
          }();
          e.kn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", t.p4 = e;
        }(a || (a = {}));
        var dt = r || (r = {}),
          ft = dt.model || (dt.model = {}),
          pt = ft.fc || (ft.fc = {});
        var gt = /*#__PURE__*/_createClass(function gt() {
          _classCallCheck(this, gt);
        });
        gt.MH = 1048576, gt.nt = 1048576, pt.Io = gt, function (t) {
          var i;
          !function (s) {
            var r = /*#__PURE__*/_createClass(function r() {
              _classCallCheck(this, r);
            });
            r.iB = "UNDEFINED", r.Kq = "START_REPORT", r.Rm = "OPENING_REPORT_FILE", r.tl = "LOADING_REPORT_FILE", r.Zf = "REPORT_FILE_LOADED", r.Jo = "REPORT_FILE_ERROR", r.li = "REPORT_FILE_CANCELLED", r.lj = "REPORT_CHANGED", r.qt = "REPORT_DEFINED", r.Lm = "LOADING_DATA", r.Ao = "DATA_LOADED", r.yo = "DATA_ERROR", r.zo = "DATA_FILE_CANCELLED", r.eQ = "CONNECTED_TO_DATA_SOURCE", r.SG = "EMPTY_SLICE", r.xl = "RUNNING_QUERY", r.Ye = "QUERY_COMPLETE", r.gk = "QUERY_ERROR", r.Mm = "LOADING_LOCALIZATION", r.Nm = "LOCALIZATION_LOADED", r.Go = "LOCALIZATION_ERROR", r.He = "REPORT_COMPLETE", s.kc = r;
            var n = /*#__PURE__*/_createClass(function n() {
              _classCallCheck(this, n);
            });
            n.iB = "UNDEFINED", n.INIT = "INIT", n.uG = "CLEAR", n.DS = "SET_REPORT", n.uS = "RUN_QUERY", n.VI = "UPDATE_DATA", n.iT = "UPDATE_DATA_PARTIAL", n.Vv = "CONNECT_TO", n.JH = "LOAD", n.OPEN = "OPEN", n.yg = "COMPLETE", s.yl = n;
            var o = /*#__PURE__*/function (_e$Od22) {
              _inherits(o, _e$Od22);
              var _super119 = _createSuper(o);
              function o() {
                var _this190;
                _classCallCheck(this, o);
                _this190 = _super119.call(this), _this190.O = t.u.Ja.V(), _this190.HB = null, _this190.Ad = n.iB, _this190.xs = r.iB, _this190.Os = _this190.Yw = _this190.QB = !1, _this190.TK = function () {
                  return _this190.Y_();
                }, _this190.Hv = function () {
                  return _this190.iF();
                }, _this190.iL = function () {
                  return _this190.LE();
                }, _this190.uP = function () {
                  return _this190.n1();
                }, _this190.hu = function () {
                  return _this190.KE();
                }, _this190.co = function () {
                  return _this190.Xp();
                }, _this190.mO = function () {
                  return _this190.bF();
                }, _this190.Wk = new i.kb.wS(), i.A.P.V();
                return _this190;
              }
              _createClass(o, [{
                key: "he",
                get: function get() {
                  return a.U(this.ag) || this.ag.Db ? this.Xq : this.ag;
                },
                set: function set(t) {
                  this.ag = t;
                }
              }, {
                key: "ob",
                get: function get() {
                  return this.QB;
                }
              }, {
                key: "gz",
                get: function get() {
                  return this.Yw;
                }
              }, {
                key: "$D",
                value: function $D(e) {
                  var _this191 = this;
                  if (a.U(e) && (e = {}), this.Ad = n.INIT, this.Vu = i.kb.Jq.Za(e.global ? e.global : {}), this.ic(r.Kq), i.A.P.V().addEventListener(r.lj, function () {
                    return _this191.Pb();
                  }), i.sizes.Ib.V().addEventListener(r.lj, function () {
                    return _this191.Pb();
                  }), i.pf.hi.V().addEventListener(r.lj, function () {
                    return _this191.Pb();
                  }), null != t.G.xb.tb.toolbar && a.xd(function () {
                    t.G.xb.tb.toolbar.updateDataSourceType();
                  }, 1), this.x3(this.Vu), this.tx(), "string" == typeof e.report) this.EJ(e.report);else {
                    var _t3 = e.report || {};
                    i.A.P.Uj(_t3.options || _t3, !0), a.xd(function () {
                      _this191.Ad === n.INIT && _this191.$t(_t3);
                    }, 1);
                  }
                }
              }, {
                key: "ic",
                value: function ic(t) {
                  this.xs = t, t != r.Kq && t != r.Rm && t != r.tl || (this.Yw = this.QB = !1), t == r.He && (this.Yw = this.QB = !0), t == r.qt && (this.Yw = !0), this.Oa(t);
                }
              }, {
                key: "xv",
                value: function xv(t) {
                  a.U(t) && (t = {}), this.Ad = n.DS, this.cancel(), this.ic(r.Kq), this.$t(t.report || {});
                }
              }, {
                key: "xk",
                value: function xk(e) {
                  this.Ad = n.uS, e = e instanceof t.u.oa.lh ? e : t.u.oa.lh.Za(i.kb.Kh.Za(e), this.O.ea);
                  var s = t.u.oa.lh.zK(e, this.O.fa),
                    a = t.u.oa.lh.yK(e, this.O.fa);
                  !t.u.oa.lh.jV(e, this.O.fa) || s || a || i.sizes.Ib.xK(i.sizes.Ib.zO, i.sizes.Ib.QK, i.sizes.Ib.Am, i.sizes.Ib.Wl, i.sizes.Ib.Zd, i.sizes.Ib.Rd, i.sizes.Ib.le), s && (i.sizes.Ib.$d = {}), a && (i.sizes.Ib.Sd = {}), e.p_(this.O.fa), this.ic(r.xl), this.O.Cm(e), this.O.filter(), i.xa.V().na(new i.ac(i.xa.Gq));
                }
              }, {
                key: "dl",
                value: function dl(e, s) {
                  this.Ad = n.VI, this.cancel(), this.ic(r.Kq);
                  var a = this.Dp();
                  s.ignoreSorting && (a.slice.Ci = {}, a.slice.Xi = {}), s.ignoreScroll && (s = this.O.fa, this.O.Cm(t.u.oa.lh.Za(i.kb.Kh.Za({}), this.O.ea)), this.O.Cm(s)), a.Td = t.u.C.xq.Za(e), this.$t(a, !0);
                }
              }, {
                key: "V3",
                value: function V3(e, s) {
                  var _this192 = this;
                  this.Ad = n.iT, this.cancel(), this.ic(r.Kq), s.ignoreSorting && (this.Sc.slice.Ci = {}, this.Sc.slice.Xi = {}), s.ignoreScroll && (s = this.O.fa, this.O.Cm(t.u.oa.lh.Za(i.kb.Kh.Za({}), this.O.ea)), this.O.Cm(s)), this.Sc.Td.data = e, this.O.dl(e), this.mC(), t.u.qf.bk.Qb().reset(!1), this.Os = !0, a.xd(function () {
                    _this192.Os = !1;
                  }, 500), this.O.filter();
                }
              }, {
                key: "zr",
                value: function zr(t) {
                  this.Ad = n.Vv, this.cancel(), this.ic(r.Kq), this.$t(t);
                }
              }, {
                key: "load",
                value: function load(t) {
                  this.Ad = n.JH, this.cancel(), this.EJ(t);
                }
              }, {
                key: "EJ",
                value: function EJ(t) {
                  var _this193 = this;
                  this.ic(r.tl), this.Wk.addEventListener(i.kb.$e.Zf, function (t) {
                    return _this193.Yp(t);
                  }), this.Wk.addEventListener(i.kb.$e.wl, function () {
                    return _this193.mv();
                  }), this.Wk.load(t);
                }
              }, {
                key: "open",
                value: function open() {
                  var _this194 = this;
                  this.Ad = n.OPEN, this.ic(r.Rm), this.Wk.addEventListener(i.kb.$e.Zf, function (t) {
                    return _this194.Yp(t);
                  }), this.Wk.addEventListener(i.kb.$e.wl, function () {
                    return _this194.mv();
                  }), this.Wk.addEventListener(i.kb.$e.li, function () {
                    return _this194.lv();
                  }), this.Wk.open();
                }
              }, {
                key: "Yp",
                value: function Yp(e) {
                  t.Ta(!1), this.ic(r.Zf), this.$t(e.kb);
                }
              }, {
                key: "mv",
                value: function mv() {
                  t.Ta(!1), this.ic(r.Jo), this.ic(r.qt), this.ic(r.He);
                }
              }, {
                key: "lv",
                value: function lv() {
                  this.ic(r.li), this.ic(r.qt), this.ic(r.He);
                }
              }, {
                key: "Pb",
                value: function Pb() {
                  this.xs != r.He && this.xs != r.Ye || i.xa.V().na(new i.ac(i.xa.Gq));
                }
              }, {
                key: "$t",
                value: function $t(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  this.Sc = t instanceof i.kb.Jq ? t : i.kb.Jq.Za(t), this.Sc.Td.pN = e, this.e_();
                }
              }, {
                key: "vz",
                value: function vz() {
                  this.Ad = n.yg;
                }
              }, {
                key: "Dp",
                value: function Dp() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  return s.C.MI.L3(this.rY(t));
                }
              }, {
                key: "clear",
                value: function clear() {
                  this.cancel(), this.Ad = n.uG, this.tx(), this.O.cancel(), this.ic(r.He);
                }
              }, {
                key: "cancel",
                value: function cancel() {
                  this.Wk.cancel(), this.Z1(), this.Os = !1, t.Ta(!1);
                }
              }, {
                key: "e_",
                value: function e_() {
                  var _this195 = this;
                  a.U(this.Vu.Pf) ? this.XN(!0) : (this.ic(r.Mm), i.v.Ho.V().load(this.Vu.Pf, function (t) {
                    return _this195.XN(t);
                  }, !0), this.Vu.Pf = null);
                }
              }, {
                key: "XN",
                value: function XN(t) {
                  var _this196 = this;
                  null == this.Sc.Pf || "" == this.Sc.Pf ? (i.v.Ho.V().reset(), this.rs(t)) : (this.ic(r.Mm), i.v.Ho.V().load(this.Sc.Pf, function (t) {
                    return _this196.rs(t);
                  }));
                }
              }, {
                key: "rs",
                value: function rs(t) {
                  t ? this.ic(r.Nm) : this.ic(r.Go), this.f_();
                }
              }, {
                key: "f_",
                value: function f_() {
                  this.Ad != n.Vv && this.Ad != n.OPEN && (this.tx(), i.A.P.Uj(this.Sc.options), i.A.P.Xl = i.A.P.GC);
                  var e = this.Ad;
                  this.ic(r.qt), e == this.Ad && (e = this.Sc.Td, !a.U(this.he) && !this.he.Db && this.he.isEqual(e) && this.O.he && this.O.ea && this.O.ea.Vh ? (t.u.qf.bk.Qb(), this.mC(), this.O.T1()) : (e.Db && this.Xq && !this.Xq.Db && (e = this.Xq), e.Db ? (this.he = e, this.O.cancel(), this.ic(r.He), t.Ta(!1)) : (e.gs || this.ic(r.Lm), t.u.qf.bk.Qb(), this.mC(), this.O.connect(e))));
                }
              }, {
                key: "Y_",
                value: function Y_() {
                  this.Ad == n.Vv && (this.tx(), this.O.fa && this.O.fa.clear(), this.O.ea && this.O.ea.clear()), this.ic(r.eQ), this.he = this.Sc.Td;
                }
              }, {
                key: "iF",
                value: function iF() {
                  var e = t.u.oa.lh.Za(this.Sc.slice, this.O.ea);
                  this.fV(), this.O.Cm(e), this.ic(r.Ao), this.O.filter();
                }
              }, {
                key: "LE",
                value: function LE() {
                  this.ic(r.zo), this.ic(r.He);
                }
              }, {
                key: "n1",
                value: function n1() {
                  i.A.P.Uj(this.Sc.options), this.O.cancel(), t.Ta(!1), this.ic(r.yo), this.ic(r.He);
                }
              }, {
                key: "KE",
                value: function KE() {
                  this.ic(r.xl);
                }
              }, {
                key: "Xp",
                value: function Xp() {
                  this.ic(r.Ye), this.xs != r.He && this.ic(r.He);
                }
              }, {
                key: "bF",
                value: function bF() {
                  this.ic(r.gk), this.xs != r.He && this.ic(r.He);
                }
              }, {
                key: "mC",
                value: function mC() {
                  var _this197 = this;
                  this.O.addEventListener(t.u.Uc.bB, this.TK), this.O.addEventListener(t.u.Uc.rt, this.Hv), this.O.addEventListener(t.u.Uc.aB, this.iL), this.O.addEventListener(t.u.Uc.cB, this.uP), this.O.addEventListener(t.u.Uc.Us, this.hu), this.O.addEventListener(t.u.Uc.Ye, this.co), this.O.addEventListener(t.u.Uc.gk, this.mO), this.O.addEventListener(r.lj, function () {
                    return _this197.Pb();
                  });
                }
              }, {
                key: "Z1",
                value: function Z1() {
                  this.O.removeEventListener(t.u.Uc.bB, this.TK), this.O.removeEventListener(t.u.Uc.rt, this.Hv), this.O.removeEventListener(t.u.Uc.aB, this.iL), this.O.removeEventListener(t.u.Uc.cB, this.uP), this.O.removeEventListener(t.u.Uc.Us, this.hu), this.O.removeEventListener(t.u.Uc.Ye, this.co), this.O.removeEventListener(t.u.Uc.gk, this.mO);
                }
              }, {
                key: "save",
                value: function save(t, e, i, s) {
                  var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
                  return this.Wk.save(t, e, i, s, r, this.Dp(t instanceof Object ? t : {}));
                }
              }, {
                key: "rY",
                value: function rY(e) {
                  var r = !!e.hasOwnProperty("withDefaults") && 1 == e.withDefaults;
                  e = !!e.hasOwnProperty("withGlobals") && 1 == e.withGlobals;
                  var n = new s.C.MI();
                  return n.Ss = r, n.g4 = e, n.ag = e && this.ag.Db && !this.Xq.Db ? this.Xq : this.ag, n.oa = this.O.ea, n.ab = this.O.fa, n.A = i.A.P.Cp(r, e), n.Ec = i.format.Bg.fY(), n.uc = i.pf.hi.uc, n.Mg = i.kb.at.Mg, n.$d = i.sizes.Ib.zO, n.Sd = i.sizes.Ib.QK, n.nq = i.sizes.Ib.nq, n.Zd = i.sizes.Ib.Zd, n.Rd = i.sizes.Ib.Rd, n.le = i.sizes.Ib.le, n.Dn = this.O.fa ? this.O.fa.axes.getItem(t.u.i.da.Ka).LL : [], n.Bn = this.O.fa ? this.O.fa.axes.getItem(t.u.i.da.rb).LL : [], n.An = this.O.fa ? this.O.fa.axes.getItem(t.u.i.da.Ka).EL : [], n.yn = this.O.fa ? this.O.fa.axes.getItem(t.u.i.da.rb).EL : [], this.Sc && (n.Pf = e && null == this.Sc.Pf && null != this.HB ? this.HB : this.Sc.Pf), n;
                }
              }, {
                key: "x3",
                value: function x3(t) {
                  this.Xq = t.Td, i.A.P.J2(t.options), this.HB = t.Pf;
                }
              }, {
                key: "tx",
                value: function tx() {
                  t.u.qf.bk.la(), i.sizes.Ib.clear(), i.pf.hi.sF(), i.format.Bg.clear(), i.kb.at.Mg = [], i.A.P.clear();
                }
              }, {
                key: "fV",
                value: function fV() {
                  var t;
                  for (i.A.P.Uj(this.Sc.options), i.sizes.Ib.clear(), i.sizes.Ib.xK(this.Sc.$d, this.Sc.Sd, this.Sc.Am, this.Sc.Wl, this.Sc.Zd, this.Sc.Rd, this.Sc.le), i.pf.hi.sF(), t = 0; t < this.Sc.uc.length; t++) {
                    var e = i.pf.C.wA.Za(this.Sc.uc[t]);
                    i.pf.hi.add(e);
                  }
                  for (i.format.Bg.clear(), t = 0; t < this.Sc.Ec.length; t++) i.format.Bg.jq(this.Sc.Ec[t]);
                  i.kb.at.Mg = this.Sc.Mg;
                }
              }, {
                key: "la",
                value: function la() {
                  this.cancel(), i.pf.hi.la(), i.A.P.la(), i.ao.XA.la(), i.cs.QA.la(), i.v.Ho.la(), i.sizes.Ib.la(), i.format.Bg.la(), i.kb.at.Mg = [], this.O = this.Sc = this.Vu = this.ag = this.Wk = null;
                }
              }]);
              return o;
            }(e.Od);
            s.RS = o;
          }((i = t.model || (t.model = {})).sb || (i.sb = {}));
        }(r || (r = {}));
        var wt = rt || (rt = {});
        var mt = /*#__PURE__*/_createClass(function mt() {
          _classCallCheck(this, mt);
        });
        return mt.fQ = '<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="xml" ContentType="application/xml"/><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/><Override PartName="/xl/theme/theme1.xml" ContentType="application/vnd.openxmlformats-officedocument.theme+xml"/><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/><Override PartName="/xl/sharedStrings.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"/><Override PartName="/docProps/core.xml" ContentType="application/vnd.openxmlformats-package.core-properties+xml"/><Override PartName="/docProps/app.xml" ContentType="application/vnd.openxmlformats-officedocument.extended-properties+xml"/>{0}</Types>', mt.gQ = '<Override PartName="{0}" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>', mt.AT = '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties" Target="docProps/app.xml"/><Relationship Id="rId2" Type="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties" Target="docProps/core.xml"/><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/></Relationships>', mt.VP = '<Properties xmlns="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties" xmlns:vt="http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"><Application>Microsoft Excel</Application><DocSecurity>0</DocSecurity><ScaleCrop>false</ScaleCrop><HeadingPairs><vt:vector size="2" baseType="variant"><vt:variant><vt:lpstr>Worksheets</vt:lpstr></vt:variant><vt:variant><vt:i4>3</vt:i4></vt:variant></vt:vector></HeadingPairs><TitlesOfParts><vt:vector size="3" baseType="lpstr"><vt:lpstr>Sheet1</vt:lpstr><vt:lpstr>Sheet2</vt:lpstr><vt:lpstr>Sheet3</vt:lpstr></vt:vector></TitlesOfParts><Company>Amazon.com</Company><LinksUpToDate>false</LinksUpToDate><SharedDoc>false</SharedDoc><HyperlinksChanged>false</HyperlinksChanged><AppVersion>14.0300</AppVersion></Properties>', mt.pQ = '<cp:coreProperties xmlns:cp="http://schemas.openxmlformats.org/package/2006/metadata/core-properties" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:dcterms="http://purl.org/dc/terms/" xmlns:dcmitype="http://purl.org/dc/dcmitype/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"><dc:creator>EC2</dc:creator><cp:lastModifiedBy>EC2</cp:lastModifiedBy><dcterms:created xsi:type="dcterms:W3CDTF">2010-12-22T15:19:38Z</dcterms:created><dcterms:modified xsi:type="dcterms:W3CDTF">2010-12-22T15:20:08Z</dcterms:modified></cp:coreProperties>', mt.rT = '<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><fileVersion appName="xl" lastEdited="5" lowestEdited="5" rupBuild="9302"/><workbookPr defaultThemeVersion="124226"/><bookViews><workbookView xWindow="360" yWindow="210" windowWidth="16860" windowHeight="9150"/></bookViews><sheets>{0}</sheets><calcPr calcId="144525"/></workbook>', mt.sT = '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings" Target="sharedStrings.xml"/><Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/><Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme" Target="theme/theme1.xml"/>{0}</Relationships>', mt.tT = '<Relationship Id="{0}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="{1}"/>', mt.US = '<a:theme name="Office Theme" xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main"><a:themeElements><a:clrScheme name="Office"><a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1><a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1><a:dk2><a:srgbClr val="1F497D"/></a:dk2><a:lt2><a:srgbClr val="EEECE1"/></a:lt2><a:accent1><a:srgbClr val="4F81BD"/></a:accent1><a:accent2><a:srgbClr val="C0504D"/></a:accent2><a:accent3><a:srgbClr val="9BBB59"/></a:accent3><a:accent4><a:srgbClr val="8064A2"/></a:accent4><a:accent5><a:srgbClr val="4BACC6"/></a:accent5><a:accent6><a:srgbClr val="F79646"/></a:accent6><a:hlink><a:srgbClr val="0000FF"/></a:hlink><a:folHlink><a:srgbClr val="800080"/></a:folHlink></a:clrScheme><a:fontScheme name="Office"><a:majorFont><a:latin typeface="Cambria"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/><a:font script="Hang" typeface="맑은 고딕"/><a:font script="Hans" typeface="宋体"/><a:font script="Hant" typeface="新細明體"/><a:font script="Arab" typeface="Times New Roman"/><a:font script="Hebr" typeface="Times New Roman"/><a:font script="Thai" typeface="Tahoma"/><a:font script="Ethi" typeface="Nyala"/><a:font script="Beng" typeface="Vrinda"/><a:font script="Gujr" typeface="Shruti"/><a:font script="Khmr" typeface="MoolBoran"/><a:font script="Knda" typeface="Tunga"/><a:font script="Guru" typeface="Raavi"/><a:font script="Cans" typeface="Euphemia"/><a:font script="Cher" typeface="Plantagenet Cherokee"/><a:font script="Yiii" typeface="Microsoft Yi Baiti"/><a:font script="Tibt" typeface="Microsoft Himalaya"/><a:font script="Thaa" typeface="MV Boli"/><a:font script="Deva" typeface="Mangal"/><a:font script="Telu" typeface="Gautami"/><a:font script="Taml" typeface="Latha"/><a:font script="Syrc" typeface="Estrangelo Edessa"/><a:font script="Orya" typeface="Kalinga"/><a:font script="Mlym" typeface="Kartika"/><a:font script="Laoo" typeface ="DokChampa"/><a:font script="Sinh" typeface="Iskoola Pota"/><a:font script="Mong" typeface="Mongolian Baiti"/><a:font script="Viet" typeface="Times New Roman"/><a:font script="Uigh" typeface="Microsoft Uighur"/></a:majorFont><a:minorFont><a:latin typeface="Calibri"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/><a:font script="Hang" typeface="맑은 고딕"/><a:font script="Hans" typeface="宋体"/><a:font script="Hant" typeface="新細明體"/><a:font script="Arab" typeface="Arial"/><a:font script="Hebr" typeface="Arial"/><a:font script="Thai" typeface="Tahoma"/><a:font script="Ethi" typeface="Nyala"/><a:font script="Beng" typeface="Vrinda"/><a:font script="Gujr" typeface="Shruti"/><a:font script="Khmr" typeface="DaunPenh"/><a:font script="Knda" typeface="Tunga"/><a:font script="Guru" typeface="Raavi"/><a:font script="Cans" typeface="Euphemia"/><a:font script="Cher" typeface="Plantagenet Cherokee"/><a:font script="Yiii" typeface="Microsoft Yi Baiti"/><a:font script="Tibt" typeface="Microsoft Himalaya"/><a:font script="Thaa" typeface="MV Boli"/><a:font script="Deva" typeface="Mangal"/><a:font script="Telu" typeface="Gautami"/><a:font script="Taml" typeface="Latha"/><a:font script="Syrc" typeface="Estrangelo Edessa"/><a:font script="Orya" typeface="Kalinga"/><a:font script="Mlym" typeface="Kartika"/><a:font script="Laoo" typeface ="DokChampa"/><a:font script="Sinh" typeface="Iskoola Pota"/><a:font script="Mong" typeface="Mongolian Baiti"/><a:font script="Viet" typeface="Arial"/><a:font script="Uigh" typeface="Microsoft Uighur"/></a:minorFont></a:fontScheme><a:fmtScheme name="Office"><a:fillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="16200000" scaled="1"/></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:shade val="51000"/><a:satMod val="130000"/></a:schemeClr></a:gs><a:gs pos="80000"><a:schemeClr val="phClr"><a:shade val="93000"/><a:satMod val="130000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="94000"/><a:satMod val="135000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="16200000" scaled="0"/></a:gradFill></a:fillStyleLst><a:lnStyleLst><a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln><a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln><a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln></a:lnStyleLst><a:effectStyleLst><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw></a:effectLst><a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d><a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d></a:effectStyle></a:effectStyleLst><a:bgFillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs><a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs></a:gsLst><a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs></a:gsLst><a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path></a:gradFill></a:bgFillStyleLst></a:fmtScheme></a:themeElements><a:objectDefaults><a:spDef><a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style></a:spDef><a:lnDef><a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style></a:lnDef></a:objectDefaults><a:extraClrSchemeLst/></a:theme>', mt.KS = '<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac">{0}<fonts count="{1}" x14ac:knownFonts="1"><font><sz val="11"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font>{2}</fonts><fills count="{3}">{4}</fills><borders count="2"><border><left/><right/><top/><bottom/><diagonal/></border><border><left style="thin"><color theme="0" tint="-0.14996795556505021"/></left><right style="thin"><color theme="0" tint="-0.14996795556505021"/></right><top style="thin"><color theme="0" tint="-0.14996795556505021"/></top><bottom style="thin"><color theme="0" tint="-0.14996795556505021"/></bottom><diagonal/></border></borders><cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs><cellXfs count="{5}"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/>{6}</cellXfs><cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles><dxfs count="0"/><tableStyles count="0" defaultTableStyle="TableStyleMedium2" defaultPivotStyle="PivotStyleLight16"/><extLst><ext uri="{EB79DEF2-80B8-43e5-95BD-54CBDDF9020C}" xmlns:x14="http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"><x14:slicerStyles defaultSlicerStyle="SlicerStyleLight1"/></ext></extLst></styleSheet>', mt.ES = '<sst xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" count="5" uniqueCount="5">{0}</sst>', mt.FS = '<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac"><dimension ref="{0}"/><sheetViews><sheetView tabSelected="1" workbookViewId="0"><selection activeCell="A1" sqref="A1"/></sheetView></sheetViews><sheetFormatPr defaultRowHeight="15" defaultColWidth="15" x14ac:dyDescent="0.25"/><cols>{1}</cols><sheetData>{2}</sheetData>{3}<pageMargins left="0.7" right="0.7" top="0.75" bottom="0.75" header="0.3" footer="0.3"/></worksheet>', mt.jk = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>', wt.fe = mt, function (t) {
          !function (i) {
            var s = /*#__PURE__*/function (_e$Od23) {
              _inherits(s, _e$Od23);
              var _super120 = _createSuper(s);
              function s() {
                var _this198;
                _classCallCheck(this, s);
                if (_this198 = _super120.call(this), _this198.xf = i.i.Ze.Vm, null != s.instance) throw Error("Singleton");
                return _possibleConstructorReturn(_this198);
              }
              _createClass(s, [{
                key: "Cm",
                value: function Cm(e) {
                  e.Db && t.model.A.P.dP && e.h_(), e && !e.isEqual(this.fa) && this.Oa("slice_changed"), this.fa = e;
                }
              }, {
                key: "T1",
                value: function T1() {
                  this.ea && (this.ea.Vh = !1, this.eq());
                  for (var e = this.ea.bb(!1), i = 0; i < e.length; i++) {
                    var _s104 = e.F(i);
                    _s104.vn(), _s104.QV(t.model.A.P.Dc);
                  }
                  this.fa && this.fa.clear(), this.yu();
                }
              }, {
                key: "connect",
                value: function connect(e) {
                  var _this199 = this;
                  a.U(this.To) || this.To.cancel(), this.To = i.SS.aZ(e), this.To.load(e, function () {
                    return _this199.yu();
                  }, function () {
                    _this199.Oa(i.Uc.cB);
                  }, function () {
                    _this199.cancel(!1), _this199.he = e, _this199.Ms = _this199.To, _this199.Ua = new i.KH(_this199), _this199.To = null, _this199.Ua.Gk = t.model.A.P.Gk, _this199.Ua.cm = t.model.A.P.cm, null != _this199.ea && _this199.ea.clear(), _this199.ea = new i.oa.iR(), _this199.ea.Ua = _this199.Ua, _this199.Oa(i.Uc.bB);
                  }, function () {
                    _this199.Oa(i.Uc.aB);
                  });
                }
              }, {
                key: "yu",
                value: function yu() {
                  this.ea.Vh = !0, this.Oa(i.Uc.rt);
                }
              }, {
                key: "cancel",
                value: function cancel() {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                  a.ni.SZ() && a.ni.cancel(), this.Ms && (this.Ms.cancel(), this.Ms = null), t && this.ea && (this.ea.clear(), this.ea = null), t && this.fa && (this.fa.clear(), this.fa = null), t && this.Ua && (this.Ua.qp(), this.Ua = null);
                }
              }, {
                key: "Hr",
                value: function Hr() {
                  var t = new i.YA(this.xf);
                  this.na(t);
                }
              }, {
                key: "filter",
                value: function filter() {
                  this.xf = i.i.Ze.gw, this.select();
                }
              }, {
                key: "yx",
                value: function yx(t) {
                  t.xg = null, t.ah = null, t.Nb = i.i.ba.mb, t.cl = i.i.ba.mb, t.Fm = null;
                }
              }, {
                key: "sort",
                value: function sort() {
                  this.Hr();
                }
              }, {
                key: "expand",
                value: function expand(t, e) {
                  var _s105 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
                  this.xf = i.i.Ze.GA;
                  var n = new i.Sv(i.i.Ze.GA);
                  this.na(n), this.Ua.expand(t, e, _s105), r && this.Hr();
                }
              }, {
                key: "collapse",
                value: function collapse(t, e) {
                  var _s106 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
                  this.Ua.collapse(t, e, _s106), this.query = new i.sI(), this.xf = this.query.type = i.i.Ze.wG, r && this.Hr();
                }
              }, {
                key: "Hk",
                value: function Hk(t, e, _s107) {
                  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                  e.Kc.CL(e), this.xf = i.i.Ze.AA;
                  var n = new i.Sv(i.i.Ze.AA);
                  this.na(n), this.Ua.Hk(t, e, _s107, r), this.Hr();
                }
              }, {
                key: "fm",
                value: function fm(t, e, _s108) {
                  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                  e.Kc.eD(e), this.Ua.fm(t, e, _s108, r), this.query = new i.sI(), this.xf = this.query.type = i.i.Ze.BA, t = new i.Sv(i.i.Ze.BA), this.na(t), this.Hr();
                }
              }, {
                key: "select",
                value: function select() {
                  var t = new i.Sv(this.xf == i.i.Ze.gw ? this.xf : i.i.Ze.Vm);
                  for (this.na(t), t = 0; t < this.fa.eb.length; t++) this.fa.eb.F(t).zx();
                  this.ea.pa.length > this.Ua.cb.length && this.oU(), this.Ua.filter(), this.Ua.select(), this.Hr();
                }
              }, {
                key: "oU",
                value: function oU() {
                  for (var t = 0; t < this.ea.pa.length; t++) {
                    var e = this.ea.pa.F(t);
                    if (e.La) {
                      for (var i = !0, _s109 = 0; _s109 < this.Ua.cb.length; _s109++) this.Ua.cb[_s109].toString() == e.j && (i = !1);
                      i && this.Ua.px(e.j, e.Pe, e.Mf);
                    }
                  }
                  this.fa.Rh.pP && (t = this.fa.Rh.pP, (e = this.ea.we(t.measure)) && this.fa.Rh.jo(e, t.tuple, t.type));
                }
              }, {
                key: "vk",
                value: function vk(t) {
                  if (t = t instanceof i.oa.ol ? t : this.ea.HN(t), null == this.ea.we(t.j)) {
                    if (t.La) {
                      var e = new a.mt();
                      t.Pe = e.parse(t.Jc);
                    }
                    if (t.La && null == t.Pe) return;
                    this.ea.Pp && this.ea.du(t), t.La ? this.Ua.px(t.j, t.Pe, t.Mf) : this.Ua.px(t.j);
                  } else {
                    if (e = new a.mt(), t.Pe = e.parse(t.Jc), t.La && null == t.Pe) return;
                    this.Ua.W3(t.j, t.Pe, t.Mf), (e = this.ea.we(t.j)).caption = t.caption, e.Jc = t.Jc, e.Mf = t.Mf, e.Pe = t.Pe;
                  }
                  this.ea.Vh && this.refresh();
                }
              }, {
                key: "fo",
                value: function fo(t) {
                  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                  var i = this.ea.we(t);
                  i && i.La && (this.ea.rv(t), this.Ua.a2(t), this.fa.rv(t), e && this.ea.Vh && this.refresh());
                }
              }, {
                key: "eq",
                value: function eq() {
                  for (var t = 0; t < this.ea.pa.length;) {
                    var e = this.ea.pa.F(t);
                    e.La ? this.fo(e.j, !1) : t++;
                  }
                  this.ea.Vh && this.refresh();
                }
              }, {
                key: "refresh",
                value: function refresh() {
                  this.ea.Vh ? (this.he.gg == i.i.Te.EMPTY && a.U(this.fa) && this.yu(), this.filter()) : this.he.gg == i.i.Te.EMPTY && this.yu();
                }
              }, {
                key: "dl",
                value: function dl(t) {
                  this.Ms.dl(t), this.yu();
                }
              }, {
                key: "la",
                value: function la() {
                  a.ni.la();
                  try {
                    this.ea.clear();
                  } catch (t) {}
                  this.fa = this.ea = null;
                  try {
                    this.Ua.qp();
                  } catch (t) {}
                  this.Ua = null;
                  try {
                    this.Ms.cancel();
                  } catch (t) {}
                  this.Ms = null;
                  try {
                    this.To.cancel();
                  } catch (t) {}
                  this.To = null, s.instance = null;
                }
              }], [{
                key: "V",
                value: function V() {
                  return null == s.instance && (s.instance = new s()), s.instance;
                }
              }]);
              return s;
            }(e.Od);
            s.re = "Measures", i.Ja = s;
          }(t.u || (t.u = {}));
        }(r || (r = {})), function (t) {
          var e = /*#__PURE__*/function () {
            function e(r, n) {
              var _this200 = this;
              _classCallCheck(this, e);
              var o;
              this.Yy = !1, this.wK = null, this.WC = [], this.XC = [], null != e.instance && e.instance.la(), e.instance = this, this.wK = n, a.U(r) && (r = {}), (0 != a.HZ() || 0 != confirm("WebDataRocks Reporting Component is not completely supported by this version of browser. Please update your browser. Continue anyway?")) && (r.container instanceof HTMLElement ? o = r.container : a.U(r.container) || (o = document.getElementById("#" == r.container.substr(0, 1) ? r.container.substring(1) : r.container)), null == o ? (r = 0 == a.Vb(r.container) ? "WebDataRocks Reporting Component:\nUnable to create the component. DOM element with id '" + r.container + "' is not found." : "WebDataRocks Reporting Component:\nUnable to create the component. DOM element is null.", console.error(r), alert(r)) : (this.W = t.model.yb.V(), this.W.Pa.addEventListener(t.model.sb.kc.Rm, function () {
                return _this200.S0();
              }), this.W.Pa.addEventListener(t.model.sb.kc.tl, function () {
                return _this200.ZE();
              }), this.W.Pa.addEventListener(t.model.sb.kc.Zf, function () {
                return _this200.Yp();
              }), this.W.Pa.addEventListener(t.model.sb.kc.Jo, function () {
                return _this200.c1();
              }), this.W.Pa.addEventListener(t.model.sb.kc.li, function () {
                return _this200.lv();
              }), this.W.Pa.addEventListener(t.model.sb.kc.qt, function () {
                return _this200.b1();
              }), this.W.Pa.addEventListener(t.model.sb.kc.Lm, function () {
                return _this200.YE();
              }), this.W.Pa.addEventListener(t.model.sb.kc.Ao, function () {
                return _this200.ns();
              }), this.W.Pa.addEventListener(t.model.sb.kc.yo, function () {
                return _this200.a0();
              }), this.W.Pa.addEventListener(t.model.sb.kc.zo, function () {
                return _this200.LE();
              }), this.W.Pa.addEventListener(t.model.sb.kc.Mm, function () {
                return _this200.G0();
              }), this.W.Pa.addEventListener(t.model.sb.kc.Nm, function () {
                return _this200.rs();
              }), this.W.Pa.addEventListener(t.model.sb.kc.Go, function () {
                return _this200.H0();
              }), this.W.Pa.addEventListener(t.model.sb.kc.SG, function () {
                return _this200.OE();
              }), this.W.Pa.addEventListener(t.model.sb.kc.xl, function () {
                return _this200.f1();
              }), this.W.Pa.addEventListener(t.model.sb.kc.Ye, function () {
                return _this200.Xp();
              }), this.W.Pa.addEventListener(t.model.sb.kc.gk, function () {
                return _this200.bF();
              }), this.W.Pa.addEventListener(t.model.sb.kc.He, function () {
                return _this200.vz();
              }), this.W.addEventListener(s.HA, function () {
                return _this200.k0();
              }), this.W.addEventListener(s.jh, function () {
                return _this200.i0();
              }), this.W.addEventListener(s.VA, function () {
                return _this200.Y0();
              }), this.W.addEventListener(s.vl, function () {
                return _this200.W0();
              }), this.$j = new t.G.xb(i.ia.Ga(o), r), this.$j.addEventListener(t.G.kf.gl, function (t) {
                return _this200.N_(t);
              }), this.$j.addEventListener(t.G.kf.uI, function () {
                return _this200.a1();
              }), this.W.$D(r), this.Yy = !0));
            }
            _createClass(e, [{
              key: "ob",
              get: function get() {
                return this.W && this.W.Pa && this.W.Pa.ob;
              }
            }, {
              key: "gz",
              get: function get() {
                return this.W && this.W.Pa && this.W.Pa.gz;
              }
            }, {
              key: "o2",
              value: function o2() {
                var _this201 = this;
                a.xd(function () {
                  for (; 0 < _this201.XC.length;) _this201.XC.shift().call(_this201);
                }, 1);
              }
            }, {
              key: "nc",
              value: function nc(t) {
                var _e105 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
                0 == _e105 ? this.WC.push(t) : this.XC.push(t);
              }
            }, {
              key: "S0",
              value: function S0() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.Rm));
              }
            }, {
              key: "ZE",
              value: function ZE() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.tl));
              }
            }, {
              key: "Yp",
              value: function Yp() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.Zf));
              }
            }, {
              key: "c1",
              value: function c1() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.Jo));
              }
            }, {
              key: "lv",
              value: function lv() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.li));
              }
            }, {
              key: "b1",
              value: function b1() {
                for (this.W.Pa.Ad == t.model.sb.yl.INIT && a.xd(function () {
                  t.model.xa.V().na(new t.model.ac(t.model.xa.ww));
                }, 1); 0 < this.WC.length;) this.WC.shift().call(this);
              }
            }, {
              key: "G0",
              value: function G0() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.Mm));
              }
            }, {
              key: "rs",
              value: function rs() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.Nm));
              }
            }, {
              key: "H0",
              value: function H0() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.Go));
              }
            }, {
              key: "YE",
              value: function YE() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.Lm));
              }
            }, {
              key: "ns",
              value: function ns() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.Ao));
              }
            }, {
              key: "LE",
              value: function LE() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.zo));
              }
            }, {
              key: "a0",
              value: function a0() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.yo));
              }
            }, {
              key: "OE",
              value: function OE() {}
            }, {
              key: "f1",
              value: function f1() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.xl));
              }
            }, {
              key: "Xp",
              value: function Xp() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.Ye)), t.model.xa.V().na(new t.model.ac(t.model.xa.Dw));
              }
            }, {
              key: "bF",
              value: function bF() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.gk));
              }
            }, {
              key: "vz",
              value: function vz() {}
            }, {
              key: "N_",
              value: function N_(_e106) {
                t.model.xa.V().na(new t.model.ac(t.model.xa.gl, _e106.data));
              }
            }, {
              key: "a1",
              value: function a1() {
                var _this202 = this;
                this.ob && this.W.Pa.Ad != t.model.sb.yl.yg && a.xd(function () {
                  _this202.o2(), _this202.W.Pa.Ad = t.model.sb.yl.yg, t.model.xa.V().na(new t.model.ac(t.model.xa.He));
                }, 1);
              }
            }, {
              key: "k0",
              value: function k0() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.bw));
              }
            }, {
              key: "i0",
              value: function i0() {
                a.xd(function () {
                  t.model.xa.V().na(new t.model.ac(t.model.xa.jh));
                }, 1);
              }
            }, {
              key: "Y0",
              value: function Y0() {
                t.model.xa.V().na(new t.model.ac(t.model.xa.uw));
              }
            }, {
              key: "W0",
              value: function W0() {
                a.xd(function () {
                  t.model.xa.V().na(new t.model.ac(t.model.xa.vl));
                }, 1);
              }
            }, {
              key: "yD",
              value: function yD() {
                return this.ob ? this.W.yD() : null;
              }
            }, {
              key: "ED",
              value: function ED(t) {
                return this.ob ? this.W.ED(t) : null;
              }
            }, {
              key: "ox",
              value: function ox(t) {
                var _this203 = this;
                this.ob ? null != t && this.W.ox(t) : this.nc(function () {
                  return _this203.ox(t);
                });
              }
            }, {
              key: "Kz",
              value: function Kz(t) {
                var _this204 = this;
                this.ob ? this.W.Kz(t) : this.nc(function () {
                  return _this204.Kz(t);
                });
              }
            }, {
              key: "Jz",
              value: function Jz() {
                var _this205 = this;
                this.ob ? this.W.Jz() : this.nc(function () {
                  return _this205.Jz();
                });
              }
            }, {
              key: "open",
              value: function open() {
                this.W.open();
              }
            }, {
              key: "load",
              value: function load(t) {
                this.W.load(t);
              }
            }, {
              key: "Dp",
              value: function Dp(t) {
                return this.W.Dp(t).Sa();
              }
            }, {
              key: "xv",
              value: function xv(_e107) {
                if ("string" == typeof _e107) try {
                  _e107 = JSON.parse(_e107);
                } catch (_e108) {
                  return void t.yc(t.model.v.g.QH, t.model.v.g.wb, t.ld.wb);
                }
                this.W.xv({
                  report: _e107
                });
              }
            }, {
              key: "getData",
              value: function getData(t, _e109, i) {
                var _this206 = this;
                this.ob ? this.W.getData(t, _e109, i) : this.nc(function () {
                  return _this206.getData(t, _e109, i);
                });
              }
            }, {
              key: "save",
              value: function save() {
                var _this207 = this;
                var _e110 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                  filename: "report.json"
                };
                var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
                var a = s;
                this.ob ? (_e110 instanceof Object && _e110.hasOwnProperty("callbackHandler") && (a = _e110.callbackHandler), null != a && "string" == typeof a && (a = t.model.xa.Rr(a)), this.W.save(_e110, i, null != a ? function (t) {
                  return a(t);
                } : null, r, n)) : this.nc(function () {
                  return _this207.save(_e110, i, s, r, n);
                });
              }
            }, {
              key: "dl",
              value: function dl(t, _e111) {
                var _this208 = this;
                null != t && (a.U(_e111) ? _e111 = {
                  partial: !1
                } : "boolean" == typeof _e111 && (_e111 = {
                  partial: _e111
                }), this.gz ? this.W.dl(t, _e111) : this.nc(function () {
                  return _this208.dl(t, _e111);
                }, 0));
              }
            }, {
              key: "zr",
              value: function zr(t) {
                var _this209 = this;
                null != t && (this.gz ? this.W.zr(t) : this.nc(function () {
                  return _this209.zr(t);
                }, 0));
              }
            }, {
              key: "vk",
              value: function vk(t) {
                var _this210 = this;
                this.ob ? null != t && this.W.vk(t) : this.nc(function () {
                  return _this210.vk(t);
                });
              }
            }, {
              key: "fo",
              value: function fo(t) {
                var _this211 = this;
                this.ob ? this.W.fo(t) : this.nc(function () {
                  return _this211.fo(t);
                });
              }
            }, {
              key: "eq",
              value: function eq() {
                var _this212 = this;
                this.ob ? this.W.eq() : this.nc(function () {
                  return _this212.eq();
                });
              }
            }, {
              key: "clear",
              value: function clear() {
                var _this213 = this;
                this.ob ? this.W.clear() : this.nc(function () {
                  return _this213.clear();
                });
              }
            }, {
              key: "la",
              value: function la() {
                a.lg.la(), a.qD.la(), a.$S.la(), this.W.la(), this.$j.la(), this.W = this.$j = null, e.instance = null, t.model.xa.la();
              }
            }, {
              key: "refresh",
              value: function refresh() {
                var _this214 = this;
                this.ob ? this.$j.Ha() : this.nc(function () {
                  return _this214.refresh();
                });
              }
            }, {
              key: "Ux",
              value: function Ux() {
                var _this215 = this;
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                this.ob ? this.W.Ux(t) : this.nc(function () {
                  return _this215.Ux(t);
                });
              }
            }, {
              key: "xp",
              value: function xp(t) {
                var _this216 = this;
                this.ob ? this.W.xp(t) : this.nc(function () {
                  return _this216.xp(t);
                });
              }
            }, {
              key: "Dx",
              value: function Dx() {
                var _this217 = this;
                this.ob ? this.W.Dx() : this.nc(function () {
                  return _this217.Dx();
                });
              }
            }, {
              key: "rp",
              value: function rp(t) {
                var _this218 = this;
                this.ob ? this.W.rp(t) : this.nc(function () {
                  return _this218.rp(t);
                });
              }
            }, {
              key: "print",
              value: function print() {
                var _this219 = this;
                var _e112 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                this.ob ? this.W.print(t.model.ao.qI.Za(_e112)) : this.nc(function () {
                  return _this219.print(_e112);
                });
              }
            }, {
              key: "Aj",
              value: function Aj(_e113) {
                var _this220 = this;
                var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                if (this.ob) {
                  if (null != _e113) {
                    null != s && "string" == typeof s && (s = t.model.xa.Rr(s));
                    var r = null != s ? function () {
                      for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                        t[_key4] = arguments[_key4];
                      }
                      return s.apply(null, t);
                    } : null;
                    this.W.Aj(_e113, t.model.Pd.ZG.Za(i), r);
                  }
                } else this.nc(function () {
                  return _this220.Aj(_e113, i, s);
                });
              }
            }, {
              key: "ID",
              value: function ID(t) {
                return this.ob ? this.W.ID(t) : null;
              }
            }, {
              key: "JD",
              value: function JD(t) {
                return this.ob ? this.W.JD(t) : null;
              }
            }, {
              key: "wv",
              value: function wv(t, _e114) {
                var _this221 = this;
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                this.ob ? this.W.wv(t, _e114, i) : this.nc(function () {
                  return _this221.wv(t, _e114, i);
                });
              }
            }, {
              key: "vn",
              value: function vn(t) {
                var _this222 = this;
                this.ob ? this.W.vn(t) : this.nc(function () {
                  return _this222.vn(t);
                });
              }
            }, {
              key: "TN",
              value: function TN(_e115, i) {
                "string" == typeof i && (i = t.model.xa.Rr(i)), t.model.xa.V().addEventListener(_e115, i);
              }
            }, {
              key: "E_",
              value: function E_(_e116, i) {
                "string" == typeof i && (i = t.model.xa.Rr(i)), null == i ? t.model.xa.V().Rc(_e116) : t.model.xa.V().removeEventListener(_e116, i);
              }
            }, {
              key: "Ru",
              value: function Ru() {
                return this.ob ? this.W.Ru() : null;
              }
            }, {
              key: "Ku",
              value: function Ku() {
                return this.ob ? this.W.Ku() : null;
              }
            }, {
              key: "Qu",
              value: function Qu() {
                return this.ob ? this.W.Qu() : null;
              }
            }, {
              key: "Pu",
              value: function Pu() {
                return this.ob ? this.W.Pu() : null;
              }
            }, {
              key: "Gn",
              value: function Gn() {
                return this.ob ? this.W.Gn() : null;
              }
            }, {
              key: "dA",
              value: function dA(t, _e117, i, s) {
                var _this223 = this;
                this.ob ? this.W.dA(t, _e117, i, s) : this.nc(function () {
                  return _this223.dA(t, _e117, i, s);
                });
              }
            }, {
              key: "jo",
              value: function jo(t, _e118) {
                var _this224 = this;
                this.ob ? this.W.jo(t, _e118) : this.nc(function () {
                  return _this224.jo(t, _e118);
                });
              }
            }, {
              key: "PD",
              value: function PD(t) {
                return this.ob ? this.W.PD(t) : null;
              }
            }, {
              key: "zv",
              value: function zv(t, _e119, i) {
                var _this225 = this;
                this.ob ? this.W.zv(t, _e119, i) : this.nc(function () {
                  return _this225.zv(t, _e119, i);
                });
              }
            }, {
              key: "uv",
              value: function uv(t, _e120, i) {
                var _this226 = this;
                this.ob ? this.W.uv(t, _e120, i) : this.nc(function () {
                  return _this226.uv(t, _e120, i);
                });
              }
            }, {
              key: "Cp",
              value: function Cp() {
                return this.ob ? this.W.Cp() : null;
              }
            }, {
              key: "Uj",
              value: function Uj(t) {
                var _this227 = this;
                this.ob ? this.W.Uj(t) : this.nc(function () {
                  return _this227.Uj(t);
                });
              }
            }, {
              key: "Ay",
              value: function Ay(_e121, i, s) {
                var _this228 = this;
                if (this.ob) return "string" == typeof s && (s = t.model.xa.Rr(s)), this.W.Ay(_e121, i, s);
                this.nc(function () {
                  return _this228.Ay(_e121, i, s);
                });
              }
            }, {
              key: "Qz",
              value: function Qz(_e122) {
                var _this229 = this;
                this.ob ? null != _e122 && this.W.Qz(t.model.kb.Kh.Za(_e122)) : this.nc(function () {
                  return _this229.Qz(_e122);
                });
              }
            }, {
              key: "Gu",
              value: function Gu() {
                return this.ob ? this.W.Gu() : null;
              }
            }, {
              key: "Lz",
              value: function Lz(t) {
                var _this230 = this;
                this.ob ? this.W.Lz(t) : this.nc(function () {
                  return _this230.Lz(t);
                });
              }
            }, {
              key: "Ne",
              value: function Ne(t) {
                return this.ob ? this.W.Ne(t) : null;
              }
            }, {
              key: "jq",
              value: function jq(t, _e123) {
                var _this231 = this;
                this.ob ? null != t && this.W.jq(t, _e123) : this.nc(function () {
                  return _this231.jq(t, _e123);
                });
              }
            }, {
              key: "Ld",
              value: function Ld(t, _e124) {
                return this.ob ? this.$j.Ld(t, _e124) : null;
              }
            }, {
              key: "Su",
              value: function Su() {
                return this.ob ? this.$j.Su() : null;
              }
            }, {
              key: "Is",
              value: function Is(t, _e125) {
                var _this232 = this;
                this.ob ? this.$j.Is(t, _e125) : this.nc(function () {
                  return _this232.Is(t, _e125);
                });
              }
            }, {
              key: "ws",
              value: function ws() {
                var _this233 = this;
                this.ob ? this.$j.ws() : this.nc(function () {
                  return _this233.ws();
                });
              }
            }, {
              key: "nv",
              value: function nv() {
                var _this234 = this;
                this.Yy ? this.$j.nv() : this.nc(function () {
                  return _this234.nv();
                });
              }
            }, {
              key: "Cx",
              value: function Cx() {
                var _this235 = this;
                this.Yy ? this.$j.Cx() : this.nc(function () {
                  return _this235.Cx();
                });
              }
            }, {
              key: "LW",
              value: function LW(_e126) {
                t.G.N.C.ad.tp = _e126, this.Yy && this.refresh();
              }
            }]);
            return e;
          }();
          e.oA = "Version 1.4.14", e.aQ = "104208971903700", t.Um = e;
          var s = /*#__PURE__*/_createClass(function s() {
            _classCallCheck(this, s);
          });
          s.VA = "print", s.vl = "printcomplete", s.HA = "export", s.jh = "exportcomplete", t.Eg = s;
        }(r || (r = {})), this.PivotApi = function (t) {
          var e = {
              version: r.Um.oA
            },
            i = new r.Um(t, e);
          if (e.getAllConditions = function () {
            return i.yD();
          }, e.getCondition = function (t) {
            return i.ED(t);
          }, e.addCondition = function (t) {
            return i.ox(t);
          }, e.removeCondition = function (t) {
            return i.Kz(t);
          }, e.removeAllConditions = function () {
            return i.Jz();
          }, e.open = function () {
            return i.open();
          }, e.load = function (t) {
            return i.load(t);
          }, e.getReport = function (t) {
            return i.Dp(t);
          }, e.setReport = function (t) {
            return i.xv(t);
          }, e.getData = function (t, e, s) {
            return i.getData(t, e, s);
          }, e.save = function () {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
              filename: "report.json"
            };
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
            return i.save(t, e, s, r, n);
          }, e.updateData = function (t, e) {
            return i.dl(t, e);
          }, e.connectTo = function (t) {
            return i.zr(t);
          }, e.addCalculatedMeasure = function (t) {
            return i.vk(t);
          }, e.removeCalculatedMeasure = function (t) {
            return i.fo(t);
          }, e.removeAllCalculatedMeasures = function () {
            return i.eq();
          }, e.clear = function () {
            return i.clear();
          }, e.dispose = function () {
            i.la();
          }, e.refresh = function () {
            return i.refresh();
          }, e.expandAllData = function () {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            return i.Ux(t);
          }, e.expandData = function (t) {
            return i.xp(t);
          }, e.collapseAllData = function () {
            return i.Dx();
          }, e.collapseData = function (t) {
            return i.rp(t);
          }, e.print = function () {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            return i.print(t);
          }, e.exportTo = function (t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            return i.Aj(t, e, s);
          }, e.getFilter = function (t) {
            return i.ID(t);
          }, e.getFilterProperties = function (t) {
            return i.JD(t);
          }, e.setFilter = function (t, e) {
            var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
            return i.wv(t, e, s);
          }, e.clearFilter = function (t) {
            return i.vn(t);
          }, e.runQuery = function (t) {
            return i.Qz(t);
          }, e.on = function (t, e) {
            return i.TN(t, e);
          }, e.off = function (t, e) {
            return i.E_(t, e);
          }, e.getRows = function () {
            return i.Ru();
          }, e.getColumns = function () {
            return i.Ku();
          }, e.getReportFilters = function () {
            return i.Qu();
          }, e.getMeasures = function () {
            return i.Pu();
          }, e.getAllMeasures = function () {
            return i.Gn();
          }, e.sortValues = function (t, e, s, r) {
            return i.dA(t, e, s, r);
          }, e.setSort = function (t, e) {
            return i.jo(t, e);
          }, e.getSort = function (t) {
            return i.PD(t);
          }, e.setTopX = function (t, e, s) {
            return i.zv(t, e, s);
          }, e.setBottomX = function (t, e, s) {
            return i.uv(t, e, s);
          }, e.getOptions = function () {
            return i.Cp();
          }, e.setOptions = function (t) {
            return i.Uj(t);
          }, e.getMembers = function (t, e, s) {
            return i.Ay(t, e, s);
          }, e.getAllHierarchies = function () {
            return i.Gu();
          }, e.replaceHierarchyCaption = function (t) {
            return i.Lz(t);
          }, e.getFormat = function (t) {
            return i.Ne(t);
          }, e.setFormat = function (t, e) {
            return i.jq(t, e);
          }, e.getCell = function (t, e) {
            return i.Ld(t, e);
          }, e.getSelectedCell = function () {
            return i.Su();
          }, e.setSelectedCell = function (t, e) {
            return i.Is(t, e);
          }, e.removeSelection = function () {
            return i.ws();
          }, e.openFieldsList = function () {
            return i.nv();
          }, e.closeFieldsList = function () {
            return i.Cx();
          }, e.customizeCell = function (t) {
            return i.LW(t);
          }, void 0 !== window.WebDataRocksHighcharts) for (var s in e.highcharts = {
            instance: e
          }, window.WebDataRocksHighcharts) e.highcharts[s] = window.WebDataRocksHighcharts[s];
          if (void 0 !== window.WebDataRocksFusioncharts) for (s in e.fusioncharts = {
            instance: e
          }, window.WebDataRocksFusioncharts) e.fusioncharts[s] = window.WebDataRocksFusioncharts[s];
          if (void 0 !== window.WebDataRocksGooglecharts) for (s in e.googlecharts = {
            instance: e
          }, window.WebDataRocksGooglecharts) e.googlecharts[s] = window.WebDataRocksGooglecharts[s];
          if (void 0 !== window.WebDataRocksAmcharts) for (s in e.amcharts = {
            instance: e
          }, window.WebDataRocksAmcharts) e.amcharts[s] = window.WebDataRocksAmcharts[s];
          return window.webdatarocks = e;
        }, this.PivotApi(t);
      };
    }) ? n.apply(e, a) : n) || (t.exports = o), h.WebDataRocks = l();
    var A = function A(t, e, i, s, r) {
      this.pivot = e, this.pivotContainer = t, this.width = "number" == typeof s || 0 > s.indexOf("px") && 0 > s.indexOf("%") ? s + "px" : s, this.Labels = r;
    };
    A.prototype.getTabs = function () {
      var t = [],
        e = this.Labels;
      return t.push({
        title: e.connect,
        id: "wdr-tab-connect",
        icon: this.icons.connect,
        menu: [{
          title: e.connect_local_csv,
          id: "wdr-tab-connect-local-csv",
          handler: this.connectLocalCSVHandler,
          mobile: !1,
          icon: this.icons.connect_csv
        }, {
          title: e.connect_local_json,
          id: "wdr-tab-connect-local-json",
          handler: this.connectLocalJSONHandler,
          mobile: !1,
          icon: this.icons.connect_json
        }, {
          title: this.osUtils.isMobile ? e.connect_remote_csv_mobile : e.connect_remote_csv,
          id: "wdr-tab-connect-remote-csv",
          handler: this.connectRemoteCSV,
          icon: this.icons.connect_csv
        }, {
          title: this.osUtils.isMobile ? e.connect_remote_json_mobile : e.connect_remote_json,
          id: "wdr-tab-connect-remote-json",
          handler: this.connectRemoteJSON,
          icon: this.icons.connect_json
        }]
      }), t.push({
        title: e.open,
        id: "wdr-tab-open",
        icon: this.icons.open,
        menu: [{
          title: e.local_report,
          id: "wdr-tab-open-local-report",
          handler: this.openLocalReport,
          mobile: !1,
          icon: this.icons.open_local
        }, {
          title: this.osUtils.isMobile ? e.remote_report_mobile : e.remote_report,
          id: "wdr-tab-open-remote-report",
          handler: this.openRemoteReport,
          icon: this.icons.open_remote
        }]
      }), t.push({
        title: e.save,
        id: "wdr-tab-save",
        handler: this.saveHandler,
        mobile: !1,
        icon: this.icons.save
      }), t.push({
        title: e.export,
        id: "wdr-tab-export",
        mobile: !1,
        icon: this.icons.export,
        menu: [{
          title: e.export_print,
          id: "wdr-tab-export-print",
          handler: this.printHandler,
          icon: this.icons.export_print
        }, {
          title: e.export_html,
          id: "wdr-tab-export-html",
          handler: this.exportHandler,
          args: "html",
          icon: this.icons.export_html
        }, {
          title: e.export_excel,
          id: "wdr-tab-export-excel",
          handler: this.exportHandler,
          args: "excel",
          icon: this.icons.export_excel
        }, {
          title: e.export_pdf,
          id: "wdr-tab-export-pdf",
          handler: this.exportHandler,
          args: "pdf",
          icon: this.icons.export_pdf
        }]
      }), t.push({
        title: e.format,
        id: "wdr-tab-format",
        icon: this.icons.format,
        rightGroup: !0,
        menu: [{
          title: this.osUtils.isMobile ? e.format_cells_mobile : e.format_cells,
          id: "wdr-tab-format-cells",
          handler: this.formatCellsHandler,
          icon: this.icons.format_number
        }, {
          title: this.osUtils.isMobile ? e.conditional_formatting_mobile : e.conditional_formatting,
          id: "wdr-tab-format-conditional",
          handler: this.conditionalFormattingHandler,
          icon: this.icons.format_conditional
        }]
      }), t.push({
        title: e.options,
        id: "wdr-tab-options",
        handler: this.optionsHandler,
        icon: this.icons.options,
        rightGroup: !0
      }), t.push({
        title: e.fields,
        id: "wdr-tab-fields",
        handler: this.fieldsHandler,
        icon: this.icons.fields,
        rightGroup: !0
      }), null != document.addEventListener && t.push({
        title: e.fullscreen,
        id: "wdr-tab-fullscreen",
        handler: this.fullscreenHandler,
        mobile: !1,
        icon: this.icons.fullscreen,
        rightGroup: !0
      }), t;
    }, A.prototype.create = function () {
      this.popupManager = new A.PopupManager(this), this.dataProvider = this.getTabs(), this.init();
    }, A.prototype.applyToolbarLayoutClasses = function () {
      if (!this.osUtils.isMobile) {
        var t = this,
          e = function e() {
            if (t.toolbarWrapper) {
              var e = t.toolbarWrapper.getBoundingClientRect().width;
              t.toolbarWrapper.classList.remove("wdr-layout-500"), t.toolbarWrapper.classList.remove("wdr-layout-360"), t.toolbarWrapper.classList.remove("wdr-layout-300"), 500 > e && t.toolbarWrapper.classList.add("wdr-layout-500"), 360 > e && t.toolbarWrapper.classList.add("wdr-layout-360"), 300 > e && t.toolbarWrapper.classList.add("wdr-layout-300");
            }
          };
        e(), window.addEventListener("resize", e);
      }
    }, A.prototype.init = function () {
      this.container = this.pivotContainer, this.container.style.position = "" == this.container.style.position ? "relative" : this.container.style.position, this.toolbarWrapper = document.createElement("div"), this.toolbarWrapper.id = "wdr-toolbar-wrapper", this.toolbarWrapper.style.width = this.width, this.osUtils.isMobile && this.addClass(this.toolbarWrapper, "wdr-mobile"), this.addClass(this.toolbarWrapper, "wdr-toolbar-ui"), this.toolbarWrapper.style.width = this.width;
      var t = document.createElement("ul");
      t.id = "wdr-toolbar";
      var e = document.createElement("div");
      e.classList.add("wdr-toolbar-group-right"), t.appendChild(e);
      for (var i = 0; i < this.dataProvider.length; i++) if (!this.isDisabled(this.dataProvider[i])) if (this.osUtils.isMobile && null != this.dataProvider[i].menu && 1 != this.dataProvider[i].collapse) for (var s = 0; s < this.dataProvider[i].menu.length; s++) this.isDisabled(this.dataProvider[i].menu[s]) || t.appendChild(this.createTab(this.dataProvider[i].menu[s]));else s = this.dataProvider[i].divider ? this.createDivider(this.dataProvider[i]) : this.createTab(this.dataProvider[i]), e && this.dataProvider[i].rightGroup ? e.appendChild(s) : t.appendChild(s);
      this.toolbarWrapper.appendChild(t), this.container.insertBefore(this.toolbarWrapper, this.container.firstChild), this.updateLabels(this.Labels), this.applyToolbarLayoutClasses();
    }, A.prototype.updateLabels = function (t) {
      t = this.Labels = t, this.setText(document.querySelector("#wdr-tab-connect > a > span"), t.connect), this.setText(document.querySelector("#wdr-tab-connect-local-csv > a > span"), t.connect_local_csv), this.setText(document.querySelector("#wdr-tab-connect-local-json > a > span"), t.connect_local_json), this.setText(document.querySelector("#wdr-tab-connect-remote-csv > a > span"), this.osUtils.isMobile ? t.connect_remote_csv_mobile : t.connect_remote_csv), this.setText(document.querySelector("#wdr-tab-open > a > span"), t.open), this.setText(document.querySelector("#wdr-tab-open-local-report > a > span"), t.local_report), this.setText(document.querySelector("#wdr-tab-open-remote-report > a > span"), this.osUtils.isMobile ? t.remote_report_mobile : t.remote_report), this.setText(document.querySelector("#wdr-tab-save > a > span"), t.save), this.setText(document.querySelector("#wdr-tab-format > a > span"), t.format), this.setText(document.querySelector("#wdr-tab-format-cells > a > span"), this.osUtils.isMobile ? t.format_cells_mobile : t.format_cells), this.setText(document.querySelector("#wdr-tab-format-conditional > a > span"), this.osUtils.isMobile ? t.conditional_formatting_mobile : t.conditional_formatting), this.setText(document.querySelector("#wdr-tab-options > a > span"), t.options), this.setText(document.querySelector("#wdr-tab-fullscreen > a > span"), t.fullscreen), this.setText(document.querySelector("#wdr-tab-export > a > span"), t.export), this.setText(document.querySelector("#wdr-tab-export-print > a > span"), t.export_print), this.setText(document.querySelector("#wdr-tab-export-html > a > span"), t.export_html), this.setText(document.querySelector("#wdr-tab-export-excel > a > span"), t.export_excel), this.setText(document.querySelector("#wdr-tab-export-pdf > a > span"), t.export_pdf), this.setText(document.querySelector("#wdr-tab-fields > a > span"), t.fields);
    }, A.prototype.icons = {
      connect: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="-305.5 396.5 36 36"><path fill="#555" d="M-274.5 425.409s-.988.277-1.422.761l-3.536-1.783c.189-.509.258-1.066.07-1.572l3.719-1.76a2.36 2.36 0 0 0 3.317.147 2.341 2.341 0 0 0 .157-3.3 2.335 2.335 0 0 0-4.055 1.582c-.009.122-.008.237.001.358l-3.896 1.884a2.281 2.281 0 0 0-1.359-.451 2.338 2.338 0 0 0-2.177 2.481 2.33 2.33 0 0 0 2.177 2.179c.491 0 .967-.156 1.359-.451l3.921 1.892a2.317 2.317 0 0 0 1.981 2.604 2.316 2.316 0 0 0 2.604-1.981c.171-1.269-1-2.432-2.262-2.603a8.794 8.794 0 0 0-.6-.026v.039zM-301.592 413.883c-.008.105-.908.222.092.326v6.836c0 2.587 5.827 5.455 13.177 5.455h1.081c-1.146-3 .303-6.854 3.299-8.155-1.448.172-2.868.069-4.334.069-7.056.009-12.775-2.093-13.315-4.531z"/><path fill="#555" d="M-288.5 416.217c7.377 0 13-2.097 13-4.683v-6.853c0-2.586-5.647-4.682-13-4.682-7.352 0-13 2.104-13 4.69v6.853c0 2.586 5.648 4.675 13 4.675zm.177-15.268c5.903 0 10.691 1.661 10.691 3.741s-4.796 3.741-10.691 3.741c-5.894 0-10.683-1.67-10.683-3.741 0-2.072 4.79-3.741 10.683-3.741z"/></svg>',
      connect_csv: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M11 24l6 0V27h-6V24z"/><path d="M12.8 22L12.8 22l1.2-2.5L15.1 22h1.9l-2-3.9L16.9 14h-1.8l-1 2.5L12.9 14h-1.8l1.9 3.9L11 22H12.8z"/><path d="M19 19h6v3h-6V19z"/><path d="M19 14h6v3L19 17V14z"/><path d="M19 24h6v3h-6V24z"/><path d="M23 4H7v28h22V11L23 4zM8 31V5h14v7h6v19H8L8 31z"/></svg>',
      connect_json: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M23 4H7v28h22V11L23 4zM8 31V5h14v7h6v19H8L8 31z"/><path d="M19 24c0 0.6-0.4 1-1 1 -0.6 0-1-0.4-1-1v-2c0-0.6 0.4-1 1-1 0.6 0 1 0.4 1 1V24zM21 18v-2c0-0.6-0.4 0-1 0 -0.6 0-1-0.4-1-1 0-0.6 0.4-1 1-1 1.7 0 3 0.3 3 2v2c0 1.1 0.9 2 2 2 0.6 0 1 0.4 1 1 0 0.6-0.4 1-1 1 -1.1 0-2 0.9-2 2v2c0 1.7-1.3 2-3 2 -0.6 0-1-0.4-1-1s0.4-1 1-1c0.6 0 1 0.6 1 0v-2c0-1.2 0.5-2.3 1.4-3C21.5 20.3 21 19.2 21 18zM11 20c1.1 0 2-0.9 2-2v-2c0-1.7 1.3-2 3-2 0.6 0 1 0.4 1 1 0 0.6-0.4 1-1 1 -0.6 0-1-0.6-1 0v2c0 1.2-0.5 2.3-1.4 3 0.8 0.7 1.4 1.8 1.4 3v2c0 0.6 0.4 0 1 0 0.6 0 1 0.4 1 1s-0.4 1-1 1c-1.7 0-3-0.3-3-2v-2c0-1.1-0.9-2-2-2 -0.6 0-1-0.4-1-1C10 20.4 10.4 20 11 20z"/><path d="M18 17c0.6 0 1 0.4 1 1s-0.4 1-1 1 -1-0.4-1-1S17.4 17 18 17z"/></svg>',
      open: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="-305.5 396.5 36 36"><path fill="#555" d="M-279.351 408.5h8.976c.064 0 .126-.067.167-.025.021.052.021.055 0 .107l-2.053 20.701c-.01.117-.104.217-.219.217h-30.102c-.116 0-.21-.104-.221-.22l-1.989-16.009c-.022-.041-.022.124 0 .083.042-.054.115.146.178.146h21.198c.87 0 1.665-.726 2.053-1.499l1.812-3.446a.414.414 0 0 1 .2-.055zm-4.052 2.473c.084-.011.162-.052.194-.126l1.813-3.288c.408-.754 1.196-1.059 2.054-1.059h7.842v-2.637c0-1.102-.83-2.166-1.929-2.25-.053 0-.183-.113-.235-.113h-18.328c-.104 0-.188.006-.241-.09.01-1.1-.858-1.91-1.958-1.91h-6.902c-1.226 0-2.406.864-2.406 2.089v9.426l20.096-.042z"/></svg>',
      open_local: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><style>.a{fill:none;}</style><path d="M30.9 10.6C30.8 10.4 30.2 10 30 10h-1V8c0-0.4-0.6-1-1-1H15l-1-2H8C7.6 5 7 5.6 7 6v4H6c-0.2 0-0.8 0.4-0.9 0.6 -0.1 0.1-0.2 0.3-0.1 0.5l2.1 19.5C7.2 30.8 7.7 31 8 31h20c0.3 0 0.8-0.2 0.9-0.5l2.1-19.5C31 10.9 31 10.7 30.9 10.6zM28 30H8L6 11h24L28 30z"/><line x1="11" y1="23" x2="11" y2="23" class="a"/><line x1="25" y1="23" x2="25" y2="23" class="a"/><polygon points="11 15 11 23 17 23 17 25 14 25 14 26 22 26 22 25 19 25 19 23 25 23 25 15 "/></svg>',
      open_remote: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M30.9 10.6C30.8 10.4 30.2 10 30 10h-1V8c0-0.4-0.6-1-1-1H15l-1-2H8C7.6 5 7 5.6 7 6v4H6c-0.2 0-0.8 0.4-0.9 0.6 -0.1 0.1-0.2 0.3-0.1 0.5l2.1 19.5C7.2 30.8 7.7 31 8 31h20c0.3 0 0.8-0.2 0.9-0.5l2.1-19.5C31 10.9 31 10.7 30.9 10.6zM28 30H8L6 11h24L28 30z"/><path d="M24.8 18.1l-0.8 1.5c-0.2 0.2-0.5 0.2-0.8 0 -1.3-1.2-3.2-1.9-5.3-1.9 -2.1 0-4 0.7-5.3 1.9 -0.2 0.2-0.5 0.2-0.8 0l-0.8-1.5c-0.1-0.1-0.2-0.2-0.2-0.3 0-0.1 0.1-0.2 0.2-0.3 1.7-1.5 4.1-2.5 6.8-2.5 2.7 0 5.1 0.9 6.8 2.5 0.1 0 0.2 0.2 0.2 0.3C25 17.9 24.9 18 24.8 18.1zM18 19.6c1.5 0 2.8 0.5 3.8 1.4 0.2 0.2 0.2 0.5 0 0.7l-0.8 1.5c-0.2 0.2-0.5 0.2-0.8 0 -0.6-0.5-1.4-0.8-2.3-0.8 -0.9 0-1.7 0.3-2.3 0.8 -0.2 0.2-0.5 0.2-0.8 0l-0.8-1.5c-0.2-0.2-0.2-0.5 0-0.7C15.2 20.1 16.5 19.6 18 19.6zM18 23.4c0.8 0 1.4 0.6 1.4 1.3 0 0.7-0.6 1.3-1.4 1.3 -0.8 0-1.4-0.6-1.4-1.3C16.6 24 17.2 23.4 18 23.4z"/></svg>',
      save: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="-17.5 774.5 36 36"><g fill="#555"><path d="M15.191 783.284l-5.457-5.467a1.101 1.101 0 0 0-.781-.317h-.835c-.2 0-.618.163-.618.363v8.889c0 .618-.245.748-.853.748H-5.638c-.617 0-.862-.14-.862-.748v-8.889c0-.2-.409-.363-.609-.363h-6.283c-.618 0-1.108.499-1.108 1.107v27.785c0 .617.5 1.107 1.108 1.107h27.784c.618 0 1.108-.499 1.108-1.107v-22.337c0-.29-.109-.562-.309-.771zM8.98 801.463c0 .618-.499 1.037-1.107 1.037H-6.873c-.617 0-.627-.357-.627-.966v-8.626c0-.617.019-1.408.627-1.408H7.882c.618 0 1.108.613 1.108 1.223l-.01 8.74z"/><path d="M-4.167 784.5h9.361c.2 0 .306.228.306.028v-6.665c0-.2-.106-.363-.306-.363h-9.361c-.2 0-.333.163-.333.363v6.665c0 .191.124-.028.333-.028zm5.667-4.294c0-.618.392-1.108 1-1.108.618 0 1 .5 1 1.108v1.97c0 .618-.392 1.108-1 1.108-.618 0-1-.5-1-1.108v-1.97zM4.168 796.5h-7.31c-.617 0-1.108.393-1.108 1s.5 1 1.108 1h7.31c.617 0 1.107-.393 1.107-1s-.498-1-1.107-1z"/></g></svg>',
      export: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="-17.5 774.5 36 36"><g fill="#555"><path d="M15.446 795.615l-4.289-6.461c-.346-.515-.803-.654-1.428-.654H7.788c-.186 0-.346-.029-.363.156-.008.076.017.07.059.137l4.76 7.108c.042.06.034.337-.017.38-.025.025-.067.219-.102.219H6.699c-.194 0-.354-.063-.363.125-.305 3.23-3.174 5.495-6.407 5.192-2.81-.263-5.039-2.329-5.3-5.14-.009-.195-.168-.178-.363-.178h-5.401c-.076 0-.144-.281-.144-.357 0-.025.008-.157.017-.175l4.76-7.203c.102-.16.05-.245-.109-.347-.06-.035-.118.082-.187.082h-1.94c-.616 0-1.199.145-1.553.658l-4.664 6.547c-.203.304-.545.586-.545.95v9.216c1 .911 1.267 1.646 2.187 1.629h27.625c.903.009 1.188-.709 1.188-1.611v-9.233c1-.373.157-.735-.054-1.04z"/><path d="M-3.674 783.5H-2.5v10.2c1 1.4 1.764 2.464 3.165 2.371 1.274-.083 1.835-1.097 2.835-2.371v-10.2h1.207c.346 0 .641-.04.65-.387.008-.151-.042-.193-.144-.311l-4.186-5.11c-.228-.287-.642-.302-.929-.073-.042.034-.076.081-.101.115l-4.135 5.172c-.22.271-.187.447.084.668.11.085.244-.074.38-.074z"/></g></svg>',
      export_print: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="-17.5 774.5 36 36"><path fill="#555" d="M-5.5 798.685v3.815h11v-7h-11v3.185zm2-1.185h7v1h-7v-1zm0 2h7v1h-7v-1zM5.5 786.308V782.5h-11v7h11z"/><path fill="#555" d="M8.94 786.5H7.5v4h-14v-4h-1.44c-1.493 0-2.56 1.064-2.56 2.558v6.87c0 1.493 1.067 2.572 2.56 2.572h1.44v-4h14v4h1.44c1.493 0 2.56-1.064 2.56-2.557v-6.878c0-1.501-1.074-2.565-2.56-2.565z"/></svg>',
      export_excel: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M24.4 15h-3.8L18 18.6 15.3 15h-3.8l4.5 5.2L11 27h7.3L18 25h-2l2-3L21.1 27H25l-5.1-6.8L24.4 15z"/><path d="M23 4H7v28h22V11L23 4zM8 31V5h14v7h6v19H8L8 31z"/></svg>',
      export_html: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M25.7 20.8l-2.3-2.5c-0.2-0.2-0.4-0.3-0.6-0.3 -0.2 0-0.4 0.1-0.6 0.3 -0.3 0.4-0.3 1 0 1.4l1.7 1.9 -1.7 1.9c-0.2 0.2-0.3 0.4-0.3 0.7 0 0.3 0.1 0.5 0.3 0.7 0.2 0.2 0.4 0.3 0.6 0.3 0.2 0 0.4-0.1 0.6-0.3l2.3-2.5C26.1 21.8 26.1 21.2 25.7 20.8z"/><path d="M14 24c0-0.3-0.1-0.5-0.3-0.7l-1.7-1.9 1.7-1.9c0.3-0.4 0.3-1 0-1.4 -0.2-0.2-0.4-0.3-0.6-0.3 -0.2 0-0.4 0.1-0.6 0.3l-2.3 2.5c-0.3 0.4-0.3 1 0 1.4l2.3 2.5c0.2 0.2 0.4 0.3 0.6 0.3 0.2 0 0.4-0.1 0.6-0.3C13.9 24.5 14 24.3 14 24z"/><path d="M20.4 15.1c-0.1 0-0.2-0.1-0.3-0.1 -0.4 0-0.8 0.3-0.9 0.6l-4.1 11.1c-0.1 0.2-0.1 0.5 0 0.7 0.1 0.2 0.3 0.4 0.5 0.5C15.7 28 15.8 28 16 28c0.4 0 0.8-0.3 0.9-0.6l4.1-11.1C21.1 15.8 20.9 15.2 20.4 15.1z"/><path d="M23 4H7v28h22V11L23 4zM8 31V5h14v7h6v19H8L8 31z"/></svg>',
      export_pdf: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M17.2 17.1L17.2 17.1C17.3 17.1 17.3 17.1 17.2 17.1c0.1-0.5 0.2-0.7 0.2-1V15.8c0.1-0.6 0.1-1 0-1.1 0 0 0 0 0-0.1l-0.1-0.1 0 0 0 0c0 0 0 0.1-0.1 0.1C16.9 15.2 16.9 16 17.2 17.1L17.2 17.1zM13.8 24.8c-0.2 0.1-0.4 0.2-0.6 0.3 -0.8 0.7-1.3 1.5-1.5 1.8l0 0 0 0 0 0C12.5 26.9 13.1 26.2 13.8 24.8 13.9 24.8 13.9 24.8 13.8 24.8 13.9 24.8 13.8 24.8 13.8 24.8zM24.1 23.1c-0.1-0.1-0.6-0.5-2.1-0.5 -0.1 0-0.1 0-0.2 0l0 0c0 0 0 0 0 0.1 0.8 0.3 1.6 0.6 2.1 0.6 0.1 0 0.1 0 0.2 0l0 0h0.1c0 0 0 0 0-0.1l0 0C24.2 23.3 24.1 23.3 24.1 23.1zM24.6 24c-0.2 0.1-0.6 0.2-1 0.2 -0.9 0-2.2-0.2-3.4-0.8 -1.9 0.2-3.4 0.5-4.5 0.9 -0.1 0-0.1 0-0.2 0.1 -1.3 2.4-2.5 3.5-3.4 3.5 -0.2 0-0.3 0-0.4-0.1l-0.6-0.3v-0.1c-0.1-0.2-0.1-0.3-0.1-0.6 0.1-0.6 0.8-1.6 2.1-2.4 0.2-0.1 0.6-0.3 1-0.6 0.3-0.6 0.7-1.2 1.1-2 0.6-1.1 0.9-2.3 1.2-3.3l0 0c-0.4-1.4-0.7-2.1-0.2-3.7 0.1-0.5 0.4-0.9 0.9-0.9h0.2c0.2 0 0.4 0.1 0.7 0.2 0.8 0.8 0.4 2.6 0 4.1 0 0.1 0 0.1 0 0.1 0.4 1.2 1.1 2.3 1.8 2.9 0.3 0.2 0.6 0.5 1 0.7 0.6 0 1-0.1 1.5-0.1 1.3 0 2.2 0.2 2.6 0.8 0.1 0.2 0.1 0.5 0.1 0.7C24.9 23.5 24.8 23.8 24.6 24zM17.3 19.6c-0.2 0.8-0.7 1.7-1.1 2.7 -0.2 0.5-0.4 0.8-0.7 1.2h0.1 0.1l0 0c1.5-0.6 2.8-0.9 3.7-1 -0.2-0.1-0.3-0.2-0.4-0.3C18.4 21.6 17.7 20.7 17.3 19.6z"/><path d="M23 4H7v28h22V11L23 4zM8 31V5h14v7h6v19H8L8 31z"/></svg>',
      format: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="-17.5 774.5 36 36"><g fill="#555"><path d="M15.144 781.92a7.62 7.62 0 0 0-4.238-4.157 4.634 4.634 0 0 0-1.201-.254.99.99 0 0 0-.906.36l-10.797 10.829c-1.462 1.462-2.916 2.908-4.37 4.378a1.347 1.347 0 0 0-.326.596c-.481 2.197-.939 4.402-1.413 6.607a.639.639 0 0 0 .792.793l6.551-1.381c.253-.049.49-.171.67-.359 5.063-5.08 10.127-10.144 15.19-15.207.237-.229.384-.548.4-.882a8.491 8.491 0 0 0-.352-1.323zm-16.825 16.652l-2.54.531a2.367 2.367 0 0 0-1.911-1.87c.18-.906.384-1.813.571-2.729a2.05 2.05 0 0 1 1.078.229 6.007 6.007 0 0 1 2.671 2.605c.139.318.245.653.311.996 0 .157 0 .157-.18.238z"/><path d="M6.568 804.5H-11.5v-18h7.761l1.83-2.118 1.593-1.882h-12.455c-.947 0-1.729 1.241-1.729 2.18v21.097c0 .947.77 1.724 1.726 1.724H8.283c.947 0 2.217-.769 2.217-1.724v-12.488l-4 3.438v7.773h.068z"/></g></svg>',
      format_number: '<svg xmlns="http://www.w3.org/2000/svg" width="52" height="36" viewBox="0 0 52 36"><path d="M31 19.2v-3.4l2.5-0.4c0.2-0.7 0.5-1.4 0.9-2.1l-1.4-2 2.4-2.4 2 1.4c0.7-0.4 1.4-0.7 2.1-0.9l0.4-2.5h3.4l0.4 2.5c0.7 0.2 1.4 0.5 2.1 0.9l2-1.4 2.4 2.4 -1.4 2c0.4 0.7 0.7 1.4 0.9 2.1L52 15.8v3.4l-2.5 0.4c-0.2 0.7-0.5 1.4-0.9 2.1l1.4 2 -2.4 2.4 -2-1.5c-0.7 0.4-1.4 0.7-2.1 0.9l-0.4 2.5h-3.4l-0.4-2.5c-0.7-0.2-1.4-0.5-2.1-0.9l-2 1.5 -2.4-2.4 1.4-2c-0.4-0.7-0.7-1.4-0.9-2.1L31 19.2zM41.5 21c1.9 0 3.5-1.6 3.5-3.5 0-1.9-1.6-3.5-3.5-3.5 -1.9 0-3.5 1.6-3.5 3.5C38 19.4 39.6 21 41.5 21z"/><path d="M38 30H1V6h36V5H0v26h38V30L38 30z"/><path d="M9.4 21.1c-0.3 0.3-0.7 0.4-1.2 0.4 -0.5 0-0.9-0.2-1.2-0.5s-0.4-0.8-0.4-1.4H5c0 0.9 0.2 1.7 0.7 2.2 0.5 0.6 1.2 0.9 2 1v1.3h1.1v-1.4c0.8-0.1 1.5-0.4 1.9-0.9 0.5-0.5 0.7-1.1 0.7-1.9 0-0.4-0.1-0.8-0.2-1.1 -0.1-0.3-0.3-0.6-0.5-0.8 -0.2-0.2-0.5-0.4-0.8-0.6 -0.3-0.2-0.8-0.4-1.4-0.6 -0.6-0.2-1-0.4-1.2-0.7s-0.4-0.6-0.4-1c0-0.4 0.1-0.8 0.4-1 0.2-0.2 0.6-0.4 1-0.4 0.4 0 0.8 0.2 1 0.5 0.3 0.3 0.4 0.8 0.4 1.4h1.6c0-0.9-0.2-1.6-0.6-2.2 -0.4-0.6-1-0.9-1.8-1v-1.5H7.9v1.5C7.1 12.6 6.5 12.9 6 13.4s-0.7 1.1-0.7 1.9c0 1.1 0.5 2 1.6 2.6 0.3 0.2 0.8 0.4 1.3 0.6 0.6 0.2 1 0.4 1.2 0.7s0.4 0.6 0.4 1C9.8 20.5 9.7 20.8 9.4 21.1z"/><path d="M16.3 12.6h-0.2l-3.8 1.5v1.4l2.4-0.8v8.1h1.6V12.6z"/><path d="M19.9 23.8c0.2-0.5 0.4-1 0.4-1.5l0-1.2h-1.5v1.3c0 0.3-0.1 0.6-0.2 1 -0.1 0.3-0.3 0.7-0.5 1.1l0.9 0.5C19.3 24.7 19.6 24.3 19.9 23.8z"/><path d="M27 16.7c0-1.4-0.3-2.5-0.8-3.2s-1.3-1.1-2.4-1.1c-1.1 0-1.9 0.4-2.4 1.1 -0.5 0.7-0.8 1.8-0.8 3.3v1.8c0 1.4 0.3 2.5 0.8 3.2s1.3 1.1 2.4 1.1c1.1 0 1.9-0.4 2.4-1.1 0.5-0.7 0.8-1.8 0.8-3.3V16.7zM25.4 18.9c0 0.9-0.1 1.6-0.4 2 -0.2 0.4-0.6 0.6-1.2 0.6 -0.5 0-0.9-0.2-1.2-0.7 -0.3-0.5-0.4-1.2-0.4-2.1v-2.3c0-0.9 0.1-1.5 0.4-2 0.3-0.4 0.6-0.6 1.2-0.6 0.5 0 0.9 0.2 1.2 0.7 0.3 0.4 0.4 1.1 0.4 2.1V18.9z"/></svg>',
      format_conditional: '<svg xmlns="http://www.w3.org/2000/svg" width="52" height="36" viewBox="0 0 52 36"><polygon points="38 5 0 5 0 31 26 31 26 30 1 30 1 6 37 6 37 10 38 10 "/><path d="M9 13H8.6L5 14.4v1.4l2-0.8V23h2V13z"/><path d="M17 22h-4l2.4-2.9c0.6-0.7 1-1.3 1.3-1.8 0.3-0.5 0.4-1.1 0.4-1.5 0-0.8-0.3-1.5-0.8-2 -0.5-0.5-1.2-0.7-2.2-0.7 -0.6 0-1.2 0.1-1.7 0.4s-0.9 0.6-1.1 1C11.1 14.9 11 16 11 16h1.6c0 0 0.1-0.9 0.4-1.3s0.7-0.4 1.2-0.4c0.4 0 0.8 0.2 1 0.5 0.3 0.3 0.4 0.7 0.4 1.1 0 0.4-0.1 0.7-0.3 1.1 -0.2 0.4-0.6 0.8-1.1 1.3L11 21.9V23h6V22z"/><path d="M21 19h0.8c0.6 0 1-0.1 1.3 0.2 0.3 0.3 0.4 0.6 0.4 1.1 0 0.5-0.1 0.8-0.4 1.1 -0.3 0.3-0.6 0.4-1.1 0.4 -0.5 0-0.8-0.3-1.1-0.5C20.6 20.9 20.5 21 20.5 20h-1.5c0 1 0.3 1.6 0.8 2.1s1.3 0.8 2.1 0.8c0.9 0 1.6-0.2 2.2-0.7 0.6-0.5 0.8-1.2 0.8-2.1 0-0.5-0.1-1-0.4-1.4 -0.3-0.4-0.6-0.7-1.1-0.9 0.4-0.2 0.7-0.5 1-0.9 0.3-0.4 0.4-0.8 0.4-1.2 0-0.9-0.3-1.5-0.8-2 -0.5-0.5-1.2-0.7-2.1-0.7 -0.5 0-1 0.1-1.5 0.3 -0.4 0.2-0.8 0.7-1 1.1S19.1 15 19.1 16h1.5c0-1 0.1-0.9 0.4-1.1 0.3-0.3 0.6-0.5 1-0.5 0.5 0 0.8 0.1 1 0.3s0.3 0.6 0.3 1.1c0 0.5-0.1 0.7-0.4 1C22.7 17 22.3 17 21.9 17H21V19z"/><path d="M47.8 7C50.1 7 52 8.9 52 11.2c0 1-0.3 1.8-0.8 2.5l-1.7 1.7L43.6 9.5l1.7-1.7C46 7.3 46.8 7 47.8 7zM30.7 22.4L29 30l7.6-1.7 11.6-11.6 -5.9-5.9L30.7 22.4zM42 17.9l-5.1 5.1 -0.9-0.9 5.1-5L42 17.9z"/></svg>',
      options: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="-17.5 774.5 36 36"><path fill="#555" d="M11.363 789.058l-.76-1.838a33.692 33.692 0 0 0 1.601-4.223l-2.327-2.328a31.444 31.444 0 0 0-4.142 1.691l-1.829-.76a32.88 32.88 0 0 0-1.83-4.101h-3.291a32.106 32.106 0 0 0-1.731 4.133l-1.83.76a33.556 33.556 0 0 0-4.206-1.609l-2.328 2.32a31.563 31.563 0 0 0 1.69 4.141l-.759 1.838a34.366 34.366 0 0 0-4.117 1.838v3.3a32.519 32.519 0 0 0 4.117 1.731l.759 1.829a33.633 33.633 0 0 0-1.608 4.223l2.327 2.328a32.986 32.986 0 0 0 4.133-1.699l1.83.76a31.481 31.481 0 0 0 1.862 4.108h3.291a32.194 32.194 0 0 0 1.732-4.133l1.837-.76a33.57 33.57 0 0 0 4.207 1.609l2.327-2.328a31.481 31.481 0 0 0-1.69-4.141l.76-1.838a32.532 32.532 0 0 0 4.108-1.829v-3.3a30.142 30.142 0 0 0-4.133-1.722zM.5 799.202a6.706 6.706 0 1 1 6.706-6.706A6.71 6.71 0 0 1 .5 799.202z"/></svg>',
      fields: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="-17.5 774.5 36 36"><g fill="#555"><path d="M11.351 787.279c1.112.367 2.027 1.221 2.55 2.221H13.5v-10.627c0-.744-.089-1.357-.825-1.373h-26.339c-.736.008-.836.612-.836 1.349v21.656c0 .735.093.995.836.995h10.836c-.008 0 .205-1.314.629-2.025-.073-.098-.123.025-.18.025H-12.5v-6h10.563l.83-1.699c.4-.76 1.606-1.258 1.606-1.667V785.5h10.843l.009 1.779zM-1.5 791.5h-11v-6h11v6z"/><path d="M15.805 801.444l-1.602-1.308c0-.237.082-.49.082-.817a2.483 2.483 0 0 0-.082-.817l1.602-1.389a.399.399 0 0 0 .082-.49l-1.528-2.86a.364.364 0 0 0-.278-.123.678.678 0 0 0-.18 0l-1.912.866a6.95 6.95 0 0 0-1.299-.817l-.311-1.989c-.017-.195-.188-.199-.384-.199H6.93c-.147 0-.384.037-.384.199l-.311 2.053c-.458.229-.899.468-1.299.786l-1.912-.834c-.041-.008-.09-.016-.131-.008a.356.356 0 0 0-.319.192l-1.528 2.817c-.082.164-.082.408.082.489l1.749 1.308c0 .237-.082.489-.082.816a2.48 2.48 0 0 0 .082.817l-1.602 1.356a.399.399 0 0 0-.082.49l1.528 2.86a.364.364 0 0 0 .278.123.678.678 0 0 0 .18 0l1.912-.817c.4.318.842.597 1.299.817l.311 2.116a.322.322 0 0 0 .221.4c.033.008.065.017.09.017h3.065c.147 0 .384-.164.384-.327l.311-2.215c.466-.212.907-.49 1.299-.817l1.831.817a.441.441 0 0 0 .54-.163l1.528-2.86c.056-.08-.018-.326-.165-.489zm-7.306.744a2.865 2.865 0 0 1-3.064-2.664c-.114-1.585 1.079-2.95 2.664-3.064a2.867 2.867 0 0 1 3.072 2.868 2.804 2.804 0 0 1-2.672 2.86z"/></g></svg>',
      fullscreen: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="-17.5 774.5 36 36"><g fill="#555"><path d="M-7.5 779.976V777.5h-7v7h3v-2.752l3.758 4.067 1.74-1.846-4.342-4.003 2.844.01zM-7.742 799.096l-3.758 4.101V800.5h-3v7h7v-2h-2.618l-.049-.371 4.124-4.054-1.699-1.979zM8.746 785.913l3.754-4.092v2.679h3v-7h-7v2h2.602l.082.381-4.126 4.041 1.688 1.991zM13.5 800.5v2.598l-.382.074-4.058-4.003-1.882 1.575 4.006 3.756H8.5v3h7v-7h-2zM-4 786.5h9c1.104 0 2.5.908 2.5 2.011v7.996c0 1.103-1.396 1.993-2.5 1.993h-9c-1.104 0-2.5-.891-2.5-1.993v-8.005c0-1.103 1.396-2.002 2.5-2.002z"/></g></svg>'
    }, A.prototype.connectLocalCSVHandler = function () {
      this.pivot.connectTo({
        dataSourceType: "csv",
        browseForFile: !0
      });
    }, A.prototype.connectLocalJSONHandler = function () {
      this.pivot.connectTo({
        dataSourceType: "json",
        browseForFile: !0
      });
    }, A.prototype.connectRemoteCSV = function () {
      this.showConnectToRemoteCSVDialog();
    }, A.prototype.connectRemoteJSON = function () {
      this.showConnectToRemoteJSONDialog();
    }, A.prototype.openLocalReport = function () {
      this.pivot.open();
    }, A.prototype.openRemoteReport = function () {
      this.showOpenRemoteReportDialog();
    }, A.prototype.saveHandler = function () {
      this.pivot.save("report.json", "file");
    }, A.prototype.formatCellsHandler = function () {
      this.showFormatCellsDialog();
    }, A.prototype.conditionalFormattingHandler = function () {
      this.showConditionalFormattingDialog();
    }, A.prototype.optionsHandler = function () {
      this.showOptionsDialog();
    }, A.prototype.fieldsHandler = function () {
      this.pivot.openFieldsList();
    }, A.prototype.printHandler = function () {
      this.pivot.print();
    }, A.prototype.exportHandler = function (t) {
      "pdf" == t ? this.showExportPdfDialog() : this.pivot.exportTo(t);
    }, A.prototype.fullscreenHandler = function () {
      this.toggleFullscreen();
    }, A.prototype.defaults = {}, A.prototype.showConnectToRemoteCSVDialog = function () {
      var t = this,
        e = this.Labels,
        i = this.popupManager.createPopup();
      i.content.classList.add("wdr-popup-w500"), i.setTitle(e.open_remote_csv), i.setToolbar([{
        id: "wdr-btn-open",
        label: e.open,
        handler: function handler() {
          0 < s.value.length && t.pivot.connectTo({
            filename: s.value,
            dataSourceType: "csv"
          });
        },
        isPositive: !0
      }, {
        id: "wdr-btn-cancel",
        label: e.cancel
      }]);
      e = document.createElement("div");
      var s = document.createElement("input");
      s.id = "wdr-inp-file-url", s.type = "text", s.value = "https://cdn.webdatarocks.com/data/data.csv", e.appendChild(s), i.setContent(e), this.popupManager.addPopup(i.content);
    }, A.prototype.showConnectToRemoteJSONDialog = function () {
      var t = this,
        e = this.Labels,
        i = this.popupManager.createPopup();
      i.content.classList.add("wdr-popup-w500"), i.setTitle(e.open_remote_json), i.setToolbar([{
        id: "wdr-btn-open",
        label: e.open,
        handler: function handler() {
          0 < s.value.length && t.pivot.connectTo({
            filename: s.value,
            dataSourceType: "json"
          });
        },
        isPositive: !0
      }, {
        id: "wdr-btn-cancel",
        label: e.cancel
      }]);
      e = document.createElement("div");
      var s = document.createElement("input");
      s.id = "wdr-inp-file-url", s.type = "text", s.value = "https://cdn.webdatarocks.com/data/data.json", e.appendChild(s), i.setContent(e), this.popupManager.addPopup(i.content);
    }, A.prototype.showOpenRemoteReportDialog = function () {
      var t = this,
        e = this.Labels,
        i = this.popupManager.createPopup();
      i.content.classList.add("wdr-popup-w500"), i.setTitle(e.open_remote_report), i.setToolbar([{
        id: "wdr-btn-open",
        label: e.open,
        handler: function handler() {
          0 < s.value.length && t.pivot.load(s.value);
        },
        isPositive: !0
      }, {
        id: "wdr-btn-cancel",
        label: e.cancel
      }]);
      e = document.createElement("div");
      var s = document.createElement("input");
      s.type = "text";
      var r = t.pivot.getOptions() || {};
      s.value = r.grid && "flat" == r.grid.type ? "https://cdn.webdatarocks.com/reports/report-flat.json" : "https://cdn.webdatarocks.com/reports/report.json", e.appendChild(s), i.setContent(e), this.popupManager.addPopup(i.content);
    }, A.prototype.showFormatCellsDialog = function () {
      var t = this,
        e = this.Labels,
        i = function i() {
          h.disabled = l.disabled = A.disabled = c.disabled = d.disabled = f.disabled = p.disabled = w.disabled = "empty" == o.value;
          var e = t.pivot.getFormat(o.value);
          h.value = "left" == e.textAlign || "right" == e.textAlign ? e.textAlign : "right", l.value = e.thousandsSeparator, A.value = e.decimalSeparator, c.value = e.decimalPlaces, d.value = e.currencySymbol, f.value = e.currencySymbolAlign, p.value = e.nullValue, w.value = 1 == e.isPercent;
        },
        s = this.popupManager.createPopup();
      s.content.id = "wdr-popup-format-cells", s.setTitle(this.osUtils.isMobile ? e.format : e.format_cells), s.setToolbar([{
        id: "wdr-btn-apply",
        label: e.apply,
        handler: function handler() {
          var e = {};
          "" == o.value && (e.name = ""), e.textAlign = h.value, e.thousandsSeparator = l.value, e.decimalSeparator = A.value, e.decimalPlaces = c.value, e.currencySymbol = d.value, e.currencySymbolAlign = f.value, e.nullValue = p.value, e.isPercent = "true" == w.value, t.pivot.setFormat(e, "" == o.value ? null : o.value), t.pivot.refresh();
        },
        isPositive: !0
      }, {
        id: "wdr-btn-cancel",
        label: e.cancel
      }], !0);
      var r = document.createElement("div"),
        n = document.createElement("div");
      n.classList.add("wdr-inp-group"), r.appendChild(n);
      var a = document.createElement("div");
      a.classList.add("wdr-inp-row"), a.classList.add("wdr-ir-horizontal"), n.appendChild(a), (u = document.createElement("label")).classList.add("wdr-uc"), t.setText(u, e.choose_value), a.appendChild(u);
      var o = (g = t.createSelect()).select;
      o.onchange = i, o.options[0] = new Option(e.choose_value, "empty"), o.options[0].disabled = !0, o.options[1] = new Option(e.all_values, ""), a.appendChild(g), (a = document.createElement("div")).classList.add("wdr-inp-row"), a.classList.add("wdr-ir-horizontal"), n.appendChild(a), (n = document.createElement("div")).classList.add("wdr-inp-group"), r.appendChild(n), (a = document.createElement("div")).classList.add("wdr-inp-row"), a.classList.add("wdr-ir-horizontal"), n.appendChild(a), u = document.createElement("label"), t.setText(u, e.text_align), a.appendChild(u);
      var h = (g = t.createSelect()).select;
      h.options[0] = new Option(e.align_left, "left"), h.options[1] = new Option(e.align_right, "right"), a.appendChild(g), (a = document.createElement("div")).classList.add("wdr-inp-row"), a.classList.add("wdr-ir-horizontal"), n.appendChild(a), u = document.createElement("label"), t.setText(u, e.thousand_separator), a.appendChild(u);
      var l = (g = t.createSelect()).select;
      l.options[0] = new Option(e.none, ""), l.options[1] = new Option(e.space, " "), l.options[2] = new Option(",", ","), l.options[3] = new Option(".", "."), a.appendChild(g), (a = document.createElement("div")).classList.add("wdr-inp-row"), a.classList.add("wdr-ir-horizontal"), n.appendChild(a), u = document.createElement("label"), t.setText(u, e.decimal_separator), a.appendChild(u);
      var A = (g = t.createSelect()).select;
      A.options[0] = new Option(".", "."), A.options[1] = new Option(",", ","), a.appendChild(g), (a = document.createElement("div")).classList.add("wdr-inp-row"), a.classList.add("wdr-ir-horizontal"), n.appendChild(a), u = document.createElement("label"), t.setText(u, e.decimal_places), a.appendChild(u);
      for (var c = (g = t.createSelect()).select, u = 0; 11 > u; u++) c.options[u] = new Option(0 === u ? e.none : u - 1, u - 1);
      a.appendChild(g), (a = document.createElement("div")).classList.add("wdr-inp-row"), a.classList.add("wdr-ir-horizontal"), n.appendChild(a), u = document.createElement("label"), t.setText(u, e.currency_symbol), a.appendChild(u);
      var d = document.createElement("input");
      d.classList.add("wdr-inp"), d.type = "text", a.appendChild(d), (a = document.createElement("div")).classList.add("wdr-inp-row"), a.classList.add("wdr-ir-horizontal"), n.appendChild(a), u = document.createElement("label"), t.setText(u, e.currency_align), a.appendChild(u);
      var f = (g = t.createSelect()).select;
      f.options[0] = new Option(e.align_left, "left"), f.options[1] = new Option(e.align_right, "right"), a.appendChild(g), (a = document.createElement("div")).classList.add("wdr-inp-row"), a.classList.add("wdr-ir-horizontal"), n.appendChild(a), u = document.createElement("label"), t.setText(u, e.null_value), a.appendChild(u);
      var p = document.createElement("input");
      p.classList.add("wdr-inp"), p.type = "text", a.appendChild(p), (a = document.createElement("div")).classList.add("wdr-inp-row"), a.classList.add("wdr-ir-horizontal"), n.appendChild(a), u = document.createElement("label"), t.setText(u, e.is_percent), a.appendChild(u);
      var g,
        w = (g = t.createSelect()).select;
      for (w.options[0] = new Option(e.true_value, !0), w.options[1] = new Option(e.false_value, !1), a.appendChild(g), s.setContent(r), this.popupManager.addPopup(s.content), e = t.pivot.getMeasures(), u = 0; u < e.length; u++) o.options[u + 2] = new Option(e[u].caption, e[u].uniqueName);
      i();
    }, A.prototype.showConditionalFormattingDialog = function () {
      var t = this,
        e = this.Labels,
        i = this.pivot.getAllConditions(),
        s = function s(t) {
          for (var e = t.match(/\W\d+\.*\d*/g), i = [], s = !1, r = "", n = 0; n < t.length; n++) '"' == t[n] || "'" == t[n] ? (s ? i.push(r) : r = "", s = !s) : s && (r += t[n]);
          return t = t.match(/<=|>=|<|>|=|=|!=|isNaN/g), null == e && null == i ? {} : {
            value1: null != e ? e[0].replace(/\s/, "") : i[0],
            value2: null != e && 1 < e.length ? e[1].replace(/\s/, "") : "",
            sign: t ? t.join("") : ""
          };
        },
        r = this.popupManager.createPopup();
      r.content.id = "wdr-popup-conditional", r.setTitle(this.osUtils.isMobile ? e.conditional : e.conditional_formatting), r.setToolbar([{
        id: "wdr-btn-apply",
        label: e.apply,
        handler: function handler() {
          t.pivot.removeAllConditions();
          for (var e = 0; e < i.length; e++) {
            var s;
            s = i[e].sign;
            var r = i[e].value1,
              n = i[e].value2,
              a = "",
              o = null == n || 0 == n.length,
              h = "><" === s,
              l = "isNaN" === s;
            if ((null == r || 0 == r.length) && !l || h && o || (h && !o ? a = "AND(#value > " + r + ", #value < " + n + ")" : l ? a = "isNaN(#value)" : (isNaN(parseFloat(r)) && (r = "'" + r + "'"), a = "#value " + s + " " + r)), null == (s = a)) return;
            i[e].formula = s, t.pivot.addCondition(i[e]);
          }
          t.pivot.refresh();
        },
        isPositive: !0
      }, {
        id: "wdr-btn-cancel",
        label: e.cancel
      }], !0);
      var n = document.createElement("a");
      n.id = "wdr-add-btn", n.setAttribute("href", "javascript:void(0)"), n.classList.add("wdr-ui-btn"), n.classList.add("wdr-ui-btn-light"), n.classList.add("wdr-button-add"), n.onclick = function () {
        var e = {
          sign: "<",
          value1: "0",
          measures: t.pivot.getMeasures(),
          format: {
            fontFamily: "Arial",
            fontSize: "12px",
            color: "#000000",
            backgroundColor: "#FFFFFF"
          }
        };
        i.push(e), a.appendChild(t.createConditionalFormattingItem(e, i)), t.popupManager.centerPopup(r.content);
      }, n.setAttribute("title", e.add_condition), (e = document.createElement("span")).classList.add("wdr-icon"), e.classList.add("wdr-icon-act_add"), n.appendChild(e), r.toolbar.insertBefore(n, r.toolbar.firstChild);
      var a = document.createElement("div");
      for (a.classList.add("wdr-popup-content"), a.onclick = function (e) {
        e.target.classList.contains("wdr-cr-delete") && t.popupManager.centerPopup(r.content);
      }, n = 0; n < i.length; n++) e = s(i[n].formula), i[n].value1 = e.value1, i[n].value2 = e.value2, i[n].sign = e.sign, i[n].measures = t.pivot.getMeasures(), a.appendChild(t.createConditionalFormattingItem(i[n], i));
      r.setContent(a), this.popupManager.addPopup(r.content);
    }, A.prototype.defaults.fontSizes = "8px 9px 10px 11px 12px 13px 14px".split(" "), A.prototype.defaults.fonts = "Arial;Lucida Sans Unicode;Verdana;Courier New;Palatino Linotype;Tahoma;Impact;Trebuchet MS;Georgia;Times New Roman".split(";"), A.prototype.defaults.conditions = [{
      label: "less_than",
      sign: "<"
    }, {
      label: "less_than_or_equal",
      sign: "<="
    }, {
      label: "greater_than",
      sign: ">"
    }, {
      label: "greater_than_or_equal",
      sign: ">="
    }, {
      label: "equal_to",
      sign: "="
    }, {
      label: "not_equal_to",
      sign: "!="
    }, {
      label: "between",
      sign: "><"
    }, {
      label: "is_empty",
      sign: "isNaN"
    }], A.prototype.createConditionalFormattingItem = function (t, e) {
      var i = this,
        s = this.Labels,
        r = function r() {
          "sign" in t && "><" === t.sign ? (d.classList.remove("wdr-width120"), d.classList.add("wdr-width50"), d.style.display = "inline-block", p.value = "value2" in t ? t.value2 : "0", p.style.display = "inline-block", f.style.display = "inline-block") : ("sign" in t && "isNaN" === t.sign ? d.style.display = "none" : (d.classList.add("wdr-width120"), d.classList.remove("wdr-width50"), d.style.display = "inline-block"), p.style.display = "none", f.style.display = "none");
        },
        n = function n() {
          var e = t.format;
          null != e && (v.style.backgroundColor = e.backgroundColor || "#fff", v.style.color = e.color || "#000", v.style.fontFamily = e.fontFamily || "Arial", v.style.fontSize = e.fontSize || "12px");
        },
        a = document.createElement("div");
      a.classList.add("wdr-condition-row");
      var o = document.createElement("div");
      o.classList.add("wdr-wrap-relative"), a.appendChild(o);
      var h = document.createElement("span");
      h.classList.add("wdr-cr-delete"), h.classList.add("wdr-icon"), h.classList.add("wdr-icon-act_trash"), h.onclick = function () {
        var i = e.indexOf(t);
        -1 < i && e.splice(i, 1), a.parentNode.removeChild(a);
      }, o.appendChild(h), (h = document.createElement("div")).classList.add("wdr-cr-inner"), o.appendChild(h);
      var l = document.createElement("div");
      l.classList.add("wdr-cr-lbl"), l.classList.add("wdr-width50"), i.setText(l, s.value + ":"), h.appendChild(l), (l = i.createSelect()).id = "wdr-values";
      var c = l.select;
      "measures" in t ? (function (t, e) {
        c[0] = new Option(s.all_values, "");
        for (var r = (r = i.pivot.getOptions() || {}).grid && "flat" == r.grid.type, n = 0; n < t.length; n++) r && 7 == t[n].type || (c[c.options.length] = new Option(t[n].caption, t[n].uniqueName));
        null != e ? c.value = e : c.selectedIndex = 0;
      }(t.measures, t.measure), c.disabled = 0 === t.measures.length) : c.disabled = !0, c.onchange = function () {
        t.measure = c.value;
      }, h.appendChild(l), (l = i.createSelect()).id = "wdr-conditions";
      var u = l.select;
      !function (t) {
        for (var e = 0; e < i.defaults.conditions.length; e++) u[e] = new Option(s[i.defaults.conditions[e].label], i.defaults.conditions[e].sign);
        null != t ? u.value = t : u.selectedIndex = 0;
      }("sign" in t ? t.sign : null), u.onchange = function () {
        t.sign = u.value, "sign" in t && "><" === t.sign ? t.value2 = 0 : ("sign" in t && "isNaN" === t.sign && delete t.value1, delete t.value2), r();
      }, h.appendChild(l);
      var d = document.createElement("input");
      d.classList.add("wdr-number-inp"), d.classList.add("wdr-width50"), d.type = "number", d.value = "value1" in t ? t.value1 : "0", d.onchange = function () {
        t.value1 = 0 == d.value.length ? "0" : d.value;
      }, h.appendChild(d);
      var f = document.createElement("span");
      f.id = "wdr-and-label", f.classList.add("wdr-width20"), i.setText(f, s.and_symbole), h.appendChild(f);
      var p = document.createElement("input");
      p.classList.add("wdr-number-inp"), p.classList.add("wdr-width50"), p.type = "number", p.value = "value2" in t ? t.value2 : "0", p.onchange = function () {
        t.value2 = 0 == p.value.length ? "0" : p.value;
      }, h.appendChild(p), r(), (h = document.createElement("div")).classList.add("wdr-cr-inner"), o.appendChild(h), (l = document.createElement("div")).classList.add("wdr-cr-lbl"), l.classList.add("wdr-width50"), i.setText(l, s.format + ":"), h.appendChild(l), (l = i.createSelect()).id = "wdr-font-family";
      var g = l.select;
      !function (t) {
        for (var e = 0; e < i.defaults.fonts.length; e++) g[e] = new Option(i.defaults.fonts[e], i.defaults.fonts[e]);
        g.value = null == t ? "Arial" : t;
      }(t.hasOwnProperty("format") && t.format.hasOwnProperty("fontFamily") ? t.format.fontFamily : null), g.onchange = function () {
        null != t.format && (t.format.fontFamily = g.value, n());
      }, h.appendChild(l), (l = i.createSelect()).id = "wdr-font-size";
      var w = l.select;
      !function (t) {
        for (var e = 0; e < i.defaults.fontSizes.length; e++) w[e] = new Option(i.defaults.fontSizes[e], i.defaults.fontSizes[e]);
        w.value = null == t ? "12px" : t;
      }(t.hasOwnProperty("format") && t.format.hasOwnProperty("fontSize") ? t.format.fontSize : null), w.onchange = function () {
        null != t.format && (t.format.fontSize = w.value, n());
      }, h.appendChild(l);
      var m = new A.ColorPicker(this, a);
      m.setColor(t.hasOwnProperty("format") && t.format.hasOwnProperty("backgroundColor") ? t.format.backgroundColor : "0xFFFFFF", "bg"), m.setColor(t.hasOwnProperty("format") && t.format.hasOwnProperty("color") ? t.format.color : "0x000000", "font"), m.changeHandler = function () {
        null != t.format && (v.style.color = m.fontColor || "#000", v.style.backgroundColor = m.backgroundColor || "#fff");
      }, m.applyHandler = function () {
        null != t.format && (t.format.color = m.fontColor, t.format.backgroundColor = m.backgroundColor, n());
      }, m.cancelHandler = function () {
        null != t.format && (m.setColor(t.format.hasOwnProperty("backgroundColor") ? t.format.backgroundColor : "0xFFFFFF", "bg"), m.setColor(t.format.hasOwnProperty("color") ? t.format.color : "0x000000", "font")), n();
      }, h.appendChild(m.element);
      var v = document.createElement("input");
      return v.id = "wdr-sample", v.classList.add("wdr-inp"), v.type = "number", v.value = "73.93", v.style.pointerEvents = "none", h.appendChild(v), n(), a;
    }, A.prototype.showOptionsDialog = function () {
      var t = this,
        e = this.Labels,
        i = this.popupManager.createPopup();
      i.content.id = "wdr-popup-options", i.setTitle(this.osUtils.isMobile ? e.options : e.layout_options), i.setToolbar([{
        id: "wdr-btn-apply",
        label: e.apply,
        handler: function handler() {
          var e, i;
          l.checked ? e = "off" : c.checked ? e = "on" : u.checked ? e = "rows" : d.checked && (e = "columns"), m.checked ? i = "off" : v.checked ? i = "on" : b.checked ? i = "rows" : B.checked && (i = "columns");
          var s = "compact";
          g && g.checked ? s = "classic" : w && w.checked && (s = "flat");
          var r = t.pivot.getOptions();
          r = {
            grid: {
              showGrandTotals: e,
              showTotals: i,
              type: s
            }
          };
          t.pivot.setOptions(r), t.pivot.refresh();
        },
        isPositive: !0
      }, {
        id: "wdr-btn-cancel",
        label: e.cancel
      }], !0);
      var s = document.createElement("div");
      s.classList.add("wdr-popup-content");
      var r = document.createElement("div");
      r.classList.add("wdr-ui-row"), s.appendChild(r);
      var n = document.createElement("div");
      n.classList.add("wdr-ui-col-2"), r.appendChild(n), (f = document.createElement("div")).classList.add("wdr-title-2"), t.setText(f, e.grand_totals), n.appendChild(f);
      var a = "wdr-grand-totals-" + Date.now();
      (f = document.createElement("ul")).classList.add("wdr-radiobtn-list"), n.appendChild(f);
      var o = document.createElement("li"),
        h = document.createElement("div");
      h.classList.add("wdr-radio-wrap");
      var l = document.createElement("input");
      l.type = "radio", l.name = a, l.id = "wdr-gt-1", l.value = "off", h.appendChild(l);
      var A = document.createElement("label");
      A.setAttribute("for", "wdr-gt-1"), t.setText(A, e.grand_totals_off), h.appendChild(A), o.appendChild(h), f.appendChild(o), o = document.createElement("li"), (h = document.createElement("div")).classList.add("wdr-radio-wrap");
      var c = document.createElement("input");
      c.type = "radio", c.name = a, c.id = "wdr-gt-2", c.value = "on", h.appendChild(c), (A = document.createElement("label")).setAttribute("for", "wdr-gt-2"), t.setText(A, e.grand_totals_on), h.appendChild(A), o.appendChild(h), f.appendChild(o), o = document.createElement("li"), (h = document.createElement("div")).classList.add("wdr-radio-wrap");
      var u = document.createElement("input");
      u.type = "radio", u.name = a, u.id = "wdr-gt-3", u.value = "rows", h.appendChild(u), (A = document.createElement("label")).setAttribute("for", "wdr-gt-3"), t.setText(A, e.grand_totals_on_rows), h.appendChild(A), o.appendChild(h), f.appendChild(o), o = document.createElement("li"), (h = document.createElement("div")).classList.add("wdr-radio-wrap");
      var d = document.createElement("input");
      d.type = "radio", d.name = a, d.id = "wdr-gt-4", d.value = "rows", h.appendChild(d), (A = document.createElement("label")).setAttribute("for", "wdr-gt-4"), t.setText(A, e.grand_totals_on_columns), h.appendChild(A), o.appendChild(h), f.appendChild(o), (f = document.createElement("div")).classList.add("wdr-title-2"), t.setText(f, e.layout), n.appendChild(f);
      var f,
        p = "wdr-layout-" + Date.now();
      (f = document.createElement("ul")).classList.add("wdr-radiobtn-list"), n.appendChild(f), o = document.createElement("li"), (h = document.createElement("div")).classList.add("wdr-radio-wrap"), (a = document.createElement("input")).type = "radio", a.name = p, a.id = "wdr-lt-1", a.value = "compact", h.appendChild(a), (A = document.createElement("label")).setAttribute("for", "wdr-lt-1"), t.setText(A, e.compact_view), h.appendChild(A), o.appendChild(h), f.appendChild(o), o = document.createElement("li"), (h = document.createElement("div")).classList.add("wdr-radio-wrap");
      var g = document.createElement("input");
      g.type = "radio", g.name = p, g.id = "wdr-lt-2", g.value = "classic", h.appendChild(g), (A = document.createElement("label")).setAttribute("for", "wdr-lt-2"), t.setText(A, e.classic_view), h.appendChild(A), o.appendChild(h), f.appendChild(o), n = t.pivot.getReport({
        withDefaults: !0,
        withGlobals: !0
      }), o = document.createElement("li"), (h = document.createElement("div")).classList.add("wdr-radio-wrap");
      var w = document.createElement("input");
      w.type = "radio", w.name = p, w.id = "wdr-lt-3", w.value = "flat", h.appendChild(w), (A = document.createElement("label")).setAttribute("for", "wdr-lt-3"), t.setText(A, e.flat_view), h.appendChild(A), o.appendChild(h), f.appendChild(o), (n = document.createElement("div")).classList.add("wdr-ui-col-2"), r.appendChild(n), (f = document.createElement("div")).classList.add("wdr-title-2"), t.setText(f, e.subtotals), n.appendChild(f), r = "wdr-subtotals-" + Date.now(), (f = document.createElement("ul")).classList.add("wdr-radiobtn-list"), n.appendChild(f), o = document.createElement("li"), (h = document.createElement("div")).classList.add("wdr-radio-wrap");
      var m = document.createElement("input");
      m.type = "radio", m.name = r, m.id = "wdr-st-1", m.value = "off", h.appendChild(m), (A = document.createElement("label")).setAttribute("for", "wdr-st-1"), t.setText(A, e.subtotals_off), h.appendChild(A), o.appendChild(h), f.appendChild(o), o = document.createElement("li"), (h = document.createElement("div")).classList.add("wdr-radio-wrap");
      var v = document.createElement("input");
      v.type = "radio", v.name = r, v.id = "wdr-st-2", v.value = "on", h.appendChild(v), (A = document.createElement("label")).setAttribute("for", "wdr-st-2"), t.setText(A, e.subtotals_on), h.appendChild(A), o.appendChild(h), f.appendChild(o), o = document.createElement("li"), (h = document.createElement("div")).classList.add("wdr-radio-wrap");
      var b = document.createElement("input");
      b.type = "radio", b.name = r, b.id = "wdr-st-3", b.value = "rows", h.appendChild(b), (A = document.createElement("label")).setAttribute("for", "wdr-st-3"), t.setText(A, e.subtotals_on_rows), h.appendChild(A), o.appendChild(h), f.appendChild(o), o = document.createElement("li"), (h = document.createElement("div")).classList.add("wdr-radio-wrap");
      var B = document.createElement("input");
      B.type = "radio", B.name = r, B.id = "wdr-st-4", B.value = "columns", h.appendChild(B), (A = document.createElement("label")).setAttribute("for", "wdr-st-4"), t.setText(A, e.subtotals_on_columns), h.appendChild(A), o.appendChild(h), f.appendChild(o), i.setContent(s), this.popupManager.addPopup(i.content), "off" == (e = (n = t.pivot.getOptions() || {}).grid || {}).showGrandTotals || 0 == e.showGrandTotals ? l.checked = !0 : "on" == e.showGrandTotals || 1 == e.showGrandTotals ? c.checked = !0 : "rows" == e.showGrandTotals ? u.checked = !0 : "columns" == e.showGrandTotals && (d.checked = !0), "off" == e.showTotals ? m.checked = !0 : "on" == e.showTotals ? v.checked = !0 : "rows" == e.showTotals ? b.checked = !0 : "columns" == e.showTotals && (B.checked = !0), "flat" == e.type && w ? w.checked = !0 : "classic" == e.type && g ? g.checked = !0 : a && (a.checked = !0);
    }, A.prototype.showExportPdfDialog = function () {
      var t = this,
        e = this.Labels,
        i = this.popupManager.createPopup();
      i.setTitle(e.choose_page_orientation), i.setToolbar([{
        id: "wdr-btn-apply",
        label: e.apply,
        handler: function handler() {
          var e = "portrait";
          o.checked && (e = "landscape"), t.pivot.exportTo("pdf", {
            pageOrientation: e
          });
        },
        isPositive: !0
      }, {
        id: "wdr-btn-cancel",
        label: e.cancel
      }]);
      var s = document.createElement("div"),
        r = document.createElement("ul");
      r.classList.add("wdr-radiobtn-list"), s.appendChild(r);
      var n = document.createElement("li");
      r.appendChild(n);
      var a = document.createElement("div");
      a.classList.add("wdr-radio-wrap"), n.appendChild(a), (n = document.createElement("input")).id = "wdr-portrait-radio", n.type = "radio", n.name = "wdr-pdf-orientation", n.checked = !0, a.appendChild(n), (n = document.createElement("label")).setAttribute("for", "wdr-portrait-radio"), t.setText(n, e.portrait), a.appendChild(n), n = document.createElement("li"), r.appendChild(n), (a = document.createElement("div")).classList.add("wdr-radio-wrap"), n.appendChild(a);
      var o = document.createElement("input");
      o.id = "wdr-landscape-radio", o.type = "radio", o.name = "wdr-pdf-orientation", a.appendChild(o), (n = document.createElement("label")).setAttribute("for", "wdr-landscape-radio"), t.setText(n, e.landscape), a.appendChild(n), i.setContent(s), this.popupManager.addPopup(i.content);
    }, A.prototype.toggleFullscreen = function () {
      this.isFullscreen() ? this.exitFullscreen() : this.enterFullscreen(this.container);
    }, A.prototype.isFullscreen = function () {
      return document.fullScreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
    }, A.prototype.enterFullscreen = function (t) {
      if (t.requestFullscreen || t.webkitRequestFullScreen || t.mozRequestFullScreen || t.msRequestFullscreen && window == top) {
        if (this.containerStyle = {
          width: this.container.style.width,
          height: this.container.style.height,
          position: this.container.style.position,
          top: this.container.style.top,
          bottom: this.container.style.bottom,
          left: this.container.style.left,
          right: this.container.style.right,
          marginTop: this.container.style.marginTop,
          marginLeft: this.container.style.left,
          toolbarWidth: this.toolbarWrapper.style.width
        }, this.container.style.width = "100%", this.container.style.height = "100%", this.container.style.position = "fixed", this.container.style.top = "0px", this.container.style.left = "0px", this.toolbarWrapper.style.width = "100%", t.requestFullscreen) t.requestFullscreen();else if (t.webkitRequestFullScreen) {
          var e = navigator.userAgent;
          -1 < e.indexOf("Safari") && -1 == e.indexOf("Chrome") ? t.webkitRequestFullScreen() : t.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        } else t.mozRequestFullScreen ? t.mozRequestFullScreen() : t.msRequestFullscreen && (window == top ? t.msRequestFullscreen() : alert("Fullscreen mode in IE 11 is not currently supported while Pivot embeded in iframe."));
        t.addEventListener("fullscreenchange", function () {
          window.screenTop || window.screenY || this.isFullscreen() || this.exitFullscreen();
        }.bind(this), !1), t.addEventListener("webkitfullscreenchange", function () {
          window.screenTop || window.screenY || this.isFullscreen() || this.exitFullscreen();
        }.bind(this), !1), t.addEventListener("mozfullscreenchange", function () {
          window.fullScreen || window.innerWidth == screen.width && window.innerHeight == screen.height || this.exitFullscreen();
        }.bind(this), !1);
      }
    }, A.prototype.exitFullscreen = function () {
      this.container.style.width = this.containerStyle.width, this.container.style.height = this.containerStyle.height, this.container.style.position = this.containerStyle.position, this.container.style.top = this.containerStyle.top, this.container.style.left = this.containerStyle.left, this.container.style.marginTop = this.containerStyle.marginTop, this.container.style.marginLeft = this.containerStyle.marginLeft, this.toolbarWrapper.style.width = this.containerStyle.toolbarWidth, document.exitFullscreen ? document.exitFullscreen() : document.cancelFullscreen ? document.cancelFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullScreen ? document.webkitExitFullScreen() : document.webkitCancelFullScreen ? document.webkitCancelFullScreen() : document.msExitFullscreen && document.msExitFullscreen();
    }, A.prototype.nullOrUndefined = function (t) {
      return null == t;
    }, A.prototype.hasClass = function (t, e) {
      return t.className.match(RegExp("(\\s|^)" + e + "(\\s|$)"));
    }, A.prototype.addClass = function (t, e) {
      this.hasClass(t, e) || (t.className += " " + e);
    }, A.prototype.removeClass = function (t, e) {
      this.hasClass(t, e) && (t.className = t.className.replace(RegExp("(\\s|^)" + e + "(\\s|$)"), " "));
    }, A.prototype.setText = function (t, e) {
      t && (void 0 !== t.innerText && (t.innerText = e), void 0 !== t.textContent && (t.textContent = e));
    }, A.prototype.createSelect = function () {
      var t = document.createElement("div");
      t.classList.add("wdr-select");
      var e = document.createElement("select");
      return t.appendChild(e), t.select = e, t;
    }, A.prototype.createDivider = function (t) {
      return (t = document.createElement("li")).className = "wdr-divider", t;
    }, A.prototype.createTab = function (t) {
      var e = document.createElement("li");
      e.id = t.id;
      var i = document.createElement("a");
      (t.hasOwnProperty("class_attr") && i.setAttribute("class", t.class_attr), i.setAttribute("href", "javascript:void(0)"), t.icon) && ((r = document.createElement("div")).classList.add("wdr-svg-icon"), r.innerHTML = t.icon, i.appendChild(r));
      r = document.createElement("span"), this.setText(r, t.title), i.appendChild(r);
      var s = this,
        r = "function" == typeof t.handler ? t.handler : this[t.handler];
      return this.nullOrUndefined(r) || (i.onclick = function (t, e) {
        return function () {
          t.call(s, e);
        };
      }(r, t.args)), this.nullOrUndefined(this[t.onShowHandler]) || (i.onmouseover = function (t) {
        return function () {
          t.call(s);
        };
      }(this[t.onShowHandler])), e.onmouseover = function () {
        s.showDropdown(this);
      }, e.onmouseout = function () {
        s.hideDropdown(this);
      }, e.appendChild(i), null == t.menu || this.osUtils.isMobile && 1 != t.collapse || e.appendChild(this.createTabMenu(t.menu)), e;
    }, A.prototype.showDropdown = function (t) {
      var e = t.querySelectorAll(".wdr-dropdown")[0];
      e && (e.style.display = "block", e.getBoundingClientRect().right > this.toolbarWrapper.getBoundingClientRect().right && (e.style.right = 0, this.addClass(t, "wdr-align-rigth")));
    }, A.prototype.hideDropdown = function (t) {
      var e = t.querySelectorAll(".wdr-dropdown")[0];
      e && (e.style.display = "none", e.style.right = null, this.removeClass(t, "wdr-align-rigth"));
    }, A.prototype.createTabMenu = function (t) {
      var e = document.createElement("div");
      e.className = "wdr-dropdown wdr-shadow-container";
      var i = document.createElement("ul");
      i.className = "wdr-dropdown-content";
      for (var s = 0; s < t.length; s++) this.isDisabled(t[s]) || i.appendChild(t[s].divider ? this.createMenuDivider() : this.createTab(t[s]));
      return e.appendChild(i), e;
    }, A.prototype.createMenuDivider = function () {
      var t = document.createElement("li");
      return t.className = "wdr-v-divider", t;
    }, A.prototype.isDisabled = function (t) {
      return !!this.nullOrUndefined(t) || !1 === t.ios && this.osUtils.isIOS || !1 === t.android && this.osUtils.isAndroid || !1 === t.mobile && this.osUtils.isMobile;
    }, A.prototype.getElementById = function (t, e) {
      var i = function i(t, e) {
        for (var s = 0; s < t.childNodes.length; s++) {
          var r = t.childNodes[s];
          if (r.id == e) return r;
          if (null != (r = i(r, e))) return r;
        }
        return null;
      };
      return i(e || this.toolbarWrapper, t);
    }, A.prototype.osUtils = {
      isIOS: !(!navigator.userAgent.match(/iPhone|iPad|iPod/i) && !navigator.platform.match(/iPhone|iPad|iPod/i)),
      isMac: /Mac/i.test(navigator.platform),
      isAndroid: !!navigator.userAgent.match(/Android/i),
      isBlackBerry: /BlackBerry/i.test(navigator.platform),
      isMobile: navigator.userAgent.match(/iPhone|iPad|iPod/i) || navigator.platform.match(/iPhone|iPad|iPod/i) || navigator.userAgent.match(/Android/i) || /BlackBerry/i.test(navigator.platform)
    }, A.PopupManager = function (t) {
      this.toolbar = t, this.activePopup = null;
    }, A.PopupManager.prototype.createPopup = function () {
      return new A.PopupManager.PopupWindow(this);
    }, A.PopupManager.prototype.addPopup = function (t) {
      if (null != t) {
        this.removePopup(), this.modalOverlay = this.createModalOverlay(), this.activePopup = t, this.toolbar.toolbarWrapper.appendChild(t), this.toolbar.toolbarWrapper.appendChild(this.modalOverlay), this.addLayoutClasses(t), this.centerPopup(t);
        var e = this;
        t.resizeHandler = function () {
          t && (e.addLayoutClasses(t), e.centerPopup(t));
        }, window.addEventListener("resize", t.resizeHandler);
      }
    }, A.PopupManager.prototype.addLayoutClasses = function (t) {
      t.classList.remove("wdr-layout-tablet"), t.classList.remove("wdr-layout-mobile"), t.classList.remove("wdr-layout-mobile-small");
      var e = this.getBoundingRect(this.toolbar.container);
      768 > e.width && t.classList.add("wdr-layout-tablet"), 580 > e.width && t.classList.add("wdr-layout-mobile"), 460 > e.width && t.classList.add("wdr-layout-mobile-small");
    }, A.PopupManager.prototype.centerPopup = function (t) {
      var e = this.getBoundingRect(this.toolbar.container),
        i = this.getBoundingRect(t),
        s = this.getBoundingRect(this.toolbar.toolbarWrapper);
      t.style.zIndex = parseInt(this.modalOverlay.style.zIndex) + 1, this.modalOverlay.style.height = e.height + "px", t.style.left = Math.max(0, (s.width - i.width) / 2) + "px", t.style.top = Math.max(0, (e.height - i.height) / 2) + "px";
    }, A.PopupManager.prototype.removePopup = function (t) {
      t = t || this.activePopup, null != this.modalOverlay && (this.toolbar.toolbarWrapper.removeChild(this.modalOverlay), this.modalOverlay = null), null != t && (this.toolbar.toolbarWrapper.removeChild(t), this.activePopup = null, window.removeEventListener("resize", t.resizeHandler));
    }, A.PopupManager.prototype.getBoundingRect = function (t) {
      var e = t.getBoundingClientRect();
      return {
        left: e.left,
        right: e.right,
        top: e.top,
        bottom: e.bottom,
        width: e.width || t.clientWidth,
        height: e.height || t.clientHeight
      };
    }, A.PopupManager.prototype.createModalOverlay = function () {
      var t = document.createElement("div");
      t.className = "wdr-modal-overlay", t.id = "wdr-popUp-modal-overlay";
      var e = this;
      return t.addEventListener("click", function (t) {
        e.removePopup(e.activePopup);
      }), t;
    }, A.PopupManager.PopupWindow = function (t) {
      this.popupManager = t;
      var e = document.createElement("div");
      e.className = "wdr-panel-content";
      var i = document.createElement("div");
      i.className = "wdr-title-bar";
      var s = document.createElement("div");
      s.className = "wdr-title-text";
      var r = document.createElement("div");
      r.className = "wdr-toolbox", r.style.clear = "both", this.content = document.createElement("div"), this.content.className = "wdr-popup wdr-panel wdr-toolbar-ui wdr-ui", this.content.appendChild(e), e.appendChild(i), i.appendChild(s), this.setTitle = function (t) {
        A.prototype.setText(s, t);
      }, this.setContent = function (t) {
        e.insertBefore(t, i.nextSibling);
      };
      var n = this;
      return this.setToolbar = function (t, a) {
        r.innerHTML = "";
        for (var o = t.length - 1; 0 <= o; o--) {
          var h = document.createElement("a");
          h.setAttribute("href", "javascript:void(0)"), h.className = "wdr-ui-btn" + (t[o].isPositive ? " wdr-ui-btn-dark" : ""), t[o].id && (h.id = t[o].id), A.prototype.setText(h, t[o].label), h.onclick = function (t) {
            return function () {
              null != t && t.call(), n.popupManager.removePopup();
            };
          }(t[o].handler), !0 === t[o].disabled ? A.prototype.addClass(h, "wdr-ui-disabled") : A.prototype.removeClass(h, "wdr-ui-disabled"), t[o].isPositive && (A.prototype.osUtils.isMac || A.prototype.osUtils.isIOS) ? r.appendChild(h) : r.insertBefore(h, r.firstChild);
        }
        a ? (r.classList.add("wdr-ui-col"), i.appendChild(r), i.classList.add("wdr-ui-row"), s.classList.add("wdr-ui-col")) : e.appendChild(r);
      }, this.toolbar = r, this.titleBar = i, this.title = s, this;
    }, A.ColorPicker = function (t, e) {
      function i(t) {
        t = t.target.getAttribute("data-c"), u.drawShades(u.colors[t]), u.setColor(t, u.currentType, !0);
      }
      function s(t) {
        t = t.target.getAttribute("data-c"), u.setColor(t, u.currentType, !0);
      }
      function r(t) {
        u.currentType = t, o.classList.remove("wdr-current"), h.classList.remove("wdr-current"), "bg" == t ? (h.classList.add("wdr-current"), u.setColor(u.backgroundColor, t, !1)) : (o.classList.add("wdr-current"), u.setColor(u.fontColor, t, !1));
      }
      function n() {
        u.closePopup(), u.cancelHandler && u.cancelHandler();
      }
      this.toolbar = t, this.element = document.createElement("div"), this.element.classList.add("wdr-colorpick-wrap"), this.element.classList.add("wdr-width40"), this.colorPickerButton = document.createElement("div"), this.colorPickerButton.classList.add("wdr-colorpick-btn"), this.element.appendChild(this.colorPickerButton), this.colorPickerIcon = document.createElement("span"), this.colorPickerIcon.classList.add("wdr-icon"), this.colorPickerIcon.classList.add("wdr-icon-act_font"), this.colorPickerButton.appendChild(this.colorPickerIcon), this.popup = document.createElement("div"), this.popup.classList.add("wdr-colorpick-popup"), this.popup.onclick = function (t) {
        t.stopPropagation();
      }, e.appendChild(this.popup);
      var a = document.createElement("div");
      a.classList.add("wdr-color-targ-switch"), this.popup.appendChild(a);
      var o = document.createElement("a");
      o.classList.add("wdr-cts-item"), o.classList.add("wdr-current"), o.href = "javascript:void(0);", o.innerHTML = t.Labels.cp_text, o.onclick = function () {
        r("font");
      }, a.appendChild(o);
      var h = document.createElement("a");
      for (var l in h.classList.add("wdr-cts-item"), h.innerHTML = t.Labels.cp_highlight, h.href = "javascript:void(0);", h.onclick = function () {
        r("bg");
      }, a.appendChild(h), (a = document.createElement("div")).classList.add("wdr-cp-sett-row"), this.popup.appendChild(a), this.colorInput = document.createElement("input"), this.colorInput.type = "text", this.colorInput.classList.add("wdr-inp"), this.colorInput.classList.add("wdr-width140"), this.colorInput.classList.add("wdr-tac"), this.colorInput.onchange = function () {
        var t = u.colorInput.value;
        u.isColor(t) && u.setColor(t, u.currentType, !0);
      }, a.appendChild(this.colorInput), this.colorPreview = document.createElement("div"), this.colorPreview.classList.add("wdr-cp-curr-color"), this.colorPreview.classList.add("wdr-width140"), a.appendChild(this.colorPreview), this.mainColors = document.createElement("div"), this.mainColors.classList.add("wdr-row-9colors"), this.popup.appendChild(this.mainColors), this.colors) {
        (a = document.createElement("div")).classList.add("wdr-r9c-item"), a.style.backgroundColor = l, a.setAttribute("data-c", l), a.addEventListener("click", i), this.mainColors.appendChild(a);
        var c = document.createElement("span");
        c.classList.add("wdr-cp-currentmark"), c.classList.add("wdr-icon"), c.classList.add("wdr-icon-act_check"), a.appendChild(c), (c = document.createElement("span")).classList.add("wdr-r9c-arrow"), c.style.borderTopColor = l, a.appendChild(c);
      }
      for (this.shadeColors = document.createElement("div"), this.shadeColors.classList.add("wdr-row-4colors"), this.popup.appendChild(this.shadeColors), l = 0; 8 > l; l++) (a = document.createElement("div")).classList.add("wdr-r4c-item"), a.addEventListener("click", s), this.shadeColors.appendChild(a), (c = document.createElement("span")).classList.add("wdr-cp-currentmark"), c.classList.add("wdr-icon"), c.classList.add("wdr-icon-act_check"), a.appendChild(c);
      this.drawShades(this.colors["#000000"]), (a = document.createElement("div")).classList.add("wdr-cp-btns-row"), this.popup.appendChild(a), (l = document.createElement("a")).innerHTML = t.Labels.apply, l.classList.add("wdr-ui-btn"), l.classList.add("wdr-ui-btn-dark"), l.addEventListener("click", function () {
        u.closePopup(), u.applyHandler && u.applyHandler();
      }), (c = document.createElement("a")).innerHTML = t.Labels.cancel, c.classList.add("wdr-ui-btn"), c.addEventListener("click", n), A.prototype.osUtils.isMac || A.prototype.osUtils.isIOS ? (a.appendChild(c), a.appendChild(l)) : (a.appendChild(l), a.appendChild(c)), this.currentType = "font", this.colorPickerButton.addEventListener("click", function (t) {
        t.stopPropagation(), u.isOpened() ? u.closePopup() : u.openPopup();
      }), document.body.addEventListener("click", function (t) {
        n();
      });
      var u = this;
    }, A.ColorPicker.prototype.colors = {
      "#000000": "#000000 #212121 #424242 #616161 #757575 #9E9E9E #BDBDBD #FFFFFF".split(" "),
      "#F44336": "#D32F2F #E53935 #F44336 #EF5350 #E57373 #EF9A9A #FFCDD2 #FFEBEE".split(" "),
      "#FF9800": "#F57C00 #FB8C00 #FF9800 #FFA726 #FFB74D #FFCC80 #FFE0B2 #FFF3E0".split(" "),
      "#FFEB3B": "#FBC02D #FDD835 #FFEB3B #FFEE58 #FFF176 #FFF59D #FFF9C4 #FFFDE7".split(" "),
      "#8BC34A": "#689F38 #7CB342 #8BC34A #9CCC65 #AED581 #C5E1A5 #DCEDC8 #F1F8E9".split(" "),
      "#009688": "#00796B #00897B #009688 #26A69A #4DB6AC #80CBC4 #B2DFDB #E0F2F1".split(" "),
      "#03A9F4": "#0288D1 #039BE5 #03A9F4 #29B6F6 #4FC3F7 #81D4FA #B3E5FC #E1F5FE".split(" "),
      "#3F51B5": "#303F9F #3949AB #3F51B5 #5C6BC0 #7986CB #9FA8DA #C5CAE9 #E8EAF6".split(" "),
      "#9C27B0": "#7B1FA2 #8E24AA #9C27B0 #AB47BC #BA68C8 #CE93D8 #E1BEE7 #F3E5F5".split(" ")
    }, A.ColorPicker.prototype.isOpened = function () {
      return this.popup.parentElement && this.popup.parentElement.classList.contains("wdr-popup-opened");
    }, A.ColorPicker.prototype.drawShades = function (t) {
      if (t) for (var e = this.shadeColors.children, i = 0; i < e.length; i++) {
        var s = e[i];
        s.setAttribute("data-c", t[i]), s.style.backgroundColor = t[i], s.style.borderRight = "#FFFFFF" == t[i] ? "1px solid #d5d5d5" : "none", s.style.borderBottom = "#FFFFFF" == t[i] ? "1px solid #d5d5d5" : "none";
      }
    }, A.ColorPicker.prototype.setColor = function (t, e, i) {
      "string" == typeof t && 0 == t.indexOf("0x") && (t = "#" + t.substr(2)), "bg" == e ? (this.backgroundColor = t, this.colorPickerButton.style.backgroundColor = t) : (this.fontColor = t, this.colorPickerIcon.style.color = t), this.colorInput.value = t, this.colorPreview.style.backgroundColor = t, this.drawSelected(), i && this.changeHandler && this.changeHandler();
    }, A.ColorPicker.prototype.drawSelected = function () {
      var t = "bg" == this.currentType ? this.backgroundColor : this.fontColor,
        e = this.findMain(t);
      this.drawShades(this.colors[e]);
      for (var i = this.mainColors.children, s = 0; s < i.length; s++) i[s].classList.remove("wdr-current");
      for ((e = this.mainColors.querySelector("[data-c='" + e + "']")) && e.classList.add("wdr-current"), i = this.shadeColors.children, s = 0; s < i.length; s++) i[s].classList.remove("wdr-current");
      (t = this.shadeColors.querySelector("[data-c='" + t + "']")) && t.classList.add("wdr-current");
    }, A.ColorPicker.prototype.findMain = function (t) {
      for (var e in "string" == typeof t && 0 == t.indexOf("0x") && (t = "#" + t.substr(2)), this.colors) if (0 <= this.colors[e].indexOf(t)) return e;
    }, A.ColorPicker.prototype.isColor = function (t) {
      return t.match(/^#?[0-9A-Fa-f]{6}$/g);
    }, A.ColorPicker.prototype.closePopup = function () {
      this.popup.parentElement && this.popup.parentElement.classList.remove("wdr-popup-opened");
    }, A.ColorPicker.prototype.openPopup = function () {
      for (var t = this.toolbar.toolbarWrapper.querySelectorAll(".wdr-colorpick-popup"), e = 0; e < t.length; e++) t[e].parentElement.classList.remove("wdr-popup-opened");
      this.popup.parentElement && (t = this.toolbar.toolbarWrapper.querySelector("#wdr-popup-conditional .wdr-panel-content"), e = this.getWhere(this.colorPickerButton, t), 0 > this.getWhere(this.colorPickerButton, document.body).top - this.popup.clientHeight ? (this.popup.classList.remove("wdr-arrow-down"), this.popup.classList.add("wdr-arrow-up"), this.popup.style.top = this.colorPickerButton.clientHeight + e.top + 11 + "px", this.popup.style.bottom = "") : (this.popup.classList.add("wdr-arrow-down"), this.popup.classList.remove("wdr-arrow-up"), this.popup.style.bottom = t.clientHeight - e.top + 5 + "px", this.popup.style.top = ""), this.popup.style.left = e.left + this.colorPickerButton.clientWidth / 2 + 2 + "px", this.popup.parentElement.classList.add("wdr-popup-opened"));
    }, A.ColorPicker.prototype.getWhere = function (t, e) {
      var i = 0,
        s = 0;
      if (t.offsetParent) {
        i = t.offsetLeft, s = t.offsetTop;
        for (var r = t; (r = r.parentNode) && r != e;) i -= 0, s -= r.scrollTop ? r.scrollTop : 0;
        for (; (t = t.offsetParent) && t != e;) i += t.offsetLeft, s += t.offsetTop;
      }
      return {
        top: s + 0,
        left: i + 0
      };
    };
    /** @license FileSaver.js | Copyright (c) 2016 Eli Grey [https://github.com/eligrey/FileSaver.js] | MIT License [https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md] */
    var c,
      u = u || "undefined" != typeof navigator && navigator.msSaveOrOpenBlob && navigator.msSaveOrOpenBlob.bind(navigator) || function (t) {
        "use strict";

        if ("undefined" == typeof navigator || !/MSIE [1-9]\./.test(navigator.userAgent)) {
          var e = t.document,
            i = e.createElementNS("http://www.w3.org/1999/xhtml", "a"),
            s = ("download" in i),
            r = function r(i) {
              var s = e.createEvent("MouseEvents");
              s.initMouseEvent("click", !0, !1, t, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), i.dispatchEvent(s);
            },
            n = t.webkitRequestFileSystem,
            a = t.requestFileSystem || n || t.mozRequestFileSystem,
            o = function o(e) {
              (t.setImmediate || t.setTimeout)(function () {
                throw e;
              }, 0);
            },
            h = 0,
            l = function l(e) {
              var i = function i() {
                "string" == typeof e ? (t.URL || t.webkitURL || t).revokeObjectURL(e) : e.remove();
              };
              t.chrome ? i() : setTimeout(i, 500);
            },
            A = function A(t, e, i) {
              for (var s = (e = [].concat(e)).length; s--;) {
                var r = t["on" + e[s]];
                if ("function" == typeof r) try {
                  r.call(t, i || t);
                } catch (t) {
                  o(t);
                }
              }
            },
            c = function c(e, o) {
              var c,
                u,
                d,
                f = this,
                p = e.type,
                g = !1,
                w = function w() {
                  A(f, ["writestart", "progress", "write", "writeend"]);
                },
                m = function m() {
                  !g && c || (c = (t.URL || t.webkitURL || t).createObjectURL(e)), u ? u.location.href = c : null == t.open(c, "_blank") && "undefined" != typeof safari && (t.location.href = c), f.readyState = f.DONE, w(), l(c);
                },
                v = function v(t) {
                  return function () {
                    if (f.readyState !== f.DONE) return t.apply(this, arguments);
                  };
                },
                b = {
                  create: !0,
                  exclusive: !1
                };
              f.readyState = f.INIT, o || (o = "download"), s ? (c = (t.URL || t.webkitURL || t).createObjectURL(e), i.href = c, i.download = o, r(i), f.readyState = f.DONE, w(), l(c)) : (t.chrome && p && "application/octet-stream" !== p && (d = e.slice || e.webkitSlice, e = d.call(e, 0, e.size, "application/octet-stream"), g = !0), n && "download" !== o && (o += ".download"), ("application/octet-stream" === p || n) && (u = t), a ? (h += e.size, a(t.TEMPORARY, h, v(function (t) {
                t.root.getDirectory("saved", b, v(function (t) {
                  var i = function i() {
                    t.getFile(o, b, v(function (t) {
                      t.createWriter(v(function (i) {
                        i.onwriteend = function (e) {
                          u.location.href = t.toURL(), f.readyState = f.DONE, A(f, "writeend", e), l(t);
                        }, i.onerror = function () {
                          var t = i.error;
                          t.code !== t.ABORT_ERR && m();
                        }, ["writestart", "progress", "write", "abort"].forEach(function (t) {
                          i["on" + t] = f["on" + t];
                        }), i.write(e), f.abort = function () {
                          i.abort(), f.readyState = f.DONE;
                        }, f.readyState = f.WRITING;
                      }), m);
                    }), m);
                  };
                  t.getFile(o, {
                    create: !1
                  }, v(function (t) {
                    t.remove(), i();
                  }), v(function (t) {
                    t.code === t.NOT_FOUND_ERR ? i() : m();
                  }));
                }), m);
              }), m)) : m());
            },
            u = c.prototype;
          return u.abort = function () {
            this.readyState = this.DONE, A(this, "abort");
          }, u.readyState = u.INIT = 0, u.WRITING = 1, u.DONE = 2, u.error = u.onwritestart = u.onprogress = u.onwrite = u.onabort = u.onerror = u.onwriteend = null, function (t, e) {
            return new c(t, e);
          };
        }
      }("undefined" != typeof self && self || "undefined" != typeof window && window || this.content);
    null !== t ? t.exports = u : null !== i(10) && null != i(11) && (void 0 === (o = function () {
      return u;
    }.call(e, i, e, t)) || (t.exports = o)), function () {
      "use strict";

      function r(t) {
        return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        })(t);
      }
      !function (t) {
        if ("object" !== r(t.console)) {
          t.console = {};
          for (var e, i, s = t.console, n = function n() {}, a = ["memory"], o = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(","); e = a.pop();) s[e] || (s[e] = {});
          for (; i = o.pop();) s[i] || (s[i] = n);
        }
        var h,
          l,
          A,
          c,
          u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        void 0 === t.btoa && (t.btoa = function (t) {
          var e,
            i,
            s,
            r,
            n,
            a = 0,
            o = 0,
            h = "",
            l = [];
          if (!t) return t;
          for (; e = (n = t.charCodeAt(a++) << 16 | t.charCodeAt(a++) << 8 | t.charCodeAt(a++)) >> 18 & 63, i = n >> 12 & 63, s = n >> 6 & 63, r = 63 & n, l[o++] = u.charAt(e) + u.charAt(i) + u.charAt(s) + u.charAt(r), a < t.length;);
          h = l.join("");
          var A = t.length % 3;
          return (A ? h.slice(0, A - 3) : h) + "===".slice(A || 3);
        }), void 0 === t.atob && (t.atob = function (t) {
          var e,
            i,
            s,
            r,
            n,
            a,
            o = 0,
            h = 0,
            l = [];
          if (!t) return t;
          for (t += ""; e = (a = u.indexOf(t.charAt(o++)) << 18 | u.indexOf(t.charAt(o++)) << 12 | (r = u.indexOf(t.charAt(o++))) << 6 | (n = u.indexOf(t.charAt(o++)))) >> 16 & 255, i = a >> 8 & 255, s = 255 & a, l[h++] = 64 == r ? String.fromCharCode(e) : 64 == n ? String.fromCharCode(e, i) : String.fromCharCode(e, i, s), o < t.length;);
          return l.join("");
        }), Array.prototype.map || (Array.prototype.map = function (t) {
          if (null == this || "function" != typeof t) throw new TypeError();
          for (var e = Object(this), i = e.length >>> 0, s = new Array(i), r = 1 < arguments.length ? arguments[1] : void 0, n = 0; n < i; n++) n in e && (s[n] = t.call(r, e[n], n, e));
          return s;
        }), Array.isArray || (Array.isArray = function (t) {
          return "[object Array]" === Object.prototype.toString.call(t);
        }), Array.prototype.forEach || (Array.prototype.forEach = function (t, e) {
          if (null == this || "function" != typeof t) throw new TypeError();
          for (var i = Object(this), s = i.length >>> 0, r = 0; r < s; r++) r in i && t.call(e, i[r], r, i);
        }), Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
          value: function value(t) {
            if (null == this) throw new TypeError('"this" is null or not defined');
            var e = Object(this),
              i = e.length >>> 0;
            if ("function" != typeof t) throw new TypeError("predicate must be a function");
            for (var s = arguments[1], r = 0; r < i;) {
              var n = e[r];
              if (t.call(s, n, r, e)) return n;
              r++;
            }
          },
          configurable: !0,
          writable: !0
        }), Object.keys || (Object.keys = (h = Object.prototype.hasOwnProperty, l = !{
          toString: null
        }.propertyIsEnumerable("toString"), c = (A = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"]).length, function (t) {
          if ("object" !== r(t) && ("function" != typeof t || null === t)) throw new TypeError();
          var e,
            i,
            s = [];
          for (e in t) h.call(t, e) && s.push(e);
          if (l) for (i = 0; i < c; i++) h.call(t, A[i]) && s.push(A[i]);
          return s;
        })), "function" != typeof Object.assign && (Object.assign = function (t) {
          if (null == t) throw new TypeError("Cannot convert undefined or null to object");
          t = Object(t);
          for (var e = 1; e < arguments.length; e++) {
            var i = arguments[e];
            if (null != i) for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (t[s] = i[s]);
          }
          return t;
        }), String.prototype.trim || (String.prototype.trim = function () {
          return this.replace(/^\s+|\s+$/g, "");
        }), String.prototype.trimLeft || (String.prototype.trimLeft = function () {
          return this.replace(/^\s+/g, "");
        }), String.prototype.trimRight || (String.prototype.trimRight = function () {
          return this.replace(/\s+$/g, "");
        }), Number.isInteger = Number.isInteger || function (t) {
          return "number" == typeof t && isFinite(t) && Math.floor(t) === t;
        };
      }("undefined" != typeof self && self || "undefined" != typeof window && window || void 0 !== s && s || Function('return typeof this === "object" && this.content')() || Function("return this")());
      var n,
        a,
        h,
        l,
        A,
        c,
        u,
        d,
        f,
        p,
        g,
        w,
        m,
        v,
        b,
        B,
        y,
        C,
        F,
        x,
        N,
        E,
        U,
        Q,
        L,
        S,
        k,
        H,
        I,
        O,
        T,
        P,
        j,
        M,
        D,
        R,
        _,
        z,
        K,
        q,
        V,
        J,
        G,
        X,
        W,
        Y,
        Z,
        $,
        tt,
        et,
        it,
        st,
        rt,
        nt,
        at,
        ot,
        ht,
        lt,
        At,
        ct,
        ut,
        dt,
        ft = function (s) {
          function n(t) {
            if ("object" !== r(t)) throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
            var e = {};
            this.subscribe = function (t, i, s) {
              if (s = s || !1, "string" != typeof t || "function" != typeof i || "boolean" != typeof s) throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
              e.hasOwnProperty(t) || (e[t] = {});
              var r = Math.random().toString(35);
              return e[t][r] = [i, !!s], r;
            }, this.unsubscribe = function (t) {
              for (var i in e) if (e[i][t]) return delete e[i][t], 0 === Object.keys(e[i]).length && delete e[i], !0;
              return !1;
            }, this.publish = function (i) {
              if (e.hasOwnProperty(i)) {
                var r = Array.prototype.slice.call(arguments, 1),
                  n = [];
                for (var a in e[i]) {
                  var o = e[i][a];
                  try {
                    o[0].apply(t, r);
                  } catch (i) {
                    s.console && console.error("jsPDF PubSub Error", i.message, i);
                  }
                  o[1] && n.push(a);
                }
                n.length && n.forEach(this.unsubscribe);
              }
            }, this.getTopics = function () {
              return e;
            };
          }
          function a(t, e, i, o) {
            var h = {},
              l = [],
              A = 1;
            "object" === r(t) && (t = (h = t).orientation, e = h.unit || e, i = h.format || i, o = h.compress || h.compressPdf || o, l = h.filters || (!0 === o ? ["FlateEncode"] : l), A = "number" == typeof h.userUnit ? Math.abs(h.userUnit) : 1), e = e || "mm", t = ("" + (t || "P")).toLowerCase();
            var c = h.putOnlyUsedFonts || !0,
              u = {},
              d = {
                internal: {},
                __private__: {}
              };
            d.__private__.PubSub = n;
            var f = "1.3",
              p = d.__private__.getPdfVersion = function () {
                return f;
              },
              g = (d.__private__.setPdfVersion = function (t) {
                f = t;
              }, {
                a0: [2383.94, 3370.39],
                a1: [1683.78, 2383.94],
                a2: [1190.55, 1683.78],
                a3: [841.89, 1190.55],
                a4: [595.28, 841.89],
                a5: [419.53, 595.28],
                a6: [297.64, 419.53],
                a7: [209.76, 297.64],
                a8: [147.4, 209.76],
                a9: [104.88, 147.4],
                a10: [73.7, 104.88],
                b0: [2834.65, 4008.19],
                b1: [2004.09, 2834.65],
                b2: [1417.32, 2004.09],
                b3: [1000.63, 1417.32],
                b4: [708.66, 1000.63],
                b5: [498.9, 708.66],
                b6: [354.33, 498.9],
                b7: [249.45, 354.33],
                b8: [175.75, 249.45],
                b9: [124.72, 175.75],
                b10: [87.87, 124.72],
                c0: [2599.37, 3676.54],
                c1: [1836.85, 2599.37],
                c2: [1298.27, 1836.85],
                c3: [918.43, 1298.27],
                c4: [649.13, 918.43],
                c5: [459.21, 649.13],
                c6: [323.15, 459.21],
                c7: [229.61, 323.15],
                c8: [161.57, 229.61],
                c9: [113.39, 161.57],
                c10: [79.37, 113.39],
                dl: [311.81, 623.62],
                letter: [612, 792],
                "government-letter": [576, 756],
                legal: [612, 1008],
                "junior-legal": [576, 360],
                ledger: [1224, 792],
                tabloid: [792, 1224],
                "credit-card": [153, 243]
              }),
              w = (d.__private__.getPageFormats = function () {
                return g;
              }, d.__private__.getPageFormat = function (t) {
                return g[t];
              });
            "string" == typeof i && (i = w(i)), i = i || w("a4");
            var m,
              v = d.f2 = d.__private__.f2 = function (t) {
                if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
                return t.toFixed(2);
              },
              b = d.__private__.f3 = function (t) {
                if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f3");
                return t.toFixed(3);
              },
              B = "00000000000000000000000000000000",
              y = d.__private__.getFileId = function () {
                return B;
              },
              C = d.__private__.setFileId = function (t) {
                return t = t || "12345678901234567890123456789012".split("").map(function () {
                  return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
                }).join(""), B = t;
              };
            d.setFileId = function (t) {
              return C(t), this;
            }, d.getFileId = function () {
              return y();
            };
            var F = d.__private__.convertDateToPDFDate = function (t) {
                var e = t.getTimezoneOffset(),
                  i = e < 0 ? "+" : "-",
                  s = Math.floor(Math.abs(e / 60)),
                  r = Math.abs(e % 60),
                  n = [i, T(s), "'", T(r), "'"].join("");
                return ["D:", t.getFullYear(), T(t.getMonth() + 1), T(t.getDate()), T(t.getHours()), T(t.getMinutes()), T(t.getSeconds()), n].join("");
              },
              x = d.__private__.convertPDFDateToDate = function (t) {
                var e = parseInt(t.substr(2, 4), 10),
                  i = parseInt(t.substr(6, 2), 10) - 1,
                  s = parseInt(t.substr(8, 2), 10),
                  r = parseInt(t.substr(10, 2), 10),
                  n = parseInt(t.substr(12, 2), 10),
                  a = parseInt(t.substr(14, 2), 10);
                return parseInt(t.substr(16, 2), 10), parseInt(t.substr(20, 2), 10), new Date(e, i, s, r, n, a, 0);
              },
              N = d.__private__.setCreationDate = function (t) {
                var e;
                if (void 0 === t && (t = new Date()), "object" === r(t) && "[object Date]" === Object.prototype.toString.call(t)) e = F(t);else {
                  if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
                  e = t;
                }
                return m = e;
              },
              E = d.__private__.getCreationDate = function (t) {
                var e = m;
                return "jsDate" === t && (e = x(m)), e;
              };
            d.setCreationDate = function (t) {
              return N(t), this;
            }, d.getCreationDate = function (t) {
              return E(t);
            };
            var U,
              Q,
              L,
              S,
              k,
              H,
              I,
              O,
              T = d.__private__.padd2 = function (t) {
                return ("0" + parseInt(t)).slice(-2);
              },
              P = !1,
              j = [],
              M = [],
              D = 0,
              R = (d.__private__.setCustomOutputDestination = function (t) {
                Q = t;
              }, d.__private__.resetCustomOutputDestination = function (t) {
                Q = void 0;
              }, d.__private__.out = function (t) {
                var e;
                return t = "string" == typeof t ? t : t.toString(), (e = void 0 === Q ? P ? j[U] : M : Q).push(t), P || (D += t.length + 1), e;
              }),
              _ = d.__private__.write = function (t) {
                return R(1 === arguments.length ? t.toString() : Array.prototype.join.call(arguments, " "));
              },
              z = d.__private__.getArrayBuffer = function (t) {
                for (var e = t.length, i = new ArrayBuffer(e), s = new Uint8Array(i); e--;) s[e] = t.charCodeAt(e);
                return i;
              },
              K = [["Helvetica", "helvetica", "normal", "WinAnsiEncoding"], ["Helvetica-Bold", "helvetica", "bold", "WinAnsiEncoding"], ["Helvetica-Oblique", "helvetica", "italic", "WinAnsiEncoding"], ["Helvetica-BoldOblique", "helvetica", "bolditalic", "WinAnsiEncoding"], ["Courier", "courier", "normal", "WinAnsiEncoding"], ["Courier-Bold", "courier", "bold", "WinAnsiEncoding"], ["Courier-Oblique", "courier", "italic", "WinAnsiEncoding"], ["Courier-BoldOblique", "courier", "bolditalic", "WinAnsiEncoding"], ["Times-Roman", "times", "normal", "WinAnsiEncoding"], ["Times-Bold", "times", "bold", "WinAnsiEncoding"], ["Times-Italic", "times", "italic", "WinAnsiEncoding"], ["Times-BoldItalic", "times", "bolditalic", "WinAnsiEncoding"], ["ZapfDingbats", "zapfdingbats", "normal", null], ["Symbol", "symbol", "normal", null]],
              q = (d.__private__.getStandardFonts = function (t) {
                return K;
              }, h.fontSize || 16),
              V = (d.__private__.setFontSize = d.setFontSize = function (t) {
                return q = t, this;
              }, d.__private__.getFontSize = d.getFontSize = function () {
                return q;
              }),
              J = h.R2L || !1,
              G = (d.__private__.setR2L = d.setR2L = function (t) {
                return J = t, this;
              }, d.__private__.getR2L = d.getR2L = function (t) {
                return J;
              }, d.__private__.setZoomMode = function (t) {
                if (/^\d*\.?\d*\%$/.test(t)) L = t;else if (isNaN(t)) {
                  if (-1 === [void 0, null, "fullwidth", "fullheight", "fullpage", "original"].indexOf(t)) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + t + '" is not recognized.');
                  L = t;
                } else L = parseInt(t, 10);
              }),
              X = (d.__private__.getZoomMode = function () {
                return L;
              }, d.__private__.setPageMode = function (t) {
                if (-1 == [void 0, null, "UseNone", "UseOutlines", "UseThumbs", "FullScreen"].indexOf(t)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + t + '" is not recognized.');
                S = t;
              }),
              W = (d.__private__.getPageMode = function () {
                return S;
              }, d.__private__.setLayoutMode = function (t) {
                if (-1 == [void 0, null, "continuous", "single", "twoleft", "tworight", "two"].indexOf(t)) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + t + '" is not recognized.');
                k = t;
              }),
              Y = (d.__private__.getLayoutMode = function () {
                return k;
              }, d.__private__.setDisplayMode = d.setDisplayMode = function (t, e, i) {
                return G(t), W(e), X(i), this;
              }, {
                title: "",
                subject: "",
                author: "",
                keywords: "",
                creator: ""
              }),
              Z = (d.__private__.getDocumentProperty = function (t) {
                if (-1 === Object.keys(Y).indexOf(t)) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
                return Y[t];
              }, d.__private__.getDocumentProperties = function (t) {
                return Y;
              }, d.__private__.setDocumentProperties = d.setProperties = d.setDocumentProperties = function (t) {
                for (var e in Y) Y.hasOwnProperty(e) && t[e] && (Y[e] = t[e]);
                return this;
              }, d.__private__.setDocumentProperty = function (t, e) {
                if (-1 === Object.keys(Y).indexOf(t)) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
                return Y[t] = e;
              }, 0),
              $ = [],
              tt = {},
              et = {},
              it = 0,
              st = [],
              rt = [],
              nt = new n(d),
              at = h.hotfixes || [],
              ot = d.__private__.newObject = function () {
                var t = ht();
                return lt(t, !0), t;
              },
              ht = d.__private__.newObjectDeferred = function () {
                return $[++Z] = function () {
                  return D;
                }, Z;
              },
              lt = function lt(t, e) {
                return e = "boolean" == typeof e && e, $[t] = D, e && R(t + " 0 obj"), t;
              },
              At = d.__private__.newAdditionalObject = function () {
                var t = {
                  objId: ht(),
                  content: ""
                };
                return rt.push(t), t;
              },
              ct = ht(),
              ut = ht(),
              dt = d.__private__.decodeColorString = function (t) {
                var e = t.split(" ");
                if (2 === e.length && ("g" === e[1] || "G" === e[1])) {
                  var i = parseFloat(e[0]);
                  e = [i, i, i, "r"];
                }
                for (var s = "#", r = 0; r < 3; r++) s += ("0" + Math.floor(255 * parseFloat(e[r])).toString(16)).slice(-2);
                return s;
              },
              ft = d.__private__.encodeColorString = function (t) {
                var e;
                "string" == typeof t && (t = {
                  ch1: t
                });
                var i = t.ch1,
                  s = t.ch2,
                  n = t.ch3,
                  a = t.ch4,
                  o = (t.precision, "draw" === t.pdfColorType ? ["G", "RG", "K"] : ["g", "rg", "k"]);
                if ("string" == typeof i && "#" !== i.charAt(0)) {
                  var h = new RGBColor(i);
                  if (h.ok) i = h.toHex();else if (!/^\d*\.?\d*$/.test(i)) throw new Error('Invalid color "' + i + '" passed to jsPDF.encodeColorString.');
                }
                if ("string" == typeof i && /^#[0-9A-Fa-f]{3}$/.test(i) && (i = "#" + i[1] + i[1] + i[2] + i[2] + i[3] + i[3]), "string" == typeof i && /^#[0-9A-Fa-f]{6}$/.test(i)) {
                  var l = parseInt(i.substr(1), 16);
                  i = l >> 16 & 255, s = l >> 8 & 255, n = 255 & l;
                }
                if (void 0 === s || void 0 === a && i === s && s === n) {
                  if ("string" == typeof i) e = i + " " + o[0];else switch (t.precision) {
                    case 2:
                      e = v(i / 255) + " " + o[0];
                      break;
                    case 3:
                    default:
                      e = b(i / 255) + " " + o[0];
                  }
                } else if (void 0 === a || "object" === r(a)) {
                  if (a && !isNaN(a.a) && 0 === a.a) return ["1.000", "1.000", "1.000", o[1]].join(" ");
                  if ("string" == typeof i) e = [i, s, n, o[1]].join(" ");else switch (t.precision) {
                    case 2:
                      e = [v(i / 255), v(s / 255), v(n / 255), o[1]].join(" ");
                      break;
                    default:
                    case 3:
                      e = [b(i / 255), b(s / 255), b(n / 255), o[1]].join(" ");
                  }
                } else if ("string" == typeof i) e = [i, s, n, a, o[2]].join(" ");else switch (t.precision) {
                  case 2:
                    e = [v(i / 255), v(s / 255), v(n / 255), v(a / 255), o[2]].join(" ");
                    break;
                  case 3:
                  default:
                    e = [b(i / 255), b(s / 255), b(n / 255), b(a / 255), o[2]].join(" ");
                }
                return e;
              },
              pt = d.__private__.getFilters = function () {
                return l;
              },
              gt = d.__private__.putStream = function (t) {
                var e,
                  i = (t = t || {}).data || "",
                  s = t.filters || pt(),
                  r = t.alreadyAppliedFilters || [],
                  n = t.addLength1 || !1,
                  o = i.length;
                !0 === s && (s = ["FlateEncode"]);
                var h = t.additionalKeyValues || [],
                  l = (e = void 0 !== a.API.processDataByFilters ? a.API.processDataByFilters(i, s) : {
                    data: i,
                    reverseChain: []
                  }).reverseChain + (Array.isArray(r) ? r.join(" ") : r.toString());
                0 !== e.data.length && (h.push({
                  key: "Length",
                  value: e.data.length
                }), !0 === n && h.push({
                  key: "Length1",
                  value: o
                })), 0 != l.length && (l.split("/").length - 1 == 1 ? h.push({
                  key: "Filter",
                  value: l
                }) : h.push({
                  key: "Filter",
                  value: "[" + l + "]"
                })), R("<<");
                for (var A = 0; A < h.length; A++) R("/" + h[A].key + " " + h[A].value);
                R(">>"), 0 !== e.data.length && (R("stream"), R(e.data), R("endstream"));
              },
              wt = d.__private__.putPage = function (t) {
                t.mediaBox;
                var e = t.number,
                  i = t.data,
                  s = t.objId,
                  r = t.contentsObjId;
                lt(s, !0), st[U].mediaBox.topRightX, st[U].mediaBox.bottomLeftX, st[U].mediaBox.topRightY, st[U].mediaBox.bottomLeftY, R("<</Type /Page"), R("/Parent " + t.rootDictionaryObjId + " 0 R"), R("/Resources " + t.resourceDictionaryObjId + " 0 R"), R("/MediaBox [" + parseFloat(v(t.mediaBox.bottomLeftX)) + " " + parseFloat(v(t.mediaBox.bottomLeftY)) + " " + v(t.mediaBox.topRightX) + " " + v(t.mediaBox.topRightY) + "]"), null !== t.cropBox && R("/CropBox [" + v(t.cropBox.bottomLeftX) + " " + v(t.cropBox.bottomLeftY) + " " + v(t.cropBox.topRightX) + " " + v(t.cropBox.topRightY) + "]"), null !== t.bleedBox && R("/BleedBox [" + v(t.bleedBox.bottomLeftX) + " " + v(t.bleedBox.bottomLeftY) + " " + v(t.bleedBox.topRightX) + " " + v(t.bleedBox.topRightY) + "]"), null !== t.trimBox && R("/TrimBox [" + v(t.trimBox.bottomLeftX) + " " + v(t.trimBox.bottomLeftY) + " " + v(t.trimBox.topRightX) + " " + v(t.trimBox.topRightY) + "]"), null !== t.artBox && R("/ArtBox [" + v(t.artBox.bottomLeftX) + " " + v(t.artBox.bottomLeftY) + " " + v(t.artBox.topRightX) + " " + v(t.artBox.topRightY) + "]"), "number" == typeof t.userUnit && 1 !== t.userUnit && R("/UserUnit " + t.userUnit), nt.publish("putPage", {
                  objId: s,
                  pageContext: st[e],
                  pageNumber: e,
                  page: i
                }), R("/Contents " + r + " 0 R"), R(">>"), R("endobj");
                var n = i.join("\n");
                return lt(r, !0), gt({
                  data: n,
                  filters: pt()
                }), R("endobj"), s;
              },
              mt = d.__private__.putPages = function () {
                var t,
                  e,
                  i = [];
                for (t = 1; t <= it; t++) st[t].objId = ht(), st[t].contentsObjId = ht();
                for (t = 1; t <= it; t++) i.push(wt({
                  number: t,
                  data: j[t],
                  objId: st[t].objId,
                  contentsObjId: st[t].contentsObjId,
                  mediaBox: st[t].mediaBox,
                  cropBox: st[t].cropBox,
                  bleedBox: st[t].bleedBox,
                  trimBox: st[t].trimBox,
                  artBox: st[t].artBox,
                  userUnit: st[t].userUnit,
                  rootDictionaryObjId: ct,
                  resourceDictionaryObjId: ut
                }));
                lt(ct, !0), R("<</Type /Pages");
                var s = "/Kids [";
                for (e = 0; e < it; e++) s += i[e] + " 0 R ";
                R(s + "]"), R("/Count " + it), R(">>"), R("endobj"), nt.publish("postPutPages");
              },
              vt = function vt(t, e, i) {
                et.hasOwnProperty(e) || (et[e] = {}), et[e][i] = t;
              },
              bt = function bt(t, e, i, s, r) {
                r = r || !1;
                var n = "F" + (Object.keys(tt).length + 1).toString(10),
                  a = {
                    id: n,
                    postScriptName: t,
                    fontName: e,
                    fontStyle: i,
                    encoding: s,
                    isStandardFont: r,
                    metadata: {}
                  };
                return nt.publish("addFont", {
                  font: a,
                  instance: this
                }), void 0 !== n && (tt[n] = a, vt(n, e, i)), n;
              },
              Bt = d.__private__.pdfEscape = d.pdfEscape = function (t, e) {
                return function (t, e) {
                  var i, s, r, n, a, o, h, l, A;
                  if (r = (e = e || {}).sourceEncoding || "Unicode", a = e.outputEncoding, (e.autoencode || a) && tt[H].metadata && tt[H].metadata[r] && tt[H].metadata[r].encoding && (n = tt[H].metadata[r].encoding, !a && tt[H].encoding && (a = tt[H].encoding), !a && n.codePages && (a = n.codePages[0]), "string" == typeof a && (a = n[a]), a)) {
                    for (h = !1, o = [], i = 0, s = t.length; i < s; i++) (l = a[t.charCodeAt(i)]) ? o.push(String.fromCharCode(l)) : o.push(t[i]), o[i].charCodeAt(0) >> 8 && (h = !0);
                    t = o.join("");
                  }
                  for (i = t.length; void 0 === h && 0 !== i;) t.charCodeAt(i - 1) >> 8 && (h = !0), i--;
                  if (!h) return t;
                  for (o = e.noBOM ? [] : [254, 255], i = 0, s = t.length; i < s; i++) {
                    if ((A = (l = t.charCodeAt(i)) >> 8) >> 8) throw new Error("Character at position " + i + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
                    o.push(A), o.push(l - (A << 8));
                  }
                  return String.fromCharCode.apply(void 0, o);
                }(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
              },
              yt = d.__private__.beginPage = function (t, e) {
                var s,
                  r = "string" == typeof e && e.toLowerCase();
                if ("string" == typeof t && (s = w(t.toLowerCase())) && (t = s[0], e = s[1]), Array.isArray(t) && (e = t[1], t = t[0]), (isNaN(t) || isNaN(e)) && (t = i[0], e = i[1]), r) {
                  switch (r.substr(0, 1)) {
                    case "l":
                      t < e && (r = "s");
                      break;
                    case "p":
                      e < t && (r = "s");
                  }
                  "s" === r && (s = t, t = e, e = s);
                }
                (14400 < t || 14400 < e) && (console.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), t = Math.min(14400, t), e = Math.min(14400, e)), i = [t, e], P = !0, j[++it] = [], st[it] = {
                  objId: 0,
                  contentsObjId: 0,
                  userUnit: Number(A),
                  artBox: null,
                  bleedBox: null,
                  cropBox: null,
                  trimBox: null,
                  mediaBox: {
                    bottomLeftX: 0,
                    bottomLeftY: 0,
                    topRightX: Number(t),
                    topRightY: Number(e)
                  }
                }, Ft(it);
              },
              Ct = function Ct() {
                yt.apply(this, arguments), Kt(zt), R(Zt), 0 !== re && R(re + " J"), 0 !== ae && R(ae + " j"), nt.publish("addPage", {
                  pageNumber: it
                });
              },
              Ft = function Ft(t) {
                0 < t && t <= it && (U = t);
              },
              xt = d.__private__.getNumberOfPages = d.getNumberOfPages = function () {
                return j.length - 1;
              },
              Nt = function Nt(t, e, i) {
                var s,
                  r = void 0;
                return i = i || {}, t = void 0 !== t ? t : tt[H].fontName, e = void 0 !== e ? e : tt[H].fontStyle, s = t.toLowerCase(), void 0 !== et[s] && void 0 !== et[s][e] ? r = et[s][e] : void 0 !== et[t] && void 0 !== et[t][e] ? r = et[t][e] : !1 === i.disableWarning && console.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), r || i.noFallback || null == (r = et.times[e]) && (r = et.times.normal), r;
              },
              Et = d.__private__.putInfo = function () {
                for (var t in ot(), R("<<"), R("/Producer (jsPDF " + a.version + ")"), Y) Y.hasOwnProperty(t) && Y[t] && R("/" + t.substr(0, 1).toUpperCase() + t.substr(1) + " (" + Bt(Y[t]) + ")");
                R("/CreationDate (" + m + ")"), R(">>"), R("endobj");
              },
              Ut = d.__private__.putCatalog = function (t) {
                var e = (t = t || {}).rootDictionaryObjId || ct;
                switch (ot(), R("<<"), R("/Type /Catalog"), R("/Pages " + e + " 0 R"), L || (L = "fullwidth"), L) {
                  case "fullwidth":
                    R("/OpenAction [3 0 R /FitH null]");
                    break;
                  case "fullheight":
                    R("/OpenAction [3 0 R /FitV null]");
                    break;
                  case "fullpage":
                    R("/OpenAction [3 0 R /Fit]");
                    break;
                  case "original":
                    R("/OpenAction [3 0 R /XYZ null null 1]");
                    break;
                  default:
                    var i = "" + L;
                    "%" === i.substr(i.length - 1) && (L = parseInt(L) / 100), "number" == typeof L && R("/OpenAction [3 0 R /XYZ null null " + v(L) + "]");
                }
                switch (k || (k = "continuous"), k) {
                  case "continuous":
                    R("/PageLayout /OneColumn");
                    break;
                  case "single":
                    R("/PageLayout /SinglePage");
                    break;
                  case "two":
                  case "twoleft":
                    R("/PageLayout /TwoColumnLeft");
                    break;
                  case "tworight":
                    R("/PageLayout /TwoColumnRight");
                }
                S && R("/PageMode /" + S), nt.publish("putCatalog"), R(">>"), R("endobj");
              },
              Qt = d.__private__.putTrailer = function () {
                R("trailer"), R("<<"), R("/Size " + (Z + 1)), R("/Root " + Z + " 0 R"), R("/Info " + (Z - 1) + " 0 R"), R("/ID [ <" + B + "> <" + B + "> ]"), R(">>");
              },
              St = d.__private__.putHeader = function () {
                R("%PDF-" + f), R("%ºß¬à");
              },
              kt = d.__private__.putXRef = function () {
                var t = 1,
                  e = "0000000000";
                for (R("xref"), R("0 " + (Z + 1)), R("0000000000 65535 f "), t = 1; t <= Z; t++) "function" == typeof $[t] ? R((e + $[t]()).slice(-10) + " 00000 n ") : void 0 !== $[t] ? R((e + $[t]).slice(-10) + " 00000 n ") : R("0000000000 00000 n ");
              },
              Ht = d.__private__.buildDocument = function () {
                P = !1, D = Z = 0, M = [], $ = [], rt = [], ct = ht(), ut = ht(), nt.publish("buildDocument"), St(), mt(), function () {
                  nt.publish("putAdditionalObjects");
                  for (var t = 0; t < rt.length; t++) {
                    var e = rt[t];
                    lt(e.objId, !0), R(e.content), R("endobj");
                  }
                  nt.publish("postPutAdditionalObjects");
                }(), function () {
                  for (var t in tt) tt.hasOwnProperty(t) && (!1 === c || !0 === c && u.hasOwnProperty(t)) && (e = tt[t], nt.publish("putFont", {
                    font: e,
                    out: R,
                    newObject: ot,
                    putStream: gt
                  }), !0 !== e.isAlreadyPutted && (e.objectNumber = ot(), R("<<"), R("/Type /Font"), R("/BaseFont /" + e.postScriptName), R("/Subtype /Type1"), "string" == typeof e.encoding && R("/Encoding /" + e.encoding), R("/FirstChar 32"), R("/LastChar 255"), R(">>"), R("endobj")));
                  var e;
                }(), nt.publish("putResources"), lt(ut, !0), R("<<"), function () {
                  for (var t in R("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), R("/Font <<"), tt) tt.hasOwnProperty(t) && (!1 === c || !0 === c && u.hasOwnProperty(t)) && R("/" + t + " " + tt[t].objectNumber + " 0 R");
                  R(">>"), R("/XObject <<"), nt.publish("putXobjectDict"), R(">>");
                }(), R(">>"), R("endobj"), nt.publish("postPutResources"), Et(), Ut();
                var t = D;
                return kt(), Qt(), R("startxref"), R("" + t), R("%%EOF"), P = !0, M.join("\n");
              },
              It = d.__private__.getBlob = function (t) {
                return new Blob([z(t)], {
                  type: "application/pdf"
                });
              },
              Ot = d.output = d.__private__.output = ((O = function O(t, e) {
                e = e || {};
                var i = Ht();
                switch ("string" == typeof e ? e = {
                  filename: e
                } : e.filename = e.filename || "generated.pdf", t) {
                  case void 0:
                    return i;
                  case "save":
                    d.save(e.filename);
                    break;
                  case "arraybuffer":
                    return z(i);
                  case "blob":
                    return It(i);
                  case "bloburi":
                  case "bloburl":
                    if (void 0 !== s.URL && "function" == typeof s.URL.createObjectURL) return s.URL && s.URL.createObjectURL(It(i)) || void 0;
                    console.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
                    break;
                  case "datauristring":
                  case "dataurlstring":
                    return "data:application/pdf;filename=" + e.filename + ";base64," + btoa(i);
                  case "dataurlnewwindow":
                    var r = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring") + '"></iframe></body></html>',
                      n = s.open();
                    if (null !== n && n.document.write(r), n || "undefined" == typeof safari) return n;
                  case "datauri":
                  case "dataurl":
                    return s.document.location.href = "data:application/pdf;filename=" + e.filename + ";base64," + btoa(i);
                  default:
                    return null;
                }
              }).foo = function () {
                try {
                  return O.apply(this, arguments);
                } catch (i) {
                  var t = i.stack || "";
                  ~t.indexOf(" at ") && (t = t.split(" at ")[1]);
                  var e = "Error in function " + t.split("\n")[0].split("<")[0] + ": " + i.message;
                  if (!s.console) throw new Error(e);
                  s.console.error(e, i), s.alert && alert(e);
                }
              }, (O.foo.bar = O).foo),
              Tt = function Tt(t) {
                return !0 === Array.isArray(at) && -1 < at.indexOf(t);
              };
            switch (e) {
              case "pt":
                I = 1;
                break;
              case "mm":
                I = 72 / 25.4;
                break;
              case "cm":
                I = 72 / 2.54;
                break;
              case "in":
                I = 72;
                break;
              case "px":
                I = 1 == Tt("px_scaling") ? .75 : 96 / 72;
                break;
              case "pc":
              case "em":
                I = 12;
                break;
              case "ex":
                I = 6;
                break;
              default:
                throw new Error("Invalid unit: " + e);
            }
            N(), C();
            var Pt = d.__private__.getPageInfo = function (t) {
                if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
                return {
                  objId: st[t].objId,
                  pageNumber: t,
                  pageContext: st[t]
                };
              },
              jt = d.__private__.getPageInfoByObjId = function (t) {
                for (var e in st) if (st[e].objId === t) break;
                if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
                return Pt(e);
              },
              Mt = d.__private__.getCurrentPageInfo = function () {
                return {
                  objId: st[U].objId,
                  pageNumber: U,
                  pageContext: st[U]
                };
              };
            d.addPage = function () {
              return Ct.apply(this, arguments), this;
            }, d.setPage = function () {
              return Ft.apply(this, arguments), this;
            }, d.insertPage = function (t) {
              return this.addPage(), this.movePage(U, t), this;
            }, d.movePage = function (t, e) {
              if (e < t) {
                for (var i = j[t], s = st[t], r = t; e < r; r--) j[r] = j[r - 1], st[r] = st[r - 1];
                j[e] = i, st[e] = s, this.setPage(e);
              } else if (t < e) {
                for (i = j[t], s = st[t], r = t; r < e; r++) j[r] = j[r + 1], st[r] = st[r + 1];
                j[e] = i, st[e] = s, this.setPage(e);
              }
              return this;
            }, d.deletePage = function () {
              return function (t) {
                0 < t && t <= it && (j.splice(t, 1), --it < U && (U = it), this.setPage(U));
              }.apply(this, arguments), this;
            }, d.__private__.text = d.text = function (t, e, i, s) {
              var n;
              "number" != typeof t || "number" != typeof e || "string" != typeof i && !Array.isArray(i) || (n = i, i = e, e = t, t = n);
              var a = arguments[3],
                o = arguments[4],
                h = arguments[5];
              if ("object" === r(a) && null !== a || ("string" == typeof o && (h = o, o = null), "string" == typeof a && (h = a, a = null), "number" == typeof a && (o = a, a = null), s = {
                flags: a,
                angle: o,
                align: h
              }), (a = a || {}).noBOM = a.noBOM || !0, a.autoencode = a.autoencode || !0, isNaN(e) || isNaN(i) || null == t) throw new Error("Invalid arguments passed to jsPDF.text");
              if (0 === t.length) return d;
              var l,
                A = "",
                c = "number" == typeof s.lineHeightFactor ? s.lineHeightFactor : _t,
                d = s.scope || this;
              function f(t) {
                for (var e, i = t.concat(), s = [], r = i.length; r--;) "string" == typeof (e = i.shift()) ? s.push(e) : Array.isArray(t) && 1 === e.length ? s.push(e[0]) : s.push([e[0], e[1], e[2]]);
                return s;
              }
              function p(t, e) {
                var i;
                if ("string" == typeof t) i = e(t)[0];else if (Array.isArray(t)) {
                  for (var s, r, n = t.concat(), a = [], o = n.length; o--;) "string" == typeof (s = n.shift()) ? a.push(e(s)[0]) : Array.isArray(s) && "string" === s[0] && (r = e(s[0], s[1], s[2]), a.push([r[0], r[1], r[2]]));
                  i = a;
                }
                return i;
              }
              var g = !1,
                w = !0;
              if ("string" == typeof t) g = !0;else if (Array.isArray(t)) {
                for (var m, B = t.concat(), y = [], C = B.length; C--;) ("string" != typeof (m = B.shift()) || Array.isArray(m) && "string" != typeof m[0]) && (w = !1);
                g = w;
              }
              if (!1 === g) throw new Error('Type of text must be string or Array. "' + t + '" is not recognized.');
              var F = tt[H].encoding;
              "WinAnsiEncoding" !== F && "StandardEncoding" !== F || (t = p(t, function (t, e, i) {
                return [(r = t, r = r.split("\t").join(Array(s.TabLen || 9).join(" ")), Bt(r, a)), e, i];
                var r;
              })), "string" == typeof t && (t = t.match(/[\r?\n]/) ? t.split(/\r\n|\r|\n/g) : [t]);
              var x = q / d.internal.scaleFactor,
                N = x * (_t - 1);
              switch (s.baseline) {
                case "bottom":
                  i -= N;
                  break;
                case "top":
                  i += x - N;
                  break;
                case "hanging":
                  i += x - 2 * N;
                  break;
                case "middle":
                  i += x / 2 - N;
              }
              0 < (_ = s.maxWidth || 0) && ("string" == typeof t ? t = d.splitTextToSize(t, _) : "[object Array]" === Object.prototype.toString.call(t) && (t = d.splitTextToSize(t.join(" "), _)));
              var E = {
                text: t,
                x: e,
                y: i,
                options: s,
                mutex: {
                  pdfEscape: Bt,
                  activeFontKey: H,
                  fonts: tt,
                  activeFontSize: q
                }
              };
              nt.publish("preProcessText", E), t = E.text, o = (s = E.options).angle;
              var U = d.internal.scaleFactor,
                Q = [];
              if (o) {
                o *= Math.PI / 180;
                var L = Math.cos(o),
                  S = Math.sin(o);
                Q = [v(L), v(S), v(-1 * S), v(L)];
              }
              void 0 !== (D = s.charSpace) && (A += b(D * U) + " Tc\n"), s.lang;
              var k = -1,
                I = void 0 !== s.renderingMode ? s.renderingMode : s.stroke,
                O = d.internal.getCurrentPageInfo().pageContext;
              switch (I) {
                case 0:
                case !1:
                case "fill":
                  k = 0;
                  break;
                case 1:
                case !0:
                case "stroke":
                  k = 1;
                  break;
                case 2:
                case "fillThenStroke":
                  k = 2;
                  break;
                case 3:
                case "invisible":
                  k = 3;
                  break;
                case 4:
                case "fillAndAddForClipping":
                  k = 4;
                  break;
                case 5:
                case "strokeAndAddPathForClipping":
                  k = 5;
                  break;
                case 6:
                case "fillThenStrokeAndAddToPathForClipping":
                  k = 6;
                  break;
                case 7:
                case "addToPathForClipping":
                  k = 7;
              }
              var T = void 0 !== O.usedRenderingMode ? O.usedRenderingMode : -1;
              -1 !== k ? A += k + " Tr\n" : -1 !== T && (A += "0 Tr\n"), -1 !== k && (O.usedRenderingMode = k), h = s.align || "left";
              var P = q * c,
                j = d.internal.pageSize.getWidth(),
                M = (U = d.internal.scaleFactor, tt[H]),
                D = s.charSpace || ie,
                _ = s.maxWidth || 0,
                z = (a = {}, []);
              if ("[object Array]" === Object.prototype.toString.call(t)) {
                var K, V;
                y = f(t), "left" !== h && (V = y.map(function (t) {
                  return d.getStringUnitWidth(t, {
                    font: M,
                    charSpace: D,
                    fontSize: q
                  }) * q / U;
                })), Math.max.apply(Math, V);
                var G,
                  X = 0;
                if ("right" === h) {
                  e -= V[0], t = [];
                  var W = 0;
                  for (C = y.length; W < C; W++) V[W], K = 0 === W ? (G = Gt(e), Xt(i)) : (G = (X - V[W]) * U, -P), t.push([y[W], G, K]), X = V[W];
                } else if ("center" === h) for (e -= V[0] / 2, t = [], W = 0, C = y.length; W < C; W++) V[W], K = 0 === W ? (G = Gt(e), Xt(i)) : (G = (X - V[W]) / 2 * U, -P), t.push([y[W], G, K]), X = V[W];else if ("left" === h) for (t = [], W = 0, C = y.length; W < C; W++) K = 0 === W ? Xt(i) : -P, G = 0 === W ? Gt(e) : 0, t.push(y[W]);else {
                  if ("justify" !== h) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                  for (t = [], _ = 0 !== _ ? _ : j, W = 0, C = y.length; W < C; W++) K = 0 === W ? Xt(i) : -P, G = 0 === W ? Gt(e) : 0, W < C - 1 && z.push(((_ - V[W]) / (y[W].split(" ").length - 1) * U).toFixed(2)), t.push([y[W], G, K]);
                }
              }
              !0 === ("boolean" == typeof s.R2L ? s.R2L : J) && (t = p(t, function (t, e, i) {
                return [t.split("").reverse().join(""), e, i];
              })), E = {
                text: t,
                x: e,
                y: i,
                options: s,
                mutex: {
                  pdfEscape: Bt,
                  activeFontKey: H,
                  fonts: tt,
                  activeFontSize: q
                }
              }, nt.publish("postProcessText", E), t = E.text, l = E.mutex.isHex, y = f(t), t = [];
              var Y,
                Z,
                $,
                et = 0,
                it = (C = y.length, "");
              for (W = 0; W < C; W++) it = "", Array.isArray(y[W]) ? (Y = parseFloat(y[W][1]), Z = parseFloat(y[W][2]), $ = (l ? "<" : "(") + y[W][0] + (l ? ">" : ")"), et = 1) : (Y = Gt(e), Z = Xt(i), $ = (l ? "<" : "(") + y[W] + (l ? ">" : ")")), void 0 !== z && void 0 !== z[W] && (it = z[W] + " Tw\n"), 0 !== Q.length && 0 === W ? t.push(it + Q.join(" ") + " " + Y.toFixed(2) + " " + Z.toFixed(2) + " Tm\n" + $) : 1 === et || 0 === et && 0 === W ? t.push(it + Y.toFixed(2) + " " + Z.toFixed(2) + " Td\n" + $) : t.push(it + $);
              t = 0 === et ? t.join(" Tj\nT* ") : t.join(" Tj\n"), t += " Tj\n";
              var st = "BT\n/" + H + " " + q + " Tf\n" + (q * c).toFixed(2) + " TL\n" + te + "\n";
              return st += A, st += t, R(st += "ET"), u[H] = !0, d;
            }, d.__private__.lstext = d.lstext = function (t, e, i, s) {
              return console.warn("jsPDF.lstext is deprecated"), this.text(t, e, i, {
                charSpace: s
              });
            }, d.__private__.clip = d.clip = function (t) {
              R("evenodd" === t ? "W*" : "W"), R("n");
            }, d.__private__.clip_fixed = d.clip_fixed = function (t) {
              console.log("clip_fixed is deprecated"), d.clip(t);
            };
            var Dt = d.__private__.isValidStyle = function (t) {
                var e = !1;
                return -1 !== [void 0, null, "S", "F", "DF", "FD", "f", "f*", "B", "B*"].indexOf(t) && (e = !0), e;
              },
              Rt = d.__private__.getStyle = function (t) {
                var e = "S";
                return "F" === t ? e = "f" : "FD" === t || "DF" === t ? e = "B" : "f" !== t && "f*" !== t && "B" !== t && "B*" !== t || (e = t), e;
              };
            d.__private__.line = d.line = function (t, e, i, s) {
              if (isNaN(t) || isNaN(e) || isNaN(i) || isNaN(s)) throw new Error("Invalid arguments passed to jsPDF.line");
              return this.lines([[i - t, s - e]], t, e);
            }, d.__private__.lines = d.lines = function (t, e, i, s, r, n) {
              var a, o, h, l, A, c, u, d, f, p, g, w;
              if ("number" == typeof t && (w = i, i = e, e = t, t = w), s = s || [1, 1], n = n || !1, isNaN(e) || isNaN(i) || !Array.isArray(t) || !Array.isArray(s) || !Dt(r) || "boolean" != typeof n) throw new Error("Invalid arguments passed to jsPDF.lines");
              for (R(b(Gt(e)) + " " + b(Xt(i)) + " m "), a = s[0], o = s[1], l = t.length, p = e, g = i, h = 0; h < l; h++) 2 === (A = t[h]).length ? (p = A[0] * a + p, g = A[1] * o + g, R(b(Gt(p)) + " " + b(Xt(g)) + " l")) : (c = A[0] * a + p, u = A[1] * o + g, d = A[2] * a + p, f = A[3] * o + g, p = A[4] * a + p, g = A[5] * o + g, R(b(Gt(c)) + " " + b(Xt(u)) + " " + b(Gt(d)) + " " + b(Xt(f)) + " " + b(Gt(p)) + " " + b(Xt(g)) + " c"));
              return n && R(" h"), null !== r && R(Rt(r)), this;
            }, d.__private__.rect = d.rect = function (t, e, i, s, r) {
              if (isNaN(t) || isNaN(e) || isNaN(i) || isNaN(s) || !Dt(r)) throw new Error("Invalid arguments passed to jsPDF.rect");
              return R([v(Gt(t)), v(Xt(e)), v(i * I), v(-s * I), "re"].join(" ")), null !== r && R(Rt(r)), this;
            }, d.__private__.triangle = d.triangle = function (t, e, i, s, r, n, a) {
              if (isNaN(t) || isNaN(e) || isNaN(i) || isNaN(s) || isNaN(r) || isNaN(n) || !Dt(a)) throw new Error("Invalid arguments passed to jsPDF.triangle");
              return this.lines([[i - t, s - e], [r - i, n - s], [t - r, e - n]], t, e, [1, 1], a, !0), this;
            }, d.__private__.roundedRect = d.roundedRect = function (t, e, i, s, r, n, a) {
              if (isNaN(t) || isNaN(e) || isNaN(i) || isNaN(s) || isNaN(r) || isNaN(n) || !Dt(a)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
              var o = 4 / 3 * (Math.SQRT2 - 1);
              return this.lines([[i - 2 * r, 0], [r * o, 0, r, n - n * o, r, n], [0, s - 2 * n], [0, n * o, -r * o, n, -r, n], [2 * r - i, 0], [-r * o, 0, -r, -n * o, -r, -n], [0, 2 * n - s], [0, -n * o, r * o, -n, r, -n]], t + r, e, [1, 1], a), this;
            }, d.__private__.ellipse = d.ellipse = function (t, e, i, s, r) {
              if (isNaN(t) || isNaN(e) || isNaN(i) || isNaN(s) || !Dt(r)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
              var n = 4 / 3 * (Math.SQRT2 - 1) * i,
                a = 4 / 3 * (Math.SQRT2 - 1) * s;
              return R([v(Gt(t + i)), v(Xt(e)), "m", v(Gt(t + i)), v(Xt(e - a)), v(Gt(t + n)), v(Xt(e - s)), v(Gt(t)), v(Xt(e - s)), "c"].join(" ")), R([v(Gt(t - n)), v(Xt(e - s)), v(Gt(t - i)), v(Xt(e - a)), v(Gt(t - i)), v(Xt(e)), "c"].join(" ")), R([v(Gt(t - i)), v(Xt(e + a)), v(Gt(t - n)), v(Xt(e + s)), v(Gt(t)), v(Xt(e + s)), "c"].join(" ")), R([v(Gt(t + n)), v(Xt(e + s)), v(Gt(t + i)), v(Xt(e + a)), v(Gt(t + i)), v(Xt(e)), "c"].join(" ")), null !== r && R(Rt(r)), this;
            }, d.__private__.circle = d.circle = function (t, e, i, s) {
              if (isNaN(t) || isNaN(e) || isNaN(i) || !Dt(s)) throw new Error("Invalid arguments passed to jsPDF.circle");
              return this.ellipse(t, e, i, i, s);
            }, d.setFont = function (t, e) {
              return H = Nt(t, e, {
                disableWarning: !1
              }), this;
            }, d.setFontStyle = d.setFontType = function (t) {
              return H = Nt(void 0, t), this;
            }, d.__private__.getFontList = d.getFontList = function () {
              var t,
                e,
                i,
                s = {};
              for (t in et) if (et.hasOwnProperty(t)) for (e in s[t] = i = [], et[t]) et[t].hasOwnProperty(e) && i.push(e);
              return s;
            }, d.addFont = function (t, e, i, s) {
              bt.call(this, t, e, i, s = s || "Identity-H");
            };
            var _t,
              zt = h.lineWidth || .200025,
              Kt = d.__private__.setLineWidth = d.setLineWidth = function (t) {
                return R((t * I).toFixed(2) + " w"), this;
              },
              qt = (d.__private__.setLineDash = a.API.setLineDash = function (t, e) {
                if (t = t || [], e = e || 0, isNaN(e) || !Array.isArray(t)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
                return t = t.map(function (t) {
                  return (t * I).toFixed(3);
                }).join(" "), e = parseFloat((e * I).toFixed(3)), R("[" + t + "] " + e + " d"), this;
              }, d.__private__.getLineHeight = d.getLineHeight = function () {
                return q * _t;
              }),
              Vt = (qt = d.__private__.getLineHeight = d.getLineHeight = function () {
                return q * _t;
              }, d.__private__.setLineHeightFactor = d.setLineHeightFactor = function (t) {
                return "number" == typeof (t = t || 1.15) && (_t = t), this;
              }),
              Jt = d.__private__.getLineHeightFactor = d.getLineHeightFactor = function () {
                return _t;
              };
            Vt(h.lineHeight);
            var Gt = d.__private__.getHorizontalCoordinate = function (t) {
                return t * I;
              },
              Xt = d.__private__.getVerticalCoordinate = function (t) {
                return st[U].mediaBox.topRightY - st[U].mediaBox.bottomLeftY - t * I;
              },
              Wt = d.__private__.getHorizontalCoordinateString = function (t) {
                return v(t * I);
              },
              Yt = d.__private__.getVerticalCoordinateString = function (t) {
                return v(st[U].mediaBox.topRightY - st[U].mediaBox.bottomLeftY - t * I);
              },
              Zt = h.strokeColor || "0 G",
              $t = (d.__private__.getStrokeColor = d.getDrawColor = function () {
                return dt(Zt);
              }, d.__private__.setStrokeColor = d.setDrawColor = function (t, e, i, s) {
                return Zt = ft({
                  ch1: t,
                  ch2: e,
                  ch3: i,
                  ch4: s,
                  pdfColorType: "draw",
                  precision: 2
                }), R(Zt), this;
              }, h.fillColor || "0 g"),
              te = (d.__private__.getFillColor = d.getFillColor = function () {
                return dt($t);
              }, d.__private__.setFillColor = d.setFillColor = function (t, e, i, s) {
                return $t = ft({
                  ch1: t,
                  ch2: e,
                  ch3: i,
                  ch4: s,
                  pdfColorType: "fill",
                  precision: 2
                }), R($t), this;
              }, h.textColor || "0 g"),
              ee = d.__private__.getTextColor = d.getTextColor = function () {
                return dt(te);
              },
              ie = (d.__private__.setTextColor = d.setTextColor = function (t, e, i, s) {
                return te = ft({
                  ch1: t,
                  ch2: e,
                  ch3: i,
                  ch4: s,
                  pdfColorType: "text",
                  precision: 3
                }), this;
              }, h.charSpace || 0),
              se = d.__private__.getCharSpace = d.getCharSpace = function () {
                return ie;
              },
              re = (d.__private__.setCharSpace = d.setCharSpace = function (t) {
                if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
                return ie = t, this;
              }, 0);
            d.CapJoinStyles = {
              0: 0,
              butt: 0,
              but: 0,
              miter: 0,
              1: 1,
              round: 1,
              rounded: 1,
              circle: 1,
              2: 2,
              projecting: 2,
              project: 2,
              square: 2,
              bevel: 2
            }, d.__private__.setLineCap = d.setLineCap = function (t) {
              var e = d.CapJoinStyles[t];
              if (void 0 === e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
              return R((re = e) + " J"), this;
            };
            var ne,
              ae = 0;
            for (var oe in d.__private__.setLineJoin = d.setLineJoin = function (t) {
              var e = d.CapJoinStyles[t];
              if (void 0 === e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
              return R((ae = e) + " j"), this;
            }, d.__private__.setMiterLimit = d.setMiterLimit = function (t) {
              if (t = t || 0, isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setMiterLimit");
              return ne = parseFloat(v(t * I)), R(ne + " M"), this;
            }, d.save = function (t, e) {
              if (t = t || "generated.pdf", (e = e || {}).returnPromise = e.returnPromise || !1, !1 !== e.returnPromise) return new Promise(function (e, i) {
                try {
                  var r = Lt(It(Ht()), t);
                  "function" == typeof Lt.unload && s.setTimeout && setTimeout(Lt.unload, 911), e(r);
                } catch (e) {
                  i(e.message);
                }
              });
              Lt(It(Ht()), t), "function" == typeof Lt.unload && s.setTimeout && setTimeout(Lt.unload, 911);
            }, a.API) a.API.hasOwnProperty(oe) && ("events" === oe && a.API.events.length ? function (t, e) {
              var i, s, r;
              for (r = e.length - 1; -1 !== r; r--) i = e[r][0], s = e[r][1], t.subscribe.apply(t, [i].concat("function" == typeof s ? [s] : s));
            }(nt, a.API.events) : d[oe] = a.API[oe]);
            return d.internal = {
              pdfEscape: Bt,
              getStyle: Rt,
              getFont: function getFont() {
                return tt[Nt.apply(d, arguments)];
              },
              getFontSize: V,
              getCharSpace: se,
              getTextColor: ee,
              getLineHeight: qt,
              getLineHeightFactor: Jt,
              write: _,
              getHorizontalCoordinate: Gt,
              getVerticalCoordinate: Xt,
              getCoordinateString: Wt,
              getVerticalCoordinateString: Yt,
              collections: {},
              newObject: ot,
              newAdditionalObject: At,
              newObjectDeferred: ht,
              newObjectDeferredBegin: lt,
              getFilters: pt,
              putStream: gt,
              events: nt,
              scaleFactor: I,
              pageSize: {
                getWidth: function getWidth() {
                  return (st[U].mediaBox.topRightX - st[U].mediaBox.bottomLeftX) / I;
                },
                setWidth: function setWidth(t) {
                  st[U].mediaBox.topRightX = t * I + st[U].mediaBox.bottomLeftX;
                },
                getHeight: function getHeight() {
                  return (st[U].mediaBox.topRightY - st[U].mediaBox.bottomLeftY) / I;
                },
                setHeight: function setHeight(t) {
                  st[U].mediaBox.topRightY = t * I + st[U].mediaBox.bottomLeftY;
                }
              },
              output: Ot,
              getNumberOfPages: xt,
              pages: j,
              out: R,
              f2: v,
              f3: b,
              getPageInfo: Pt,
              getPageInfoByObjId: jt,
              getCurrentPageInfo: Mt,
              getPDFVersion: p,
              hasHotfix: Tt
            }, Object.defineProperty(d.internal.pageSize, "width", {
              get: function get() {
                return (st[U].mediaBox.topRightX - st[U].mediaBox.bottomLeftX) / I;
              },
              set: function set(t) {
                st[U].mediaBox.topRightX = t * I + st[U].mediaBox.bottomLeftX;
              },
              enumerable: !0,
              configurable: !0
            }), Object.defineProperty(d.internal.pageSize, "height", {
              get: function get() {
                return (st[U].mediaBox.topRightY - st[U].mediaBox.bottomLeftY) / I;
              },
              set: function set(t) {
                st[U].mediaBox.topRightY = t * I + st[U].mediaBox.bottomLeftY;
              },
              enumerable: !0,
              configurable: !0
            }), function (t) {
              for (var e = 0, i = K.length; e < i; e++) {
                var s = bt(t[e][0], t[e][1], t[e][2], K[e][3], !0);
                u[s] = !0;
                var r = t[e][0].split("-");
                vt(s, r[0], r[1] || "");
              }
              nt.publish("addFonts", {
                fonts: tt,
                dictionary: et
              });
            }(K), H = "F1", Ct(i, t), nt.publish("initialized"), d;
          }
          return a.API = {
            events: []
          }, a.version = "1.5.3", s.jsPDF = a, void 0 !== (o = function () {
            return a;
          }.call(e, i, e, t)) && (t.exports = o), a;
        }("undefined" != typeof self && self || "undefined" != typeof window && window || void 0 !== s && s || Function('return typeof this === "object" && this.content')() || Function("return this")());
      /**
         * @license
         * Copyright (c) 2016 Alexander Weidt,
         * https://github.com/BiggA94
         * 
         * Licensed under the MIT License. http://opensource.org/licenses/mit-license
         */
      (function (t, e) {
        var i,
          s = 1,
          n = function n(t) {
            return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
          },
          a = function a(t) {
            return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
          },
          o = function o(t) {
            if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
            return t.toFixed(2);
          },
          h = function h(t) {
            if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
            return t.toFixed(5);
          };
        t.__acroform__ = {};
        var l = function l(t, e) {
            t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
          },
          A = function A(t) {
            return t * s;
          },
          c = function c(t) {
            return t / s;
          },
          u = function u(t) {
            var e = new I(),
              i = G.internal.getHeight(t) || 0,
              s = G.internal.getWidth(t) || 0;
            return e.BBox = [0, 0, Number(o(s)), Number(o(i))], e;
          },
          d = t.__acroform__.setBit = function (t, e) {
            if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
            return t | 1 << e;
          },
          f = t.__acroform__.clearBit = function (t, e) {
            if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
            return t & ~(1 << e);
          },
          p = t.__acroform__.getBit = function (t, e) {
            if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
            return 0 == (t & 1 << e) ? 0 : 1;
          },
          g = t.__acroform__.getBitForPdf = function (t, e) {
            if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
            return p(t, e - 1);
          },
          w = t.__acroform__.setBitForPdf = function (t, e) {
            if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
            return d(t, e - 1);
          },
          m = t.__acroform__.clearBitForPdf = function (t, e, i) {
            if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
            return f(t, e - 1);
          },
          v = t.__acroform__.calculateCoordinates = function (t) {
            var e = this.internal.getHorizontalCoordinate,
              i = this.internal.getVerticalCoordinate,
              s = t[0],
              r = t[1],
              n = t[2],
              a = t[3],
              h = {};
            return h.lowerLeft_X = e(s) || 0, h.lowerLeft_Y = i(r + a) || 0, h.upperRight_X = e(s + n) || 0, h.upperRight_Y = i(r) || 0, [Number(o(h.lowerLeft_X)), Number(o(h.lowerLeft_Y)), Number(o(h.upperRight_X)), Number(o(h.upperRight_Y))];
          },
          b = function b(t) {
            if (t.appearanceStreamContent) return t.appearanceStreamContent;
            if (t.V || t.DV) {
              var e = [],
                s = t.V || t.DV,
                r = B(t, s),
                n = i.internal.getFont(t.fontName, t.fontStyle).id;
              e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(i.__private__.encodeColorString(t.color)), e.push("/" + n + " " + o(r.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(r.text), e.push("ET"), e.push("Q"), e.push("EMC");
              var a = new u(t);
              return a.stream = e.join("\n"), a;
            }
          },
          B = function B(t, e) {
            var s = t.maxFontSize || 12,
              r = (t.fontName, {
                text: "",
                fontSize: ""
              }),
              a = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" "),
              h = (i.__private__.encodeColorString(t.color), s),
              l = G.internal.getHeight(t) || 0;
            l = l < 0 ? -l : l;
            var A = G.internal.getWidth(t) || 0;
            A = A < 0 ? -A : A;
            var c = function c(e, i, s) {
              if (e + 1 < a.length) {
                var r = i + " " + a[e + 1];
                return y(r, t, s).width <= A - 4;
              }
              return !1;
            };
            h++;
            t: for (;;) {
              e = "";
              var u = y("3", t, --h).height,
                d = t.multiline ? l - h : (l - u) / 2,
                f = -2,
                p = d += 2,
                g = 0,
                w = 0,
                m = 0;
              if (h <= 0) {
                e = "(...) Tj\n", e += "% Width of Text: " + y(e, t, h = 12).width + ", FieldWidth:" + A + "\n";
                break;
              }
              m = y(a[0] + " ", t, h).width;
              var v = "",
                b = 0;
              for (var B in a) if (a.hasOwnProperty(B)) {
                v = " " == (v += a[B] + " ").substr(v.length - 1) ? v.substr(0, v.length - 1) : v;
                var C = parseInt(B);
                m = y(v + " ", t, h).width;
                var F = c(C, v, h),
                  x = B >= a.length - 1;
                if (F && !x) {
                  v += " ";
                  continue;
                }
                if (F || x) {
                  if (x) w = C;else if (t.multiline && l < (u + 2) * (b + 2) + 2) continue t;
                } else {
                  if (!t.multiline) continue t;
                  if (l < (u + 2) * (b + 2) + 2) continue t;
                  w = C;
                }
                for (var N = "", E = g; E <= w; E++) N += a[E] + " ";
                switch (N = " " == N.substr(N.length - 1) ? N.substr(0, N.length - 1) : N, m = y(N, t, h).width, t.textAlign) {
                  case "right":
                    f = A - m - 2;
                    break;
                  case "center":
                    f = (A - m) / 2;
                    break;
                  case "left":
                  default:
                    f = 2;
                }
                e += o(f) + " " + o(p) + " Td\n", e += "(" + n(N) + ") Tj\n", e += -o(f) + " 0 Td\n", p = -(h + 2), m = 0, g = w + 1, b++, v = "";
              }
              break;
            }
            return r.text = e, r.fontSize = h, r;
          },
          y = function y(t, e, s) {
            var r = i.internal.getFont(e.fontName, e.fontStyle),
              n = i.getStringUnitWidth(t, {
                font: r,
                fontSize: parseFloat(s),
                charSpace: 0
              }) * parseFloat(s);
            return {
              height: i.getStringUnitWidth("3", {
                font: r,
                fontSize: parseFloat(s),
                charSpace: 0
              }) * parseFloat(s) * 1.5,
              width: n
            };
          },
          C = {
            fields: [],
            xForms: [],
            acroFormDictionaryRoot: null,
            printedOut: !1,
            internal: null,
            isInitialized: !1
          },
          F = function F() {
            i.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
            var t = i.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
            for (var e in t) if (t.hasOwnProperty(e)) {
              var s = t[e];
              s.objId = void 0, s.hasAnnotation && x.call(i, s);
            }
          },
          x = function x(t) {
            var e = {
              type: "reference",
              object: t
            };
            void 0 === i.internal.getPageInfo(t.page).pageContext.annotations.find(function (t) {
              return t.type === e.type && t.object === e.object;
            }) && i.internal.getPageInfo(t.page).pageContext.annotations.push(e);
          },
          N = function N() {
            if (void 0 === i.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("putCatalogCallback: Root missing.");
            i.internal.write("/AcroForm " + i.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
          },
          E = function E() {
            i.internal.events.unsubscribe(i.internal.acroformPlugin.acroFormDictionaryRoot.Event_ID), delete i.internal.acroformPlugin.acroFormDictionaryRoot.Event_ID, i.internal.acroformPlugin.printedOut = !0;
          },
          U = function U(t) {
            var e = !t;
            for (var s in t || (i.internal.newObjectDeferredBegin(i.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), i.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), t = t || i.internal.acroformPlugin.acroFormDictionaryRoot.Kids) if (t.hasOwnProperty(s)) {
              var n = t[s],
                a = [],
                o = n.Rect;
              if (n.Rect && (n.Rect = v.call(this, n.Rect)), i.internal.newObjectDeferredBegin(n.objId, !0), n.DA = G.createDefaultAppearanceStream(n), "object" === r(n) && "function" == typeof n.getKeyValueListForStream && (a = n.getKeyValueListForStream()), n.Rect = o, n.hasAppearanceStream && !n.appearanceStreamContent) {
                var h = b.call(this, n);
                a.push({
                  key: "AP",
                  value: "<</N " + h + ">>"
                }), i.internal.acroformPlugin.xForms.push(h);
              }
              if (n.appearanceStreamContent) {
                var l = "";
                for (var A in n.appearanceStreamContent) if (n.appearanceStreamContent.hasOwnProperty(A)) {
                  var c = n.appearanceStreamContent[A];
                  if (l += "/" + A + " ", l += "<<", 1 <= Object.keys(c).length || Array.isArray(c)) for (var s in c) {
                    var u;
                    c.hasOwnProperty(s) && ("function" == typeof (u = c[s]) && (u = u.call(this, n)), l += "/" + s + " " + u + " ", 0 <= i.internal.acroformPlugin.xForms.indexOf(u) || i.internal.acroformPlugin.xForms.push(u));
                  } else "function" == typeof (u = c) && (u = u.call(this, n)), l += "/" + s + " " + u, 0 <= i.internal.acroformPlugin.xForms.indexOf(u) || i.internal.acroformPlugin.xForms.push(u);
                  l += ">>";
                }
                a.push({
                  key: "AP",
                  value: "<<\n" + l + ">>"
                });
              }
              i.internal.putStream({
                additionalKeyValues: a
              }), i.internal.out("endobj");
            }
            e && Q.call(this, i.internal.acroformPlugin.xForms);
          },
          Q = function Q(t) {
            for (var e in t) if (t.hasOwnProperty(e)) {
              var s = e,
                n = t[e];
              i.internal.newObjectDeferredBegin(n && n.objId, !0), "object" === r(n) && "function" == typeof n.putStream && n.putStream(), delete t[s];
            }
          },
          L = function L() {
            if (void 0 !== this.internal && (void 0 === this.internal.acroformPlugin || !1 === this.internal.acroformPlugin.isInitialized)) {
              if (i = this, T.FieldNum = 0, this.internal.acroformPlugin = JSON.parse(JSON.stringify(C)), this.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
              s = i.internal.scaleFactor, i.internal.acroformPlugin.acroFormDictionaryRoot = new O(), i.internal.acroformPlugin.acroFormDictionaryRoot.Event_ID = i.internal.events.subscribe("postPutResources", E), i.internal.events.subscribe("buildDocument", F), i.internal.events.subscribe("putCatalog", N), i.internal.events.subscribe("postPutPages", U), i.internal.acroformPlugin.isInitialized = !0;
            }
          },
          S = t.__acroform__.arrayToPdfArray = function (t) {
            if (Array.isArray(t)) {
              for (var e = "[", i = 0; i < t.length; i++) switch (0 !== i && (e += " "), r(t[i])) {
                case "boolean":
                case "number":
                case "object":
                  e += t[i].toString();
                  break;
                case "string":
                  "/" !== t[i].substr(0, 1) ? e += "(" + n(t[i].toString()) + ")" : e += t[i].toString();
              }
              return e + "]";
            }
            throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
          },
          k = function k(t) {
            return (t = t || "").toString(), "(" + n(t) + ")";
          },
          H = function H() {
            var t;
            Object.defineProperty(this, "objId", {
              configurable: !0,
              get: function get() {
                if (t || (t = i.internal.newObjectDeferred()), !t) throw new Error("AcroFormPDFObject: Couldn't create Object ID");
                return t;
              },
              set: function set(e) {
                t = e;
              }
            });
          };
        H.prototype.toString = function () {
          return this.objId + " 0 R";
        }, H.prototype.putStream = function () {
          var t = this.getKeyValueListForStream();
          i.internal.putStream({
            data: this.stream,
            additionalKeyValues: t
          }), i.internal.out("endobj");
        }, H.prototype.getKeyValueListForStream = function () {
          return function (t) {
            var e = [],
              i = Object.getOwnPropertyNames(t).filter(function (t) {
                return "content" != t && "appearanceStreamContent" != t && "_" != t.substring(0, 1);
              });
            for (var s in i) if (!1 === Object.getOwnPropertyDescriptor(t, i[s]).configurable) {
              var r = i[s],
                n = t[r];
              n && (Array.isArray(n) ? e.push({
                key: r,
                value: S(n)
              }) : n instanceof H ? e.push({
                key: r,
                value: n.objId + " 0 R"
              }) : "function" != typeof n && e.push({
                key: r,
                value: n
              }));
            }
            return e;
          }(this);
        };
        var I = function I() {
          H.call(this), Object.defineProperty(this, "Type", {
            value: "/XObject",
            configurable: !1,
            writeable: !0
          }), Object.defineProperty(this, "Subtype", {
            value: "/Form",
            configurable: !1,
            writeable: !0
          }), Object.defineProperty(this, "FormType", {
            value: 1,
            configurable: !1,
            writeable: !0
          });
          var t,
            e = [];
          Object.defineProperty(this, "BBox", {
            configurable: !1,
            writeable: !0,
            get: function get() {
              return e;
            },
            set: function set(t) {
              e = t;
            }
          }), Object.defineProperty(this, "Resources", {
            value: "2 0 R",
            configurable: !1,
            writeable: !0
          }), Object.defineProperty(this, "stream", {
            enumerable: !1,
            configurable: !0,
            set: function set(e) {
              t = e.trim();
            },
            get: function get() {
              return t || null;
            }
          });
        };
        l(I, H);
        var O = function O() {
          H.call(this);
          var t,
            e = [];
          Object.defineProperty(this, "Kids", {
            enumerable: !1,
            configurable: !0,
            get: function get() {
              return 0 < e.length ? e : void 0;
            }
          }), Object.defineProperty(this, "Fields", {
            enumerable: !1,
            configurable: !1,
            get: function get() {
              return e;
            }
          }), Object.defineProperty(this, "DA", {
            enumerable: !1,
            configurable: !1,
            get: function get() {
              if (t) return "(" + t + ")";
            },
            set: function set(e) {
              t = e;
            }
          });
        };
        l(O, H);
        var T = function t() {
          H.call(this);
          var e = 4;
          Object.defineProperty(this, "F", {
            enumerable: !1,
            configurable: !1,
            get: function get() {
              return e;
            },
            set: function set(t) {
              if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute F supplied.');
              e = t;
            }
          }), Object.defineProperty(this, "showWhenPrinted", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(e, 3));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.F = w(e, 3) : this.F = m(e, 3);
            }
          });
          var i = 0;
          Object.defineProperty(this, "Ff", {
            enumerable: !1,
            configurable: !1,
            get: function get() {
              return i;
            },
            set: function set(t) {
              if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute Ff supplied.');
              i = t;
            }
          });
          var s = [];
          Object.defineProperty(this, "Rect", {
            enumerable: !1,
            configurable: !1,
            get: function get() {
              if (0 !== s.length) return s;
            },
            set: function set(t) {
              s = void 0 !== t ? t : [];
            }
          }), Object.defineProperty(this, "x", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return !s || isNaN(s[0]) ? 0 : c(s[0]);
            },
            set: function set(t) {
              s[0] = A(t);
            }
          }), Object.defineProperty(this, "y", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return !s || isNaN(s[1]) ? 0 : c(s[1]);
            },
            set: function set(t) {
              s[1] = A(t);
            }
          }), Object.defineProperty(this, "width", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return !s || isNaN(s[2]) ? 0 : c(s[2]);
            },
            set: function set(t) {
              s[2] = A(t);
            }
          }), Object.defineProperty(this, "height", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return !s || isNaN(s[3]) ? 0 : c(s[3]);
            },
            set: function set(t) {
              s[3] = A(t);
            }
          });
          var r = "";
          Object.defineProperty(this, "FT", {
            enumerable: !0,
            configurable: !1,
            get: function get() {
              return r;
            },
            set: function set(t) {
              switch (t) {
                case "/Btn":
                case "/Tx":
                case "/Ch":
                case "/Sig":
                  r = t;
                  break;
                default:
                  throw new Error('Invalid value "' + t + '" for attribute FT supplied.');
              }
            }
          });
          var o = null;
          Object.defineProperty(this, "T", {
            enumerable: !0,
            configurable: !1,
            get: function get() {
              if (!o || o.length < 1) {
                if (this instanceof K) return;
                o = "FieldObject" + t.FieldNum++;
              }
              return "(" + n(o) + ")";
            },
            set: function set(t) {
              o = t.toString();
            }
          }), Object.defineProperty(this, "fieldName", {
            configurable: !0,
            enumerable: !0,
            get: function get() {
              return o;
            },
            set: function set(t) {
              o = t;
            }
          });
          var h = "helvetica";
          Object.defineProperty(this, "fontName", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return h;
            },
            set: function set(t) {
              h = t;
            }
          });
          var l = "normal";
          Object.defineProperty(this, "fontStyle", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return l;
            },
            set: function set(t) {
              l = t;
            }
          });
          var u = 0;
          Object.defineProperty(this, "fontSize", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return c(u);
            },
            set: function set(t) {
              u = A(t);
            }
          });
          var d = 50;
          Object.defineProperty(this, "maxFontSize", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return c(d);
            },
            set: function set(t) {
              d = A(t);
            }
          });
          var f = "black";
          Object.defineProperty(this, "color", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return f;
            },
            set: function set(t) {
              f = t;
            }
          });
          var p = "/F1 0 Tf 0 g";
          Object.defineProperty(this, "DA", {
            enumerable: !0,
            configurable: !1,
            get: function get() {
              if (!(!p || this instanceof K || this instanceof V)) return k(p);
            },
            set: function set(t) {
              t = t.toString(), p = t;
            }
          });
          var v = null;
          Object.defineProperty(this, "DV", {
            enumerable: !1,
            configurable: !1,
            get: function get() {
              if (v) return this instanceof R == 0 ? k(v) : v;
            },
            set: function set(t) {
              t = t.toString(), v = this instanceof R == 0 ? "(" === t.substr(0, 1) ? a(t.substr(1, t.length - 2)) : a(t) : t;
            }
          }), Object.defineProperty(this, "defaultValue", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return this instanceof R == 1 ? a(v.substr(1, v.length - 1)) : v;
            },
            set: function set(t) {
              t = t.toString(), v = this instanceof R == 1 ? "/" + t : t;
            }
          });
          var b = null;
          Object.defineProperty(this, "V", {
            enumerable: !1,
            configurable: !1,
            get: function get() {
              if (b) return this instanceof R == 0 ? k(b) : b;
            },
            set: function set(t) {
              t = t.toString(), b = this instanceof R == 0 ? "(" === t.substr(0, 1) ? a(t.substr(1, t.length - 2)) : a(t) : t;
            }
          }), Object.defineProperty(this, "value", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return this instanceof R == 1 ? a(b.substr(1, b.length - 1)) : b;
            },
            set: function set(t) {
              t = t.toString(), b = this instanceof R == 1 ? "/" + t : t;
            }
          }), Object.defineProperty(this, "hasAnnotation", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return this.Rect;
            }
          }), Object.defineProperty(this, "Type", {
            enumerable: !0,
            configurable: !1,
            get: function get() {
              return this.hasAnnotation ? "/Annot" : null;
            }
          }), Object.defineProperty(this, "Subtype", {
            enumerable: !0,
            configurable: !1,
            get: function get() {
              return this.hasAnnotation ? "/Widget" : null;
            }
          });
          var B,
            y = !1;
          Object.defineProperty(this, "hasAppearanceStream", {
            enumerable: !0,
            configurable: !0,
            writeable: !0,
            get: function get() {
              return y;
            },
            set: function set(t) {
              t = Boolean(t), y = t;
            }
          }), Object.defineProperty(this, "page", {
            enumerable: !0,
            configurable: !0,
            writeable: !0,
            get: function get() {
              if (B) return B;
            },
            set: function set(t) {
              B = t;
            }
          }), Object.defineProperty(this, "readOnly", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 1));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 1) : this.Ff = m(this.Ff, 1);
            }
          }), Object.defineProperty(this, "required", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 2));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 2) : this.Ff = m(this.Ff, 2);
            }
          }), Object.defineProperty(this, "noExport", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 3));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 3) : this.Ff = m(this.Ff, 3);
            }
          });
          var C = null;
          Object.defineProperty(this, "Q", {
            enumerable: !0,
            configurable: !1,
            get: function get() {
              if (null !== C) return C;
            },
            set: function set(t) {
              if (-1 === [0, 1, 2].indexOf(t)) throw new Error('Invalid value "' + t + '" for attribute Q supplied.');
              C = t;
            }
          }), Object.defineProperty(this, "textAlign", {
            get: function get() {
              var t = "left";
              switch (C) {
                case 0:
                default:
                  t = "left";
                  break;
                case 1:
                  t = "center";
                  break;
                case 2:
                  t = "right";
              }
              return t;
            },
            configurable: !0,
            enumerable: !0,
            set: function set(t) {
              switch (t) {
                case "right":
                case 2:
                  C = 2;
                  break;
                case "center":
                case 1:
                  C = 1;
                  break;
                case "left":
                case 0:
                default:
                  C = 0;
              }
            }
          });
        };
        l(T, H);
        var P = function P() {
          T.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
          var t = 0;
          Object.defineProperty(this, "TI", {
            enumerable: !0,
            configurable: !1,
            get: function get() {
              return t;
            },
            set: function set(e) {
              t = e;
            }
          }), Object.defineProperty(this, "topIndex", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return t;
            },
            set: function set(e) {
              t = e;
            }
          });
          var e = [];
          Object.defineProperty(this, "Opt", {
            enumerable: !0,
            configurable: !1,
            get: function get() {
              return S(e);
            },
            set: function set(t) {
              var i, s;
              s = [], "string" == typeof (i = t) && (s = function (t, e, i) {
                i || (i = 1);
                for (var s, r = []; s = e.exec(t);) r.push(s[i]);
                return r;
              }(i, /\((.*?)\)/g)), e = s;
            }
          }), this.getOptions = function () {
            return e;
          }, this.setOptions = function (t) {
            e = t, this.sort && e.sort();
          }, this.addOption = function (t) {
            t = (t = t || "").toString(), e.push(t), this.sort && e.sort();
          }, this.removeOption = function (t, i) {
            for (i = i || !1, t = (t = t || "").toString(); -1 !== e.indexOf(t) && (e.splice(e.indexOf(t), 1), !1 !== i););
          }, Object.defineProperty(this, "combo", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 18));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 18) : this.Ff = m(this.Ff, 18);
            }
          }), Object.defineProperty(this, "edit", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 19));
            },
            set: function set(t) {
              !0 === this.combo && (!0 === Boolean(t) ? this.Ff = w(this.Ff, 19) : this.Ff = m(this.Ff, 19));
            }
          }), Object.defineProperty(this, "sort", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 20));
            },
            set: function set(t) {
              !0 === Boolean(t) ? (this.Ff = w(this.Ff, 20), e.sort()) : this.Ff = m(this.Ff, 20);
            }
          }), Object.defineProperty(this, "multiSelect", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 22));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 22) : this.Ff = m(this.Ff, 22);
            }
          }), Object.defineProperty(this, "doNotSpellCheck", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 23));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 23) : this.Ff = m(this.Ff, 23);
            }
          }), Object.defineProperty(this, "commitOnSelChange", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 27));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 27) : this.Ff = m(this.Ff, 27);
            }
          }), this.hasAppearanceStream = !1;
        };
        l(P, T);
        var j = function j() {
          P.call(this), this.fontName = "helvetica", this.combo = !1;
        };
        l(j, P);
        var M = function M() {
          j.call(this), this.combo = !0;
        };
        l(M, j);
        var D = function D() {
          M.call(this), this.edit = !0;
        };
        l(D, M);
        var R = function R() {
          T.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 15));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 15) : this.Ff = m(this.Ff, 15);
            }
          }), Object.defineProperty(this, "radio", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 16));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 16) : this.Ff = m(this.Ff, 16);
            }
          }), Object.defineProperty(this, "pushButton", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 17));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 17) : this.Ff = m(this.Ff, 17);
            }
          }), Object.defineProperty(this, "radioIsUnison", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 26));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 26) : this.Ff = m(this.Ff, 26);
            }
          });
          var t,
            e = {};
          Object.defineProperty(this, "MK", {
            enumerable: !1,
            configurable: !1,
            get: function get() {
              if (0 !== Object.keys(e).length) {
                var t,
                  i = [];
                for (t in i.push("<<"), e) i.push("/" + t + " (" + e[t] + ")");
                return i.push(">>"), i.join("\n");
              }
            },
            set: function set(t) {
              "object" === r(t) && (e = t);
            }
          }), Object.defineProperty(this, "caption", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return e.CA || "";
            },
            set: function set(t) {
              "string" == typeof t && (e.CA = t);
            }
          }), Object.defineProperty(this, "AS", {
            enumerable: !1,
            configurable: !1,
            get: function get() {
              return t;
            },
            set: function set(e) {
              t = e;
            }
          }), Object.defineProperty(this, "appearanceState", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return t.substr(1, t.length - 1);
            },
            set: function set(e) {
              t = "/" + e;
            }
          });
        };
        l(R, T);
        var _ = function _() {
          R.call(this), this.pushButton = !0;
        };
        l(_, R);
        var z = function z() {
          R.call(this), this.radio = !0, this.pushButton = !1;
          var t = [];
          Object.defineProperty(this, "Kids", {
            enumerable: !0,
            configurable: !1,
            get: function get() {
              return t;
            },
            set: function set(e) {
              t = void 0 !== e ? e : [];
            }
          });
        };
        l(z, R);
        var K = function K() {
          var t, e;
          T.call(this), Object.defineProperty(this, "Parent", {
            enumerable: !1,
            configurable: !1,
            get: function get() {
              return t;
            },
            set: function set(e) {
              t = e;
            }
          }), Object.defineProperty(this, "optionName", {
            enumerable: !1,
            configurable: !0,
            get: function get() {
              return e;
            },
            set: function set(t) {
              e = t;
            }
          });
          var i,
            s = {};
          Object.defineProperty(this, "MK", {
            enumerable: !1,
            configurable: !1,
            get: function get() {
              var t,
                e = [];
              for (t in e.push("<<"), s) e.push("/" + t + " (" + s[t] + ")");
              return e.push(">>"), e.join("\n");
            },
            set: function set(t) {
              "object" === r(t) && (s = t);
            }
          }), Object.defineProperty(this, "caption", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return s.CA || "";
            },
            set: function set(t) {
              "string" == typeof t && (s.CA = t);
            }
          }), Object.defineProperty(this, "AS", {
            enumerable: !1,
            configurable: !1,
            get: function get() {
              return i;
            },
            set: function set(t) {
              i = t;
            }
          }), Object.defineProperty(this, "appearanceState", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return i.substr(1, i.length - 1);
            },
            set: function set(t) {
              i = "/" + t;
            }
          }), this.optionName = name, this.caption = "l", this.appearanceState = "Off", this._AppearanceType = G.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(name);
        };
        l(K, T), z.prototype.setAppearance = function (t) {
          if (!("createAppearanceStream" in t) || !("getCA" in t)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
          for (var e in this.Kids) if (this.Kids.hasOwnProperty(e)) {
            var i = this.Kids[e];
            i.appearanceStreamContent = t.createAppearanceStream(i.optionName), i.caption = t.getCA();
          }
        }, z.prototype.createOption = function (t) {
          this.Kids.length;
          var e = new K();
          return e.Parent = this, e.optionName = t, this.Kids.push(e), X.call(this, e), e;
        };
        var q = function q() {
          R.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = G.CheckBox.createAppearanceStream();
        };
        l(q, R);
        var V = function V() {
          T.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 13));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 13) : this.Ff = m(this.Ff, 13);
            }
          }), Object.defineProperty(this, "fileSelect", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 21));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 21) : this.Ff = m(this.Ff, 21);
            }
          }), Object.defineProperty(this, "doNotSpellCheck", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 23));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 23) : this.Ff = m(this.Ff, 23);
            }
          }), Object.defineProperty(this, "doNotScroll", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 24));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 24) : this.Ff = m(this.Ff, 24);
            }
          }), Object.defineProperty(this, "comb", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 25));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 25) : this.Ff = m(this.Ff, 25);
            }
          }), Object.defineProperty(this, "richText", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 26));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 26) : this.Ff = m(this.Ff, 26);
            }
          });
          var t = null;
          Object.defineProperty(this, "MaxLen", {
            enumerable: !0,
            configurable: !1,
            get: function get() {
              return t;
            },
            set: function set(e) {
              t = e;
            }
          }), Object.defineProperty(this, "maxLength", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return t;
            },
            set: function set(e) {
              Number.isInteger(e) && (t = e);
            }
          }), Object.defineProperty(this, "hasAppearanceStream", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return this.V || this.DV;
            }
          });
        };
        l(V, T);
        var J = function J() {
          V.call(this), Object.defineProperty(this, "password", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return Boolean(g(this.Ff, 14));
            },
            set: function set(t) {
              !0 === Boolean(t) ? this.Ff = w(this.Ff, 14) : this.Ff = m(this.Ff, 14);
            }
          }), this.password = !0;
        };
        l(J, V);
        var G = {
          CheckBox: {
            createAppearanceStream: function createAppearanceStream() {
              return {
                N: {
                  On: G.CheckBox.YesNormal
                },
                D: {
                  On: G.CheckBox.YesPushDown,
                  Off: G.CheckBox.OffPushDown
                }
              };
            },
            YesPushDown: function YesPushDown(t) {
              var e = u(t),
                s = [],
                r = i.internal.getFont(t.fontName, t.fontStyle).id,
                n = i.__private__.encodeColorString(t.color),
                a = B(t, t.caption);
              return s.push("0.749023 g"), s.push("0 0 " + o(G.internal.getWidth(t)) + " " + o(G.internal.getHeight(t)) + " re"), s.push("f"), s.push("BMC"), s.push("q"), s.push("0 0 1 rg"), s.push("/" + r + " " + o(a.fontSize) + " Tf " + n), s.push("BT"), s.push(a.text), s.push("ET"), s.push("Q"), s.push("EMC"), e.stream = s.join("\n"), e;
            },
            YesNormal: function YesNormal(t) {
              var e = u(t),
                s = i.internal.getFont(t.fontName, t.fontStyle).id,
                r = i.__private__.encodeColorString(t.color),
                n = [],
                a = G.internal.getHeight(t),
                h = G.internal.getWidth(t),
                l = B(t, t.caption);
              return n.push("1 g"), n.push("0 0 " + o(h) + " " + o(a) + " re"), n.push("f"), n.push("q"), n.push("0 0 1 rg"), n.push("0 0 " + o(h - 1) + " " + o(a - 1) + " re"), n.push("W"), n.push("n"), n.push("0 g"), n.push("BT"), n.push("/" + s + " " + o(l.fontSize) + " Tf " + r), n.push(l.text), n.push("ET"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            OffPushDown: function OffPushDown(t) {
              var e = u(t),
                i = [];
              return i.push("0.749023 g"), i.push("0 0 " + o(G.internal.getWidth(t)) + " " + o(G.internal.getHeight(t)) + " re"), i.push("f"), e.stream = i.join("\n"), e;
            }
          },
          RadioButton: {
            Circle: {
              createAppearanceStream: function createAppearanceStream(t) {
                var e = {
                  D: {
                    Off: G.RadioButton.Circle.OffPushDown
                  },
                  N: {}
                };
                return e.N[t] = G.RadioButton.Circle.YesNormal, e.D[t] = G.RadioButton.Circle.YesPushDown, e;
              },
              getCA: function getCA() {
                return "l";
              },
              YesNormal: function YesNormal(t) {
                var e = u(t),
                  i = [],
                  s = G.internal.getWidth(t) <= G.internal.getHeight(t) ? G.internal.getWidth(t) / 4 : G.internal.getHeight(t) / 4;
                s = Number((.9 * s).toFixed(5));
                var r = G.internal.Bezier_C,
                  n = Number((s * r).toFixed(5));
                return i.push("q"), i.push("1 0 0 1 " + h(G.internal.getWidth(t) / 2) + " " + h(G.internal.getHeight(t) / 2) + " cm"), i.push(s + " 0 m"), i.push(s + " " + n + " " + n + " " + s + " 0 " + s + " c"), i.push("-" + n + " " + s + " -" + s + " " + n + " -" + s + " 0 c"), i.push("-" + s + " -" + n + " -" + n + " -" + s + " 0 -" + s + " c"), i.push(n + " -" + s + " " + s + " -" + n + " " + s + " 0 c"), i.push("f"), i.push("Q"), e.stream = i.join("\n"), e;
              },
              YesPushDown: function YesPushDown(t) {
                var e = u(t),
                  i = [],
                  s = G.internal.getWidth(t) <= G.internal.getHeight(t) ? G.internal.getWidth(t) / 4 : G.internal.getHeight(t) / 4,
                  r = (s = Number((.9 * s).toFixed(5)), Number((2 * s).toFixed(5))),
                  n = Number((r * G.internal.Bezier_C).toFixed(5)),
                  a = Number((s * G.internal.Bezier_C).toFixed(5));
                return i.push("0.749023 g"), i.push("q"), i.push("1 0 0 1 " + h(G.internal.getWidth(t) / 2) + " " + h(G.internal.getHeight(t) / 2) + " cm"), i.push(r + " 0 m"), i.push(r + " " + n + " " + n + " " + r + " 0 " + r + " c"), i.push("-" + n + " " + r + " -" + r + " " + n + " -" + r + " 0 c"), i.push("-" + r + " -" + n + " -" + n + " -" + r + " 0 -" + r + " c"), i.push(n + " -" + r + " " + r + " -" + n + " " + r + " 0 c"), i.push("f"), i.push("Q"), i.push("0 g"), i.push("q"), i.push("1 0 0 1 " + h(G.internal.getWidth(t) / 2) + " " + h(G.internal.getHeight(t) / 2) + " cm"), i.push(s + " 0 m"), i.push(s + " " + a + " " + a + " " + s + " 0 " + s + " c"), i.push("-" + a + " " + s + " -" + s + " " + a + " -" + s + " 0 c"), i.push("-" + s + " -" + a + " -" + a + " -" + s + " 0 -" + s + " c"), i.push(a + " -" + s + " " + s + " -" + a + " " + s + " 0 c"), i.push("f"), i.push("Q"), e.stream = i.join("\n"), e;
              },
              OffPushDown: function OffPushDown(t) {
                var e = u(t),
                  i = [],
                  s = G.internal.getWidth(t) <= G.internal.getHeight(t) ? G.internal.getWidth(t) / 4 : G.internal.getHeight(t) / 4,
                  r = (s = Number((.9 * s).toFixed(5)), Number((2 * s).toFixed(5))),
                  n = Number((r * G.internal.Bezier_C).toFixed(5));
                return i.push("0.749023 g"), i.push("q"), i.push("1 0 0 1 " + h(G.internal.getWidth(t) / 2) + " " + h(G.internal.getHeight(t) / 2) + " cm"), i.push(r + " 0 m"), i.push(r + " " + n + " " + n + " " + r + " 0 " + r + " c"), i.push("-" + n + " " + r + " -" + r + " " + n + " -" + r + " 0 c"), i.push("-" + r + " -" + n + " -" + n + " -" + r + " 0 -" + r + " c"), i.push(n + " -" + r + " " + r + " -" + n + " " + r + " 0 c"), i.push("f"), i.push("Q"), e.stream = i.join("\n"), e;
              }
            },
            Cross: {
              createAppearanceStream: function createAppearanceStream(t) {
                var e = {
                  D: {
                    Off: G.RadioButton.Cross.OffPushDown
                  },
                  N: {}
                };
                return e.N[t] = G.RadioButton.Cross.YesNormal, e.D[t] = G.RadioButton.Cross.YesPushDown, e;
              },
              getCA: function getCA() {
                return "8";
              },
              YesNormal: function YesNormal(t) {
                var e = u(t),
                  i = [],
                  s = G.internal.calculateCross(t);
                return i.push("q"), i.push("1 1 " + o(G.internal.getWidth(t) - 2) + " " + o(G.internal.getHeight(t) - 2) + " re"), i.push("W"), i.push("n"), i.push(o(s.x1.x) + " " + o(s.x1.y) + " m"), i.push(o(s.x2.x) + " " + o(s.x2.y) + " l"), i.push(o(s.x4.x) + " " + o(s.x4.y) + " m"), i.push(o(s.x3.x) + " " + o(s.x3.y) + " l"), i.push("s"), i.push("Q"), e.stream = i.join("\n"), e;
              },
              YesPushDown: function YesPushDown(t) {
                var e = u(t),
                  i = G.internal.calculateCross(t),
                  s = [];
                return s.push("0.749023 g"), s.push("0 0 " + o(G.internal.getWidth(t)) + " " + o(G.internal.getHeight(t)) + " re"), s.push("f"), s.push("q"), s.push("1 1 " + o(G.internal.getWidth(t) - 2) + " " + o(G.internal.getHeight(t) - 2) + " re"), s.push("W"), s.push("n"), s.push(o(i.x1.x) + " " + o(i.x1.y) + " m"), s.push(o(i.x2.x) + " " + o(i.x2.y) + " l"), s.push(o(i.x4.x) + " " + o(i.x4.y) + " m"), s.push(o(i.x3.x) + " " + o(i.x3.y) + " l"), s.push("s"), s.push("Q"), e.stream = s.join("\n"), e;
              },
              OffPushDown: function OffPushDown(t) {
                var e = u(t),
                  i = [];
                return i.push("0.749023 g"), i.push("0 0 " + o(G.internal.getWidth(t)) + " " + o(G.internal.getHeight(t)) + " re"), i.push("f"), e.stream = i.join("\n"), e;
              }
            }
          },
          createDefaultAppearanceStream: function createDefaultAppearanceStream(t) {
            var e = i.internal.getFont(t.fontName, t.fontStyle).id,
              s = i.__private__.encodeColorString(t.color);
            return "/" + e + " " + t.fontSize + " Tf " + s;
          }
        };
        G.internal = {
          Bezier_C: .551915024494,
          calculateCross: function calculateCross(t) {
            var e = G.internal.getWidth(t),
              i = G.internal.getHeight(t),
              s = Math.min(e, i);
            return {
              x1: {
                x: (e - s) / 2,
                y: (i - s) / 2 + s
              },
              x2: {
                x: (e - s) / 2 + s,
                y: (i - s) / 2
              },
              x3: {
                x: (e - s) / 2,
                y: (i - s) / 2
              },
              x4: {
                x: (e - s) / 2 + s,
                y: (i - s) / 2 + s
              }
            };
          }
        }, G.internal.getWidth = function (t) {
          var e = 0;
          return "object" === r(t) && (e = A(t.Rect[2])), e;
        }, G.internal.getHeight = function (t) {
          var e = 0;
          return "object" === r(t) && (e = A(t.Rect[3])), e;
        };
        var X = t.addField = function (t) {
          if (L.call(this), !(t instanceof T)) throw new Error("Invalid argument passed to jsPDF.addField.");
          return function (t) {
            i.internal.acroformPlugin.printedOut && (i.internal.acroformPlugin.printedOut = !1, i.internal.acroformPlugin.acroFormDictionaryRoot = null), i.internal.acroformPlugin.acroFormDictionaryRoot || L.call(i), i.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t);
          }.call(this, t), t.page = i.internal.getCurrentPageInfo().pageNumber, this;
        };
        t.addButton = function (t) {
          if (t instanceof R == 0) throw new Error("Invalid argument passed to jsPDF.addButton.");
          return X.call(this, t);
        }, t.addTextField = function (t) {
          if (t instanceof V == 0) throw new Error("Invalid argument passed to jsPDF.addTextField.");
          return X.call(this, t);
        }, t.addChoiceField = function (t) {
          if (t instanceof P == 0) throw new Error("Invalid argument passed to jsPDF.addChoiceField.");
          return X.call(this, t);
        }, "object" == r(e) && void 0 === e.ChoiceField && void 0 === e.ListBox && void 0 === e.ComboBox && void 0 === e.EditBox && void 0 === e.Button && void 0 === e.PushButton && void 0 === e.RadioButton && void 0 === e.CheckBox && void 0 === e.TextField && void 0 === e.PasswordField ? (e.ChoiceField = P, e.ListBox = j, e.ComboBox = M, e.EditBox = D, e.Button = R, e.PushButton = _, e.RadioButton = z, e.CheckBox = q, e.TextField = V, e.PasswordField = J, e.AcroForm = {
          Appearance: G
        }) : console.warn("AcroForm-Classes are not populated into global-namespace, because the class-Names exist already."), t.AcroFormChoiceField = P, t.AcroFormListBox = j, t.AcroFormComboBox = M, t.AcroFormEditBox = D, t.AcroFormButton = R, t.AcroFormPushButton = _, t.AcroFormRadioButton = z, t.AcroFormCheckBox = q, t.AcroFormTextField = V, t.AcroFormPasswordField = J, t.AcroFormAppearance = G, t.AcroForm = {
          ChoiceField: P,
          ListBox: j,
          ComboBox: M,
          EditBox: D,
          Button: R,
          PushButton: _,
          RadioButton: z,
          CheckBox: q,
          TextField: V,
          PasswordField: J,
          Appearance: G
        };
      })((window.tmp = ft).API, "undefined" != typeof window && window || void 0 !== s && s),
      /** @license
         * jsPDF addImage plugin
         * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
         *               2013 Chris Dowling, https://github.com/gingerchris
         *               2013 Trinh Ho, https://github.com/ineedfat
         *               2013 Edwin Alejandro Perez, https://github.com/eaparango
         *               2013 Norah Smith, https://github.com/burnburnrocket
         *               2014 Diego Casorran, https://github.com/diegocr
         *               2014 James Robb, https://github.com/jamesbrobb
         *
         * 
         */
      function (t) {
        var e = "addImage_",
          i = {
            PNG: [[137, 80, 78, 71]],
            TIFF: [[77, 77, 0, 42], [73, 73, 42, 0]],
            JPEG: [[255, 216, 255, 224, void 0, void 0, 74, 70, 73, 70, 0], [255, 216, 255, 225, void 0, void 0, 69, 120, 105, 102, 0, 0]],
            JPEG2000: [[0, 0, 0, 12, 106, 80, 32, 32]],
            GIF87a: [[71, 73, 70, 56, 55, 97]],
            GIF89a: [[71, 73, 70, 56, 57, 97]],
            BMP: [[66, 77], [66, 65], [67, 73], [67, 80], [73, 67], [80, 84]]
          },
          s = t.getImageFileTypeByImageData = function (e, s) {
            var r, n;
            s = s || "UNKNOWN";
            var a,
              o,
              h,
              l = "UNKNOWN";
            for (h in t.isArrayBufferView(e) && (e = t.arrayBufferToBinaryString(e)), i) for (a = i[h], r = 0; r < a.length; r += 1) {
              for (o = !0, n = 0; n < a[r].length; n += 1) if (void 0 !== a[r][n] && a[r][n] !== e.charCodeAt(n)) {
                o = !1;
                break;
              }
              if (!0 === o) {
                l = h;
                break;
              }
            }
            return "UNKNOWN" === l && "UNKNOWN" !== s && (console.warn('FileType of Image not recognized. Processing image as "' + s + '".'), l = s), l;
          },
          n = function t(e) {
            for (var i = this.internal.newObject(), s = this.internal.write, r = this.internal.putStream, n = (0, this.internal.getFilters)(); -1 !== n.indexOf("FlateEncode");) n.splice(n.indexOf("FlateEncode"), 1);
            e.n = i;
            var a = [];
            if (a.push({
              key: "Type",
              value: "/XObject"
            }), a.push({
              key: "Subtype",
              value: "/Image"
            }), a.push({
              key: "Width",
              value: e.w
            }), a.push({
              key: "Height",
              value: e.h
            }), e.cs === this.color_spaces.INDEXED ? a.push({
              key: "ColorSpace",
              value: "[/Indexed /DeviceRGB " + (e.pal.length / 3 - 1) + " " + ("smask" in e ? i + 2 : i + 1) + " 0 R]"
            }) : (a.push({
              key: "ColorSpace",
              value: "/" + e.cs
            }), e.cs === this.color_spaces.DEVICE_CMYK && a.push({
              key: "Decode",
              value: "[1 0 1 0 1 0 1 0]"
            })), a.push({
              key: "BitsPerComponent",
              value: e.bpc
            }), "dp" in e && a.push({
              key: "DecodeParms",
              value: "<<" + e.dp + ">>"
            }), "trns" in e && e.trns.constructor == Array) {
              for (var o = "", h = 0, l = e.trns.length; h < l; h++) o += e.trns[h] + " " + e.trns[h] + " ";
              a.push({
                key: "Mask",
                value: "[" + o + "]"
              });
            }
            "smask" in e && a.push({
              key: "SMask",
              value: i + 1 + " 0 R"
            });
            var A = void 0 !== e.f ? ["/" + e.f] : void 0;
            if (r({
              data: e.data,
              additionalKeyValues: a,
              alreadyAppliedFilters: A
            }), s("endobj"), "smask" in e) {
              var c = "/Predictor " + e.p + " /Colors 1 /BitsPerComponent " + e.bpc + " /Columns " + e.w,
                u = {
                  w: e.w,
                  h: e.h,
                  cs: "DeviceGray",
                  bpc: e.bpc,
                  dp: c,
                  data: e.smask
                };
              "f" in e && (u.f = e.f), t.call(this, u);
            }
            e.cs === this.color_spaces.INDEXED && (this.internal.newObject(), r({
              data: this.arrayBufferToBinaryString(new Uint8Array(e.pal))
            }), s("endobj"));
          },
          a = function a() {
            var t = this.internal.collections[e + "images"];
            for (var i in t) n.call(this, t[i]);
          },
          o = function o() {
            var t,
              i = this.internal.collections[e + "images"],
              s = this.internal.write;
            for (var r in i) s("/I" + (t = i[r]).i, t.n, "0", "R");
          },
          h = function h(e) {
            return "function" == typeof t["process" + e.toUpperCase()];
          },
          l = function l(t) {
            return "object" === r(t) && 1 === t.nodeType;
          },
          A = function A(e, i) {
            if ("IMG" === e.nodeName && e.hasAttribute("src")) {
              var s = "" + e.getAttribute("src");
              if (0 === s.indexOf("data:image/")) return unescape(s);
              var r = t.loadFile(s);
              if (void 0 !== r) return btoa(r);
            }
            if ("CANVAS" === e.nodeName) {
              var n = e;
              return e.toDataURL("image/jpeg", 1);
            }
            (n = document.createElement("canvas")).width = e.clientWidth || e.width, n.height = e.clientHeight || e.height;
            var a = n.getContext("2d");
            if (!a) throw "addImage requires canvas to be supported by browser.";
            return a.drawImage(e, 0, 0, n.width, n.height), n.toDataURL("png" == ("" + i).toLowerCase() ? "image/png" : "image/jpeg");
          },
          c = function c(t, e) {
            var i;
            if (e) for (var s in e) if (t === e[s].alias) {
              i = e[s];
              break;
            }
            return i;
          };
        t.color_spaces = {
          DEVICE_RGB: "DeviceRGB",
          DEVICE_GRAY: "DeviceGray",
          DEVICE_CMYK: "DeviceCMYK",
          CAL_GREY: "CalGray",
          CAL_RGB: "CalRGB",
          LAB: "Lab",
          ICC_BASED: "ICCBased",
          INDEXED: "Indexed",
          PATTERN: "Pattern",
          SEPARATION: "Separation",
          DEVICE_N: "DeviceN"
        }, t.decode = {
          DCT_DECODE: "DCTDecode",
          FLATE_DECODE: "FlateDecode",
          LZW_DECODE: "LZWDecode",
          JPX_DECODE: "JPXDecode",
          JBIG2_DECODE: "JBIG2Decode",
          ASCII85_DECODE: "ASCII85Decode",
          ASCII_HEX_DECODE: "ASCIIHexDecode",
          RUN_LENGTH_DECODE: "RunLengthDecode",
          CCITT_FAX_DECODE: "CCITTFaxDecode"
        }, t.image_compression = {
          NONE: "NONE",
          FAST: "FAST",
          MEDIUM: "MEDIUM",
          SLOW: "SLOW"
        }, t.sHashCode = function (t) {
          var e,
            i = 0;
          if (0 === (t = t || "").length) return i;
          for (e = 0; e < t.length; e++) i = (i << 5) - i + t.charCodeAt(e), i |= 0;
          return i;
        }, t.isString = function (t) {
          return "string" == typeof t;
        }, t.validateStringAsBase64 = function (t) {
          (t = t || "").toString().trim();
          var e = !0;
          return 0 === t.length && (e = !1), t.length % 4 != 0 && (e = !1), !1 === /^[A-Za-z0-9+\/]+$/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /^[A-Za-z0-9\/][A-Za-z0-9+\/]|[A-Za-z0-9+\/]=|==$/.test(t.substr(-2)) && (e = !1), e;
        }, t.extractInfoFromBase64DataURI = function (t) {
          return /^data:([\w]+?\/([\w]+?));\S*;*base64,(.+)$/g.exec(t);
        }, t.extractImageFromDataUrl = function (t) {
          var e = (t = t || "").split("base64,"),
            i = null;
          if (2 === e.length) {
            var s = /^data:(\w*\/\w*);*(charset=[\w=-]*)*;*$/.exec(e[0]);
            Array.isArray(s) && (i = {
              mimeType: s[1],
              charset: s[2],
              data: e[1]
            });
          }
          return i;
        }, t.supportsArrayBuffer = function () {
          return "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array;
        }, t.isArrayBuffer = function (t) {
          return !!this.supportsArrayBuffer() && t instanceof ArrayBuffer;
        }, t.isArrayBufferView = function (t) {
          return !!this.supportsArrayBuffer() && "undefined" != typeof Uint32Array && (t instanceof Int8Array || t instanceof Uint8Array || "undefined" != typeof Uint8ClampedArray && t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array);
        }, t.binaryStringToUint8Array = function (t) {
          for (var e = t.length, i = new Uint8Array(e), s = 0; s < e; s++) i[s] = t.charCodeAt(s);
          return i;
        }, t.arrayBufferToBinaryString = function (t) {
          if ("function" == typeof atob) return atob(this.arrayBufferToBase64(t));
        }, t.arrayBufferToBase64 = function (t) {
          for (var e, i = "", s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", r = new Uint8Array(t), n = r.byteLength, a = n % 3, o = n - a, h = 0; h < o; h += 3) i += s[(16515072 & (e = r[h] << 16 | r[h + 1] << 8 | r[h + 2])) >> 18] + s[(258048 & e) >> 12] + s[(4032 & e) >> 6] + s[63 & e];
          return 1 == a ? i += s[(252 & (e = r[o])) >> 2] + s[(3 & e) << 4] + "==" : 2 == a && (i += s[(64512 & (e = r[o] << 8 | r[o + 1])) >> 10] + s[(1008 & e) >> 4] + s[(15 & e) << 2] + "="), i;
        }, t.createImageInfo = function (t, e, i, s, r, n, a, o, h, l, A, c, u) {
          var d = {
            alias: o,
            w: e,
            h: i,
            cs: s,
            bpc: r,
            i: a,
            data: t
          };
          return n && (d.f = n), h && (d.dp = h), l && (d.trns = l), A && (d.pal = A), c && (d.smask = c), u && (d.p = u), d;
        }, t.addImage = function (i, s, n, u, d, f, p, g, w) {
          var m = "";
          if ("string" != typeof s) {
            var v = f;
            f = d, d = u, u = n, n = s, s = v;
          }
          if ("object" === r(i) && !l(i) && "imageData" in i) {
            var b = i;
            i = b.imageData, s = b.format || s || "UNKNOWN", n = b.x || n || 0, u = b.y || u || 0, d = b.w || d, f = b.h || f, p = b.alias || p, g = b.compression || g, w = b.rotation || b.angle || w;
          }
          var B = this.internal.getFilters();
          if (void 0 === g && -1 !== B.indexOf("FlateEncode") && (g = "SLOW"), "string" == typeof i && (i = unescape(i)), isNaN(n) || isNaN(u)) throw console.error("jsPDF.addImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addImage");
          var y,
            C,
            F,
            x,
            N,
            E,
            U,
            Q = function () {
              var t = this.internal.collections[e + "images"];
              return t || (this.internal.collections[e + "images"] = t = {}, this.internal.events.subscribe("putResources", a), this.internal.events.subscribe("putXobjectDict", o)), t;
            }.call(this);
          if (!((y = c(i, Q)) || (l(i) && (i = A(i, s)), (null == (U = p) || 0 === U.length) && (p = "string" == typeof (E = i) ? t.sHashCode(E) : t.isArrayBufferView(E) ? t.sHashCode(t.arrayBufferToBinaryString(E)) : null), y = c(p, Q)))) {
            if (this.isString(i) && ("" !== (m = this.convertStringToImageData(i)) || void 0 !== (m = t.loadFile(i))) && (i = m), s = this.getImageFileTypeByImageData(i, s), !h(s)) throw new Error("addImage does not support files of type '" + s + "', please ensure that a plugin for '" + s + "' support is added.");
            if (this.supportsArrayBuffer() && (i instanceof Uint8Array || (C = i, i = this.binaryStringToUint8Array(i))), !(y = this["process" + s.toUpperCase()](i, (N = 0, (x = Q) && (N = Object.keys ? Object.keys(x).length : function (t) {
              var e = 0;
              for (var i in t) t.hasOwnProperty(i) && e++;
              return e;
            }(x)), N), p, ((F = g) && "string" == typeof F && (F = F.toUpperCase()), F in t.image_compression ? F : t.image_compression.NONE), C))) throw new Error("An unknown error occurred whilst processing the image");
          }
          return function (t, e, i, s, r, n, a, o) {
            var h = function (t, e, i) {
                return t || e || (e = t = -96), t < 0 && (t = -1 * i.w * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * i.h * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * i.w / i.h), 0 === e && (e = t * i.h / i.w), [t, e];
              }.call(this, i, s, r),
              l = this.internal.getCoordinateString,
              A = this.internal.getVerticalCoordinateString;
            if (i = h[0], s = h[1], a[n] = r, o) {
              o *= Math.PI / 180;
              var c = Math.cos(o),
                u = Math.sin(o),
                d = function d(t) {
                  return t.toFixed(4);
                },
                f = [d(c), d(u), d(-1 * u), d(c), 0, 0, "cm"];
            }
            this.internal.write("q"), o ? (this.internal.write([1, "0", "0", 1, l(t), A(e + s), "cm"].join(" ")), this.internal.write(f.join(" ")), this.internal.write([l(i), "0", "0", l(s), "0", "0", "cm"].join(" "))) : this.internal.write([l(i), "0", "0", l(s), l(t), A(e + s), "cm"].join(" ")), this.internal.write("/I" + r.i + " Do"), this.internal.write("Q");
          }.call(this, n, u, d, f, y, y.i, Q, w), this;
        }, t.convertStringToImageData = function (e) {
          var i,
            s = "";
          if (this.isString(e)) {
            var r;
            i = null !== (r = this.extractImageFromDataUrl(e)) ? r.data : e;
            try {
              s = atob(i);
            } catch (e) {
              throw t.validateStringAsBase64(i) ? new Error("atob-Error in jsPDF.convertStringToImageData " + e.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertStringToImageData ");
            }
          }
          return s;
        };
        var u = function u(t, e) {
          return t.subarray(e, e + 5);
        };
        t.processJPEG = function (t, e, i, r, n, a) {
          var o,
            h = this.decode.DCT_DECODE;
          if (!this.isString(t) && !this.isArrayBuffer(t) && !this.isArrayBufferView(t)) return null;
          if (this.isString(t) && (o = function (t) {
            var e;
            if ("JPEG" !== s(t)) throw new Error("getJpegSize requires a binary string jpeg file");
            for (var i = 256 * t.charCodeAt(4) + t.charCodeAt(5), r = 4, n = t.length; r < n;) {
              if (r += i, 255 !== t.charCodeAt(r)) throw new Error("getJpegSize could not find the size of the image");
              if (192 === t.charCodeAt(r + 1) || 193 === t.charCodeAt(r + 1) || 194 === t.charCodeAt(r + 1) || 195 === t.charCodeAt(r + 1) || 196 === t.charCodeAt(r + 1) || 197 === t.charCodeAt(r + 1) || 198 === t.charCodeAt(r + 1) || 199 === t.charCodeAt(r + 1)) return e = 256 * t.charCodeAt(r + 5) + t.charCodeAt(r + 6), [256 * t.charCodeAt(r + 7) + t.charCodeAt(r + 8), e, t.charCodeAt(r + 9)];
              r += 2, i = 256 * t.charCodeAt(r) + t.charCodeAt(r + 1);
            }
          }(t)), this.isArrayBuffer(t) && (t = new Uint8Array(t)), this.isArrayBufferView(t) && (o = function (t) {
            if (65496 != (t[0] << 8 | t[1])) throw new Error("Supplied data is not a JPEG");
            for (var e, i = t.length, s = (t[4] << 8) + t[5], r = 4; r < i;) {
              if (s = ((e = u(t, r += s))[2] << 8) + e[3], (192 === e[1] || 194 === e[1]) && 255 === e[0] && 7 < s) return {
                width: ((e = u(t, r + 5))[2] << 8) + e[3],
                height: (e[0] << 8) + e[1],
                numcomponents: e[4]
              };
              r += 2;
            }
            throw new Error("getJpegSizeFromBytes could not find the size of the image");
          }(t), t = n || this.arrayBufferToBinaryString(t)), void 0 === a) switch (o.numcomponents) {
            case 1:
              a = this.color_spaces.DEVICE_GRAY;
              break;
            case 4:
              a = this.color_spaces.DEVICE_CMYK;
              break;
            default:
            case 3:
              a = this.color_spaces.DEVICE_RGB;
          }
          return this.createImageInfo(t, o.width, o.height, a, 8, h, e, i);
        }, t.processJPG = function () {
          return this.processJPEG.apply(this, arguments);
        }, t.getImageProperties = function (e) {
          var i,
            s,
            r = "";
          if (l(e) && (e = A(e)), this.isString(e) && ("" !== (r = this.convertStringToImageData(e)) || void 0 !== (r = t.loadFile(e))) && (e = r), s = this.getImageFileTypeByImageData(e), !h(s)) throw new Error("addImage does not support files of type '" + s + "', please ensure that a plugin for '" + s + "' support is added.");
          if (this.supportsArrayBuffer() && (e instanceof Uint8Array || (e = this.binaryStringToUint8Array(e))), !(i = this["process" + s.toUpperCase()](e))) throw new Error("An unknown error occurred whilst processing the image");
          return {
            fileType: s,
            width: i.w,
            height: i.h,
            colorSpace: i.cs,
            compressionMode: i.f,
            bitsPerComponent: i.bpc
          };
        };
      }(ft.API),
      /**
         * @license
         * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
         *
         * Licensed under the MIT License.
         * http://opensource.org/licenses/mit-license
         */
      n = ft.API, ft.API.events.push(["addPage", function (t) {
        this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
      }]), n.events.push(["putPage", function (t) {
        for (var e = this.internal.getPageInfoByObjId(t.objId), i = t.pageContext.annotations, s = function s(t) {
            if (void 0 !== t && "" != t) return !0;
          }, r = !1, n = 0; n < i.length && !r; n++) switch ((h = i[n]).type) {
          case "link":
            if (s(h.options.url) || s(h.options.pageNumber)) {
              r = !0;
              break;
            }
          case "reference":
          case "text":
          case "freetext":
            r = !0;
        }
        if (0 != r) {
          this.internal.write("/Annots ["), this.internal.pageSize.height;
          var a = this.internal.getCoordinateString,
            o = this.internal.getVerticalCoordinateString;
          for (n = 0; n < i.length; n++) {
            var h;
            switch ((h = i[n]).type) {
              case "reference":
                this.internal.write(" " + h.object.objId + " 0 R ");
                break;
              case "text":
                var l = this.internal.newAdditionalObject(),
                  A = this.internal.newAdditionalObject(),
                  c = h.title || "Note";
                g = "<</Type /Annot /Subtype /Text " + (d = "/Rect [" + a(h.bounds.x) + " " + o(h.bounds.y + h.bounds.h) + " " + a(h.bounds.x + h.bounds.w) + " " + o(h.bounds.y) + "] ") + "/Contents (" + h.contents + ")", g += " /Popup " + A.objId + " 0 R", g += " /P " + e.objId + " 0 R", g += " /T (" + c + ") >>", l.content = g;
                var u = l.objId + " 0 R";
                g = "<</Type /Annot /Subtype /Popup " + (d = "/Rect [" + a(h.bounds.x + 30) + " " + o(h.bounds.y + h.bounds.h) + " " + a(h.bounds.x + h.bounds.w + 30) + " " + o(h.bounds.y) + "] ") + " /Parent " + u, h.open && (g += " /Open true"), g += " >>", A.content = g, this.internal.write(l.objId, "0 R", A.objId, "0 R");
                break;
              case "freetext":
                var d = "/Rect [" + a(h.bounds.x) + " " + o(h.bounds.y) + " " + a(h.bounds.x + h.bounds.w) + " " + o(h.bounds.y + h.bounds.h) + "] ",
                  f = h.color || "#000000";
                g = "<</Type /Annot /Subtype /FreeText " + d + "/Contents (" + h.contents + ")", g += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + f + ")", g += " /Border [0 0 0]", g += " >>", this.internal.write(g);
                break;
              case "link":
                if (h.options.name) {
                  var p = this.annotations._nameMap[h.options.name];
                  h.options.pageNumber = p.page, h.options.top = p.y;
                } else h.options.top || (h.options.top = 0);
                d = "/Rect [" + a(h.x) + " " + o(h.y) + " " + a(h.x + h.w) + " " + o(h.y + h.h) + "] ";
                var g = "";
                if (h.options.url) g = "<</Type /Annot /Subtype /Link " + d + "/Border [0 0 0] /A <</S /URI /URI (" + h.options.url + ") >>";else if (h.options.pageNumber) switch (g = "<</Type /Annot /Subtype /Link " + d + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(h.options.pageNumber).objId + " 0 R", h.options.magFactor = h.options.magFactor || "XYZ", h.options.magFactor) {
                  case "Fit":
                    g += " /Fit]";
                    break;
                  case "FitH":
                    g += " /FitH " + h.options.top + "]";
                    break;
                  case "FitV":
                    h.options.left = h.options.left || 0, g += " /FitV " + h.options.left + "]";
                    break;
                  case "XYZ":
                  default:
                    var w = o(h.options.top);
                    h.options.left = h.options.left || 0, void 0 === h.options.zoom && (h.options.zoom = 0), g += " /XYZ " + h.options.left + " " + w + " " + h.options.zoom + "]";
                }
                "" != g && (g += " >>", this.internal.write(g));
            }
          }
          this.internal.write("]");
        }
      }]), n.createAnnotation = function (t) {
        var e = this.internal.getCurrentPageInfo();
        switch (t.type) {
          case "link":
            this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
            break;
          case "text":
          case "freetext":
            e.pageContext.annotations.push(t);
        }
      }, n.link = function (t, e, i, s, r) {
        this.internal.getCurrentPageInfo().pageContext.annotations.push({
          x: t,
          y: e,
          w: i,
          h: s,
          options: r,
          type: "link"
        });
      }, n.textWithLink = function (t, e, i, s) {
        var r = this.getTextWidth(t),
          n = this.internal.getLineHeight() / this.internal.scaleFactor;
        return this.text(t, e, i), i += .2 * n, this.link(e, i - n, r, n, s), r;
      }, n.getTextWidth = function (t) {
        var e = this.internal.getFontSize();
        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
      },
      /**
         * @license
         * Copyright (c) 2017 Aras Abbasi 
         *
         * Licensed under the MIT License.
         * http://opensource.org/licenses/mit-license
         */
      function (t) {
        var e = {
            1569: [65152],
            1570: [65153, 65154],
            1571: [65155, 65156],
            1572: [65157, 65158],
            1573: [65159, 65160],
            1574: [65161, 65162, 65163, 65164],
            1575: [65165, 65166],
            1576: [65167, 65168, 65169, 65170],
            1577: [65171, 65172],
            1578: [65173, 65174, 65175, 65176],
            1579: [65177, 65178, 65179, 65180],
            1580: [65181, 65182, 65183, 65184],
            1581: [65185, 65186, 65187, 65188],
            1582: [65189, 65190, 65191, 65192],
            1583: [65193, 65194],
            1584: [65195, 65196],
            1585: [65197, 65198],
            1586: [65199, 65200],
            1587: [65201, 65202, 65203, 65204],
            1588: [65205, 65206, 65207, 65208],
            1589: [65209, 65210, 65211, 65212],
            1590: [65213, 65214, 65215, 65216],
            1591: [65217, 65218, 65219, 65220],
            1592: [65221, 65222, 65223, 65224],
            1593: [65225, 65226, 65227, 65228],
            1594: [65229, 65230, 65231, 65232],
            1601: [65233, 65234, 65235, 65236],
            1602: [65237, 65238, 65239, 65240],
            1603: [65241, 65242, 65243, 65244],
            1604: [65245, 65246, 65247, 65248],
            1605: [65249, 65250, 65251, 65252],
            1606: [65253, 65254, 65255, 65256],
            1607: [65257, 65258, 65259, 65260],
            1608: [65261, 65262],
            1609: [65263, 65264, 64488, 64489],
            1610: [65265, 65266, 65267, 65268],
            1649: [64336, 64337],
            1655: [64477],
            1657: [64358, 64359, 64360, 64361],
            1658: [64350, 64351, 64352, 64353],
            1659: [64338, 64339, 64340, 64341],
            1662: [64342, 64343, 64344, 64345],
            1663: [64354, 64355, 64356, 64357],
            1664: [64346, 64347, 64348, 64349],
            1667: [64374, 64375, 64376, 64377],
            1668: [64370, 64371, 64372, 64373],
            1670: [64378, 64379, 64380, 64381],
            1671: [64382, 64383, 64384, 64385],
            1672: [64392, 64393],
            1676: [64388, 64389],
            1677: [64386, 64387],
            1678: [64390, 64391],
            1681: [64396, 64397],
            1688: [64394, 64395],
            1700: [64362, 64363, 64364, 64365],
            1702: [64366, 64367, 64368, 64369],
            1705: [64398, 64399, 64400, 64401],
            1709: [64467, 64468, 64469, 64470],
            1711: [64402, 64403, 64404, 64405],
            1713: [64410, 64411, 64412, 64413],
            1715: [64406, 64407, 64408, 64409],
            1722: [64414, 64415],
            1723: [64416, 64417, 64418, 64419],
            1726: [64426, 64427, 64428, 64429],
            1728: [64420, 64421],
            1729: [64422, 64423, 64424, 64425],
            1733: [64480, 64481],
            1734: [64473, 64474],
            1735: [64471, 64472],
            1736: [64475, 64476],
            1737: [64482, 64483],
            1739: [64478, 64479],
            1740: [64508, 64509, 64510, 64511],
            1744: [64484, 64485, 64486, 64487],
            1746: [64430, 64431],
            1747: [64432, 64433]
          },
          i = {
            65247: {
              65154: 65269,
              65156: 65271,
              65160: 65273,
              65166: 65275
            },
            65248: {
              65154: 65270,
              65156: 65272,
              65160: 65274,
              65166: 65276
            },
            65165: {
              65247: {
                65248: {
                  65258: 65010
                }
              }
            },
            1617: {
              1612: 64606,
              1613: 64607,
              1614: 64608,
              1615: 64609,
              1616: 64610
            }
          },
          s = {
            1612: 64606,
            1613: 64607,
            1614: 64608,
            1615: 64609,
            1616: 64610
          },
          r = [1570, 1571, 1573, 1575];
        t.__arabicParser__ = {};
        var n = t.__arabicParser__.isInArabicSubstitutionA = function (t) {
            return void 0 !== e[t.charCodeAt(0)];
          },
          a = t.__arabicParser__.isArabicLetter = function (t) {
            return "string" == typeof t && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t);
          },
          o = t.__arabicParser__.isArabicEndLetter = function (t) {
            return a(t) && n(t) && e[t.charCodeAt(0)].length <= 2;
          },
          h = t.__arabicParser__.isArabicAlfLetter = function (t) {
            return a(t) && 0 <= r.indexOf(t.charCodeAt(0));
          },
          l = (t.__arabicParser__.arabicLetterHasIsolatedForm = function (t) {
            return a(t) && n(t) && 1 <= e[t.charCodeAt(0)].length;
          }, t.__arabicParser__.arabicLetterHasFinalForm = function (t) {
            return a(t) && n(t) && 2 <= e[t.charCodeAt(0)].length;
          }),
          A = (t.__arabicParser__.arabicLetterHasInitialForm = function (t) {
            return a(t) && n(t) && 3 <= e[t.charCodeAt(0)].length;
          }, t.__arabicParser__.arabicLetterHasMedialForm = function (t) {
            return a(t) && n(t) && 4 == e[t.charCodeAt(0)].length;
          }),
          c = t.__arabicParser__.resolveLigatures = function (t) {
            var e = 0,
              s = i,
              r = 0,
              n = "",
              a = 0;
            for (e = 0; e < t.length; e += 1) void 0 !== s[t.charCodeAt(e)] ? (a++, "number" == typeof (s = s[t.charCodeAt(e)]) && (r = -1 !== (r = u(t.charAt(e), t.charAt(e - a), t.charAt(e + 1))) ? r : 0, n += String.fromCharCode(s), s = i, a = 0), e === t.length - 1 && (s = i, n += t.charAt(e - (a - 1)), e -= a - 1, a = 0)) : (s = i, n += t.charAt(e - a), e -= a, a = 0);
            return n;
          },
          u = (t.__arabicParser__.isArabicDiacritic = function (t) {
            return void 0 !== t && void 0 !== s[t.charCodeAt(0)];
          }, t.__arabicParser__.getCorrectForm = function (t, e, i) {
            return a(t) ? !1 === n(t) ? -1 : !l(t) || !a(e) && !a(i) || !a(i) && o(e) || o(t) && !a(e) || o(t) && h(e) || o(t) && o(e) ? 0 : A(t) && a(e) && !o(e) && a(i) && l(i) ? 3 : o(t) || !a(i) ? 1 : 2 : -1;
          }),
          d = t.__arabicParser__.processArabic = t.processArabic = function (t) {
            var i = 0,
              s = 0,
              r = 0,
              n = "",
              o = "",
              h = "",
              l = (t = t || "").split("\\s+"),
              A = [];
            for (i = 0; i < l.length; i += 1) {
              for (A.push(""), s = 0; s < l[i].length; s += 1) n = l[i][s], o = l[i][s - 1], h = l[i][s + 1], a(n) ? (r = u(n, o, h), A[i] += -1 !== r ? String.fromCharCode(e[n.charCodeAt(0)][r]) : n) : A[i] += n;
              A[i] = c(A[i]);
            }
            return A.join(" ");
          };
        t.events.push(["preProcessText", function (t) {
          var e = t.text,
            i = (t.x, t.y, t.options || {}),
            s = (t.mutex, i.lang, []);
          if ("[object Array]" === Object.prototype.toString.call(e)) {
            var r = 0;
            for (s = [], r = 0; r < e.length; r += 1) "[object Array]" === Object.prototype.toString.call(e[r]) ? s.push([d(e[r][0]), e[r][1], e[r][2]]) : s.push([d(e[r])]);
            t.text = s;
          } else t.text = d(e);
        }]);
      }(ft.API), ft.API.autoPrint = function (t) {
        var e;
        switch ((t = t || {}).variant = t.variant || "non-conform", t.variant) {
          case "javascript":
            this.addJS("print({});");
            break;
          case "non-conform":
          default:
            this.internal.events.subscribe("postPutResources", function () {
              e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
            }), this.internal.events.subscribe("putCatalog", function () {
              this.internal.out("/OpenAction " + e + " 0 R");
            });
        }
        return this;
      },
      /**
         * @license
         * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
         *
         * Licensed under the MIT License.
         * http://opensource.org/licenses/mit-license
         */
      a = ft.API, (h = function h() {
        var t = void 0;
        Object.defineProperty(this, "pdf", {
          get: function get() {
            return t;
          },
          set: function set(e) {
            t = e;
          }
        });
        var e = 150;
        Object.defineProperty(this, "width", {
          get: function get() {
            return e;
          },
          set: function set(t) {
            e = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 150 : t, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = e + 1);
          }
        });
        var i = 300;
        Object.defineProperty(this, "height", {
          get: function get() {
            return i;
          },
          set: function set(t) {
            i = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 300 : t, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = i + 1);
          }
        });
        var s = [];
        Object.defineProperty(this, "childNodes", {
          get: function get() {
            return s;
          },
          set: function set(t) {
            s = t;
          }
        });
        var r = {};
        Object.defineProperty(this, "style", {
          get: function get() {
            return r;
          },
          set: function set(t) {
            r = t;
          }
        }), Object.defineProperty(this, "parentNode", {
          get: function get() {
            return !1;
          }
        });
      }).prototype.getContext = function (t, e) {
        var i;
        if ("2d" !== (t = t || "2d")) return null;
        for (i in e) this.pdf.context2d.hasOwnProperty(i) && (this.pdf.context2d[i] = e[i]);
        return (this.pdf.context2d._canvas = this).pdf.context2d;
      }, h.prototype.toDataURL = function () {
        throw new Error("toDataURL is not implemented.");
      }, a.events.push(["initialized", function () {
        this.canvas = new h(), this.canvas.pdf = this;
      }]),
      /** 
         * @license
         * ====================================================================
         * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
         *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
         *               2013 Lee Driscoll, https://github.com/lsdriscoll
         *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
         *               2014 James Hall, james@parall.ax
         *               2014 Diego Casorran, https://github.com/diegocr
         *
         * 
         * ====================================================================
         */
      l = ft.API, c = {
        x: void 0,
        y: void 0,
        w: void 0,
        h: void 0,
        ln: void 0
      }, u = 1, d = function d(t, e, i, s, r) {
        c = {
          x: t,
          y: e,
          w: i,
          h: s,
          ln: r
        };
      }, f = function f() {
        return c;
      }, p = {
        left: 0,
        top: 0,
        bottom: 0
      }, l.setHeaderFunction = function (t) {
        A = t;
      }, l.getTextDimensions = function (t, e) {
        var i = this.table_font_size || this.internal.getFontSize(),
          s = (this.internal.getFont().fontStyle, (e = e || {}).scaleFactor || this.internal.scaleFactor),
          r = 0,
          n = 0,
          a = 0;
        if ("string" == typeof t) 0 != (r = this.getStringUnitWidth(t) * i) && (n = 1);else {
          if ("[object Array]" !== Object.prototype.toString.call(t)) throw new Error("getTextDimensions expects text-parameter to be of type String or an Array of Strings.");
          for (var o = 0; o < t.length; o++) r < (a = this.getStringUnitWidth(t[o]) * i) && (r = a);
          0 !== r && (n = t.length);
        }
        return {
          w: r /= s,
          h: Math.max((n * i * this.getLineHeightFactor() - i * (this.getLineHeightFactor() - 1)) / s, 0)
        };
      }, l.cellAddPage = function () {
        var t = this.margins || p;
        this.addPage(), d(t.left, t.top, void 0, void 0), u += 1;
      }, l.cellInitialize = function () {
        c = {
          x: void 0,
          y: void 0,
          w: void 0,
          h: void 0,
          ln: void 0
        }, u = 1;
      }, l.cell = function (t, e, i, s, r, n, a) {
        var o = f(),
          h = !1;
        if (void 0 !== o.ln) if (o.ln === n) t = o.x + o.w, e = o.y;else {
          var l = this.margins || p;
          o.y + o.h + s + 13 >= this.internal.pageSize.getHeight() - l.bottom && (this.cellAddPage(), h = !0, this.printHeaders && this.tableHeaderRow && this.printHeaderRow(n, !0)), e = f().y + f().h, h && (e = 23);
        }
        if (void 0 !== r[0]) if (this.printingHeaderRow ? this.rect(t, e, i, s, "FD") : this.rect(t, e, i, s), "right" === a) {
          r instanceof Array || (r = [r]);
          for (var A = 0; A < r.length; A++) {
            var c = r[A],
              u = this.getStringUnitWidth(c) * this.internal.getFontSize() / this.internal.scaleFactor;
            this.text(c, t + i - u - 3, e + this.internal.getLineHeight() * (A + 1));
          }
        } else this.text(r, t + 3, e + this.internal.getLineHeight());
        return d(t, e, i, s, n), this;
      }, l.arrayMax = function (t, e) {
        var i,
          s,
          r,
          n = t[0];
        for (i = 0, s = t.length; i < s; i += 1) r = t[i], e ? -1 === e(n, r) && (n = r) : n < r && (n = r);
        return n;
      }, l.table = function (t, e, i, s, r) {
        if (!i) throw "No data for PDF table";
        var n,
          a,
          o,
          h,
          A,
          d,
          f,
          g,
          w,
          m,
          v = [],
          b = [],
          B = {},
          y = {},
          C = [],
          F = [],
          x = !1,
          N = !0,
          E = 12,
          U = p;
        if (U.width = this.internal.pageSize.getWidth(), r && (!0 === r.autoSize && (x = !0), !1 === r.printHeaders && (N = !1), r.fontSize && (E = r.fontSize), r.css && void 0 !== r.css["font-size"] && (E = 16 * r.css["font-size"]), r.margins && (U = r.margins)), this.lnMod = 0, c = {
          x: void 0,
          y: void 0,
          w: void 0,
          h: void 0,
          ln: void 0
        }, u = 1, this.printHeaders = N, this.margins = U, this.setFontSize(E), this.table_font_size = E, null == s) v = Object.keys(i[0]);else if (s[0] && "string" != typeof s[0]) for (a = 0, o = s.length; a < o; a += 1) n = s[a], v.push(n.name), b.push(n.prompt), y[n.name] = n.width * (19.049976 / 25.4);else v = s;
        if (x) for (m = function m(t) {
          return t[n];
        }, a = 0, o = v.length; a < o; a += 1) {
          for (B[n = v[a]] = i.map(m), C.push(this.getTextDimensions(b[a] || n, {
            scaleFactor: 1
          }).w), f = 0, h = (d = B[n]).length; f < h; f += 1) A = d[f], C.push(this.getTextDimensions(A, {
            scaleFactor: 1
          }).w);
          y[n] = l.arrayMax(C), C = [];
        }
        if (N) {
          var Q = this.calculateLineHeight(v, y, b.length ? b : v);
          for (a = 0, o = v.length; a < o; a += 1) n = v[a], F.push([t, e, y[n], Q, String(b.length ? b[a] : n)]);
          this.setTableHeaderRow(F), this.printHeaderRow(1, !1);
        }
        for (a = 0, o = i.length; a < o; a += 1) for (g = i[a], Q = this.calculateLineHeight(v, y, g), f = 0, w = v.length; f < w; f += 1) n = v[f], this.cell(t, e, y[n], Q, g[n], a + 2, n.align);
        return this.lastCellPos = c, this.table_x = t, this.table_y = e, this;
      }, l.calculateLineHeight = function (t, e, i) {
        for (var s, r = 0, n = 0; n < t.length; n++) {
          i[s = t[n]] = this.splitTextToSize(String(i[s]), e[s] - 3);
          var a = this.internal.getLineHeight() * i[s].length + 3;
          r < a && (r = a);
        }
        return r;
      }, l.setTableHeaderRow = function (t) {
        this.tableHeaderRow = t;
      }, l.printHeaderRow = function (t, e) {
        if (!this.tableHeaderRow) throw "Property tableHeaderRow does not exist.";
        var i, s, r, n;
        if (this.printingHeaderRow = !0, void 0 !== A) {
          var a = A(this, u);
          d(a[0], a[1], a[2], a[3], -1);
        }
        this.setFontStyle("bold");
        var o = [];
        for (r = 0, n = this.tableHeaderRow.length; r < n; r += 1) this.setFillColor(200, 200, 200), i = this.tableHeaderRow[r], e && (this.margins.top = 13, i[1] = this.margins && this.margins.top || 0, o.push(i)), s = [].concat(i), this.cell.apply(this, s.concat(t));
        0 < o.length && this.setTableHeaderRow(o), this.setFontStyle("normal"), this.printingHeaderRow = !1;
      }, function (t, e) {
        var i,
          s,
          n,
          a,
          o,
          h = function h(t) {
            return t = t || {}, this.isStrokeTransparent = t.isStrokeTransparent || !1, this.strokeOpacity = t.strokeOpacity || 1, this.strokeStyle = t.strokeStyle || "#000000", this.fillStyle = t.fillStyle || "#000000", this.isFillTransparent = t.isFillTransparent || !1, this.fillOpacity = t.fillOpacity || 1, this.font = t.font || "10px sans-serif", this.textBaseline = t.textBaseline || "alphabetic", this.textAlign = t.textAlign || "left", this.lineWidth = t.lineWidth || 1, this.lineJoin = t.lineJoin || "miter", this.lineCap = t.lineCap || "butt", this.path = t.path || [], this.transform = void 0 !== t.transform ? t.transform.clone() : new O(), this.globalCompositeOperation = t.globalCompositeOperation || "normal", this.globalAlpha = t.globalAlpha || 1, this.clip_path = t.clip_path || [], this.currentPoint = t.currentPoint || new H(), this.miterLimit = t.miterLimit || 10, this.lastPoint = t.lastPoint || new H(), this.ignoreClearRect = "boolean" != typeof t.ignoreClearRect || t.ignoreClearRect, this;
          };
        t.events.push(["initialized", function () {
          this.context2d = new l(this), i = this.internal.f2, this.internal.f3, s = this.internal.getCoordinateString, n = this.internal.getVerticalCoordinateString, a = this.internal.getHorizontalCoordinate, o = this.internal.getVerticalCoordinate;
        }]);
        var l = function l(t) {
          Object.defineProperty(this, "canvas", {
            get: function get() {
              return {
                parentNode: !1,
                style: !1
              };
            }
          }), Object.defineProperty(this, "pdf", {
            get: function get() {
              return t;
            }
          });
          var e = !1;
          Object.defineProperty(this, "pageWrapXEnabled", {
            get: function get() {
              return e;
            },
            set: function set(t) {
              e = Boolean(t);
            }
          });
          var i = !1;
          Object.defineProperty(this, "pageWrapYEnabled", {
            get: function get() {
              return i;
            },
            set: function set(t) {
              i = Boolean(t);
            }
          });
          var s = 0;
          Object.defineProperty(this, "posX", {
            get: function get() {
              return s;
            },
            set: function set(t) {
              isNaN(t) || (s = t);
            }
          });
          var r = 0;
          Object.defineProperty(this, "posY", {
            get: function get() {
              return r;
            },
            set: function set(t) {
              isNaN(t) || (r = t);
            }
          });
          var n = !1;
          Object.defineProperty(this, "autoPaging", {
            get: function get() {
              return n;
            },
            set: function set(t) {
              n = Boolean(t);
            }
          });
          var a = 0;
          Object.defineProperty(this, "lastBreak", {
            get: function get() {
              return a;
            },
            set: function set(t) {
              a = t;
            }
          });
          var o = [];
          Object.defineProperty(this, "pageBreaks", {
            get: function get() {
              return o;
            },
            set: function set(t) {
              o = t;
            }
          });
          var l = new h();
          Object.defineProperty(this, "ctx", {
            get: function get() {
              return l;
            },
            set: function set(t) {
              t instanceof h && (l = t);
            }
          }), Object.defineProperty(this, "path", {
            get: function get() {
              return l.path;
            },
            set: function set(t) {
              l.path = t;
            }
          });
          var c = [];
          Object.defineProperty(this, "ctxStack", {
            get: function get() {
              return c;
            },
            set: function set(t) {
              c = t;
            }
          }), Object.defineProperty(this, "fillStyle", {
            get: function get() {
              return this.ctx.fillStyle;
            },
            set: function set(t) {
              var e;
              e = A(t), this.ctx.fillStyle = e.style, this.ctx.isFillTransparent = 0 === e.a, this.ctx.fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
                a: e.a
              }), this.pdf.setTextColor(e.r, e.g, e.b, {
                a: e.a
              });
            }
          }), Object.defineProperty(this, "strokeStyle", {
            get: function get() {
              return this.ctx.strokeStyle;
            },
            set: function set(t) {
              var e = A(t);
              this.ctx.strokeStyle = e.style, this.ctx.isStrokeTransparent = 0 === e.a, this.ctx.strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
            }
          }), Object.defineProperty(this, "lineCap", {
            get: function get() {
              return this.ctx.lineCap;
            },
            set: function set(t) {
              -1 !== ["butt", "round", "square"].indexOf(t) && (this.ctx.lineCap = t, this.pdf.setLineCap(t));
            }
          }), Object.defineProperty(this, "lineWidth", {
            get: function get() {
              return this.ctx.lineWidth;
            },
            set: function set(t) {
              isNaN(t) || (this.ctx.lineWidth = t, this.pdf.setLineWidth(t));
            }
          }), Object.defineProperty(this, "lineJoin", {
            get: function get() {
              return this.ctx.lineJoin;
            },
            set: function set(t) {
              -1 !== ["bevel", "round", "miter"].indexOf(t) && (this.ctx.lineJoin = t, this.pdf.setLineJoin(t));
            }
          }), Object.defineProperty(this, "miterLimit", {
            get: function get() {
              return this.ctx.miterLimit;
            },
            set: function set(t) {
              isNaN(t) || (this.ctx.miterLimit = t, this.pdf.setMiterLimit(t));
            }
          }), Object.defineProperty(this, "textBaseline", {
            get: function get() {
              return this.ctx.textBaseline;
            },
            set: function set(t) {
              this.ctx.textBaseline = t;
            }
          }), Object.defineProperty(this, "textAlign", {
            get: function get() {
              return this.ctx.textAlign;
            },
            set: function set(t) {
              -1 !== ["right", "end", "center", "left", "start"].indexOf(t) && (this.ctx.textAlign = t);
            }
          }), Object.defineProperty(this, "font", {
            get: function get() {
              return this.ctx.font;
            },
            set: function set(t) {
              var e;
              if (this.ctx.font = t, null !== (e = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))) {
                var i = e[1],
                  s = (e[2], e[3]),
                  r = e[4],
                  n = e[5],
                  a = e[6];
                r = "px" === n ? Math.floor(parseFloat(r)) : "em" === n ? Math.floor(parseFloat(r) * this.pdf.getFontSize()) : Math.floor(parseFloat(r)), this.pdf.setFontSize(r);
                var o = "";
                ("bold" === s || 700 <= parseInt(s, 10) || "bold" === i) && (o = "bold"), "italic" === i && (o += "italic"), 0 === o.length && (o = "normal");
                for (var h = "", l = a.toLowerCase().replace(/"|'/g, "").split(/\s*,\s*/), A = {
                    arial: "Helvetica",
                    verdana: "Helvetica",
                    helvetica: "Helvetica",
                    "sans-serif": "Helvetica",
                    fixed: "Courier",
                    monospace: "Courier",
                    terminal: "Courier",
                    courier: "Courier",
                    times: "Times",
                    cursive: "Times",
                    fantasy: "Times",
                    serif: "Times"
                  }, c = 0; c < l.length; c++) {
                  if (void 0 !== this.pdf.internal.getFont(l[c], o, {
                    noFallback: !0,
                    disableWarning: !0
                  })) {
                    h = l[c];
                    break;
                  }
                  if ("bolditalic" === o && void 0 !== this.pdf.internal.getFont(l[c], "bold", {
                    noFallback: !0,
                    disableWarning: !0
                  })) h = l[c], o = "bold";else if (void 0 !== this.pdf.internal.getFont(l[c], "normal", {
                    noFallback: !0,
                    disableWarning: !0
                  })) {
                    h = l[c], o = "normal";
                    break;
                  }
                }
                if ("" === h) for (c = 0; c < l.length; c++) if (A[l[c]]) {
                  h = A[l[c]];
                  break;
                }
                h = "" === h ? "Times" : h, this.pdf.setFont(h, o);
              }
            }
          }), Object.defineProperty(this, "globalCompositeOperation", {
            get: function get() {
              return this.ctx.globalCompositeOperation;
            },
            set: function set(t) {
              this.ctx.globalCompositeOperation = t;
            }
          }), Object.defineProperty(this, "globalAlpha", {
            get: function get() {
              return this.ctx.globalAlpha;
            },
            set: function set(t) {
              this.ctx.globalAlpha = t;
            }
          }), Object.defineProperty(this, "ignoreClearRect", {
            get: function get() {
              return this.ctx.ignoreClearRect;
            },
            set: function set(t) {
              this.ctx.ignoreClearRect = Boolean(t);
            }
          });
        };
        l.prototype.fill = function () {
          g.call(this, "fill", !1);
        }, l.prototype.stroke = function () {
          g.call(this, "stroke", !1);
        }, l.prototype.beginPath = function () {
          this.path = [{
            type: "begin"
          }];
        }, l.prototype.moveTo = function (t, e) {
          if (isNaN(t) || isNaN(e)) throw console.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
          var i = this.ctx.transform.applyToPoint(new H(t, e));
          this.path.push({
            type: "mt",
            x: i.x,
            y: i.y
          }), this.ctx.lastPoint = new H(t, e);
        }, l.prototype.closePath = function () {
          var t = new H(0, 0),
            e = 0;
          for (e = this.path.length - 1; -1 !== e; e--) if ("begin" === this.path[e].type && "object" === r(this.path[e + 1]) && "number" == typeof this.path[e + 1].x) {
            t = new H(this.path[e + 1].x, this.path[e + 1].y), this.path.push({
              type: "lt",
              x: t.x,
              y: t.y
            });
            break;
          }
          "object" === r(this.path[e + 2]) && "number" == typeof this.path[e + 2].x && this.path.push(JSON.parse(JSON.stringify(this.path[e + 2]))), this.path.push({
            type: "close"
          }), this.ctx.lastPoint = new H(t.x, t.y);
        }, l.prototype.lineTo = function (t, e) {
          if (isNaN(t) || isNaN(e)) throw console.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
          var i = this.ctx.transform.applyToPoint(new H(t, e));
          this.path.push({
            type: "lt",
            x: i.x,
            y: i.y
          }), this.ctx.lastPoint = new H(i.x, i.y);
        }, l.prototype.clip = function () {
          this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), g.call(this, null, !0);
        }, l.prototype.quadraticCurveTo = function (t, e, i, s) {
          if (isNaN(i) || isNaN(s) || isNaN(t) || isNaN(e)) throw console.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
          var r = this.ctx.transform.applyToPoint(new H(i, s)),
            n = this.ctx.transform.applyToPoint(new H(t, e));
          this.path.push({
            type: "qct",
            x1: n.x,
            y1: n.y,
            x: r.x,
            y: r.y
          }), this.ctx.lastPoint = new H(r.x, r.y);
        }, l.prototype.bezierCurveTo = function (t, e, i, s, r, n) {
          if (isNaN(r) || isNaN(n) || isNaN(t) || isNaN(e) || isNaN(i) || isNaN(s)) throw console.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
          var a = this.ctx.transform.applyToPoint(new H(r, n)),
            o = this.ctx.transform.applyToPoint(new H(t, e)),
            h = this.ctx.transform.applyToPoint(new H(i, s));
          this.path.push({
            type: "bct",
            x1: o.x,
            y1: o.y,
            x2: h.x,
            y2: h.y,
            x: a.x,
            y: a.y
          }), this.ctx.lastPoint = new H(a.x, a.y);
        }, l.prototype.arc = function (t, e, i, s, r, n) {
          if (isNaN(t) || isNaN(e) || isNaN(i) || isNaN(s) || isNaN(r)) throw console.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
          if (n = Boolean(n), !this.ctx.transform.isIdentity) {
            var a = this.ctx.transform.applyToPoint(new H(t, e));
            t = a.x, e = a.y;
            var o = this.ctx.transform.applyToPoint(new H(0, i)),
              h = this.ctx.transform.applyToPoint(new H(0, 0));
            i = Math.sqrt(Math.pow(o.x - h.x, 2) + Math.pow(o.y - h.y, 2));
          }
          Math.abs(r - s) >= 2 * Math.PI && (s = 0, r = 2 * Math.PI), this.path.push({
            type: "arc",
            x: t,
            y: e,
            radius: i,
            startAngle: s,
            endAngle: r,
            counterclockwise: n
          });
        }, l.prototype.arcTo = function (t, e, i, s, r) {
          throw new Error("arcTo not implemented.");
        }, l.prototype.rect = function (t, e, i, s) {
          if (isNaN(t) || isNaN(e) || isNaN(i) || isNaN(s)) throw console.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
          this.moveTo(t, e), this.lineTo(t + i, e), this.lineTo(t + i, e + s), this.lineTo(t, e + s), this.lineTo(t, e), this.lineTo(t + i, e), this.lineTo(t, e);
        }, l.prototype.fillRect = function (t, e, i, s) {
          if (isNaN(t) || isNaN(e) || isNaN(i) || isNaN(s)) throw console.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
          if (!c.call(this)) {
            var r = {};
            "butt" !== this.lineCap && (r.lineCap = this.lineCap, this.lineCap = "butt"), "miter" !== this.lineJoin && (r.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(t, e, i, s), this.fill(), r.hasOwnProperty("lineCap") && (this.lineCap = r.lineCap), r.hasOwnProperty("lineJoin") && (this.lineJoin = r.lineJoin);
          }
        }, l.prototype.strokeRect = function (t, e, i, s) {
          if (isNaN(t) || isNaN(e) || isNaN(i) || isNaN(s)) throw console.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
          u.call(this) || (this.beginPath(), this.rect(t, e, i, s), this.stroke());
        }, l.prototype.clearRect = function (t, e, i, s) {
          if (isNaN(t) || isNaN(e) || isNaN(i) || isNaN(s)) throw console.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
          this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(t, e, i, s));
        }, l.prototype.save = function (t) {
          t = "boolean" != typeof t || t;
          for (var e = this.pdf.internal.getCurrentPageInfo().pageNumber, i = 0; i < this.pdf.internal.getNumberOfPages(); i++) this.pdf.setPage(i + 1), this.pdf.internal.out("q");
          if (this.pdf.setPage(e), t) {
            this.ctx.fontSize = this.pdf.internal.getFontSize();
            var s = new h(this.ctx);
            this.ctxStack.push(this.ctx), this.ctx = s;
          }
        }, l.prototype.restore = function (t) {
          t = "boolean" != typeof t || t;
          for (var e = this.pdf.internal.getCurrentPageInfo().pageNumber, i = 0; i < this.pdf.internal.getNumberOfPages(); i++) this.pdf.setPage(i + 1), this.pdf.internal.out("Q");
          this.pdf.setPage(e), t && 0 !== this.ctxStack.length && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin);
        }, l.prototype.toDataURL = function () {
          throw new Error("toDataUrl not implemented.");
        };
        var A = function A(t) {
            var e, i, s, r;
            if (!0 === t.isCanvasGradient && (t = t.getColor()), !t) return {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              style: t
            };
            if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t)) r = s = i = e = 0;else {
              var n = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);
              if (null !== n) e = parseInt(n[1]), i = parseInt(n[2]), s = parseInt(n[3]), r = 1;else if (null !== (n = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/.exec(t))) e = parseInt(n[1]), i = parseInt(n[2]), s = parseInt(n[3]), r = parseFloat(n[4]);else {
                if (r = 1, "string" == typeof t && "#" !== t.charAt(0)) {
                  var a = new RGBColor(t);
                  t = a.ok ? a.toHex() : "#000000";
                }
                4 === t.length ? (e = t.substring(1, 2), e += e, i = t.substring(2, 3), i += i, s = t.substring(3, 4), s += s) : (e = t.substring(1, 3), i = t.substring(3, 5), s = t.substring(5, 7)), e = parseInt(e, 16), i = parseInt(i, 16), s = parseInt(s, 16);
              }
            }
            return {
              r: e,
              g: i,
              b: s,
              a: r,
              style: t
            };
          },
          c = function c() {
            return this.ctx.isFillTransparent || 0 == this.globalAlpha;
          },
          u = function u() {
            return Boolean(this.ctx.isStrokeTransparent || 0 == this.globalAlpha);
          };
        l.prototype.fillText = function (t, e, i, s) {
          if (isNaN(e) || isNaN(i) || "string" != typeof t) throw console.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
          if (s = isNaN(s) ? void 0 : s, !c.call(this)) {
            i = m.call(this, i);
            var r = Q(this.ctx.transform.rotation),
              n = this.ctx.transform.scaleX;
            C.call(this, {
              text: t,
              x: e,
              y: i,
              scale: n,
              angle: r,
              align: this.textAlign,
              maxWidth: s
            });
          }
        }, l.prototype.strokeText = function (t, e, i, s) {
          if (isNaN(e) || isNaN(i) || "string" != typeof t) throw console.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
          if (!u.call(this)) {
            s = isNaN(s) ? void 0 : s, i = m.call(this, i);
            var r = Q(this.ctx.transform.rotation),
              n = this.ctx.transform.scaleX;
            C.call(this, {
              text: t,
              x: e,
              y: i,
              scale: n,
              renderingMode: "stroke",
              angle: r,
              align: this.textAlign,
              maxWidth: s
            });
          }
        }, l.prototype.measureText = function (t) {
          if ("string" != typeof t) throw console.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
          var e = this.pdf,
            i = this.pdf.internal.scaleFactor,
            s = e.internal.getFontSize(),
            r = e.getStringUnitWidth(t) * s / e.internal.scaleFactor;
          return new function (t) {
            var e = (t = t || {}).width || 0;
            return Object.defineProperty(this, "width", {
              get: function get() {
                return e;
              }
            }), this;
          }({
            width: r *= Math.round(96 * i / 72 * 1e4) / 1e4
          });
        }, l.prototype.scale = function (t, e) {
          if (isNaN(t) || isNaN(e)) throw console.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
          var i = new O(t, 0, 0, e, 0, 0);
          this.ctx.transform = this.ctx.transform.multiply(i);
        }, l.prototype.rotate = function (t) {
          if (isNaN(t)) throw console.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
          var e = new O(Math.cos(t), Math.sin(t), -Math.sin(t), Math.cos(t), 0, 0);
          this.ctx.transform = this.ctx.transform.multiply(e);
        }, l.prototype.translate = function (t, e) {
          if (isNaN(t) || isNaN(e)) throw console.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
          var i = new O(1, 0, 0, 1, t, e);
          this.ctx.transform = this.ctx.transform.multiply(i);
        }, l.prototype.transform = function (t, e, i, s, r, n) {
          if (isNaN(t) || isNaN(e) || isNaN(i) || isNaN(s) || isNaN(r) || isNaN(n)) throw console.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
          var a = new O(t, e, i, s, r, n);
          this.ctx.transform = this.ctx.transform.multiply(a);
        }, l.prototype.setTransform = function (t, e, i, s, r, n) {
          t = isNaN(t) ? 1 : t, e = isNaN(e) ? 0 : e, i = isNaN(i) ? 0 : i, s = isNaN(s) ? 1 : s, r = isNaN(r) ? 0 : r, n = isNaN(n) ? 0 : n, this.ctx.transform = new O(t, e, i, s, r, n);
        }, l.prototype.drawImage = function (t, e, i, s, r, n, a, o, h) {
          var l = this.pdf.getImageProperties(t),
            A = 1,
            c = 1,
            u = 1,
            f = 1;
          void 0 !== s && void 0 !== o && (u = o / s, f = h / r, A = l.width / s * o / s, c = l.height / r * h / r), void 0 === n && (n = e, a = i, i = e = 0), void 0 !== s && void 0 === o && (o = s, h = r), void 0 === s && void 0 === o && (o = l.width, h = l.height);
          var g = this.ctx.transform.decompose(),
            m = Q(g.rotate.shx);
          g.scale.sx, g.scale.sy;
          for (var v, b = new O(), B = ((b = (b = (b = b.multiply(g.translate)).multiply(g.skew)).multiply(g.scale)).applyToPoint(new H(o, h)), b.applyToRectangle(new I(n - e * u, a - i * f, s * A, r * c))), y = d.call(this, B), C = [], F = 0; F < y.length; F += 1) -1 === C.indexOf(y[F]) && C.push(y[F]);
          if (C.sort(), this.autoPaging) for (var x = C[0], N = C[C.length - 1], E = x; E < N + 1; E++) {
            if (this.pdf.setPage(E), 0 !== this.ctx.clip_path.length) {
              var U = this.path;
              v = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = p(v, this.posX, -1 * this.pdf.internal.pageSize.height * (E - 1) + this.posY), w.call(this, "fill", !0), this.path = U;
            }
            var L = JSON.parse(JSON.stringify(B));
            L = p([L], this.posX, -1 * this.pdf.internal.pageSize.height * (E - 1) + this.posY)[0], this.pdf.addImage(t, "jpg", L.x, L.y, L.w, L.h, null, null, m);
          } else this.pdf.addImage(t, "jpg", B.x, B.y, B.w, B.h, null, null, m);
        };
        var d = function d(t, e, i) {
            var s = [];
            switch (e = e || this.pdf.internal.pageSize.width, i = i || this.pdf.internal.pageSize.height, t.type) {
              default:
              case "mt":
              case "lt":
                s.push(Math.floor((t.y + this.posY) / i) + 1);
                break;
              case "arc":
                s.push(Math.floor((t.y + this.posY - t.radius) / i) + 1), s.push(Math.floor((t.y + this.posY + t.radius) / i) + 1);
                break;
              case "qct":
                var r = S(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x, t.y);
                s.push(Math.floor(r.y / i) + 1), s.push(Math.floor((r.y + r.h) / i) + 1);
                break;
              case "bct":
                var n = k(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x2, t.y2, t.x, t.y);
                s.push(Math.floor(n.y / i) + 1), s.push(Math.floor((n.y + n.h) / i) + 1);
                break;
              case "rect":
                s.push(Math.floor((t.y + this.posY) / i) + 1), s.push(Math.floor((t.y + t.h + this.posY) / i) + 1);
            }
            for (var a = 0; a < s.length; a += 1) for (; this.pdf.internal.getNumberOfPages() < s[a];) f.call(this);
            return s;
          },
          f = function f() {
            var t = this.fillStyle,
              e = this.strokeStyle,
              i = this.font,
              s = this.lineCap,
              r = this.lineWidth,
              n = this.lineJoin;
            this.pdf.addPage(), this.fillStyle = t, this.strokeStyle = e, this.font = i, this.lineCap = s, this.lineWidth = r, this.lineJoin = n;
          },
          p = function p(t, e, i) {
            for (var s = 0; s < t.length; s++) switch (t[s].type) {
              case "bct":
                t[s].x2 += e, t[s].y2 += i;
              case "qct":
                t[s].x1 += e, t[s].y1 += i;
              case "mt":
              case "lt":
              case "arc":
              default:
                t[s].x += e, t[s].y += i;
            }
            return t;
          },
          g = function g(t, e) {
            for (var i, s, r = this.fillStyle, n = this.strokeStyle, a = (this.font, this.lineCap), o = this.lineWidth, h = this.lineJoin, l = JSON.parse(JSON.stringify(this.path)), A = JSON.parse(JSON.stringify(this.path)), c = [], u = 0; u < A.length; u++) if (void 0 !== A[u].x) for (var g = d.call(this, A[u]), m = 0; m < g.length; m += 1) -1 === c.indexOf(g[m]) && c.push(g[m]);
            for (u = 0; u < c.length; u++) for (; this.pdf.internal.getNumberOfPages() < c[u];) f.call(this);
            if (c.sort(), this.autoPaging) {
              var v = c[0],
                b = c[c.length - 1];
              for (u = v; u < b + 1; u++) {
                if (this.pdf.setPage(u), this.fillStyle = r, this.strokeStyle = n, this.lineCap = a, this.lineWidth = o, this.lineJoin = h, 0 !== this.ctx.clip_path.length) {
                  var B = this.path;
                  i = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = p(i, this.posX, -1 * this.pdf.internal.pageSize.height * (u - 1) + this.posY), w.call(this, t, !0), this.path = B;
                }
                s = JSON.parse(JSON.stringify(l)), this.path = p(s, this.posX, -1 * this.pdf.internal.pageSize.height * (u - 1) + this.posY), !1 !== e && 0 !== u || w.call(this, t, e);
              }
            } else w.call(this, t, e);
            this.path = l;
          },
          w = function w(t, e) {
            if (("stroke" !== t || e || !u.call(this)) && ("stroke" === t || e || !c.call(this))) {
              var i = [];
              this.ctx.globalAlpha, this.ctx.fillOpacity < 1 && this.ctx.fillOpacity;
              for (var s, r = this.path, n = 0; n < r.length; n++) {
                var a = r[n];
                switch (a.type) {
                  case "begin":
                    i.push({
                      begin: !0
                    });
                    break;
                  case "close":
                    i.push({
                      close: !0
                    });
                    break;
                  case "mt":
                    i.push({
                      start: a,
                      deltas: [],
                      abs: []
                    });
                    break;
                  case "lt":
                    var o = i.length;
                    if (!isNaN(r[n - 1].x)) {
                      var h = [a.x - r[n - 1].x, a.y - r[n - 1].y];
                      if (0 < o) for (; 0 <= o; o--) if (!0 !== i[o - 1].close && !0 !== i[o - 1].begin) {
                        i[o - 1].deltas.push(h), i[o - 1].abs.push(a);
                        break;
                      }
                    }
                    break;
                  case "bct":
                    h = [a.x1 - r[n - 1].x, a.y1 - r[n - 1].y, a.x2 - r[n - 1].x, a.y2 - r[n - 1].y, a.x - r[n - 1].x, a.y - r[n - 1].y], i[i.length - 1].deltas.push(h);
                    break;
                  case "qct":
                    var l = r[n - 1].x + 2 / 3 * (a.x1 - r[n - 1].x),
                      A = r[n - 1].y + 2 / 3 * (a.y1 - r[n - 1].y),
                      d = a.x + 2 / 3 * (a.x1 - a.x),
                      f = a.y + 2 / 3 * (a.y1 - a.y),
                      p = a.x,
                      g = a.y;
                    h = [l - r[n - 1].x, A - r[n - 1].y, d - r[n - 1].x, f - r[n - 1].y, p - r[n - 1].x, g - r[n - 1].y], i[i.length - 1].deltas.push(h);
                    break;
                  case "arc":
                    i.push({
                      deltas: [],
                      abs: [],
                      arc: !0
                    }), Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(a);
                }
              }
              for (s = e ? null : "stroke" === t ? "stroke" : "fill", n = 0; n < i.length; n++) {
                if (i[n].arc) for (var w = i[n].abs, m = 0; m < w.length; m++) {
                  var y = w[m];
                  if (void 0 !== y.startAngle) {
                    var C = Q(y.startAngle),
                      N = Q(y.endAngle),
                      E = y.x,
                      U = y.y;
                    v.call(this, E, U, y.radius, C, N, y.counterclockwise, s, e);
                  } else F.call(this, y.x, y.y);
                }
                i[n].arc || !0 === i[n].close || !0 === i[n].begin || (E = i[n].start.x, U = i[n].start.y, x.call(this, i[n].deltas, E, U, null, null));
              }
              s && b.call(this, s), e && B.call(this);
            }
          },
          m = function m(t) {
            var e = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor,
              i = e * (this.pdf.internal.getLineHeightFactor() - 1);
            switch (this.ctx.textBaseline) {
              case "bottom":
                return t - i;
              case "top":
                return t + e - i;
              case "hanging":
                return t + e - 2 * i;
              case "middle":
                return t + e / 2 - i;
              case "ideographic":
                return t;
              case "alphabetic":
              default:
                return t;
            }
          };
        l.prototype.createLinearGradient = function () {
          var t = function t() {};
          return t.colorStops = [], t.addColorStop = function (t, e) {
            this.colorStops.push([t, e]);
          }, t.getColor = function () {
            return 0 === this.colorStops.length ? "#000000" : this.colorStops[0][1];
          }, t.isCanvasGradient = !0, t;
        }, l.prototype.createPattern = function () {
          return this.createLinearGradient();
        }, l.prototype.createRadialGradient = function () {
          return this.createLinearGradient();
        };
        var v = function v(t, e, i, s, r, n, a, o) {
            this.pdf.internal.scaleFactor;
            for (var h = L(s), l = L(r), A = E.call(this, i, h, l, n), c = 0; c < A.length; c++) {
              var u = A[c];
              0 === c && y.call(this, u.x1 + t, u.y1 + e), N.call(this, t, e, u.x2, u.y2, u.x3, u.y3, u.x4, u.y4);
            }
            o ? B.call(this) : b.call(this, a);
          },
          b = function b(t) {
            switch (t) {
              case "stroke":
                this.pdf.internal.out("S");
                break;
              case "fill":
                this.pdf.internal.out("f");
            }
          },
          B = function B() {
            this.pdf.clip();
          },
          y = function y(t, e) {
            this.pdf.internal.out(s(t) + " " + n(e) + " m");
          },
          C = function C(t) {
            var e;
            switch (t.align) {
              case "right":
              case "end":
                e = "right";
                break;
              case "center":
                e = "center";
                break;
              case "left":
              case "start":
              default:
                e = "left";
            }
            var i = this.ctx.transform.applyToPoint(new H(t.x, t.y)),
              s = this.ctx.transform.decompose(),
              r = new O();
            r = (r = (r = r.multiply(s.translate)).multiply(s.skew)).multiply(s.scale);
            for (var n, a = this.pdf.getTextDimensions(t.text), o = this.ctx.transform.applyToRectangle(new I(t.x, t.y, a.w, a.h)), h = r.applyToRectangle(new I(t.x, t.y - a.h, a.w, a.h)), l = d.call(this, h), A = [], c = 0; c < l.length; c += 1) -1 === A.indexOf(l[c]) && A.push(l[c]);
            if (A.sort(), !0 === this.autoPaging) for (var u = A[0], f = A[A.length - 1], g = u; g < f + 1; g++) {
              if (this.pdf.setPage(g), 0 !== this.ctx.clip_path.length) {
                var m = this.path;
                n = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = p(n, this.posX, -1 * this.pdf.internal.pageSize.height * (g - 1) + this.posY), w.call(this, "fill", !0), this.path = m;
              }
              var v = JSON.parse(JSON.stringify(o));
              if (v = p([v], this.posX, -1 * this.pdf.internal.pageSize.height * (g - 1) + this.posY)[0], .01 <= t.scale) {
                var b = this.pdf.internal.getFontSize();
                this.pdf.setFontSize(b * t.scale);
              }
              this.pdf.text(t.text, v.x, v.y, {
                angle: t.angle,
                align: e,
                renderingMode: t.renderingMode,
                maxWidth: t.maxWidth
              }), .01 <= t.scale && this.pdf.setFontSize(b);
            } else .01 <= t.scale && (b = this.pdf.internal.getFontSize(), this.pdf.setFontSize(b * t.scale)), this.pdf.text(t.text, i.x + this.posX, i.y + this.posY, {
              angle: t.angle,
              align: e,
              renderingMode: t.renderingMode,
              maxWidth: t.maxWidth
            }), .01 <= t.scale && this.pdf.setFontSize(b);
          },
          F = function F(t, e, i, r) {
            i = i || 0, r = r || 0, this.pdf.internal.out(s(t + i) + " " + n(e + r) + " l");
          },
          x = function x(t, e, i) {
            return this.pdf.lines(t, e, i, null, null);
          },
          N = function N(t, e, s, r, n, h, l, A) {
            this.pdf.internal.out([i(a(s + t)), i(o(r + e)), i(a(n + t)), i(o(h + e)), i(a(l + t)), i(o(A + e)), "c"].join(" "));
          },
          E = function E(t, e, i, s) {
            var r = 2 * Math.PI,
              n = e;
            (n < r || r < n) && (n %= r);
            var a = i;
            (a < r || r < a) && (a %= r);
            for (var o = [], h = Math.PI / 2, l = s ? -1 : 1, A = e, c = Math.min(r, Math.abs(a - n)); 1e-5 < c;) {
              var u = A + l * Math.min(c, h);
              o.push(U.call(this, t, A, u)), c -= Math.abs(u - A), A = u;
            }
            return o;
          },
          U = function U(t, e, i) {
            var s = (i - e) / 2,
              r = t * Math.cos(s),
              n = t * Math.sin(s),
              a = r,
              o = -n,
              h = a * a + o * o,
              l = h + a * r + o * n,
              A = 4 / 3 * (Math.sqrt(2 * h * l) - l) / (a * n - o * r),
              c = a - A * o,
              u = o + A * a,
              d = c,
              f = -u,
              p = s + e,
              g = Math.cos(p),
              w = Math.sin(p);
            return {
              x1: t * Math.cos(e),
              y1: t * Math.sin(e),
              x2: c * g - u * w,
              y2: c * w + u * g,
              x3: d * g - f * w,
              y3: d * w + f * g,
              x4: t * Math.cos(i),
              y4: t * Math.sin(i)
            };
          },
          Q = function Q(t) {
            return 180 * t / Math.PI;
          },
          L = function L(t) {
            return t * Math.PI / 180;
          },
          S = function S(t, e, i, s, r, n) {
            var a = t + .5 * (i - t),
              o = e + .5 * (s - e),
              h = r + .5 * (i - r),
              l = n + .5 * (s - n),
              A = Math.min(t, r, a, h),
              c = Math.max(t, r, a, h),
              u = Math.min(e, n, o, l),
              d = Math.max(e, n, o, l);
            return new I(A, u, c - A, d - u);
          },
          k = function k(t, e, i, s, r, n, a, o) {
            for (var h, l, A, c, u, d, f, p, g, w, m, v, b, B = i - t, y = s - e, C = r - i, F = n - s, x = a - r, N = o - n, E = 0; E < 41; E++) p = (d = (l = t + (h = E / 40) * B) + h * ((c = i + h * C) - l)) + h * (c + h * (r + h * x - c) - d), g = (f = (A = e + h * y) + h * ((u = s + h * F) - A)) + h * (u + h * (n + h * N - u) - f), b = 0 == E ? (v = w = p, m = g) : (w = Math.min(w, p), m = Math.min(m, g), v = Math.max(v, p), Math.max(b, g));
            return new I(Math.round(w), Math.round(m), Math.round(v - w), Math.round(b - m));
          },
          H = function H(t, e) {
            var i = t || 0;
            Object.defineProperty(this, "x", {
              enumerable: !0,
              get: function get() {
                return i;
              },
              set: function set(t) {
                isNaN(t) || (i = parseFloat(t));
              }
            });
            var s = e || 0;
            Object.defineProperty(this, "y", {
              enumerable: !0,
              get: function get() {
                return s;
              },
              set: function set(t) {
                isNaN(t) || (s = parseFloat(t));
              }
            });
            var r = "pt";
            return Object.defineProperty(this, "type", {
              enumerable: !0,
              get: function get() {
                return r;
              },
              set: function set(t) {
                r = t.toString();
              }
            }), this;
          },
          I = function I(t, e, i, s) {
            H.call(this, t, e), this.type = "rect";
            var r = i || 0;
            Object.defineProperty(this, "w", {
              enumerable: !0,
              get: function get() {
                return r;
              },
              set: function set(t) {
                isNaN(t) || (r = parseFloat(t));
              }
            });
            var n = s || 0;
            return Object.defineProperty(this, "h", {
              enumerable: !0,
              get: function get() {
                return n;
              },
              set: function set(t) {
                isNaN(t) || (n = parseFloat(t));
              }
            }), this;
          },
          O = function O(t, e, i, s, r, n) {
            var a = [];
            return Object.defineProperty(this, "sx", {
              get: function get() {
                return a[0];
              },
              set: function set(t) {
                a[0] = Math.round(1e5 * t) / 1e5;
              }
            }), Object.defineProperty(this, "shy", {
              get: function get() {
                return a[1];
              },
              set: function set(t) {
                a[1] = Math.round(1e5 * t) / 1e5;
              }
            }), Object.defineProperty(this, "shx", {
              get: function get() {
                return a[2];
              },
              set: function set(t) {
                a[2] = Math.round(1e5 * t) / 1e5;
              }
            }), Object.defineProperty(this, "sy", {
              get: function get() {
                return a[3];
              },
              set: function set(t) {
                a[3] = Math.round(1e5 * t) / 1e5;
              }
            }), Object.defineProperty(this, "tx", {
              get: function get() {
                return a[4];
              },
              set: function set(t) {
                a[4] = Math.round(1e5 * t) / 1e5;
              }
            }), Object.defineProperty(this, "ty", {
              get: function get() {
                return a[5];
              },
              set: function set(t) {
                a[5] = Math.round(1e5 * t) / 1e5;
              }
            }), Object.defineProperty(this, "rotation", {
              get: function get() {
                return Math.atan2(this.shx, this.sx);
              }
            }), Object.defineProperty(this, "scaleX", {
              get: function get() {
                return this.decompose().scale.sx;
              }
            }), Object.defineProperty(this, "scaleY", {
              get: function get() {
                return this.decompose().scale.sy;
              }
            }), Object.defineProperty(this, "isIdentity", {
              get: function get() {
                return 1 === this.sx && 0 === this.shy && 0 === this.shx && 1 === this.sy && 0 === this.tx && 0 === this.ty;
              }
            }), this.sx = isNaN(t) ? 1 : t, this.shy = isNaN(e) ? 0 : e, this.shx = isNaN(i) ? 0 : i, this.sy = isNaN(s) ? 1 : s, this.tx = isNaN(r) ? 0 : r, this.ty = isNaN(n) ? 0 : n, this;
          };
        O.prototype.multiply = function (t) {
          var e = t.sx * this.sx + t.shy * this.shx,
            i = t.sx * this.shy + t.shy * this.sy,
            s = t.shx * this.sx + t.sy * this.shx,
            r = t.shx * this.shy + t.sy * this.sy,
            n = t.tx * this.sx + t.ty * this.shx + this.tx,
            a = t.tx * this.shy + t.ty * this.sy + this.ty;
          return new O(e, i, s, r, n, a);
        }, O.prototype.decompose = function () {
          var t = this.sx,
            e = this.shy,
            i = this.shx,
            s = this.sy,
            r = this.tx,
            n = this.ty,
            a = Math.sqrt(t * t + e * e),
            o = (t /= a) * i + (e /= a) * s;
          i -= t * o, s -= e * o;
          var h = Math.sqrt(i * i + s * s);
          return o /= h, t * (s /= h) < e * (i /= h) && (t = -t, e = -e, o = -o, a = -a), {
            scale: new O(a, 0, 0, h, 0, 0),
            translate: new O(1, 0, 0, 1, r, n),
            rotate: new O(t, e, -e, t, 0, 0),
            skew: new O(1, 0, o, 1, 0, 0)
          };
        }, O.prototype.applyToPoint = function (t) {
          var e = t.x * this.sx + t.y * this.shx + this.tx,
            i = t.x * this.shy + t.y * this.sy + this.ty;
          return new H(e, i);
        }, O.prototype.applyToRectangle = function (t) {
          var e = this.applyToPoint(t),
            i = this.applyToPoint(new H(t.x + t.w, t.y + t.h));
          return new I(e.x, e.y, i.x - e.x, i.y - e.y);
        }, O.prototype.clone = function () {
          var t = this.sx,
            e = this.shy,
            i = this.shx,
            s = this.sy,
            r = this.tx,
            n = this.ty;
          return new O(t, e, i, s, r, n);
        };
      }(ft.API, "undefined" != typeof self && self || "undefined" != typeof window && window || void 0 !== s && s || Function('return typeof this === "object" && this.content')() || Function("return this")()), g = ft.API, w = function w(t) {
        var e, i, s, r, n, a, o, h, l, A;
        for (/[^\x00-\xFF]/.test(t), i = [], s = 0, r = (t += e = "\0\0\0\0".slice(t.length % 4 || 4)).length; s < r; s += 4) 0 !== (n = (t.charCodeAt(s) << 24) + (t.charCodeAt(s + 1) << 16) + (t.charCodeAt(s + 2) << 8) + t.charCodeAt(s + 3)) ? (a = (n = ((n = ((n = ((n = (n - (A = n % 85)) / 85) - (l = n % 85)) / 85) - (h = n % 85)) / 85) - (o = n % 85)) / 85) % 85, i.push(a + 33, o + 33, h + 33, l + 33, A + 33)) : i.push(122);
        return function (t, i) {
          for (var s = e.length; 0 < s; s--) t.pop();
        }(i), String.fromCharCode.apply(String, i) + "~>";
      }, m = function m(t) {
        var e,
          i,
          s,
          r,
          n,
          a = String,
          o = "length",
          h = "charCodeAt",
          l = "slice",
          A = "replace";
        for (t[l](-2), t = t[l](0, -2)[A](/\s/g, "")[A]("z", "!!!!!"), s = [], r = 0, n = (t += e = "uuuuu"[l](t[o] % 5 || 5))[o]; r < n; r += 5) i = 52200625 * (t[h](r) - 33) + 614125 * (t[h](r + 1) - 33) + 7225 * (t[h](r + 2) - 33) + 85 * (t[h](r + 3) - 33) + (t[h](r + 4) - 33), s.push(255 & i >> 24, 255 & i >> 16, 255 & i >> 8, 255 & i);
        return function (t, i) {
          for (var s = e[o]; 0 < s; s--) t.pop();
        }(s), a.fromCharCode.apply(a, s);
      }, v = function v(t) {
        for (var e = "", i = 0; i < t.length; i += 1) e += ("0" + t.charCodeAt(i).toString(16)).slice(-2);
        return e + ">";
      }, b = function b(t) {
        var e = new RegExp(/^([0-9A-Fa-f]{2})+$/);
        if (-1 !== (t = t.replace(/\s/g, "")).indexOf(">") && (t = t.substr(0, t.indexOf(">"))), t.length % 2 && (t += "0"), !1 === e.test(t)) return "";
        for (var i = "", s = 0; s < t.length; s += 2) i += String.fromCharCode("0x" + (t[s] + t[s + 1]));
        return i;
      }, B = function B(t, e) {
        e = Object.assign({
          predictor: 1,
          colors: 1,
          bitsPerComponent: 8,
          columns: 1
        }, e);
        for (var i, s, r = [], n = t.length; n--;) r[n] = t.charCodeAt(n);
        return i = g.adler32cs.from(t), (s = new Deflater(6)).append(new Uint8Array(r)), t = s.flush(), (r = new Uint8Array(t.length + 6)).set(new Uint8Array([120, 156])), r.set(t, 2), r.set(new Uint8Array([255 & i, i >> 8 & 255, i >> 16 & 255, i >> 24 & 255]), t.length + 2), String.fromCharCode.apply(null, r);
      }, g.processDataByFilters = function (t, e) {
        var i = 0,
          s = t || "",
          r = [];
        for ("string" == typeof (e = e || []) && (e = [e]), i = 0; i < e.length; i += 1) switch (e[i]) {
          case "ASCII85Decode":
          case "/ASCII85Decode":
            s = m(s), r.push("/ASCII85Encode");
            break;
          case "ASCII85Encode":
          case "/ASCII85Encode":
            s = w(s), r.push("/ASCII85Decode");
            break;
          case "ASCIIHexDecode":
          case "/ASCIIHexDecode":
            s = b(s), r.push("/ASCIIHexEncode");
            break;
          case "ASCIIHexEncode":
          case "/ASCIIHexEncode":
            s = v(s), r.push("/ASCIIHexDecode");
            break;
          case "FlateEncode":
          case "/FlateEncode":
            s = B(s), r.push("/FlateDecode");
            break;
          default:
            throw 'The filter: "' + e[i] + '" is not implemented';
        }
        return {
          data: s,
          reverseChain: r.reverse().join(" ")
        };
      }, (y = ft.API).loadFile = function (t, e, i) {
        var s;
        e = e || !0, i = i || function () {};
        try {
          s = function (t, e, i) {
            var s = new XMLHttpRequest(),
              r = [],
              n = 0,
              a = function a(t) {
                var e = t.length,
                  i = String.fromCharCode;
                for (n = 0; n < e; n += 1) r.push(i(255 & t.charCodeAt(n)));
                return r.join("");
              };
            if (s.open("GET", t, !e), s.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (s.onload = function () {
              return a(this.responseText);
            }), s.send(null), 200 === s.status) return e ? a(s.responseText) : void 0;
            console.warn('Unable to load file "' + t + '"');
          }(t, e);
        } catch (t) {
          s = void 0;
        }
        return s;
      }, y.loadImageFile = y.loadFile, C = ft.API, F = "undefined" != typeof window && window || void 0 !== s && s, x = function x(t) {
        var e = r(t);
        return "undefined" === e ? "undefined" : "string" === e || t instanceof String ? "string" : "number" === e || t instanceof Number ? "number" : "function" === e || t instanceof Function ? "function" : t && t.constructor === Array ? "array" : t && 1 === t.nodeType ? "element" : "object" === e ? "object" : "unknown";
      }, N = function N(t, e) {
        var i = document.createElement(t);
        if (e.className && (i.className = e.className), e.innerHTML) {
          i.innerHTML = e.innerHTML;
          for (var s = i.getElementsByTagName("script"), r = s.length; 0 < r--; null) s[r].parentNode.removeChild(s[r]);
        }
        for (var n in e.style) i.style[n] = e.style[n];
        return i;
      }, (((E = function t(e) {
        var i = Object.assign(t.convert(Promise.resolve()), JSON.parse(JSON.stringify(t.template))),
          s = t.convert(Promise.resolve(), i);
        return (s = s.setProgress(1, t, 1, [t])).set(e);
      }).prototype = Object.create(Promise.prototype)).constructor = E).convert = function (t, e) {
        return t.__proto__ = e || E.prototype, t;
      }, E.template = {
        prop: {
          src: null,
          container: null,
          overlay: null,
          canvas: null,
          img: null,
          pdf: null,
          pageSize: null,
          callback: function callback() {}
        },
        progress: {
          val: 0,
          state: null,
          n: 0,
          stack: []
        },
        opt: {
          filename: "file.pdf",
          margin: [0, 0, 0, 0],
          enableLinks: !0,
          x: 0,
          y: 0,
          html2canvas: {},
          jsPDF: {}
        }
      }, E.prototype.from = function (t, e) {
        return this.then(function () {
          switch (e = e || function (t) {
            switch (x(t)) {
              case "string":
                return "string";
              case "element":
                return "canvas" === t.nodeName.toLowerCase ? "canvas" : "element";
              default:
                return "unknown";
            }
          }(t)) {
            case "string":
              return this.set({
                src: N("div", {
                  innerHTML: t
                })
              });
            case "element":
              return this.set({
                src: t
              });
            case "canvas":
              return this.set({
                canvas: t
              });
            case "img":
              return this.set({
                img: t
              });
            default:
              return this.error("Unknown source type.");
          }
        });
      }, E.prototype.to = function (t) {
        switch (t) {
          case "container":
            return this.toContainer();
          case "canvas":
            return this.toCanvas();
          case "img":
            return this.toImg();
          case "pdf":
            return this.toPdf();
          default:
            return this.error("Invalid target.");
        }
      }, E.prototype.toContainer = function () {
        return this.thenList([function () {
          return this.prop.src || this.error("Cannot duplicate - no source HTML.");
        }, function () {
          return this.prop.pageSize || this.setPageSize();
        }]).then(function () {
          var t = {
              position: "relative",
              display: "inline-block",
              width: Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) + "px",
              left: 0,
              right: 0,
              top: 0,
              margin: "auto",
              backgroundColor: "white"
            },
            e = function t(e, i) {
              for (var s = 3 === e.nodeType ? document.createTextNode(e.nodeValue) : e.cloneNode(!1), r = e.firstChild; r; r = r.nextSibling) !0 !== i && 1 === r.nodeType && "SCRIPT" === r.nodeName || s.appendChild(t(r, i));
              return 1 === e.nodeType && ("CANVAS" === e.nodeName ? (s.width = e.width, s.height = e.height, s.getContext("2d").drawImage(e, 0, 0)) : "TEXTAREA" !== e.nodeName && "SELECT" !== e.nodeName || (s.value = e.value), s.addEventListener("load", function () {
                s.scrollTop = e.scrollTop, s.scrollLeft = e.scrollLeft;
              }, !0)), s;
            }(this.prop.src, this.opt.html2canvas.javascriptEnabled);
          "BODY" === e.tagName && (t.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = N("div", {
            className: "html2pdf__overlay",
            style: {
              position: "fixed",
              overflow: "hidden",
              zIndex: 1e3,
              left: "-100000px",
              right: 0,
              bottom: 0,
              top: 0
            }
          }), this.prop.container = N("div", {
            className: "html2pdf__container",
            style: t
          }), this.prop.container.appendChild(e), this.prop.container.firstChild.appendChild(N("div", {
            style: {
              clear: "both",
              border: "0 none transparent",
              margin: 0,
              padding: 0,
              height: 0
            }
          })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
        });
      }, E.prototype.toCanvas = function () {
        var t = [function () {
          return document.body.contains(this.prop.container) || this.toContainer();
        }];
        return this.thenList(t).then(function () {
          var t = Object.assign({}, this.opt.html2canvas);
          if (delete t.onrendered, this.isHtml2CanvasLoaded()) return html2canvas(this.prop.container, t);
        }).then(function (t) {
          (this.opt.html2canvas.onrendered || function () {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
      }, E.prototype.toContext2d = function () {
        var t = [function () {
          return document.body.contains(this.prop.container) || this.toContainer();
        }];
        return this.thenList(t).then(function () {
          var t = this.opt.jsPDF,
            e = Object.assign({
              async: !0,
              allowTaint: !0,
              backgroundColor: "#ffffff",
              imageTimeout: 15e3,
              logging: !0,
              proxy: null,
              removeContainer: !0,
              foreignObjectRendering: !1,
              useCORS: !1
            }, this.opt.html2canvas);
          if (delete e.onrendered, t.context2d.autoPaging = !0, t.context2d.posX = this.opt.x, t.context2d.posY = this.opt.y, e.windowHeight = e.windowHeight || 0, e.windowHeight = 0 == e.windowHeight ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : e.windowHeight, this.isHtml2CanvasLoaded()) return html2canvas(this.prop.container, e);
        }).then(function (t) {
          (this.opt.html2canvas.onrendered || function () {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
      }, E.prototype.toImg = function () {
        return this.thenList([function () {
          return this.prop.canvas || this.toCanvas();
        }]).then(function () {
          var t = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
          this.prop.img = document.createElement("img"), this.prop.img.src = t;
        });
      }, E.prototype.toPdf = function () {
        return this.thenList([function () {
          return this.toContext2d();
        }]).then(function () {
          this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
        });
      }, E.prototype.output = function (t, e, i) {
        return "img" === (i = i || "pdf").toLowerCase() || "image" === i.toLowerCase() ? this.outputImg(t, e) : this.outputPdf(t, e);
      }, E.prototype.outputPdf = function (t, e) {
        return this.thenList([function () {
          return this.prop.pdf || this.toPdf();
        }]).then(function () {
          return this.prop.pdf.output(t, e);
        });
      }, E.prototype.outputImg = function (t, e) {
        return this.thenList([function () {
          return this.prop.img || this.toImg();
        }]).then(function () {
          switch (t) {
            case void 0:
            case "img":
              return this.prop.img;
            case "datauristring":
            case "dataurlstring":
              return this.prop.img.src;
            case "datauri":
            case "dataurl":
              return document.location.href = this.prop.img.src;
            default:
              throw 'Image output type "' + t + '" is not supported.';
          }
        });
      }, E.prototype.isHtml2CanvasLoaded = function () {
        var t = void 0 !== F.html2canvas;
        return t || console.error("html2canvas not loaded."), t;
      }, E.prototype.save = function (t) {
        if (this.isHtml2CanvasLoaded()) return this.thenList([function () {
          return this.prop.pdf || this.toPdf();
        }]).set(t ? {
          filename: t
        } : null).then(function () {
          this.prop.pdf.save(this.opt.filename);
        });
      }, E.prototype.doCallback = function (t) {
        if (this.isHtml2CanvasLoaded()) return this.thenList([function () {
          return this.prop.pdf || this.toPdf();
        }]).then(function () {
          this.prop.callback(this.prop.pdf);
        });
      }, E.prototype.set = function (t) {
        if ("object" !== x(t)) return this;
        var e = Object.keys(t || {}).map(function (e) {
          if (e in E.template.prop) return function () {
            this.prop[e] = t[e];
          };
          switch (e) {
            case "margin":
              return this.setMargin.bind(this, t.margin);
            case "jsPDF":
              return function () {
                return this.opt.jsPDF = t.jsPDF, this.setPageSize();
              };
            case "pageSize":
              return this.setPageSize.bind(this, t.pageSize);
            default:
              return function () {
                this.opt[e] = t[e];
              };
          }
        }, this);
        return this.then(function () {
          return this.thenList(e);
        });
      }, E.prototype.get = function (t, e) {
        return this.then(function () {
          var i = t in E.template.prop ? this.prop[t] : this.opt[t];
          return e ? e(i) : i;
        });
      }, E.prototype.setMargin = function (t) {
        return this.then(function () {
          switch (x(t)) {
            case "number":
              t = [t, t, t, t];
            case "array":
              if (2 === t.length && (t = [t[0], t[1], t[0], t[1]]), 4 === t.length) break;
            default:
              return this.error("Invalid margin array.");
          }
          this.opt.margin = t;
        }).then(this.setPageSize);
      }, E.prototype.setPageSize = function (t) {
        function e(t, e) {
          return Math.floor(t * e / 72 * 96);
        }
        return this.then(function () {
          (t = t || ft.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (t.inner = {
            width: t.width - this.opt.margin[1] - this.opt.margin[3],
            height: t.height - this.opt.margin[0] - this.opt.margin[2]
          }, t.inner.px = {
            width: e(t.inner.width, t.k),
            height: e(t.inner.height, t.k)
          }, t.inner.ratio = t.inner.height / t.inner.width), this.prop.pageSize = t;
        });
      }, E.prototype.setProgress = function (t, e, i, s) {
        return null != t && (this.progress.val = t), null != e && (this.progress.state = e), null != i && (this.progress.n = i), null != s && (this.progress.stack = s), this.progress.ratio = this.progress.val / this.progress.state, this;
      }, E.prototype.updateProgress = function (t, e, i, s) {
        return this.setProgress(t ? this.progress.val + t : null, e || null, i ? this.progress.n + i : null, s ? this.progress.stack.concat(s) : null);
      }, E.prototype.then = function (t, e) {
        var i = this;
        return this.thenCore(t, e, function (t, e) {
          return i.updateProgress(null, null, 1, [t]), Promise.prototype.then.call(this, function (e) {
            return i.updateProgress(null, t), e;
          }).then(t, e).then(function (t) {
            return i.updateProgress(1), t;
          });
        });
      }, E.prototype.thenCore = function (t, e, i) {
        i = i || Promise.prototype.then;
        var s = this;
        t && (t = t.bind(s)), e && (e = e.bind(s));
        var r = -1 !== Promise.toString().indexOf("[native code]") && "Promise" === Promise.name ? s : E.convert(Object.assign({}, s), Promise.prototype),
          n = i.call(r, t, e);
        return E.convert(n, s.__proto__);
      }, E.prototype.thenExternal = function (t, e) {
        return Promise.prototype.then.call(this, t, e);
      }, E.prototype.thenList = function (t) {
        var e = this;
        return t.forEach(function (t) {
          e = e.thenCore(t);
        }), e;
      }, E.prototype.catch = function (t) {
        t && (t = t.bind(this));
        var e = Promise.prototype.catch.call(this, t);
        return E.convert(e, this);
      }, E.prototype.catchExternal = function (t) {
        return Promise.prototype.catch.call(this, t);
      }, E.prototype.error = function (t) {
        return this.then(function () {
          throw new Error(t);
        });
      }, E.prototype.using = E.prototype.set, E.prototype.saveAs = E.prototype.save, E.prototype.export = E.prototype.output, E.prototype.run = E.prototype.then, ft.getPageSize = function (t, e, i) {
        if ("object" === r(t)) {
          var s = t;
          t = s.orientation, e = s.unit || e, i = s.format || i;
        }
        e = e || "mm", i = i || "a4", t = ("" + (t || "P")).toLowerCase();
        var n = ("" + i).toLowerCase(),
          a = {
            a0: [2383.94, 3370.39],
            a1: [1683.78, 2383.94],
            a2: [1190.55, 1683.78],
            a3: [841.89, 1190.55],
            a4: [595.28, 841.89],
            a5: [419.53, 595.28],
            a6: [297.64, 419.53],
            a7: [209.76, 297.64],
            a8: [147.4, 209.76],
            a9: [104.88, 147.4],
            a10: [73.7, 104.88],
            b0: [2834.65, 4008.19],
            b1: [2004.09, 2834.65],
            b2: [1417.32, 2004.09],
            b3: [1000.63, 1417.32],
            b4: [708.66, 1000.63],
            b5: [498.9, 708.66],
            b6: [354.33, 498.9],
            b7: [249.45, 354.33],
            b8: [175.75, 249.45],
            b9: [124.72, 175.75],
            b10: [87.87, 124.72],
            c0: [2599.37, 3676.54],
            c1: [1836.85, 2599.37],
            c2: [1298.27, 1836.85],
            c3: [918.43, 1298.27],
            c4: [649.13, 918.43],
            c5: [459.21, 649.13],
            c6: [323.15, 459.21],
            c7: [229.61, 323.15],
            c8: [161.57, 229.61],
            c9: [113.39, 161.57],
            c10: [79.37, 113.39],
            dl: [311.81, 623.62],
            letter: [612, 792],
            "government-letter": [576, 756],
            legal: [612, 1008],
            "junior-legal": [576, 360],
            ledger: [1224, 792],
            tabloid: [792, 1224],
            "credit-card": [153, 243]
          };
        switch (e) {
          case "pt":
            var o = 1;
            break;
          case "mm":
            o = 72 / 25.4;
            break;
          case "cm":
            o = 72 / 2.54;
            break;
          case "in":
            o = 72;
            break;
          case "px":
            o = .75;
            break;
          case "pc":
          case "em":
            o = 12;
            break;
          case "ex":
            o = 6;
            break;
          default:
            throw "Invalid unit: " + e;
        }
        if (a.hasOwnProperty(n)) var h = a[n][1] / o,
          l = a[n][0] / o;else try {
          h = i[1], l = i[0];
        } catch (t) {
          throw new Error("Invalid format: " + i);
        }
        if ("p" === t || "portrait" === t) {
          if (t = "p", h < l) {
            var A = l;
            l = h, h = A;
          }
        } else {
          if ("l" !== t && "landscape" !== t) throw "Invalid orientation: " + t;
          t = "l", l < h && (A = l, l = h, h = A);
        }
        return {
          width: l,
          height: h,
          unit: e,
          k: o
        };
      }, C.html = function (t, e) {
        (e = e || {}).callback = e.callback || function () {}, e.html2canvas = e.html2canvas || {}, e.html2canvas.canvas = e.html2canvas.canvas || this.canvas, e.jsPDF = e.jsPDF || this, e.jsPDF;
        var i = new E(e);
        return e.worker ? i : i.from(t).doCallback();
      }, ft.API.addJS = function (t) {
        return L = t, this.internal.events.subscribe("postPutResources", function (t) {
          U = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (U + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), Q = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + L + ")"), this.internal.out(">>"), this.internal.out("endobj");
        }), this.internal.events.subscribe("putCatalog", function () {
          void 0 !== U && void 0 !== Q && this.internal.out("/Names <</JavaScript " + U + " 0 R>>");
        }), this;
      },
      /**
         * @license
         * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
         *
         * Licensed under the MIT License.
         * http://opensource.org/licenses/mit-license
         */
      (S = ft.API).events.push(["postPutResources", function () {
        var t = this,
          e = /^(\d+) 0 obj$/;
        if (0 < this.outline.root.children.length) for (var i = t.outline.render().split(/\r\n/), s = 0; s < i.length; s++) {
          var r = i[s],
            n = e.exec(r);
          if (null != n) {
            var a = n[1];
            t.internal.newObjectDeferredBegin(a, !1);
          }
          t.internal.write(r);
        }
        if (this.outline.createNamedDestinations) {
          var o = this.internal.pages.length,
            h = [];
          for (s = 0; s < o; s++) {
            var l = t.internal.newObject();
            h.push(l);
            var A = t.internal.getPageInfo(s + 1);
            t.internal.write("<< /D[" + A.objId + " 0 R /XYZ null null null]>> endobj");
          }
          var c = t.internal.newObject();
          for (t.internal.write("<< /Names [ "), s = 0; s < h.length; s++) t.internal.write("(page_" + (s + 1) + ")" + h[s] + " 0 R");
          t.internal.write(" ] >>", "endobj"), t.internal.newObject(), t.internal.write("<< /Dests " + c + " 0 R"), t.internal.write(">>", "endobj");
        }
      }]), S.events.push(["putCatalog", function () {
        0 < this.outline.root.children.length && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + namesOid + " 0 R"));
      }]), S.events.push(["initialized", function () {
        var t = this;
        t.outline = {
          createNamedDestinations: !1,
          root: {
            children: []
          }
        }, t.outline.add = function (t, e, i) {
          var s = {
            title: e,
            options: i,
            children: []
          };
          return null == t && (t = this.root), t.children.push(s), s;
        }, t.outline.render = function () {
          return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = t, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
        }, t.outline.genIds_r = function (e) {
          e.id = t.internal.newObjectDeferred();
          for (var i = 0; i < e.children.length; i++) this.genIds_r(e.children[i]);
        }, t.outline.renderRoot = function (t) {
          this.objStart(t), this.line("/Type /Outlines"), 0 < t.children.length && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
            count: 0
          }, t)), this.objEnd();
        }, t.outline.renderItems = function (e) {
          this.ctx.pdf.internal.getCoordinateString;
          for (var i = this.ctx.pdf.internal.getVerticalCoordinateString, s = 0; s < e.children.length; s++) {
            var r = e.children[s];
            this.objStart(r), this.line("/Title " + this.makeString(r.title)), this.line("/Parent " + this.makeRef(e)), 0 < s && this.line("/Prev " + this.makeRef(e.children[s - 1])), s < e.children.length - 1 && this.line("/Next " + this.makeRef(e.children[s + 1])), 0 < r.children.length && (this.line("/First " + this.makeRef(r.children[0])), this.line("/Last " + this.makeRef(r.children[r.children.length - 1])));
            var n = this.count = this.count_r({
              count: 0
            }, r);
            if (0 < n && this.line("/Count " + n), r.options && r.options.pageNumber) {
              var a = t.internal.getPageInfo(r.options.pageNumber);
              this.line("/Dest [" + a.objId + " 0 R /XYZ 0 " + i(0) + " 0]");
            }
            this.objEnd();
          }
          for (s = 0; s < e.children.length; s++) r = e.children[s], this.renderItems(r);
        }, t.outline.line = function (t) {
          this.ctx.val += t + "\r\n";
        }, t.outline.makeRef = function (t) {
          return t.id + " 0 R";
        }, t.outline.makeString = function (e) {
          return "(" + t.internal.pdfEscape(e) + ")";
        }, t.outline.objStart = function (t) {
          this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
        }, t.outline.objEnd = function (t) {
          this.ctx.val += ">> \r\nendobj\r\n";
        }, t.outline.count_r = function (t, e) {
          for (var i = 0; i < e.children.length; i++) t.count++, this.count_r(t, e.children[i]);
          return t.count;
        };
      }]),
      /**
         * @license
         * 
         * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
         *
         * 
         * ====================================================================
         */
      k = ft.API, H = function H() {
        var t = "function" == typeof Deflater;
        if (!t) throw new Error("requires deflate.js for compression");
        return t;
      }, I = function I(t, e, i, s) {
        var r = 5,
          n = D;
        switch (s) {
          case k.image_compression.FAST:
            r = 3, n = M;
            break;
          case k.image_compression.MEDIUM:
            r = 6, n = R;
            break;
          case k.image_compression.SLOW:
            r = 9, n = _;
        }
        t = P(t, e, i, n);
        var a = new Uint8Array(O(r)),
          o = T(t),
          h = new Deflater(r),
          l = h.append(t),
          A = h.flush(),
          c = a.length + l.length + A.length,
          u = new Uint8Array(c + 4);
        return u.set(a), u.set(l, a.length), u.set(A, a.length + l.length), u[c++] = o >>> 24 & 255, u[c++] = o >>> 16 & 255, u[c++] = o >>> 8 & 255, u[c++] = 255 & o, k.arrayBufferToBinaryString(u);
      }, O = function O(t, e) {
        var i = Math.LOG2E * Math.log(32768) - 8 << 4 | 8,
          s = i << 8;
        return s |= Math.min(3, (e - 1 & 255) >> 1) << 6, s |= 0, [i, 255 & (s += 31 - s % 31)];
      }, T = function T(t, e) {
        for (var i, s = 1, r = 0, n = t.length, a = 0; 0 < n;) {
          for (n -= i = e < n ? e : n; r += s += t[a++], --i;);
          s %= 65521, r %= 65521;
        }
        return (r << 16 | s) >>> 0;
      }, P = function P(t, e, i, s) {
        for (var r, n, a, o = t.length / e, h = new Uint8Array(t.length + o), l = K(), A = 0; A < o; A++) {
          if (a = A * e, r = t.subarray(a, a + e), s) h.set(s(r, i, n), a + A);else {
            for (var c = 0, u = l.length, d = []; c < u; c++) d[c] = l[c](r, i, n);
            var f = q(d.concat());
            h.set(d[f], a + A);
          }
          n = r;
        }
        return h;
      }, j = function j(t, e, i) {
        var s = Array.apply([], t);
        return s.unshift(0), s;
      }, M = function M(t, e, i) {
        var s,
          r = [],
          n = 0,
          a = t.length;
        for (r[0] = 1; n < a; n++) s = t[n - e] || 0, r[n + 1] = t[n] - s + 256 & 255;
        return r;
      }, D = function D(t, e, i) {
        var s,
          r = [],
          n = 0,
          a = t.length;
        for (r[0] = 2; n < a; n++) s = i && i[n] || 0, r[n + 1] = t[n] - s + 256 & 255;
        return r;
      }, R = function R(t, e, i) {
        var s,
          r,
          n = [],
          a = 0,
          o = t.length;
        for (n[0] = 3; a < o; a++) s = t[a - e] || 0, r = i && i[a] || 0, n[a + 1] = t[a] + 256 - (s + r >>> 1) & 255;
        return n;
      }, _ = function _(t, e, i) {
        var s,
          r,
          n,
          a,
          o = [],
          h = 0,
          l = t.length;
        for (o[0] = 4; h < l; h++) s = t[h - e] || 0, r = i && i[h] || 0, n = i && i[h - e] || 0, a = z(s, r, n), o[h + 1] = t[h] - a + 256 & 255;
        return o;
      }, z = function z(t, e, i) {
        var s = t + e - i,
          r = Math.abs(s - t),
          n = Math.abs(s - e),
          a = Math.abs(s - i);
        return r <= n && r <= a ? t : n <= a ? e : i;
      }, K = function K() {
        return [j, M, D, R, _];
      }, q = function q(t) {
        for (var e, i, s, r = 0, n = t.length; r < n;) ((e = V(t[r].slice(1))) < i || !i) && (i = e, s = r), r++;
        return s;
      }, V = function V(t) {
        for (var e = 0, i = t.length, s = 0; e < i;) s += Math.abs(t[e++]);
        return s;
      }, k.processPNG = function (t, e, i, s, r) {
        var n,
          a,
          o,
          h,
          l,
          A,
          c = this.color_spaces.DEVICE_RGB,
          u = this.decode.FLATE_DECODE,
          d = 8;
        if (this.isArrayBuffer(t) && (t = new Uint8Array(t)), this.isArrayBufferView(t)) {
          if ("function" != typeof PNG || "function" != typeof Tt) throw new Error("PNG support requires png.js and zlib.js");
          if (t = (n = new PNG(t)).imgData, d = n.bits, c = n.colorSpace, h = n.colors, -1 !== [4, 6].indexOf(n.colorType)) {
            if (8 === n.bits) for (var f, p = (N = 32 == n.pixelBitlength ? new Uint32Array(n.decodePixels().buffer) : 16 == n.pixelBitlength ? new Uint16Array(n.decodePixels().buffer) : new Uint8Array(n.decodePixels().buffer)).length, g = new Uint8Array(p * n.colors), w = new Uint8Array(p), m = n.pixelBitlength - n.bits, v = 0, b = 0; v < p; v++) {
              for (B = N[v], f = 0; f < m;) g[b++] = B >>> f & 255, f += n.bits;
              w[v] = B >>> f & 255;
            }
            if (16 === n.bits) {
              p = (N = new Uint32Array(n.decodePixels().buffer)).length, g = new Uint8Array(p * (32 / n.pixelBitlength) * n.colors), w = new Uint8Array(p * (32 / n.pixelBitlength));
              for (var B, y = 1 < n.colors, C = b = v = 0; v < p;) B = N[v++], g[b++] = B >>> 0 & 255, y && (g[b++] = B >>> 16 & 255, B = N[v++], g[b++] = B >>> 0 & 255), w[C++] = B >>> 16 & 255;
              d = 8;
            }
            s !== k.image_compression.NONE && H() ? (t = I(g, n.width * n.colors, n.colors, s), A = I(w, n.width, 1, s)) : (t = g, A = w, u = null);
          }
          if (3 === n.colorType && (c = this.color_spaces.INDEXED, l = n.palette, n.transparency.indexed)) {
            var F = n.transparency.indexed,
              x = 0;
            for (v = 0, p = F.length; v < p; ++v) x += F[v];
            if ((x /= 255) == p - 1 && -1 !== F.indexOf(0)) o = [F.indexOf(0)];else if (x !== p) {
              var N = n.decodePixels();
              for (w = new Uint8Array(N.length), v = 0, p = N.length; v < p; v++) w[v] = F[N[v]];
              A = I(w, n.width, 1);
            }
          }
          var E = function (t) {
            var e;
            switch (t) {
              case k.image_compression.FAST:
                e = 11;
                break;
              case k.image_compression.MEDIUM:
                e = 13;
                break;
              case k.image_compression.SLOW:
                e = 14;
                break;
              default:
                e = 12;
            }
            return e;
          }(s);
          return a = u === this.decode.FLATE_DECODE ? "/Predictor " + E + " /Colors " + h + " /BitsPerComponent " + d + " /Columns " + n.width : "/Colors " + h + " /BitsPerComponent " + d + " /Columns " + n.width, (this.isArrayBuffer(t) || this.isArrayBufferView(t)) && (t = this.arrayBufferToBinaryString(t)), (A && this.isArrayBuffer(A) || this.isArrayBufferView(A)) && (A = this.arrayBufferToBinaryString(A)), this.createImageInfo(t, n.width, n.height, c, d, u, e, i, a, o, l, A, E);
        }
        throw new Error("Unsupported PNG image data, try using JPEG instead.");
      },
      /**
         * @license
         * Copyright (c) 2017 Aras Abbasi 
         *
         * Licensed under the MIT License.
         * http://opensource.org/licenses/mit-license
         */
      (J = ft.API).processGIF89A = function (t, e, i, s, r) {
        var n = new St(t),
          a = n.width,
          o = n.height,
          h = [];
        n.decodeAndBlitFrameRGBA(0, h);
        var l = {
            data: h,
            width: a,
            height: o
          },
          A = new Ht(100).encode(l, 100);
        return J.processJPEG.call(this, A, e, i, s);
      }, J.processGIF87A = J.processGIF89A, (G = ft.API).processBMP = function (t, e, i, s, r) {
        var n = new It(t, !1),
          a = n.width,
          o = n.height,
          h = {
            data: n.getData(),
            width: a,
            height: o
          },
          l = new Ht(100).encode(h, 100);
        return G.processJPEG.call(this, l, e, i, s);
      }, ft.API.setLanguage = function (t) {
        return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== {
          af: "Afrikaans",
          sq: "Albanian",
          ar: "Arabic (Standard)",
          "ar-DZ": "Arabic (Algeria)",
          "ar-BH": "Arabic (Bahrain)",
          "ar-EG": "Arabic (Egypt)",
          "ar-IQ": "Arabic (Iraq)",
          "ar-JO": "Arabic (Jordan)",
          "ar-KW": "Arabic (Kuwait)",
          "ar-LB": "Arabic (Lebanon)",
          "ar-LY": "Arabic (Libya)",
          "ar-MA": "Arabic (Morocco)",
          "ar-OM": "Arabic (Oman)",
          "ar-QA": "Arabic (Qatar)",
          "ar-SA": "Arabic (Saudi Arabia)",
          "ar-SY": "Arabic (Syria)",
          "ar-TN": "Arabic (Tunisia)",
          "ar-AE": "Arabic (U.A.E.)",
          "ar-YE": "Arabic (Yemen)",
          an: "Aragonese",
          hy: "Armenian",
          as: "Assamese",
          ast: "Asturian",
          az: "Azerbaijani",
          eu: "Basque",
          be: "Belarusian",
          bn: "Bengali",
          bs: "Bosnian",
          br: "Breton",
          bg: "Bulgarian",
          my: "Burmese",
          ca: "Catalan",
          ch: "Chamorro",
          ce: "Chechen",
          zh: "Chinese",
          "zh-HK": "Chinese (Hong Kong)",
          "zh-CN": "Chinese (PRC)",
          "zh-SG": "Chinese (Singapore)",
          "zh-TW": "Chinese (Taiwan)",
          cv: "Chuvash",
          co: "Corsican",
          cr: "Cree",
          hr: "Croatian",
          cs: "Czech",
          da: "Danish",
          nl: "Dutch (Standard)",
          "nl-BE": "Dutch (Belgian)",
          en: "English",
          "en-AU": "English (Australia)",
          "en-BZ": "English (Belize)",
          "en-CA": "English (Canada)",
          "en-IE": "English (Ireland)",
          "en-JM": "English (Jamaica)",
          "en-NZ": "English (New Zealand)",
          "en-PH": "English (Philippines)",
          "en-ZA": "English (South Africa)",
          "en-TT": "English (Trinidad & Tobago)",
          "en-GB": "English (United Kingdom)",
          "en-US": "English (United States)",
          "en-ZW": "English (Zimbabwe)",
          eo: "Esperanto",
          et: "Estonian",
          fo: "Faeroese",
          fj: "Fijian",
          fi: "Finnish",
          fr: "French (Standard)",
          "fr-BE": "French (Belgium)",
          "fr-CA": "French (Canada)",
          "fr-FR": "French (France)",
          "fr-LU": "French (Luxembourg)",
          "fr-MC": "French (Monaco)",
          "fr-CH": "French (Switzerland)",
          fy: "Frisian",
          fur: "Friulian",
          gd: "Gaelic (Scots)",
          "gd-IE": "Gaelic (Irish)",
          gl: "Galacian",
          ka: "Georgian",
          de: "German (Standard)",
          "de-AT": "German (Austria)",
          "de-DE": "German (Germany)",
          "de-LI": "German (Liechtenstein)",
          "de-LU": "German (Luxembourg)",
          "de-CH": "German (Switzerland)",
          el: "Greek",
          gu: "Gujurati",
          ht: "Haitian",
          he: "Hebrew",
          hi: "Hindi",
          hu: "Hungarian",
          is: "Icelandic",
          id: "Indonesian",
          iu: "Inuktitut",
          ga: "Irish",
          it: "Italian (Standard)",
          "it-CH": "Italian (Switzerland)",
          ja: "Japanese",
          kn: "Kannada",
          ks: "Kashmiri",
          kk: "Kazakh",
          km: "Khmer",
          ky: "Kirghiz",
          tlh: "Klingon",
          ko: "Korean",
          "ko-KP": "Korean (North Korea)",
          "ko-KR": "Korean (South Korea)",
          la: "Latin",
          lv: "Latvian",
          lt: "Lithuanian",
          lb: "Luxembourgish",
          mk: "FYRO Macedonian",
          ms: "Malay",
          ml: "Malayalam",
          mt: "Maltese",
          mi: "Maori",
          mr: "Marathi",
          mo: "Moldavian",
          nv: "Navajo",
          ng: "Ndonga",
          ne: "Nepali",
          no: "Norwegian",
          nb: "Norwegian (Bokmal)",
          nn: "Norwegian (Nynorsk)",
          oc: "Occitan",
          or: "Oriya",
          om: "Oromo",
          fa: "Persian",
          "fa-IR": "Persian/Iran",
          pl: "Polish",
          pt: "Portuguese",
          "pt-BR": "Portuguese (Brazil)",
          pa: "Punjabi",
          "pa-IN": "Punjabi (India)",
          "pa-PK": "Punjabi (Pakistan)",
          qu: "Quechua",
          rm: "Rhaeto-Romanic",
          ro: "Romanian",
          "ro-MO": "Romanian (Moldavia)",
          ru: "Russian",
          "ru-MO": "Russian (Moldavia)",
          sz: "Sami (Lappish)",
          sg: "Sango",
          sa: "Sanskrit",
          sc: "Sardinian",
          sd: "Sindhi",
          si: "Singhalese",
          sr: "Serbian",
          sk: "Slovak",
          sl: "Slovenian",
          so: "Somani",
          sb: "Sorbian",
          es: "Spanish",
          "es-AR": "Spanish (Argentina)",
          "es-BO": "Spanish (Bolivia)",
          "es-CL": "Spanish (Chile)",
          "es-CO": "Spanish (Colombia)",
          "es-CR": "Spanish (Costa Rica)",
          "es-DO": "Spanish (Dominican Republic)",
          "es-EC": "Spanish (Ecuador)",
          "es-SV": "Spanish (El Salvador)",
          "es-GT": "Spanish (Guatemala)",
          "es-HN": "Spanish (Honduras)",
          "es-MX": "Spanish (Mexico)",
          "es-NI": "Spanish (Nicaragua)",
          "es-PA": "Spanish (Panama)",
          "es-PY": "Spanish (Paraguay)",
          "es-PE": "Spanish (Peru)",
          "es-PR": "Spanish (Puerto Rico)",
          "es-ES": "Spanish (Spain)",
          "es-UY": "Spanish (Uruguay)",
          "es-VE": "Spanish (Venezuela)",
          sx: "Sutu",
          sw: "Swahili",
          sv: "Swedish",
          "sv-FI": "Swedish (Finland)",
          "sv-SV": "Swedish (Sweden)",
          ta: "Tamil",
          tt: "Tatar",
          te: "Teluga",
          th: "Thai",
          tig: "Tigre",
          ts: "Tsonga",
          tn: "Tswana",
          tr: "Turkish",
          tk: "Turkmen",
          uk: "Ukrainian",
          hsb: "Upper Sorbian",
          ur: "Urdu",
          ve: "Venda",
          vi: "Vietnamese",
          vo: "Volapuk",
          wa: "Walloon",
          cy: "Welsh",
          xh: "Xhosa",
          ji: "Yiddish",
          zu: "Zulu"
        }[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function () {
          this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
        }), this.internal.languageSettings.isSubscribed = !0)), this;
        /** @license
           * MIT license.
           * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
           *               2014 Diego Casorran, https://github.com/diegocr
           *
           * 
           * ====================================================================
           */
      }, X = ft.API, W = X.getCharWidthsArray = function (t, e) {
        var i,
          s,
          r,
          n = (e = e || {}).font || this.internal.getFont(),
          a = e.fontSize || this.internal.getFontSize(),
          o = e.charSpace || this.internal.getCharSpace(),
          h = e.widths ? e.widths : n.metadata.Unicode.widths,
          l = h.fof ? h.fof : 1,
          A = e.kerning ? e.kerning : n.metadata.Unicode.kerning,
          c = A.fof ? A.fof : 1,
          u = 0,
          d = h[0] || l,
          f = [];
        for (i = 0, s = t.length; i < s; i++) r = t.charCodeAt(i), "function" == typeof n.metadata.widthOfString ? f.push((n.metadata.widthOfGlyph(n.metadata.characterToGlyph(r)) + o * (1e3 / a) || 0) / 1e3) : f.push((h[r] || d) / l + (A[r] && A[r][u] || 0) / c), u = r;
        return f;
      }, Y = X.getArraySum = function (t) {
        for (var e = t.length, i = 0; e;) i += t[--e];
        return i;
      }, Z = X.getStringUnitWidth = function (t, e) {
        var i = (e = e || {}).fontSize || this.internal.getFontSize(),
          s = e.font || this.internal.getFont(),
          r = e.charSpace || this.internal.getCharSpace();
        return "function" == typeof s.metadata.widthOfString ? s.metadata.widthOfString(t, i, r) / i : Y(W.apply(this, arguments));
      }, $ = function $(t, e, i, s) {
        for (var r = [], n = 0, a = t.length, o = 0; n !== a && o + e[n] < i;) o += e[n], n++;
        r.push(t.slice(0, n));
        var h = n;
        for (o = 0; n !== a;) o + e[n] > s && (r.push(t.slice(h, n)), o = 0, h = n), o += e[n], n++;
        return h !== n && r.push(t.slice(h, n)), r;
      }, tt = function tt(t, e, i) {
        i || (i = {});
        var s,
          r,
          n,
          a,
          o,
          h,
          l = [],
          A = [l],
          c = i.textIndent || 0,
          u = 0,
          d = 0,
          f = t.split(" "),
          p = W.apply(this, [" ", i])[0];
        if (h = -1 === i.lineIndent ? f[0].length + 2 : i.lineIndent || 0) {
          var g = Array(h).join(" "),
            w = [];
          f.map(function (t) {
            1 < (t = t.split(/\s*\n/)).length ? w = w.concat(t.map(function (t, e) {
              return (e && t.length ? "\n" : "") + t;
            })) : w.push(t[0]);
          }), f = w, h = Z.apply(this, [g, i]);
        }
        for (n = 0, a = f.length; n < a; n++) {
          var m = 0;
          if (s = f[n], h && "\n" == s[0] && (s = s.substr(1), m = 1), r = W.apply(this, [s, i]), e < c + u + (d = Y(r)) || m) {
            if (e < d) {
              for (o = $.apply(this, [s, r, e - (c + u), e]), l.push(o.shift()), l = [o.pop()]; o.length;) A.push([o.shift()]);
              d = Y(r.slice(s.length - (l[0] ? l[0].length : 0)));
            } else l = [s];
            A.push(l), c = d + h, u = p;
          } else l.push(s), c += u + d, u = p;
        }
        if (h) var v = function v(t, e) {
          return (e ? g : "") + t.join(" ");
        };else v = function v(t) {
          return t.join(" ");
        };
        return A.map(v);
      }, X.splitTextToSize = function (t, e, i) {
        var s,
          r = (i = i || {}).fontSize || this.internal.getFontSize(),
          n = function (t) {
            if (t.widths && t.kerning) return {
              widths: t.widths,
              kerning: t.kerning
            };
            var e = this.internal.getFont(t.fontName, t.fontStyle),
              i = "Unicode";
            return e.metadata[i] ? {
              widths: e.metadata[i].widths || {
                0: 1
              },
              kerning: e.metadata[i].kerning || {}
            } : {
              font: e.metadata,
              fontSize: this.internal.getFontSize(),
              charSpace: this.internal.getCharSpace()
            };
          }.call(this, i);
        s = Array.isArray(t) ? t : t.split(/\r?\n/);
        var a = 1 * this.internal.scaleFactor * e / r;
        n.textIndent = i.textIndent ? 1 * i.textIndent * this.internal.scaleFactor / r : 0, n.lineIndent = i.lineIndent;
        var o,
          h,
          l = [];
        for (o = 0, h = s.length; o < h; o++) l = l.concat(tt.apply(this, [s[o], a, n]));
        return l;
      },
      /** @license
         jsPDF standard_fonts_metrics plugin
         * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
         * MIT license.
         * 
         * ====================================================================
         */
      et = ft.API, st = {
        codePages: ["WinAnsiEncoding"],
        WinAnsiEncoding: (it = function it(t) {
          for (var e = "klmnopqrstuvwxyz", i = {}, s = 0; s < e.length; s++) i[e[s]] = "0123456789abcdef"[s];
          var r,
            n,
            a,
            o,
            h,
            l = {},
            A = 1,
            c = l,
            u = [],
            d = "",
            f = "",
            p = t.length - 1;
          for (s = 1; s != p;) h = t[s], s += 1, "'" == h ? n = n ? (o = n.join(""), r) : [] : n ? n.push(h) : "{" == h ? (u.push([c, o]), c = {}, o = r) : "}" == h ? ((a = u.pop())[0][a[1]] = c, o = r, c = a[0]) : "-" == h ? A = -1 : o === r ? i.hasOwnProperty(h) ? (d += i[h], o = parseInt(d, 16) * A, A = 1, d = "") : d += h : i.hasOwnProperty(h) ? (f += i[h], c[o] = parseInt(f, 16) * A, A = 1, o = r, f = "") : f += h;
          return l;
        })("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
      }, rt = {
        Unicode: {
          Courier: st,
          "Courier-Bold": st,
          "Courier-BoldOblique": st,
          "Courier-Oblique": st,
          Helvetica: st,
          "Helvetica-Bold": st,
          "Helvetica-BoldOblique": st,
          "Helvetica-Oblique": st,
          "Times-Roman": st,
          "Times-Bold": st,
          "Times-BoldItalic": st,
          "Times-Italic": st
        }
      }, nt = {
        Unicode: {
          "Courier-Oblique": it("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
          "Times-BoldItalic": it("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
          "Helvetica-Bold": it("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
          Courier: it("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
          "Courier-BoldOblique": it("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
          "Times-Bold": it("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
          Symbol: it("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
          Helvetica: it("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
          "Helvetica-BoldOblique": it("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
          ZapfDingbats: it("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
          "Courier-Bold": it("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
          "Times-Italic": it("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
          "Times-Roman": it("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
          "Helvetica-Oblique": it("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
      }, et.events.push(["addFont", function (t) {
        var e,
          i,
          s,
          r = t.font,
          n = "Unicode";
        (e = nt[n][r.postScriptName]) && ((i = r.metadata[n] ? r.metadata[n] : r.metadata[n] = {}).widths = e.widths, i.kerning = e.kerning), (s = rt[n][r.postScriptName]) && ((i = r.metadata[n] ? r.metadata[n] : r.metadata[n] = {}).encoding = s).codePages && s.codePages.length && (r.encoding = s.codePages[0]);
      }]),
      /**
         * @license
         * Licensed under the MIT License.
         * http://opensource.org/licenses/mit-license
         */
      at = ft, "undefined" != typeof self && self || void 0 !== s && s || "undefined" != typeof window && window || Function("return this")(), at.API.events.push(["addFont", function (t) {
        var e = t.font,
          i = t.instance;
        if (void 0 !== i && i.existsFileInVFS(e.postScriptName)) {
          var s = i.getFileFromVFS(e.postScriptName);
          if ("string" != typeof s) throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + e.postScriptName + "').");
          e.metadata = at.API.TTFFont.open(e.postScriptName, e.fontName, s, e.encoding), e.metadata.Unicode = e.metadata.Unicode || {
            encoding: {},
            kerning: {},
            widths: []
          }, e.metadata.glyIdsUsed = [0];
        } else if (!1 === e.isStandardFont) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + e.postScriptName + "').");
      }]),
      /** @license
         * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
         * 
         * 
         * ====================================================================
         */
      (ot = ft.API).addSvg = function (t, e, i, s, r) {
        if (void 0 === e || void 0 === i) throw new Error("addSVG needs values for 'x' and 'y'");
        function n(t) {
          for (var e = parseFloat(t[1]), i = parseFloat(t[2]), s = [], r = 3, n = t.length; r < n;) "c" === t[r] ? (s.push([parseFloat(t[r + 1]), parseFloat(t[r + 2]), parseFloat(t[r + 3]), parseFloat(t[r + 4]), parseFloat(t[r + 5]), parseFloat(t[r + 6])]), r += 7) : "l" === t[r] ? (s.push([parseFloat(t[r + 1]), parseFloat(t[r + 2])]), r += 3) : r += 1;
          return [e, i, s];
        }
        var a,
          o,
          h,
          l,
          A,
          c,
          u,
          d,
          f = (a = t, (h = ((d = (l = document).createElement("iframe"), A = ".jsPDF_sillysvg_iframe {display:none;position:absolute;}", (u = (c = l).createElement("style")).type = "text/css", u.styleSheet ? u.styleSheet.cssText = A : u.appendChild(c.createTextNode(A)), c.getElementsByTagName("head")[0].appendChild(u), d.name = "childframe", d.setAttribute("width", 0), d.setAttribute("height", 0), d.setAttribute("frameborder", "0"), d.setAttribute("scrolling", "no"), d.setAttribute("seamless", "seamless"), d.setAttribute("class", "jsPDF_sillysvg_iframe"), l.body.appendChild(d), o = d).contentWindow || o.contentDocument).document).write(a), h.close(), h.getElementsByTagName("svg")[0]),
          p = [1, 1],
          g = parseFloat(f.getAttribute("width")),
          w = parseFloat(f.getAttribute("height"));
        g && w && (s && r ? p = [s / g, r / w] : s ? p = [s / g, s / g] : r && (p = [r / w, r / w]));
        var m,
          v,
          b,
          B,
          y = f.childNodes;
        for (m = 0, v = y.length; m < v; m++) (b = y[m]).tagName && "PATH" === b.tagName.toUpperCase() && ((B = n(b.getAttribute("d").split(" ")))[0] = B[0] * p[0] + e, B[1] = B[1] * p[1] + i, this.lines.call(this, B[2], B[0], B[1], p));
        return this;
      }, ot.addSVG = ot.addSvg, ot.addSvgAsImage = function (t, e, i, s, r, n, a, o) {
        if (isNaN(e) || isNaN(i)) throw console.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
        if (isNaN(s) || isNaN(r)) throw console.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
        var h = document.createElement("canvas");
        h.width = s, h.height = r;
        var l = h.getContext("2d");
        return l.fillStyle = "#fff", l.fillRect(0, 0, h.width, h.height), canvg(h, t, {
          ignoreMouse: !0,
          ignoreAnimation: !0,
          ignoreDimensions: !0,
          ignoreClear: !0
        }), this.addImage(h.toDataURL("image/jpeg", 1), e, i, s, r, a, o), this;
      }, ft.API.putTotalPages = function (t) {
        var e, i;
        i = parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(t, "g"), this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
        for (var s = 1; s <= this.internal.getNumberOfPages(); s++) for (var r = 0; r < this.internal.pages[s].length; r++) this.internal.pages[s][r] = this.internal.pages[s][r].replace(e, i);
        return this;
      }, ft.API.viewerPreferences = function (t, e) {
        var i;
        t = t || {}, e = e || !1;
        var s,
          n,
          a = {
            HideToolbar: {
              defaultValue: !1,
              value: !1,
              type: "boolean",
              explicitSet: !1,
              valueSet: [!0, !1],
              pdfVersion: 1.3
            },
            HideMenubar: {
              defaultValue: !1,
              value: !1,
              type: "boolean",
              explicitSet: !1,
              valueSet: [!0, !1],
              pdfVersion: 1.3
            },
            HideWindowUI: {
              defaultValue: !1,
              value: !1,
              type: "boolean",
              explicitSet: !1,
              valueSet: [!0, !1],
              pdfVersion: 1.3
            },
            FitWindow: {
              defaultValue: !1,
              value: !1,
              type: "boolean",
              explicitSet: !1,
              valueSet: [!0, !1],
              pdfVersion: 1.3
            },
            CenterWindow: {
              defaultValue: !1,
              value: !1,
              type: "boolean",
              explicitSet: !1,
              valueSet: [!0, !1],
              pdfVersion: 1.3
            },
            DisplayDocTitle: {
              defaultValue: !1,
              value: !1,
              type: "boolean",
              explicitSet: !1,
              valueSet: [!0, !1],
              pdfVersion: 1.4
            },
            NonFullScreenPageMode: {
              defaultValue: "UseNone",
              value: "UseNone",
              type: "name",
              explicitSet: !1,
              valueSet: ["UseNone", "UseOutlines", "UseThumbs", "UseOC"],
              pdfVersion: 1.3
            },
            Direction: {
              defaultValue: "L2R",
              value: "L2R",
              type: "name",
              explicitSet: !1,
              valueSet: ["L2R", "R2L"],
              pdfVersion: 1.3
            },
            ViewArea: {
              defaultValue: "CropBox",
              value: "CropBox",
              type: "name",
              explicitSet: !1,
              valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"],
              pdfVersion: 1.4
            },
            ViewClip: {
              defaultValue: "CropBox",
              value: "CropBox",
              type: "name",
              explicitSet: !1,
              valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"],
              pdfVersion: 1.4
            },
            PrintArea: {
              defaultValue: "CropBox",
              value: "CropBox",
              type: "name",
              explicitSet: !1,
              valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"],
              pdfVersion: 1.4
            },
            PrintClip: {
              defaultValue: "CropBox",
              value: "CropBox",
              type: "name",
              explicitSet: !1,
              valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"],
              pdfVersion: 1.4
            },
            PrintScaling: {
              defaultValue: "AppDefault",
              value: "AppDefault",
              type: "name",
              explicitSet: !1,
              valueSet: ["AppDefault", "None"],
              pdfVersion: 1.6
            },
            Duplex: {
              defaultValue: "",
              value: "none",
              type: "name",
              explicitSet: !1,
              valueSet: ["Simplex", "DuplexFlipShortEdge", "DuplexFlipLongEdge", "none"],
              pdfVersion: 1.7
            },
            PickTrayByPDFSize: {
              defaultValue: !1,
              value: !1,
              type: "boolean",
              explicitSet: !1,
              valueSet: [!0, !1],
              pdfVersion: 1.7
            },
            PrintPageRange: {
              defaultValue: "",
              value: "",
              type: "array",
              explicitSet: !1,
              valueSet: null,
              pdfVersion: 1.7
            },
            NumCopies: {
              defaultValue: 1,
              value: 1,
              type: "integer",
              explicitSet: !1,
              valueSet: null,
              pdfVersion: 1.7
            }
          },
          o = Object.keys(a),
          h = [],
          l = 0,
          A = 0,
          c = 0,
          u = !0;
        function d(t, e) {
          var i,
            s = !1;
          for (i = 0; i < t.length; i += 1) t[i] === e && (s = !0);
          return s;
        }
        if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(a)), this.internal.viewerpreferences.isSubscribed = !1), i = this.internal.viewerpreferences.configuration, "reset" === t || !0 === e) {
          var f = o.length;
          for (c = 0; c < f; c += 1) i[o[c]].value = i[o[c]].defaultValue, i[o[c]].explicitSet = !1;
        }
        if ("object" === r(t)) for (s in t) if (n = t[s], d(o, s) && void 0 !== n) {
          if ("boolean" === i[s].type && "boolean" == typeof n) i[s].value = n;else if ("name" === i[s].type && d(i[s].valueSet, n)) i[s].value = n;else if ("integer" === i[s].type && Number.isInteger(n)) i[s].value = n;else if ("array" === i[s].type) {
            for (l = 0; l < n.length; l += 1) if (u = !0, 1 === n[l].length && "number" == typeof n[l][0]) h.push(String(n[l] - 1));else if (1 < n[l].length) {
              for (A = 0; A < n[l].length; A += 1) "number" != typeof n[l][A] && (u = !1);
              !0 === u && h.push([n[l][0] - 1, n[l][1] - 1].join(" "));
            }
            i[s].value = "[" + h.join(" ") + "]";
          } else i[s].value = i[s].defaultValue;
          i[s].explicitSet = !0;
        }
        return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function () {
          var t,
            e = [];
          for (t in i) !0 === i[t].explicitSet && ("name" === i[t].type ? e.push("/" + t + " /" + i[t].value) : e.push("/" + t + " " + i[t].value));
          0 !== e.length && this.internal.write("/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>");
        }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = i, this;
      }, ht = ft.API, ct = At = lt = "", ht.addMetadata = function (t, e) {
        return At = e || "http://jspdf.default.namespaceuri/", lt = t, this.internal.events.subscribe("postPutResources", function () {
          if (lt) {
            var t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + At + '"><jspdf:metadata>',
              e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),
              i = unescape(encodeURIComponent(t)),
              s = unescape(encodeURIComponent(lt)),
              r = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),
              n = unescape(encodeURIComponent("</x:xmpmeta>")),
              a = i.length + s.length + r.length + e.length + n.length;
            ct = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + a + " >>"), this.internal.write("stream"), this.internal.write(e + i + s + r + n), this.internal.write("endstream"), this.internal.write("endobj");
          } else ct = "";
        }), this.internal.events.subscribe("putCatalog", function () {
          ct && this.internal.write("/Metadata " + ct + " 0 R");
        }), this;
      }, function (t, e) {
        var i = t.API,
          s = i.pdfEscape16 = function (t, e) {
            for (var i, s = e.metadata.Unicode.widths, r = ["", "0", "00", "000", "0000"], n = [""], a = 0, o = t.length; a < o; ++a) {
              if (i = e.metadata.characterToGlyph(t.charCodeAt(a)), e.metadata.glyIdsUsed.push(i), e.metadata.toUnicode[i] = t.charCodeAt(a), -1 == s.indexOf(i) && (s.push(i), s.push([parseInt(e.metadata.widthOfGlyph(i), 10)])), "0" == i) return n.join("");
              i = i.toString(16), n.push(r[4 - i.length], i);
            }
            return n.join("");
          },
          r = function r(t) {
            var e, i, s, r, n, a, o;
            for (n = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange", s = [], a = 0, o = (i = Object.keys(t).sort(function (t, e) {
              return t - e;
            })).length; a < o; a++) e = i[a], 100 <= s.length && (n += "\n" + s.length + " beginbfchar\n" + s.join("\n") + "\nendbfchar", s = []), r = ("0000" + t[e].toString(16)).slice(-4), e = ("0000" + (+e).toString(16)).slice(-4), s.push("<" + e + "><" + r + ">");
            return s.length && (n += "\n" + s.length + " beginbfchar\n" + s.join("\n") + "\nendbfchar\n"), n + "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
          };
        i.events.push(["putFont", function (e) {
          !function (e, i, s, n) {
            if (e.metadata instanceof t.API.TTFFont && "Identity-H" === e.encoding) {
              for (var a = e.metadata.Unicode.widths, o = e.metadata.subset.encode(e.metadata.glyIdsUsed, 1), h = "", l = 0; l < o.length; l++) h += String.fromCharCode(o[l]);
              var A = s();
              n({
                data: h,
                addLength1: !0
              }), i("endobj");
              var c = s();
              n({
                data: r(e.metadata.toUnicode),
                addLength1: !0
              }), i("endobj");
              var u = s();
              i("<<"), i("/Type /FontDescriptor"), i("/FontName /" + e.fontName), i("/FontFile2 " + A + " 0 R"), i("/FontBBox " + t.API.PDFObject.convert(e.metadata.bbox)), i("/Flags " + e.metadata.flags), i("/StemV " + e.metadata.stemV), i("/ItalicAngle " + e.metadata.italicAngle), i("/Ascent " + e.metadata.ascender), i("/Descent " + e.metadata.decender), i("/CapHeight " + e.metadata.capHeight), i(">>"), i("endobj");
              var d = s();
              i("<<"), i("/Type /Font"), i("/BaseFont /" + e.fontName), i("/FontDescriptor " + u + " 0 R"), i("/W " + t.API.PDFObject.convert(a)), i("/CIDToGIDMap /Identity"), i("/DW 1000"), i("/Subtype /CIDFontType2"), i("/CIDSystemInfo"), i("<<"), i("/Supplement 0"), i("/Registry (Adobe)"), i("/Ordering (" + e.encoding + ")"), i(">>"), i(">>"), i("endobj"), e.objectNumber = s(), i("<<"), i("/Type /Font"), i("/Subtype /Type0"), i("/ToUnicode " + c + " 0 R"), i("/BaseFont /" + e.fontName), i("/Encoding /" + e.encoding), i("/DescendantFonts [" + d + " 0 R]"), i(">>"), i("endobj"), e.isAlreadyPutted = !0;
            }
          }(e.font, e.out, e.newObject, e.putStream);
        }]), i.events.push(["putFont", function (e) {
          !function (e, i, s, n) {
            if (e.metadata instanceof t.API.TTFFont && "WinAnsiEncoding" === e.encoding) {
              e.metadata.Unicode.widths;
              for (var a = e.metadata.rawData, o = "", h = 0; h < a.length; h++) o += String.fromCharCode(a[h]);
              var l = s();
              n({
                data: o,
                addLength1: !0
              }), i("endobj");
              var A = s();
              n({
                data: r(e.metadata.toUnicode),
                addLength1: !0
              }), i("endobj");
              var c = s();
              for (i("<<"), i("/Descent " + e.metadata.decender), i("/CapHeight " + e.metadata.capHeight), i("/StemV " + e.metadata.stemV), i("/Type /FontDescriptor"), i("/FontFile2 " + l + " 0 R"), i("/Flags 96"), i("/FontBBox " + t.API.PDFObject.convert(e.metadata.bbox)), i("/FontName /" + e.fontName), i("/ItalicAngle " + e.metadata.italicAngle), i("/Ascent " + e.metadata.ascender), i(">>"), i("endobj"), e.objectNumber = s(), h = 0; h < e.metadata.hmtx.widths.length; h++) e.metadata.hmtx.widths[h] = parseInt(e.metadata.hmtx.widths[h] * (1e3 / e.metadata.head.unitsPerEm));
              i("<</Subtype/TrueType/Type/Font/ToUnicode " + A + " 0 R/BaseFont/" + e.fontName + "/FontDescriptor " + c + " 0 R/Encoding/" + e.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t.API.PDFObject.convert(e.metadata.hmtx.widths) + ">>"), i("endobj"), e.isAlreadyPutted = !0;
            }
          }(e.font, e.out, e.newObject, e.putStream);
        }]);
        var n = function n(t) {
          var e,
            i,
            r = t.text || "",
            n = t.x,
            a = t.y,
            o = t.options || {},
            h = t.mutex || {},
            l = h.pdfEscape,
            A = h.activeFontKey,
            c = h.fonts,
            u = (h.activeFontSize, ""),
            d = 0,
            f = "",
            p = c[i = A].encoding;
          if ("Identity-H" !== c[i].encoding) return {
            text: r,
            x: n,
            y: a,
            options: o,
            mutex: h
          };
          for (f = r, i = A, "[object Array]" === Object.prototype.toString.call(r) && (f = r[0]), d = 0; d < f.length; d += 1) c[i].metadata.hasOwnProperty("cmap") && (e = c[i].metadata.cmap.unicode.codeMap[f[d].charCodeAt(0)]), e || f[d].charCodeAt(0) < 256 && c[i].metadata.hasOwnProperty("Unicode") ? u += f[d] : u += "";
          var g = "";
          return parseInt(i.slice(1)) < 14 || "WinAnsiEncoding" === p ? g = function (t) {
            for (var e = "", i = 0; i < t.length; i++) e += "" + t.charCodeAt(i).toString(16);
            return e;
          }(l(u, i)) : "Identity-H" === p && (g = s(u, c[i])), h.isHex = !0, {
            text: g,
            x: n,
            y: a,
            options: o,
            mutex: h
          };
        };
        i.events.push(["postProcessText", function (t) {
          var e = t.text || "",
            i = t.x,
            s = t.y,
            r = t.options,
            a = t.mutex,
            o = (r.lang, []),
            h = {
              text: e,
              x: i,
              y: s,
              options: r,
              mutex: a
            };
          if ("[object Array]" === Object.prototype.toString.call(e)) {
            var l = 0;
            for (l = 0; l < e.length; l += 1) "[object Array]" === Object.prototype.toString.call(e[l]) && 3 === e[l].length ? o.push([n(Object.assign({}, h, {
              text: e[l][0]
            })).text, e[l][1], e[l][2]]) : o.push(n(Object.assign({}, h, {
              text: e[l]
            })).text);
            t.text = o;
          } else t.text = n(Object.assign({}, h, {
            text: e
          })).text;
        }]);
      }(ft, "undefined" != typeof self && self || void 0 !== s && s || "undefined" != typeof window && window || Function("return this")()), ut = ft.API, dt = function dt(t) {
        return void 0 !== t && (void 0 === t.vFS && (t.vFS = {}), !0);
      }, ut.existsFileInVFS = function (t) {
        return !!dt(this.internal) && void 0 !== this.internal.vFS[t];
      }, ut.addFileToVFS = function (t, e) {
        return dt(this.internal), this.internal.vFS[t] = e, this;
      }, ut.getFileFromVFS = function (t) {
        return dt(this.internal), void 0 !== this.internal.vFS[t] ? this.internal.vFS[t] : null;
      }, ft.API.addHTML = function (t, e, i, s, r) {
        if ("undefined" == typeof html2canvas && "undefined" == typeof rasterizeHTML) throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");
        "number" != typeof e && (s = e, r = i), "function" == typeof s && (r = s, s = null), "function" != typeof r && (r = function r() {});
        var n = this.internal,
          a = n.scaleFactor,
          o = n.pageSize.getWidth(),
          h = n.pageSize.getHeight();
        if ((s = s || {}).onrendered = function (t) {
          e = parseInt(e) || 0, i = parseInt(i) || 0;
          var n = s.dim || {},
            l = Object.assign({
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              useFor: "content"
            }, s.margin),
            A = n.h || Math.min(h, t.height / a),
            c = n.w || Math.min(o, t.width / a) - e,
            u = s.format || "JPEG",
            d = s.imageCompression || "SLOW";
          if (t.height > h - l.top - l.bottom && s.pagesplit) {
            var f = function f(t, e, i, r, n) {
                var a = document.createElement("canvas");
                a.height = n, a.width = r;
                var o = a.getContext("2d");
                return o.mozImageSmoothingEnabled = !1, o.webkitImageSmoothingEnabled = !1, o.msImageSmoothingEnabled = !1, o.imageSmoothingEnabled = !1, o.fillStyle = s.backgroundColor || "#ffffff", o.fillRect(0, 0, r, n), o.drawImage(t, e, i, r, n, 0, 0, r, n), a;
              },
              p = function () {
                for (var s, n, A = 0, p = 0, g = {}, w = !1;;) {
                  var m;
                  if (p = 0, g.top = 0 !== A ? l.top : i, g.left = 0 !== A ? l.left : e, w = (o - l.left - l.right) * a < t.width, "content" === l.useFor ? 0 === A ? (s = Math.min((o - l.left) * a, t.width), n = Math.min((h - l.top) * a, t.height - A)) : (s = Math.min(o * a, t.width), n = Math.min(h * a, t.height - A), g.top = 0) : (s = Math.min((o - l.left - l.right) * a, t.width), n = Math.min((h - l.bottom - l.top) * a, t.height - A)), w) for (;;) {
                    "content" === l.useFor && (0 === p ? s = Math.min((o - l.left) * a, t.width) : (s = Math.min(o * a, t.width - p), g.left = 0));
                    var v = [m = f(t, p, A, s, n), g.left, g.top, m.width / a, m.height / a, u, null, d];
                    if (this.addImage.apply(this, v), (p += s) >= t.width) break;
                    this.addPage();
                  } else v = [m = f(t, 0, A, s, n), g.left, g.top, m.width / a, m.height / a, u, null, d], this.addImage.apply(this, v);
                  if ((A += n) >= t.height) break;
                  this.addPage();
                }
                r(c, A, null, v);
              }.bind(this);
            if ("CANVAS" === t.nodeName) {
              var g = new Image();
              g.onload = p, g.src = t.toDataURL("image/png"), t = g;
            } else p();
          } else {
            var w = Math.random().toString(35),
              m = [t, e, i, c, A, u, w, d];
            this.addImage.apply(this, m), r(c, A, w, m);
          }
        }.bind(this), "undefined" != typeof html2canvas && !s.rstz) return html2canvas(t, s);
        if ("undefined" == typeof rasterizeHTML) return null;
        var l = "drawDocument";
        return "string" == typeof t && (l = /^http/.test(t) ? "drawURL" : "drawHTML"), s.width = s.width || o * a, rasterizeHTML[l](t, void 0, s).then(function (t) {
          s.onrendered(t.image);
        }, function (t) {
          r(null, t);
        });
        /**
           * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
           * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
           *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
           *               2014 Diego Casorran, https://github.com/diegocr
           *               2014 Daniel Husar, https://github.com/danielhusar
           *               2014 Wolfgang Gassler, https://github.com/woolfg
           *               2014 Steven Spungin, https://github.com/flamenco
           *
           * @license
           * 
           * ====================================================================
           */
      }, function (t) {
        var e, _i123, s, n, a, o, h, l, A, c, u, d, f, p, g, w, m, v, b, B;
        e = function () {
          return function (e) {
            return t.prototype = e, new t();
          };
          function t() {}
        }(), c = function c(t) {
          var e, i, s, r, n, a, o;
          for (i = 0, s = t.length, e = void 0, a = r = !1; !r && i !== s;) (e = t[i] = t[i].trimLeft()) && (r = !0), i++;
          for (i = s - 1; s && !a && -1 !== i;) (e = t[i] = t[i].trimRight()) && (a = !0), i--;
          for (n = /\s+$/g, o = !0, i = 0; i !== s;) "\u2028" != t[i] && (e = t[i].replace(/\s+/g, " "), o && (e = e.trimLeft()), e && (o = n.test(e)), t[i] = e), i++;
          return t;
        }, d = function d(t) {
          var e, i, r;
          for (e = void 0, i = (r = t.split(",")).shift(); !e && i;) e = s[i.trim().toLowerCase()], i = r.shift();
          return e;
        }, f = function f(t) {
          var e;
          return -1 < (t = "auto" === t ? "0px" : t).indexOf("em") && !isNaN(Number(t.replace("em", ""))) && (t = 18.719 * Number(t.replace("em", "")) + "px"), -1 < t.indexOf("pt") && !isNaN(Number(t.replace("pt", ""))) && (t = 1.333 * Number(t.replace("pt", "")) + "px"), (e = p[t]) ? e : void 0 !== (e = {
            "xx-small": 9,
            "x-small": 11,
            small: 13,
            medium: 16,
            large: 19,
            "x-large": 23,
            "xx-large": 28,
            auto: 0
          }[t]) || (e = parseFloat(t)) ? p[t] = e / 16 : (e = t.match(/([\d\.]+)(px)/), Array.isArray(e) && 3 === e.length ? p[t] = parseFloat(e[1]) / 16 : p[t] = 1);
        }, A = function A(t) {
          var e, i, s, r, A;
          return A = t, r = document.defaultView && document.defaultView.getComputedStyle ? document.defaultView.getComputedStyle(A, null) : A.currentStyle ? A.currentStyle : A.style, i = void 0, (e = {})["font-family"] = d((s = function s(t) {
            return t = t.replace(/-\D/g, function (t) {
              return t.charAt(1).toUpperCase();
            }), r[t];
          })("font-family")) || "times", e["font-style"] = n[s("font-style")] || "normal", e["text-align"] = a[s("text-align")] || "left", "bold" === (i = o[s("font-weight")] || "normal") && ("normal" === e["font-style"] ? e["font-style"] = i : e["font-style"] = i + e["font-style"]), e["font-size"] = f(s("font-size")) || 1, e["line-height"] = f(s("line-height")) || 1, e.display = "inline" === s("display") ? "inline" : "block", i = "block" === e.display, e["margin-top"] = i && f(s("margin-top")) || 0, e["margin-bottom"] = i && f(s("margin-bottom")) || 0, e["padding-top"] = i && f(s("padding-top")) || 0, e["padding-bottom"] = i && f(s("padding-bottom")) || 0, e["margin-left"] = i && f(s("margin-left")) || 0, e["margin-right"] = i && f(s("margin-right")) || 0, e["padding-left"] = i && f(s("padding-left")) || 0, e["padding-right"] = i && f(s("padding-right")) || 0, e["page-break-before"] = s("page-break-before") || "auto", e.float = h[s("cssFloat")] || "none", e.clear = l[s("clear")] || "none", e.color = s("color"), e;
        }, g = function g(t, e, i) {
          var s, r, n, a, o;
          if (n = !1, a = r = void 0, s = i["#" + t.id]) if ("function" == typeof s) n = s(t, e);else for (r = 0, a = s.length; !n && r !== a;) n = s[r](t, e), r++;
          if (s = i[t.nodeName], !n && s) if ("function" == typeof s) n = s(t, e);else for (r = 0, a = s.length; !n && r !== a;) n = s[r](t, e), r++;
          for (o = "string" == typeof t.className ? t.className.split(" ") : [], r = 0; r < o.length; r++) if (s = i["." + o[r]], !n && s) if ("function" == typeof s) n = s(t, e);else for (r = 0, a = s.length; !n && r !== a;) n = s[r](t, e), r++;
          return n;
        }, B = function B(t, e) {
          var i, s, r, n, a, o, h, l, A;
          for (i = [], s = [], r = 0, A = t.rows[0].cells.length, h = t.clientWidth; r < A;) l = t.rows[0].cells[r], s[r] = {
            name: l.textContent.toLowerCase().replace(/\s+/g, ""),
            prompt: l.textContent.replace(/\r?\n/g, ""),
            width: l.clientWidth / h * e.pdf.internal.pageSize.getWidth()
          }, r++;
          for (r = 1; r < t.rows.length;) {
            for (o = t.rows[r], a = {}, n = 0; n < o.cells.length;) a[s[n].name] = o.cells[n].textContent.replace(/\r?\n/g, ""), n++;
            i.push(a), r++;
          }
          return {
            rows: i,
            headers: s
          };
        };
        var y = {
            SCRIPT: 1,
            STYLE: 1,
            NOSCRIPT: 1,
            OBJECT: 1,
            EMBED: 1,
            SELECT: 1
          },
          C = 1;
        _i123 = function i(t, s, n) {
          var a, o, h, l, c, u, d, f;
          for (o = t.childNodes, a = void 0, (c = "block" === (h = A(t)).display) && (s.setBlockBoundary(), s.setBlockStyle(h)), l = 0, u = o.length; l < u;) {
            if ("object" === r(a = o[l])) {
              if (s.executeWatchFunctions(a), 1 === a.nodeType && "HEADER" === a.nodeName) {
                var p = a,
                  m = s.pdf.margins_doc.top;
                s.pdf.internal.events.subscribe("addPage", function (t) {
                  s.y = m, _i123(p, s, n), s.pdf.margins_doc.top = s.y + 10, s.y += 10;
                }, !1);
              }
              if (8 === a.nodeType && "#comment" === a.nodeName) ~a.textContent.indexOf("ADD_PAGE") && (s.pdf.addPage(), s.y = s.pdf.margins_doc.top);else if (1 !== a.nodeType || y[a.nodeName]) {
                if (3 === a.nodeType) {
                  var v = a.nodeValue;
                  if (a.nodeValue && "LI" === a.parentNode.nodeName) if ("OL" === a.parentNode.parentNode.nodeName) v = C++ + ". " + v;else {
                    var b = h["font-size"],
                      F = (3 - .75 * b) * s.pdf.internal.scaleFactor,
                      x = .75 * b * s.pdf.internal.scaleFactor,
                      N = 1.74 * b / s.pdf.internal.scaleFactor;
                    f = function f(t, e) {
                      this.pdf.circle(t + F, e + x, N, "FD");
                    };
                  }
                  16 & a.ownerDocument.body.compareDocumentPosition(a) && s.addText(v, h);
                } else "string" == typeof a && s.addText(a, h);
              } else {
                var E;
                if ("IMG" === a.nodeName) {
                  var U = a.getAttribute("src");
                  E = w[s.pdf.sHashCode(U) || U];
                }
                if (E) {
                  s.pdf.internal.pageSize.getHeight() - s.pdf.margins_doc.bottom < s.y + a.height && s.y > s.pdf.margins_doc.top && (s.pdf.addPage(), s.y = s.pdf.margins_doc.top, s.executeWatchFunctions(a));
                  var Q = A(a),
                    L = s.x,
                    S = 12 / s.pdf.internal.scaleFactor,
                    k = (Q["margin-left"] + Q["padding-left"]) * S,
                    H = (Q["margin-right"] + Q["padding-right"]) * S,
                    I = (Q["margin-top"] + Q["padding-top"]) * S,
                    O = (Q["margin-bottom"] + Q["padding-bottom"]) * S;
                  void 0 !== Q.float && "right" === Q.float ? L += s.settings.width - a.width - H : L += k, s.pdf.addImage(E, L, s.y + I, a.width, a.height), E = void 0, "right" === Q.float || "left" === Q.float ? (s.watchFunctions.push(function (t, e, i, r) {
                    return s.y >= e ? (s.x += t, s.settings.width += i, !0) : !!(r && 1 === r.nodeType && !y[r.nodeName] && s.x + r.width > s.pdf.margins_doc.left + s.pdf.margins_doc.width) && (s.x += t, s.y = e, s.settings.width += i, !0);
                  }.bind(this, "left" === Q.float ? -a.width - k - H : 0, s.y + a.height + I + O, a.width)), s.watchFunctions.push(function (t, e, i) {
                    return !(s.y < t && e === s.pdf.internal.getNumberOfPages()) || 1 === i.nodeType && "both" === A(i).clear && (s.y = t, !0);
                  }.bind(this, s.y + a.height, s.pdf.internal.getNumberOfPages())), s.settings.width -= a.width + k + H, "left" === Q.float && (s.x += a.width + k + H)) : s.y += a.height + I + O;
                } else if ("TABLE" === a.nodeName) d = B(a, s), s.y += 10, s.pdf.table(s.x, s.y, d.rows, d.headers, {
                  autoSize: !1,
                  printHeaders: n.printHeaders,
                  margins: s.pdf.margins_doc,
                  css: A(a)
                }), s.y = s.pdf.lastCellPos.y + s.pdf.lastCellPos.h + 20;else if ("OL" === a.nodeName || "UL" === a.nodeName) C = 1, g(a, s, n) || _i123(a, s, n), s.y += 10;else if ("LI" === a.nodeName) {
                  var T = s.x;
                  s.x += 20 / s.pdf.internal.scaleFactor, s.y += 3, g(a, s, n) || _i123(a, s, n), s.x = T;
                } else "BR" === a.nodeName ? (s.y += h["font-size"] * s.pdf.internal.scaleFactor, s.addText("\u2028", e(h))) : g(a, s, n) || _i123(a, s, n);
              }
            }
            l++;
          }
          if (n.outY = s.y, c) return s.setBlockBoundary(f);
        }, w = {}, m = function m(t, e, i, s) {
          var r,
            n = t.getElementsByTagName("img"),
            a = n.length,
            o = 0;
          function h() {
            e.pdf.internal.events.publish("imagesLoaded"), s(r);
          }
          function l(t, i, s) {
            if (t) {
              var n = new Image();
              r = ++o, n.crossOrigin = "", n.onerror = n.onload = function () {
                if (n.complete && (0 === n.src.indexOf("data:image/") && (n.width = i || n.width || 0, n.height = s || n.height || 0), n.width + n.height)) {
                  var r = e.pdf.sHashCode(t) || t;
                  w[r] = w[r] || n;
                }
                --o || h();
              }, n.src = t;
            }
          }
          for (; a--;) l(n[a].getAttribute("src"), n[a].width, n[a].height);
          return o || h();
        }, v = function v(t, e, s) {
          var r = t.getElementsByTagName("footer");
          if (0 < r.length) {
            r = r[0];
            var n = e.pdf.internal.write,
              a = e.y;
            e.pdf.internal.write = function () {}, _i123(r, e, s);
            var o = Math.ceil(e.y - a) + 5;
            e.y = a, e.pdf.internal.write = n, e.pdf.margins_doc.bottom += o;
            for (var h = function h(t) {
                var n = void 0 !== t ? t.pageNumber : 1,
                  a = e.y;
                e.y = e.pdf.internal.pageSize.getHeight() - e.pdf.margins_doc.bottom, e.pdf.margins_doc.bottom -= o;
                for (var h = r.getElementsByTagName("span"), l = 0; l < h.length; ++l) -1 < (" " + h[l].className + " ").replace(/[\n\t]/g, " ").indexOf(" pageCounter ") && (h[l].innerHTML = n), -1 < (" " + h[l].className + " ").replace(/[\n\t]/g, " ").indexOf(" totalPages ") && (h[l].innerHTML = "###jsPDFVarTotalPages###");
                _i123(r, e, s), e.pdf.margins_doc.bottom += o, e.y = a;
              }, l = r.getElementsByTagName("span"), A = 0; A < l.length; ++A) -1 < (" " + l[A].className + " ").replace(/[\n\t]/g, " ").indexOf(" totalPages ") && e.pdf.internal.events.subscribe("htmlRenderingFinished", e.pdf.putTotalPages.bind(e.pdf, "###jsPDFVarTotalPages###"), !0);
            e.pdf.internal.events.subscribe("addPage", h, !1), h(), y.FOOTER = 1;
          }
        }, b = function b(t, e, s, r, n, a) {
          if (!e) return !1;
          var o, h, l, A;
          "string" == typeof e || e.parentNode || (e = "" + e.innerHTML), "string" == typeof e && (o = e.replace(/<\/?script[^>]*?>/gi, ""), A = "jsPDFhtmlText" + Date.now().toString() + (1e3 * Math.random()).toFixed(0), (l = document.createElement("div")).style.cssText = "position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;", l.innerHTML = '<iframe style="height:1px;width:1px" name="' + A + '" />', document.body.appendChild(l), (h = window.frames[A]).document.open(), h.document.writeln(o), h.document.close(), e = h.document.body);
          var c,
            d = new u(t, s, r, n);
          return m.call(this, e, d, n.elementHandlers, function (t) {
            v(e, d, n.elementHandlers), _i123(e, d, n.elementHandlers), d.pdf.internal.events.publish("htmlRenderingFinished"), c = d.dispose(), "function" == typeof a ? a(c) : t && console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!");
          }), c || {
            x: d.x,
            y: d.y
          };
        }, (u = function u(t, e, i, s) {
          return this.pdf = t, this.x = e, this.y = i, this.settings = s, this.watchFunctions = [], this.init(), this;
        }).prototype.init = function () {
          return this.paragraph = {
            text: [],
            style: []
          }, this.pdf.internal.write("q");
        }, u.prototype.dispose = function () {
          return this.pdf.internal.write("Q"), {
            x: this.x,
            y: this.y,
            ready: !0
          };
        }, u.prototype.executeWatchFunctions = function (t) {
          var e = !1,
            i = [];
          if (0 < this.watchFunctions.length) {
            for (var s = 0; s < this.watchFunctions.length; ++s) !0 === this.watchFunctions[s](t) ? e = !0 : i.push(this.watchFunctions[s]);
            this.watchFunctions = i;
          }
          return e;
        }, u.prototype.splitFragmentsIntoLines = function (t, i) {
          var s, r, n, a, o, h, l, A, c, u, d, f, p, g;
          for (u = this.pdf.internal.scaleFactor, a = {}, h = l = A = g = o = n = c = r = void 0, f = [d = []], s = 0, p = this.settings.width; t.length;) if (o = t.shift(), g = i.shift(), o) if ((n = a[(r = g["font-family"]) + (c = g["font-style"])]) || (n = this.pdf.internal.getFont(r, c).metadata.Unicode, a[r + c] = n), A = {
            widths: n.widths,
            kerning: n.kerning,
            fontSize: 12 * g["font-size"],
            textIndent: s
          }, l = this.pdf.getStringUnitWidth(o, A) * A.fontSize / u, "\u2028" == o) d = [], f.push(d);else if (p < s + l) {
            for (h = this.pdf.splitTextToSize(o, p, A), d.push([h.shift(), g]); h.length;) d = [[h.shift(), g]], f.push(d);
            s = this.pdf.getStringUnitWidth(d[0][0], A) * A.fontSize / u;
          } else d.push([o, g]), s += l;
          if (void 0 !== g["text-align"] && ("center" === g["text-align"] || "right" === g["text-align"] || "justify" === g["text-align"])) for (var w = 0; w < f.length; ++w) {
            var m = this.pdf.getStringUnitWidth(f[w][0][0], A) * A.fontSize / u;
            0 < w && (f[w][0][1] = e(f[w][0][1]));
            var v = p - m;
            if ("right" === g["text-align"]) f[w][0][1]["margin-left"] = v;else if ("center" === g["text-align"]) f[w][0][1]["margin-left"] = v / 2;else if ("justify" === g["text-align"]) {
              var b = f[w][0][0].split(" ").length - 1;
              f[w][0][1]["word-spacing"] = v / b, w === f.length - 1 && (f[w][0][1]["word-spacing"] = 0);
            }
          }
          return f;
        }, u.prototype.RenderTextFragment = function (t, e) {
          var i, s;
          s = 0, this.pdf.internal.pageSize.getHeight() - this.pdf.margins_doc.bottom < this.y + this.pdf.internal.getFontSize() && (this.pdf.internal.write("ET", "Q"), this.pdf.addPage(), this.y = this.pdf.margins_doc.top, this.pdf.internal.write("q", "BT", this.getPdfColor(e.color), this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td"), s = Math.max(s, e["line-height"], e["font-size"]), this.pdf.internal.write(0, (-12 * s).toFixed(2), "Td")), i = this.pdf.internal.getFont(e["font-family"], e["font-style"]);
          var r = this.getPdfColor(e.color);
          r !== this.lastTextColor && (this.pdf.internal.write(r), this.lastTextColor = r), void 0 !== e["word-spacing"] && 0 < e["word-spacing"] && this.pdf.internal.write(e["word-spacing"].toFixed(2), "Tw"), this.pdf.internal.write("/" + i.id, (12 * e["font-size"]).toFixed(2), "Tf", "(" + this.pdf.internal.pdfEscape(t) + ") Tj"), void 0 !== e["word-spacing"] && this.pdf.internal.write(0, "Tw");
        }, u.prototype.getPdfColor = function (t) {
          var e,
            i,
            s,
            r = /rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);
          if (null != r) e = parseInt(r[1]), i = parseInt(r[2]), s = parseInt(r[3]);else {
            if ("string" == typeof t && "#" != t.charAt(0)) {
              var n = new RGBColor(t);
              t = n.ok ? n.toHex() : "#000000";
            }
            e = t.substring(1, 3), e = parseInt(e, 16), i = t.substring(3, 5), i = parseInt(i, 16), s = t.substring(5, 7), s = parseInt(s, 16);
          }
          if ("string" == typeof e && /^#[0-9A-Fa-f]{6}$/.test(e)) {
            var a = parseInt(e.substr(1), 16);
            e = a >> 16 & 255, i = a >> 8 & 255, s = 255 & a;
          }
          var o = this.f3;
          return 0 === e && 0 === i && 0 === s || void 0 === i ? o(e / 255) + " g" : [o(e / 255), o(i / 255), o(s / 255), "rg"].join(" ");
        }, u.prototype.f3 = function (t) {
          return t.toFixed(3);
        }, u.prototype.renderParagraph = function (t) {
          var e, i, s, r, n, a, o, h, l, A, u, d, f;
          if (s = c(this.paragraph.text), d = this.paragraph.style, e = this.paragraph.blockstyle, this.paragraph.priorblockstyle, this.paragraph = {
            text: [],
            style: [],
            blockstyle: {},
            priorblockstyle: e
          }, s.join("").trim()) {
            o = this.splitFragmentsIntoLines(s, d), h = a = void 0, i = 12 / this.pdf.internal.scaleFactor, this.priorMarginBottom = this.priorMarginBottom || 0, u = (Math.max((e["margin-top"] || 0) - this.priorMarginBottom, 0) + (e["padding-top"] || 0)) * i, A = ((e["margin-bottom"] || 0) + (e["padding-bottom"] || 0)) * i, this.priorMarginBottom = e["margin-bottom"] || 0, "always" === e["page-break-before"] && (this.pdf.addPage(), this.y = 0, u = ((e["margin-top"] || 0) + (e["padding-top"] || 0)) * i), l = this.pdf.internal.write, n = r = void 0, this.y += u, l("q", "BT 0 g", this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td");
            for (var p = 0; o.length;) {
              for (r = h = 0, n = (a = o.shift()).length; r !== n;) a[r][0].trim() && (h = Math.max(h, a[r][1]["line-height"], a[r][1]["font-size"]), f = 7 * a[r][1]["font-size"]), r++;
              var g = 0,
                w = 0;
              for (void 0 !== a[0][1]["margin-left"] && 0 < a[0][1]["margin-left"] && (g = (w = this.pdf.internal.getCoordinateString(a[0][1]["margin-left"])) - p, p = w), l(g + Math.max(e["margin-left"] || 0, 0) * i, (-12 * h).toFixed(2), "Td"), r = 0, n = a.length; r !== n;) a[r][0] && this.RenderTextFragment(a[r][0], a[r][1]), r++;
              if (this.y += h * i, this.executeWatchFunctions(a[0][1]) && 0 < o.length) {
                var m = [],
                  v = [];
                o.forEach(function (t) {
                  for (var e = 0, i = t.length; e !== i;) t[e][0] && (m.push(t[e][0] + " "), v.push(t[e][1])), ++e;
                }), o = this.splitFragmentsIntoLines(c(m), v), l("ET", "Q"), l("q", "BT 0 g", this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td");
              }
            }
            return t && "function" == typeof t && t.call(this, this.x - 9, this.y - f / 2), l("ET", "Q"), this.y += A;
          }
        }, u.prototype.setBlockBoundary = function (t) {
          return this.renderParagraph(t);
        }, u.prototype.setBlockStyle = function (t) {
          return this.paragraph.blockstyle = t;
        }, u.prototype.addText = function (t, e) {
          return this.paragraph.text.push(t), this.paragraph.style.push(e);
        }, s = {
          helvetica: "helvetica",
          "sans-serif": "helvetica",
          "times new roman": "times",
          serif: "times",
          times: "times",
          monospace: "courier",
          courier: "courier"
        }, o = {
          100: "normal",
          200: "normal",
          300: "normal",
          400: "normal",
          500: "bold",
          600: "bold",
          700: "bold",
          800: "bold",
          900: "bold",
          normal: "normal",
          bold: "bold",
          bolder: "bold",
          lighter: "normal"
        }, n = {
          normal: "normal",
          italic: "italic",
          oblique: "italic"
        }, a = {
          left: "left",
          right: "right",
          center: "center",
          justify: "justify"
        }, h = {
          none: "none",
          right: "right",
          left: "left"
        }, l = {
          none: "none",
          both: "both"
        }, p = {
          normal: 1
        }, t.fromHTML = function (t, e, i, s, r, n) {
          return this.margins_doc = n || {
            top: 0,
            bottom: 0
          }, s || (s = {}), s.elementHandlers || (s.elementHandlers = {}), b(this, t, isNaN(e) ? 4 : e, isNaN(i) ? 4 : i, s, r);
        };
      }(ft.API), ft.API, ("undefined" != typeof window && window || void 0 !== s && s).html2pdf = function (t, e, i) {
        var s = e.canvas;
        if (s) {
          var r, n;
          if ((s.pdf = e).annotations = {
            _nameMap: [],
            createAnnotation: function createAnnotation(t, i) {
              var s,
                r = e.context2d._wrapX(i.left),
                n = e.context2d._wrapY(i.top),
                a = (e.context2d._page(i.top), t.indexOf("#"));
              s = 0 <= a ? {
                name: t.substring(a + 1)
              } : {
                url: t
              }, e.link(r, n, i.right - i.left, i.bottom - i.top, s);
            },
            setName: function setName(t, i) {
              var s = e.context2d._wrapX(i.left),
                r = e.context2d._wrapY(i.top),
                n = e.context2d._page(i.top);
              this._nameMap[t] = {
                page: n,
                x: s,
                y: r
              };
            }
          }, s.annotations = e.annotations, e.context2d._pageBreakAt = function (t) {
            this.pageBreaks.push(t);
          }, e.context2d._gotoPage = function (t) {
            for (; e.internal.getNumberOfPages() < t;) e.addPage();
            e.setPage(t);
          }, "string" == typeof t) {
            t = t.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "");
            var a,
              o,
              h = document.createElement("iframe");
            document.body.appendChild(h), null != (a = h.contentDocument) && null != a || (a = h.contentWindow.document), a.open(), a.write(t), a.close(), r = a.body, o = a.body || {}, t = a.documentElement || {}, n = Math.max(o.scrollHeight, o.offsetHeight, t.clientHeight, t.scrollHeight, t.offsetHeight);
          } else o = (r = t).body || {}, n = Math.max(o.scrollHeight, o.offsetHeight, t.clientHeight, t.scrollHeight, t.offsetHeight);
          var l = {
            async: !0,
            allowTaint: !0,
            backgroundColor: "#ffffff",
            canvas: s,
            imageTimeout: 15e3,
            logging: !0,
            proxy: null,
            removeContainer: !0,
            foreignObjectRendering: !1,
            useCORS: !1,
            windowHeight: n = e.internal.pageSize.getHeight(),
            scrollY: n
          };
          e.context2d.pageWrapYEnabled = !0, e.context2d.pageWrapY = e.internal.pageSize.getHeight(), html2canvas(r, l).then(function (t) {
            i && (h && h.parentElement.removeChild(h), i(e));
          });
        } else alert("jsPDF canvas plugin not installed");
      }, window.tmp = html2pdf, function (t) {
        var e = t.BlobBuilder || t.WebKitBlobBuilder || t.MSBlobBuilder || t.MozBlobBuilder;
        t.URL = t.URL || t.webkitURL || function (t, e) {
          return (e = document.createElement("a")).href = t, e;
        };
        var i = t.Blob,
          s = URL.createObjectURL,
          r = URL.revokeObjectURL,
          n = t.Symbol && t.Symbol.toStringTag,
          a = !1,
          o = !1,
          h = !!t.ArrayBuffer,
          l = e && e.prototype.append && e.prototype.getBlob;
        try {
          a = 2 === new Blob(["ä"]).size, o = 2 === new Blob([new Uint8Array([1, 2])]).size;
        } catch (a) {}
        function A(t) {
          return t.map(function (t) {
            if (t.buffer instanceof ArrayBuffer) {
              var e = t.buffer;
              if (t.byteLength !== e.byteLength) {
                var i = new Uint8Array(t.byteLength);
                i.set(new Uint8Array(e, t.byteOffset, t.byteLength)), e = i.buffer;
              }
              return e;
            }
            return t;
          });
        }
        function c(t, i) {
          i = i || {};
          var s = new e();
          return A(t).forEach(function (t) {
            s.append(t);
          }), i.type ? s.getBlob(i.type) : s.getBlob();
        }
        function u(t, e) {
          return new i(A(t), e || {});
        }
        if (t.Blob && (c.prototype = Blob.prototype, u.prototype = Blob.prototype), n) try {
          File.prototype[n] = "File", Blob.prototype[n] = "Blob", FileReader.prototype[n] = "FileReader";
        } catch (a) {}
        function d() {
          var e = !!t.ActiveXObject || "-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style,
            i = t.XMLHttpRequest && t.XMLHttpRequest.prototype.send;
          e && i && (XMLHttpRequest.prototype.send = function (t) {
            t instanceof Blob && this.setRequestHeader("Content-Type", t.type), i.call(this, t);
          });
          try {
            new File([], "");
          } catch (e) {
            try {
              var s = new Function('class File extends Blob {constructor(chunks, name, opts) {opts = opts || {};super(chunks, opts || {});this.name = name;this.lastModifiedDate = opts.lastModified ? new Date(opts.lastModified) : new Date;this.lastModified = +this.lastModifiedDate;}};return new File([], ""), File')();
              t.File = s;
            } catch (e) {
              s = function s(t, e, i) {
                var s = new Blob(t, i),
                  r = i && void 0 !== i.lastModified ? new Date(i.lastModified) : new Date();
                return s.name = e, s.lastModifiedDate = r, s.lastModified = +r, s.toString = function () {
                  return "[object File]";
                }, n && (s[n] = "File"), s;
              }, t.File = s;
            }
          }
        }
        a ? (d(), t.Blob = o ? t.Blob : u) : l ? (d(), t.Blob = c) : function () {
          function e(t) {
            for (var e = [], i = 0; i < t.length; i++) {
              var s = t.charCodeAt(i);
              s < 128 ? e.push(s) : s < 2048 ? e.push(192 | s >> 6, 128 | 63 & s) : s < 55296 || 57344 <= s ? e.push(224 | s >> 12, 128 | s >> 6 & 63, 128 | 63 & s) : (i++, s = 65536 + ((1023 & s) << 10 | 1023 & t.charCodeAt(i)), e.push(240 | s >> 18, 128 | s >> 12 & 63, 128 | s >> 6 & 63, 128 | 63 & s));
            }
            return e;
          }
          function i(t) {
            var e, i, s, r, n, a;
            for (e = "", s = t.length, i = 0; i < s;) switch ((r = t[i++]) >> 4) {
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
              case 6:
              case 7:
                e += String.fromCharCode(r);
                break;
              case 12:
              case 13:
                n = t[i++], e += String.fromCharCode((31 & r) << 6 | 63 & n);
                break;
              case 14:
                n = t[i++], a = t[i++], e += String.fromCharCode((15 & r) << 12 | (63 & n) << 6 | (63 & a) << 0);
            }
            return e;
          }
          function n(t) {
            for (var e = new Array(t.byteLength), i = new Uint8Array(t), s = e.length; s--;) e[s] = i[s];
            return e;
          }
          function a(t) {
            for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", i = [], s = 0; s < t.length; s += 3) {
              var r = t[s],
                n = s + 1 < t.length,
                a = n ? t[s + 1] : 0,
                o = s + 2 < t.length,
                h = o ? t[s + 2] : 0,
                l = r >> 2,
                A = (3 & r) << 4 | a >> 4,
                c = (15 & a) << 2 | h >> 6,
                u = 63 & h;
              o || (u = 64, n || (c = 64)), i.push(e[l], e[A], e[c], e[u]);
            }
            return i.join("");
          }
          var o = Object.create || function (t) {
            function e() {}
            return e.prototype = t, new e();
          };
          if (h) var l = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
            A = ArrayBuffer.isView || function (t) {
              return t && -1 < l.indexOf(Object.prototype.toString.call(t));
            };
          function c(t, i) {
            for (var s = 0, r = (t = t || []).length; s < r; s++) {
              var a = t[s];
              a instanceof c ? t[s] = a._buffer : "string" == typeof a ? t[s] = e(a) : h && (ArrayBuffer.prototype.isPrototypeOf(a) || A(a)) ? t[s] = n(a) : h && (o = a) && DataView.prototype.isPrototypeOf(o) ? t[s] = n(a.buffer) : t[s] = e(String(a));
            }
            var o;
            this._buffer = [].concat.apply([], t), this.size = this._buffer.length, this.type = i && i.type || "";
          }
          function u(t, e, i) {
            var s = c.call(this, t, i = i || {}) || this;
            return s.name = e, s.lastModifiedDate = i.lastModified ? new Date(i.lastModified) : new Date(), s.lastModified = +s.lastModifiedDate, s;
          }
          if (c.prototype.slice = function (t, e, i) {
            return new c([this._buffer.slice(t || 0, e || this._buffer.length)], {
              type: i
            });
          }, c.prototype.toString = function () {
            return "[object Blob]";
          }, (u.prototype = o(c.prototype)).constructor = u, Object.setPrototypeOf) Object.setPrototypeOf(u, c);else try {
            u.__proto__ = c;
          } catch (o) {}
          function d() {
            if (!(this instanceof d)) throw new TypeError("Failed to construct 'FileReader': Please use the 'new' operator, this DOM object constructor cannot be called as a function.");
            var t = document.createDocumentFragment();
            this.addEventListener = t.addEventListener, this.dispatchEvent = function (e) {
              var i = this["on" + e.type];
              "function" == typeof i && i(e), t.dispatchEvent(e);
            }, this.removeEventListener = t.removeEventListener;
          }
          function f(t, e, i) {
            if (!(e instanceof c)) throw new TypeError("Failed to execute '" + i + "' on 'FileReader': parameter 1 is not of type 'Blob'.");
            t.result = "", setTimeout(function () {
              this.readyState = d.LOADING, t.dispatchEvent(new Event("load")), t.dispatchEvent(new Event("loadend"));
            });
          }
          u.prototype.toString = function () {
            return "[object File]";
          }, d.EMPTY = 0, d.LOADING = 1, d.DONE = 2, d.prototype.error = null, d.prototype.onabort = null, d.prototype.onerror = null, d.prototype.onload = null, d.prototype.onloadend = null, d.prototype.onloadstart = null, d.prototype.onprogress = null, d.prototype.readAsDataURL = function (t) {
            f(this, t, "readAsDataURL"), this.result = "data:" + t.type + ";base64," + a(t._buffer);
          }, d.prototype.readAsText = function (t) {
            f(this, t, "readAsText"), this.result = i(t._buffer);
          }, d.prototype.readAsArrayBuffer = function (t) {
            f(this, t, "readAsText"), this.result = t._buffer.slice();
          }, d.prototype.abort = function () {}, URL.createObjectURL = function (t) {
            return t instanceof c ? "data:" + t.type + ";base64," + a(t._buffer) : s.call(URL, t);
          }, URL.revokeObjectURL = function (t) {
            r && r.call(URL, t);
          };
          var p = t.XMLHttpRequest && t.XMLHttpRequest.prototype.send;
          p && (XMLHttpRequest.prototype.send = function (t) {
            t instanceof c ? (this.setRequestHeader("Content-Type", t.type), p.call(this, i(t._buffer))) : p.call(this, t);
          }), t.FileReader = d, t.File = u, t.Blob = c;
        }();
      }("undefined" != typeof self && self || "undefined" != typeof window && window || void 0 !== s && s || Function('return typeof this === "object" && this.content')() || Function("return this")());
      var pt,
        gt,
        wt,
        _mt,
        vt,
        bt,
        Bt,
        yt,
        Ct,
        Ft,
        xt,
        Nt,
        Et,
        Ut,
        Qt,
        Lt = Lt || function (t) {
          if (!(void 0 === t || "undefined" != typeof navigator && /MSIE [1-9]\./.test(navigator.userAgent))) {
            var e = t.document,
              i = function i() {
                return t.URL || t.webkitURL || t;
              },
              s = e.createElementNS("http://www.w3.org/1999/xhtml", "a"),
              r = ("download" in s),
              n = /constructor/i.test(t.HTMLElement) || t.safari,
              a = /CriOS\/[\d]+/.test(navigator.userAgent),
              o = t.setImmediate || t.setTimeout,
              h = function h(t) {
                o(function () {
                  throw t;
                }, 0);
              },
              l = function l(t) {
                setTimeout(function () {
                  "string" == typeof t ? i().revokeObjectURL(t) : t.remove();
                }, 4e4);
              },
              A = function A(t) {
                return /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type) ? new Blob([String.fromCharCode(65279), t], {
                  type: t.type
                }) : t;
              },
              c = function c(e, _c, u) {
                u || (e = A(e));
                var d,
                  f = this,
                  p = "application/octet-stream" === e.type,
                  g = function g() {
                    !function (t, e, i) {
                      for (var s = (e = [].concat(e)).length; s--;) {
                        var r = t["on" + e[s]];
                        if ("function" == typeof r) try {
                          r.call(t, t);
                        } catch (t) {
                          h(t);
                        }
                      }
                    }(f, "writestart progress write writeend".split(" "));
                  };
                if (f.readyState = f.INIT, r) return d = i().createObjectURL(e), void o(function () {
                  var t, e;
                  s.href = d, s.download = _c, t = s, e = new MouseEvent("click"), t.dispatchEvent(e), g(), l(d), f.readyState = f.DONE;
                }, 0);
                !function () {
                  if ((a || p && n) && t.FileReader) {
                    var s = new FileReader();
                    return s.onloadend = function () {
                      var e = a ? s.result : s.result.replace(/^data:[^;]*;/, "data:attachment/file;");
                      t.open(e, "_blank") || (t.location.href = e), e = void 0, f.readyState = f.DONE, g();
                    }, s.readAsDataURL(e), f.readyState = f.INIT;
                  }
                  d || (d = i().createObjectURL(e)), p ? t.location.href = d : t.open(d, "_blank") || (t.location.href = d), f.readyState = f.DONE, g(), l(d);
                }();
              },
              u = c.prototype;
            return "undefined" != typeof navigator && navigator.msSaveOrOpenBlob ? function (t, e, i) {
              return e = e || t.name || "download", i || (t = A(t)), navigator.msSaveOrOpenBlob(t, e);
            } : (u.abort = function () {}, u.readyState = u.INIT = 0, u.WRITING = 1, u.DONE = 2, u.error = u.onwritestart = u.onprogress = u.onwrite = u.onabort = u.onerror = u.onwriteend = null, function (t, e, i) {
              return new c(t, e || t.name || "download", i);
            });
          }
        }("undefined" != typeof self && self || "undefined" != typeof window && window || void 0);
      function St(t) {
        var e = 0;
        if (71 !== t[e++] || 73 !== t[e++] || 70 !== t[e++] || 56 !== t[e++] || 56 != (t[e++] + 1 & 253) || 97 !== t[e++]) throw "Invalid GIF 87a/89a header.";
        var i = t[e++] | t[e++] << 8,
          s = t[e++] | t[e++] << 8,
          r = t[e++],
          n = r >> 7,
          a = 1 << 1 + (7 & r);
        t[e++], t[e++];
        var o = null;
        n && (o = e, e += 3 * a);
        var h = !0,
          l = [],
          A = 0,
          c = null,
          u = 0,
          d = null;
        for (this.width = i, this.height = s; h && e < t.length;) switch (t[e++]) {
          case 33:
            switch (t[e++]) {
              case 255:
                if (11 !== t[e] || 78 == t[e + 1] && 69 == t[e + 2] && 84 == t[e + 3] && 83 == t[e + 4] && 67 == t[e + 5] && 65 == t[e + 6] && 80 == t[e + 7] && 69 == t[e + 8] && 50 == t[e + 9] && 46 == t[e + 10] && 48 == t[e + 11] && 3 == t[e + 12] && 1 == t[e + 13] && 0 == t[e + 16]) e += 14, d = t[e++] | t[e++] << 8, e++;else for (e += 12; 0 !== (F = t[e++]);) e += F;
                break;
              case 249:
                if (4 !== t[e++] || 0 !== t[e + 4]) throw "Invalid graphics extension block.";
                var f = t[e++];
                A = t[e++] | t[e++] << 8, c = t[e++], 0 == (1 & f) && (c = null), u = f >> 2 & 7, e++;
                break;
              case 254:
                for (; 0 !== (F = t[e++]);) e += F;
                break;
              default:
                throw "Unknown graphic control label: 0x" + t[e - 1].toString(16);
            }
            break;
          case 44:
            var p = t[e++] | t[e++] << 8,
              g = t[e++] | t[e++] << 8,
              w = t[e++] | t[e++] << 8,
              m = t[e++] | t[e++] << 8,
              v = t[e++],
              b = v >> 6 & 1,
              B = o,
              y = !1;
            v >> 7 && (y = !0, B = e, e += 3 * (1 << 1 + (7 & v)));
            var C = e;
            for (e++;;) {
              var F;
              if (0 === (F = t[e++])) break;
              e += F;
            }
            l.push({
              x: p,
              y: g,
              width: w,
              height: m,
              has_local_palette: y,
              palette_offset: B,
              data_offset: C,
              data_length: e - C,
              transparent_index: c,
              interlaced: !!b,
              delay: A,
              disposal: u
            });
            break;
          case 59:
            h = !1;
            break;
          default:
            throw "Unknown gif block: 0x" + t[e - 1].toString(16);
        }
        this.numFrames = function () {
          return l.length;
        }, this.loopCount = function () {
          return d;
        }, this.frameInfo = function (t) {
          if (t < 0 || t >= l.length) throw "Frame index out of range.";
          return l[t];
        }, this.decodeAndBlitFrameBGRA = function (e, s) {
          var r = this.frameInfo(e),
            n = r.width * r.height,
            a = new Uint8Array(n);
          kt(t, r.data_offset, a, n);
          var o = r.palette_offset,
            h = r.transparent_index;
          null === h && (h = 256);
          var l = r.width,
            A = i - l,
            c = l,
            u = 4 * (r.y * i + r.x),
            d = 4 * ((r.y + r.height) * i + r.x),
            f = u,
            p = 4 * A;
          !0 === r.interlaced && (p += 4 * (l + A) * 7);
          for (var g = 8, w = 0, m = a.length; w < m; ++w) {
            var v = a[w];
            if (0 === c && (c = l, d <= (f += p) && (p = A + 4 * (l + A) * (g - 1), f = u + (l + A) * (g << 1), g >>= 1)), v === h) f += 4;else {
              var b = t[o + 3 * v],
                B = t[o + 3 * v + 1],
                y = t[o + 3 * v + 2];
              s[f++] = y, s[f++] = B, s[f++] = b, s[f++] = 255;
            }
            --c;
          }
        }, this.decodeAndBlitFrameRGBA = function (e, s) {
          var r = this.frameInfo(e),
            n = r.width * r.height,
            a = new Uint8Array(n);
          kt(t, r.data_offset, a, n);
          var o = r.palette_offset,
            h = r.transparent_index;
          null === h && (h = 256);
          var l = r.width,
            A = i - l,
            c = l,
            u = 4 * (r.y * i + r.x),
            d = 4 * ((r.y + r.height) * i + r.x),
            f = u,
            p = 4 * A;
          !0 === r.interlaced && (p += 4 * (l + A) * 7);
          for (var g = 8, w = 0, m = a.length; w < m; ++w) {
            var v = a[w];
            if (0 === c && (c = l, d <= (f += p) && (p = A + 4 * (l + A) * (g - 1), f = u + (l + A) * (g << 1), g >>= 1)), v === h) f += 4;else {
              var b = t[o + 3 * v],
                B = t[o + 3 * v + 1],
                y = t[o + 3 * v + 2];
              s[f++] = b, s[f++] = B, s[f++] = y, s[f++] = 255;
            }
            --c;
          }
        };
      }
      function kt(t, e, i, s) {
        for (var r = t[e++], n = 1 << r, a = n + 1, o = a + 1, h = r + 1, l = (1 << h) - 1, A = 0, c = 0, u = 0, d = t[e++], f = new Int32Array(4096), p = null;;) {
          for (; A < 16 && 0 !== d;) c |= t[e++] << A, A += 8, 1 === d ? d = t[e++] : --d;
          if (A < h) break;
          var g = c & l;
          if (c >>= h, A -= h, g !== n) {
            if (g === a) break;
            for (var w = g < o ? g : p, m = 0, v = w; n < v;) v = f[v] >> 8, ++m;
            var b = v;
            if (s < u + m + (w !== g ? 1 : 0)) return void console.log("Warning, gif stream longer than expected.");
            i[u++] = b;
            var B = u += m;
            for (w !== g && (i[u++] = b), v = w; m--;) v = f[v], i[--B] = 255 & v, v >>= 8;
            null !== p && o < 4096 && (f[o++] = p << 8 | b, l + 1 <= o && h < 12 && (++h, l = l << 1 | 1)), p = g;
          } else o = a + 1, l = (1 << (h = r + 1)) - 1, p = null;
        }
        return u !== s && console.log("Warning, gif stream shorter than expected."), i;
      }
      try {
        e.GifWriter = function (t, e, i, s) {
          var r = 0,
            n = void 0 === (s = void 0 === s ? {} : s).loop ? null : s.loop,
            a = void 0 === s.palette ? null : s.palette;
          if (e <= 0 || i <= 0 || 65535 < e || 65535 < i) throw "Width/Height invalid.";
          function o(t) {
            var e = t.length;
            if (e < 2 || 256 < e || e & e - 1) throw "Invalid code/color length, must be power of 2 and 2 .. 256.";
            return e;
          }
          t[r++] = 71, t[r++] = 73, t[r++] = 70, t[r++] = 56, t[r++] = 57, t[r++] = 97;
          var h = 0,
            l = 0;
          if (null !== a) {
            for (var A = o(a); A >>= 1;) ++h;
            if (A = 1 << h, --h, void 0 !== s.background) {
              if (A <= (l = s.background)) throw "Background index out of range.";
              if (0 === l) throw "Background index explicitly passed as 0.";
            }
          }
          if (t[r++] = 255 & e, t[r++] = e >> 8 & 255, t[r++] = 255 & i, t[r++] = i >> 8 & 255, t[r++] = (null !== a ? 128 : 0) | h, t[r++] = l, t[r++] = 0, null !== a) for (var c = 0, u = a.length; c < u; ++c) {
            var d = a[c];
            t[r++] = d >> 16 & 255, t[r++] = d >> 8 & 255, t[r++] = 255 & d;
          }
          if (null !== n) {
            if (n < 0 || 65535 < n) throw "Loop count invalid.";
            t[r++] = 33, t[r++] = 255, t[r++] = 11, t[r++] = 78, t[r++] = 69, t[r++] = 84, t[r++] = 83, t[r++] = 67, t[r++] = 65, t[r++] = 80, t[r++] = 69, t[r++] = 50, t[r++] = 46, t[r++] = 48, t[r++] = 3, t[r++] = 1, t[r++] = 255 & n, t[r++] = n >> 8 & 255, t[r++] = 0;
          }
          var f = !1;
          this.addFrame = function (e, i, s, n, h, l) {
            if (!0 === f && (--r, f = !1), l = void 0 === l ? {} : l, e < 0 || i < 0 || 65535 < e || 65535 < i) throw "x/y invalid.";
            if (s <= 0 || n <= 0 || 65535 < s || 65535 < n) throw "Width/Height invalid.";
            if (h.length < s * n) throw "Not enough pixels for the frame size.";
            var A = !0,
              c = l.palette;
            if (null == c && (A = !1, c = a), null == c) throw "Must supply either a local or global palette.";
            for (var u = o(c), d = 0; u >>= 1;) ++d;
            u = 1 << d;
            var p = void 0 === l.delay ? 0 : l.delay,
              g = void 0 === l.disposal ? 0 : l.disposal;
            if (g < 0 || 3 < g) throw "Disposal out of range.";
            var w = !1,
              m = 0;
            if (void 0 !== l.transparent && null !== l.transparent && (w = !0, (m = l.transparent) < 0 || u <= m)) throw "Transparent color index.";
            if ((0 !== g || w || 0 !== p) && (t[r++] = 33, t[r++] = 249, t[r++] = 4, t[r++] = g << 2 | (!0 === w ? 1 : 0), t[r++] = 255 & p, t[r++] = p >> 8 & 255, t[r++] = m, t[r++] = 0), t[r++] = 44, t[r++] = 255 & e, t[r++] = e >> 8 & 255, t[r++] = 255 & i, t[r++] = i >> 8 & 255, t[r++] = 255 & s, t[r++] = s >> 8 & 255, t[r++] = 255 & n, t[r++] = n >> 8 & 255, t[r++] = !0 === A ? 128 | d - 1 : 0, !0 === A) for (var v = 0, b = c.length; v < b; ++v) {
              var B = c[v];
              t[r++] = B >> 16 & 255, t[r++] = B >> 8 & 255, t[r++] = 255 & B;
            }
            r = function (t, e, i, s) {
              t[e++] = i;
              var r = e++,
                n = 1 << i,
                a = n - 1,
                o = n + 1,
                h = o + 1,
                l = i + 1,
                A = 0,
                c = 0;
              function u(i) {
                for (; i <= A;) t[e++] = 255 & c, c >>= 8, A -= 8, e === r + 256 && (t[r] = 255, r = e++);
              }
              function d(t) {
                c |= t << A, A += l, u(8);
              }
              var f = s[0] & a,
                p = {};
              d(n);
              for (var g = 1, w = s.length; g < w; ++g) {
                var m = s[g] & a,
                  v = f << 8 | m,
                  b = p[v];
                if (void 0 === b) {
                  for (c |= f << A, A += l; 8 <= A;) t[e++] = 255 & c, c >>= 8, A -= 8, e === r + 256 && (t[r] = 255, r = e++);
                  4096 === h ? (d(n), h = o + 1, l = i + 1, p = {}) : (1 << l <= h && ++l, p[v] = h++), f = m;
                } else f = b;
              }
              return d(f), d(o), u(1), r + 1 === e ? t[r] = 0 : (t[r] = e - r - 1, t[e++] = 0), e;
            }(t, r, d < 2 ? 2 : d, h);
          }, this.end = function () {
            return !1 === f && (t[r++] = 59, f = !0), r;
          };
        }, e.GifReader = St;
      } catch (n) {}
      function Ht(t) {
        var e,
          i,
          s,
          r,
          n,
          a = Math.floor,
          o = new Array(64),
          h = new Array(64),
          l = new Array(64),
          A = new Array(64),
          c = new Array(65535),
          u = new Array(65535),
          d = new Array(64),
          f = new Array(64),
          p = [],
          g = 0,
          w = 7,
          m = new Array(64),
          v = new Array(64),
          b = new Array(64),
          B = new Array(256),
          y = new Array(2048),
          C = [0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12, 17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32, 39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50, 56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63],
          F = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
          x = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
          N = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125],
          E = [1, 2, 3, 0, 4, 17, 5, 18, 33, 49, 65, 6, 19, 81, 97, 7, 34, 113, 20, 50, 129, 145, 161, 8, 35, 66, 177, 193, 21, 82, 209, 240, 36, 51, 98, 114, 130, 9, 10, 22, 23, 24, 25, 26, 37, 38, 39, 40, 41, 42, 52, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250],
          U = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
          Q = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
          L = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119],
          S = [0, 1, 2, 3, 17, 4, 5, 33, 49, 6, 18, 65, 81, 7, 97, 113, 19, 34, 50, 129, 8, 20, 66, 145, 161, 177, 193, 9, 35, 51, 82, 240, 21, 98, 114, 209, 10, 22, 36, 52, 225, 37, 241, 23, 24, 25, 26, 38, 39, 40, 41, 42, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 130, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 226, 227, 228, 229, 230, 231, 232, 233, 234, 242, 243, 244, 245, 246, 247, 248, 249, 250];
        function k(t, e) {
          for (var i = 0, s = 0, r = new Array(), n = 1; n <= 16; n++) {
            for (var a = 1; a <= t[n]; a++) r[e[s]] = [], r[e[s]][0] = i, r[e[s]][1] = n, s++, i++;
            i *= 2;
          }
          return r;
        }
        function H(t) {
          for (var e = t[0], i = t[1] - 1; 0 <= i;) e & 1 << i && (g |= 1 << w), i--, --w < 0 && (255 == g ? (I(255), I(0)) : I(g), w = 7, g = 0);
        }
        function I(t) {
          p.push(t);
        }
        function O(t) {
          I(t >> 8 & 255), I(255 & t);
        }
        function T(t, e, i, s, r) {
          for (var n, a = r[0], o = r[240], h = function (t, e) {
              var i,
                s,
                r,
                n,
                a,
                o,
                h,
                l,
                A,
                c,
                u = 0;
              for (A = 0; A < 8; ++A) {
                i = t[u], s = t[u + 1], r = t[u + 2], n = t[u + 3], a = t[u + 4], o = t[u + 5], h = t[u + 6];
                var f = i + (l = t[u + 7]),
                  p = i - l,
                  g = s + h,
                  w = s - h,
                  m = r + o,
                  v = r - o,
                  b = n + a,
                  B = n - a,
                  y = f + b,
                  C = f - b,
                  F = g + m,
                  x = g - m;
                t[u] = y + F, t[u + 4] = y - F;
                var N = .707106781 * (x + C);
                t[u + 2] = C + N, t[u + 6] = C - N;
                var E = .382683433 * ((y = B + v) - (x = w + p)),
                  U = .5411961 * y + E,
                  Q = 1.306562965 * x + E,
                  L = .707106781 * (F = v + w),
                  S = p + L,
                  k = p - L;
                t[u + 5] = k + U, t[u + 3] = k - U, t[u + 1] = S + Q, t[u + 7] = S - Q, u += 8;
              }
              for (A = u = 0; A < 8; ++A) {
                i = t[u], s = t[u + 8], r = t[u + 16], n = t[u + 24], a = t[u + 32], o = t[u + 40], h = t[u + 48];
                var H = i + (l = t[u + 56]),
                  I = i - l,
                  O = s + h,
                  T = s - h,
                  P = r + o,
                  j = r - o,
                  M = n + a,
                  D = n - a,
                  R = H + M,
                  _ = H - M,
                  z = O + P,
                  K = O - P;
                t[u] = R + z, t[u + 32] = R - z;
                var q = .707106781 * (K + _);
                t[u + 16] = _ + q, t[u + 48] = _ - q;
                var V = .382683433 * ((R = D + j) - (K = T + I)),
                  J = .5411961 * R + V,
                  G = 1.306562965 * K + V,
                  X = .707106781 * (z = j + T),
                  W = I + X,
                  Y = I - X;
                t[u + 40] = Y + J, t[u + 24] = Y - J, t[u + 8] = W + G, t[u + 56] = W - G, u++;
              }
              for (A = 0; A < 64; ++A) c = t[A] * e[A], d[A] = 0 < c ? c + .5 | 0 : c - .5 | 0;
              return d;
            }(t, e), l = 0; l < 64; ++l) f[C[l]] = h[l];
          var A = f[0] - i;
          i = f[0], 0 == A ? H(s[0]) : (H(s[u[n = 32767 + A]]), H(c[n]));
          for (var p = 63; 0 < p && 0 == f[p]; p--);
          if (0 == p) return H(a), i;
          for (var g, w = 1; w <= p;) {
            for (var m = w; 0 == f[w] && w <= p; ++w);
            var v = w - m;
            if (16 <= v) {
              g = v >> 4;
              for (var b = 1; b <= g; ++b) H(o);
              v &= 15;
            }
            n = 32767 + f[w], H(r[(v << 4) + u[n]]), H(c[n]), w++;
          }
          return 63 != p && H(a), i;
        }
        function P(t) {
          t <= 0 && (t = 1), 100 < t && (t = 100), n != t && (function (t) {
            for (var e = [16, 11, 10, 16, 24, 40, 51, 61, 12, 12, 14, 19, 26, 58, 60, 55, 14, 13, 16, 24, 40, 57, 69, 56, 14, 17, 22, 29, 51, 87, 80, 62, 18, 22, 37, 56, 68, 109, 103, 77, 24, 35, 55, 64, 81, 104, 113, 92, 49, 64, 78, 87, 103, 121, 120, 101, 72, 92, 95, 98, 112, 100, 103, 99], i = 0; i < 64; i++) {
              var s = a((e[i] * t + 50) / 100);
              s < 1 ? s = 1 : 255 < s && (s = 255), o[C[i]] = s;
            }
            for (var r = [17, 18, 24, 47, 99, 99, 99, 99, 18, 21, 26, 66, 99, 99, 99, 99, 24, 26, 56, 99, 99, 99, 99, 99, 47, 66, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99], n = 0; n < 64; n++) {
              var c = a((r[n] * t + 50) / 100);
              c < 1 ? c = 1 : 255 < c && (c = 255), h[C[n]] = c;
            }
            for (var u = [1, 1.387039845, 1.306562965, 1.175875602, 1, .785694958, .5411961, .275899379], d = 0, f = 0; f < 8; f++) for (var p = 0; p < 8; p++) l[d] = 1 / (o[C[d]] * u[f] * u[p] * 8), A[d] = 1 / (h[C[d]] * u[f] * u[p] * 8), d++;
          }(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), n = t);
        }
        this.encode = function (t, n) {
          var a, c;
          new Date().getTime(), n && P(n), p = new Array(), g = 0, w = 7, O(65496), O(65504), O(16), I(74), I(70), I(73), I(70), I(0), I(1), I(1), I(0), O(1), O(1), I(0), I(0), function () {
            O(65499), O(132), I(0);
            for (var t = 0; t < 64; t++) I(o[t]);
            I(1);
            for (var e = 0; e < 64; e++) I(h[e]);
          }(), a = t.width, c = t.height, O(65472), O(17), I(8), O(c), O(a), I(3), I(1), I(17), I(0), I(2), I(17), I(1), I(3), I(17), I(1), function () {
            O(65476), O(418), I(0);
            for (var t = 0; t < 16; t++) I(F[t + 1]);
            for (var e = 0; e <= 11; e++) I(x[e]);
            I(16);
            for (var i = 0; i < 16; i++) I(N[i + 1]);
            for (var s = 0; s <= 161; s++) I(E[s]);
            I(1);
            for (var r = 0; r < 16; r++) I(U[r + 1]);
            for (var n = 0; n <= 11; n++) I(Q[n]);
            I(17);
            for (var a = 0; a < 16; a++) I(L[a + 1]);
            for (var o = 0; o <= 161; o++) I(S[o]);
          }(), O(65498), O(12), I(3), I(1), I(0), I(2), I(17), I(3), I(17), I(0), I(63), I(0);
          var u = 0,
            d = 0,
            f = 0;
          g = 0, w = 7, this.encode.displayName = "_encode_";
          for (var B, C, k, j, M, D, R, _, z, K = t.data, q = t.width, V = t.height, J = 4 * q, G = 0; G < V;) {
            for (B = 0; B < J;) {
              for (D = M = J * G + B, R = -1, z = _ = 0; z < 64; z++) D = M + (_ = z >> 3) * J + (R = 4 * (7 & z)), V <= G + _ && (D -= J * (G + 1 + _ - V)), J <= B + R && (D -= B + R - J + 4), C = K[D++], k = K[D++], j = K[D++], m[z] = (y[C] + y[k + 256 >> 0] + y[j + 512 >> 0] >> 16) - 128, v[z] = (y[C + 768 >> 0] + y[k + 1024 >> 0] + y[j + 1280 >> 0] >> 16) - 128, b[z] = (y[C + 1280 >> 0] + y[k + 1536 >> 0] + y[j + 1792 >> 0] >> 16) - 128;
              u = T(m, l, u, e, s), d = T(v, A, d, i, r), f = T(b, A, f, i, r), B += 32;
            }
            G += 8;
          }
          if (0 <= w) {
            var X = [];
            X[1] = w + 1, X[0] = (1 << w + 1) - 1, H(X);
          }
          return O(65497), new Uint8Array(p);
        }, new Date().getTime(), t || (t = 50), function () {
          for (var t = String.fromCharCode, e = 0; e < 256; e++) B[e] = t(e);
        }(), e = k(F, x), i = k(U, Q), s = k(N, E), r = k(L, S), function () {
          for (var t = 1, e = 2, i = 1; i <= 15; i++) {
            for (var s = t; s < e; s++) u[32767 + s] = i, c[32767 + s] = [], c[32767 + s][1] = i, c[32767 + s][0] = s;
            for (var r = -(e - 1); r <= -t; r++) u[32767 + r] = i, c[32767 + r] = [], c[32767 + r][1] = i, c[32767 + r][0] = e - 1 + r;
            t <<= 1, e <<= 1;
          }
        }(), function () {
          for (var t = 0; t < 256; t++) y[t] = 19595 * t, y[t + 256 >> 0] = 38470 * t, y[t + 512 >> 0] = 7471 * t + 32768, y[t + 768 >> 0] = -11059 * t, y[t + 1024 >> 0] = -21709 * t, y[t + 1280 >> 0] = 32768 * t + 8421375, y[t + 1536 >> 0] = -27439 * t, y[t + 1792 >> 0] = -5329 * t;
        }(), P(t), new Date().getTime();
      }
      function It(t, e) {
        if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === ["BM", "BA", "CI", "CP", "IC", "PT"].indexOf(this.flag)) throw new Error("Invalid BMP File");
        this.parseHeader(), this.parseBGR();
      }
      window.tmp = St, ft.API.adler32cs = (bt = "function" == typeof ArrayBuffer && "function" == typeof Uint8Array, Bt = null, yt = function () {
        if (!bt) return function () {
          return !1;
        };
        try {
          var t = {};
          "function" == typeof t.Buffer && (Bt = t.Buffer);
        } catch (t) {}
        return function (t) {
          return t instanceof ArrayBuffer || null !== Bt && t instanceof Bt;
        };
      }(), Ct = null !== Bt ? function (t) {
        return new Bt(t, "utf8").toString("binary");
      } : function (t) {
        return unescape(encodeURIComponent(t));
      }, Ft = function Ft(t, e) {
        for (var i = 65535 & t, s = t >>> 16, r = 0, n = e.length; r < n; r++) s = (s + (i = (i + (255 & e.charCodeAt(r))) % 65521)) % 65521;
        return (s << 16 | i) >>> 0;
      }, xt = function xt(t, e) {
        for (var i = 65535 & t, s = t >>> 16, r = 0, n = e.length; r < n; r++) s = (s + (i = (i + e[r]) % 65521)) % 65521;
        return (s << 16 | i) >>> 0;
      }, Et = (Nt = {}).Adler32 = (((vt = (_mt = function mt(t) {
        if (!(this instanceof _mt)) throw new TypeError("Constructor cannot called be as a function.");
        if (!isFinite(t = null == t ? 1 : +t)) throw new Error("First arguments needs to be a finite number.");
        this.checksum = t >>> 0;
      }).prototype = {}).constructor = _mt).from = ((pt = function pt(t) {
        if (!(this instanceof _mt)) throw new TypeError("Constructor cannot called be as a function.");
        if (null == t) throw new Error("First argument needs to be a string.");
        this.checksum = Ft(1, t.toString());
      }).prototype = vt, pt), _mt.fromUtf8 = ((gt = function gt(t) {
        if (!(this instanceof _mt)) throw new TypeError("Constructor cannot called be as a function.");
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = Ct(t.toString());
        this.checksum = Ft(1, e);
      }).prototype = vt, gt), bt && (_mt.fromBuffer = ((wt = function wt(t) {
        if (!(this instanceof _mt)) throw new TypeError("Constructor cannot called be as a function.");
        if (!yt(t)) throw new Error("First argument needs to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return this.checksum = xt(1, e);
      }).prototype = vt, wt)), vt.update = function (t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        return t = t.toString(), this.checksum = Ft(this.checksum, t);
      }, vt.updateUtf8 = function (t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = Ct(t.toString());
        return this.checksum = Ft(this.checksum, e);
      }, bt && (vt.updateBuffer = function (t) {
        if (!yt(t)) throw new Error("First argument needs to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return this.checksum = xt(this.checksum, e);
      }), vt.clone = function () {
        return new Et(this.checksum);
      }, _mt), Nt.from = function (t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        return Ft(1, t.toString());
      }, Nt.fromUtf8 = function (t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = Ct(t.toString());
        return Ft(1, e);
      }, bt && (Nt.fromBuffer = function (t) {
        if (!yt(t)) throw new Error("First argument need to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return xt(1, e);
      }), Nt), function (t) {
        t.__bidiEngine__ = t.prototype.__bidiEngine__ = function (t) {
          var i,
            s,
            r,
            n,
            a,
            o,
            h,
            l = e,
            A = [[0, 3, 0, 1, 0, 0, 0], [0, 3, 0, 1, 2, 2, 0], [0, 3, 0, 17, 2, 0, 1], [0, 3, 5, 5, 4, 1, 0], [0, 3, 21, 21, 4, 0, 1], [0, 3, 5, 5, 4, 2, 0]],
            c = [[2, 0, 1, 1, 0, 1, 0], [2, 0, 1, 1, 0, 2, 0], [2, 0, 2, 1, 3, 2, 0], [2, 0, 2, 33, 3, 1, 1]],
            u = {
              L: 0,
              R: 1,
              EN: 2,
              AN: 3,
              N: 4,
              B: 5,
              S: 6
            },
            d = {
              0: 0,
              5: 1,
              6: 2,
              7: 3,
              32: 4,
              251: 5,
              254: 6,
              255: 7
            },
            f = ["(", ")", "(", "<", ">", "<", "[", "]", "[", "{", "}", "{", "«", "»", "«", "‹", "›", "‹", "�?�", "�?�", "�?�", "�?�", "�?�", "�?�", "�?", "₎", "�?", "≤", "≥", "≤", "〈", "〉", "〈", "﹙", "﹚", "﹙", "﹛", "﹜", "﹛", "�?", "﹞", "�?", "﹤", "﹥", "﹤"],
            p = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/),
            g = !1,
            w = 0;
          this.__bidiEngine__ = {};
          var m = function m(t) {
              var e = t.charCodeAt(),
                i = e >> 8,
                s = d[i];
              return void 0 !== s ? l[256 * s + (255 & e)] : 252 === i || 253 === i ? "AL" : p.test(i) ? "L" : 8 === i ? "R" : "N";
            },
            v = function v(t) {
              for (var e, i = 0; i < t.length; i++) {
                if ("L" === (e = m(t.charAt(i)))) return !1;
                if ("R" === e) return !0;
              }
              return !1;
            },
            b = function b(t, e, a, o) {
              var h,
                l,
                A,
                c,
                u = e[o];
              switch (u) {
                case "L":
                case "R":
                  g = !1;
                  break;
                case "N":
                case "AN":
                  break;
                case "EN":
                  g && (u = "AN");
                  break;
                case "AL":
                  g = !0, u = "R";
                  break;
                case "WS":
                  u = "N";
                  break;
                case "CS":
                  o < 1 || o + 1 >= e.length || "EN" !== (h = a[o - 1]) && "AN" !== h || "EN" !== (l = e[o + 1]) && "AN" !== l ? u = "N" : g && (l = "AN"), u = l === h ? l : "N";
                  break;
                case "ES":
                  u = "EN" === (h = 0 < o ? a[o - 1] : "B") && o + 1 < e.length && "EN" === e[o + 1] ? "EN" : "N";
                  break;
                case "ET":
                  if (0 < o && "EN" === a[o - 1]) {
                    u = "EN";
                    break;
                  }
                  if (g) {
                    u = "N";
                    break;
                  }
                  for (A = o + 1, c = e.length; A < c && "ET" === e[A];) A++;
                  u = A < c && "EN" === e[A] ? "EN" : "N";
                  break;
                case "NSM":
                  if (r && !n) {
                    for (c = e.length, A = o + 1; A < c && "NSM" === e[A];) A++;
                    if (A < c) {
                      var d = t[o],
                        f = 1425 <= d && d <= 2303 || 64286 === d;
                      if (h = e[A], f && ("R" === h || "AL" === h)) {
                        u = "R";
                        break;
                      }
                    }
                  }
                  u = o < 1 || "B" === (h = e[o - 1]) ? "N" : a[o - 1];
                  break;
                case "B":
                  i = !(g = !1), u = w;
                  break;
                case "S":
                  s = !0, u = "N";
                  break;
                case "LRE":
                case "RLE":
                case "LRO":
                case "RLO":
                case "PDF":
                  g = !1;
                  break;
                case "BN":
                  u = "N";
              }
              return u;
            },
            B = function B(t, e, i) {
              var s = t.split("");
              return i && y(s, i, {
                hiLevel: w
              }), s.reverse(), e && e.reverse(), s.join("");
            },
            y = function y(t, e, r) {
              var n,
                a,
                o,
                h,
                l,
                d = -1,
                f = t.length,
                p = 0,
                v = [],
                B = w ? c : A,
                y = [];
              for (s = i = g = !1, a = 0; a < f; a++) y[a] = m(t[a]);
              for (o = 0; o < f; o++) {
                if (l = p, v[o] = b(t, y, v, o), n = 240 & (p = B[l][u[v[o]]]), p &= 15, e[o] = h = B[p][5], 0 < n) if (16 === n) {
                  for (a = d; a < o; a++) e[a] = 1;
                  d = -1;
                } else d = -1;
                if (B[p][6]) -1 === d && (d = o);else if (-1 < d) {
                  for (a = d; a < o; a++) e[a] = h;
                  d = -1;
                }
                "B" === y[o] && (e[o] = 0), r.hiLevel |= h;
              }
              s && function (t, e, i) {
                for (var s = 0; s < i; s++) if ("S" === t[s]) {
                  e[s] = w;
                  for (var r = s - 1; 0 <= r && "WS" === t[r]; r--) e[r] = w;
                }
              }(y, e, f);
            },
            C = function C(t, e, s, r, n) {
              if (!(n.hiLevel < t)) {
                if (1 === t && 1 === w && !i) return e.reverse(), void (s && s.reverse());
                for (var a, o, h, l, A = e.length, c = 0; c < A;) {
                  if (r[c] >= t) {
                    for (h = c + 1; h < A && r[h] >= t;) h++;
                    for (l = c, o = h - 1; l < o; l++, o--) a = e[l], e[l] = e[o], e[o] = a, s && (a = s[l], s[l] = s[o], s[o] = a);
                    c = h;
                  }
                  c++;
                }
              }
            },
            F = function F(t, e, i) {
              var s = t.split(""),
                r = {
                  hiLevel: w
                };
              return i || (i = []), y(s, i, r), function (t, e, i) {
                if (0 !== i.hiLevel && h) for (var s, r = 0; r < t.length; r++) 1 === e[r] && 0 <= (s = f.indexOf(t[r])) && (t[r] = f[s + 1]);
              }(s, i, r), C(2, s, e, i, r), C(1, s, e, i, r), s.join("");
            };
          return this.__bidiEngine__.doBidiReorder = function (t, e, i) {
            if (function (t, e) {
              if (e) for (var i = 0; i < t.length; i++) e[i] = i;
              void 0 === n && (n = v(t)), void 0 === o && (o = v(t));
            }(t, e), r || !a || o) {
              if (r && a && n ^ o) w = n ? 1 : 0, t = B(t, e, i);else if (!r && a && o) w = n ? 1 : 0, t = F(t, e, i), t = B(t, e);else if (!r || n || a || o) {
                if (r && !a && n ^ o) t = B(t, e), t = n ? (w = 0, F(t, e, i)) : (w = 1, t = F(t, e, i), B(t, e));else if (r && n && !a && o) w = 1, t = F(t, e, i), t = B(t, e);else if (!r && !a && n ^ o) {
                  var s = h;
                  n ? (w = 1, t = F(t, e, i), w = 0, h = !1, t = F(t, e, i), h = s) : (w = 0, t = F(t, e, i), t = B(t, e), h = !(w = 1), t = F(t, e, i), h = s, t = B(t, e));
                }
              } else w = 0, t = F(t, e, i);
            } else w = n ? 1 : 0, t = F(t, e, i);
            return t;
          }, this.__bidiEngine__.setOptions = function (t) {
            t && (r = t.isInputVisual, a = t.isOutputVisual, n = t.isInputRtl, o = t.isOutputRtl, h = t.isSymmetricSwapping);
          }, this.__bidiEngine__.setOptions(t), this.__bidiEngine__;
        };
        var e = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "N", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "L", "N", "N", "BN", "N", "N", "ET", "ET", "EN", "EN", "N", "L", "N", "N", "N", "EN", "L", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "N", "N", "N", "N", "N", "ET", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "NSM", "R", "NSM", "NSM", "R", "NSM", "NSM", "R", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AN", "AN", "AN", "AN", "AN", "AN", "N", "N", "AL", "ET", "ET", "AL", "CS", "AL", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "N", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "R", "N", "N", "N", "N", "R", "N", "N", "N", "N", "N", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "BN", "BN", "BN", "L", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "B", "LRE", "RLE", "PDF", "LRO", "RLO", "CS", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "BN", "BN", "BN", "BN", "BN", "N", "LRI", "RLI", "FSI", "PDI", "BN", "BN", "BN", "BN", "BN", "BN", "EN", "L", "N", "N", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "L", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "R", "NSM", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "ES", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "R", "R", "R", "R", "R", "N", "R", "N", "R", "R", "N", "R", "R", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "CS", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "ET", "N", "N", "ES", "ES", "N", "N", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "BN", "N", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "N", "N", "N", "ET", "ET", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N"],
          i = new t.__bidiEngine__({
            isInputVisual: !0
          });
        t.API.events.push(["postProcessText", function (t) {
          var e = t.text,
            s = (t.x, t.y, t.options || {}),
            r = (t.mutex, s.lang, []);
          if ("[object Array]" === Object.prototype.toString.call(e)) {
            var n = 0;
            for (r = [], n = 0; n < e.length; n += 1) "[object Array]" === Object.prototype.toString.call(e[n]) ? r.push([i.doBidiReorder(e[n][0]), e[n][1], e[n][2]]) : r.push([i.doBidiReorder(e[n])]);
            t.text = r;
          } else t.text = i.doBidiReorder(e);
        }]);
      }(ft), window.tmp = Ht, It.prototype.parseHeader = function () {
        if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
          var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
          this.palette = new Array(t);
          for (var e = 0; e < t; e++) {
            var i = this.datav.getUint8(this.pos++, !0),
              s = this.datav.getUint8(this.pos++, !0),
              r = this.datav.getUint8(this.pos++, !0),
              n = this.datav.getUint8(this.pos++, !0);
            this.palette[e] = {
              red: r,
              green: s,
              blue: i,
              quad: n
            };
          }
        }
        this.height < 0 && (this.height *= -1, this.bottom_up = !1);
      }, It.prototype.parseBGR = function () {
        this.pos = this.offset;
        try {
          var t = "bit" + this.bitPP,
            e = this.width * this.height * 4;
          this.data = new Uint8Array(e), this[t]();
        } catch (t) {
          console.log("bit decode error:" + t);
        }
      }, It.prototype.bit1 = function () {
        var t = Math.ceil(this.width / 8),
          e = t % 4,
          i = 0 <= this.height ? this.height - 1 : -this.height;
        for (i = this.height - 1; 0 <= i; i--) {
          for (var s = this.bottom_up ? i : this.height - 1 - i, r = 0; r < t; r++) for (var n = this.datav.getUint8(this.pos++, !0), a = s * this.width * 4 + 8 * r * 4, o = 0; o < 8 && 8 * r + o < this.width; o++) {
            var h = this.palette[n >> 7 - o & 1];
            this.data[a + 4 * o] = h.blue, this.data[a + 4 * o + 1] = h.green, this.data[a + 4 * o + 2] = h.red, this.data[a + 4 * o + 3] = 255;
          }
          0 != e && (this.pos += 4 - e);
        }
      }, It.prototype.bit4 = function () {
        for (var t = Math.ceil(this.width / 2), e = t % 4, i = this.height - 1; 0 <= i; i--) {
          for (var s = this.bottom_up ? i : this.height - 1 - i, r = 0; r < t; r++) {
            var n = this.datav.getUint8(this.pos++, !0),
              a = s * this.width * 4 + 2 * r * 4,
              o = n >> 4,
              h = 15 & n,
              l = this.palette[o];
            if (this.data[a] = l.blue, this.data[a + 1] = l.green, this.data[a + 2] = l.red, this.data[a + 3] = 255, 2 * r + 1 >= this.width) break;
            l = this.palette[h], this.data[a + 4] = l.blue, this.data[a + 4 + 1] = l.green, this.data[a + 4 + 2] = l.red, this.data[a + 4 + 3] = 255;
          }
          0 != e && (this.pos += 4 - e);
        }
      }, It.prototype.bit8 = function () {
        for (var t = this.width % 4, e = this.height - 1; 0 <= e; e--) {
          for (var i = this.bottom_up ? e : this.height - 1 - e, s = 0; s < this.width; s++) {
            var r = this.datav.getUint8(this.pos++, !0),
              n = i * this.width * 4 + 4 * s;
            if (r < this.palette.length) {
              var a = this.palette[r];
              this.data[n] = a.red, this.data[n + 1] = a.green, this.data[n + 2] = a.blue, this.data[n + 3] = 255;
            } else this.data[n] = 255, this.data[n + 1] = 255, this.data[n + 2] = 255, this.data[n + 3] = 255;
          }
          0 != t && (this.pos += 4 - t);
        }
      }, It.prototype.bit15 = function () {
        for (var t = this.width % 3, e = parseInt("11111", 2), i = this.height - 1; 0 <= i; i--) {
          for (var s = this.bottom_up ? i : this.height - 1 - i, r = 0; r < this.width; r++) {
            var n = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var a = (n & e) / e * 255 | 0,
              o = (n >> 5 & e) / e * 255 | 0,
              h = (n >> 10 & e) / e * 255 | 0,
              l = n >> 15 ? 255 : 0,
              A = s * this.width * 4 + 4 * r;
            this.data[A] = h, this.data[A + 1] = o, this.data[A + 2] = a, this.data[A + 3] = l;
          }
          this.pos += t;
        }
      }, It.prototype.bit16 = function () {
        for (var t = this.width % 3, e = parseInt("11111", 2), i = parseInt("111111", 2), s = this.height - 1; 0 <= s; s--) {
          for (var r = this.bottom_up ? s : this.height - 1 - s, n = 0; n < this.width; n++) {
            var a = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var o = (a & e) / e * 255 | 0,
              h = (a >> 5 & i) / i * 255 | 0,
              l = (a >> 11) / e * 255 | 0,
              A = r * this.width * 4 + 4 * n;
            this.data[A] = l, this.data[A + 1] = h, this.data[A + 2] = o, this.data[A + 3] = 255;
          }
          this.pos += t;
        }
      }, It.prototype.bit24 = function () {
        for (var t = this.height - 1; 0 <= t; t--) {
          for (var e = this.bottom_up ? t : this.height - 1 - t, i = 0; i < this.width; i++) {
            var s = this.datav.getUint8(this.pos++, !0),
              r = this.datav.getUint8(this.pos++, !0),
              n = this.datav.getUint8(this.pos++, !0),
              a = e * this.width * 4 + 4 * i;
            this.data[a] = n, this.data[a + 1] = r, this.data[a + 2] = s, this.data[a + 3] = 255;
          }
          this.pos += this.width % 4;
        }
      }, It.prototype.bit32 = function () {
        for (var t = this.height - 1; 0 <= t; t--) for (var e = this.bottom_up ? t : this.height - 1 - t, i = 0; i < this.width; i++) {
          var s = this.datav.getUint8(this.pos++, !0),
            r = this.datav.getUint8(this.pos++, !0),
            n = this.datav.getUint8(this.pos++, !0),
            a = this.datav.getUint8(this.pos++, !0),
            o = e * this.width * 4 + 4 * i;
          this.data[o] = n, this.data[o + 1] = r, this.data[o + 2] = s, this.data[o + 3] = a;
        }
      }, It.prototype.getData = function () {
        return this.data;
      }, window.tmp = It, function (t) {
        var e = [0, 1, 2, 3, 4, 4, 5, 5, 6, 6, 6, 6, 7, 7, 7, 7, 8, 8, 8, 8, 8, 8, 8, 8, 9, 9, 9, 9, 9, 9, 9, 9, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 0, 0, 16, 17, 18, 18, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29];
        function i() {
          var t = this;
          function e(t, e) {
            for (var i = 0; i |= 1 & t, t >>>= 1, i <<= 1, 0 < --e;);
            return i >>> 1;
          }
          t.build_tree = function (i) {
            var s,
              r,
              n,
              a = t.dyn_tree,
              o = t.stat_desc.static_tree,
              h = t.stat_desc.elems,
              l = -1;
            for (i.heap_len = 0, i.heap_max = 573, s = 0; s < h; s++) 0 !== a[2 * s] ? (i.heap[++i.heap_len] = l = s, i.depth[s] = 0) : a[2 * s + 1] = 0;
            for (; i.heap_len < 2;) a[2 * (n = i.heap[++i.heap_len] = l < 2 ? ++l : 0)] = 1, i.depth[n] = 0, i.opt_len--, o && (i.static_len -= o[2 * n + 1]);
            for (t.max_code = l, s = Math.floor(i.heap_len / 2); 1 <= s; s--) i.pqdownheap(a, s);
            for (n = h; s = i.heap[1], i.heap[1] = i.heap[i.heap_len--], i.pqdownheap(a, 1), r = i.heap[1], i.heap[--i.heap_max] = s, i.heap[--i.heap_max] = r, a[2 * n] = a[2 * s] + a[2 * r], i.depth[n] = Math.max(i.depth[s], i.depth[r]) + 1, a[2 * s + 1] = a[2 * r + 1] = n, i.heap[1] = n++, i.pqdownheap(a, 1), 2 <= i.heap_len;);
            i.heap[--i.heap_max] = i.heap[1], function (e) {
              var i,
                s,
                r,
                n,
                a,
                o,
                h = t.dyn_tree,
                l = t.stat_desc.static_tree,
                A = t.stat_desc.extra_bits,
                c = t.stat_desc.extra_base,
                u = t.stat_desc.max_length,
                d = 0;
              for (n = 0; n <= 15; n++) e.bl_count[n] = 0;
              for (h[2 * e.heap[e.heap_max] + 1] = 0, i = e.heap_max + 1; i < 573; i++) u < (n = h[2 * h[2 * (s = e.heap[i]) + 1] + 1] + 1) && (n = u, d++), h[2 * s + 1] = n, s > t.max_code || (e.bl_count[n]++, a = 0, c <= s && (a = A[s - c]), o = h[2 * s], e.opt_len += o * (n + a), l && (e.static_len += o * (l[2 * s + 1] + a)));
              if (0 !== d) {
                do {
                  for (n = u - 1; 0 === e.bl_count[n];) n--;
                  e.bl_count[n]--, e.bl_count[n + 1] += 2, e.bl_count[u]--, d -= 2;
                } while (0 < d);
                for (n = u; 0 !== n; n--) for (s = e.bl_count[n]; 0 !== s;) (r = e.heap[--i]) > t.max_code || (h[2 * r + 1] != n && (e.opt_len += (n - h[2 * r + 1]) * h[2 * r], h[2 * r + 1] = n), s--);
              }
            }(i), function (t, i, s) {
              var r,
                n,
                a,
                o = [],
                h = 0;
              for (r = 1; r <= 15; r++) o[r] = h = h + s[r - 1] << 1;
              for (n = 0; n <= i; n++) 0 !== (a = t[2 * n + 1]) && (t[2 * n] = e(o[a]++, a));
            }(a, t.max_code, i.bl_count);
          };
        }
        function s(t, e, i, s, r) {
          this.static_tree = t, this.extra_bits = e, this.extra_base = i, this.elems = s, this.max_length = r;
        }
        function r(t, e, i, s, r) {
          this.good_length = t, this.max_lazy = e, this.nice_length = i, this.max_chain = s, this.func = r;
        }
        i._length_code = [0, 1, 2, 3, 4, 5, 6, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 28], i.base_length = [0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 14, 16, 20, 24, 28, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 0], i.base_dist = [0, 1, 2, 3, 4, 6, 8, 12, 16, 24, 32, 48, 64, 96, 128, 192, 256, 384, 512, 768, 1024, 1536, 2048, 3072, 4096, 6144, 8192, 12288, 16384, 24576], i.d_code = function (t) {
          return t < 256 ? e[t] : e[256 + (t >>> 7)];
        }, i.extra_lbits = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], i.extra_dbits = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], i.extra_blbits = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], i.bl_order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], s.static_ltree = [12, 8, 140, 8, 76, 8, 204, 8, 44, 8, 172, 8, 108, 8, 236, 8, 28, 8, 156, 8, 92, 8, 220, 8, 60, 8, 188, 8, 124, 8, 252, 8, 2, 8, 130, 8, 66, 8, 194, 8, 34, 8, 162, 8, 98, 8, 226, 8, 18, 8, 146, 8, 82, 8, 210, 8, 50, 8, 178, 8, 114, 8, 242, 8, 10, 8, 138, 8, 74, 8, 202, 8, 42, 8, 170, 8, 106, 8, 234, 8, 26, 8, 154, 8, 90, 8, 218, 8, 58, 8, 186, 8, 122, 8, 250, 8, 6, 8, 134, 8, 70, 8, 198, 8, 38, 8, 166, 8, 102, 8, 230, 8, 22, 8, 150, 8, 86, 8, 214, 8, 54, 8, 182, 8, 118, 8, 246, 8, 14, 8, 142, 8, 78, 8, 206, 8, 46, 8, 174, 8, 110, 8, 238, 8, 30, 8, 158, 8, 94, 8, 222, 8, 62, 8, 190, 8, 126, 8, 254, 8, 1, 8, 129, 8, 65, 8, 193, 8, 33, 8, 161, 8, 97, 8, 225, 8, 17, 8, 145, 8, 81, 8, 209, 8, 49, 8, 177, 8, 113, 8, 241, 8, 9, 8, 137, 8, 73, 8, 201, 8, 41, 8, 169, 8, 105, 8, 233, 8, 25, 8, 153, 8, 89, 8, 217, 8, 57, 8, 185, 8, 121, 8, 249, 8, 5, 8, 133, 8, 69, 8, 197, 8, 37, 8, 165, 8, 101, 8, 229, 8, 21, 8, 149, 8, 85, 8, 213, 8, 53, 8, 181, 8, 117, 8, 245, 8, 13, 8, 141, 8, 77, 8, 205, 8, 45, 8, 173, 8, 109, 8, 237, 8, 29, 8, 157, 8, 93, 8, 221, 8, 61, 8, 189, 8, 125, 8, 253, 8, 19, 9, 275, 9, 147, 9, 403, 9, 83, 9, 339, 9, 211, 9, 467, 9, 51, 9, 307, 9, 179, 9, 435, 9, 115, 9, 371, 9, 243, 9, 499, 9, 11, 9, 267, 9, 139, 9, 395, 9, 75, 9, 331, 9, 203, 9, 459, 9, 43, 9, 299, 9, 171, 9, 427, 9, 107, 9, 363, 9, 235, 9, 491, 9, 27, 9, 283, 9, 155, 9, 411, 9, 91, 9, 347, 9, 219, 9, 475, 9, 59, 9, 315, 9, 187, 9, 443, 9, 123, 9, 379, 9, 251, 9, 507, 9, 7, 9, 263, 9, 135, 9, 391, 9, 71, 9, 327, 9, 199, 9, 455, 9, 39, 9, 295, 9, 167, 9, 423, 9, 103, 9, 359, 9, 231, 9, 487, 9, 23, 9, 279, 9, 151, 9, 407, 9, 87, 9, 343, 9, 215, 9, 471, 9, 55, 9, 311, 9, 183, 9, 439, 9, 119, 9, 375, 9, 247, 9, 503, 9, 15, 9, 271, 9, 143, 9, 399, 9, 79, 9, 335, 9, 207, 9, 463, 9, 47, 9, 303, 9, 175, 9, 431, 9, 111, 9, 367, 9, 239, 9, 495, 9, 31, 9, 287, 9, 159, 9, 415, 9, 95, 9, 351, 9, 223, 9, 479, 9, 63, 9, 319, 9, 191, 9, 447, 9, 127, 9, 383, 9, 255, 9, 511, 9, 0, 7, 64, 7, 32, 7, 96, 7, 16, 7, 80, 7, 48, 7, 112, 7, 8, 7, 72, 7, 40, 7, 104, 7, 24, 7, 88, 7, 56, 7, 120, 7, 4, 7, 68, 7, 36, 7, 100, 7, 20, 7, 84, 7, 52, 7, 116, 7, 3, 8, 131, 8, 67, 8, 195, 8, 35, 8, 163, 8, 99, 8, 227, 8], s.static_dtree = [0, 5, 16, 5, 8, 5, 24, 5, 4, 5, 20, 5, 12, 5, 28, 5, 2, 5, 18, 5, 10, 5, 26, 5, 6, 5, 22, 5, 14, 5, 30, 5, 1, 5, 17, 5, 9, 5, 25, 5, 5, 5, 21, 5, 13, 5, 29, 5, 3, 5, 19, 5, 11, 5, 27, 5, 7, 5, 23, 5], s.static_l_desc = new s(s.static_ltree, i.extra_lbits, 257, 286, 15), s.static_d_desc = new s(s.static_dtree, i.extra_dbits, 0, 30, 15), s.static_bl_desc = new s(null, i.extra_blbits, 0, 19, 7);
        var n = [new r(0, 0, 0, 0, 0), new r(4, 4, 8, 4, 1), new r(4, 5, 16, 8, 1), new r(4, 6, 32, 32, 1), new r(4, 4, 16, 16, 2), new r(8, 16, 32, 32, 2), new r(8, 16, 128, 128, 2), new r(8, 32, 128, 256, 2), new r(32, 128, 258, 1024, 2), new r(32, 258, 258, 4096, 2)],
          a = ["need dictionary", "stream end", "", "", "stream error", "data error", "", "buffer error", "", ""];
        function o(t, e, i, s) {
          var r = t[2 * e],
            n = t[2 * i];
          return r < n || r == n && s[e] <= s[i];
        }
        function h() {
          var t,
            e,
            r,
            h,
            l,
            A,
            c,
            u,
            d,
            f,
            p,
            g,
            w,
            m,
            v,
            b,
            B,
            y,
            C,
            F,
            x,
            N,
            E,
            U,
            Q,
            L,
            S,
            k,
            H,
            I,
            O,
            T,
            P,
            j,
            M,
            D,
            R,
            _,
            z,
            K,
            q,
            V = this,
            J = new i(),
            G = new i(),
            X = new i();
          function W() {
            var t;
            for (t = 0; t < 286; t++) O[2 * t] = 0;
            for (t = 0; t < 30; t++) T[2 * t] = 0;
            for (t = 0; t < 19; t++) P[2 * t] = 0;
            O[512] = 1, V.opt_len = V.static_len = 0, D = _ = 0;
          }
          function Y(t, e) {
            var i,
              s,
              r = -1,
              n = t[1],
              a = 0,
              o = 7,
              h = 4;
            for (0 === n && (o = 138, h = 3), t[2 * (e + 1) + 1] = 65535, i = 0; i <= e; i++) s = n, n = t[2 * (i + 1) + 1], ++a < o && s == n || (a < h ? P[2 * s] += a : 0 !== s ? (s != r && P[2 * s]++, P[32]++) : a <= 10 ? P[34]++ : P[36]++, r = s, h = (a = 0) === n ? (o = 138, 3) : s == n ? (o = 6, 3) : (o = 7, 4));
          }
          function Z(t) {
            V.pending_buf[V.pending++] = t;
          }
          function $(t) {
            Z(255 & t), Z(t >>> 8 & 255);
          }
          function tt(t, e) {
            var i,
              s = e;
            16 - s < q ? ($(K |= (i = t) << q & 65535), K = i >>> 16 - q, q += s - 16) : (K |= t << q & 65535, q += s);
          }
          function et(t, e) {
            var i = 2 * t;
            tt(65535 & e[i], 65535 & e[i + 1]);
          }
          function it(t, e) {
            var i,
              s,
              r = -1,
              n = t[1],
              a = 0,
              o = 7,
              h = 4;
            for (0 === n && (o = 138, h = 3), i = 0; i <= e; i++) if (s = n, n = t[2 * (i + 1) + 1], !(++a < o && s == n)) {
              if (a < h) for (; et(s, P), 0 != --a;);else 0 !== s ? (s != r && (et(s, P), a--), et(16, P), tt(a - 3, 2)) : a <= 10 ? (et(17, P), tt(a - 3, 3)) : (et(18, P), tt(a - 11, 7));
              r = s, h = (a = 0) === n ? (o = 138, 3) : s == n ? (o = 6, 3) : (o = 7, 4);
            }
          }
          function st() {
            16 == q ? ($(K), q = K = 0) : 8 <= q && (Z(255 & K), K >>>= 8, q -= 8);
          }
          function rt(t, e) {
            var s, r, n;
            if (V.pending_buf[R + 2 * D] = t >>> 8 & 255, V.pending_buf[R + 2 * D + 1] = 255 & t, V.pending_buf[j + D] = 255 & e, D++, 0 === t ? O[2 * e]++ : (_++, t--, O[2 * (i._length_code[e] + 256 + 1)]++, T[2 * i.d_code(t)]++), 0 == (8191 & D) && 2 < S) {
              for (s = 8 * D, r = x - B, n = 0; n < 30; n++) s += T[2 * n] * (5 + i.extra_dbits[n]);
              if (s >>>= 3, _ < Math.floor(D / 2) && s < Math.floor(r / 2)) return !0;
            }
            return D == M - 1;
          }
          function nt(t, e) {
            var s,
              r,
              n,
              a,
              o = 0;
            if (0 !== D) for (; s = V.pending_buf[R + 2 * o] << 8 & 65280 | 255 & V.pending_buf[R + 2 * o + 1], r = 255 & V.pending_buf[j + o], o++, 0 === s ? et(r, t) : (et((n = i._length_code[r]) + 256 + 1, t), 0 !== (a = i.extra_lbits[n]) && tt(r -= i.base_length[n], a), et(n = i.d_code(--s), e), 0 !== (a = i.extra_dbits[n]) && tt(s -= i.base_dist[n], a)), o < D;);
            et(256, t), z = t[513];
          }
          function at() {
            8 < q ? $(K) : 0 < q && Z(255 & K), q = K = 0;
          }
          function ot(t, e, i) {
            var s, r;
            tt(0 + (i ? 1 : 0), 3), s = t, r = e, at(), z = 8, $(r), $(~r), V.pending_buf.set(u.subarray(s, s + r), V.pending), V.pending += r;
          }
          function ht(e) {
            (function (t, e, r) {
              var n,
                a,
                o = 0;
              0 < S ? (J.build_tree(V), G.build_tree(V), o = function () {
                var t;
                for (Y(O, J.max_code), Y(T, G.max_code), X.build_tree(V), t = 18; 3 <= t && 0 === P[2 * i.bl_order[t] + 1]; t--);
                return V.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
              }(), n = V.opt_len + 3 + 7 >>> 3, (a = V.static_len + 3 + 7 >>> 3) <= n && (n = a)) : n = a = e + 5, e + 4 <= n && -1 != t ? ot(t, e, r) : a == n ? (tt(2 + (r ? 1 : 0), 3), nt(s.static_ltree, s.static_dtree)) : (tt(4 + (r ? 1 : 0), 3), function (t, e, s) {
                var r;
                for (tt(t - 257, 5), tt(e - 1, 5), tt(s - 4, 4), r = 0; r < s; r++) tt(P[2 * i.bl_order[r] + 1], 3);
                it(O, t - 1), it(T, e - 1);
              }(J.max_code + 1, G.max_code + 1, o + 1), nt(O, T)), W(), r && at();
            })(0 <= B ? B : -1, x - B, e), B = x, t.flush_pending();
          }
          function lt() {
            var e, i, s, r;
            do {
              if (0 == (r = d - E - x) && 0 === x && 0 === E) r = l;else if (-1 == r) r--;else if (l + l - 262 <= x) {
                for (u.set(u.subarray(l, l + l), 0), N -= l, x -= l, B -= l, s = e = w; i = 65535 & p[--s], p[s] = l <= i ? i - l : 0, 0 != --e;);
                for (s = e = l; i = 65535 & f[--s], f[s] = l <= i ? i - l : 0, 0 != --e;);
                r += l;
              }
              if (0 === t.avail_in) return;
              e = t.read_buf(u, x + E, r), 3 <= (E += e) && (g = ((g = 255 & u[x]) << b ^ 255 & u[x + 1]) & v);
            } while (E < 262 && 0 !== t.avail_in);
          }
          function At(t) {
            var e,
              i,
              s = Q,
              r = x,
              n = U,
              a = l - 262 < x ? x - (l - 262) : 0,
              o = I,
              h = c,
              A = x + 258,
              d = u[r + n - 1],
              p = u[r + n];
            H <= U && (s >>= 2), E < o && (o = E);
            do {
              if (u[(e = t) + n] == p && u[e + n - 1] == d && u[e] == u[r] && u[++e] == u[r + 1]) {
                r += 2, e++;
                do {} while (u[++r] == u[++e] && u[++r] == u[++e] && u[++r] == u[++e] && u[++r] == u[++e] && u[++r] == u[++e] && u[++r] == u[++e] && u[++r] == u[++e] && u[++r] == u[++e] && r < A);
                if (i = 258 - (A - r), r = A - 258, n < i) {
                  if (N = t, o <= (n = i)) break;
                  d = u[r + n - 1], p = u[r + n];
                }
              }
            } while ((t = 65535 & f[t & h]) > a && 0 != --s);
            return n <= E ? n : E;
          }
          function ct(t) {
            return t.total_in = t.total_out = 0, t.msg = null, V.pending = 0, V.pending_out = 0, e = 113, h = 0, J.dyn_tree = O, J.stat_desc = s.static_l_desc, G.dyn_tree = T, G.stat_desc = s.static_d_desc, X.dyn_tree = P, X.stat_desc = s.static_bl_desc, q = K = 0, z = 8, W(), function () {
              var t;
              for (d = 2 * l, t = p[w - 1] = 0; t < w - 1; t++) p[t] = 0;
              L = n[S].max_lazy, H = n[S].good_length, I = n[S].nice_length, Q = n[S].max_chain, y = U = 2, g = F = E = B = x = 0;
            }(), 0;
          }
          V.depth = [], V.bl_count = [], V.heap = [], O = [], T = [], P = [], V.pqdownheap = function (t, e) {
            for (var i = V.heap, s = i[e], r = e << 1; r <= V.heap_len && (r < V.heap_len && o(t, i[r + 1], i[r], V.depth) && r++, !o(t, s, i[r], V.depth));) i[e] = i[r], e = r, r <<= 1;
            i[e] = s;
          }, V.deflateInit = function (t, e, i, s, n, a) {
            return s || (s = 8), n || (n = 8), a || (a = 0), t.msg = null, -1 == e && (e = 6), n < 1 || 9 < n || 8 != s || i < 9 || 15 < i || e < 0 || 9 < e || a < 0 || 2 < a ? -2 : (t.dstate = V, c = (l = 1 << (A = i)) - 1, v = (w = 1 << (m = n + 7)) - 1, b = Math.floor((m + 3 - 1) / 3), u = new Uint8Array(2 * l), f = [], p = [], M = 1 << n + 6, V.pending_buf = new Uint8Array(4 * M), r = 4 * M, R = Math.floor(M / 2), j = 3 * M, S = e, k = a, ct(t));
          }, V.deflateEnd = function () {
            return 42 != e && 113 != e && 666 != e ? -2 : (V.pending_buf = null, u = f = p = null, V.dstate = null, 113 == e ? -3 : 0);
          }, V.deflateParams = function (t, e, i) {
            var s = 0;
            return -1 == e && (e = 6), e < 0 || 9 < e || i < 0 || 2 < i ? -2 : (n[S].func != n[e].func && 0 !== t.total_in && (s = t.deflate(1)), S != e && (L = n[S = e].max_lazy, H = n[S].good_length, I = n[S].nice_length, Q = n[S].max_chain), k = i, s);
          }, V.deflateSetDictionary = function (t, i, s) {
            var r,
              n = s,
              a = 0;
            if (!i || 42 != e) return -2;
            if (n < 3) return 0;
            for (l - 262 < n && (a = s - (n = l - 262)), u.set(i.subarray(a, a + n), 0), B = x = n, g = ((g = 255 & u[0]) << b ^ 255 & u[1]) & v, r = 0; r <= n - 3; r++) g = (g << b ^ 255 & u[r + 2]) & v, f[r & c] = p[g], p[g] = r;
            return 0;
          }, V.deflate = function (i, o) {
            var d, m, Q, H, I, O;
            if (4 < o || o < 0) return -2;
            if (!i.next_out || !i.next_in && 0 !== i.avail_in || 666 == e && 4 != o) return i.msg = a[4], -2;
            if (0 === i.avail_out) return i.msg = a[7], -5;
            if (t = i, H = h, h = o, 42 == e && (m = 8 + (A - 8 << 4) << 8, 3 < (Q = (S - 1 & 255) >> 1) && (Q = 3), m |= Q << 6, 0 !== x && (m |= 32), e = 113, Z((O = m += 31 - m % 31) >> 8 & 255), Z(255 & O)), 0 !== V.pending) {
              if (t.flush_pending(), 0 === t.avail_out) return h = -1, 0;
            } else if (0 === t.avail_in && o <= H && 4 != o) return t.msg = a[7], -5;
            if (666 == e && 0 !== t.avail_in) return i.msg = a[7], -5;
            if (0 !== t.avail_in || 0 !== E || 0 != o && 666 != e) {
              switch (I = -1, n[S].func) {
                case 0:
                  I = function (e) {
                    var i,
                      s = 65535;
                    for (r - 5 < s && (s = r - 5);;) {
                      if (E <= 1) {
                        if (lt(), 0 === E && 0 == e) return 0;
                        if (0 === E) break;
                      }
                      if (x += E, i = B + s, ((E = 0) === x || i <= x) && (E = x - i, x = i, ht(!1), 0 === t.avail_out)) return 0;
                      if (l - 262 <= x - B && (ht(!1), 0 === t.avail_out)) return 0;
                    }
                    return ht(4 == e), 0 === t.avail_out ? 4 == e ? 2 : 0 : 4 == e ? 3 : 1;
                  }(o);
                  break;
                case 1:
                  I = function (e) {
                    for (var i, s = 0;;) {
                      if (E < 262) {
                        if (lt(), E < 262 && 0 == e) return 0;
                        if (0 === E) break;
                      }
                      if (3 <= E && (g = (g << b ^ 255 & u[x + 2]) & v, s = 65535 & p[g], f[x & c] = p[g], p[g] = x), 0 !== s && (x - s & 65535) <= l - 262 && 2 != k && (y = At(s)), 3 <= y) {
                        if (i = rt(x - N, y - 3), E -= y, y <= L && 3 <= E) {
                          for (y--; g = (g << b ^ 255 & u[2 + ++x]) & v, s = 65535 & p[g], f[x & c] = p[g], p[g] = x, 0 != --y;);
                          x++;
                        } else x += y, y = 0, g = ((g = 255 & u[x]) << b ^ 255 & u[x + 1]) & v;
                      } else i = rt(0, 255 & u[x]), E--, x++;
                      if (i && (ht(!1), 0 === t.avail_out)) return 0;
                    }
                    return ht(4 == e), 0 === t.avail_out ? 4 == e ? 2 : 0 : 4 == e ? 3 : 1;
                  }(o);
                  break;
                case 2:
                  I = function (e) {
                    for (var i, s, r = 0;;) {
                      if (E < 262) {
                        if (lt(), E < 262 && 0 == e) return 0;
                        if (0 === E) break;
                      }
                      if (3 <= E && (g = (g << b ^ 255 & u[x + 2]) & v, r = 65535 & p[g], f[x & c] = p[g], p[g] = x), U = y, C = N, y = 2, 0 !== r && U < L && (x - r & 65535) <= l - 262 && (2 != k && (y = At(r)), y <= 5 && (1 == k || 3 == y && 4096 < x - N) && (y = 2)), 3 <= U && y <= U) {
                        for (s = x + E - 3, i = rt(x - 1 - C, U - 3), E -= U - 1, U -= 2; ++x <= s && (g = (g << b ^ 255 & u[x + 2]) & v, r = 65535 & p[g], f[x & c] = p[g], p[g] = x), 0 != --U;);
                        if (F = 0, y = 2, x++, i && (ht(!1), 0 === t.avail_out)) return 0;
                      } else if (0 !== F) {
                        if ((i = rt(0, 255 & u[x - 1])) && ht(!1), x++, E--, 0 === t.avail_out) return 0;
                      } else F = 1, x++, E--;
                    }
                    return 0 !== F && (i = rt(0, 255 & u[x - 1]), F = 0), ht(4 == e), 0 === t.avail_out ? 4 == e ? 2 : 0 : 4 == e ? 3 : 1;
                  }(o);
              }
              if (2 != I && 3 != I || (e = 666), 0 == I || 2 == I) return 0 === t.avail_out && (h = -1), 0;
              if (1 == I) {
                if (1 == o) tt(2, 3), et(256, s.static_ltree), st(), 1 + z + 10 - q < 9 && (tt(2, 3), et(256, s.static_ltree), st()), z = 7;else if (ot(0, 0, !1), 3 == o) for (d = 0; d < w; d++) p[d] = 0;
                if (t.flush_pending(), 0 === t.avail_out) return h = -1, 0;
              }
            }
            return 4 != o ? 0 : 1;
          };
        }
        function l() {
          this.next_in_index = 0, this.next_out_index = 0, this.avail_in = 0, this.total_in = 0, this.avail_out = 0, this.total_out = 0;
        }
        l.prototype = {
          deflateInit: function deflateInit(t, e) {
            return this.dstate = new h(), e || (e = 15), this.dstate.deflateInit(this, t, e);
          },
          deflate: function deflate(t) {
            return this.dstate ? this.dstate.deflate(this, t) : -2;
          },
          deflateEnd: function deflateEnd() {
            if (!this.dstate) return -2;
            var t = this.dstate.deflateEnd();
            return this.dstate = null, t;
          },
          deflateParams: function deflateParams(t, e) {
            return this.dstate ? this.dstate.deflateParams(this, t, e) : -2;
          },
          deflateSetDictionary: function deflateSetDictionary(t, e) {
            return this.dstate ? this.dstate.deflateSetDictionary(this, t, e) : -2;
          },
          read_buf: function read_buf(t, e, i) {
            var s = this.avail_in;
            return i < s && (s = i), 0 === s ? 0 : (this.avail_in -= s, t.set(this.next_in.subarray(this.next_in_index, this.next_in_index + s), e), this.next_in_index += s, this.total_in += s, s);
          },
          flush_pending: function flush_pending() {
            var t = this,
              e = t.dstate.pending;
            e > t.avail_out && (e = t.avail_out), 0 !== e && (t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out, t.dstate.pending_out + e), t.next_out_index), t.next_out_index += e, t.dstate.pending_out += e, t.total_out += e, t.avail_out -= e, t.dstate.pending -= e, 0 === t.dstate.pending && (t.dstate.pending_out = 0));
          }
        };
        var A = t.zip || t;
        A.Deflater = A._jzlib_Deflater = function (t) {
          var e = new l(),
            i = new Uint8Array(512),
            s = t ? t.level : -1;
          void 0 === s && (s = -1), e.deflateInit(s), e.next_out = i, this.append = function (t, s) {
            var r,
              n = [],
              a = 0,
              o = 0,
              h = 0;
            if (t.length) {
              e.next_in_index = 0, e.next_in = t, e.avail_in = t.length;
              do {
                if (e.next_out_index = 0, e.avail_out = 512, 0 != e.deflate(0)) throw new Error("deflating: " + e.msg);
                e.next_out_index && (512 == e.next_out_index ? n.push(new Uint8Array(i)) : n.push(new Uint8Array(i.subarray(0, e.next_out_index)))), h += e.next_out_index, s && 0 < e.next_in_index && e.next_in_index != a && (s(e.next_in_index), a = e.next_in_index);
              } while (0 < e.avail_in || 0 === e.avail_out);
              return r = new Uint8Array(h), n.forEach(function (t) {
                r.set(t, o), o += t.length;
              }), r;
            }
          }, this.flush = function () {
            var t,
              s,
              r = [],
              n = 0,
              a = 0;
            do {
              if (e.next_out_index = 0, e.avail_out = 512, 1 != (t = e.deflate(4)) && 0 != t) throw new Error("deflating: " + e.msg);
              0 < 512 - e.avail_out && r.push(new Uint8Array(i.subarray(0, e.next_out_index))), a += e.next_out_index;
            } while (0 < e.avail_in || 0 === e.avail_out);
            return e.deflateEnd(), s = new Uint8Array(a), r.forEach(function (t) {
              s.set(t, n), n += t.length;
            }), s;
          };
        };
      }("undefined" != typeof self && self || "undefined" != typeof window && window || void 0 !== s && s || Function('return typeof this === "object" && this.content')() || Function("return this")()), ("undefined" != typeof self && self || "undefined" != typeof window && window || void 0 !== s && s || Function('return typeof this === "object" && this.content')() || Function("return this")()).RGBColor = function (t) {
        var e;
        t = t || "", this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6)), t = (t = t.replace(/ /g, "")).toLowerCase();
        var i = {
          aliceblue: "f0f8ff",
          antiquewhite: "faebd7",
          aqua: "00ffff",
          aquamarine: "7fffd4",
          azure: "f0ffff",
          beige: "f5f5dc",
          bisque: "ffe4c4",
          black: "000000",
          blanchedalmond: "ffebcd",
          blue: "0000ff",
          blueviolet: "8a2be2",
          brown: "a52a2a",
          burlywood: "deb887",
          cadetblue: "5f9ea0",
          chartreuse: "7fff00",
          chocolate: "d2691e",
          coral: "ff7f50",
          cornflowerblue: "6495ed",
          cornsilk: "fff8dc",
          crimson: "dc143c",
          cyan: "00ffff",
          darkblue: "00008b",
          darkcyan: "008b8b",
          darkgoldenrod: "b8860b",
          darkgray: "a9a9a9",
          darkgreen: "006400",
          darkkhaki: "bdb76b",
          darkmagenta: "8b008b",
          darkolivegreen: "556b2f",
          darkorange: "ff8c00",
          darkorchid: "9932cc",
          darkred: "8b0000",
          darksalmon: "e9967a",
          darkseagreen: "8fbc8f",
          darkslateblue: "483d8b",
          darkslategray: "2f4f4f",
          darkturquoise: "00ced1",
          darkviolet: "9400d3",
          deeppink: "ff1493",
          deepskyblue: "00bfff",
          dimgray: "696969",
          dodgerblue: "1e90ff",
          feldspar: "d19275",
          firebrick: "b22222",
          floralwhite: "fffaf0",
          forestgreen: "228b22",
          fuchsia: "ff00ff",
          gainsboro: "dcdcdc",
          ghostwhite: "f8f8ff",
          gold: "ffd700",
          goldenrod: "daa520",
          gray: "808080",
          green: "008000",
          greenyellow: "adff2f",
          honeydew: "f0fff0",
          hotpink: "ff69b4",
          indianred: "cd5c5c",
          indigo: "4b0082",
          ivory: "fffff0",
          khaki: "f0e68c",
          lavender: "e6e6fa",
          lavenderblush: "fff0f5",
          lawngreen: "7cfc00",
          lemonchiffon: "fffacd",
          lightblue: "add8e6",
          lightcoral: "f08080",
          lightcyan: "e0ffff",
          lightgoldenrodyellow: "fafad2",
          lightgrey: "d3d3d3",
          lightgreen: "90ee90",
          lightpink: "ffb6c1",
          lightsalmon: "ffa07a",
          lightseagreen: "20b2aa",
          lightskyblue: "87cefa",
          lightslateblue: "8470ff",
          lightslategray: "778899",
          lightsteelblue: "b0c4de",
          lightyellow: "ffffe0",
          lime: "00ff00",
          limegreen: "32cd32",
          linen: "faf0e6",
          magenta: "ff00ff",
          maroon: "800000",
          mediumaquamarine: "66cdaa",
          mediumblue: "0000cd",
          mediumorchid: "ba55d3",
          mediumpurple: "9370d8",
          mediumseagreen: "3cb371",
          mediumslateblue: "7b68ee",
          mediumspringgreen: "00fa9a",
          mediumturquoise: "48d1cc",
          mediumvioletred: "c71585",
          midnightblue: "191970",
          mintcream: "f5fffa",
          mistyrose: "ffe4e1",
          moccasin: "ffe4b5",
          navajowhite: "ffdead",
          navy: "000080",
          oldlace: "fdf5e6",
          olive: "808000",
          olivedrab: "6b8e23",
          orange: "ffa500",
          orangered: "ff4500",
          orchid: "da70d6",
          palegoldenrod: "eee8aa",
          palegreen: "98fb98",
          paleturquoise: "afeeee",
          palevioletred: "d87093",
          papayawhip: "ffefd5",
          peachpuff: "ffdab9",
          peru: "cd853f",
          pink: "ffc0cb",
          plum: "dda0dd",
          powderblue: "b0e0e6",
          purple: "800080",
          red: "ff0000",
          rosybrown: "bc8f8f",
          royalblue: "4169e1",
          saddlebrown: "8b4513",
          salmon: "fa8072",
          sandybrown: "f4a460",
          seagreen: "2e8b57",
          seashell: "fff5ee",
          sienna: "a0522d",
          silver: "c0c0c0",
          skyblue: "87ceeb",
          slateblue: "6a5acd",
          slategray: "708090",
          snow: "fffafa",
          springgreen: "00ff7f",
          steelblue: "4682b4",
          tan: "d2b48c",
          teal: "008080",
          thistle: "d8bfd8",
          tomato: "ff6347",
          turquoise: "40e0d0",
          violet: "ee82ee",
          violetred: "d02090",
          wheat: "f5deb3",
          white: "ffffff",
          whitesmoke: "f5f5f5",
          yellow: "ffff00",
          yellowgreen: "9acd32"
        };
        for (var s in i) t == s && (t = i[s]);
        for (var r = [{
            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
            process: function process(t) {
              return [parseInt(t[1]), parseInt(t[2]), parseInt(t[3])];
            }
          }, {
            re: /^(\w{2})(\w{2})(\w{2})$/,
            example: ["#00ff00", "336699"],
            process: function process(t) {
              return [parseInt(t[1], 16), parseInt(t[2], 16), parseInt(t[3], 16)];
            }
          }, {
            re: /^(\w{1})(\w{1})(\w{1})$/,
            example: ["#fb0", "f0f"],
            process: function process(t) {
              return [parseInt(t[1] + t[1], 16), parseInt(t[2] + t[2], 16), parseInt(t[3] + t[3], 16)];
            }
          }], n = 0; n < r.length; n++) {
          var a = r[n].re,
            o = r[n].process,
            h = a.exec(t);
          h && (e = o(h), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
        }
        this.r = this.r < 0 || isNaN(this.r) ? 0 : 255 < this.r ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : 255 < this.g ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : 255 < this.b ? 255 : this.b, this.toRGB = function () {
          return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
        }, this.toHex = function () {
          var t = this.r.toString(16),
            e = this.g.toString(16),
            i = this.b.toString(16);
          return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == i.length && (i = "0" + i), "#" + t + e + i;
        };
      }, function (t) {
        var e = "+".charCodeAt(0),
          i = "/".charCodeAt(0),
          s = "0".charCodeAt(0),
          r = "a".charCodeAt(0),
          n = "A".charCodeAt(0),
          a = "-".charCodeAt(0),
          o = "_".charCodeAt(0),
          h = function h(t) {
            var h = t.charCodeAt(0);
            return h === e || h === a ? 62 : h === i || h === o ? 63 : h < s ? -1 : h < s + 10 ? h - s + 26 + 26 : h < n + 26 ? h - n : h < r + 26 ? h - r + 26 : void 0;
          };
        t.API.TTFFont = function () {
          function t(t, e, i) {
            var s;
            if (this.rawData = t, s = this.contents = new A(t), this.contents.pos = 4, "ttcf" === s.readString(4)) {
              if (!e) throw new Error("Must specify a font name for TTC files.");
              throw new Error("Font " + e + " not found in TTC file.");
            }
            s.pos = 0, this.parse(), this.subset = new Q(this), this.registerTTF();
          }
          return t.open = function (e, i, s, r) {
            if ("string" != typeof s) throw new Error("Invalid argument supplied in TTFFont.open");
            return new t(function (t) {
              var e, i, s, r, n, a;
              if (0 < t.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
              var o = t.length;
              n = "=" === t.charAt(o - 2) ? 2 : "=" === t.charAt(o - 1) ? 1 : 0, a = new Uint8Array(3 * t.length / 4 - n), s = 0 < n ? t.length - 4 : t.length;
              var l = 0;
              function A(t) {
                a[l++] = t;
              }
              for (i = e = 0; e < s; e += 4, i += 3) A((16711680 & (r = h(t.charAt(e)) << 18 | h(t.charAt(e + 1)) << 12 | h(t.charAt(e + 2)) << 6 | h(t.charAt(e + 3)))) >> 16), A((65280 & r) >> 8), A(255 & r);
              return 2 === n ? A(255 & (r = h(t.charAt(e)) << 2 | h(t.charAt(e + 1)) >> 4)) : 1 === n && (A((r = h(t.charAt(e)) << 10 | h(t.charAt(e + 1)) << 4 | h(t.charAt(e + 2)) >> 2) >> 8 & 255), A(255 & r)), a;
            }(s), i, r);
          }, t.prototype.parse = function () {
            return this.directory = new c(this.contents), this.head = new f(this), this.name = new B(this), this.cmap = new g(this), this.toUnicode = new Map(), this.hhea = new w(this), this.maxp = new y(this), this.hmtx = new C(this), this.post = new v(this), this.os2 = new m(this), this.loca = new U(this), this.glyf = new x(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax];
          }, t.prototype.registerTTF = function () {
            var t, e, i, s, r;
            if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = function () {
              var e, i, s, r;
              for (r = [], e = 0, i = (s = this.bbox).length; e < i; e++) t = s[e], r.push(Math.round(t * this.scaleFactor));
              return r;
            }.call(this), this.stemV = 0, this.post.exists ? (i = 255 & (s = this.post.italic_angle), !0 & (e = s >> 16) && (e = -(1 + (65535 ^ e))), this.italicAngle = +(e + "." + i)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (r = this.familyClass) || 2 === r || 3 === r || 4 === r || 5 === r || 7 === r, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
          }, t.prototype.characterToGlyph = function (t) {
            var e;
            return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
          }, t.prototype.widthOfGlyph = function (t) {
            var e;
            return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
          }, t.prototype.widthOfString = function (t, e, i) {
            var s, r, n, a, o;
            for (r = a = n = 0, o = (t = "" + t).length; 0 <= o ? a < o : o < a; r = 0 <= o ? ++a : --a) s = t.charCodeAt(r), n += this.widthOfGlyph(this.characterToGlyph(s)) + i * (1e3 / e) || 0;
            return n * (e / 1e3);
          }, t.prototype.lineHeight = function (t, e) {
            var i;
            return null == e && (e = !1), i = e ? this.lineGap : 0, (this.ascender + i - this.decender) / 1e3 * t;
          }, t;
        }();
        var l,
          A = function () {
            function t(t) {
              this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
            }
            return t.prototype.readByte = function () {
              return this.data[this.pos++];
            }, t.prototype.writeByte = function (t) {
              return this.data[this.pos++] = t;
            }, t.prototype.readUInt32 = function () {
              return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
            }, t.prototype.writeUInt32 = function (t) {
              return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
            }, t.prototype.readInt32 = function () {
              var t;
              return 2147483648 <= (t = this.readUInt32()) ? t - 4294967296 : t;
            }, t.prototype.writeInt32 = function (t) {
              return t < 0 && (t += 4294967296), this.writeUInt32(t);
            }, t.prototype.readUInt16 = function () {
              return this.readByte() << 8 | this.readByte();
            }, t.prototype.writeUInt16 = function (t) {
              return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
            }, t.prototype.readInt16 = function () {
              var t;
              return 32768 <= (t = this.readUInt16()) ? t - 65536 : t;
            }, t.prototype.writeInt16 = function (t) {
              return t < 0 && (t += 65536), this.writeUInt16(t);
            }, t.prototype.readString = function (t) {
              var e, i, s;
              for (i = [], e = s = 0; 0 <= t ? s < t : t < s; e = 0 <= t ? ++s : --s) i[e] = String.fromCharCode(this.readByte());
              return i.join("");
            }, t.prototype.writeString = function (t) {
              var e, i, s, r;
              for (r = [], e = i = 0, s = t.length; 0 <= s ? i < s : s < i; e = 0 <= s ? ++i : --i) r.push(this.writeByte(t.charCodeAt(e)));
              return r;
            }, t.prototype.readShort = function () {
              return this.readInt16();
            }, t.prototype.writeShort = function (t) {
              return this.writeInt16(t);
            }, t.prototype.readLongLong = function () {
              var t, e, i, s, r, n, a, o;
              return t = this.readByte(), e = this.readByte(), i = this.readByte(), s = this.readByte(), r = this.readByte(), n = this.readByte(), a = this.readByte(), o = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ i) + 4294967296 * (255 ^ s) + 16777216 * (255 ^ r) + 65536 * (255 ^ n) + 256 * (255 ^ a) + (255 ^ o) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * i + 4294967296 * s + 16777216 * r + 65536 * n + 256 * a + o;
            }, t.prototype.writeLongLong = function (t) {
              var e, i;
              return e = Math.floor(t / 4294967296), i = 4294967295 & t, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(i >> 24 & 255), this.writeByte(i >> 16 & 255), this.writeByte(i >> 8 & 255), this.writeByte(255 & i);
            }, t.prototype.readInt = function () {
              return this.readInt32();
            }, t.prototype.writeInt = function (t) {
              return this.writeInt32(t);
            }, t.prototype.read = function (t) {
              var e, i;
              for (e = [], i = 0; 0 <= t ? i < t : t < i; 0 <= t ? ++i : --i) e.push(this.readByte());
              return e;
            }, t.prototype.write = function (t) {
              var e, i, s, r;
              for (r = [], i = 0, s = t.length; i < s; i++) e = t[i], r.push(this.writeByte(e));
              return r;
            }, t;
          }(),
          c = function () {
            var t;
            function e(t) {
              var e, i, s;
              for (this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, i = 0, s = this.tableCount; 0 <= s ? i < s : s < i; 0 <= s ? ++i : --i) e = {
                tag: t.readString(4),
                checksum: t.readInt(),
                offset: t.readInt(),
                length: t.readInt()
              }, this.tables[e.tag] = e;
            }
            return e.prototype.encode = function (e) {
              var i, s, r, n, a, o, h, l, c, u, d, f, p;
              for (p in d = Object.keys(e).length, o = Math.log(2), c = 16 * Math.floor(Math.log(d) / o), n = Math.floor(c / o), l = 16 * d - c, (s = new A()).writeInt(this.scalarType), s.writeShort(d), s.writeShort(c), s.writeShort(n), s.writeShort(l), r = 16 * d, h = s.pos + r, a = null, f = [], e) for (u = e[p], s.writeString(p), s.writeInt(t(u)), s.writeInt(h), s.writeInt(u.length), f = f.concat(u), "head" === p && (a = h), h += u.length; h % 4;) f.push(0), h++;
              return s.write(f), i = 2981146554 - t(s.data), s.pos = a + 8, s.writeUInt32(i), s.data;
            }, t = function t(_t4) {
              var e, i, s, r;
              for (_t4 = F.call(_t4); _t4.length % 4;) _t4.push(0);
              for (i = new A(_t4), s = e = 0, r = _t4.length; s < r; s += 4) e += i.readUInt32();
              return 4294967295 & e;
            }, e;
          }(),
          u = {}.hasOwnProperty,
          d = function d(t, e) {
            for (var i in e) u.call(e, i) && (t[i] = e[i]);
            function s() {
              this.constructor = t;
            }
            return s.prototype = e.prototype, t.prototype = new s(), t.__super__ = e.prototype, t;
          };
        l = function () {
          function t(t) {
            var e;
            this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
          }
          return t.prototype.parse = function () {}, t.prototype.encode = function () {}, t.prototype.raw = function () {
            return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
          }, t;
        }();
        var f = function (t) {
            function e() {
              return e.__super__.constructor.apply(this, arguments);
            }
            return d(e, l), e.prototype.tag = "head", e.prototype.parse = function (t) {
              return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
            }, e.prototype.encode = function (t) {
              var e;
              return (e = new A()).writeInt(this.version), e.writeInt(this.revision), e.writeInt(this.checkSumAdjustment), e.writeInt(this.magicNumber), e.writeShort(this.flags), e.writeShort(this.unitsPerEm), e.writeLongLong(this.created), e.writeLongLong(this.modified), e.writeShort(this.xMin), e.writeShort(this.yMin), e.writeShort(this.xMax), e.writeShort(this.yMax), e.writeShort(this.macStyle), e.writeShort(this.lowestRecPPEM), e.writeShort(this.fontDirectionHint), e.writeShort(t), e.writeShort(this.glyphDataFormat), e.data;
            }, e;
          }(),
          p = function () {
            function t(t, e) {
              var i, s, r, n, a, o, h, l, A, c, u, d, f, p, g, w, m, v;
              switch (this.platformID = t.readUInt16(), this.encodingID = t.readShort(), this.offset = e + t.readInt(), A = t.pos, t.pos = this.offset, this.format = t.readUInt16(), this.length = t.readUInt16(), this.language = t.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format) {
                case 0:
                  for (o = g = 0; g < 256; o = ++g) this.codeMap[o] = t.readByte();
                  break;
                case 4:
                  for (u = t.readUInt16(), c = u / 2, t.pos += 6, r = function () {
                    var e, i;
                    for (i = [], o = e = 0; 0 <= c ? e < c : c < e; o = 0 <= c ? ++e : --e) i.push(t.readUInt16());
                    return i;
                  }(), t.pos += 2, f = function () {
                    var e, i;
                    for (i = [], o = e = 0; 0 <= c ? e < c : c < e; o = 0 <= c ? ++e : --e) i.push(t.readUInt16());
                    return i;
                  }(), h = function () {
                    var e, i;
                    for (i = [], o = e = 0; 0 <= c ? e < c : c < e; o = 0 <= c ? ++e : --e) i.push(t.readUInt16());
                    return i;
                  }(), l = function () {
                    var e, i;
                    for (i = [], o = e = 0; 0 <= c ? e < c : c < e; o = 0 <= c ? ++e : --e) i.push(t.readUInt16());
                    return i;
                  }(), s = (this.length - t.pos + this.offset) / 2, a = function () {
                    var e, i;
                    for (i = [], o = e = 0; 0 <= s ? e < s : s < e; o = 0 <= s ? ++e : --e) i.push(t.readUInt16());
                    return i;
                  }(), o = w = 0, v = r.length; w < v; o = ++w) for (p = r[o], i = m = d = f[o]; d <= p ? m <= p : p <= m; i = d <= p ? ++m : --m) 0 === l[o] ? n = i + h[o] : 0 !== (n = a[l[o] / 2 + (i - d) - (c - o)] || 0) && (n += h[o]), this.codeMap[i] = 65535 & n;
              }
              t.pos = A;
            }
            return t.encode = function (t, e) {
              var i, s, r, n, a, o, h, l, c, u, d, f, p, g, w, m, v, b, B, y, C, F, x, N, E, U, Q, L, S, k, H, I, O, T, P, j, M, D, R, _, z, K, q, V, J, G;
              switch (L = new A(), n = Object.keys(t).sort(function (t, e) {
                return t - e;
              }), e) {
                case "macroman":
                  for (p = 0, g = function () {
                    var t, e;
                    for (e = [], f = t = 0; t < 256; f = ++t) e.push(0);
                    return e;
                  }(), m = {
                    0: 0
                  }, r = {}, S = 0, O = n.length; S < O; S++) null == m[q = t[s = n[S]]] && (m[q] = ++p), r[s] = {
                    old: t[s],
                    new: m[t[s]]
                  }, g[s] = m[t[s]];
                  return L.writeUInt16(1), L.writeUInt16(0), L.writeUInt32(12), L.writeUInt16(0), L.writeUInt16(262), L.writeUInt16(0), L.write(g), {
                    charMap: r,
                    subtable: L.data,
                    maxGlyphID: p + 1
                  };
                case "unicode":
                  for (U = [], c = [], m = {}, i = {}, w = h = null, k = v = 0, T = n.length; k < T; k++) null == m[B = t[s = n[k]]] && (m[B] = ++v), i[s] = {
                    old: B,
                    new: m[B]
                  }, a = m[B] - s, null != w && a === h || (w && c.push(w), U.push(s), h = a), w = s;
                  for (w && c.push(w), c.push(65535), U.push(65535), N = 2 * (x = U.length), F = 2 * Math.pow(Math.log(x) / Math.LN2, 2), u = Math.log(F / 2) / Math.LN2, C = 2 * x - F, o = [], y = [], d = [], f = H = 0, P = U.length; H < P; f = ++H) {
                    if (E = U[f], l = c[f], 65535 === E) {
                      o.push(0), y.push(0);
                      break;
                    }
                    if (32768 <= E - (Q = i[E].new)) for (o.push(0), y.push(2 * (d.length + x - f)), s = I = E; E <= l ? I <= l : l <= I; s = E <= l ? ++I : --I) d.push(i[s].new);else o.push(Q - E), y.push(0);
                  }
                  for (L.writeUInt16(3), L.writeUInt16(1), L.writeUInt32(12), L.writeUInt16(4), L.writeUInt16(16 + 8 * x + 2 * d.length), L.writeUInt16(0), L.writeUInt16(N), L.writeUInt16(F), L.writeUInt16(u), L.writeUInt16(C), z = 0, j = c.length; z < j; z++) s = c[z], L.writeUInt16(s);
                  for (L.writeUInt16(0), K = 0, M = U.length; K < M; K++) s = U[K], L.writeUInt16(s);
                  for (V = 0, D = o.length; V < D; V++) a = o[V], L.writeUInt16(a);
                  for (J = 0, R = y.length; J < R; J++) b = y[J], L.writeUInt16(b);
                  for (G = 0, _ = d.length; G < _; G++) p = d[G], L.writeUInt16(p);
                  return {
                    charMap: i,
                    subtable: L.data,
                    maxGlyphID: v + 1
                  };
              }
            }, t;
          }(),
          g = function (t) {
            function e() {
              return e.__super__.constructor.apply(this, arguments);
            }
            return d(e, l), e.prototype.tag = "cmap", e.prototype.parse = function (t) {
              var e, i, s;
              for (t.pos = this.offset, this.version = t.readUInt16(), i = t.readUInt16(), this.tables = [], this.unicode = null, s = 0; 0 <= i ? s < i : i < s; 0 <= i ? ++s : --s) e = new p(t, this.offset), this.tables.push(e), e.isUnicode && null == this.unicode && (this.unicode = e);
              return !0;
            }, e.encode = function (t, e) {
              var i, s;
              return null == e && (e = "macroman"), i = p.encode(t, e), (s = new A()).writeUInt16(0), s.writeUInt16(1), i.table = s.data.concat(i.subtable), i;
            }, e;
          }(),
          w = function (t) {
            function e() {
              return e.__super__.constructor.apply(this, arguments);
            }
            return d(e, l), e.prototype.tag = "hhea", e.prototype.parse = function (t) {
              return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
            }, e;
          }(),
          m = function (t) {
            function e() {
              return e.__super__.constructor.apply(this, arguments);
            }
            return d(e, l), e.prototype.tag = "OS/2", e.prototype.parse = function (t) {
              if (t.pos = this.offset, this.version = t.readUInt16(), this.averageCharWidth = t.readShort(), this.weightClass = t.readUInt16(), this.widthClass = t.readUInt16(), this.type = t.readShort(), this.ySubscriptXSize = t.readShort(), this.ySubscriptYSize = t.readShort(), this.ySubscriptXOffset = t.readShort(), this.ySubscriptYOffset = t.readShort(), this.ySuperscriptXSize = t.readShort(), this.ySuperscriptYSize = t.readShort(), this.ySuperscriptXOffset = t.readShort(), this.ySuperscriptYOffset = t.readShort(), this.yStrikeoutSize = t.readShort(), this.yStrikeoutPosition = t.readShort(), this.familyClass = t.readShort(), this.panose = function () {
                var e, i;
                for (i = [], e = 0; e < 10; ++e) i.push(t.readByte());
                return i;
              }(), this.charRange = function () {
                var e, i;
                for (i = [], e = 0; e < 4; ++e) i.push(t.readInt());
                return i;
              }(), this.vendorID = t.readString(4), this.selection = t.readShort(), this.firstCharIndex = t.readShort(), this.lastCharIndex = t.readShort(), 0 < this.version && (this.ascent = t.readShort(), this.descent = t.readShort(), this.lineGap = t.readShort(), this.winAscent = t.readShort(), this.winDescent = t.readShort(), this.codePageRange = function () {
                var e, i;
                for (i = [], e = 0; e < 2; ++e) i.push(t.readInt());
                return i;
              }(), 1 < this.version)) return this.xHeight = t.readShort(), this.capHeight = t.readShort(), this.defaultChar = t.readShort(), this.breakChar = t.readShort(), this.maxContext = t.readShort();
            }, e;
          }(),
          v = function (t) {
            function e() {
              return e.__super__.constructor.apply(this, arguments);
            }
            return d(e, l), e.prototype.tag = "post", e.prototype.parse = function (t) {
              var e, i, s, r;
              switch (t.pos = this.offset, this.format = t.readInt(), this.italicAngle = t.readInt(), this.underlinePosition = t.readShort(), this.underlineThickness = t.readShort(), this.isFixedPitch = t.readInt(), this.minMemType42 = t.readInt(), this.maxMemType42 = t.readInt(), this.minMemType1 = t.readInt(), this.maxMemType1 = t.readInt(), this.format) {
                case 65536:
                  break;
                case 131072:
                  for (i = t.readUInt16(), this.glyphNameIndex = [], s = 0; 0 <= i ? s < i : i < s; 0 <= i ? ++s : --s) this.glyphNameIndex.push(t.readUInt16());
                  for (this.names = [], r = []; t.pos < this.offset + this.length;) e = t.readByte(), r.push(this.names.push(t.readString(e)));
                  return r;
                case 151552:
                  return i = t.readUInt16(), this.offsets = t.read(i);
                case 196608:
                  break;
                case 262144:
                  return this.map = function () {
                    var e, i, s;
                    for (s = [], e = 0, i = this.file.maxp.numGlyphs; 0 <= i ? e < i : i < e; 0 <= i ? ++e : --e) s.push(t.readUInt32());
                    return s;
                  }.call(this);
              }
            }, e;
          }(),
          b = function b(t, e) {
            this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
          },
          B = function (t) {
            function e() {
              return e.__super__.constructor.apply(this, arguments);
            }
            return d(e, l), e.prototype.tag = "name", e.prototype.parse = function (t) {
              var e, i, s, r, n, a, o, h, l, A, c, u;
              for (t.pos = this.offset, t.readShort(), e = t.readShort(), a = t.readShort(), i = [], r = l = 0; 0 <= e ? l < e : e < l; r = 0 <= e ? ++l : --l) i.push({
                platformID: t.readShort(),
                encodingID: t.readShort(),
                languageID: t.readShort(),
                nameID: t.readShort(),
                length: t.readShort(),
                offset: this.offset + a + t.readShort()
              });
              for (o = {}, r = A = 0, c = i.length; A < c; r = ++A) s = i[r], t.pos = s.offset, h = t.readString(s.length), n = new b(h, s), null == o[u = s.nameID] && (o[u] = []), o[s.nameID].push(n);
              this.strings = o, this.copyright = o[0], this.fontFamily = o[1], this.fontSubfamily = o[2], this.uniqueSubfamily = o[3], this.fontName = o[4], this.version = o[5];
              try {
                this.postscriptName = o[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
              } catch (t) {
                this.postscriptName = o[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
              }
              return this.trademark = o[7], this.manufacturer = o[8], this.designer = o[9], this.description = o[10], this.vendorUrl = o[11], this.designerUrl = o[12], this.license = o[13], this.licenseUrl = o[14], this.preferredFamily = o[15], this.preferredSubfamily = o[17], this.compatibleFull = o[18], this.sampleText = o[19];
            }, e;
          }(),
          y = function (t) {
            function e() {
              return e.__super__.constructor.apply(this, arguments);
            }
            return d(e, l), e.prototype.tag = "maxp", e.prototype.parse = function (t) {
              return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
            }, e;
          }(),
          C = function (t) {
            function e() {
              return e.__super__.constructor.apply(this, arguments);
            }
            return d(e, l), e.prototype.tag = "hmtx", e.prototype.parse = function (t) {
              var e, i, s, r, n, a, o;
              for (t.pos = this.offset, this.metrics = [], r = 0, a = this.file.hhea.numberOfMetrics; 0 <= a ? r < a : a < r; 0 <= a ? ++r : --r) this.metrics.push({
                advance: t.readUInt16(),
                lsb: t.readInt16()
              });
              for (i = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function () {
                var e, s;
                for (s = [], e = 0; 0 <= i ? e < i : i < e; 0 <= i ? ++e : --e) s.push(t.readInt16());
                return s;
              }(), this.widths = function () {
                var t, e, i, r;
                for (r = [], t = 0, e = (i = this.metrics).length; t < e; t++) s = i[t], r.push(s.advance);
                return r;
              }.call(this), e = this.widths[this.widths.length - 1], o = [], n = 0; 0 <= i ? n < i : i < n; 0 <= i ? ++n : --n) o.push(this.widths.push(e));
              return o;
            }, e.prototype.forGlyph = function (t) {
              return t in this.metrics ? this.metrics[t] : {
                advance: this.metrics[this.metrics.length - 1].advance,
                lsb: this.leftSideBearings[t - this.metrics.length]
              };
            }, e;
          }(),
          F = [].slice,
          x = function (t) {
            function e() {
              return e.__super__.constructor.apply(this, arguments);
            }
            return d(e, l), e.prototype.tag = "glyf", e.prototype.parse = function (t) {
              return this.cache = {};
            }, e.prototype.glyphFor = function (t) {
              var e, i, s, r, n, a, o, h, l, c;
              return (t = t) in this.cache ? this.cache[t] : (r = this.file.loca, e = this.file.contents, i = r.indexOf(t), 0 === (s = r.lengthOf(t)) ? this.cache[t] = null : (e.pos = this.offset + i, n = (a = new A(e.read(s))).readShort(), h = a.readShort(), c = a.readShort(), o = a.readShort(), l = a.readShort(), this.cache[t] = -1 === n ? new E(a, h, c, o, l) : new N(a, n, h, c, o, l), this.cache[t]));
            }, e.prototype.encode = function (t, e, i) {
              var s, r, n, a, o;
              for (n = [], r = [], a = 0, o = e.length; a < o; a++) s = t[e[a]], r.push(n.length), s && (n = n.concat(s.encode(i)));
              return r.push(n.length), {
                table: n,
                offsets: r
              };
            }, e;
          }(),
          N = function () {
            function t(t, e, i, s, r, n) {
              this.raw = t, this.numberOfContours = e, this.xMin = i, this.yMin = s, this.xMax = r, this.yMax = n, this.compound = !1;
            }
            return t.prototype.encode = function () {
              return this.raw.data;
            }, t;
          }(),
          E = function () {
            function t(t, e, i, s, r) {
              var n, a;
              for (this.raw = t, this.xMin = e, this.yMin = i, this.xMax = s, this.yMax = r, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], n = this.raw; a = n.readShort(), this.glyphOffsets.push(n.pos), this.glyphIDs.push(n.readShort()), 32 & a;) n.pos += 1 & a ? 4 : 2, 128 & a ? n.pos += 8 : 64 & a ? n.pos += 4 : 8 & a && (n.pos += 2);
            }
            return t.prototype.encode = function (t) {
              var e, i, s, r, n;
              for (i = new A(F.call(this.raw.data)), e = s = 0, r = (n = this.glyphIDs).length; s < r; e = ++s) n[e], i.pos = this.glyphOffsets[e];
              return i.data;
            }, t;
          }(),
          U = function (t) {
            function e() {
              return e.__super__.constructor.apply(this, arguments);
            }
            return d(e, l), e.prototype.tag = "loca", e.prototype.parse = function (t) {
              var e;
              return t.pos = this.offset, e = this.file.head.indexToLocFormat, this.offsets = 0 === e ? function () {
                var e, i, s;
                for (s = [], e = 0, i = this.length; e < i; e += 2) s.push(2 * t.readUInt16());
                return s;
              }.call(this) : function () {
                var e, i, s;
                for (s = [], e = 0, i = this.length; e < i; e += 4) s.push(t.readUInt32());
                return s;
              }.call(this);
            }, e.prototype.indexOf = function (t) {
              return this.offsets[t];
            }, e.prototype.lengthOf = function (t) {
              return this.offsets[t + 1] - this.offsets[t];
            }, e.prototype.encode = function (t, e) {
              for (var i = new Uint32Array(this.offsets.length), s = 0, r = 0, n = 0; n < i.length; ++n) if (i[n] = s, r < e.length && e[r] == n) {
                ++r, i[n] = s;
                var a = this.offsets[n],
                  o = this.offsets[n + 1] - a;
                0 < o && (s += o);
              }
              for (var h = new Array(4 * i.length), l = 0; l < i.length; ++l) h[4 * l + 3] = 255 & i[l], h[4 * l + 2] = (65280 & i[l]) >> 8, h[4 * l + 1] = (16711680 & i[l]) >> 16, h[4 * l] = (4278190080 & i[l]) >> 24;
              return h;
            }, e;
          }(),
          Q = function () {
            function t(t) {
              this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
            }
            return t.prototype.generateCmap = function () {
              var t, e, i, s, r;
              for (e in s = this.font.cmap.tables[0].codeMap, t = {}, r = this.subset) i = r[e], t[e] = s[i];
              return t;
            }, t.prototype.glyphsFor = function (t) {
              var e, i, s, r, n, a, o;
              for (s = {}, n = 0, a = t.length; n < a; n++) s[r = t[n]] = this.font.glyf.glyphFor(r);
              for (r in e = [], s) (null != (i = s[r]) ? i.compound : void 0) && e.push.apply(e, i.glyphIDs);
              if (0 < e.length) for (r in o = this.glyphsFor(e)) i = o[r], s[r] = i;
              return s;
            }, t.prototype.encode = function (t, e) {
              var i, s, r, n, a, o, h, l, A, c, u, d, f, p, w;
              for (s in i = g.encode(this.generateCmap(), "unicode"), n = this.glyphsFor(t), u = {
                0: 0
              }, w = i.charMap) u[(o = w[s]).old] = o.new;
              for (d in c = i.maxGlyphID, n) d in u || (u[d] = c++);
              return l = function (t) {
                var e, i;
                for (e in i = {}, t) i[t[e]] = e;
                return i;
              }(u), A = Object.keys(l).sort(function (t, e) {
                return t - e;
              }), f = function () {
                var t, e, i;
                for (i = [], t = 0, e = A.length; t < e; t++) a = A[t], i.push(l[a]);
                return i;
              }(), r = this.font.glyf.encode(n, f, u), h = this.font.loca.encode(r.offsets, f), p = {
                cmap: this.font.cmap.raw(),
                glyf: r.table,
                loca: h,
                hmtx: this.font.hmtx.raw(),
                hhea: this.font.hhea.raw(),
                maxp: this.font.maxp.raw(),
                post: this.font.post.raw(),
                name: this.font.name.raw(),
                head: this.font.head.encode(e)
              }, this.font.os2.exists && (p["OS/2"] = this.font.os2.raw()), this.font.directory.encode(p);
            }, t;
          }();
        t.API.PDFObject = function () {
          var t;
          function e() {}
          return t = function t(_t5, e) {
            return (Array(e + 1).join("0") + _t5).slice(-e);
          }, e.convert = function (i) {
            var s, r, n, a;
            if (Array.isArray(i)) return "[" + function () {
              var t, r, n;
              for (n = [], t = 0, r = i.length; t < r; t++) s = i[t], n.push(e.convert(s));
              return n;
            }().join(" ") + "]";
            if ("string" == typeof i) return "/" + i;
            if (null != i ? i.isString : void 0) return "(" + i + ")";
            if (i instanceof Date) return "(D:" + t(i.getUTCFullYear(), 4) + t(i.getUTCMonth(), 2) + t(i.getUTCDate(), 2) + t(i.getUTCHours(), 2) + t(i.getUTCMinutes(), 2) + t(i.getUTCSeconds(), 2) + "Z)";
            if ("[object Object]" !== {}.toString.call(i)) return "" + i;
            for (r in n = ["<<"], i) a = i[r], n.push("/" + r + " " + e.convert(a));
            return n.push(">>"), n.join("\n");
          }, e;
        }();
      }(ft), Ut = "undefined" != typeof self && self || "undefined" != typeof window && window || void 0 !== s && s || Function('return typeof this === "object" && this.content')() || Function("return this")(), Qt = function () {
        var t, e, i;
        function s(t) {
          var e, i, s, r, n, a, o, h, l, A, c, u, d, f;
          for (this.data = t, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, a = null;;) {
            switch (e = this.readUInt32(), l = function () {
              var t, e;
              for (e = [], t = 0; t < 4; ++t) e.push(String.fromCharCode(this.data[this.pos++]));
              return e;
            }.call(this).join("")) {
              case "IHDR":
                this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
                break;
              case "acTL":
                this.animation = {
                  numFrames: this.readUInt32(),
                  numPlays: this.readUInt32() || 1 / 0,
                  frames: []
                };
                break;
              case "PLTE":
                this.palette = this.read(e);
                break;
              case "fcTL":
                a && this.animation.frames.push(a), this.pos += 4, a = {
                  width: this.readUInt32(),
                  height: this.readUInt32(),
                  xOffset: this.readUInt32(),
                  yOffset: this.readUInt32()
                }, n = this.readUInt16(), r = this.readUInt16() || 100, a.delay = 1e3 * n / r, a.disposeOp = this.data[this.pos++], a.blendOp = this.data[this.pos++], a.data = [];
                break;
              case "IDAT":
              case "fdAT":
                for ("fdAT" === l && (this.pos += 4, e -= 4), t = (null != a ? a.data : void 0) || this.imgData, u = 0; 0 <= e ? u < e : e < u; 0 <= e ? ++u : --u) t.push(this.data[this.pos++]);
                break;
              case "tRNS":
                switch (this.transparency = {}, this.colorType) {
                  case 3:
                    if (s = this.palette.length / 3, this.transparency.indexed = this.read(e), this.transparency.indexed.length > s) throw new Error("More transparent colors than palette size");
                    if (0 < (A = s - this.transparency.indexed.length)) for (d = 0; 0 <= A ? d < A : A < d; 0 <= A ? ++d : --d) this.transparency.indexed.push(255);
                    break;
                  case 0:
                    this.transparency.grayscale = this.read(e)[0];
                    break;
                  case 2:
                    this.transparency.rgb = this.read(e);
                }
                break;
              case "tEXt":
                o = (c = this.read(e)).indexOf(0), h = String.fromCharCode.apply(String, c.slice(0, o)), this.text[h] = String.fromCharCode.apply(String, c.slice(o + 1));
                break;
              case "IEND":
                return a && this.animation.frames.push(a), this.colors = function () {
                  switch (this.colorType) {
                    case 0:
                    case 3:
                    case 4:
                      return 1;
                    case 2:
                    case 6:
                      return 3;
                  }
                }.call(this), this.hasAlphaChannel = 4 === (f = this.colorType) || 6 === f, i = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * i, this.colorSpace = function () {
                  switch (this.colors) {
                    case 1:
                      return "DeviceGray";
                    case 3:
                      return "DeviceRGB";
                  }
                }.call(this), void (this.imgData = new Uint8Array(this.imgData));
              default:
                this.pos += e;
            }
            if (this.pos += 4, this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
          }
        }
        s.load = function (t, e, i) {
          var r;
          return "function" == typeof e && (i = e), (r = new XMLHttpRequest()).open("GET", t, !0), r.responseType = "arraybuffer", r.onload = function () {
            var t;
            return t = new s(new Uint8Array(r.response || r.mozResponseArrayBuffer)), "function" == typeof (null != e ? e.getContext : void 0) && t.render(e), "function" == typeof i ? i(t) : void 0;
          }, r.send(null);
        }, s.prototype.read = function (t) {
          var e, i;
          for (i = [], e = 0; 0 <= t ? e < t : t < e; 0 <= t ? ++e : --e) i.push(this.data[this.pos++]);
          return i;
        }, s.prototype.readUInt32 = function () {
          return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
        }, s.prototype.readUInt16 = function () {
          return this.data[this.pos++] << 8 | this.data[this.pos++];
        }, s.prototype.decodePixels = function (t) {
          var e = this.pixelBitlength / 8,
            i = new Uint8Array(this.width * this.height * e),
            s = 0,
            r = this;
          if (null == t && (t = this.imgData), 0 === t.length) return new Uint8Array(0);
          function n(n, a, o, h) {
            var l,
              A,
              c,
              u,
              d,
              f,
              p,
              g,
              w,
              m,
              v,
              b,
              B,
              y,
              C,
              F,
              x,
              N,
              E,
              U,
              Q,
              L = Math.ceil((r.width - n) / o),
              S = Math.ceil((r.height - a) / h),
              k = r.width == L && r.height == S;
            for (y = e * L, b = k ? i : new Uint8Array(y * S), f = t.length, A = B = 0; B < S && s < f;) {
              switch (t[s++]) {
                case 0:
                  for (u = x = 0; x < y; u = x += 1) b[A++] = t[s++];
                  break;
                case 1:
                  for (u = N = 0; N < y; u = N += 1) l = t[s++], d = u < e ? 0 : b[A - e], b[A++] = (l + d) % 256;
                  break;
                case 2:
                  for (u = E = 0; E < y; u = E += 1) l = t[s++], c = (u - u % e) / e, C = B && b[(B - 1) * y + c * e + u % e], b[A++] = (C + l) % 256;
                  break;
                case 3:
                  for (u = U = 0; U < y; u = U += 1) l = t[s++], c = (u - u % e) / e, d = u < e ? 0 : b[A - e], C = B && b[(B - 1) * y + c * e + u % e], b[A++] = (l + Math.floor((d + C) / 2)) % 256;
                  break;
                case 4:
                  for (u = Q = 0; Q < y; u = Q += 1) l = t[s++], c = (u - u % e) / e, d = u < e ? 0 : b[A - e], 0 === B ? C = F = 0 : (C = b[(B - 1) * y + c * e + u % e], F = c && b[(B - 1) * y + (c - 1) * e + u % e]), p = d + C - F, g = Math.abs(p - d), m = Math.abs(p - C), v = Math.abs(p - F), w = g <= m && g <= v ? d : m <= v ? C : F, b[A++] = (l + w) % 256;
                  break;
                default:
                  throw new Error("Invalid filter algorithm: " + t[s - 1]);
              }
              if (!k) {
                var H = ((a + B * h) * r.width + n) * e,
                  I = B * y;
                for (u = 0; u < L; u += 1) {
                  for (var O = 0; O < e; O += 1) i[H++] = b[I++];
                  H += (o - 1) * e;
                }
              }
              B++;
            }
          }
          return t = (t = new Tt(t)).getBytes(), 1 == r.interlaceMethod ? (n(0, 0, 8, 8), n(4, 0, 8, 8), n(0, 4, 4, 8), n(2, 0, 4, 4), n(0, 2, 2, 4), n(1, 0, 2, 2), n(0, 1, 1, 2)) : n(0, 0, 1, 1), i;
        }, s.prototype.decodePalette = function () {
          var t, e, i, s, r, n, a, o, h;
          for (i = this.palette, n = this.transparency.indexed || [], r = new Uint8Array((n.length || 0) + i.length), s = 0, i.length, e = a = t = 0, o = i.length; a < o; e = a += 3) r[s++] = i[e], r[s++] = i[e + 1], r[s++] = i[e + 2], r[s++] = null != (h = n[t++]) ? h : 255;
          return r;
        }, s.prototype.copyToImageData = function (t, e) {
          var i, s, r, n, a, o, h, l, A, c, u;
          if (s = this.colors, A = null, i = this.hasAlphaChannel, this.palette.length && (A = null != (u = this._decodedPalette) ? u : this._decodedPalette = this.decodePalette(), s = 4, i = !0), l = (r = t.data || t).length, a = A || e, n = o = 0, 1 === s) for (; n < l;) h = A ? 4 * e[n / 4] : o, c = a[h++], r[n++] = c, r[n++] = c, r[n++] = c, r[n++] = i ? a[h++] : 255, o = h;else for (; n < l;) h = A ? 4 * e[n / 4] : o, r[n++] = a[h++], r[n++] = a[h++], r[n++] = a[h++], r[n++] = i ? a[h++] : 255, o = h;
        }, s.prototype.decode = function () {
          var t;
          return t = new Uint8Array(this.width * this.height * 4), this.copyToImageData(t, this.decodePixels()), t;
        };
        try {
          e = Ut.document.createElement("canvas"), i = e.getContext("2d");
        } catch (t) {
          return -1;
        }
        return t = function t(_t6) {
          var s;
          return i.width = _t6.width, i.height = _t6.height, i.clearRect(0, 0, _t6.width, _t6.height), i.putImageData(_t6, 0, 0), (s = new Image()).src = e.toDataURL(), s;
        }, s.prototype.decodeFrames = function (e) {
          var i, s, r, n, a, o, h, l;
          if (this.animation) {
            for (l = [], s = a = 0, o = (h = this.animation.frames).length; a < o; s = ++a) i = h[s], r = e.createImageData(i.width, i.height), n = this.decodePixels(new Uint8Array(i.data)), this.copyToImageData(r, n), i.imageData = r, l.push(i.image = t(r));
            return l;
          }
        }, s.prototype.renderFrame = function (t, e) {
          var i, s, r;
          return i = (s = this.animation.frames)[e], r = s[e - 1], 0 === e && t.clearRect(0, 0, this.width, this.height), 1 === (null != r ? r.disposeOp : void 0) ? t.clearRect(r.xOffset, r.yOffset, r.width, r.height) : 2 === (null != r ? r.disposeOp : void 0) && t.putImageData(r.imageData, r.xOffset, r.yOffset), 0 === i.blendOp && t.clearRect(i.xOffset, i.yOffset, i.width, i.height), t.drawImage(i.image, i.xOffset, i.yOffset);
        }, s.prototype.animate = function (t) {
          var _e127,
            i,
            s,
            r,
            n,
            a,
            o = this;
          return i = 0, a = this.animation, r = a.numFrames, s = a.frames, n = a.numPlays, (_e127 = function e() {
            var a, h;
            if (a = i++ % r, h = s[a], o.renderFrame(t, a), 1 < r && i / r < n) return o.animation._timeout = setTimeout(_e127, h.delay);
          })();
        }, s.prototype.stopAnimation = function () {
          var t;
          return clearTimeout(null != (t = this.animation) ? t._timeout : void 0);
        }, s.prototype.render = function (t) {
          var e, i;
          return t._png && t._png.stopAnimation(), t._png = this, t.width = this.width, t.height = this.height, e = t.getContext("2d"), this.animation ? (this.decodeFrames(e), this.animate(e)) : (i = e.createImageData(this.width, this.height), this.copyToImageData(i, this.decodePixels()), e.putImageData(i, 0, 0));
        }, s;
      }(), Ut.PNG = Qt;
      var Ot = function () {
          function t() {
            this.pos = 0, this.bufferLength = 0, this.eof = !1, this.buffer = null;
          }
          return t.prototype = {
            ensureBuffer: function ensureBuffer(t) {
              var e = this.buffer,
                i = e ? e.byteLength : 0;
              if (t < i) return e;
              for (var s = 512; s < t;) s <<= 1;
              for (var r = new Uint8Array(s), n = 0; n < i; ++n) r[n] = e[n];
              return this.buffer = r;
            },
            getByte: function getByte() {
              for (var t = this.pos; this.bufferLength <= t;) {
                if (this.eof) return null;
                this.readBlock();
              }
              return this.buffer[this.pos++];
            },
            getBytes: function getBytes(t) {
              var e = this.pos;
              if (t) {
                this.ensureBuffer(e + t);
                for (var i = e + t; !this.eof && this.bufferLength < i;) this.readBlock();
                var s = this.bufferLength;
                s < i && (i = s);
              } else {
                for (; !this.eof;) this.readBlock();
                i = this.bufferLength;
              }
              return this.pos = i, this.buffer.subarray(e, i);
            },
            lookChar: function lookChar() {
              for (var t = this.pos; this.bufferLength <= t;) {
                if (this.eof) return null;
                this.readBlock();
              }
              return String.fromCharCode(this.buffer[this.pos]);
            },
            getChar: function getChar() {
              for (var t = this.pos; this.bufferLength <= t;) {
                if (this.eof) return null;
                this.readBlock();
              }
              return String.fromCharCode(this.buffer[this.pos++]);
            },
            makeSubStream: function makeSubStream(t, e, i) {
              for (var s = t + e; this.bufferLength <= s && !this.eof;) this.readBlock();
              return new Stream(this.buffer, t, e, i);
            },
            skip: function skip(t) {
              t || (t = 1), this.pos += t;
            },
            reset: function reset() {
              this.pos = 0;
            }
          }, t;
        }(),
        Tt = function () {
          if ("undefined" != typeof Uint32Array) {
            var t = new Uint32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
              e = new Uint32Array([3, 4, 5, 6, 7, 8, 9, 10, 65547, 65549, 65551, 65553, 131091, 131095, 131099, 131103, 196643, 196651, 196659, 196667, 262211, 262227, 262243, 262259, 327811, 327843, 327875, 327907, 258, 258, 258]),
              i = new Uint32Array([1, 2, 3, 4, 65541, 65543, 131081, 131085, 196625, 196633, 262177, 262193, 327745, 327777, 393345, 393409, 459009, 459137, 524801, 525057, 590849, 591361, 657409, 658433, 724993, 727041, 794625, 798721, 868353, 876545]),
              s = [new Uint32Array([459008, 524368, 524304, 524568, 459024, 524400, 524336, 590016, 459016, 524384, 524320, 589984, 524288, 524416, 524352, 590048, 459012, 524376, 524312, 589968, 459028, 524408, 524344, 590032, 459020, 524392, 524328, 59e4, 524296, 524424, 524360, 590064, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590024, 459018, 524388, 524324, 589992, 524292, 524420, 524356, 590056, 459014, 524380, 524316, 589976, 459030, 524412, 524348, 590040, 459022, 524396, 524332, 590008, 524300, 524428, 524364, 590072, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590020, 459017, 524386, 524322, 589988, 524290, 524418, 524354, 590052, 459013, 524378, 524314, 589972, 459029, 524410, 524346, 590036, 459021, 524394, 524330, 590004, 524298, 524426, 524362, 590068, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590028, 459019, 524390, 524326, 589996, 524294, 524422, 524358, 590060, 459015, 524382, 524318, 589980, 459031, 524414, 524350, 590044, 459023, 524398, 524334, 590012, 524302, 524430, 524366, 590076, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590018, 459016, 524385, 524321, 589986, 524289, 524417, 524353, 590050, 459012, 524377, 524313, 589970, 459028, 524409, 524345, 590034, 459020, 524393, 524329, 590002, 524297, 524425, 524361, 590066, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590026, 459018, 524389, 524325, 589994, 524293, 524421, 524357, 590058, 459014, 524381, 524317, 589978, 459030, 524413, 524349, 590042, 459022, 524397, 524333, 590010, 524301, 524429, 524365, 590074, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590022, 459017, 524387, 524323, 589990, 524291, 524419, 524355, 590054, 459013, 524379, 524315, 589974, 459029, 524411, 524347, 590038, 459021, 524395, 524331, 590006, 524299, 524427, 524363, 590070, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590030, 459019, 524391, 524327, 589998, 524295, 524423, 524359, 590062, 459015, 524383, 524319, 589982, 459031, 524415, 524351, 590046, 459023, 524399, 524335, 590014, 524303, 524431, 524367, 590078, 459008, 524368, 524304, 524568, 459024, 524400, 524336, 590017, 459016, 524384, 524320, 589985, 524288, 524416, 524352, 590049, 459012, 524376, 524312, 589969, 459028, 524408, 524344, 590033, 459020, 524392, 524328, 590001, 524296, 524424, 524360, 590065, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590025, 459018, 524388, 524324, 589993, 524292, 524420, 524356, 590057, 459014, 524380, 524316, 589977, 459030, 524412, 524348, 590041, 459022, 524396, 524332, 590009, 524300, 524428, 524364, 590073, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590021, 459017, 524386, 524322, 589989, 524290, 524418, 524354, 590053, 459013, 524378, 524314, 589973, 459029, 524410, 524346, 590037, 459021, 524394, 524330, 590005, 524298, 524426, 524362, 590069, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590029, 459019, 524390, 524326, 589997, 524294, 524422, 524358, 590061, 459015, 524382, 524318, 589981, 459031, 524414, 524350, 590045, 459023, 524398, 524334, 590013, 524302, 524430, 524366, 590077, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590019, 459016, 524385, 524321, 589987, 524289, 524417, 524353, 590051, 459012, 524377, 524313, 589971, 459028, 524409, 524345, 590035, 459020, 524393, 524329, 590003, 524297, 524425, 524361, 590067, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590027, 459018, 524389, 524325, 589995, 524293, 524421, 524357, 590059, 459014, 524381, 524317, 589979, 459030, 524413, 524349, 590043, 459022, 524397, 524333, 590011, 524301, 524429, 524365, 590075, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590023, 459017, 524387, 524323, 589991, 524291, 524419, 524355, 590055, 459013, 524379, 524315, 589975, 459029, 524411, 524347, 590039, 459021, 524395, 524331, 590007, 524299, 524427, 524363, 590071, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590031, 459019, 524391, 524327, 589999, 524295, 524423, 524359, 590063, 459015, 524383, 524319, 589983, 459031, 524415, 524351, 590047, 459023, 524399, 524335, 590015, 524303, 524431, 524367, 590079]), 9],
              r = [new Uint32Array([327680, 327696, 327688, 327704, 327684, 327700, 327692, 327708, 327682, 327698, 327690, 327706, 327686, 327702, 327694, 0, 327681, 327697, 327689, 327705, 327685, 327701, 327693, 327709, 327683, 327699, 327691, 327707, 327687, 327703, 327695, 0]), 5];
            return (a.prototype = Object.create(Ot.prototype)).getBits = function (t) {
              for (var e, i = this.codeSize, s = this.codeBuf, r = this.bytes, a = this.bytesPos; i < t;) void 0 === (e = r[a++]) && n("Bad encoding in flate stream"), s |= e << i, i += 8;
              return e = s & (1 << t) - 1, this.codeBuf = s >> t, this.codeSize = i -= t, this.bytesPos = a, e;
            }, a.prototype.getCode = function (t) {
              for (var e = t[0], i = t[1], s = this.codeSize, r = this.codeBuf, a = this.bytes, o = this.bytesPos; s < i;) {
                var h;
                void 0 === (h = a[o++]) && n("Bad encoding in flate stream"), r |= h << s, s += 8;
              }
              var l = e[r & (1 << i) - 1],
                A = l >> 16,
                c = 65535 & l;
              return (0 == s || s < A || 0 == A) && n("Bad encoding in flate stream"), this.codeBuf = r >> A, this.codeSize = s - A, this.bytesPos = o, c;
            }, a.prototype.generateHuffmanTable = function (t) {
              for (var e = t.length, i = 0, s = 0; s < e; ++s) t[s] > i && (i = t[s]);
              for (var r = 1 << i, n = new Uint32Array(r), a = 1, o = 0, h = 2; a <= i; ++a, o <<= 1, h <<= 1) for (var l = 0; l < e; ++l) if (t[l] == a) {
                var A = 0,
                  c = o;
                for (s = 0; s < a; ++s) A = A << 1 | 1 & c, c >>= 1;
                for (s = A; s < r; s += h) n[s] = a << 16 | l;
                ++o;
              }
              return [n, i];
            }, a.prototype.readBlock = function () {
              function a(t, e, i, s, r) {
                for (var n = t.getBits(i) + s; 0 < n--;) e[f++] = r;
              }
              var o = this.getBits(3);
              if (1 & o && (this.eof = !0), 0 != (o >>= 1)) {
                var h, l;
                if (1 == o) h = s, l = r;else if (2 == o) {
                  for (var A = this.getBits(5) + 257, c = this.getBits(5) + 1, u = this.getBits(4) + 4, d = Array(t.length), f = 0; f < u;) d[t[f++]] = this.getBits(3);
                  for (var p = this.generateHuffmanTable(d), g = 0, w = (f = 0, A + c), m = new Array(w); f < w;) {
                    var v = this.getCode(p);
                    16 == v ? a(this, m, 2, 3, g) : 17 == v ? a(this, m, 3, 3, g = 0) : 18 == v ? a(this, m, 7, 11, g = 0) : m[f++] = g = v;
                  }
                  h = this.generateHuffmanTable(m.slice(0, A)), l = this.generateHuffmanTable(m.slice(A, w));
                } else n("Unknown block type in flate stream");
                for (var b = (k = this.buffer) ? k.length : 0, B = this.bufferLength;;) {
                  var y = this.getCode(h);
                  if (y < 256) b <= B + 1 && (b = (k = this.ensureBuffer(B + 1)).length), k[B++] = y;else {
                    if (256 == y) return void (this.bufferLength = B);
                    var C = (y = e[y -= 257]) >> 16;
                    0 < C && (C = this.getBits(C)), g = (65535 & y) + C, y = this.getCode(l), 0 < (C = (y = i[y]) >> 16) && (C = this.getBits(C));
                    var F = (65535 & y) + C;
                    b <= B + g && (b = (k = this.ensureBuffer(B + g)).length);
                    for (var x = 0; x < g; ++x, ++B) k[B] = k[B - F];
                  }
                }
              } else {
                var N,
                  E = this.bytes,
                  U = this.bytesPos;
                void 0 === (N = E[U++]) && n("Bad block header in flate stream");
                var Q = N;
                void 0 === (N = E[U++]) && n("Bad block header in flate stream"), Q |= N << 8, void 0 === (N = E[U++]) && n("Bad block header in flate stream");
                var L = N;
                void 0 === (N = E[U++]) && n("Bad block header in flate stream"), (L |= N << 8) != (65535 & ~Q) && n("Bad uncompressed block length in flate stream"), this.codeBuf = 0, this.codeSize = 0;
                var S = this.bufferLength,
                  k = this.ensureBuffer(S + Q),
                  H = S + Q;
                this.bufferLength = H;
                for (var I = S; I < H; ++I) {
                  if (void 0 === (N = E[U++])) {
                    this.eof = !0;
                    break;
                  }
                  k[I] = N;
                }
                this.bytesPos = U;
              }
            }, a;
          }
          function n(t) {
            throw new Error(t);
          }
          function a(t) {
            var e = 0,
              i = t[e++],
              s = t[e++];
            -1 != i && -1 != s || n("Invalid header in flate stream"), 8 != (15 & i) && n("Unknown compression method in flate stream"), ((i << 8) + s) % 31 != 0 && n("Bad FCHECK in flate stream"), 32 & s && n("FDICT bit set in flate stream"), this.bytes = t, this.bytesPos = 2, this.codeSize = 0, this.codeBuf = 0, Ot.call(this);
          }
        }();
      window.tmp = Tt;
    }();
    try {
      t.exports = jsPDF;
    } catch (t) {}
    /** @license html2canvas 1.0.0-rc.1 | Copyright (c) 2019 Niklas von Hertzen [https://html2canvas.hertzen.com] | MIT License [https://github.com/niklasvh/html2canvas/blob/master/LICENSE] */
    c = function c() {
      return function (t) {
        var e = {};
        function i(s) {
          if (e[s]) return e[s].exports;
          var r = e[s] = {
            i: s,
            l: !1,
            exports: {}
          };
          return t[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
        }
        return i.m = t, i.c = e, i.d = function (t, e, s) {
          i.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: s
          });
        }, i.r = function (t) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(t, "__esModule", {
            value: !0
          });
        }, i.t = function (t, e) {
          if (1 & e && (t = i(t)), 8 & e) return t;
          if (4 & e && "object" == typeof t && t && t.__esModule) return t;
          var s = Object.create(null);
          if (i.r(s), Object.defineProperty(s, "default", {
            enumerable: !0,
            value: t
          }), 2 & e && "string" != typeof t) for (var r in t) i.d(s, r, function (e) {
            return t[e];
          }.bind(null, r));
          return s;
        }, i.n = function (t) {
          var e = t && t.__esModule ? function () {
            return t.default;
          } : function () {
            return t;
          };
          return i.d(e, "a", e), e;
        }, i.o = function (t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }, i.p = "", i(i.s = 5);
      }([function (t, e, i) {
        "use strict";

        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var s = i(1);
        Object.defineProperty(e, "toCodePoints", {
          enumerable: !0,
          get: function get() {
            return s.toCodePoints;
          }
        }), Object.defineProperty(e, "fromCodePoint", {
          enumerable: !0,
          get: function get() {
            return s.fromCodePoint;
          }
        });
        var r = i(2);
        Object.defineProperty(e, "LineBreaker", {
          enumerable: !0,
          get: function get() {
            return r.LineBreaker;
          }
        });
      }, function (t, e, i) {
        "use strict";

        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.toCodePoints = function (t) {
          for (var e = [], i = 0, s = t.length; i < s;) {
            var r = t.charCodeAt(i++);
            if (r >= 55296 && r <= 56319 && i < s) {
              var n = t.charCodeAt(i++);
              56320 == (64512 & n) ? e.push(((1023 & r) << 10) + (1023 & n) + 65536) : (e.push(r), i--);
            } else e.push(r);
          }
          return e;
        }, e.fromCodePoint = function () {
          if (String.fromCodePoint) return String.fromCodePoint.apply(String, arguments);
          var t = arguments.length;
          if (!t) return "";
          for (var e = [], i = -1, s = ""; ++i < t;) {
            var r = arguments.length <= i ? void 0 : arguments[i];
            r <= 65535 ? e.push(r) : (r -= 65536, e.push(55296 + (r >> 10), r % 1024 + 56320)), (i + 1 === t || e.length > 16384) && (s += String.fromCharCode.apply(String, e), e.length = 0);
          }
          return s;
        };
        for (var s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", r = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256), n = 0; n < s.length; n++) r[s.charCodeAt(n)] = n;
        e.decode = function (t) {
          var e = .75 * t.length,
            i = t.length,
            s = void 0,
            n = 0,
            a = void 0,
            o = void 0,
            h = void 0,
            l = void 0;
          "=" === t[t.length - 1] && (e--, "=" === t[t.length - 2] && e--);
          var A = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array && void 0 !== Uint8Array.prototype.slice ? new ArrayBuffer(e) : new Array(e),
            c = Array.isArray(A) ? A : new Uint8Array(A);
          for (s = 0; s < i; s += 4) a = r[t.charCodeAt(s)], o = r[t.charCodeAt(s + 1)], h = r[t.charCodeAt(s + 2)], l = r[t.charCodeAt(s + 3)], c[n++] = a << 2 | o >> 4, c[n++] = (15 & o) << 4 | h >> 2, c[n++] = (3 & h) << 6 | 63 & l;
          return A;
        }, e.polyUint16Array = function (t) {
          for (var e = t.length, i = [], s = 0; s < e; s += 2) i.push(t[s + 1] << 8 | t[s]);
          return i;
        }, e.polyUint32Array = function (t) {
          for (var e = t.length, i = [], s = 0; s < e; s += 4) i.push(t[s + 3] << 24 | t[s + 2] << 16 | t[s + 1] << 8 | t[s]);
          return i;
        };
      }, function (t, e, i) {
        "use strict";

        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.LineBreaker = e.inlineBreakOpportunities = e.lineBreakAtIndex = e.codePointsToCharacterClasses = e.UnicodeTrie = e.BREAK_ALLOWED = e.BREAK_NOT_ALLOWED = e.BREAK_MANDATORY = e.classes = e.LETTER_NUMBER_MODIFIER = void 0;
        var s = function () {
            function t(t, e) {
              for (var i = 0; i < e.length; i++) {
                var s = e[i];
                s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
              }
            }
            return function (e, i, s) {
              return i && t(e.prototype, i), s && t(e, s), e;
            };
          }(),
          r = function r(t, e) {
            if (Array.isArray(t)) return t;
            if (Symbol.iterator in Object(t)) return function (t, e) {
              var i = [],
                s = !0,
                r = !1,
                n = void 0;
              try {
                for (var a, o = t[Symbol.iterator](); !(s = (a = o.next()).done) && (i.push(a.value), !e || i.length !== e); s = !0);
              } catch (t) {
                r = !0, n = t;
              } finally {
                try {
                  !s && o.return && o.return();
                } finally {
                  if (r) throw n;
                }
              }
              return i;
            }(t, e);
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          },
          n = i(3),
          a = function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          }(i(4)),
          o = i(1),
          h = e.LETTER_NUMBER_MODIFIER = 50,
          l = 10,
          A = 13,
          c = 15,
          u = 17,
          d = 18,
          f = 19,
          p = 20,
          g = 21,
          w = 22,
          m = 24,
          v = 25,
          b = 26,
          B = 27,
          y = 28,
          C = 30,
          F = 32,
          x = 33,
          N = 34,
          E = 35,
          U = 37,
          Q = 38,
          L = 39,
          S = 40,
          k = 42,
          H = (e.classes = {
            BK: 1,
            CR: 2,
            LF: 3,
            CM: 4,
            NL: 5,
            SG: 6,
            WJ: 7,
            ZW: 8,
            GL: 9,
            SP: l,
            ZWJ: 11,
            B2: 12,
            BA: A,
            BB: 14,
            HY: c,
            CB: 16,
            CL: u,
            CP: d,
            EX: f,
            IN: p,
            NS: g,
            OP: w,
            QU: 23,
            IS: m,
            NU: v,
            PO: b,
            PR: B,
            SY: y,
            AI: 29,
            AL: C,
            CJ: 31,
            EB: F,
            EM: x,
            H2: N,
            H3: E,
            HL: 36,
            ID: U,
            JL: Q,
            JV: L,
            JT: S,
            RI: 41,
            SA: k,
            XX: 43
          }, e.BREAK_MANDATORY = "!"),
          I = e.BREAK_NOT_ALLOWED = "×",
          O = e.BREAK_ALLOWED = "÷",
          T = e.UnicodeTrie = (0, n.createTrieFromBase64)(a.default),
          P = [C, 36],
          j = [1, 2, 3, 5],
          M = [l, 8],
          D = [B, b],
          R = j.concat(M),
          _ = [Q, L, S, N, E],
          z = [c, A],
          K = e.codePointsToCharacterClasses = function (t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "strict",
              i = [],
              s = [],
              r = [];
            return t.forEach(function (t, n) {
              var a = T.get(t);
              if (a > h ? (r.push(!0), a -= h) : r.push(!1), -1 !== ["normal", "auto", "loose"].indexOf(e) && -1 !== [8208, 8211, 12316, 12448].indexOf(t)) return s.push(n), i.push(16);
              if (4 === a || 11 === a) {
                if (0 === n) return s.push(n), i.push(C);
                var o = i[n - 1];
                return -1 === R.indexOf(o) ? (s.push(s[n - 1]), i.push(o)) : (s.push(n), i.push(C));
              }
              return s.push(n), 31 === a ? i.push("strict" === e ? g : U) : a === k || 29 === a ? i.push(C) : 43 === a ? t >= 131072 && t <= 196605 || t >= 196608 && t <= 262141 ? i.push(U) : i.push(C) : void i.push(a);
            }), [s, i, r];
          },
          q = function q(t, e, i, s) {
            var r = s[i];
            if (Array.isArray(t) ? -1 !== t.indexOf(r) : t === r) for (var n = i; n <= s.length;) {
              var a = s[++n];
              if (a === e) return !0;
              if (a !== l) break;
            }
            if (r === l) for (var o = i; o > 0;) {
              var h = s[--o];
              if (Array.isArray(t) ? -1 !== t.indexOf(h) : t === h) for (var A = i; A <= s.length;) {
                var c = s[++A];
                if (c === e) return !0;
                if (c !== l) break;
              }
              if (h !== l) break;
            }
            return !1;
          },
          V = function V(t, e) {
            for (var i = t; i >= 0;) {
              var s = e[i];
              if (s !== l) return s;
              i--;
            }
            return 0;
          },
          J = function J(t, e, i, s, r) {
            if (0 === i[s]) return I;
            var n = s - 1;
            if (Array.isArray(r) && !0 === r[n]) return I;
            var a = n - 1,
              o = n + 1,
              h = e[n],
              C = a >= 0 ? e[a] : 0,
              k = e[o];
            if (2 === h && 3 === k) return I;
            if (-1 !== j.indexOf(h)) return H;
            if (-1 !== j.indexOf(k)) return I;
            if (-1 !== M.indexOf(k)) return I;
            if (8 === V(n, e)) return O;
            if (11 === T.get(t[n]) && (k === U || k === F || k === x)) return I;
            if (7 === h || 7 === k) return I;
            if (9 === h) return I;
            if (-1 === [l, A, c].indexOf(h) && 9 === k) return I;
            if (-1 !== [u, d, f, m, y].indexOf(k)) return I;
            if (V(n, e) === w) return I;
            if (q(23, w, n, e)) return I;
            if (q([u, d], g, n, e)) return I;
            if (q(12, 12, n, e)) return I;
            if (h === l) return O;
            if (23 === h || 23 === k) return I;
            if (16 === k || 16 === h) return O;
            if (-1 !== [A, c, g].indexOf(k) || 14 === h) return I;
            if (36 === C && -1 !== z.indexOf(h)) return I;
            if (h === y && 36 === k) return I;
            if (k === p && -1 !== P.concat(p, f, v, U, F, x).indexOf(h)) return I;
            if (-1 !== P.indexOf(k) && h === v || -1 !== P.indexOf(h) && k === v) return I;
            if (h === B && -1 !== [U, F, x].indexOf(k) || -1 !== [U, F, x].indexOf(h) && k === b) return I;
            if (-1 !== P.indexOf(h) && -1 !== D.indexOf(k) || -1 !== D.indexOf(h) && -1 !== P.indexOf(k)) return I;
            if (-1 !== [B, b].indexOf(h) && (k === v || -1 !== [w, c].indexOf(k) && e[o + 1] === v) || -1 !== [w, c].indexOf(h) && k === v || h === v && -1 !== [v, y, m].indexOf(k)) return I;
            if (-1 !== [v, y, m, u, d].indexOf(k)) for (var R = n; R >= 0;) {
              var K = e[R];
              if (K === v) return I;
              if (-1 === [y, m].indexOf(K)) break;
              R--;
            }
            if (-1 !== [B, b].indexOf(k)) for (var J = -1 !== [u, d].indexOf(h) ? a : n; J >= 0;) {
              var G = e[J];
              if (G === v) return I;
              if (-1 === [y, m].indexOf(G)) break;
              J--;
            }
            if (Q === h && -1 !== [Q, L, N, E].indexOf(k) || -1 !== [L, N].indexOf(h) && -1 !== [L, S].indexOf(k) || -1 !== [S, E].indexOf(h) && k === S) return I;
            if (-1 !== _.indexOf(h) && -1 !== [p, b].indexOf(k) || -1 !== _.indexOf(k) && h === B) return I;
            if (-1 !== P.indexOf(h) && -1 !== P.indexOf(k)) return I;
            if (h === m && -1 !== P.indexOf(k)) return I;
            if (-1 !== P.concat(v).indexOf(h) && k === w || -1 !== P.concat(v).indexOf(k) && h === d) return I;
            if (41 === h && 41 === k) {
              for (var X = i[n], W = 1; X > 0 && 41 === e[--X];) W++;
              if (W % 2 != 0) return I;
            }
            return h === F && k === x ? I : O;
          },
          G = (e.lineBreakAtIndex = function (t, e) {
            if (0 === e) return I;
            if (e >= t.length) return H;
            var i = K(t),
              s = r(i, 2),
              n = s[0],
              a = s[1];
            return J(t, a, n, e);
          }, function (t, e) {
            e || (e = {
              lineBreak: "normal",
              wordBreak: "normal"
            });
            var i = K(t, e.lineBreak),
              s = r(i, 3),
              n = s[0],
              a = s[1],
              o = s[2];
            return "break-all" !== e.wordBreak && "break-word" !== e.wordBreak || (a = a.map(function (t) {
              return -1 !== [v, C, k].indexOf(t) ? U : t;
            })), [n, a, "keep-all" === e.wordBreak ? o.map(function (e, i) {
              return e && t[i] >= 19968 && t[i] <= 40959;
            }) : null];
          }),
          X = (e.inlineBreakOpportunities = function (t, e) {
            var i = (0, o.toCodePoints)(t),
              s = I,
              n = G(i, e),
              a = r(n, 3),
              h = a[0],
              l = a[1],
              A = a[2];
            return i.forEach(function (t, e) {
              s += (0, o.fromCodePoint)(t) + (e >= i.length - 1 ? H : J(i, l, h, e + 1, A));
            }), s;
          }, function () {
            function t(e, i, s, r) {
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, t), this._codePoints = e, this.required = i === H, this.start = s, this.end = r;
            }
            return s(t, [{
              key: "slice",
              value: function value() {
                return o.fromCodePoint.apply(void 0, function (t) {
                  if (Array.isArray(t)) {
                    for (var e = 0, i = Array(t.length); e < t.length; e++) i[e] = t[e];
                    return i;
                  }
                  return Array.from(t);
                }(this._codePoints.slice(this.start, this.end)));
              }
            }]), t;
          }());
        e.LineBreaker = function (t, e) {
          var i = (0, o.toCodePoints)(t),
            s = G(i, e),
            n = r(s, 3),
            a = n[0],
            h = n[1],
            l = n[2],
            A = i.length,
            c = 0,
            u = 0;
          return {
            next: function next() {
              if (u >= A) return {
                done: !0
              };
              for (var t = I; u < A && (t = J(i, h, a, ++u, l)) === I;);
              if (t !== I || u === A) {
                var e = new X(i, t, c, u);
                return c = u, {
                  value: e,
                  done: !1
                };
              }
              return {
                done: !0
              };
            }
          };
        };
      }, function (t, e, i) {
        "use strict";

        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Trie = e.createTrieFromBase64 = e.UTRIE2_INDEX_2_MASK = e.UTRIE2_INDEX_2_BLOCK_LENGTH = e.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = e.UTRIE2_INDEX_1_OFFSET = e.UTRIE2_UTF8_2B_INDEX_2_LENGTH = e.UTRIE2_UTF8_2B_INDEX_2_OFFSET = e.UTRIE2_INDEX_2_BMP_LENGTH = e.UTRIE2_LSCP_INDEX_2_LENGTH = e.UTRIE2_DATA_MASK = e.UTRIE2_DATA_BLOCK_LENGTH = e.UTRIE2_LSCP_INDEX_2_OFFSET = e.UTRIE2_SHIFT_1_2 = e.UTRIE2_INDEX_SHIFT = e.UTRIE2_SHIFT_1 = e.UTRIE2_SHIFT_2 = void 0;
        var s = function () {
            function t(t, e) {
              for (var i = 0; i < e.length; i++) {
                var s = e[i];
                s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
              }
            }
            return function (e, i, s) {
              return i && t(e.prototype, i), s && t(e, s), e;
            };
          }(),
          r = i(1),
          n = e.UTRIE2_SHIFT_2 = 5,
          a = e.UTRIE2_SHIFT_1 = 11,
          o = e.UTRIE2_INDEX_SHIFT = 2,
          h = e.UTRIE2_SHIFT_1_2 = a - n,
          l = e.UTRIE2_LSCP_INDEX_2_OFFSET = 65536 >> n,
          A = e.UTRIE2_DATA_BLOCK_LENGTH = 1 << n,
          c = e.UTRIE2_DATA_MASK = A - 1,
          u = e.UTRIE2_LSCP_INDEX_2_LENGTH = 1024 >> n,
          d = e.UTRIE2_INDEX_2_BMP_LENGTH = l + u,
          f = e.UTRIE2_UTF8_2B_INDEX_2_OFFSET = d,
          p = e.UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32,
          g = e.UTRIE2_INDEX_1_OFFSET = f + p,
          w = e.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 65536 >> a,
          m = e.UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << h,
          v = e.UTRIE2_INDEX_2_MASK = m - 1,
          b = (e.createTrieFromBase64 = function (t) {
            var e = (0, r.decode)(t),
              i = Array.isArray(e) ? (0, r.polyUint32Array)(e) : new Uint32Array(e),
              s = Array.isArray(e) ? (0, r.polyUint16Array)(e) : new Uint16Array(e),
              n = s.slice(12, i[4] / 2),
              a = 2 === i[5] ? s.slice((24 + i[4]) / 2) : i.slice(Math.ceil((24 + i[4]) / 4));
            return new b(i[0], i[1], i[2], i[3], n, a);
          }, e.Trie = function () {
            function t(e, i, s, r, n, a) {
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, t), this.initialValue = e, this.errorValue = i, this.highStart = s, this.highValueIndex = r, this.index = n, this.data = a;
            }
            return s(t, [{
              key: "get",
              value: function value(t) {
                var e = void 0;
                if (t >= 0) {
                  if (t < 55296 || t > 56319 && t <= 65535) return e = ((e = this.index[t >> n]) << o) + (t & c), this.data[e];
                  if (t <= 65535) return e = ((e = this.index[l + (t - 55296 >> n)]) << o) + (t & c), this.data[e];
                  if (t < this.highStart) return e = g - w + (t >> a), e = this.index[e], e += t >> n & v, e = ((e = this.index[e]) << o) + (t & c), this.data[e];
                  if (t <= 1114111) return this.data[this.highValueIndex];
                }
                return this.errorValue;
              }
            }]), t;
          }());
      }, function (t, e, i) {
        "use strict";

        t.exports = "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";
      }, function (t, e, i) {
        "use strict";

        i.r(e);
        var s = 0,
          r = 1,
          n = 2,
          a = /^#([a-f0-9]{3})$/i,
          o = function o(t) {
            var e = t.match(a);
            return !!e && [parseInt(e[1][0] + e[1][0], 16), parseInt(e[1][1] + e[1][1], 16), parseInt(e[1][2] + e[1][2], 16), null];
          },
          h = /^#([a-f0-9]{6})$/i,
          l = function l(t) {
            var e = t.match(h);
            return !!e && [parseInt(e[1].substring(0, 2), 16), parseInt(e[1].substring(2, 4), 16), parseInt(e[1].substring(4, 6), 16), null];
          },
          A = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,
          c = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/,
          u = function () {
            function t(e) {
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, t);
              var i = function (t, e) {
                  return function (t) {
                    if (Array.isArray(t)) return t;
                  }(t) || function (t, e) {
                    var i = [],
                      s = !0,
                      r = !1,
                      n = void 0;
                    try {
                      for (var a, o = t[Symbol.iterator](); !(s = (a = o.next()).done) && (i.push(a.value), 4 !== i.length); s = !0);
                    } catch (t) {
                      r = !0, n = t;
                    } finally {
                      try {
                        s || null == o.return || o.return();
                      } finally {
                        if (r) throw n;
                      }
                    }
                    return i;
                  }(t) || function () {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                  }();
                }(Array.isArray(e) ? function (t) {
                  return [Math.min(t[0], 255), Math.min(t[1], 255), Math.min(t[2], 255), t.length > 3 ? t[3] : null];
                }(e) : o(e) || function (t) {
                  var e = t.match(A);
                  return !!e && [Number(e[1]), Number(e[2]), Number(e[3]), null];
                }(e) || function (t) {
                  var e = t.match(c);
                  return !!(e && e.length > 4) && [Number(e[1]), Number(e[2]), Number(e[3]), Number(e[4])];
                }(e) || function (t) {
                  return d[t.toLowerCase()] || !1;
                }(e) || l(e) || [0, 0, 0, null]),
                s = i[0],
                r = i[1],
                n = i[2],
                a = i[3];
              this.r = s, this.g = r, this.b = n, this.a = a;
            }
            return function (t, e, i) {
              e && function (t, e) {
                for (var i = 0; i < e.length; i++) {
                  var s = e[i];
                  s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
                }
              }(t.prototype, e);
            }(t, [{
              key: "isTransparent",
              value: function value() {
                return 0 === this.a;
              }
            }, {
              key: "toString",
              value: function value() {
                return null !== this.a && 1 !== this.a ? "rgba(".concat(this.r, ",").concat(this.g, ",").concat(this.b, ",").concat(this.a, ")") : "rgb(".concat(this.r, ",").concat(this.g, ",").concat(this.b, ")");
              }
            }]), t;
          }(),
          d = {
            transparent: [0, 0, 0, 0],
            aliceblue: [240, 248, 255, null],
            antiquewhite: [250, 235, 215, null],
            aqua: [0, 255, 255, null],
            aquamarine: [127, 255, 212, null],
            azure: [240, 255, 255, null],
            beige: [245, 245, 220, null],
            bisque: [255, 228, 196, null],
            black: [0, 0, 0, null],
            blanchedalmond: [255, 235, 205, null],
            blue: [0, 0, 255, null],
            blueviolet: [138, 43, 226, null],
            brown: [165, 42, 42, null],
            burlywood: [222, 184, 135, null],
            cadetblue: [95, 158, 160, null],
            chartreuse: [127, 255, 0, null],
            chocolate: [210, 105, 30, null],
            coral: [255, 127, 80, null],
            cornflowerblue: [100, 149, 237, null],
            cornsilk: [255, 248, 220, null],
            crimson: [220, 20, 60, null],
            cyan: [0, 255, 255, null],
            darkblue: [0, 0, 139, null],
            darkcyan: [0, 139, 139, null],
            darkgoldenrod: [184, 134, 11, null],
            darkgray: [169, 169, 169, null],
            darkgreen: [0, 100, 0, null],
            darkgrey: [169, 169, 169, null],
            darkkhaki: [189, 183, 107, null],
            darkmagenta: [139, 0, 139, null],
            darkolivegreen: [85, 107, 47, null],
            darkorange: [255, 140, 0, null],
            darkorchid: [153, 50, 204, null],
            darkred: [139, 0, 0, null],
            darksalmon: [233, 150, 122, null],
            darkseagreen: [143, 188, 143, null],
            darkslateblue: [72, 61, 139, null],
            darkslategray: [47, 79, 79, null],
            darkslategrey: [47, 79, 79, null],
            darkturquoise: [0, 206, 209, null],
            darkviolet: [148, 0, 211, null],
            deeppink: [255, 20, 147, null],
            deepskyblue: [0, 191, 255, null],
            dimgray: [105, 105, 105, null],
            dimgrey: [105, 105, 105, null],
            dodgerblue: [30, 144, 255, null],
            firebrick: [178, 34, 34, null],
            floralwhite: [255, 250, 240, null],
            forestgreen: [34, 139, 34, null],
            fuchsia: [255, 0, 255, null],
            gainsboro: [220, 220, 220, null],
            ghostwhite: [248, 248, 255, null],
            gold: [255, 215, 0, null],
            goldenrod: [218, 165, 32, null],
            gray: [128, 128, 128, null],
            green: [0, 128, 0, null],
            greenyellow: [173, 255, 47, null],
            grey: [128, 128, 128, null],
            honeydew: [240, 255, 240, null],
            hotpink: [255, 105, 180, null],
            indianred: [205, 92, 92, null],
            indigo: [75, 0, 130, null],
            ivory: [255, 255, 240, null],
            khaki: [240, 230, 140, null],
            lavender: [230, 230, 250, null],
            lavenderblush: [255, 240, 245, null],
            lawngreen: [124, 252, 0, null],
            lemonchiffon: [255, 250, 205, null],
            lightblue: [173, 216, 230, null],
            lightcoral: [240, 128, 128, null],
            lightcyan: [224, 255, 255, null],
            lightgoldenrodyellow: [250, 250, 210, null],
            lightgray: [211, 211, 211, null],
            lightgreen: [144, 238, 144, null],
            lightgrey: [211, 211, 211, null],
            lightpink: [255, 182, 193, null],
            lightsalmon: [255, 160, 122, null],
            lightseagreen: [32, 178, 170, null],
            lightskyblue: [135, 206, 250, null],
            lightslategray: [119, 136, 153, null],
            lightslategrey: [119, 136, 153, null],
            lightsteelblue: [176, 196, 222, null],
            lightyellow: [255, 255, 224, null],
            lime: [0, 255, 0, null],
            limegreen: [50, 205, 50, null],
            linen: [250, 240, 230, null],
            magenta: [255, 0, 255, null],
            maroon: [128, 0, 0, null],
            mediumaquamarine: [102, 205, 170, null],
            mediumblue: [0, 0, 205, null],
            mediumorchid: [186, 85, 211, null],
            mediumpurple: [147, 112, 219, null],
            mediumseagreen: [60, 179, 113, null],
            mediumslateblue: [123, 104, 238, null],
            mediumspringgreen: [0, 250, 154, null],
            mediumturquoise: [72, 209, 204, null],
            mediumvioletred: [199, 21, 133, null],
            midnightblue: [25, 25, 112, null],
            mintcream: [245, 255, 250, null],
            mistyrose: [255, 228, 225, null],
            moccasin: [255, 228, 181, null],
            navajowhite: [255, 222, 173, null],
            navy: [0, 0, 128, null],
            oldlace: [253, 245, 230, null],
            olive: [128, 128, 0, null],
            olivedrab: [107, 142, 35, null],
            orange: [255, 165, 0, null],
            orangered: [255, 69, 0, null],
            orchid: [218, 112, 214, null],
            palegoldenrod: [238, 232, 170, null],
            palegreen: [152, 251, 152, null],
            paleturquoise: [175, 238, 238, null],
            palevioletred: [219, 112, 147, null],
            papayawhip: [255, 239, 213, null],
            peachpuff: [255, 218, 185, null],
            peru: [205, 133, 63, null],
            pink: [255, 192, 203, null],
            plum: [221, 160, 221, null],
            powderblue: [176, 224, 230, null],
            purple: [128, 0, 128, null],
            rebeccapurple: [102, 51, 153, null],
            red: [255, 0, 0, null],
            rosybrown: [188, 143, 143, null],
            royalblue: [65, 105, 225, null],
            saddlebrown: [139, 69, 19, null],
            salmon: [250, 128, 114, null],
            sandybrown: [244, 164, 96, null],
            seagreen: [46, 139, 87, null],
            seashell: [255, 245, 238, null],
            sienna: [160, 82, 45, null],
            silver: [192, 192, 192, null],
            skyblue: [135, 206, 235, null],
            slateblue: [106, 90, 205, null],
            slategray: [112, 128, 144, null],
            slategrey: [112, 128, 144, null],
            snow: [255, 250, 250, null],
            springgreen: [0, 255, 127, null],
            steelblue: [70, 130, 180, null],
            tan: [210, 180, 140, null],
            teal: [0, 128, 128, null],
            thistle: [216, 191, 216, null],
            tomato: [255, 99, 71, null],
            turquoise: [64, 224, 208, null],
            violet: [238, 130, 238, null],
            wheat: [245, 222, 179, null],
            white: [255, 255, 255, null],
            whitesmoke: [245, 245, 245, null],
            yellow: [255, 255, 0, null],
            yellowgreen: [154, 205, 50, null]
          },
          f = new u([0, 0, 0, 0]),
          p = function p(t) {
            switch (t) {
              case "underline":
                return 1;
              case "overline":
                return 2;
              case "line-through":
                return 3;
            }
            return 4;
          },
          g = function g(t) {
            var e = function (t) {
              return "none" === t ? null : t.split(" ").map(p);
            }(t.textDecorationLine ? t.textDecorationLine : t.textDecoration);
            return null === e ? null : {
              textDecorationLine: e,
              textDecorationColor: t.textDecorationColor ? new u(t.textDecorationColor) : null,
              textDecorationStyle: function (t) {
                switch (t) {
                  case "double":
                    return 1;
                  case "dotted":
                    return 2;
                  case "dashed":
                    return 3;
                  case "wavy":
                    return 4;
                }
                return 0;
              }(t.textDecorationStyle)
            };
          },
          w = function w(t, e) {
            var i = Math.max.apply(null, t.colorStops.map(function (t) {
                return t.stop;
              })),
              s = 1 / Math.max(1, i);
            t.colorStops.forEach(function (t) {
              e.addColorStop(Math.floor(Math.max(0, s * t.stop)), t.color.toString());
            });
          },
          m = function () {
            function t(e) {
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, t), this.canvas = e || document.createElement("canvas");
            }
            return function (t, e, i) {
              e && function (t, e) {
                for (var i = 0; i < e.length; i++) {
                  var s = e[i];
                  s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
                }
              }(t.prototype, e);
            }(t, [{
              key: "render",
              value: function value(t) {
                this.ctx = this.canvas.getContext("2d"), this.options = t, this.canvas.width = Math.floor(t.width * t.scale), this.canvas.height = Math.floor(t.height * t.scale), this.canvas.style.width = "".concat(t.width, "px"), this.canvas.style.height = "".concat(t.height, "px"), this.ctx.scale(this.options.scale, this.options.scale), this.ctx.translate(-t.x, -t.y), this.ctx.textBaseline = "bottom", t.logger.log("Canvas renderer initialized (".concat(t.width, "x").concat(t.height, " at ").concat(t.x, ",").concat(t.y, ") with scale ").concat(this.options.scale));
              }
            }, {
              key: "clip",
              value: function value(t, e) {
                var i = this;
                t.length && (this.ctx.save(), t.forEach(function (t) {
                  i.path(t), i.ctx.clip();
                })), e(), t.length && this.ctx.restore();
              }
            }, {
              key: "drawImage",
              value: function value(t, e, i) {
                this.ctx.drawImage(t, e.left, e.top, e.width, e.height, i.left, i.top, i.width, i.height);
              }
            }, {
              key: "drawShape",
              value: function value(t, e) {
                this.path(t), this.ctx.fillStyle = e.toString(), this.ctx.fill();
              }
            }, {
              key: "fill",
              value: function value(t) {
                this.ctx.fillStyle = t.toString(), this.ctx.fill();
              }
            }, {
              key: "getTarget",
              value: function value() {
                return this.canvas.getContext("2d").setTransform(1, 0, 0, 1, 0, 0), Promise.resolve(this.canvas);
              }
            }, {
              key: "path",
              value: function value(t) {
                var e = this;
                this.ctx.beginPath(), Array.isArray(t) ? t.forEach(function (t, i) {
                  var n = t.type === s ? t : t.start;
                  0 === i ? e.ctx.moveTo(n.x, n.y) : e.ctx.lineTo(n.x, n.y), t.type === r && e.ctx.bezierCurveTo(t.startControl.x, t.startControl.y, t.endControl.x, t.endControl.y, t.end.x, t.end.y);
                }) : this.ctx.arc(t.x + t.radius, t.y + t.radius, t.radius, 0, 2 * Math.PI, !0), this.ctx.closePath();
              }
            }, {
              key: "rectangle",
              value: function value(t, e, i, s, r) {
                this.ctx.fillStyle = r.toString(), this.ctx.fillRect(t, e, i, s);
              }
            }, {
              key: "renderLinearGradient",
              value: function value(t, e) {
                var i = this.ctx.createLinearGradient(t.left + e.direction.x1, t.top + e.direction.y1, t.left + e.direction.x0, t.top + e.direction.y0);
                w(e, i), this.ctx.fillStyle = i, this.ctx.fillRect(t.left, t.top, t.width, t.height);
              }
            }, {
              key: "renderRadialGradient",
              value: function value(t, e) {
                var i = this,
                  s = t.left + e.center.x,
                  r = t.top + e.center.y,
                  n = this.ctx.createRadialGradient(s, r, 0, s, r, e.radius.x);
                if (n) if (w(e, n), this.ctx.fillStyle = n, e.radius.x !== e.radius.y) {
                  var a = t.left + .5 * t.width,
                    o = t.top + .5 * t.height,
                    h = e.radius.y / e.radius.x,
                    l = 1 / h;
                  this.transform(a, o, [1, 0, 0, h, 0, 0], function () {
                    return i.ctx.fillRect(t.left, l * (t.top - o) + o, t.width, t.height * l);
                  });
                } else this.ctx.fillRect(t.left, t.top, t.width, t.height);
              }
            }, {
              key: "renderRepeat",
              value: function value(t, e, i, s, r) {
                this.path(t), this.ctx.fillStyle = this.ctx.createPattern(this.resizeImage(e, i), "repeat"), this.ctx.translate(s, r), this.ctx.fill(), this.ctx.translate(-s, -r);
              }
            }, {
              key: "renderTextNode",
              value: function value(t, e, i, s, r) {
                var n = this;
                this.ctx.font = [i.fontStyle, i.fontVariant, i.fontWeight, i.fontSize, i.fontFamily].join(" "), t.forEach(function (t) {
                  if (n.ctx.fillStyle = e.toString(), r && t.text.trim().length ? (r.slice(0).reverse().forEach(function (e) {
                    n.ctx.shadowColor = e.color.toString(), n.ctx.shadowOffsetX = e.offsetX * n.options.scale, n.ctx.shadowOffsetY = e.offsetY * n.options.scale, n.ctx.shadowBlur = e.blur, n.ctx.fillText(t.text, t.bounds.left, t.bounds.top + t.bounds.height);
                  }), n.ctx.shadowColor = "", n.ctx.shadowOffsetX = 0, n.ctx.shadowOffsetY = 0, n.ctx.shadowBlur = 0) : n.ctx.fillText(t.text, t.bounds.left, t.bounds.top + t.bounds.height), null !== s) {
                    var a = s.textDecorationColor || e;
                    s.textDecorationLine.forEach(function (e) {
                      switch (e) {
                        case 1:
                          var s = n.options.fontMetrics.getMetrics(i).baseline;
                          n.rectangle(t.bounds.left, Math.round(t.bounds.top + s), t.bounds.width, 1, a);
                          break;
                        case 2:
                          n.rectangle(t.bounds.left, Math.round(t.bounds.top), t.bounds.width, 1, a);
                          break;
                        case 3:
                          var r = n.options.fontMetrics.getMetrics(i).middle;
                          n.rectangle(t.bounds.left, Math.ceil(t.bounds.top + r), t.bounds.width, 1, a);
                      }
                    });
                  }
                });
              }
            }, {
              key: "resizeImage",
              value: function value(t, e) {
                if (t.width === e.width && t.height === e.height) return t;
                var i = this.canvas.ownerDocument.createElement("canvas");
                return i.width = e.width, i.height = e.height, i.getContext("2d").drawImage(t, 0, 0, t.width, t.height, 0, 0, e.width, e.height), i;
              }
            }, {
              key: "setOpacity",
              value: function value(t) {
                this.ctx.globalAlpha = t;
              }
            }, {
              key: "transform",
              value: function value(t, e, i, s) {
                this.ctx.save(), this.ctx.translate(t, e), this.ctx.transform(i[0], i[1], i[2], i[3], i[4], i[5]), this.ctx.translate(-t, -e), s(), this.ctx.restore();
              }
            }]), t;
          }(),
          v = function () {
            function t(e, i, s) {
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, t), this.enabled = "undefined" != typeof window && e, this.start = s || Date.now(), this.id = i;
            }
            return function (t, e, i) {
              e && function (t, e) {
                for (var i = 0; i < e.length; i++) {
                  var s = e[i];
                  s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
                }
              }(t.prototype, e);
            }(t, [{
              key: "child",
              value: function value(e) {
                return new t(this.enabled, e, this.start);
              }
            }, {
              key: "log",
              value: function value() {}
            }, {
              key: "error",
              value: function value() {
                if (this.enabled && window.console && window.console.error) {
                  for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
                  Function.prototype.bind.call(window.console.error, window.console).apply(window.console, [Date.now() - this.start + "ms", this.id ? "html2canvas (".concat(this.id, "):") : "html2canvas:"].concat([].slice.call(e, 0)));
                }
              }
            }]), t;
          }(),
          b = function b(t, e) {
            return 0 != (t & e);
          },
          B = function B(t, e) {
            return Math.sqrt(t * t + e * e);
          },
          y = function y(t, e) {
            for (var i = t.length - 1; i >= 0; i--) {
              var s = t.item(i);
              "content" !== s && e.style.setProperty(s, t.getPropertyValue(s));
            }
            return e;
          };
        function C(t, e) {
          for (var i = 0; i < e.length; i++) {
            var s = e[i];
            s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
          }
        }
        var F = 0,
          x = 1,
          N = function () {
            function t(e) {
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, t), this.type = "%" === e.substr(e.length - 1) ? x : F;
              var i = parseFloat(e);
              this.value = isNaN(i) ? 0 : i;
            }
            return function (t, e, i) {
              e && C(t.prototype, e), i && C(t, i);
            }(t, [{
              key: "isPercentage",
              value: function value() {
                return this.type === x;
              }
            }, {
              key: "getAbsoluteValue",
              value: function value(t) {
                return this.isPercentage() ? t * (this.value / 100) : this.value;
              }
            }], [{
              key: "create",
              value: function value(e) {
                return new t(e);
              }
            }]), t;
          }(),
          E = function E(t, e, i) {
            switch (i) {
              case "px":
              case "%":
                return new N(e + i);
              case "em":
              case "rem":
                var s = new N(e);
                return s.value *= "em" === i ? parseFloat(t.style.font.fontSize) : function t(e) {
                  var i = e.parent;
                  return i ? t(i) : parseFloat(e.style.font.fontSize);
                }(t), s;
              default:
                return new N("0");
            }
          },
          U = function t(e, i) {
            !function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), this.width = e, this.height = i;
          },
          Q = function t(e, i) {
            !function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), this.type = s, this.x = e, this.y = i;
          },
          L = function L(t, e, i) {
            return new Q(t.x + (e.x - t.x) * i, t.y + (e.y - t.y) * i);
          },
          S = function () {
            function t(e, i, s, n) {
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, t), this.type = r, this.start = e, this.startControl = i, this.endControl = s, this.end = n;
            }
            return function (t, e, i) {
              e && function (t, e) {
                for (var i = 0; i < e.length; i++) {
                  var s = e[i];
                  s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
                }
              }(t.prototype, e);
            }(t, [{
              key: "subdivide",
              value: function value(e, i) {
                var s = L(this.start, this.startControl, e),
                  r = L(this.startControl, this.endControl, e),
                  n = L(this.endControl, this.end, e),
                  a = L(s, r, e),
                  o = L(r, n, e),
                  h = L(a, o, e);
                return i ? new t(this.start, s, a, h) : new t(h, o, n, this.end);
              }
            }, {
              key: "reverse",
              value: function value() {
                return new t(this.end, this.endControl, this.startControl, this.start);
              }
            }]), t;
          }(),
          k = function () {
            function t(e, i, s, r) {
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, t), this.left = e, this.top = i, this.width = s, this.height = r;
            }
            return function (t, e, i) {
              i && function (t, e) {
                for (var i = 0; i < e.length; i++) {
                  var s = e[i];
                  s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
                }
              }(t, i);
            }(t, 0, [{
              key: "fromClientRect",
              value: function value(e, i, s) {
                return new t(e.left + i, e.top + s, e.width, e.height);
              }
            }]), t;
          }(),
          H = function H(t, e, i) {
            return k.fromClientRect(t.getBoundingClientRect(), e, i);
          },
          I = function I(t) {
            var e = t.body,
              i = t.documentElement;
            if (!e || !i) throw new Error("");
            var s = Math.max(Math.max(e.scrollWidth, i.scrollWidth), Math.max(e.offsetWidth, i.offsetWidth), Math.max(e.clientWidth, i.clientWidth)),
              r = Math.max(Math.max(e.scrollHeight, i.scrollHeight), Math.max(e.offsetHeight, i.offsetHeight), Math.max(e.clientHeight, i.clientHeight));
            return new k(0, 0, s, r);
          },
          O = function O(t, e, i, s) {
            var r = [];
            return t instanceof S ? r.push(t.subdivide(.5, !1)) : r.push(t), i instanceof S ? r.push(i.subdivide(.5, !0)) : r.push(i), s instanceof S ? r.push(s.subdivide(.5, !0).reverse()) : r.push(s), e instanceof S ? r.push(e.subdivide(.5, !1).reverse()) : r.push(e), r;
          },
          T = function T(t) {
            return [t.topLeftInner, t.topRightInner, t.bottomRightInner, t.bottomLeftInner];
          },
          P = function P(t, e, i) {
            var s = i[j.TOP_LEFT][0].getAbsoluteValue(t.width),
              r = i[j.TOP_LEFT][1].getAbsoluteValue(t.height),
              n = i[j.TOP_RIGHT][0].getAbsoluteValue(t.width),
              a = i[j.TOP_RIGHT][1].getAbsoluteValue(t.height),
              o = i[j.BOTTOM_RIGHT][0].getAbsoluteValue(t.width),
              h = i[j.BOTTOM_RIGHT][1].getAbsoluteValue(t.height),
              l = i[j.BOTTOM_LEFT][0].getAbsoluteValue(t.width),
              A = i[j.BOTTOM_LEFT][1].getAbsoluteValue(t.height),
              c = [];
            c.push((s + n) / t.width), c.push((l + o) / t.width), c.push((r + A) / t.height), c.push((a + h) / t.height);
            var u = Math.max.apply(Math, c);
            u > 1 && (s /= u, r /= u, n /= u, a /= u, o /= u, h /= u, l /= u, A /= u);
            var d = t.width - n,
              f = t.height - h,
              p = t.width - o,
              g = t.height - A;
            return {
              topLeftOuter: s > 0 || r > 0 ? M(t.left, t.top, s, r, j.TOP_LEFT) : new Q(t.left, t.top),
              topLeftInner: s > 0 || r > 0 ? M(t.left + e[3].borderWidth, t.top + e[0].borderWidth, Math.max(0, s - e[3].borderWidth), Math.max(0, r - e[0].borderWidth), j.TOP_LEFT) : new Q(t.left + e[3].borderWidth, t.top + e[0].borderWidth),
              topRightOuter: n > 0 || a > 0 ? M(t.left + d, t.top, n, a, j.TOP_RIGHT) : new Q(t.left + t.width, t.top),
              topRightInner: n > 0 || a > 0 ? M(t.left + Math.min(d, t.width + e[3].borderWidth), t.top + e[0].borderWidth, d > t.width + e[3].borderWidth ? 0 : n - e[3].borderWidth, a - e[0].borderWidth, j.TOP_RIGHT) : new Q(t.left + t.width - e[1].borderWidth, t.top + e[0].borderWidth),
              bottomRightOuter: o > 0 || h > 0 ? M(t.left + p, t.top + f, o, h, j.BOTTOM_RIGHT) : new Q(t.left + t.width, t.top + t.height),
              bottomRightInner: o > 0 || h > 0 ? M(t.left + Math.min(p, t.width - e[3].borderWidth), t.top + Math.min(f, t.height + e[0].borderWidth), Math.max(0, o - e[1].borderWidth), h - e[2].borderWidth, j.BOTTOM_RIGHT) : new Q(t.left + t.width - e[1].borderWidth, t.top + t.height - e[2].borderWidth),
              bottomLeftOuter: l > 0 || A > 0 ? M(t.left, t.top + g, l, A, j.BOTTOM_LEFT) : new Q(t.left, t.top + t.height),
              bottomLeftInner: l > 0 || A > 0 ? M(t.left + e[3].borderWidth, t.top + g, Math.max(0, l - e[3].borderWidth), A - e[2].borderWidth, j.BOTTOM_LEFT) : new Q(t.left + e[3].borderWidth, t.top + t.height - e[2].borderWidth)
            };
          },
          j = {
            TOP_LEFT: 0,
            TOP_RIGHT: 1,
            BOTTOM_RIGHT: 2,
            BOTTOM_LEFT: 3
          },
          M = function M(t, e, i, s, r) {
            var n = (Math.sqrt(2) - 1) / 3 * 4,
              a = i * n,
              o = s * n,
              h = t + i,
              l = e + s;
            switch (r) {
              case j.TOP_LEFT:
                return new S(new Q(t, l), new Q(t, l - o), new Q(h - a, e), new Q(h, e));
              case j.TOP_RIGHT:
                return new S(new Q(t, e), new Q(t + a, e), new Q(h, l - o), new Q(h, l));
              case j.BOTTOM_RIGHT:
                return new S(new Q(h, e), new Q(h, e + o), new Q(t + a, l), new Q(t, l));
              case j.BOTTOM_LEFT:
              default:
                return new S(new Q(h, l), new Q(h - a, l), new Q(t, e + o), new Q(t, e));
            }
          },
          D = ["top", "right", "bottom", "left"],
          R = function R(t) {
            return D.map(function (e) {
              return new N(t.getPropertyValue("padding-".concat(e)));
            });
          },
          _ = {
            BORDER_BOX: 0,
            PADDING_BOX: 1,
            CONTENT_BOX: 2
          },
          z = _,
          K = function t(e) {
            switch (function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), e) {
              case "contain":
                this.size = 1;
                break;
              case "cover":
                this.size = 2;
                break;
              case "auto":
                this.size = 0;
                break;
              default:
                this.value = new N(e);
            }
          },
          q = new K("auto"),
          V = function V(t, e, i, s) {
            var r = function (t, e) {
              return new k(t.left + e[3].borderWidth, t.top + e[0].borderWidth, t.width - (e[1].borderWidth + e[3].borderWidth), t.height - (e[0].borderWidth + e[2].borderWidth));
            }(e, s);
            switch (t) {
              case z.BORDER_BOX:
                return e;
              case z.CONTENT_BOX:
                var n = i[3].getAbsoluteValue(e.width),
                  a = i[1].getAbsoluteValue(e.width),
                  o = i[0].getAbsoluteValue(e.width),
                  h = i[2].getAbsoluteValue(e.width);
                return new k(r.left + n, r.top + o, r.width - n - a, r.height - o - h);
              case z.PADDING_BOX:
              default:
                return r;
            }
          },
          J = function J(t, e, i) {
            return new Q(t[0].getAbsoluteValue(i.width - e.width), t[1].getAbsoluteValue(i.height - e.height));
          },
          G = function G(t, e) {
            return {
              backgroundColor: new u(t.backgroundColor),
              backgroundImage: Y(t, e),
              backgroundClip: X(t.backgroundClip),
              backgroundOrigin: W(t.backgroundOrigin)
            };
          },
          X = function X(t) {
            switch (t) {
              case "padding-box":
                return _.PADDING_BOX;
              case "content-box":
                return _.CONTENT_BOX;
            }
            return _.BORDER_BOX;
          },
          W = function W(t) {
            switch (t) {
              case "padding-box":
                return z.PADDING_BOX;
              case "content-box":
                return z.CONTENT_BOX;
            }
            return z.BORDER_BOX;
          },
          Y = function Y(t, e) {
            var i = tt(t.backgroundImage).map(function (t) {
                if ("url" === t.method) {
                  var i = e.loadImage(t.args[0]);
                  t.args = i ? [i] : [];
                }
                return t;
              }),
              s = t.backgroundPosition.split(","),
              r = t.backgroundRepeat.split(","),
              n = t.backgroundSize.split(",");
            return i.map(function (t, e) {
              var i = (n[e] || "auto").trim().split(" ").map(Z),
                a = (s[e] || "auto").trim().split(" ").map($);
              return {
                source: t,
                repeat: function (t) {
                  switch (("string" == typeof r[e] ? r[e] : r[0]).trim()) {
                    case "no-repeat":
                      return 1;
                    case "repeat-x":
                    case "repeat no-repeat":
                      return 2;
                    case "repeat-y":
                    case "no-repeat repeat":
                      return 3;
                    case "repeat":
                      return 0;
                  }
                  return 0;
                }(),
                size: i.length < 2 ? [i[0], q] : [i[0], i[1]],
                position: a.length < 2 ? [a[0], a[0]] : [a[0], a[1]]
              };
            });
          },
          Z = function Z(t) {
            return "auto" === t ? q : new K(t);
          },
          $ = function $(t) {
            switch (t) {
              case "bottom":
              case "right":
                return new N("100%");
              case "left":
              case "top":
                return new N("0%");
              case "auto":
                return new N("0");
            }
            return new N(t);
          },
          tt = function tt(t) {
            var e = /^\s$/,
              i = [],
              s = [],
              r = "",
              n = null,
              a = "",
              o = 0,
              h = 0,
              l = function l() {
                var t = "";
                if (r) {
                  '"' === a.substr(0, 1) && (a = a.substr(1, a.length - 2)), a && s.push(a.trim());
                  var e = r.indexOf("-", 1) + 1;
                  "-" === r.substr(0, 1) && e > 0 && (t = r.substr(0, e).toLowerCase(), r = r.substr(e)), "none" !== (r = r.toLowerCase()) && i.push({
                    prefix: t,
                    method: r,
                    args: s
                  });
                }
                s = [], r = a = "";
              };
            return t.split("").forEach(function (t) {
              if (0 !== o || !e.test(t)) {
                switch (t) {
                  case '"':
                    n ? n === t && (n = null) : n = t;
                    break;
                  case "(":
                    if (n) break;
                    if (0 === o) return void (o = 1);
                    h++;
                    break;
                  case ")":
                    if (n) break;
                    if (1 === o) {
                      if (0 === h) return o = 0, void l();
                      h--;
                    }
                    break;
                  case ",":
                    if (n) break;
                    if (0 === o) return void l();
                    if (1 === o && 0 === h && !r.match(/^url$/i)) return s.push(a.trim()), void (a = "");
                }
                0 === o ? r += t : a += t;
              }
            }), l(), i;
          },
          et = Object.keys({
            TOP: 0,
            RIGHT: 1,
            BOTTOM: 2,
            LEFT: 3
          }).map(function (t) {
            return t.toLowerCase();
          }),
          it = function it(t) {
            return et.map(function (e) {
              var i = new u(t.getPropertyValue("border-".concat(e, "-color"))),
                s = function (t) {
                  switch (t) {
                    case "none":
                      return 0;
                  }
                  return 1;
                }(t.getPropertyValue("border-".concat(e, "-style"))),
                r = parseFloat(t.getPropertyValue("border-".concat(e, "-width")));
              return {
                borderColor: i,
                borderStyle: s,
                borderWidth: isNaN(r) ? 0 : r
              };
            });
          },
          st = ["top-left", "top-right", "bottom-right", "bottom-left"],
          rt = function rt(t) {
            return st.map(function (e) {
              var i = function (t, e) {
                  return function (t) {
                    if (Array.isArray(t)) return t;
                  }(t) || function (t, e) {
                    var i = [],
                      s = !0,
                      r = !1,
                      n = void 0;
                    try {
                      for (var a, o = t[Symbol.iterator](); !(s = (a = o.next()).done) && (i.push(a.value), 2 !== i.length); s = !0);
                    } catch (t) {
                      r = !0, n = t;
                    } finally {
                      try {
                        s || null == o.return || o.return();
                      } finally {
                        if (r) throw n;
                      }
                    }
                    return i;
                  }(t) || function () {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                  }();
                }(t.getPropertyValue("border-".concat(e, "-radius")).split(" ").map(N.create)),
                s = i[0],
                r = i[1];
              return void 0 === r ? [s, s] : [s, r];
            });
          },
          nt = 1,
          at = 2,
          ot = 4,
          ht = 8,
          lt = 16,
          At = 32,
          ct = 64,
          ut = 128,
          dt = 256,
          ft = 512,
          pt = 1024,
          gt = 2048,
          wt = 4096,
          mt = 8192,
          vt = 16384,
          bt = 32768,
          Bt = 65536,
          yt = 1 << 17,
          Ct = 1 << 18,
          Ft = 1 << 19,
          xt = 1 << 20,
          Nt = 1 << 21,
          Et = 1 << 22,
          Ut = 1 << 23,
          Qt = 1 << 24,
          Lt = 1 << 25,
          St = 1 << 26,
          kt = 1 << 27,
          Ht = 1 << 28,
          It = 1 << 29,
          Ot = function Ot(t, e) {
            return t | function (t) {
              switch (e) {
                case "block":
                  return at;
                case "inline":
                  return ot;
                case "run-in":
                  return ht;
                case "flow":
                  return lt;
                case "flow-root":
                  return At;
                case "table":
                  return ct;
                case "flex":
                  return ut;
                case "grid":
                  return dt;
                case "ruby":
                  return ft;
                case "subgrid":
                  return pt;
                case "list-item":
                  return gt;
                case "table-row-group":
                  return wt;
                case "table-header-group":
                  return mt;
                case "table-footer-group":
                  return vt;
                case "table-row":
                  return bt;
                case "table-cell":
                  return Bt;
                case "table-column-group":
                  return yt;
                case "table-column":
                  return Ct;
                case "table-caption":
                  return Ft;
                case "ruby-base":
                  return xt;
                case "ruby-text":
                  return Nt;
                case "ruby-base-container":
                  return Et;
                case "ruby-text-container":
                  return Ut;
                case "contents":
                  return Qt;
                case "inline-block":
                  return Lt;
                case "inline-list-item":
                  return St;
                case "inline-table":
                  return kt;
                case "inline-flex":
                  return Ht;
                case "inline-grid":
                  return It;
              }
              return nt;
            }();
          },
          Tt = function Tt(t) {
            switch (t) {
              case "left":
                return 1;
              case "right":
                return 2;
              case "inline-start":
                return 3;
              case "inline-end":
                return 4;
            }
            return 0;
          },
          Pt = function Pt(t) {
            return {
              fontFamily: t.fontFamily,
              fontSize: t.fontSize,
              fontStyle: t.fontStyle,
              fontVariant: t.fontVariant,
              fontWeight: function (t) {
                switch (t) {
                  case "normal":
                    return 400;
                  case "bold":
                    return 700;
                }
                var e = parseInt(t, 10);
                return isNaN(e) ? 400 : e;
              }(t.fontWeight)
            };
          },
          jt = function jt(t) {
            if ("normal" === t) return 0;
            var e = parseFloat(t);
            return isNaN(e) ? 0 : e;
          },
          Mt = function Mt(t) {
            switch (t) {
              case "strict":
                return "strict";
              case "normal":
              default:
                return "normal";
            }
          },
          Dt = function Dt(t) {
            switch (t) {
              case "disc":
                return 0;
              case "circle":
                return 1;
              case "square":
                return 2;
              case "decimal":
                return 3;
              case "cjk-decimal":
                return 4;
              case "decimal-leading-zero":
                return 5;
              case "lower-roman":
                return 6;
              case "upper-roman":
                return 7;
              case "lower-greek":
                return 8;
              case "lower-alpha":
                return 9;
              case "upper-alpha":
                return 10;
              case "arabic-indic":
                return 11;
              case "armenian":
                return 12;
              case "bengali":
                return 13;
              case "cambodian":
                return 14;
              case "cjk-earthly-branch":
                return 15;
              case "cjk-heavenly-stem":
                return 16;
              case "cjk-ideographic":
                return 17;
              case "devanagari":
                return 18;
              case "ethiopic-numeric":
                return 19;
              case "georgian":
                return 20;
              case "gujarati":
                return 21;
              case "gurmukhi":
              case "hebrew":
                return 22;
              case "hiragana":
                return 23;
              case "hiragana-iroha":
                return 24;
              case "japanese-formal":
                return 25;
              case "japanese-informal":
                return 26;
              case "kannada":
                return 27;
              case "katakana":
                return 28;
              case "katakana-iroha":
                return 29;
              case "khmer":
                return 30;
              case "korean-hangul-formal":
                return 31;
              case "korean-hanja-formal":
                return 32;
              case "korean-hanja-informal":
                return 33;
              case "lao":
                return 34;
              case "lower-armenian":
                return 35;
              case "malayalam":
                return 36;
              case "mongolian":
                return 37;
              case "myanmar":
                return 38;
              case "oriya":
                return 39;
              case "persian":
                return 40;
              case "simp-chinese-formal":
                return 41;
              case "simp-chinese-informal":
                return 42;
              case "tamil":
                return 43;
              case "telugu":
                return 44;
              case "thai":
                return 45;
              case "tibetan":
                return 46;
              case "trad-chinese-formal":
                return 47;
              case "trad-chinese-informal":
                return 48;
              case "upper-armenian":
                return 49;
              case "disclosure-open":
                return 50;
              case "disclosure-closed":
                return 51;
              case "none":
              default:
                return -1;
            }
          },
          Rt = function Rt(t) {
            var e = tt(t.getPropertyValue("list-style-image"));
            return {
              listStyleType: Dt(t.getPropertyValue("list-style-type")),
              listStyleImage: e.length ? e[0] : null,
              listStylePosition: _t(t.getPropertyValue("list-style-position"))
            };
          },
          _t = function _t(t) {
            switch (t) {
              case "inside":
                return 0;
              case "outside":
              default:
                return 1;
            }
          },
          zt = ["top", "right", "bottom", "left"],
          Kt = function Kt(t) {
            return zt.map(function (e) {
              return new N(t.getPropertyValue("margin-".concat(e)));
            });
          },
          qt = 0,
          Vt = 1,
          Jt = 2,
          Gt = 3,
          Xt = function Xt(t) {
            switch (t) {
              case "hidden":
                return Vt;
              case "scroll":
                return Jt;
              case "auto":
                return Gt;
              case "visible":
              default:
                return qt;
            }
          },
          Wt = function Wt(t) {
            switch (t) {
              case "break-word":
                return 1;
              case "normal":
              default:
                return 0;
            }
          },
          Yt = 0,
          Zt = 1,
          $t = 2,
          te = 3,
          ee = 4,
          ie = /^([+-]|\d|\.)$/i,
          se = function se(t) {
            if ("none" === t || "string" != typeof t) return null;
            for (var e = "", i = !1, s = [], r = [], n = 0, a = null, o = function o() {
                e.length && (i ? s.push(parseFloat(e)) : a = new u(e)), i = !1, e = "";
              }, h = function h() {
                s.length && null !== a && r.push({
                  color: a,
                  offsetX: s[0] || 0,
                  offsetY: s[1] || 0,
                  blur: s[2] || 0
                }), s.splice(0, s.length), a = null;
              }, l = 0; l < t.length; l++) {
              var A = t[l];
              switch (A) {
                case "(":
                  e += A, n++;
                  break;
                case ")":
                  e += A, n--;
                  break;
                case ",":
                  0 === n ? (o(), h()) : e += A;
                  break;
                case " ":
                  0 === n ? o() : e += A;
                  break;
                default:
                  0 === e.length && ie.test(A) && (i = !0), e += A;
              }
            }
            return o(), h(), 0 === r.length ? null : r;
          },
          re = function re(t) {
            switch (t) {
              case "uppercase":
                return 2;
              case "lowercase":
                return 1;
              case "capitalize":
                return 3;
            }
            return 0;
          },
          ne = function ne(t) {
            return parseFloat(t.trim());
          },
          ae = /(matrix|matrix3d)\((.+)\)/,
          oe = function oe(t) {
            var e = le(t.transform || t.webkitTransform || t.mozTransform || t.msTransform || t.oTransform);
            return null === e ? null : {
              transform: e,
              transformOrigin: he(t.transformOrigin || t.webkitTransformOrigin || t.mozTransformOrigin || t.msTransformOrigin || t.oTransformOrigin)
            };
          },
          he = function he(t) {
            if ("string" != typeof t) {
              var e = new N("0");
              return [e, e];
            }
            var i = t.split(" ").map(N.create);
            return [i[0], i[1]];
          },
          le = function le(t) {
            if ("none" === t || "string" != typeof t) return null;
            var e = t.match(ae);
            if (e) {
              if ("matrix" === e[1]) {
                var i = e[2].split(",").map(ne);
                return [i[0], i[1], i[2], i[3], i[4], i[5]];
              }
              var s = e[2].split(",").map(ne);
              return [s[0], s[1], s[4], s[5], s[12], s[13]];
            }
            return null;
          },
          Ae = function Ae(t) {
            switch (t) {
              case "hidden":
                return 1;
              case "collapse":
                return 2;
              case "visible":
              default:
                return 0;
            }
          },
          ce = function ce(t) {
            switch (t) {
              case "break-all":
                return "break-all";
              case "keep-all":
                return "keep-all";
              case "normal":
              default:
                return "normal";
            }
          },
          ue = function ue(t) {
            var e = "auto" === t;
            return {
              auto: e,
              order: e ? 0 : parseInt(t, 10)
            };
          },
          de = function () {
            function t(e) {
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, t), this.element = e;
            }
            return function (t, e, i) {
              e && function (t, e) {
                for (var i = 0; i < e.length; i++) {
                  var s = e[i];
                  s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
                }
              }(t.prototype, e);
            }(t, [{
              key: "render",
              value: function value(t) {
                var e = this;
                this.options = t, this.canvas = document.createElement("canvas"), this.ctx = this.canvas.getContext("2d"), this.canvas.width = Math.floor(t.width) * t.scale, this.canvas.height = Math.floor(t.height) * t.scale, this.canvas.style.width = "".concat(t.width, "px"), this.canvas.style.height = "".concat(t.height, "px"), this.ctx.scale(t.scale, t.scale), t.logger.log("ForeignObject renderer initialized (".concat(t.width, "x").concat(t.height, " at ").concat(t.x, ",").concat(t.y, ") with scale ").concat(t.scale));
                var i = fe(Math.max(t.windowWidth, t.width) * t.scale, Math.max(t.windowHeight, t.height) * t.scale, t.scrollX * t.scale, t.scrollY * t.scale, this.element);
                return pe(i).then(function (i) {
                  return t.backgroundColor && (e.ctx.fillStyle = t.backgroundColor.toString(), e.ctx.fillRect(0, 0, t.width * t.scale, t.height * t.scale)), e.ctx.drawImage(i, -t.x * t.scale, -t.y * t.scale), e.canvas;
                });
              }
            }]), t;
          }(),
          fe = function fe(t, e, i, s, r) {
            var n = "http://www.w3.org/2000/svg",
              a = document.createElementNS(n, "svg"),
              o = document.createElementNS(n, "foreignObject");
            return a.setAttributeNS(null, "width", t), a.setAttributeNS(null, "height", e), o.setAttributeNS(null, "width", "100%"), o.setAttributeNS(null, "height", "100%"), o.setAttributeNS(null, "x", i), o.setAttributeNS(null, "y", s), o.setAttributeNS(null, "externalResourcesRequired", "true"), a.appendChild(o), o.appendChild(r), a;
          },
          pe = function pe(t) {
            return new Promise(function (e, i) {
              var s = new Image();
              s.onload = function () {
                return e(s);
              }, s.onerror = i, s.src = "data:image/svg+xml;charset=utf-8,".concat(encodeURIComponent(new XMLSerializer().serializeToString(t)));
            });
          },
          ge = function ge(t) {
            return 0 === t[0] && 255 === t[1] && 0 === t[2] && 255 === t[3];
          },
          we = {
            get SUPPORT_RANGE_BOUNDS() {
              var t = function (t) {
                if (t.createRange) {
                  var e = t.createRange();
                  if (e.getBoundingClientRect) {
                    var i = t.createElement("boundtest");
                    i.style.height = "".concat(123, "px"), i.style.display = "block", t.body.appendChild(i), e.selectNode(i);
                    var s = e.getBoundingClientRect(),
                      r = Math.round(s.height);
                    if (t.body.removeChild(i), 123 === r) return !0;
                  }
                }
                return !1;
              }(document);
              return Object.defineProperty(we, "SUPPORT_RANGE_BOUNDS", {
                value: t
              }), t;
            },
            get SUPPORT_SVG_DRAWING() {
              var t = function (t) {
                var e = new Image(),
                  i = t.createElement("canvas"),
                  s = i.getContext("2d");
                e.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
                try {
                  s.drawImage(e, 0, 0), i.toDataURL();
                } catch (t) {
                  return !1;
                }
                return !0;
              }(document);
              return Object.defineProperty(we, "SUPPORT_SVG_DRAWING", {
                value: t
              }), t;
            },
            get SUPPORT_FOREIGNOBJECT_DRAWING() {
              var t = "function" == typeof Array.from && "function" == typeof window.fetch ? function (t) {
                var e = t.createElement("canvas");
                e.width = 100, e.height = 100;
                var i = e.getContext("2d");
                i.fillStyle = "rgb(0, 255, 0)", i.fillRect(0, 0, 100, 100);
                var s = new Image(),
                  r = e.toDataURL();
                s.src = r;
                var n = fe(100, 100, 0, 0, s);
                return i.fillStyle = "red", i.fillRect(0, 0, 100, 100), pe(n).then(function (e) {
                  i.drawImage(e, 0, 0);
                  var s = i.getImageData(0, 0, 100, 100).data;
                  i.fillStyle = "red", i.fillRect(0, 0, 100, 100);
                  var n = t.createElement("div");
                  return n.style.backgroundImage = "url(".concat(r, ")"), n.style.height = "".concat(100, "px"), ge(s) ? pe(fe(100, 100, 0, 0, n)) : Promise.reject(!1);
                }).then(function (t) {
                  return i.drawImage(t, 0, 0), ge(i.getImageData(0, 0, 100, 100).data);
                }).catch(function (t) {
                  return !1;
                });
              }(document) : Promise.resolve(!1);
              return Object.defineProperty(we, "SUPPORT_FOREIGNOBJECT_DRAWING", {
                value: t
              }), t;
            },
            get SUPPORT_CORS_IMAGES() {
              var t = void 0 !== new Image().crossOrigin;
              return Object.defineProperty(we, "SUPPORT_CORS_IMAGES", {
                value: t
              }), t;
            },
            get SUPPORT_RESPONSE_TYPE() {
              var t = "string" == typeof new XMLHttpRequest().responseType;
              return Object.defineProperty(we, "SUPPORT_RESPONSE_TYPE", {
                value: t
              }), t;
            },
            get SUPPORT_CORS_XHR() {
              var t = ("withCredentials" in new XMLHttpRequest());
              return Object.defineProperty(we, "SUPPORT_CORS_XHR", {
                value: t
              }), t;
            }
          },
          me = we,
          ve = i(0),
          be = function t(e, i) {
            !function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), this.text = e, this.bounds = i;
          },
          Be = function Be(t, e, i) {
            var s = t.ownerDocument.createElement("html2canvaswrapper");
            s.appendChild(t.cloneNode(!0));
            var r = t.parentNode;
            if (r) {
              r.replaceChild(s, t);
              var n = H(s, e, i);
              return s.firstChild && r.replaceChild(s.firstChild, s), n;
            }
            return new k(0, 0, 0, 0);
          },
          ye = function ye(t, e, i, s, r) {
            var n = t.ownerDocument.createRange();
            return n.setStart(t, e), n.setEnd(t, e + i), k.fromClientRect(n.getBoundingClientRect(), s, r);
          },
          Ce = function () {
            function t(e, i, s) {
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, t), this.text = e, this.parent = i, this.bounds = s;
            }
            return function (t, e, i) {
              i && function (t, e) {
                for (var i = 0; i < e.length; i++) {
                  var s = e[i];
                  s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
                }
              }(t, i);
            }(t, 0, [{
              key: "fromTextNode",
              value: function value(e, i) {
                var s = xe(e.data, i.style.textTransform);
                return new t(s, i, function (t, e, i) {
                  for (var s = 0 !== e.style.letterSpacing ? Object(ve.toCodePoints)(t).map(function (t) {
                      return Object(ve.fromCodePoint)(t);
                    }) : function (t, e) {
                      for (var i, s = Object(ve.LineBreaker)(t, {
                          lineBreak: e.style.lineBreak,
                          wordBreak: 1 === e.style.overflowWrap ? "break-word" : e.style.wordBreak
                        }), r = []; !(i = s.next()).done;) r.push(i.value.slice());
                      return r;
                    }(t, e), r = s.length, n = i.parentNode ? i.parentNode.ownerDocument.defaultView : null, a = n ? n.pageXOffset : 0, o = n ? n.pageYOffset : 0, h = [], l = 0, A = 0; A < r; A++) {
                    var c = s[A];
                    if (null !== e.style.textDecoration || c.trim().length > 0) {
                      if (me.SUPPORT_RANGE_BOUNDS) h.push(new be(c, ye(i, l, c.length, a, o)));else {
                        var u = i.splitText(c.length);
                        h.push(new be(c, Be(i, a, o))), i = u;
                      }
                    } else me.SUPPORT_RANGE_BOUNDS || (i = i.splitText(c.length));
                    l += c.length;
                  }
                  return h;
                }(s, i, e));
              }
            }]), t;
          }(),
          Fe = /(^|\s|:|-|\(|\))([a-z])/g,
          xe = function xe(t, e) {
            switch (e) {
              case 1:
                return t.toLowerCase();
              case 3:
                return t.replace(Fe, Ne);
              case 2:
                return t.toUpperCase();
              default:
                return t;
            }
          };
        function Ne(t, e, i) {
          return t.length > 0 ? e + i.toUpperCase() : t;
        }
        var Ee = function t(e, i, s) {
            !function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), this.type = n, this.x = e, this.y = i, this.radius = s;
          },
          Ue = new u([42, 42, 42]),
          Qe = new u([165, 165, 165]),
          Le = new u([222, 222, 222]),
          Se = {
            borderWidth: 1,
            borderColor: Qe,
            borderStyle: 1
          },
          ke = [Se, Se, Se, Se],
          He = {
            backgroundColor: Le,
            backgroundImage: [],
            backgroundClip: _.PADDING_BOX,
            backgroundOrigin: z.PADDING_BOX
          },
          Ie = new N("50%"),
          Oe = [Ie, Ie],
          Te = [Oe, Oe, Oe, Oe],
          Pe = new N("3px"),
          je = [Pe, Pe],
          Me = [je, je, je, je],
          De = function De(t) {
            return "radio" === t.type ? Te : Me;
          },
          Re = function Re(t, e) {
            if ("radio" === t.type || "checkbox" === t.type) {
              if (t.checked) {
                var i = Math.min(e.bounds.width, e.bounds.height);
                e.childNodes.push("checkbox" === t.type ? [new Q(e.bounds.left + .39363 * i, e.bounds.top + .79 * i), new Q(e.bounds.left + .16 * i, e.bounds.top + .5549 * i), new Q(e.bounds.left + .27347 * i, e.bounds.top + .44071 * i), new Q(e.bounds.left + .39694 * i, e.bounds.top + .5649 * i), new Q(e.bounds.left + .72983 * i, e.bounds.top + .23 * i), new Q(e.bounds.left + .84 * i, e.bounds.top + .34085 * i), new Q(e.bounds.left + .39363 * i, e.bounds.top + .79 * i)] : new Ee(e.bounds.left + i / 4, e.bounds.top + i / 4, i / 4));
              }
            } else Ke(qe(t), t, e, !1);
          },
          _e = function _e(t, e) {
            Ke(t.value, t, e, !0);
          },
          ze = function ze(t, e) {
            var i = t.options[t.selectedIndex || 0];
            Ke(i && i.text || "", t, e, !1);
          },
          Ke = function Ke(t, e, i, s) {
            var r = e.ownerDocument.body;
            if (t.length > 0 && r) {
              var n = e.ownerDocument.createElement("html2canvaswrapper");
              y(e.ownerDocument.defaultView.getComputedStyle(e, null), n), n.style.position = "absolute", n.style.left = "".concat(i.bounds.left, "px"), n.style.top = "".concat(i.bounds.top, "px"), s || (n.style.whiteSpace = "nowrap");
              var a = e.ownerDocument.createTextNode(t);
              n.appendChild(a), r.appendChild(n), i.childNodes.push(Ce.fromTextNode(a, i)), r.removeChild(n);
            }
          },
          qe = function qe(t) {
            var e = "password" === t.type ? new Array(t.value.length + 1).join("•") : t.value;
            return 0 === e.length ? t.placeholder || "" : e;
          },
          Ve = ["OL", "UL", "MENU"],
          Je = function Je(t, e, i) {
            var s = e.style.listStyle;
            if (s) {
              var r,
                n = t.ownerDocument.defaultView.getComputedStyle(t, null),
                a = t.ownerDocument.createElement("html2canvaswrapper");
              switch (y(n, a), a.style.position = "absolute", a.style.bottom = "auto", a.style.display = "block", a.style.letterSpacing = "normal", s.listStylePosition) {
                case 1:
                  a.style.left = "auto", a.style.right = "".concat(t.ownerDocument.defaultView.innerWidth - e.bounds.left - e.style.margin[1].getAbsoluteValue(e.bounds.width) + 7, "px"), a.style.textAlign = "right";
                  break;
                case 0:
                  a.style.left = "".concat(e.bounds.left - e.style.margin[3].getAbsoluteValue(e.bounds.width), "px"), a.style.right = "auto", a.style.textAlign = "left";
              }
              var o = e.style.margin[0].getAbsoluteValue(e.bounds.width),
                h = s.listStyleImage;
              if (h) {
                if ("url" === h.method) {
                  var l = t.ownerDocument.createElement("img");
                  l.src = h.args[0], a.style.top = "".concat(e.bounds.top - o, "px"), a.style.width = "auto", a.style.height = "auto", a.appendChild(l);
                } else {
                  var A = .5 * parseFloat(e.style.font.fontSize);
                  a.style.top = "".concat(e.bounds.top - o + e.bounds.height - 1.5 * A, "px"), a.style.width = "".concat(A, "px"), a.style.height = "".concat(A, "px"), a.style.backgroundImage = n.listStyleImage;
                }
              } else "number" == typeof e.listIndex && (r = t.ownerDocument.createTextNode(si(e.listIndex, s.listStyleType, !0)), a.appendChild(r), a.style.top = "".concat(e.bounds.top - o, "px"));
              var c = t.ownerDocument.body;
              c.appendChild(a), r ? (e.childNodes.push(Ce.fromTextNode(r, e)), c.removeChild(a)) : e.childNodes.push(new ni(a, e, i, 0));
            }
          },
          Ge = {
            integers: [1e3, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
            values: ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"]
          },
          Xe = {
            integers: [9e3, 8e3, 7e3, 6e3, 5e3, 4e3, 3e3, 2e3, 1e3, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
            values: ["Ք", "Փ", "Ւ", "Ց", "�?", "�?", "Վ", "�?", "Ռ", "Ջ", "Պ", "Չ", "Ո", "Շ", "Ն", "Յ", "Մ", "Ճ", "Ղ", "�?", "Հ", "Կ", "Ծ", "Խ", "Լ", "Ի", "Ժ", "Թ", "Ը", "Է", "Զ", "Ե", "Դ", "Գ", "Բ", "Ա"]
          },
          We = {
            integers: [1e4, 9e3, 8e3, 7e3, 6e3, 5e3, 4e3, 3e3, 2e3, 1e3, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
            values: ["י׳", "ט׳", "ח׳", "ז׳", "ו׳", "ה׳", "ד׳", "ג׳", "ב׳", "�?׳", "ת", "ש", "ר", "ק", "צ", "פ", "ע", "ס", "נ", "מ", "ל", "כ", "יט", "יח", "יז", "טז", "טו", "י", "ט", "ח", "ז", "ו", "ה", "ד", "ג", "ב", "�?"]
          },
          Ye = {
            integers: [1e4, 9e3, 8e3, 7e3, 6e3, 5e3, 4e3, 3e3, 2e3, 1e3, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
            values: ["ჵ", "ჰ", "ჯ", "ჴ", "ხ", "ჭ", "წ", "ძ", "ც", "ჩ", "შ", "ყ", "ღ", "ქ", "ფ", "ჳ", "ტ", "ს", "რ", "ჟ", "პ", "�?", "ჲ", "ნ", "მ", "ლ", "კ", "ი", "თ", "ჱ", "ზ", "ვ", "ე", "დ", "გ", "ბ", "�?"]
          },
          Ze = function Ze(t, e, i, s, r, n) {
            return t < e || t > i ? si(t, r, n.length > 0) : s.integers.reduce(function (e, i, r) {
              for (; t >= i;) t -= i, e += s.values[r];
              return e;
            }, "") + n;
          },
          $e = function $e(t, e, i, s) {
            var r = "";
            do {
              i || t--, r = s(t) + r, t /= e;
            } while (t * e >= e);
            return r;
          },
          ti = function ti(t, e, i, s, r) {
            var n = i - e + 1;
            return (t < 0 ? "-" : "") + ($e(Math.abs(t), n, s, function (t) {
              return Object(ve.fromCodePoint)(Math.floor(t % n) + e);
            }) + r);
          },
          ei = function ei(t, e) {
            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ". ",
              s = e.length;
            return $e(Math.abs(t), s, !1, function (t) {
              return e[Math.floor(t % s)];
            }) + i;
          },
          ii = function ii(t, e, i, s, r, n) {
            if (t < -9999 || t > 9999) return si(t, 4, r.length > 0);
            var a = Math.abs(t),
              o = r;
            if (0 === a) return e[0] + o;
            for (var h = 0; a > 0 && h <= 4; h++) {
              var l = a % 10;
              0 === l && b(n, 1) && "" !== o ? o = e[l] + o : l > 1 || 1 === l && 0 === h || 1 === l && 1 === h && b(n, 2) || 1 === l && 1 === h && b(n, 4) && t > 100 || 1 === l && h > 1 && b(n, 8) ? o = e[l] + (h > 0 ? i[h - 1] : "") + o : 1 === l && h > 0 && (o = i[h - 1] + o), a = Math.floor(a / 10);
            }
            return (t < 0 ? s : "") + o;
          },
          si = function si(t, e, i) {
            var s = i ? ". " : "",
              r = i ? "�?" : "",
              n = i ? ", " : "";
            switch (e) {
              case 0:
                return "•";
              case 1:
                return "◦";
              case 2:
                return "◾";
              case 5:
                var a = ti(t, 48, 57, !0, s);
                return a.length < 4 ? "0".concat(a) : a;
              case 4:
                return ei(t, "〇一二三四五六七八�?", r);
              case 6:
                return Ze(t, 1, 3999, Ge, 3, s).toLowerCase();
              case 7:
                return Ze(t, 1, 3999, Ge, 3, s);
              case 8:
                return ti(t, 945, 969, !1, s);
              case 9:
                return ti(t, 97, 122, !1, s);
              case 10:
                return ti(t, 65, 90, !1, s);
              case 11:
                return ti(t, 1632, 1641, !0, s);
              case 12:
              case 49:
                return Ze(t, 1, 9999, Xe, 3, s);
              case 35:
                return Ze(t, 1, 9999, Xe, 3, s).toLowerCase();
              case 13:
                return ti(t, 2534, 2543, !0, s);
              case 14:
              case 30:
                return ti(t, 6112, 6121, !0, s);
              case 15:
                return ei(t, "�?丑寅�?�辰巳�?�未申酉戌亥", r);
              case 16:
                return ei(t, "甲乙丙�?戊己庚辛壬癸", r);
              case 17:
              case 48:
                return ii(t, "零一二三四五六七八�?", "�??百�?��?�", "負", r, 14);
              case 47:
                return ii(t, "零壹貳�?�肆�?陸柒�?�玖", "拾佰仟�?�", "負", r, 15);
              case 42:
                return ii(t, "零一二三四五六七八�?", "�??百�?��?�", "负", r, 14);
              case 41:
                return ii(t, "零壹贰�??肆�?陆柒�?�玖", "拾佰仟�?�", "负", r, 15);
              case 26:
                return ii(t, "〇一二三四五六七八�?", "�??百�?�万", "マイナス", r, 0);
              case 25:
                return ii(t, "零壱�?�?�四�?六七八�?", "拾百�?�万", "マイナス", r, 7);
              case 31:
                return ii(t, "�?�?��?�삼사오육칠팔구", "십백천만", "마�?�너스", n, 7);
              case 33:
                return ii(t, "零一二三四五六七八�?", "�??百�?��?�", "마�?�너스", n, 0);
              case 32:
                return ii(t, "零壹貳�?�四五六七八�?", "拾百�?�", "마�?�너스", n, 7);
              case 18:
                return ti(t, 2406, 2415, !0, s);
              case 20:
                return Ze(t, 1, 19999, Ye, 3, s);
              case 21:
                return ti(t, 2790, 2799, !0, s);
              case 22:
                return ti(t, 2662, 2671, !0, s);
              case 22:
                return Ze(t, 1, 10999, We, 3, s);
              case 23:
                return ei(t, "�?��?��?��?��?��?��??�??�?��?��?��?��?��?��??�?��?��?��?��?��?��?��?��?��?��?��?��?��?��?��?��?�む�?もやゆよらりるれ�?�?�?ゑをん");
              case 24:
                return ei(t, "�?��?�?��?��?��?��?��?�り�?�るを�?�?�よ�?�れ�??�?��?��?�らむ�?��?�?��?��??や�?��?��?��?��?��?��?��?��??ゆ�?�?��?�ゑ�?�も�?��?�");
              case 27:
                return ti(t, 3302, 3311, !0, s);
              case 28:
                return ei(t, "アイウエオカキクケコサシスセソタ�?ツテトナニヌ�?ノ�?ヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", r);
              case 29:
                return ei(t, "イロ�?ニホヘト�?リヌルヲワカヨタレソツ�?ナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", r);
              case 34:
                return ti(t, 3792, 3801, !0, s);
              case 37:
                return ti(t, 6160, 6169, !0, s);
              case 38:
                return ti(t, 4160, 4169, !0, s);
              case 39:
                return ti(t, 2918, 2927, !0, s);
              case 40:
                return ti(t, 1776, 1785, !0, s);
              case 43:
                return ti(t, 3046, 3055, !0, s);
              case 44:
                return ti(t, 3174, 3183, !0, s);
              case 45:
                return ti(t, 3664, 3673, !0, s);
              case 46:
                return ti(t, 3872, 3881, !0, s);
              case 3:
              default:
                return ti(t, 48, 57, !0, s);
            }
          },
          ri = ["INPUT", "TEXTAREA", "SELECT"],
          ni = function () {
            function t(e, i, s, r) {
              var n = this;
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, t), this.parent = i, this.tagName = e.tagName, this.index = r, this.childNodes = [], this.listItems = [], "number" == typeof e.start && (this.listStart = e.start);
              var a = e.ownerDocument.defaultView,
                o = a.pageXOffset,
                h = a.pageYOffset,
                l = a.getComputedStyle(e, null),
                A = function (t) {
                  return t.split(" ").reduce(Ot, 0);
                }(l.display),
                c = "radio" === e.type || "checkbox" === e.type,
                d = function (t) {
                  switch (t) {
                    case "relative":
                      return Zt;
                    case "absolute":
                      return $t;
                    case "fixed":
                      return te;
                    case "sticky":
                      return ee;
                  }
                  return Yt;
                }(l.position);
              if (this.style = {
                background: c ? He : G(l, s),
                border: c ? ke : it(l),
                borderRadius: (e instanceof a.HTMLInputElement || e instanceof HTMLInputElement) && c ? De(e) : rt(l),
                color: c ? Ue : new u(l.color),
                display: A,
                float: Tt(l.float),
                font: Pt(l),
                letterSpacing: jt(l.letterSpacing),
                listStyle: A === gt ? Rt(l) : null,
                lineBreak: Mt(l.lineBreak),
                margin: Kt(l),
                opacity: parseFloat(l.opacity),
                overflow: -1 === ri.indexOf(e.tagName) ? Xt(l.overflow) : Vt,
                overflowWrap: Wt(l.overflowWrap ? l.overflowWrap : l.wordWrap),
                padding: R(l),
                position: d,
                textDecoration: g(l),
                textShadow: se(l.textShadow),
                textTransform: re(l.textTransform),
                transform: oe(l),
                visibility: Ae(l.visibility),
                wordBreak: ce(l.wordBreak),
                zIndex: ue(d !== Yt ? l.zIndex : "auto")
              }, this.isTransformed() && (e.style.transform = "matrix(1,0,0,1,0,0)"), A === gt) {
                var f = function (t) {
                  var e = t.parent;
                  if (!e) return null;
                  do {
                    if (-1 !== Ve.indexOf(e.tagName)) return e;
                    e = e.parent;
                  } while (e);
                  return t.parent;
                }(this);
                if (f) {
                  var p = f.listItems.length;
                  f.listItems.push(this), this.listIndex = e.hasAttribute("value") && "number" == typeof e.value ? e.value : 0 === p ? "number" == typeof f.listStart ? f.listStart : 1 : f.listItems[p - 1].listIndex + 1;
                }
              }
              "IMG" === e.tagName && e.addEventListener("load", function () {
                n.bounds = H(e, o, h), n.curvedBounds = P(n.bounds, n.style.border, n.style.borderRadius);
              }), this.image = ai(e, s), this.bounds = c ? function (t) {
                return t.width > t.height ? (t.left += (t.width - t.height) / 2, t.width = t.height) : t.width < t.height && (t.top += (t.height - t.width) / 2, t.height = t.width), t;
              }(H(e, o, h)) : H(e, o, h), this.curvedBounds = P(this.bounds, this.style.border, this.style.borderRadius);
            }
            return function (t, e, i) {
              e && function (t, e) {
                for (var i = 0; i < e.length; i++) {
                  var s = e[i];
                  s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
                }
              }(t.prototype, e);
            }(t, [{
              key: "getClipPaths",
              value: function value() {
                var t = this.parent ? this.parent.getClipPaths() : [];
                return this.style.overflow !== qt ? t.concat([T(this.curvedBounds)]) : t;
              }
            }, {
              key: "isInFlow",
              value: function value() {
                return this.isRootElement() && !this.isFloating() && !this.isAbsolutelyPositioned();
              }
            }, {
              key: "isVisible",
              value: function value() {
                return !b(this.style.display, nt) && this.style.opacity > 0 && 0 === this.style.visibility;
              }
            }, {
              key: "isAbsolutelyPositioned",
              value: function value() {
                return this.style.position !== Yt && this.style.position !== Zt;
              }
            }, {
              key: "isPositioned",
              value: function value() {
                return this.style.position !== Yt;
              }
            }, {
              key: "isFloating",
              value: function value() {
                return 0 !== this.style.float;
              }
            }, {
              key: "isRootElement",
              value: function value() {
                return null === this.parent;
              }
            }, {
              key: "isTransformed",
              value: function value() {
                return null !== this.style.transform;
              }
            }, {
              key: "isPositionedWithZIndex",
              value: function value() {
                return this.isPositioned() && !this.style.zIndex.auto;
              }
            }, {
              key: "isInlineLevel",
              value: function value() {
                return b(this.style.display, ot) || b(this.style.display, Lt) || b(this.style.display, Ht) || b(this.style.display, It) || b(this.style.display, St) || b(this.style.display, kt);
              }
            }, {
              key: "isInlineBlockOrInlineTable",
              value: function value() {
                return b(this.style.display, Lt) || b(this.style.display, kt);
              }
            }]), t;
          }(),
          ai = function ai(t, e) {
            if (t instanceof t.ownerDocument.defaultView.SVGSVGElement || t instanceof SVGSVGElement) {
              var i = new XMLSerializer();
              return e.loadImage("data:image/svg+xml,".concat(encodeURIComponent(i.serializeToString(t))));
            }
            switch (t.tagName) {
              case "IMG":
                var s = t;
                return e.loadImage(s.currentSrc || s.src);
              case "CANVAS":
                var r = t;
                return e.loadCanvas(r);
              case "IFRAME":
                var n = t.getAttribute("data-html2canvas-internal-iframe-key");
                if (n) return n;
            }
            return null;
          },
          oi = function () {
            function t(e, i, s) {
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, t), this.container = e, this.parent = i, this.contexts = [], this.children = [], this.treatAsRealStackingContext = s;
            }
            return function (t, e, i) {
              e && function (t, e) {
                for (var i = 0; i < e.length; i++) {
                  var s = e[i];
                  s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
                }
              }(t.prototype, e);
            }(t, [{
              key: "getOpacity",
              value: function value() {
                return this.parent ? this.container.style.opacity * this.parent.getOpacity() : this.container.style.opacity;
              }
            }, {
              key: "getRealParentStackingContext",
              value: function value() {
                return !this.parent || this.treatAsRealStackingContext ? this : this.parent.getRealParentStackingContext();
              }
            }]), t;
          }(),
          hi = ["SCRIPT", "HEAD", "TITLE", "OBJECT", "BR", "OPTION"],
          li = function li(t, e) {
            return t.isRootElement() || t.isPositionedWithZIndex() || t.style.opacity < 1 || t.isTransformed() || ci(t, e);
          },
          Ai = function Ai(t) {
            return t.isPositioned() || t.isFloating();
          },
          ci = function ci(t, e) {
            return "BODY" === e.nodeName && t.parent instanceof ni && t.parent.style.background.backgroundColor.isTransparent();
          },
          ui = function () {
            function t(e) {
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, t), this._data = {}, this._document = e;
            }
            return function (t, e, i) {
              e && function (t, e) {
                for (var i = 0; i < e.length; i++) {
                  var s = e[i];
                  s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
                }
              }(t.prototype, e);
            }(t, [{
              key: "_parseMetrics",
              value: function value(t) {
                var e = this._document.createElement("div"),
                  i = this._document.createElement("img"),
                  s = this._document.createElement("span"),
                  r = this._document.body;
                if (!r) throw new Error("");
                e.style.visibility = "hidden", e.style.fontFamily = t.fontFamily, e.style.fontSize = t.fontSize, e.style.margin = "0", e.style.padding = "0", r.appendChild(e), i.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", i.width = 1, i.height = 1, i.style.margin = "0", i.style.padding = "0", i.style.verticalAlign = "baseline", s.style.fontFamily = t.fontFamily, s.style.fontSize = t.fontSize, s.style.margin = "0", s.style.padding = "0", s.appendChild(this._document.createTextNode("Hidden Text")), e.appendChild(s), e.appendChild(i);
                var n = i.offsetTop - s.offsetTop + 2;
                e.removeChild(s), e.appendChild(this._document.createTextNode("Hidden Text")), e.style.lineHeight = "normal", i.style.verticalAlign = "super";
                var a = i.offsetTop - e.offsetTop + 2;
                return r.removeChild(e), {
                  baseline: n,
                  middle: a
                };
              }
            }, {
              key: "getMetrics",
              value: function value(t) {
                var e = "".concat(t.fontFamily, " ").concat(t.fontSize);
                return void 0 === this._data[e] && (this._data[e] = this._parseMetrics(t)), this._data[e];
              }
            }]), t;
          }(),
          di = /([+-]?\d*\.?\d+)(deg|grad|rad|turn)/i;
        function fi(t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        var pi = /^(to )?(left|top|right|bottom)( (left|top|right|bottom))?$/i,
          gi = /^([+-]?\d*\.?\d+)% ([+-]?\d*\.?\d+)%$/i,
          wi = /(px)|%|( 0)$/i,
          mi = /^(from|to|color-stop)\((?:([\d.]+)(%)?,\s*)?(.+?)\)$/i,
          vi = /^\s*(circle|ellipse)?\s*((?:([\d.]+)(px|r?em|%)\s*(?:([\d.]+)(px|r?em|%))?)|closest-side|closest-corner|farthest-side|farthest-corner)?\s*(?:at\s*(?:(left|center|right)|([\d.]+)(px|r?em|%))\s+(?:(top|center|bottom)|([\d.]+)(px|r?em|%)))?(?:\s|$)/i,
          bi = {
            left: new N("0%"),
            top: new N("0%"),
            center: new N("50%"),
            right: new N("100%"),
            bottom: new N("100%")
          },
          Bi = function Bi(t, e, i) {
            for (var s = [], r = e; r < t.length; r++) {
              var n = t[r],
                a = wi.test(n),
                o = n.lastIndexOf(" "),
                h = new u(a ? n.substring(0, o) : n),
                l = a ? new N(n.substring(o + 1)) : r === e ? new N("0%") : r === t.length - 1 ? new N("100%") : null;
              s.push({
                color: h,
                stop: l
              });
            }
            for (var A = s.map(function (t) {
                var e = t.color,
                  s = t.stop;
                return {
                  color: e,
                  stop: 0 === i ? 0 : s ? s.getAbsoluteValue(i) / i : null
                };
              }), c = A[0].stop, d = 0; d < A.length; d++) if (null !== c) {
              var f = A[d].stop;
              if (null === f) {
                for (var p = d; null === A[p].stop;) p++;
                for (var g = p - d + 1, w = (A[p].stop - c) / g; d < p; d++) c = A[d].stop = c + w;
              } else c = f;
            }
            return A;
          },
          yi = function yi(t, e, i) {
            var s = function (t) {
                var e = t.match(di);
                if (e) {
                  var i = parseFloat(e[1]);
                  switch (e[2].toLowerCase()) {
                    case "deg":
                      return Math.PI * i / 180;
                    case "grad":
                      return Math.PI / 200 * i;
                    case "rad":
                      return i;
                    case "turn":
                      return 2 * Math.PI * i;
                  }
                }
                return null;
              }(t[0]),
              r = pi.test(t[0]),
              n = r || null !== s || gi.test(t[0]),
              a = n ? null !== s ? Fi(i ? s - .5 * Math.PI : s, e) : r ? Ni(t[0], e) : Ei(t[0], e) : Fi(Math.PI, e),
              o = n ? 1 : 0,
              h = Math.min(B(Math.abs(a.x0) + Math.abs(a.x1), Math.abs(a.y0) + Math.abs(a.y1)), 2 * e.width, 2 * e.height);
            return new function t(e, i) {
              fi(this, t), this.type = 0, this.colorStops = e, this.direction = i;
            }(Bi(t, o, h), a);
          },
          Ci = function Ci(t, e, i) {
            var s = e[0].match(vi),
              r = s && ("circle" === s[1] || void 0 !== s[3] && void 0 === s[5]) ? 0 : 1,
              n = {},
              a = {};
            s && (void 0 !== s[3] && (n.x = E(t, s[3], s[4]).getAbsoluteValue(i.width)), void 0 !== s[5] && (n.y = E(t, s[5], s[6]).getAbsoluteValue(i.height)), s[7] ? a.x = bi[s[7].toLowerCase()] : void 0 !== s[8] && (a.x = E(t, s[8], s[9])), s[10] ? a.y = bi[s[10].toLowerCase()] : void 0 !== s[11] && (a.y = E(t, s[11], s[12])));
            var o = {
                x: void 0 === a.x ? i.width / 2 : a.x.getAbsoluteValue(i.width),
                y: void 0 === a.y ? i.height / 2 : a.y.getAbsoluteValue(i.height)
              },
              h = Qi(s && s[2] || "farthest-corner", r, o, n, i);
            return new function t(e, i, s, r) {
              fi(this, t), this.type = 1, this.colorStops = e, this.shape = i, this.center = s, this.radius = r;
            }(Bi(e, s ? 1 : 0, Math.min(h.x, h.y)), r, o, h);
          },
          Fi = function Fi(t, e) {
            var i = e.width,
              s = e.height,
              r = .5 * i,
              n = .5 * s,
              a = (Math.abs(i * Math.sin(t)) + Math.abs(s * Math.cos(t))) / 2,
              o = r + Math.sin(t) * a,
              h = n - Math.cos(t) * a;
            return {
              x0: o,
              x1: i - o,
              y0: h,
              y1: s - h
            };
          },
          xi = function xi(t) {
            return Math.acos(t.width / 2 / (B(t.width, t.height) / 2));
          },
          Ni = function Ni(t, e) {
            switch (t) {
              case "bottom":
              case "to top":
                return Fi(0, e);
              case "left":
              case "to right":
                return Fi(Math.PI / 2, e);
              case "right":
              case "to left":
                return Fi(3 * Math.PI / 2, e);
              case "top right":
              case "right top":
              case "to bottom left":
              case "to left bottom":
                return Fi(Math.PI + xi(e), e);
              case "top left":
              case "left top":
              case "to bottom right":
              case "to right bottom":
                return Fi(Math.PI - xi(e), e);
              case "bottom left":
              case "left bottom":
              case "to top right":
              case "to right top":
                return Fi(xi(e), e);
              case "bottom right":
              case "right bottom":
              case "to top left":
              case "to left top":
                return Fi(2 * Math.PI - xi(e), e);
              case "top":
              case "to bottom":
              default:
                return Fi(Math.PI, e);
            }
          },
          Ei = function Ei(t, e) {
            var i = function (t, e) {
                return function (t) {
                  if (Array.isArray(t)) return t;
                }(t) || function (t, e) {
                  var i = [],
                    s = !0,
                    r = !1,
                    n = void 0;
                  try {
                    for (var a, o = t[Symbol.iterator](); !(s = (a = o.next()).done) && (i.push(a.value), 2 !== i.length); s = !0);
                  } catch (t) {
                    r = !0, n = t;
                  } finally {
                    try {
                      s || null == o.return || o.return();
                    } finally {
                      if (r) throw n;
                    }
                  }
                  return i;
                }(t) || function () {
                  throw new TypeError("Invalid attempt to destructure non-iterable instance");
                }();
              }(t.split(" ").map(parseFloat)),
              s = i[0],
              r = i[1],
              n = s / 100 * e.width / (r / 100 * e.height);
            return Fi(Math.atan(isNaN(n) ? 1 : n) + Math.PI / 2, e);
          },
          Ui = function Ui(t, e, i, s) {
            return [{
              x: 0,
              y: 0
            }, {
              x: 0,
              y: t.height
            }, {
              x: t.width,
              y: 0
            }, {
              x: t.width,
              y: t.height
            }].reduce(function (t, r) {
              var n = B(e - r.x, i - r.y);
              return (s ? n < t.optimumDistance : n > t.optimumDistance) ? {
                optimumCorner: r,
                optimumDistance: n
              } : t;
            }, {
              optimumDistance: s ? 1 / 0 : -1 / 0,
              optimumCorner: null
            }).optimumCorner;
          },
          Qi = function Qi(t, e, i, s, r) {
            var n = i.x,
              a = i.y,
              o = 0,
              h = 0;
            switch (t) {
              case "closest-side":
                0 === e ? o = h = Math.min(Math.abs(n), Math.abs(n - r.width), Math.abs(a), Math.abs(a - r.height)) : 1 === e && (o = Math.min(Math.abs(n), Math.abs(n - r.width)), h = Math.min(Math.abs(a), Math.abs(a - r.height)));
                break;
              case "closest-corner":
                if (0 === e) o = h = Math.min(B(n, a), B(n, a - r.height), B(n - r.width, a), B(n - r.width, a - r.height));else if (1 === e) {
                  var l = Math.min(Math.abs(a), Math.abs(a - r.height)) / Math.min(Math.abs(n), Math.abs(n - r.width)),
                    A = Ui(r, n, a, !0);
                  h = l * (o = B(A.x - n, (A.y - a) / l));
                }
                break;
              case "farthest-side":
                0 === e ? o = h = Math.max(Math.abs(n), Math.abs(n - r.width), Math.abs(a), Math.abs(a - r.height)) : 1 === e && (o = Math.max(Math.abs(n), Math.abs(n - r.width)), h = Math.max(Math.abs(a), Math.abs(a - r.height)));
                break;
              case "farthest-corner":
                if (0 === e) o = h = Math.max(B(n, a), B(n, a - r.height), B(n - r.width, a), B(n - r.width, a - r.height));else if (1 === e) {
                  var c = Math.max(Math.abs(a), Math.abs(a - r.height)) / Math.max(Math.abs(n), Math.abs(n - r.width)),
                    u = Ui(r, n, a, !1);
                  h = c * (o = B(u.x - n, (u.y - a) / c));
                }
                break;
              default:
                o = s.x || 0, h = void 0 !== s.y ? s.y : o;
            }
            return {
              x: o,
              y: h
            };
          },
          Li = function Li(t) {
            var e = "",
              i = "",
              s = "",
              r = "",
              n = 0,
              a = /^(left|center|right|\d+(?:px|r?em|%)?)(?:\s+(top|center|bottom|\d+(?:px|r?em|%)?))?$/i,
              o = /^\d+(px|r?em|%)?(?:\s+\d+(px|r?em|%)?)?$/i,
              h = t[n].match(a);
            h && n++;
            var l = t[n].match(/^(circle|ellipse)?\s*(closest-side|closest-corner|farthest-side|farthest-corner|contain|cover)?$/i);
            l && (e = l[1] || "", "contain" === (s = l[2] || "") ? s = "closest-side" : "cover" === s && (s = "farthest-corner"), n++);
            var A = t[n].match(o);
            A && n++;
            var c = t[n].match(a);
            c && n++;
            var u = t[n].match(o);
            u && n++;
            var d = c || h;
            d && d[1] && (r = d[1] + (/^\d+$/.test(d[1]) ? "px" : ""), d[2] && (r += " " + d[2] + (/^\d+$/.test(d[2]) ? "px" : "")));
            var f = u || A;
            return f && (i = f[0], f[1] || (i += "px")), !r || e || i || s || (i = r, r = ""), r && (r = "at ".concat(r)), [[e, s, i, r].filter(function (t) {
              return !!t;
            }).join(" ")].concat(t.slice(n));
          },
          Si = function Si(t) {
            return t.map(function (t) {
              return t.match(mi);
            }).map(function (e, i) {
              if (!e) return t[i];
              switch (e[1]) {
                case "from":
                  return "".concat(e[4], " 0%");
                case "to":
                  return "".concat(e[4], " 100%");
                case "color-stop":
                  return "%" === e[3] ? "".concat(e[4], " ").concat(e[2]) : "".concat(e[4], " ").concat(100 * parseFloat(e[2]), "%");
              }
            });
          };
        function ki(t, e) {
          return function (t) {
            if (Array.isArray(t)) return t;
          }(t) || function (t, e) {
            var i = [],
              s = !0,
              r = !1,
              n = void 0;
            try {
              for (var a, o = t[Symbol.iterator](); !(s = (a = o.next()).done) && (i.push(a.value), !e || i.length !== e); s = !0);
            } catch (t) {
              r = !0, n = t;
            } finally {
              try {
                s || null == o.return || o.return();
              } finally {
                if (r) throw n;
              }
            }
            return i;
          }(t, e) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }();
        }
        var Hi = function () {
            function t(e, i) {
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, t), this.target = e, this.options = i, e.render(i);
            }
            return function (t, e, i) {
              e && function (t, e) {
                for (var i = 0; i < e.length; i++) {
                  var s = e[i];
                  s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
                }
              }(t.prototype, e);
            }(t, [{
              key: "renderNode",
              value: function value(t) {
                t.isVisible() && (this.renderNodeBackgroundAndBorders(t), this.renderNodeContent(t));
              }
            }, {
              key: "renderNodeContent",
              value: function value(t) {
                var e = this,
                  i = function i() {
                    if (t.childNodes.length && t.childNodes.forEach(function (i) {
                      if (i instanceof Ce) {
                        var s = i.parent.style;
                        e.target.renderTextNode(i.bounds, s.color, s.font, s.textDecoration, s.textShadow);
                      } else e.target.drawShape(i, t.style.color);
                    }), t.image) {
                      var i = e.options.imageStore.get(t.image);
                      if (i) {
                        var s = function (t, e, i) {
                            var s = e[0].value,
                              r = e[1].value,
                              n = e[2].value,
                              a = e[3].value;
                            return new k(t.left + a + i[3].borderWidth, t.top + s + i[0].borderWidth, t.width - (i[1].borderWidth + i[3].borderWidth + a + r), t.height - (i[0].borderWidth + i[2].borderWidth + s + n));
                          }(t.bounds, t.style.padding, t.style.border),
                          r = "number" == typeof i.width && i.width > 0 ? i.width : s.width,
                          n = "number" == typeof i.height && i.height > 0 ? i.height : s.height;
                        r > 0 && n > 0 && e.target.clip([T(t.curvedBounds)], function () {
                          e.target.drawImage(i, new k(0, 0, r, n), s);
                        });
                      }
                    }
                  },
                  s = t.getClipPaths();
                s.length ? this.target.clip(s, i) : i();
              }
            }, {
              key: "renderNodeBackgroundAndBorders",
              value: function value(t) {
                var e = this,
                  i = !t.style.background.backgroundColor.isTransparent() || t.style.background.backgroundImage.length,
                  s = t.style.border.some(function (t) {
                    return 0 !== t.borderStyle && !t.borderColor.isTransparent();
                  }),
                  r = function r() {
                    var s = function (t, e) {
                      switch (e) {
                        case _.BORDER_BOX:
                          return function (t) {
                            return [t.topLeftOuter, t.topRightOuter, t.bottomRightOuter, t.bottomLeftOuter];
                          }(t);
                        case _.PADDING_BOX:
                        default:
                          return T(t);
                      }
                    }(t.curvedBounds, t.style.background.backgroundClip);
                    i && e.target.clip([s], function () {
                      t.style.background.backgroundColor.isTransparent() || e.target.fill(t.style.background.backgroundColor), e.renderBackgroundImage(t);
                    }), t.style.border.forEach(function (i, s) {
                      0 === i.borderStyle || i.borderColor.isTransparent() || e.renderBorder(i, s, t.curvedBounds);
                    });
                  };
                if (i || s) {
                  var n = t.parent ? t.parent.getClipPaths() : [];
                  n.length ? this.target.clip(n, r) : r();
                }
              }
            }, {
              key: "renderBackgroundImage",
              value: function value(t) {
                var e = this;
                t.style.background.backgroundImage.slice(0).reverse().forEach(function (i) {
                  "url" === i.source.method && i.source.args.length ? e.renderBackgroundRepeat(t, i) : /gradient/i.test(i.source.method) && e.renderBackgroundGradient(t, i);
                });
              }
            }, {
              key: "renderBackgroundRepeat",
              value: function value(t, e) {
                var i = this.options.imageStore.get(e.source.args[0]);
                if (i) {
                  var s = V(t.style.background.backgroundOrigin, t.bounds, t.style.padding, t.style.border),
                    r = function (t, e, i) {
                      var s = 0,
                        r = 0,
                        n = t.size;
                      if (1 === n[0].size || 2 === n[0].size) {
                        var a = i.width / i.height,
                          o = e.width / e.height;
                        return a < o != (2 === n[0].size) ? new U(i.width, i.width / o) : new U(i.height * o, i.height);
                      }
                      return n[0].value && (s = n[0].value.getAbsoluteValue(i.width)), 0 === n[0].size && 0 === n[1].size ? r = e.height : 0 === n[1].size ? r = s / e.width * e.height : n[1].value && (r = n[1].value.getAbsoluteValue(i.height)), 0 === n[0].size && (s = r / e.height * e.width), new U(s, r);
                    }(e, i, s),
                    n = J(e.position, r, s),
                    a = function (t, e, i, s, r) {
                      switch (t.repeat) {
                        case 2:
                          return [new Q(Math.round(r.left), Math.round(s.top + e.y)), new Q(Math.round(r.left + r.width), Math.round(s.top + e.y)), new Q(Math.round(r.left + r.width), Math.round(i.height + s.top + e.y)), new Q(Math.round(r.left), Math.round(i.height + s.top + e.y))];
                        case 3:
                          return [new Q(Math.round(s.left + e.x), Math.round(r.top)), new Q(Math.round(s.left + e.x + i.width), Math.round(r.top)), new Q(Math.round(s.left + e.x + i.width), Math.round(r.height + r.top)), new Q(Math.round(s.left + e.x), Math.round(r.height + r.top))];
                        case 1:
                          return [new Q(Math.round(s.left + e.x), Math.round(s.top + e.y)), new Q(Math.round(s.left + e.x + i.width), Math.round(s.top + e.y)), new Q(Math.round(s.left + e.x + i.width), Math.round(s.top + e.y + i.height)), new Q(Math.round(s.left + e.x), Math.round(s.top + e.y + i.height))];
                        default:
                          return [new Q(Math.round(r.left), Math.round(r.top)), new Q(Math.round(r.left + r.width), Math.round(r.top)), new Q(Math.round(r.left + r.width), Math.round(r.height + r.top)), new Q(Math.round(r.left), Math.round(r.height + r.top))];
                      }
                    }(e, n, r, s, t.bounds),
                    o = Math.round(s.left + n.x),
                    h = Math.round(s.top + n.y);
                  this.target.renderRepeat(a, i, r, o, h);
                }
              }
            }, {
              key: "renderBackgroundGradient",
              value: function value(t, e) {
                var i = V(t.style.background.backgroundOrigin, t.bounds, t.style.padding, t.style.border),
                  s = function (t, e) {
                    var i = t.size,
                      s = i[0].value ? i[0].value.getAbsoluteValue(e.width) : e.width,
                      r = i[1].value ? i[1].value.getAbsoluteValue(e.height) : i[0].value ? s : e.height;
                    return new U(s, r);
                  }(e, i),
                  r = J(e.position, s, i),
                  n = new k(Math.round(i.left + r.x), Math.round(i.top + r.y), s.width, s.height),
                  a = function (t, e, i) {
                    var s = e.args,
                      r = e.method,
                      n = e.prefix;
                    return "linear-gradient" === r ? yi(s, i, !!n) : "gradient" === r && "linear" === s[0] ? yi(["to bottom"].concat(Si(s.slice(3))), i, !!n) : "radial-gradient" === r ? Ci(t, "-webkit-" === n ? Li(s) : s, i) : "gradient" === r && "radial" === s[0] ? Ci(t, Si(Li(s.slice(1))), i) : void 0;
                  }(t, e.source, n);
                if (a) switch (a.type) {
                  case 0:
                    this.target.renderLinearGradient(n, a);
                    break;
                  case 1:
                    this.target.renderRadialGradient(n, a);
                }
              }
            }, {
              key: "renderBorder",
              value: function value(t, e, i) {
                this.target.drawShape(function (t, e) {
                  switch (e) {
                    case 0:
                      return O(t.topLeftOuter, t.topLeftInner, t.topRightOuter, t.topRightInner);
                    case 1:
                      return O(t.topRightOuter, t.topRightInner, t.bottomRightOuter, t.bottomRightInner);
                    case 2:
                      return O(t.bottomRightOuter, t.bottomRightInner, t.bottomLeftOuter, t.bottomLeftInner);
                    case 3:
                    default:
                      return O(t.bottomLeftOuter, t.bottomLeftInner, t.topLeftOuter, t.topLeftInner);
                  }
                }(i, e), t.borderColor);
              }
            }, {
              key: "renderStack",
              value: function value(t) {
                var e = this;
                if (t.container.isVisible()) {
                  var i = t.getOpacity();
                  i !== this._opacity && (this.target.setOpacity(t.getOpacity()), this._opacity = i);
                  var s = t.container.style.transform;
                  null !== s ? this.target.transform(t.container.bounds.left + s.transformOrigin[0].value, t.container.bounds.top + s.transformOrigin[1].value, s.transform, function () {
                    return e.renderStackContent(t);
                  }) : this.renderStackContent(t);
                }
              }
            }, {
              key: "renderStackContent",
              value: function value(t) {
                var e = ki(Oi(t), 5),
                  i = e[0],
                  s = e[1],
                  r = e[2],
                  n = e[3],
                  a = e[4],
                  o = ki(Ii(t), 2),
                  h = o[0],
                  l = o[1];
                this.renderNodeBackgroundAndBorders(t.container), i.sort(Ti).forEach(this.renderStack, this), this.renderNodeContent(t.container), l.forEach(this.renderNode, this), n.forEach(this.renderStack, this), a.forEach(this.renderStack, this), h.forEach(this.renderNode, this), s.forEach(this.renderStack, this), r.sort(Ti).forEach(this.renderStack, this);
              }
            }, {
              key: "render",
              value: function value(t) {
                return this.options.backgroundColor && this.target.rectangle(this.options.x, this.options.y, this.options.width, this.options.height, this.options.backgroundColor), this.renderStack(t), this.target.getTarget();
              }
            }]), t;
          }(),
          Ii = function Ii(t) {
            for (var e = [], i = [], s = t.children.length, r = 0; r < s; r++) {
              var n = t.children[r];
              n.isInlineLevel() ? e.push(n) : i.push(n);
            }
            return [e, i];
          },
          Oi = function Oi(t) {
            for (var e = [], i = [], s = [], r = [], n = [], a = t.contexts.length, o = 0; o < a; o++) {
              var h = t.contexts[o];
              h.container.isPositioned() || h.container.style.opacity < 1 || h.container.isTransformed() ? h.container.style.zIndex.order < 0 ? e.push(h) : h.container.style.zIndex.order > 0 ? s.push(h) : i.push(h) : h.container.isFloating() ? r.push(h) : n.push(h);
            }
            return [e, i, s, r, n];
          },
          Ti = function Ti(t, e) {
            return t.container.style.zIndex.order > e.container.style.zIndex.order ? 1 : t.container.style.zIndex.order < e.container.style.zIndex.order ? -1 : t.container.index > e.container.index ? 1 : -1;
          },
          Pi = function Pi(t, e) {
            if (!e.proxy) return Promise.reject(null);
            var i = e.proxy;
            return new Promise(function (s, r) {
              var n = me.SUPPORT_CORS_XHR && me.SUPPORT_RESPONSE_TYPE ? "blob" : "text",
                a = me.SUPPORT_CORS_XHR ? new XMLHttpRequest() : new XDomainRequest();
              if (a.onload = function () {
                if (a instanceof XMLHttpRequest) {
                  if (200 === a.status) {
                    if ("text" === n) s(a.response);else {
                      var t = new FileReader();
                      t.addEventListener("load", function () {
                        return s(t.result);
                      }, !1), t.addEventListener("error", function (t) {
                        return r(t);
                      }, !1), t.readAsDataURL(a.response);
                    }
                  } else r("");
                } else s(a.responseText);
              }, a.onerror = r, a.open("GET", "".concat(i, "?url=").concat(encodeURIComponent(t), "&responseType=").concat(n)), "text" !== n && a instanceof XMLHttpRequest && (a.responseType = n), e.imageTimeout) {
                var o = e.imageTimeout;
                a.timeout = o, a.ontimeout = function () {
                  return r("");
                };
              }
              a.send();
            });
          };
        function ji(t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function Mi(t, e) {
          for (var i = 0; i < e.length; i++) {
            var s = e[i];
            s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
          }
        }
        function Di(t, e, i) {
          return e && Mi(t.prototype, e), i && Mi(t, i), t;
        }
        var Ri = function () {
            function t(e, i, s) {
              ji(this, t), this.options = e, this._window = s, this.origin = this.getOrigin(s.location.href), this.cache = {}, this.logger = i, this._index = 0;
            }
            return Di(t, [{
              key: "loadImage",
              value: function value(t) {
                var e = this;
                if (this.hasResourceInCache(t)) return t;
                if (Gi(t)) return this.cache[t] = Wi(t, this.options.imageTimeout || 0), t;
                if (!Xi(t) || me.SUPPORT_SVG_DRAWING) {
                  if (!0 === this.options.allowTaint || Vi(t) || this.isSameOrigin(t)) return this.addImage(t, t, !1);
                  if (!this.isSameOrigin(t)) {
                    if ("string" == typeof this.options.proxy) return this.cache[t] = Pi(t, this.options).then(function (t) {
                      return Wi(t, e.options.imageTimeout || 0);
                    }), t;
                    if (!0 === this.options.useCORS && me.SUPPORT_CORS_IMAGES) return this.addImage(t, t, !0);
                  }
                }
              }
            }, {
              key: "inlineImage",
              value: function value(t) {
                var e = this;
                return Vi(t) ? Wi(t, this.options.imageTimeout || 0) : this.hasResourceInCache(t) ? this.cache[t] : this.isSameOrigin(t) || "string" != typeof this.options.proxy ? this.xhrImage(t) : this.cache[t] = Pi(t, this.options).then(function (t) {
                  return Wi(t, e.options.imageTimeout || 0);
                });
              }
            }, {
              key: "xhrImage",
              value: function value(t) {
                var e = this;
                return this.cache[t] = new Promise(function (i, s) {
                  var r = new XMLHttpRequest();
                  if (r.onreadystatechange = function () {
                    if (4 === r.readyState) if (200 !== r.status) s("Failed to fetch image ".concat(t.substring(0, 256), " with status code ").concat(r.status));else {
                      var e = new FileReader();
                      e.addEventListener("load", function () {
                        var t = e.result;
                        i(t);
                      }, !1), e.addEventListener("error", function (t) {
                        return s(t);
                      }, !1), e.readAsDataURL(r.response);
                    }
                  }, r.responseType = "blob", e.options.imageTimeout) {
                    var n = e.options.imageTimeout;
                    r.timeout = n, r.ontimeout = function () {
                      return s("");
                    };
                  }
                  r.open("GET", t, !0), r.send();
                }).then(function (t) {
                  return Wi(t, e.options.imageTimeout || 0);
                }), this.cache[t];
              }
            }, {
              key: "loadCanvas",
              value: function value(t) {
                var e = String(this._index++);
                return this.cache[e] = Promise.resolve(t), e;
              }
            }, {
              key: "hasResourceInCache",
              value: function value(t) {
                return void 0 !== this.cache[t];
              }
            }, {
              key: "addImage",
              value: function value(t, e, i) {
                var s = this;
                return this.cache[t] = new Promise(function (t, r) {
                  var n = new Image();
                  if (n.onload = function () {
                    return t(n);
                  }, (Ji(e) || i) && (n.crossOrigin = "anonymous"), n.onerror = r, n.src = e, !0 === n.complete && setTimeout(function () {
                    t(n);
                  }, 500), s.options.imageTimeout) {
                    var a = s.options.imageTimeout;
                    setTimeout(function () {
                      return r("");
                    }, a);
                  }
                }), t;
              }
            }, {
              key: "isSameOrigin",
              value: function value(t) {
                return this.getOrigin(t) === this.origin;
              }
            }, {
              key: "getOrigin",
              value: function value(t) {
                var e = this._link || (this._link = this._window.document.createElement("a"));
                return e.href = t, e.href = e.href, e.protocol + e.hostname + e.port;
              }
            }, {
              key: "ready",
              value: function value() {
                var t = this,
                  e = Object.keys(this.cache),
                  i = e.map(function (e) {
                    return t.cache[e].catch(function (t) {
                      return null;
                    });
                  });
                return Promise.all(i).then(function (t) {
                  return new _i(e, t);
                });
              }
            }]), t;
          }(),
          _i = function () {
            function t(e, i) {
              ji(this, t), this._keys = e, this._resources = i;
            }
            return Di(t, [{
              key: "get",
              value: function value(t) {
                var e = this._keys.indexOf(t);
                return -1 === e ? null : this._resources[e];
              }
            }]), t;
          }(),
          zi = /^data:image\/svg\+xml/i,
          Ki = /^data:image\/.*;base64,/i,
          qi = /^data:image\/.*/i,
          Vi = function Vi(t) {
            return qi.test(t);
          },
          Ji = function Ji(t) {
            return Ki.test(t);
          },
          Gi = function Gi(t) {
            return "blob" === t.substr(0, 4);
          },
          Xi = function Xi(t) {
            return "svg" === t.substr(-3).toLowerCase() || zi.test(t);
          },
          Wi = function Wi(t, e) {
            return new Promise(function (i, s) {
              var r = new Image();
              r.onload = function () {
                return i(r);
              }, r.onerror = s, r.src = t, !0 === r.complete && setTimeout(function () {
                i(r);
              }, 500), e && setTimeout(function () {
                return s("");
              }, e);
            });
          };
        function Yi(t, e) {
          return function (t) {
            if (Array.isArray(t)) return t;
          }(t) || function (t, e) {
            var i = [],
              s = !0,
              r = !1,
              n = void 0;
            try {
              for (var a, o = t[Symbol.iterator](); !(s = (a = o.next()).done) && (i.push(a.value), !e || i.length !== e); s = !0);
            } catch (t) {
              r = !0, n = t;
            } finally {
              try {
                s || null == o.return || o.return();
              } finally {
                if (r) throw n;
              }
            }
            return i;
          }(t, e) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }();
        }
        var Zi = function Zi(t, e, i) {
            if (!e || !e.content || "none" === e.content || "-moz-alt-content" === e.content || "none" === e.display) return null;
            var s = $i(e.content),
              r = s.length,
              n = [],
              a = "",
              o = e.counterIncrement;
            if (o && "none" !== o) {
              var h = Yi(o.split(/\s+/), 2),
                l = h[0],
                A = h[1],
                c = i.counters[l];
              c && (c[c.length - 1] += void 0 === A ? 1 : parseInt(A, 10));
            }
            for (var u = 0; u < r; u++) {
              var d = s[u];
              switch (d.type) {
                case 0:
                  a += d.value || "";
                  break;
                case 1:
                  t instanceof HTMLElement && d.value && (a += t.getAttribute(d.value) || "");
                  break;
                case 3:
                  var f = i.counters[d.name || ""];
                  f && (a += is([f[f.length - 1]], "", d.format));
                  break;
                case 4:
                  var p = i.counters[d.name || ""];
                  p && (a += is(p, d.glue, d.format));
                  break;
                case 5:
                  a += es(e, !0, i.quoteDepth), i.quoteDepth++;
                  break;
                case 6:
                  i.quoteDepth--, a += es(e, !1, i.quoteDepth);
                  break;
                case 2:
                  a && (n.push({
                    type: 0,
                    value: a
                  }), a = ""), n.push({
                    type: 1,
                    value: d.value || ""
                  });
              }
            }
            return a && n.push({
              type: 0,
              value: a
            }), n;
          },
          $i = function $i(t, e) {
            if (e && e[t]) return e[t];
            for (var i = [], s = t.length, r = !1, n = !1, a = !1, o = "", h = "", l = [], A = 0; A < s; A++) {
              var c = t.charAt(A);
              switch (c) {
                case "'":
                case '"':
                  n ? o += c : (r = !r, a || r || (i.push({
                    type: 0,
                    value: o
                  }), o = ""));
                  break;
                case "\\":
                  n ? (o += c, n = !1) : n = !0;
                  break;
                case "(":
                  r ? o += c : (a = !0, h = o, o = "", l = []);
                  break;
                case ")":
                  if (r) o += c;else if (a) {
                    switch (o && l.push(o), h) {
                      case "attr":
                        l.length > 0 && i.push({
                          type: 1,
                          value: l[0]
                        });
                        break;
                      case "counter":
                        if (l.length > 0) {
                          var u = {
                            type: 3,
                            name: l[0]
                          };
                          l.length > 1 && (u.format = l[1]), i.push(u);
                        }
                        break;
                      case "counters":
                        if (l.length > 0) {
                          var d = {
                            type: 4,
                            name: l[0]
                          };
                          l.length > 1 && (d.glue = l[1]), l.length > 2 && (d.format = l[2]), i.push(d);
                        }
                        break;
                      case "url":
                        l.length > 0 && i.push({
                          type: 2,
                          value: l[0]
                        });
                    }
                    a = !1, o = "";
                  }
                  break;
                case ",":
                  r ? o += c : a && (l.push(o), o = "");
                  break;
                case " ":
                case "\t":
                  r ? o += c : o && (ts(i, o), o = "");
                  break;
                default:
                  o += c;
              }
              "\\" !== c && (n = !1);
            }
            return o && ts(i, o), e && (e[t] = i), i;
          },
          ts = function ts(t, e) {
            switch (e) {
              case "open-quote":
                t.push({
                  type: 5
                });
                break;
              case "close-quote":
                t.push({
                  type: 6
                });
            }
          },
          es = function es(t, e, i) {
            var s = t.quotes ? t.quotes.split(/\s+/) : ["'\"'", "'\"'"],
              r = 2 * i;
            return r >= s.length && (r = s.length - 2), e || ++r, s[r].replace(/^["']|["']$/g, "");
          },
          is = function is(t, e, i) {
            for (var s = t.length, r = "", n = 0; n < s; n++) n > 0 && (r += e || ""), r += si(t[n], Dt(i || "decimal"), !1);
            return r;
          },
          ss = function () {
            function t(e, i, s, r, n) {
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, t), this.referenceElement = e, this.scrolledElements = [], this.copyStyles = r, this.inlineImages = r, this.logger = s, this.options = i, this.renderer = n, this.resourceLoader = new Ri(i, s, window), this.pseudoContentData = {
                counters: {},
                quoteDepth: 0
              }, this.documentElement = this.cloneNode(e.ownerDocument.documentElement);
            }
            return function (t, e, i) {
              e && function (t, e) {
                for (var i = 0; i < e.length; i++) {
                  var s = e[i];
                  s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
                }
              }(t.prototype, e);
            }(t, [{
              key: "inlineAllImages",
              value: function value(t) {
                var e = this;
                if (this.inlineImages && t) {
                  var i = t.style;
                  Promise.all(tt(i.backgroundImage).map(function (t) {
                    return "url" === t.method ? e.resourceLoader.inlineImage(t.args[0]).then(function (t) {
                      return t && "string" == typeof t.src ? 'url("'.concat(t.src, '")') : "none";
                    }).catch(function (t) {}) : Promise.resolve("".concat(t.prefix).concat(t.method, "(").concat(t.args.join(","), ")"));
                  })).then(function (t) {
                    t.length > 1 && (i.backgroundColor = ""), i.backgroundImage = t.join(",");
                  }), t instanceof HTMLImageElement && this.resourceLoader.inlineImage(t.src).then(function (e) {
                    if (e && t instanceof HTMLImageElement && t.parentNode) {
                      var i = t.parentNode,
                        s = y(t.style, e.cloneNode(!1));
                      i.replaceChild(s, t);
                    }
                  }).catch(function (t) {});
                }
              }
            }, {
              key: "inlineFonts",
              value: function value(t) {
                var e = this;
                return Promise.all(Array.from(t.styleSheets).map(function (e) {
                  return e.href ? fetch(e.href).then(function (t) {
                    return t.text();
                  }).then(function (t) {
                    return ns(t, e.href);
                  }).catch(function (t) {
                    return [];
                  }) : rs(e, t);
                })).then(function (t) {
                  return t.reduce(function (t, e) {
                    return t.concat(e);
                  }, []);
                }).then(function (t) {
                  return Promise.all(t.map(function (t) {
                    return fetch(t.formats[0].src).then(function (t) {
                      return t.blob();
                    }).then(function (t) {
                      return new Promise(function (e, i) {
                        var s = new FileReader();
                        s.onerror = i, s.onload = function () {
                          var t = s.result;
                          e(t);
                        }, s.readAsDataURL(t);
                      });
                    }).then(function (e) {
                      return t.fontFace.setProperty("src", 'url("'.concat(e, '")')), "@font-face {".concat(t.fontFace.cssText, " ");
                    });
                  }));
                }).then(function (i) {
                  var s = t.createElement("style");
                  s.textContent = i.join("\n"), e.documentElement.appendChild(s);
                });
              }
            }, {
              key: "createElementClone",
              value: function value(t) {
                var e = this;
                if (this.copyStyles && t instanceof HTMLCanvasElement) {
                  var i = t.ownerDocument.createElement("img");
                  try {
                    return i.src = t.toDataURL(), i;
                  } catch (t) {}
                }
                if (t instanceof HTMLIFrameElement) {
                  var s = t.cloneNode(!1),
                    r = ps();
                  s.setAttribute("data-html2canvas-internal-iframe-key", r);
                  var n = H(t, 0, 0),
                    a = n.width,
                    o = n.height;
                  return this.resourceLoader.cache[r] = ws(t, this.options).then(function (t) {
                    return e.renderer(t, {
                      allowTaint: e.options.allowTaint,
                      backgroundColor: "#ffffff",
                      canvas: null,
                      imageTimeout: e.options.imageTimeout,
                      logging: e.options.logging,
                      proxy: e.options.proxy,
                      removeContainer: e.options.removeContainer,
                      scale: e.options.scale,
                      foreignObjectRendering: e.options.foreignObjectRendering,
                      useCORS: e.options.useCORS,
                      target: new m(),
                      width: a,
                      height: o,
                      x: 0,
                      y: 0,
                      windowWidth: t.ownerDocument.defaultView.innerWidth,
                      windowHeight: t.ownerDocument.defaultView.innerHeight,
                      scrollX: t.ownerDocument.defaultView.pageXOffset,
                      scrollY: t.ownerDocument.defaultView.pageYOffset
                    }, e.logger.child(r));
                  }).then(function (e) {
                    return new Promise(function (i, r) {
                      var n = document.createElement("img");
                      n.onload = function () {
                        return i(e);
                      }, n.onerror = function (t) {
                        "data:," == n.src ? i(e) : r(t);
                      }, n.src = e.toDataURL(), s.parentNode && s.parentNode.replaceChild(y(t.ownerDocument.defaultView.getComputedStyle(t), n), s);
                    });
                  }), s;
                }
                try {
                  if (t instanceof HTMLStyleElement && t.sheet && t.sheet.cssRules) {
                    var h = [].slice.call(t.sheet.cssRules, 0).reduce(function (t, e) {
                        return e && e.cssText ? t + e.cssText : t;
                      }, ""),
                      l = t.cloneNode(!1);
                    return l.textContent = h, l;
                  }
                } catch (t) {
                  if (this.logger.log("Unable to access cssRules property"), "SecurityError" !== t.name) throw this.logger.log(t), t;
                }
                return t.cloneNode(!1);
              }
            }, {
              key: "cloneNode",
              value: function value(t) {
                var e = t.nodeType === Node.TEXT_NODE ? document.createTextNode(t.nodeValue) : this.createElementClone(t),
                  i = t.ownerDocument.defaultView,
                  s = t instanceof i.HTMLElement ? i.getComputedStyle(t) : null,
                  r = t instanceof i.HTMLElement ? i.getComputedStyle(t, ":before") : null,
                  n = t instanceof i.HTMLElement ? i.getComputedStyle(t, ":after") : null;
                this.referenceElement === t && e instanceof i.HTMLElement && (this.clonedReferenceElement = e), e instanceof i.HTMLBodyElement && us(e);
                for (var a = function (t, e) {
                    if (!t || !t.counterReset || "none" === t.counterReset) return [];
                    for (var i = [], s = t.counterReset.split(/\s*,\s*/), r = s.length, n = 0; n < r; n++) {
                      var a = Yi(s[n].split(/\s+/), 2),
                        o = a[0],
                        h = a[1];
                      i.push(o);
                      var l = e.counters[o];
                      l || (l = e.counters[o] = []), l.push(parseInt(h || 0, 10));
                    }
                    return i;
                  }(s, this.pseudoContentData), o = Zi(t, r, this.pseudoContentData), h = t.firstChild; h; h = h.nextSibling) h.nodeType === Node.ELEMENT_NODE && ("SCRIPT" === h.nodeName || h.hasAttribute("data-html2canvas-ignore") || "function" == typeof this.options.ignoreElements && this.options.ignoreElements(h)) || this.copyStyles && "STYLE" === h.nodeName || e.appendChild(this.cloneNode(h));
                var l = Zi(t, n, this.pseudoContentData);
                if (function (t, e) {
                  for (var i = t.length, s = 0; s < i; s++) e.counters[t[s]].pop();
                }(a, this.pseudoContentData), t instanceof i.HTMLElement && e instanceof i.HTMLElement) switch (r && this.inlineAllImages(os(t, e, r, o, hs)), n && this.inlineAllImages(os(t, e, n, l, ls)), !s || !this.copyStyles || t instanceof HTMLIFrameElement || y(s, e), this.inlineAllImages(e), 0 === t.scrollTop && 0 === t.scrollLeft || this.scrolledElements.push([e, t.scrollLeft, t.scrollTop]), t.nodeName) {
                  case "CANVAS":
                    this.copyStyles || as(t, e);
                    break;
                  case "TEXTAREA":
                  case "SELECT":
                    e.value = t.value;
                }
                return e;
              }
            }]), t;
          }(),
          rs = function rs(t, e) {
            return (t.cssRules ? Array.from(t.cssRules) : []).filter(function (t) {
              return t.type === CSSRule.FONT_FACE_RULE;
            }).map(function (t) {
              for (var i = tt(t.style.getPropertyValue("src")), s = [], r = 0; r < i.length; r++) if ("url" === i[r].method && i[r + 1] && "format" === i[r + 1].method) {
                var n = e.createElement("a");
                n.href = i[r].args[0], e.body && e.body.appendChild(n);
                var a = {
                  src: n.href,
                  format: i[r + 1].args[0]
                };
                s.push(a);
              }
              return {
                formats: s.filter(function (t) {
                  return /^woff/i.test(t.format);
                }),
                fontFace: t.style
              };
            }).filter(function (t) {
              return t.formats.length;
            });
          },
          ns = function ns(t, e) {
            var i = document.implementation.createHTMLDocument(""),
              s = document.createElement("base");
            s.href = e;
            var r = document.createElement("style");
            return r.textContent = t, i.head && i.head.appendChild(s), i.body && i.body.appendChild(r), r.sheet ? rs(r.sheet, i) : [];
          },
          as = function as(t, e) {
            try {
              if (e) {
                e.width = t.width, e.height = t.height;
                var i = t.getContext("2d"),
                  s = e.getContext("2d");
                i ? s.putImageData(i.getImageData(0, 0, t.width, t.height), 0, 0) : s.drawImage(t, 0, 0);
              }
            } catch (t) {}
          },
          os = function os(t, e, i, s, r) {
            if (i && i.content && "none" !== i.content && "-moz-alt-content" !== i.content && "none" !== i.display) {
              var n = e.ownerDocument.createElement("html2canvaspseudoelement");
              if (y(i, n), s) for (var a = s.length, o = 0; o < a; o++) {
                var h = s[o];
                switch (h.type) {
                  case 1:
                    var l = e.ownerDocument.createElement("img");
                    l.src = tt("url(".concat(h.value, ")"))[0].args[0], l.style.opacity = "1", n.appendChild(l);
                    break;
                  case 0:
                    n.appendChild(e.ownerDocument.createTextNode(h.value));
                }
              }
              return n.className = "".concat(As, " ").concat(cs), e.className += " ".concat(r === hs ? As : cs), r === hs ? e.insertBefore(n, e.firstChild) : e.appendChild(n), n;
            }
          },
          hs = ":before",
          ls = ":after",
          As = "___html2canvas___pseudoelement_before",
          cs = "___html2canvas___pseudoelement_after",
          us = function us(t) {
            ds(t, ".".concat(As).concat(hs).concat('{\n    content: "" !important;\n    display: none !important;\n}', "\n         .").concat(cs).concat(ls).concat('{\n    content: "" !important;\n    display: none !important;\n}'));
          },
          ds = function ds(t, e) {
            var i = t.ownerDocument.createElement("style");
            i.innerHTML = e, t.appendChild(i);
          },
          fs = function fs(t) {
            var e = function (t, e) {
                return function (t) {
                  if (Array.isArray(t)) return t;
                }(t) || function (t, e) {
                  var i = [],
                    s = !0,
                    r = !1,
                    n = void 0;
                  try {
                    for (var a, o = t[Symbol.iterator](); !(s = (a = o.next()).done) && (i.push(a.value), 3 !== i.length); s = !0);
                  } catch (t) {
                    r = !0, n = t;
                  } finally {
                    try {
                      s || null == o.return || o.return();
                    } finally {
                      if (r) throw n;
                    }
                  }
                  return i;
                }(t) || function () {
                  throw new TypeError("Invalid attempt to destructure non-iterable instance");
                }();
              }(t),
              i = e[0],
              s = e[1],
              r = e[2];
            i.scrollLeft = s, i.scrollTop = r;
          },
          ps = function ps() {
            return Math.ceil(Date.now() + 1e7 * Math.random()).toString(16);
          },
          gs = /^data:text\/(.+);(base64)?,(.*)$/i,
          ws = function ws(t, e) {
            try {
              return Promise.resolve(t.contentWindow.document.documentElement);
            } catch (i) {
              return e.proxy ? Pi(t.src, e).then(function (t) {
                var e = t.match(gs);
                return e ? "base64" === e[2] ? window.atob(decodeURIComponent(e[3])) : decodeURIComponent(e[3]) : Promise.reject();
              }).then(function (e) {
                return ms(t.ownerDocument, H(t, 0, 0)).then(function (t) {
                  var i = t.contentWindow.document;
                  i.open(), i.write(e);
                  var s = vs(t).then(function () {
                    return i.documentElement;
                  });
                  return i.close(), s;
                });
              }) : Promise.reject();
            }
          },
          ms = function ms(t, e) {
            var i = t.createElement("iframe");
            return i.className = "html2canvas-container", i.style.visibility = "hidden", i.style.position = "fixed", i.style.left = "-10000px", i.style.top = "0px", i.style.border = "0", i.width = e.width.toString(), i.height = e.height.toString(), i.scrolling = "no", i.setAttribute("data-html2canvas-ignore", "true"), t.body ? (t.body.appendChild(i), Promise.resolve(i)) : Promise.reject("");
          },
          vs = function vs(t) {
            var e = t.contentWindow,
              i = e.document;
            return new Promise(function (s, r) {
              e.onload = t.onload = i.onreadystatechange = function () {
                var e = setInterval(function () {
                  i.body.childNodes.length > 0 && "complete" === i.readyState && (clearInterval(e), s(t));
                }, 50);
              };
            });
          };
        function bs(t, e, i) {
          return e in t ? Object.defineProperty(t, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : t[e] = i, t;
        }
        var Bs = function Bs(t, e) {
          var i = e || {},
            s = new v("boolean" != typeof i.logging || i.logging);
          s.log("html2canvas ".concat("1.0.0-rc.1"));
          var r = t.ownerDocument;
          if (!r) return Promise.reject("Provided element is not within a Document");
          var n = r.defaultView;
          return function t(e, i, s) {
            var r = e.ownerDocument,
              n = new k(i.scrollX, i.scrollY, i.windowWidth, i.windowHeight),
              a = r.documentElement ? new u(getComputedStyle(r.documentElement).backgroundColor) : f,
              o = r.body ? new u(getComputedStyle(r.body).backgroundColor) : f,
              h = e === r.documentElement ? a.isTransparent() ? o.isTransparent() ? i.backgroundColor ? new u(i.backgroundColor) : null : o : a : i.backgroundColor ? new u(i.backgroundColor) : null;
            return (i.foreignObjectRendering ? me.SUPPORT_FOREIGNOBJECT_DRAWING : Promise.resolve(!1)).then(function (a) {
              return a ? function (t) {
                return t.inlineFonts(r).then(function () {
                  return t.resourceLoader.ready();
                }).then(function () {
                  var n = new de(t.documentElement),
                    a = r.defaultView,
                    o = a.pageXOffset,
                    l = a.pageYOffset,
                    A = "HTML" === e.tagName || "BODY" === e.tagName ? I(r) : H(e, o, l),
                    c = A.width,
                    u = A.height,
                    d = A.left,
                    f = A.top;
                  return n.render({
                    backgroundColor: h,
                    logger: s,
                    scale: i.scale,
                    x: "number" == typeof i.x ? i.x : d,
                    y: "number" == typeof i.y ? i.y : f,
                    width: "number" == typeof i.width ? i.width : Math.ceil(c),
                    height: "number" == typeof i.height ? i.height : Math.ceil(u),
                    windowWidth: i.windowWidth,
                    windowHeight: i.windowHeight,
                    scrollX: i.scrollX,
                    scrollY: i.scrollY
                  });
                });
              }(new ss(e, i, s, !0, t)) : function (t, e, i, s, r, n) {
                var a = new ss(i, s, r, !1, n),
                  o = t.defaultView.pageXOffset,
                  h = t.defaultView.pageYOffset;
                return ms(t, e).then(function (r) {
                  var n = r.contentWindow,
                    l = n.document,
                    A = vs(r).then(function () {
                      a.scrolledElements.forEach(fs), n.scrollTo(e.left, e.top), !/(iPad|iPhone|iPod)/g.test(navigator.userAgent) || n.scrollY === e.top && n.scrollX === e.left || (l.documentElement.style.top = -e.top + "px", l.documentElement.style.left = -e.left + "px", l.documentElement.style.position = "absolute");
                      var i = Promise.resolve([r, a.clonedReferenceElement, a.resourceLoader]),
                        o = s.onclone;
                      return a.clonedReferenceElement instanceof n.HTMLElement || a.clonedReferenceElement instanceof t.defaultView.HTMLElement || a.clonedReferenceElement instanceof HTMLElement ? "function" == typeof o ? Promise.resolve().then(function () {
                        return o(l);
                      }).then(function () {
                        return i;
                      }) : i : Promise.reject("");
                    });
                  return l.open(), l.write("".concat(function (t) {
                    var e = "";
                    return t && (e += "<!DOCTYPE ", t.name && (e += t.name), t.internalSubset && (e += t.internalSubset), t.publicId && (e += '"'.concat(t.publicId, '"')), t.systemId && (e += '"'.concat(t.systemId, '"')), e += ">"), e;
                  }(document.doctype), "<html></html>")), function (t, e, i) {
                    !t.defaultView || e === t.defaultView.pageXOffset && i === t.defaultView.pageYOffset || t.defaultView.scrollTo(e, i);
                  }(i.ownerDocument, o, h), l.replaceChild(l.adoptNode(a.documentElement), l.documentElement), l.close(), A;
                });
              }(r, n, e, i, s, t).then(function (t) {
                var e = function (t, e) {
                    return function (t) {
                      if (Array.isArray(t)) return t;
                    }(t) || function (t, e) {
                      var i = [],
                        s = !0,
                        r = !1,
                        n = void 0;
                      try {
                        for (var a, o = t[Symbol.iterator](); !(s = (a = o.next()).done) && (i.push(a.value), 3 !== i.length); s = !0);
                      } catch (t) {
                        r = !0, n = t;
                      } finally {
                        try {
                          s || null == o.return || o.return();
                        } finally {
                          if (r) throw n;
                        }
                      }
                      return i;
                    }(t) || function () {
                      throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    }();
                  }(t),
                  n = e[0],
                  a = e[1],
                  o = e[2],
                  l = function (t, e, i) {
                    var s = 0,
                      r = new ni(t, null, e, s++),
                      n = new oi(r, null, !0);
                    return function t(e, i, s, r, n) {
                      for (var a, o = e.firstChild; o; o = a) {
                        a = o.nextSibling;
                        var h = o.ownerDocument.defaultView;
                        if (o instanceof h.Text || o instanceof Text || h.parent && o instanceof h.parent.Text) o.data.trim().length > 0 && i.childNodes.push(Ce.fromTextNode(o, i));else if (o instanceof h.HTMLElement || o instanceof HTMLElement || h.parent && o instanceof h.parent.HTMLElement) {
                          if (-1 === hi.indexOf(o.nodeName)) {
                            var l = new ni(o, i, r, n++);
                            if (l.isVisible()) {
                              "INPUT" === o.tagName ? Re(o, l) : "TEXTAREA" === o.tagName ? _e(o, l) : "SELECT" === o.tagName ? ze(o, l) : l.style.listStyle && -1 !== l.style.listStyle.listStyleType && Je(o, l, r);
                              var A = "TEXTAREA" !== o.tagName,
                                c = li(l, o);
                              if (c || Ai(l)) {
                                var u = c || l.isPositioned() ? s.getRealParentStackingContext() : s,
                                  d = new oi(l, u, c);
                                u.contexts.push(d), A && t(o, l, d, r, n);
                              } else s.children.push(l), A && t(o, l, s, r, n);
                            }
                          }
                        } else if (o instanceof h.SVGSVGElement || o instanceof SVGSVGElement || h.parent && o instanceof h.parent.SVGSVGElement) {
                          var f = new ni(o, i, r, n++),
                            p = li(f, o);
                          if (p || Ai(f)) {
                            var g = p || f.isPositioned() ? s.getRealParentStackingContext() : s,
                              w = new oi(f, g, p);
                            g.contexts.push(w);
                          } else s.children.push(f);
                        }
                      }
                    }(t, r, n, e, 1), n;
                  }(a, o),
                  A = a.ownerDocument;
                return h === l.container.style.background.backgroundColor && (l.container.style.background.backgroundColor = f), o.ready().then(function (t) {
                  var e = new ui(A),
                    o = A.defaultView,
                    c = o.pageXOffset,
                    u = o.pageYOffset,
                    d = "HTML" === a.tagName || "BODY" === a.tagName ? I(r) : H(a, c, u),
                    f = d.width,
                    p = d.height,
                    g = d.left,
                    w = d.top,
                    m = {
                      backgroundColor: h,
                      fontMetrics: e,
                      imageStore: t,
                      logger: s,
                      scale: i.scale,
                      x: "number" == typeof i.x ? i.x : g,
                      y: "number" == typeof i.y ? i.y : w,
                      width: "number" == typeof i.width ? i.width : Math.ceil(f),
                      height: "number" == typeof i.height ? i.height : Math.ceil(p)
                    };
                  if (Array.isArray(i.target)) return Promise.all(i.target.map(function (t) {
                    return new Hi(t, m).render(l);
                  }));
                  var v = new Hi(i.target, m).render(l);
                  return !0 === i.removeContainer && n.parentNode && n.parentNode.removeChild(n), v;
                });
              });
            });
          }(t, function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var i = null != arguments[e] ? arguments[e] : {},
                s = Object.keys(i);
              "function" == typeof Object.getOwnPropertySymbols && (s = s.concat(Object.getOwnPropertySymbols(i).filter(function (t) {
                return Object.getOwnPropertyDescriptor(i, t).enumerable;
              }))), s.forEach(function (e) {
                bs(t, e, i[e]);
              });
            }
            return t;
          }({}, {
            allowTaint: !1,
            backgroundColor: "#ffffff",
            imageTimeout: 15e3,
            logging: !0,
            proxy: null,
            removeContainer: !0,
            foreignObjectRendering: !1,
            scale: n.devicePixelRatio || 1,
            target: new m(i.canvas),
            useCORS: !1,
            windowWidth: n.innerWidth,
            windowHeight: n.innerHeight,
            scrollX: n.pageXOffset,
            scrollY: n.pageYOffset
          }, i), s);
        };
        Bs.CanvasRenderer = m, e.default = Bs;
      }]).default;
    }, window.html2canvas = c(), t.exports = c();
    /** @license JSZip v3.1.5 | Copyright (c) 2009-2016 Stuart Knightley <stuart@stuartk.com> [https://stuk.github.io/jszip/] | MIT License [https://raw.github.com/Stuk/jszip/master/LICENSE.markdown] */
    var d,
      f = "undefined",
      p = null,
      g = function g(t, e) {
        this.files = {}, this.root = "", t && this.load(t, e);
      };
    g.signature = {
      LOCAL_FILE_HEADER: "PK",
      CENTRAL_FILE_HEADER: "PK",
      CENTRAL_DIRECTORY_END: "PK",
      ZIP64_CENTRAL_DIRECTORY_LOCATOR: "PK",
      ZIP64_CENTRAL_DIRECTORY_END: "PK",
      DATA_DESCRIPTOR: "PK\b"
    }, g.defaults = {
      base64: !1,
      binary: !1,
      dir: !1,
      date: p,
      compression: p
    }, g.support = {
      arraybuffer: typeof ArrayBuffer !== f && typeof Uint8Array !== f,
      nodebuffer: typeof r !== f,
      uint8array: typeof Uint8Array !== f,
      blob: function () {
        if (typeof ArrayBuffer === f) return !1;
        var t = new ArrayBuffer(0);
        try {
          return 0 === new Blob([t], {
            type: "application/zip"
          }).size;
        } catch (t) {}
        try {
          var e = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder)();
          return e.append(t), 0 === e.getBlob("application/zip").size;
        } catch (t) {}
        return !1;
      }()
    }, g.prototype = function () {
      var t, e;
      g.support.uint8array && "function" == typeof TextEncoder && "function" == typeof TextDecoder && (t = new TextEncoder("utf-8"), e = new TextDecoder("utf-8"));
      var i = function i(t) {
          if (t._data instanceof g.CompressedObject && (t._data = t._data.getContent(), t.options.binary = !0, t.options.base64 = !1, "uint8array" === g.utils.getTypeOf(t._data))) {
            var e = t._data;
            t._data = new Uint8Array(e.length), 0 !== e.length && t._data.set(e, 0);
          }
          return t._data;
        },
        s = function s(e) {
          var s = i(e);
          if ("string" === g.utils.getTypeOf(s)) {
            if (!e.options.binary) {
              if (t) return t.encode(s);
              if (g.support.nodebuffer) return new r(s, "utf-8");
            }
            return e.asBinary();
          }
          return s;
        },
        n = function n(t) {
          var e = i(this);
          return null == e ? "" : (this.options.base64 && (e = g.base64.decode(e)), e = t && this.options.binary ? g.prototype.utf8decode(e) : g.utils.transformTo("string", e), t || this.options.binary || (e = g.prototype.utf8encode(e)), e);
        },
        a = function a(t, e, i) {
          this.name = t, this._data = e, this.options = i;
        };
      a.prototype = {
        asText: function asText() {
          return n.call(this, !0);
        },
        asBinary: function asBinary() {
          return n.call(this, !1);
        },
        asNodeBuffer: function asNodeBuffer() {
          var t = s(this);
          return g.utils.transformTo("nodebuffer", t);
        },
        asUint8Array: function asUint8Array() {
          var t = s(this);
          return g.utils.transformTo("uint8array", t);
        },
        asArrayBuffer: function asArrayBuffer() {
          return this.asUint8Array().buffer;
        }
      };
      var o = function o(t, e) {
          var i,
            s = "";
          for (i = 0; i < e; i++) s += String.fromCharCode(255 & t), t >>>= 8;
          return s;
        },
        h = function h() {
          var t,
            e,
            i = {};
          for (t = 0; t < arguments.length; t++) for (e in arguments[t]) arguments[t].hasOwnProperty(e) && void 0 === i[e] && (i[e] = arguments[t][e]);
          return i;
        },
        l = function l(t, e, i) {
          var s = A(t),
            r = g.utils.getTypeOf(e);
          if (s && c.call(this, s), (i = function (t) {
            return !0 === (t = t || {}).base64 && null == t.binary && (t.binary = !0), (t = h(t, g.defaults)).date = t.date || new Date(), null !== t.compression && (t.compression = t.compression.toUpperCase()), t;
          }(i)).dir || null == e) i.base64 = !1, i.binary = !1, e = null;else if ("string" === r) i.binary && !i.base64 && !0 !== i.optimizedBinaryString && (e = g.utils.string2binary(e));else {
            if (i.base64 = !1, i.binary = !0, !(r || e instanceof g.CompressedObject)) throw new Error("The data of '" + t + "' is in an unsupported format !");
            "arraybuffer" === r && (e = g.utils.transformTo("uint8array", e));
          }
          return this.files[t] = new a(t, e, i);
        },
        A = function A(t) {
          "/" == t.slice(-1) && (t = t.substring(0, t.length - 1));
          var e = t.lastIndexOf("/");
          return e > 0 ? t.substring(0, e) : "";
        },
        c = function c(t) {
          return "/" != t.slice(-1) && (t += "/"), this.files[t] || l.call(this, t, null, {
            dir: !0
          }), this.files[t];
        },
        u = function u(t, e) {
          var i,
            r = new g.CompressedObject();
          return t._data instanceof g.CompressedObject ? (r.uncompressedSize = t._data.uncompressedSize, r.crc32 = t._data.crc32, 0 === r.uncompressedSize || t.options.dir ? (e = g.compressions.STORE, r.compressedContent = "", r.crc32 = 0) : t._data.compressionMethod === e.magic ? r.compressedContent = t._data.getCompressedContent() : (i = t._data.getContent(), r.compressedContent = e.compress(g.utils.transformTo(e.compressInputType, i)))) : ((i = s(t)) && 0 !== i.length && !t.options.dir || (e = g.compressions.STORE, i = ""), r.uncompressedSize = i.length, r.crc32 = this.crc32(i), r.compressedContent = e.compress(g.utils.transformTo(e.compressInputType, i))), r.compressedSize = r.compressedContent.length, r.compressionMethod = e.magic, r;
        },
        d = function d(t, e, i, s) {
          i.compressedContent;
          var r,
            n,
            a = this.utf8encode(e.name),
            h = a !== e.name,
            l = e.options;
          r = l.date.getHours(), r <<= 6, r |= l.date.getMinutes(), r <<= 5, r |= l.date.getSeconds() / 2, n = l.date.getFullYear() - 1980, n <<= 4, n |= l.date.getMonth() + 1, n <<= 5, n |= l.date.getDate();
          var A = "";
          return A += "\n\0", A += h ? "\0\b" : "\0\0", A += i.compressionMethod, A += o(r, 2), A += o(n, 2), A += o(i.crc32, 4), A += o(i.compressedSize, 4), A += o(i.uncompressedSize, 4), A += o(a.length, 2), A += "\0\0", {
            fileRecord: g.signature.LOCAL_FILE_HEADER + A + a,
            dirRecord: g.signature.CENTRAL_FILE_HEADER + "\0" + A + "\0\0\0\0\0\0" + (!0 === e.options.dir ? "\0\0\0" : "\0\0\0\0") + o(s, 4) + a,
            compressedObject: i
          };
        },
        f = function f() {
          this.data = [];
        };
      f.prototype = {
        append: function append(t) {
          t = g.utils.transformTo("string", t), this.data.push(t);
        },
        finalize: function finalize() {
          return this.data.join("");
        }
      };
      var p = function p(t) {
        this.data = new Uint8Array(t), this.index = 0;
      };
      return p.prototype = {
        append: function append(t) {
          0 !== t.length && (t = g.utils.transformTo("uint8array", t), this.data.set(t, this.index), this.index += t.length);
        },
        finalize: function finalize() {
          return this.data;
        }
      }, {
        load: function load(t, e) {
          throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
        },
        filter: function filter(t) {
          var e,
            i,
            s,
            r,
            n = [];
          for (e in this.files) this.files.hasOwnProperty(e) && (s = this.files[e], r = new a(s.name, s._data, h(s.options)), i = e.slice(this.root.length, e.length), e.slice(0, this.root.length) === this.root && t(i, r) && n.push(r));
          return n;
        },
        file: function file(t, e, i) {
          if (1 === arguments.length) {
            if (g.utils.isRegExp(t)) {
              var s = t;
              return this.filter(function (t, e) {
                return !e.options.dir && s.test(t);
              });
            }
            return this.filter(function (e, i) {
              return !i.options.dir && e === t;
            })[0] || null;
          }
          return t = this.root + t, l.call(this, t, e, i), this;
        },
        folder: function folder(t) {
          if (!t) return this;
          if (g.utils.isRegExp(t)) return this.filter(function (e, i) {
            return i.options.dir && t.test(e);
          });
          var e = this.root + t,
            i = c.call(this, e),
            s = this.clone();
          return s.root = i.name, s;
        },
        remove: function remove(t) {
          t = this.root + t;
          var e = this.files[t];
          if (e || ("/" != t.slice(-1) && (t += "/"), e = this.files[t]), e) if (e.options.dir) for (var i = this.filter(function (e, i) {
              return i.name.slice(0, t.length) === t;
            }), s = 0; s < i.length; s++) delete this.files[i[s].name];else delete this.files[t];
          return this;
        },
        generate: function generate(t) {
          t = h(t || {}, {
            base64: !0,
            compression: "STORE",
            type: "base64"
          }), g.utils.checkSupport(t.type);
          var e,
            i,
            s = [],
            r = 0,
            n = 0;
          for (var a in this.files) if (this.files.hasOwnProperty(a)) {
            var l = this.files[a],
              A = l.options.compression || t.compression.toUpperCase(),
              c = g.compressions[A];
            if (!c) throw new Error(A + " is not a valid compression method !");
            var w = u.call(this, l, c),
              m = d.call(this, a, l, w, r);
            r += m.fileRecord.length + w.compressedSize, n += m.dirRecord.length, s.push(m);
          }
          var v;
          switch (v = g.signature.CENTRAL_DIRECTORY_END + "\0\0\0\0" + o(s.length, 2) + o(s.length, 2) + o(n, 4) + o(r, 4) + "\0\0", t.type.toLowerCase()) {
            case "uint8array":
            case "arraybuffer":
            case "blob":
            case "nodebuffer":
              e = new p(r + n + v.length);
              break;
            case "base64":
            default:
              e = new f(r + n + v.length);
          }
          for (i = 0; i < s.length; i++) e.append(s[i].fileRecord), e.append(s[i].compressedObject.compressedContent);
          for (i = 0; i < s.length; i++) e.append(s[i].dirRecord);
          e.append(v);
          var b = e.finalize();
          switch (t.type.toLowerCase()) {
            case "uint8array":
            case "arraybuffer":
            case "nodebuffer":
              return g.utils.transformTo(t.type.toLowerCase(), b);
            case "blob":
              return g.utils.arrayBuffer2Blob(g.utils.transformTo("arraybuffer", b));
            case "base64":
              return t.base64 ? g.base64.encode(b) : b;
            default:
              return b;
          }
        },
        crc32: function crc32(t, e) {
          if (void 0 === t || !t.length) return 0;
          var i = "string" !== g.utils.getTypeOf(t),
            s = [0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615, 3915621685, 2657392035, 249268274, 2044508324, 3772115230, 2547177864, 162941995, 2125561021, 3887607047, 2428444049, 498536548, 1789927666, 4089016648, 2227061214, 450548861, 1843258603, 4107580753, 2211677639, 325883990, 1684777152, 4251122042, 2321926636, 335633487, 1661365465, 4195302755, 2366115317, 997073096, 1281953886, 3579855332, 2724688242, 1006888145, 1258607687, 3524101629, 2768942443, 901097722, 1119000684, 3686517206, 2898065728, 853044451, 1172266101, 3705015759, 2882616665, 651767980, 1373503546, 3369554304, 3218104598, 565507253, 1454621731, 3485111705, 3099436303, 671266974, 1594198024, 3322730930, 2970347812, 795835527, 1483230225, 3244367275, 3060149565, 1994146192, 31158534, 2563907772, 4023717930, 1907459465, 112637215, 2680153253, 3904427059, 2013776290, 251722036, 2517215374, 3775830040, 2137656763, 141376813, 2439277719, 3865271297, 1802195444, 476864866, 2238001368, 4066508878, 1812370925, 453092731, 2181625025, 4111451223, 1706088902, 314042704, 2344532202, 4240017532, 1658658271, 366619977, 2362670323, 4224994405, 1303535960, 984961486, 2747007092, 3569037538, 1256170817, 1037604311, 2765210733, 3554079995, 1131014506, 879679996, 2909243462, 3663771856, 1141124467, 855842277, 2852801631, 3708648649, 1342533948, 654459306, 3188396048, 3373015174, 1466479909, 544179635, 3110523913, 3462522015, 1591671054, 702138776, 2966460450, 3352799412, 1504918807, 783551873, 3082640443, 3233442989, 3988292384, 2596254646, 62317068, 1957810842, 3939845945, 2647816111, 81470997, 1943803523, 3814918930, 2489596804, 225274430, 2053790376, 3826175755, 2466906013, 167816743, 2097651377, 4027552580, 2265490386, 503444072, 1762050814, 4150417245, 2154129355, 426522225, 1852507879, 4275313526, 2312317920, 282753626, 1742555852, 4189708143, 2394877945, 397917763, 1622183637, 3604390888, 2714866558, 953729732, 1340076626, 3518719985, 2797360999, 1068828381, 1219638859, 3624741850, 2936675148, 906185462, 1090812512, 3747672003, 2825379669, 829329135, 1181335161, 3412177804, 3160834842, 628085408, 1382605366, 3423369109, 3138078467, 570562233, 1426400815, 3317316542, 2998733608, 733239954, 1555261956, 3268935591, 3050360625, 752459403, 1541320221, 2607071920, 3965973030, 1969922972, 40735498, 2617837225, 3943577151, 1913087877, 83908371, 2512341634, 3803740692, 2075208622, 213261112, 2463272603, 3855990285, 2094854071, 198958881, 2262029012, 4057260610, 1759359992, 534414190, 2176718541, 4139329115, 1873836001, 414664567, 2282248934, 4279200368, 1711684554, 285281116, 2405801727, 4167216745, 1634467795, 376229701, 2685067896, 3608007406, 1308918612, 956543938, 2808555105, 3495958263, 1231636301, 1047427035, 2932959818, 3654703836, 1088359270, 936918e3, 2847714899, 3736837829, 1202900863, 817233897, 3183342108, 3401237130, 1404277552, 615818150, 3134207493, 3453421203, 1423857449, 601450431, 3009837614, 3294710456, 1567103746, 711928724, 3020668471, 3272380065, 1510334235, 755167117];
          void 0 === e && (e = 0);
          e ^= -1;
          for (var r = 0, n = t.length; r < n; r++) e = e >>> 8 ^ s[255 & (e ^ (i ? t[r] : t.charCodeAt(r)))];
          return -1 ^ e;
        },
        clone: function clone() {
          var t = new g();
          for (var e in this) "function" != typeof this[e] && (t[e] = this[e]);
          return t;
        },
        utf8encode: function utf8encode(e) {
          if (t) {
            var i = t.encode(e);
            return g.utils.transformTo("string", i);
          }
          if (g.support.nodebuffer) return g.utils.transformTo("string", new r(e, "utf-8"));
          for (var s = [], n = 0, a = 0; a < e.length; a++) {
            var o = e.charCodeAt(a);
            o < 128 ? s[n++] = String.fromCharCode(o) : o > 127 && o < 2048 ? (s[n++] = String.fromCharCode(o >> 6 | 192), s[n++] = String.fromCharCode(63 & o | 128)) : (s[n++] = String.fromCharCode(o >> 12 | 224), s[n++] = String.fromCharCode(o >> 6 & 63 | 128), s[n++] = String.fromCharCode(63 & o | 128));
          }
          return s.join("");
        },
        utf8decode: function utf8decode(t) {
          var i = [],
            s = 0,
            r = "string" !== g.utils.getTypeOf(t),
            n = 0,
            a = 0,
            o = 0,
            h = 0;
          if (e) return e.decode(g.utils.transformTo("uint8array", t));
          if (g.support.nodebuffer) return g.utils.transformTo("nodebuffer", t).toString("utf-8");
          for (; n < t.length;) (a = r ? t[n] : t.charCodeAt(n)) < 128 ? (i[s++] = String.fromCharCode(a), n++) : a > 191 && a < 224 ? (o = r ? t[n + 1] : t.charCodeAt(n + 1), i[s++] = String.fromCharCode((31 & a) << 6 | 63 & o), n += 2) : (o = r ? t[n + 1] : t.charCodeAt(n + 1), h = r ? t[n + 2] : t.charCodeAt(n + 2), i[s++] = String.fromCharCode((15 & a) << 12 | (63 & o) << 6 | 63 & h), n += 3);
          return i.join("");
        }
      };
    }(), g.compressions = {
      STORE: {
        magic: "\0\0",
        compress: function compress(t) {
          return t;
        },
        uncompress: function uncompress(t) {
          return t;
        },
        compressInputType: p,
        uncompressInputType: p
      }
    }, function () {
      function t(t) {
        return t;
      }
      function e(t, e) {
        for (var i = 0; i < t.length; ++i) e[i] = 255 & t.charCodeAt(i);
        return e;
      }
      function i(t) {
        var e = 65536,
          i = [],
          s = t.length,
          n = g.utils.getTypeOf(t),
          a = 0,
          o = !0;
        try {
          switch (n) {
            case "uint8array":
              String.fromCharCode.apply(null, new Uint8Array(0));
              break;
            case "nodebuffer":
              String.fromCharCode.apply(null, new r(0));
          }
        } catch (t) {
          o = !1;
        }
        if (!o) {
          for (var h = "", l = 0; l < t.length; l++) h += String.fromCharCode(t[l]);
          return h;
        }
        for (; a < s && e > 1;) try {
          "array" === n || "nodebuffer" === n ? i.push(String.fromCharCode.apply(null, t.slice(a, Math.min(a + e, s)))) : i.push(String.fromCharCode.apply(null, t.subarray(a, Math.min(a + e, s)))), a += e;
        } catch (t) {
          e = Math.floor(e / 2);
        }
        return i.join("");
      }
      function s(t, e) {
        for (var i = 0; i < t.length; i++) e[i] = t[i];
        return e;
      }
      g.utils = {
        string2binary: function string2binary(t) {
          for (var e = "", i = 0; i < t.length; i++) e += String.fromCharCode(255 & t.charCodeAt(i));
          return e;
        },
        string2Uint8Array: function string2Uint8Array(t) {
          return g.utils.transformTo("uint8array", t);
        },
        uint8Array2String: function uint8Array2String(t) {
          return g.utils.transformTo("string", t);
        },
        arrayBuffer2Blob: function arrayBuffer2Blob(t) {
          g.utils.checkSupport("blob");
          try {
            return new Blob([t], {
              type: "application/zip"
            });
          } catch (t) {}
          try {
            var e = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder)();
            return e.append(t), e.getBlob("application/zip");
          } catch (t) {}
          throw new Error("Bug : can't construct the Blob.");
        },
        string2Blob: function string2Blob(t) {
          var e = g.utils.transformTo("arraybuffer", t);
          return g.utils.arrayBuffer2Blob(e);
        }
      };
      var n = {};
      n.string = {
        string: t,
        array: function array(t) {
          return e(t, new Array(t.length));
        },
        arraybuffer: function arraybuffer(t) {
          return n.string.uint8array(t).buffer;
        },
        uint8array: function uint8array(t) {
          return e(t, new Uint8Array(t.length));
        },
        nodebuffer: function nodebuffer(t) {
          return e(t, new r(t.length));
        }
      }, n.array = {
        string: i,
        array: t,
        arraybuffer: function arraybuffer(t) {
          return new Uint8Array(t).buffer;
        },
        uint8array: function uint8array(t) {
          return new Uint8Array(t);
        },
        nodebuffer: function nodebuffer(t) {
          return new r(t);
        }
      }, n.arraybuffer = {
        string: function string(t) {
          return i(new Uint8Array(t));
        },
        array: function array(t) {
          return s(new Uint8Array(t), new Array(t.byteLength));
        },
        arraybuffer: t,
        uint8array: function uint8array(t) {
          return new Uint8Array(t);
        },
        nodebuffer: function nodebuffer(t) {
          return new r(new Uint8Array(t));
        }
      }, n.uint8array = {
        string: i,
        array: function array(t) {
          return s(t, new Array(t.length));
        },
        arraybuffer: function arraybuffer(t) {
          return t.buffer;
        },
        uint8array: t,
        nodebuffer: function nodebuffer(t) {
          return new r(t);
        }
      }, n.nodebuffer = {
        string: i,
        array: function array(t) {
          return s(t, new Array(t.length));
        },
        arraybuffer: function arraybuffer(t) {
          return n.nodebuffer.uint8array(t).buffer;
        },
        uint8array: function uint8array(t) {
          return s(t, new Uint8Array(t.length));
        },
        nodebuffer: t
      }, g.utils.transformTo = function (t, e) {
        if (e || (e = ""), !t) return e;
        g.utils.checkSupport(t);
        var i = g.utils.getTypeOf(e);
        return n[i][t](e);
      }, g.utils.getTypeOf = function (t) {
        return "string" == typeof t ? "string" : "[object Array]" === Object.prototype.toString.call(t) ? "array" : g.support.nodebuffer && r.isBuffer(t) ? "nodebuffer" : g.support.uint8array && t instanceof Uint8Array ? "uint8array" : g.support.arraybuffer && t instanceof ArrayBuffer ? "arraybuffer" : void 0;
      }, g.utils.isRegExp = function (t) {
        return "[object RegExp]" === Object.prototype.toString.call(t);
      }, g.utils.checkSupport = function (t) {
        var e = !0;
        switch (t.toLowerCase()) {
          case "uint8array":
            e = g.support.uint8array;
            break;
          case "arraybuffer":
            e = g.support.arraybuffer;
            break;
          case "nodebuffer":
            e = g.support.nodebuffer;
            break;
          case "blob":
            e = g.support.blob;
        }
        if (!e) throw new Error(t + " is not supported by this browser");
      };
    }(), g.CompressedObject = function () {
      this.compressedSize = 0, this.uncompressedSize = 0, this.crc32 = 0, this.compressionMethod = p, this.compressedContent = p;
    }, g.CompressedObject.prototype = {
      getContent: function getContent() {
        return p;
      },
      getCompressedContent: function getCompressedContent() {
        return p;
      }
    }, g.base64 = (d = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", {
      encode: function encode(t, e) {
        for (var i, s, r, n, a, o, h, l = "", A = 0; A < t.length;) n = (i = t.charCodeAt(A++)) >> 2, a = (3 & i) << 4 | (s = t.charCodeAt(A++)) >> 4, o = (15 & s) << 2 | (r = t.charCodeAt(A++)) >> 6, h = 63 & r, isNaN(s) ? o = h = 64 : isNaN(r) && (h = 64), l = l + d.charAt(n) + d.charAt(a) + d.charAt(o) + d.charAt(h);
        return l;
      },
      decode: function decode(t, e) {
        var i,
          s,
          r,
          n,
          a,
          o,
          h = "",
          l = 0;
        for (t = t.replace(/[^A-Za-z0-9\+\/\=]/g, ""); l < t.length;) i = d.indexOf(t.charAt(l++)) << 2 | (n = d.indexOf(t.charAt(l++))) >> 4, s = (15 & n) << 4 | (a = d.indexOf(t.charAt(l++))) >> 2, r = (3 & a) << 6 | (o = d.indexOf(t.charAt(l++))), h += String.fromCharCode(i), 64 != a && (h += String.fromCharCode(s)), 64 != o && (h += String.fromCharCode(r));
        return h;
      }
    }), void 0 !== window.jQuery && (window.jQuery.fn.webdatarocks = function (t) {
      return (t = t || {}).container = this.get(0), t = window.WebDataRocks ? window.WebDataRocks(t) : window.PivotApi(t), this.data("webdatarocks", t), t;
    }), void 0 !== window.angular && window.angular.module("webdatarocks", []).directive("wbrPivot", function () {
      return {
        restrict: "A",
        scope: {
          report: "=wbrReport",
          customizeCell: "&wbrCustomizeCell",
          cellclick: "&wbrCellClick",
          celldoubleclick: "&wbrCellDoubleClick",
          dataerror: "&wbrDataError",
          datafilecancelled: "&wbrDataFileCancelled",
          dataloaded: "&wbrDataLoaded",
          datachanged: "&wbrDataChanged",
          fieldslistclose: "&wbrFieldsListClose",
          fieldslistopen: "&wbrFieldsListOpen",
          filteropen: "&wbrFilteropen",
          fullscreen: "&wbrFullscreen",
          loadingdata: "&wbrLoadingData",
          loadinglocalization: "&wbrLoadingLocalization",
          loadingolapstructure: "&wbrLoadingOlapStructure",
          loadingreportfile: "&wbrLoadingReportFile",
          localizationerror: "&wbrLocalizationError",
          localizationloaded: "&wbrLocalizationLoaded",
          openingreportfile: "&wbrOpeningReportFile",
          querycomplete: "&wbrQueryComplete",
          queryerror: "&wbrQueryError",
          ready: "&wbrReady",
          reportchange: "&wbrReportChange",
          reportcomplete: "&wbrReportComplete",
          reportfilecancelled: "&wbrReportFileCancelled",
          reportfileerror: "&wbrReportFileError",
          reportfileloaded: "&wbrReportFileLoaded",
          runningquery: "&wbrRunningQuery",
          update: "&wbrUpdate",
          beforetoolbarcreated: "&wbrBeforeToolbarCreated"
        },
        link: function link(t, e, i, s) {
          (s = {}).container = e[0], function (t, e) {
            void 0 !== t.wbrGlobal && (e.global = t.wbrGlobal), void 0 !== t.wbrWidth && (e.width = t.wbrWidth), void 0 !== t.wbrHeight && (e.height = t.wbrHeight), void 0 !== t.wbrToolbar && (e.toolbar = !0 === t.wbrToolbar || "true" == t.wbrToolbar || "on" == t.wbrToolbar);
          }(i, s), t.customizeCell && (s.customizeCell = function (e, i) {
            return t.customizeCell({
              html: e,
              data: i
            });
          }), t.cellclick && (s.cellclick = function (e) {
            t.cellclick({
              cell: e
            });
          }), t.celldoubleclick && (s.celldoubleclick = function (e) {
            t.celldoubleclick({
              cell: e
            });
          }), s.dataerror = t.dataerror, s.datafilecancelled = t.datafilecancelled, s.dataloaded = t.dataloaded, s.datachanged && (s.datachanged = function (e) {
            t.datachanged({
              event: e
            });
          }), s.fieldslistclose = t.fieldslistclose, s.fieldslistopen = t.fieldslistopen, s.filteropen && (s.filteropen = function (e) {
            t.filteropen({
              params: e
            });
          }), s.fullscreen && (s.fullscreen = function (e) {
            t.fullscreen({
              fullScreenMode: e
            });
          }), s.loadingdata = t.loadingdata, s.loadinglocalization = t.loadinglocalization, s.loadingolapstructure = t.loadingolapstructure, s.loadingreportfile = t.loadingreportfile, s.localizationerror = t.localizationerror, s.localizationloaded = t.localizationloaded, s.olapstructureerror = t.olapstructureerror, s.olapstructureloaded = t.olapstructureloaded, s.openingreportfile = t.openingreportfile, s.querycomplete = t.querycomplete, s.queryerror = t.queryerror, t.ready && (s.ready = function () {
            t.ready({
              pivot: r
            });
          }), s.reportchange = t.reportchange, s.reportcomplete = t.reportcomplete, s.reportfilecancelled = t.reportfilecancelled, s.reportfileerror = t.reportfileerror, s.reportfileloaded = t.reportfileloaded, s.runningquery = t.runningquery, s.loadingdata = t.loadingdata, s.loadingdata = t.loadingdata, s.loadingdata = t.loadingdata, s.update = t.update, t.beforetoolbarcreated && (s.beforetoolbarcreated = function (e) {
            t.beforetoolbarcreated({
              toolbar: e
            });
          }), t.report && (s.report = t.report), t.global && (s.global = t.global);
          var r = new WebDataRocks(s);
        }
      };
    }), void 0 !== window.React && (window.WebDataRocksReact = {
      Pivot: React.createClass({
        propTypes: {
          global: React.PropTypes.object,
          width: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
          height: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
          report: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.object]),
          toolbar: React.PropTypes.bool,
          customizeCell: React.PropTypes.func,
          cellclick: React.PropTypes.func,
          celldoubleclick: React.PropTypes.func,
          dataerror: React.PropTypes.func,
          datafilecancelled: React.PropTypes.func,
          dataloaded: React.PropTypes.func,
          datachanged: React.PropTypes.func,
          fieldslistclose: React.PropTypes.func,
          fieldslistopen: React.PropTypes.func,
          filteropen: React.PropTypes.func,
          fullscreen: React.PropTypes.func,
          loadingdata: React.PropTypes.func,
          loadinglocalization: React.PropTypes.func,
          loadingolapstructure: React.PropTypes.func,
          loadingreportfile: React.PropTypes.func,
          localizationerror: React.PropTypes.func,
          localizationloaded: React.PropTypes.func,
          olapstructureerror: React.PropTypes.func,
          olapstructureloaded: React.PropTypes.func,
          openingreportfile: React.PropTypes.func,
          querycomplete: React.PropTypes.func,
          queryerror: React.PropTypes.func,
          ready: React.PropTypes.func,
          reportchange: React.PropTypes.func,
          reportcomplete: React.PropTypes.func,
          reportfilecancelled: React.PropTypes.func,
          reportfileerror: React.PropTypes.func,
          reportfileloaded: React.PropTypes.func,
          runningquery: React.PropTypes.func,
          update: React.PropTypes.func,
          beforetoolbarcreated: React.PropTypes.func
        },
        render: function render() {
          return React.DOM.div();
        },
        componentDidMount: function componentDidMount() {
          var t = {};
          t.container = ReactDOM.findDOMNode(this), this.parseProps(t), this.webdatarocks = new window.WebDataRocks(t);
        },
        shouldComponentUpdate: function shouldComponentUpdate() {
          return !1;
        },
        componentWillUnmount: function componentWillUnmount() {},
        parseProps: function parseProps(t) {
          for (var e in this.props) t[e] = this.props[e];
        }
      })
    }), t.exports && (t.exports = WebDataRocks);
  }).call(this, i(5)(t), i(0), i(6).Buffer);
}, function (t, e) {
  t.exports = function (t) {
    return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
      enumerable: !0,
      get: function get() {
        return t.l;
      }
    }), Object.defineProperty(t, "id", {
      enumerable: !0,
      get: function get() {
        return t.i;
      }
    }), t.webpackPolyfill = 1), t;
  };
}, function (t, e, i) {
  "use strict";

  (function (t) {
    /*!
     * The buffer module from node.js, for the browser.
     *
     * @author   Feross Aboukhadijeh <http://feross.org>
     * @license  MIT
     */
    var s = i(7),
      r = i(8),
      n = i(9);
    function a() {
      return h.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
    }
    function o(t, e) {
      if (a() < e) throw new RangeError("Invalid typed array length");
      return h.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = h.prototype : (null === t && (t = new h(e)), t.length = e), t;
    }
    function h(t, e, i) {
      if (!(h.TYPED_ARRAY_SUPPORT || this instanceof h)) return new h(t, e, i);
      if ("number" == typeof t) {
        if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
        return c(this, t);
      }
      return l(this, t, e, i);
    }
    function l(t, e, i, s) {
      if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
      return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, i, s) {
        if (e.byteLength, i < 0 || e.byteLength < i) throw new RangeError("'offset' is out of bounds");
        if (e.byteLength < i + (s || 0)) throw new RangeError("'length' is out of bounds");
        e = void 0 === i && void 0 === s ? new Uint8Array(e) : void 0 === s ? new Uint8Array(e, i) : new Uint8Array(e, i, s);
        h.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = h.prototype : t = u(t, e);
        return t;
      }(t, e, i, s) : "string" == typeof e ? function (t, e, i) {
        "string" == typeof i && "" !== i || (i = "utf8");
        if (!h.isEncoding(i)) throw new TypeError('"encoding" must be a valid string encoding');
        var s = 0 | f(e, i),
          r = (t = o(t, s)).write(e, i);
        r !== s && (t = t.slice(0, r));
        return t;
      }(t, e, i) : function (t, e) {
        if (h.isBuffer(e)) {
          var i = 0 | d(e.length);
          return 0 === (t = o(t, i)).length || e.copy(t, 0, 0, i), t;
        }
        if (e) {
          if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (s = e.length) != s ? o(t, 0) : u(t, e);
          if ("Buffer" === e.type && n(e.data)) return u(t, e.data);
        }
        var s;
        throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
      }(t, e);
    }
    function A(t) {
      if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
      if (t < 0) throw new RangeError('"size" argument must not be negative');
    }
    function c(t, e) {
      if (A(e), t = o(t, e < 0 ? 0 : 0 | d(e)), !h.TYPED_ARRAY_SUPPORT) for (var i = 0; i < e; ++i) t[i] = 0;
      return t;
    }
    function u(t, e) {
      var i = e.length < 0 ? 0 : 0 | d(e.length);
      t = o(t, i);
      for (var s = 0; s < i; s += 1) t[s] = 255 & e[s];
      return t;
    }
    function d(t) {
      if (t >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
      return 0 | t;
    }
    function f(t, e) {
      if (h.isBuffer(t)) return t.length;
      if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
      "string" != typeof t && (t = "" + t);
      var i = t.length;
      if (0 === i) return 0;
      for (var s = !1;;) switch (e) {
        case "ascii":
        case "latin1":
        case "binary":
          return i;
        case "utf8":
        case "utf-8":
        case void 0:
          return D(t).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return 2 * i;
        case "hex":
          return i >>> 1;
        case "base64":
          return R(t).length;
        default:
          if (s) return D(t).length;
          e = ("" + e).toLowerCase(), s = !0;
      }
    }
    function p(t, e, i) {
      var s = !1;
      if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
      if ((void 0 === i || i > this.length) && (i = this.length), i <= 0) return "";
      if ((i >>>= 0) <= (e >>>= 0)) return "";
      for (t || (t = "utf8");;) switch (t) {
        case "hex":
          return Q(this, e, i);
        case "utf8":
        case "utf-8":
          return N(this, e, i);
        case "ascii":
          return E(this, e, i);
        case "latin1":
        case "binary":
          return U(this, e, i);
        case "base64":
          return x(this, e, i);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return L(this, e, i);
        default:
          if (s) throw new TypeError("Unknown encoding: " + t);
          t = (t + "").toLowerCase(), s = !0;
      }
    }
    function g(t, e, i) {
      var s = t[e];
      t[e] = t[i], t[i] = s;
    }
    function w(t, e, i, s, r) {
      if (0 === t.length) return -1;
      if ("string" == typeof i ? (s = i, i = 0) : i > 2147483647 ? i = 2147483647 : i < -2147483648 && (i = -2147483648), i = +i, isNaN(i) && (i = r ? 0 : t.length - 1), i < 0 && (i = t.length + i), i >= t.length) {
        if (r) return -1;
        i = t.length - 1;
      } else if (i < 0) {
        if (!r) return -1;
        i = 0;
      }
      if ("string" == typeof e && (e = h.from(e, s)), h.isBuffer(e)) return 0 === e.length ? -1 : m(t, e, i, s, r);
      if ("number" == typeof e) return e &= 255, h.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? r ? Uint8Array.prototype.indexOf.call(t, e, i) : Uint8Array.prototype.lastIndexOf.call(t, e, i) : m(t, [e], i, s, r);
      throw new TypeError("val must be string, number or Buffer");
    }
    function m(t, e, i, s, r) {
      var n,
        a = 1,
        o = t.length,
        h = e.length;
      if (void 0 !== s && ("ucs2" === (s = String(s).toLowerCase()) || "ucs-2" === s || "utf16le" === s || "utf-16le" === s)) {
        if (t.length < 2 || e.length < 2) return -1;
        a = 2, o /= 2, h /= 2, i /= 2;
      }
      function l(t, e) {
        return 1 === a ? t[e] : t.readUInt16BE(e * a);
      }
      if (r) {
        var A = -1;
        for (n = i; n < o; n++) if (l(t, n) === l(e, -1 === A ? 0 : n - A)) {
          if (-1 === A && (A = n), n - A + 1 === h) return A * a;
        } else -1 !== A && (n -= n - A), A = -1;
      } else for (i + h > o && (i = o - h), n = i; n >= 0; n--) {
        for (var c = !0, u = 0; u < h; u++) if (l(t, n + u) !== l(e, u)) {
          c = !1;
          break;
        }
        if (c) return n;
      }
      return -1;
    }
    function v(t, e, i, s) {
      i = Number(i) || 0;
      var r = t.length - i;
      s ? (s = Number(s)) > r && (s = r) : s = r;
      var n = e.length;
      if (n % 2 != 0) throw new TypeError("Invalid hex string");
      s > n / 2 && (s = n / 2);
      for (var a = 0; a < s; ++a) {
        var o = parseInt(e.substr(2 * a, 2), 16);
        if (isNaN(o)) return a;
        t[i + a] = o;
      }
      return a;
    }
    function b(t, e, i, s) {
      return _(D(e, t.length - i), t, i, s);
    }
    function B(t, e, i, s) {
      return _(function (t) {
        for (var e = [], i = 0; i < t.length; ++i) e.push(255 & t.charCodeAt(i));
        return e;
      }(e), t, i, s);
    }
    function y(t, e, i, s) {
      return B(t, e, i, s);
    }
    function C(t, e, i, s) {
      return _(R(e), t, i, s);
    }
    function F(t, e, i, s) {
      return _(function (t, e) {
        for (var i, s, r, n = [], a = 0; a < t.length && !((e -= 2) < 0); ++a) i = t.charCodeAt(a), s = i >> 8, r = i % 256, n.push(r), n.push(s);
        return n;
      }(e, t.length - i), t, i, s);
    }
    function x(t, e, i) {
      return 0 === e && i === t.length ? s.fromByteArray(t) : s.fromByteArray(t.slice(e, i));
    }
    function N(t, e, i) {
      i = Math.min(t.length, i);
      for (var s = [], r = e; r < i;) {
        var n,
          a,
          o,
          h,
          l = t[r],
          A = null,
          c = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
        if (r + c <= i) switch (c) {
          case 1:
            l < 128 && (A = l);
            break;
          case 2:
            128 == (192 & (n = t[r + 1])) && (h = (31 & l) << 6 | 63 & n) > 127 && (A = h);
            break;
          case 3:
            n = t[r + 1], a = t[r + 2], 128 == (192 & n) && 128 == (192 & a) && (h = (15 & l) << 12 | (63 & n) << 6 | 63 & a) > 2047 && (h < 55296 || h > 57343) && (A = h);
            break;
          case 4:
            n = t[r + 1], a = t[r + 2], o = t[r + 3], 128 == (192 & n) && 128 == (192 & a) && 128 == (192 & o) && (h = (15 & l) << 18 | (63 & n) << 12 | (63 & a) << 6 | 63 & o) > 65535 && h < 1114112 && (A = h);
        }
        null === A ? (A = 65533, c = 1) : A > 65535 && (A -= 65536, s.push(A >>> 10 & 1023 | 55296), A = 56320 | 1023 & A), s.push(A), r += c;
      }
      return function (t) {
        var e = t.length;
        if (e <= 4096) return String.fromCharCode.apply(String, t);
        var i = "",
          s = 0;
        for (; s < e;) i += String.fromCharCode.apply(String, t.slice(s, s += 4096));
        return i;
      }(s);
    }
    e.Buffer = h, e.SlowBuffer = function (t) {
      +t != t && (t = 0);
      return h.alloc(+t);
    }, e.INSPECT_MAX_BYTES = 50, h.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
      try {
        var t = new Uint8Array(1);
        return t.__proto__ = {
          __proto__: Uint8Array.prototype,
          foo: function foo() {
            return 42;
          }
        }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
      } catch (t) {
        return !1;
      }
    }(), e.kMaxLength = a(), h.poolSize = 8192, h._augment = function (t) {
      return t.__proto__ = h.prototype, t;
    }, h.from = function (t, e, i) {
      return l(null, t, e, i);
    }, h.TYPED_ARRAY_SUPPORT && (h.prototype.__proto__ = Uint8Array.prototype, h.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && h[Symbol.species] === h && Object.defineProperty(h, Symbol.species, {
      value: null,
      configurable: !0
    })), h.alloc = function (t, e, i) {
      return function (t, e, i, s) {
        return A(e), e <= 0 ? o(t, e) : void 0 !== i ? "string" == typeof s ? o(t, e).fill(i, s) : o(t, e).fill(i) : o(t, e);
      }(null, t, e, i);
    }, h.allocUnsafe = function (t) {
      return c(null, t);
    }, h.allocUnsafeSlow = function (t) {
      return c(null, t);
    }, h.isBuffer = function (t) {
      return !(null == t || !t._isBuffer);
    }, h.compare = function (t, e) {
      if (!h.isBuffer(t) || !h.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
      if (t === e) return 0;
      for (var i = t.length, s = e.length, r = 0, n = Math.min(i, s); r < n; ++r) if (t[r] !== e[r]) {
        i = t[r], s = e[r];
        break;
      }
      return i < s ? -1 : s < i ? 1 : 0;
    }, h.isEncoding = function (t) {
      switch (String(t).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, h.concat = function (t, e) {
      if (!n(t)) throw new TypeError('"list" argument must be an Array of Buffers');
      if (0 === t.length) return h.alloc(0);
      var i;
      if (void 0 === e) for (e = 0, i = 0; i < t.length; ++i) e += t[i].length;
      var s = h.allocUnsafe(e),
        r = 0;
      for (i = 0; i < t.length; ++i) {
        var a = t[i];
        if (!h.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
        a.copy(s, r), r += a.length;
      }
      return s;
    }, h.byteLength = f, h.prototype._isBuffer = !0, h.prototype.swap16 = function () {
      var t = this.length;
      if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var e = 0; e < t; e += 2) g(this, e, e + 1);
      return this;
    }, h.prototype.swap32 = function () {
      var t = this.length;
      if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var e = 0; e < t; e += 4) g(this, e, e + 3), g(this, e + 1, e + 2);
      return this;
    }, h.prototype.swap64 = function () {
      var t = this.length;
      if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var e = 0; e < t; e += 8) g(this, e, e + 7), g(this, e + 1, e + 6), g(this, e + 2, e + 5), g(this, e + 3, e + 4);
      return this;
    }, h.prototype.toString = function () {
      var t = 0 | this.length;
      return 0 === t ? "" : 0 === arguments.length ? N(this, 0, t) : p.apply(this, arguments);
    }, h.prototype.equals = function (t) {
      if (!h.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
      return this === t || 0 === h.compare(this, t);
    }, h.prototype.inspect = function () {
      var t = "",
        i = e.INSPECT_MAX_BYTES;
      return this.length > 0 && (t = this.toString("hex", 0, i).match(/.{2}/g).join(" "), this.length > i && (t += " ... ")), "<Buffer " + t + ">";
    }, h.prototype.compare = function (t, e, i, s, r) {
      if (!h.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
      if (void 0 === e && (e = 0), void 0 === i && (i = t ? t.length : 0), void 0 === s && (s = 0), void 0 === r && (r = this.length), e < 0 || i > t.length || s < 0 || r > this.length) throw new RangeError("out of range index");
      if (s >= r && e >= i) return 0;
      if (s >= r) return -1;
      if (e >= i) return 1;
      if (this === t) return 0;
      for (var n = (r >>>= 0) - (s >>>= 0), a = (i >>>= 0) - (e >>>= 0), o = Math.min(n, a), l = this.slice(s, r), A = t.slice(e, i), c = 0; c < o; ++c) if (l[c] !== A[c]) {
        n = l[c], a = A[c];
        break;
      }
      return n < a ? -1 : a < n ? 1 : 0;
    }, h.prototype.includes = function (t, e, i) {
      return -1 !== this.indexOf(t, e, i);
    }, h.prototype.indexOf = function (t, e, i) {
      return w(this, t, e, i, !0);
    }, h.prototype.lastIndexOf = function (t, e, i) {
      return w(this, t, e, i, !1);
    }, h.prototype.write = function (t, e, i, s) {
      if (void 0 === e) s = "utf8", i = this.length, e = 0;else if (void 0 === i && "string" == typeof e) s = e, i = this.length, e = 0;else {
        if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
        e |= 0, isFinite(i) ? (i |= 0, void 0 === s && (s = "utf8")) : (s = i, i = void 0);
      }
      var r = this.length - e;
      if ((void 0 === i || i > r) && (i = r), t.length > 0 && (i < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
      s || (s = "utf8");
      for (var n = !1;;) switch (s) {
        case "hex":
          return v(this, t, e, i);
        case "utf8":
        case "utf-8":
          return b(this, t, e, i);
        case "ascii":
          return B(this, t, e, i);
        case "latin1":
        case "binary":
          return y(this, t, e, i);
        case "base64":
          return C(this, t, e, i);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return F(this, t, e, i);
        default:
          if (n) throw new TypeError("Unknown encoding: " + s);
          s = ("" + s).toLowerCase(), n = !0;
      }
    }, h.prototype.toJSON = function () {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function E(t, e, i) {
      var s = "";
      i = Math.min(t.length, i);
      for (var r = e; r < i; ++r) s += String.fromCharCode(127 & t[r]);
      return s;
    }
    function U(t, e, i) {
      var s = "";
      i = Math.min(t.length, i);
      for (var r = e; r < i; ++r) s += String.fromCharCode(t[r]);
      return s;
    }
    function Q(t, e, i) {
      var s = t.length;
      (!e || e < 0) && (e = 0), (!i || i < 0 || i > s) && (i = s);
      for (var r = "", n = e; n < i; ++n) r += M(t[n]);
      return r;
    }
    function L(t, e, i) {
      for (var s = t.slice(e, i), r = "", n = 0; n < s.length; n += 2) r += String.fromCharCode(s[n] + 256 * s[n + 1]);
      return r;
    }
    function S(t, e, i) {
      if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
      if (t + e > i) throw new RangeError("Trying to access beyond buffer length");
    }
    function k(t, e, i, s, r, n) {
      if (!h.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (e > r || e < n) throw new RangeError('"value" argument is out of bounds');
      if (i + s > t.length) throw new RangeError("Index out of range");
    }
    function H(t, e, i, s) {
      e < 0 && (e = 65535 + e + 1);
      for (var r = 0, n = Math.min(t.length - i, 2); r < n; ++r) t[i + r] = (e & 255 << 8 * (s ? r : 1 - r)) >>> 8 * (s ? r : 1 - r);
    }
    function I(t, e, i, s) {
      e < 0 && (e = 4294967295 + e + 1);
      for (var r = 0, n = Math.min(t.length - i, 4); r < n; ++r) t[i + r] = e >>> 8 * (s ? r : 3 - r) & 255;
    }
    function O(t, e, i, s, r, n) {
      if (i + s > t.length) throw new RangeError("Index out of range");
      if (i < 0) throw new RangeError("Index out of range");
    }
    function T(t, e, i, s, n) {
      return n || O(t, 0, i, 4), r.write(t, e, i, s, 23, 4), i + 4;
    }
    function P(t, e, i, s, n) {
      return n || O(t, 0, i, 8), r.write(t, e, i, s, 52, 8), i + 8;
    }
    h.prototype.slice = function (t, e) {
      var i,
        s = this.length;
      if ((t = ~~t) < 0 ? (t += s) < 0 && (t = 0) : t > s && (t = s), (e = void 0 === e ? s : ~~e) < 0 ? (e += s) < 0 && (e = 0) : e > s && (e = s), e < t && (e = t), h.TYPED_ARRAY_SUPPORT) (i = this.subarray(t, e)).__proto__ = h.prototype;else {
        var r = e - t;
        i = new h(r, void 0);
        for (var n = 0; n < r; ++n) i[n] = this[n + t];
      }
      return i;
    }, h.prototype.readUIntLE = function (t, e, i) {
      t |= 0, e |= 0, i || S(t, e, this.length);
      for (var s = this[t], r = 1, n = 0; ++n < e && (r *= 256);) s += this[t + n] * r;
      return s;
    }, h.prototype.readUIntBE = function (t, e, i) {
      t |= 0, e |= 0, i || S(t, e, this.length);
      for (var s = this[t + --e], r = 1; e > 0 && (r *= 256);) s += this[t + --e] * r;
      return s;
    }, h.prototype.readUInt8 = function (t, e) {
      return e || S(t, 1, this.length), this[t];
    }, h.prototype.readUInt16LE = function (t, e) {
      return e || S(t, 2, this.length), this[t] | this[t + 1] << 8;
    }, h.prototype.readUInt16BE = function (t, e) {
      return e || S(t, 2, this.length), this[t] << 8 | this[t + 1];
    }, h.prototype.readUInt32LE = function (t, e) {
      return e || S(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
    }, h.prototype.readUInt32BE = function (t, e) {
      return e || S(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
    }, h.prototype.readIntLE = function (t, e, i) {
      t |= 0, e |= 0, i || S(t, e, this.length);
      for (var s = this[t], r = 1, n = 0; ++n < e && (r *= 256);) s += this[t + n] * r;
      return s >= (r *= 128) && (s -= Math.pow(2, 8 * e)), s;
    }, h.prototype.readIntBE = function (t, e, i) {
      t |= 0, e |= 0, i || S(t, e, this.length);
      for (var s = e, r = 1, n = this[t + --s]; s > 0 && (r *= 256);) n += this[t + --s] * r;
      return n >= (r *= 128) && (n -= Math.pow(2, 8 * e)), n;
    }, h.prototype.readInt8 = function (t, e) {
      return e || S(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
    }, h.prototype.readInt16LE = function (t, e) {
      e || S(t, 2, this.length);
      var i = this[t] | this[t + 1] << 8;
      return 32768 & i ? 4294901760 | i : i;
    }, h.prototype.readInt16BE = function (t, e) {
      e || S(t, 2, this.length);
      var i = this[t + 1] | this[t] << 8;
      return 32768 & i ? 4294901760 | i : i;
    }, h.prototype.readInt32LE = function (t, e) {
      return e || S(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
    }, h.prototype.readInt32BE = function (t, e) {
      return e || S(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
    }, h.prototype.readFloatLE = function (t, e) {
      return e || S(t, 4, this.length), r.read(this, t, !0, 23, 4);
    }, h.prototype.readFloatBE = function (t, e) {
      return e || S(t, 4, this.length), r.read(this, t, !1, 23, 4);
    }, h.prototype.readDoubleLE = function (t, e) {
      return e || S(t, 8, this.length), r.read(this, t, !0, 52, 8);
    }, h.prototype.readDoubleBE = function (t, e) {
      return e || S(t, 8, this.length), r.read(this, t, !1, 52, 8);
    }, h.prototype.writeUIntLE = function (t, e, i, s) {
      (t = +t, e |= 0, i |= 0, s) || k(this, t, e, i, Math.pow(2, 8 * i) - 1, 0);
      var r = 1,
        n = 0;
      for (this[e] = 255 & t; ++n < i && (r *= 256);) this[e + n] = t / r & 255;
      return e + i;
    }, h.prototype.writeUIntBE = function (t, e, i, s) {
      (t = +t, e |= 0, i |= 0, s) || k(this, t, e, i, Math.pow(2, 8 * i) - 1, 0);
      var r = i - 1,
        n = 1;
      for (this[e + r] = 255 & t; --r >= 0 && (n *= 256);) this[e + r] = t / n & 255;
      return e + i;
    }, h.prototype.writeUInt8 = function (t, e, i) {
      return t = +t, e |= 0, i || k(this, t, e, 1, 255, 0), h.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
    }, h.prototype.writeUInt16LE = function (t, e, i) {
      return t = +t, e |= 0, i || k(this, t, e, 2, 65535, 0), h.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : H(this, t, e, !0), e + 2;
    }, h.prototype.writeUInt16BE = function (t, e, i) {
      return t = +t, e |= 0, i || k(this, t, e, 2, 65535, 0), h.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : H(this, t, e, !1), e + 2;
    }, h.prototype.writeUInt32LE = function (t, e, i) {
      return t = +t, e |= 0, i || k(this, t, e, 4, 4294967295, 0), h.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : I(this, t, e, !0), e + 4;
    }, h.prototype.writeUInt32BE = function (t, e, i) {
      return t = +t, e |= 0, i || k(this, t, e, 4, 4294967295, 0), h.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : I(this, t, e, !1), e + 4;
    }, h.prototype.writeIntLE = function (t, e, i, s) {
      if (t = +t, e |= 0, !s) {
        var r = Math.pow(2, 8 * i - 1);
        k(this, t, e, i, r - 1, -r);
      }
      var n = 0,
        a = 1,
        o = 0;
      for (this[e] = 255 & t; ++n < i && (a *= 256);) t < 0 && 0 === o && 0 !== this[e + n - 1] && (o = 1), this[e + n] = (t / a >> 0) - o & 255;
      return e + i;
    }, h.prototype.writeIntBE = function (t, e, i, s) {
      if (t = +t, e |= 0, !s) {
        var r = Math.pow(2, 8 * i - 1);
        k(this, t, e, i, r - 1, -r);
      }
      var n = i - 1,
        a = 1,
        o = 0;
      for (this[e + n] = 255 & t; --n >= 0 && (a *= 256);) t < 0 && 0 === o && 0 !== this[e + n + 1] && (o = 1), this[e + n] = (t / a >> 0) - o & 255;
      return e + i;
    }, h.prototype.writeInt8 = function (t, e, i) {
      return t = +t, e |= 0, i || k(this, t, e, 1, 127, -128), h.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
    }, h.prototype.writeInt16LE = function (t, e, i) {
      return t = +t, e |= 0, i || k(this, t, e, 2, 32767, -32768), h.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : H(this, t, e, !0), e + 2;
    }, h.prototype.writeInt16BE = function (t, e, i) {
      return t = +t, e |= 0, i || k(this, t, e, 2, 32767, -32768), h.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : H(this, t, e, !1), e + 2;
    }, h.prototype.writeInt32LE = function (t, e, i) {
      return t = +t, e |= 0, i || k(this, t, e, 4, 2147483647, -2147483648), h.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : I(this, t, e, !0), e + 4;
    }, h.prototype.writeInt32BE = function (t, e, i) {
      return t = +t, e |= 0, i || k(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), h.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : I(this, t, e, !1), e + 4;
    }, h.prototype.writeFloatLE = function (t, e, i) {
      return T(this, t, e, !0, i);
    }, h.prototype.writeFloatBE = function (t, e, i) {
      return T(this, t, e, !1, i);
    }, h.prototype.writeDoubleLE = function (t, e, i) {
      return P(this, t, e, !0, i);
    }, h.prototype.writeDoubleBE = function (t, e, i) {
      return P(this, t, e, !1, i);
    }, h.prototype.copy = function (t, e, i, s) {
      if (i || (i = 0), s || 0 === s || (s = this.length), e >= t.length && (e = t.length), e || (e = 0), s > 0 && s < i && (s = i), s === i) return 0;
      if (0 === t.length || 0 === this.length) return 0;
      if (e < 0) throw new RangeError("targetStart out of bounds");
      if (i < 0 || i >= this.length) throw new RangeError("sourceStart out of bounds");
      if (s < 0) throw new RangeError("sourceEnd out of bounds");
      s > this.length && (s = this.length), t.length - e < s - i && (s = t.length - e + i);
      var r,
        n = s - i;
      if (this === t && i < e && e < s) for (r = n - 1; r >= 0; --r) t[r + e] = this[r + i];else if (n < 1e3 || !h.TYPED_ARRAY_SUPPORT) for (r = 0; r < n; ++r) t[r + e] = this[r + i];else Uint8Array.prototype.set.call(t, this.subarray(i, i + n), e);
      return n;
    }, h.prototype.fill = function (t, e, i, s) {
      if ("string" == typeof t) {
        if ("string" == typeof e ? (s = e, e = 0, i = this.length) : "string" == typeof i && (s = i, i = this.length), 1 === t.length) {
          var r = t.charCodeAt(0);
          r < 256 && (t = r);
        }
        if (void 0 !== s && "string" != typeof s) throw new TypeError("encoding must be a string");
        if ("string" == typeof s && !h.isEncoding(s)) throw new TypeError("Unknown encoding: " + s);
      } else "number" == typeof t && (t &= 255);
      if (e < 0 || this.length < e || this.length < i) throw new RangeError("Out of range index");
      if (i <= e) return this;
      var n;
      if (e >>>= 0, i = void 0 === i ? this.length : i >>> 0, t || (t = 0), "number" == typeof t) for (n = e; n < i; ++n) this[n] = t;else {
        var a = h.isBuffer(t) ? t : D(new h(t, s).toString()),
          o = a.length;
        for (n = 0; n < i - e; ++n) this[n + e] = a[n % o];
      }
      return this;
    };
    var j = /[^+\/0-9A-Za-z-_]/g;
    function M(t) {
      return t < 16 ? "0" + t.toString(16) : t.toString(16);
    }
    function D(t, e) {
      var i;
      e = e || 1 / 0;
      for (var s = t.length, r = null, n = [], a = 0; a < s; ++a) {
        if ((i = t.charCodeAt(a)) > 55295 && i < 57344) {
          if (!r) {
            if (i > 56319) {
              (e -= 3) > -1 && n.push(239, 191, 189);
              continue;
            }
            if (a + 1 === s) {
              (e -= 3) > -1 && n.push(239, 191, 189);
              continue;
            }
            r = i;
            continue;
          }
          if (i < 56320) {
            (e -= 3) > -1 && n.push(239, 191, 189), r = i;
            continue;
          }
          i = 65536 + (r - 55296 << 10 | i - 56320);
        } else r && (e -= 3) > -1 && n.push(239, 191, 189);
        if (r = null, i < 128) {
          if ((e -= 1) < 0) break;
          n.push(i);
        } else if (i < 2048) {
          if ((e -= 2) < 0) break;
          n.push(i >> 6 | 192, 63 & i | 128);
        } else if (i < 65536) {
          if ((e -= 3) < 0) break;
          n.push(i >> 12 | 224, i >> 6 & 63 | 128, 63 & i | 128);
        } else {
          if (!(i < 1114112)) throw new Error("Invalid code point");
          if ((e -= 4) < 0) break;
          n.push(i >> 18 | 240, i >> 12 & 63 | 128, i >> 6 & 63 | 128, 63 & i | 128);
        }
      }
      return n;
    }
    function R(t) {
      return s.toByteArray(function (t) {
        if ((t = function (t) {
          return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
        }(t).replace(j, "")).length < 2) return "";
        for (; t.length % 4 != 0;) t += "=";
        return t;
      }(t));
    }
    function _(t, e, i, s) {
      for (var r = 0; r < s && !(r + i >= e.length || r >= t.length); ++r) e[r + i] = t[r];
      return r;
    }
  }).call(this, i(0));
}, function (t, e, i) {
  "use strict";

  e.byteLength = function (t) {
    var e = l(t),
      i = e[0],
      s = e[1];
    return 3 * (i + s) / 4 - s;
  }, e.toByteArray = function (t) {
    var e,
      i,
      s = l(t),
      a = s[0],
      o = s[1],
      h = new n(function (t, e, i) {
        return 3 * (e + i) / 4 - i;
      }(0, a, o)),
      A = 0,
      c = o > 0 ? a - 4 : a;
    for (i = 0; i < c; i += 4) e = r[t.charCodeAt(i)] << 18 | r[t.charCodeAt(i + 1)] << 12 | r[t.charCodeAt(i + 2)] << 6 | r[t.charCodeAt(i + 3)], h[A++] = e >> 16 & 255, h[A++] = e >> 8 & 255, h[A++] = 255 & e;
    2 === o && (e = r[t.charCodeAt(i)] << 2 | r[t.charCodeAt(i + 1)] >> 4, h[A++] = 255 & e);
    1 === o && (e = r[t.charCodeAt(i)] << 10 | r[t.charCodeAt(i + 1)] << 4 | r[t.charCodeAt(i + 2)] >> 2, h[A++] = e >> 8 & 255, h[A++] = 255 & e);
    return h;
  }, e.fromByteArray = function (t) {
    for (var e, i = t.length, r = i % 3, n = [], a = 0, o = i - r; a < o; a += 16383) n.push(A(t, a, a + 16383 > o ? o : a + 16383));
    1 === r ? (e = t[i - 1], n.push(s[e >> 2] + s[e << 4 & 63] + "==")) : 2 === r && (e = (t[i - 2] << 8) + t[i - 1], n.push(s[e >> 10] + s[e >> 4 & 63] + s[e << 2 & 63] + "="));
    return n.join("");
  };
  for (var s = [], r = [], n = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", o = 0, h = a.length; o < h; ++o) s[o] = a[o], r[a.charCodeAt(o)] = o;
  function l(t) {
    var e = t.length;
    if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    var i = t.indexOf("=");
    return -1 === i && (i = e), [i, i === e ? 0 : 4 - i % 4];
  }
  function A(t, e, i) {
    for (var r, n, a = [], o = e; o < i; o += 3) r = (t[o] << 16 & 16711680) + (t[o + 1] << 8 & 65280) + (255 & t[o + 2]), a.push(s[(n = r) >> 18 & 63] + s[n >> 12 & 63] + s[n >> 6 & 63] + s[63 & n]);
    return a.join("");
  }
  r["-".charCodeAt(0)] = 62, r["_".charCodeAt(0)] = 63;
}, function (t, e) {
  /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
  e.read = function (t, e, i, s, r) {
    var n,
      a,
      o = 8 * r - s - 1,
      h = (1 << o) - 1,
      l = h >> 1,
      A = -7,
      c = i ? r - 1 : 0,
      u = i ? -1 : 1,
      d = t[e + c];
    for (c += u, n = d & (1 << -A) - 1, d >>= -A, A += o; A > 0; n = 256 * n + t[e + c], c += u, A -= 8);
    for (a = n & (1 << -A) - 1, n >>= -A, A += s; A > 0; a = 256 * a + t[e + c], c += u, A -= 8);
    if (0 === n) n = 1 - l;else {
      if (n === h) return a ? NaN : 1 / 0 * (d ? -1 : 1);
      a += Math.pow(2, s), n -= l;
    }
    return (d ? -1 : 1) * a * Math.pow(2, n - s);
  }, e.write = function (t, e, i, s, r, n) {
    var a,
      o,
      h,
      l = 8 * n - r - 1,
      A = (1 << l) - 1,
      c = A >> 1,
      u = 23 === r ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
      d = s ? 0 : n - 1,
      f = s ? 1 : -1,
      p = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
    for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (o = isNaN(e) ? 1 : 0, a = A) : (a = Math.floor(Math.log(e) / Math.LN2), e * (h = Math.pow(2, -a)) < 1 && (a--, h *= 2), (e += a + c >= 1 ? u / h : u * Math.pow(2, 1 - c)) * h >= 2 && (a++, h /= 2), a + c >= A ? (o = 0, a = A) : a + c >= 1 ? (o = (e * h - 1) * Math.pow(2, r), a += c) : (o = e * Math.pow(2, c - 1) * Math.pow(2, r), a = 0)); r >= 8; t[i + d] = 255 & o, d += f, o /= 256, r -= 8);
    for (a = a << r | o, l += r; l > 0; t[i + d] = 255 & a, d += f, a /= 256, l -= 8);
    t[i + d - f] |= 128 * p;
  };
}, function (t, e) {
  var i = {}.toString;
  t.exports = Array.isArray || function (t) {
    return "[object Array]" == i.call(t);
  };
}, function (t, e) {
  t.exports = function () {
    throw new Error("define cannot be used indirect");
  };
}, function (t, e) {
  (function (e) {
    t.exports = e;
  }).call(this, {});
}]);